var Ov = Object.defineProperty;
var Pv = Object.getPrototypeOf;
var zv = Reflect.get;
var Zb = (i) => {
  throw TypeError(i);
};
var Dv = (i, t, e) => t in i ? Ov(i, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : i[t] = e;
var Fc = (i, t, e) => Dv(i, typeof t != "symbol" ? t + "" : t, e), _c = (i, t, e) => t.has(i) || Zb("Cannot " + e);
var ze = (i, t, e) => (_c(i, t, "read from private field"), e ? e.call(i) : t.get(i)), Fe = (i, t, e) => t.has(i) ? Zb("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(i) : t.set(i, e), Ne = (i, t, e, a) => (_c(i, t, "write to private field"), a ? a.call(i, e) : t.set(i, e), e), Ze = (i, t, e) => (_c(i, t, "access private method"), e);
var Jb = (i, t, e) => zv(Pv(i), e, t);
const Iv = "0.5rem", Bv = "#0C2A4DCC", Rv = "0.25rem", Dd = "0.5rem", Nv = "1rem", Fv = "1.5rem", _v = "320px", fh = "640px", Zg = "960px", Jg = "1280px", Uv = "0.5rem";
var jv = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function fi(i) {
  return i && i.__esModule && Object.prototype.hasOwnProperty.call(i, "default") ? i.default : i;
}
var em = { exports: {} };
(function(i) {
  /**
  * Highcharts JS v11.4.8 (2024-08-29)
  *
  * (c) 2009-2024 Torstein Honsi
  *
  * License: www.highcharts.com/license
  */
  (function(t, e) {
    i.exports ? (e.default = e, i.exports = t && t.document ? e(t) : e) : (t.Highcharts && t.Highcharts.error(16, !0), t.Highcharts = e(t));
  })(typeof window < "u" ? window : jv, function(t) {
    var e = {};
    function a(o, n, r, T) {
      !o.hasOwnProperty(n) && (o[n] = T.apply(null, r), t && typeof CustomEvent == "function" && t.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", { detail: { path: n, module: o[n] } })));
    }
    return a(e, "Core/Globals.js", [], function() {
      var o, n;
      return (n = o || (o = {})).SVG_NS = "http://www.w3.org/2000/svg", n.product = "Highcharts", n.version = "11.4.8", n.win = t !== void 0 ? t : {}, n.doc = n.win.document, n.svg = n.doc && n.doc.createElementNS && !!n.doc.createElementNS(n.SVG_NS, "svg").createSVGRect, n.userAgent = n.win.navigator && n.win.navigator.userAgent || "", n.isChrome = n.win.chrome, n.isFirefox = n.userAgent.indexOf("Firefox") !== -1, n.isMS = /(edge|msie|trident)/i.test(n.userAgent) && !n.win.opera, n.isSafari = !n.isChrome && n.userAgent.indexOf("Safari") !== -1, n.isTouchDevice = /(Mobile|Android|Windows Phone)/.test(n.userAgent), n.isWebKit = n.userAgent.indexOf("AppleWebKit") !== -1, n.deg2rad = 2 * Math.PI / 360, n.hasBidiBug = n.isFirefox && 4 > parseInt(n.userAgent.split("Firefox/")[1], 10), n.marginNames = ["plotTop", "marginRight", "marginBottom", "plotLeft"], n.noop = function() {
      }, n.supportsPassiveEvents = function() {
        let r = !1;
        if (!n.isMS) {
          let T = Object.defineProperty({}, "passive", { get: function() {
            r = !0;
          } });
          n.win.addEventListener && n.win.removeEventListener && (n.win.addEventListener("testPassive", n.noop, T), n.win.removeEventListener("testPassive", n.noop, T));
        }
        return r;
      }(), n.charts = [], n.composed = [], n.dateFormats = {}, n.seriesTypes = {}, n.symbolSizes = {}, n.chartCount = 0, o;
    }), a(e, "Core/Utilities.js", [e["Core/Globals.js"]], function(o) {
      let n, { charts: r, doc: T, win: O } = o;
      function j(s, l, b, u) {
        let c = l ? "Highcharts error" : "Highcharts warning";
        s === 32 && (s = `${c}: Deprecated member`);
        let h = x(s), g = h ? `${c} #${s}: www.highcharts.com/errors/${s}/` : s.toString();
        if (u !== void 0) {
          let E = "";
          h && (g += "?"), P(u, function(R, L) {
            E += `
 - ${L}: ${R}`, h && (g += encodeURI(L) + "=" + encodeURI(R));
          }), g += E;
        }
        S(o, "displayError", { chart: b, code: s, message: g, params: u }, function() {
          if (l) throw Error(g);
          O.console && j.messages.indexOf(g) === -1 && console.warn(g);
        }), j.messages.push(g);
      }
      function D(s, l) {
        return parseInt(s, l || 10);
      }
      function F(s) {
        return typeof s == "string";
      }
      function B(s) {
        let l = Object.prototype.toString.call(s);
        return l === "[object Array]" || l === "[object Array Iterator]";
      }
      function N(s, l) {
        return !!s && typeof s == "object" && (!l || !B(s));
      }
      function f(s) {
        return N(s) && typeof s.nodeType == "number";
      }
      function w(s) {
        let l = s && s.constructor;
        return !!(N(s, !0) && !f(s) && l && l.name && l.name !== "Object");
      }
      function x(s) {
        return typeof s == "number" && !isNaN(s) && s < 1 / 0 && s > -1 / 0;
      }
      function M(s) {
        return s != null;
      }
      function p(s, l, b) {
        let u, c = F(l) && !M(b), h = (g, E) => {
          M(g) ? s.setAttribute(E, g) : c ? (u = s.getAttribute(E)) || E !== "class" || (u = s.getAttribute(E + "Name")) : s.removeAttribute(E);
        };
        return F(l) ? h(b, l) : P(l, h), u;
      }
      function v(s) {
        return B(s) ? s : [s];
      }
      function k(s, l) {
        let b;
        for (b in s || (s = {}), l) s[b] = l[b];
        return s;
      }
      function m() {
        let s = arguments, l = s.length;
        for (let b = 0; b < l; b++) {
          let u = s[b];
          if (u != null) return u;
        }
      }
      function A(s, l) {
        k(s.style, l);
      }
      function C(s) {
        return Math.pow(10, Math.floor(Math.log(s) / Math.LN10));
      }
      function H(s, l) {
        return s > 1e14 ? s : parseFloat(s.toPrecision(l || 14));
      }
      (j || (j = {})).messages = [], Math.easeInOutSine = function(s) {
        return -0.5 * (Math.cos(Math.PI * s) - 1);
      };
      let G = Array.prototype.find ? function(s, l) {
        return s.find(l);
      } : function(s, l) {
        let b, u = s.length;
        for (b = 0; b < u; b++) if (l(s[b], b)) return s[b];
      };
      function P(s, l, b) {
        for (let u in s) Object.hasOwnProperty.call(s, u) && l.call(b || s[u], s[u], u, s);
      }
      function y(s, l, b) {
        function u(g, E) {
          let R = s.removeEventListener;
          R && R.call(s, g, E, !1);
        }
        function c(g) {
          let E, R;
          s.nodeName && (l ? (E = {})[l] = !0 : E = g, P(E, function(L, U) {
            if (g[U]) for (R = g[U].length; R--; ) u(U, g[U][R].fn);
          }));
        }
        let h = typeof s == "function" && s.prototype || s;
        if (Object.hasOwnProperty.call(h, "hcEvents")) {
          let g = h.hcEvents;
          if (l) {
            let E = g[l] || [];
            b ? (g[l] = E.filter(function(R) {
              return b !== R.fn;
            }), u(l, b)) : (c(g), g[l] = []);
          } else c(g), delete h.hcEvents;
        }
      }
      function S(s, l, b, u) {
        if (b = b || {}, T.createEvent && (s.dispatchEvent || s.fireEvent && s !== o)) {
          let c = T.createEvent("Events");
          c.initEvent(l, !0, !0), b = k(c, b), s.dispatchEvent ? s.dispatchEvent(b) : s.fireEvent(l, b);
        } else if (s.hcEvents) {
          b.target || k(b, { preventDefault: function() {
            b.defaultPrevented = !0;
          }, target: s, type: l });
          let c = [], h = s, g = !1;
          for (; h.hcEvents; ) Object.hasOwnProperty.call(h, "hcEvents") && h.hcEvents[l] && (c.length && (g = !0), c.unshift.apply(c, h.hcEvents[l])), h = Object.getPrototypeOf(h);
          g && c.sort((E, R) => E.order - R.order), c.forEach((E) => {
            E.fn.call(s, b) === !1 && b.preventDefault();
          });
        }
        u && !b.defaultPrevented && u.call(s, b);
      }
      P({ map: "map", each: "forEach", grep: "filter", reduce: "reduce", some: "some" }, function(s, l) {
        o[l] = function(b) {
          return j(32, !1, void 0, { [`Highcharts.${l}`]: `use Array.${s}` }), Array.prototype[s].apply(b, [].slice.call(arguments, 1));
        };
      });
      let d = function() {
        let s = Math.random().toString(36).substring(2, 9) + "-", l = 0;
        return function() {
          return "highcharts-" + (n ? "" : s) + l++;
        };
      }();
      return O.jQuery && (O.jQuery.fn.highcharts = function() {
        let s = [].slice.call(arguments);
        if (this[0]) return s[0] ? (new o[F(s[0]) ? s.shift() : "Chart"](this[0], s[0], s[1]), this) : r[p(this[0], "data-highcharts-chart")];
      }), { addEvent: function(s, l, b, u = {}) {
        let c = typeof s == "function" && s.prototype || s;
        Object.hasOwnProperty.call(c, "hcEvents") || (c.hcEvents = {});
        let h = c.hcEvents;
        o.Point && s instanceof o.Point && s.series && s.series.chart && (s.series.chart.runTrackerClick = !0);
        let g = s.addEventListener;
        g && g.call(s, l, b, !!o.supportsPassiveEvents && { passive: u.passive === void 0 ? l.indexOf("touch") !== -1 : u.passive, capture: !1 }), h[l] || (h[l] = []);
        let E = { fn: b, order: typeof u.order == "number" ? u.order : 1 / 0 };
        return h[l].push(E), h[l].sort((R, L) => R.order - L.order), function() {
          y(s, l, b);
        };
      }, arrayMax: function(s) {
        let l = s.length, b = s[0];
        for (; l--; ) s[l] > b && (b = s[l]);
        return b;
      }, arrayMin: function(s) {
        let l = s.length, b = s[0];
        for (; l--; ) s[l] < b && (b = s[l]);
        return b;
      }, attr: p, clamp: function(s, l, b) {
        return s > l ? s < b ? s : b : l;
      }, clearTimeout: function(s) {
        M(s) && clearTimeout(s);
      }, correctFloat: H, createElement: function(s, l, b, u, c) {
        let h = T.createElement(s);
        return l && k(h, l), c && A(h, { padding: "0", border: "none", margin: "0" }), b && A(h, b), u && u.appendChild(h), h;
      }, crisp: (s, l = 0, b) => {
        let u = l % 2 / 2, c = b ? -1 : 1;
        return (Math.round(s * c - u) + u) * c;
      }, css: A, defined: M, destroyObjectProperties: function(s, l, b) {
        P(s, function(u, c) {
          u !== l && (u != null && u.destroy) && u.destroy(), (u != null && u.destroy || !b) && delete s[c];
        });
      }, diffObjects: function(s, l, b, u) {
        let c = {};
        return function h(g, E, R, L) {
          let U = b ? E : g;
          P(g, function(V, q) {
            if (!L && u && u.indexOf(q) > -1 && E[q]) {
              V = v(V), R[q] = [];
              for (let Y = 0; Y < Math.max(V.length, E[q].length); Y++) E[q][Y] && (V[Y] === void 0 ? R[q][Y] = E[q][Y] : (R[q][Y] = {}, h(V[Y], E[q][Y], R[q][Y], L + 1)));
            } else N(V, !0) && !V.nodeType ? (R[q] = B(V) ? [] : {}, h(V, E[q] || {}, R[q], L + 1), Object.keys(R[q]).length !== 0 || q === "colorAxis" && L === 0 || delete R[q]) : (g[q] !== E[q] || q in g && !(q in E)) && q !== "__proto__" && q !== "constructor" && (R[q] = U[q]);
          });
        }(s, l, c, 0), c;
      }, discardElement: function(s) {
        s && s.parentElement && s.parentElement.removeChild(s);
      }, erase: function(s, l) {
        let b = s.length;
        for (; b--; ) if (s[b] === l) {
          s.splice(b, 1);
          break;
        }
      }, error: j, extend: k, extendClass: function(s, l) {
        let b = function() {
        };
        return b.prototype = new s(), k(b.prototype, l), b;
      }, find: G, fireEvent: S, getClosestDistance: function(s, l) {
        let b, u, c, h = !l;
        return s.forEach((g) => {
          if (g.length > 1) for (c = g.length - 1; c > 0; c--) (u = g[c] - g[c - 1]) < 0 && !h ? (l == null || l(), l = void 0) : u && (b === void 0 || u < b) && (b = u);
        }), b;
      }, getMagnitude: C, getNestedProperty: function(s, l) {
        let b = s.split(".");
        for (; b.length && M(l); ) {
          let u = b.shift();
          if (u === void 0 || u === "__proto__") return;
          if (u === "this") {
            let h;
            return N(l) && (h = l["@this"]), h != null ? h : l;
          }
          let c = l[u];
          if (!M(c) || typeof c == "function" || typeof c.nodeType == "number" || c === O) return;
          l = c;
        }
        return l;
      }, getStyle: function s(l, b, u) {
        let c;
        if (b === "width") {
          let g = Math.min(l.offsetWidth, l.scrollWidth), E = l.getBoundingClientRect && l.getBoundingClientRect().width;
          return E < g && E >= g - 1 && (g = Math.floor(E)), Math.max(0, g - (s(l, "padding-left", !0) || 0) - (s(l, "padding-right", !0) || 0));
        }
        if (b === "height") return Math.max(0, Math.min(l.offsetHeight, l.scrollHeight) - (s(l, "padding-top", !0) || 0) - (s(l, "padding-bottom", !0) || 0));
        let h = O.getComputedStyle(l, void 0);
        return h && (c = h.getPropertyValue(b), m(u, b !== "opacity") && (c = D(c))), c;
      }, inArray: function(s, l, b) {
        return j(32, !1, void 0, { "Highcharts.inArray": "use Array.indexOf" }), l.indexOf(s, b);
      }, insertItem: function(s, l) {
        let b, u = s.options.index, c = l.length;
        for (b = s.options.isInternal ? c : 0; b < c + 1; b++) if (!l[b] || x(u) && u < m(l[b].options.index, l[b]._i) || l[b].options.isInternal) {
          l.splice(b, 0, s);
          break;
        }
        return b;
      }, isArray: B, isClass: w, isDOMElement: f, isFunction: function(s) {
        return typeof s == "function";
      }, isNumber: x, isObject: N, isString: F, keys: function(s) {
        return j(32, !1, void 0, { "Highcharts.keys": "use Object.keys" }), Object.keys(s);
      }, merge: function() {
        let s, l = arguments, b = {}, u = function(h, g) {
          return typeof h != "object" && (h = {}), P(g, function(E, R) {
            R !== "__proto__" && R !== "constructor" && (!N(E, !0) || w(E) || f(E) ? h[R] = g[R] : h[R] = u(h[R] || {}, E));
          }), h;
        };
        l[0] === !0 && (b = l[1], l = Array.prototype.slice.call(l, 2));
        let c = l.length;
        for (s = 0; s < c; s++) b = u(b, l[s]);
        return b;
      }, normalizeTickInterval: function(s, l, b, u, c) {
        let h, g = s;
        b = m(b, C(s));
        let E = s / b;
        for (!l && (l = c ? [1, 1.2, 1.5, 2, 2.5, 3, 4, 5, 6, 8, 10] : [1, 2, 2.5, 5, 10], u === !1 && (b === 1 ? l = l.filter(function(R) {
          return R % 1 == 0;
        }) : b <= 0.1 && (l = [1 / b]))), h = 0; h < l.length && (g = l[h], (!c || !(g * b >= s)) && (c || !(E <= (l[h] + (l[h + 1] || l[h])) / 2))); h++) ;
        return H(g * b, -Math.round(Math.log(1e-3) / Math.LN10));
      }, objectEach: P, offset: function(s) {
        let l = T.documentElement, b = s.parentElement || s.parentNode ? s.getBoundingClientRect() : { top: 0, left: 0, width: 0, height: 0 };
        return { top: b.top + (O.pageYOffset || l.scrollTop) - (l.clientTop || 0), left: b.left + (O.pageXOffset || l.scrollLeft) - (l.clientLeft || 0), width: b.width, height: b.height };
      }, pad: function(s, l, b) {
        return Array((l || 2) + 1 - String(s).replace("-", "").length).join(b || "0") + s;
      }, pick: m, pInt: D, pushUnique: function(s, l) {
        return 0 > s.indexOf(l) && !!s.push(l);
      }, relativeLength: function(s, l, b) {
        return /%$/.test(s) ? l * parseFloat(s) / 100 + (b || 0) : parseFloat(s);
      }, removeEvent: y, replaceNested: function(s, ...l) {
        let b, u;
        do
          for (u of (b = s, l)) s = s.replace(u[0], u[1]);
        while (s !== b);
        return s;
      }, splat: v, stableSort: function(s, l) {
        let b, u, c = s.length;
        for (u = 0; u < c; u++) s[u].safeI = u;
        for (s.sort(function(h, g) {
          return (b = l(h, g)) === 0 ? h.safeI - g.safeI : b;
        }), u = 0; u < c; u++) delete s[u].safeI;
      }, syncTimeout: function(s, l, b) {
        return l > 0 ? setTimeout(s, l, b) : (s.call(0, b), -1);
      }, timeUnits: { millisecond: 1, second: 1e3, minute: 6e4, hour: 36e5, day: 864e5, week: 6048e5, month: 24192e5, year: 314496e5 }, uniqueKey: d, useSerialIds: function(s) {
        return n = m(s, n);
      }, wrap: function(s, l, b) {
        let u = s[l];
        s[l] = function() {
          let c = arguments, h = this;
          return b.apply(this, [function() {
            return u.apply(h, arguments.length ? arguments : c);
          }].concat([].slice.call(arguments)));
        };
      } };
    }), a(e, "Core/Chart/ChartDefaults.js", [], function() {
      return { alignThresholds: !1, panning: { enabled: !1, type: "x" }, styledMode: !1, borderRadius: 0, colorCount: 10, allowMutatingData: !0, ignoreHiddenSeries: !0, spacing: [10, 10, 15, 10], resetZoomButton: { theme: {}, position: {} }, reflow: !0, type: "line", zooming: { singleTouch: !1, resetButton: { theme: { zIndex: 6 }, position: { align: "right", x: -10, y: 10 } } }, width: null, height: null, borderColor: "#334eff", backgroundColor: "#ffffff", plotBorderColor: "#cccccc" };
    }), a(e, "Core/Color/Palettes.js", [], function() {
      return { colors: ["#2caffe", "#544fc5", "#00e272", "#fe6a35", "#6b8abc", "#d568fb", "#2ee0ca", "#fa4b42", "#feb56a", "#91e8e1"] };
    }), a(e, "Core/Time.js", [e["Core/Globals.js"], e["Core/Utilities.js"]], function(o, n) {
      let { win: r } = o, { defined: T, error: O, extend: j, isNumber: D, isObject: F, merge: B, objectEach: N, pad: f, pick: w, splat: x, timeUnits: M } = n, p = o.isSafari && r.Intl && r.Intl.DateTimeFormat.prototype.formatRange, v = o.isSafari && r.Intl && !r.Intl.DateTimeFormat.prototype.formatRange;
      class k {
        constructor(A) {
          this.options = {}, this.useUTC = !1, this.variableTimezone = !1, this.Date = r.Date, this.getTimezoneOffset = this.timezoneOffsetFunction(), this.update(A);
        }
        get(A, C) {
          if (this.variableTimezone || this.timezoneOffset) {
            let H = C.getTime(), G = H - this.getTimezoneOffset(C);
            C.setTime(G);
            let P = C["getUTC" + A]();
            return C.setTime(H), P;
          }
          return this.useUTC ? C["getUTC" + A]() : C["get" + A]();
        }
        set(A, C, H) {
          if (this.variableTimezone || this.timezoneOffset) {
            if (A === "Milliseconds" || A === "Seconds" || A === "Minutes" && this.getTimezoneOffset(C) % 36e5 == 0) return C["setUTC" + A](H);
            let G = this.getTimezoneOffset(C), P = C.getTime() - G;
            C.setTime(P), C["setUTC" + A](H);
            let y = this.getTimezoneOffset(C);
            return P = C.getTime() + y, C.setTime(P);
          }
          return this.useUTC || p && A === "FullYear" ? C["setUTC" + A](H) : C["set" + A](H);
        }
        update(A = {}) {
          let C = w(A.useUTC, !0);
          this.options = A = B(!0, this.options, A), this.Date = A.Date || r.Date || Date, this.useUTC = C, this.timezoneOffset = C && A.timezoneOffset || void 0, this.getTimezoneOffset = this.timezoneOffsetFunction(), this.variableTimezone = C && !!(A.getTimezoneOffset || A.timezone);
        }
        makeTime(A, C, H, G, P, y) {
          let S, d, s;
          return this.useUTC ? (S = this.Date.UTC.apply(0, arguments), d = this.getTimezoneOffset(S), S += d, d !== (s = this.getTimezoneOffset(S)) ? S += s - d : d - 36e5 !== this.getTimezoneOffset(S - 36e5) || v || (S -= 36e5)) : S = new this.Date(A, C, w(H, 1), w(G, 0), w(P, 0), w(y, 0)).getTime(), S;
        }
        timezoneOffsetFunction() {
          let A = this, C = this.options, H = C.getTimezoneOffset;
          return this.useUTC ? C.timezone ? (G) => {
            try {
              let P = `shortOffset,${C.timezone || ""}`, [y, S, d, s, l = 0] = (k.formatCache[P] = k.formatCache[P] || Intl.DateTimeFormat("en", { timeZone: C.timezone, timeZoneName: "shortOffset" })).format(G).split(/(GMT|:)/).map(Number), b = -(36e5 * (d + l / 60));
              if (D(b)) return b;
            } catch {
              O(34);
            }
            return 0;
          } : this.useUTC && H ? (G) => 6e4 * H(G.valueOf()) : () => 6e4 * (A.timezoneOffset || 0) : (G) => 6e4 * new Date(G.toString()).getTimezoneOffset();
        }
        dateFormat(A, C, H) {
          if (!T(C) || isNaN(C)) return o.defaultOptions.lang && o.defaultOptions.lang.invalidDate || "";
          A = w(A, "%Y-%m-%d %H:%M:%S");
          let G = this, P = new this.Date(C), y = this.get("Hours", P), S = this.get("Day", P), d = this.get("Date", P), s = this.get("Month", P), l = this.get("FullYear", P), b = o.defaultOptions.lang, u = b && b.weekdays, c = b && b.shortWeekdays;
          return N(j({ a: c ? c[S] : u[S].substr(0, 3), A: u[S], d: f(d), e: f(d, 2, " "), w: S, b: b.shortMonths[s], B: b.months[s], m: f(s + 1), o: s + 1, y: l.toString().substr(2, 2), Y: l, H: f(y), k: y, I: f(y % 12 || 12), l: y % 12 || 12, M: f(this.get("Minutes", P)), p: y < 12 ? "AM" : "PM", P: y < 12 ? "am" : "pm", S: f(this.get("Seconds", P)), L: f(Math.floor(C % 1e3), 3) }, o.dateFormats), function(h, g) {
            for (; A.indexOf("%" + g) !== -1; ) A = A.replace("%" + g, typeof h == "function" ? h.call(G, C) : h);
          }), H ? A.substr(0, 1).toUpperCase() + A.substr(1) : A;
        }
        resolveDTLFormat(A) {
          return F(A, !0) ? A : { main: (A = x(A))[0], from: A[1], to: A[2] };
        }
        getTimeTicks(A, C, H, G) {
          let P, y, S, d, s = this, l = s.Date, b = [], u = {}, c = new l(C), h = A.unitRange, g = A.count || 1;
          if (G = w(G, 1), T(C)) {
            s.set("Milliseconds", c, h >= M.second ? 0 : g * Math.floor(s.get("Milliseconds", c) / g)), h >= M.second && s.set("Seconds", c, h >= M.minute ? 0 : g * Math.floor(s.get("Seconds", c) / g)), h >= M.minute && s.set("Minutes", c, h >= M.hour ? 0 : g * Math.floor(s.get("Minutes", c) / g)), h >= M.hour && s.set("Hours", c, h >= M.day ? 0 : g * Math.floor(s.get("Hours", c) / g)), h >= M.day && s.set("Date", c, h >= M.month ? 1 : Math.max(1, g * Math.floor(s.get("Date", c) / g))), h >= M.month && (s.set("Month", c, h >= M.year ? 0 : g * Math.floor(s.get("Month", c) / g)), y = s.get("FullYear", c)), h >= M.year && (y -= y % g, s.set("FullYear", c, y)), h === M.week && (d = s.get("Day", c), s.set("Date", c, s.get("Date", c) - d + G + (d < G ? -7 : 0))), y = s.get("FullYear", c);
            let E = s.get("Month", c), R = s.get("Date", c), L = s.get("Hours", c);
            C = c.getTime(), (s.variableTimezone || !s.useUTC) && T(H) && (S = H - C > 4 * M.month || s.getTimezoneOffset(C) !== s.getTimezoneOffset(H));
            let U = c.getTime();
            for (P = 1; U < H; ) b.push(U), h === M.year ? U = s.makeTime(y + P * g, 0) : h === M.month ? U = s.makeTime(y, E + P * g) : S && (h === M.day || h === M.week) ? U = s.makeTime(y, E, R + P * g * (h === M.day ? 1 : 7)) : S && h === M.hour && g > 1 ? U = s.makeTime(y, E, R, L + P * g) : U += h * g, P++;
            b.push(U), h <= M.hour && b.length < 1e4 && b.forEach(function(V) {
              V % 18e5 == 0 && s.dateFormat("%H%M%S%L", V) === "000000000" && (u[V] = "day");
            });
          }
          return b.info = j(A, { higherRanks: u, totalRange: h * g }), b;
        }
        getDateFormat(A, C, H, G) {
          let P = this.dateFormat("%m-%d %H:%M:%S.%L", C), y = "01-01 00:00:00.000", S = { millisecond: 15, second: 12, minute: 9, hour: 6, day: 3 }, d = "millisecond", s = d;
          for (d in M) {
            if (A === M.week && +this.dateFormat("%w", C) === H && P.substr(6) === y.substr(6)) {
              d = "week";
              break;
            }
            if (M[d] > A) {
              d = s;
              break;
            }
            if (S[d] && P.substr(S[d]) !== y.substr(S[d])) break;
            d !== "week" && (s = d);
          }
          return this.resolveDTLFormat(G[d]).main;
        }
      }
      return k.formatCache = {}, k;
    }), a(e, "Core/Defaults.js", [e["Core/Chart/ChartDefaults.js"], e["Core/Globals.js"], e["Core/Color/Palettes.js"], e["Core/Time.js"], e["Core/Utilities.js"]], function(o, n, r, T, O) {
      let { isTouchDevice: j } = n, { fireEvent: D, merge: F } = O, B = { colors: r.colors, symbols: ["circle", "diamond", "square", "triangle", "triangle-down"], lang: { loading: "Loading...", months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"], shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"], weekdays: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"], decimalPoint: ".", numericSymbols: ["k", "M", "G", "T", "P", "E"], resetZoom: "Reset zoom", resetZoomTitle: "Reset zoom level 1:1", thousandsSep: " " }, global: { buttonTheme: { fill: "#f7f7f7", padding: 8, r: 2, stroke: "#cccccc", "stroke-width": 1, style: { color: "#333333", cursor: "pointer", fontSize: "0.8em", fontWeight: "normal" }, states: { hover: { fill: "#e6e6e6" }, select: { fill: "#e6e9ff", style: { color: "#000000", fontWeight: "bold" } }, disabled: { style: { color: "#cccccc" } } } } }, time: { Date: void 0, getTimezoneOffset: void 0, timezone: void 0, timezoneOffset: 0, useUTC: !0 }, chart: o, title: { style: { color: "#333333", fontWeight: "bold" }, text: "Chart title", align: "center", margin: 15, widthAdjust: -44 }, subtitle: { style: { color: "#666666", fontSize: "0.8em" }, text: "", align: "center", widthAdjust: -44 }, caption: { margin: 15, style: { color: "#666666", fontSize: "0.8em" }, text: "", align: "left", verticalAlign: "bottom" }, plotOptions: {}, legend: { enabled: !0, align: "center", alignColumns: !0, className: "highcharts-no-tooltip", events: {}, layout: "horizontal", itemMarginBottom: 2, itemMarginTop: 2, labelFormatter: function() {
        return this.name;
      }, borderColor: "#999999", borderRadius: 0, navigation: { style: { fontSize: "0.8em" }, activeColor: "#0022ff", inactiveColor: "#cccccc" }, itemStyle: { color: "#333333", cursor: "pointer", fontSize: "0.8em", textDecoration: "none", textOverflow: "ellipsis" }, itemHoverStyle: { color: "#000000" }, itemHiddenStyle: { color: "#666666", textDecoration: "line-through" }, shadow: !1, itemCheckboxStyle: { position: "absolute", width: "13px", height: "13px" }, squareSymbol: !0, symbolPadding: 5, verticalAlign: "bottom", x: 0, y: 0, title: { style: { fontSize: "0.8em", fontWeight: "bold" } } }, loading: { labelStyle: { fontWeight: "bold", position: "relative", top: "45%" }, style: { position: "absolute", backgroundColor: "#ffffff", opacity: 0.5, textAlign: "center" } }, tooltip: { enabled: !0, animation: { duration: 300, easing: (f) => Math.sqrt(1 - Math.pow(f - 1, 2)) }, borderRadius: 3, dateTimeLabelFormats: { millisecond: "%A, %e %b, %H:%M:%S.%L", second: "%A, %e %b, %H:%M:%S", minute: "%A, %e %b, %H:%M", hour: "%A, %e %b, %H:%M", day: "%A, %e %b %Y", week: "Week from %A, %e %b %Y", month: "%B %Y", year: "%Y" }, footerFormat: "", headerShape: "callout", hideDelay: 500, padding: 8, shape: "callout", shared: !1, snap: j ? 25 : 10, headerFormat: '<span style="font-size: 0.8em">{point.key}</span><br/>', pointFormat: '<span style="color:{point.color}">●</span> {series.name}: <b>{point.y}</b><br/>', backgroundColor: "#ffffff", borderWidth: void 0, shadow: !0, stickOnContact: !1, style: { color: "#333333", cursor: "default", fontSize: "0.8em" }, useHTML: !1 }, credits: { enabled: !0, href: "https://www.highcharts.com?credits", position: { align: "right", x: -10, verticalAlign: "bottom", y: -5 }, style: { cursor: "pointer", color: "#999999", fontSize: "0.6em" }, text: "Highcharts.com" } };
      B.chart.styledMode = !1;
      let N = new T(B.time);
      return { defaultOptions: B, defaultTime: N, getOptions: function() {
        return B;
      }, setOptions: function(f) {
        return D(n, "setOptions", { options: f }), F(!0, B, f), (f.time || f.global) && (n.time ? n.time.update(F(B.global, B.time, f.global, f.time)) : n.time = N), B;
      } };
    }), a(e, "Core/Color/Color.js", [e["Core/Globals.js"], e["Core/Utilities.js"]], function(o, n) {
      let { isNumber: r, merge: T, pInt: O } = n;
      class j {
        static parse(F) {
          return F ? new j(F) : j.None;
        }
        constructor(F) {
          let B, N, f, w;
          this.rgba = [NaN, NaN, NaN, NaN], this.input = F;
          let x = o.Color;
          if (x && x !== j) return new x(F);
          if (typeof F == "object" && F.stops !== void 0) this.stops = F.stops.map((M) => new j(M[1]));
          else if (typeof F == "string") {
            if (this.input = F = j.names[F.toLowerCase()] || F, F.charAt(0) === "#") {
              let M = F.length, p = parseInt(F.substr(1), 16);
              M === 7 ? N = [(16711680 & p) >> 16, (65280 & p) >> 8, 255 & p, 1] : M === 4 && (N = [(3840 & p) >> 4 | (3840 & p) >> 8, (240 & p) >> 4 | 240 & p, (15 & p) << 4 | 15 & p, 1]);
            }
            if (!N) for (f = j.parsers.length; f-- && !N; ) (B = (w = j.parsers[f]).regex.exec(F)) && (N = w.parse(B));
          }
          N && (this.rgba = N);
        }
        get(F) {
          let B = this.input, N = this.rgba;
          if (typeof B == "object" && this.stops !== void 0) {
            let f = T(B);
            return f.stops = [].slice.call(f.stops), this.stops.forEach((w, x) => {
              f.stops[x] = [f.stops[x][0], w.get(F)];
            }), f;
          }
          return N && r(N[0]) ? F !== "rgb" && (F || N[3] !== 1) ? F === "a" ? `${N[3]}` : "rgba(" + N.join(",") + ")" : "rgb(" + N[0] + "," + N[1] + "," + N[2] + ")" : B;
        }
        brighten(F) {
          let B = this.rgba;
          if (this.stops) this.stops.forEach(function(N) {
            N.brighten(F);
          });
          else if (r(F) && F !== 0) for (let N = 0; N < 3; N++) B[N] += O(255 * F), B[N] < 0 && (B[N] = 0), B[N] > 255 && (B[N] = 255);
          return this;
        }
        setOpacity(F) {
          return this.rgba[3] = F, this;
        }
        tweenTo(F, B) {
          let N = this.rgba, f = F.rgba;
          if (!r(N[0]) || !r(f[0])) return F.input || "none";
          let w = f[3] !== 1 || N[3] !== 1;
          return (w ? "rgba(" : "rgb(") + Math.round(f[0] + (N[0] - f[0]) * (1 - B)) + "," + Math.round(f[1] + (N[1] - f[1]) * (1 - B)) + "," + Math.round(f[2] + (N[2] - f[2]) * (1 - B)) + (w ? "," + (f[3] + (N[3] - f[3]) * (1 - B)) : "") + ")";
        }
      }
      return j.names = { white: "#ffffff", black: "#000000" }, j.parsers = [{ regex: /rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d?(?:\.\d+)?)\s*\)/, parse: function(D) {
        return [O(D[1]), O(D[2]), O(D[3]), parseFloat(D[4], 10)];
      } }, { regex: /rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)/, parse: function(D) {
        return [O(D[1]), O(D[2]), O(D[3]), 1];
      } }], j.None = new j(""), j;
    }), a(e, "Core/Animation/Fx.js", [e["Core/Color/Color.js"], e["Core/Globals.js"], e["Core/Utilities.js"]], function(o, n, r) {
      let { parse: T } = o, { win: O } = n, { isNumber: j, objectEach: D } = r;
      class F {
        constructor(N, f, w) {
          this.pos = NaN, this.options = f, this.elem = N, this.prop = w;
        }
        dSetter() {
          let N = this.paths, f = N && N[0], w = N && N[1], x = this.now || 0, M = [];
          if (x !== 1 && f && w)
            if (f.length === w.length && x < 1) for (let p = 0; p < w.length; p++) {
              let v = f[p], k = w[p], m = [];
              for (let A = 0; A < k.length; A++) {
                let C = v[A], H = k[A];
                j(C) && j(H) && !(k[0] === "A" && (A === 4 || A === 5)) ? m[A] = C + x * (H - C) : m[A] = H;
              }
              M.push(m);
            }
            else M = w;
          else M = this.toD || [];
          this.elem.attr("d", M, void 0, !0);
        }
        update() {
          let N = this.elem, f = this.prop, w = this.now, x = this.options.step;
          this[f + "Setter"] ? this[f + "Setter"]() : N.attr ? N.element && N.attr(f, w, null, !0) : N.style[f] = w + this.unit, x && x.call(N, w, this);
        }
        run(N, f, w) {
          let x = this, M = x.options, p = function(m) {
            return !p.stopped && x.step(m);
          }, v = O.requestAnimationFrame || function(m) {
            setTimeout(m, 13);
          }, k = function() {
            for (let m = 0; m < F.timers.length; m++) F.timers[m]() || F.timers.splice(m--, 1);
            F.timers.length && v(k);
          };
          N !== f || this.elem["forceAnimate:" + this.prop] ? (this.startTime = +/* @__PURE__ */ new Date(), this.start = N, this.end = f, this.unit = w, this.now = this.start, this.pos = 0, p.elem = this.elem, p.prop = this.prop, p() && F.timers.push(p) === 1 && v(k)) : (delete M.curAnim[this.prop], M.complete && Object.keys(M.curAnim).length === 0 && M.complete.call(this.elem));
        }
        step(N) {
          let f, w, x = +/* @__PURE__ */ new Date(), M = this.options, p = this.elem, v = M.complete, k = M.duration, m = M.curAnim;
          return p.attr && !p.element ? f = !1 : N || x >= k + this.startTime ? (this.now = this.end, this.pos = 1, this.update(), m[this.prop] = !0, w = !0, D(m, function(A) {
            A !== !0 && (w = !1);
          }), w && v && v.call(p), f = !1) : (this.pos = M.easing((x - this.startTime) / k), this.now = this.start + (this.end - this.start) * this.pos, this.update(), f = !0), f;
        }
        initPath(N, f, w) {
          let x = N.startX, M = N.endX, p = w.slice(), v = N.isArea, k = v ? 2 : 1, m = f && w.length > f.length && w.hasStackedCliffs, A, C, H, G, P = f && f.slice();
          if (!P || m) return [p, p];
          function y(d, s) {
            for (; d.length < C; ) {
              let l = d[0], b = s[C - d.length];
              if (b && l[0] === "M" && (b[0] === "C" ? d[0] = ["C", l[1], l[2], l[1], l[2], l[1], l[2]] : d[0] = ["L", l[1], l[2]]), d.unshift(l), v) {
                let u = d.pop();
                d.push(d[d.length - 1], u);
              }
            }
          }
          function S(d) {
            for (; d.length < C; ) {
              let s = d[Math.floor(d.length / k) - 1].slice();
              if (s[0] === "C" && (s[1] = s[5], s[2] = s[6]), v) {
                let l = d[Math.floor(d.length / k)].slice();
                d.splice(d.length / 2, 0, s, l);
              } else d.push(s);
            }
          }
          if (x && M && M.length) {
            for (H = 0; H < x.length; H++) {
              if (x[H] === M[0]) {
                A = H;
                break;
              }
              if (x[0] === M[M.length - x.length + H]) {
                A = H, G = !0;
                break;
              }
              if (x[x.length - 1] === M[M.length - x.length + H]) {
                A = x.length - H;
                break;
              }
            }
            A === void 0 && (P = []);
          }
          return P.length && j(A) && (C = p.length + A * k, G ? (y(P, p), S(p)) : (y(p, P), S(P))), [P, p];
        }
        fillSetter() {
          F.prototype.strokeSetter.apply(this, arguments);
        }
        strokeSetter() {
          this.elem.attr(this.prop, T(this.start).tweenTo(T(this.end), this.pos), void 0, !0);
        }
      }
      return F.timers = [], F;
    }), a(e, "Core/Animation/AnimationUtilities.js", [e["Core/Animation/Fx.js"], e["Core/Utilities.js"]], function(o, n) {
      let { defined: r, getStyle: T, isArray: O, isNumber: j, isObject: D, merge: F, objectEach: B, pick: N } = n;
      function f(x) {
        return D(x) ? F({ duration: 500, defer: 0 }, x) : { duration: x ? 500 : 0, defer: 0 };
      }
      function w(x, M) {
        let p = o.timers.length;
        for (; p--; ) o.timers[p].elem !== x || M && M !== o.timers[p].prop || (o.timers[p].stopped = !0);
      }
      return { animate: function(x, M, p) {
        let v, k = "", m, A, C;
        D(p) || (C = arguments, p = { duration: C[2], easing: C[3], complete: C[4] }), j(p.duration) || (p.duration = 400), p.easing = typeof p.easing == "function" ? p.easing : Math[p.easing] || Math.easeInOutSine, p.curAnim = F(M), B(M, function(H, G) {
          w(x, G), A = new o(x, p, G), m = void 0, G === "d" && O(M.d) ? (A.paths = A.initPath(x, x.pathArray, M.d), A.toD = M.d, v = 0, m = 1) : x.attr ? v = x.attr(G) : (v = parseFloat(T(x, G)) || 0, G !== "opacity" && (k = "px")), m || (m = H), typeof m == "string" && m.match("px") && (m = m.replace(/px/g, "")), A.run(v, m, k);
        });
      }, animObject: f, getDeferredAnimation: function(x, M, p) {
        let v = f(M), k = p ? [p] : x.series, m = 0, A = 0;
        return k.forEach((C) => {
          let H = f(C.options.animation);
          m = D(M) && r(M.defer) ? v.defer : Math.max(m, H.duration + H.defer), A = Math.min(v.duration, H.duration);
        }), x.renderer.forExport && (m = 0), { defer: Math.max(0, m - A), duration: Math.min(m, A) };
      }, setAnimation: function(x, M) {
        M.renderer.globalAnimation = N(x, M.options.chart.animation, !0);
      }, stop: w };
    }), a(e, "Core/Renderer/HTML/AST.js", [e["Core/Globals.js"], e["Core/Utilities.js"]], function(o, n) {
      let { SVG_NS: r, win: T } = o, { attr: O, createElement: j, css: D, error: F, isFunction: B, isString: N, objectEach: f, splat: w } = n, { trustedTypes: x } = T, M = x && B(x.createPolicy) && x.createPolicy("highcharts", { createHTML: (m) => m }), p = M ? M.createHTML("") : "", v = function() {
        try {
          return !!new DOMParser().parseFromString(p, "text/html");
        } catch {
          return !1;
        }
      }();
      class k {
        static filterUserAttributes(A) {
          return f(A, (C, H) => {
            let G = !0;
            k.allowedAttributes.indexOf(H) === -1 && (G = !1), ["background", "dynsrc", "href", "lowsrc", "src"].indexOf(H) !== -1 && (G = N(C) && k.allowedReferences.some((P) => C.indexOf(P) === 0)), G || (F(33, !1, void 0, { "Invalid attribute in config": `${H}` }), delete A[H]), N(C) && A[H] && (A[H] = C.replace(/</g, "&lt;"));
          }), A;
        }
        static parseStyle(A) {
          return A.split(";").reduce((C, H) => {
            let G = H.split(":").map((y) => y.trim()), P = G.shift();
            return P && G.length && (C[P.replace(/-([a-z])/g, (y) => y[1].toUpperCase())] = G.join(":")), C;
          }, {});
        }
        static setElementHTML(A, C) {
          A.innerHTML = k.emptyHTML, C && new k(C).addToDOM(A);
        }
        constructor(A) {
          this.nodes = typeof A == "string" ? this.parseMarkup(A) : A;
        }
        addToDOM(A) {
          return function C(H, G) {
            let P;
            return w(H).forEach(function(y) {
              let S, d = y.tagName, s = y.textContent ? o.doc.createTextNode(y.textContent) : void 0, l = k.bypassHTMLFiltering;
              if (d)
                if (d === "#text") S = s;
                else if (k.allowedTags.indexOf(d) !== -1 || l) {
                  let b = d === "svg" ? r : G.namespaceURI || r, u = o.doc.createElementNS(b, d), c = y.attributes || {};
                  f(y, function(h, g) {
                    g !== "tagName" && g !== "attributes" && g !== "children" && g !== "style" && g !== "textContent" && (c[g] = h);
                  }), O(u, l ? c : k.filterUserAttributes(c)), y.style && D(u, y.style), s && u.appendChild(s), C(y.children || [], u), S = u;
                } else F(33, !1, void 0, { "Invalid tagName in config": d });
              S && G.appendChild(S), P = S;
            }), P;
          }(this.nodes, A);
        }
        parseMarkup(A) {
          let C, H = [];
          if (A = A.trim().replace(/ style=(["'])/g, " data-style=$1"), v) C = new DOMParser().parseFromString(M ? M.createHTML(A) : A, "text/html");
          else {
            let P = j("div");
            P.innerHTML = A, C = { body: P };
          }
          let G = (P, y) => {
            let S = P.nodeName.toLowerCase(), d = { tagName: S };
            S === "#text" && (d.textContent = P.textContent || "");
            let s = P.attributes;
            if (s) {
              let l = {};
              [].forEach.call(s, (b) => {
                b.name === "data-style" ? d.style = k.parseStyle(b.value) : l[b.name] = b.value;
              }), d.attributes = l;
            }
            if (P.childNodes.length) {
              let l = [];
              [].forEach.call(P.childNodes, (b) => {
                G(b, l);
              }), l.length && (d.children = l);
            }
            y.push(d);
          };
          return [].forEach.call(C.body.childNodes, (P) => G(P, H)), H;
        }
      }
      return k.allowedAttributes = ["alt", "aria-controls", "aria-describedby", "aria-expanded", "aria-haspopup", "aria-hidden", "aria-label", "aria-labelledby", "aria-live", "aria-pressed", "aria-readonly", "aria-roledescription", "aria-selected", "class", "clip-path", "color", "colspan", "cx", "cy", "d", "dx", "dy", "disabled", "fill", "filterUnits", "flood-color", "flood-opacity", "height", "href", "id", "in", "in2", "markerHeight", "markerWidth", "offset", "opacity", "operator", "orient", "padding", "paddingLeft", "paddingRight", "patternUnits", "r", "radius", "refX", "refY", "role", "scope", "slope", "src", "startOffset", "stdDeviation", "stroke", "stroke-linecap", "stroke-width", "style", "tableValues", "result", "rowspan", "summary", "target", "tabindex", "text-align", "text-anchor", "textAnchor", "textLength", "title", "type", "valign", "width", "x", "x1", "x2", "xlink:href", "y", "y1", "y2", "zIndex"], k.allowedReferences = ["https://", "http://", "mailto:", "/", "../", "./", "#"], k.allowedTags = ["a", "abbr", "b", "br", "button", "caption", "circle", "clipPath", "code", "dd", "defs", "div", "dl", "dt", "em", "feComponentTransfer", "feComposite", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feMorphology", "feOffset", "feMerge", "feMergeNode", "filter", "h1", "h2", "h3", "h4", "h5", "h6", "hr", "i", "img", "li", "linearGradient", "marker", "ol", "p", "path", "pattern", "pre", "rect", "small", "span", "stop", "strong", "style", "sub", "sup", "svg", "table", "text", "textPath", "thead", "title", "tbody", "tspan", "td", "th", "tr", "u", "ul", "#text"], k.emptyHTML = p, k.bypassHTMLFiltering = !1, k;
    }), a(e, "Core/Templating.js", [e["Core/Defaults.js"], e["Core/Utilities.js"]], function(o, n) {
      let { defaultOptions: r, defaultTime: T } = o, { extend: O, getNestedProperty: j, isArray: D, isNumber: F, isObject: B, pick: N, pInt: f } = n, w = { add: (p, v) => p + v, divide: (p, v) => v !== 0 ? p / v : "", eq: (p, v) => p == v, each: function(p) {
        let v = arguments[arguments.length - 1];
        return !!D(p) && p.map((k, m) => x(v.body, O(B(k) ? k : { "@this": k }, { "@index": m, "@first": m === 0, "@last": m === p.length - 1 }))).join("");
      }, ge: (p, v) => p >= v, gt: (p, v) => p > v, if: (p) => !!p, le: (p, v) => p <= v, lt: (p, v) => p < v, multiply: (p, v) => p * v, ne: (p, v) => p != v, subtract: (p, v) => p - v, unless: (p) => !p };
      function x(p = "", v, k) {
        let m = /\{([\w\:\.\,;\-\/<>%@"'’= #\(\)]+)\}/g, A = /\(([\w\:\.\,;\-\/<>%@"'= ]+)\)/g, C = [], H = /f$/, G = /\.(\d)/, P = r.lang, y = k && k.time || T, S = k && k.numberFormatter || M, d = (c = "") => {
          let h;
          return c === "true" || c !== "false" && ((h = Number(c)).toString() === c ? h : j(c, v));
        }, s, l, b = 0, u;
        for (; (s = m.exec(p)) !== null; ) {
          let c = A.exec(s[1]);
          c && (s = c, u = !0), l && l.isBlock || (l = { ctx: v, expression: s[1], find: s[0], isBlock: s[1].charAt(0) === "#", start: s.index, startInner: s.index + s[0].length, length: s[0].length });
          let h = s[1].split(" ")[0].replace("#", "");
          w[h] && (l.isBlock && h === l.fn && b++, l.fn || (l.fn = h));
          let g = s[1] === "else";
          if (l.isBlock && l.fn && (s[1] === `/${l.fn}` || g))
            if (b) !g && b--;
            else {
              let E = l.startInner, R = p.substr(E, s.index - E);
              l.body === void 0 ? (l.body = R, l.startInner = s.index + s[0].length) : l.elseBody = R, l.find += R + s[0], g || (C.push(l), l = void 0);
            }
          else l.isBlock || C.push(l);
          if (c && !(l != null && l.isBlock)) break;
        }
        return C.forEach((c) => {
          let h, g, { body: E, elseBody: R, expression: L, fn: U } = c;
          if (U) {
            let V = [c], q = L.split(" ");
            for (g = w[U].length; g--; ) V.unshift(d(q[g + 1]));
            h = w[U].apply(v, V), c.isBlock && typeof h == "boolean" && (h = x(h ? E : R, v, k));
          } else {
            let V = L.split(":");
            if (h = d(V.shift() || ""), V.length && typeof h == "number") {
              let q = V.join(":");
              if (H.test(q)) {
                let Y = parseInt((q.match(G) || ["", "-1"])[1], 10);
                h !== null && (h = S(h, Y, P.decimalPoint, q.indexOf(",") > -1 ? P.thousandsSep : ""));
              } else h = y.dateFormat(q, h);
            }
          }
          p = p.replace(c.find, N(h, ""));
        }), u ? x(p, v, k) : p;
      }
      function M(p, v, k, m) {
        let A, C;
        p = +p || 0, v = +v;
        let H = r.lang, G = (p.toString().split(".")[1] || "").split("e")[0].length, P = p.toString().split("e"), y = v;
        v === -1 ? v = Math.min(G, 20) : F(v) ? v && P[1] && P[1] < 0 && ((C = v + +P[1]) >= 0 ? (P[0] = (+P[0]).toExponential(C).split("e")[0], v = C) : (P[0] = P[0].split(".")[0] || 0, p = v < 20 ? (P[0] * Math.pow(10, P[1])).toFixed(v) : 0, P[1] = 0)) : v = 2;
        let S = (Math.abs(P[1] ? P[0] : p) + Math.pow(10, -Math.max(v, G) - 1)).toFixed(v), d = String(f(S)), s = d.length > 3 ? d.length % 3 : 0;
        return k = N(k, H.decimalPoint), m = N(m, H.thousandsSep), A = (p < 0 ? "-" : "") + (s ? d.substr(0, s) + m : ""), 0 > +P[1] && !y ? A = "0" : A += d.substr(s).replace(/(\d{3})(?=\d)/g, "$1" + m), v ? A += k + S.slice(-v) : +A == 0 && (A = "0"), P[1] && +A != 0 && (A += "e" + P[1]), A;
      }
      return { dateFormat: function(p, v, k) {
        return T.dateFormat(p, v, k);
      }, format: x, helpers: w, numberFormat: M };
    }), a(e, "Core/Renderer/RendererRegistry.js", [e["Core/Globals.js"]], function(o) {
      var n, r;
      let T;
      return (r = n || (n = {})).rendererTypes = {}, r.getRendererType = function(O = T) {
        return r.rendererTypes[O] || r.rendererTypes[T];
      }, r.registerRendererType = function(O, j, D) {
        r.rendererTypes[O] = j, (!T || D) && (T = O, o.Renderer = j);
      }, n;
    }), a(e, "Core/Renderer/RendererUtilities.js", [e["Core/Utilities.js"]], function(o) {
      var n;
      let { clamp: r, pick: T, pushUnique: O, stableSort: j } = o;
      return (n || (n = {})).distribute = function D(F, B, N) {
        let f = F, w = f.reducedLen || B, x = (d, s) => d.target - s.target, M = [], p = F.length, v = [], k = M.push, m, A, C, H = !0, G, P, y = 0, S;
        for (m = p; m--; ) y += F[m].size;
        if (y > w) {
          for (j(F, (d, s) => (s.rank || 0) - (d.rank || 0)), C = (S = F[0].rank === F[F.length - 1].rank) ? p / 2 : -1, A = S ? C : p - 1; C && y > w; ) G = F[m = Math.floor(A)], O(v, m) && (y -= G.size), A += C, S && A >= F.length && (C /= 2, A = C);
          v.sort((d, s) => s - d).forEach((d) => k.apply(M, F.splice(d, 1)));
        }
        for (j(F, x), F = F.map((d) => ({ size: d.size, targets: [d.target], align: T(d.align, 0.5) })); H; ) {
          for (m = F.length; m--; ) G = F[m], P = (Math.min.apply(0, G.targets) + Math.max.apply(0, G.targets)) / 2, G.pos = r(P - G.size * G.align, 0, B - G.size);
          for (m = F.length, H = !1; m--; ) m > 0 && F[m - 1].pos + F[m - 1].size > F[m].pos && (F[m - 1].size += F[m].size, F[m - 1].targets = F[m - 1].targets.concat(F[m].targets), F[m - 1].align = 0.5, F[m - 1].pos + F[m - 1].size > B && (F[m - 1].pos = B - F[m - 1].size), F.splice(m, 1), H = !0);
        }
        return k.apply(f, M), m = 0, F.some((d) => {
          let s = 0;
          return (d.targets || []).some(() => (f[m].pos = d.pos + s, N !== void 0 && Math.abs(f[m].pos - f[m].target) > N ? (f.slice(0, m + 1).forEach((l) => delete l.pos), f.reducedLen = (f.reducedLen || B) - 0.1 * B, f.reducedLen > 0.1 * B && D(f, B, N), !0) : (s += f[m].size, m++, !1)));
        }), j(f, x), f;
      }, n;
    }), a(e, "Core/Renderer/SVG/SVGElement.js", [e["Core/Animation/AnimationUtilities.js"], e["Core/Color/Color.js"], e["Core/Globals.js"], e["Core/Utilities.js"]], function(o, n, r, T) {
      let { animate: O, animObject: j, stop: D } = o, { deg2rad: F, doc: B, svg: N, SVG_NS: f, win: w } = r, { addEvent: x, attr: M, createElement: p, crisp: v, css: k, defined: m, erase: A, extend: C, fireEvent: H, isArray: G, isFunction: P, isObject: y, isString: S, merge: d, objectEach: s, pick: l, pInt: b, pushUnique: u, replaceNested: c, syncTimeout: h, uniqueKey: g } = T;
      class E {
        _defaultGetter(L) {
          let U = l(this[L + "Value"], this[L], this.element ? this.element.getAttribute(L) : null, 0);
          return /^-?[\d\.]+$/.test(U) && (U = parseFloat(U)), U;
        }
        _defaultSetter(L, U, V) {
          V.setAttribute(U, L);
        }
        add(L) {
          let U, V = this.renderer, q = this.element;
          return L && (this.parentGroup = L), this.textStr !== void 0 && this.element.nodeName === "text" && V.buildText(this), this.added = !0, (!L || L.handleZ || this.zIndex) && (U = this.zIndexSetter()), U || (L ? L.element : V.box).appendChild(q), this.onAdd && this.onAdd(), this;
        }
        addClass(L, U) {
          let V = U ? "" : this.attr("class") || "";
          return (L = (L || "").split(/ /g).reduce(function(q, Y) {
            return V.indexOf(Y) === -1 && q.push(Y), q;
          }, V ? [V] : []).join(" ")) !== V && this.attr("class", L), this;
        }
        afterSetters() {
          this.doTransform && (this.updateTransform(), this.doTransform = !1);
        }
        align(L, U, V, q = !0) {
          let Y, I, _, W, X = {}, z = this.renderer, $ = z.alignedObjects, K = !!L;
          L ? (this.alignOptions = L, this.alignByTranslate = U, this.alignTo = V) : (L = this.alignOptions || {}, U = this.alignByTranslate, V = this.alignTo);
          let Q = !V || S(V) ? V || "renderer" : void 0;
          Q && (K && u($, this), V = void 0);
          let Z = l(V, z[Q], z), ee = L.align, J = L.verticalAlign;
          return Y = (Z.x || 0) + (L.x || 0), I = (Z.y || 0) + (L.y || 0), ee === "right" ? _ = 1 : ee === "center" && (_ = 2), _ && (Y += ((Z.width || 0) - (L.width || 0)) / _), X[U ? "translateX" : "x"] = Math.round(Y), J === "bottom" ? W = 1 : J === "middle" && (W = 2), W && (I += ((Z.height || 0) - (L.height || 0)) / W), X[U ? "translateY" : "y"] = Math.round(I), q && (this[this.placed ? "animate" : "attr"](X), this.placed = !0), this.alignAttr = X, this;
        }
        alignSetter(L) {
          let U = { left: "start", center: "middle", right: "end" };
          U[L] && (this.alignValue = L, this.element.setAttribute("text-anchor", U[L]));
        }
        animate(L, U, V) {
          let q = j(l(U, this.renderer.globalAnimation, !0)), Y = q.defer;
          return B.hidden && (q.duration = 0), q.duration !== 0 ? (V && (q.complete = V), h(() => {
            this.element && O(this, L, q);
          }, Y)) : (this.attr(L, void 0, V || q.complete), s(L, function(I, _) {
            q.step && q.step.call(this, I, { prop: _, pos: 1, elem: this });
          }, this)), this;
        }
        applyTextOutline(L) {
          let U = this.element;
          L.indexOf("contrast") !== -1 && (L = L.replace(/contrast/g, this.renderer.getContrast(U.style.fill)));
          let V = L.split(" "), q = V[V.length - 1], Y = V[0];
          if (Y && Y !== "none" && r.svg) {
            this.fakeTS = !0, Y = Y.replace(/(^[\d\.]+)(.*?)$/g, function(z, $, K) {
              return 2 * Number($) + K;
            }), this.removeTextOutline();
            let I = B.createElementNS(f, "tspan");
            M(I, { class: "highcharts-text-outline", fill: q, stroke: q, "stroke-width": Y, "stroke-linejoin": "round" });
            let _ = U.querySelector("textPath") || U;
            [].forEach.call(_.childNodes, (z) => {
              let $ = z.cloneNode(!0);
              $.removeAttribute && ["fill", "stroke", "stroke-width", "stroke"].forEach((K) => $.removeAttribute(K)), I.appendChild($);
            });
            let W = 0;
            [].forEach.call(_.querySelectorAll("text tspan"), (z) => {
              W += Number(z.getAttribute("dy"));
            });
            let X = B.createElementNS(f, "tspan");
            X.textContent = "​", M(X, { x: Number(U.getAttribute("x")), dy: -W }), I.appendChild(X), _.insertBefore(I, _.firstChild);
          }
        }
        attr(L, U, V, q) {
          let { element: Y } = this, I = E.symbolCustomAttribs, _, W, X = this, z;
          return typeof L == "string" && U !== void 0 && (_ = L, (L = {})[_] = U), typeof L == "string" ? X = (this[L + "Getter"] || this._defaultGetter).call(this, L, Y) : (s(L, function($, K) {
            z = !1, q || D(this, K), this.symbolName && I.indexOf(K) !== -1 && (W || (this.symbolAttr(L), W = !0), z = !0), this.rotation && (K === "x" || K === "y") && (this.doTransform = !0), z || (this[K + "Setter"] || this._defaultSetter).call(this, $, K, Y);
          }, this), this.afterSetters()), V && V.call(this), X;
        }
        clip(L) {
          if (L && !L.clipPath) {
            let U = g() + "-", V = this.renderer.createElement("clipPath").attr({ id: U }).add(this.renderer.defs);
            C(L, { clipPath: V, id: U, count: 0 }), L.add(V);
          }
          return this.attr("clip-path", L ? `url(${this.renderer.url}#${L.id})` : "none");
        }
        crisp(L, U) {
          U = Math.round(U || L.strokeWidth || 0);
          let V = L.x || this.x || 0, q = L.y || this.y || 0, Y = (L.width || this.width || 0) + V, I = (L.height || this.height || 0) + q, _ = v(V, U), W = v(q, U);
          return C(L, { x: _, y: W, width: v(Y, U) - _, height: v(I, U) - W }), m(L.strokeWidth) && (L.strokeWidth = U), L;
        }
        complexColor(L, U, V) {
          let q = this.renderer, Y, I, _, W, X, z, $, K, Q, Z, ee = [], J;
          H(this.renderer, "complexColor", { args: arguments }, function() {
            if (L.radialGradient ? I = "radialGradient" : L.linearGradient && (I = "linearGradient"), I) {
              if (_ = L[I], X = q.gradients, z = L.stops, Q = V.radialReference, G(_) && (L[I] = _ = { x1: _[0], y1: _[1], x2: _[2], y2: _[3], gradientUnits: "userSpaceOnUse" }), I === "radialGradient" && Q && !m(_.gradientUnits) && (W = _, _ = d(_, q.getRadialAttr(Q, W), { gradientUnits: "userSpaceOnUse" })), s(_, function(ae, re) {
                re !== "id" && ee.push(re, ae);
              }), s(z, function(ae) {
                ee.push(ae);
              }), X[ee = ee.join(",")]) Z = X[ee].attr("id");
              else {
                _.id = Z = g();
                let ae = X[ee] = q.createElement(I).attr(_).add(q.defs);
                ae.radAttr = W, ae.stops = [], z.forEach(function(re) {
                  re[1].indexOf("rgba") === 0 ? ($ = (Y = n.parse(re[1])).get("rgb"), K = Y.get("a")) : ($ = re[1], K = 1);
                  let ce = q.createElement("stop").attr({ offset: re[0], "stop-color": $, "stop-opacity": K }).add(ae);
                  ae.stops.push(ce);
                });
              }
              J = "url(" + q.url + "#" + Z + ")", V.setAttribute(U, J), V.gradient = ee, L.toString = function() {
                return J;
              };
            }
          });
        }
        css(L) {
          let U = this.styles, V = {}, q = this.element, Y, I = !U;
          if (U && s(L, function(_, W) {
            U && U[W] !== _ && (V[W] = _, I = !0);
          }), I) {
            U && (L = C(U, V)), L.width === null || L.width === "auto" ? delete this.textWidth : q.nodeName.toLowerCase() === "text" && L.width && (Y = this.textWidth = b(L.width)), C(this.styles, L), Y && !N && this.renderer.forExport && delete L.width;
            let _ = d(L);
            q.namespaceURI === this.SVG_NS && (["textOutline", "textOverflow", "width"].forEach((W) => _ && delete _[W]), _.color && (_.fill = _.color)), k(q, _);
          }
          return this.added && (this.element.nodeName === "text" && this.renderer.buildText(this), L.textOutline && this.applyTextOutline(L.textOutline)), this;
        }
        dashstyleSetter(L) {
          let U, V = this["stroke-width"];
          if (V === "inherit" && (V = 1), L = L && L.toLowerCase()) {
            let q = L.replace("shortdashdotdot", "3,1,1,1,1,1,").replace("shortdashdot", "3,1,1,1").replace("shortdot", "1,1,").replace("shortdash", "3,1,").replace("longdash", "8,3,").replace(/dot/g, "1,3,").replace("dash", "4,3,").replace(/,$/, "").split(",");
            for (U = q.length; U--; ) q[U] = "" + b(q[U]) * l(V, NaN);
            L = q.join(",").replace(/NaN/g, "none"), this.element.setAttribute("stroke-dasharray", L);
          }
        }
        destroy() {
          var W;
          let L = this, U = L.element || {}, V = L.renderer, q = U.ownerSVGElement, Y = U.nodeName === "SPAN" && L.parentGroup || void 0, I, _;
          if (U.onclick = U.onmouseout = U.onmouseover = U.onmousemove = U.point = null, D(L), L.clipPath && q) {
            let X = L.clipPath;
            [].forEach.call(q.querySelectorAll("[clip-path],[CLIP-PATH]"), function(z) {
              z.getAttribute("clip-path").indexOf(X.element.id) > -1 && z.removeAttribute("clip-path");
            }), L.clipPath = X.destroy();
          }
          if (L.connector = (W = L.connector) == null ? void 0 : W.destroy(), L.stops) {
            for (_ = 0; _ < L.stops.length; _++) L.stops[_].destroy();
            L.stops.length = 0, L.stops = void 0;
          }
          for (L.safeRemoveChild(U); Y && Y.div && Y.div.childNodes.length === 0; ) I = Y.parentGroup, L.safeRemoveChild(Y.div), delete Y.div, Y = I;
          L.alignOptions && A(V.alignedObjects, L), s(L, function(X, z) {
            L[z] && L[z].parentGroup === L && L[z].destroy && L[z].destroy(), delete L[z];
          });
        }
        dSetter(L, U, V) {
          G(L) && (typeof L[0] == "string" && (L = this.renderer.pathToSegments(L)), this.pathArray = L, L = L.reduce((q, Y, I) => Y && Y.join ? (I ? q + " " : "") + Y.join(" ") : (Y || "").toString(), "")), /(NaN| {2}|^$)/.test(L) && (L = "M 0 0"), this[U] !== L && (V.setAttribute(U, L), this[U] = L);
        }
        fillSetter(L, U, V) {
          typeof L == "string" ? V.setAttribute(U, L) : L && this.complexColor(L, U, V);
        }
        hrefSetter(L, U, V) {
          V.setAttributeNS("http://www.w3.org/1999/xlink", U, L);
        }
        getBBox(L, U) {
          let V, q, Y, I, { alignValue: _, element: W, renderer: X, styles: z, textStr: $ } = this, { cache: K, cacheKeys: Q } = X, Z = W.namespaceURI === this.SVG_NS, ee = l(U, this.rotation, 0), J = X.styledMode ? W && E.prototype.getStyle.call(W, "font-size") : z.fontSize;
          if (m($) && ((I = $.toString()).indexOf("<") === -1 && (I = I.replace(/\d/g, "0")), I += ["", X.rootFontSize, J, ee, this.textWidth, _, z.textOverflow, z.fontWeight].join(",")), I && !L && (V = K[I]), !V || V.polygon) {
            if (Z || X.forExport) {
              try {
                Y = this.fakeTS && function(re) {
                  let ce = W.querySelector(".highcharts-text-outline");
                  ce && k(ce, { display: re });
                }, P(Y) && Y("none"), V = W.getBBox ? C({}, W.getBBox()) : { width: W.offsetWidth, height: W.offsetHeight, x: 0, y: 0 }, P(Y) && Y("");
              } catch {
              }
              (!V || V.width < 0) && (V = { x: 0, y: 0, width: 0, height: 0 });
            } else V = this.htmlGetBBox();
            q = V.height, Z && (V.height = q = { "11px,17": 14, "13px,20": 16 }[`${J || ""},${Math.round(q)}`] || q), ee && (V = this.getRotatedBox(V, ee));
            let ae = { bBox: V };
            H(this, "afterGetBBox", ae), V = ae.bBox;
          }
          if (I && ($ === "" || V.height > 0)) {
            for (; Q.length > 250; ) delete K[Q.shift()];
            K[I] || Q.push(I), K[I] = V;
          }
          return V;
        }
        getRotatedBox(L, U) {
          let { x: V, y: q, width: Y, height: I } = L, { alignValue: _, translateY: W, rotationOriginX: X = 0, rotationOriginY: z = 0 } = this, $ = { right: 1, center: 0.5 }[_ || 0] || 0, K = Number(this.element.getAttribute("y") || 0) - (W ? 0 : q), Q = U * F, Z = (U - 90) * F, ee = Math.cos(Q), J = Math.sin(Q), ae = Y * ee, re = Y * J, ce = Math.cos(Z), he = Math.sin(Z), [[ne, te], [se, oe]] = [X, z].map((Me) => [Me - Me * ee, Me * J]), ie = V + $ * (Y - ae) + ne + oe + K * ce, le = ie + ae, de = le - I * ce, be = de - ae, ge = q + K - $ * re - te + se + K * he, me = ge + re, fe = me - I * he, Ae = fe - re, ye = Math.min(ie, le, de, be), xe = Math.min(ge, me, fe, Ae), we = Math.max(ie, le, de, be) - ye, ke = Math.max(ge, me, fe, Ae) - xe;
          return { x: ye, y: xe, width: we, height: ke, polygon: [[ie, ge], [le, me], [de, fe], [be, Ae]] };
        }
        getStyle(L) {
          return w.getComputedStyle(this.element || this, "").getPropertyValue(L);
        }
        hasClass(L) {
          return ("" + this.attr("class")).split(" ").indexOf(L) !== -1;
        }
        hide() {
          return this.attr({ visibility: "hidden" });
        }
        htmlGetBBox() {
          return { height: 0, width: 0, x: 0, y: 0 };
        }
        constructor(L, U) {
          this.onEvents = {}, this.opacity = 1, this.SVG_NS = f, this.element = U === "span" || U === "body" ? p(U) : B.createElementNS(this.SVG_NS, U), this.renderer = L, this.styles = {}, H(this, "afterInit");
        }
        on(L, U) {
          let { onEvents: V } = this;
          return V[L] && V[L](), V[L] = x(this.element, L, U), this;
        }
        opacitySetter(L, U, V) {
          let q = Number(Number(L).toFixed(3));
          this.opacity = q, V.setAttribute(U, q);
        }
        reAlign() {
          var L;
          (L = this.alignOptions) != null && L.width && this.alignOptions.align !== "left" && (this.alignOptions.width = this.getBBox().width, this.placed = !1, this.align());
        }
        removeClass(L) {
          return this.attr("class", ("" + this.attr("class")).replace(S(L) ? RegExp(`(^| )${L}( |$)`) : L, " ").replace(/ +/g, " ").trim());
        }
        removeTextOutline() {
          let L = this.element.querySelector("tspan.highcharts-text-outline");
          L && this.safeRemoveChild(L);
        }
        safeRemoveChild(L) {
          let U = L.parentNode;
          U && U.removeChild(L);
        }
        setRadialReference(L) {
          let U = this.element.gradient && this.renderer.gradients[this.element.gradient];
          return this.element.radialReference = L, U && U.radAttr && U.animate(this.renderer.getRadialAttr(L, U.radAttr)), this;
        }
        shadow(L) {
          var Y;
          let { renderer: U } = this, V = d(((Y = this.parentGroup) == null ? void 0 : Y.rotation) === 90 ? { offsetX: -1, offsetY: -1 } : {}, y(L) ? L : {}), q = U.shadowDefinition(V);
          return this.attr({ filter: L ? `url(${U.url}#${q})` : "none" });
        }
        show(L = !0) {
          return this.attr({ visibility: L ? "inherit" : "visible" });
        }
        "stroke-widthSetter"(L, U, V) {
          this[U] = L, V.setAttribute(U, L);
        }
        strokeWidth() {
          if (!this.renderer.styledMode) return this["stroke-width"] || 0;
          let L = this.getStyle("stroke-width"), U = 0, V;
          return /px$/.test(L) ? U = b(L) : L !== "" && (M(V = B.createElementNS(f, "rect"), { width: L, "stroke-width": 0 }), this.element.parentNode.appendChild(V), U = V.getBBox().width, V.parentNode.removeChild(V)), U;
        }
        symbolAttr(L) {
          let U = this;
          E.symbolCustomAttribs.forEach(function(V) {
            U[V] = l(L[V], U[V]);
          }), U.attr({ d: U.renderer.symbols[U.symbolName](U.x, U.y, U.width, U.height, U) });
        }
        textSetter(L) {
          L !== this.textStr && (delete this.textPxLength, this.textStr = L, this.added && this.renderer.buildText(this), this.reAlign());
        }
        titleSetter(L) {
          let U = this.element, V = U.getElementsByTagName("title")[0] || B.createElementNS(this.SVG_NS, "title");
          U.insertBefore ? U.insertBefore(V, U.firstChild) : U.appendChild(V), V.textContent = c(l(L, ""), [/<[^>]*>/g, ""]).replace(/&lt;/g, "<").replace(/&gt;/g, ">");
        }
        toFront() {
          let L = this.element;
          return L.parentNode.appendChild(L), this;
        }
        translate(L, U) {
          return this.attr({ translateX: L, translateY: U });
        }
        updateTransform(L = "transform") {
          var K;
          let { element: U, matrix: V, rotation: q = 0, rotationOriginX: Y, rotationOriginY: I, scaleX: _, scaleY: W, translateX: X = 0, translateY: z = 0 } = this, $ = ["translate(" + X + "," + z + ")"];
          m(V) && $.push("matrix(" + V.join(",") + ")"), q && ($.push("rotate(" + q + " " + l(Y, U.getAttribute("x"), 0) + " " + l(I, U.getAttribute("y") || 0) + ")"), ((K = this.text) == null ? void 0 : K.element.tagName) === "SPAN" && this.text.attr({ rotation: q, rotationOriginX: (Y || 0) - this.padding, rotationOriginY: (I || 0) - this.padding })), (m(_) || m(W)) && $.push("scale(" + l(_, 1) + " " + l(W, 1) + ")"), $.length && !(this.text || this).textPath && U.setAttribute(L, $.join(" "));
        }
        visibilitySetter(L, U, V) {
          L === "inherit" ? V.removeAttribute(U) : this[U] !== L && V.setAttribute(U, L), this[U] = L;
        }
        xGetter(L) {
          return this.element.nodeName === "circle" && (L === "x" ? L = "cx" : L === "y" && (L = "cy")), this._defaultGetter(L);
        }
        zIndexSetter(L, U) {
          let V = this.renderer, q = this.parentGroup, Y = (q || V).element || V.box, I = this.element, _ = Y === V.box, W, X, z, $ = !1, K, Q = this.added, Z;
          if (m(L) ? (I.setAttribute("data-z-index", L), L = +L, this[U] === L && (Q = !1)) : m(this[U]) && I.removeAttribute("data-z-index"), this[U] = L, Q) {
            for ((L = this.zIndex) && q && (q.handleZ = !0), Z = (W = Y.childNodes).length - 1; Z >= 0 && !$; Z--) K = !m(z = (X = W[Z]).getAttribute("data-z-index")), X !== I && (L < 0 && K && !_ && !Z ? (Y.insertBefore(I, W[Z]), $ = !0) : (b(z) <= L || K && (!m(L) || L >= 0)) && (Y.insertBefore(I, W[Z + 1]), $ = !0));
            $ || (Y.insertBefore(I, W[_ ? 3 : 0]), $ = !0);
          }
          return $;
        }
      }
      return E.symbolCustomAttribs = ["anchorX", "anchorY", "clockwise", "end", "height", "innerR", "r", "start", "width", "x", "y"], E.prototype.strokeSetter = E.prototype.fillSetter, E.prototype.yGetter = E.prototype.xGetter, E.prototype.matrixSetter = E.prototype.rotationOriginXSetter = E.prototype.rotationOriginYSetter = E.prototype.rotationSetter = E.prototype.scaleXSetter = E.prototype.scaleYSetter = E.prototype.translateXSetter = E.prototype.translateYSetter = E.prototype.verticalAlignSetter = function(R, L) {
        this[L] = R, this.doTransform = !0;
      }, E;
    }), a(e, "Core/Renderer/SVG/SVGLabel.js", [e["Core/Renderer/SVG/SVGElement.js"], e["Core/Utilities.js"]], function(o, n) {
      let { defined: r, extend: T, isNumber: O, merge: j, pick: D, removeEvent: F } = n;
      class B extends o {
        constructor(f, w, x, M, p, v, k, m, A, C) {
          let H;
          super(f, "g"), this.paddingLeftSetter = this.paddingSetter, this.paddingRightSetter = this.paddingSetter, this.doUpdate = !1, this.textStr = w, this.x = x, this.y = M, this.anchorX = v, this.anchorY = k, this.baseline = A, this.className = C, this.addClass(C === "button" ? "highcharts-no-tooltip" : "highcharts-label"), C && this.addClass("highcharts-" + C), this.text = f.text(void 0, 0, 0, m).attr({ zIndex: 1 }), typeof p == "string" && ((H = /^url\((.*?)\)$/.test(p)) || this.renderer.symbols[p]) && (this.symbolKey = p), this.bBox = B.emptyBBox, this.padding = 3, this.baselineOffset = 0, this.needsBox = f.styledMode || H, this.deferredAttr = {}, this.alignFactor = 0;
        }
        alignSetter(f) {
          let w = { left: 0, center: 0.5, right: 1 }[f];
          w !== this.alignFactor && (this.alignFactor = w, this.bBox && O(this.xSetting) && this.attr({ x: this.xSetting }));
        }
        anchorXSetter(f, w) {
          this.anchorX = f, this.boxAttr(w, Math.round(f) - this.getCrispAdjust() - this.xSetting);
        }
        anchorYSetter(f, w) {
          this.anchorY = f, this.boxAttr(w, f - this.ySetting);
        }
        boxAttr(f, w) {
          this.box ? this.box.attr(f, w) : this.deferredAttr[f] = w;
        }
        css(f) {
          if (f) {
            let w = {};
            f = j(f), B.textProps.forEach((x) => {
              f[x] !== void 0 && (w[x] = f[x], delete f[x]);
            }), this.text.css(w), "fontSize" in w || "fontWeight" in w ? this.updateTextPadding() : ("width" in w || "textOverflow" in w) && this.updateBoxSize();
          }
          return o.prototype.css.call(this, f);
        }
        destroy() {
          F(this.element, "mouseenter"), F(this.element, "mouseleave"), this.text && this.text.destroy(), this.box && (this.box = this.box.destroy()), o.prototype.destroy.call(this);
        }
        fillSetter(f, w) {
          f && (this.needsBox = !0), this.fill = f, this.boxAttr(w, f);
        }
        getBBox(f, w) {
          this.textStr && this.bBox.width === 0 && this.bBox.height === 0 && this.updateBoxSize();
          let { padding: x, height: M = 0, translateX: p = 0, translateY: v = 0, width: k = 0 } = this, m = D(this.paddingLeft, x), A = w != null ? w : this.rotation || 0, C = { width: k, height: M, x: p + this.bBox.x - m, y: v + this.bBox.y - x + this.baselineOffset };
          return A && (C = this.getRotatedBox(C, A)), C;
        }
        getCrispAdjust() {
          return (this.renderer.styledMode && this.box ? this.box.strokeWidth() : this["stroke-width"] ? parseInt(this["stroke-width"], 10) : 0) % 2 / 2;
        }
        heightSetter(f) {
          this.heightSetting = f, this.doUpdate = !0;
        }
        afterSetters() {
          super.afterSetters(), this.doUpdate && (this.updateBoxSize(), this.doUpdate = !1);
        }
        onAdd() {
          this.text.add(this), this.attr({ text: D(this.textStr, ""), x: this.x || 0, y: this.y || 0 }), this.box && r(this.anchorX) && this.attr({ anchorX: this.anchorX, anchorY: this.anchorY });
        }
        paddingSetter(f, w) {
          O(f) ? f !== this[w] && (this[w] = f, this.updateTextPadding()) : this[w] = void 0;
        }
        rSetter(f, w) {
          this.boxAttr(w, f);
        }
        strokeSetter(f, w) {
          this.stroke = f, this.boxAttr(w, f);
        }
        "stroke-widthSetter"(f, w) {
          f && (this.needsBox = !0), this["stroke-width"] = f, this.boxAttr(w, f);
        }
        "text-alignSetter"(f) {
          this.textAlign = f;
        }
        textSetter(f) {
          f !== void 0 && this.text.attr({ text: f }), this.updateTextPadding(), this.reAlign();
        }
        updateBoxSize() {
          let f, w = this.text, x = {}, M = this.padding, p = this.bBox = (!O(this.widthSetting) || !O(this.heightSetting) || this.textAlign) && r(w.textStr) ? w.getBBox(void 0, 0) : B.emptyBBox;
          this.width = this.getPaddedWidth(), this.height = (this.heightSetting || p.height || 0) + 2 * M;
          let v = this.renderer.fontMetrics(w);
          if (this.baselineOffset = M + Math.min((this.text.firstLineMetrics || v).b, p.height || 1 / 0), this.heightSetting && (this.baselineOffset += (this.heightSetting - v.h) / 2), this.needsBox && !w.textPath) {
            if (!this.box) {
              let k = this.box = this.symbolKey ? this.renderer.symbol(this.symbolKey) : this.renderer.rect();
              k.addClass((this.className === "button" ? "" : "highcharts-label-box") + (this.className ? " highcharts-" + this.className + "-box" : "")), k.add(this);
            }
            f = this.getCrispAdjust(), x.x = f, x.y = (this.baseline ? -this.baselineOffset : 0) + f, x.width = Math.round(this.width), x.height = Math.round(this.height), this.box.attr(T(x, this.deferredAttr)), this.deferredAttr = {};
          }
        }
        updateTextPadding() {
          let f = this.text;
          if (!f.textPath) {
            this.updateBoxSize();
            let w = this.baseline ? 0 : this.baselineOffset, x = D(this.paddingLeft, this.padding);
            r(this.widthSetting) && this.bBox && (this.textAlign === "center" || this.textAlign === "right") && (x += { center: 0.5, right: 1 }[this.textAlign] * (this.widthSetting - this.bBox.width)), (x !== f.x || w !== f.y) && (f.attr("x", x), f.hasBoxWidthChanged && (this.bBox = f.getBBox(!0)), w !== void 0 && f.attr("y", w)), f.x = x, f.y = w;
          }
        }
        widthSetter(f) {
          this.widthSetting = O(f) ? f : void 0, this.doUpdate = !0;
        }
        getPaddedWidth() {
          let f = this.padding, w = D(this.paddingLeft, f), x = D(this.paddingRight, f);
          return (this.widthSetting || this.bBox.width || 0) + w + x;
        }
        xSetter(f) {
          this.x = f, this.alignFactor && (f -= this.alignFactor * this.getPaddedWidth(), this["forceAnimate:x"] = !0), this.xSetting = Math.round(f), this.attr("translateX", this.xSetting);
        }
        ySetter(f) {
          this.ySetting = this.y = Math.round(f), this.attr("translateY", this.ySetting);
        }
      }
      return B.emptyBBox = { width: 0, height: 0, x: 0, y: 0 }, B.textProps = ["color", "direction", "fontFamily", "fontSize", "fontStyle", "fontWeight", "lineHeight", "textAlign", "textDecoration", "textOutline", "textOverflow", "whiteSpace", "width"], B;
    }), a(e, "Core/Renderer/SVG/Symbols.js", [e["Core/Utilities.js"]], function(o) {
      let { defined: n, isNumber: r, pick: T } = o;
      function O(F, B, N, f, w) {
        let x = [];
        if (w) {
          let M = w.start || 0, p = T(w.r, N), v = T(w.r, f || N), k = 2e-4 / (w.borderRadius ? 1 : Math.max(p, 1)), m = Math.abs((w.end || 0) - M - 2 * Math.PI) < k, A = (w.end || 0) - (m ? k : 0), C = w.innerR, H = T(w.open, m), G = Math.cos(M), P = Math.sin(M), y = Math.cos(A), S = Math.sin(A), d = T(w.longArc, A - M - Math.PI < k ? 0 : 1), s = ["A", p, v, 0, d, T(w.clockwise, 1), F + p * y, B + v * S];
          s.params = { start: M, end: A, cx: F, cy: B }, x.push(["M", F + p * G, B + v * P], s), n(C) && ((s = ["A", C, C, 0, d, n(w.clockwise) ? 1 - w.clockwise : 0, F + C * G, B + C * P]).params = { start: A, end: M, cx: F, cy: B }, x.push(H ? ["M", F + C * y, B + C * S] : ["L", F + C * y, B + C * S], s)), H || x.push(["Z"]);
        }
        return x;
      }
      function j(F, B, N, f, w) {
        return w && w.r ? D(F, B, N, f, w) : [["M", F, B], ["L", F + N, B], ["L", F + N, B + f], ["L", F, B + f], ["Z"]];
      }
      function D(F, B, N, f, w) {
        let x = (w == null ? void 0 : w.r) || 0;
        return [["M", F + x, B], ["L", F + N - x, B], ["A", x, x, 0, 0, 1, F + N, B + x], ["L", F + N, B + f - x], ["A", x, x, 0, 0, 1, F + N - x, B + f], ["L", F + x, B + f], ["A", x, x, 0, 0, 1, F, B + f - x], ["L", F, B + x], ["A", x, x, 0, 0, 1, F + x, B], ["Z"]];
      }
      return { arc: O, callout: function(F, B, N, f, w) {
        let x = Math.min(w && w.r || 0, N, f), M = x + 6, p = w && w.anchorX, v = w && w.anchorY || 0, k = D(F, B, N, f, { r: x });
        if (!r(p) || p < N && p > 0 && v < f && v > 0) return k;
        if (F + p > N - M)
          if (v > B + M && v < B + f - M) k.splice(3, 1, ["L", F + N, v - 6], ["L", F + N + 6, v], ["L", F + N, v + 6], ["L", F + N, B + f - x]);
          else if (p < N) {
            let m = v < B + M, A = m ? B : B + f;
            k.splice(m ? 2 : 5, 0, ["L", p, v], ["L", F + N - x, A]);
          } else k.splice(3, 1, ["L", F + N, f / 2], ["L", p, v], ["L", F + N, f / 2], ["L", F + N, B + f - x]);
        else if (F + p < M)
          if (v > B + M && v < B + f - M) k.splice(7, 1, ["L", F, v + 6], ["L", F - 6, v], ["L", F, v - 6], ["L", F, B + x]);
          else if (p > 0) {
            let m = v < B + M, A = m ? B : B + f;
            k.splice(m ? 1 : 6, 0, ["L", p, v], ["L", F + x, A]);
          } else k.splice(7, 1, ["L", F, f / 2], ["L", p, v], ["L", F, f / 2], ["L", F, B + x]);
        else v > f && p < N - M ? k.splice(5, 1, ["L", p + 6, B + f], ["L", p, B + f + 6], ["L", p - 6, B + f], ["L", F + x, B + f]) : v < 0 && p > M && k.splice(1, 1, ["L", p - 6, B], ["L", p, B - 6], ["L", p + 6, B], ["L", N - x, B]);
        return k;
      }, circle: function(F, B, N, f) {
        return O(F + N / 2, B + f / 2, N / 2, f / 2, { start: 0.5 * Math.PI, end: 2.5 * Math.PI, open: !1 });
      }, diamond: function(F, B, N, f) {
        return [["M", F + N / 2, B], ["L", F + N, B + f / 2], ["L", F + N / 2, B + f], ["L", F, B + f / 2], ["Z"]];
      }, rect: j, roundedRect: D, square: j, triangle: function(F, B, N, f) {
        return [["M", F + N / 2, B], ["L", F + N, B + f], ["L", F, B + f], ["Z"]];
      }, "triangle-down": function(F, B, N, f) {
        return [["M", F, B], ["L", F + N, B], ["L", F + N / 2, B + f], ["Z"]];
      } };
    }), a(e, "Core/Renderer/SVG/TextBuilder.js", [e["Core/Renderer/HTML/AST.js"], e["Core/Globals.js"], e["Core/Utilities.js"]], function(o, n, r) {
      let { doc: T, SVG_NS: O, win: j } = n, { attr: D, extend: F, fireEvent: B, isString: N, objectEach: f, pick: w } = r;
      return class {
        constructor(x) {
          let M = x.styles;
          this.renderer = x.renderer, this.svgElement = x, this.width = x.textWidth, this.textLineHeight = M && M.lineHeight, this.textOutline = M && M.textOutline, this.ellipsis = !!(M && M.textOverflow === "ellipsis"), this.noWrap = !!(M && M.whiteSpace === "nowrap");
        }
        buildSVG() {
          let x = this.svgElement, M = x.element, p = x.renderer, v = w(x.textStr, "").toString(), k = v.indexOf("<") !== -1, m = M.childNodes, A = !x.added && p.box, C = [v, this.ellipsis, this.noWrap, this.textLineHeight, this.textOutline, x.getStyle("font-size"), this.width].join(",");
          if (C !== x.textCache) {
            x.textCache = C, delete x.actualWidth;
            for (let H = m.length; H--; ) M.removeChild(m[H]);
            if (k || this.ellipsis || this.width || x.textPath || v.indexOf(" ") !== -1 && (!this.noWrap || /<br.*?>/g.test(v))) {
              if (v !== "") {
                A && A.appendChild(M);
                let H = new o(v);
                this.modifyTree(H.nodes), H.addToDOM(M), this.modifyDOM(), this.ellipsis && (M.textContent || "").indexOf("…") !== -1 && x.attr("title", this.unescapeEntities(x.textStr || "", ["&lt;", "&gt;"])), A && A.removeChild(M);
              }
            } else M.appendChild(T.createTextNode(this.unescapeEntities(v)));
            N(this.textOutline) && x.applyTextOutline && x.applyTextOutline(this.textOutline);
          }
        }
        modifyDOM() {
          let x, M = this.svgElement, p = D(M.element, "x");
          for (M.firstLineMetrics = void 0; (x = M.element.firstChild) && /^[\s\u200B]*$/.test(x.textContent || " "); ) M.element.removeChild(x);
          [].forEach.call(M.element.querySelectorAll("tspan.highcharts-br"), (A, C) => {
            A.nextSibling && A.previousSibling && (C === 0 && A.previousSibling.nodeType === 1 && (M.firstLineMetrics = M.renderer.fontMetrics(A.previousSibling)), D(A, { dy: this.getLineHeight(A.nextSibling), x: p }));
          });
          let v = this.width || 0;
          if (!v) return;
          let k = (A, C) => {
            let H = A.textContent || "", G = H.replace(/([^\^])-/g, "$1- ").split(" "), P = !this.noWrap && (G.length > 1 || M.element.childNodes.length > 1), y = this.getLineHeight(C), S = 0, d = M.actualWidth;
            if (this.ellipsis) H && this.truncate(A, H, void 0, 0, Math.max(0, v - 0.8 * y), (s, l) => s.substring(0, l) + "…");
            else if (P) {
              let s = [], l = [];
              for (; C.firstChild && C.firstChild !== A; ) l.push(C.firstChild), C.removeChild(C.firstChild);
              for (; G.length; ) G.length && !this.noWrap && S > 0 && (s.push(A.textContent || ""), A.textContent = G.join(" ").replace(/- /g, "-")), this.truncate(A, void 0, G, S === 0 && d || 0, v, (b, u) => G.slice(0, u).join(" ").replace(/- /g, "-")), d = M.actualWidth, S++;
              l.forEach((b) => {
                C.insertBefore(b, A);
              }), s.forEach((b) => {
                C.insertBefore(T.createTextNode(b), A);
                let u = T.createElementNS(O, "tspan");
                u.textContent = "​", D(u, { dy: y, x: p }), C.insertBefore(u, A);
              });
            }
          }, m = (A) => {
            [].slice.call(A.childNodes).forEach((C) => {
              C.nodeType === j.Node.TEXT_NODE ? k(C, A) : (C.className.baseVal.indexOf("highcharts-br") !== -1 && (M.actualWidth = 0), m(C));
            });
          };
          m(M.element);
        }
        getLineHeight(x) {
          let M = x.nodeType === j.Node.TEXT_NODE ? x.parentElement : x;
          return this.textLineHeight ? parseInt(this.textLineHeight.toString(), 10) : this.renderer.fontMetrics(M || this.svgElement.element).h;
        }
        modifyTree(x) {
          let M = (p, v) => {
            let { attributes: k = {}, children: m, style: A = {}, tagName: C } = p, H = this.renderer.styledMode;
            if (C === "b" || C === "strong" ? H ? k.class = "highcharts-strong" : A.fontWeight = "bold" : (C === "i" || C === "em") && (H ? k.class = "highcharts-emphasized" : A.fontStyle = "italic"), A && A.color && (A.fill = A.color), C === "br") {
              k.class = "highcharts-br", p.textContent = "​";
              let G = x[v + 1];
              G && G.textContent && (G.textContent = G.textContent.replace(/^ +/gm, ""));
            } else C === "a" && m && m.some((G) => G.tagName === "#text") && (p.children = [{ children: m, tagName: "tspan" }]);
            C !== "#text" && C !== "a" && (p.tagName = "tspan"), F(p, { attributes: k, style: A }), m && m.filter((G) => G.tagName !== "#text").forEach(M);
          };
          x.forEach(M), B(this.svgElement, "afterModifyTree", { nodes: x });
        }
        truncate(x, M, p, v, k, m) {
          let A, C, H = this.svgElement, { rotation: G } = H, P = [], y = p ? 1 : 0, S = (M || p || "").length, d = S, s = function(l, b) {
            let u = b || l, c = x.parentNode;
            if (c && P[u] === void 0 && c.getSubStringLength) try {
              P[u] = v + c.getSubStringLength(0, p ? u + 1 : u);
            } catch {
            }
            return P[u];
          };
          if (H.rotation = 0, v + (C = s(x.textContent.length)) > k) {
            for (; y <= S; ) d = Math.ceil((y + S) / 2), p && (A = m(p, d)), C = s(d, A && A.length - 1), y === S ? y = S + 1 : C > k ? S = d - 1 : y = d;
            S === 0 ? x.textContent = "" : M && S === M.length - 1 || (x.textContent = A || m(M || p, d));
          }
          p && p.splice(0, d), H.actualWidth = C, H.rotation = G;
        }
        unescapeEntities(x, M) {
          return f(this.renderer.escapes, function(p, v) {
            M && M.indexOf(p) !== -1 || (x = x.toString().replace(RegExp(p, "g"), v));
          }), x;
        }
      };
    }), a(e, "Core/Renderer/SVG/SVGRenderer.js", [e["Core/Renderer/HTML/AST.js"], e["Core/Defaults.js"], e["Core/Color/Color.js"], e["Core/Globals.js"], e["Core/Renderer/RendererRegistry.js"], e["Core/Renderer/SVG/SVGElement.js"], e["Core/Renderer/SVG/SVGLabel.js"], e["Core/Renderer/SVG/Symbols.js"], e["Core/Renderer/SVG/TextBuilder.js"], e["Core/Utilities.js"]], function(o, n, r, T, O, j, D, F, B, N) {
      let f, { defaultOptions: w } = n, { charts: x, deg2rad: M, doc: p, isFirefox: v, isMS: k, isWebKit: m, noop: A, SVG_NS: C, symbolSizes: H, win: G } = T, { addEvent: P, attr: y, createElement: S, crisp: d, css: s, defined: l, destroyObjectProperties: b, extend: u, isArray: c, isNumber: h, isObject: g, isString: E, merge: R, pick: L, pInt: U, replaceNested: V, uniqueKey: q } = N;
      class Y {
        constructor(_, W, X, z, $, K, Q) {
          let Z, ee, J = this.createElement("svg").attr({ version: "1.1", class: "highcharts-root" }), ae = J.element;
          Q || J.css(this.getStyle(z || {})), _.appendChild(ae), y(_, "dir", "ltr"), _.innerHTML.indexOf("xmlns") === -1 && y(ae, "xmlns", this.SVG_NS), this.box = ae, this.boxWrapper = J, this.alignedObjects = [], this.url = this.getReferenceURL(), this.createElement("desc").add().element.appendChild(p.createTextNode("Created with Highcharts 11.4.8")), this.defs = this.createElement("defs").add(), this.allowHTML = K, this.forExport = $, this.styledMode = Q, this.gradients = {}, this.cache = {}, this.cacheKeys = [], this.imgCount = 0, this.rootFontSize = J.getStyle("font-size"), this.setSize(W, X, !1), v && _.getBoundingClientRect && ((Z = function() {
            s(_, { left: 0, top: 0 }), ee = _.getBoundingClientRect(), s(_, { left: Math.ceil(ee.left) - ee.left + "px", top: Math.ceil(ee.top) - ee.top + "px" });
          })(), this.unSubPixelFix = P(G, "resize", Z));
        }
        definition(_) {
          return new o([_]).addToDOM(this.defs.element);
        }
        getReferenceURL() {
          if ((v || m) && p.getElementsByTagName("base").length) {
            if (!l(f)) {
              let _ = q(), W = new o([{ tagName: "svg", attributes: { width: 8, height: 8 }, children: [{ tagName: "defs", children: [{ tagName: "clipPath", attributes: { id: _ }, children: [{ tagName: "rect", attributes: { width: 4, height: 4 } }] }] }, { tagName: "rect", attributes: { id: "hitme", width: 8, height: 8, "clip-path": `url(#${_})`, fill: "rgba(0,0,0,0.001)" } }] }]).addToDOM(p.body);
              s(W, { position: "fixed", top: 0, left: 0, zIndex: 9e5 });
              let X = p.elementFromPoint(6, 6);
              f = (X && X.id) === "hitme", p.body.removeChild(W);
            }
            if (f) return V(G.location.href.split("#")[0], [/<[^>]*>/g, ""], [/([\('\)])/g, "\\$1"], [/ /g, "%20"]);
          }
          return "";
        }
        getStyle(_) {
          return this.style = u({ fontFamily: "Helvetica, Arial, sans-serif", fontSize: "1rem" }, _), this.style;
        }
        setStyle(_) {
          this.boxWrapper.css(this.getStyle(_));
        }
        isHidden() {
          return !this.boxWrapper.getBBox().width;
        }
        destroy() {
          let _ = this.defs;
          return this.box = null, this.boxWrapper = this.boxWrapper.destroy(), b(this.gradients || {}), this.gradients = null, this.defs = _.destroy(), this.unSubPixelFix && this.unSubPixelFix(), this.alignedObjects = null, null;
        }
        createElement(_) {
          return new this.Element(this, _);
        }
        getRadialAttr(_, W) {
          return { cx: _[0] - _[2] / 2 + (W.cx || 0) * _[2], cy: _[1] - _[2] / 2 + (W.cy || 0) * _[2], r: (W.r || 0) * _[2] };
        }
        shadowDefinition(_) {
          let W = [`highcharts-drop-shadow-${this.chartIndex}`, ...Object.keys(_).map((z) => `${z}-${_[z]}`)].join("-").toLowerCase().replace(/[^a-z\d\-]/g, ""), X = R({ color: "#000000", offsetX: 1, offsetY: 1, opacity: 0.15, width: 5 }, _);
          return this.defs.element.querySelector(`#${W}`) || this.definition({ tagName: "filter", attributes: { id: W, filterUnits: X.filterUnits }, children: this.getShadowFilterContent(X) }), W;
        }
        getShadowFilterContent(_) {
          return [{ tagName: "feDropShadow", attributes: { dx: _.offsetX, dy: _.offsetY, "flood-color": _.color, "flood-opacity": Math.min(5 * _.opacity, 1), stdDeviation: _.width / 2 } }];
        }
        buildText(_) {
          new B(_).buildSVG();
        }
        getContrast(_) {
          let W = r.parse(_).rgba.map((z) => {
            let $ = z / 255;
            return $ <= 0.03928 ? $ / 12.92 : Math.pow(($ + 0.055) / 1.055, 2.4);
          }), X = 0.2126 * W[0] + 0.7152 * W[1] + 0.0722 * W[2];
          return 1.05 / (X + 0.05) > (X + 0.05) / 0.05 ? "#FFFFFF" : "#000000";
        }
        button(_, W, X, z, $ = {}, K, Q, Z, ee, J) {
          let ae = this.label(_, W, X, ee, void 0, void 0, J, void 0, "button"), re = this.styledMode, ce = arguments, he = 0;
          $ = R(w.global.buttonTheme, $), re && (delete $.fill, delete $.stroke, delete $["stroke-width"]);
          let ne = $.states || {}, te = $.style || {};
          delete $.states, delete $.style;
          let se = [o.filterUserAttributes($)], oe = [te];
          return re || ["hover", "select", "disabled"].forEach((ie, le) => {
            se.push(R(se[0], o.filterUserAttributes(ce[le + 5] || ne[ie] || {}))), oe.push(se[le + 1].style), delete se[le + 1].style;
          }), P(ae.element, k ? "mouseover" : "mouseenter", function() {
            he !== 3 && ae.setState(1);
          }), P(ae.element, k ? "mouseout" : "mouseleave", function() {
            he !== 3 && ae.setState(he);
          }), ae.setState = (ie = 0) => {
            if (ie !== 1 && (ae.state = he = ie), ae.removeClass(/highcharts-button-(normal|hover|pressed|disabled)/).addClass("highcharts-button-" + ["normal", "hover", "pressed", "disabled"][ie]), !re) {
              ae.attr(se[ie]);
              let le = oe[ie];
              g(le) && ae.css(le);
            }
          }, ae.attr(se[0]), !re && (ae.css(u({ cursor: "default" }, te)), J && ae.text.css({ pointerEvents: "none" })), ae.on("touchstart", (ie) => ie.stopPropagation()).on("click", function(ie) {
            he !== 3 && z.call(ae, ie);
          });
        }
        crispLine(_, W) {
          let [X, z] = _;
          return l(X[1]) && X[1] === z[1] && (X[1] = z[1] = d(X[1], W)), l(X[2]) && X[2] === z[2] && (X[2] = z[2] = d(X[2], W)), _;
        }
        path(_) {
          let W = this.styledMode ? {} : { fill: "none" };
          return c(_) ? W.d = _ : g(_) && u(W, _), this.createElement("path").attr(W);
        }
        circle(_, W, X) {
          let z = g(_) ? _ : _ === void 0 ? {} : { x: _, y: W, r: X }, $ = this.createElement("circle");
          return $.xSetter = $.ySetter = function(K, Q, Z) {
            Z.setAttribute("c" + Q, K);
          }, $.attr(z);
        }
        arc(_, W, X, z, $, K) {
          let Q;
          g(_) ? (W = (Q = _).y, X = Q.r, z = Q.innerR, $ = Q.start, K = Q.end, _ = Q.x) : Q = { innerR: z, start: $, end: K };
          let Z = this.symbol("arc", _, W, X, X, Q);
          return Z.r = X, Z;
        }
        rect(_, W, X, z, $, K) {
          let Q = g(_) ? _ : _ === void 0 ? {} : { x: _, y: W, r: $, width: Math.max(X || 0, 0), height: Math.max(z || 0, 0) }, Z = this.createElement("rect");
          return this.styledMode || (K !== void 0 && (Q["stroke-width"] = K, u(Q, Z.crisp(Q))), Q.fill = "none"), Z.rSetter = function(ee, J, ae) {
            Z.r = ee, y(ae, { rx: ee, ry: ee });
          }, Z.rGetter = function() {
            return Z.r || 0;
          }, Z.attr(Q);
        }
        roundedRect(_) {
          return this.symbol("roundedRect").attr(_);
        }
        setSize(_, W, X) {
          this.width = _, this.height = W, this.boxWrapper.animate({ width: _, height: W }, { step: function() {
            this.attr({ viewBox: "0 0 " + this.attr("width") + " " + this.attr("height") });
          }, duration: L(X, !0) ? void 0 : 0 }), this.alignElements();
        }
        g(_) {
          let W = this.createElement("g");
          return _ ? W.attr({ class: "highcharts-" + _ }) : W;
        }
        image(_, W, X, z, $, K) {
          let Q = { preserveAspectRatio: "none" };
          h(W) && (Q.x = W), h(X) && (Q.y = X), h(z) && (Q.width = z), h($) && (Q.height = $);
          let Z = this.createElement("image").attr(Q), ee = function(J) {
            Z.attr({ href: _ }), K.call(Z, J);
          };
          if (K) {
            Z.attr({ href: "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" });
            let J = new G.Image();
            P(J, "load", ee), J.src = _, J.complete && ee({});
          } else Z.attr({ href: _ });
          return Z;
        }
        symbol(_, W, X, z, $, K) {
          let Q, Z, ee, J, ae = this, re = /^url\((.*?)\)$/, ce = re.test(_), he = !ce && (this.symbols[_] ? _ : "circle"), ne = he && this.symbols[he];
          if (ne) typeof W == "number" && (Z = ne.call(this.symbols, W || 0, X || 0, z || 0, $ || 0, K)), Q = this.path(Z), ae.styledMode || Q.attr("fill", "none"), u(Q, { symbolName: he || void 0, x: W, y: X, width: z, height: $ }), K && u(Q, K);
          else if (ce) {
            ee = _.match(re)[1];
            let te = Q = this.image(ee);
            te.imgwidth = L(K && K.width, H[ee] && H[ee].width), te.imgheight = L(K && K.height, H[ee] && H[ee].height), J = (se) => se.attr({ width: se.width, height: se.height }), ["width", "height"].forEach((se) => {
              te[`${se}Setter`] = function(oe, ie) {
                this[ie] = oe;
                let { alignByTranslate: le, element: de, width: be, height: ge, imgwidth: me, imgheight: fe } = this, Ae = ie === "width" ? me : fe, ye = 1;
                K && K.backgroundSize === "within" && be && ge && me && fe ? (ye = Math.min(be / me, ge / fe), y(de, { width: Math.round(me * ye), height: Math.round(fe * ye) })) : de && Ae && de.setAttribute(ie, Ae), !le && me && fe && this.translate(((be || 0) - me * ye) / 2, ((ge || 0) - fe * ye) / 2);
              };
            }), l(W) && te.attr({ x: W, y: X }), te.isImg = !0, te.symbolUrl = _, l(te.imgwidth) && l(te.imgheight) ? J(te) : (te.attr({ width: 0, height: 0 }), S("img", { onload: function() {
              let se = x[ae.chartIndex];
              this.width === 0 && (s(this, { position: "absolute", top: "-999em" }), p.body.appendChild(this)), H[ee] = { width: this.width, height: this.height }, te.imgwidth = this.width, te.imgheight = this.height, te.element && J(te), this.parentNode && this.parentNode.removeChild(this), ae.imgCount--, ae.imgCount || !se || se.hasLoaded || se.onload();
            }, src: ee }), this.imgCount++);
          }
          return Q;
        }
        clipRect(_, W, X, z) {
          return this.rect(_, W, X, z, 0);
        }
        text(_, W, X, z) {
          let $ = {};
          if (z && (this.allowHTML || !this.forExport)) return this.html(_, W, X);
          $.x = Math.round(W || 0), X && ($.y = Math.round(X)), l(_) && ($.text = _);
          let K = this.createElement("text").attr($);
          return z && (!this.forExport || this.allowHTML) || (K.xSetter = function(Q, Z, ee) {
            let J = ee.getElementsByTagName("tspan"), ae = ee.getAttribute(Z);
            for (let re = 0, ce; re < J.length; re++) (ce = J[re]).getAttribute(Z) === ae && ce.setAttribute(Z, Q);
            ee.setAttribute(Z, Q);
          }), K;
        }
        fontMetrics(_) {
          let W = U(j.prototype.getStyle.call(_, "font-size") || 0), X = W < 24 ? W + 3 : Math.round(1.2 * W), z = Math.round(0.8 * X);
          return { h: X, b: z, f: W };
        }
        rotCorr(_, W, X) {
          let z = _;
          return W && X && (z = Math.max(z * Math.cos(W * M), 4)), { x: -_ / 3 * Math.sin(W * M), y: z };
        }
        pathToSegments(_) {
          let W = [], X = [], z = { A: 8, C: 7, H: 2, L: 3, M: 3, Q: 5, S: 5, T: 3, V: 2 };
          for (let $ = 0; $ < _.length; $++) E(X[0]) && h(_[$]) && X.length === z[X[0].toUpperCase()] && _.splice($, 0, X[0].replace("M", "L").replace("m", "l")), typeof _[$] == "string" && (X.length && W.push(X.slice(0)), X.length = 0), X.push(_[$]);
          return W.push(X.slice(0)), W;
        }
        label(_, W, X, z, $, K, Q, Z, ee) {
          return new D(this, _, W, X, z, $, K, Q, Z, ee);
        }
        alignElements() {
          this.alignedObjects.forEach((_) => _.align());
        }
      }
      return u(Y.prototype, { Element: j, SVG_NS: C, escapes: { "&": "&amp;", "<": "&lt;", ">": "&gt;", "'": "&#39;", '"': "&quot;" }, symbols: F, draw: A }), O.registerRendererType("svg", Y, !0), Y;
    }), a(e, "Core/Renderer/HTML/HTMLElement.js", [e["Core/Renderer/HTML/AST.js"], e["Core/Globals.js"], e["Core/Renderer/SVG/SVGElement.js"], e["Core/Utilities.js"]], function(o, n, r, T) {
      let { composed: O } = n, { attr: j, css: D, createElement: F, defined: B, extend: N, pInt: f, pushUnique: w } = T;
      function x(k, m, A) {
        var H;
        let C = ((H = this.div) == null ? void 0 : H.style) || A.style;
        r.prototype[`${m}Setter`].call(this, k, m, A), C && (C[m] = k);
      }
      let M = (k, m) => {
        var A;
        if (!k.div) {
          let C = j(k.element, "class"), H = k.css, G = F("div", C ? { className: C } : void 0, { position: "absolute", left: `${k.translateX || 0}px`, top: `${k.translateY || 0}px`, ...k.styles, display: k.display, opacity: k.opacity, visibility: k.visibility }, ((A = k.parentGroup) == null ? void 0 : A.div) || m);
          k.classSetter = (P, y, S) => {
            S.setAttribute("class", P), G.className = P;
          }, k.translateXSetter = k.translateYSetter = (P, y) => {
            k[y] = P, G.style[y === "translateX" ? "left" : "top"] = `${P}px`, k.doTransform = !0;
          }, k.opacitySetter = k.visibilitySetter = x, k.css = (P) => (H.call(k, P), P.cursor && (G.style.cursor = P.cursor), P.pointerEvents && (G.style.pointerEvents = P.pointerEvents), k), k.on = function() {
            return r.prototype.on.apply({ element: G, onEvents: k.onEvents }, arguments), k;
          }, k.div = G;
        }
        return k.div;
      };
      class p extends r {
        static compose(m) {
          w(O, this.compose) && (m.prototype.html = function(A, C, H) {
            return new p(this, "span").attr({ text: A, x: Math.round(C), y: Math.round(H) });
          });
        }
        constructor(m, A) {
          super(m, A), this.css({ position: "absolute", ...m.styledMode ? {} : { fontFamily: m.style.fontFamily, fontSize: m.style.fontSize } }), this.element.style.whiteSpace = "nowrap";
        }
        getSpanCorrection(m, A, C) {
          this.xCorr = -m * C, this.yCorr = -A;
        }
        css(m) {
          let A, { element: C } = this, H = C.tagName === "SPAN" && m && "width" in m, G = H && m.width;
          return H && (delete m.width, this.textWidth = f(G) || void 0, A = !0), (m == null ? void 0 : m.textOverflow) === "ellipsis" && (m.whiteSpace = "nowrap", m.overflow = "hidden"), N(this.styles, m), D(C, m), A && this.updateTransform(), this;
        }
        htmlGetBBox() {
          let { element: m } = this;
          return { x: m.offsetLeft, y: m.offsetTop, width: m.offsetWidth, height: m.offsetHeight };
        }
        updateTransform() {
          var h;
          if (!this.added) {
            this.alignOnAdd = !0;
            return;
          }
          let { element: m, renderer: A, rotation: C, rotationOriginX: H, rotationOriginY: G, styles: P, textAlign: y = "left", textWidth: S, translateX: d = 0, translateY: s = 0, x: l = 0, y: b = 0 } = this, u = { left: 0, center: 0.5, right: 1 }[y], c = P.whiteSpace;
          if (D(m, { marginLeft: `${d}px`, marginTop: `${s}px` }), m.tagName === "SPAN") {
            let g = [C, y, m.innerHTML, S, this.textAlign].join(","), E = -(((h = this.parentGroup) == null ? void 0 : h.padding) * 1) || 0, R, L = !1;
            if (S !== this.oldTextWidth) {
              let I = this.textPxLength ? this.textPxLength : (D(m, { width: "", whiteSpace: c || "nowrap" }), m.offsetWidth), _ = S || 0;
              (_ > this.oldTextWidth || I > _) && (/[ \-]/.test(m.textContent || m.innerText) || m.style.textOverflow === "ellipsis") && (D(m, { width: I > _ || C ? S + "px" : "auto", display: "block", whiteSpace: c || "normal" }), this.oldTextWidth = S, L = !0);
            }
            this.hasBoxWidthChanged = L, g !== this.cTT && (R = A.fontMetrics(m).b, B(C) && (C !== (this.oldRotation || 0) || y !== this.oldAlign) && this.setSpanRotation(C, E, E), this.getSpanCorrection(!B(C) && this.textPxLength || m.offsetWidth, R, u));
            let { xCorr: U = 0, yCorr: V = 0 } = this, q = (H != null ? H : l) - U - l - E, Y = (G != null ? G : b) - V - b - E;
            D(m, { left: `${l + U}px`, top: `${b + V}px`, transformOrigin: `${q}px ${Y}px` }), this.cTT = g, this.oldRotation = C, this.oldAlign = y;
          }
        }
        setSpanRotation(m, A, C) {
          D(this.element, { transform: `rotate(${m}deg)`, transformOrigin: `${A}% ${C}px` });
        }
        add(m) {
          let A, C = this.renderer.box.parentNode, H = [];
          if (this.parentGroup = m, m && !(A = m.div)) {
            let G = m;
            for (; G; ) H.push(G), G = G.parentGroup;
            for (let P of H.reverse()) A = M(P, C);
          }
          return (A || C).appendChild(this.element), this.added = !0, this.alignOnAdd && this.updateTransform(), this;
        }
        textSetter(m) {
          m !== this.textStr && (delete this.bBox, delete this.oldTextWidth, o.setElementHTML(this.element, m != null ? m : ""), this.textStr = m, this.doTransform = !0);
        }
        alignSetter(m) {
          this.alignValue = this.textAlign = m, this.doTransform = !0;
        }
        xSetter(m, A) {
          this[A] = m, this.doTransform = !0;
        }
      }
      let v = p.prototype;
      return v.visibilitySetter = v.opacitySetter = x, v.ySetter = v.rotationSetter = v.rotationOriginXSetter = v.rotationOriginYSetter = v.xSetter, p;
    }), a(e, "Core/Axis/AxisDefaults.js", [], function() {
      var o, n;
      return (n = o || (o = {})).xAxis = { alignTicks: !0, allowDecimals: void 0, panningEnabled: !0, zIndex: 2, zoomEnabled: !0, dateTimeLabelFormats: { millisecond: { main: "%H:%M:%S.%L", range: !1 }, second: { main: "%H:%M:%S", range: !1 }, minute: { main: "%H:%M", range: !1 }, hour: { main: "%H:%M", range: !1 }, day: { main: "%e %b" }, week: { main: "%e %b" }, month: { main: "%b '%y" }, year: { main: "%Y" } }, endOnTick: !1, gridLineDashStyle: "Solid", gridZIndex: 1, labels: { autoRotationLimit: 80, distance: 15, enabled: !0, indentation: 10, overflow: "justify", reserveSpace: void 0, rotation: void 0, staggerLines: 0, step: 0, useHTML: !1, zIndex: 7, style: { color: "#333333", cursor: "default", fontSize: "0.8em" } }, maxPadding: 0.01, minorGridLineDashStyle: "Solid", minorTickLength: 2, minorTickPosition: "outside", minorTicksPerMajor: 5, minPadding: 0.01, offset: void 0, reversed: void 0, reversedStacks: !1, showEmpty: !0, showFirstLabel: !0, showLastLabel: !0, startOfWeek: 1, startOnTick: !1, tickLength: 10, tickPixelInterval: 100, tickmarkPlacement: "between", tickPosition: "outside", title: { align: "middle", useHTML: !1, x: 0, y: 0, style: { color: "#666666", fontSize: "0.8em" } }, visible: !0, minorGridLineColor: "#f2f2f2", minorGridLineWidth: 1, minorTickColor: "#999999", lineColor: "#333333", lineWidth: 1, gridLineColor: "#e6e6e6", gridLineWidth: void 0, tickColor: "#333333" }, n.yAxis = { reversedStacks: !0, endOnTick: !0, maxPadding: 0.05, minPadding: 0.05, tickPixelInterval: 72, showLastLabel: !0, labels: { x: void 0 }, startOnTick: !0, title: { text: "Values" }, stackLabels: { animation: {}, allowOverlap: !1, enabled: !1, crop: !0, overflow: "justify", formatter: function() {
        let { numberFormatter: r } = this.axis.chart;
        return r(this.total || 0, -1);
      }, style: { color: "#000000", fontSize: "0.7em", fontWeight: "bold", textOutline: "1px contrast" } }, gridLineWidth: 1, lineWidth: 0 }, o;
    }), a(e, "Core/Foundation.js", [e["Core/Utilities.js"]], function(o) {
      var n;
      let { addEvent: r, isFunction: T, objectEach: O, removeEvent: j } = o;
      return (n || (n = {})).registerEventOptions = function(D, F) {
        D.eventOptions = D.eventOptions || {}, O(F.events, function(B, N) {
          D.eventOptions[N] !== B && (D.eventOptions[N] && (j(D, N, D.eventOptions[N]), delete D.eventOptions[N]), T(B) && (D.eventOptions[N] = B, r(D, N, B, { order: 0 })));
        });
      }, n;
    }), a(e, "Core/Axis/Tick.js", [e["Core/Templating.js"], e["Core/Globals.js"], e["Core/Utilities.js"]], function(o, n, r) {
      let { deg2rad: T } = n, { clamp: O, correctFloat: j, defined: D, destroyObjectProperties: F, extend: B, fireEvent: N, isNumber: f, merge: w, objectEach: x, pick: M } = r;
      return class {
        constructor(p, v, k, m, A) {
          this.isNew = !0, this.isNewLabel = !0, this.axis = p, this.pos = v, this.type = k || "", this.parameters = A || {}, this.tickmarkOffset = this.parameters.tickmarkOffset, this.options = this.parameters.options, N(this, "init"), k || m || this.addLabel();
        }
        addLabel() {
          let p = this, v = p.axis, k = v.options, m = v.chart, A = v.categories, C = v.logarithmic, H = v.names, G = p.pos, P = M(p.options && p.options.labels, k.labels), y = v.tickPositions, S = G === y[0], d = G === y[y.length - 1], s = (!P.step || P.step === 1) && v.tickInterval === 1, l = y.info, b = p.label, u, c, h, g = this.parameters.category || (A ? M(A[G], H[G], G) : G);
          C && f(g) && (g = j(C.lin2log(g))), v.dateTime && (l ? u = (c = m.time.resolveDTLFormat(k.dateTimeLabelFormats[!k.grid && l.higherRanks[G] || l.unitName])).main : f(g) && (u = v.dateTime.getXDateFormat(g, k.dateTimeLabelFormats || {}))), p.isFirst = S, p.isLast = d;
          let E = { axis: v, chart: m, dateTimeLabelFormat: u, isFirst: S, isLast: d, pos: G, tick: p, tickPositionInfo: l, value: g };
          N(this, "labelFormat", E);
          let R = (V) => P.formatter ? P.formatter.call(V, V) : P.format ? (V.text = v.defaultLabelFormatter.call(V), o.format(P.format, V, m)) : v.defaultLabelFormatter.call(V), L = R.call(E, E), U = c && c.list;
          U ? p.shortenLabel = function() {
            for (h = 0; h < U.length; h++) if (B(E, { dateTimeLabelFormat: U[h] }), b.attr({ text: R.call(E, E) }), b.getBBox().width < v.getSlotWidth(p) - 2 * (P.padding || 0)) return;
            b.attr({ text: "" });
          } : p.shortenLabel = void 0, s && v._addedPlotLB && p.moveLabel(L, P), D(b) || p.movedLabel ? b && b.textStr !== L && !s && (!b.textWidth || P.style.width || b.styles.width || b.css({ width: null }), b.attr({ text: L }), b.textPxLength = b.getBBox().width) : (p.label = b = p.createLabel(L, P), p.rotation = 0);
        }
        createLabel(p, v, k) {
          let m = this.axis, A = m.chart, C = D(p) && v.enabled ? A.renderer.text(p, k == null ? void 0 : k.x, k == null ? void 0 : k.y, v.useHTML).add(m.labelGroup) : void 0;
          return C && (A.styledMode || C.css(w(v.style)), C.textPxLength = C.getBBox().width), C;
        }
        destroy() {
          F(this, this.axis);
        }
        getPosition(p, v, k, m) {
          let A = this.axis, C = A.chart, H = m && C.oldChartHeight || C.chartHeight, G = { x: p ? j(A.translate(v + k, void 0, void 0, m) + A.transB) : A.left + A.offset + (A.opposite ? (m && C.oldChartWidth || C.chartWidth) - A.right - A.left : 0), y: p ? H - A.bottom + A.offset - (A.opposite ? A.height : 0) : j(H - A.translate(v + k, void 0, void 0, m) - A.transB) };
          return G.y = O(G.y, -1e9, 1e9), N(this, "afterGetPosition", { pos: G }), G;
        }
        getLabelPosition(p, v, k, m, A, C, H, G) {
          let P, y, S = this.axis, d = S.transA, s = S.isLinked && S.linkedParent ? S.linkedParent.reversed : S.reversed, l = S.staggerLines, b = S.tickRotCorr || { x: 0, y: 0 }, u = m || S.reserveSpaceDefault ? 0 : -S.labelOffset * (S.labelAlign === "center" ? 0.5 : 1), c = A.distance, h = {};
          return P = S.side === 0 ? k.rotation ? -c : -k.getBBox().height : S.side === 2 ? b.y + c : Math.cos(k.rotation * T) * (b.y - k.getBBox(!1, 0).height / 2), D(A.y) && (P = S.side === 0 && S.horiz ? A.y + P : A.y), p = p + M(A.x, [0, 1, 0, -1][S.side] * c) + u + b.x - (C && m ? C * d * (s ? -1 : 1) : 0), v = v + P - (C && !m ? C * d * (s ? 1 : -1) : 0), l && (y = H / (G || 1) % l, S.opposite && (y = l - y - 1), v += y * (S.labelOffset / l)), h.x = p, h.y = Math.round(v), N(this, "afterGetLabelPosition", { pos: h, tickmarkOffset: C, index: H }), h;
        }
        getLabelSize() {
          return this.label ? this.label.getBBox()[this.axis.horiz ? "height" : "width"] : 0;
        }
        getMarkPath(p, v, k, m, A = !1, C) {
          return C.crispLine([["M", p, v], ["L", p + (A ? 0 : -k), v + (A ? k : 0)]], m);
        }
        handleOverflow(p) {
          let v = this.axis, k = v.options.labels, m = p.x, A = v.chart.chartWidth, C = v.chart.spacing, H = M(v.labelLeft, Math.min(v.pos, C[3])), G = M(v.labelRight, Math.max(v.isRadial ? 0 : v.pos + v.len, A - C[1])), P = this.label, y = this.rotation, S = { left: 0, center: 0.5, right: 1 }[v.labelAlign || P.attr("align")], d = P.getBBox().width, s = v.getSlotWidth(this), l = {}, b = s, u = 1, c, h, g;
          y || k.overflow !== "justify" ? y < 0 && m - S * d < H ? g = Math.round(m / Math.cos(y * T) - H) : y > 0 && m + S * d > G && (g = Math.round((A - m) / Math.cos(y * T))) : (c = m - S * d, h = m + (1 - S) * d, c < H ? b = p.x + b * (1 - S) - H : h > G && (b = G - p.x + b * S, u = -1), (b = Math.min(s, b)) < s && v.labelAlign === "center" && (p.x += u * (s - b - S * (s - Math.min(d, b)))), (d > b || v.autoRotation && (P.styles || {}).width) && (g = b)), g && (this.shortenLabel ? this.shortenLabel() : (l.width = Math.floor(g) + "px", (k.style || {}).textOverflow || (l.textOverflow = "ellipsis"), P.css(l)));
        }
        moveLabel(p, v) {
          let k = this, m = k.label, A = k.axis, C = !1, H;
          m && m.textStr === p ? (k.movedLabel = m, C = !0, delete k.label) : x(A.ticks, function(G) {
            C || G.isNew || G === k || !G.label || G.label.textStr !== p || (k.movedLabel = G.label, C = !0, G.labelPos = k.movedLabel.xy, delete G.label);
          }), !C && (k.labelPos || m) && (H = k.labelPos || m.xy, k.movedLabel = k.createLabel(p, v, H), k.movedLabel && k.movedLabel.attr({ opacity: 0 }));
        }
        render(p, v, k) {
          let m = this.axis, A = m.horiz, C = this.pos, H = M(this.tickmarkOffset, m.tickmarkOffset), G = this.getPosition(A, C, H, v), P = G.x, y = G.y, S = m.pos, d = S + m.len, s = A ? P : y;
          !m.chart.polar && this.isNew && (j(s) < S || s > d) && (k = 0);
          let l = M(k, this.label && this.label.newOpacity, 1);
          k = M(k, 1), this.isActive = !0, this.renderGridLine(v, k), this.renderMark(G, k), this.renderLabel(G, v, l, p), this.isNew = !1, N(this, "afterRender");
        }
        renderGridLine(p, v) {
          let k = this.axis, m = k.options, A = {}, C = this.pos, H = this.type, G = M(this.tickmarkOffset, k.tickmarkOffset), P = k.chart.renderer, y = this.gridLine, S, d = m.gridLineWidth, s = m.gridLineColor, l = m.gridLineDashStyle;
          this.type === "minor" && (d = m.minorGridLineWidth, s = m.minorGridLineColor, l = m.minorGridLineDashStyle), y || (k.chart.styledMode || (A.stroke = s, A["stroke-width"] = d || 0, A.dashstyle = l), H || (A.zIndex = 1), p && (v = 0), this.gridLine = y = P.path().attr(A).addClass("highcharts-" + (H ? H + "-" : "") + "grid-line").add(k.gridGroup)), y && (S = k.getPlotLinePath({ value: C + G, lineWidth: y.strokeWidth(), force: "pass", old: p, acrossPanes: !1 })) && y[p || this.isNew ? "attr" : "animate"]({ d: S, opacity: v });
        }
        renderMark(p, v) {
          let k = this.axis, m = k.options, A = k.chart.renderer, C = this.type, H = k.tickSize(C ? C + "Tick" : "tick"), G = p.x, P = p.y, y = M(m[C !== "minor" ? "tickWidth" : "minorTickWidth"], !C && k.isXAxis ? 1 : 0), S = m[C !== "minor" ? "tickColor" : "minorTickColor"], d = this.mark, s = !d;
          H && (k.opposite && (H[0] = -H[0]), d || (this.mark = d = A.path().addClass("highcharts-" + (C ? C + "-" : "") + "tick").add(k.axisGroup), k.chart.styledMode || d.attr({ stroke: S, "stroke-width": y })), d[s ? "attr" : "animate"]({ d: this.getMarkPath(G, P, H[0], d.strokeWidth(), k.horiz, A), opacity: v }));
        }
        renderLabel(p, v, k, m) {
          let A = this.axis, C = A.horiz, H = A.options, G = this.label, P = H.labels, y = P.step, S = M(this.tickmarkOffset, A.tickmarkOffset), d = p.x, s = p.y, l = !0;
          G && f(d) && (G.xy = p = this.getLabelPosition(d, s, G, C, P, S, m, y), (!this.isFirst || this.isLast || H.showFirstLabel) && (!this.isLast || this.isFirst || H.showLastLabel) ? !C || P.step || P.rotation || v || k === 0 || this.handleOverflow(p) : l = !1, y && m % y && (l = !1), l && f(p.y) ? (p.opacity = k, G[this.isNewLabel ? "attr" : "animate"](p).show(!0), this.isNewLabel = !1) : (G.hide(), this.isNewLabel = !0));
        }
        replaceMovedLabel() {
          let p = this.label, v = this.axis;
          p && !this.isNew && (p.animate({ opacity: 0 }, void 0, p.destroy), delete this.label), v.isDirty = !0, this.label = this.movedLabel, delete this.movedLabel;
        }
      };
    }), a(e, "Core/Axis/Axis.js", [e["Core/Animation/AnimationUtilities.js"], e["Core/Axis/AxisDefaults.js"], e["Core/Color/Color.js"], e["Core/Defaults.js"], e["Core/Foundation.js"], e["Core/Globals.js"], e["Core/Axis/Tick.js"], e["Core/Utilities.js"]], function(o, n, r, T, O, j, D, F) {
      let { animObject: B } = o, { xAxis: N, yAxis: f } = n, { defaultOptions: w } = T, { registerEventOptions: x } = O, { deg2rad: M } = j, { arrayMax: p, arrayMin: v, clamp: k, correctFloat: m, defined: A, destroyObjectProperties: C, erase: H, error: G, extend: P, fireEvent: y, getClosestDistance: S, insertItem: d, isArray: s, isNumber: l, isString: b, merge: u, normalizeTickInterval: c, objectEach: h, pick: g, relativeLength: E, removeEvent: R, splat: L, syncTimeout: U } = F, V = (Y, I) => c(I, void 0, void 0, g(Y.options.allowDecimals, I < 0.5 || Y.tickAmount !== void 0), !!Y.tickAmount);
      P(w, { xAxis: N, yAxis: u(N, f) });
      class q {
        constructor(I, _, W) {
          this.init(I, _, W);
        }
        init(I, _, W = this.coll) {
          var Z, ee, J, ae;
          let X = W === "xAxis", z = this.isZAxis || (I.inverted ? !X : X);
          this.chart = I, this.horiz = z, this.isXAxis = X, this.coll = W, y(this, "init", { userOptions: _ }), this.opposite = g(_.opposite, this.opposite), this.side = g(_.side, this.side, z ? this.opposite ? 0 : 2 : this.opposite ? 1 : 3), this.setOptions(_);
          let $ = this.options, K = $.labels;
          (Z = this.type) != null || (this.type = $.type || "linear"), (J = this.uniqueNames) != null || (this.uniqueNames = (ee = $.uniqueNames) != null ? ee : !0), y(this, "afterSetType"), this.userOptions = _, this.minPixelPadding = 0, this.reversed = g($.reversed, this.reversed), this.visible = $.visible, this.zoomEnabled = $.zoomEnabled, this.hasNames = this.type === "category" || $.categories === !0, this.categories = s($.categories) && $.categories || (this.hasNames ? [] : void 0), this.names || (this.names = [], this.names.keys = {}), this.plotLinesAndBandsGroups = {}, this.positiveValuesOnly = !!this.logarithmic, this.isLinked = A($.linkedTo), this.ticks = {}, this.labelEdge = [], this.minorTicks = {}, this.plotLinesAndBands = [], this.alternateBands = {}, (ae = this.len) != null || (this.len = 0), this.minRange = this.userMinRange = $.minRange || $.maxZoom, this.range = $.range, this.offset = $.offset || 0, this.max = void 0, this.min = void 0;
          let Q = g($.crosshair, L(I.options.tooltip.crosshairs)[X ? 0 : 1]);
          this.crosshair = Q === !0 ? {} : Q, I.axes.indexOf(this) === -1 && (X ? I.axes.splice(I.xAxis.length, 0, this) : I.axes.push(this), d(this, I[this.coll])), I.orderItems(this.coll), this.series = this.series || [], I.inverted && !this.isZAxis && X && !A(this.reversed) && (this.reversed = !0), this.labelRotation = l(K.rotation) ? K.rotation : void 0, x(this, $), y(this, "afterInit");
        }
        setOptions(I) {
          let _ = this.horiz ? { labels: { autoRotation: [-45], padding: 4 }, margin: 15 } : { labels: { padding: 1 }, title: { rotation: 90 * this.side } };
          this.options = u(_, w[this.coll], I), y(this, "afterSetOptions", { userOptions: I });
        }
        defaultLabelFormatter() {
          let I = this.axis, { numberFormatter: _ } = this.chart, W = l(this.value) ? this.value : NaN, X = I.chart.time, z = I.categories, $ = this.dateTimeLabelFormat, K = w.lang, Q = K.numericSymbols, Z = K.numericSymbolMagnitude || 1e3, ee = I.logarithmic ? Math.abs(W) : I.tickInterval, J = Q && Q.length, ae, re;
          if (z) re = `${this.value}`;
          else if ($) re = X.dateFormat($, W);
          else if (J && Q && ee >= 1e3) for (; J-- && re === void 0; ) ee >= (ae = Math.pow(Z, J + 1)) && 10 * W % ae == 0 && Q[J] !== null && W !== 0 && (re = _(W / ae, -1) + Q[J]);
          return re === void 0 && (re = Math.abs(W) >= 1e4 ? _(W, -1) : _(W, -1, void 0, "")), re;
        }
        getSeriesExtremes() {
          let I, _ = this;
          y(this, "getSeriesExtremes", null, function() {
            _.hasVisibleSeries = !1, _.dataMin = _.dataMax = _.threshold = void 0, _.softThreshold = !_.isXAxis, _.series.forEach((W) => {
              if (W.reserveSpace()) {
                let X = W.options, z, $ = X.threshold, K, Q;
                if (_.hasVisibleSeries = !0, _.positiveValuesOnly && 0 >= ($ || 0) && ($ = void 0), _.isXAxis) (z = W.xData) && z.length && (z = _.logarithmic ? z.filter((Z) => Z > 0) : z, K = (I = W.getXExtremes(z)).min, Q = I.max, l(K) || K instanceof Date || (z = z.filter(l), K = (I = W.getXExtremes(z)).min, Q = I.max), z.length && (_.dataMin = Math.min(g(_.dataMin, K), K), _.dataMax = Math.max(g(_.dataMax, Q), Q)));
                else {
                  let Z = W.applyExtremes();
                  l(Z.dataMin) && (K = Z.dataMin, _.dataMin = Math.min(g(_.dataMin, K), K)), l(Z.dataMax) && (Q = Z.dataMax, _.dataMax = Math.max(g(_.dataMax, Q), Q)), A($) && (_.threshold = $), (!X.softThreshold || _.positiveValuesOnly) && (_.softThreshold = !1);
                }
              }
            });
          }), y(this, "afterGetSeriesExtremes");
        }
        translate(I, _, W, X, z, $) {
          var he;
          let K = this.linkedParent || this, Q = X && K.old ? K.old.min : K.min;
          if (!l(Q)) return NaN;
          let Z = K.minPixelPadding, ee = (K.isOrdinal || ((he = K.brokenAxis) == null ? void 0 : he.hasBreaks) || K.logarithmic && z) && K.lin2val, J = 1, ae = 0, re = X && K.old ? K.old.transA : K.transA, ce = 0;
          return re || (re = K.transA), W && (J *= -1, ae = K.len), K.reversed && (J *= -1, ae -= J * (K.sector || K.len)), _ ? (ce = (I = I * J + ae - Z) / re + Q, ee && (ce = K.lin2val(ce))) : (ee && (I = K.val2lin(I)), ce = J * (I - Q) * re + ae + J * Z + (l($) ? re * $ : 0), K.isRadial || (ce = m(ce))), ce;
        }
        toPixels(I, _) {
          return this.translate(I, !1, !this.horiz, void 0, !0) + (_ ? 0 : this.pos);
        }
        toValue(I, _) {
          return this.translate(I - (_ ? 0 : this.pos), !0, !this.horiz, void 0, !0);
        }
        getPlotLinePath(I) {
          let _ = this, W = _.chart, X = _.left, z = _.top, $ = I.old, K = I.value, Q = I.lineWidth, Z = $ && W.oldChartHeight || W.chartHeight, ee = $ && W.oldChartWidth || W.chartWidth, J = _.transB, ae = I.translatedValue, re = I.force, ce, he, ne, te, se;
          function oe(le, de, be) {
            return re !== "pass" && (le < de || le > be) && (re ? le = k(le, de, be) : se = !0), le;
          }
          let ie = { value: K, lineWidth: Q, old: $, force: re, acrossPanes: I.acrossPanes, translatedValue: ae };
          return y(this, "getPlotLinePath", ie, function(le) {
            ce = ne = (ae = k(ae = g(ae, _.translate(K, void 0, void 0, $)), -1e9, 1e9)) + J, he = te = Z - ae - J, l(ae) ? _.horiz ? (he = z, te = Z - _.bottom + (_.options.isInternal ? 0 : W.scrollablePixelsY || 0), ce = ne = oe(ce, X, X + _.width)) : (ce = X, ne = ee - _.right + (W.scrollablePixelsX || 0), he = te = oe(he, z, z + _.height)) : (se = !0, re = !1), le.path = se && !re ? void 0 : W.renderer.crispLine([["M", ce, he], ["L", ne, te]], Q || 1);
          }), ie.path;
        }
        getLinearTickPositions(I, _, W) {
          let X, z, $, K = m(Math.floor(_ / I) * I), Q = m(Math.ceil(W / I) * I), Z = [];
          if (m(K + I) === K && ($ = 20), this.single) return [_];
          for (X = K; X <= Q && (Z.push(X), (X = m(X + I, $)) !== z); ) z = X;
          return Z;
        }
        getMinorTickInterval() {
          let { minorTicks: I, minorTickInterval: _ } = this.options;
          return I === !0 ? g(_, "auto") : I !== !1 ? _ : void 0;
        }
        getMinorTickPositions() {
          let I = this.options, _ = this.tickPositions, W = this.minorTickInterval, X = this.pointRangePadding || 0, z = (this.min || 0) - X, $ = (this.max || 0) + X, K = $ - z, Q = [], Z;
          if (K && K / W < this.len / 3) {
            let ee = this.logarithmic;
            if (ee) this.paddedTicks.forEach(function(J, ae, re) {
              ae && Q.push.apply(Q, ee.getLogTickPositions(W, re[ae - 1], re[ae], !0));
            });
            else if (this.dateTime && this.getMinorTickInterval() === "auto") Q = Q.concat(this.getTimeTicks(this.dateTime.normalizeTimeTickInterval(W), z, $, I.startOfWeek));
            else for (Z = z + (_[0] - z) % W; Z <= $ && Z !== Q[0]; Z += W) Q.push(Z);
          }
          return Q.length !== 0 && this.trimTicks(Q), Q;
        }
        adjustForMinRange() {
          let I = this.options, _ = this.logarithmic, { max: W, min: X, minRange: z } = this, $, K, Q, Z;
          this.isXAxis && z === void 0 && !_ && (z = A(I.min) || A(I.max) || A(I.floor) || A(I.ceiling) ? null : Math.min(5 * (S(this.series.map((ee) => {
            var J;
            return (ee.xIncrement ? (J = ee.xData) == null ? void 0 : J.slice(0, 2) : ee.xData) || [];
          })) || 0), this.dataMax - this.dataMin)), l(W) && l(X) && l(z) && W - X < z && (K = this.dataMax - this.dataMin >= z, $ = (z - W + X) / 2, Q = [X - $, g(I.min, X - $)], K && (Q[2] = _ ? _.log2lin(this.dataMin) : this.dataMin), Z = [(X = p(Q)) + z, g(I.max, X + z)], K && (Z[2] = _ ? _.log2lin(this.dataMax) : this.dataMax), (W = v(Z)) - X < z && (Q[0] = W - z, Q[1] = g(I.min, W - z), X = p(Q))), this.minRange = z, this.min = X, this.max = W;
        }
        getClosest() {
          let I, _;
          if (this.categories) _ = 1;
          else {
            let W = [];
            this.series.forEach(function(X) {
              var $;
              let z = X.closestPointRange;
              (($ = X.xData) == null ? void 0 : $.length) === 1 ? W.push(X.xData[0]) : !X.noSharedTooltip && A(z) && X.reserveSpace() && (_ = A(_) ? Math.min(_, z) : z);
            }), W.length && (W.sort((X, z) => X - z), I = S([W]));
          }
          return I && _ ? Math.min(I, _) : I || _;
        }
        nameToX(I) {
          let _ = s(this.options.categories), W = _ ? this.categories : this.names, X = I.options.x, z;
          return I.series.requireSorting = !1, A(X) || (X = this.uniqueNames && W ? _ ? W.indexOf(I.name) : g(W.keys[I.name], -1) : I.series.autoIncrement()), X === -1 ? !_ && W && (z = W.length) : z = X, z !== void 0 ? (this.names[z] = I.name, this.names.keys[I.name] = z) : I.x && (z = I.x), z;
        }
        updateNames() {
          let I = this, _ = this.names;
          _.length > 0 && (Object.keys(_.keys).forEach(function(W) {
            delete _.keys[W];
          }), _.length = 0, this.minRange = this.userMinRange, (this.series || []).forEach((W) => {
            W.xIncrement = null, (!W.points || W.isDirtyData) && (I.max = Math.max(I.max, W.xData.length - 1), W.processData(), W.generatePoints()), W.data.forEach(function(X, z) {
              let $;
              X != null && X.options && X.name !== void 0 && ($ = I.nameToX(X)) !== void 0 && $ !== X.x && (X.x = $, W.xData[z] = $);
            });
          }));
        }
        setAxisTranslation() {
          let I = this, _ = I.max - I.min, W = I.linkedParent, X = !!I.categories, z = I.isXAxis, $ = I.axisPointRange || 0, K, Q = 0, Z = 0, ee, J = I.transA;
          (z || X || $) && (K = I.getClosest(), W ? (Q = W.minPointOffset, Z = W.pointRangePadding) : I.series.forEach(function(ae) {
            let re = X ? 1 : z ? g(ae.options.pointRange, K, 0) : I.axisPointRange || 0, ce = ae.options.pointPlacement;
            if ($ = Math.max($, re), !I.single || X) {
              let he = ae.is("xrange") ? !z : z;
              Q = Math.max(Q, he && b(ce) ? 0 : re / 2), Z = Math.max(Z, he && ce === "on" ? 0 : re);
            }
          }), ee = I.ordinal && I.ordinal.slope && K ? I.ordinal.slope / K : 1, I.minPointOffset = Q *= ee, I.pointRangePadding = Z *= ee, I.pointRange = Math.min($, I.single && X ? 1 : _), z && K && (I.closestPointRange = K)), I.translationSlope = I.transA = J = I.staticScale || I.len / (_ + Z || 1), I.transB = I.horiz ? I.left : I.bottom, I.minPixelPadding = J * Q, y(this, "afterSetAxisTranslation");
        }
        minFromRange() {
          let { max: I, min: _ } = this;
          return l(I) && l(_) && I - _ || void 0;
        }
        setTickInterval(I) {
          var we, ke, Me, Te;
          let { categories: _, chart: W, dataMax: X, dataMin: z, dateTime: $, isXAxis: K, logarithmic: Q, options: Z, softThreshold: ee } = this, J = l(this.threshold) ? this.threshold : void 0, ae = this.minRange || 0, { ceiling: re, floor: ce, linkedTo: he, softMax: ne, softMin: te } = Z, se = l(he) && ((we = W[this.coll]) == null ? void 0 : we[he]), oe = Z.tickPixelInterval, ie = Z.maxPadding, le = Z.minPadding, de = 0, be, ge = l(Z.tickInterval) && Z.tickInterval >= 0 ? Z.tickInterval : void 0, me, fe, Ae, ye;
          if ($ || _ || se || this.getTickAmount(), Ae = g(this.userMin, Z.min), ye = g(this.userMax, Z.max), se ? (this.linkedParent = se, be = se.getExtremes(), this.min = g(be.min, be.dataMin), this.max = g(be.max, be.dataMax), this.type !== se.type && G(11, !0, W)) : (ee && A(J) && l(X) && l(z) && (z >= J ? (me = J, le = 0) : X <= J && (fe = J, ie = 0)), this.min = g(Ae, me, z), this.max = g(ye, fe, X)), l(this.max) && l(this.min) && (Q && (this.positiveValuesOnly && !I && 0 >= Math.min(this.min, g(z, this.min)) && G(10, !0, W), this.min = m(Q.log2lin(this.min), 16), this.max = m(Q.log2lin(this.max), 16)), this.range && l(z) && (this.userMin = this.min = Ae = Math.max(z, this.minFromRange() || 0), this.userMax = ye = this.max, this.range = void 0)), y(this, "foundExtremes"), this.adjustForMinRange(), l(this.min) && l(this.max)) {
            if (!l(this.userMin) && l(te) && te < this.min && (this.min = Ae = te), !l(this.userMax) && l(ne) && ne > this.max && (this.max = ye = ne), _ || this.axisPointRange || (ke = this.stacking) != null && ke.usePercentage || se || !(de = this.max - this.min) || (!A(Ae) && le && (this.min -= de * le), A(ye) || !ie || (this.max += de * ie)), !l(this.userMin) && l(ce) && (this.min = Math.max(this.min, ce)), !l(this.userMax) && l(re) && (this.max = Math.min(this.max, re)), ee && l(z) && l(X)) {
              let Ie = J || 0;
              !A(Ae) && this.min < Ie && z >= Ie ? this.min = Z.minRange ? Math.min(Ie, this.max - ae) : Ie : !A(ye) && this.max > Ie && X <= Ie && (this.max = Z.minRange ? Math.max(Ie, this.min + ae) : Ie);
            }
            !W.polar && this.min > this.max && (A(Z.min) ? this.max = this.min : A(Z.max) && (this.min = this.max)), de = this.max - this.min;
          }
          if (this.min !== this.max && l(this.min) && l(this.max) ? se && !ge && oe === se.options.tickPixelInterval ? this.tickInterval = ge = se.tickInterval : this.tickInterval = g(ge, this.tickAmount ? de / Math.max(this.tickAmount - 1, 1) : void 0, _ ? 1 : de * oe / Math.max(this.len, oe)) : this.tickInterval = 1, K && !I) {
            let Ie = this.min !== ((Me = this.old) == null ? void 0 : Me.min) || this.max !== ((Te = this.old) == null ? void 0 : Te.max);
            this.series.forEach(function(He) {
              var $e;
              He.forceCrop = ($e = He.forceCropping) == null ? void 0 : $e.call(He), He.processData(Ie);
            }), y(this, "postProcessData", { hasExtremesChanged: Ie });
          }
          this.setAxisTranslation(), y(this, "initialAxisTranslation"), this.pointRange && !ge && (this.tickInterval = Math.max(this.pointRange, this.tickInterval));
          let xe = g(Z.minTickInterval, $ && !this.series.some((Ie) => Ie.noSharedTooltip) ? this.closestPointRange : 0);
          !ge && this.tickInterval < xe && (this.tickInterval = xe), $ || Q || ge || (this.tickInterval = V(this, this.tickInterval)), this.tickAmount || (this.tickInterval = this.unsquish()), this.setTickPositions();
        }
        setTickPositions() {
          var ee, J;
          let I = this.options, _ = I.tickPositions, W = I.tickPositioner, X = this.getMinorTickInterval(), z = !this.isPanning, $ = z && I.startOnTick, K = z && I.endOnTick, Q = [], Z;
          if (this.tickmarkOffset = this.categories && I.tickmarkPlacement === "between" && this.tickInterval === 1 ? 0.5 : 0, this.single = this.min === this.max && A(this.min) && !this.tickAmount && (this.min % 1 == 0 || I.allowDecimals !== !1), _) Q = _.slice();
          else if (l(this.min) && l(this.max)) {
            if (!((ee = this.ordinal) != null && ee.positions) && (this.max - this.min) / this.tickInterval > Math.max(2 * this.len, 200)) Q = [this.min, this.max], G(19, !1, this.chart);
            else if (this.dateTime) Q = this.getTimeTicks(this.dateTime.normalizeTimeTickInterval(this.tickInterval, I.units), this.min, this.max, I.startOfWeek, (J = this.ordinal) == null ? void 0 : J.positions, this.closestPointRange, !0);
            else if (this.logarithmic) Q = this.logarithmic.getLogTickPositions(this.tickInterval, this.min, this.max);
            else {
              let ae = this.tickInterval, re = ae;
              for (; re <= 2 * ae && (Q = this.getLinearTickPositions(this.tickInterval, this.min, this.max), this.tickAmount && Q.length > this.tickAmount); ) this.tickInterval = V(this, re *= 1.1);
            }
            Q.length > this.len && (Q = [Q[0], Q[Q.length - 1]])[0] === Q[1] && (Q.length = 1), W && (this.tickPositions = Q, (Z = W.apply(this, [this.min, this.max])) && (Q = Z));
          }
          this.tickPositions = Q, this.minorTickInterval = X === "auto" && this.tickInterval ? this.tickInterval / I.minorTicksPerMajor : X, this.paddedTicks = Q.slice(0), this.trimTicks(Q, $, K), !this.isLinked && l(this.min) && l(this.max) && (this.single && Q.length < 2 && !this.categories && !this.series.some((ae) => ae.is("heatmap") && ae.options.pointPlacement === "between") && (this.min -= 0.5, this.max += 0.5), _ || Z || this.adjustTickAmount()), y(this, "afterSetTickPositions");
        }
        trimTicks(I, _, W) {
          let X = I[0], z = I[I.length - 1], $ = !this.isOrdinal && this.minPointOffset || 0;
          if (y(this, "trimTicks"), !this.isLinked) {
            if (_ && X !== -1 / 0) this.min = X;
            else for (; this.min - $ > I[0]; ) I.shift();
            if (W) this.max = z;
            else for (; this.max + $ < I[I.length - 1]; ) I.pop();
            I.length === 0 && A(X) && !this.options.tickPositions && I.push((z + X) / 2);
          }
        }
        alignToOthers() {
          let I, _ = this, W = _.chart, X = [this], z = _.options, $ = W.options.chart, K = this.coll === "yAxis" && $.alignThresholds, Q = [];
          if (_.thresholdAlignment = void 0, ($.alignTicks !== !1 && z.alignTicks || K) && z.startOnTick !== !1 && z.endOnTick !== !1 && !_.logarithmic) {
            let Z = (J) => {
              let { horiz: ae, options: re } = J;
              return [ae ? re.left : re.top, re.width, re.height, re.pane].join(",");
            }, ee = Z(this);
            W[this.coll].forEach(function(J) {
              let { series: ae } = J;
              ae.length && ae.some((re) => re.visible) && J !== _ && Z(J) === ee && (I = !0, X.push(J));
            });
          }
          if (I && K) {
            X.forEach((ee) => {
              let J = ee.getThresholdAlignment(_);
              l(J) && Q.push(J);
            });
            let Z = Q.length > 1 ? Q.reduce((ee, J) => ee += J, 0) / Q.length : void 0;
            X.forEach((ee) => {
              ee.thresholdAlignment = Z;
            });
          }
          return I;
        }
        getThresholdAlignment(I) {
          if ((!l(this.dataMin) || this !== I && this.series.some((_) => _.isDirty || _.isDirtyData)) && this.getSeriesExtremes(), l(this.threshold)) {
            let _ = k((this.threshold - (this.dataMin || 0)) / ((this.dataMax || 0) - (this.dataMin || 0)), 0, 1);
            return this.options.reversed && (_ = 1 - _), _;
          }
        }
        getTickAmount() {
          let I = this.options, _ = I.tickPixelInterval, W = I.tickAmount;
          A(I.tickInterval) || W || !(this.len < _) || this.isRadial || this.logarithmic || !I.startOnTick || !I.endOnTick || (W = 2), !W && this.alignToOthers() && (W = Math.ceil(this.len / _) + 1), W < 4 && (this.finalTickAmt = W, W = 5), this.tickAmount = W;
        }
        adjustTickAmount() {
          let I = this, { finalTickAmt: _, max: W, min: X, options: z, tickPositions: $, tickAmount: K, thresholdAlignment: Q } = I, Z = $ == null ? void 0 : $.length, ee = g(I.threshold, I.softThreshold ? 0 : null), J, ae, re = I.tickInterval, ce, he = () => $.push(m($[$.length - 1] + re)), ne = () => $.unshift(m($[0] - re));
          if (l(Q) && (ce = Q < 0.5 ? Math.ceil(Q * (K - 1)) : Math.floor(Q * (K - 1)), z.reversed && (ce = K - 1 - ce)), I.hasData() && l(X) && l(W)) {
            let te = () => {
              I.transA *= (Z - 1) / (K - 1), I.min = z.startOnTick ? $[0] : Math.min(X, $[0]), I.max = z.endOnTick ? $[$.length - 1] : Math.max(W, $[$.length - 1]);
            };
            if (l(ce) && l(I.threshold)) {
              for (; $[ce] !== ee || $.length !== K || $[0] > X || $[$.length - 1] < W; ) {
                for ($.length = 0, $.push(I.threshold); $.length < K; ) $[ce] === void 0 || $[ce] > I.threshold ? ne() : he();
                if (re > 8 * I.tickInterval) break;
                re *= 2;
              }
              te();
            } else if (Z < K) {
              for (; $.length < K; ) $.length % 2 || X === ee ? he() : ne();
              te();
            }
            if (A(_)) {
              for (ae = J = $.length; ae--; ) (_ === 3 && ae % 2 == 1 || _ <= 2 && ae > 0 && ae < J - 1) && $.splice(ae, 1);
              I.finalTickAmt = void 0;
            }
          }
        }
        setScale() {
          var $, K;
          let { coll: I, stacking: _ } = this, W = !1, X = !1;
          this.series.forEach((Q) => {
            W = W || Q.isDirtyData || Q.isDirty, X = X || Q.xAxis && Q.xAxis.isDirty || !1;
          }), this.setAxisSize();
          let z = this.len !== (this.old && this.old.len);
          z || W || X || this.isLinked || this.forceRedraw || this.userMin !== (this.old && this.old.userMin) || this.userMax !== (this.old && this.old.userMax) || this.alignToOthers() ? (_ && I === "yAxis" && _.buildStacks(), this.forceRedraw = !1, this.userMinRange || (this.minRange = void 0), this.getSeriesExtremes(), this.setTickInterval(), _ && I === "xAxis" && _.buildStacks(), this.isDirty || (this.isDirty = z || this.min !== (($ = this.old) == null ? void 0 : $.min) || this.max !== ((K = this.old) == null ? void 0 : K.max))) : _ && _.cleanStacks(), W && delete this.allExtremes, y(this, "afterSetScale");
        }
        setExtremes(I, _, W = !0, X, z) {
          this.series.forEach(($) => {
            delete $.kdTree;
          }), y(this, "setExtremes", z = P(z, { min: I, max: _ }), ($) => {
            this.userMin = $.min, this.userMax = $.max, this.eventArgs = $, W && this.chart.redraw(X);
          });
        }
        setAxisSize() {
          let I = this.chart, _ = this.options, W = _.offsets || [0, 0, 0, 0], X = this.horiz, z = this.width = Math.round(E(g(_.width, I.plotWidth - W[3] + W[1]), I.plotWidth)), $ = this.height = Math.round(E(g(_.height, I.plotHeight - W[0] + W[2]), I.plotHeight)), K = this.top = Math.round(E(g(_.top, I.plotTop + W[0]), I.plotHeight, I.plotTop)), Q = this.left = Math.round(E(g(_.left, I.plotLeft + W[3]), I.plotWidth, I.plotLeft));
          this.bottom = I.chartHeight - $ - K, this.right = I.chartWidth - z - Q, this.len = Math.max(X ? z : $, 0), this.pos = X ? Q : K;
        }
        getExtremes() {
          let I = this.logarithmic;
          return { min: I ? m(I.lin2log(this.min)) : this.min, max: I ? m(I.lin2log(this.max)) : this.max, dataMin: this.dataMin, dataMax: this.dataMax, userMin: this.userMin, userMax: this.userMax };
        }
        getThreshold(I) {
          let _ = this.logarithmic, W = _ ? _.lin2log(this.min) : this.min, X = _ ? _.lin2log(this.max) : this.max;
          return I === null || I === -1 / 0 ? I = W : I === 1 / 0 ? I = X : W > I ? I = W : X < I && (I = X), this.translate(I, 0, 1, 0, 1);
        }
        autoLabelAlign(I) {
          let _ = (g(I, 0) - 90 * this.side + 720) % 360, W = { align: "center" };
          return y(this, "autoLabelAlign", W, function(X) {
            _ > 15 && _ < 165 ? X.align = "right" : _ > 195 && _ < 345 && (X.align = "left");
          }), W.align;
        }
        tickSize(I) {
          let _ = this.options, W = g(_[I === "tick" ? "tickWidth" : "minorTickWidth"], I === "tick" && this.isXAxis && !this.categories ? 1 : 0), X = _[I === "tick" ? "tickLength" : "minorTickLength"], z;
          W && X && (_[I + "Position"] === "inside" && (X = -X), z = [X, W]);
          let $ = { tickSize: z };
          return y(this, "afterTickSize", $), $.tickSize;
        }
        labelMetrics() {
          let I = this.chart.renderer, _ = this.ticks, W = _[Object.keys(_)[0]] || {};
          return this.chart.renderer.fontMetrics(W.label || W.movedLabel || I.box);
        }
        unsquish() {
          let I = this.options.labels, _ = I.padding || 0, W = this.horiz, X = this.tickInterval, z = this.len / (((this.categories ? 1 : 0) + this.max - this.min) / X), $ = I.rotation, K = m(0.8 * this.labelMetrics().h), Q = Math.max(this.max - this.min, 0), Z = function(ce) {
            let he = (ce + 2 * _) / (z || 1);
            return (he = he > 1 ? Math.ceil(he) : 1) * X > Q && ce !== 1 / 0 && z !== 1 / 0 && Q && (he = Math.ceil(Q / X)), m(he * X);
          }, ee = X, J, ae = Number.MAX_VALUE, re;
          if (W) {
            if (!I.staggerLines && (l($) ? re = [$] : z < I.autoRotationLimit && (re = I.autoRotation)), re) {
              let ce, he;
              for (let ne of re) (ne === $ || ne && ne >= -90 && ne <= 90) && (he = (ce = Z(Math.abs(K / Math.sin(M * ne)))) + Math.abs(ne / 360)) < ae && (ae = he, J = ne, ee = ce);
            }
          } else ee = Z(0.75 * K);
          return this.autoRotation = re, this.labelRotation = g(J, l($) ? $ : 0), I.step ? X : ee;
        }
        getSlotWidth(I) {
          let _ = this.chart, W = this.horiz, X = this.options.labels, z = Math.max(this.tickPositions.length - (this.categories ? 0 : 1), 1), $ = _.margin[3];
          if (I && l(I.slotWidth)) return I.slotWidth;
          if (W && X.step < 2) return X.rotation ? 0 : (this.staggerLines || 1) * this.len / z;
          if (!W) {
            let K = X.style.width;
            if (K !== void 0) return parseInt(String(K), 10);
            if ($) return $ - _.spacing[3];
          }
          return 0.33 * _.chartWidth;
        }
        renderUnsquish() {
          let I = this.chart, _ = I.renderer, W = this.tickPositions, X = this.ticks, z = this.options.labels, $ = z.style, K = this.horiz, Q = this.getSlotWidth(), Z = Math.max(1, Math.round(Q - (K ? 2 * (z.padding || 0) : z.distance || 0))), ee = {}, J = this.labelMetrics(), ae = $.textOverflow, re, ce, he = 0, ne, te;
          if (b(z.rotation) || (ee.rotation = z.rotation || 0), W.forEach(function(se) {
            let oe = X[se];
            oe.movedLabel && oe.replaceMovedLabel(), oe && oe.label && oe.label.textPxLength > he && (he = oe.label.textPxLength);
          }), this.maxLabelLength = he, this.autoRotation) he > Z && he > J.h ? ee.rotation = this.labelRotation : this.labelRotation = 0;
          else if (Q && (re = Z, !ae)) for (ce = "clip", te = W.length; !K && te--; ) (ne = X[W[te]].label) && (ne.styles.textOverflow === "ellipsis" ? ne.css({ textOverflow: "clip" }) : ne.textPxLength > Q && ne.css({ width: Q + "px" }), ne.getBBox().height > this.len / W.length - (J.h - J.f) && (ne.specificTextOverflow = "ellipsis"));
          ee.rotation && (re = he > 0.5 * I.chartHeight ? 0.33 * I.chartHeight : he, ae || (ce = "ellipsis")), this.labelAlign = z.align || this.autoLabelAlign(this.labelRotation), this.labelAlign && (ee.align = this.labelAlign), W.forEach(function(se) {
            let oe = X[se], ie = oe && oe.label, le = $.width, de = {};
            ie && (ie.attr(ee), oe.shortenLabel ? oe.shortenLabel() : re && !le && $.whiteSpace !== "nowrap" && (re < ie.textPxLength || ie.element.tagName === "SPAN") ? (de.width = re + "px", ae || (de.textOverflow = ie.specificTextOverflow || ce), ie.css(de)) : !ie.styles.width || de.width || le || ie.css({ width: null }), delete ie.specificTextOverflow, oe.rotation = ee.rotation);
          }, this), this.tickRotCorr = _.rotCorr(J.b, this.labelRotation || 0, this.side !== 0);
        }
        hasData() {
          return this.series.some(function(I) {
            return I.hasData();
          }) || this.options.showEmpty && A(this.min) && A(this.max);
        }
        addTitle(I) {
          let _, W = this.chart.renderer, X = this.horiz, z = this.opposite, $ = this.options.title, K = this.chart.styledMode;
          this.axisTitle || ((_ = $.textAlign) || (_ = (X ? { low: "left", middle: "center", high: "right" } : { low: z ? "right" : "left", middle: "center", high: z ? "left" : "right" })[$.align]), this.axisTitle = W.text($.text || "", 0, 0, $.useHTML).attr({ zIndex: 7, rotation: $.rotation || 0, align: _ }).addClass("highcharts-axis-title"), K || this.axisTitle.css(u($.style)), this.axisTitle.add(this.axisGroup), this.axisTitle.isNew = !0), K || $.style.width || this.isRadial || this.axisTitle.css({ width: this.len + "px" }), this.axisTitle[I ? "show" : "hide"](I);
        }
        generateTick(I) {
          let _ = this.ticks;
          _[I] ? _[I].addLabel() : _[I] = new D(this, I);
        }
        createGroups() {
          let { axisParent: I, chart: _, coll: W, options: X } = this, z = _.renderer, $ = (K, Q, Z) => z.g(K).attr({ zIndex: Z }).addClass(`highcharts-${W.toLowerCase()}${Q} ` + (this.isRadial ? `highcharts-radial-axis${Q} ` : "") + (X.className || "")).add(I);
          this.axisGroup || (this.gridGroup = $("grid", "-grid", X.gridZIndex), this.axisGroup = $("axis", "", X.zIndex), this.labelGroup = $("axis-labels", "-labels", X.labels.zIndex));
        }
        getOffset() {
          let I = this, { chart: _, horiz: W, options: X, side: z, ticks: $, tickPositions: K, coll: Q } = I, Z = _.inverted && !I.isZAxis ? [1, 0, 3, 2][z] : z, ee = I.hasData(), J = X.title, ae = X.labels, re = l(X.crossing), ce = _.axisOffset, he = _.clipOffset, ne = [-1, 1, 1, -1][z], te, se = 0, oe, ie = 0, le = 0, de, be;
          if (I.showAxis = te = ee || X.showEmpty, I.staggerLines = I.horiz && ae.staggerLines || void 0, I.createGroups(), ee || I.isLinked ? (K.forEach(function(ge) {
            I.generateTick(ge);
          }), I.renderUnsquish(), I.reserveSpaceDefault = z === 0 || z === 2 || { 1: "left", 3: "right" }[z] === I.labelAlign, g(ae.reserveSpace, !re && null, I.labelAlign === "center" || null, I.reserveSpaceDefault) && K.forEach(function(ge) {
            le = Math.max($[ge].getLabelSize(), le);
          }), I.staggerLines && (le *= I.staggerLines), I.labelOffset = le * (I.opposite ? -1 : 1)) : h($, function(ge, me) {
            ge.destroy(), delete $[me];
          }), J != null && J.text && J.enabled !== !1 && (I.addTitle(te), te && !re && J.reserveSpace !== !1 && (I.titleOffset = se = I.axisTitle.getBBox()[W ? "height" : "width"], ie = A(oe = J.offset) ? 0 : g(J.margin, W ? 5 : 10))), I.renderLine(), I.offset = ne * g(X.offset, ce[z] ? ce[z] + (X.margin || 0) : 0), I.tickRotCorr = I.tickRotCorr || { x: 0, y: 0 }, be = z === 0 ? -I.labelMetrics().h : z === 2 ? I.tickRotCorr.y : 0, de = Math.abs(le) + ie, le && (de -= be, de += ne * (W ? g(ae.y, I.tickRotCorr.y + ne * ae.distance) : g(ae.x, ne * ae.distance))), I.axisTitleMargin = g(oe, de), I.getMaxLabelDimensions && (I.maxLabelDimensions = I.getMaxLabelDimensions($, K)), Q !== "colorAxis" && he) {
            let ge = this.tickSize("tick");
            ce[z] = Math.max(ce[z], (I.axisTitleMargin || 0) + se + ne * I.offset, de, K && K.length && ge ? ge[0] + ne * I.offset : 0);
            let me = !I.axisLine || X.offset ? 0 : I.axisLine.strokeWidth() / 2;
            he[Z] = Math.max(he[Z], me);
          }
          y(this, "afterGetOffset");
        }
        getLinePath(I) {
          let _ = this.chart, W = this.opposite, X = this.offset, z = this.horiz, $ = this.left + (W ? this.width : 0) + X, K = _.chartHeight - this.bottom - (W ? this.height : 0) + X;
          return W && (I *= -1), _.renderer.crispLine([["M", z ? this.left : $, z ? K : this.top], ["L", z ? _.chartWidth - this.right : $, z ? K : _.chartHeight - this.bottom]], I);
        }
        renderLine() {
          this.axisLine || (this.axisLine = this.chart.renderer.path().addClass("highcharts-axis-line").add(this.axisGroup), this.chart.styledMode || this.axisLine.attr({ stroke: this.options.lineColor, "stroke-width": this.options.lineWidth, zIndex: 7 }));
        }
        getTitlePosition(I) {
          let _ = this.horiz, W = this.left, X = this.top, z = this.len, $ = this.options.title, K = _ ? W : X, Q = this.opposite, Z = this.offset, ee = $.x, J = $.y, ae = this.chart.renderer.fontMetrics(I), re = I ? Math.max(I.getBBox(!1, 0).height - ae.h - 1, 0) : 0, ce = { low: K + (_ ? 0 : z), middle: K + z / 2, high: K + (_ ? z : 0) }[$.align], he = (_ ? X + this.height : W) + (_ ? 1 : -1) * (Q ? -1 : 1) * (this.axisTitleMargin || 0) + [-re, re, ae.f, -re][this.side], ne = { x: _ ? ce + ee : he + (Q ? this.width : 0) + Z + ee, y: _ ? he + J - (Q ? this.height : 0) + Z : ce + J };
          return y(this, "afterGetTitlePosition", { titlePosition: ne }), ne;
        }
        renderMinorTick(I, _) {
          let W = this.minorTicks;
          W[I] || (W[I] = new D(this, I, "minor")), _ && W[I].isNew && W[I].render(null, !0), W[I].render(null, !1, 1);
        }
        renderTick(I, _, W) {
          let X = this.isLinked, z = this.ticks;
          (!X || I >= this.min && I <= this.max || this.grid && this.grid.isColumn) && (z[I] || (z[I] = new D(this, I)), W && z[I].isNew && z[I].render(_, !0, -1), z[I].render(_));
        }
        render() {
          let I, _, W = this, X = W.chart, z = W.logarithmic, $ = X.renderer, K = W.options, Q = W.isLinked, Z = W.tickPositions, ee = W.axisTitle, J = W.ticks, ae = W.minorTicks, re = W.alternateBands, ce = K.stackLabels, he = K.alternateGridColor, ne = K.crossing, te = W.tickmarkOffset, se = W.axisLine, oe = W.showAxis, ie = B($.globalAnimation);
          if (W.labelEdge.length = 0, W.overlap = !1, [J, ae, re].forEach(function(le) {
            h(le, function(de) {
              de.isActive = !1;
            });
          }), l(ne)) {
            let le = this.isXAxis ? X.yAxis[0] : X.xAxis[0], de = [1, -1, -1, 1][this.side];
            if (le) {
              let be = le.toPixels(ne, !0);
              W.horiz && (be = le.len - be), W.offset = de * be;
            }
          }
          if (W.hasData() || Q) {
            let le = W.chart.hasRendered && W.old && l(W.old.min);
            W.minorTickInterval && !W.categories && W.getMinorTickPositions().forEach(function(de) {
              W.renderMinorTick(de, le);
            }), Z.length && (Z.forEach(function(de, be) {
              W.renderTick(de, be, le);
            }), te && (W.min === 0 || W.single) && (J[-1] || (J[-1] = new D(W, -1, null, !0)), J[-1].render(-1))), he && Z.forEach(function(de, be) {
              _ = Z[be + 1] !== void 0 ? Z[be + 1] + te : W.max - te, be % 2 == 0 && de < W.max && _ <= W.max + (X.polar ? -te : te) && (re[de] || (re[de] = new j.PlotLineOrBand(W, {})), I = de + te, re[de].options = { from: z ? z.lin2log(I) : I, to: z ? z.lin2log(_) : _, color: he, className: "highcharts-alternate-grid" }, re[de].render(), re[de].isActive = !0);
            }), W._addedPlotLB || (W._addedPlotLB = !0, (K.plotLines || []).concat(K.plotBands || []).forEach(function(de) {
              W.addPlotBandOrLine(de);
            }));
          }
          [J, ae, re].forEach(function(le) {
            let de = [], be = ie.duration;
            h(le, function(ge, me) {
              ge.isActive || (ge.render(me, !1, 0), ge.isActive = !1, de.push(me));
            }), U(function() {
              let ge = de.length;
              for (; ge--; ) le[de[ge]] && !le[de[ge]].isActive && (le[de[ge]].destroy(), delete le[de[ge]]);
            }, le !== re && X.hasRendered && be ? be : 0);
          }), se && (se[se.isPlaced ? "animate" : "attr"]({ d: this.getLinePath(se.strokeWidth()) }), se.isPlaced = !0, se[oe ? "show" : "hide"](oe)), ee && oe && (ee[ee.isNew ? "attr" : "animate"](W.getTitlePosition(ee)), ee.isNew = !1), ce && ce.enabled && W.stacking && W.stacking.renderStackTotals(), W.old = { len: W.len, max: W.max, min: W.min, transA: W.transA, userMax: W.userMax, userMin: W.userMin }, W.isDirty = !1, y(this, "afterRender");
        }
        redraw() {
          this.visible && (this.render(), this.plotLinesAndBands.forEach(function(I) {
            I.render();
          })), this.series.forEach(function(I) {
            I.isDirty = !0;
          });
        }
        getKeepProps() {
          return this.keepProps || q.keepProps;
        }
        destroy(I) {
          let _ = this, W = _.plotLinesAndBands, X = this.eventOptions;
          if (y(this, "destroy", { keepEvents: I }), I || R(_), [_.ticks, _.minorTicks, _.alternateBands].forEach(function(z) {
            C(z);
          }), W) {
            let z = W.length;
            for (; z--; ) W[z].destroy();
          }
          for (let z in ["axisLine", "axisTitle", "axisGroup", "gridGroup", "labelGroup", "cross", "scrollbar"].forEach(function($) {
            _[$] && (_[$] = _[$].destroy());
          }), _.plotLinesAndBandsGroups) _.plotLinesAndBandsGroups[z] = _.plotLinesAndBandsGroups[z].destroy();
          h(_, function(z, $) {
            _.getKeepProps().indexOf($) === -1 && delete _[$];
          }), this.eventOptions = X;
        }
        drawCrosshair(I, _) {
          let W = this.crosshair, X = g(W && W.snap, !0), z = this.chart, $, K, Q, Z = this.cross, ee;
          if (y(this, "drawCrosshair", { e: I, point: _ }), I || (I = this.cross && this.cross.e), W && (A(_) || !X) !== !1) {
            if (X ? A(_) && (K = g(this.coll !== "colorAxis" ? _.crosshairPos : null, this.isXAxis ? _.plotX : this.len - _.plotY)) : K = I && (this.horiz ? I.chartX - this.pos : this.len - I.chartY + this.pos), A(K) && (ee = { value: _ && (this.isXAxis ? _.x : g(_.stackY, _.y)), translatedValue: K }, z.polar && P(ee, { isCrosshair: !0, chartX: I && I.chartX, chartY: I && I.chartY, point: _ }), $ = this.getPlotLinePath(ee) || null), !A($)) {
              this.hideCrosshair();
              return;
            }
            Q = this.categories && !this.isRadial, Z || (this.cross = Z = z.renderer.path().addClass("highcharts-crosshair highcharts-crosshair-" + (Q ? "category " : "thin ") + (W.className || "")).attr({ zIndex: g(W.zIndex, 2) }).add(), !z.styledMode && (Z.attr({ stroke: W.color || (Q ? r.parse("#ccd3ff").setOpacity(0.25).get() : "#cccccc"), "stroke-width": g(W.width, 1) }).css({ "pointer-events": "none" }), W.dashStyle && Z.attr({ dashstyle: W.dashStyle }))), Z.show().attr({ d: $ }), Q && !W.width && Z.attr({ "stroke-width": this.transA }), this.cross.e = I;
          } else this.hideCrosshair();
          y(this, "afterDrawCrosshair", { e: I, point: _ });
        }
        hideCrosshair() {
          this.cross && this.cross.hide(), y(this, "afterHideCrosshair");
        }
        update(I, _) {
          let W = this.chart;
          I = u(this.userOptions, I), this.destroy(!0), this.init(W, I), W.isDirtyBox = !0, g(_, !0) && W.redraw();
        }
        remove(I) {
          let _ = this.chart, W = this.coll, X = this.series, z = X.length;
          for (; z--; ) X[z] && X[z].remove(!1);
          H(_.axes, this), H(_[W] || [], this), _.orderItems(W), this.destroy(), _.isDirtyBox = !0, g(I, !0) && _.redraw();
        }
        setTitle(I, _) {
          this.update({ title: I }, _);
        }
        setCategories(I, _) {
          this.update({ categories: I }, _);
        }
      }
      return q.keepProps = ["coll", "extKey", "hcEvents", "len", "names", "series", "userMax", "userMin"], q;
    }), a(e, "Core/Axis/DateTimeAxis.js", [e["Core/Utilities.js"]], function(o) {
      var n;
      let { addEvent: r, getMagnitude: T, normalizeTickInterval: O, timeUnits: j } = o;
      return function(D) {
        function F() {
          return this.chart.time.getTimeTicks.apply(this.chart.time, arguments);
        }
        function B() {
          if (this.type !== "datetime") {
            this.dateTime = void 0;
            return;
          }
          this.dateTime || (this.dateTime = new N(this));
        }
        D.compose = function(f) {
          return f.keepProps.includes("dateTime") || (f.keepProps.push("dateTime"), f.prototype.getTimeTicks = F, r(f, "afterSetType", B)), f;
        };
        class N {
          constructor(w) {
            this.axis = w;
          }
          normalizeTimeTickInterval(w, x) {
            let M = x || [["millisecond", [1, 2, 5, 10, 20, 25, 50, 100, 200, 500]], ["second", [1, 2, 5, 10, 15, 30]], ["minute", [1, 2, 5, 10, 15, 30]], ["hour", [1, 2, 3, 4, 6, 8, 12]], ["day", [1, 2]], ["week", [1, 2]], ["month", [1, 2, 3, 4, 6]], ["year", null]], p = M[M.length - 1], v = j[p[0]], k = p[1], m;
            for (m = 0; m < M.length && (v = j[(p = M[m])[0]], k = p[1], !M[m + 1] || !(w <= (v * k[k.length - 1] + j[M[m + 1][0]]) / 2)); m++) ;
            v === j.year && w < 5 * v && (k = [1, 2, 5]);
            let A = O(w / v, k, p[0] === "year" ? Math.max(T(w / v), 1) : 1);
            return { unitRange: v, count: A, unitName: p[0] };
          }
          getXDateFormat(w, x) {
            let { axis: M } = this, p = M.chart.time;
            return M.closestPointRange ? p.getDateFormat(M.closestPointRange, w, M.options.startOfWeek, x) || p.resolveDTLFormat(x.year).main : p.resolveDTLFormat(x.day).main;
          }
        }
        D.Additions = N;
      }(n || (n = {})), n;
    }), a(e, "Core/Axis/LogarithmicAxis.js", [e["Core/Utilities.js"]], function(o) {
      var n;
      let { addEvent: r, normalizeTickInterval: T, pick: O } = o;
      return function(j) {
        function D() {
          var N;
          this.type !== "logarithmic" ? this.logarithmic = void 0 : (N = this.logarithmic) != null || (this.logarithmic = new B(this));
        }
        function F() {
          let N = this.logarithmic;
          N && (this.lin2val = function(f) {
            return N.lin2log(f);
          }, this.val2lin = function(f) {
            return N.log2lin(f);
          });
        }
        j.compose = function(N) {
          return N.keepProps.includes("logarithmic") || (N.keepProps.push("logarithmic"), r(N, "afterSetType", D), r(N, "afterInit", F)), N;
        };
        class B {
          constructor(f) {
            this.axis = f;
          }
          getLogTickPositions(f, w, x, M) {
            let p = this.axis, v = p.len, k = p.options, m = [];
            if (M || (this.minorAutoInterval = void 0), f >= 0.5) f = Math.round(f), m = p.getLinearTickPositions(f, w, x);
            else if (f >= 0.08) {
              let A, C, H, G, P, y, S, d = Math.floor(w);
              for (A = f > 0.3 ? [1, 2, 4] : f > 0.15 ? [1, 2, 4, 6, 8] : [1, 2, 3, 4, 5, 6, 7, 8, 9], C = d; C < x + 1 && !S; C++) for (H = 0, G = A.length; H < G && !S; H++) (P = this.log2lin(this.lin2log(C) * A[H])) > w && (!M || y <= x) && y !== void 0 && m.push(y), y > x && (S = !0), y = P;
            } else {
              let A = this.lin2log(w), C = this.lin2log(x), H = M ? p.getMinorTickInterval() : k.tickInterval, G = k.tickPixelInterval / (M ? 5 : 1), P = M ? v / p.tickPositions.length : v;
              f = T(f = O(H === "auto" ? null : H, this.minorAutoInterval, (C - A) * G / (P || 1))), m = p.getLinearTickPositions(f, A, C).map(this.log2lin), M || (this.minorAutoInterval = f / 5);
            }
            return M || (p.tickInterval = f), m;
          }
          lin2log(f) {
            return Math.pow(10, f);
          }
          log2lin(f) {
            return Math.log(f) / Math.LN10;
          }
        }
        j.Additions = B;
      }(n || (n = {})), n;
    }), a(e, "Core/Axis/PlotLineOrBand/PlotLineOrBandAxis.js", [e["Core/Utilities.js"]], function(o) {
      var n;
      let { erase: r, extend: T, isNumber: O } = o;
      return function(j) {
        let D;
        function F(p) {
          return this.addPlotBandOrLine(p, "plotBands");
        }
        function B(p, v) {
          let k = this.userOptions, m = new D(this, p);
          if (this.visible && (m = m.render()), m) {
            if (this._addedPlotLB || (this._addedPlotLB = !0, (k.plotLines || []).concat(k.plotBands || []).forEach((A) => {
              this.addPlotBandOrLine(A);
            })), v) {
              let A = k[v] || [];
              A.push(p), k[v] = A;
            }
            this.plotLinesAndBands.push(m);
          }
          return m;
        }
        function N(p) {
          return this.addPlotBandOrLine(p, "plotLines");
        }
        function f(p, v, k) {
          k = k || this.options;
          let m = this.getPlotLinePath({ value: v, force: !0, acrossPanes: k.acrossPanes }), A = [], C = this.horiz, H = !O(this.min) || !O(this.max) || p < this.min && v < this.min || p > this.max && v > this.max, G = this.getPlotLinePath({ value: p, force: !0, acrossPanes: k.acrossPanes }), P, y = 1, S;
          if (G && m) for (H && (S = G.toString() === m.toString(), y = 0), P = 0; P < G.length; P += 2) {
            let d = G[P], s = G[P + 1], l = m[P], b = m[P + 1];
            (d[0] === "M" || d[0] === "L") && (s[0] === "M" || s[0] === "L") && (l[0] === "M" || l[0] === "L") && (b[0] === "M" || b[0] === "L") && (C && l[1] === d[1] ? (l[1] += y, b[1] += y) : C || l[2] !== d[2] || (l[2] += y, b[2] += y), A.push(["M", d[1], d[2]], ["L", s[1], s[2]], ["L", b[1], b[2]], ["L", l[1], l[2]], ["Z"])), A.isFlat = S;
          }
          return A;
        }
        function w(p) {
          this.removePlotBandOrLine(p);
        }
        function x(p) {
          let v = this.plotLinesAndBands, k = this.options, m = this.userOptions;
          if (v) {
            let A = v.length;
            for (; A--; ) v[A].id === p && v[A].destroy();
            [k.plotLines || [], m.plotLines || [], k.plotBands || [], m.plotBands || []].forEach(function(C) {
              for (A = C.length; A--; ) (C[A] || {}).id === p && r(C, C[A]);
            });
          }
        }
        function M(p) {
          this.removePlotBandOrLine(p);
        }
        j.compose = function(p, v) {
          let k = v.prototype;
          return k.addPlotBand || (D = p, T(k, { addPlotBand: F, addPlotLine: N, addPlotBandOrLine: B, getPlotBandPath: f, removePlotBand: w, removePlotLine: M, removePlotBandOrLine: x })), v;
        };
      }(n || (n = {})), n;
    }), a(e, "Core/Axis/PlotLineOrBand/PlotLineOrBand.js", [e["Core/Axis/PlotLineOrBand/PlotLineOrBandAxis.js"], e["Core/Utilities.js"]], function(o, n) {
      let { addEvent: r, arrayMax: T, arrayMin: O, defined: j, destroyObjectProperties: D, erase: F, fireEvent: B, merge: N, objectEach: f, pick: w } = n;
      class x {
        static compose(p, v) {
          return r(p, "afterInit", function() {
            this.labelCollectors.push(() => {
              var m;
              let k = [];
              for (let A of this.axes) for (let { label: C, options: H } of A.plotLinesAndBands) C && !((m = H == null ? void 0 : H.label) != null && m.allowOverlap) && k.push(C);
              return k;
            });
          }), o.compose(x, v);
        }
        constructor(p, v) {
          this.axis = p, this.options = v, this.id = v.id;
        }
        render() {
          var V, q, Y;
          B(this, "render");
          let { axis: p, options: v } = this, { horiz: k, logarithmic: m } = p, { color: A, events: C, zIndex: H = 0 } = v, G = {}, P = p.chart.renderer, y = v.to, S = v.from, d = v.value, s = v.borderWidth, l = v.label, { label: b, svgElem: u } = this, c = [], h, g = j(S) && j(y), E = j(d), R = !u, L = { class: "highcharts-plot-" + (g ? "band " : "line ") + (v.className || "") }, U = g ? "bands" : "lines";
          if (!p.chart.styledMode && (E ? (L.stroke = A || "#999999", L["stroke-width"] = w(v.width, 1), v.dashStyle && (L.dashstyle = v.dashStyle)) : g && (L.fill = A || "#e6e9ff", s && (L.stroke = v.borderColor, L["stroke-width"] = s))), G.zIndex = H, U += "-" + H, (h = p.plotLinesAndBandsGroups[U]) || (p.plotLinesAndBandsGroups[U] = h = P.g("plot-" + U).attr(G).add()), u || (this.svgElem = u = P.path().attr(L).add(h)), j(d)) c = p.getPlotLinePath({ value: (V = m == null ? void 0 : m.log2lin(d)) != null ? V : d, lineWidth: u.strokeWidth(), acrossPanes: v.acrossPanes });
          else {
            if (!(j(S) && j(y))) return;
            c = p.getPlotBandPath((q = m == null ? void 0 : m.log2lin(S)) != null ? q : S, (Y = m == null ? void 0 : m.log2lin(y)) != null ? Y : y, v);
          }
          return !this.eventsAdded && C && (f(C, (I, _) => {
            u == null || u.on(_, (W) => {
              C[_].apply(this, [W]);
            });
          }), this.eventsAdded = !0), (R || !u.d) && (c != null && c.length) ? u.attr({ d: c }) : u && (c ? (u.show(), u.animate({ d: c })) : u.d && (u.hide(), b && (this.label = b = b.destroy()))), l && (j(l.text) || j(l.formatter)) && (c != null && c.length) && p.width > 0 && p.height > 0 && !c.isFlat ? (l = N({ align: k && g ? "center" : void 0, x: k ? !g && 4 : 10, verticalAlign: !k && g ? "middle" : void 0, y: k ? g ? 16 : 10 : g ? 6 : -4, rotation: k && !g ? 90 : 0, ...g ? { inside: !0 } : {} }, l), this.renderLabel(l, c, g, H)) : b && b.hide(), this;
        }
        renderLabel(p, v, k, m) {
          var l;
          let A = this.axis, C = A.chart.renderer, H = p.inside, G = this.label;
          G || (this.label = G = C.text(this.getLabelText(p), 0, 0, p.useHTML).attr({ align: p.textAlign || p.align, rotation: p.rotation, class: "highcharts-plot-" + (k ? "band" : "line") + "-label " + (p.className || ""), zIndex: m }), A.chart.styledMode || G.css(N({ fontSize: "0.8em", textOverflow: k && !H ? "" : "ellipsis" }, p.style)), G.add());
          let P = v.xBounds || [v[0][1], v[1][1], k ? v[2][1] : v[0][1]], y = v.yBounds || [v[0][2], v[1][2], k ? v[2][2] : v[0][2]], S = O(P), d = O(y), s = T(P) - S;
          G.align(p, !1, { x: S, y: d, width: s, height: T(y) - d }), (!G.alignValue || G.alignValue === "left" || j(H)) && G.css({ width: (((l = p.style) == null ? void 0 : l.width) || (k && H ? s : G.rotation === 90 ? A.height - (G.alignAttr.y - A.top) : (p.clip ? A.width : A.chart.chartWidth) - (G.alignAttr.x - A.left))) + "px" }), G.show(!0);
        }
        getLabelText(p) {
          return j(p.formatter) ? p.formatter.call(this) : p.text;
        }
        destroy() {
          F(this.axis.plotLinesAndBands, this), delete this.axis, D(this);
        }
      }
      return x;
    }), a(e, "Core/Tooltip.js", [e["Core/Animation/AnimationUtilities.js"], e["Core/Templating.js"], e["Core/Globals.js"], e["Core/Renderer/RendererUtilities.js"], e["Core/Renderer/RendererRegistry.js"], e["Core/Utilities.js"]], function(o, n, r, T, O, j) {
      var D;
      let { animObject: F } = o, { format: B } = n, { composed: N, doc: f, isSafari: w } = r, { distribute: x } = T, { addEvent: M, clamp: p, css: v, discardElement: k, extend: m, fireEvent: A, isArray: C, isNumber: H, isString: G, merge: P, pick: y, pushUnique: S, splat: d, syncTimeout: s } = j;
      class l {
        constructor(u, c, h) {
          this.allowShared = !0, this.crosshairs = [], this.distance = 0, this.isHidden = !0, this.isSticky = !1, this.options = {}, this.outside = !1, this.chart = u, this.init(u, c), this.pointer = h;
        }
        bodyFormatter(u) {
          return u.map(function(c) {
            let h = c.series.tooltipOptions;
            return (h[(c.point.formatPrefix || "point") + "Formatter"] || c.point.tooltipFormatter).call(c.point, h[(c.point.formatPrefix || "point") + "Format"] || "");
          });
        }
        cleanSplit(u) {
          this.chart.series.forEach(function(c) {
            let h = c && c.tt;
            h && (!h.isActive || u ? c.tt = h.destroy() : h.isActive = !1);
          });
        }
        defaultFormatter(u) {
          let c, h = this.points || d(this);
          return (c = (c = [u.tooltipFooterHeaderFormatter(h[0])]).concat(u.bodyFormatter(h))).push(u.tooltipFooterHeaderFormatter(h[0], !0)), c;
        }
        destroy() {
          this.label && (this.label = this.label.destroy()), this.split && (this.cleanSplit(!0), this.tt && (this.tt = this.tt.destroy())), this.renderer && (this.renderer = this.renderer.destroy(), k(this.container)), j.clearTimeout(this.hideTimer);
        }
        getAnchor(u, c) {
          let h, { chart: g, pointer: E } = this, R = g.inverted, L = g.plotTop, U = g.plotLeft;
          if ((u = d(u))[0].series && u[0].series.yAxis && !u[0].series.yAxis.options.reversedStacks && (u = u.slice().reverse()), this.followPointer && c) c.chartX === void 0 && (c = E.normalize(c)), h = [c.chartX - U, c.chartY - L];
          else if (u[0].tooltipPos) h = u[0].tooltipPos;
          else {
            let V = 0, q = 0;
            u.forEach(function(Y) {
              let I = Y.pos(!0);
              I && (V += I[0], q += I[1]);
            }), V /= u.length, q /= u.length, this.shared && u.length > 1 && c && (R ? V = c.chartX : q = c.chartY), h = [V - U, q - L];
          }
          return h.map(Math.round);
        }
        getClassName(u, c, h) {
          let g = this.options, E = u.series, R = E.options;
          return [g.className, "highcharts-label", h && "highcharts-tooltip-header", c ? "highcharts-tooltip-box" : "highcharts-tooltip", !h && "highcharts-color-" + y(u.colorIndex, E.colorIndex), R && R.className].filter(G).join(" ");
        }
        getLabel({ anchorX: u, anchorY: c } = { anchorX: 0, anchorY: 0 }) {
          let h = this, g = this.chart.styledMode, E = this.options, R = this.split && this.allowShared, L = this.container, U = this.chart.renderer;
          if (this.label) {
            let V = !this.label.hasClass("highcharts-label");
            (!R && V || R && !V) && this.destroy();
          }
          if (!this.label) {
            if (this.outside) {
              let V = this.chart.options.chart.style, q = O.getRendererType();
              this.container = L = r.doc.createElement("div"), L.className = "highcharts-tooltip-container", v(L, { position: "absolute", top: "1px", pointerEvents: "none", zIndex: Math.max(this.options.style.zIndex || 0, (V && V.zIndex || 0) + 3) }), this.renderer = U = new q(L, 0, 0, V, void 0, void 0, U.styledMode);
            }
            if (R ? this.label = U.g("tooltip") : (this.label = U.label("", u, c, E.shape, void 0, void 0, E.useHTML, void 0, "tooltip").attr({ padding: E.padding, r: E.borderRadius }), g || this.label.attr({ fill: E.backgroundColor, "stroke-width": E.borderWidth || 0 }).css(E.style).css({ pointerEvents: E.style.pointerEvents || (this.shouldStickOnContact() ? "auto" : "none") })), h.outside) {
              let V = this.label;
              [V.xSetter, V.ySetter].forEach((q, Y) => {
                V[Y ? "ySetter" : "xSetter"] = (I) => {
                  q.call(V, h.distance), V[Y ? "y" : "x"] = I, L && (L.style[Y ? "top" : "left"] = `${I}px`);
                };
              });
            }
            this.label.attr({ zIndex: 8 }).shadow(E.shadow).add();
          }
          return L && !L.parentElement && r.doc.body.appendChild(L), this.label;
        }
        getPlayingField() {
          let { body: u, documentElement: c } = f, { chart: h, distance: g, outside: E } = this;
          return { width: E ? Math.max(u.scrollWidth, c.scrollWidth, u.offsetWidth, c.offsetWidth, c.clientWidth) - 2 * g : h.chartWidth, height: E ? Math.max(u.scrollHeight, c.scrollHeight, u.offsetHeight, c.offsetHeight, c.clientHeight) : h.chartHeight };
        }
        getPosition(u, c, h) {
          var ie, le;
          let { distance: g, chart: E, outside: R, pointer: L } = this, { inverted: U, plotLeft: V, plotTop: q, polar: Y } = E, { plotX: I = 0, plotY: _ = 0 } = h, W = {}, X = U && h.h || 0, { height: z, width: $ } = this.getPlayingField(), K = L.getChartPosition(), Q = (de) => de * K.scaleX, Z = (de) => de * K.scaleY, ee = (de) => {
            let be = de === "x";
            return [de, be ? $ : z, be ? u : c].concat(R ? [be ? Q(u) : Z(c), be ? K.left - g + Q(I + V) : K.top - g + Z(_ + q), 0, be ? $ : z] : [be ? u : c, be ? I + V : _ + q, be ? V : q, be ? V + E.plotWidth : q + E.plotHeight]);
          }, J = ee("y"), ae = ee("x"), re, ce = !!h.negative;
          !Y && ((le = (ie = E.hoverSeries) == null ? void 0 : ie.yAxis) != null && le.reversed) && (ce = !ce);
          let he = !this.followPointer && y(h.ttBelow, !Y && !U === ce), ne = function(de, be, ge, me, fe, Ae, ye) {
            let xe = R ? de === "y" ? Z(g) : Q(g) : g, we = (ge - me) / 2, ke = me < fe - g, Me = fe + g + me < be, Te = fe - xe - ge + we, Ie = fe + xe - we;
            if (he && Me) W[de] = Ie;
            else if (!he && ke) W[de] = Te;
            else if (ke) W[de] = Math.min(ye - me, Te - X < 0 ? Te : Te - X);
            else {
              if (!Me) return !1;
              W[de] = Math.max(Ae, Ie + X + ge > be ? Ie : Ie + X);
            }
          }, te = function(de, be, ge, me, fe) {
            if (fe < g || fe > be - g) return !1;
            fe < ge / 2 ? W[de] = 1 : fe > be - me / 2 ? W[de] = be - me - 2 : W[de] = fe - ge / 2;
          }, se = function(de) {
            [J, ae] = [ae, J], re = de;
          }, oe = () => {
            ne.apply(0, J) !== !1 ? te.apply(0, ae) !== !1 || re || (se(!0), oe()) : re ? W.x = W.y = 0 : (se(!0), oe());
          };
          return (U && !Y || this.len > 1) && se(), oe(), W;
        }
        hide(u) {
          let c = this;
          j.clearTimeout(this.hideTimer), u = y(u, this.options.hideDelay), this.isHidden || (this.hideTimer = s(function() {
            let h = c.getLabel();
            c.getLabel().animate({ opacity: 0 }, { duration: u && 150, complete: () => {
              h.hide(), c.container && c.container.remove();
            } }), c.isHidden = !0;
          }, u));
        }
        init(u, c) {
          this.chart = u, this.options = c, this.crosshairs = [], this.isHidden = !0, this.split = c.split && !u.inverted && !u.polar, this.shared = c.shared || this.split, this.outside = y(c.outside, !!(u.scrollablePixelsX || u.scrollablePixelsY));
        }
        shouldStickOnContact(u) {
          return !!(!this.followPointer && this.options.stickOnContact && (!u || this.pointer.inClass(u.target, "highcharts-tooltip")));
        }
        move(u, c, h, g) {
          let E = this, R = F(!E.isHidden && E.options.animation), L = E.followPointer || (E.len || 0) > 1, U = { x: u, y: c };
          L || (U.anchorX = h, U.anchorY = g), R.step = () => E.drawTracker(), E.getLabel().animate(U, R);
        }
        refresh(u, c) {
          let { chart: h, options: g, pointer: E, shared: R } = this, L = d(u), U = L[0], V = [], q = g.format, Y = g.formatter || this.defaultFormatter, I = h.styledMode, _ = {}, W = this.allowShared;
          if (!g.enabled || !U.series) return;
          j.clearTimeout(this.hideTimer), this.allowShared = !(!C(u) && u.series && u.series.noSharedTooltip), W = W && !this.allowShared, this.followPointer = !this.split && U.series.tooltipOptions.followPointer;
          let X = this.getAnchor(u, c), z = X[0], $ = X[1];
          R && this.allowShared ? (E.applyInactiveState(L), L.forEach(function(Z) {
            Z.setState("hover"), V.push(Z.getLabelConfig());
          }), (_ = U.getLabelConfig()).points = V) : _ = U.getLabelConfig(), this.len = V.length;
          let K = G(q) ? B(q, _, h) : Y.call(_, this), Q = U.series;
          if (this.distance = y(Q.tooltipOptions.distance, 16), K === !1) this.hide();
          else {
            if (this.split && this.allowShared) this.renderSplit(K, L);
            else {
              let Z = z, ee = $;
              if (c && E.isDirectTouch && (Z = c.chartX - h.plotLeft, ee = c.chartY - h.plotTop), h.polar || Q.options.clip === !1 || L.some((J) => E.isDirectTouch || J.series.shouldShowTooltip(Z, ee))) {
                let J = this.getLabel(W && this.tt || {});
                (!g.style.width || I) && J.css({ width: (this.outside ? this.getPlayingField() : h.spacingBox).width + "px" }), J.attr({ class: this.getClassName(U), text: K && K.join ? K.join("") : K }), this.outside && J.attr({ x: p(J.x || 0, 0, this.getPlayingField().width - (J.width || 0)) }), I || J.attr({ stroke: g.borderColor || U.color || Q.color || "#666666" }), this.updatePosition({ plotX: z, plotY: $, negative: U.negative, ttBelow: U.ttBelow, h: X[2] || 0 });
              } else {
                this.hide();
                return;
              }
            }
            this.isHidden && this.label && this.label.attr({ opacity: 1 }).show(), this.isHidden = !1;
          }
          A(this, "refresh");
        }
        renderSplit(u, c) {
          var be;
          let h = this, { chart: g, chart: { chartWidth: E, chartHeight: R, plotHeight: L, plotLeft: U, plotTop: V, scrollablePixelsY: q = 0, scrollablePixelsX: Y, styledMode: I }, distance: _, options: W, options: { positioner: X }, pointer: z } = h, { scrollLeft: $ = 0, scrollTop: K = 0 } = ((be = g.scrollablePlotArea) == null ? void 0 : be.scrollingContainer) || {}, Q = h.outside && typeof Y != "number" ? f.documentElement.getBoundingClientRect() : { left: $, right: $ + E }, Z = h.getLabel(), ee = this.renderer || g.renderer, J = !!(g.xAxis[0] && g.xAxis[0].opposite), { left: ae, top: re } = z.getChartPosition(), ce = V + K, he = 0, ne = L - q;
          function te(ge, me, fe, Ae, ye = !0) {
            let xe, we;
            return fe ? (xe = J ? 0 : ne, we = p(ge - Ae / 2, Q.left, Q.right - Ae - (h.outside ? ae : 0))) : (xe = me - ce, we = p(we = ye ? ge - Ae - _ : ge + _, ye ? we : Q.left, Q.right)), { x: we, y: xe };
          }
          G(u) && (u = [!1, u]);
          let se = u.slice(0, c.length + 1).reduce(function(ge, me, fe) {
            if (me !== !1 && me !== "") {
              let Ae = c[fe - 1] || { isHeader: !0, plotX: c[0].plotX, plotY: L, series: {} }, ye = Ae.isHeader, xe = ye ? h : Ae.series, we = xe.tt = function(He, $e, ht) {
                var la;
                let At = He, { isHeader: Ua, series: Ei } = $e;
                if (!At) {
                  let ca = { padding: W.padding, r: W.borderRadius };
                  I || (ca.fill = W.backgroundColor, ca["stroke-width"] = (la = W.borderWidth) != null ? la : 1), At = ee.label("", 0, 0, W[Ua ? "headerShape" : "shape"], void 0, void 0, W.useHTML).addClass(h.getClassName($e, !0, Ua)).attr(ca).add(Z);
                }
                return At.isActive = !0, At.attr({ text: ht }), I || At.css(W.style).attr({ stroke: W.borderColor || $e.color || Ei.color || "#333333" }), At;
              }(xe.tt, Ae, me.toString()), ke = we.getBBox(), Me = ke.width + we.strokeWidth();
              ye && (he = ke.height, ne += he, J && (ce -= he));
              let { anchorX: Te, anchorY: Ie } = function(He) {
                let $e, ht, { isHeader: At, plotX: Ua = 0, plotY: Ei = 0, series: la } = He;
                if (At) $e = Math.max(U + Ua, U), ht = V + L / 2;
                else {
                  let { xAxis: ca, yAxis: co } = la;
                  $e = ca.pos + p(Ua, -_, ca.len + _), la.shouldShowTooltip(0, co.pos - V + Ei, { ignoreX: !0 }) && (ht = co.pos + Ei);
                }
                return { anchorX: $e = p($e, Q.left - _, Q.right + _), anchorY: ht };
              }(Ae);
              if (typeof Ie == "number") {
                let He = ke.height + 1, $e = X ? X.call(h, Me, He, Ae) : te(Te, Ie, ye, Me);
                ge.push({ align: X ? 0 : void 0, anchorX: Te, anchorY: Ie, boxWidth: Me, point: Ae, rank: y($e.rank, ye ? 1 : 0), size: He, target: $e.y, tt: we, x: $e.x });
              } else we.isActive = !1;
            }
            return ge;
          }, []);
          !X && se.some((ge) => {
            let { outside: me } = h, fe = (me ? ae : 0) + ge.anchorX;
            return fe < Q.left && fe + ge.boxWidth < Q.right || fe < ae - Q.left + ge.boxWidth && Q.right - fe > fe;
          }) && (se = se.map((ge) => {
            let { x: me, y: fe } = te(ge.anchorX, ge.anchorY, ge.point.isHeader, ge.boxWidth, !1);
            return m(ge, { target: fe, x: me });
          })), h.cleanSplit(), x(se, ne);
          let oe = { left: ae, right: ae };
          se.forEach(function(ge) {
            let { x: me, boxWidth: fe, isHeader: Ae } = ge;
            !Ae && (h.outside && ae + me < oe.left && (oe.left = ae + me), !Ae && h.outside && oe.left + fe > oe.right && (oe.right = ae + me));
          }), se.forEach(function(ge) {
            let { x: me, anchorX: fe, anchorY: Ae, pos: ye, point: { isHeader: xe } } = ge, we = { visibility: ye === void 0 ? "hidden" : "inherit", x: me, y: (ye || 0) + ce, anchorX: fe, anchorY: Ae };
            if (h.outside && me < fe) {
              let ke = ae - oe.left;
              ke > 0 && (xe || (we.x = me + ke, we.anchorX = fe + ke), xe && (we.x = (oe.right - oe.left) / 2, we.anchorX = fe + ke));
            }
            ge.tt.attr(we);
          });
          let { container: ie, outside: le, renderer: de } = h;
          if (le && ie && de) {
            let { width: ge, height: me, x: fe, y: Ae } = Z.getBBox();
            de.setSize(ge + fe, me + Ae, !1), ie.style.left = oe.left + "px", ie.style.top = re + "px";
          }
          w && Z.attr({ opacity: Z.opacity === 1 ? 0.999 : 1 });
        }
        drawTracker() {
          if (!this.shouldStickOnContact()) {
            this.tracker && (this.tracker = this.tracker.destroy());
            return;
          }
          let u = this.chart, c = this.label, h = this.shared ? u.hoverPoints : u.hoverPoint;
          if (!c || !h) return;
          let g = { x: 0, y: 0, width: 0, height: 0 }, E = this.getAnchor(h), R = c.getBBox();
          E[0] += u.plotLeft - (c.translateX || 0), E[1] += u.plotTop - (c.translateY || 0), g.x = Math.min(0, E[0]), g.y = Math.min(0, E[1]), g.width = E[0] < 0 ? Math.max(Math.abs(E[0]), R.width - E[0]) : Math.max(Math.abs(E[0]), R.width), g.height = E[1] < 0 ? Math.max(Math.abs(E[1]), R.height - Math.abs(E[1])) : Math.max(Math.abs(E[1]), R.height), this.tracker ? this.tracker.attr(g) : (this.tracker = c.renderer.rect(g).addClass("highcharts-tracker").add(c), u.styledMode || this.tracker.attr({ fill: "rgba(0,0,0,0)" }));
        }
        styledModeFormat(u) {
          return u.replace('style="font-size: 0.8em"', 'class="highcharts-header"').replace(/style="color:{(point|series)\.color}"/g, 'class="highcharts-color-{$1.colorIndex} {series.options.className} {point.options.className}"');
        }
        tooltipFooterHeaderFormatter(u, c) {
          let h = u.series, g = h.tooltipOptions, E = h.xAxis, R = E && E.dateTime, L = { isFooter: c, labelConfig: u }, U = g.xDateFormat, V = g[c ? "footerFormat" : "headerFormat"];
          return A(this, "headerFormatter", L, function(q) {
            R && !U && H(u.key) && (U = R.getXDateFormat(u.key, g.dateTimeLabelFormats)), R && U && (u.point && u.point.tooltipDateKeys || ["key"]).forEach(function(Y) {
              V = V.replace("{point." + Y + "}", "{point." + Y + ":" + U + "}");
            }), h.chart.styledMode && (V = this.styledModeFormat(V)), q.text = B(V, { point: u, series: h }, this.chart);
          }), L.text;
        }
        update(u) {
          this.destroy(), this.init(this.chart, P(!0, this.options, u));
        }
        updatePosition(u) {
          let { chart: c, container: h, distance: g, options: E, pointer: R, renderer: L } = this, { height: U = 0, width: V = 0 } = this.getLabel(), { left: q, top: Y, scaleX: I, scaleY: _ } = R.getChartPosition(), W = (E.positioner || this.getPosition).call(this, V, U, u), X = (u.plotX || 0) + c.plotLeft, z = (u.plotY || 0) + c.plotTop, $;
          L && h && (E.positioner && (W.x += q - g, W.y += Y - g), $ = (E.borderWidth || 0) + 2 * g + 2, L.setSize(V + $, U + $, !1), (I !== 1 || _ !== 1) && (v(h, { transform: `scale(${I}, ${_})` }), X *= I, z *= _), X += q - W.x, z += Y - W.y), this.move(Math.round(W.x), Math.round(W.y || 0), X, z);
        }
      }
      return (D = l || (l = {})).compose = function(b) {
        S(N, "Core.Tooltip") && M(b, "afterInit", function() {
          let u = this.chart;
          u.options.tooltip && (u.tooltip = new D(u, u.options.tooltip, this));
        });
      }, l;
    }), a(e, "Core/Series/Point.js", [e["Core/Renderer/HTML/AST.js"], e["Core/Animation/AnimationUtilities.js"], e["Core/Defaults.js"], e["Core/Templating.js"], e["Core/Utilities.js"]], function(o, n, r, T, O) {
      let { animObject: j } = n, { defaultOptions: D } = r, { format: F } = T, { addEvent: B, crisp: N, erase: f, extend: w, fireEvent: x, getNestedProperty: M, isArray: p, isFunction: v, isNumber: k, isObject: m, merge: A, pick: C, syncTimeout: H, removeEvent: G, uniqueKey: P } = O;
      class y {
        animateBeforeDestroy() {
          let d = this, s = { x: d.startXPos, opacity: 0 }, l = d.getGraphicalProps();
          l.singular.forEach(function(b) {
            d[b] = d[b].animate(b === "dataLabel" ? { x: d[b].startXPos, y: d[b].startYPos, opacity: 0 } : s);
          }), l.plural.forEach(function(b) {
            d[b].forEach(function(u) {
              u.element && u.animate(w({ x: d.startXPos }, u.startYPos ? { x: u.startXPos, y: u.startYPos } : {}));
            });
          });
        }
        applyOptions(d, s) {
          let l = this.series, b = l.options.pointValKey || l.pointValKey;
          return w(this, d = y.prototype.optionsToObject.call(this, d)), this.options = this.options ? w(this.options, d) : d, d.group && delete this.group, d.dataLabels && delete this.dataLabels, b && (this.y = y.prototype.getNestedProperty.call(this, b)), this.selected && (this.state = "select"), "name" in this && s === void 0 && l.xAxis && l.xAxis.hasNames && (this.x = l.xAxis.nameToX(this)), this.x === void 0 && l ? this.x = s != null ? s : l.autoIncrement() : k(d.x) && l.options.relativeXValue && (this.x = l.autoIncrement(d.x)), this.isNull = this.isValid && !this.isValid(), this.formatPrefix = this.isNull ? "null" : "point", this;
        }
        destroy() {
          if (!this.destroyed) {
            let d = this, s = d.series, l = s.chart, b = s.options.dataSorting, u = l.hoverPoints, c = j(d.series.chart.renderer.globalAnimation), h = () => {
              for (let g in (d.graphic || d.graphics || d.dataLabel || d.dataLabels) && (G(d), d.destroyElements()), d) delete d[g];
            };
            d.legendItem && l.legend.destroyItem(d), u && (d.setState(), f(u, d), u.length || (l.hoverPoints = null)), d === l.hoverPoint && d.onMouseOut(), b && b.enabled ? (this.animateBeforeDestroy(), H(h, c.duration)) : h(), l.pointCount--;
          }
          this.destroyed = !0;
        }
        destroyElements(d) {
          let s = this, l = s.getGraphicalProps(d);
          l.singular.forEach(function(b) {
            s[b] = s[b].destroy();
          }), l.plural.forEach(function(b) {
            s[b].forEach(function(u) {
              u && u.element && u.destroy();
            }), delete s[b];
          });
        }
        firePointEvent(d, s, l) {
          let b = this, u = this.series.options;
          b.manageEvent(d), d === "click" && u.allowPointSelect && (l = function(c) {
            !b.destroyed && b.select && b.select(null, c.ctrlKey || c.metaKey || c.shiftKey);
          }), x(b, d, s, l);
        }
        getClassName() {
          return "highcharts-point" + (this.selected ? " highcharts-point-select" : "") + (this.negative ? " highcharts-negative" : "") + (this.isNull ? " highcharts-null-point" : "") + (this.colorIndex !== void 0 ? " highcharts-color-" + this.colorIndex : "") + (this.options.className ? " " + this.options.className : "") + (this.zone && this.zone.className ? " " + this.zone.className.replace("highcharts-negative", "") : "");
        }
        getGraphicalProps(d) {
          let s, l, b = this, u = [], c = { singular: [], plural: [] };
          for ((d = d || { graphic: 1, dataLabel: 1 }).graphic && u.push("graphic", "connector"), d.dataLabel && u.push("dataLabel", "dataLabelPath", "dataLabelUpper"), l = u.length; l--; ) b[s = u[l]] && c.singular.push(s);
          return ["graphic", "dataLabel"].forEach(function(h) {
            let g = h + "s";
            d[h] && b[g] && c.plural.push(g);
          }), c;
        }
        getLabelConfig() {
          return { x: this.category, y: this.y, color: this.color, colorIndex: this.colorIndex, key: this.name || this.category, series: this.series, point: this, percentage: this.percentage, total: this.total || this.stackTotal };
        }
        getNestedProperty(d) {
          return d ? d.indexOf("custom.") === 0 ? M(d, this.options) : this[d] : void 0;
        }
        getZone() {
          let d = this.series, s = d.zones, l = d.zoneAxis || "y", b, u = 0;
          for (b = s[0]; this[l] >= b.value; ) b = s[++u];
          return this.nonZonedColor || (this.nonZonedColor = this.color), b && b.color && !this.options.color ? this.color = b.color : this.color = this.nonZonedColor, b;
        }
        hasNewShapeType() {
          return (this.graphic && (this.graphic.symbolName || this.graphic.element.nodeName)) !== this.shapeType;
        }
        constructor(d, s, l) {
          var b;
          this.formatPrefix = "point", this.visible = !0, this.series = d, this.applyOptions(s, l), (b = this.id) != null || (this.id = P()), this.resolveColor(), d.chart.pointCount++, x(this, "afterInit");
        }
        isValid() {
          return (k(this.x) || this.x instanceof Date) && k(this.y);
        }
        optionsToObject(d) {
          let s = this.series, l = s.options.keys, b = l || s.pointArrayMap || ["y"], u = b.length, c = {}, h, g = 0, E = 0;
          if (k(d) || d === null) c[b[0]] = d;
          else if (p(d)) for (!l && d.length > u && ((h = typeof d[0]) == "string" ? c.name = d[0] : h === "number" && (c.x = d[0]), g++); E < u; ) l && d[g] === void 0 || (b[E].indexOf(".") > 0 ? y.prototype.setNestedProperty(c, d[g], b[E]) : c[b[E]] = d[g]), g++, E++;
          else typeof d == "object" && (c = d, d.dataLabels && (s.hasDataLabels = () => !0), d.marker && (s._hasPointMarkers = !0));
          return c;
        }
        pos(d, s = this.plotY) {
          if (!this.destroyed) {
            let { plotX: l, series: b } = this, { chart: u, xAxis: c, yAxis: h } = b, g = 0, E = 0;
            if (k(l) && k(s)) return d && (g = c ? c.pos : u.plotLeft, E = h ? h.pos : u.plotTop), u.inverted && c && h ? [h.len - s + E, c.len - l + g] : [l + g, s + E];
          }
        }
        resolveColor() {
          let d = this.series, s = d.chart.options.chart, l = d.chart.styledMode, b, u, c = s.colorCount, h;
          delete this.nonZonedColor, d.options.colorByPoint ? (l || (b = (u = d.options.colors || d.chart.options.colors)[d.colorCounter], c = u.length), h = d.colorCounter, d.colorCounter++, d.colorCounter === c && (d.colorCounter = 0)) : (l || (b = d.color), h = d.colorIndex), this.colorIndex = C(this.options.colorIndex, h), this.color = C(this.options.color, b);
        }
        setNestedProperty(d, s, l) {
          return l.split(".").reduce(function(b, u, c, h) {
            let g = h.length - 1 === c;
            return b[u] = g ? s : m(b[u], !0) ? b[u] : {}, b[u];
          }, d), d;
        }
        shouldDraw() {
          return !this.isNull;
        }
        tooltipFormatter(d) {
          let s = this.series, l = s.tooltipOptions, b = C(l.valueDecimals, ""), u = l.valuePrefix || "", c = l.valueSuffix || "";
          return s.chart.styledMode && (d = s.chart.tooltip.styledModeFormat(d)), (s.pointArrayMap || ["y"]).forEach(function(h) {
            h = "{point." + h, (u || c) && (d = d.replace(RegExp(h + "}", "g"), u + h + "}" + c)), d = d.replace(RegExp(h + "}", "g"), h + ":,." + b + "f}");
          }), F(d, { point: this, series: this.series }, s.chart);
        }
        update(d, s, l, b) {
          let u, c = this, h = c.series, g = c.graphic, E = h.chart, R = h.options;
          function L() {
            c.applyOptions(d);
            let U = g && c.hasMockGraphic, V = c.y === null ? !U : U;
            g && V && (c.graphic = g.destroy(), delete c.hasMockGraphic), m(d, !0) && (g && g.element && d && d.marker && d.marker.symbol !== void 0 && (c.graphic = g.destroy()), d != null && d.dataLabels && c.dataLabel && (c.dataLabel = c.dataLabel.destroy())), u = c.index, h.updateParallelArrays(c, u), R.data[u] = m(R.data[u], !0) || m(d, !0) ? c.options : C(d, R.data[u]), h.isDirty = h.isDirtyData = !0, !h.fixedBox && h.hasCartesianSeries && (E.isDirtyBox = !0), R.legendType === "point" && (E.isDirtyLegend = !0), s && E.redraw(l);
          }
          s = C(s, !0), b === !1 ? L() : c.firePointEvent("update", { options: d }, L);
        }
        remove(d, s) {
          this.series.removePoint(this.series.data.indexOf(this), d, s);
        }
        select(d, s) {
          let l = this, b = l.series, u = b.chart;
          d = C(d, !l.selected), this.selectedStaging = d, l.firePointEvent(d ? "select" : "unselect", { accumulate: s }, function() {
            l.selected = l.options.selected = d, b.options.data[b.data.indexOf(l)] = l.options, l.setState(d && "select"), s || u.getSelectedPoints().forEach(function(c) {
              let h = c.series;
              c.selected && c !== l && (c.selected = c.options.selected = !1, h.options.data[h.data.indexOf(c)] = c.options, c.setState(u.hoverPoints && h.options.inactiveOtherPoints ? "inactive" : ""), c.firePointEvent("unselect"));
            });
          }), delete this.selectedStaging;
        }
        onMouseOver(d) {
          let { inverted: s, pointer: l } = this.series.chart;
          l && (d = d ? l.normalize(d) : l.getChartCoordinatesFromPoint(this, s), l.runPointActions(d, this));
        }
        onMouseOut() {
          let d = this.series.chart;
          this.firePointEvent("mouseOut"), this.series.options.inactiveOtherPoints || (d.hoverPoints || []).forEach(function(s) {
            s.setState();
          }), d.hoverPoints = d.hoverPoint = null;
        }
        manageEvent(d) {
          var b, u, c, h, g, E;
          let s = A(this.series.options.point, this.options), l = (b = s.events) == null ? void 0 : b[d];
          v(l) && (!((u = this.hcEvents) != null && u[d]) || ((h = (c = this.hcEvents) == null ? void 0 : c[d]) == null ? void 0 : h.map((R) => R.fn).indexOf(l)) === -1) ? ((g = this.importedUserEvent) == null || g.call(this), this.importedUserEvent = B(this, d, l)) : this.importedUserEvent && !l && ((E = this.hcEvents) != null && E[d]) && (G(this, d), delete this.hcEvents[d], Object.keys(this.hcEvents) || delete this.importedUserEvent);
        }
        setState(d, s) {
          var K;
          let l = this.series, b = this.state, u = l.options.states[d || "normal"] || {}, c = D.plotOptions[l.type].marker && l.options.marker, h = c && c.enabled === !1, g = c && c.states && c.states[d || "normal"] || {}, E = g.enabled === !1, R = this.marker || {}, L = l.chart, U = c && l.markerAttribs, V = l.halo, q, Y, I, _ = l.stateMarkerGraphic, W;
          if ((d = d || "") === this.state && !s || this.selected && d !== "select" || u.enabled === !1 || d && (E || h && g.enabled === !1) || d && R.states && R.states[d] && R.states[d].enabled === !1) return;
          if (this.state = d, U && (q = l.markerAttribs(this, d)), this.graphic && !this.hasMockGraphic) {
            if (b && this.graphic.removeClass("highcharts-point-" + b), d && this.graphic.addClass("highcharts-point-" + d), !L.styledMode) {
              Y = l.pointAttribs(this, d), I = C(L.options.chart.animation, u.animation);
              let Q = Y.opacity;
              l.options.inactiveOtherPoints && k(Q) && (this.dataLabels || []).forEach(function(Z) {
                Z && !Z.hasClass("highcharts-data-label-hidden") && (Z.animate({ opacity: Q }, I), Z.connector && Z.connector.animate({ opacity: Q }, I));
              }), this.graphic.animate(Y, I);
            }
            q && this.graphic.animate(q, C(L.options.chart.animation, g.animation, c.animation)), _ && _.hide();
          } else d && g && (W = R.symbol || l.symbol, _ && _.currentSymbol !== W && (_ = _.destroy()), q && (_ ? _[s ? "animate" : "attr"]({ x: q.x, y: q.y }) : W && (l.stateMarkerGraphic = _ = L.renderer.symbol(W, q.x, q.y, q.width, q.height).add(l.markerGroup), _.currentSymbol = W)), !L.styledMode && _ && this.state !== "inactive" && _.attr(l.pointAttribs(this, d))), _ && (_[d && this.isInside ? "show" : "hide"](), _.element.point = this, _.addClass(this.getClassName(), !0));
          let X = u.halo, z = this.graphic || _, $ = z && z.visibility || "inherit";
          X && X.size && z && $ !== "hidden" && !this.isCluster ? (V || (l.halo = V = L.renderer.path().add(z.parentGroup)), V.show()[s ? "animate" : "attr"]({ d: this.haloPath(X.size) }), V.attr({ class: "highcharts-halo highcharts-color-" + C(this.colorIndex, l.colorIndex) + (this.className ? " " + this.className : ""), visibility: $, zIndex: -1 }), V.point = this, L.styledMode || V.attr(w({ fill: this.color || l.color, "fill-opacity": X.opacity }, o.filterUserAttributes(X.attributes || {})))) : (K = V == null ? void 0 : V.point) != null && K.haloPath && !V.point.destroyed && V.animate({ d: V.point.haloPath(0) }, null, V.hide), x(this, "afterSetState", { state: d });
        }
        haloPath(d) {
          let s = this.pos();
          return s ? this.series.chart.renderer.symbols.circle(N(s[0], 1) - d, s[1] - d, 2 * d, 2 * d) : [];
        }
      }
      return y;
    }), a(e, "Core/Pointer.js", [e["Core/Color/Color.js"], e["Core/Globals.js"], e["Core/Utilities.js"]], function(o, n, r) {
      var T;
      let { parse: O } = o, { charts: j, composed: D, isTouchDevice: F } = n, { addEvent: B, attr: N, css: f, extend: w, find: x, fireEvent: M, isNumber: p, isObject: v, objectEach: k, offset: m, pick: A, pushUnique: C, splat: H } = r;
      class G {
        applyInactiveState(y) {
          let S = [], d;
          (y || []).forEach(function(s) {
            d = s.series, S.push(d), d.linkedParent && S.push(d.linkedParent), d.linkedSeries && (S = S.concat(d.linkedSeries)), d.navigatorSeries && S.push(d.navigatorSeries);
          }), this.chart.series.forEach(function(s) {
            S.indexOf(s) === -1 ? s.setState("inactive", !0) : s.options.inactiveOtherPoints && s.setAllPointsToState("inactive");
          });
        }
        destroy() {
          let y = this;
          this.eventsToUnbind.forEach((S) => S()), this.eventsToUnbind = [], !n.chartCount && (G.unbindDocumentMouseUp && G.unbindDocumentMouseUp.forEach((S) => S()), G.unbindDocumentTouchEnd && (G.unbindDocumentTouchEnd = G.unbindDocumentTouchEnd())), clearInterval(y.tooltipTimeout), k(y, function(S, d) {
            y[d] = void 0;
          });
        }
        getSelectionMarkerAttrs(y, S) {
          let d = { args: { chartX: y, chartY: S }, attrs: {}, shapeType: "rect" };
          return M(this, "getSelectionMarkerAttrs", d, (s) => {
            let l, { chart: b, zoomHor: u, zoomVert: c } = this, { mouseDownX: h = 0, mouseDownY: g = 0 } = b, E = s.attrs;
            E.x = b.plotLeft, E.y = b.plotTop, E.width = u ? 1 : b.plotWidth, E.height = c ? 1 : b.plotHeight, u && (l = y - h, E.width = Math.max(1, Math.abs(l)), E.x = (l > 0 ? 0 : l) + h), c && (l = S - g, E.height = Math.max(1, Math.abs(l)), E.y = (l > 0 ? 0 : l) + g);
          }), d;
        }
        drag(y) {
          let { chart: S } = this, { mouseDownX: d = 0, mouseDownY: s = 0 } = S, { panning: l, panKey: b, selectionMarkerFill: u } = S.options.chart, c = S.plotLeft, h = S.plotTop, g = S.plotWidth, E = S.plotHeight, R = v(l) ? l.enabled : l, L = b && y[`${b}Key`], U = y.chartX, V = y.chartY, q, Y = this.selectionMarker;
          if ((!Y || !Y.touch) && (U < c ? U = c : U > c + g && (U = c + g), V < h ? V = h : V > h + E && (V = h + E), this.hasDragged = Math.sqrt(Math.pow(d - U, 2) + Math.pow(s - V, 2)), this.hasDragged > 10)) {
            q = S.isInsidePlot(d - c, s - h, { visiblePlotOnly: !0 });
            let { shapeType: I, attrs: _ } = this.getSelectionMarkerAttrs(U, V);
            (S.hasCartesianSeries || S.mapView) && this.hasZoom && q && !L && !Y && (this.selectionMarker = Y = S.renderer[I](), Y.attr({ class: "highcharts-selection-marker", zIndex: 7 }).add(), S.styledMode || Y.attr({ fill: u || O("#334eff").setOpacity(0.25).get() })), Y && Y.attr(_), q && !Y && R && S.pan(y, l);
          }
        }
        dragStart(y) {
          let S = this.chart;
          S.mouseIsDown = y.type, S.cancelClick = !1, S.mouseDownX = y.chartX, S.mouseDownY = y.chartY;
        }
        getSelectionBox(y) {
          let S = { args: { marker: y }, result: y.getBBox() };
          return M(this, "getSelectionBox", S), S.result;
        }
        drop(y) {
          let S, { chart: d, selectionMarker: s } = this;
          for (let l of d.axes) l.isPanning && (l.isPanning = !1, (l.options.startOnTick || l.options.endOnTick || l.series.some((b) => b.boosted)) && (l.forceRedraw = !0, l.setExtremes(l.userMin, l.userMax, !1), S = !0));
          if (S && d.redraw(), s && y) {
            if (this.hasDragged) {
              let l = this.getSelectionBox(s);
              d.transform({ axes: d.axes.filter((b) => b.zoomEnabled && (b.coll === "xAxis" && this.zoomX || b.coll === "yAxis" && this.zoomY)), selection: { originalEvent: y, xAxis: [], yAxis: [], ...l }, from: l });
            }
            p(d.index) && (this.selectionMarker = s.destroy());
          }
          d && p(d.index) && (f(d.container, { cursor: d._cursor }), d.cancelClick = this.hasDragged > 10, d.mouseIsDown = !1, this.hasDragged = 0, this.pinchDown = []);
        }
        findNearestKDPoint(y, S, d) {
          let s;
          return y.forEach(function(l) {
            let b = !(l.noSharedTooltip && S) && 0 > l.options.findNearestPointBy.indexOf("y"), u = l.searchPoint(d, b);
            v(u, !0) && u.series && (!v(s, !0) || function(c, h) {
              var L, U;
              let g = c.distX - h.distX, E = c.dist - h.dist, R = ((L = h.series.group) == null ? void 0 : L.zIndex) - ((U = c.series.group) == null ? void 0 : U.zIndex);
              return g !== 0 && S ? g : E !== 0 ? E : R !== 0 ? R : c.series.index > h.series.index ? -1 : 1;
            }(s, u) > 0) && (s = u);
          }), s;
        }
        getChartCoordinatesFromPoint(y, S) {
          var b, u;
          let { xAxis: d, yAxis: s } = y.series, l = y.shapeArgs;
          if (d && s) {
            let c = (u = (b = y.clientX) != null ? b : y.plotX) != null ? u : 0, h = y.plotY || 0;
            return y.isNode && l && p(l.x) && p(l.y) && (c = l.x, h = l.y), S ? { chartX: s.len + s.pos - h, chartY: d.len + d.pos - c } : { chartX: c + d.pos, chartY: h + s.pos };
          }
          if (l && l.x && l.y) return { chartX: l.x, chartY: l.y };
        }
        getChartPosition() {
          if (this.chartPosition) return this.chartPosition;
          let { container: y } = this.chart, S = m(y);
          this.chartPosition = { left: S.left, top: S.top, scaleX: 1, scaleY: 1 };
          let { offsetHeight: d, offsetWidth: s } = y;
          return s > 2 && d > 2 && (this.chartPosition.scaleX = S.width / s, this.chartPosition.scaleY = S.height / d), this.chartPosition;
        }
        getCoordinates(y) {
          let S = { xAxis: [], yAxis: [] };
          for (let d of this.chart.axes) S[d.isXAxis ? "xAxis" : "yAxis"].push({ axis: d, value: d.toValue(y[d.horiz ? "chartX" : "chartY"]) });
          return S;
        }
        getHoverData(y, S, d, s, l, b) {
          let u = [], c = function(L) {
            return L.visible && !(!l && L.directTouch) && A(L.options.enableMouseTracking, !0);
          }, h = S, g, E = { chartX: b ? b.chartX : void 0, chartY: b ? b.chartY : void 0, shared: l };
          M(this, "beforeGetHoverData", E), g = h && !h.stickyTracking ? [h] : d.filter((L) => L.stickyTracking && (E.filter || c)(L));
          let R = s && y || !b ? y : this.findNearestKDPoint(g, l, b);
          return h = R && R.series, R && (l && !h.noSharedTooltip ? (g = d.filter(function(L) {
            return E.filter ? E.filter(L) : c(L) && !L.noSharedTooltip;
          })).forEach(function(L) {
            let U = x(L.points, function(V) {
              return V.x === R.x && !V.isNull;
            });
            v(U) && (L.boosted && L.boost && (U = L.boost.getPoint(U)), u.push(U));
          }) : u.push(R)), M(this, "afterGetHoverData", E = { hoverPoint: R }), { hoverPoint: E.hoverPoint, hoverSeries: h, hoverPoints: u };
        }
        getPointFromEvent(y) {
          let S = y.target, d;
          for (; S && !d; ) d = S.point, S = S.parentNode;
          return d;
        }
        onTrackerMouseOut(y) {
          let S = this.chart, d = y.relatedTarget, s = S.hoverSeries;
          this.isDirectTouch = !1, !s || !d || s.stickyTracking || this.inClass(d, "highcharts-tooltip") || this.inClass(d, "highcharts-series-" + s.index) && this.inClass(d, "highcharts-tracker") || s.onMouseOut();
        }
        inClass(y, S) {
          let d = y, s;
          for (; d; ) {
            if (s = N(d, "class")) {
              if (s.indexOf(S) !== -1) return !0;
              if (s.indexOf("highcharts-container") !== -1) return !1;
            }
            d = d.parentElement;
          }
        }
        constructor(y, S) {
          var d;
          this.hasDragged = 0, this.pointerCaptureEventsToUnbind = [], this.eventsToUnbind = [], this.options = S, this.chart = y, this.runChartClick = !!((d = S.chart.events) != null && d.click), this.pinchDown = [], this.setDOMEvents(), M(this, "afterInit");
        }
        normalize(y, S) {
          let d = y.touches, s = d ? d.length ? d.item(0) : A(d.changedTouches, y.changedTouches)[0] : y;
          S || (S = this.getChartPosition());
          let l = s.pageX - S.left, b = s.pageY - S.top;
          return w(y, { chartX: Math.round(l /= S.scaleX), chartY: Math.round(b /= S.scaleY) });
        }
        onContainerClick(y) {
          let S = this.chart, d = S.hoverPoint, s = this.normalize(y), l = S.plotLeft, b = S.plotTop;
          !S.cancelClick && (d && this.inClass(s.target, "highcharts-tracker") ? (M(d.series, "click", w(s, { point: d })), S.hoverPoint && d.firePointEvent("click", s)) : (w(s, this.getCoordinates(s)), S.isInsidePlot(s.chartX - l, s.chartY - b, { visiblePlotOnly: !0 }) && M(S, "click", s)));
        }
        onContainerMouseDown(y) {
          var d;
          let S = (1 & (y.buttons || y.button)) == 1;
          y = this.normalize(y), n.isFirefox && y.button !== 0 && this.onContainerMouseMove(y), (y.button === void 0 || S) && (this.zoomOption(y), S && ((d = y.preventDefault) == null || d.call(y)), this.dragStart(y));
        }
        onContainerMouseLeave(y) {
          let { pointer: S } = j[A(G.hoverChartIndex, -1)] || {};
          y = this.normalize(y), this.onContainerMouseMove(y), S && !this.inClass(y.relatedTarget, "highcharts-tooltip") && (S.reset(), S.chartPosition = void 0);
        }
        onContainerMouseEnter() {
          delete this.chartPosition;
        }
        onContainerMouseMove(y) {
          let S = this.chart, d = S.tooltip, s = this.normalize(y);
          this.setHoverChartIndex(y), (S.mouseIsDown === "mousedown" || this.touchSelect(s)) && this.drag(s), !S.openMenu && (this.inClass(s.target, "highcharts-tracker") || S.isInsidePlot(s.chartX - S.plotLeft, s.chartY - S.plotTop, { visiblePlotOnly: !0 })) && !(d && d.shouldStickOnContact(s)) && (this.inClass(s.target, "highcharts-no-tooltip") ? this.reset(!1, 0) : this.runPointActions(s));
        }
        onDocumentTouchEnd(y) {
          this.onDocumentMouseUp(y);
        }
        onContainerTouchMove(y) {
          this.touchSelect(y) ? this.onContainerMouseMove(y) : this.touch(y);
        }
        onContainerTouchStart(y) {
          this.touchSelect(y) ? this.onContainerMouseDown(y) : (this.zoomOption(y), this.touch(y, !0));
        }
        onDocumentMouseMove(y) {
          let S = this.chart, d = S.tooltip, s = this.chartPosition, l = this.normalize(y, s);
          !s || S.isInsidePlot(l.chartX - S.plotLeft, l.chartY - S.plotTop, { visiblePlotOnly: !0 }) || d && d.shouldStickOnContact(l) || l.target !== S.container.ownerDocument && this.inClass(l.target, "highcharts-tracker") || this.reset();
        }
        onDocumentMouseUp(y) {
          var S, d;
          (d = (S = j[A(G.hoverChartIndex, -1)]) == null ? void 0 : S.pointer) == null || d.drop(y);
        }
        pinch(y) {
          let S = this, { chart: d, hasZoom: s, lastTouches: l } = S, b = [].map.call(y.touches || [], (E) => S.normalize(E)), u = b.length, c = u === 1 && (S.inClass(y.target, "highcharts-tracker") && d.runTrackerClick || S.runChartClick), h = d.tooltip, g = u === 1 && A(h == null ? void 0 : h.options.followTouchMove, !0);
          u > 1 ? S.initiated = !0 : g && (S.initiated = !1), s && S.initiated && !c && y.cancelable !== !1 && y.preventDefault(), y.type === "touchstart" ? (S.pinchDown = b, S.res = !0, d.mouseDownX = y.chartX) : g ? this.runPointActions(S.normalize(y)) : l && (M(d, "touchpan", { originalEvent: y, touches: b }, () => {
            let E = (R) => {
              let L = R[0], U = R[1] || L;
              return { x: L.chartX, y: L.chartY, width: U.chartX - L.chartX, height: U.chartY - L.chartY };
            };
            d.transform({ axes: d.axes.filter((R) => R.zoomEnabled && (this.zoomHor && R.horiz || this.zoomVert && !R.horiz)), to: E(b), from: E(l), trigger: y.type });
          }), S.res && (S.res = !1, this.reset(!1, 0))), S.lastTouches = b;
        }
        reset(y, S) {
          let d = this.chart, s = d.hoverSeries, l = d.hoverPoint, b = d.hoverPoints, u = d.tooltip, c = u && u.shared ? b : l;
          y && c && H(c).forEach(function(h) {
            h.series.isCartesian && h.plotX === void 0 && (y = !1);
          }), y ? u && c && H(c).length && (u.refresh(c), u.shared && b ? b.forEach(function(h) {
            h.setState(h.state, !0), h.series.isCartesian && (h.series.xAxis.crosshair && h.series.xAxis.drawCrosshair(null, h), h.series.yAxis.crosshair && h.series.yAxis.drawCrosshair(null, h));
          }) : l && (l.setState(l.state, !0), d.axes.forEach(function(h) {
            h.crosshair && l.series[h.coll] === h && h.drawCrosshair(null, l);
          }))) : (l && l.onMouseOut(), b && b.forEach(function(h) {
            h.setState();
          }), s && s.onMouseOut(), u && u.hide(S), this.unDocMouseMove && (this.unDocMouseMove = this.unDocMouseMove()), d.axes.forEach(function(h) {
            h.hideCrosshair();
          }), d.hoverPoints = d.hoverPoint = void 0);
        }
        runPointActions(y, S, d) {
          let s = this.chart, l = s.series, b = s.tooltip && s.tooltip.options.enabled ? s.tooltip : void 0, u = !!b && b.shared, c = S || s.hoverPoint, h = c && c.series || s.hoverSeries, g = (!y || y.type !== "touchmove") && (!!S || h && h.directTouch && this.isDirectTouch), E = this.getHoverData(c, h, l, g, u, y);
          c = E.hoverPoint, h = E.hoverSeries;
          let R = E.hoverPoints, L = h && h.tooltipOptions.followPointer && !h.tooltipOptions.split, U = u && h && !h.noSharedTooltip;
          if (c && (d || c !== s.hoverPoint || b && b.isHidden)) {
            if ((s.hoverPoints || []).forEach(function(V) {
              R.indexOf(V) === -1 && V.setState();
            }), s.hoverSeries !== h && h.onMouseOver(), this.applyInactiveState(R), (R || []).forEach(function(V) {
              V.setState("hover");
            }), s.hoverPoint && s.hoverPoint.firePointEvent("mouseOut"), !c.series) return;
            s.hoverPoints = R, s.hoverPoint = c, c.firePointEvent("mouseOver", void 0, () => {
              b && c && b.refresh(U ? R : c, y);
            });
          } else if (L && b && !b.isHidden) {
            let V = b.getAnchor([{}], y);
            s.isInsidePlot(V[0], V[1], { visiblePlotOnly: !0 }) && b.updatePosition({ plotX: V[0], plotY: V[1] });
          }
          this.unDocMouseMove || (this.unDocMouseMove = B(s.container.ownerDocument, "mousemove", (V) => {
            var q, Y, I;
            return (I = (Y = j[(q = G.hoverChartIndex) != null ? q : -1]) == null ? void 0 : Y.pointer) == null ? void 0 : I.onDocumentMouseMove(V);
          }), this.eventsToUnbind.push(this.unDocMouseMove)), s.axes.forEach(function(V) {
            let q, Y = A((V.crosshair || {}).snap, !0);
            !Y || (q = s.hoverPoint) && q.series[V.coll] === V || (q = x(R, (I) => I.series && I.series[V.coll] === V)), q || !Y ? V.drawCrosshair(y, q) : V.hideCrosshair();
          });
        }
        setDOMEvents() {
          let y = this.chart.container, S = y.ownerDocument;
          y.onmousedown = this.onContainerMouseDown.bind(this), y.onmousemove = this.onContainerMouseMove.bind(this), y.onclick = this.onContainerClick.bind(this), this.eventsToUnbind.push(B(y, "mouseenter", this.onContainerMouseEnter.bind(this)), B(y, "mouseleave", this.onContainerMouseLeave.bind(this))), G.unbindDocumentMouseUp || (G.unbindDocumentMouseUp = []), G.unbindDocumentMouseUp.push(B(S, "mouseup", this.onDocumentMouseUp.bind(this)));
          let d = this.chart.renderTo.parentElement;
          for (; d && d.tagName !== "BODY"; ) this.eventsToUnbind.push(B(d, "scroll", () => {
            delete this.chartPosition;
          })), d = d.parentElement;
          this.eventsToUnbind.push(B(y, "touchstart", this.onContainerTouchStart.bind(this), { passive: !1 }), B(y, "touchmove", this.onContainerTouchMove.bind(this), { passive: !1 })), G.unbindDocumentTouchEnd || (G.unbindDocumentTouchEnd = B(S, "touchend", this.onDocumentTouchEnd.bind(this), { passive: !1 })), this.setPointerCapture(), B(this.chart, "redraw", this.setPointerCapture.bind(this));
        }
        setPointerCapture() {
          var l, b;
          if (!F) return;
          let y = this.pointerCaptureEventsToUnbind, S = this.chart, d = S.container, s = A((l = S.options.tooltip) == null ? void 0 : l.followTouchMove, !0) && S.series.some((u) => u.options.findNearestPointBy.indexOf("y") > -1);
          !this.hasPointerCapture && s ? (y.push(B(d, "pointerdown", (u) => {
            var c, h;
            (c = u.target) != null && c.hasPointerCapture(u.pointerId) && ((h = u.target) == null || h.releasePointerCapture(u.pointerId));
          }), B(d, "pointermove", (u) => {
            var c, h;
            (h = (c = S.pointer) == null ? void 0 : c.getPointFromEvent(u)) == null || h.onMouseOver(u);
          })), S.styledMode || f(d, { "touch-action": "none" }), d.className += " highcharts-no-touch-action", this.hasPointerCapture = !0) : this.hasPointerCapture && !s && (y.forEach((u) => u()), y.length = 0, S.styledMode || f(d, { "touch-action": A((b = S.options.chart.style) == null ? void 0 : b["touch-action"], "manipulation") }), d.className = d.className.replace(" highcharts-no-touch-action", ""), this.hasPointerCapture = !1);
        }
        setHoverChartIndex(y) {
          var s;
          let S = this.chart, d = n.charts[A(G.hoverChartIndex, -1)];
          if (d && d !== S) {
            let l = { relatedTarget: S.container };
            y && !(y != null && y.relatedTarget) && (y = { ...l, ...y }), (s = d.pointer) == null || s.onContainerMouseLeave(y || l);
          }
          d && d.mouseIsDown || (G.hoverChartIndex = S.index);
        }
        touch(y, S) {
          let d, { chart: s, pinchDown: l = [] } = this;
          this.setHoverChartIndex(), (y = this.normalize(y)).touches.length === 1 ? s.isInsidePlot(y.chartX - s.plotLeft, y.chartY - s.plotTop, { visiblePlotOnly: !0 }) && !s.openMenu ? (S && this.runPointActions(y), y.type === "touchmove" && (d = !!l[0] && Math.pow(l[0].chartX - y.chartX, 2) + Math.pow(l[0].chartY - y.chartY, 2) >= 16), A(d, !0) && this.pinch(y)) : S && this.reset() : y.touches.length === 2 && this.pinch(y);
        }
        touchSelect(y) {
          return !!(this.chart.zooming.singleTouch && y.touches && y.touches.length === 1);
        }
        zoomOption(y) {
          let S = this.chart, d = S.inverted, s = S.zooming.type || "", l, b;
          /touch/.test(y.type) && (s = A(S.zooming.pinchType, s)), this.zoomX = l = /x/.test(s), this.zoomY = b = /y/.test(s), this.zoomHor = l && !d || b && d, this.zoomVert = b && !d || l && d, this.hasZoom = l || b;
        }
      }
      return (T = G || (G = {})).compose = function(P) {
        C(D, "Core.Pointer") && B(P, "beforeRender", function() {
          this.pointer = new T(this, this.options);
        });
      }, G;
    }), a(e, "Core/Legend/LegendSymbol.js", [e["Core/Utilities.js"]], function(o) {
      var n;
      let { extend: r, merge: T, pick: O } = o;
      return function(j) {
        function D(F, B, N) {
          var d, s;
          let f = this.legendItem = this.legendItem || {}, { chart: w, options: x } = this, { baseline: M = 0, symbolWidth: p, symbolHeight: v } = F, k = this.symbol || "circle", m = v / 2, A = w.renderer, C = f.group, H = M - Math.round((((d = F.fontMetrics) == null ? void 0 : d.b) || v) * (N ? 0.4 : 0.3)), G = {}, P, y = x.marker, S = 0;
          if (w.styledMode || (G["stroke-width"] = Math.min(x.lineWidth || 0, 24), x.dashStyle ? G.dashstyle = x.dashStyle : x.linecap === "square" || (G["stroke-linecap"] = "round")), f.line = A.path().addClass("highcharts-graph").attr(G).add(C), N && (f.area = A.path().addClass("highcharts-area").add(C)), G["stroke-linecap"] && (S = Math.min(f.line.strokeWidth(), p) / 2), p) {
            let l = [["M", S, H], ["L", p - S, H]];
            f.line.attr({ d: l }), (s = f.area) == null || s.attr({ d: [...l, ["L", p - S, M], ["L", S, M]] });
          }
          if (y && y.enabled !== !1 && p) {
            let l = Math.min(O(y.radius, m), m);
            k.indexOf("url") === 0 && (y = T(y, { width: v, height: v }), l = 0), f.symbol = P = A.symbol(k, p / 2 - l, H - l, 2 * l, 2 * l, r({ context: "legend" }, y)).addClass("highcharts-point").add(C), P.isMarker = !0;
          }
        }
        j.areaMarker = function(F, B) {
          D.call(this, F, B, !0);
        }, j.lineMarker = D, j.rectangle = function(F, B) {
          let N = B.legendItem || {}, f = F.options, w = F.symbolHeight, x = f.squareSymbol, M = x ? w : F.symbolWidth;
          N.symbol = this.chart.renderer.rect(x ? (F.symbolWidth - w) / 2 : 0, F.baseline - w + 1, M, w, O(F.options.symbolRadius, w / 2)).addClass("highcharts-point").attr({ zIndex: 3 }).add(N.group);
        };
      }(n || (n = {})), n;
    }), a(e, "Core/Series/SeriesDefaults.js", [], function() {
      return { lineWidth: 2, allowPointSelect: !1, crisp: !0, showCheckbox: !1, animation: { duration: 1e3 }, enableMouseTracking: !0, events: {}, marker: { enabledThreshold: 2, lineColor: "#ffffff", lineWidth: 0, radius: 4, states: { normal: { animation: !0 }, hover: { animation: { duration: 150 }, enabled: !0, radiusPlus: 2, lineWidthPlus: 1 }, select: { fillColor: "#cccccc", lineColor: "#000000", lineWidth: 2 } } }, point: { events: {} }, dataLabels: { animation: {}, align: "center", borderWidth: 0, defer: !0, formatter: function() {
        let { numberFormatter: o } = this.series.chart;
        return typeof this.y != "number" ? "" : o(this.y, -1);
      }, padding: 5, style: { fontSize: "0.7em", fontWeight: "bold", color: "contrast", textOutline: "1px contrast" }, verticalAlign: "bottom", x: 0, y: 0 }, cropThreshold: 300, opacity: 1, pointRange: 0, softThreshold: !0, states: { normal: { animation: !0 }, hover: { animation: { duration: 150 }, lineWidthPlus: 1, marker: {}, halo: { size: 10, opacity: 0.25 } }, select: { animation: { duration: 0 } }, inactive: { animation: { duration: 150 }, opacity: 0.2 } }, stickyTracking: !0, turboThreshold: 1e3, findNearestPointBy: "x" };
    }), a(e, "Core/Series/SeriesRegistry.js", [e["Core/Globals.js"], e["Core/Defaults.js"], e["Core/Series/Point.js"], e["Core/Utilities.js"]], function(o, n, r, T) {
      var O;
      let { defaultOptions: j } = n, { extend: D, extendClass: F, merge: B } = T;
      return function(N) {
        function f(w, x) {
          let M = j.plotOptions || {}, p = x.defaultOptions, v = x.prototype;
          return v.type = w, v.pointClass || (v.pointClass = r), !N.seriesTypes[w] && (p && (M[w] = p), N.seriesTypes[w] = x, !0);
        }
        N.seriesTypes = o.seriesTypes, N.registerSeriesType = f, N.seriesType = function(w, x, M, p, v) {
          let k = j.plotOptions || {};
          if (x = x || "", k[w] = B(k[x], M), delete N.seriesTypes[w], f(w, F(N.seriesTypes[x] || function() {
          }, p)), N.seriesTypes[w].prototype.type = w, v) {
            class m extends r {
            }
            D(m.prototype, v), N.seriesTypes[w].prototype.pointClass = m;
          }
          return N.seriesTypes[w];
        };
      }(O || (O = {})), O;
    }), a(e, "Core/Series/Series.js", [e["Core/Animation/AnimationUtilities.js"], e["Core/Defaults.js"], e["Core/Foundation.js"], e["Core/Globals.js"], e["Core/Legend/LegendSymbol.js"], e["Core/Series/Point.js"], e["Core/Series/SeriesDefaults.js"], e["Core/Series/SeriesRegistry.js"], e["Core/Renderer/SVG/SVGElement.js"], e["Core/Utilities.js"]], function(o, n, r, T, O, j, D, F, B, N) {
      let { animObject: f, setAnimation: w } = o, { defaultOptions: x } = n, { registerEventOptions: M } = r, { svg: p, win: v } = T, { seriesTypes: k } = F, { arrayMax: m, arrayMin: A, clamp: C, correctFloat: H, crisp: G, defined: P, destroyObjectProperties: y, diffObjects: S, erase: d, error: s, extend: l, find: b, fireEvent: u, getClosestDistance: c, getNestedProperty: h, insertItem: g, isArray: E, isNumber: R, isString: L, merge: U, objectEach: V, pick: q, removeEvent: Y, splat: I, syncTimeout: _ } = N;
      class W {
        constructor() {
          this.zoneAxis = "y";
        }
        init(z, $) {
          let K;
          u(this, "init", { options: $ });
          let Q = this, Z = z.series;
          this.eventsToUnbind = [], Q.chart = z, Q.options = Q.setOptions($);
          let ee = Q.options, J = ee.visible !== !1;
          Q.linkedSeries = [], Q.bindAxes(), l(Q, { name: ee.name, state: "", visible: J, selected: ee.selected === !0 }), M(this, ee);
          let ae = ee.events;
          (ae && ae.click || ee.point && ee.point.events && ee.point.events.click || ee.allowPointSelect) && (z.runTrackerClick = !0), Q.getColor(), Q.getSymbol(), Q.parallelArrays.forEach(function(re) {
            Q[re + "Data"] || (Q[re + "Data"] = []);
          }), Q.isCartesian && (z.hasCartesianSeries = !0), Z.length && (K = Z[Z.length - 1]), Q._i = q(K && K._i, -1) + 1, Q.opacity = Q.options.opacity, z.orderItems("series", g(this, Z)), ee.dataSorting && ee.dataSorting.enabled ? Q.setDataSortingOptions() : Q.points || Q.data || Q.setData(ee.data, !1), u(this, "afterInit");
        }
        is(z) {
          return k[z] && this instanceof k[z];
        }
        bindAxes() {
          let z, $ = this, K = $.options, Q = $.chart;
          u(this, "bindAxes", null, function() {
            ($.axisTypes || []).forEach(function(Z) {
              (Q[Z] || []).forEach(function(ee) {
                z = ee.options, (q(K[Z], 0) === ee.index || K[Z] !== void 0 && K[Z] === z.id) && (g($, ee.series), $[Z] = ee, ee.isDirty = !0);
              }), $[Z] || $.optionalAxis === Z || s(18, !0, Q);
            });
          }), u(this, "afterBindAxes");
        }
        updateParallelArrays(z, $, K) {
          let Q = z.series, Z = R($) ? function(ee) {
            let J = ee === "y" && Q.toYData ? Q.toYData(z) : z[ee];
            Q[ee + "Data"][$] = J;
          } : function(ee) {
            Array.prototype[$].apply(Q[ee + "Data"], K);
          };
          Q.parallelArrays.forEach(Z);
        }
        hasData() {
          return this.visible && this.dataMax !== void 0 && this.dataMin !== void 0 || this.visible && this.yData && this.yData.length > 0;
        }
        hasMarkerChanged(z, $) {
          let K = z.marker, Q = $.marker || {};
          return K && (Q.enabled && !K.enabled || Q.symbol !== K.symbol || Q.height !== K.height || Q.width !== K.width);
        }
        autoIncrement(z) {
          let $ = this.options, K = $.pointIntervalUnit, Q = $.relativeXValue, Z = this.chart.time, ee = this.xIncrement, J, ae;
          return ee = q(ee, $.pointStart, 0), this.pointInterval = ae = q(this.pointInterval, $.pointInterval, 1), Q && R(z) && (ae *= z), K && (J = new Z.Date(ee), K === "day" ? Z.set("Date", J, Z.get("Date", J) + ae) : K === "month" ? Z.set("Month", J, Z.get("Month", J) + ae) : K === "year" && Z.set("FullYear", J, Z.get("FullYear", J) + ae), ae = J.getTime() - ee), Q && R(z) ? ee + ae : (this.xIncrement = ee + ae, ee);
        }
        setDataSortingOptions() {
          let z = this.options;
          l(this, { requireSorting: !1, sorted: !1, enabledDataSorting: !0, allowDG: !1 }), P(z.pointRange) || (z.pointRange = 1);
        }
        setOptions(z) {
          var ie, le;
          let $, K = this.chart, Q = K.options.plotOptions, Z = K.userOptions || {}, ee = U(z), J = K.styledMode, ae = { plotOptions: Q, userOptions: ee };
          u(this, "setOptions", ae);
          let re = ae.plotOptions[this.type], ce = Z.plotOptions || {}, he = ce.series || {}, ne = x.plotOptions[this.type] || {}, te = ce[this.type] || {};
          this.userOptions = ae.userOptions;
          let se = U(re, Q.series, te, ee);
          this.tooltipOptions = U(x.tooltip, (ie = x.plotOptions.series) == null ? void 0 : ie.tooltip, ne == null ? void 0 : ne.tooltip, K.userOptions.tooltip, (le = ce.series) == null ? void 0 : le.tooltip, te.tooltip, ee.tooltip), this.stickyTracking = q(ee.stickyTracking, te.stickyTracking, he.stickyTracking, !!this.tooltipOptions.shared && !this.noSharedTooltip || se.stickyTracking), re.marker === null && delete se.marker, this.zoneAxis = se.zoneAxis || "y";
          let oe = this.zones = (se.zones || []).map((de) => ({ ...de }));
          return (se.negativeColor || se.negativeFillColor) && !se.zones && ($ = { value: se[this.zoneAxis + "Threshold"] || se.threshold || 0, className: "highcharts-negative" }, J || ($.color = se.negativeColor, $.fillColor = se.negativeFillColor), oe.push($)), oe.length && P(oe[oe.length - 1].value) && oe.push(J ? {} : { color: this.color, fillColor: this.fillColor }), u(this, "afterSetOptions", { options: se }), se;
        }
        getName() {
          return q(this.options.name, "Series " + (this.index + 1));
        }
        getCyclic(z, $, K) {
          let Q, Z, ee = this.chart, J = `${z}Index`, ae = `${z}Counter`, re = (K == null ? void 0 : K.length) || ee.options.chart.colorCount;
          !$ && (P(Z = q(z === "color" ? this.options.colorIndex : void 0, this[J])) ? Q = Z : (ee.series.length || (ee[ae] = 0), Q = ee[ae] % re, ee[ae] += 1), K && ($ = K[Q])), Q !== void 0 && (this[J] = Q), this[z] = $;
        }
        getColor() {
          this.chart.styledMode ? this.getCyclic("color") : this.options.colorByPoint ? this.color = "#cccccc" : this.getCyclic("color", this.options.color || x.plotOptions[this.type].color, this.chart.options.colors);
        }
        getPointsCollection() {
          return (this.hasGroupedData ? this.points : this.data) || [];
        }
        getSymbol() {
          let z = this.options.marker;
          this.getCyclic("symbol", z.symbol, this.chart.options.symbols);
        }
        findPointIndex(z, $) {
          let K, Q, Z, ee = z.id, J = z.x, ae = this.points, re = this.options.dataSorting;
          if (ee) {
            let ce = this.chart.get(ee);
            ce instanceof j && (K = ce);
          } else if (this.linkedParent || this.enabledDataSorting || this.options.relativeXValue) {
            let ce = (he) => !he.touched && he.index === z.index;
            if (re && re.matchByName ? ce = (he) => !he.touched && he.name === z.name : this.options.relativeXValue && (ce = (he) => !he.touched && he.options.x === z.x), !(K = b(ae, ce))) return;
          }
          return K && (Z = K && K.index) !== void 0 && (Q = !0), Z === void 0 && R(J) && (Z = this.xData.indexOf(J, $)), Z !== -1 && Z !== void 0 && this.cropped && (Z = Z >= this.cropStart ? Z - this.cropStart : Z), !Q && R(Z) && ae[Z] && ae[Z].touched && (Z = void 0), Z;
        }
        updateData(z, $) {
          let K = this.options, Q = K.dataSorting, Z = this.points, ee = [], J = this.requireSorting, ae = z.length === Z.length, re, ce, he, ne, te = !0;
          if (this.xIncrement = null, z.forEach(function(se, oe) {
            let ie, le = P(se) && this.pointClass.prototype.optionsToObject.call({ series: this }, se) || {}, de = le.x;
            le.id || R(de) ? ((ie = this.findPointIndex(le, ne)) === -1 || ie === void 0 ? ee.push(se) : Z[ie] && se !== K.data[ie] ? (Z[ie].update(se, !1, null, !1), Z[ie].touched = !0, J && (ne = ie + 1)) : Z[ie] && (Z[ie].touched = !0), (!ae || oe !== ie || Q && Q.enabled || this.hasDerivedData) && (re = !0)) : ee.push(se);
          }, this), re) for (ce = Z.length; ce--; ) (he = Z[ce]) && !he.touched && he.remove && he.remove(!1, $);
          else !ae || Q && Q.enabled ? te = !1 : (z.forEach(function(se, oe) {
            se === Z[oe].y || Z[oe].destroyed || Z[oe].update(se, !1, null, !1);
          }), ee.length = 0);
          return Z.forEach(function(se) {
            se && (se.touched = !1);
          }), !!te && (ee.forEach(function(se) {
            this.addPoint(se, !1, null, null, !1);
          }, this), this.xIncrement === null && this.xData && this.xData.length && (this.xIncrement = m(this.xData), this.autoIncrement()), !0);
        }
        setData(z, $ = !0, K, Q) {
          var xe;
          let Z = this, ee = Z.points, J = ee && ee.length || 0, ae = Z.options, re = Z.chart, ce = ae.dataSorting, he = Z.xAxis, ne = ae.turboThreshold, te = this.xData, se = this.yData, oe = Z.pointArrayMap, ie = oe && oe.length, le = ae.keys, de, be, ge, me = 0, fe = 1, Ae;
          re.options.chart.allowMutatingData || (ae.data && delete Z.options.data, Z.userOptions.data && delete Z.userOptions.data, Ae = U(!0, z));
          let ye = (z = Ae || z || []).length;
          if (ce && ce.enabled && (z = this.sortData(z)), re.options.chart.allowMutatingData && Q !== !1 && ye && J && !Z.cropped && !Z.hasGroupedData && Z.visible && !Z.boosted && (ge = this.updateData(z, K)), !ge) {
            Z.xIncrement = null, Z.colorCounter = 0, this.parallelArrays.forEach(function(ke) {
              Z[ke + "Data"].length = 0;
            });
            let we = ne && ye > ne;
            if (we) {
              let ke = Z.getFirstValidPoint(z), Me = Z.getFirstValidPoint(z, ye - 1, -1), Te = (Ie) => !!(E(Ie) && (le || R(Ie[0])));
              if (R(ke) && R(Me)) for (de = 0; de < ye; de++) te[de] = this.autoIncrement(), se[de] = z[de];
              else if (Te(ke) && Te(Me))
                if (ie)
                  if (ke.length === ie) for (de = 0; de < ye; de++) te[de] = this.autoIncrement(), se[de] = z[de];
                  else for (de = 0; de < ye; de++) be = z[de], te[de] = be[0], se[de] = be.slice(1, ie + 1);
                else if (le && (me = le.indexOf("x"), fe = le.indexOf("y"), me = me >= 0 ? me : 0, fe = fe >= 0 ? fe : 1), ke.length === 1 && (fe = 0), me === fe) for (de = 0; de < ye; de++) te[de] = this.autoIncrement(), se[de] = z[de][fe];
                else for (de = 0; de < ye; de++) be = z[de], te[de] = be[me], se[de] = be[fe];
              else we = !1;
            }
            if (!we) for (de = 0; de < ye; de++) be = { series: Z }, Z.pointClass.prototype.applyOptions.apply(be, [z[de]]), Z.updateParallelArrays(be, de);
            for (se && L(se[0]) && s(14, !0, re), Z.data = [], Z.options.data = Z.userOptions.data = z, de = J; de--; ) (xe = ee[de]) == null || xe.destroy();
            he && (he.minRange = he.userMinRange), Z.isDirty = re.isDirtyBox = !0, Z.isDirtyData = !!ee, K = !1;
          }
          ae.legendType === "point" && (this.processData(), this.generatePoints()), $ && re.redraw(K);
        }
        sortData(z) {
          let $ = this, K = $.options.dataSorting.sortKey || "y", Q = function(Z, ee) {
            return P(ee) && Z.pointClass.prototype.optionsToObject.call({ series: Z }, ee) || {};
          };
          return z.forEach(function(Z, ee) {
            z[ee] = Q($, Z), z[ee].index = ee;
          }, this), z.concat().sort((Z, ee) => {
            let J = h(K, Z), ae = h(K, ee);
            return ae < J ? -1 : ae > J ? 1 : 0;
          }).forEach(function(Z, ee) {
            Z.x = ee;
          }, this), $.linkedSeries && $.linkedSeries.forEach(function(Z) {
            let ee = Z.options, J = ee.data;
            ee.dataSorting && ee.dataSorting.enabled || !J || (J.forEach(function(ae, re) {
              J[re] = Q(Z, ae), z[re] && (J[re].x = z[re].x, J[re].index = re);
            }), Z.setData(J, !1));
          }), z;
        }
        getProcessedData(z) {
          let $ = this, K = $.xAxis, Q = $.options.cropThreshold, Z = K == null ? void 0 : K.logarithmic, ee = $.isCartesian, J, ae, re = 0, ce, he, ne, te = $.xData, se = $.yData, oe = !1, ie = te.length;
          K && (he = (ce = K.getExtremes()).min, ne = ce.max, oe = !!(K.categories && !K.names.length)), ee && $.sorted && !z && (!Q || ie > Q || $.forceCrop) && (te[ie - 1] < he || te[0] > ne ? (te = [], se = []) : $.yData && (te[0] < he || te[ie - 1] > ne) && (te = (J = this.cropData($.xData, $.yData, he, ne)).xData, se = J.yData, re = J.start, ae = !0));
          let le = c([Z ? te.map(Z.log2lin) : te], () => $.requireSorting && !oe && s(15, !1, $.chart));
          return { xData: te, yData: se, cropped: ae, cropStart: re, closestPointRange: le };
        }
        processData(z) {
          let $ = this.xAxis;
          if (this.isCartesian && !this.isDirty && !$.isDirty && !this.yAxis.isDirty && !z) return !1;
          let K = this.getProcessedData();
          this.cropped = K.cropped, this.cropStart = K.cropStart, this.processedXData = K.xData, this.processedYData = K.yData, this.closestPointRange = this.basePointRange = K.closestPointRange, u(this, "afterProcessData");
        }
        cropData(z, $, K, Q) {
          let Z = z.length, ee, J, ae = 0, re = Z;
          for (ee = 0; ee < Z; ee++) if (z[ee] >= K) {
            ae = Math.max(0, ee - 1);
            break;
          }
          for (J = ee; J < Z; J++) if (z[J] > Q) {
            re = J + 1;
            break;
          }
          return { xData: z.slice(ae, re), yData: $.slice(ae, re), start: ae, end: re };
        }
        generatePoints() {
          let z = this.options, $ = this.processedData || z.data, K = this.processedXData, Q = this.processedYData, Z = this.pointClass, ee = K.length, J = this.cropStart || 0, ae = this.hasGroupedData, re = z.keys, ce = [], he = z.dataGrouping && z.dataGrouping.groupAll ? J : 0, ne, te, se, oe, ie = this.data;
          if (!ie && !ae) {
            let le = [];
            le.length = $.length, ie = this.data = le;
          }
          for (re && ae && (this.options.keys = !1), oe = 0; oe < ee; oe++) te = J + oe, ae ? ((se = new Z(this, [K[oe]].concat(I(Q[oe])))).dataGroup = this.groupMap[he + oe], se.dataGroup.options && (se.options = se.dataGroup.options, l(se, se.dataGroup.options), delete se.dataLabels)) : (se = ie[te]) || $[te] === void 0 || (ie[te] = se = new Z(this, $[te], K[oe])), se && (se.index = ae ? he + oe : te, ce[oe] = se);
          if (this.options.keys = re, ie && (ee !== (ne = ie.length) || ae)) for (oe = 0; oe < ne; oe++) oe !== J || ae || (oe += ee), ie[oe] && (ie[oe].destroyElements(), ie[oe].plotX = void 0);
          this.data = ie, this.points = ce, u(this, "afterGeneratePoints");
        }
        getXExtremes(z) {
          return { min: A(z), max: m(z) };
        }
        getExtremes(z, $) {
          let K = this.xAxis, Q = this.yAxis, Z = [], ee = this.requireSorting && !this.is("column") ? 1 : 0, J = !!Q && Q.positiveValuesOnly, ae = $ || this.getExtremesFromAll || this.options.getExtremesFromAll, { processedXData: re, processedYData: ce } = this, he, ne, te, se, oe, ie, le, de = 0, be = 0, ge = 0;
          if (this.cropped && ae) {
            let ye = this.getProcessedData(!0);
            re = ye.xData, ce = ye.yData;
          }
          let me = (z = z || this.stackedYData || ce || []).length, fe = re || this.xData;
          for (K && (de = (he = K.getExtremes()).min, be = he.max), ie = 0; ie < me; ie++) if (se = fe[ie], ne = (R(oe = z[ie]) || E(oe)) && ((R(oe) ? oe > 0 : oe.length) || !J), te = $ || this.getExtremesFromAll || this.options.getExtremesFromAll || this.cropped || !K || (fe[ie + ee] || se) >= de && (fe[ie - ee] || se) <= be, ne && te)
            if (le = oe.length) for (; le--; ) R(oe[le]) && (Z[ge++] = oe[le]);
            else Z[ge++] = oe;
          let Ae = { activeYData: Z, dataMin: A(Z), dataMax: m(Z) };
          return u(this, "afterGetExtremes", { dataExtremes: Ae }), Ae;
        }
        applyExtremes() {
          let z = this.getExtremes();
          return this.dataMin = z.dataMin, this.dataMax = z.dataMax, z;
        }
        getFirstValidPoint(z, $ = 0, K = 1) {
          let Q = z.length, Z = $;
          for (; Z >= 0 && Z < Q; ) {
            if (P(z[Z])) return z[Z];
            Z += K;
          }
        }
        translate() {
          var be;
          this.processedXData || this.processData(), this.generatePoints();
          let z = this.options, $ = z.stacking, K = this.xAxis, Q = K.categories, Z = this.enabledDataSorting, ee = this.yAxis, J = this.points, ae = J.length, re = this.pointPlacementToXValue(), ce = !!re, he = z.threshold, ne = z.startFromThreshold ? he : 0, te, se, oe, ie, le = Number.MAX_VALUE;
          function de(ge) {
            return C(ge, -1e9, 1e9);
          }
          for (te = 0; te < ae; te++) {
            let ge, me = J[te], fe = me.x, Ae, ye, xe = me.y, we = me.low, ke = $ && ((be = ee.stacking) == null ? void 0 : be.stacks[(this.negStacks && xe < (ne ? 0 : he) ? "-" : "") + this.stackKey]);
            se = K.translate(fe, !1, !1, !1, !0, re), me.plotX = R(se) ? H(de(se)) : void 0, $ && this.visible && ke && ke[fe] && (ie = this.getStackIndicator(ie, fe, this.index), !me.isNull && ie.key && (ye = (Ae = ke[fe]).points[ie.key]), Ae && E(ye) && (we = ye[0], xe = ye[1], we === ne && ie.key === ke[fe].base && (we = q(R(he) ? he : ee.min)), ee.positiveValuesOnly && P(we) && we <= 0 && (we = void 0), me.total = me.stackTotal = q(Ae.total), me.percentage = P(me.y) && Ae.total ? me.y / Ae.total * 100 : void 0, me.stackY = xe, this.irregularWidths || Ae.setOffset(this.pointXOffset || 0, this.barW || 0, void 0, void 0, void 0, this.xAxis))), me.yBottom = P(we) ? de(ee.translate(we, !1, !0, !1, !0)) : void 0, this.dataModify && (xe = this.dataModify.modifyValue(xe, te)), R(xe) && me.plotX !== void 0 && (ge = R(ge = ee.translate(xe, !1, !0, !1, !0)) ? de(ge) : void 0), me.plotY = ge, me.isInside = this.isPointInside(me), me.clientX = ce ? H(K.translate(fe, !1, !1, !1, !0, re)) : se, me.negative = (me.y || 0) < (he || 0), me.category = q(Q && Q[me.x], me.x), me.isNull || me.visible === !1 || (oe !== void 0 && (le = Math.min(le, Math.abs(se - oe))), oe = se), me.zone = this.zones.length ? me.getZone() : void 0, !me.graphic && this.group && Z && (me.isNew = !0);
          }
          this.closestPointRangePx = le, u(this, "afterTranslate");
        }
        getValidPoints(z, $, K) {
          let Q = this.chart;
          return (z || this.points || []).filter(function(Z) {
            let { plotX: ee, plotY: J } = Z;
            return !!((K || !Z.isNull && R(J)) && (!$ || Q.isInsidePlot(ee, J, { inverted: Q.inverted }))) && Z.visible !== !1;
          });
        }
        getClipBox() {
          let { chart: z, xAxis: $, yAxis: K } = this, { x: Q, y: Z, width: ee, height: J } = U(z.clipBox);
          return $ && $.len !== z.plotSizeX && (ee = $.len), K && K.len !== z.plotSizeY && (J = K.len), z.inverted && !this.invertible && ([ee, J] = [J, ee]), { x: Q, y: Z, width: ee, height: J };
        }
        getSharedClipKey() {
          return this.sharedClipKey = (this.options.xAxis || 0) + "," + (this.options.yAxis || 0), this.sharedClipKey;
        }
        setClip() {
          let { chart: z, group: $, markerGroup: K } = this, Q = z.sharedClips, Z = z.renderer, ee = this.getClipBox(), J = this.getSharedClipKey(), ae = Q[J];
          ae ? ae.animate(ee) : Q[J] = ae = Z.clipRect(ee), $ && $.clip(this.options.clip === !1 ? void 0 : ae), K && K.clip();
        }
        animate(z) {
          let { chart: $, group: K, markerGroup: Q } = this, Z = $.inverted, ee = f(this.options.animation), J = [this.getSharedClipKey(), ee.duration, ee.easing, ee.defer].join(","), ae = $.sharedClips[J], re = $.sharedClips[J + "m"];
          if (z && K) {
            let ce = this.getClipBox();
            if (ae) ae.attr("height", ce.height);
            else {
              ce.width = 0, Z && (ce.x = $.plotHeight), ae = $.renderer.clipRect(ce), $.sharedClips[J] = ae;
              let he = { x: -99, y: -99, width: Z ? $.plotWidth + 199 : 99, height: Z ? 99 : $.plotHeight + 199 };
              re = $.renderer.clipRect(he), $.sharedClips[J + "m"] = re;
            }
            K.clip(ae), Q == null || Q.clip(re);
          } else if (ae && !ae.hasClass("highcharts-animating")) {
            let ce = this.getClipBox(), he = ee.step;
            (Q != null && Q.element.childNodes.length || $.series.length > 1) && (ee.step = function(ne, te) {
              he && he.apply(te, arguments), te.prop === "width" && (re != null && re.element) && re.attr(Z ? "height" : "width", ne + 99);
            }), ae.addClass("highcharts-animating").animate(ce, ee);
          }
        }
        afterAnimate() {
          this.setClip(), V(this.chart.sharedClips, (z, $, K) => {
            z && !this.chart.container.querySelector(`[clip-path="url(#${z.id})"]`) && (z.destroy(), delete K[$]);
          }), this.finishedAnimating = !0, u(this, "afterAnimate");
        }
        drawPoints(z = this.points) {
          let $, K, Q, Z, ee, J, ae, re = this.chart, ce = re.styledMode, { colorAxis: he, options: ne } = this, te = ne.marker, se = this[this.specialGroup || "markerGroup"], oe = this.xAxis, ie = q(te.enabled, !oe || !!oe.isRadial || null, this.closestPointRangePx >= te.enabledThreshold * te.radius);
          if (te.enabled !== !1 || this._hasPointMarkers) for ($ = 0; $ < z.length; $++) if (Z = (Q = (K = z[$]).graphic) ? "animate" : "attr", ee = K.marker || {}, J = !!K.marker, (ie && ee.enabled === void 0 || ee.enabled) && !K.isNull && K.visible !== !1) {
            let le = q(ee.symbol, this.symbol, "rect");
            ae = this.markerAttribs(K, K.selected && "select"), this.enabledDataSorting && (K.startXPos = oe.reversed ? -(ae.width || 0) : oe.width);
            let de = K.isInside !== !1;
            if (!Q && de && ((ae.width || 0) > 0 || K.hasImage) && (K.graphic = Q = re.renderer.symbol(le, ae.x, ae.y, ae.width, ae.height, J ? ee : te).add(se), this.enabledDataSorting && re.hasRendered && (Q.attr({ x: K.startXPos }), Z = "animate")), Q && Z === "animate" && Q[de ? "show" : "hide"](de).animate(ae), Q) {
              let be = this.pointAttribs(K, ce || !K.selected ? void 0 : "select");
              ce ? he && Q.css({ fill: be.fill }) : Q[Z](be);
            }
            Q && Q.addClass(K.getClassName(), !0);
          } else Q && (K.graphic = Q.destroy());
        }
        markerAttribs(z, $) {
          let K = this.options, Q = K.marker, Z = z.marker || {}, ee = Z.symbol || Q.symbol, J = {}, ae, re, ce = q(Z.radius, Q && Q.radius);
          $ && (ae = Q.states[$], ce = q((re = Z.states && Z.states[$]) && re.radius, ae && ae.radius, ce && ce + (ae && ae.radiusPlus || 0))), z.hasImage = ee && ee.indexOf("url") === 0, z.hasImage && (ce = 0);
          let he = z.pos();
          return R(ce) && he && (K.crisp && (he[0] = G(he[0], z.hasImage ? 0 : ee === "rect" ? (Q == null ? void 0 : Q.lineWidth) || 0 : 1)), J.x = he[0] - ce, J.y = he[1] - ce), ce && (J.width = J.height = 2 * ce), J;
        }
        pointAttribs(z, $) {
          let K = this.options.marker, Q = z && z.options, Z = Q && Q.marker || {}, ee = Q && Q.color, J = z && z.color, ae = z && z.zone && z.zone.color, re, ce, he = this.color, ne, te, se = q(Z.lineWidth, K.lineWidth), oe = 1;
          return he = ee || ae || J || he, ne = Z.fillColor || K.fillColor || he, te = Z.lineColor || K.lineColor || he, $ = $ || "normal", re = K.states[$] || {}, se = q((ce = Z.states && Z.states[$] || {}).lineWidth, re.lineWidth, se + q(ce.lineWidthPlus, re.lineWidthPlus, 0)), ne = ce.fillColor || re.fillColor || ne, { stroke: te = ce.lineColor || re.lineColor || te, "stroke-width": se, fill: ne, opacity: oe = q(ce.opacity, re.opacity, oe) };
        }
        destroy(z) {
          let $, K, Q, Z = this, ee = Z.chart, J = /AppleWebKit\/533/.test(v.navigator.userAgent), ae = Z.data || [];
          for (u(Z, "destroy", { keepEventsForUpdate: z }), this.removeEvents(z), (Z.axisTypes || []).forEach(function(re) {
            (Q = Z[re]) && Q.series && (d(Q.series, Z), Q.isDirty = Q.forceRedraw = !0);
          }), Z.legendItem && Z.chart.legend.destroyItem(Z), $ = ae.length; $--; ) (K = ae[$]) && K.destroy && K.destroy();
          for (let re of Z.zones) y(re, void 0, !0);
          N.clearTimeout(Z.animationTimeout), V(Z, function(re, ce) {
            re instanceof B && !re.survive && re[J && ce === "group" ? "hide" : "destroy"]();
          }), ee.hoverSeries === Z && (ee.hoverSeries = void 0), d(ee.series, Z), ee.orderItems("series"), V(Z, function(re, ce) {
            z && ce === "hcEvents" || delete Z[ce];
          });
        }
        applyZones() {
          let { area: z, chart: $, graph: K, zones: Q, points: Z, xAxis: ee, yAxis: J, zoneAxis: ae } = this, { inverted: re, renderer: ce } = $, he = this[`${ae}Axis`], { isXAxis: ne, len: te = 0 } = he || {}, se = ((K == null ? void 0 : K.strokeWidth()) || 0) / 2 + 1, oe = (ie, le = 0, de = 0) => {
            re && (de = te - de);
            let { translated: be = 0, lineClip: ge } = ie, me = de - be;
            ge == null || ge.push(["L", le, Math.abs(me) < se ? de - se * (me <= 0 ? -1 : 1) : be]);
          };
          if (Q.length && (K || z) && he && R(he.min)) {
            let ie = he.getExtremes().max, le = (ge) => {
              ge.forEach((me, fe) => {
                (me[0] === "M" || me[0] === "L") && (ge[fe] = [me[0], ne ? te - me[1] : me[1], ne ? me[2] : te - me[2]]);
              });
            };
            if (Q.forEach((ge) => {
              ge.lineClip = [], ge.translated = C(he.toPixels(q(ge.value, ie), !0) || 0, 0, te);
            }), K && !this.showLine && K.hide(), z && z.hide(), ae === "y" && Z.length < ee.len) for (let ge of Z) {
              let { plotX: me, plotY: fe, zone: Ae } = ge, ye = Ae && Q[Q.indexOf(Ae) - 1];
              Ae && oe(Ae, me, fe), ye && oe(ye, me, fe);
            }
            let de = [], be = he.toPixels(he.getExtremes().min, !0);
            Q.forEach((ge) => {
              var He, $e;
              let me = ge.lineClip || [], fe = Math.round(ge.translated || 0);
              ee.reversed && me.reverse();
              let { clip: Ae, simpleClip: ye } = ge, xe = 0, we = 0, ke = ee.len, Me = J.len;
              ne ? (xe = fe, ke = be) : (we = fe, Me = be);
              let Te = [["M", xe, we], ["L", ke, we], ["L", ke, Me], ["L", xe, Me], ["Z"]], Ie = [Te[0], ...me, Te[1], Te[2], ...de, Te[3], Te[4]];
              de = me.reverse(), be = fe, re && (le(Ie), z && le(Te)), Ae ? (Ae.animate({ d: Ie }), ye == null || ye.animate({ d: Te })) : (Ae = ge.clip = ce.path(Ie), z && (ye = ge.simpleClip = ce.path(Te))), K && ((He = ge.graph) == null || He.clip(Ae)), z && (($e = ge.area) == null || $e.clip(ye));
            });
          } else this.visible && (K && K.show(), z && z.show());
        }
        plotGroup(z, $, K, Q, Z) {
          let ee = this[z], J = !ee, ae = { visibility: K, zIndex: Q || 0.1 };
          return P(this.opacity) && !this.chart.styledMode && this.state !== "inactive" && (ae.opacity = this.opacity), ee || (this[z] = ee = this.chart.renderer.g().add(Z)), ee.addClass("highcharts-" + $ + " highcharts-series-" + this.index + " highcharts-" + this.type + "-series " + (P(this.colorIndex) ? "highcharts-color-" + this.colorIndex + " " : "") + (this.options.className || "") + (ee.hasClass("highcharts-tracker") ? " highcharts-tracker" : ""), !0), ee.attr(ae)[J ? "attr" : "animate"](this.getPlotBox($)), ee;
        }
        getPlotBox(z) {
          let $ = this.xAxis, K = this.yAxis, Q = this.chart, Z = Q.inverted && !Q.polar && $ && this.invertible && z === "series";
          return Q.inverted && ($ = K, K = this.xAxis), { translateX: $ ? $.left : Q.plotLeft, translateY: K ? K.top : Q.plotTop, rotation: Z ? 90 : 0, rotationOriginX: Z ? ($.len - K.len) / 2 : 0, rotationOriginY: Z ? ($.len + K.len) / 2 : 0, scaleX: Z ? -1 : 1, scaleY: 1 };
        }
        removeEvents(z) {
          let { eventsToUnbind: $ } = this;
          z || Y(this), $.length && ($.forEach((K) => {
            K();
          }), $.length = 0);
        }
        render() {
          var ce, he, ne, te, se;
          let z = this, { chart: $, options: K, hasRendered: Q } = z, Z = f(K.animation), ee = z.visible ? "inherit" : "hidden", J = K.zIndex, ae = $.seriesGroup, re = z.finishedAnimating ? 0 : Z.duration;
          u(this, "render"), z.plotGroup("group", "series", ee, J, ae), z.markerGroup = z.plotGroup("markerGroup", "markers", ee, J, ae), K.clip !== !1 && z.setClip(), re && ((ce = z.animate) == null || ce.call(z, !0)), z.drawGraph && (z.drawGraph(), z.applyZones()), z.visible && z.drawPoints(), (he = z.drawDataLabels) == null || he.call(z), (ne = z.redrawPoints) == null || ne.call(z), K.enableMouseTracking && ((te = z.drawTracker) == null || te.call(z)), re && ((se = z.animate) == null || se.call(z)), Q || (re && Z.defer && (re += Z.defer), z.animationTimeout = _(() => {
            z.afterAnimate();
          }, re || 0)), z.isDirty = !1, z.hasRendered = !0, u(z, "afterRender");
        }
        redraw() {
          let z = this.isDirty || this.isDirtyData;
          this.translate(), this.render(), z && delete this.kdTree;
        }
        reserveSpace() {
          return this.visible || !this.chart.options.chart.ignoreHiddenSeries;
        }
        searchPoint(z, $) {
          let { xAxis: K, yAxis: Q } = this, Z = this.chart.inverted;
          return this.searchKDTree({ clientX: Z ? K.len - z.chartY + K.pos : z.chartX - K.pos, plotY: Z ? Q.len - z.chartX + Q.pos : z.chartY - Q.pos }, $, z);
        }
        buildKDTree(z) {
          this.buildingKdTree = !0;
          let $ = this, K = $.options.findNearestPointBy.indexOf("y") > -1 ? 2 : 1;
          delete $.kdTree, _(function() {
            $.kdTree = function Q(Z, ee, J) {
              let ae, re, ce = Z == null ? void 0 : Z.length;
              if (ce) return ae = $.kdAxisArray[ee % J], Z.sort((he, ne) => (he[ae] || 0) - (ne[ae] || 0)), { point: Z[re = Math.floor(ce / 2)], left: Q(Z.slice(0, re), ee + 1, J), right: Q(Z.slice(re + 1), ee + 1, J) };
            }($.getValidPoints(void 0, !$.directTouch), K, K), $.buildingKdTree = !1;
          }, $.options.kdNow || (z == null ? void 0 : z.type) === "touchstart" ? 0 : 1);
        }
        searchKDTree(z, $, K) {
          let Q = this, [Z, ee] = this.kdAxisArray, J = $ ? "distX" : "dist", ae = (Q.options.findNearestPointBy || "").indexOf("y") > -1 ? 2 : 1, re = !!Q.isBubble;
          if (this.kdTree || this.buildingKdTree || this.buildKDTree(K), this.kdTree) return function ce(he, ne, te, se) {
            var Ae;
            let oe = ne.point, ie = Q.kdAxisArray[te % se], le, de, be = oe;
            (function(ye, xe) {
              var ht;
              let we = ye[Z], ke = xe[Z], Me = P(we) && P(ke) ? we - ke : null, Te = ye[ee], Ie = xe[ee], He = P(Te) && P(Ie) ? Te - Ie : 0, $e = re && ((ht = xe.marker) == null ? void 0 : ht.radius) || 0;
              xe.dist = Math.sqrt((Me && Me * Me || 0) + He * He) - $e, xe.distX = P(Me) ? Math.abs(Me) - $e : Number.MAX_VALUE;
            })(he, oe);
            let ge = (he[ie] || 0) - (oe[ie] || 0) + (re && ((Ae = oe.marker) == null ? void 0 : Ae.radius) || 0), me = ge < 0 ? "left" : "right", fe = ge < 0 ? "right" : "left";
            return ne[me] && (be = (le = ce(he, ne[me], te + 1, se))[J] < be[J] ? le : oe), ne[fe] && Math.sqrt(ge * ge) < be[J] && (be = (de = ce(he, ne[fe], te + 1, se))[J] < be[J] ? de : be), be;
          }(z, this.kdTree, ae, ae);
        }
        pointPlacementToXValue() {
          let { options: z, xAxis: $ } = this, K = z.pointPlacement;
          return K === "between" && (K = $.reversed ? -0.5 : 0.5), R(K) ? K * (z.pointRange || $.pointRange) : 0;
        }
        isPointInside(z) {
          let { chart: $, xAxis: K, yAxis: Q } = this, { plotX: Z = -1, plotY: ee = -1 } = z;
          return ee >= 0 && ee <= (Q ? Q.len : $.plotHeight) && Z >= 0 && Z <= (K ? K.len : $.plotWidth);
        }
        drawTracker() {
          var ne;
          let z = this, $ = z.options, K = $.trackByArea, Q = [].concat((K ? z.areaPath : z.graphPath) || []), Z = z.chart, ee = Z.pointer, J = Z.renderer, ae = ((ne = Z.options.tooltip) == null ? void 0 : ne.snap) || 0, re = () => {
            $.enableMouseTracking && Z.hoverSeries !== z && z.onMouseOver();
          }, ce = "rgba(192,192,192," + (p ? 1e-4 : 2e-3) + ")", he = z.tracker;
          he ? he.attr({ d: Q }) : z.graph && (z.tracker = he = J.path(Q).attr({ visibility: z.visible ? "inherit" : "hidden", zIndex: 2 }).addClass(K ? "highcharts-tracker-area" : "highcharts-tracker-line").add(z.group), Z.styledMode || he.attr({ "stroke-linecap": "round", "stroke-linejoin": "round", stroke: ce, fill: K ? ce : "none", "stroke-width": z.graph.strokeWidth() + (K ? 0 : 2 * ae) }), [z.tracker, z.markerGroup, z.dataLabelsGroup].forEach((te) => {
            te && (te.addClass("highcharts-tracker").on("mouseover", re).on("mouseout", (se) => {
              ee == null || ee.onTrackerMouseOut(se);
            }), $.cursor && !Z.styledMode && te.css({ cursor: $.cursor }), te.on("touchstart", re));
          })), u(this, "afterDrawTracker");
        }
        addPoint(z, $, K, Q, Z) {
          let ee, J, ae = this.options, re = this.data, ce = this.chart, he = this.xAxis, ne = he && he.hasNames && he.names, te = ae.data, se = this.xData;
          $ = q($, !0);
          let oe = { series: this };
          this.pointClass.prototype.applyOptions.apply(oe, [z]);
          let ie = oe.x;
          if (J = se.length, this.requireSorting && ie < se[J - 1]) for (ee = !0; J && se[J - 1] > ie; ) J--;
          this.updateParallelArrays(oe, "splice", [J, 0, 0]), this.updateParallelArrays(oe, J), ne && oe.name && (ne[ie] = oe.name), te.splice(J, 0, z), (ee || this.processedData) && (this.data.splice(J, 0, null), this.processData()), ae.legendType === "point" && this.generatePoints(), K && (re[0] && re[0].remove ? re[0].remove(!1) : (re.shift(), this.updateParallelArrays(oe, "shift"), te.shift())), Z !== !1 && u(this, "addPoint", { point: oe }), this.isDirty = !0, this.isDirtyData = !0, $ && ce.redraw(Q);
        }
        removePoint(z, $, K) {
          let Q = this, Z = Q.data, ee = Z[z], J = Q.points, ae = Q.chart, re = function() {
            J && J.length === Z.length && J.splice(z, 1), Z.splice(z, 1), Q.options.data.splice(z, 1), Q.updateParallelArrays(ee || { series: Q }, "splice", [z, 1]), ee && ee.destroy(), Q.isDirty = !0, Q.isDirtyData = !0, $ && ae.redraw();
          };
          w(K, ae), $ = q($, !0), ee ? ee.firePointEvent("remove", null, re) : re();
        }
        remove(z, $, K, Q) {
          let Z = this, ee = Z.chart;
          function J() {
            Z.destroy(Q), ee.isDirtyLegend = ee.isDirtyBox = !0, ee.linkSeries(Q), q(z, !0) && ee.redraw($);
          }
          K !== !1 ? u(Z, "remove", null, J) : J();
        }
        update(z, $) {
          var le, de, be, ge, me;
          u(this, "update", { options: z = S(z, this.userOptions) });
          let K = this, Q = K.chart, Z = K.userOptions, ee = K.initialType || K.type, J = Q.options.plotOptions, ae = k[ee].prototype, re = K.finishedAnimating && { animation: !1 }, ce = {}, he, ne, te = ["colorIndex", "eventOptions", "navigatorSeries", "symbolIndex", "baseSeries"], se = z.type || Z.type || Q.options.chart.type, oe = !(this.hasDerivedData || se && se !== this.type || z.pointStart !== void 0 || z.pointInterval !== void 0 || z.relativeXValue !== void 0 || z.joinBy || z.mapData || ["dataGrouping", "pointStart", "pointInterval", "pointIntervalUnit", "keys"].some((fe) => K.hasOptionChanged(fe)));
          se = se || ee, oe && (te.push("data", "isDirtyData", "isDirtyCanvas", "points", "processedData", "processedXData", "processedYData", "xIncrement", "cropped", "_hasPointMarkers", "hasDataLabels", "nodes", "layout", "level", "mapMap", "mapData", "minY", "maxY", "minX", "maxX", "transformGroups"), z.visible !== !1 && te.push("area", "graph"), K.parallelArrays.forEach(function(fe) {
            te.push(fe + "Data");
          }), z.data && (z.dataSorting && l(K.options.dataSorting, z.dataSorting), this.setData(z.data, !1))), z = U(Z, { index: Z.index === void 0 ? K.index : Z.index, pointStart: (ge = (de = (le = J == null ? void 0 : J.series) == null ? void 0 : le.pointStart) != null ? de : Z.pointStart) != null ? ge : (be = K.xData) == null ? void 0 : be[0] }, !oe && { data: K.options.data }, z, re), oe && z.data && (z.data = K.options.data), (te = ["group", "markerGroup", "dataLabelsGroup", "transformGroup"].concat(te)).forEach(function(fe) {
            te[fe] = K[fe], delete K[fe];
          });
          let ie = !1;
          if (k[se]) {
            if (ie = se !== K.type, K.remove(!1, !1, !1, !0), ie)
              if (Q.propFromSeries(), Object.setPrototypeOf) Object.setPrototypeOf(K, k[se].prototype);
              else {
                let fe = Object.hasOwnProperty.call(K, "hcEvents") && K.hcEvents;
                for (ne in ae) K[ne] = void 0;
                l(K, k[se].prototype), fe ? K.hcEvents = fe : delete K.hcEvents;
              }
          } else s(17, !0, Q, { missingModuleFor: se });
          if (te.forEach(function(fe) {
            K[fe] = te[fe];
          }), K.init(Q, z), oe && this.points) for (let fe of ((he = K.options).visible === !1 ? (ce.graphic = 1, ce.dataLabel = 1) : (this.hasMarkerChanged(he, Z) && (ce.graphic = 1), (me = K.hasDataLabels) != null && me.call(K) || (ce.dataLabel = 1)), this.points)) fe && fe.series && (fe.resolveColor(), Object.keys(ce).length && fe.destroyElements(ce), he.showInLegend === !1 && fe.legendItem && Q.legend.destroyItem(fe));
          K.initialType = ee, Q.linkSeries(), Q.setSortedData(), ie && K.linkedSeries.length && (K.isDirtyData = !0), u(this, "afterUpdate"), q($, !0) && Q.redraw(!!oe && void 0);
        }
        setName(z) {
          this.name = this.options.name = this.userOptions.name = z, this.chart.isDirtyLegend = !0;
        }
        hasOptionChanged(z) {
          var J, ae;
          let $ = this.chart, K = this.options[z], Q = $.options.plotOptions, Z = this.userOptions[z], ee = q((J = Q == null ? void 0 : Q[this.type]) == null ? void 0 : J[z], (ae = Q == null ? void 0 : Q.series) == null ? void 0 : ae[z]);
          return Z && !P(ee) ? K !== Z : K !== q(ee, K);
        }
        onMouseOver() {
          let z = this.chart, $ = z.hoverSeries, K = z.pointer;
          K == null || K.setHoverChartIndex(), $ && $ !== this && $.onMouseOut(), this.options.events.mouseOver && u(this, "mouseOver"), this.setState("hover"), z.hoverSeries = this;
        }
        onMouseOut() {
          let z = this.options, $ = this.chart, K = $.tooltip, Q = $.hoverPoint;
          $.hoverSeries = null, Q && Q.onMouseOut(), this && z.events.mouseOut && u(this, "mouseOut"), K && !this.stickyTracking && (!K.shared || this.noSharedTooltip) && K.hide(), $.series.forEach(function(Z) {
            Z.setState("", !0);
          });
        }
        setState(z, $) {
          let K = this, Q = K.options, Z = K.graph, ee = Q.inactiveOtherPoints, J = Q.states, ae = q(J[z || "normal"] && J[z || "normal"].animation, K.chart.options.chart.animation), re = Q.lineWidth, ce = Q.opacity;
          if (z = z || "", K.state !== z && ([K.group, K.markerGroup, K.dataLabelsGroup].forEach(function(he) {
            he && (K.state && he.removeClass("highcharts-series-" + K.state), z && he.addClass("highcharts-series-" + z));
          }), K.state = z, !K.chart.styledMode)) {
            if (J[z] && J[z].enabled === !1) return;
            if (z && (re = J[z].lineWidth || re + (J[z].lineWidthPlus || 0), ce = q(J[z].opacity, ce)), Z && !Z.dashstyle && R(re)) for (let he of [Z, ...this.zones.map((ne) => ne.graph)]) he == null || he.animate({ "stroke-width": re }, ae);
            ee || [K.group, K.markerGroup, K.dataLabelsGroup, K.labelBySeries].forEach(function(he) {
              he && he.animate({ opacity: ce }, ae);
            });
          }
          $ && ee && K.points && K.setAllPointsToState(z || void 0);
        }
        setAllPointsToState(z) {
          this.points.forEach(function($) {
            $.setState && $.setState(z);
          });
        }
        setVisible(z, $) {
          var ae;
          let K = this, Q = K.chart, Z = Q.options.chart.ignoreHiddenSeries, ee = K.visible;
          K.visible = z = K.options.visible = K.userOptions.visible = z === void 0 ? !ee : z;
          let J = z ? "show" : "hide";
          ["group", "dataLabelsGroup", "markerGroup", "tracker", "tt"].forEach((re) => {
            var ce;
            (ce = K[re]) == null || ce[J]();
          }), (Q.hoverSeries === K || ((ae = Q.hoverPoint) == null ? void 0 : ae.series) === K) && K.onMouseOut(), K.legendItem && Q.legend.colorizeItem(K, z), K.isDirty = !0, K.options.stacking && Q.series.forEach((re) => {
            re.options.stacking && re.visible && (re.isDirty = !0);
          }), K.linkedSeries.forEach((re) => {
            re.setVisible(z, !1);
          }), Z && (Q.isDirtyBox = !0), u(K, J), $ !== !1 && Q.redraw();
        }
        show() {
          this.setVisible(!0);
        }
        hide() {
          this.setVisible(!1);
        }
        select(z) {
          this.selected = z = this.options.selected = z === void 0 ? !this.selected : z, this.checkbox && (this.checkbox.checked = z), u(this, z ? "select" : "unselect");
        }
        shouldShowTooltip(z, $, K = {}) {
          return K.series = this, K.visiblePlotOnly = !0, this.chart.isInsidePlot(z, $, K);
        }
        drawLegendSymbol(z, $) {
          var K;
          (K = O[this.options.legendSymbol || "rectangle"]) == null || K.call(this, z, $);
        }
      }
      return W.defaultOptions = D, W.types = F.seriesTypes, W.registerType = F.registerSeriesType, l(W.prototype, { axisTypes: ["xAxis", "yAxis"], coll: "series", colorCounter: 0, directTouch: !1, invertible: !0, isCartesian: !0, kdAxisArray: ["clientX", "plotY"], parallelArrays: ["x", "y"], pointClass: j, requireSorting: !0, sorted: !0 }), F.series = W, W;
    }), a(e, "Core/Legend/Legend.js", [e["Core/Animation/AnimationUtilities.js"], e["Core/Foundation.js"], e["Core/Globals.js"], e["Core/Series/Series.js"], e["Core/Series/Point.js"], e["Core/Renderer/RendererUtilities.js"], e["Core/Templating.js"], e["Core/Utilities.js"]], function(o, n, r, T, O, j, D, F) {
      var B;
      let { animObject: N, setAnimation: f } = o, { registerEventOptions: w } = n, { composed: x, marginNames: M } = r, { distribute: p } = j, { format: v } = D, { addEvent: k, createElement: m, css: A, defined: C, discardElement: H, find: G, fireEvent: P, isNumber: y, merge: S, pick: d, pushUnique: s, relativeLength: l, stableSort: b, syncTimeout: u } = F;
      class c {
        constructor(g, E) {
          this.allItems = [], this.initialItemY = 0, this.itemHeight = 0, this.itemMarginBottom = 0, this.itemMarginTop = 0, this.itemX = 0, this.itemY = 0, this.lastItemY = 0, this.lastLineHeight = 0, this.legendHeight = 0, this.legendWidth = 0, this.maxItemWidth = 0, this.maxLegendWidth = 0, this.offsetWidth = 0, this.padding = 0, this.pages = [], this.symbolHeight = 0, this.symbolWidth = 0, this.titleHeight = 0, this.totalItemWidth = 0, this.widthOption = 0, this.chart = g, this.setOptions(E), E.enabled && (this.render(), w(this, E), k(this.chart, "endResize", function() {
            this.legend.positionCheckboxes();
          })), k(this.chart, "render", () => {
            this.options.enabled && this.proximate && (this.proximatePositions(), this.positionItems());
          });
        }
        setOptions(g) {
          let E = d(g.padding, 8);
          this.options = g, this.chart.styledMode || (this.itemStyle = g.itemStyle, this.itemHiddenStyle = S(this.itemStyle, g.itemHiddenStyle)), this.itemMarginTop = g.itemMarginTop, this.itemMarginBottom = g.itemMarginBottom, this.padding = E, this.initialItemY = E - 5, this.symbolWidth = d(g.symbolWidth, 16), this.pages = [], this.proximate = g.layout === "proximate" && !this.chart.inverted, this.baseline = void 0;
        }
        update(g, E) {
          let R = this.chart;
          this.setOptions(S(!0, this.options, g)), "events" in this.options && w(this, this.options), this.destroy(), R.isDirtyLegend = R.isDirtyBox = !0, d(E, !0) && R.redraw(), P(this, "afterUpdate", { redraw: E });
        }
        colorizeItem(g, E) {
          let { area: R, group: L, label: U, line: V, symbol: q } = g.legendItem || {};
          if (L == null || L[E ? "removeClass" : "addClass"]("highcharts-legend-item-hidden"), !this.chart.styledMode) {
            let { itemHiddenStyle: Y = {} } = this, I = Y.color, { fillColor: _, fillOpacity: W, lineColor: X, marker: z } = g.options, $ = (K) => (!E && (K.fill && (K.fill = I), K.stroke && (K.stroke = I)), K);
            U == null || U.css(S(E ? this.itemStyle : Y)), V == null || V.attr($({ stroke: X || g.color })), q && q.attr($(z && q.isMarker ? g.pointAttribs() : { fill: g.color })), R == null || R.attr($({ fill: _ || g.color, "fill-opacity": _ ? 1 : W != null ? W : 0.75 }));
          }
          P(this, "afterColorizeItem", { item: g, visible: E });
        }
        positionItems() {
          this.allItems.forEach(this.positionItem, this), this.chart.isResizing || this.positionCheckboxes();
        }
        positionItem(g) {
          let { group: E, x: R = 0, y: L = 0 } = g.legendItem || {}, U = this.options, V = U.symbolPadding, q = !U.rtl, Y = g.checkbox;
          if (E && E.element) {
            let I = { translateX: q ? R : this.legendWidth - R - 2 * V - 4, translateY: L };
            E[C(E.translateY) ? "animate" : "attr"](I, void 0, () => {
              P(this, "afterPositionItem", { item: g });
            });
          }
          Y && (Y.x = R, Y.y = L);
        }
        destroyItem(g) {
          let E = g.checkbox, R = g.legendItem || {};
          for (let L of ["group", "label", "line", "symbol"]) R[L] && (R[L] = R[L].destroy());
          E && H(E), g.legendItem = void 0;
        }
        destroy() {
          for (let g of this.getAllItems()) this.destroyItem(g);
          for (let g of ["clipRect", "up", "down", "pager", "nav", "box", "title", "group"]) this[g] && (this[g] = this[g].destroy());
          this.display = null;
        }
        positionCheckboxes() {
          let g, E = this.group && this.group.alignAttr, R = this.clipHeight || this.legendHeight, L = this.titleHeight;
          E && (g = E.translateY, this.allItems.forEach(function(U) {
            let V, q = U.checkbox;
            q && (V = g + L + q.y + (this.scrollOffset || 0) + 3, A(q, { left: E.translateX + U.checkboxOffset + q.x - 20 + "px", top: V + "px", display: this.proximate || V > g - 6 && V < g + R - 6 ? "" : "none" }));
          }, this));
        }
        renderTitle() {
          let g = this.options, E = this.padding, R = g.title, L, U = 0;
          R.text && (this.title || (this.title = this.chart.renderer.label(R.text, E - 3, E - 4, void 0, void 0, void 0, g.useHTML, void 0, "legend-title").attr({ zIndex: 1 }), this.chart.styledMode || this.title.css(R.style), this.title.add(this.group)), R.width || this.title.css({ width: this.maxLegendWidth + "px" }), U = (L = this.title.getBBox()).height, this.offsetWidth = L.width, this.contentGroup.attr({ translateY: U })), this.titleHeight = U;
        }
        setText(g) {
          let E = this.options;
          g.legendItem.label.attr({ text: E.labelFormat ? v(E.labelFormat, g, this.chart) : E.labelFormatter.call(g) });
        }
        renderItem(g) {
          let E = g.legendItem = g.legendItem || {}, R = this.chart, L = R.renderer, U = this.options, V = U.layout === "horizontal", q = this.symbolWidth, Y = U.symbolPadding || 0, I = this.itemStyle, _ = this.itemHiddenStyle, W = V ? d(U.itemDistance, 20) : 0, X = !U.rtl, z = !g.series, $ = !z && g.series.drawLegendSymbol ? g.series : g, K = $.options, Q = !!this.createCheckboxForItem && K && K.showCheckbox, Z = U.useHTML, ee = g.options.className, J = E.label, ae = q + Y + W + (Q ? 20 : 0);
          !J && (E.group = L.g("legend-item").addClass("highcharts-" + $.type + "-series highcharts-color-" + g.colorIndex + (ee ? " " + ee : "") + (z ? " highcharts-series-" + g.index : "")).attr({ zIndex: 1 }).add(this.scrollGroup), E.label = J = L.text("", X ? q + Y : -Y, this.baseline || 0, Z), R.styledMode || J.css(S(g.visible ? I : _)), J.attr({ align: X ? "left" : "right", zIndex: 2 }).add(E.group), !this.baseline && (this.fontMetrics = L.fontMetrics(J), this.baseline = this.fontMetrics.f + 3 + this.itemMarginTop, J.attr("y", this.baseline), this.symbolHeight = d(U.symbolHeight, this.fontMetrics.f), U.squareSymbol && (this.symbolWidth = d(U.symbolWidth, Math.max(this.symbolHeight, 16)), ae = this.symbolWidth + Y + W + (Q ? 20 : 0), X && J.attr("x", this.symbolWidth + Y))), $.drawLegendSymbol(this, g), this.setItemEvents && this.setItemEvents(g, J, Z)), Q && !g.checkbox && this.createCheckboxForItem && this.createCheckboxForItem(g), this.colorizeItem(g, g.visible), (R.styledMode || !I.width) && J.css({ width: (U.itemWidth || this.widthOption || R.spacingBox.width) - ae + "px" }), this.setText(g);
          let re = J.getBBox(), ce = this.fontMetrics && this.fontMetrics.h || 0;
          g.itemWidth = g.checkboxOffset = U.itemWidth || E.labelWidth || re.width + ae, this.maxItemWidth = Math.max(this.maxItemWidth, g.itemWidth), this.totalItemWidth += g.itemWidth, this.itemHeight = g.itemHeight = Math.round(E.labelHeight || (re.height > 1.5 * ce ? re.height : ce));
        }
        layoutItem(g) {
          let E = this.options, R = this.padding, L = E.layout === "horizontal", U = g.itemHeight, V = this.itemMarginBottom, q = this.itemMarginTop, Y = L ? d(E.itemDistance, 20) : 0, I = this.maxLegendWidth, _ = E.alignColumns && this.totalItemWidth > I ? this.maxItemWidth : g.itemWidth, W = g.legendItem || {};
          L && this.itemX - R + _ > I && (this.itemX = R, this.lastLineHeight && (this.itemY += q + this.lastLineHeight + V), this.lastLineHeight = 0), this.lastItemY = q + this.itemY + V, this.lastLineHeight = Math.max(U, this.lastLineHeight), W.x = this.itemX, W.y = this.itemY, L ? this.itemX += _ : (this.itemY += q + U + V, this.lastLineHeight = U), this.offsetWidth = this.widthOption || Math.max((L ? this.itemX - R - (g.checkbox ? 0 : Y) : _) + R, this.offsetWidth);
        }
        getAllItems() {
          let g = [];
          return this.chart.series.forEach(function(E) {
            let R = E && E.options;
            E && d(R.showInLegend, !C(R.linkedTo) && void 0, !0) && (g = g.concat((E.legendItem || {}).labels || (R.legendType === "point" ? E.data : E)));
          }), P(this, "afterGetAllItems", { allItems: g }), g;
        }
        getAlignment() {
          let g = this.options;
          return this.proximate ? g.align.charAt(0) + "tv" : g.floating ? "" : g.align.charAt(0) + g.verticalAlign.charAt(0) + g.layout.charAt(0);
        }
        adjustMargins(g, E) {
          let R = this.chart, L = this.options, U = this.getAlignment();
          U && [/(lth|ct|rth)/, /(rtv|rm|rbv)/, /(rbh|cb|lbh)/, /(lbv|lm|ltv)/].forEach(function(V, q) {
            V.test(U) && !C(g[q]) && (R[M[q]] = Math.max(R[M[q]], R.legend[(q + 1) % 2 ? "legendHeight" : "legendWidth"] + [1, -1, -1, 1][q] * L[q % 2 ? "x" : "y"] + d(L.margin, 12) + E[q] + (R.titleOffset[q] || 0)));
          });
        }
        proximatePositions() {
          let g, E = this.chart, R = [], L = this.options.align === "left";
          for (let U of (this.allItems.forEach(function(V) {
            let q, Y, I = L, _, W;
            V.yAxis && (V.xAxis.options.reversed && (I = !I), V.points && (q = G(I ? V.points : V.points.slice(0).reverse(), function(X) {
              return y(X.plotY);
            })), Y = this.itemMarginTop + V.legendItem.label.getBBox().height + this.itemMarginBottom, W = V.yAxis.top - E.plotTop, _ = V.visible ? (q ? q.plotY : V.yAxis.height) + (W - 0.3 * Y) : W + V.yAxis.height, R.push({ target: _, size: Y, item: V }));
          }, this), p(R, E.plotHeight))) g = U.item.legendItem || {}, y(U.pos) && (g.y = E.plotTop - E.spacing[0] + U.pos);
        }
        render() {
          let g = this.chart, E = g.renderer, R = this.options, L = this.padding, U = this.getAllItems(), V, q, Y, I = this.group, _, W = this.box;
          this.itemX = L, this.itemY = this.initialItemY, this.offsetWidth = 0, this.lastItemY = 0, this.widthOption = l(R.width, g.spacingBox.width - L), _ = g.spacingBox.width - 2 * L - R.x, ["rm", "lm"].indexOf(this.getAlignment().substring(0, 2)) > -1 && (_ /= 2), this.maxLegendWidth = this.widthOption || _, I || (this.group = I = E.g("legend").addClass(R.className || "").attr({ zIndex: 7 }).add(), this.contentGroup = E.g().attr({ zIndex: 1 }).add(I), this.scrollGroup = E.g().add(this.contentGroup)), this.renderTitle(), b(U, (X, z) => (X.options && X.options.legendIndex || 0) - (z.options && z.options.legendIndex || 0)), R.reversed && U.reverse(), this.allItems = U, this.display = V = !!U.length, this.lastLineHeight = 0, this.maxItemWidth = 0, this.totalItemWidth = 0, this.itemHeight = 0, U.forEach(this.renderItem, this), U.forEach(this.layoutItem, this), q = (this.widthOption || this.offsetWidth) + L, Y = this.lastItemY + this.lastLineHeight + this.titleHeight, Y = this.handleOverflow(Y) + L, W || (this.box = W = E.rect().addClass("highcharts-legend-box").attr({ r: R.borderRadius }).add(I)), g.styledMode || W.attr({ stroke: R.borderColor, "stroke-width": R.borderWidth || 0, fill: R.backgroundColor || "none" }).shadow(R.shadow), q > 0 && Y > 0 && W[W.placed ? "animate" : "attr"](W.crisp.call({}, { x: 0, y: 0, width: q, height: Y }, W.strokeWidth())), I[V ? "show" : "hide"](), g.styledMode && I.getStyle("display") === "none" && (q = Y = 0), this.legendWidth = q, this.legendHeight = Y, V && this.align(), this.proximate || this.positionItems(), P(this, "afterRender");
        }
        align(g = this.chart.spacingBox) {
          let E = this.chart, R = this.options, L = g.y;
          /(lth|ct|rth)/.test(this.getAlignment()) && E.titleOffset[0] > 0 ? L += E.titleOffset[0] : /(lbh|cb|rbh)/.test(this.getAlignment()) && E.titleOffset[2] > 0 && (L -= E.titleOffset[2]), L !== g.y && (g = S(g, { y: L })), E.hasRendered || (this.group.placed = !1), this.group.align(S(R, { width: this.legendWidth, height: this.legendHeight, verticalAlign: this.proximate ? "top" : R.verticalAlign }), !0, g);
        }
        handleOverflow(g) {
          let E = this, R = this.chart, L = R.renderer, U = this.options, V = U.y, q = U.verticalAlign === "top", Y = this.padding, I = U.maxHeight, _ = U.navigation, W = d(_.animation, !0), X = _.arrowSize || 12, z = this.pages, $ = this.allItems, K = function(he) {
            typeof he == "number" ? ce.attr({ height: he }) : ce && (E.clipRect = ce.destroy(), E.contentGroup.clip()), E.contentGroup.div && (E.contentGroup.div.style.clip = he ? "rect(" + Y + "px,9999px," + (Y + he) + "px,0)" : "auto");
          }, Q = function(he) {
            return E[he] = L.circle(0, 0, 1.3 * X).translate(X / 2, X / 2).add(re), R.styledMode || E[he].attr("fill", "rgba(0,0,0,0.0001)"), E[he];
          }, Z, ee, J, ae = R.spacingBox.height + (q ? -V : V) - Y, re = this.nav, ce = this.clipRect;
          return U.layout !== "horizontal" || U.verticalAlign === "middle" || U.floating || (ae /= 2), I && (ae = Math.min(ae, I)), z.length = 0, g && ae > 0 && g > ae && _.enabled !== !1 ? (this.clipHeight = Z = Math.max(ae - 20 - this.titleHeight - Y, 0), this.currentPage = d(this.currentPage, 1), this.fullHeight = g, $.forEach((he, ne) => {
            let te = (J = he.legendItem || {}).y || 0, se = Math.round(J.label.getBBox().height), oe = z.length;
            (!oe || te - z[oe - 1] > Z && (ee || te) !== z[oe - 1]) && (z.push(ee || te), oe++), J.pageIx = oe - 1, ee && (($[ne - 1].legendItem || {}).pageIx = oe - 1), ne === $.length - 1 && te + se - z[oe - 1] > Z && te > z[oe - 1] && (z.push(te), J.pageIx = oe), te !== ee && (ee = te);
          }), ce || (ce = E.clipRect = L.clipRect(0, Y - 2, 9999, 0), E.contentGroup.clip(ce)), K(Z), re || (this.nav = re = L.g().attr({ zIndex: 1 }).add(this.group), this.up = L.symbol("triangle", 0, 0, X, X).add(re), Q("upTracker").on("click", function() {
            E.scroll(-1, W);
          }), this.pager = L.text("", 15, 10).addClass("highcharts-legend-navigation"), !R.styledMode && _.style && this.pager.css(_.style), this.pager.add(re), this.down = L.symbol("triangle-down", 0, 0, X, X).add(re), Q("downTracker").on("click", function() {
            E.scroll(1, W);
          })), E.scroll(0), g = ae) : re && (K(), this.nav = re.destroy(), this.scrollGroup.attr({ translateY: 1 }), this.clipHeight = 0), g;
        }
        scroll(g, E) {
          let R = this.chart, L = this.pages, U = L.length, V = this.clipHeight, q = this.options.navigation, Y = this.pager, I = this.padding, _ = this.currentPage + g;
          _ > U && (_ = U), _ > 0 && (E !== void 0 && f(E, R), this.nav.attr({ translateX: I, translateY: V + this.padding + 7 + this.titleHeight, visibility: "inherit" }), [this.up, this.upTracker].forEach(function(W) {
            W.attr({ class: _ === 1 ? "highcharts-legend-nav-inactive" : "highcharts-legend-nav-active" });
          }), Y.attr({ text: _ + "/" + U }), [this.down, this.downTracker].forEach(function(W) {
            W.attr({ x: 18 + this.pager.getBBox().width, class: _ === U ? "highcharts-legend-nav-inactive" : "highcharts-legend-nav-active" });
          }, this), R.styledMode || (this.up.attr({ fill: _ === 1 ? q.inactiveColor : q.activeColor }), this.upTracker.css({ cursor: _ === 1 ? "default" : "pointer" }), this.down.attr({ fill: _ === U ? q.inactiveColor : q.activeColor }), this.downTracker.css({ cursor: _ === U ? "default" : "pointer" })), this.scrollOffset = -L[_ - 1] + this.initialItemY, this.scrollGroup.animate({ translateY: this.scrollOffset }), this.currentPage = _, this.positionCheckboxes(), u(() => {
            P(this, "afterScroll", { currentPage: _ });
          }, N(d(E, R.renderer.globalAnimation, !0)).duration));
        }
        setItemEvents(g, E, R) {
          let L = this, U = g.legendItem || {}, V = L.chart.renderer.boxWrapper, q = g instanceof O, Y = g instanceof T, I = "highcharts-legend-" + (q ? "point" : "series") + "-active", _ = L.chart.styledMode, W = R ? [E, U.symbol] : [U.group], X = (z) => {
            L.allItems.forEach(($) => {
              g !== $ && [$].concat($.linkedSeries || []).forEach((K) => {
                K.setState(z, !q);
              });
            });
          };
          for (let z of W) z && z.on("mouseover", function() {
            g.visible && X("inactive"), g.setState("hover"), g.visible && V.addClass(I), _ || E.css(L.options.itemHoverStyle);
          }).on("mouseout", function() {
            L.chart.styledMode || E.css(S(g.visible ? L.itemStyle : L.itemHiddenStyle)), X(""), V.removeClass(I), g.setState();
          }).on("click", function($) {
            let K = function() {
              g.setVisible && g.setVisible(), X(g.visible ? "inactive" : "");
            };
            V.removeClass(I), P(L, "itemClick", { browserEvent: $, legendItem: g }, K), q ? g.firePointEvent("legendItemClick", { browserEvent: $ }) : Y && P(g, "legendItemClick", { browserEvent: $ });
          });
        }
        createCheckboxForItem(g) {
          g.checkbox = m("input", { type: "checkbox", className: "highcharts-legend-checkbox", checked: g.selected, defaultChecked: g.selected }, this.options.itemCheckboxStyle, this.chart.container), k(g.checkbox, "click", function(E) {
            let R = E.target;
            P(g.series || g, "checkboxClick", { checked: R.checked, item: g }, function() {
              g.select();
            });
          });
        }
      }
      return (B = c || (c = {})).compose = function(h) {
        s(x, "Core.Legend") && k(h, "beforeMargins", function() {
          this.legend = new B(this, this.options.legend);
        });
      }, c;
    }), a(e, "Core/Chart/Chart.js", [e["Core/Animation/AnimationUtilities.js"], e["Core/Axis/Axis.js"], e["Core/Defaults.js"], e["Core/Templating.js"], e["Core/Foundation.js"], e["Core/Globals.js"], e["Core/Renderer/RendererRegistry.js"], e["Core/Series/Series.js"], e["Core/Series/SeriesRegistry.js"], e["Core/Renderer/SVG/SVGRenderer.js"], e["Core/Time.js"], e["Core/Utilities.js"], e["Core/Renderer/HTML/AST.js"], e["Core/Axis/Tick.js"]], function(o, n, r, T, O, j, D, F, B, N, f, w, x, M) {
      let { animate: p, animObject: v, setAnimation: k } = o, { defaultOptions: m, defaultTime: A } = r, { numberFormat: C } = T, { registerEventOptions: H } = O, { charts: G, doc: P, marginNames: y, svg: S, win: d } = j, { seriesTypes: s } = B, { addEvent: l, attr: b, createElement: u, css: c, defined: h, diffObjects: g, discardElement: E, erase: R, error: L, extend: U, find: V, fireEvent: q, getStyle: Y, isArray: I, isNumber: _, isObject: W, isString: X, merge: z, objectEach: $, pick: K, pInt: Q, relativeLength: Z, removeEvent: ee, splat: J, syncTimeout: ae, uniqueKey: re } = w;
      class ce {
        static chart(ne, te, se) {
          return new ce(ne, te, se);
        }
        constructor(ne, te, se) {
          this.sharedClips = {};
          let oe = [...arguments];
          (X(ne) || ne.nodeName) && (this.renderTo = oe.shift()), this.init(oe[0], oe[1]);
        }
        setZoomOptions() {
          let ne = this.options.chart, te = ne.zooming;
          this.zooming = { ...te, type: K(ne.zoomType, te.type), key: K(ne.zoomKey, te.key), pinchType: K(ne.pinchType, te.pinchType), singleTouch: K(ne.zoomBySingleTouch, te.singleTouch, !1), resetButton: z(te.resetButton, ne.resetZoomButton) };
        }
        init(ne, te) {
          q(this, "init", { args: arguments }, function() {
            let se = z(m, ne), oe = se.chart;
            this.userOptions = U({}, ne), this.margin = [], this.spacing = [], this.labelCollectors = [], this.callback = te, this.isResizing = 0, this.options = se, this.axes = [], this.series = [], this.time = ne.time && Object.keys(ne.time).length ? new f(ne.time) : j.time, this.numberFormatter = oe.numberFormatter || C, this.styledMode = oe.styledMode, this.hasCartesianSeries = oe.showAxes, this.index = G.length, G.push(this), j.chartCount++, H(this, oe), this.xAxis = [], this.yAxis = [], this.pointCount = this.colorCounter = this.symbolCounter = 0, this.setZoomOptions(), q(this, "afterInit"), this.firstRender();
          });
        }
        initSeries(ne) {
          let te = this.options.chart, se = ne.type || te.type, oe = s[se];
          oe || L(17, !0, this, { missingModuleFor: se });
          let ie = new oe();
          return typeof ie.init == "function" && ie.init(this, ne), ie;
        }
        setSortedData() {
          this.getSeriesOrderByLinks().forEach(function(ne) {
            ne.points || ne.data || !ne.enabledDataSorting || ne.setData(ne.options.data, !1);
          });
        }
        getSeriesOrderByLinks() {
          return this.series.concat().sort(function(ne, te) {
            return ne.linkedSeries.length || te.linkedSeries.length ? te.linkedSeries.length - ne.linkedSeries.length : 0;
          });
        }
        orderItems(ne, te = 0) {
          let se = this[ne], oe = this.options[ne] = J(this.options[ne]).slice(), ie = this.userOptions[ne] = this.userOptions[ne] ? J(this.userOptions[ne]).slice() : [];
          if (this.hasRendered && (oe.splice(te), ie.splice(te)), se) for (let le = te, de = se.length; le < de; ++le) {
            let be = se[le];
            be && (be.index = le, be instanceof F && (be.name = be.getName()), be.options.isInternal || (oe[le] = be.options, ie[le] = be.userOptions));
          }
        }
        isInsidePlot(ne, te, se = {}) {
          var ke;
          let { inverted: oe, plotBox: ie, plotLeft: le, plotTop: de, scrollablePlotBox: be } = this, { scrollLeft: ge = 0, scrollTop: me = 0 } = se.visiblePlotOnly && ((ke = this.scrollablePlotArea) == null ? void 0 : ke.scrollingContainer) || {}, fe = se.series, Ae = se.visiblePlotOnly && be || ie, ye = se.inverted ? te : ne, xe = se.inverted ? ne : te, we = { x: ye, y: xe, isInsidePlot: !0, options: se };
          if (!se.ignoreX) {
            let Me = fe && (oe && !this.polar ? fe.yAxis : fe.xAxis) || { pos: le, len: 1 / 0 }, Te = se.paneCoordinates ? Me.pos + ye : le + ye;
            Te >= Math.max(ge + le, Me.pos) && Te <= Math.min(ge + le + Ae.width, Me.pos + Me.len) || (we.isInsidePlot = !1);
          }
          if (!se.ignoreY && we.isInsidePlot) {
            let Me = !oe && se.axis && !se.axis.isXAxis && se.axis || fe && (oe ? fe.xAxis : fe.yAxis) || { pos: de, len: 1 / 0 }, Te = se.paneCoordinates ? Me.pos + xe : de + xe;
            Te >= Math.max(me + de, Me.pos) && Te <= Math.min(me + de + Ae.height, Me.pos + Me.len) || (we.isInsidePlot = !1);
          }
          return q(this, "afterIsInsidePlot", we), we.isInsidePlot;
        }
        redraw(ne) {
          q(this, "beforeRedraw");
          let te = this.hasCartesianSeries ? this.axes : this.colorAxis || [], se = this.series, oe = this.pointer, ie = this.legend, le = this.userOptions.legend, de = this.renderer, be = de.isHidden(), ge = [], me, fe, Ae, ye = this.isDirtyBox, xe = this.isDirtyLegend, we;
          for (de.rootFontSize = de.boxWrapper.getStyle("font-size"), this.setResponsive && this.setResponsive(!1), k(!!this.hasRendered && ne, this), be && this.temporaryDisplay(), this.layOutTitles(!1), Ae = se.length; Ae--; ) if (((we = se[Ae]).options.stacking || we.options.centerInCategory) && (fe = !0, we.isDirty)) {
            me = !0;
            break;
          }
          if (me) for (Ae = se.length; Ae--; ) (we = se[Ae]).options.stacking && (we.isDirty = !0);
          se.forEach(function(ke) {
            ke.isDirty && (ke.options.legendType === "point" ? (typeof ke.updateTotals == "function" && ke.updateTotals(), xe = !0) : le && (le.labelFormatter || le.labelFormat) && (xe = !0)), ke.isDirtyData && q(ke, "updatedData");
          }), xe && ie && ie.options.enabled && (ie.render(), this.isDirtyLegend = !1), fe && this.getStacks(), te.forEach(function(ke) {
            ke.updateNames(), ke.setScale();
          }), this.getMargins(), te.forEach(function(ke) {
            ke.isDirty && (ye = !0);
          }), te.forEach(function(ke) {
            let Me = ke.min + "," + ke.max;
            ke.extKey !== Me && (ke.extKey = Me, ge.push(function() {
              q(ke, "afterSetExtremes", U(ke.eventArgs, ke.getExtremes())), delete ke.eventArgs;
            })), (ye || fe) && ke.redraw();
          }), ye && this.drawChartBox(), q(this, "predraw"), se.forEach(function(ke) {
            (ye || ke.isDirty) && ke.visible && ke.redraw(), ke.isDirtyData = !1;
          }), oe && oe.reset(!0), de.draw(), q(this, "redraw"), q(this, "render"), be && this.temporaryDisplay(!0), ge.forEach(function(ke) {
            ke.call();
          });
        }
        get(ne) {
          let te = this.series;
          function se(ie) {
            return ie.id === ne || ie.options && ie.options.id === ne;
          }
          let oe = V(this.axes, se) || V(this.series, se);
          for (let ie = 0; !oe && ie < te.length; ie++) oe = V(te[ie].points || [], se);
          return oe;
        }
        getAxes() {
          let ne = this.userOptions;
          for (let te of (q(this, "getAxes"), ["xAxis", "yAxis"])) for (let se of ne[te] = J(ne[te] || {})) new n(this, se, te);
          q(this, "afterGetAxes");
        }
        getSelectedPoints() {
          return this.series.reduce((ne, te) => (te.getPointsCollection().forEach((se) => {
            K(se.selectedStaging, se.selected) && ne.push(se);
          }), ne), []);
        }
        getSelectedSeries() {
          return this.series.filter(function(ne) {
            return ne.selected;
          });
        }
        setTitle(ne, te, se) {
          this.applyDescription("title", ne), this.applyDescription("subtitle", te), this.applyDescription("caption", void 0), this.layOutTitles(se);
        }
        applyDescription(ne, te) {
          let se = this, oe = this.options[ne] = z(this.options[ne], te), ie = this[ne];
          ie && te && (this[ne] = ie = ie.destroy()), oe && !ie && ((ie = this.renderer.text(oe.text, 0, 0, oe.useHTML).attr({ align: oe.align, class: "highcharts-" + ne, zIndex: oe.zIndex || 4 }).add()).update = function(le, de) {
            se.applyDescription(ne, le), se.layOutTitles(de);
          }, this.styledMode || ie.css(U(ne === "title" ? { fontSize: this.options.isStock ? "1em" : "1.2em" } : {}, oe.style)), this[ne] = ie);
        }
        layOutTitles(ne = !0) {
          let te = [0, 0, 0], se = this.renderer, oe = this.spacingBox;
          ["title", "subtitle", "caption"].forEach(function(le) {
            let de = this[le], be = this.options[le], ge = be.verticalAlign || "top", me = le === "title" ? ge === "top" ? -3 : 0 : ge === "top" ? te[0] + 2 : 0;
            if (de) {
              de.css({ width: (be.width || oe.width + (be.widthAdjust || 0)) + "px" });
              let fe = se.fontMetrics(de).b, Ae = Math.round(de.getBBox(be.useHTML).height);
              de.align(U({ y: ge === "bottom" ? fe : me + fe, height: Ae }, be), !1, "spacingBox"), be.floating || (ge === "top" ? te[0] = Math.ceil(te[0] + Ae) : ge === "bottom" && (te[2] = Math.ceil(te[2] + Ae)));
            }
          }, this), te[0] && (this.options.title.verticalAlign || "top") === "top" && (te[0] += this.options.title.margin), te[2] && this.options.caption.verticalAlign === "bottom" && (te[2] += this.options.caption.margin);
          let ie = !this.titleOffset || this.titleOffset.join(",") !== te.join(",");
          this.titleOffset = te, q(this, "afterLayOutTitles"), !this.isDirtyBox && ie && (this.isDirtyBox = this.isDirtyLegend = ie, this.hasRendered && ne && this.isDirtyBox && this.redraw());
        }
        getContainerBox() {
          let ne = [].map.call(this.renderTo.children, (se) => {
            if (se !== this.container) {
              let oe = se.style.display;
              return se.style.display = "none", [se, oe];
            }
          }), te = { width: Y(this.renderTo, "width", !0) || 0, height: Y(this.renderTo, "height", !0) || 0 };
          return ne.filter(Boolean).forEach(([se, oe]) => {
            se.style.display = oe;
          }), te;
        }
        getChartSize() {
          var le;
          let ne = this.options.chart, te = ne.width, se = ne.height, oe = this.getContainerBox(), ie = oe.height > 1 && !(!((le = this.renderTo.parentElement) != null && le.style.height) && this.renderTo.style.height === "100%");
          this.chartWidth = Math.max(0, te || oe.width || 600), this.chartHeight = Math.max(0, Z(se, this.chartWidth) || (ie ? oe.height : 400)), this.containerBox = oe;
        }
        temporaryDisplay(ne) {
          let te = this.renderTo, se;
          if (ne) for (; te && te.style; ) te.hcOrigStyle && (c(te, te.hcOrigStyle), delete te.hcOrigStyle), te.hcOrigDetached && (P.body.removeChild(te), te.hcOrigDetached = !1), te = te.parentNode;
          else for (; te && te.style && (P.body.contains(te) || te.parentNode || (te.hcOrigDetached = !0, P.body.appendChild(te)), (Y(te, "display", !1) === "none" || te.hcOricDetached) && (te.hcOrigStyle = { display: te.style.display, height: te.style.height, overflow: te.style.overflow }, se = { display: "block", overflow: "hidden" }, te !== this.renderTo && (se.height = 0), c(te, se), te.offsetWidth || te.style.setProperty("display", "block", "important")), (te = te.parentNode) !== P.body); ) ;
        }
        setClassName(ne) {
          this.container.className = "highcharts-container " + (ne || "");
        }
        getContainer() {
          var Ae;
          let ne = this.options, te = ne.chart, se = "data-highcharts-chart", oe = re(), ie, le = this.renderTo;
          le || (this.renderTo = le = te.renderTo), X(le) && (this.renderTo = le = P.getElementById(le)), le || L(13, !0, this);
          let de = Q(b(le, se));
          _(de) && G[de] && G[de].hasRendered && G[de].destroy(), b(le, se, this.index), le.innerHTML = x.emptyHTML, te.skipClone || le.offsetWidth || this.temporaryDisplay(), this.getChartSize();
          let be = this.chartHeight, ge = this.chartWidth;
          c(le, { overflow: "hidden" }), this.styledMode || (ie = U({ position: "relative", overflow: "hidden", width: ge + "px", height: be + "px", textAlign: "left", lineHeight: "normal", zIndex: 0, "-webkit-tap-highlight-color": "rgba(0,0,0,0)", userSelect: "none", "touch-action": "manipulation", outline: "none", padding: "0px" }, te.style || {}));
          let me = u("div", { id: oe }, ie, le);
          this.container = me, this.getChartSize(), ge === this.chartWidth || (ge = this.chartWidth, this.styledMode || c(me, { width: K((Ae = te.style) == null ? void 0 : Ae.width, ge + "px") })), this.containerBox = this.getContainerBox(), this._cursor = me.style.cursor;
          let fe = te.renderer || !S ? D.getRendererType(te.renderer) : N;
          if (this.renderer = new fe(me, ge, be, void 0, te.forExport, ne.exporting && ne.exporting.allowHTML, this.styledMode), k(void 0, this), this.setClassName(te.className), this.styledMode) for (let ye in ne.defs) this.renderer.definition(ne.defs[ye]);
          else this.renderer.setStyle(te.style);
          this.renderer.chartIndex = this.index, q(this, "afterGetContainer");
        }
        getMargins(ne) {
          let { spacing: te, margin: se, titleOffset: oe } = this;
          this.resetMargins(), oe[0] && !h(se[0]) && (this.plotTop = Math.max(this.plotTop, oe[0] + te[0])), oe[2] && !h(se[2]) && (this.marginBottom = Math.max(this.marginBottom, oe[2] + te[2])), this.legend && this.legend.display && this.legend.adjustMargins(se, te), q(this, "getMargins"), ne || this.getAxisMargins();
        }
        getAxisMargins() {
          let ne = this, te = ne.axisOffset = [0, 0, 0, 0], se = ne.colorAxis, oe = ne.margin, ie = function(le) {
            le.forEach(function(de) {
              de.visible && de.getOffset();
            });
          };
          ne.hasCartesianSeries ? ie(ne.axes) : se && se.length && ie(se), y.forEach(function(le, de) {
            h(oe[de]) || (ne[le] += te[de]);
          }), ne.setChartSize();
        }
        getOptions() {
          return g(this.userOptions, m);
        }
        reflow(ne) {
          var ie;
          let te = this, se = te.containerBox, oe = te.getContainerBox();
          (ie = te.pointer) == null || delete ie.chartPosition, !te.isPrinting && !te.isResizing && se && oe.width && ((oe.width !== se.width || oe.height !== se.height) && (w.clearTimeout(te.reflowTimeout), te.reflowTimeout = ae(function() {
            te.container && te.setSize(void 0, void 0, !1);
          }, ne ? 100 : 0)), te.containerBox = oe);
        }
        setReflow() {
          let ne = this, te = (se) => {
            var oe;
            (oe = ne.options) != null && oe.chart.reflow && ne.hasLoaded && ne.reflow(se);
          };
          if (typeof ResizeObserver == "function") new ResizeObserver(te).observe(ne.renderTo);
          else {
            let se = l(d, "resize", te);
            l(this, "destroy", se);
          }
        }
        setSize(ne, te, se) {
          let oe = this, ie = oe.renderer;
          oe.isResizing += 1, k(se, oe);
          let le = ie.globalAnimation;
          oe.oldChartHeight = oe.chartHeight, oe.oldChartWidth = oe.chartWidth, ne !== void 0 && (oe.options.chart.width = ne), te !== void 0 && (oe.options.chart.height = te), oe.getChartSize();
          let { chartWidth: de, chartHeight: be, scrollablePixelsX: ge = 0, scrollablePixelsY: me = 0 } = oe;
          (oe.isDirtyBox || de !== oe.oldChartWidth || be !== oe.oldChartHeight) && (oe.styledMode || (le ? p : c)(oe.container, { width: `${de + ge}px`, height: `${be + me}px` }, le), oe.setChartSize(!0), ie.setSize(de, be, le), oe.axes.forEach(function(fe) {
            fe.isDirty = !0, fe.setScale();
          }), oe.isDirtyLegend = !0, oe.isDirtyBox = !0, oe.layOutTitles(), oe.getMargins(), oe.redraw(le), oe.oldChartHeight = void 0, q(oe, "resize"), setTimeout(() => {
            oe && q(oe, "endResize");
          }, v(le).duration)), oe.isResizing -= 1;
        }
        setChartSize(ne) {
          let te, se, oe, ie, { chartHeight: le, chartWidth: de, inverted: be, spacing: ge, renderer: me } = this, fe = this.clipOffset, Ae = Math[be ? "floor" : "round"];
          this.plotLeft = te = Math.round(this.plotLeft), this.plotTop = se = Math.round(this.plotTop), this.plotWidth = oe = Math.max(0, Math.round(de - te - this.marginRight)), this.plotHeight = ie = Math.max(0, Math.round(le - se - this.marginBottom)), this.plotSizeX = be ? ie : oe, this.plotSizeY = be ? oe : ie, this.spacingBox = me.spacingBox = { x: ge[3], y: ge[0], width: de - ge[3] - ge[1], height: le - ge[0] - ge[2] }, this.plotBox = me.plotBox = { x: te, y: se, width: oe, height: ie }, fe && (this.clipBox = { x: Ae(fe[3]), y: Ae(fe[0]), width: Ae(this.plotSizeX - fe[1] - fe[3]), height: Ae(this.plotSizeY - fe[0] - fe[2]) }), ne || (this.axes.forEach(function(ye) {
            ye.setAxisSize(), ye.setAxisTranslation();
          }), me.alignElements()), q(this, "afterSetChartSize", { skipAxes: ne });
        }
        resetMargins() {
          q(this, "resetMargins");
          let ne = this, te = ne.options.chart, se = te.plotBorderWidth || 0, oe = se / 2;
          ["margin", "spacing"].forEach(function(ie) {
            let le = te[ie], de = W(le) ? le : [le, le, le, le];
            ["Top", "Right", "Bottom", "Left"].forEach(function(be, ge) {
              ne[ie][ge] = K(te[ie + be], de[ge]);
            });
          }), y.forEach(function(ie, le) {
            ne[ie] = K(ne.margin[le], ne.spacing[le]);
          }), ne.axisOffset = [0, 0, 0, 0], ne.clipOffset = [oe, oe, oe, oe], ne.plotBorderWidth = se;
        }
        drawChartBox() {
          let ne = this.options.chart, te = this.renderer, se = this.chartWidth, oe = this.chartHeight, ie = this.styledMode, le = this.plotBGImage, de = ne.backgroundColor, be = ne.plotBackgroundColor, ge = ne.plotBackgroundImage, me = this.plotLeft, fe = this.plotTop, Ae = this.plotWidth, ye = this.plotHeight, xe = this.plotBox, we = this.clipRect, ke = this.clipBox, Me = this.chartBackground, Te = this.plotBackground, Ie = this.plotBorder, He, $e, ht, At = "animate";
          Me || (this.chartBackground = Me = te.rect().addClass("highcharts-background").add(), At = "attr"), ie ? He = $e = Me.strokeWidth() : ($e = (He = ne.borderWidth || 0) + (ne.shadow ? 8 : 0), ht = { fill: de || "none" }, (He || Me["stroke-width"]) && (ht.stroke = ne.borderColor, ht["stroke-width"] = He), Me.attr(ht).shadow(ne.shadow)), Me[At]({ x: $e / 2, y: $e / 2, width: se - $e - He % 2, height: oe - $e - He % 2, r: ne.borderRadius }), At = "animate", Te || (At = "attr", this.plotBackground = Te = te.rect().addClass("highcharts-plot-background").add()), Te[At](xe), !ie && (Te.attr({ fill: be || "none" }).shadow(ne.plotShadow), ge && (le ? (ge !== le.attr("href") && le.attr("href", ge), le.animate(xe)) : this.plotBGImage = te.image(ge, me, fe, Ae, ye).add())), we ? we.animate({ width: ke.width, height: ke.height }) : this.clipRect = te.clipRect(ke), At = "animate", Ie || (At = "attr", this.plotBorder = Ie = te.rect().addClass("highcharts-plot-border").attr({ zIndex: 1 }).add()), ie || Ie.attr({ stroke: ne.plotBorderColor, "stroke-width": ne.plotBorderWidth || 0, fill: "none" }), Ie[At](Ie.crisp({ x: me, y: fe, width: Ae, height: ye }, -Ie.strokeWidth())), this.isDirtyBox = !1, q(this, "afterDrawChartBox");
        }
        propFromSeries() {
          let ne, te, se, oe = this, ie = oe.options.chart, le = oe.options.series;
          ["inverted", "angular", "polar"].forEach(function(de) {
            for (te = s[ie.type], se = ie[de] || te && te.prototype[de], ne = le && le.length; !se && ne--; ) (te = s[le[ne].type]) && te.prototype[de] && (se = !0);
            oe[de] = se;
          });
        }
        linkSeries(ne) {
          let te = this, se = te.series;
          se.forEach(function(oe) {
            oe.linkedSeries.length = 0;
          }), se.forEach(function(oe) {
            let { linkedTo: ie } = oe.options;
            if (X(ie)) {
              let le;
              (le = ie === ":previous" ? te.series[oe.index - 1] : te.get(ie)) && le.linkedParent !== oe && (le.linkedSeries.push(oe), oe.linkedParent = le, le.enabledDataSorting && oe.setDataSortingOptions(), oe.visible = K(oe.options.visible, le.options.visible, oe.visible));
            }
          }), q(this, "afterLinkSeries", { isUpdating: ne });
        }
        renderSeries() {
          this.series.forEach(function(ne) {
            ne.translate(), ne.render();
          });
        }
        render() {
          var me;
          let ne = this.axes, te = this.colorAxis, se = this.renderer, oe = this.options.chart.axisLayoutRuns || 2, ie = (fe) => {
            fe.forEach((Ae) => {
              Ae.visible && Ae.render();
            });
          }, le = 0, de = !0, be, ge = 0;
          for (let fe of (this.setTitle(), q(this, "beforeMargins"), (me = this.getStacks) == null || me.call(this), this.getMargins(!0), this.setChartSize(), ne)) {
            let { options: Ae } = fe, { labels: ye } = Ae;
            if (this.hasCartesianSeries && fe.horiz && fe.visible && ye.enabled && fe.series.length && fe.coll !== "colorAxis" && !this.polar) {
              le = Ae.tickLength, fe.createGroups();
              let xe = new M(fe, 0, "", !0), we = xe.createLabel("x", ye);
              if (xe.destroy(), we && K(ye.reserveSpace, !_(Ae.crossing)) && (le = we.getBBox().height + ye.distance + Math.max(Ae.offset || 0, 0)), le) {
                we == null || we.destroy();
                break;
              }
            }
          }
          for (this.plotHeight = Math.max(this.plotHeight - le, 0); (de || be || oe > 1) && ge < oe; ) {
            let fe = this.plotWidth, Ae = this.plotHeight;
            for (let ye of ne) ge === 0 ? ye.setScale() : (ye.horiz && de || !ye.horiz && be) && ye.setTickInterval(!0);
            ge === 0 ? this.getAxisMargins() : this.getMargins(), de = fe / this.plotWidth > (ge ? 1 : 1.1), be = Ae / this.plotHeight > (ge ? 1 : 1.05), ge++;
          }
          this.drawChartBox(), this.hasCartesianSeries ? ie(ne) : te && te.length && ie(te), this.seriesGroup || (this.seriesGroup = se.g("series-group").attr({ zIndex: 3 }).shadow(this.options.chart.seriesGroupShadow).add()), this.renderSeries(), this.addCredits(), this.setResponsive && this.setResponsive(), this.hasRendered = !0;
        }
        addCredits(ne) {
          let te = this, se = z(!0, this.options.credits, ne);
          se.enabled && !this.credits && (this.credits = this.renderer.text(se.text + (this.mapCredits || ""), 0, 0).addClass("highcharts-credits").on("click", function() {
            se.href && (d.location.href = se.href);
          }).attr({ align: se.position.align, zIndex: 8 }), te.styledMode || this.credits.css(se.style), this.credits.add().align(se.position), this.credits.update = function(oe) {
            te.credits = te.credits.destroy(), te.addCredits(oe);
          });
        }
        destroy() {
          let ne, te = this, se = te.axes, oe = te.series, ie = te.container, le = ie && ie.parentNode;
          for (q(te, "destroy"), te.renderer.forExport ? R(G, te) : G[te.index] = void 0, j.chartCount--, te.renderTo.removeAttribute("data-highcharts-chart"), ee(te), ne = se.length; ne--; ) se[ne] = se[ne].destroy();
          for (this.scroller && this.scroller.destroy && this.scroller.destroy(), ne = oe.length; ne--; ) oe[ne] = oe[ne].destroy();
          ["title", "subtitle", "chartBackground", "plotBackground", "plotBGImage", "plotBorder", "seriesGroup", "clipRect", "credits", "pointer", "rangeSelector", "legend", "resetZoomButton", "tooltip", "renderer"].forEach(function(de) {
            let be = te[de];
            be && be.destroy && (te[de] = be.destroy());
          }), ie && (ie.innerHTML = x.emptyHTML, ee(ie), le && E(ie)), $(te, function(de, be) {
            delete te[be];
          });
        }
        firstRender() {
          var oe;
          let ne = this, te = ne.options;
          ne.getContainer(), ne.resetMargins(), ne.setChartSize(), ne.propFromSeries(), ne.getAxes();
          let se = I(te.series) ? te.series : [];
          te.series = [], se.forEach(function(ie) {
            ne.initSeries(ie);
          }), ne.linkSeries(), ne.setSortedData(), q(ne, "beforeRender"), ne.render(), (oe = ne.pointer) == null || oe.getChartPosition(), ne.renderer.imgCount || ne.hasLoaded || ne.onload(), ne.temporaryDisplay(!0);
        }
        onload() {
          this.callbacks.concat([this.callback]).forEach(function(ne) {
            ne && this.index !== void 0 && ne.apply(this, [this]);
          }, this), q(this, "load"), q(this, "render"), h(this.index) && this.setReflow(), this.warnIfA11yModuleNotLoaded(), this.hasLoaded = !0;
        }
        warnIfA11yModuleNotLoaded() {
          let { options: ne, title: te } = this;
          !ne || this.accessibility || (this.renderer.boxWrapper.attr({ role: "img", "aria-label": (te && te.element.textContent || "").replace(/</g, "&lt;") }), ne.accessibility && ne.accessibility.enabled === !1 || L('Highcharts warning: Consider including the "accessibility.js" module to make your chart more usable for people with disabilities. Set the "accessibility.enabled" option to false to remove this warning. See https://www.highcharts.com/docs/accessibility/accessibility-module.', !1, this));
        }
        addSeries(ne, te, se) {
          let oe, ie = this;
          return ne && (te = K(te, !0), q(ie, "addSeries", { options: ne }, function() {
            oe = ie.initSeries(ne), ie.isDirtyLegend = !0, ie.linkSeries(), oe.enabledDataSorting && oe.setData(ne.data, !1), q(ie, "afterAddSeries", { series: oe }), te && ie.redraw(se);
          })), oe;
        }
        addAxis(ne, te, se, oe) {
          return this.createAxis(te ? "xAxis" : "yAxis", { axis: ne, redraw: se, animation: oe });
        }
        addColorAxis(ne, te, se) {
          return this.createAxis("colorAxis", { axis: ne, redraw: te, animation: se });
        }
        createAxis(ne, te) {
          let se = new n(this, te.axis, ne);
          return K(te.redraw, !0) && this.redraw(te.animation), se;
        }
        showLoading(ne) {
          let te = this, se = te.options, oe = se.loading, ie = function() {
            le && c(le, { left: te.plotLeft + "px", top: te.plotTop + "px", width: te.plotWidth + "px", height: te.plotHeight + "px" });
          }, le = te.loadingDiv, de = te.loadingSpan;
          le || (te.loadingDiv = le = u("div", { className: "highcharts-loading highcharts-loading-hidden" }, null, te.container)), de || (te.loadingSpan = de = u("span", { className: "highcharts-loading-inner" }, null, le), l(te, "redraw", ie)), le.className = "highcharts-loading", x.setElementHTML(de, K(ne, se.lang.loading, "")), te.styledMode || (c(le, U(oe.style, { zIndex: 10 })), c(de, oe.labelStyle), te.loadingShown || (c(le, { opacity: 0, display: "" }), p(le, { opacity: oe.style.opacity || 0.5 }, { duration: oe.showDuration || 0 }))), te.loadingShown = !0, ie();
        }
        hideLoading() {
          let ne = this.options, te = this.loadingDiv;
          te && (te.className = "highcharts-loading highcharts-loading-hidden", this.styledMode || p(te, { opacity: 0 }, { duration: ne.loading.hideDuration || 100, complete: function() {
            c(te, { display: "none" });
          } })), this.loadingShown = !1;
        }
        update(ne, te, se, oe) {
          let ie, le, de, be = this, ge = { credits: "addCredits", title: "setTitle", subtitle: "setSubtitle", caption: "setCaption" }, me = ne.isResponsiveOptions, fe = [];
          q(be, "update", { options: ne }), me || be.setResponsive(!1, !0), ne = g(ne, be.options), be.userOptions = z(be.userOptions, ne);
          let Ae = ne.chart;
          Ae && (z(!0, be.options.chart, Ae), this.setZoomOptions(), "className" in Ae && be.setClassName(Ae.className), ("inverted" in Ae || "polar" in Ae || "type" in Ae) && (be.propFromSeries(), ie = !0), "alignTicks" in Ae && (ie = !0), "events" in Ae && H(this, Ae), $(Ae, function(we, ke) {
            be.propsRequireUpdateSeries.indexOf("chart." + ke) !== -1 && (le = !0), be.propsRequireDirtyBox.indexOf(ke) !== -1 && (be.isDirtyBox = !0), be.propsRequireReflow.indexOf(ke) === -1 || (be.isDirtyBox = !0, me || (de = !0));
          }), !be.styledMode && Ae.style && be.renderer.setStyle(be.options.chart.style || {})), !be.styledMode && ne.colors && (this.options.colors = ne.colors), ne.time && (this.time === A && (this.time = new f(ne.time)), z(!0, be.options.time, ne.time)), $(ne, function(we, ke) {
            be[ke] && typeof be[ke].update == "function" ? be[ke].update(we, !1) : typeof be[ge[ke]] == "function" ? be[ge[ke]](we) : ke !== "colors" && be.collectionsWithUpdate.indexOf(ke) === -1 && z(!0, be.options[ke], ne[ke]), ke !== "chart" && be.propsRequireUpdateSeries.indexOf(ke) !== -1 && (le = !0);
          }), this.collectionsWithUpdate.forEach(function(we) {
            ne[we] && (J(ne[we]).forEach(function(ke, Me) {
              let Te, Ie = h(ke.id);
              Ie && (Te = be.get(ke.id)), !Te && be[we] && (Te = be[we][K(ke.index, Me)]) && (Ie && h(Te.options.id) || Te.options.isInternal) && (Te = void 0), Te && Te.coll === we && (Te.update(ke, !1), se && (Te.touched = !0)), !Te && se && be.collectionsWithInit[we] && (be.collectionsWithInit[we][0].apply(be, [ke].concat(be.collectionsWithInit[we][1] || []).concat([!1])).touched = !0);
            }), se && be[we].forEach(function(ke) {
              ke.touched || ke.options.isInternal ? delete ke.touched : fe.push(ke);
            }));
          }), fe.forEach(function(we) {
            we.chart && we.remove && we.remove(!1);
          }), ie && be.axes.forEach(function(we) {
            we.update({}, !1);
          }), le && be.getSeriesOrderByLinks().forEach(function(we) {
            we.chart && we.update({}, !1);
          }, this);
          let ye = Ae && Ae.width, xe = Ae && (X(Ae.height) ? Z(Ae.height, ye || be.chartWidth) : Ae.height);
          de || _(ye) && ye !== be.chartWidth || _(xe) && xe !== be.chartHeight ? be.setSize(ye, xe, oe) : K(te, !0) && be.redraw(oe), q(be, "afterUpdate", { options: ne, redraw: te, animation: oe });
        }
        setSubtitle(ne, te) {
          this.applyDescription("subtitle", ne), this.layOutTitles(te);
        }
        setCaption(ne, te) {
          this.applyDescription("caption", ne), this.layOutTitles(te);
        }
        showResetZoom() {
          let ne = this, te = m.lang, se = ne.zooming.resetButton, oe = se.theme, ie = se.relativeTo === "chart" || se.relativeTo === "spacingBox" ? null : "plotBox";
          function le() {
            ne.zoomOut();
          }
          q(this, "beforeShowResetZoom", null, function() {
            ne.resetZoomButton = ne.renderer.button(te.resetZoom, null, null, le, oe).attr({ align: se.position.align, title: te.resetZoomTitle }).addClass("highcharts-reset-zoom").add().align(se.position, !1, ie);
          }), q(this, "afterShowResetZoom");
        }
        zoomOut() {
          q(this, "selection", { resetSelection: !0 }, () => this.transform({ reset: !0, trigger: "zoom" }));
        }
        pan(ne, te) {
          let se = this, oe = typeof te == "object" ? te : { enabled: te, type: "x" }, ie = oe.type, le = ie && se[{ x: "xAxis", xy: "axes", y: "yAxis" }[ie]].filter((be) => be.options.panningEnabled && !be.options.isInternal), de = se.options.chart;
          de != null && de.panning && (de.panning = oe), q(this, "pan", { originalEvent: ne }, () => {
            se.transform({ axes: le, event: ne, to: { x: ne.chartX - (se.mouseDownX || 0), y: ne.chartY - (se.mouseDownY || 0) }, trigger: "pan" }), c(se.container, { cursor: "move" });
          });
        }
        transform(ne) {
          var ye, xe, we, ke, Me;
          let { axes: te = this.axes, event: se, from: oe = {}, reset: ie, selection: le, to: de = {}, trigger: be } = ne, { inverted: ge } = this, me = !1, fe, Ae;
          for (let Te of ((ye = this.hoverPoints) == null || ye.forEach((Ie) => Ie.setState()), te)) {
            let { horiz: Ie, len: He, minPointOffset: $e = 0, options: ht, reversed: At } = Te, Ua = Ie ? "width" : "height", Ei = Ie ? "x" : "y", la = K(de[Ua], Te.len), ca = K(oe[Ua], Te.len), co = 10 > Math.abs(la) ? 1 : la / ca, Pc = (oe[Ei] || 0) + ca / 2 - Te.pos, zc = Pc - (((xe = de[Ei]) != null ? xe : Te.pos) + la / 2 - Te.pos) / co, Kb = At && !ge || !At && ge ? -1 : 1;
            if (!ie && (Pc < 0 || Pc > Te.len)) continue;
            let ao = Te.toValue(zc, !0) + (le || Te.isOrdinal ? 0 : $e * Kb), io = Te.toValue(zc + He / co, !0) - (le || Te.isOrdinal ? 0 : $e * Kb || 0), To = Te.allExtremes;
            if (ao > io && ([ao, io] = [io, ao]), co === 1 && !ie && Te.coll === "yAxis" && !To) {
              for (let Xb of Te.series) {
                let Gs = Xb.getExtremes(Xb.getProcessedData(!0).yData, !0);
                To != null || (To = { dataMin: Number.MAX_VALUE, dataMax: -Number.MAX_VALUE }), _(Gs.dataMin) && _(Gs.dataMax) && (To.dataMin = Math.min(Gs.dataMin, To.dataMin), To.dataMax = Math.max(Gs.dataMax, To.dataMax));
              }
              Te.allExtremes = To;
            }
            let { dataMin: Dc, dataMax: Ic, min: Gb, max: Wb } = U(Te.getExtremes(), To || {}), qb = Dc != null ? Dc : ht.min, Vb = Ic != null ? Ic : ht.max, Bc = io - ao, Yb = Te.categories ? 0 : Math.min(Bc, Vb - qb), Rc = qb - Yb * (h(ht.min) ? 0 : ht.minPadding), Nc = Vb + Yb * (h(ht.max) ? 0 : ht.maxPadding), Qb = Te.allowZoomOutside || co === 1 || be !== "zoom" && co > 1, Hs = Math.min((we = ht.min) != null ? we : Rc, Rc, Qb ? Gb : Rc), Ks = Math.max((ke = ht.max) != null ? ke : Nc, Nc, Qb ? Wb : Nc);
            (!Te.isOrdinal || Te.options.overscroll || co !== 1 || ie) && (ao < Hs && (ao = Hs, co >= 1 && (io = ao + Bc)), io > Ks && (io = Ks, co >= 1 && (ao = io - Bc)), (ie || Te.series.length && (ao !== Gb || io !== Wb) && ao >= Hs && io <= Ks) && (le ? le[Te.coll].push({ axis: Te, min: ao, max: io }) : (Te.isPanning = be !== "zoom", Te.isPanning && (Ae = !0), Te.setExtremes(ie ? void 0 : ao, ie ? void 0 : io, !1, !1, { move: zc, trigger: be, scale: co }), !ie && (ao > Hs || io < Ks) && be !== "mousewheel" && (fe = !0)), me = !0), se && (this[Ie ? "mouseDownX" : "mouseDownY"] = se[Ie ? "chartX" : "chartY"]));
          }
          return me && (le ? q(this, "selection", le, () => {
            delete ne.selection, ne.trigger = "zoom", this.transform(ne);
          }) : (!fe || Ae || this.resetZoomButton ? !fe && this.resetZoomButton && (this.resetZoomButton = this.resetZoomButton.destroy()) : this.showResetZoom(), this.redraw(be === "zoom" && ((Me = this.options.chart.animation) != null ? Me : this.pointCount < 100)))), me;
        }
      }
      return U(ce.prototype, { callbacks: [], collectionsWithInit: { xAxis: [ce.prototype.addAxis, [!0]], yAxis: [ce.prototype.addAxis, [!1]], series: [ce.prototype.addSeries] }, collectionsWithUpdate: ["xAxis", "yAxis", "series"], propsRequireDirtyBox: ["backgroundColor", "borderColor", "borderWidth", "borderRadius", "plotBackgroundColor", "plotBackgroundImage", "plotBorderColor", "plotBorderWidth", "plotShadow", "shadow"], propsRequireReflow: ["margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "spacing", "spacingTop", "spacingRight", "spacingBottom", "spacingLeft"], propsRequireUpdateSeries: ["chart.inverted", "chart.polar", "chart.ignoreHiddenSeries", "chart.type", "colors", "plotOptions", "time", "tooltip"] }), ce;
    }), a(e, "Extensions/ScrollablePlotArea.js", [e["Core/Animation/AnimationUtilities.js"], e["Core/Globals.js"], e["Core/Renderer/RendererRegistry.js"], e["Core/Utilities.js"]], function(o, n, r, T) {
      let { stop: O } = o, { composed: j } = n, { addEvent: D, createElement: F, css: B, defined: N, merge: f, pushUnique: w } = T;
      function x() {
        let v = this.scrollablePlotArea;
        (this.scrollablePixelsX || this.scrollablePixelsY) && !v && (this.scrollablePlotArea = v = new p(this)), v == null || v.applyFixed();
      }
      function M() {
        this.chart.scrollablePlotArea && (this.chart.scrollablePlotArea.isDirty = !0);
      }
      class p {
        static compose(k, m, A) {
          w(j, this.compose) && (D(k, "afterInit", M), D(m, "afterSetChartSize", (C) => this.afterSetSize(C.target, C)), D(m, "render", x), D(A, "show", M));
        }
        static afterSetSize(k, m) {
          let A, C, H, { minWidth: G, minHeight: P } = k.options.chart.scrollablePlotArea || {}, { clipBox: y, plotBox: S, inverted: d, renderer: s } = k;
          if (!s.forExport && (G ? (k.scrollablePixelsX = A = Math.max(0, G - k.chartWidth), A && (k.scrollablePlotBox = f(k.plotBox), S.width = k.plotWidth += A, y[d ? "height" : "width"] += A, H = !0)) : P && (k.scrollablePixelsY = C = Math.max(0, P - k.chartHeight), N(C) && (k.scrollablePlotBox = f(k.plotBox), S.height = k.plotHeight += C, y[d ? "width" : "height"] += C, H = !1)), N(H) && !m.skipAxes)) for (let l of k.axes) l.horiz === H && (l.setAxisSize(), l.setAxisTranslation());
        }
        constructor(k) {
          var b, u;
          let m, A = k.options.chart, C = r.getRendererType(), H = A.scrollablePlotArea || {}, G = this.moveFixedElements.bind(this), P = { WebkitOverflowScrolling: "touch", overflowX: "hidden", overflowY: "hidden" };
          k.scrollablePixelsX && (P.overflowX = "auto"), k.scrollablePixelsY && (P.overflowY = "auto"), this.chart = k;
          let y = this.parentDiv = F("div", { className: "highcharts-scrolling-parent" }, { position: "relative" }, k.renderTo), S = this.scrollingContainer = F("div", { className: "highcharts-scrolling" }, P, y), d = this.innerContainer = F("div", { className: "highcharts-inner-container" }, void 0, S), s = this.fixedDiv = F("div", { className: "highcharts-fixed" }, { position: "absolute", overflow: "hidden", pointerEvents: "none", zIndex: (((b = A.style) == null ? void 0 : b.zIndex) || 0) + 2, top: 0 }, void 0, !0), l = this.fixedRenderer = new C(s, k.chartWidth, k.chartHeight, A.style);
          this.mask = l.path().attr({ fill: A.backgroundColor || "#fff", "fill-opacity": (u = H.opacity) != null ? u : 0.85, zIndex: -1 }).addClass("highcharts-scrollable-mask").add(), S.parentNode.insertBefore(s, S), B(k.renderTo, { overflow: "visible" }), D(k, "afterShowResetZoom", G), D(k, "afterApplyDrilldown", G), D(k, "afterLayOutTitles", G), D(S, "scroll", () => {
            let { pointer: c, hoverPoint: h } = k;
            c && (delete c.chartPosition, h && (m = h), c.runPointActions(void 0, m, !0));
          }), d.appendChild(k.container);
        }
        applyFixed() {
          var _;
          let { chart: k, fixedRenderer: m, isDirty: A, scrollingContainer: C } = this, { axisOffset: H, chartWidth: G, chartHeight: P, container: y, plotHeight: S, plotLeft: d, plotTop: s, plotWidth: l, scrollablePixelsX: b = 0, scrollablePixelsY: u = 0 } = k, { scrollPositionX: c = 0, scrollPositionY: h = 0 } = k.options.chart.scrollablePlotArea || {}, g = G + b, E = P + u;
          m.setSize(G, P), (A == null || A) && (this.isDirty = !1, this.moveFixedElements()), O(k.container), B(y, { width: `${g}px`, height: `${E}px` }), k.renderer.boxWrapper.attr({ width: g, height: E, viewBox: [0, 0, g, E].join(" ") }), (_ = k.chartBackground) == null || _.attr({ width: g, height: E }), B(C, { width: `${G}px`, height: `${P}px` }), N(A) || (C.scrollLeft = b * c, C.scrollTop = u * h);
          let R = s - H[0] - 1, L = d - H[3] - 1, U = s + S + H[2] + 1, V = d + l + H[1] + 1, q = d + l - b, Y = s + S - u, I = [["M", 0, 0]];
          b ? I = [["M", 0, R], ["L", d - 1, R], ["L", d - 1, U], ["L", 0, U], ["Z"], ["M", q, R], ["L", G, R], ["L", G, U], ["L", q, U], ["Z"]] : u && (I = [["M", L, 0], ["L", L, s - 1], ["L", V, s - 1], ["L", V, 0], ["Z"], ["M", L, Y], ["L", L, P], ["L", V, P], ["L", V, Y], ["Z"]]), k.redrawTrigger !== "adjustHeight" && this.mask.attr({ d: I });
        }
        moveFixedElements() {
          let k, { container: m, inverted: A, scrollablePixelsX: C, scrollablePixelsY: H } = this.chart, G = this.fixedRenderer, P = p.fixedSelectors;
          for (let y of (C && !A ? k = ".highcharts-yaxis" : C && A || H && !A ? k = ".highcharts-xaxis" : H && A && (k = ".highcharts-yaxis"), k && P.push(`${k}:not(.highcharts-radial-axis)`, `${k}-labels:not(.highcharts-radial-axis-labels)`), P)) [].forEach.call(m.querySelectorAll(y), (S) => {
            (S.namespaceURI === G.SVG_NS ? G.box : G.box.parentNode).appendChild(S), S.style.pointerEvents = "auto";
          });
        }
      }
      return p.fixedSelectors = [".highcharts-breadcrumbs-group", ".highcharts-contextbutton", ".highcharts-caption", ".highcharts-credits", ".highcharts-drillup-button", ".highcharts-legend", ".highcharts-legend-checkbox", ".highcharts-navigator-series", ".highcharts-navigator-xaxis", ".highcharts-navigator-yaxis", ".highcharts-navigator", ".highcharts-range-selector-group", ".highcharts-reset-zoom", ".highcharts-scrollbar", ".highcharts-subtitle", ".highcharts-title"], p;
    }), a(e, "Core/Axis/Stacking/StackItem.js", [e["Core/Templating.js"], e["Core/Series/SeriesRegistry.js"], e["Core/Utilities.js"]], function(o, n, r) {
      let { format: T } = o, { series: O } = n, { destroyObjectProperties: j, fireEvent: D, isNumber: F, pick: B } = r;
      return class {
        constructor(N, f, w, x, M) {
          let p = N.chart.inverted, v = N.reversed;
          this.axis = N;
          let k = this.isNegative = !!w != !!v;
          this.options = f = f || {}, this.x = x, this.total = null, this.cumulative = null, this.points = {}, this.hasValidPoints = !1, this.stack = M, this.leftCliff = 0, this.rightCliff = 0, this.alignOptions = { align: f.align || (p ? k ? "left" : "right" : "center"), verticalAlign: f.verticalAlign || (p ? "middle" : k ? "bottom" : "top"), y: f.y, x: f.x }, this.textAlign = f.textAlign || (p ? k ? "right" : "left" : "center");
        }
        destroy() {
          j(this, this.axis);
        }
        render(N) {
          let f = this.axis.chart, w = this.options, x = w.format, M = x ? T(x, this, f) : w.formatter.call(this);
          if (this.label) this.label.attr({ text: M, visibility: "hidden" });
          else {
            this.label = f.renderer.label(M, null, void 0, w.shape, void 0, void 0, w.useHTML, !1, "stack-labels");
            let p = { r: w.borderRadius || 0, text: M, padding: B(w.padding, 5), visibility: "hidden" };
            f.styledMode || (p.fill = w.backgroundColor, p.stroke = w.borderColor, p["stroke-width"] = w.borderWidth, this.label.css(w.style || {})), this.label.attr(p), this.label.added || this.label.add(N);
          }
          this.label.labelrank = f.plotSizeY, D(this, "afterRender");
        }
        setOffset(N, f, w, x, M, p) {
          let { alignOptions: v, axis: k, label: m, options: A, textAlign: C } = this, H = k.chart, G = this.getStackBox({ xOffset: N, width: f, boxBottom: w, boxTop: x, defaultX: M, xAxis: p }), { verticalAlign: P } = v;
          if (m && G) {
            let y = m.getBBox(void 0, 0), S = m.padding, d = B(A.overflow, "justify") === "justify", s;
            v.x = A.x || 0, v.y = A.y || 0;
            let { x: l, y: b } = this.adjustStackPosition({ labelBox: y, verticalAlign: P, textAlign: C });
            G.x -= l, G.y -= b, m.align(v, !1, G), (s = H.isInsidePlot(m.alignAttr.x + v.x + l, m.alignAttr.y + v.y + b)) || (d = !1), d && O.prototype.justifyDataLabel.call(k, m, v, m.alignAttr, y, G), m.attr({ x: m.alignAttr.x, y: m.alignAttr.y, rotation: A.rotation, rotationOriginX: y.width * { left: 0, center: 0.5, right: 1 }[A.textAlign || "center"], rotationOriginY: y.height / 2 }), B(!d && A.crop, !0) && (s = F(m.x) && F(m.y) && H.isInsidePlot(m.x - S + (m.width || 0), m.y) && H.isInsidePlot(m.x + S, m.y)), m[s ? "show" : "hide"]();
          }
          D(this, "afterSetOffset", { xOffset: N, width: f });
        }
        adjustStackPosition({ labelBox: N, verticalAlign: f, textAlign: w }) {
          let x = { bottom: 0, middle: 1, top: 2, right: 1, center: 0, left: -1 }, M = x[f], p = x[w];
          return { x: N.width / 2 + N.width / 2 * p, y: N.height / 2 * M };
        }
        getStackBox(N) {
          let f = this.axis, w = f.chart, { boxTop: x, defaultX: M, xOffset: p, width: v, boxBottom: k } = N, m = f.stacking.usePercentage ? 100 : B(x, this.total, 0), A = f.toPixels(m), C = N.xAxis || w.xAxis[0], H = B(M, C.translate(this.x)) + p, G = Math.abs(A - f.toPixels(k || F(f.min) && f.logarithmic && f.logarithmic.lin2log(f.min) || 0)), P = w.inverted, y = this.isNegative;
          return P ? { x: (y ? A : A - G) - w.plotLeft, y: C.height - H - v + C.top - w.plotTop, width: G, height: v } : { x: H + C.transB - w.plotLeft, y: (y ? A - G : A) - w.plotTop, width: v, height: G };
        }
      };
    }), a(e, "Core/Axis/Stacking/StackingAxis.js", [e["Core/Animation/AnimationUtilities.js"], e["Core/Axis/Axis.js"], e["Core/Series/SeriesRegistry.js"], e["Core/Axis/Stacking/StackItem.js"], e["Core/Utilities.js"]], function(o, n, r, T, O) {
      var j;
      let { getDeferredAnimation: D } = o, { series: { prototype: F } } = r, { addEvent: B, correctFloat: N, defined: f, destroyObjectProperties: w, fireEvent: x, isArray: M, isNumber: p, objectEach: v, pick: k } = O;
      function m() {
        let s = this.inverted;
        this.axes.forEach((l) => {
          l.stacking && l.stacking.stacks && l.hasVisibleSeries && (l.stacking.oldStacks = l.stacking.stacks);
        }), this.series.forEach((l) => {
          let b = l.xAxis && l.xAxis.options || {};
          l.options.stacking && l.reserveSpace() && (l.stackKey = [l.type, k(l.options.stack, ""), s ? b.top : b.left, s ? b.height : b.width].join(","));
        });
      }
      function A() {
        var l;
        let s = this.stacking;
        if (s) {
          let b = s.stacks;
          v(b, (u, c) => {
            w(u), delete b[c];
          }), (l = s.stackTotalGroup) == null || l.destroy();
        }
      }
      function C() {
        this.stacking || (this.stacking = new d(this));
      }
      function H(s, l, b, u) {
        return !f(s) || s.x !== l || u && s.stackKey !== u ? s = { x: l, index: 0, key: u, stackKey: u } : s.index++, s.key = [b, l, s.index].join(","), s;
      }
      function G() {
        let s, l = this, b = l.yAxis, u = l.stackKey || "", c = b.stacking.stacks, h = l.processedXData, g = l.options.stacking, E = l[g + "Stacker"];
        E && [u, "-" + u].forEach((R) => {
          var Y;
          let L = h.length, U, V, q;
          for (; L--; ) U = h[L], s = l.getStackIndicator(s, U, l.index, R), V = (Y = c[R]) == null ? void 0 : Y[U], (q = V == null ? void 0 : V.points[s.key || ""]) && E.call(l, q, V, L);
        });
      }
      function P(s, l, b) {
        let u = l.total ? 100 / l.total : 0;
        s[0] = N(s[0] * u), s[1] = N(s[1] * u), this.stackedYData[b] = s[1];
      }
      function y(s) {
        (this.is("column") || this.is("columnrange")) && (this.options.centerInCategory && !this.options.stacking && this.chart.series.length > 1 ? F.setStackedPoints.call(this, s, "group") : s.stacking.resetStacks());
      }
      function S(s, l) {
        var re, ce;
        let b, u, c, h, g, E, R, L, U, V = l || this.options.stacking;
        if (!V || !this.reserveSpace() || ({ group: "xAxis" }[V] || "yAxis") !== s.coll) return;
        let q = this.processedXData, Y = this.processedYData, I = [], _ = Y.length, W = this.options, X = W.threshold || 0, z = W.startFromThreshold ? X : 0, $ = W.stack, K = l ? `${this.type},${V}` : this.stackKey || "", Q = "-" + K, Z = this.negStacks, ee = s.stacking, J = ee.stacks, ae = ee.oldStacks;
        for (ee.stacksTouched += 1, R = 0; R < _; R++) {
          L = q[R], U = Y[R], E = (b = this.getStackIndicator(b, L, this.index)).key || "", J[g = (u = Z && U < (z ? 0 : X)) ? Q : K] || (J[g] = {}), J[g][L] || ((re = ae[g]) != null && re[L] ? (J[g][L] = ae[g][L], J[g][L].total = null) : J[g][L] = new T(s, s.options.stackLabels, !!u, L, $)), c = J[g][L], U !== null ? (c.points[E] = c.points[this.index] = [k(c.cumulative, z)], f(c.cumulative) || (c.base = E), c.touched = ee.stacksTouched, b.index > 0 && this.singleStacks === !1 && (c.points[E][0] = c.points[this.index + "," + L + ",0"][0])) : (delete c.points[E], delete c.points[this.index]);
          let he = c.total || 0;
          V === "percent" ? (h = u ? K : Q, he = Z && ((ce = J[h]) != null && ce[L]) ? (h = J[h][L]).total = Math.max(h.total || 0, he) + Math.abs(U) || 0 : N(he + (Math.abs(U) || 0))) : V === "group" ? (M(U) && (U = U[0]), U !== null && he++) : he = N(he + (U || 0)), V === "group" ? c.cumulative = (he || 1) - 1 : c.cumulative = N(k(c.cumulative, z) + (U || 0)), c.total = he, U !== null && (c.points[E].push(c.cumulative), I[R] = c.cumulative, c.hasValidPoints = !0);
        }
        V === "percent" && (ee.usePercentage = !0), V !== "group" && (this.stackedYData = I), ee.oldStacks = {};
      }
      class d {
        constructor(l) {
          this.oldStacks = {}, this.stacks = {}, this.stacksTouched = 0, this.axis = l;
        }
        buildStacks() {
          let l, b, u = this.axis, c = u.series, h = u.coll === "xAxis", g = u.options.reversedStacks, E = c.length;
          for (this.resetStacks(), this.usePercentage = !1, b = E; b--; ) l = c[g ? b : E - b - 1], h && l.setGroupedPoints(u), l.setStackedPoints(u);
          if (!h) for (b = 0; b < E; b++) c[b].modifyStacks();
          x(u, "afterBuildStacks");
        }
        cleanStacks() {
          this.oldStacks && (this.stacks = this.oldStacks, v(this.stacks, (l) => {
            v(l, (b) => {
              b.cumulative = b.total;
            });
          }));
        }
        resetStacks() {
          v(this.stacks, (l) => {
            v(l, (b, u) => {
              p(b.touched) && b.touched < this.stacksTouched ? (b.destroy(), delete l[u]) : (b.total = null, b.cumulative = null);
            });
          });
        }
        renderStackTotals() {
          var E;
          let l = this.axis, b = l.chart, u = b.renderer, c = this.stacks, h = D(b, ((E = l.options.stackLabels) == null ? void 0 : E.animation) || !1), g = this.stackTotalGroup = this.stackTotalGroup || u.g("stack-labels").attr({ zIndex: 6, opacity: 0 }).add();
          g.translate(b.plotLeft, b.plotTop), v(c, (R) => {
            v(R, (L) => {
              L.render(g);
            });
          }), g.animate({ opacity: 1 }, h);
        }
      }
      return (j || (j = {})).compose = function(s, l, b) {
        let u = l.prototype, c = b.prototype;
        u.getStacks || (B(s, "init", C), B(s, "destroy", A), u.getStacks = m, c.getStackIndicator = H, c.modifyStacks = G, c.percentStacker = P, c.setGroupedPoints = y, c.setStackedPoints = S);
      }, j;
    }), a(e, "Series/Line/LineSeries.js", [e["Core/Series/Series.js"], e["Core/Series/SeriesRegistry.js"], e["Core/Utilities.js"]], function(o, n, r) {
      let { defined: T, merge: O, isObject: j } = r;
      class D extends o {
        drawGraph() {
          let B = this.options, N = (this.gappedPath || this.getGraphPath).call(this), f = this.chart.styledMode;
          [this, ...this.zones].forEach((w, x) => {
            let M, p = w.graph, v = p ? "animate" : "attr", k = w.dashStyle || B.dashStyle;
            p ? (p.endX = this.preventGraphAnimation ? null : N.xMap, p.animate({ d: N })) : N.length && (w.graph = p = this.chart.renderer.path(N).addClass("highcharts-graph" + (x ? ` highcharts-zone-graph-${x - 1} ` : " ") + (x && w.className || "")).attr({ zIndex: 1 }).add(this.group)), p && !f && (M = { stroke: !x && B.lineColor || w.color || this.color || "#cccccc", "stroke-width": B.lineWidth || 0, fill: this.fillGraph && this.color || "none" }, k ? M.dashstyle = k : B.linecap !== "square" && (M["stroke-linecap"] = M["stroke-linejoin"] = "round"), p[v](M).shadow(x < 2 && B.shadow && O({ filterUnits: "userSpaceOnUse" }, j(B.shadow) ? B.shadow : {}))), p && (p.startX = N.xMap, p.isArea = N.isArea);
          });
        }
        getGraphPath(B, N, f) {
          let w = this, x = w.options, M = [], p = [], v, k = x.step, m = (B = B || w.points).reversed;
          return m && B.reverse(), (k = { right: 1, center: 2 }[k] || k && 3) && m && (k = 4 - k), (B = this.getValidPoints(B, !1, !(x.connectNulls && !N && !f))).forEach(function(A, C) {
            let H, G = A.plotX, P = A.plotY, y = B[C - 1], S = A.isNull || typeof P != "number";
            (A.leftCliff || y && y.rightCliff) && !f && (v = !0), S && !T(N) && C > 0 ? v = !x.connectNulls : S && !N ? v = !0 : (C === 0 || v ? H = [["M", A.plotX, A.plotY]] : w.getPointSpline ? H = [w.getPointSpline(B, A, C)] : k ? (H = k === 1 ? [["L", y.plotX, P]] : k === 2 ? [["L", (y.plotX + G) / 2, y.plotY], ["L", (y.plotX + G) / 2, P]] : [["L", G, y.plotY]]).push(["L", G, P]) : H = [["L", G, P]], p.push(A.x), k && (p.push(A.x), k === 2 && p.push(A.x)), M.push.apply(M, H), v = !1);
          }), M.xMap = p, w.graphPath = M, M;
        }
      }
      return D.defaultOptions = O(o.defaultOptions, { legendSymbol: "lineMarker" }), n.registerSeriesType("line", D), D;
    }), a(e, "Series/Area/AreaSeriesDefaults.js", [], function() {
      return { threshold: 0, legendSymbol: "areaMarker" };
    }), a(e, "Series/Area/AreaSeries.js", [e["Series/Area/AreaSeriesDefaults.js"], e["Core/Series/SeriesRegistry.js"], e["Core/Utilities.js"]], function(o, n, r) {
      let { seriesTypes: { line: T } } = n, { extend: O, merge: j, objectEach: D, pick: F } = r;
      class B extends T {
        drawGraph() {
          this.areaPath = [], super.drawGraph.apply(this);
          let { areaPath: f, options: w } = this;
          [this, ...this.zones].forEach((x, M) => {
            var A;
            let p = {}, v = x.fillColor || w.fillColor, k = x.area, m = k ? "animate" : "attr";
            k ? (k.endX = this.preventGraphAnimation ? null : f.xMap, k.animate({ d: f })) : (p.zIndex = 0, (k = x.area = this.chart.renderer.path(f).addClass("highcharts-area" + (M ? ` highcharts-zone-area-${M - 1} ` : " ") + (M && x.className || "")).add(this.group)).isArea = !0), this.chart.styledMode || (p.fill = v || x.color || this.color, p["fill-opacity"] = v ? 1 : (A = w.fillOpacity) != null ? A : 0.75, k.css({ pointerEvents: this.stickyTracking ? "none" : "auto" })), k[m](p), k.startX = f.xMap, k.shiftUnit = w.step ? 2 : 1;
          });
        }
        getGraphPath(f) {
          let w, x, M, p = T.prototype.getGraphPath, v = this.options, k = v.stacking, m = this.yAxis, A = [], C = [], H = this.index, G = m.stacking.stacks[this.stackKey], P = v.threshold, y = Math.round(m.getThreshold(v.threshold)), S = F(v.connectNulls, k === "percent"), d = function(h, g, E) {
            let R = f[h], L = k && G[R.x].points[H], U = R[E + "Null"] || 0, V = R[E + "Cliff"] || 0, q, Y, I = !0;
            V || U ? (q = (U ? L[0] : L[1]) + V, Y = L[0] + V, I = !!U) : !k && f[g] && f[g].isNull && (q = Y = P), q !== void 0 && (C.push({ plotX: w, plotY: q === null ? y : m.getThreshold(q), isNull: I, isCliff: !0 }), A.push({ plotX: w, plotY: Y === null ? y : m.getThreshold(Y), doCurve: !1 }));
          };
          f = f || this.points, k && (f = this.getStackPoints(f));
          for (let h = 0, g = f.length; h < g; ++h) k || (f[h].leftCliff = f[h].rightCliff = f[h].leftNull = f[h].rightNull = void 0), x = f[h].isNull, w = F(f[h].rectPlotX, f[h].plotX), M = k ? F(f[h].yBottom, y) : y, x && !S || (S || d(h, h - 1, "left"), x && !k && S || (C.push(f[h]), A.push({ x: h, plotX: w, plotY: M })), S || d(h, h + 1, "right"));
          let s = p.call(this, C, !0, !0);
          A.reversed = !0;
          let l = p.call(this, A, !0, !0), b = l[0];
          b && b[0] === "M" && (l[0] = ["L", b[1], b[2]]);
          let u = s.concat(l);
          u.length && u.push(["Z"]);
          let c = p.call(this, C, !1, S);
          return this.chart.series.length > 1 && k && C.some((h) => h.isCliff) && (u.hasStackedCliffs = c.hasStackedCliffs = !0), u.xMap = s.xMap, this.areaPath = u, c;
        }
        getStackPoints(f) {
          let w = this, x = [], M = [], p = this.xAxis, v = this.yAxis, k = v.stacking.stacks[this.stackKey], m = {}, A = v.series, C = A.length, H = v.options.reversedStacks ? 1 : -1, G = A.indexOf(w);
          if (f = f || this.points, this.options.stacking) {
            for (let y = 0; y < f.length; y++) f[y].leftNull = f[y].rightNull = void 0, m[f[y].x] = f[y];
            D(k, function(y, S) {
              y.total !== null && M.push(S);
            }), M.sort(function(y, S) {
              return y - S;
            });
            let P = A.map((y) => y.visible);
            M.forEach(function(y, S) {
              let d = 0, s, l;
              if (m[y] && !m[y].isNull) x.push(m[y]), [-1, 1].forEach(function(b) {
                let u = b === 1 ? "rightNull" : "leftNull", c = k[M[S + b]], h = 0;
                if (c) {
                  let g = G;
                  for (; g >= 0 && g < C; ) {
                    let E = A[g].index;
                    !(s = c.points[E]) && (E === w.index ? m[y][u] = !0 : P[g] && (l = k[y].points[E]) && (h -= l[1] - l[0])), g += H;
                  }
                }
                m[y][b === 1 ? "rightCliff" : "leftCliff"] = h;
              });
              else {
                let b = G;
                for (; b >= 0 && b < C; ) {
                  let u = A[b].index;
                  if (s = k[y].points[u]) {
                    d = s[1];
                    break;
                  }
                  b += H;
                }
                d = F(d, 0), d = v.translate(d, 0, 1, 0, 1), x.push({ isNull: !0, plotX: p.translate(y, 0, 0, 0, 1), x: y, plotY: d, yBottom: d });
              }
            });
          }
          return x;
        }
      }
      return B.defaultOptions = j(T.defaultOptions, o), O(B.prototype, { singleStacks: !1 }), n.registerSeriesType("area", B), B;
    }), a(e, "Series/Spline/SplineSeries.js", [e["Core/Series/SeriesRegistry.js"], e["Core/Utilities.js"]], function(o, n) {
      let { line: r } = o.seriesTypes, { merge: T, pick: O } = n;
      class j extends r {
        getPointSpline(F, B, N) {
          let f, w, x, M, p = B.plotX || 0, v = B.plotY || 0, k = F[N - 1], m = F[N + 1];
          function A(H) {
            return H && !H.isNull && H.doCurve !== !1 && !B.isCliff;
          }
          if (A(k) && A(m)) {
            let H = k.plotX || 0, G = k.plotY || 0, P = m.plotX || 0, y = m.plotY || 0, S = 0;
            f = (1.5 * p + H) / 2.5, w = (1.5 * v + G) / 2.5, x = (1.5 * p + P) / 2.5, M = (1.5 * v + y) / 2.5, x !== f && (S = (M - w) * (x - p) / (x - f) + v - M), w += S, M += S, w > G && w > v ? (w = Math.max(G, v), M = 2 * v - w) : w < G && w < v && (w = Math.min(G, v), M = 2 * v - w), M > y && M > v ? (M = Math.max(y, v), w = 2 * v - M) : M < y && M < v && (M = Math.min(y, v), w = 2 * v - M), B.rightContX = x, B.rightContY = M, B.controlPoints = { low: [f, w], high: [x, M] };
          }
          let C = ["C", O(k.rightContX, k.plotX, 0), O(k.rightContY, k.plotY, 0), O(f, p, 0), O(w, v, 0), p, v];
          return k.rightContX = k.rightContY = void 0, C;
        }
      }
      return j.defaultOptions = T(r.defaultOptions), o.registerSeriesType("spline", j), j;
    }), a(e, "Series/AreaSpline/AreaSplineSeries.js", [e["Series/Spline/SplineSeries.js"], e["Core/Series/SeriesRegistry.js"], e["Core/Utilities.js"]], function(o, n, r) {
      let { area: T, area: { prototype: O } } = n.seriesTypes, { extend: j, merge: D } = r;
      class F extends o {
      }
      return F.defaultOptions = D(o.defaultOptions, T.defaultOptions), j(F.prototype, { getGraphPath: O.getGraphPath, getStackPoints: O.getStackPoints, drawGraph: O.drawGraph }), n.registerSeriesType("areaspline", F), F;
    }), a(e, "Series/Column/ColumnSeriesDefaults.js", [], function() {
      return { borderRadius: 3, centerInCategory: !1, groupPadding: 0.2, marker: null, pointPadding: 0.1, minPointLength: 0, cropThreshold: 50, pointRange: null, states: { hover: { halo: !1, brightness: 0.1 }, select: { color: "#cccccc", borderColor: "#000000" } }, dataLabels: { align: void 0, verticalAlign: void 0, y: void 0 }, startFromThreshold: !0, stickyTracking: !1, tooltip: { distance: 6 }, threshold: 0, borderColor: "#ffffff" };
    }), a(e, "Series/Column/ColumnSeries.js", [e["Core/Animation/AnimationUtilities.js"], e["Core/Color/Color.js"], e["Series/Column/ColumnSeriesDefaults.js"], e["Core/Globals.js"], e["Core/Series/Series.js"], e["Core/Series/SeriesRegistry.js"], e["Core/Utilities.js"]], function(o, n, r, T, O, j, D) {
      let { animObject: F } = o, { parse: B } = n, { noop: N } = T, { clamp: f, crisp: w, defined: x, extend: M, fireEvent: p, isArray: v, isNumber: k, merge: m, pick: A, objectEach: C } = D;
      class H extends O {
        animate(P) {
          let y, S, d = this, s = this.yAxis, l = s.pos, b = s.reversed, u = d.options, { clipOffset: c, inverted: h } = this.chart, g = {}, E = h ? "translateX" : "translateY";
          P && c ? (g.scaleY = 1e-3, S = f(s.toPixels(u.threshold), l, l + s.len), h ? (S += b ? -Math.floor(c[0]) : Math.ceil(c[2]), g.translateX = S - s.len) : (S += b ? Math.ceil(c[0]) : -Math.floor(c[2]), g.translateY = S), d.clipBox && d.setClip(), d.group.attr(g)) : (y = Number(d.group.attr(E)), d.group.animate({ scaleY: 1 }, M(F(d.options.animation), { step: function(R, L) {
            d.group && (g[E] = y + L.pos * (l - y), d.group.attr(g));
          } })));
        }
        init(P, y) {
          super.init.apply(this, arguments);
          let S = this;
          (P = S.chart).hasRendered && P.series.forEach(function(d) {
            d.type === S.type && (d.isDirty = !0);
          });
        }
        getColumnMetrics() {
          var U, V;
          let P = this, y = P.options, S = P.xAxis, d = P.yAxis, s = S.options.reversedStacks, l = S.reversed && !s || !S.reversed && s, b = {}, u, c = 0;
          y.grouping === !1 ? c = 1 : P.chart.series.forEach(function(q) {
            let Y, I = q.yAxis, _ = q.options;
            q.type === P.type && q.reserveSpace() && d.len === I.len && d.pos === I.pos && (_.stacking && _.stacking !== "group" ? (b[u = q.stackKey] === void 0 && (b[u] = c++), Y = b[u]) : _.grouping !== !1 && (Y = c++), q.columnIndex = Y);
          });
          let h = Math.min(Math.abs(S.transA) * (!((U = S.brokenAxis) != null && U.hasBreaks) && ((V = S.ordinal) == null ? void 0 : V.slope) || y.pointRange || S.closestPointRange || S.tickInterval || 1), S.len), g = h * y.groupPadding, E = (h - 2 * g) / (c || 1), R = Math.min(y.maxPointWidth || S.len, A(y.pointWidth, E * (1 - 2 * y.pointPadding))), L = (P.columnIndex || 0) + (l ? 1 : 0);
          return P.columnMetrics = { width: R, offset: (E - R) / 2 + (g + L * E - h / 2) * (l ? -1 : 1), paddedWidth: E, columnCount: c }, P.columnMetrics;
        }
        crispCol(P, y, S, d) {
          let s = this.borderWidth, l = this.chart.inverted;
          return d = w(y + d, s, l) - (y = w(y, s, l)), this.options.crisp && (S = w(P + S, s) - (P = w(P, s))), { x: P, y, width: S, height: d };
        }
        adjustForMissingColumns(P, y, S, d) {
          var s;
          if (!S.isNull && d.columnCount > 1) {
            let l = this.xAxis.series.filter((h) => h.visible).map((h) => h.index), b = 0, u = 0;
            C((s = this.xAxis.stacking) == null ? void 0 : s.stacks, (h) => {
              if (typeof S.x == "number") {
                let g = h[S.x.toString()];
                if (g && v(g.points[this.index])) {
                  let E = Object.keys(g.points).filter((R) => !R.match(",") && g.points[R] && g.points[R].length > 1).map(parseFloat).filter((R) => l.indexOf(R) !== -1).sort((R, L) => L - R);
                  b = E.indexOf(this.index), u = E.length;
                }
              }
            }), b = this.xAxis.reversed ? u - 1 - b : b;
            let c = (u - 1) * d.paddedWidth + y;
            P = (S.plotX || 0) + c / 2 - y - b * d.paddedWidth;
          }
          return P;
        }
        translate() {
          let P = this, y = P.chart, S = P.options, d = P.dense = P.closestPointRange * P.xAxis.transA < 2, s = P.borderWidth = A(S.borderWidth, d ? 0 : 1), l = P.xAxis, b = P.yAxis, u = S.threshold, c = A(S.minPointLength, 5), h = P.getColumnMetrics(), g = h.width, E = P.pointXOffset = h.offset, R = P.dataMin, L = P.dataMax, U = P.translatedThreshold = b.getThreshold(u), V = P.barW = Math.max(g, 1 + 2 * s);
          S.pointPadding && (V = Math.ceil(V)), O.prototype.translate.apply(P), P.points.forEach(function(q) {
            let Y = A(q.yBottom, U), I = 999 + Math.abs(Y), _ = q.plotX || 0, W = f(q.plotY, -I, b.len + I), X, z = Math.min(W, Y), $ = Math.max(W, Y) - z, K = g, Q = _ + E, Z = V;
            c && Math.abs($) < c && ($ = c, X = !b.reversed && !q.negative || b.reversed && q.negative, k(u) && k(L) && q.y === u && L <= u && (b.min || 0) < u && (R !== L || (b.max || 0) <= u) && (X = !X, q.negative = !q.negative), z = Math.abs(z - U) > c ? Y - c : U - (X ? c : 0)), x(q.options.pointWidth) && (Q -= Math.round(((K = Z = Math.ceil(q.options.pointWidth)) - g) / 2)), S.centerInCategory && !S.stacking && (Q = P.adjustForMissingColumns(Q, K, q, h)), q.barX = Q, q.pointWidth = K, q.tooltipPos = y.inverted ? [f(b.len + b.pos - y.plotLeft - W, b.pos - y.plotLeft, b.len + b.pos - y.plotLeft), l.len + l.pos - y.plotTop - Q - Z / 2, $] : [l.left - y.plotLeft + Q + Z / 2, f(W + b.pos - y.plotTop, b.pos - y.plotTop, b.len + b.pos - y.plotTop), $], q.shapeType = P.pointClass.prototype.shapeType || "roundedRect", q.shapeArgs = P.crispCol(Q, q.isNull ? U : z, Z, q.isNull ? 0 : $);
          }), p(this, "afterColumnTranslate");
        }
        drawGraph() {
          this.group[this.dense ? "addClass" : "removeClass"]("highcharts-dense-data");
        }
        pointAttribs(P, y) {
          let S = this.options, d = this.pointAttrToOptions || {}, s = d.stroke || "borderColor", l = d["stroke-width"] || "borderWidth", b, u, c, h = P && P.color || this.color, g = P && P[s] || S[s] || h, E = P && P.options.dashStyle || S.dashStyle, R = P && P[l] || S[l] || this[l] || 0, L = A(P && P.opacity, S.opacity, 1);
          P && this.zones.length && (u = P.getZone(), h = P.options.color || u && (u.color || P.nonZonedColor) || this.color, u && (g = u.borderColor || g, E = u.dashStyle || E, R = u.borderWidth || R)), y && P && (c = (b = m(S.states[y], P.options.states && P.options.states[y] || {})).brightness, h = b.color || c !== void 0 && B(h).brighten(b.brightness).get() || h, g = b[s] || g, R = b[l] || R, E = b.dashStyle || E, L = A(b.opacity, L));
          let U = { fill: h, stroke: g, "stroke-width": R, opacity: L };
          return E && (U.dashstyle = E), U;
        }
        drawPoints(P = this.points) {
          let y, S = this, d = this.chart, s = S.options, l = d.renderer, b = s.animationLimit || 250;
          P.forEach(function(u) {
            let c = u.plotY, h = u.graphic, g = !!h, E = h && d.pointCount < b ? "animate" : "attr";
            k(c) && u.y !== null ? (y = u.shapeArgs, h && u.hasNewShapeType() && (h = h.destroy()), S.enabledDataSorting && (u.startXPos = S.xAxis.reversed ? -(y && y.width || 0) : S.xAxis.width), !h && (u.graphic = h = l[u.shapeType](y).add(u.group || S.group), h && S.enabledDataSorting && d.hasRendered && d.pointCount < b && (h.attr({ x: u.startXPos }), g = !0, E = "animate")), h && g && h[E](m(y)), d.styledMode || h[E](S.pointAttribs(u, u.selected && "select")).shadow(u.allowShadow !== !1 && s.shadow), h && (h.addClass(u.getClassName(), !0), h.attr({ visibility: u.visible ? "inherit" : "hidden" }))) : h && (u.graphic = h.destroy());
          });
        }
        drawTracker(P = this.points) {
          let y, S = this, d = S.chart, s = d.pointer, l = function(b) {
            let u = s == null ? void 0 : s.getPointFromEvent(b);
            s && u && S.options.enableMouseTracking && (s.isDirectTouch = !0, u.onMouseOver(b));
          };
          P.forEach(function(b) {
            y = v(b.dataLabels) ? b.dataLabels : b.dataLabel ? [b.dataLabel] : [], b.graphic && (b.graphic.element.point = b), y.forEach(function(u) {
              (u.div || u.element).point = b;
            });
          }), S._hasTracking || (S.trackerGroups.forEach(function(b) {
            S[b] && (S[b].addClass("highcharts-tracker").on("mouseover", l).on("mouseout", function(u) {
              s == null || s.onTrackerMouseOut(u);
            }).on("touchstart", l), !d.styledMode && S.options.cursor && S[b].css({ cursor: S.options.cursor }));
          }), S._hasTracking = !0), p(this, "afterDrawTracker");
        }
        remove() {
          let P = this, y = P.chart;
          y.hasRendered && y.series.forEach(function(S) {
            S.type === P.type && (S.isDirty = !0);
          }), O.prototype.remove.apply(P, arguments);
        }
      }
      return H.defaultOptions = m(O.defaultOptions, r), M(H.prototype, { directTouch: !0, getSymbol: N, negStacks: !0, trackerGroups: ["group", "dataLabelsGroup"] }), j.registerSeriesType("column", H), H;
    }), a(e, "Core/Series/DataLabel.js", [e["Core/Animation/AnimationUtilities.js"], e["Core/Templating.js"], e["Core/Utilities.js"]], function(o, n, r) {
      var T;
      let { getDeferredAnimation: O } = o, { format: j } = n, { defined: D, extend: F, fireEvent: B, isArray: N, isString: f, merge: w, objectEach: x, pick: M, pInt: p, splat: v } = r;
      return function(k) {
        function m() {
          return S(this).some((s) => s == null ? void 0 : s.enabled);
        }
        function A(s, l, b, u, c) {
          var W;
          let { chart: h, enabledDataSorting: g } = this, E = this.isCartesian && h.inverted, R = s.plotX, L = s.plotY, U = b.rotation || 0, V = D(R) && D(L) && h.isInsidePlot(R, Math.round(L), { inverted: E, paneCoordinates: !0, series: this }), q = U === 0 && M(b.overflow, g ? "none" : "justify") === "justify", Y = this.visible && s.visible !== !1 && D(R) && (s.series.forceDL || g && !q || V || M(b.inside, !!this.options.stacking) && u && h.isInsidePlot(R, E ? u.x + 1 : u.y + u.height - 1, { inverted: E, paneCoordinates: !0, series: this })), I = s.pos();
          if (Y && I) {
            var _;
            let X = l.getBBox(), z = l.getBBox(void 0, 0), $ = { right: 1, center: 0.5 }[b.align || 0] || 0, K = { bottom: 1, middle: 0.5 }[b.verticalAlign || 0] || 0;
            if (u = F({ x: I[0], y: Math.round(I[1]), width: 0, height: 0 }, u || {}), b.alignTo === "plotEdges" && this.isCartesian && (u[E ? "x" : "y"] = 0, u[E ? "width" : "height"] = ((W = this.yAxis) == null ? void 0 : W.len) || 0), F(b, { width: X.width, height: X.height }), _ = u, g && this.xAxis && !q && this.setDataLabelStartPos(s, l, c, V, _), l.align(w(b, { width: z.width, height: z.height }), !1, u, !1), l.alignAttr.x += $ * (z.width - X.width), l.alignAttr.y += K * (z.height - X.height), l[l.placed ? "animate" : "attr"]({ x: l.alignAttr.x + (X.width - z.width) / 2, y: l.alignAttr.y + (X.height - z.height) / 2, rotationOriginX: (l.width || 0) / 2, rotationOriginY: (l.height || 0) / 2 }), q && u.height >= 0) this.justifyDataLabel(l, b, l.alignAttr, X, u, c);
            else if (M(b.crop, !0)) {
              let { x: Q, y: Z } = l.alignAttr;
              Y = h.isInsidePlot(Q, Z, { paneCoordinates: !0, series: this }) && h.isInsidePlot(Q + X.width - 1, Z + X.height - 1, { paneCoordinates: !0, series: this });
            }
            b.shape && !U && l[c ? "attr" : "animate"]({ anchorX: I[0], anchorY: I[1] });
          }
          c && g && (l.placed = !1), Y || g && !q ? (l.show(), l.placed = !0) : (l.hide(), l.placed = !1);
        }
        function C() {
          return this.plotGroup("dataLabelsGroup", "data-labels", this.hasRendered ? "inherit" : "hidden", this.options.dataLabels.zIndex || 6);
        }
        function H(s) {
          let l = this.hasRendered || 0, b = this.initDataLabelsGroup().attr({ opacity: +l });
          return !l && b && (this.visible && b.show(), this.options.animation ? b.animate({ opacity: 1 }, s) : b.attr({ opacity: 1 })), b;
        }
        function G(s) {
          var Y;
          let l;
          s = s || this.points;
          let b = this, u = b.chart, c = b.options, h = u.renderer, { backgroundColor: g, plotBackgroundColor: E } = u.options.chart, R = h.getContrast(f(E) && E || f(g) && g || "#000000"), L = S(b), { animation: U, defer: V } = L[0], q = V ? O(u, U, b) : { defer: 0, duration: 0 };
          B(this, "drawDataLabels"), (Y = b.hasDataLabels) != null && Y.call(b) && (l = this.initDataLabels(q), s.forEach((I) => {
            var X, z;
            let _ = I.dataLabels || [];
            v(y(L, I.dlOptions || ((X = I.options) == null ? void 0 : X.dataLabels))).forEach(($, K) => {
              let Q = $.enabled && (I.visible || I.dataLabelOnHidden) && (!I.isNull || I.dataLabelOnNull) && function(le, de) {
                let be = de.filter;
                if (be) {
                  let ge = be.operator, me = le[be.property], fe = be.value;
                  return ge === ">" && me > fe || ge === "<" && me < fe || ge === ">=" && me >= fe || ge === "<=" && me <= fe || ge === "==" && me == fe || ge === "===" && me === fe || ge === "!=" && me != fe || ge === "!==" && me !== fe;
                }
                return !0;
              }(I, $), { backgroundColor: Z, borderColor: ee, distance: J, style: ae = {} } = $, re, ce, he, ne, te = {}, se = _[K], oe = !se, ie;
              Q && (ce = M($[I.formatPrefix + "Format"], $.format), re = I.getLabelConfig(), he = D(ce) ? j(ce, re, u) : ($[I.formatPrefix + "Formatter"] || $.formatter).call(re, $), ne = $.rotation, !u.styledMode && (ae.color = M($.color, ae.color, f(b.color) ? b.color : void 0, "#000000"), ae.color === "contrast" ? (Z !== "none" && (ie = Z), I.contrastColor = h.getContrast(ie !== "auto" && ie || I.color || b.color), ae.color = ie || !D(J) && $.inside || 0 > p(J || 0) || c.stacking ? I.contrastColor : R) : delete I.contrastColor, c.cursor && (ae.cursor = c.cursor)), te = { r: $.borderRadius || 0, rotation: ne, padding: $.padding, zIndex: 1 }, u.styledMode || (te.fill = Z === "auto" ? I.color : Z, te.stroke = ee === "auto" ? I.color : ee, te["stroke-width"] = $.borderWidth), x(te, (le, de) => {
                le === void 0 && delete te[de];
              })), !se || Q && D(he) && !!se.div == !!$.useHTML && (se.rotation && $.rotation || se.rotation === $.rotation) || (se = void 0, oe = !0), Q && D(he) && (se ? te.text = he : (se = h.label(he, 0, 0, $.shape, void 0, void 0, $.useHTML, void 0, "data-label")).addClass(" highcharts-data-label-color-" + I.colorIndex + " " + ($.className || "") + ($.useHTML ? " highcharts-tracker" : "")), se && (se.options = $, se.attr(te), u.styledMode ? ae.width && se.css({ width: ae.width, textOverflow: ae.textOverflow }) : se.css(ae).shadow($.shadow), B(se, "beforeAddingDataLabel", { labelOptions: $, point: I }), se.added || se.add(l), b.alignDataLabel(I, se, $, void 0, oe), se.isActive = !0, _[K] && _[K] !== se && _[K].destroy(), _[K] = se));
            });
            let W = _.length;
            for (; W--; ) _[W] && _[W].isActive ? _[W].isActive = !1 : ((z = _[W]) == null || z.destroy(), _.splice(W, 1));
            I.dataLabel = _[0], I.dataLabels = _;
          })), B(this, "afterDrawDataLabels");
        }
        function P(s, l, b, u, c, h) {
          let g = this.chart, E = l.align, R = l.verticalAlign, L = s.box ? 0 : s.padding || 0, U = g.inverted ? this.yAxis : this.xAxis, V = U ? U.left - g.plotLeft : 0, q = g.inverted ? this.xAxis : this.yAxis, Y = q ? q.top - g.plotTop : 0, { x: I = 0, y: _ = 0 } = l, W, X;
          return (W = (b.x || 0) + L + V) < 0 && (E === "right" && I >= 0 ? (l.align = "left", l.inside = !0) : I -= W, X = !0), (W = (b.x || 0) + u.width - L + V) > g.plotWidth && (E === "left" && I <= 0 ? (l.align = "right", l.inside = !0) : I += g.plotWidth - W, X = !0), (W = b.y + L + Y) < 0 && (R === "bottom" && _ >= 0 ? (l.verticalAlign = "top", l.inside = !0) : _ -= W, X = !0), (W = (b.y || 0) + u.height - L + Y) > g.plotHeight && (R === "top" && _ <= 0 ? (l.verticalAlign = "bottom", l.inside = !0) : _ += g.plotHeight - W, X = !0), X && (l.x = I, l.y = _, s.placed = !h, s.align(l, void 0, c)), X;
        }
        function y(s, l) {
          let b = [], u;
          if (N(s) && !N(l)) b = s.map(function(c) {
            return w(c, l);
          });
          else if (N(l) && !N(s)) b = l.map(function(c) {
            return w(s, c);
          });
          else if (N(s) || N(l)) {
            if (N(s) && N(l)) for (u = Math.max(s.length, l.length); u--; ) b[u] = w(s[u], l[u]);
          } else b = w(s, l);
          return b;
        }
        function S(s) {
          var b, u;
          let l = s.chart.options.plotOptions;
          return v(y(y((b = l == null ? void 0 : l.series) == null ? void 0 : b.dataLabels, (u = l == null ? void 0 : l[s.type]) == null ? void 0 : u.dataLabels), s.options.dataLabels));
        }
        function d(s, l, b, u, c) {
          let h = this.chart, g = h.inverted, E = this.xAxis, R = E.reversed, L = ((g ? l.height : l.width) || 0) / 2, U = s.pointWidth, V = U ? U / 2 : 0;
          l.startXPos = g ? c.x : R ? -L - V : E.width - L + V, l.startYPos = g ? R ? this.yAxis.height - L + V : -L - V : c.y, u ? l.visibility === "hidden" && (l.show(), l.attr({ opacity: 0 }).animate({ opacity: 1 })) : l.attr({ opacity: 1 }).animate({ opacity: 0 }, void 0, l.hide), h.hasRendered && (b && l.attr({ x: l.startXPos, y: l.startYPos }), l.placed = !0);
        }
        k.compose = function(s) {
          let l = s.prototype;
          l.initDataLabels || (l.initDataLabels = H, l.initDataLabelsGroup = C, l.alignDataLabel = A, l.drawDataLabels = G, l.justifyDataLabel = P, l.setDataLabelStartPos = d, l.hasDataLabels = m);
        };
      }(T || (T = {})), T;
    }), a(e, "Series/Column/ColumnDataLabel.js", [e["Core/Series/DataLabel.js"], e["Core/Globals.js"], e["Core/Series/SeriesRegistry.js"], e["Core/Utilities.js"]], function(o, n, r, T) {
      var O;
      let { composed: j } = n, { series: D } = r, { merge: F, pick: B, pushUnique: N } = T;
      return function(f) {
        function w(x, M, p, v, k) {
          let m = this.chart.inverted, A = x.series, C = (A.xAxis ? A.xAxis.len : this.chart.plotSizeX) || 0, H = (A.yAxis ? A.yAxis.len : this.chart.plotSizeY) || 0, G = x.dlBox || x.shapeArgs, P = B(x.below, x.plotY > B(this.translatedThreshold, H)), y = B(p.inside, !!this.options.stacking);
          if (G) {
            if (v = F(G), !(p.overflow === "allow" && p.crop === !1)) {
              v.y < 0 && (v.height += v.y, v.y = 0);
              let S = v.y + v.height - H;
              S > 0 && S < v.height - 1 && (v.height -= S);
            }
            m && (v = { x: H - v.y - v.height, y: C - v.x - v.width, width: v.height, height: v.width }), y || (m ? (v.x += P ? 0 : v.width, v.width = 0) : (v.y += P ? v.height : 0, v.height = 0));
          }
          p.align = B(p.align, !m || y ? "center" : P ? "right" : "left"), p.verticalAlign = B(p.verticalAlign, m || y ? "middle" : P ? "top" : "bottom"), D.prototype.alignDataLabel.call(this, x, M, p, v, k), p.inside && x.contrastColor && M.css({ color: x.contrastColor });
        }
        f.compose = function(x) {
          o.compose(D), N(j, "ColumnDataLabel") && (x.prototype.alignDataLabel = w);
        };
      }(O || (O = {})), O;
    }), a(e, "Series/Bar/BarSeries.js", [e["Series/Column/ColumnSeries.js"], e["Core/Series/SeriesRegistry.js"], e["Core/Utilities.js"]], function(o, n, r) {
      let { extend: T, merge: O } = r;
      class j extends o {
      }
      return j.defaultOptions = O(o.defaultOptions, {}), T(j.prototype, { inverted: !0 }), n.registerSeriesType("bar", j), j;
    }), a(e, "Series/Scatter/ScatterSeriesDefaults.js", [], function() {
      return { lineWidth: 0, findNearestPointBy: "xy", jitter: { x: 0, y: 0 }, marker: { enabled: !0 }, tooltip: { headerFormat: '<span style="color:{point.color}">●</span> <span style="font-size: 0.8em"> {series.name}</span><br/>', pointFormat: "x: <b>{point.x}</b><br/>y: <b>{point.y}</b><br/>" } };
    }), a(e, "Series/Scatter/ScatterSeries.js", [e["Series/Scatter/ScatterSeriesDefaults.js"], e["Core/Series/SeriesRegistry.js"], e["Core/Utilities.js"]], function(o, n, r) {
      let { column: T, line: O } = n.seriesTypes, { addEvent: j, extend: D, merge: F } = r;
      class B extends O {
        applyJitter() {
          let f = this, w = this.options.jitter, x = this.points.length;
          w && this.points.forEach(function(M, p) {
            ["x", "y"].forEach(function(v, k) {
              if (w[v] && !M.isNull) {
                let m = `plot${v.toUpperCase()}`, A = f[`${v}Axis`], C = w[v] * A.transA;
                if (A && !A.logarithmic) {
                  let H = Math.max(0, (M[m] || 0) - C), G = Math.min(A.len, (M[m] || 0) + C);
                  M[m] = H + (G - H) * function(P) {
                    let y = 1e4 * Math.sin(P);
                    return y - Math.floor(y);
                  }(p + k * x), v === "x" && (M.clientX = M.plotX);
                }
              }
            });
          });
        }
        drawGraph() {
          this.options.lineWidth ? super.drawGraph() : this.graph && (this.graph = this.graph.destroy());
        }
      }
      return B.defaultOptions = F(O.defaultOptions, o), D(B.prototype, { drawTracker: T.prototype.drawTracker, sorted: !1, requireSorting: !1, noSharedTooltip: !0, trackerGroups: ["group", "markerGroup", "dataLabelsGroup"] }), j(B, "afterTranslate", function() {
        this.applyJitter();
      }), n.registerSeriesType("scatter", B), B;
    }), a(e, "Series/CenteredUtilities.js", [e["Core/Globals.js"], e["Core/Series/Series.js"], e["Core/Utilities.js"]], function(o, n, r) {
      var T, O;
      let { deg2rad: j } = o, { fireEvent: D, isNumber: F, pick: B, relativeLength: N } = r;
      return (O = T || (T = {})).getCenter = function() {
        let f = this.options, w = this.chart, x = 2 * (f.slicedOffset || 0), M = w.plotWidth - 2 * x, p = w.plotHeight - 2 * x, v = f.center, k = Math.min(M, p), m = f.thickness, A, C = f.size, H = f.innerSize || 0, G, P;
        typeof C == "string" && (C = parseFloat(C)), typeof H == "string" && (H = parseFloat(H));
        let y = [B(v[0], "50%"), B(v[1], "50%"), B(C && C < 0 ? void 0 : f.size, "100%"), B(H && H < 0 ? void 0 : f.innerSize || 0, "0%")];
        for (!w.angular || this instanceof n || (y[3] = 0), G = 0; G < 4; ++G) P = y[G], A = G < 2 || G === 2 && /%$/.test(P), y[G] = N(P, [M, p, k, y[2]][G]) + (A ? x : 0);
        return y[3] > y[2] && (y[3] = y[2]), F(m) && 2 * m < y[2] && m > 0 && (y[3] = y[2] - 2 * m), D(this, "afterGetCenter", { positions: y }), y;
      }, O.getStartAndEndRadians = function(f, w) {
        let x = F(f) ? f : 0, M = F(w) && w > x && w - x < 360 ? w : x + 360;
        return { start: j * (x + -90), end: j * (M + -90) };
      }, T;
    }), a(e, "Series/Pie/PiePoint.js", [e["Core/Animation/AnimationUtilities.js"], e["Core/Series/Point.js"], e["Core/Utilities.js"]], function(o, n, r) {
      let { setAnimation: T } = o, { addEvent: O, defined: j, extend: D, isNumber: F, pick: B, relativeLength: N } = r;
      class f extends n {
        getConnectorPath(x) {
          let M = x.dataLabelPosition, p = x.options || {}, v = p.connectorShape, k = this.connectorShapes[v] || v;
          return M && k.call(this, { ...M.computed, alignment: M.alignment }, M.connectorPosition, p) || [];
        }
        getTranslate() {
          return this.sliced && this.slicedTranslation || { translateX: 0, translateY: 0 };
        }
        haloPath(x) {
          let M = this.shapeArgs;
          return this.sliced || !this.visible ? [] : this.series.chart.renderer.symbols.arc(M.x, M.y, M.r + x, M.r + x, { innerR: M.r - 1, start: M.start, end: M.end, borderRadius: M.borderRadius });
        }
        constructor(x, M, p) {
          var k;
          super(x, M, p), this.half = 0, (k = this.name) != null || (this.name = "Slice");
          let v = (m) => {
            this.slice(m.type === "select");
          };
          O(this, "select", v), O(this, "unselect", v);
        }
        isValid() {
          return F(this.y) && this.y >= 0;
        }
        setVisible(x, M = !0) {
          x !== this.visible && this.update({ visible: x != null ? x : !this.visible }, M, void 0, !1);
        }
        slice(x, M, p) {
          let v = this.series;
          T(p, v.chart), M = B(M, !0), this.sliced = this.options.sliced = x = j(x) ? x : !this.sliced, v.options.data[v.data.indexOf(this)] = this.options, this.graphic && this.graphic.animate(this.getTranslate());
        }
      }
      return D(f.prototype, { connectorShapes: { fixedOffset: function(w, x, M) {
        let p = x.breakAt, v = x.touchingSliceAt, k = M.softConnector ? ["C", w.x + (w.alignment === "left" ? -5 : 5), w.y, 2 * p.x - v.x, 2 * p.y - v.y, p.x, p.y] : ["L", p.x, p.y];
        return [["M", w.x, w.y], k, ["L", v.x, v.y]];
      }, straight: function(w, x) {
        let M = x.touchingSliceAt;
        return [["M", w.x, w.y], ["L", M.x, M.y]];
      }, crookedLine: function(w, x, M) {
        let { breakAt: p, touchingSliceAt: v } = x, { series: k } = this, [m, A, C] = k.center, H = C / 2, { plotLeft: G, plotWidth: P } = k.chart, y = w.alignment === "left", { x: S, y: d } = w, s = p.x;
        if (M.crookDistance) {
          let b = N(M.crookDistance, 1);
          s = y ? m + H + (P + G - m - H) * (1 - b) : G + (m - H) * b;
        } else s = m + (A - d) * Math.tan((this.angle || 0) - Math.PI / 2);
        let l = [["M", S, d]];
        return (y ? s <= S && s >= p.x : s >= S && s <= p.x) && l.push(["L", s, d]), l.push(["L", p.x, p.y], ["L", v.x, v.y]), l;
      } } }), f;
    }), a(e, "Series/Pie/PieSeriesDefaults.js", [], function() {
      return { borderRadius: 3, center: [null, null], clip: !1, colorByPoint: !0, dataLabels: { connectorPadding: 5, connectorShape: "crookedLine", crookDistance: void 0, distance: 30, enabled: !0, formatter: function() {
        return this.point.isNull ? void 0 : this.point.name;
      }, softConnector: !0, x: 0 }, fillColor: void 0, ignoreHiddenPoint: !0, inactiveOtherPoints: !0, legendType: "point", marker: null, size: null, showInLegend: !1, slicedOffset: 10, stickyTracking: !1, tooltip: { followPointer: !0 }, borderColor: "#ffffff", borderWidth: 1, lineWidth: void 0, states: { hover: { brightness: 0.1 } } };
    }), a(e, "Series/Pie/PieSeries.js", [e["Series/CenteredUtilities.js"], e["Series/Column/ColumnSeries.js"], e["Core/Globals.js"], e["Series/Pie/PiePoint.js"], e["Series/Pie/PieSeriesDefaults.js"], e["Core/Series/Series.js"], e["Core/Series/SeriesRegistry.js"], e["Core/Renderer/SVG/Symbols.js"], e["Core/Utilities.js"]], function(o, n, r, T, O, j, D, F, B) {
      let { getStartAndEndRadians: N } = o, { noop: f } = r, { clamp: w, extend: x, fireEvent: M, merge: p, pick: v } = B;
      class k extends j {
        animate(A) {
          let C = this, H = C.points, G = C.startAngleRad;
          A || H.forEach(function(P) {
            let y = P.graphic, S = P.shapeArgs;
            y && S && (y.attr({ r: v(P.startR, C.center && C.center[3] / 2), start: G, end: G }), y.animate({ r: S.r, start: S.start, end: S.end }, C.options.animation));
          });
        }
        drawEmpty() {
          let A, C, H = this.startAngleRad, G = this.endAngleRad, P = this.options;
          this.total === 0 && this.center ? (A = this.center[0], C = this.center[1], this.graph || (this.graph = this.chart.renderer.arc(A, C, this.center[1] / 2, 0, H, G).addClass("highcharts-empty-series").add(this.group)), this.graph.attr({ d: F.arc(A, C, this.center[2] / 2, 0, { start: H, end: G, innerR: this.center[3] / 2 }) }), this.chart.styledMode || this.graph.attr({ "stroke-width": P.borderWidth, fill: P.fillColor || "none", stroke: P.color || "#cccccc" })) : this.graph && (this.graph = this.graph.destroy());
        }
        drawPoints() {
          let A = this.chart.renderer;
          this.points.forEach(function(C) {
            C.graphic && C.hasNewShapeType() && (C.graphic = C.graphic.destroy()), C.graphic || (C.graphic = A[C.shapeType](C.shapeArgs).add(C.series.group), C.delayedRendering = !0);
          });
        }
        generatePoints() {
          super.generatePoints(), this.updateTotals();
        }
        getX(A, C, H, G) {
          let P = this.center, y = this.radii ? this.radii[H.index] || 0 : P[2] / 2, S = G.dataLabelPosition, d = (S == null ? void 0 : S.distance) || 0, s = Math.asin(w((A - P[1]) / (y + d), -1, 1));
          return P[0] + Math.cos(s) * (y + d) * (C ? -1 : 1) + (d > 0 ? (C ? -1 : 1) * (G.padding || 0) : 0);
        }
        hasData() {
          return !!this.processedXData.length;
        }
        redrawPoints() {
          let A, C, H, G, P = this, y = P.chart;
          this.drawEmpty(), P.group && !y.styledMode && P.group.shadow(P.options.shadow), P.points.forEach(function(S) {
            let d = {};
            C = S.graphic, !S.isNull && C ? (G = S.shapeArgs, A = S.getTranslate(), y.styledMode || (H = P.pointAttribs(S, S.selected && "select")), S.delayedRendering ? (C.setRadialReference(P.center).attr(G).attr(A), y.styledMode || C.attr(H).attr({ "stroke-linejoin": "round" }), S.delayedRendering = !1) : (C.setRadialReference(P.center), y.styledMode || p(!0, d, H), p(!0, d, G, A), C.animate(d)), C.attr({ visibility: S.visible ? "inherit" : "hidden" }), C.addClass(S.getClassName(), !0)) : C && (S.graphic = C.destroy());
          });
        }
        sortByAngle(A, C) {
          A.sort(function(H, G) {
            return H.angle !== void 0 && (G.angle - H.angle) * C;
          });
        }
        translate(A) {
          M(this, "translate"), this.generatePoints();
          let C = this.options, H = C.slicedOffset, G = N(C.startAngle, C.endAngle), P = this.startAngleRad = G.start, y = (this.endAngleRad = G.end) - P, S = this.points, d = C.ignoreHiddenPoint, s = S.length, l, b, u, c, h, g, E, R = 0;
          for (A || (this.center = A = this.getCenter()), g = 0; g < s; g++) {
            E = S[g], l = P + R * y, E.isValid() && (!d || E.visible) && (R += E.percentage / 100), b = P + R * y;
            let L = { x: A[0], y: A[1], r: A[2] / 2, innerR: A[3] / 2, start: Math.round(1e3 * l) / 1e3, end: Math.round(1e3 * b) / 1e3 };
            E.shapeType = "arc", E.shapeArgs = L, (u = (b + l) / 2) > 1.5 * Math.PI ? u -= 2 * Math.PI : u < -Math.PI / 2 && (u += 2 * Math.PI), E.slicedTranslation = { translateX: Math.round(Math.cos(u) * H), translateY: Math.round(Math.sin(u) * H) }, c = Math.cos(u) * A[2] / 2, h = Math.sin(u) * A[2] / 2, E.tooltipPos = [A[0] + 0.7 * c, A[1] + 0.7 * h], E.half = u < -Math.PI / 2 || u > Math.PI / 2 ? 1 : 0, E.angle = u;
          }
          M(this, "afterTranslate");
        }
        updateTotals() {
          let A = this.points, C = A.length, H = this.options.ignoreHiddenPoint, G, P, y = 0;
          for (G = 0; G < C; G++) (P = A[G]).isValid() && (!H || P.visible) && (y += P.y);
          for (G = 0, this.total = y; G < C; G++) (P = A[G]).percentage = y > 0 && (P.visible || !H) ? P.y / y * 100 : 0, P.total = y;
        }
      }
      return k.defaultOptions = p(j.defaultOptions, O), x(k.prototype, { axisTypes: [], directTouch: !0, drawGraph: void 0, drawTracker: n.prototype.drawTracker, getCenter: o.getCenter, getSymbol: f, invertible: !1, isCartesian: !1, noSharedTooltip: !0, pointAttribs: n.prototype.pointAttribs, pointClass: T, requireSorting: !1, searchPoint: f, trackerGroups: ["group", "dataLabelsGroup"] }), D.registerSeriesType("pie", k), k;
    }), a(e, "Series/Pie/PieDataLabel.js", [e["Core/Series/DataLabel.js"], e["Core/Globals.js"], e["Core/Renderer/RendererUtilities.js"], e["Core/Series/SeriesRegistry.js"], e["Core/Utilities.js"]], function(o, n, r, T, O) {
      var j;
      let { composed: D, noop: F } = n, { distribute: B } = r, { series: N } = T, { arrayMax: f, clamp: w, defined: x, pick: M, pushUnique: p, relativeLength: v } = O;
      return function(k) {
        let m = { radialDistributionY: function(P, y) {
          var S;
          return (((S = y.dataLabelPosition) == null ? void 0 : S.top) || 0) + P.distributeBox.pos;
        }, radialDistributionX: function(P, y, S, d, s) {
          let l = s.dataLabelPosition;
          return P.getX(S < ((l == null ? void 0 : l.top) || 0) + 2 || S > ((l == null ? void 0 : l.bottom) || 0) - 2 ? d : S, y.half, y, s);
        }, justify: function(P, y, S, d) {
          var s;
          return d[0] + (P.half ? -1 : 1) * (S + (((s = y.dataLabelPosition) == null ? void 0 : s.distance) || 0));
        }, alignToPlotEdges: function(P, y, S, d) {
          let s = P.getBBox().width;
          return y ? s + d : S - s - d;
        }, alignToConnectors: function(P, y, S, d) {
          let s = 0, l;
          return P.forEach(function(b) {
            (l = b.dataLabel.getBBox().width) > s && (s = l);
          }), y ? s + d : S - s - d;
        } };
        function A(P, y) {
          let { center: S, options: d } = this, s = S[2] / 2, l = P.angle || 0, b = Math.cos(l), u = Math.sin(l), c = S[0] + b * s, h = S[1] + u * s, g = Math.min((d.slicedOffset || 0) + (d.borderWidth || 0), y / 5);
          return { natural: { x: c + b * y, y: h + u * y }, computed: {}, alignment: y < 0 ? "center" : P.half ? "right" : "left", connectorPosition: { breakAt: { x: c + b * g, y: h + u * g }, touchingSliceAt: { x: c, y: h } }, distance: y };
        }
        function C() {
          var Y;
          let P = this, y = P.points, S = P.chart, d = S.plotWidth, s = S.plotHeight, l = S.plotLeft, b = Math.round(S.chartWidth / 3), u = P.center, c = u[2] / 2, h = u[1], g = [[], []], E = [0, 0, 0, 0], R = P.dataLabelPositioners, L, U, V, q = 0;
          P.visible && ((Y = P.hasDataLabels) != null && Y.call(P)) && (y.forEach((I) => {
            (I.dataLabels || []).forEach((_) => {
              _.shortened && (_.attr({ width: "auto" }).css({ width: "auto", textOverflow: "clip" }), _.shortened = !1);
            });
          }), N.prototype.drawDataLabels.apply(P), y.forEach((I) => {
            (I.dataLabels || []).forEach((_, W) => {
              var K;
              let X = u[2] / 2, z = _.options, $ = v((z == null ? void 0 : z.distance) || 0, X);
              W === 0 && g[I.half].push(I), !x((K = z == null ? void 0 : z.style) == null ? void 0 : K.width) && _.getBBox().width > b && (_.css({ width: Math.round(0.7 * b) + "px" }), _.shortened = !0), _.dataLabelPosition = this.getDataLabelPosition(I, $), q = Math.max(q, $);
            });
          }), g.forEach((I, _) => {
            let W = I.length, X = [], z, $, K = 0, Q;
            W && (P.sortByAngle(I, _ - 0.5), q > 0 && (z = Math.max(0, h - c - q), $ = Math.min(h + c + q, S.plotHeight), I.forEach((Z) => {
              (Z.dataLabels || []).forEach((ee) => {
                var ae;
                let J = ee.dataLabelPosition;
                J && J.distance > 0 && (J.top = Math.max(0, h - c - J.distance), J.bottom = Math.min(h + c + J.distance, S.plotHeight), K = ee.getBBox().height || 21, ee.lineHeight = S.renderer.fontMetrics(ee.text || ee).h + 2 * ee.padding, Z.distributeBox = { target: (((ae = ee.dataLabelPosition) == null ? void 0 : ae.natural.y) || 0) - J.top + ee.lineHeight / 2, size: K, rank: Z.y }, X.push(Z.distributeBox));
              });
            }), B(X, Q = $ + K - z, Q / 5)), I.forEach((Z) => {
              (Z.dataLabels || []).forEach((ee) => {
                let J = ee.options || {}, ae = Z.distributeBox, re = ee.dataLabelPosition, ce = (re == null ? void 0 : re.natural.y) || 0, he = J.connectorPadding || 0, ne = ee.lineHeight || 21, te = (ne - ee.getBBox().height) / 2, se = 0, oe = ce, ie = "inherit";
                if (re) {
                  if (X && x(ae) && re.distance > 0 && (ae.pos === void 0 ? ie = "hidden" : (V = ae.size, oe = R.radialDistributionY(Z, ee))), J.justify) se = R.justify(Z, ee, c, u);
                  else switch (J.alignTo) {
                    case "connectors":
                      se = R.alignToConnectors(I, _, d, l);
                      break;
                    case "plotEdges":
                      se = R.alignToPlotEdges(ee, _, d, l);
                      break;
                    default:
                      se = R.radialDistributionX(P, Z, oe - te, ce, ee);
                  }
                  if (re.attribs = { visibility: ie, align: re.alignment }, re.posAttribs = { x: se + (J.x || 0) + ({ left: he, right: -he }[re.alignment] || 0), y: oe + (J.y || 0) - ne / 2 }, re.computed.x = se, re.computed.y = oe - te, M(J.crop, !0)) {
                    let le;
                    se - (U = ee.getBBox().width) < he && _ === 1 ? (le = Math.round(U - se + he), E[3] = Math.max(le, E[3])) : se + U > d - he && _ === 0 && (le = Math.round(se + U - d + he), E[1] = Math.max(le, E[1])), oe - V / 2 < 0 ? E[0] = Math.max(Math.round(-oe + V / 2), E[0]) : oe + V / 2 > s && (E[2] = Math.max(Math.round(oe + V / 2 - s), E[2])), re.sideOverflow = le;
                  }
                }
              });
            }));
          }), (f(E) === 0 || this.verifyDataLabelOverflow(E)) && (this.placeDataLabels(), this.points.forEach((I) => {
            (I.dataLabels || []).forEach((_) => {
              var $;
              let { connectorColor: W, connectorWidth: X = 1 } = _.options || {}, z = _.dataLabelPosition;
              if (X) {
                let K;
                L = _.connector, z && z.distance > 0 ? (K = !L, L || (_.connector = L = S.renderer.path().addClass("highcharts-data-label-connector  highcharts-color-" + I.colorIndex + (I.className ? " " + I.className : "")).add(P.dataLabelsGroup)), S.styledMode || L.attr({ "stroke-width": X, stroke: W || I.color || "#666666" }), L[K ? "attr" : "animate"]({ d: I.getConnectorPath(_) }), L.attr({ visibility: ($ = z.attribs) == null ? void 0 : $.visibility })) : L && (_.connector = L.destroy());
              }
            });
          })));
        }
        function H() {
          this.points.forEach((P) => {
            (P.dataLabels || []).forEach((y) => {
              var d;
              let S = y.dataLabelPosition;
              S ? (S.sideOverflow && (y.css({ width: Math.max(y.getBBox().width - S.sideOverflow, 0) + "px", textOverflow: (((d = y.options) == null ? void 0 : d.style) || {}).textOverflow || "ellipsis" }), y.shortened = !0), y.attr(S.attribs), y[y.moved ? "animate" : "attr"](S.posAttribs), y.moved = !0) : y && y.attr({ y: -9999 });
            }), delete P.distributeBox;
          }, this);
        }
        function G(P) {
          let y = this.center, S = this.options, d = S.center, s = S.minSize || 80, l = s, b = S.size !== null;
          return !b && (d[0] !== null ? l = Math.max(y[2] - Math.max(P[1], P[3]), s) : (l = Math.max(y[2] - P[1] - P[3], s), y[0] += (P[3] - P[1]) / 2), d[1] !== null ? l = w(l, s, y[2] - Math.max(P[0], P[2])) : (l = w(l, s, y[2] - P[0] - P[2]), y[1] += (P[0] - P[2]) / 2), l < y[2] ? (y[2] = l, y[3] = Math.min(S.thickness ? Math.max(0, l - 2 * S.thickness) : Math.max(0, v(S.innerSize || 0, l)), l), this.translate(y), this.drawDataLabels && this.drawDataLabels()) : b = !0), b;
        }
        k.compose = function(P) {
          if (o.compose(N), p(D, "PieDataLabel")) {
            let y = P.prototype;
            y.dataLabelPositioners = m, y.alignDataLabel = F, y.drawDataLabels = C, y.getDataLabelPosition = A, y.placeDataLabels = H, y.verifyDataLabelOverflow = G;
          }
        };
      }(j || (j = {})), j;
    }), a(e, "Core/Geometry/GeometryUtilities.js", [], function() {
      var o, n;
      return (n = o || (o = {})).getCenterOfPoints = function(r) {
        let T = r.reduce((O, j) => (O.x += j.x, O.y += j.y, O), { x: 0, y: 0 });
        return { x: T.x / r.length, y: T.y / r.length };
      }, n.getDistanceBetweenPoints = function(r, T) {
        return Math.sqrt(Math.pow(T.x - r.x, 2) + Math.pow(T.y - r.y, 2));
      }, n.getAngleBetweenPoints = function(r, T) {
        return Math.atan2(T.x - r.x, T.y - r.y);
      }, n.pointInPolygon = function({ x: r, y: T }, O) {
        let j = O.length, D, F, B = !1;
        for (D = 0, F = j - 1; D < j; F = D++) {
          let [N, f] = O[D], [w, x] = O[F];
          f > T != x > T && r < (w - N) * (T - f) / (x - f) + N && (B = !B);
        }
        return B;
      }, o;
    }), a(e, "Extensions/OverlappingDataLabels.js", [e["Core/Geometry/GeometryUtilities.js"], e["Core/Utilities.js"]], function(o, n) {
      let { pointInPolygon: r } = o, { addEvent: T, fireEvent: O, objectEach: j, pick: D } = n;
      function F(f) {
        let w = f.length, x = (H, G) => !(G.x >= H.x + H.width || G.x + G.width <= H.x || G.y >= H.y + H.height || G.y + G.height <= H.y), M = (H, G) => {
          for (let P of H) if (r({ x: P[0], y: P[1] }, G)) return !0;
          return !1;
        }, p, v, k, m, A, C = !1;
        for (let H = 0; H < w; H++) (p = f[H]) && (p.oldOpacity = p.opacity, p.newOpacity = 1, p.absoluteBox = function(G) {
          var P, y;
          if (G && (!G.alignAttr || G.placed)) {
            let S = G.box ? 0 : G.padding || 0, d = G.alignAttr || { x: G.attr("x"), y: G.attr("y") }, s = G.getBBox();
            return G.width = s.width, G.height = s.height, { x: d.x + (((P = G.parentGroup) == null ? void 0 : P.translateX) || 0) + S, y: d.y + (((y = G.parentGroup) == null ? void 0 : y.translateY) || 0) + S, width: (G.width || 0) - 2 * S, height: (G.height || 0) - 2 * S, polygon: s == null ? void 0 : s.polygon };
          }
        }(p));
        f.sort((H, G) => (G.labelrank || 0) - (H.labelrank || 0));
        for (let H = 0; H < w; ++H) {
          m = (v = f[H]) && v.absoluteBox;
          let G = m == null ? void 0 : m.polygon;
          for (let P = H + 1; P < w; ++P) {
            A = (k = f[P]) && k.absoluteBox;
            let y = !1;
            if (m && A && v !== k && v.newOpacity !== 0 && k.newOpacity !== 0 && v.visibility !== "hidden" && k.visibility !== "hidden") {
              let S = A.polygon;
              if (G && S && G !== S ? M(G, S) && (y = !0) : x(m, A) && (y = !0), y) {
                let d = v.labelrank < k.labelrank ? v : k, s = d.text;
                d.newOpacity = 0, s != null && s.element.querySelector("textPath") && s.hide();
              }
            }
          }
        }
        for (let H of f) B(H, this) && (C = !0);
        C && O(this, "afterHideAllOverlappingLabels");
      }
      function B(f, w) {
        let x, M, p = !1;
        return f && (M = f.newOpacity, f.oldOpacity !== M && (f.hasClass("highcharts-data-label") ? (f[M ? "removeClass" : "addClass"]("highcharts-data-label-hidden"), x = function() {
          w.styledMode || f.css({ pointerEvents: M ? "auto" : "none" });
        }, p = !0, f[f.isOld ? "animate" : "attr"]({ opacity: M }, void 0, x), O(w, "afterHideOverlappingLabel")) : f.attr({ opacity: M })), f.isOld = !0), p;
      }
      function N() {
        var x;
        let f = this, w = [];
        for (let M of f.labelCollectors || []) w = w.concat(M());
        for (let M of f.yAxis || []) M.stacking && M.options.stackLabels && !M.options.stackLabels.allowOverlap && j(M.stacking.stacks, (p) => {
          j(p, (v) => {
            v.label && w.push(v.label);
          });
        });
        for (let M of f.series || []) if (M.visible && ((x = M.hasDataLabels) != null && x.call(M))) {
          let p = (v) => {
            for (let k of v) k.visible && (k.dataLabels || []).forEach((m) => {
              var C, H;
              let A = m.options || {};
              m.labelrank = D(A.labelrank, k.labelrank, (C = k.shapeArgs) == null ? void 0 : C.height), ((H = A.allowOverlap) != null ? H : Number(A.distance) > 0) ? (m.oldOpacity = m.opacity, m.newOpacity = 1, B(m, f)) : w.push(m);
            });
          };
          p(M.nodes || []), p(M.points);
        }
        this.hideOverlappingLabels(w);
      }
      return { compose: function(f) {
        let w = f.prototype;
        w.hideOverlappingLabels || (w.hideOverlappingLabels = F, T(f, "render", N));
      } };
    }), a(e, "Extensions/BorderRadius.js", [e["Core/Defaults.js"], e["Core/Globals.js"], e["Core/Utilities.js"]], function(o, n, r) {
      let { defaultOptions: T } = o, { noop: O } = n, { addEvent: j, extend: D, isObject: F, merge: B, relativeLength: N } = r, f = { radius: 0, scope: "stack", where: void 0 }, w = O, x = O;
      function M(A, C, H, G, P = {}) {
        let y = w(A, C, H, G, P), { innerR: S = 0, r: d = H, start: s = 0, end: l = 0 } = P;
        if (P.open || !P.borderRadius) return y;
        let b = l - s, u = Math.sin(b / 2), c = Math.max(Math.min(N(P.borderRadius || 0, d - S), (d - S) / 2, d * u / (1 + u)), 0), h = Math.min(c, b / Math.PI * 2 * S), g = y.length - 1;
        for (; g--; ) (function(E, R, L) {
          let U, V, q, Y = E[R], I = E[R + 1];
          if (I[0] === "Z" && (I = E[0]), (Y[0] === "M" || Y[0] === "L") && I[0] === "A" ? (U = Y, V = I, q = !0) : Y[0] === "A" && (I[0] === "M" || I[0] === "L") && (U = I, V = Y), U && V && V.params) {
            let _ = V[1], W = V[5], X = V.params, { start: z, end: $, cx: K, cy: Q } = X, Z = W ? _ - L : _ + L, ee = Z ? Math.asin(L / Z) : 0, J = W ? ee : -ee, ae = Math.cos(ee) * Z;
            q ? (X.start = z + J, U[1] = K + ae * Math.cos(z), U[2] = Q + ae * Math.sin(z), E.splice(R + 1, 0, ["A", L, L, 0, 0, 1, K + _ * Math.cos(X.start), Q + _ * Math.sin(X.start)])) : (X.end = $ - J, V[6] = K + _ * Math.cos(X.end), V[7] = Q + _ * Math.sin(X.end), E.splice(R + 1, 0, ["A", L, L, 0, 0, 1, K + ae * Math.cos($), Q + ae * Math.sin($)])), V[4] = Math.abs(X.end - X.start) < Math.PI ? 0 : 1;
          }
        })(y, g, g > 1 ? h : c);
        return y;
      }
      function p() {
        var A, C;
        if (this.options.borderRadius && !(this.chart.is3d && this.chart.is3d())) {
          let { options: H, yAxis: G } = this, P = H.stacking === "percent", y = (C = (A = T.plotOptions) == null ? void 0 : A[this.type]) == null ? void 0 : C.borderRadius, S = v(H.borderRadius, F(y) ? y : {}), d = G.options.reversed;
          for (let s of this.points) {
            let { shapeArgs: l } = s;
            if (s.shapeType === "roundedRect" && l) {
              let { width: b = 0, height: u = 0, y: c = 0 } = l, h = c, g = u;
              if (S.scope === "stack" && s.stackTotal) {
                let U = G.translate(P ? 100 : s.stackTotal, !1, !0, !1, !0), V = G.translate(H.threshold || 0, !1, !0, !1, !0), q = this.crispCol(0, Math.min(U, V), 0, Math.abs(U - V));
                h = q.y, g = q.height;
              }
              let E = (s.negative ? -1 : 1) * (d ? -1 : 1) == -1, R = S.where;
              !R && this.is("waterfall") && Math.abs((s.yBottom || 0) - (this.translatedThreshold || 0)) > this.borderWidth && (R = "all"), R || (R = "end");
              let L = Math.min(N(S.radius, b), b / 2, R === "all" ? u / 2 : 1 / 0) || 0;
              R === "end" && (E && (h -= L), g += L), D(l, { brBoxHeight: g, brBoxY: h, r: L });
            }
          }
        }
      }
      function v(A, C) {
        return F(A) || (A = { radius: A || 0 }), B(f, C, A);
      }
      function k() {
        let A = v(this.options.borderRadius);
        for (let C of this.points) {
          let H = C.shapeArgs;
          H && (H.borderRadius = N(A.radius, (H.r || 0) - (H.innerR || 0)));
        }
      }
      function m(A, C, H, G, P = {}) {
        let y = x(A, C, H, G, P), { r: S = 0, brBoxHeight: d = G, brBoxY: s = C } = P, l = C - s, b = s + d - (C + G), u = l - S > -0.1 ? 0 : S, c = b - S > -0.1 ? 0 : S, h = Math.max(u && l, 0), g = Math.max(c && b, 0), E = [A + u, C], R = [A + H - u, C], L = [A + H, C + u], U = [A + H, C + G - c], V = [A + H - c, C + G], q = [A + c, C + G], Y = [A, C + G - c], I = [A, C + u], _ = (W, X) => Math.sqrt(Math.pow(W, 2) - Math.pow(X, 2));
        if (h) {
          let W = _(u, u - h);
          E[0] -= W, R[0] += W, L[1] = I[1] = C + u - h;
        }
        if (G < u - h) {
          let W = _(u, u - h - G);
          L[0] = U[0] = A + H - u + W, V[0] = Math.min(L[0], V[0]), q[0] = Math.max(U[0], q[0]), Y[0] = I[0] = A + u - W, L[1] = I[1] = C + G;
        }
        if (g) {
          let W = _(c, c - g);
          V[0] += W, q[0] -= W, U[1] = Y[1] = C + G - c + g;
        }
        if (G < c - g) {
          let W = _(c, c - g - G);
          L[0] = U[0] = A + H - c + W, R[0] = Math.min(L[0], R[0]), E[0] = Math.max(U[0], E[0]), Y[0] = I[0] = A + c - W, U[1] = Y[1] = C;
        }
        return y.length = 0, y.push(["M", ...E], ["L", ...R], ["A", u, u, 0, 0, 1, ...L], ["L", ...U], ["A", c, c, 0, 0, 1, ...V], ["L", ...q], ["A", c, c, 0, 0, 1, ...Y], ["L", ...I], ["A", u, u, 0, 0, 1, ...E], ["Z"]), y;
      }
      return { compose: function(A, C, H) {
        let G = A.types.pie;
        if (!C.symbolCustomAttribs.includes("borderRadius")) {
          let P = H.prototype.symbols;
          j(A, "afterColumnTranslate", p, { order: 9 }), j(G, "afterTranslate", k), C.symbolCustomAttribs.push("borderRadius", "brBoxHeight", "brBoxY"), w = P.arc, x = P.roundedRect, P.arc = M, P.roundedRect = m;
        }
      }, optionsToObject: v };
    }), a(e, "Core/Responsive.js", [e["Core/Utilities.js"]], function(o) {
      var n;
      let { diffObjects: r, extend: T, find: O, merge: j, pick: D, uniqueKey: F } = o;
      return function(B) {
        function N(w, x) {
          let M = w.condition;
          (M.callback || function() {
            return this.chartWidth <= D(M.maxWidth, Number.MAX_VALUE) && this.chartHeight <= D(M.maxHeight, Number.MAX_VALUE) && this.chartWidth >= D(M.minWidth, 0) && this.chartHeight >= D(M.minHeight, 0);
          }).call(this) && x.push(w._id);
        }
        function f(w, x) {
          let M = this.options.responsive, p = this.currentResponsive, v = [], k;
          !x && M && M.rules && M.rules.forEach((C) => {
            C._id === void 0 && (C._id = F()), this.matchResponsiveRule(C, v);
          }, this);
          let m = j(...v.map((C) => O((M || {}).rules || [], (H) => H._id === C)).map((C) => C && C.chartOptions));
          m.isResponsiveOptions = !0, v = v.toString() || void 0;
          let A = p && p.ruleIds;
          v === A || (p && (this.currentResponsive = void 0, this.updatingResponsive = !0, this.update(p.undoOptions, w, !0), this.updatingResponsive = !1), v ? ((k = r(m, this.options, !0, this.collectionsWithUpdate)).isResponsiveOptions = !0, this.currentResponsive = { ruleIds: v, mergedOptions: m, undoOptions: k }, this.updatingResponsive || this.update(m, w, !0)) : this.currentResponsive = void 0);
        }
        B.compose = function(w) {
          let x = w.prototype;
          return x.matchResponsiveRule || T(x, { matchResponsiveRule: N, setResponsive: f }), w;
        };
      }(n || (n = {})), n;
    }), a(e, "masters/highcharts.src.js", [e["Core/Globals.js"], e["Core/Utilities.js"], e["Core/Defaults.js"], e["Core/Animation/Fx.js"], e["Core/Animation/AnimationUtilities.js"], e["Core/Renderer/HTML/AST.js"], e["Core/Templating.js"], e["Core/Renderer/RendererRegistry.js"], e["Core/Renderer/RendererUtilities.js"], e["Core/Renderer/SVG/SVGElement.js"], e["Core/Renderer/SVG/SVGRenderer.js"], e["Core/Renderer/HTML/HTMLElement.js"], e["Core/Axis/Axis.js"], e["Core/Axis/DateTimeAxis.js"], e["Core/Axis/LogarithmicAxis.js"], e["Core/Axis/PlotLineOrBand/PlotLineOrBand.js"], e["Core/Axis/Tick.js"], e["Core/Tooltip.js"], e["Core/Series/Point.js"], e["Core/Pointer.js"], e["Core/Legend/Legend.js"], e["Core/Legend/LegendSymbol.js"], e["Core/Chart/Chart.js"], e["Extensions/ScrollablePlotArea.js"], e["Core/Axis/Stacking/StackingAxis.js"], e["Core/Axis/Stacking/StackItem.js"], e["Core/Series/Series.js"], e["Core/Series/SeriesRegistry.js"], e["Series/Column/ColumnDataLabel.js"], e["Series/Pie/PieDataLabel.js"], e["Core/Series/DataLabel.js"], e["Extensions/OverlappingDataLabels.js"], e["Extensions/BorderRadius.js"], e["Core/Responsive.js"], e["Core/Color/Color.js"], e["Core/Time.js"]], function(o, n, r, T, O, j, D, F, B, N, f, w, x, M, p, v, k, m, A, C, H, G, P, y, S, d, s, l, b, u, c, h, g, E, R, L) {
      return o.AST = j, o.Axis = x, o.Chart = P, o.Color = R, o.DataLabel = c, o.Fx = T, o.HTMLElement = w, o.Legend = H, o.LegendSymbol = G, o.OverlappingDataLabels = o.OverlappingDataLabels || h, o.PlotLineOrBand = v, o.Point = A, o.Pointer = C, o.RendererRegistry = F, o.Series = s, o.SeriesRegistry = l, o.StackItem = d, o.SVGElement = N, o.SVGRenderer = f, o.Templating = D, o.Tick = k, o.Time = L, o.Tooltip = m, o.animate = O.animate, o.animObject = O.animObject, o.chart = P.chart, o.color = R.parse, o.dateFormat = D.dateFormat, o.defaultOptions = r.defaultOptions, o.distribute = B.distribute, o.format = D.format, o.getDeferredAnimation = O.getDeferredAnimation, o.getOptions = r.getOptions, o.numberFormat = D.numberFormat, o.seriesType = l.seriesType, o.setAnimation = O.setAnimation, o.setOptions = r.setOptions, o.stop = O.stop, o.time = r.defaultTime, o.timers = T.timers, g.compose(o.Series, o.SVGElement, o.SVGRenderer), b.compose(o.Series.types.column), c.compose(o.Series), M.compose(o.Axis), w.compose(o.SVGRenderer), H.compose(o.Chart), p.compose(o.Axis), h.compose(o.Chart), u.compose(o.Series.types.pie), v.compose(o.Chart, o.Axis), C.compose(o.Chart), E.compose(o.Chart), y.compose(o.Axis, o.Chart, o.Series), S.compose(o.Axis, o.Chart, o.Series), m.compose(o.Pointer), n.extend(o, n), o;
    }), e["masters/highcharts.src.js"]._modules = e, e["masters/highcharts.src.js"];
  });
})(em);
var ma = em.exports;
const zo = /* @__PURE__ */ fi(ma);
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const ll = globalThis, Ri = ll.ShadowRoot && (ll.ShadyCSS === void 0 || ll.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, vh = Symbol(), ep = /* @__PURE__ */ new WeakMap();
let tm = class {
  constructor(t, e, a) {
    if (this._$cssResult$ = !0, a !== vh) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
    this.cssText = t, this.t = e;
  }
  get styleSheet() {
    let t = this.o;
    const e = this.t;
    if (Ri && t === void 0) {
      const a = e !== void 0 && e.length === 1;
      a && (t = ep.get(e)), t === void 0 && ((this.o = t = new CSSStyleSheet()).replaceSync(this.cssText), a && ep.set(e, t));
    }
    return t;
  }
  toString() {
    return this.cssText;
  }
};
const $v = (i) => new tm(typeof i == "string" ? i : i + "", void 0, vh), ve = (i, ...t) => {
  const e = i.length === 1 ? i[0] : t.reduce((a, o, n) => a + ((r) => {
    if (r._$cssResult$ === !0) return r.cssText;
    if (typeof r == "number") return r;
    throw Error("Value passed to 'css' function must be a 'css' function result: " + r + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
  })(o) + i[n + 1], i[0]);
  return new tm(e, i, vh);
}, Hv = (i, t) => {
  if (Ri) i.adoptedStyleSheets = t.map((e) => e instanceof CSSStyleSheet ? e : e.styleSheet);
  else for (const e of t) {
    const a = document.createElement("style"), o = ll.litNonce;
    o !== void 0 && a.setAttribute("nonce", o), a.textContent = e.cssText, i.appendChild(a);
  }
}, tp = Ri ? (i) => i : (i) => i instanceof CSSStyleSheet ? ((t) => {
  let e = "";
  for (const a of t.cssRules) e += a.cssText;
  return $v(e);
})(i) : i;
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const { is: Kv, defineProperty: Gv, getOwnPropertyDescriptor: Wv, getOwnPropertyNames: qv, getOwnPropertySymbols: Vv, getPrototypeOf: Yv } = Object, ii = globalThis, op = ii.trustedTypes, Qv = op ? op.emptyScript : "", Uc = ii.reactiveElementPolyfillSupport, $r = (i, t) => i, gl = { toAttribute(i, t) {
  switch (t) {
    case Boolean:
      i = i ? Qv : null;
      break;
    case Object:
    case Array:
      i = i == null ? i : JSON.stringify(i);
  }
  return i;
}, fromAttribute(i, t) {
  let e = i;
  switch (t) {
    case Boolean:
      e = i !== null;
      break;
    case Number:
      e = i === null ? null : Number(i);
      break;
    case Object:
    case Array:
      try {
        e = JSON.parse(i);
      } catch {
        e = null;
      }
  }
  return e;
} }, rc = (i, t) => !Kv(i, t), ap = { attribute: !0, type: String, converter: gl, reflect: !1, hasChanged: rc };
var Wg, qg;
(Wg = Symbol.metadata) != null || (Symbol.metadata = Symbol("metadata")), (qg = ii.litPropertyMetadata) != null || (ii.litPropertyMetadata = /* @__PURE__ */ new WeakMap());
class Dn extends HTMLElement {
  static addInitializer(t) {
    var e;
    this._$Ei(), ((e = this.l) != null ? e : this.l = []).push(t);
  }
  static get observedAttributes() {
    return this.finalize(), this._$Eh && [...this._$Eh.keys()];
  }
  static createProperty(t, e = ap) {
    if (e.state && (e.attribute = !1), this._$Ei(), this.elementProperties.set(t, e), !e.noAccessor) {
      const a = Symbol(), o = this.getPropertyDescriptor(t, a, e);
      o !== void 0 && Gv(this.prototype, t, o);
    }
  }
  static getPropertyDescriptor(t, e, a) {
    var r;
    const { get: o, set: n } = (r = Wv(this.prototype, t)) != null ? r : { get() {
      return this[e];
    }, set(T) {
      this[e] = T;
    } };
    return { get() {
      return o == null ? void 0 : o.call(this);
    }, set(T) {
      const O = o == null ? void 0 : o.call(this);
      n.call(this, T), this.requestUpdate(t, O, a);
    }, configurable: !0, enumerable: !0 };
  }
  static getPropertyOptions(t) {
    var e;
    return (e = this.elementProperties.get(t)) != null ? e : ap;
  }
  static _$Ei() {
    if (this.hasOwnProperty($r("elementProperties"))) return;
    const t = Yv(this);
    t.finalize(), t.l !== void 0 && (this.l = [...t.l]), this.elementProperties = new Map(t.elementProperties);
  }
  static finalize() {
    if (this.hasOwnProperty($r("finalized"))) return;
    if (this.finalized = !0, this._$Ei(), this.hasOwnProperty($r("properties"))) {
      const e = this.properties, a = [...qv(e), ...Vv(e)];
      for (const o of a) this.createProperty(o, e[o]);
    }
    const t = this[Symbol.metadata];
    if (t !== null) {
      const e = litPropertyMetadata.get(t);
      if (e !== void 0) for (const [a, o] of e) this.elementProperties.set(a, o);
    }
    this._$Eh = /* @__PURE__ */ new Map();
    for (const [e, a] of this.elementProperties) {
      const o = this._$Eu(e, a);
      o !== void 0 && this._$Eh.set(o, e);
    }
    this.elementStyles = this.finalizeStyles(this.styles);
  }
  static finalizeStyles(t) {
    const e = [];
    if (Array.isArray(t)) {
      const a = new Set(t.flat(1 / 0).reverse());
      for (const o of a) e.unshift(tp(o));
    } else t !== void 0 && e.push(tp(t));
    return e;
  }
  static _$Eu(t, e) {
    const a = e.attribute;
    return a === !1 ? void 0 : typeof a == "string" ? a : typeof t == "string" ? t.toLowerCase() : void 0;
  }
  constructor() {
    super(), this._$Ep = void 0, this.isUpdatePending = !1, this.hasUpdated = !1, this._$Em = null, this._$Ev();
  }
  _$Ev() {
    var t;
    this._$ES = new Promise((e) => this.enableUpdating = e), this._$AL = /* @__PURE__ */ new Map(), this._$E_(), this.requestUpdate(), (t = this.constructor.l) == null || t.forEach((e) => e(this));
  }
  addController(t) {
    var e, a;
    ((e = this._$EO) != null ? e : this._$EO = /* @__PURE__ */ new Set()).add(t), this.renderRoot !== void 0 && this.isConnected && ((a = t.hostConnected) == null || a.call(t));
  }
  removeController(t) {
    var e;
    (e = this._$EO) == null || e.delete(t);
  }
  _$E_() {
    const t = /* @__PURE__ */ new Map(), e = this.constructor.elementProperties;
    for (const a of e.keys()) this.hasOwnProperty(a) && (t.set(a, this[a]), delete this[a]);
    t.size > 0 && (this._$Ep = t);
  }
  createRenderRoot() {
    var e;
    const t = (e = this.shadowRoot) != null ? e : this.attachShadow(this.constructor.shadowRootOptions);
    return Hv(t, this.constructor.elementStyles), t;
  }
  connectedCallback() {
    var t, e;
    (t = this.renderRoot) != null || (this.renderRoot = this.createRenderRoot()), this.enableUpdating(!0), (e = this._$EO) == null || e.forEach((a) => {
      var o;
      return (o = a.hostConnected) == null ? void 0 : o.call(a);
    });
  }
  enableUpdating(t) {
  }
  disconnectedCallback() {
    var t;
    (t = this._$EO) == null || t.forEach((e) => {
      var a;
      return (a = e.hostDisconnected) == null ? void 0 : a.call(e);
    });
  }
  attributeChangedCallback(t, e, a) {
    this._$AK(t, a);
  }
  _$EC(t, e) {
    var n;
    const a = this.constructor.elementProperties.get(t), o = this.constructor._$Eu(t, a);
    if (o !== void 0 && a.reflect === !0) {
      const r = (((n = a.converter) == null ? void 0 : n.toAttribute) !== void 0 ? a.converter : gl).toAttribute(e, a.type);
      this._$Em = t, r == null ? this.removeAttribute(o) : this.setAttribute(o, r), this._$Em = null;
    }
  }
  _$AK(t, e) {
    var n;
    const a = this.constructor, o = a._$Eh.get(t);
    if (o !== void 0 && this._$Em !== o) {
      const r = a.getPropertyOptions(o), T = typeof r.converter == "function" ? { fromAttribute: r.converter } : ((n = r.converter) == null ? void 0 : n.fromAttribute) !== void 0 ? r.converter : gl;
      this._$Em = o, this[o] = T.fromAttribute(e, r.type), this._$Em = null;
    }
  }
  requestUpdate(t, e, a) {
    var o;
    if (t !== void 0) {
      if (a != null || (a = this.constructor.getPropertyOptions(t)), !((o = a.hasChanged) != null ? o : rc)(this[t], e)) return;
      this.P(t, e, a);
    }
    this.isUpdatePending === !1 && (this._$ES = this._$ET());
  }
  P(t, e, a) {
    var o;
    this._$AL.has(t) || this._$AL.set(t, e), a.reflect === !0 && this._$Em !== t && ((o = this._$Ej) != null ? o : this._$Ej = /* @__PURE__ */ new Set()).add(t);
  }
  async _$ET() {
    this.isUpdatePending = !0;
    try {
      await this._$ES;
    } catch (e) {
      Promise.reject(e);
    }
    const t = this.scheduleUpdate();
    return t != null && await t, !this.isUpdatePending;
  }
  scheduleUpdate() {
    return this.performUpdate();
  }
  performUpdate() {
    var a, o;
    if (!this.isUpdatePending) return;
    if (!this.hasUpdated) {
      if ((a = this.renderRoot) != null || (this.renderRoot = this.createRenderRoot()), this._$Ep) {
        for (const [r, T] of this._$Ep) this[r] = T;
        this._$Ep = void 0;
      }
      const n = this.constructor.elementProperties;
      if (n.size > 0) for (const [r, T] of n) T.wrapped !== !0 || this._$AL.has(r) || this[r] === void 0 || this.P(r, this[r], T);
    }
    let t = !1;
    const e = this._$AL;
    try {
      t = this.shouldUpdate(e), t ? (this.willUpdate(e), (o = this._$EO) == null || o.forEach((n) => {
        var r;
        return (r = n.hostUpdate) == null ? void 0 : r.call(n);
      }), this.update(e)) : this._$EU();
    } catch (n) {
      throw t = !1, this._$EU(), n;
    }
    t && this._$AE(e);
  }
  willUpdate(t) {
  }
  _$AE(t) {
    var e;
    (e = this._$EO) == null || e.forEach((a) => {
      var o;
      return (o = a.hostUpdated) == null ? void 0 : o.call(a);
    }), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t)), this.updated(t);
  }
  _$EU() {
    this._$AL = /* @__PURE__ */ new Map(), this.isUpdatePending = !1;
  }
  get updateComplete() {
    return this.getUpdateComplete();
  }
  getUpdateComplete() {
    return this._$ES;
  }
  shouldUpdate(t) {
    return !0;
  }
  update(t) {
    this._$Ej && (this._$Ej = this._$Ej.forEach((e) => this._$EC(e, this[e]))), this._$EU();
  }
  updated(t) {
  }
  firstUpdated(t) {
  }
}
var Vg;
Dn.elementStyles = [], Dn.shadowRootOptions = { mode: "open" }, Dn[$r("elementProperties")] = /* @__PURE__ */ new Map(), Dn[$r("finalized")] = /* @__PURE__ */ new Map(), Uc == null || Uc({ ReactiveElement: Dn }), ((Vg = ii.reactiveElementVersions) != null ? Vg : ii.reactiveElementVersions = []).push("2.0.4");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const Hr = globalThis, ml = Hr.trustedTypes, ip = ml ? ml.createPolicy("lit-html", { createHTML: (i) => i }) : void 0, om = "$lit$", Za = `lit$${Math.random().toFixed(9).slice(2)}$`, am = "?" + Za, Xv = `<${am}>`, Ji = document, Qr = () => Ji.createComment(""), Xr = (i) => i === null || typeof i != "object" && typeof i != "function", Ah = Array.isArray, Zv = (i) => Ah(i) || typeof (i == null ? void 0 : i[Symbol.iterator]) == "function", jc = `[ 	
\f\r]`, Tr = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, np = /-->/g, rp = />/g, Ti = RegExp(`>|${jc}(?:([^\\s"'>=/]+)(${jc}*=${jc}*(?:[^ 	
\f\r"'\`<>=]|("|')|))|$)`, "g"), sp = /'/g, lp = /"/g, im = /^(?:script|style|textarea|title)$/i, Jv = (i) => (t, ...e) => ({ _$litType$: i, strings: t, values: e }), pe = Jv(1), Qo = Symbol.for("lit-noChange"), _e = Symbol.for("lit-nothing"), cp = /* @__PURE__ */ new WeakMap(), Ni = Ji.createTreeWalker(Ji, 129);
function nm(i, t) {
  if (!Ah(i) || !i.hasOwnProperty("raw")) throw Error("invalid template strings array");
  return ip !== void 0 ? ip.createHTML(t) : t;
}
const eA = (i, t) => {
  const e = i.length - 1, a = [];
  let o, n = t === 2 ? "<svg>" : t === 3 ? "<math>" : "", r = Tr;
  for (let T = 0; T < e; T++) {
    const O = i[T];
    let j, D, F = -1, B = 0;
    for (; B < O.length && (r.lastIndex = B, D = r.exec(O), D !== null); ) B = r.lastIndex, r === Tr ? D[1] === "!--" ? r = np : D[1] !== void 0 ? r = rp : D[2] !== void 0 ? (im.test(D[2]) && (o = RegExp("</" + D[2], "g")), r = Ti) : D[3] !== void 0 && (r = Ti) : r === Ti ? D[0] === ">" ? (r = o != null ? o : Tr, F = -1) : D[1] === void 0 ? F = -2 : (F = r.lastIndex - D[2].length, j = D[1], r = D[3] === void 0 ? Ti : D[3] === '"' ? lp : sp) : r === lp || r === sp ? r = Ti : r === np || r === rp ? r = Tr : (r = Ti, o = void 0);
    const N = r === Ti && i[T + 1].startsWith("/>") ? " " : "";
    n += r === Tr ? O + Xv : F >= 0 ? (a.push(j), O.slice(0, F) + om + O.slice(F) + Za + N) : O + Za + (F === -2 ? T : N);
  }
  return [nm(i, n + (i[e] || "<?>") + (t === 2 ? "</svg>" : t === 3 ? "</math>" : "")), a];
};
class Zr {
  constructor({ strings: t, _$litType$: e }, a) {
    let o;
    this.parts = [];
    let n = 0, r = 0;
    const T = t.length - 1, O = this.parts, [j, D] = eA(t, e);
    if (this.el = Zr.createElement(j, a), Ni.currentNode = this.el.content, e === 2 || e === 3) {
      const F = this.el.content.firstChild;
      F.replaceWith(...F.childNodes);
    }
    for (; (o = Ni.nextNode()) !== null && O.length < T; ) {
      if (o.nodeType === 1) {
        if (o.hasAttributes()) for (const F of o.getAttributeNames()) if (F.endsWith(om)) {
          const B = D[r++], N = o.getAttribute(F).split(Za), f = /([.?@])?(.*)/.exec(B);
          O.push({ type: 1, index: n, name: f[2], strings: N, ctor: f[1] === "." ? oA : f[1] === "?" ? aA : f[1] === "@" ? iA : sc }), o.removeAttribute(F);
        } else F.startsWith(Za) && (O.push({ type: 6, index: n }), o.removeAttribute(F));
        if (im.test(o.tagName)) {
          const F = o.textContent.split(Za), B = F.length - 1;
          if (B > 0) {
            o.textContent = ml ? ml.emptyScript : "";
            for (let N = 0; N < B; N++) o.append(F[N], Qr()), Ni.nextNode(), O.push({ type: 2, index: ++n });
            o.append(F[B], Qr());
          }
        }
      } else if (o.nodeType === 8) if (o.data === am) O.push({ type: 2, index: n });
      else {
        let F = -1;
        for (; (F = o.data.indexOf(Za, F + 1)) !== -1; ) O.push({ type: 7, index: n }), F += Za.length - 1;
      }
      n++;
    }
  }
  static createElement(t, e) {
    const a = Ji.createElement("template");
    return a.innerHTML = t, a;
  }
}
function Xn(i, t, e = i, a) {
  var r, T, O;
  if (t === Qo) return t;
  let o = a !== void 0 ? (r = e._$Co) == null ? void 0 : r[a] : e._$Cl;
  const n = Xr(t) ? void 0 : t._$litDirective$;
  return (o == null ? void 0 : o.constructor) !== n && ((T = o == null ? void 0 : o._$AO) == null || T.call(o, !1), n === void 0 ? o = void 0 : (o = new n(i), o._$AT(i, e, a)), a !== void 0 ? ((O = e._$Co) != null ? O : e._$Co = [])[a] = o : e._$Cl = o), o !== void 0 && (t = Xn(i, o._$AS(i, t.values), o, a)), t;
}
let tA = class {
  constructor(t, e) {
    this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = e;
  }
  get parentNode() {
    return this._$AM.parentNode;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  u(t) {
    var j;
    const { el: { content: e }, parts: a } = this._$AD, o = ((j = t == null ? void 0 : t.creationScope) != null ? j : Ji).importNode(e, !0);
    Ni.currentNode = o;
    let n = Ni.nextNode(), r = 0, T = 0, O = a[0];
    for (; O !== void 0; ) {
      if (r === O.index) {
        let D;
        O.type === 2 ? D = new pr(n, n.nextSibling, this, t) : O.type === 1 ? D = new O.ctor(n, O.name, O.strings, this, t) : O.type === 6 && (D = new nA(n, this, t)), this._$AV.push(D), O = a[++T];
      }
      r !== (O == null ? void 0 : O.index) && (n = Ni.nextNode(), r++);
    }
    return Ni.currentNode = Ji, o;
  }
  p(t) {
    let e = 0;
    for (const a of this._$AV) a !== void 0 && (a.strings !== void 0 ? (a._$AI(t, a, e), e += a.strings.length - 2) : a._$AI(t[e])), e++;
  }
};
class pr {
  get _$AU() {
    var t, e;
    return (e = (t = this._$AM) == null ? void 0 : t._$AU) != null ? e : this._$Cv;
  }
  constructor(t, e, a, o) {
    var n;
    this.type = 2, this._$AH = _e, this._$AN = void 0, this._$AA = t, this._$AB = e, this._$AM = a, this.options = o, this._$Cv = (n = o == null ? void 0 : o.isConnected) != null ? n : !0;
  }
  get parentNode() {
    let t = this._$AA.parentNode;
    const e = this._$AM;
    return e !== void 0 && (t == null ? void 0 : t.nodeType) === 11 && (t = e.parentNode), t;
  }
  get startNode() {
    return this._$AA;
  }
  get endNode() {
    return this._$AB;
  }
  _$AI(t, e = this) {
    t = Xn(this, t, e), Xr(t) ? t === _e || t == null || t === "" ? (this._$AH !== _e && this._$AR(), this._$AH = _e) : t !== this._$AH && t !== Qo && this._(t) : t._$litType$ !== void 0 ? this.$(t) : t.nodeType !== void 0 ? this.T(t) : Zv(t) ? this.k(t) : this._(t);
  }
  O(t) {
    return this._$AA.parentNode.insertBefore(t, this._$AB);
  }
  T(t) {
    this._$AH !== t && (this._$AR(), this._$AH = this.O(t));
  }
  _(t) {
    this._$AH !== _e && Xr(this._$AH) ? this._$AA.nextSibling.data = t : this.T(Ji.createTextNode(t)), this._$AH = t;
  }
  $(t) {
    var n;
    const { values: e, _$litType$: a } = t, o = typeof a == "number" ? this._$AC(t) : (a.el === void 0 && (a.el = Zr.createElement(nm(a.h, a.h[0]), this.options)), a);
    if (((n = this._$AH) == null ? void 0 : n._$AD) === o) this._$AH.p(e);
    else {
      const r = new tA(o, this), T = r.u(this.options);
      r.p(e), this.T(T), this._$AH = r;
    }
  }
  _$AC(t) {
    let e = cp.get(t.strings);
    return e === void 0 && cp.set(t.strings, e = new Zr(t)), e;
  }
  k(t) {
    Ah(this._$AH) || (this._$AH = [], this._$AR());
    const e = this._$AH;
    let a, o = 0;
    for (const n of t) o === e.length ? e.push(a = new pr(this.O(Qr()), this.O(Qr()), this, this.options)) : a = e[o], a._$AI(n), o++;
    o < e.length && (this._$AR(a && a._$AB.nextSibling, o), e.length = o);
  }
  _$AR(t = this._$AA.nextSibling, e) {
    var a;
    for ((a = this._$AP) == null ? void 0 : a.call(this, !1, !0, e); t && t !== this._$AB; ) {
      const o = t.nextSibling;
      t.remove(), t = o;
    }
  }
  setConnected(t) {
    var e;
    this._$AM === void 0 && (this._$Cv = t, (e = this._$AP) == null || e.call(this, t));
  }
}
class sc {
  get tagName() {
    return this.element.tagName;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  constructor(t, e, a, o, n) {
    this.type = 1, this._$AH = _e, this._$AN = void 0, this.element = t, this.name = e, this._$AM = o, this.options = n, a.length > 2 || a[0] !== "" || a[1] !== "" ? (this._$AH = Array(a.length - 1).fill(new String()), this.strings = a) : this._$AH = _e;
  }
  _$AI(t, e = this, a, o) {
    const n = this.strings;
    let r = !1;
    if (n === void 0) t = Xn(this, t, e, 0), r = !Xr(t) || t !== this._$AH && t !== Qo, r && (this._$AH = t);
    else {
      const T = t;
      let O, j;
      for (t = n[0], O = 0; O < n.length - 1; O++) j = Xn(this, T[a + O], e, O), j === Qo && (j = this._$AH[O]), r || (r = !Xr(j) || j !== this._$AH[O]), j === _e ? t = _e : t !== _e && (t += (j != null ? j : "") + n[O + 1]), this._$AH[O] = j;
    }
    r && !o && this.j(t);
  }
  j(t) {
    t === _e ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, t != null ? t : "");
  }
}
class oA extends sc {
  constructor() {
    super(...arguments), this.type = 3;
  }
  j(t) {
    this.element[this.name] = t === _e ? void 0 : t;
  }
}
class aA extends sc {
  constructor() {
    super(...arguments), this.type = 4;
  }
  j(t) {
    this.element.toggleAttribute(this.name, !!t && t !== _e);
  }
}
class iA extends sc {
  constructor(t, e, a, o, n) {
    super(t, e, a, o, n), this.type = 5;
  }
  _$AI(t, e = this) {
    var r;
    if ((t = (r = Xn(this, t, e, 0)) != null ? r : _e) === Qo) return;
    const a = this._$AH, o = t === _e && a !== _e || t.capture !== a.capture || t.once !== a.once || t.passive !== a.passive, n = t !== _e && (a === _e || o);
    o && this.element.removeEventListener(this.name, this, a), n && this.element.addEventListener(this.name, this, t), this._$AH = t;
  }
  handleEvent(t) {
    var e, a;
    typeof this._$AH == "function" ? this._$AH.call((a = (e = this.options) == null ? void 0 : e.host) != null ? a : this.element, t) : this._$AH.handleEvent(t);
  }
}
class nA {
  constructor(t, e, a) {
    this.element = t, this.type = 6, this._$AN = void 0, this._$AM = e, this.options = a;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  _$AI(t) {
    Xn(this, t);
  }
}
const rA = { I: pr }, $c = Hr.litHtmlPolyfillSupport;
var Yg;
$c == null || $c(Zr, pr), ((Yg = Hr.litHtmlVersions) != null ? Yg : Hr.litHtmlVersions = []).push("3.2.1");
const Es = (i, t, e) => {
  var n, r;
  const a = (n = e == null ? void 0 : e.renderBefore) != null ? n : t;
  let o = a._$litPart$;
  if (o === void 0) {
    const T = (r = e == null ? void 0 : e.renderBefore) != null ? r : null;
    a._$litPart$ = o = new pr(t.insertBefore(Qr(), T), T, void 0, e != null ? e : {});
  }
  return o._$AI(i), o;
};
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
let Nn = class extends Dn {
  constructor() {
    super(...arguments), this.renderOptions = { host: this }, this._$Do = void 0;
  }
  createRenderRoot() {
    var e, a;
    const t = super.createRenderRoot();
    return (a = (e = this.renderOptions).renderBefore) != null || (e.renderBefore = t.firstChild), t;
  }
  update(t) {
    const e = this.render();
    this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t), this._$Do = Es(e, this.renderRoot, this.renderOptions);
  }
  connectedCallback() {
    var t;
    super.connectedCallback(), (t = this._$Do) == null || t.setConnected(!0);
  }
  disconnectedCallback() {
    var t;
    super.disconnectedCallback(), (t = this._$Do) == null || t.setConnected(!1);
  }
  render() {
    return Qo;
  }
};
var Qg;
Nn._$litElement$ = !0, Nn.finalized = !0, (Qg = globalThis.litElementHydrateSupport) == null || Qg.call(globalThis, { LitElement: Nn });
const Hc = globalThis.litElementPolyfillSupport;
Hc == null || Hc({ LitElement: Nn });
var Xg;
((Xg = globalThis.litElementVersions) != null ? Xg : globalThis.litElementVersions = []).push("4.1.1");
const sA = ve`/**
 * @license Highcharts
 *
 * (c) 2009-2022 Torstein Honsi
 *
 * License: www.highcharts.com/license
 */:root,.highcharts-light{--highcharts-color-0: #2caffe;--highcharts-color-1: #544fc5;--highcharts-color-2: #00e272;--highcharts-color-3: #fe6a35;--highcharts-color-4: #6b8abc;--highcharts-color-5: #d568fb;--highcharts-color-6: #2ee0ca;--highcharts-color-7: #fa4b42;--highcharts-color-8: #feb56a;--highcharts-color-9: #91e8e1;--highcharts-background-color: #ffffff;--highcharts-neutral-color-100: #000000;--highcharts-neutral-color-80: #333333;--highcharts-neutral-color-60: #666666;--highcharts-neutral-color-40: #999999;--highcharts-neutral-color-20: #cccccc;--highcharts-neutral-color-10: #e6e6e6;--highcharts-neutral-color-5: #f2f2f2;--highcharts-neutral-color-3: #f7f7f7;--highcharts-highlight-color-100: #0022ff;--highcharts-highlight-color-80: #334eff;--highcharts-highlight-color-60: #667aff;--highcharts-highlight-color-20: #ccd3ff;--highcharts-highlight-color-10: #e6e9ff;--highcharts-positive-color: #06b535;--highcharts-negative-color: #f21313;--highcharts-annotation-color-0: rgba(130, 170, 255, .4);--highcharts-annotation-color-1: rgba(139, 191, 216, .4);--highcharts-annotation-color-2: rgba(150, 216, 192, .4);--highcharts-annotation-color-3: rgba(156, 229, 161, .4);--highcharts-annotation-color-4: rgba(162, 241, 130, .4);--highcharts-annotation-color-5: rgba(169, 255, 101, .4)}@media (prefers-color-scheme: dark){:root{--highcharts-background-color: rgb(48, 48, 48);--highcharts-neutral-color-100: rgb(255, 255, 255);--highcharts-neutral-color-80: rgb(214, 214, 214);--highcharts-neutral-color-60: rgb(173, 173, 173);--highcharts-neutral-color-40: rgb(133, 133, 133);--highcharts-neutral-color-20: rgb(92, 92, 92);--highcharts-neutral-color-10: rgb(71, 71, 71);--highcharts-neutral-color-5: rgb(61, 61, 61);--highcharts-neutral-color-3: rgb(57, 57, 57);--highcharts-highlight-color-100: rgb(122, 167, 255);--highcharts-highlight-color-80: rgb(108, 144, 214);--highcharts-highlight-color-60: rgb(94, 121, 173);--highcharts-highlight-color-20: rgb(65, 74, 92);--highcharts-highlight-color-10: rgb(58, 63, 71)}}.highcharts-dark{--highcharts-background-color: rgb(48, 48, 48);--highcharts-neutral-color-100: rgb(255, 255, 255);--highcharts-neutral-color-80: rgb(214, 214, 214);--highcharts-neutral-color-60: rgb(173, 173, 173);--highcharts-neutral-color-40: rgb(133, 133, 133);--highcharts-neutral-color-20: rgb(92, 92, 92);--highcharts-neutral-color-10: rgb(71, 71, 71);--highcharts-neutral-color-5: rgb(61, 61, 61);--highcharts-neutral-color-3: rgb(57, 57, 57);--highcharts-highlight-color-100: rgb(122, 167, 255);--highcharts-highlight-color-80: rgb(108, 144, 214);--highcharts-highlight-color-60: rgb(94, 121, 173);--highcharts-highlight-color-20: rgb(65, 74, 92);--highcharts-highlight-color-10: rgb(58, 63, 71)}.highcharts-container{position:relative;overflow:hidden;width:100%;height:100%;text-align:left;line-height:normal;z-index:0;-webkit-tap-highlight-color:rgba(0,0,0,0);font-family:Helvetica,Arial,sans-serif;font-size:1rem;-webkit-user-select:none;user-select:none;touch-action:manipulation;outline:none}.highcharts-no-touch-action{touch-action:none}.highcharts-root{display:block}.highcharts-root text{stroke-width:0}.highcharts-strong{font-weight:700}.highcharts-emphasized{font-style:italic}.highcharts-anchor{cursor:pointer}.highcharts-background{fill:var(--highcharts-background-color)}.highcharts-plot-border,.highcharts-plot-background,.highcharts-label-box{fill:none}.highcharts-label text{fill:var(--highcharts-neutral-color-80);font-size:.8em}.highcharts-button-box{fill:inherit}.highcharts-tracker-line{stroke-linejoin:round;stroke:#c0c0c000;stroke-width:22;fill:none}.highcharts-tracker-area{fill:#c0c0c000;stroke-width:0}.highcharts-title{fill:var(--highcharts-neutral-color-80);font-size:1.2em;font-weight:700}.highcharts-subtitle{fill:var(--highcharts-neutral-color-60);font-size:.8em}.highcharts-axis-line{fill:none;stroke:var(--highcharts-neutral-color-80)}.highcharts-yaxis .highcharts-axis-line{stroke-width:0}.highcharts-axis-title{fill:var(--highcharts-neutral-color-60);font-size:.8em}.highcharts-axis-labels{fill:var(--highcharts-neutral-color-80);cursor:default;font-size:.8em}.highcharts-grid-line{fill:none;stroke:var(--highcharts-neutral-color-10)}.highcharts-xaxis-grid .highcharts-grid-line{stroke-width:0}.highcharts-tick{stroke:var(--highcharts-neutral-color-80)}.highcharts-yaxis .highcharts-tick{stroke-width:0}.highcharts-minor-grid-line{stroke:var(--highcharts-neutral-color-5)}.highcharts-crosshair-thin{stroke-width:1px;stroke:var(--highcharts-neutral-color-20)}.highcharts-crosshair-category{stroke:var(--highcharts-highlight-color-20);stroke-opacity:.25}.highcharts-credits{cursor:pointer;fill:var(--highcharts-neutral-color-40);font-size:.6em;transition:fill .25s,font-size .25s}.highcharts-credits:hover{fill:var(--highcharts-neutral-color-100);font-size:.7em}.highcharts-tooltip{cursor:default;pointer-events:none;white-space:nowrap;transition:stroke .15s}.highcharts-tooltip .highcharts-tracker{fill:none;stroke:none}.highcharts-tooltip text{fill:var(--highcharts-neutral-color-80);font-size:.8em}.highcharts-tooltip .highcharts-header{font-size:.8em}.highcharts-tooltip-box{stroke-width:1px;fill:var(--highcharts-background-color)}.highcharts-tooltip-box{stroke-width:0;fill:var(--highcharts-background-color)}.highcharts-tooltip-box .highcharts-label-box{fill:var(--highcharts-background-color)}div.highcharts-tooltip{filter:none;font-size:.8em}.highcharts-selection-marker{fill:var(--highcharts-highlight-color-80);fill-opacity:.25}.highcharts-graph{fill:none;stroke-width:2px;stroke-linecap:round;stroke-linejoin:round}.highcharts-empty-series{stroke-width:1px;fill:none;stroke:var(--highcharts-neutral-color-20)}.highcharts-state-hover .highcharts-graph{stroke-width:3}.highcharts-point-inactive,.highcharts-series-inactive{opacity:.2;transition:opacity 50ms}.highcharts-state-hover path{transition:stroke-width 50ms}.highcharts-state-normal path{transition:stroke-width .25s}g.highcharts-series,.highcharts-point,.highcharts-markers,.highcharts-data-labels{transition:opacity .25s}.highcharts-legend-series-active g.highcharts-series:not(.highcharts-series-hover),.highcharts-legend-point-active .highcharts-point:not(.highcharts-point-hover,.highcharts-point-select),.highcharts-legend-series-active .highcharts-markers:not(.highcharts-series-hover),.highcharts-legend-series-active .highcharts-data-labels:not(.highcharts-series-hover){opacity:.2}.highcharts-color-0{fill:var(--highcharts-color-0);stroke:var(--highcharts-color-0)}.highcharts-color-1{fill:var(--highcharts-color-1);stroke:var(--highcharts-color-1)}.highcharts-color-2{fill:var(--highcharts-color-2);stroke:var(--highcharts-color-2)}.highcharts-color-3{fill:var(--highcharts-color-3);stroke:var(--highcharts-color-3)}.highcharts-color-4{fill:var(--highcharts-color-4);stroke:var(--highcharts-color-4)}.highcharts-color-5{fill:var(--highcharts-color-5);stroke:var(--highcharts-color-5)}.highcharts-color-6{fill:var(--highcharts-color-6);stroke:var(--highcharts-color-6)}.highcharts-color-7{fill:var(--highcharts-color-7);stroke:var(--highcharts-color-7)}.highcharts-color-8{fill:var(--highcharts-color-8);stroke:var(--highcharts-color-8)}.highcharts-color-9{fill:var(--highcharts-color-9);stroke:var(--highcharts-color-9)}.highcharts-area{fill-opacity:.75;stroke-width:0}.highcharts-markers{stroke-width:1px;stroke:var(--highcharts-background-color)}.highcharts-a11y-markers-hidden .highcharts-point:not(.highcharts-point-hover,.highcharts-a11y-marker-visible),.highcharts-a11y-marker-hidden{opacity:0}.highcharts-point{stroke-width:1px}.highcharts-dense-data .highcharts-point{stroke-width:0}.highcharts-data-label text,text.highcharts-data-label{font-size:.7em;font-weight:700}.highcharts-data-label-box{fill:none;stroke-width:0}.highcharts-data-label text,text.highcharts-data-label{fill:var(--highcharts-neutral-color-80)}.highcharts-data-label-connector{fill:none}.highcharts-data-label-hidden{pointer-events:none}.highcharts-halo{fill-opacity:.25;stroke-width:0}.highcharts-series-label text{fill:inherit;font-weight:700}.highcharts-series:not(.highcharts-pie-series) .highcharts-point-select,.highcharts-markers .highcharts-point-select{fill:var(--highcharts-neutral-color-20);stroke:var(--highcharts-neutral-color-100)}.highcharts-column-series path.highcharts-point,.highcharts-bar-series path.highcharts-point{stroke:var(--highcharts-background-color)}.highcharts-column-series .highcharts-point{transition:fill-opacity .25s}.highcharts-column-series .highcharts-point-hover{fill-opacity:.75;transition:fill-opacity 50ms}.highcharts-pie-series .highcharts-point{stroke-linejoin:round;stroke:var(--highcharts-background-color)}.highcharts-pie-series .highcharts-point-hover{fill-opacity:.75;transition:fill-opacity 50ms}.highcharts-funnel-series .highcharts-point{stroke-linejoin:round;stroke:var(--highcharts-background-color)}.highcharts-funnel-series .highcharts-point-hover{fill-opacity:.75;transition:fill-opacity 50ms}.highcharts-funnel-series .highcharts-point-select{fill:inherit;stroke:inherit}.highcharts-pyramid-series .highcharts-point{stroke-linejoin:round;stroke:var(--highcharts-background-color)}.highcharts-pyramid-series .highcharts-point-hover{fill-opacity:.75;transition:fill-opacity 50ms}.highcharts-pyramid-series .highcharts-point-select{fill:inherit;stroke:inherit}.highcharts-solidgauge-series .highcharts-point{stroke-width:0}.highcharts-treemap-series .highcharts-point{stroke-width:1px;stroke:var(--highcharts-neutral-color-10);transition:stroke .25s,fill .25s,fill-opacity .25s}.highcharts-treemap-series .highcharts-point-hover{stroke:var(--highcharts-neutral-color-40);transition:stroke 25ms,fill 25ms,fill-opacity 25ms}.highcharts-treemap-series .highcharts-above-level{display:none}.highcharts-treemap-series .highcharts-internal-node{fill:none}.highcharts-treemap-series .highcharts-internal-node-interactive{fill-opacity:.15;cursor:pointer}.highcharts-treemap-series .highcharts-internal-node-interactive:hover{fill-opacity:.75}.highcharts-vector-series .highcharts-point,.highcharts-windbarb-series .highcharts-point{fill:none;stroke-width:2px}.highcharts-lollipop-stem{stroke:var(--highcharts-neutral-color-100)}.highcharts-focus-border{fill:none;stroke-width:2px}.highcharts-legend-item-hidden .highcharts-focus-border{fill:none!important}.highcharts-legend-box{fill:none;stroke-width:0}.highcharts-legend-item>text{fill:var(--highcharts-neutral-color-80);font-weight:700;font-size:.8em;cursor:pointer;stroke-width:0}.highcharts-legend-item:hover text{fill:var(--highcharts-neutral-color-100)}.highcharts-legend-item-hidden *{fill:var(--highcharts-neutral-color-60)!important;stroke:var(--highcharts-neutral-color-60)!important;transition:fill .25s;text-decoration:line-through}.highcharts-legend-nav-active{fill:var(--highcharts-highlight-color-100);cursor:pointer}.highcharts-legend-nav-inactive{fill:var(--highcharts-neutral-color-20)}circle.highcharts-legend-nav-active,circle.highcharts-legend-nav-inactive{fill:#c0c0c000}.highcharts-legend-title-box{fill:none;stroke-width:0}.highcharts-bubble-legend-symbol{stroke-width:2;fill-opacity:.5}.highcharts-bubble-legend-connectors{stroke-width:1}.highcharts-bubble-legend-labels{fill:var(--highcharts-neutral-color-80);font-size:.7em}.highcharts-loading{position:absolute;background-color:var(--highcharts-background-color);opacity:.5;text-align:center;z-index:10;transition:opacity .25s}.highcharts-loading-hidden{height:0!important;opacity:0;overflow:hidden;transition:opacity .25s,height .25s step-end}.highcharts-loading-inner{font-weight:700;position:relative;top:45%}.highcharts-plot-band,.highcharts-pane{fill:var(--highcharts-neutral-color-100);fill-opacity:.05}.highcharts-plot-line{fill:none;stroke:var(--highcharts-neutral-color-40);stroke-width:1px}.highcharts-plot-line-label{font-size:.8em}.highcharts-boxplot-box{fill:var(--highcharts-background-color)}.highcharts-boxplot-median{stroke-width:2px}.highcharts-bubble-series .highcharts-point{fill-opacity:.5}.highcharts-errorbar-series .highcharts-point{stroke:var(--highcharts-neutral-color-100)}.highcharts-gauge-series .highcharts-data-label-box{stroke:var(--highcharts-neutral-color-20);stroke-width:1px}.highcharts-gauge-series .highcharts-dial{fill:var(--highcharts-neutral-color-100);stroke-width:0}.highcharts-polygon-series .highcharts-graph{fill:inherit;stroke-width:0}.highcharts-waterfall-series .highcharts-graph{stroke:var(--highcharts-neutral-color-80);stroke-dasharray:1,3}.highcharts-sankey-series .highcharts-point{stroke-width:0}.highcharts-sankey-series .highcharts-link{transition:fill .25s,fill-opacity .25s;fill-opacity:.5}.highcharts-sankey-series .highcharts-point-hover.highcharts-link{transition:fill 50ms,fill-opacity 50ms;fill-opacity:1}.highcharts-venn-series .highcharts-point{fill-opacity:.75;stroke:var(--highcharts-neutral-color-20);transition:stroke .25s,fill-opacity .25s}.highcharts-venn-series .highcharts-point-hover{fill-opacity:1;stroke:var(--highcharts-neutral-color-20)}.highcharts-timeline-series .highcharts-graph{stroke:var(--highcharts-neutral-color-20)}.highcharts-navigator-mask-outside{fill-opacity:0}.highcharts-navigator-mask-inside{fill:var(--highcharts-highlight-color-60);fill-opacity:.25;cursor:ew-resize}.highcharts-navigator-outline{stroke:var(--highcharts-neutral-color-40);fill:none}.highcharts-navigator-handle{stroke:var(--highcharts-neutral-color-40);fill:var(--highcharts-neutral-color-5);cursor:ew-resize}.highcharts-navigator-series{fill:var(--highcharts-highlight-color-80);stroke:var(--highcharts-highlight-color-80)}.highcharts-navigator-series .highcharts-graph{stroke-width:1px}.highcharts-navigator-series .highcharts-area{fill-opacity:.05}.highcharts-navigator-xaxis .highcharts-axis-line{stroke-width:0}.highcharts-navigator-xaxis .highcharts-grid-line{stroke-width:1px;stroke:var(--highcharts-neutral-color-10)}.highcharts-navigator-xaxis.highcharts-axis-labels{fill:var(--highcharts-neutral-color-100);font-size:.7em;opacity:.6}.highcharts-navigator-yaxis .highcharts-grid-line{stroke-width:0}.highcharts-scrollbar-thumb{fill:var(--highcharts-neutral-color-20);stroke:var(--highcharts-neutral-color-20);stroke-width:0}.highcharts-scrollbar-button{fill:var(--highcharts-neutral-color-10);stroke:var(--highcharts-neutral-color-20);stroke-width:1px}.highcharts-scrollbar-arrow{fill:var(--highcharts-neutral-color-60)}.highcharts-scrollbar-rifles{stroke:none;stroke-width:1px}.highcharts-scrollbar-track{fill:#fff0;stroke:var(--highcharts-neutral-color-20);stroke-width:1px}.highcharts-button{fill:var(--highcharts-neutral-color-3);stroke:var(--highcharts-neutral-color-20);cursor:default;stroke-width:1px;transition:fill .25s}.highcharts-button text{fill:var(--highcharts-neutral-color-80);font-size:.8em}.highcharts-button-hover{transition:fill 0ms;fill:var(--highcharts-neutral-color-10);stroke:var(--highcharts-neutral-color-20)}.highcharts-button-hover text{fill:var(--highcharts-neutral-color-80)}.highcharts-button-pressed{font-weight:700;fill:var(--highcharts-highlight-color-10);stroke:var(--highcharts-neutral-color-20)}.highcharts-button-pressed text{fill:var(--highcharts-neutral-color-80);font-weight:700}.highcharts-button-disabled text{fill:var(--highcharts-neutral-color-80)}.highcharts-range-selector-buttons .highcharts-button{stroke-width:0}.highcharts-range-label rect{fill:none}.highcharts-range-label text{fill:var(--highcharts-neutral-color-60)}.highcharts-range-input rect{fill:none}.highcharts-range-input text{fill:var(--highcharts-neutral-color-80);font-size:.8em}.highcharts-range-input{stroke-width:1px;stroke:var(--highcharts-neutral-color-20)}input.highcharts-range-selector{position:absolute;border:0;width:1px;height:1px;padding:0;text-align:center;left:-9em}.highcharts-crosshair-label text{fill:var(--highcharts-background-color);font-size:1.7em}.highcharts-crosshair-label .highcharts-label-box{fill:inherit}.highcharts-candlestick-series .highcharts-point{stroke:var(--highcharts-neutral-color-100);stroke-width:1px}.highcharts-candlestick-series .highcharts-point-up{fill:var(--highcharts-background-color)}.highcharts-hollowcandlestick-series .highcharts-point-down{fill:var(--highcharts-negative-color);stroke:var(--highcharts-negative-color)}.highcharts-hollowcandlestick-series .highcharts-point-down-bearish-up{fill:var(--highcharts-positive-color);stroke:var(--highcharts-positive-color)}.highcharts-hollowcandlestick-series .highcharts-point-up{fill:transparent;stroke:var(--highcharts-positive-color)}.highcharts-ohlc-series .highcharts-point-hover{stroke-width:3px}.highcharts-flags-series .highcharts-point .highcharts-label-box{stroke:var(--highcharts-neutral-color-40);fill:var(--highcharts-background-color);transition:fill .25s}.highcharts-flags-series .highcharts-point-hover .highcharts-label-box{stroke:var(--highcharts-neutral-color-100);fill:var(--highcharts-highlight-color-20)}.highcharts-flags-series .highcharts-point text{fill:var(--highcharts-neutral-color-100);font-size:.9em;font-weight:700}.highcharts-map-series .highcharts-point{transition:fill .5s,fill-opacity .5s,stroke-width .25s;stroke:var(--highcharts-neutral-color-20);stroke-width:inherit}.highcharts-map-series .highcharts-point-hover{transition:fill 0ms,fill-opacity 0ms;fill-opacity:.5}.highcharts-mapline-series .highcharts-point{fill:none}.highcharts-heatmap-series .highcharts-point{stroke-width:0}.highcharts-map-navigation{font-size:1.3em;font-weight:700;text-align:center}.highcharts-map-navigation.highcharts-button{fill:var(--highcharts-background-color);stroke:var(--highcharts-neutral-color-10)}.highcharts-map-navigation.highcharts-button:hover{fill:var(--highcharts-neutral-color-10)}.highcharts-map-navigation.highcharts-button .highcharts-button-symbol{stroke-width:2px}.highcharts-mapview-inset-border{stroke:var(--highcharts-neutral-color-20);stroke-width:1px;fill:none}.highcharts-coloraxis{stroke-width:0}.highcharts-coloraxis-marker{fill:var(--highcharts-neutral-color-40)}.highcharts-null-point{fill:var(--highcharts-neutral-color-3)}.highcharts-3d-frame{fill:transparent}.highcharts-contextbutton{fill:var(--highcharts-background-color);stroke:none;stroke-linecap:round}.highcharts-contextbutton:hover{fill:var(--highcharts-neutral-color-10);stroke:var(--highcharts-neutral-color-10)}.highcharts-button-symbol{stroke:var(--highcharts-neutral-color-60);stroke-width:3px}.highcharts-menu{border:none;background:var(--highcharts-background-color);border-radius:3px;padding:.5em;box-shadow:3px 3px 10px #888}.highcharts-menu-item{background:none;border-radius:3px;color:var(--highcharts-neutral-color-80);cursor:pointer;font-size:.8em;list-style-type:none;padding:.5em;transition:background .25s,color .25s}.highcharts-menu-item:hover{background:var(--highcharts-neutral-color-5)}.highcharts-breadcrumbs-button{fill:none;stroke-width:0;cursor:pointer}.highcharts-breadcrumbs-separator{fill:var(--highcharts-neutral-color-60)}.highcharts-drilldown-point{cursor:pointer}.highcharts-drilldown-data-label text,text.highcharts-drilldown-data-label,.highcharts-drilldown-axis-label{cursor:pointer;fill:var(--highcharts-highlight-color-100);font-weight:700;text-decoration:underline}.highcharts-no-data text{font-weight:700;font-size:.8em;fill:var(--highcharts-neutral-color-60)}.highcharts-axis-resizer{cursor:ns-resize;stroke:var(--highcharts-neutral-color-100);stroke-width:2px}.highcharts-bullet-target{stroke-width:0}.highcharts-lineargauge-target,.highcharts-lineargauge-target-line{stroke-width:1px;stroke:var(--highcharts-neutral-color-80)}.highcharts-fibonacci-background-0,.highcharts-pitchfork-inner-background,.highcharts-measure-background{fill:var(--highcharts-annotation-color-0)}.highcharts-fibonacci-background-1{fill:var(--highcharts-annotation-color-1)}.highcharts-fibonacci-background-2{fill:var(--highcharts-annotation-color-2)}.highcharts-fibonacci-background-3,.highcharts-pitchfork-outer-background{fill:var(--highcharts-annotation-color-3)}.highcharts-fibonacci-background-4{fill:var(--highcharts-annotation-color-4)}.highcharts-fibonacci-background-5{fill:var(--highcharts-annotation-color-5)}.highcharts-fibonacci-line{stroke:var(--highcharts-neutral-color-40)}.highcharts-crooked-lines,.highcharts-tunnel-lines,.highcharts-infinity-lines,.highcharts-timecycles-lines,.highcharts-fibonacci-timezones-lines,.highcharts-pitchfork-lines,.highcharts-vertical-line,.highcharts-measure-crosshair-x,.highcharts-measure-crosshair-y{stroke:var(--highcharts-neutral-color-100);stroke-opacity:.75;fill:none}.highcharts-measure-crosshair-x,.highcharts-measure-crosshair-y{stroke-dasharray:1,3}.highcharts-tunnel-background{fill:var(--highcharts-color-0)}.highcharts-annotation-shapes{cursor:move}.highcharts-basic-shape{fill:var(--highcharts-neutral-color-100);stroke:var(--highcharts-neutral-color-100);opacity:.74}.highcharts-annotation-label-box{stroke-width:1px;stroke:var(--highcharts-neutral-color-100);fill:var(--highcharts-neutral-color-100);fill-opacity:.75}.highcharts-annotation-label text{fill:var(--highcharts-neutral-color-10);font-size:.8em}.highcharts-a11y-proxy-element{border-width:0;background-color:transparent;cursor:pointer;outline:none;opacity:.001;z-index:999;overflow:hidden;padding:0;margin:0;display:block;position:absolute}.highcharts-a11y-proxy-group li{list-style:none}.highcharts-visually-hidden{position:absolute;width:1px;height:1px;overflow:hidden;white-space:nowrap;clip:rect(1px,1px,1px,1px);margin-top:-3px;opacity:.01}.highcharts-a11y-invisible{visibility:hidden}.highcharts-a11y-proxy-container,.highcharts-a11y-proxy-container-before,.highcharts-a11y-proxy-container-after{position:absolute;white-space:nowrap}g.highcharts-series,.highcharts-markers,.highcharts-point{outline:none}.highcharts-treegrid-node-collapsed,.highcharts-treegrid-node-expanded{cursor:pointer}.highcharts-point-connecting-path{fill:none}.highcharts-grid-axis .highcharts-tick,.highcharts-grid-axis .highcharts-axis-line{stroke:var(--highcharts-neutral-color-20);stroke-width:1px}`;
var rm = { exports: {} };
(function(i) {
  /**
  * Highcharts JS v11.4.8 (2024-08-29)
  *
  * Accessibility module
  *
  * (c) 2010-2024 Highsoft AS
  * Author: Oystein Moseng
  *
  * License: www.highcharts.com/license
  */
  (function(t) {
    i.exports ? (t.default = t, i.exports = t) : t(typeof Highcharts < "u" ? Highcharts : void 0);
  })(function(t) {
    var e = t ? t._modules : {};
    function a(o, n, r, T) {
      o.hasOwnProperty(n) || (o[n] = T.apply(null, r), typeof CustomEvent == "function" && t.win.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", { detail: { path: n, module: o[n] } })));
    }
    a(e, "Accessibility/Utils/HTMLUtilities.js", [e["Core/Globals.js"], e["Core/Utilities.js"]], function(o, n) {
      let { doc: r, win: T } = o, { css: O } = n, j = T.EventTarget && new T.EventTarget() || "none";
      function D(B) {
        if (typeof T.MouseEvent == "function") return new T.MouseEvent(B.type, B);
        if (r.createEvent) {
          let N = r.createEvent("MouseEvent");
          if (N.initMouseEvent) return N.initMouseEvent(B.type, B.bubbles, B.cancelable, B.view || T, B.detail, B.screenX, B.screenY, B.clientX, B.clientY, B.ctrlKey, B.altKey, B.shiftKey, B.metaKey, B.button, B.relatedTarget), N;
        }
        return F(B.type);
      }
      function F(B, N, f) {
        let w = N || { x: 0, y: 0 };
        if (typeof T.MouseEvent == "function") return new T.MouseEvent(B, { bubbles: !0, cancelable: !0, composed: !0, button: 0, buttons: 1, relatedTarget: f || j, view: T, detail: B === "click" ? 1 : 0, screenX: w.x, screenY: w.y, clientX: w.x, clientY: w.y });
        if (r.createEvent) {
          let x = r.createEvent("MouseEvent");
          if (x.initMouseEvent) return x.initMouseEvent(B, !0, !0, T, B === "click" ? 1 : 0, w.x, w.y, w.x, w.y, !1, !1, !1, !1, 0, null), x;
        }
        return { type: B };
      }
      return { addClass: function(B, N) {
        B.classList ? B.classList.add(N) : 0 > B.className.indexOf(N) && (B.className += " " + N);
      }, cloneMouseEvent: D, cloneTouchEvent: function(B) {
        let N = (w) => {
          let x = [];
          for (let M = 0; M < w.length; ++M) {
            let p = w.item(M);
            p && x.push(p);
          }
          return x;
        };
        if (typeof T.TouchEvent == "function") {
          let w = new T.TouchEvent(B.type, { touches: N(B.touches), targetTouches: N(B.targetTouches), changedTouches: N(B.changedTouches), ctrlKey: B.ctrlKey, shiftKey: B.shiftKey, altKey: B.altKey, metaKey: B.metaKey, bubbles: B.bubbles, cancelable: B.cancelable, composed: B.composed, detail: B.detail, view: B.view });
          return B.defaultPrevented && w.preventDefault(), w;
        }
        let f = D(B);
        return f.touches = B.touches, f.changedTouches = B.changedTouches, f.targetTouches = B.targetTouches, f;
      }, escapeStringForHTML: function(B) {
        return B.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;").replace(/\//g, "&#x2F;");
      }, getElement: function(B) {
        return r.getElementById(B);
      }, getFakeMouseEvent: F, getHeadingTagNameForElement: function(B) {
        let N = (M) => "h" + Math.min(6, parseInt(M.slice(1), 10) + 1), f = (M) => /^H[1-6]$/i.test(M), w = (M) => {
          let p = M;
          for (; p = p.previousSibling; ) {
            let v = p.tagName || "";
            if (f(v)) return v;
          }
          return "";
        }, x = (M) => {
          let p = w(M);
          if (p) return N(p);
          let v = M.parentElement;
          if (!v) return "p";
          let k = v.tagName;
          return f(k) ? N(k) : x(v);
        };
        return x(B);
      }, removeChildNodes: function(B) {
        for (; B.lastChild; ) B.removeChild(B.lastChild);
      }, removeClass: function(B, N) {
        B.classList ? B.classList.remove(N) : B.className = B.className.replace(RegExp(N, "g"), "");
      }, removeElement: function(B) {
        B && B.parentNode && B.parentNode.removeChild(B);
      }, reverseChildNodes: function(B) {
        let N = B.childNodes.length;
        for (; N--; ) B.appendChild(B.childNodes[N]);
      }, simulatedEventTarget: j, stripHTMLTagsFromString: function(B, N = !1) {
        return typeof B == "string" ? N ? B.replace(/<\/?[^>]+(>|$)/g, "") : B.replace(/<\/?(?!\s)[^>]+(>|$)/g, "") : B;
      }, visuallyHideElement: function(B) {
        O(B, { position: "absolute", width: "1px", height: "1px", overflow: "hidden", whiteSpace: "nowrap", clip: "rect(1px, 1px, 1px, 1px)", marginTop: "-3px", "-ms-filter": "progid:DXImageTransform.Microsoft.Alpha(Opacity=1)", filter: "alpha(opacity=1)", opacity: 0.01 });
      } };
    }), a(e, "Accessibility/A11yI18n.js", [e["Core/Templating.js"], e["Core/Utilities.js"]], function(o, n) {
      var r;
      let { format: T } = o, { getNestedProperty: O, pick: j } = n;
      return function(D) {
        function F(N, f, w) {
          let x = (m, A) => {
            let C = m.slice(A || 0), H = C.indexOf("{"), G = C.indexOf("}");
            if (H > -1 && G > H) return { statement: C.substring(H + 1, G), begin: A + H + 1, end: A + G };
          }, M = [], p, v, k = 0;
          do
            p = x(N, k), (v = N.substring(k, p && p.begin - 1)).length && M.push({ value: v, type: "constant" }), p && M.push({ value: p.statement, type: "statement" }), k = p ? p.end + 1 : k + 1;
          while (p);
          return M.forEach((m) => {
            m.type === "statement" && (m.value = function(A, C) {
              let H, G, P = A.indexOf("#each("), y = A.indexOf("#plural("), S = A.indexOf("["), d = A.indexOf("]");
              if (P > -1) {
                let l = A.slice(P).indexOf(")") + P, b = A.substring(0, P), u = A.substring(l + 1), c = A.substring(P + 6, l).split(","), h = Number(c[1]), g;
                if (G = "", H = O(c[0], C)) {
                  g = (h = isNaN(h) ? H.length : h) < 0 ? H.length + h : Math.min(h, H.length);
                  for (let E = 0; E < g; ++E) G += b + H[E] + u;
                }
                return G.length ? G : "";
              }
              if (y > -1) {
                var s;
                let l = A.slice(y).indexOf(")") + y, b = A.substring(y + 8, l).split(",");
                switch (Number(O(b[0], C))) {
                  case 0:
                    G = j(b[4], b[1]);
                    break;
                  case 1:
                    G = j(b[2], b[1]);
                    break;
                  case 2:
                    G = j(b[3], b[1]);
                    break;
                  default:
                    G = b[1];
                }
                return G ? (s = G).trim && s.trim() || s.replace(/^\s+|\s+$/g, "") : "";
              }
              if (S > -1) {
                let l, b = A.substring(0, S), u = Number(A.substring(S + 1, d));
                return H = O(b, C), !isNaN(u) && H && (u < 0 ? (l = H[H.length + u]) === void 0 && (l = H[0]) : (l = H[u]) === void 0 && (l = H[H.length - 1])), l !== void 0 ? l : "";
              }
              return "{" + A + "}";
            }(m.value, f));
          }), T(M.reduce((m, A) => m + A.value, ""), f, w);
        }
        function B(N, f) {
          let w = N.split("."), x = this.options.lang, M = 0;
          for (; M < w.length; ++M) x = x && x[w[M]];
          return typeof x == "string" ? F(x, f, this) : "";
        }
        D.compose = function(N) {
          let f = N.prototype;
          f.langFormat || (f.langFormat = B);
        }, D.i18nFormat = F;
      }(r || (r = {})), r;
    }), a(e, "Accessibility/Utils/ChartUtilities.js", [e["Core/Globals.js"], e["Accessibility/Utils/HTMLUtilities.js"], e["Core/Utilities.js"]], function(o, n, r) {
      let { doc: T } = o, { stripHTMLTagsFromString: O } = n, { defined: j, find: D, fireEvent: F } = r;
      function B(f) {
        if (f.points && f.points.length) {
          let w = D(f.points, (x) => !!x.graphic);
          return w && w.graphic && w.graphic.element;
        }
      }
      function N(f) {
        let w = B(f);
        return w && w.parentNode || f.graph && f.graph.element || f.group && f.group.element;
      }
      return { fireEventOnWrappedOrUnwrappedElement: function f(w, x) {
        let M = x.type, p = w.hcEvents;
        T.createEvent && (w.dispatchEvent || w.fireEvent) ? w.dispatchEvent ? w.dispatchEvent(x) : w.fireEvent(M, x) : p && p[M] ? F(w, M, x) : w.element && f(w.element, x);
      }, getChartTitle: function(f) {
        return O(f.options.title.text || f.langFormat("accessibility.defaultChartTitle", { chart: f }), f.renderer.forExport);
      }, getAxisDescription: function(f) {
        var w, x;
        return f && (((w = f.options.accessibility) == null ? void 0 : w.description) || ((x = f.axisTitle) == null ? void 0 : x.textStr) || f.options.id || f.categories && "categories" || f.dateTime && "Time" || "values");
      }, getAxisRangeDescription: function(f) {
        let w = f.options || {};
        return w.accessibility && w.accessibility.rangeDescription !== void 0 ? w.accessibility.rangeDescription : f.categories ? function(x) {
          let M = x.chart;
          return x.dataMax && x.dataMin ? M.langFormat("accessibility.axis.rangeCategories", { chart: M, axis: x, numCategories: x.dataMax - x.dataMin + 1 }) : "";
        }(f) : f.dateTime && (f.min === 0 || f.dataMin === 0) ? function(x) {
          let M = x.chart, p = {}, v = x.dataMin || x.min || 0, k = x.dataMax || x.max || 0, m = "Seconds";
          p.Seconds = (k - v) / 1e3, p.Minutes = p.Seconds / 60, p.Hours = p.Minutes / 60, p.Days = p.Hours / 24, ["Minutes", "Hours", "Days"].forEach(function(C) {
            p[C] > 2 && (m = C);
          });
          let A = p[m].toFixed(m !== "Seconds" && m !== "Minutes" ? 1 : 0);
          return M.langFormat("accessibility.axis.timeRange" + m, { chart: M, axis: x, range: A.replace(".0", "") });
        }(f) : function(x) {
          let M = x.chart, p = M.options, v = p && p.accessibility && p.accessibility.screenReaderSection.axisRangeDateFormat || "", k = { min: x.dataMin || x.min || 0, max: x.dataMax || x.max || 0 }, m = function(A) {
            return x.dateTime ? M.time.dateFormat(v, k[A]) : k[A].toString();
          };
          return M.langFormat("accessibility.axis.rangeFromTo", { chart: M, axis: x, rangeFrom: m("min"), rangeTo: m("max") });
        }(f);
      }, getPointFromXY: function(f, w, x) {
        let M = f.length, p;
        for (; M--; ) if (p = D(f[M].points || [], function(v) {
          return v.x === w && v.y === x;
        })) return p;
      }, getSeriesFirstPointElement: B, getSeriesFromName: function(f, w) {
        return w ? (f.series || []).filter(function(x) {
          return x.name === w;
        }) : f.series;
      }, getSeriesA11yElement: N, unhideChartElementFromAT: function f(w, x) {
        x.setAttribute("aria-hidden", !1), x !== w.renderTo && x.parentNode && x.parentNode !== T.body && (Array.prototype.forEach.call(x.parentNode.childNodes, function(M) {
          M.hasAttribute("aria-hidden") || M.setAttribute("aria-hidden", !0);
        }), f(w, x.parentNode));
      }, hideSeriesFromAT: function(f) {
        let w = N(f);
        w && w.setAttribute("aria-hidden", !0);
      }, scrollAxisToPoint: function(f) {
        let w = f.series.xAxis, x = f.series.yAxis, M = w && w.scrollbar ? w : x, p = M && M.scrollbar;
        if (p && j(p.to) && j(p.from)) {
          let v = p.to - p.from, k = function(m, A) {
            if (!j(m.dataMin) || !j(m.dataMax)) return 0;
            let C = m.toPixels(m.dataMin), H = m.toPixels(m.dataMax), G = m.coll === "xAxis" ? "x" : "y";
            return (m.toPixels(A[G] || 0) - C) / (H - C);
          }(M, f);
          p.updatePosition(k - v / 2, k + v / 2), F(p, "changed", { from: p.from, to: p.to, trigger: "scrollbar", DOMEvent: null });
        }
      } };
    }), a(e, "Accessibility/Utils/DOMElementProvider.js", [e["Core/Globals.js"], e["Accessibility/Utils/HTMLUtilities.js"]], function(o, n) {
      let { doc: r } = o, { removeElement: T } = n;
      return class {
        constructor() {
          this.elements = [];
        }
        createElement() {
          let O = r.createElement.apply(r, arguments);
          return this.elements.push(O), O;
        }
        removeElement(O) {
          T(O), this.elements.splice(this.elements.indexOf(O), 1);
        }
        destroyCreatedElements() {
          this.elements.forEach(function(O) {
            T(O);
          }), this.elements = [];
        }
      };
    }), a(e, "Accessibility/Utils/EventProvider.js", [e["Core/Globals.js"], e["Core/Utilities.js"]], function(o, n) {
      let { addEvent: r } = n;
      return class {
        constructor() {
          this.eventRemovers = [];
        }
        addEvent() {
          let T = r.apply(o, arguments);
          return this.eventRemovers.push({ element: arguments[0], remover: T }), T;
        }
        removeEvent(T) {
          let O = this.eventRemovers.map((j) => j.remover).indexOf(T);
          this.eventRemovers[O].remover(), this.eventRemovers.splice(O, 1);
        }
        removeAddedEvents() {
          this.eventRemovers.map((T) => T.remover).forEach((T) => T()), this.eventRemovers = [];
        }
      };
    }), a(e, "Accessibility/AccessibilityComponent.js", [e["Accessibility/Utils/ChartUtilities.js"], e["Accessibility/Utils/DOMElementProvider.js"], e["Accessibility/Utils/EventProvider.js"], e["Accessibility/Utils/HTMLUtilities.js"]], function(o, n, r, T) {
      let { fireEventOnWrappedOrUnwrappedElement: O } = o, { getFakeMouseEvent: j } = T;
      return class {
        destroy() {
        }
        getKeyboardNavigation() {
          return [];
        }
        init() {
        }
        onChartRender() {
        }
        onChartUpdate() {
        }
        initBase(D, F) {
          this.chart = D, this.eventProvider = new r(), this.domElementProvider = new n(), this.proxyProvider = F, this.keyCodes = { left: 37, right: 39, up: 38, down: 40, enter: 13, space: 32, esc: 27, tab: 9, pageUp: 33, pageDown: 34, end: 35, home: 36 };
        }
        addEvent(D, F, B, N) {
          return this.eventProvider.addEvent(D, F, B, N);
        }
        createElement(D, F) {
          return this.domElementProvider.createElement(D, F);
        }
        fakeClickEvent(D) {
          O(D, j("click"));
        }
        destroyBase() {
          this.domElementProvider.destroyCreatedElements(), this.eventProvider.removeAddedEvents();
        }
      };
    }), a(e, "Accessibility/KeyboardNavigationHandler.js", [e["Core/Utilities.js"]], function(o) {
      let { find: n } = o;
      return class {
        constructor(r, T) {
          this.chart = r, this.keyCodeMap = T.keyCodeMap || [], this.validate = T.validate, this.init = T.init, this.terminate = T.terminate, this.response = { success: 1, prev: 2, next: 3, noHandler: 4, fail: 5 };
        }
        run(r) {
          let T = r.which || r.keyCode, O = this.response.noHandler, j = n(this.keyCodeMap, function(D) {
            return D[0].indexOf(T) > -1;
          });
          return j ? O = j[1].call(this, T, r) : T === 9 && (O = this.response[r.shiftKey ? "prev" : "next"]), O;
        }
      };
    }), a(e, "Accessibility/Components/ContainerComponent.js", [e["Accessibility/AccessibilityComponent.js"], e["Accessibility/KeyboardNavigationHandler.js"], e["Accessibility/Utils/ChartUtilities.js"], e["Core/Globals.js"], e["Accessibility/Utils/HTMLUtilities.js"]], function(o, n, r, T, O) {
      let { unhideChartElementFromAT: j, getChartTitle: D } = r, { doc: F } = T, { stripHTMLTagsFromString: B } = O;
      return class extends o {
        onChartUpdate() {
          this.handleSVGTitleElement(), this.setSVGContainerLabel(), this.setGraphicContainerAttrs(), this.setRenderToAttrs(), this.makeCreditsAccessible();
        }
        handleSVGTitleElement() {
          let N = this.chart, f = "highcharts-title-" + N.index, w = B(N.langFormat("accessibility.svgContainerTitle", { chartTitle: D(N) }));
          if (w.length) {
            let x = this.svgTitleElement = this.svgTitleElement || F.createElementNS("http://www.w3.org/2000/svg", "title");
            x.textContent = w, x.id = f, N.renderTo.insertBefore(x, N.renderTo.firstChild);
          }
        }
        setSVGContainerLabel() {
          let N = this.chart, f = N.langFormat("accessibility.svgContainerLabel", { chartTitle: D(N) });
          N.renderer.box && f.length && N.renderer.box.setAttribute("aria-label", f);
        }
        setGraphicContainerAttrs() {
          let N = this.chart, f = N.langFormat("accessibility.graphicContainerLabel", { chartTitle: D(N) });
          f.length && N.container.setAttribute("aria-label", f);
        }
        setRenderToAttrs() {
          let N = this.chart, f = N.options.accessibility.landmarkVerbosity !== "disabled", w = N.langFormat("accessibility.chartContainerLabel", { title: D(N), chart: N });
          w && (N.renderTo.setAttribute("role", f ? "region" : "group"), N.renderTo.setAttribute("aria-label", w));
        }
        makeCreditsAccessible() {
          let N = this.chart, f = N.credits;
          f && (f.textStr && f.element.setAttribute("aria-label", N.langFormat("accessibility.credits", { creditsStr: B(f.textStr, N.renderer.forExport) })), j(N, f.element));
        }
        getKeyboardNavigation() {
          let N = this.chart;
          return new n(N, { keyCodeMap: [], validate: function() {
            return !0;
          }, init: function() {
            let f = N.accessibility;
            f && f.keyboardNavigation.tabindexContainer.focus();
          } });
        }
        destroy() {
          this.chart.renderTo.setAttribute("aria-hidden", !0);
        }
      };
    }), a(e, "Accessibility/FocusBorder.js", [e["Core/Utilities.js"]], function(o) {
      var n;
      let { addEvent: r, pick: T } = o;
      return function(O) {
        let j = ["x", "y", "transform", "width", "height", "r", "d", "stroke-width"];
        function D() {
          let f = this.focusElement, w = this.options.accessibility.keyboardNavigation.focusBorder;
          f && (f.removeFocusBorder(), w.enabled && f.addFocusBorder(w.margin, { stroke: w.style.color, strokeWidth: w.style.lineWidth, r: w.style.borderRadius }));
        }
        function F(f, w) {
          let x = this.options.accessibility.keyboardNavigation.focusBorder, M = w || f.element;
          M && M.focus && (M.hcEvents && M.hcEvents.focusin || r(M, "focusin", function() {
          }), M.focus(), x.hideBrowserFocusOutline && (M.style.outline = "none")), this.focusElement && this.focusElement.removeFocusBorder(), this.focusElement = f, this.renderFocusBorder();
        }
        function B(f, w) {
          this.focusBorder && this.removeFocusBorder();
          let x = this.getBBox(), M = T(f, 3), p = this.parentGroup, v = this.scaleX || p && p.scaleX, k = this.scaleY || p && p.scaleY, m = (v ? !k : k) ? Math.abs(v || k || 1) : (Math.abs(v || 1) + Math.abs(k || 1)) / 2;
          x.x += this.translateX ? this.translateX : 0, x.y += this.translateY ? this.translateY : 0;
          let A = x.x - M, C = x.y - M, H = x.width + 2 * M, G = x.height + 2 * M, P = !!this.text;
          if (this.element.nodeName === "text" || P) {
            let y, S, d = !!this.rotation, s = P ? { x: d ? 1 : 0, y: 0 } : (y = 0, S = 0, this.attr("text-anchor") === "middle" ? y = S = 0.5 : this.rotation ? y = 0.25 : S = 0.75, { x: y, y: S }), l = +this.attr("x"), b = +this.attr("y");
            if (isNaN(l) || (A = l - x.width * s.x - M), isNaN(b) || (C = b - x.height * s.y - M), P && d) {
              let u = H;
              H = G, G = u, isNaN(l) || (A = l - x.height * s.x - M), isNaN(b) || (C = b - x.width * s.y - M);
            }
          }
          this.focusBorder = this.renderer.rect(A, C, H, G, parseInt((w && w.r || 0).toString(), 10) / m).addClass("highcharts-focus-border").attr({ zIndex: 99 }).add(p), this.renderer.styledMode || this.focusBorder.attr({ stroke: w && w.stroke, "stroke-width": (w && w.strokeWidth || 0) / m }), function(y, ...S) {
            y.focusBorderUpdateHooks || (y.focusBorderUpdateHooks = {}, j.forEach((d) => {
              let s = d + "Setter", l = y[s] || y._defaultSetter;
              y.focusBorderUpdateHooks[s] = l, y[s] = function() {
                let b = l.apply(y, arguments);
                return y.addFocusBorder.apply(y, S), b;
              };
            }));
          }(this, f, w), function(y) {
            if (y.focusBorderDestroyHook) return;
            let S = y.destroy;
            y.destroy = function() {
              return y.focusBorder && y.focusBorder.destroy && y.focusBorder.destroy(), S.apply(y, arguments);
            }, y.focusBorderDestroyHook = S;
          }(this);
        }
        function N() {
          var f;
          f = this, f.focusBorderUpdateHooks && (Object.keys(f.focusBorderUpdateHooks).forEach((w) => {
            let x = f.focusBorderUpdateHooks[w];
            x === f._defaultSetter ? delete f[w] : f[w] = x;
          }), delete f.focusBorderUpdateHooks), this.focusBorderDestroyHook && (this.destroy = this.focusBorderDestroyHook, delete this.focusBorderDestroyHook), this.focusBorder && (this.focusBorder.destroy(), delete this.focusBorder);
        }
        O.compose = function(f, w) {
          let x = f.prototype, M = w.prototype;
          x.renderFocusBorder || (x.renderFocusBorder = D, x.setFocusToElement = F), M.addFocusBorder || (M.addFocusBorder = B, M.removeFocusBorder = N);
        };
      }(n || (n = {})), n;
    }), a(e, "Accessibility/Utils/Announcer.js", [e["Core/Renderer/HTML/AST.js"], e["Accessibility/Utils/DOMElementProvider.js"], e["Core/Globals.js"], e["Accessibility/Utils/HTMLUtilities.js"], e["Core/Utilities.js"]], function(o, n, r, T, O) {
      let { doc: j } = r, { addClass: D, visuallyHideElement: F } = T, { attr: B } = O;
      return class {
        constructor(N, f) {
          this.chart = N, this.domElementProvider = new n(), this.announceRegion = this.addAnnounceRegion(f);
        }
        destroy() {
          this.domElementProvider.destroyCreatedElements();
        }
        announce(N) {
          o.setElementHTML(this.announceRegion, N), this.clearAnnouncementRegionTimer && clearTimeout(this.clearAnnouncementRegionTimer), this.clearAnnouncementRegionTimer = setTimeout(() => {
            this.announceRegion.innerHTML = o.emptyHTML, delete this.clearAnnouncementRegionTimer;
          }, 3e3);
        }
        addAnnounceRegion(N) {
          let f = this.chart.announcerContainer || this.createAnnouncerContainer(), w = this.domElementProvider.createElement("div");
          return B(w, { "aria-hidden": !1, "aria-live": N, "aria-atomic": !0 }), this.chart.styledMode ? D(w, "highcharts-visually-hidden") : F(w), f.appendChild(w), w;
        }
        createAnnouncerContainer() {
          let N = this.chart, f = j.createElement("div");
          return B(f, { "aria-hidden": !1, class: "highcharts-announcer-container" }), f.style.position = "relative", N.renderTo.insertBefore(f, N.renderTo.firstChild), N.announcerContainer = f, f;
        }
      };
    }), a(e, "Accessibility/Components/AnnotationsA11y.js", [e["Accessibility/Utils/HTMLUtilities.js"]], function(o) {
      let { escapeStringForHTML: n, stripHTMLTagsFromString: r } = o;
      function T(F) {
        return (F.annotations || []).reduce((B, N) => (N.options && N.options.visible !== !1 && (B = B.concat(N.labels)), B), []);
      }
      function O(F) {
        return F.options && F.options.accessibility && F.options.accessibility.description || F.graphic && F.graphic.text && F.graphic.text.textStr || "";
      }
      function j(F) {
        let B = F.options && F.options.accessibility && F.options.accessibility.description;
        if (B) return B;
        let N = F.chart, f = O(F), w = F.points, x = (m) => m.graphic && m.graphic.element && m.graphic.element.getAttribute("aria-label") || "", M = w.filter((m) => !!m.graphic).map((m) => {
          let A = m.accessibility && m.accessibility.valueDescription || x(m), C = m && m.series.name || "";
          return (C ? C + ", " : "") + "data point " + A;
        }).filter((m) => !!m), p = M.length, v = p > 1 ? "MultiplePoints" : p ? "SinglePoint" : "NoPoints", k = { annotationText: f, annotation: F, numPoints: p, annotationPoint: M[0], additionalAnnotationPoints: M.slice(1) };
        return N.langFormat("accessibility.screenReaderSection.annotations.description" + v, k);
      }
      function D(F) {
        return T(F).map((B) => {
          let N = n(r(j(B), F.renderer.forExport));
          return N ? `<li>${N}</li>` : "";
        });
      }
      return { getAnnotationsInfoHTML: function(F) {
        let B = F.annotations;
        return B && B.length ? `<ul style="list-style-type: none">${D(F).join(" ")}</ul>` : "";
      }, getAnnotationLabelDescription: j, getAnnotationListItems: D, getPointAnnotationTexts: function(F) {
        let B = T(F.series.chart).filter((N) => N.points.indexOf(F) > -1);
        return B.length ? B.map((N) => `${O(N)}`) : [];
      } };
    }), a(e, "Accessibility/Components/InfoRegionsComponent.js", [e["Accessibility/A11yI18n.js"], e["Accessibility/AccessibilityComponent.js"], e["Accessibility/Utils/Announcer.js"], e["Accessibility/Components/AnnotationsA11y.js"], e["Core/Renderer/HTML/AST.js"], e["Accessibility/Utils/ChartUtilities.js"], e["Core/Templating.js"], e["Core/Globals.js"], e["Accessibility/Utils/HTMLUtilities.js"], e["Core/Utilities.js"]], function(o, n, r, T, O, j, D, F, B, N) {
      let { getAnnotationsInfoHTML: f } = T, { getAxisDescription: w, getAxisRangeDescription: x, getChartTitle: M, unhideChartElementFromAT: p } = j, { format: v } = D, { doc: k } = F, { addClass: m, getElement: A, getHeadingTagNameForElement: C, stripHTMLTagsFromString: H, visuallyHideElement: G } = B, { attr: P, pick: y, replaceNested: S } = N;
      function d(s) {
        return S(s, [/<([\w\-.:!]+)\b[^<>]*>\s*<\/\1>/g, ""]);
      }
      return class extends n {
        constructor() {
          super(...arguments), this.screenReaderSections = {};
        }
        init() {
          let s = this.chart, l = this;
          this.initRegionsDefinitions(), this.addEvent(s, "aftergetTableAST", function(b) {
            l.onDataTableCreated(b);
          }), this.addEvent(s, "afterViewData", function(b) {
            b.wasHidden && (l.dataTableDiv = b.element, setTimeout(function() {
              l.focusDataTable();
            }, 300));
          }), this.addEvent(s, "afterHideData", function() {
            l.viewDataTableButton && l.viewDataTableButton.setAttribute("aria-expanded", "false");
          }), s.exporting && this.addEvent(s, "afterPrint", function() {
            l.updateAllScreenReaderSections();
          }), this.announcer = new r(s, "assertive");
        }
        initRegionsDefinitions() {
          let s = this, l = this.chart.options.accessibility;
          this.screenReaderSections = { before: { element: null, buildContent: function(b) {
            let u = l.screenReaderSection.beforeChartFormatter;
            return u ? u(b) : s.defaultBeforeChartFormatter(b);
          }, insertIntoDOM: function(b, u) {
            u.renderTo.insertBefore(b, u.renderTo.firstChild);
          }, afterInserted: function() {
            s.sonifyButtonId !== void 0 && s.initSonifyButton(s.sonifyButtonId), s.dataTableButtonId !== void 0 && s.initDataTableButton(s.dataTableButtonId);
          } }, after: { element: null, buildContent: function(b) {
            let u = l.screenReaderSection.afterChartFormatter;
            return u ? u(b) : s.defaultAfterChartFormatter();
          }, insertIntoDOM: function(b, u) {
            u.renderTo.insertBefore(b, u.container.nextSibling);
          }, afterInserted: function() {
            s.chart.accessibility && l.keyboardNavigation.enabled && s.chart.accessibility.keyboardNavigation.updateExitAnchor();
          } } };
        }
        onChartRender() {
          this.linkedDescriptionElement = this.getLinkedDescriptionElement(), this.setLinkedDescriptionAttrs(), this.updateAllScreenReaderSections();
        }
        updateAllScreenReaderSections() {
          let s = this;
          Object.keys(this.screenReaderSections).forEach(function(l) {
            s.updateScreenReaderSection(l);
          });
        }
        getLinkedDescriptionElement() {
          let s = this.chart.options.accessibility.linkedDescription;
          if (!s) return;
          if (typeof s != "string") return s;
          let l = v(s, this.chart), b = k.querySelectorAll(l);
          if (b.length === 1) return b[0];
        }
        setLinkedDescriptionAttrs() {
          let s = this.linkedDescriptionElement;
          s && (s.setAttribute("aria-hidden", "true"), m(s, "highcharts-linked-description"));
        }
        updateScreenReaderSection(s) {
          let l = this.chart, b = this.screenReaderSections[s], u = b.buildContent(l), c = b.element = b.element || this.createElement("div"), h = c.firstChild || this.createElement("div");
          u ? (this.setScreenReaderSectionAttribs(c, s), O.setElementHTML(h, u), c.appendChild(h), b.insertIntoDOM(c, l), l.styledMode ? m(h, "highcharts-visually-hidden") : G(h), p(l, h), b.afterInserted && b.afterInserted()) : (c.parentNode && c.parentNode.removeChild(c), b.element = null);
        }
        setScreenReaderSectionAttribs(s, l) {
          let b = this.chart, u = b.langFormat("accessibility.screenReaderSection." + l + "RegionLabel", { chart: b, chartTitle: M(b) });
          P(s, { id: `highcharts-screen-reader-region-${l}-${b.index}`, "aria-label": u || void 0 }), s.style.position = "relative", u && s.setAttribute("role", b.options.accessibility.landmarkVerbosity === "all" ? "region" : "group");
        }
        defaultBeforeChartFormatter() {
          let s = this.chart, l = s.options.accessibility.screenReaderSection.beforeChartFormat;
          if (!l) return "";
          let b = this.getAxesDescription(), u = s.sonify && s.options.sonification && s.options.sonification.enabled, c = "highcharts-a11y-sonify-data-btn-" + s.index, h = "hc-linkto-highcharts-data-table-" + s.index, g = f(s), E = s.langFormat("accessibility.screenReaderSection.annotations.heading", { chart: s }), R = { headingTagName: C(s.renderTo), chartTitle: M(s), typeDescription: this.getTypeDescriptionText(), chartSubtitle: this.getSubtitleText(), chartLongdesc: this.getLongdescText(), xAxisDescription: b.xAxis, yAxisDescription: b.yAxis, playAsSoundButton: u ? this.getSonifyButtonText(c) : "", viewTableButton: s.getCSV ? this.getDataTableButtonText(h) : "", annotationsTitle: g ? E : "", annotationsList: g }, L = o.i18nFormat(l, R, s);
          return this.dataTableButtonId = h, this.sonifyButtonId = c, d(L);
        }
        defaultAfterChartFormatter() {
          let s = this.chart, l = s.options.accessibility.screenReaderSection.afterChartFormat;
          if (!l) return "";
          let b = { endOfChartMarker: this.getEndOfChartMarkerText() };
          return d(o.i18nFormat(l, b, s));
        }
        getLinkedDescription() {
          let s = this.linkedDescriptionElement;
          return H(s && s.innerHTML || "", this.chart.renderer.forExport);
        }
        getLongdescText() {
          let s = this.chart.options, l = s.caption, b = l && l.text, u = this.getLinkedDescription();
          return s.accessibility.description || u || b || "";
        }
        getTypeDescriptionText() {
          let s = this.chart;
          return s.types ? s.options.accessibility.typeDescription || function(l, b) {
            let u = b[0], c = l.series && l.series[0] || {}, h = l.mapView && l.mapView.geoMap && l.mapView.geoMap.title, g = { numSeries: l.series.length, numPoints: c.points && c.points.length, chart: l, mapTitle: h };
            return u ? u === "map" || u === "tiledwebmap" ? g.mapTitle ? l.langFormat("accessibility.chartTypes.mapTypeDescription", g) : l.langFormat("accessibility.chartTypes.unknownMap", g) : l.types.length > 1 ? l.langFormat("accessibility.chartTypes.combinationChart", g) : function(E, R, L) {
              let U = R[0], V = E.langFormat("accessibility.seriesTypeDescriptions." + U, L), q = E.series && E.series.length < 2 ? "Single" : "Multiple";
              return (E.langFormat("accessibility.chartTypes." + U + q, L) || E.langFormat("accessibility.chartTypes.default" + q, L)) + (V ? " " + V : "");
            }(l, b, g) : l.langFormat("accessibility.chartTypes.emptyChart", g);
          }(s, s.types) : "";
        }
        getDataTableButtonText(s) {
          let l = this.chart;
          return '<button id="' + s + '">' + l.langFormat("accessibility.table.viewAsDataTableButtonText", { chart: l, chartTitle: M(l) }) + "</button>";
        }
        getSonifyButtonText(s) {
          let l = this.chart;
          return l.options.sonification && l.options.sonification.enabled === !1 ? "" : '<button id="' + s + '">' + l.langFormat("accessibility.sonification.playAsSoundButtonText", { chart: l, chartTitle: M(l) }) + "</button>";
        }
        getSubtitleText() {
          let s = this.chart.options.subtitle;
          return H(s && s.text || "", this.chart.renderer.forExport);
        }
        getEndOfChartMarkerText() {
          let s = A(`highcharts-end-of-chart-marker-${this.chart.index}`);
          if (s) return s.outerHTML;
          let l = this.chart, b = l.langFormat("accessibility.screenReaderSection.endOfChartMarker", { chart: l });
          return '<div id="highcharts-end-of-chart-marker-' + l.index + '">' + b + "</div>";
        }
        onDataTableCreated(s) {
          let l = this.chart;
          if (l.options.accessibility.enabled) {
            this.viewDataTableButton && this.viewDataTableButton.setAttribute("aria-expanded", "true");
            let b = s.tree.attributes || {};
            b.tabindex = -1, b.summary = l.langFormat("accessibility.table.tableSummary", { chart: l }), s.tree.attributes = b;
          }
        }
        focusDataTable() {
          let s = this.dataTableDiv, l = s && s.getElementsByTagName("table")[0];
          l && l.focus && l.focus();
        }
        initSonifyButton(s) {
          let l = this.sonifyButton = A(s), b = this.chart, u = (c) => {
            l && (l.setAttribute("aria-hidden", "true"), l.setAttribute("aria-label", "")), c.preventDefault(), c.stopPropagation();
            let h = b.langFormat("accessibility.sonification.playAsSoundClickAnnouncement", { chart: b });
            this.announcer.announce(h), setTimeout(() => {
              l && (l.removeAttribute("aria-hidden"), l.removeAttribute("aria-label")), b.sonify && b.sonify();
            }, 1e3);
          };
          l && b && (l.setAttribute("tabindex", -1), l.onclick = function(c) {
            (b.options.accessibility && b.options.accessibility.screenReaderSection.onPlayAsSoundClick || u).call(this, c, b);
          });
        }
        initDataTableButton(s) {
          let l = this.viewDataTableButton = A(s), b = this.chart, u = s.replace("hc-linkto-", "");
          l && (P(l, { tabindex: -1, "aria-expanded": !!A(u) }), l.onclick = b.options.accessibility.screenReaderSection.onViewDataTableClick || function() {
            b.viewData();
          });
        }
        getAxesDescription() {
          let s = this.chart, l = function(E, R) {
            let L = s[E];
            return L.length > 1 || L[0] && y(L[0].options.accessibility && L[0].options.accessibility.enabled, R);
          }, b = !!s.types && 0 > s.types.indexOf("map") && 0 > s.types.indexOf("treemap") && 0 > s.types.indexOf("tilemap"), u = !!s.hasCartesianSeries, c = l("xAxis", !s.angular && u && b), h = l("yAxis", u && b), g = {};
          return c && (g.xAxis = this.getAxisDescriptionText("xAxis")), h && (g.yAxis = this.getAxisDescriptionText("yAxis")), g;
        }
        getAxisDescriptionText(s) {
          let l = this.chart, b = l[s];
          return l.langFormat("accessibility.axis." + s + "Description" + (b.length > 1 ? "Plural" : "Singular"), { chart: l, names: b.map(function(u) {
            return w(u);
          }), ranges: b.map(function(u) {
            return x(u);
          }), numAxes: b.length });
        }
        destroy() {
          this.announcer && this.announcer.destroy();
        }
      };
    }), a(e, "Accessibility/Components/MenuComponent.js", [e["Core/Utilities.js"], e["Accessibility/AccessibilityComponent.js"], e["Accessibility/KeyboardNavigationHandler.js"], e["Accessibility/Utils/ChartUtilities.js"], e["Accessibility/Utils/HTMLUtilities.js"]], function(o, n, r, T, O) {
      let { attr: j } = o, { getChartTitle: D, unhideChartElementFromAT: F } = T, { getFakeMouseEvent: B } = O;
      function N(w) {
        return w.exportSVGElements && w.exportSVGElements[0];
      }
      class f extends n {
        init() {
          let x = this.chart, M = this;
          this.addEvent(x, "exportMenuShown", function() {
            M.onMenuShown();
          }), this.addEvent(x, "exportMenuHidden", function() {
            M.onMenuHidden();
          }), this.createProxyGroup();
        }
        onMenuHidden() {
          let x = this.chart.exportContextMenu;
          x && x.setAttribute("aria-hidden", "true"), this.setExportButtonExpandedState("false");
        }
        onMenuShown() {
          let x = this.chart, M = x.exportContextMenu;
          M && (this.addAccessibleContextMenuAttribs(), F(x, M)), this.setExportButtonExpandedState("true");
        }
        setExportButtonExpandedState(x) {
          this.exportButtonProxy && this.exportButtonProxy.innerElement.setAttribute("aria-expanded", x);
        }
        onChartRender() {
          let x = this.chart, M = x.focusElement, p = x.accessibility;
          this.proxyProvider.clearGroup("chartMenu"), this.proxyMenuButton(), this.exportButtonProxy && M && M === x.exportingGroup && (M.focusBorder ? x.setFocusToElement(M, this.exportButtonProxy.innerElement) : p && p.keyboardNavigation.tabindexContainer.focus());
        }
        proxyMenuButton() {
          let x = this.chart, M = this.proxyProvider, p = N(x);
          (function(v) {
            let k = v.options.exporting, m = N(v);
            return !!(k && k.enabled !== !1 && k.accessibility && k.accessibility.enabled && m && m.element);
          })(x) && p && (this.exportButtonProxy = M.addProxyElement("chartMenu", { click: p }, "button", { "aria-label": x.langFormat("accessibility.exporting.menuButtonLabel", { chart: x, chartTitle: D(x) }), "aria-expanded": !1, title: x.options.lang.contextButtonTitle || null }));
        }
        createProxyGroup() {
          this.chart && this.proxyProvider && this.proxyProvider.addGroup("chartMenu");
        }
        addAccessibleContextMenuAttribs() {
          let x = this.chart, M = x.exportDivElements;
          if (M && M.length) {
            M.forEach((v) => {
              v && (v.tagName !== "LI" || v.children && v.children.length ? v.setAttribute("aria-hidden", "true") : v.setAttribute("tabindex", -1));
            });
            let p = M[0] && M[0].parentNode;
            p && j(p, { "aria-hidden": void 0, "aria-label": x.langFormat("accessibility.exporting.chartMenuLabel", { chart: x }), role: "list" });
          }
        }
        getKeyboardNavigation() {
          let x = this.keyCodes, M = this.chart, p = this;
          return new r(M, { keyCodeMap: [[[x.left, x.up], function() {
            return p.onKbdPrevious(this);
          }], [[x.right, x.down], function() {
            return p.onKbdNext(this);
          }], [[x.enter, x.space], function() {
            return p.onKbdClick(this);
          }]], validate: function() {
            return !!M.exporting && M.options.exporting.enabled !== !1 && M.options.exporting.accessibility.enabled !== !1;
          }, init: function() {
            let v = p.exportButtonProxy, k = p.chart.exportingGroup;
            v && k && M.setFocusToElement(k, v.innerElement);
          }, terminate: function() {
            M.hideExportMenu();
          } });
        }
        onKbdPrevious(x) {
          let M = this.chart, p = M.options.accessibility, v = x.response, k = M.highlightedExportItemIx || 0;
          for (; k--; ) if (M.highlightExportItem(k)) return v.success;
          return p.keyboardNavigation.wrapAround ? (M.highlightLastExportItem(), v.success) : v.prev;
        }
        onKbdNext(x) {
          let M = this.chart, p = M.options.accessibility, v = x.response;
          for (let k = (M.highlightedExportItemIx || 0) + 1; k < M.exportDivElements.length; ++k) if (M.highlightExportItem(k)) return v.success;
          return p.keyboardNavigation.wrapAround ? (M.highlightExportItem(0), v.success) : v.next;
        }
        onKbdClick(x) {
          let M = this.chart, p = M.exportDivElements[M.highlightedExportItemIx], v = N(M).element;
          return M.openMenu ? this.fakeClickEvent(p) : (this.fakeClickEvent(v), M.highlightExportItem(0)), x.response.success;
        }
      }
      return function(w) {
        function x() {
          let k = N(this);
          if (k) {
            let m = k.element;
            m.onclick && m.onclick(B("click"));
          }
        }
        function M() {
          let k = this.exportDivElements;
          k && this.exportContextMenu && this.openMenu && (k.forEach((m) => {
            m && m.className === "highcharts-menu-item" && m.onmouseout && m.onmouseout(B("mouseout"));
          }), this.highlightedExportItemIx = 0, this.exportContextMenu.hideMenu(), this.container.focus());
        }
        function p(k) {
          let m = this.exportDivElements && this.exportDivElements[k], A = this.exportDivElements && this.exportDivElements[this.highlightedExportItemIx];
          if (m && m.tagName === "LI" && !(m.children && m.children.length)) {
            let C = !!(this.renderTo.getElementsByTagName("g")[0] || {}).focus;
            return m.focus && C && m.focus(), A && A.onmouseout && A.onmouseout(B("mouseout")), m.onmouseover && m.onmouseover(B("mouseover")), this.highlightedExportItemIx = k, !0;
          }
          return !1;
        }
        function v() {
          if (this.exportDivElements) {
            let k = this.exportDivElements.length;
            for (; k--; ) if (this.highlightExportItem(k)) return !0;
          }
          return !1;
        }
        w.compose = function(k) {
          let m = k.prototype;
          m.hideExportMenu || (m.hideExportMenu = M, m.highlightExportItem = p, m.highlightLastExportItem = v, m.showExportMenu = x);
        };
      }(f || (f = {})), f;
    }), a(e, "Accessibility/KeyboardNavigation.js", [e["Core/Globals.js"], e["Accessibility/Components/MenuComponent.js"], e["Core/Utilities.js"], e["Accessibility/Utils/EventProvider.js"], e["Accessibility/Utils/HTMLUtilities.js"]], function(o, n, r, T, O) {
      let { doc: j, win: D } = o, { addEvent: F, defined: B, fireEvent: N } = r, { getElement: f, simulatedEventTarget: w } = O;
      class x {
        constructor(p, v) {
          this.currentModuleIx = NaN, this.modules = [], this.init(p, v);
        }
        init(p, v) {
          let k = this.eventProvider = new T();
          this.chart = p, this.components = v, this.modules = [], this.currentModuleIx = 0, this.update(), k.addEvent(this.tabindexContainer, "keydown", (m) => this.onKeydown(m)), k.addEvent(this.tabindexContainer, "focus", (m) => this.onFocus(m)), ["mouseup", "touchend"].forEach((m) => k.addEvent(j, m, (A) => this.onMouseUp(A))), ["mousedown", "touchstart"].forEach((m) => k.addEvent(p.renderTo, m, () => {
            this.isClickingChart = !0;
          }));
        }
        update(p) {
          let v = this.chart.options.accessibility, k = v && v.keyboardNavigation, m = this.components;
          this.updateContainerTabindex(), k && k.enabled && p && p.length ? (this.modules = p.reduce(function(A, C) {
            let H = m[C].getKeyboardNavigation();
            return A.concat(H);
          }, []), this.updateExitAnchor()) : (this.modules = [], this.currentModuleIx = 0, this.removeExitAnchor());
        }
        updateExitAnchor() {
          let p = f(`highcharts-end-of-chart-marker-${this.chart.index}`);
          this.removeExitAnchor(), p ? (this.makeElementAnExitAnchor(p), this.exitAnchor = p) : this.createExitAnchor();
        }
        move(p) {
          let v = this.modules && this.modules[this.currentModuleIx];
          v && v.terminate && v.terminate(p), this.chart.focusElement && this.chart.focusElement.removeFocusBorder(), this.currentModuleIx += p;
          let k = this.modules && this.modules[this.currentModuleIx];
          if (k) {
            if (k.validate && !k.validate()) return this.move(p);
            if (k.init) return k.init(p), !0;
          }
          return this.currentModuleIx = 0, this.exiting = !0, p > 0 ? this.exitAnchor && this.exitAnchor.focus() : this.tabindexContainer.focus(), !1;
        }
        onFocus(p) {
          let v = this.chart, k = p.relatedTarget && v.container.contains(p.relatedTarget), m = v.options.accessibility, A = m && m.keyboardNavigation;
          if (A && A.enabled && !this.exiting && !this.tabbingInBackwards && !this.isClickingChart && !k) {
            let C = this.getFirstValidModuleIx();
            C !== null && (this.currentModuleIx = C, this.modules[C].init(1));
          }
          this.keyboardReset = !1, this.exiting = !1;
        }
        onMouseUp(p) {
          if (delete this.isClickingChart, !this.keyboardReset && p.relatedTarget !== w) {
            let v = this.chart;
            if (!p.target || !v.container.contains(p.target)) {
              let k = this.modules && this.modules[this.currentModuleIx || 0];
              k && k.terminate && k.terminate(), this.currentModuleIx = 0;
            }
            v.focusElement && (v.focusElement.removeFocusBorder(), delete v.focusElement), this.keyboardReset = !0;
          }
        }
        onKeydown(p) {
          let v, k = p || D.event, m = this.modules && this.modules.length && this.modules[this.currentModuleIx], A = k.target;
          if ((!A || A.nodeName !== "INPUT" || A.classList.contains("highcharts-a11y-proxy-element")) && (this.keyboardReset = !1, this.exiting = !1, m)) {
            let C = m.run(k);
            C === m.response.success ? v = !0 : C === m.response.prev ? v = this.move(-1) : C === m.response.next && (v = this.move(1)), v && (k.preventDefault(), k.stopPropagation());
          }
        }
        updateContainerTabindex() {
          let p, v = this.chart.options.accessibility, k = v && v.keyboardNavigation, m = !(k && k.enabled === !1), A = this.chart, C = A.container;
          A.renderTo.hasAttribute("tabindex") ? (C.removeAttribute("tabindex"), p = A.renderTo) : p = C, this.tabindexContainer = p;
          let H = p.getAttribute("tabindex");
          m && !H ? p.setAttribute("tabindex", "0") : m || A.container.removeAttribute("tabindex");
        }
        createExitAnchor() {
          let p = this.chart, v = this.exitAnchor = j.createElement("div");
          p.renderTo.appendChild(v), this.makeElementAnExitAnchor(v);
        }
        makeElementAnExitAnchor(p) {
          let v = this.tabindexContainer.getAttribute("tabindex") || 0;
          p.setAttribute("class", "highcharts-exit-anchor"), p.setAttribute("tabindex", v), p.setAttribute("aria-hidden", !1), this.addExitAnchorEventsToEl(p);
        }
        removeExitAnchor() {
          if (this.exitAnchor) {
            let p = this.eventProvider.eventRemovers.find((v) => v.element === this.exitAnchor);
            p && B(p.remover) && this.eventProvider.removeEvent(p.remover), this.exitAnchor.parentNode && this.exitAnchor.parentNode.removeChild(this.exitAnchor), delete this.exitAnchor;
          }
        }
        addExitAnchorEventsToEl(p) {
          let v = this.chart, k = this;
          this.eventProvider.addEvent(p, "focus", function(m) {
            let A = m || D.event, C = !(A.relatedTarget && v.container.contains(A.relatedTarget) || k.exiting);
            if (v.focusElement && delete v.focusElement, C) {
              if (k.tabbingInBackwards = !0, k.tabindexContainer.focus(), delete k.tabbingInBackwards, A.preventDefault(), k.modules && k.modules.length) {
                k.currentModuleIx = k.modules.length - 1;
                let H = k.modules[k.currentModuleIx];
                H && H.validate && !H.validate() ? k.move(-1) : H && H.init(-1);
              }
            } else k.exiting = !1;
          });
        }
        getFirstValidModuleIx() {
          let p = this.modules.length;
          for (let v = 0; v < p; ++v) {
            let k = this.modules[v];
            if (!k.validate || k.validate()) return v;
          }
          return null;
        }
        destroy() {
          this.removeExitAnchor(), this.eventProvider.removeAddedEvents(), this.chart.container.removeAttribute("tabindex");
        }
      }
      return function(M) {
        function p() {
          let k = this;
          N(this, "dismissPopupContent", {}, function() {
            k.tooltip && k.tooltip.hide(0), k.hideExportMenu();
          });
        }
        function v(k) {
          (k.which || k.keyCode) === 27 && o.charts && o.charts.forEach((m) => {
            m && m.dismissPopupContent && m.dismissPopupContent();
          });
        }
        M.compose = function(k) {
          n.compose(k);
          let m = k.prototype;
          return m.dismissPopupContent || (m.dismissPopupContent = p, F(j, "keydown", v)), k;
        };
      }(x || (x = {})), x;
    }), a(e, "Accessibility/Components/LegendComponent.js", [e["Core/Animation/AnimationUtilities.js"], e["Core/Globals.js"], e["Core/Legend/Legend.js"], e["Core/Utilities.js"], e["Accessibility/AccessibilityComponent.js"], e["Accessibility/KeyboardNavigationHandler.js"], e["Accessibility/Utils/ChartUtilities.js"], e["Accessibility/Utils/HTMLUtilities.js"]], function(o, n, r, T, O, j, D, F) {
      let { animObject: B } = o, { doc: N } = n, { addEvent: f, fireEvent: w, isNumber: x, pick: M, syncTimeout: p } = T, { getChartTitle: v } = D, { stripHTMLTagsFromString: k, addClass: m, removeClass: A } = F;
      function C(P) {
        let y = P.legend && P.legend.allItems, S = P.options.legend.accessibility || {}, d = P.colorAxis && P.colorAxis.some((s) => !s.dataClasses || !s.dataClasses.length);
        return !!(y && y.length && !d && S.enabled !== !1);
      }
      function H(P, y) {
        let S = y.legendItem || {};
        for (let d of (y.setState(P ? "hover" : "", !0), ["group", "label", "symbol"])) {
          let s = S[d], l = s && s.element || s;
          l && w(l, P ? "mouseover" : "mouseout");
        }
      }
      class G extends O {
        constructor() {
          super(...arguments), this.highlightedLegendItemIx = NaN, this.proxyGroup = null;
        }
        init() {
          let y = this;
          this.recreateProxies(), this.addEvent(r, "afterScroll", function() {
            this.chart === y.chart && (y.proxyProvider.updateGroupProxyElementPositions("legend"), y.updateLegendItemProxyVisibility(), y.highlightedLegendItemIx > -1 && this.chart.highlightLegendItem(y.highlightedLegendItemIx));
          }), this.addEvent(r, "afterPositionItem", function(S) {
            this.chart === y.chart && this.chart.renderer && y.updateProxyPositionForItem(S.item);
          }), this.addEvent(r, "afterRender", function() {
            this.chart === y.chart && this.chart.renderer && y.recreateProxies() && p(() => y.proxyProvider.updateGroupProxyElementPositions("legend"), B(M(this.chart.renderer.globalAnimation, !0)).duration);
          });
        }
        updateLegendItemProxyVisibility() {
          let y, S = this.chart, d = S.legend, s = d.allItems || [], l = d.currentPage || 1, b = d.clipHeight || 0;
          s.forEach((u) => {
            if (u.a11yProxyElement) {
              let c = d.pages && d.pages.length, h = u.a11yProxyElement.element, g = !1;
              if (y = u.legendItem || {}, c) {
                let E = y.pageIx || 0;
                g = (y.y || 0) + (y.label ? Math.round(y.label.getBBox().height) : 0) - d.pages[E] > b || E !== l - 1;
              }
              g ? S.styledMode ? m(h, "highcharts-a11y-invisible") : h.style.visibility = "hidden" : (A(h, "highcharts-a11y-invisible"), h.style.visibility = "");
            }
          });
        }
        onChartRender() {
          C(this.chart) || this.removeProxies();
        }
        highlightAdjacentLegendPage(y) {
          let S = this.chart, d = S.legend, s = (d.currentPage || 1) + y, l = d.pages || [];
          if (s > 0 && s <= l.length) {
            let b = 0;
            for (let u of d.allItems) ((u.legendItem || {}).pageIx || 0) + 1 === s && S.highlightLegendItem(b) && (this.highlightedLegendItemIx = b), ++b;
          }
        }
        updateProxyPositionForItem(y) {
          y.a11yProxyElement && y.a11yProxyElement.refreshPosition();
        }
        recreateProxies() {
          let y = N.activeElement, S = this.proxyGroup, d = y && S && S.contains(y);
          return this.removeProxies(), !!C(this.chart) && (this.addLegendProxyGroup(), this.proxyLegendItems(), this.updateLegendItemProxyVisibility(), this.updateLegendTitle(), d && this.chart.highlightLegendItem(this.highlightedLegendItemIx), !0);
        }
        removeProxies() {
          this.proxyProvider.removeGroup("legend");
        }
        updateLegendTitle() {
          let y = this.chart, S = k((y.legend && y.legend.options.title && y.legend.options.title.text || "").replace(/<br ?\/?>/g, " "), y.renderer.forExport), d = y.langFormat("accessibility.legend.legendLabel" + (S ? "" : "NoTitle"), { chart: y, legendTitle: S, chartTitle: v(y) });
          this.proxyProvider.updateGroupAttrs("legend", { "aria-label": d });
        }
        addLegendProxyGroup() {
          let y = this.chart.options.accessibility.landmarkVerbosity === "all" ? "region" : null;
          this.proxyGroup = this.proxyProvider.addGroup("legend", "ul", { "aria-label": "_placeholder_", role: y });
        }
        proxyLegendItems() {
          let y, S = this;
          ((this.chart.legend || {}).allItems || []).forEach((d) => {
            (y = d.legendItem || {}).label && y.label.element && S.proxyLegendItem(d);
          });
        }
        proxyLegendItem(y) {
          let S = y.legendItem || {};
          if (!S.label || !S.group) return;
          let d = this.chart.langFormat("accessibility.legend.legendItem", { chart: this.chart, itemName: k(y.name, this.chart.renderer.forExport), item: y }), s = { tabindex: -1, "aria-pressed": y.visible, "aria-label": d }, l = S.group.div ? S.label : S.group;
          y.a11yProxyElement = this.proxyProvider.addProxyElement("legend", { click: S.label, visual: l.element }, "button", s);
        }
        getKeyboardNavigation() {
          let y = this.keyCodes, S = this, d = this.chart;
          return new j(d, { keyCodeMap: [[[y.left, y.right, y.up, y.down], function(s) {
            return S.onKbdArrowKey(this, s);
          }], [[y.enter, y.space], function() {
            return S.onKbdClick(this);
          }], [[y.pageDown, y.pageUp], function(s) {
            let l = s === y.pageDown ? 1 : -1;
            return S.highlightAdjacentLegendPage(l), this.response.success;
          }]], validate: function() {
            return S.shouldHaveLegendNavigation();
          }, init: function() {
            d.highlightLegendItem(0), S.highlightedLegendItemIx = 0;
          }, terminate: function() {
            S.highlightedLegendItemIx = -1, d.legend.allItems.forEach((s) => H(!1, s));
          } });
        }
        onKbdArrowKey(y, S) {
          let { keyCodes: { left: d, up: s }, highlightedLegendItemIx: l, chart: b } = this, u = b.legend.allItems.length, c = b.options.accessibility.keyboardNavigation.wrapAround, h = S === d || S === s ? -1 : 1;
          return b.highlightLegendItem(l + h) ? this.highlightedLegendItemIx += h : c && u > 1 && (this.highlightedLegendItemIx = h > 0 ? 0 : u - 1, b.highlightLegendItem(this.highlightedLegendItemIx)), y.response.success;
        }
        onKbdClick(y) {
          let S = this.chart.legend.allItems[this.highlightedLegendItemIx];
          return S && S.a11yProxyElement && S.a11yProxyElement.click(), y.response.success;
        }
        shouldHaveLegendNavigation() {
          if (!C(this.chart)) return !1;
          let y = this.chart, S = (y.options.legend || {}).accessibility || {};
          return !!(y.legend.display && S.keyboardNavigation && S.keyboardNavigation.enabled);
        }
        destroy() {
          this.removeProxies();
        }
      }
      return function(P) {
        function y(d) {
          let s = this.legend.allItems, l = this.accessibility && this.accessibility.components.legend.highlightedLegendItemIx, b = s[d], u = (b == null ? void 0 : b.legendItem) || {};
          if (b) {
            x(l) && s[l] && H(!1, s[l]), function(g, E) {
              let R = (g.allItems[E].legendItem || {}).pageIx, L = g.currentPage;
              R !== void 0 && R + 1 !== L && g.scroll(1 + R - L);
            }(this.legend, d);
            let c = u.label, h = b.a11yProxyElement && b.a11yProxyElement.innerElement;
            return c && c.element && h && this.setFocusToElement(c, h), H(!0, b), !0;
          }
          return !1;
        }
        function S(d) {
          let s = this.chart.options.accessibility, l = d.item;
          s.enabled && l && l.a11yProxyElement && l.a11yProxyElement.innerElement.setAttribute("aria-pressed", d.visible ? "true" : "false");
        }
        P.compose = function(d, s) {
          let l = d.prototype;
          l.highlightLegendItem || (l.highlightLegendItem = y, f(s, "afterColorizeItem", S));
        };
      }(G || (G = {})), G;
    }), a(e, "Stock/Navigator/ChartNavigatorComposition.js", [e["Core/Globals.js"], e["Core/Utilities.js"]], function(o, n) {
      let r, { isTouchDevice: T } = o, { addEvent: O, merge: j, pick: D } = n, F = [];
      function B() {
        this.navigator && this.navigator.setBaseSeries(null, !1);
      }
      function N() {
        var H;
        let v, k, m, A = this.legend, C = this.navigator;
        if (C) {
          v = A && A.options, k = C.xAxis, m = C.yAxis;
          let { scrollbarHeight: G, scrollButtonSize: P } = C;
          this.inverted ? (C.left = C.opposite ? this.chartWidth - G - C.height : this.spacing[3] + G, C.top = this.plotTop + P) : (C.left = D(k.left, this.plotLeft + P), C.top = C.navigatorOptions.top || this.chartHeight - C.height - G - (((H = this.scrollbar) == null ? void 0 : H.options.margin) || 0) - this.spacing[2] - (this.rangeSelector && this.extraBottomMargin ? this.rangeSelector.getHeight() : 0) - (v && v.verticalAlign === "bottom" && v.layout !== "proximate" && v.enabled && !v.floating ? A.legendHeight + D(v.margin, 10) : 0) - (this.titleOffset ? this.titleOffset[2] : 0)), k && m && (this.inverted ? k.options.left = m.options.left = C.left : k.options.top = m.options.top = C.top, k.setAxisSize(), m.setAxisSize());
        }
      }
      function f(v) {
        !this.navigator && !this.scroller && (this.options.navigator.enabled || this.options.scrollbar.enabled) && (this.scroller = this.navigator = new r(this), D(v.redraw, !0) && this.redraw(v.animation));
      }
      function w() {
        let v = this.options;
        (v.navigator.enabled || v.scrollbar.enabled) && (this.scroller = this.navigator = new r(this));
      }
      function x() {
        let v = this.options, k = v.navigator, m = v.rangeSelector;
        if ((k && k.enabled || m && m.enabled) && (!T && this.zooming.type === "x" || T && this.zooming.pinchType === "x")) return !1;
      }
      function M(v) {
        let k = v.navigator;
        if (k && v.xAxis[0]) {
          let m = v.xAxis[0].getExtremes();
          k.render(m.min, m.max);
        }
      }
      function p(v) {
        let k = v.options.navigator || {}, m = v.options.scrollbar || {};
        !this.navigator && !this.scroller && (k.enabled || m.enabled) && (j(!0, this.options.navigator, k), j(!0, this.options.scrollbar, m), delete v.options.navigator, delete v.options.scrollbar);
      }
      return { compose: function(v, k) {
        if (n.pushUnique(F, v)) {
          let m = v.prototype;
          r = k, m.callbacks.push(M), O(v, "afterAddSeries", B), O(v, "afterSetChartSize", N), O(v, "afterUpdate", f), O(v, "beforeRender", w), O(v, "beforeShowResetZoom", x), O(v, "update", p);
        }
      } };
    }), a(e, "Core/Axis/NavigatorAxisComposition.js", [e["Core/Globals.js"], e["Core/Utilities.js"]], function(o, n) {
      let { isTouchDevice: r } = o, { addEvent: T, correctFloat: O, defined: j, isNumber: D, pick: F } = n;
      function B() {
        this.navigatorAxis || (this.navigatorAxis = new f(this));
      }
      function N(w) {
        let x, M = this.chart, p = M.options, v = p.navigator, k = this.navigatorAxis, m = M.zooming.pinchType, A = p.rangeSelector, C = M.zooming.type;
        if (this.isXAxis && (v != null && v.enabled || A != null && A.enabled)) {
          if (C === "y" && w.trigger === "zoom") x = !1;
          else if ((w.trigger === "zoom" && C === "xy" || r && m === "xy") && this.options.range) {
            let H = k.previousZoom;
            j(w.min) ? k.previousZoom = [this.min, this.max] : H && (w.min = H[0], w.max = H[1], k.previousZoom = void 0);
          }
        }
        x !== void 0 && w.preventDefault();
      }
      class f {
        static compose(x) {
          x.keepProps.includes("navigatorAxis") || (x.keepProps.push("navigatorAxis"), T(x, "init", B), T(x, "setExtremes", N));
        }
        constructor(x) {
          this.axis = x;
        }
        destroy() {
          this.axis = void 0;
        }
        toFixedRange(x, M, p, v) {
          let k = this.axis, m = (k.pointRange || 0) / 2, A = F(p, k.translate(x, !0, !k.horiz)), C = F(v, k.translate(M, !0, !k.horiz));
          return j(p) || (A = O(A + m)), j(v) || (C = O(C - m)), D(A) && D(C) || (A = C = void 0), { min: A, max: C };
        }
      }
      return f;
    }), a(e, "Stock/Navigator/NavigatorDefaults.js", [e["Core/Color/Color.js"], e["Core/Series/SeriesRegistry.js"]], function(o, n) {
      let { parse: r } = o, { seriesTypes: T } = n;
      return { height: 40, margin: 25, maskInside: !0, handles: { width: 7, borderRadius: 0, height: 15, symbols: ["navigator-handle", "navigator-handle"], enabled: !0, lineWidth: 1, backgroundColor: "#f2f2f2", borderColor: "#999999" }, maskFill: r("#667aff").setOpacity(0.3).get(), outlineColor: "#999999", outlineWidth: 1, series: { type: T.areaspline === void 0 ? "line" : "areaspline", fillOpacity: 0.05, lineWidth: 1, compare: null, sonification: { enabled: !1 }, dataGrouping: { approximation: "average", enabled: !0, groupPixelWidth: 2, firstAnchor: "firstPoint", anchor: "middle", lastAnchor: "lastPoint", units: [["millisecond", [1, 2, 5, 10, 20, 25, 50, 100, 200, 500]], ["second", [1, 2, 5, 10, 15, 30]], ["minute", [1, 2, 5, 10, 15, 30]], ["hour", [1, 2, 3, 4, 6, 8, 12]], ["day", [1, 2, 3, 4]], ["week", [1, 2, 3]], ["month", [1, 3, 6]], ["year", null]] }, dataLabels: { enabled: !1, zIndex: 2 }, id: "highcharts-navigator-series", className: "highcharts-navigator-series", lineColor: null, marker: { enabled: !1 }, threshold: null }, xAxis: { className: "highcharts-navigator-xaxis", tickLength: 0, lineWidth: 0, gridLineColor: "#e6e6e6", id: "navigator-x-axis", gridLineWidth: 1, tickPixelInterval: 200, labels: { align: "left", style: { color: "#000000", fontSize: "0.7em", opacity: 0.6, textOutline: "2px contrast" }, x: 3, y: -4 }, crosshair: !1 }, yAxis: { className: "highcharts-navigator-yaxis", gridLineWidth: 0, startOnTick: !1, endOnTick: !1, minPadding: 0.1, id: "navigator-y-axis", maxPadding: 0.1, labels: { enabled: !1 }, crosshair: !1, title: { text: null }, tickLength: 0, tickWidth: 0 } };
    }), a(e, "Stock/Navigator/NavigatorSymbols.js", [e["Core/Renderer/SVG/Symbols.js"], e["Core/Utilities.js"]], function(o, n) {
      let { relativeLength: r } = n;
      return { "navigator-handle": function(T, O, j, D, F = {}) {
        let B = F.width ? F.width / 2 : j, N = r(F.borderRadius || 0, Math.min(2 * B, D));
        return [["M", -1.5, (D = F.height || D) / 2 - 3.5], ["L", -1.5, D / 2 + 4.5], ["M", 0.5, D / 2 - 3.5], ["L", 0.5, D / 2 + 4.5], ...o.rect(-B - 1, 0.5, 2 * B + 1, D, { r: N })];
      } };
    }), a(e, "Stock/Utilities/StockUtilities.js", [e["Core/Utilities.js"]], function(o) {
      let { defined: n } = o;
      return { setFixedRange: function(r) {
        let T = this.xAxis[0];
        n(T.dataMax) && n(T.dataMin) && r ? this.fixedRange = Math.min(r, T.dataMax - T.dataMin) : this.fixedRange = r;
      } };
    }), a(e, "Stock/Navigator/NavigatorComposition.js", [e["Core/Defaults.js"], e["Core/Globals.js"], e["Core/Axis/NavigatorAxisComposition.js"], e["Stock/Navigator/NavigatorDefaults.js"], e["Stock/Navigator/NavigatorSymbols.js"], e["Core/Renderer/RendererRegistry.js"], e["Stock/Utilities/StockUtilities.js"], e["Core/Utilities.js"]], function(o, n, r, T, O, j, D, F) {
      let { setOptions: B } = o, { composed: N } = n, { getRendererType: f } = j, { setFixedRange: w } = D, { addEvent: x, extend: M, pushUnique: p } = F;
      function v() {
        this.chart.navigator && !this.options.isInternal && this.chart.navigator.setBaseSeries(null, !1);
      }
      return { compose: function(k, m, A) {
        r.compose(m), p(N, "Navigator") && (k.prototype.setFixedRange = w, M(f().prototype.symbols, O), x(A, "afterUpdate", v), B({ navigator: T }));
      } };
    }), a(e, "Core/Axis/ScrollbarAxis.js", [e["Core/Globals.js"], e["Core/Utilities.js"]], function(o, n) {
      var r;
      let { composed: T } = o, { addEvent: O, defined: j, pick: D, pushUnique: F } = n;
      return function(B) {
        let N;
        function f(p) {
          let v = D(p.options && p.options.min, p.min), k = D(p.options && p.options.max, p.max);
          return { axisMin: v, axisMax: k, scrollMin: j(p.dataMin) ? Math.min(v, p.min, p.dataMin, D(p.threshold, 1 / 0)) : v, scrollMax: j(p.dataMax) ? Math.max(k, p.max, p.dataMax, D(p.threshold, -1 / 0)) : k };
        }
        function w() {
          let p = this.scrollbar, v = p && !p.options.opposite, k = this.horiz ? 2 : v ? 3 : 1;
          p && (this.chart.scrollbarsOffsets = [0, 0], this.chart.axisOffset[k] += p.size + (p.options.margin || 0));
        }
        function x() {
          let p = this;
          p.options && p.options.scrollbar && p.options.scrollbar.enabled && (p.options.scrollbar.vertical = !p.horiz, p.options.startOnTick = p.options.endOnTick = !1, p.scrollbar = new N(p.chart.renderer, p.options.scrollbar, p.chart), O(p.scrollbar, "changed", function(v) {
            let k, m, { axisMin: A, axisMax: C, scrollMin: H, scrollMax: G } = f(p), P = G - H;
            if (j(A) && j(C))
              if (p.horiz && !p.reversed || !p.horiz && p.reversed ? (k = H + P * this.to, m = H + P * this.from) : (k = H + P * (1 - this.from), m = H + P * (1 - this.to)), this.shouldUpdateExtremes(v.DOMType)) {
                let y = v.DOMType !== "mousemove" && v.DOMType !== "touchmove" && void 0;
                p.setExtremes(m, k, !0, y, v);
              } else this.setRange(this.from, this.to);
          }));
        }
        function M() {
          let p, v, k, { scrollMin: m, scrollMax: A } = f(this), C = this.scrollbar, H = this.axisTitleMargin + (this.titleOffset || 0), G = this.chart.scrollbarsOffsets, P = this.options.margin || 0;
          if (C && G) {
            if (this.horiz) this.opposite || (G[1] += H), C.position(this.left, this.top + this.height + 2 + G[1] - (this.opposite ? P : 0), this.width, this.height), this.opposite || (G[1] += P), p = 1;
            else {
              let y;
              this.opposite && (G[0] += H), y = C.options.opposite ? this.left + this.width + 2 + G[0] - (this.opposite ? 0 : P) : this.opposite ? 0 : P, C.position(y, this.top, this.width, this.height), this.opposite && (G[0] += P), p = 0;
            }
            if (G[p] += C.size + (C.options.margin || 0), isNaN(m) || isNaN(A) || !j(this.min) || !j(this.max) || this.dataMin === this.dataMax) C.setRange(0, 1);
            else if (this.min === this.max) {
              let y = this.pointRange / (this.dataMax + 1);
              v = y * this.min, k = y * (this.max + 1), C.setRange(v, k);
            } else v = (this.min - m) / (A - m), k = (this.max - m) / (A - m), this.horiz && !this.reversed || !this.horiz && this.reversed ? C.setRange(v, k) : C.setRange(1 - k, 1 - v);
          }
        }
        B.compose = function(p, v) {
          F(T, "Axis.Scrollbar") && (N = v, O(p, "afterGetOffset", w), O(p, "afterInit", x), O(p, "afterRender", M));
        };
      }(r || (r = {})), r;
    }), a(e, "Stock/Scrollbar/ScrollbarDefaults.js", [], function() {
      return { height: 10, barBorderRadius: 5, buttonBorderRadius: 0, buttonsEnabled: !1, liveRedraw: void 0, margin: void 0, minWidth: 6, opposite: !0, step: 0.2, zIndex: 3, barBackgroundColor: "#cccccc", barBorderWidth: 0, barBorderColor: "#cccccc", buttonArrowColor: "#333333", buttonBackgroundColor: "#e6e6e6", buttonBorderColor: "#cccccc", buttonBorderWidth: 1, rifleColor: "none", trackBackgroundColor: "rgba(255, 255, 255, 0.001)", trackBorderColor: "#cccccc", trackBorderRadius: 5, trackBorderWidth: 1 };
    }), a(e, "Stock/Scrollbar/Scrollbar.js", [e["Core/Defaults.js"], e["Core/Globals.js"], e["Core/Axis/ScrollbarAxis.js"], e["Stock/Scrollbar/ScrollbarDefaults.js"], e["Core/Utilities.js"]], function(o, n, r, T, O) {
      let { defaultOptions: j } = o, { addEvent: D, correctFloat: F, crisp: B, defined: N, destroyObjectProperties: f, fireEvent: w, merge: x, pick: M, removeEvent: p } = O;
      class v {
        static compose(m) {
          r.compose(m, v);
        }
        static swapXY(m, A) {
          return A && m.forEach((C) => {
            let H, G = C.length;
            for (let P = 0; P < G; P += 2) typeof (H = C[P + 1]) == "number" && (C[P + 1] = C[P + 2], C[P + 2] = H);
          }), m;
        }
        constructor(m, A, C) {
          this._events = [], this.chartX = 0, this.chartY = 0, this.from = 0, this.scrollbarButtons = [], this.scrollbarLeft = 0, this.scrollbarStrokeWidth = 1, this.scrollbarTop = 0, this.size = 0, this.to = 0, this.trackBorderWidth = 1, this.x = 0, this.y = 0, this.init(m, A, C);
        }
        addEvents() {
          let m = this.options.inverted ? [1, 0] : [0, 1], A = this.scrollbarButtons, C = this.scrollbarGroup.element, H = this.track.element, G = this.mouseDownHandler.bind(this), P = this.mouseMoveHandler.bind(this), y = this.mouseUpHandler.bind(this), S = [[A[m[0]].element, "click", this.buttonToMinClick.bind(this)], [A[m[1]].element, "click", this.buttonToMaxClick.bind(this)], [H, "click", this.trackClick.bind(this)], [C, "mousedown", G], [C.ownerDocument, "mousemove", P], [C.ownerDocument, "mouseup", y], [C, "touchstart", G], [C.ownerDocument, "touchmove", P], [C.ownerDocument, "touchend", y]];
          S.forEach(function(d) {
            D.apply(null, d);
          }), this._events = S;
        }
        buttonToMaxClick(m) {
          let A = (this.to - this.from) * M(this.options.step, 0.2);
          this.updatePosition(this.from + A, this.to + A), w(this, "changed", { from: this.from, to: this.to, trigger: "scrollbar", DOMEvent: m });
        }
        buttonToMinClick(m) {
          let A = F(this.to - this.from) * M(this.options.step, 0.2);
          this.updatePosition(F(this.from - A), F(this.to - A)), w(this, "changed", { from: this.from, to: this.to, trigger: "scrollbar", DOMEvent: m });
        }
        cursorToScrollbarPosition(m) {
          let A = this.options, C = A.minWidth > this.calculatedWidth ? A.minWidth : 0;
          return { chartX: (m.chartX - this.x - this.xOffset) / (this.barWidth - C), chartY: (m.chartY - this.y - this.yOffset) / (this.barWidth - C) };
        }
        destroy() {
          let m = this, A = m.chart.scroller;
          m.removeEvents(), ["track", "scrollbarRifles", "scrollbar", "scrollbarGroup", "group"].forEach(function(C) {
            m[C] && m[C].destroy && (m[C] = m[C].destroy());
          }), A && m === A.scrollbar && (A.scrollbar = null, f(A.scrollbarButtons));
        }
        drawScrollbarButton(m) {
          let A = this.renderer, C = this.scrollbarButtons, H = this.options, G = this.size, P = A.g().add(this.group);
          if (C.push(P), H.buttonsEnabled) {
            let y = A.rect().addClass("highcharts-scrollbar-button").add(P);
            this.chart.styledMode || y.attr({ stroke: H.buttonBorderColor, "stroke-width": H.buttonBorderWidth, fill: H.buttonBackgroundColor }), y.attr(y.crisp({ x: -0.5, y: -0.5, width: G, height: G, r: H.buttonBorderRadius }, y.strokeWidth()));
            let S = A.path(v.swapXY([["M", G / 2 + (m ? -1 : 1), G / 2 - 3], ["L", G / 2 + (m ? -1 : 1), G / 2 + 3], ["L", G / 2 + (m ? 2 : -2), G / 2]], H.vertical)).addClass("highcharts-scrollbar-arrow").add(C[m]);
            this.chart.styledMode || S.attr({ fill: H.buttonArrowColor });
          }
        }
        init(m, A, C) {
          this.scrollbarButtons = [], this.renderer = m, this.userOptions = A, this.options = x(T, j.scrollbar, A), this.options.margin = M(this.options.margin, 10), this.chart = C, this.size = M(this.options.size, this.options.height), A.enabled && (this.render(), this.addEvents());
        }
        mouseDownHandler(m) {
          var H;
          let A = ((H = this.chart.pointer) == null ? void 0 : H.normalize(m)) || m, C = this.cursorToScrollbarPosition(A);
          this.chartX = C.chartX, this.chartY = C.chartY, this.initPositions = [this.from, this.to], this.grabbedCenter = !0;
        }
        mouseMoveHandler(m) {
          var P;
          let A, C = ((P = this.chart.pointer) == null ? void 0 : P.normalize(m)) || m, H = this.options.vertical ? "chartY" : "chartX", G = this.initPositions || [];
          this.grabbedCenter && (!m.touches || m.touches[0][H] !== 0) && (A = this.cursorToScrollbarPosition(C)[H] - this[H], this.hasDragged = !0, this.updatePosition(G[0] + A, G[1] + A), this.hasDragged && w(this, "changed", { from: this.from, to: this.to, trigger: "scrollbar", DOMType: m.type, DOMEvent: m }));
        }
        mouseUpHandler(m) {
          this.hasDragged && w(this, "changed", { from: this.from, to: this.to, trigger: "scrollbar", DOMType: m.type, DOMEvent: m }), this.grabbedCenter = this.hasDragged = this.chartX = this.chartY = null;
        }
        position(m, A, C, H) {
          let { buttonsEnabled: G, margin: P = 0, vertical: y } = this.options, S = this.rendered ? "animate" : "attr", d = H, s = 0;
          this.group.show(), this.x = m, this.y = A + this.trackBorderWidth, this.width = C, this.height = H, this.xOffset = d, this.yOffset = s, y ? (this.width = this.yOffset = C = s = this.size, this.xOffset = d = 0, this.yOffset = s = G ? this.size : 0, this.barWidth = H - (G ? 2 * C : 0), this.x = m += P) : (this.height = H = this.size, this.xOffset = d = G ? this.size : 0, this.barWidth = C - (G ? 2 * H : 0), this.y = this.y + P), this.group[S]({ translateX: m, translateY: this.y }), this.track[S]({ width: C, height: H }), this.scrollbarButtons[1][S]({ translateX: y ? 0 : C - d, translateY: y ? H - s : 0 });
        }
        removeEvents() {
          this._events.forEach(function(m) {
            p.apply(null, m);
          }), this._events.length = 0;
        }
        render() {
          let m = this.renderer, A = this.options, C = this.size, H = this.chart.styledMode, G = m.g("scrollbar").attr({ zIndex: A.zIndex }).hide().add();
          this.group = G, this.track = m.rect().addClass("highcharts-scrollbar-track").attr({ r: A.trackBorderRadius || 0, height: C, width: C }).add(G), H || this.track.attr({ fill: A.trackBackgroundColor, stroke: A.trackBorderColor, "stroke-width": A.trackBorderWidth });
          let P = this.trackBorderWidth = this.track.strokeWidth();
          this.track.attr({ x: -B(0, P), y: -B(0, P) }), this.scrollbarGroup = m.g().add(G), this.scrollbar = m.rect().addClass("highcharts-scrollbar-thumb").attr({ height: C - P, width: C - P, r: A.barBorderRadius || 0 }).add(this.scrollbarGroup), this.scrollbarRifles = m.path(v.swapXY([["M", -3, C / 4], ["L", -3, 2 * C / 3], ["M", 0, C / 4], ["L", 0, 2 * C / 3], ["M", 3, C / 4], ["L", 3, 2 * C / 3]], A.vertical)).addClass("highcharts-scrollbar-rifles").add(this.scrollbarGroup), H || (this.scrollbar.attr({ fill: A.barBackgroundColor, stroke: A.barBorderColor, "stroke-width": A.barBorderWidth }), this.scrollbarRifles.attr({ stroke: A.rifleColor, "stroke-width": 1 })), this.scrollbarStrokeWidth = this.scrollbar.strokeWidth(), this.scrollbarGroup.translate(-B(0, this.scrollbarStrokeWidth), -B(0, this.scrollbarStrokeWidth)), this.drawScrollbarButton(0), this.drawScrollbarButton(1);
        }
        setRange(m, A) {
          let C, H, G = this.options, P = G.vertical, y = G.minWidth, S = this.barWidth, d = !this.rendered || this.hasDragged || this.chart.navigator && this.chart.navigator.hasDragged ? "attr" : "animate";
          if (!N(S)) return;
          let s = S * Math.min(A, 1);
          C = Math.ceil(S * (m = Math.max(m, 0))), this.calculatedWidth = H = F(s - C), H < y && (C = (S - y + H) * m, H = y);
          let l = Math.floor(C + this.xOffset + this.yOffset), b = H / 2 - 0.5;
          this.from = m, this.to = A, P ? (this.scrollbarGroup[d]({ translateY: l }), this.scrollbar[d]({ height: H }), this.scrollbarRifles[d]({ translateY: b }), this.scrollbarTop = l, this.scrollbarLeft = 0) : (this.scrollbarGroup[d]({ translateX: l }), this.scrollbar[d]({ width: H }), this.scrollbarRifles[d]({ translateX: b }), this.scrollbarLeft = l, this.scrollbarTop = 0), H <= 12 ? this.scrollbarRifles.hide() : this.scrollbarRifles.show(), G.showFull === !1 && (m <= 0 && A >= 1 ? this.group.hide() : this.group.show()), this.rendered = !0;
        }
        shouldUpdateExtremes(m) {
          return M(this.options.liveRedraw, n.svg && !n.isTouchDevice && !this.chart.boosted) || m === "mouseup" || m === "touchend" || !N(m);
        }
        trackClick(m) {
          var P;
          let A = ((P = this.chart.pointer) == null ? void 0 : P.normalize(m)) || m, C = this.to - this.from, H = this.y + this.scrollbarTop, G = this.x + this.scrollbarLeft;
          this.options.vertical && A.chartY > H || !this.options.vertical && A.chartX > G ? this.updatePosition(this.from + C, this.to + C) : this.updatePosition(this.from - C, this.to - C), w(this, "changed", { from: this.from, to: this.to, trigger: "scrollbar", DOMEvent: m });
        }
        update(m) {
          this.destroy(), this.init(this.chart.renderer, x(!0, this.options, m), this.chart);
        }
        updatePosition(m, A) {
          A > 1 && (m = F(1 - F(A - m)), A = 1), m < 0 && (A = F(A - m), m = 0), this.from = m, this.to = A;
        }
      }
      return v.defaultOptions = T, j.scrollbar = x(!0, v.defaultOptions, j.scrollbar), v;
    }), a(e, "Stock/Navigator/Navigator.js", [e["Core/Axis/Axis.js"], e["Stock/Navigator/ChartNavigatorComposition.js"], e["Core/Defaults.js"], e["Core/Globals.js"], e["Core/Axis/NavigatorAxisComposition.js"], e["Stock/Navigator/NavigatorComposition.js"], e["Stock/Scrollbar/Scrollbar.js"], e["Core/Renderer/SVG/SVGRenderer.js"], e["Core/Utilities.js"]], function(o, n, r, T, O, j, D, F, B) {
      let { defaultOptions: N } = r, { isTouchDevice: f } = T, { prototype: { symbols: w } } = F, { addEvent: x, clamp: M, correctFloat: p, defined: v, destroyObjectProperties: k, erase: m, extend: A, find: C, fireEvent: H, isArray: G, isNumber: P, merge: y, pick: S, removeEvent: d, splat: s } = B;
      function l(u, ...c) {
        let h = [].filter.call(c, P);
        if (h.length) return Math[u].apply(0, h);
      }
      class b {
        static compose(c, h, g) {
          n.compose(c, b), j.compose(c, h, g);
        }
        constructor(c) {
          this.isDirty = !1, this.scrollbarHeight = 0, this.init(c);
        }
        drawHandle(c, h, g, E) {
          let R = this.navigatorOptions.handles.height;
          this.handles[h][E](g ? { translateX: Math.round(this.left + this.height / 2), translateY: Math.round(this.top + parseInt(c, 10) + 0.5 - R) } : { translateX: Math.round(this.left + parseInt(c, 10)), translateY: Math.round(this.top + this.height / 2 - R / 2 - 1) });
        }
        drawOutline(c, h, g, E) {
          let R = this.navigatorOptions.maskInside, L = this.outline.strokeWidth(), U = L / 2, V = L % 2 / 2, q = this.scrollButtonSize, Y = this.size, I = this.top, _ = this.height, W = I - U, X = I + _, z = this.left, $, K;
          g ? ($ = I + h + V, h = I + c + V, K = [["M", z + _, I - q - V], ["L", z + _, $], ["L", z, $], ["M", z, h], ["L", z + _, h], ["L", z + _, I + Y + q]], R && K.push(["M", z + _, $ - U], ["L", z + _, h + U])) : (z -= q, c += z + q - V, h += z + q - V, K = [["M", z, W], ["L", c, W], ["L", c, X], ["M", h, X], ["L", h, W], ["L", z + Y + 2 * q, W]], R && K.push(["M", c - U, W], ["L", h + U, W])), this.outline[E]({ d: K });
        }
        drawMasks(c, h, g, E) {
          let R, L, U, V, q = this.left, Y = this.top, I = this.height;
          g ? (U = [q, q, q], V = [Y, Y + c, Y + h], L = [I, I, I], R = [c, h - c, this.size - h]) : (U = [q, q + c, q + h], V = [Y, Y, Y], L = [c, h - c, this.size - h], R = [I, I, I]), this.shades.forEach((_, W) => {
            _[E]({ x: U[W], y: V[W], width: L[W], height: R[W] });
          });
        }
        renderElements() {
          var q, Y;
          let c = this, h = c.navigatorOptions, g = h.maskInside, E = c.chart, R = E.inverted, L = E.renderer, U = { cursor: R ? "ns-resize" : "ew-resize" }, V = (q = c.navigatorGroup) != null ? q : c.navigatorGroup = L.g("navigator").attr({ zIndex: 8, visibility: "hidden" }).add();
          if ([!g, g, !g].forEach((I, _) => {
            var X;
            let W = (X = c.shades[_]) != null ? X : c.shades[_] = L.rect().addClass("highcharts-navigator-mask" + (_ === 1 ? "-inside" : "-outside")).add(V);
            E.styledMode || (W.attr({ fill: I ? h.maskFill : "rgba(0,0,0,0)" }), _ === 1 && W.css(U));
          }), c.outline || (c.outline = L.path().addClass("highcharts-navigator-outline").add(V)), E.styledMode || c.outline.attr({ "stroke-width": h.outlineWidth, stroke: h.outlineColor }), (Y = h.handles) == null ? void 0 : Y.enabled) {
            let I = h.handles, { height: _, width: W } = I;
            [0, 1].forEach((X) => {
              var $;
              let z = I.symbols[X];
              if (c.handles[X] && c.handles[X].symbolUrl === z) {
                if (!c.handles[X].isImg && c.handles[X].symbolName !== z) {
                  let K = w[z].call(w, -W / 2 - 1, 0, W, _);
                  c.handles[X].attr({ d: K }), c.handles[X].symbolName = z;
                }
              } else ($ = c.handles[X]) == null || $.destroy(), c.handles[X] = L.symbol(z, -W / 2 - 1, 0, W, _, I), c.handles[X].attr({ zIndex: 7 - X }).addClass("highcharts-navigator-handle highcharts-navigator-handle-" + ["left", "right"][X]).add(V), c.addMouseEvents();
              E.inverted && c.handles[X].attr({ rotation: 90, rotationOriginX: Math.floor(-W / 2), rotationOriginY: (_ + W) / 2 }), E.styledMode || c.handles[X].attr({ fill: I.backgroundColor, stroke: I.borderColor, "stroke-width": I.lineWidth, width: I.width, height: I.height, x: -W / 2 - 1, y: 0 }).css(U);
            });
          }
        }
        update(c, h = !1) {
          var R, L;
          let g = this.chart, E = g.options.chart.inverted !== ((R = g.scrollbar) == null ? void 0 : R.options.vertical);
          if (y(!0, g.options.navigator, c), this.navigatorOptions = g.options.navigator || {}, this.setOpposite(), v(c.enabled) || E) return this.destroy(), this.navigatorEnabled = c.enabled || this.navigatorEnabled, this.init(g);
          if (this.navigatorEnabled && (this.isDirty = !0, c.adaptToUpdatedData === !1 && this.baseSeries.forEach((U) => {
            d(U, "updatedData", this.updatedDataHandler);
          }, this), c.adaptToUpdatedData && this.baseSeries.forEach((U) => {
            U.eventsToUnbind.push(x(U, "updatedData", this.updatedDataHandler));
          }, this), (c.series || c.baseSeries) && this.setBaseSeries(void 0, !1), c.height || c.xAxis || c.yAxis)) {
            this.height = (L = c.height) != null ? L : this.height;
            let U = this.getXAxisOffsets();
            this.xAxis.update({ ...c.xAxis, offsets: U, [g.inverted ? "width" : "height"]: this.height, [g.inverted ? "height" : "width"]: void 0 }, !1), this.yAxis.update({ ...c.yAxis, [g.inverted ? "width" : "height"]: this.height }, !1);
          }
          h && g.redraw();
        }
        render(c, h, g, E) {
          let R = this.chart, L = this.xAxis, U = L.pointRange || 0, V = L.navigatorAxis.fake ? R.xAxis[0] : L, q = this.navigatorEnabled, Y = this.rendered, I = R.inverted, _ = R.xAxis[0].minRange, W = R.xAxis[0].options.maxRange, X = this.scrollButtonSize, z, $, K, Q = this.scrollbarHeight, Z, ee;
          if (this.hasDragged && !v(g)) return;
          if (this.isDirty && this.renderElements(), c = p(c - U / 2), h = p(h + U / 2), !P(c) || !P(h)) {
            if (!Y) return;
            g = 0, E = S(L.width, V.width);
          }
          this.left = S(L.left, R.plotLeft + X + (I ? R.plotWidth : 0));
          let J = this.size = Z = S(L.len, (I ? R.plotHeight : R.plotWidth) - 2 * X);
          z = I ? Q : Z + 2 * X, g = S(g, L.toPixels(c, !0)), E = S(E, L.toPixels(h, !0)), P(g) && Math.abs(g) !== 1 / 0 || (g = 0, E = z);
          let ae = L.toValue(g, !0), re = L.toValue(E, !0), ce = Math.abs(p(re - ae));
          ce < _ ? this.grabbedLeft ? g = L.toPixels(re - _ - U, !0) : this.grabbedRight && (E = L.toPixels(ae + _ + U, !0)) : v(W) && p(ce - U) > W && (this.grabbedLeft ? g = L.toPixels(re - W - U, !0) : this.grabbedRight && (E = L.toPixels(ae + W + U, !0))), this.zoomedMax = M(Math.max(g, E), 0, J), this.zoomedMin = M(this.fixedWidth ? this.zoomedMax - this.fixedWidth : Math.min(g, E), 0, J), this.range = this.zoomedMax - this.zoomedMin, J = Math.round(this.zoomedMax);
          let he = Math.round(this.zoomedMin);
          q && (this.navigatorGroup.attr({ visibility: "inherit" }), ee = Y && !this.hasDragged ? "animate" : "attr", this.drawMasks(he, J, I, ee), this.drawOutline(he, J, I, ee), this.navigatorOptions.handles.enabled && (this.drawHandle(he, 0, I, ee), this.drawHandle(J, 1, I, ee))), this.scrollbar && (I ? (K = this.top - X, $ = this.left - Q + (q || !V.opposite ? 0 : (V.titleOffset || 0) + V.axisTitleMargin), Q = Z + 2 * X) : (K = this.top + (q ? this.height : -Q), $ = this.left - X), this.scrollbar.position($, K, z, Q), this.scrollbar.setRange(this.zoomedMin / (Z || 1), this.zoomedMax / (Z || 1))), this.rendered = !0, this.isDirty = !1, H(this, "afterRender");
        }
        addMouseEvents() {
          let c = this, h = c.chart, g = h.container, E = [], R, L;
          c.mouseMoveHandler = R = function(U) {
            c.onMouseMove(U);
          }, c.mouseUpHandler = L = function(U) {
            c.onMouseUp(U);
          }, (E = c.getPartsEvents("mousedown")).push(x(h.renderTo, "mousemove", R), x(g.ownerDocument, "mouseup", L), x(h.renderTo, "touchmove", R), x(g.ownerDocument, "touchend", L)), E.concat(c.getPartsEvents("touchstart")), c.eventsToUnbind = E, c.series && c.series[0] && E.push(x(c.series[0].xAxis, "foundExtremes", function() {
            h.navigator.modifyNavigatorAxisExtremes();
          }));
        }
        getPartsEvents(c) {
          let h = this, g = [];
          return ["shades", "handles"].forEach(function(E) {
            h[E].forEach(function(R, L) {
              g.push(x(R.element, c, function(U) {
                h[E + "Mousedown"](U, L);
              }));
            });
          }), g;
        }
        shadesMousedown(c, h) {
          var X;
          c = ((X = this.chart.pointer) == null ? void 0 : X.normalize(c)) || c;
          let g = this.chart, E = this.xAxis, R = this.zoomedMin, L = this.size, U = this.range, V = this.left, q = c.chartX, Y, I, _, W;
          g.inverted && (q = c.chartY, V = this.top), h === 1 ? (this.grabbedCenter = q, this.fixedWidth = U, this.dragOffset = q - R) : (W = q - V - U / 2, h === 0 ? W = Math.max(0, W) : h === 2 && W + U >= L && (W = L - U, this.reversedExtremes ? (W -= U, I = this.getUnionExtremes().dataMin) : Y = this.getUnionExtremes().dataMax), W !== R && (this.fixedWidth = U, v((_ = E.navigatorAxis.toFixedRange(W, W + U, I, Y)).min) && H(this, "setRange", { min: Math.min(_.min, _.max), max: Math.max(_.min, _.max), redraw: !0, eventArguments: { trigger: "navigator" } })));
        }
        handlesMousedown(c, h) {
          var L;
          c = ((L = this.chart.pointer) == null ? void 0 : L.normalize(c)) || c;
          let g = this.chart, E = g.xAxis[0], R = this.reversedExtremes;
          h === 0 ? (this.grabbedLeft = !0, this.otherHandlePos = this.zoomedMax, this.fixedExtreme = R ? E.min : E.max) : (this.grabbedRight = !0, this.otherHandlePos = this.zoomedMin, this.fixedExtreme = R ? E.max : E.min), g.setFixedRange(void 0);
        }
        onMouseMove(c) {
          var Y;
          let h = this, g = h.chart, E = h.navigatorSize, R = h.range, L = h.dragOffset, U = g.inverted, V = h.left, q;
          (!c.touches || c.touches[0].pageX !== 0) && (q = (c = ((Y = g.pointer) == null ? void 0 : Y.normalize(c)) || c).chartX, U && (V = h.top, q = c.chartY), h.grabbedLeft ? (h.hasDragged = !0, h.render(0, 0, q - V, h.otherHandlePos)) : h.grabbedRight ? (h.hasDragged = !0, h.render(0, 0, h.otherHandlePos, q - V)) : h.grabbedCenter && (h.hasDragged = !0, q < L ? q = L : q > E + L - R && (q = E + L - R), h.render(0, 0, q - L, q - L + R)), h.hasDragged && h.scrollbar && S(h.scrollbar.options.liveRedraw, !f && !this.chart.boosted) && (c.DOMType = c.type, setTimeout(function() {
            h.onMouseUp(c);
          }, 0)));
        }
        onMouseUp(c) {
          let h, g, E, R, L, U, V = this.chart, q = this.xAxis, Y = this.scrollbar, I = c.DOMEvent || c, _ = V.inverted, W = this.rendered && !this.hasDragged ? "animate" : "attr";
          (this.hasDragged && (!Y || !Y.hasDragged) || c.trigger === "scrollbar") && (E = this.getUnionExtremes(), this.zoomedMin === this.otherHandlePos ? R = this.fixedExtreme : this.zoomedMax === this.otherHandlePos && (L = this.fixedExtreme), this.zoomedMax === this.size && (L = this.reversedExtremes ? E.dataMin : E.dataMax), this.zoomedMin === 0 && (R = this.reversedExtremes ? E.dataMax : E.dataMin), v((U = q.navigatorAxis.toFixedRange(this.zoomedMin, this.zoomedMax, R, L)).min) && H(this, "setRange", { min: Math.min(U.min, U.max), max: Math.max(U.min, U.max), redraw: !0, animation: !this.hasDragged && null, eventArguments: { trigger: "navigator", triggerOp: "navigator-drag", DOMEvent: I } })), c.DOMType !== "mousemove" && c.DOMType !== "touchmove" && (this.grabbedLeft = this.grabbedRight = this.grabbedCenter = this.fixedWidth = this.fixedExtreme = this.otherHandlePos = this.hasDragged = this.dragOffset = null), this.navigatorEnabled && P(this.zoomedMin) && P(this.zoomedMax) && (g = Math.round(this.zoomedMin), h = Math.round(this.zoomedMax), this.shades && this.drawMasks(g, h, _, W), this.outline && this.drawOutline(g, h, _, W), this.navigatorOptions.handles.enabled && Object.keys(this.handles).length === this.handles.length && (this.drawHandle(g, 0, _, W), this.drawHandle(h, 1, _, W)));
        }
        removeEvents() {
          this.eventsToUnbind && (this.eventsToUnbind.forEach(function(c) {
            c();
          }), this.eventsToUnbind = void 0), this.removeBaseSeriesEvents();
        }
        removeBaseSeriesEvents() {
          let c = this.baseSeries || [];
          this.navigatorEnabled && c[0] && (this.navigatorOptions.adaptToUpdatedData !== !1 && c.forEach(function(h) {
            d(h, "updatedData", this.updatedDataHandler);
          }, this), c[0].xAxis && d(c[0].xAxis, "foundExtremes", this.modifyBaseAxisExtremes));
        }
        getXAxisOffsets() {
          return this.chart.inverted ? [this.scrollButtonSize, 0, -this.scrollButtonSize, 0] : [0, -this.scrollButtonSize, 0, this.scrollButtonSize];
        }
        init(c) {
          var z;
          let h = c.options, g = h.navigator || {}, E = g.enabled, R = h.scrollbar || {}, L = R.enabled, U = E && g.height || 0, V = L && R.height || 0, q = R.buttonsEnabled && V || 0;
          this.handles = [], this.shades = [], this.chart = c, this.setBaseSeries(), this.height = U, this.scrollbarHeight = V, this.scrollButtonSize = q, this.scrollbarEnabled = L, this.navigatorEnabled = E, this.navigatorOptions = g, this.scrollbarOptions = R, this.setOpposite();
          let Y = this, I = Y.baseSeries, _ = c.xAxis.length, W = c.yAxis.length, X = I && I[0] && I[0].xAxis || c.xAxis[0] || { options: {} };
          if (c.isDirtyBox = !0, Y.navigatorEnabled) {
            let $ = this.getXAxisOffsets();
            Y.xAxis = new o(c, y({ breaks: X.options.breaks, ordinal: X.options.ordinal, overscroll: X.options.overscroll }, g.xAxis, { type: "datetime", yAxis: (z = g.yAxis) == null ? void 0 : z.id, index: _, isInternal: !0, offset: 0, keepOrdinalPadding: !0, startOnTick: !1, endOnTick: !1, minPadding: X.options.ordinal ? 0 : X.options.minPadding, maxPadding: X.options.ordinal ? 0 : X.options.maxPadding, zoomEnabled: !1 }, c.inverted ? { offsets: $, width: U } : { offsets: $, height: U }), "xAxis"), Y.yAxis = new o(c, y(g.yAxis, { alignTicks: !1, offset: 0, index: W, isInternal: !0, reversed: S(g.yAxis && g.yAxis.reversed, c.yAxis[0] && c.yAxis[0].reversed, !1), zoomEnabled: !1 }, c.inverted ? { width: U } : { height: U }), "yAxis"), I || g.series.data ? Y.updateNavigatorSeries(!1) : c.series.length === 0 && (Y.unbindRedraw = x(c, "beforeRedraw", function() {
              c.series.length > 0 && !Y.series && (Y.setBaseSeries(), Y.unbindRedraw());
            })), Y.reversedExtremes = c.inverted && !Y.xAxis.reversed || !c.inverted && Y.xAxis.reversed, Y.renderElements(), Y.addMouseEvents();
          } else Y.xAxis = { chart: c, navigatorAxis: { fake: !0 }, translate: function($, K) {
            let Q = c.xAxis[0], Z = Q.getExtremes(), ee = Q.len - 2 * q, J = l("min", Q.options.min, Z.dataMin), ae = l("max", Q.options.max, Z.dataMax) - J;
            return K ? $ * ae / ee + J : ee * ($ - J) / ae;
          }, toPixels: function($) {
            return this.translate($);
          }, toValue: function($) {
            return this.translate($, !0);
          } }, Y.xAxis.navigatorAxis.axis = Y.xAxis, Y.xAxis.navigatorAxis.toFixedRange = O.prototype.toFixedRange.bind(Y.xAxis.navigatorAxis);
          if (c.options.scrollbar.enabled) {
            let $ = y(c.options.scrollbar, { vertical: c.inverted });
            !P($.margin) && Y.navigatorEnabled && ($.margin = c.inverted ? -3 : 3), c.scrollbar = Y.scrollbar = new D(c.renderer, $, c), x(Y.scrollbar, "changed", function(K) {
              let Q = Y.size, Z = Q * this.to, ee = Q * this.from;
              Y.hasDragged = Y.scrollbar.hasDragged, Y.render(0, 0, ee, Z), this.shouldUpdateExtremes(K.DOMType) && setTimeout(function() {
                Y.onMouseUp(K);
              });
            });
          }
          Y.addBaseSeriesEvents(), Y.addChartEvents();
        }
        setOpposite() {
          let c = this.navigatorOptions, h = this.navigatorEnabled, g = this.chart;
          this.opposite = S(c.opposite, !!(!h && g.inverted));
        }
        getUnionExtremes(c) {
          let h, g = this.chart.xAxis[0], E = this.xAxis, R = E.options, L = g.options;
          return c && g.dataMin === null || (h = { dataMin: S(R && R.min, l("min", L.min, g.dataMin, E.dataMin, E.min)), dataMax: S(R && R.max, l("max", L.max, g.dataMax, E.dataMax, E.max)) }), h;
        }
        setBaseSeries(c, h) {
          let g = this.chart, E = this.baseSeries = [];
          c = c || g.options && g.options.navigator.baseSeries || (g.series.length ? C(g.series, (R) => !R.options.isInternal).index : 0), (g.series || []).forEach((R, L) => {
            !R.options.isInternal && (R.options.showInNavigator || (L === c || R.options.id === c) && R.options.showInNavigator !== !1) && E.push(R);
          }), this.xAxis && !this.xAxis.navigatorAxis.fake && this.updateNavigatorSeries(!0, h);
        }
        updateNavigatorSeries(c, h) {
          var _, W;
          let g = this, E = g.chart, R = g.baseSeries, L = { enableMouseTracking: !1, index: null, linkedTo: null, group: "nav", padXAxis: !1, xAxis: (_ = this.navigatorOptions.xAxis) == null ? void 0 : _.id, yAxis: (W = this.navigatorOptions.yAxis) == null ? void 0 : W.id, showInLegend: !1, stacking: void 0, isInternal: !0, states: { inactive: { opacity: 1 } } }, U = g.series = (g.series || []).filter((X) => {
            let z = X.baseSeries;
            return !(0 > R.indexOf(z)) || (z && (d(z, "updatedData", g.updatedDataHandler), delete z.navigatorSeries), X.chart && X.destroy(), !1);
          }), V, q, Y = g.navigatorOptions.series, I;
          R && R.length && R.forEach((X) => {
            let z = X.navigatorSeries, $ = A({ color: X.color, visible: X.visible }, G(Y) ? N.navigator.series : Y);
            if (z && g.navigatorOptions.adaptToUpdatedData === !1) return;
            L.name = "Navigator " + R.length, I = (V = X.options || {}).navigatorOptions || {}, $.dataLabels = s($.dataLabels), (q = y(V, L, $, I)).pointRange = S($.pointRange, I.pointRange, N.plotOptions[q.type || "line"].pointRange);
            let K = I.data || $.data;
            g.hasNavigatorData = g.hasNavigatorData || !!K, q.data = K || V.data && V.data.slice(0), z && z.options ? z.update(q, h) : (X.navigatorSeries = E.initSeries(q), E.setSortedData(), X.navigatorSeries.baseSeries = X, U.push(X.navigatorSeries));
          }), (Y.data && !(R && R.length) || G(Y)) && (g.hasNavigatorData = !1, (Y = s(Y)).forEach((X, z) => {
            L.name = "Navigator " + (U.length + 1), (q = y(N.navigator.series, { color: E.series[z] && !E.series[z].options.isInternal && E.series[z].color || E.options.colors[z] || E.options.colors[0] }, L, X)).data = X.data, q.data && (g.hasNavigatorData = !0, U.push(E.initSeries(q)));
          })), c && this.addBaseSeriesEvents();
        }
        addBaseSeriesEvents() {
          let c = this, h = c.baseSeries || [];
          h[0] && h[0].xAxis && h[0].eventsToUnbind.push(x(h[0].xAxis, "foundExtremes", this.modifyBaseAxisExtremes)), h.forEach((g) => {
            g.eventsToUnbind.push(x(g, "show", function() {
              this.navigatorSeries && this.navigatorSeries.setVisible(!0, !1);
            })), g.eventsToUnbind.push(x(g, "hide", function() {
              this.navigatorSeries && this.navigatorSeries.setVisible(!1, !1);
            })), this.navigatorOptions.adaptToUpdatedData !== !1 && g.xAxis && g.eventsToUnbind.push(x(g, "updatedData", this.updatedDataHandler)), g.eventsToUnbind.push(x(g, "remove", function() {
              h && m(h, g), this.navigatorSeries && (m(c.series, this.navigatorSeries), v(this.navigatorSeries.options) && this.navigatorSeries.remove(!1), delete this.navigatorSeries);
            }));
          });
        }
        getBaseSeriesMin(c) {
          return this.baseSeries.reduce(function(h, g) {
            return Math.min(h, g.xData && g.xData.length ? g.xData[0] : h);
          }, c);
        }
        modifyNavigatorAxisExtremes() {
          let c = this.xAxis;
          if (c.getExtremes !== void 0) {
            let h = this.getUnionExtremes(!0);
            h && (h.dataMin !== c.min || h.dataMax !== c.max) && (c.min = h.dataMin, c.max = h.dataMax);
          }
        }
        modifyBaseAxisExtremes() {
          var z;
          let c, h, g = this.chart.navigator, E = this.getExtremes(), R = E.min, L = E.max, U = E.dataMin, V = E.dataMax, q = L - R, Y = g.stickToMin, I = g.stickToMax, _ = S((z = this.ordinal) == null ? void 0 : z.convertOverscroll(this.options.overscroll), 0), W = g.series && g.series[0], X = !!this.setExtremes;
          !(this.eventArgs && this.eventArgs.trigger === "rangeSelectorButton") && (Y && (c = (h = U) + q), I && (c = V + _, Y || (h = Math.max(U, c - q, g.getBaseSeriesMin(W && W.xData ? W.xData[0] : -Number.MAX_VALUE)))), X && (Y || I) && P(h) && (this.min = this.userMin = h, this.max = this.userMax = c)), g.stickToMin = g.stickToMax = null;
        }
        updatedDataHandler() {
          let c = this.chart.navigator, h = this.navigatorSeries, g = c.reversedExtremes ? Math.round(c.zoomedMin) === 0 : Math.round(c.zoomedMax) >= Math.round(c.size);
          c.stickToMax = S(this.chart.options.navigator && this.chart.options.navigator.stickToMax, g), c.stickToMin = c.shouldStickToMin(this, c), h && !c.hasNavigatorData && (h.options.pointStart = this.xData[0], h.setData(this.options.data, !1, null, !1));
        }
        shouldStickToMin(c, h) {
          let g = h.getBaseSeriesMin(c.xData[0]), E = c.xAxis, R = E.max, L = E.min, U = E.options.range;
          return !!(P(R) && P(L)) && (U && R - g > 0 ? R - g < U : L <= g);
        }
        addChartEvents() {
          this.eventsToUnbind || (this.eventsToUnbind = []), this.eventsToUnbind.push(x(this.chart, "redraw", function() {
            let c = this.navigator, h = c && (c.baseSeries && c.baseSeries[0] && c.baseSeries[0].xAxis || this.xAxis[0]);
            h && c.render(h.min, h.max);
          }), x(this.chart, "getMargins", function() {
            let c = this.navigator, h = c.opposite ? "plotTop" : "marginBottom";
            this.inverted && (h = c.opposite ? "marginRight" : "plotLeft"), this[h] = (this[h] || 0) + (c.navigatorEnabled || !this.inverted ? c.height + c.scrollbarHeight : 0) + c.navigatorOptions.margin;
          }), x(b, "setRange", function(c) {
            this.chart.xAxis[0].setExtremes(c.min, c.max, c.redraw, c.animation, c.eventArguments);
          }));
        }
        destroy() {
          this.removeEvents(), this.xAxis && (m(this.chart.xAxis, this.xAxis), m(this.chart.axes, this.xAxis)), this.yAxis && (m(this.chart.yAxis, this.yAxis), m(this.chart.axes, this.yAxis)), (this.series || []).forEach((c) => {
            c.destroy && c.destroy();
          }), ["series", "xAxis", "yAxis", "shades", "outline", "scrollbarTrack", "scrollbarRifles", "scrollbarGroup", "scrollbar", "navigatorGroup", "rendered"].forEach((c) => {
            this[c] && this[c].destroy && this[c].destroy(), this[c] = null;
          }), [this.handles].forEach((c) => {
            k(c);
          }), this.navigatorEnabled = !1;
        }
      }
      return b;
    }), a(e, "Accessibility/Components/NavigatorComponent.js", [e["Accessibility/AccessibilityComponent.js"], e["Accessibility/Utils/Announcer.js"], e["Accessibility/KeyboardNavigationHandler.js"], e["Stock/Navigator/Navigator.js"], e["Core/Animation/AnimationUtilities.js"], e["Core/Templating.js"], e["Core/Utilities.js"], e["Accessibility/Utils/HTMLUtilities.js"], e["Accessibility/Utils/ChartUtilities.js"]], function(o, n, r, T, O, j, D, F, B) {
      let { animObject: N } = O, { format: f } = j, { clamp: w, pick: x, syncTimeout: M } = D, { getFakeMouseEvent: p } = F, { getAxisRangeDescription: v, fireEventOnWrappedOrUnwrappedElement: k } = B;
      return class extends o {
        init() {
          let m = this.chart, A = this;
          this.announcer = new n(m, "polite"), this.addEvent(T, "afterRender", function() {
            this.chart === A.chart && this.chart.renderer && M(() => {
              A.proxyProvider.updateGroupProxyElementPositions("navigator"), A.updateHandleValues();
            }, N(x(this.chart.renderer.globalAnimation, !0)).duration);
          });
        }
        onChartUpdate() {
          var H, G, P;
          let m = this.chart, A = m.options, C = A.navigator;
          if (C.enabled && ((H = C.accessibility) != null && H.enabled)) {
            let y = A.accessibility.landmarkVerbosity, S = (G = A.lang.accessibility) == null ? void 0 : G.navigator.groupLabel;
            this.proxyProvider.removeGroup("navigator"), this.proxyProvider.addGroup("navigator", "div", { role: y === "all" ? "region" : "group", "aria-label": f(S, { chart: m }, m) });
            let d = (P = A.lang.accessibility) == null ? void 0 : P.navigator.handleLabel;
            [0, 1].forEach((s) => {
              let l = this.getHandleByIx(s);
              if (l) {
                let b = this.proxyProvider.addProxyElement("navigator", { click: l }, "input", { type: "range", "aria-label": f(d, { handleIx: s, chart: m }, m) });
                this[s ? "maxHandleProxy" : "minHandleProxy"] = b.innerElement, b.innerElement.style.pointerEvents = "none", b.innerElement.oninput = () => this.updateNavigator();
              }
            }), this.updateHandleValues();
          } else this.proxyProvider.removeGroup("navigator");
        }
        getNavigatorHandleNavigation(m) {
          let A = this, C = this.chart, H = m ? this.maxHandleProxy : this.minHandleProxy, G = this.keyCodes;
          return new r(C, { keyCodeMap: [[[G.left, G.right, G.up, G.down], function(P) {
            if (H) {
              let y = P === G.left || P === G.up ? -1 : 1;
              H.value = "" + w(parseFloat(H.value) + y, 0, 100), A.updateNavigator(() => {
                let S = A.getHandleByIx(m);
                S && C.setFocusToElement(S, H);
              });
            }
            return this.response.success;
          }]], init: () => {
            C.setFocusToElement(this.getHandleByIx(m), H);
          }, validate: () => {
            var P;
            return !!(this.getHandleByIx(m) && H && ((P = C.options.navigator.accessibility) != null && P.enabled));
          } });
        }
        getKeyboardNavigation() {
          return [this.getNavigatorHandleNavigation(0), this.getNavigatorHandleNavigation(1)];
        }
        destroy() {
          this.updateNavigatorThrottleTimer && clearTimeout(this.updateNavigatorThrottleTimer), this.proxyProvider.removeGroup("navigator"), this.announcer && this.announcer.destroy();
        }
        updateHandleValues() {
          let m = this.chart.navigator;
          if (m && this.minHandleProxy && this.maxHandleProxy) {
            let A = m.size;
            this.minHandleProxy.value = "" + Math.round(m.zoomedMin / A * 100), this.maxHandleProxy.value = "" + Math.round(m.zoomedMax / A * 100);
          }
        }
        getHandleByIx(m) {
          let A = this.chart.navigator;
          return A && A.handles && A.handles[m];
        }
        updateNavigator(m) {
          this.updateNavigatorThrottleTimer && clearTimeout(this.updateNavigatorThrottleTimer), this.updateNavigatorThrottleTimer = setTimeout(((A) => {
            var P;
            let C = this.chart, { navigator: H, pointer: G } = C;
            if (H && G && this.minHandleProxy && this.maxHandleProxy) {
              let y = G.getChartPosition(), S = parseFloat(this.minHandleProxy.value) / 100 * H.size, d = parseFloat(this.maxHandleProxy.value) / 100 * H.size;
              [[0, "mousedown", H.zoomedMin], [0, "mousemove", S], [0, "mouseup", S], [1, "mousedown", H.zoomedMax], [1, "mousemove", d], [1, "mouseup", d]].forEach(([b, u, c]) => {
                var g;
                let h = (g = this.getHandleByIx(b)) == null ? void 0 : g.element;
                h && k(h, p(u, { x: y.left + H.left + c, y: y.top + H.top }, h));
              }), A && A();
              let s = (P = C.options.lang.accessibility) == null ? void 0 : P.navigator.changeAnnouncement, l = v(C.xAxis[0]);
              this.announcer.announce(f(s, { axisRangeDescription: l, chart: C }, C));
            }
          }).bind(this, m), 20);
        }
      };
    }), a(e, "Accessibility/Components/SeriesComponent/SeriesDescriber.js", [e["Accessibility/Components/AnnotationsA11y.js"], e["Accessibility/Utils/ChartUtilities.js"], e["Core/Templating.js"], e["Accessibility/Utils/HTMLUtilities.js"], e["Core/Utilities.js"]], function(o, n, r, T, O) {
      let { getPointAnnotationTexts: j } = o, { getAxisDescription: D, getSeriesFirstPointElement: F, getSeriesA11yElement: B, unhideChartElementFromAT: N } = n, { format: f, numberFormat: w } = r, { reverseChildNodes: x, stripHTMLTagsFromString: M } = T, { find: p, isNumber: v, isString: k, pick: m, defined: A } = O;
      function C(S) {
        let d = S.chart.options.accessibility.series.pointDescriptionEnabledThreshold;
        return !!(d !== !1 && S.points && S.points.length >= +d);
      }
      function H(S, d) {
        let s = S.series, l = s.chart, b = l.options.accessibility.point || {}, u = s.options.accessibility && s.options.accessibility.point || {}, c = s.tooltipOptions || {}, h = l.options.lang;
        return v(d) ? w(d, u.valueDecimals || b.valueDecimals || c.valueDecimals || -1, h.decimalPoint, h.accessibility.thousandsSep || h.thousandsSep) : d;
      }
      function G(S, d) {
        let s = S[d];
        return S.chart.langFormat("accessibility.series." + d + "Description", { name: D(s), series: S });
      }
      function P(S) {
        let d = S.series, s = d.chart.series.length > 1 || d.options.name, l = function(h) {
          let g = h.series, E = g.chart, R = g.options.accessibility, L = R && R.point && R.point.valueDescriptionFormat || E.options.accessibility.point.valueDescriptionFormat, U = m(g.xAxis && g.xAxis.options.accessibility && g.xAxis.options.accessibility.enabled, !E.angular && g.type !== "flowmap"), V = U ? function(q) {
            let Y = function(X) {
              let z = X.series, $ = z.chart, K = z.options.accessibility && z.options.accessibility.point || {}, Q = $.options.accessibility.point || {}, Z = z.xAxis && z.xAxis.dateTime;
              if (Z) {
                let ee = Z.getXDateFormat(X.x || 0, $.options.tooltip.dateTimeLabelFormats), J = K.dateFormatter && K.dateFormatter(X) || Q.dateFormatter && Q.dateFormatter(X) || K.dateFormat || Q.dateFormat || ee;
                return $.time.dateFormat(J, X.x || 0, void 0);
              }
            }(q), I = (q.series.xAxis || {}).categories && A(q.category) && ("" + q.category).replace("<br/>", " "), _ = A(q.id) && 0 > ("" + q.id).indexOf("highcharts-"), W = "x, " + q.x;
            return q.name || Y || I || (_ ? q.id : W);
          }(h) : "";
          return f(L, { point: h, index: A(h.index) ? h.index + 1 : "", xDescription: V, value: function(q) {
            let Y = q.series, I = Y.chart.options.accessibility.point || {}, _ = Y.chart.options.accessibility && Y.chart.options.accessibility.point || {}, W = Y.tooltipOptions || {}, X = _.valuePrefix || I.valuePrefix || W.valuePrefix || "", z = _.valueSuffix || I.valueSuffix || W.valueSuffix || "", $ = q.value !== void 0 ? "value" : "y", K = H(q, q[$]);
            return q.isNull ? Y.chart.langFormat("accessibility.series.nullPointValue", { point: q }) : Y.pointArrayMap ? function(Q, Z, ee) {
              let J = Z || "", ae = ee || "", re = function(ce) {
                let he = H(Q, m(Q[ce], Q.options[ce]));
                return he !== void 0 ? ce + ": " + J + he + ae : he;
              };
              return Q.series.pointArrayMap.reduce(function(ce, he) {
                let ne = re(he);
                return ne ? ce + (ce.length ? ", " : "") + ne : ce;
              }, "");
            }(q, X, z) : X + K + z;
          }(h), separator: U ? ", " : "" }, E);
        }(S), b = S.options && S.options.accessibility && S.options.accessibility.description, u = s ? " " + d.name + "." : "", c = function(h) {
          let g = h.series.chart, E = j(h);
          return E.length ? g.langFormat("accessibility.series.pointAnnotationsDescription", { point: h, annotations: E }) : "";
        }(S);
        return S.accessibility = S.accessibility || {}, S.accessibility.valueDescription = l, l + (b ? " " + b : "") + u + (c ? " " + c : "");
      }
      function y(S) {
        let d = S.chart, s = d.types || [], l = function(U) {
          let V = (U.options.accessibility || {}).description;
          return V && U.chart.langFormat("accessibility.series.description", { description: V, series: U }) || "";
        }(S), b = function(U) {
          return d[U] && d[U].length > 1 && S[U];
        }, u = S.index + 1, c = G(S, "xAxis"), h = G(S, "yAxis"), g = { seriesNumber: u, series: S, chart: d }, E = s.length > 1 ? "Combination" : "", R = d.langFormat("accessibility.series.summary." + S.type + E, g) || d.langFormat("accessibility.series.summary.default" + E, g), L = (b("yAxis") ? " " + h + "." : "") + (b("xAxis") ? " " + c + "." : "");
        return f(m(S.options.accessibility && S.options.accessibility.descriptionFormat, d.options.accessibility.series.descriptionFormat, ""), { seriesDescription: R, authorDescription: l ? " " + l : "", axisDescription: L, series: S, chart: d, seriesNumber: u }, void 0);
      }
      return { defaultPointDescriptionFormatter: P, defaultSeriesDescriptionFormatter: y, describeSeries: function(S) {
        let d = S.chart, s = F(S), l = B(S), b = d.is3d && d.is3d();
        l && (l.lastChild !== s || b || x(l), function(u) {
          let c = function(E) {
            let R = E.options.accessibility || {};
            return !C(E) && !R.exposeAsGroupOnly;
          }(u), h = function(E) {
            let R = E.chart.options.accessibility.keyboardNavigation.seriesNavigation;
            return !!(E.points && (E.points.length < +R.pointNavigationEnabledThreshold || R.pointNavigationEnabledThreshold === !1));
          }(u), g = u.chart.options.accessibility.point.describeNull;
          (c || h) && u.points.forEach((E) => {
            let R = E.graphic && E.graphic.element || function(U) {
              let V = U.series, q = V && V.chart, Y = V && V.is("sunburst"), I = U.isNull, _ = q && q.options.accessibility.point.describeNull;
              return I && !Y && _;
            }(E) && function(U) {
              let V = U.series, q = function(X) {
                let z = X.index;
                return X.series && X.series.data && A(z) && p(X.series.data, function($) {
                  return !!($ && $.index !== void 0 && $.index > z && $.graphic && $.graphic.element);
                }) || null;
              }(U), Y = q && q.graphic, I = Y ? Y.parentGroup : V.graph || V.group, _ = q ? { x: m(U.plotX, q.plotX, 0), y: m(U.plotY, q.plotY, 0) } : { x: m(U.plotX, 0), y: m(U.plotY, 0) }, W = function(X, z) {
                let $ = X.series.chart.renderer.rect(z.x, z.y, 1, 1);
                return $.attr({ class: "highcharts-a11y-mock-point", fill: "none", opacity: 0, "fill-opacity": 0, "stroke-opacity": 0 }), $;
              }(U, _);
              if (I && I.element) return U.graphic = W, U.hasMockGraphic = !0, W.add(I), I.element.insertBefore(W.element, Y ? Y.element : null), W.element;
            }(E), L = E.options && E.options.accessibility && E.options.accessibility.enabled === !1;
            if (R) {
              if (E.isNull && !g) {
                R.setAttribute("aria-hidden", !0);
                return;
              }
              R.setAttribute("tabindex", "-1"), u.chart.styledMode || (R.style.outline = "none"), c && !L ? function(U, V) {
                var W, X, z;
                let q = U.series, Y = ((W = q.options.accessibility) == null ? void 0 : W.point) || {}, I = q.chart.options.accessibility.point || {}, _ = M(k(Y.descriptionFormat) && f(Y.descriptionFormat, U, q.chart) || ((X = Y.descriptionFormatter) == null ? void 0 : X.call(Y, U)) || k(I.descriptionFormat) && f(I.descriptionFormat, U, q.chart) || ((z = I.descriptionFormatter) == null ? void 0 : z.call(I, U)) || P(U), q.chart.renderer.forExport);
                V.setAttribute("role", "img"), V.setAttribute("aria-label", _);
              }(E, R) : R.setAttribute("aria-hidden", !0);
            }
          });
        }(S), N(d, l), function(u) {
          let c = u.chart, h = c.options.chart, g = h.options3d && h.options3d.enabled, E = c.series.length > 1, R = c.options.accessibility.series.describeSingleSeries, L = (u.options.accessibility || {}).exposeAsGroupOnly;
          return !(g && E) && (E || R || L || C(u));
        }(S) ? function(u, c) {
          let h = u.options.accessibility || {}, g = u.chart.options.accessibility, E = g.landmarkVerbosity;
          h.exposeAsGroupOnly ? c.setAttribute("role", "img") : E === "all" ? c.setAttribute("role", "region") : c.setAttribute("role", "group"), c.setAttribute("tabindex", "-1"), u.chart.styledMode || (c.style.outline = "none"), c.setAttribute("aria-label", M(g.series.descriptionFormatter && g.series.descriptionFormatter(u) || y(u), u.chart.renderer.forExport));
        }(S, l) : l.removeAttribute("aria-label"));
      } };
    }), a(e, "Accessibility/Components/SeriesComponent/NewDataAnnouncer.js", [e["Core/Globals.js"], e["Core/Utilities.js"], e["Accessibility/Utils/Announcer.js"], e["Accessibility/Utils/ChartUtilities.js"], e["Accessibility/Utils/EventProvider.js"], e["Accessibility/Components/SeriesComponent/SeriesDescriber.js"]], function(o, n, r, T, O, j) {
      let { composed: D } = o, { addEvent: F, defined: B, pushUnique: N } = n, { getChartTitle: f } = T, { defaultPointDescriptionFormatter: w, defaultSeriesDescriptionFormatter: x } = j;
      function M(v) {
        return !!v.options.accessibility.announceNewData.enabled;
      }
      class p {
        constructor(k) {
          this.dirty = { allSeries: {} }, this.lastAnnouncementTime = 0, this.chart = k;
        }
        init() {
          let k = this.chart, m = k.options.accessibility.announceNewData.interruptUser ? "assertive" : "polite";
          this.lastAnnouncementTime = 0, this.dirty = { allSeries: {} }, this.eventProvider = new O(), this.announcer = new r(k, m), this.addEventListeners();
        }
        destroy() {
          this.eventProvider.removeAddedEvents(), this.announcer.destroy();
        }
        addEventListeners() {
          let k = this, m = this.chart, A = this.eventProvider;
          A.addEvent(m, "afterApplyDrilldown", function() {
            k.lastAnnouncementTime = 0;
          }), A.addEvent(m, "afterAddSeries", function(C) {
            k.onSeriesAdded(C.series);
          }), A.addEvent(m, "redraw", function() {
            k.announceDirtyData();
          });
        }
        onSeriesAdded(k) {
          M(this.chart) && (this.dirty.hasDirty = !0, this.dirty.allSeries[k.name + k.index] = k, this.dirty.newSeries = B(this.dirty.newSeries) ? void 0 : k);
        }
        announceDirtyData() {
          let k = this.chart, m = this;
          if (k.options.accessibility.announceNewData && this.dirty.hasDirty) {
            let A = this.dirty.newPoint;
            A && (A = function(C) {
              let H = C.series.data.filter((G) => C.x === G.x && C.y === G.y);
              return H.length === 1 ? H[0] : C;
            }(A)), this.queueAnnouncement(Object.keys(this.dirty.allSeries).map((C) => m.dirty.allSeries[C]), this.dirty.newSeries, A), this.dirty = { allSeries: {} };
          }
        }
        queueAnnouncement(k, m, A) {
          let C = this.chart.options.accessibility.announceNewData;
          if (C.enabled) {
            let H = +/* @__PURE__ */ new Date(), G = H - this.lastAnnouncementTime, P = Math.max(0, C.minAnnounceInterval - G), y = function(d, s) {
              let l = (d || []).concat(s || []).reduce((b, u) => (b[u.name + u.index] = u, b), {});
              return Object.keys(l).map((b) => l[b]);
            }(this.queuedAnnouncement && this.queuedAnnouncement.series, k), S = this.buildAnnouncementMessage(y, m, A);
            S && (this.queuedAnnouncement && clearTimeout(this.queuedAnnouncementTimer), this.queuedAnnouncement = { time: H, message: S, series: y }, this.queuedAnnouncementTimer = setTimeout(() => {
              this && this.announcer && (this.lastAnnouncementTime = +/* @__PURE__ */ new Date(), this.announcer.announce(this.queuedAnnouncement.message), delete this.queuedAnnouncement, delete this.queuedAnnouncementTimer);
            }, P));
          }
        }
        buildAnnouncementMessage(k, m, A) {
          let C = this.chart, H = C.options.accessibility.announceNewData;
          if (H.announcementFormatter) {
            let S = H.announcementFormatter(k, m, A);
            if (S !== !1) return S.length ? S : null;
          }
          let G = o.charts && o.charts.length > 1 ? "Multiple" : "Single", P = m ? "newSeriesAnnounce" + G : A ? "newPointAnnounce" + G : "newDataAnnounce", y = f(C);
          return C.langFormat("accessibility.announceNewData." + P, { chartTitle: y, seriesDesc: m ? x(m) : null, pointDesc: A ? w(A) : null, point: A, series: m });
        }
      }
      return function(v) {
        function k(A) {
          var G;
          let C = this.chart, H = (G = C.accessibility) == null ? void 0 : G.components.series.newDataAnnouncer;
          H && H.chart === C && M(C) && (H.dirty.newPoint = B(H.dirty.newPoint) ? void 0 : A.point);
        }
        function m() {
          var H;
          let A = this.chart, C = (H = A.accessibility) == null ? void 0 : H.components.series.newDataAnnouncer;
          C && C.chart === A && M(A) && (C.dirty.hasDirty = !0, C.dirty.allSeries[this.name + this.index] = this);
        }
        v.compose = function(A) {
          N(D, "A11y.NDA") && (F(A, "addPoint", k), F(A, "updatedData", m));
        };
      }(p || (p = {})), p;
    }), a(e, "Accessibility/ProxyElement.js", [e["Core/Globals.js"], e["Core/Utilities.js"], e["Accessibility/Utils/EventProvider.js"], e["Accessibility/Utils/ChartUtilities.js"], e["Accessibility/Utils/HTMLUtilities.js"]], function(o, n, r, T, O) {
      let { doc: j } = o, { attr: D, css: F, merge: B } = n, { fireEventOnWrappedOrUnwrappedElement: N } = T, { cloneMouseEvent: f, cloneTouchEvent: w, getFakeMouseEvent: x, removeElement: M } = O;
      return class {
        constructor(p, v, k = "button", m, A) {
          this.chart = p, this.target = v, this.eventProvider = new r();
          let C = this.innerElement = j.createElement(k), H = this.element = m ? j.createElement(m) : C;
          p.styledMode || this.hideElementVisually(C), m && (m !== "li" || p.styledMode || (H.style.listStyle = "none"), H.appendChild(C), this.element = H), this.updateTarget(v, A);
        }
        click() {
          let p = this.getTargetPosition();
          p.x += p.width / 2, p.y += p.height / 2;
          let v = x("click", p);
          N(this.target.click, v);
        }
        updateTarget(p, v) {
          this.target = p, this.updateCSSClassName();
          let k = v || {};
          Object.keys(k).forEach((A) => {
            k[A] === null && delete k[A];
          });
          let m = this.getTargetAttr(p.click, "aria-label");
          D(this.innerElement, B(m ? { "aria-label": m } : {}, k)), this.eventProvider.removeAddedEvents(), this.addProxyEventsToElement(this.innerElement, p.click), this.refreshPosition();
        }
        refreshPosition() {
          let p = this.getTargetPosition();
          F(this.innerElement, { width: (p.width || 1) + "px", height: (p.height || 1) + "px", left: (Math.round(p.x) || 0) + "px", top: (Math.round(p.y) || 0) + "px" });
        }
        remove() {
          this.eventProvider.removeAddedEvents(), M(this.element);
        }
        updateCSSClassName() {
          let p = (C) => C.indexOf("highcharts-no-tooltip") > -1, v = this.chart.legend, k = v.group && v.group.div, m = p(k && k.className || ""), A = p(this.getTargetAttr(this.target.click, "class") || "");
          this.innerElement.className = m || A ? "highcharts-a11y-proxy-element highcharts-no-tooltip" : "highcharts-a11y-proxy-element";
        }
        addProxyEventsToElement(p, v) {
          ["click", "touchstart", "touchend", "touchcancel", "touchmove", "mouseover", "mouseenter", "mouseleave", "mouseout"].forEach((k) => {
            let m = k.indexOf("touch") === 0;
            this.eventProvider.addEvent(p, k, (A) => {
              let C = m ? w(A) : f(A);
              v && N(v, C), A.stopPropagation(), m || A.preventDefault();
            }, { passive: !1 });
          });
        }
        hideElementVisually(p) {
          F(p, { borderWidth: 0, backgroundColor: "transparent", cursor: "pointer", outline: "none", opacity: 1e-3, filter: "alpha(opacity=1)", zIndex: 999, overflow: "hidden", padding: 0, margin: 0, display: "block", position: "absolute", "-ms-filter": "progid:DXImageTransform.Microsoft.Alpha(Opacity=1)" });
        }
        getTargetPosition() {
          let p = this.target.click, v = p.element ? p.element : p, k = this.target.visual || v, m = this.chart.renderTo, A = this.chart.pointer;
          if (m && (k != null && k.getBoundingClientRect) && A) {
            let C = k.getBoundingClientRect(), H = A.getChartPosition();
            return { x: (C.left - H.left) / H.scaleX, y: (C.top - H.top) / H.scaleY, width: C.right / H.scaleX - C.left / H.scaleX, height: C.bottom / H.scaleY - C.top / H.scaleY };
          }
          return { x: 0, y: 0, width: 1, height: 1 };
        }
        getTargetAttr(p, v) {
          return p.element ? p.element.getAttribute(v) : p.getAttribute(v);
        }
      };
    }), a(e, "Accessibility/ProxyProvider.js", [e["Core/Globals.js"], e["Core/Utilities.js"], e["Accessibility/Utils/ChartUtilities.js"], e["Accessibility/Utils/DOMElementProvider.js"], e["Accessibility/Utils/HTMLUtilities.js"], e["Accessibility/ProxyElement.js"]], function(o, n, r, T, O, j) {
      let { doc: D } = o, { attr: F, css: B } = n, { unhideChartElementFromAT: N } = r, { removeChildNodes: f } = O;
      return class {
        constructor(w) {
          this.chart = w, this.domElementProvider = new T(), this.groups = {}, this.groupOrder = [], this.beforeChartProxyPosContainer = this.createProxyPosContainer("before"), this.afterChartProxyPosContainer = this.createProxyPosContainer("after"), this.update();
        }
        addProxyElement(w, x, M = "button", p) {
          let v = this.groups[w];
          if (!v) throw Error("ProxyProvider.addProxyElement: Invalid group key " + w);
          let k = v.type === "ul" || v.type === "ol" ? "li" : void 0, m = new j(this.chart, x, M, k, p);
          return v.proxyContainerElement.appendChild(m.element), v.proxyElements.push(m), m;
        }
        addGroup(w, x = "div", M) {
          let p, v = this.groups[w];
          if (v) return v.groupElement;
          let k = this.domElementProvider.createElement(x);
          return M && M.role && x !== "div" ? (p = this.domElementProvider.createElement("div")).appendChild(k) : p = k, p.className = "highcharts-a11y-proxy-group highcharts-a11y-proxy-group-" + w.replace(/\W/g, "-"), this.groups[w] = { proxyContainerElement: k, groupElement: p, type: x, proxyElements: [] }, F(p, M || {}), x === "ul" && k.setAttribute("role", "list"), this.afterChartProxyPosContainer.appendChild(p), this.updateGroupOrder(this.groupOrder), p;
        }
        updateGroupAttrs(w, x) {
          let M = this.groups[w];
          if (!M) throw Error("ProxyProvider.updateGroupAttrs: Invalid group key " + w);
          F(M.groupElement, x);
        }
        updateGroupOrder(w) {
          if (this.groupOrder = w.slice(), this.isDOMOrderGroupOrder()) return;
          let x = w.indexOf("series"), M = x > -1 ? w.slice(0, x) : w, p = x > -1 ? w.slice(x + 1) : [], v = D.activeElement;
          ["before", "after"].forEach((k) => {
            let m = this[k === "before" ? "beforeChartProxyPosContainer" : "afterChartProxyPosContainer"];
            f(m), (k === "before" ? M : p).forEach((A) => {
              let C = this.groups[A];
              C && m.appendChild(C.groupElement);
            });
          }), (this.beforeChartProxyPosContainer.contains(v) || this.afterChartProxyPosContainer.contains(v)) && v && v.focus && v.focus();
        }
        clearGroup(w) {
          let x = this.groups[w];
          if (!x) throw Error("ProxyProvider.clearGroup: Invalid group key " + w);
          f(x.proxyContainerElement);
        }
        removeGroup(w) {
          let x = this.groups[w];
          x && (this.domElementProvider.removeElement(x.groupElement), x.groupElement !== x.proxyContainerElement && this.domElementProvider.removeElement(x.proxyContainerElement), delete this.groups[w]);
        }
        update() {
          this.updatePosContainerPositions(), this.updateGroupOrder(this.groupOrder), this.updateProxyElementPositions();
        }
        updateProxyElementPositions() {
          Object.keys(this.groups).forEach(this.updateGroupProxyElementPositions.bind(this));
        }
        updateGroupProxyElementPositions(w) {
          let x = this.groups[w];
          x && x.proxyElements.forEach((M) => M.refreshPosition());
        }
        destroy() {
          this.domElementProvider.destroyCreatedElements();
        }
        createProxyPosContainer(w) {
          let x = this.domElementProvider.createElement("div");
          return x.setAttribute("aria-hidden", "false"), x.className = "highcharts-a11y-proxy-container" + (w ? "-" + w : ""), B(x, { top: "0", left: "0" }), this.chart.styledMode || (x.style.whiteSpace = "nowrap", x.style.position = "absolute"), x;
        }
        getCurrentGroupOrderInDOM() {
          let w = (v) => {
            let k = Object.keys(this.groups), m = k.length;
            for (; m--; ) {
              let A = k[m], C = this.groups[A];
              if (C && v === C.groupElement) return A;
            }
          }, x = (v) => {
            let k = [], m = v.children;
            for (let A = 0; A < m.length; ++A) {
              let C = w(m[A]);
              C && k.push(C);
            }
            return k;
          }, M = x(this.beforeChartProxyPosContainer), p = x(this.afterChartProxyPosContainer);
          return M.push("series"), M.concat(p);
        }
        isDOMOrderGroupOrder() {
          let w = this.getCurrentGroupOrderInDOM(), x = this.groupOrder.filter((p) => p === "series" || !!this.groups[p]), M = w.length;
          if (M !== x.length) return !1;
          for (; M--; ) if (w[M] !== x[M]) return !1;
          return !0;
        }
        updatePosContainerPositions() {
          let w = this.chart;
          if (w.renderer.forExport) return;
          let x = w.renderer.box;
          w.container.insertBefore(this.afterChartProxyPosContainer, x.nextSibling), w.container.insertBefore(this.beforeChartProxyPosContainer, x), N(this.chart, this.afterChartProxyPosContainer), N(this.chart, this.beforeChartProxyPosContainer);
        }
      };
    }), a(e, "Accessibility/Components/RangeSelectorComponent.js", [e["Accessibility/AccessibilityComponent.js"], e["Accessibility/Utils/Announcer.js"], e["Accessibility/Utils/ChartUtilities.js"], e["Accessibility/KeyboardNavigationHandler.js"], e["Core/Utilities.js"]], function(o, n, r, T, O) {
      let { unhideChartElementFromAT: j, getAxisRangeDescription: D } = r, { addEvent: F, attr: B } = O;
      class N extends o {
        init() {
          let w = this.chart;
          this.announcer = new n(w, "polite");
        }
        onChartUpdate() {
          let w = this.chart, x = this, M = w.rangeSelector;
          M && (this.updateSelectorVisibility(), this.setDropdownAttrs(), M.buttons && M.buttons.length && M.buttons.forEach((p) => {
            x.setRangeButtonAttrs(p);
          }), M.maxInput && M.minInput && ["minInput", "maxInput"].forEach(function(p, v) {
            let k = M[p];
            k && (j(w, k), x.setRangeInputAttrs(k, "accessibility.rangeSelector." + (v ? "max" : "min") + "InputLabel"));
          }));
        }
        updateSelectorVisibility() {
          let w = this.chart, x = w.rangeSelector, M = x && x.dropdown, p = x && x.buttons || [], v = (k) => k.setAttribute("aria-hidden", !0);
          x && x.hasVisibleDropdown && M ? (j(w, M), p.forEach((k) => v(k.element))) : (M && v(M), p.forEach((k) => j(w, k.element)));
        }
        setDropdownAttrs() {
          let w = this.chart, x = w.rangeSelector && w.rangeSelector.dropdown;
          if (x) {
            let M = w.langFormat("accessibility.rangeSelector.dropdownLabel", { rangeTitle: w.options.lang.rangeSelectorZoom });
            x.setAttribute("aria-label", M), x.setAttribute("tabindex", -1);
          }
        }
        setRangeButtonAttrs(w) {
          B(w.element, { tabindex: -1, role: "button" });
        }
        setRangeInputAttrs(w, x) {
          let M = this.chart;
          B(w, { tabindex: -1, "aria-label": M.langFormat(x, { chart: M }) });
        }
        onButtonNavKbdArrowKey(w, x) {
          let M = w.response, p = this.keyCodes, v = this.chart, k = v.options.accessibility.keyboardNavigation.wrapAround, m = x === p.left || x === p.up ? -1 : 1;
          return v.highlightRangeSelectorButton(v.highlightedRangeSelectorItemIx + m) ? M.success : k ? (w.init(m), M.success) : M[m > 0 ? "next" : "prev"];
        }
        onButtonNavKbdClick(w) {
          let x = w.response, M = this.chart;
          return M.oldRangeSelectorItemState !== 3 && this.fakeClickEvent(M.rangeSelector.buttons[M.highlightedRangeSelectorItemIx].element), x.success;
        }
        onAfterBtnClick() {
          let w = this.chart, x = D(w.xAxis[0]), M = w.langFormat("accessibility.rangeSelector.clickButtonAnnouncement", { chart: w, axisRangeDescription: x });
          M && this.announcer.announce(M);
        }
        onInputKbdMove(w) {
          let x = this.chart, M = x.rangeSelector, p = x.highlightedInputRangeIx = (x.highlightedInputRangeIx || 0) + w;
          if (p > 1 || p < 0) {
            if (x.accessibility) return x.accessibility.keyboardNavigation.exiting = !0, x.accessibility.keyboardNavigation.tabindexContainer.focus(), x.accessibility.keyboardNavigation.move(w);
          } else if (M) {
            let v = M[p ? "maxDateBox" : "minDateBox"], k = M[p ? "maxInput" : "minInput"];
            v && k && x.setFocusToElement(v, k);
          }
          return !0;
        }
        onInputNavInit(w) {
          let x = this, M = this.chart, p = w > 0 ? 0 : 1, v = M.rangeSelector, k = v && v[p ? "maxDateBox" : "minDateBox"], m = v && v.minInput, A = v && v.maxInput;
          if (M.highlightedInputRangeIx = p, k && m && A) {
            M.setFocusToElement(k, p ? A : m), this.removeInputKeydownHandler && this.removeInputKeydownHandler();
            let C = (P) => {
              (P.which || P.keyCode) === this.keyCodes.tab && x.onInputKbdMove(P.shiftKey ? -1 : 1) && (P.preventDefault(), P.stopPropagation());
            }, H = F(m, "keydown", C), G = F(A, "keydown", C);
            this.removeInputKeydownHandler = () => {
              H(), G();
            };
          }
        }
        onInputNavTerminate() {
          let w = this.chart.rangeSelector || {};
          w.maxInput && w.hideInput("max"), w.minInput && w.hideInput("min"), this.removeInputKeydownHandler && (this.removeInputKeydownHandler(), delete this.removeInputKeydownHandler);
        }
        initDropdownNav() {
          let w = this.chart, x = w.rangeSelector, M = x && x.dropdown;
          x && M && (w.setFocusToElement(x.buttonGroup, M), this.removeDropdownKeydownHandler && this.removeDropdownKeydownHandler(), this.removeDropdownKeydownHandler = F(M, "keydown", (p) => {
            let v = (p.which || p.keyCode) === this.keyCodes.tab, k = w.accessibility;
            v && (p.preventDefault(), p.stopPropagation(), k && (k.keyboardNavigation.tabindexContainer.focus(), k.keyboardNavigation.move(p.shiftKey ? -1 : 1)));
          }));
        }
        getRangeSelectorButtonNavigation() {
          let w = this.chart, x = this.keyCodes, M = this;
          return new T(w, { keyCodeMap: [[[x.left, x.right, x.up, x.down], function(p) {
            return M.onButtonNavKbdArrowKey(this, p);
          }], [[x.enter, x.space], function() {
            return M.onButtonNavKbdClick(this);
          }]], validate: function() {
            return !!(w.rangeSelector && w.rangeSelector.buttons && w.rangeSelector.buttons.length);
          }, init: function(p) {
            let v = w.rangeSelector;
            if (v && v.hasVisibleDropdown) M.initDropdownNav();
            else if (v) {
              let k = v.buttons.length - 1;
              w.highlightRangeSelectorButton(p > 0 ? 0 : k);
            }
          }, terminate: function() {
            M.removeDropdownKeydownHandler && (M.removeDropdownKeydownHandler(), delete M.removeDropdownKeydownHandler);
          } });
        }
        getRangeSelectorInputNavigation() {
          let w = this.chart, x = this;
          return new T(w, { keyCodeMap: [], validate: function() {
            return !!(w.rangeSelector && w.rangeSelector.inputGroup && w.rangeSelector.inputGroup.element.style.visibility !== "hidden" && w.options.rangeSelector.inputEnabled !== !1 && w.rangeSelector.minInput && w.rangeSelector.maxInput);
          }, init: function(M) {
            x.onInputNavInit(M);
          }, terminate: function() {
            x.onInputNavTerminate();
          } });
        }
        getKeyboardNavigation() {
          return [this.getRangeSelectorButtonNavigation(), this.getRangeSelectorInputNavigation()];
        }
        destroy() {
          this.removeDropdownKeydownHandler && this.removeDropdownKeydownHandler(), this.removeInputKeydownHandler && this.removeInputKeydownHandler(), this.announcer && this.announcer.destroy();
        }
      }
      return function(f) {
        function w(M) {
          let p = this.rangeSelector && this.rangeSelector.buttons || [], v = this.highlightedRangeSelectorItemIx, k = this.rangeSelector && this.rangeSelector.selected;
          return v !== void 0 && p[v] && v !== k && p[v].setState(this.oldRangeSelectorItemState || 0), this.highlightedRangeSelectorItemIx = M, !!p[M] && (this.setFocusToElement(p[M].box, p[M].element), M !== k && (this.oldRangeSelectorItemState = p[M].state, p[M].setState(1)), !0);
        }
        function x() {
          let M = this.chart.accessibility;
          if (M && M.components.rangeSelector) return M.components.rangeSelector.onAfterBtnClick();
        }
        f.compose = function(M, p) {
          let v = M.prototype;
          v.highlightRangeSelectorButton || (v.highlightRangeSelectorButton = w, F(p, "afterBtnClick", x));
        };
      }(N || (N = {})), N;
    }), a(e, "Accessibility/Components/SeriesComponent/ForcedMarkers.js", [e["Core/Globals.js"], e["Core/Utilities.js"]], function(o, n) {
      var r;
      let { composed: T } = o, { addEvent: O, merge: j, pushUnique: D } = n;
      return function(F) {
        function B(v) {
          j(!0, v, { marker: { enabled: !0, states: { normal: { opacity: 0 } } } });
        }
        function N(v) {
          return v.marker.states && v.marker.states.normal && v.marker.states.normal.opacity;
        }
        function f(v) {
          return !!(v._hasPointMarkers && v.points && v.points.length);
        }
        function w() {
          this.chart.styledMode && (this.markerGroup && this.markerGroup[this.a11yMarkersForced ? "addClass" : "removeClass"]("highcharts-a11y-markers-hidden"), f(this) && this.points.forEach((v) => {
            v.graphic && (v.graphic[v.hasForcedA11yMarker ? "addClass" : "removeClass"]("highcharts-a11y-marker-hidden"), v.graphic[v.hasForcedA11yMarker === !1 ? "addClass" : "removeClass"]("highcharts-a11y-marker-visible"));
          }));
        }
        function x(v) {
          this.resetA11yMarkerOptions = j(v.options.marker || {}, this.userOptions.marker || {});
        }
        function M() {
          let v = this.options;
          (function(k) {
            let m = k.chart.options.accessibility.enabled, A = (k.options.accessibility && k.options.accessibility.enabled) !== !1;
            return m && A && function(C) {
              let H = C.chart.options.accessibility;
              return C.points.length < H.series.pointDescriptionEnabledThreshold || H.series.pointDescriptionEnabledThreshold === !1;
            }(k);
          })(this) ? (v.marker && v.marker.enabled === !1 && (this.a11yMarkersForced = !0, B(this.options)), f(this) && function(k) {
            let m = k.points.length;
            for (; m--; ) {
              let A = k.points[m], C = A.options, H = A.hasForcedA11yMarker;
              if (delete A.hasForcedA11yMarker, C.marker) {
                let G = H && N(C) === 0;
                C.marker.enabled && !G ? (j(!0, C.marker, { states: { normal: { opacity: N(C) || 1 } } }), A.hasForcedA11yMarker = !1) : C.marker.enabled === !1 && (B(C), A.hasForcedA11yMarker = !0);
              }
            }
          }(this)) : this.a11yMarkersForced && (delete this.a11yMarkersForced, function(k) {
            let m = k.resetA11yMarkerOptions;
            if (m) {
              let A = m.states && m.states.normal && m.states.normal.opacity;
              k.userOptions && k.userOptions.marker && (k.userOptions.marker.enabled = !0), k.update({ marker: { enabled: m.enabled, states: { normal: { opacity: A } } } });
            }
          }(this), delete this.resetA11yMarkerOptions);
        }
        function p() {
          this.boosted && this.a11yMarkersForced && (j(!0, this.options, { marker: { enabled: !1 } }), delete this.a11yMarkersForced);
        }
        F.compose = function(v) {
          D(T, "A11y.FM") && (O(v, "afterSetOptions", x), O(v, "render", M), O(v, "afterRender", w), O(v, "renderCanvas", p));
        };
      }(r || (r = {})), r;
    }), a(e, "Accessibility/Components/SeriesComponent/SeriesKeyboardNavigation.js", [e["Core/Series/Point.js"], e["Core/Series/Series.js"], e["Core/Series/SeriesRegistry.js"], e["Core/Globals.js"], e["Core/Utilities.js"], e["Accessibility/KeyboardNavigationHandler.js"], e["Accessibility/Utils/EventProvider.js"], e["Accessibility/Utils/ChartUtilities.js"]], function(o, n, r, T, O, j, D, F) {
      let { seriesTypes: B } = r, { doc: N } = T, { defined: f, fireEvent: w } = O, { getPointFromXY: x, getSeriesFromName: M, scrollAxisToPoint: p } = F;
      function v(P) {
        let y = P.index, S = P.series.points, d = S.length;
        if (S[y] === P) return y;
        for (; d--; ) if (S[d] === P) return d;
      }
      function k(P) {
        let y = P.chart.options.accessibility.keyboardNavigation.seriesNavigation, S = P.options.accessibility || {}, d = S.keyboardNavigation;
        return d && d.enabled === !1 || S.enabled === !1 || P.options.enableMouseTracking === !1 || !P.visible || y.pointNavigationEnabledThreshold && +y.pointNavigationEnabledThreshold <= P.points.length;
      }
      function m(P) {
        let y = P.series.chart.options.accessibility, S = P.options.accessibility && P.options.accessibility.enabled === !1;
        return P.isNull && y.keyboardNavigation.seriesNavigation.skipNullPoints || P.visible === !1 || P.isInside === !1 || S || k(P.series);
      }
      function A(P) {
        let y = P.series || [], S = y.length;
        for (let d = 0; d < S; ++d) if (!k(y[d])) {
          let s = function(l) {
            let b = l.points || [], u = b.length;
            for (let c = 0; c < u; ++c) if (!m(b[c])) return b[c];
            return null;
          }(y[d]);
          if (s) return s;
        }
        return null;
      }
      function C(P) {
        let y = P.series.length, S = !1;
        for (; y-- && (P.highlightedPoint = P.series[y].points[P.series[y].points.length - 1], !(S = P.series[y].highlightNextValidPoint())); ) ;
        return S;
      }
      function H(P) {
        delete P.highlightedPoint;
        let y = A(P);
        return !!y && y.highlight();
      }
      class G {
        constructor(y, S) {
          this.keyCodes = S, this.chart = y;
        }
        init() {
          let y = this, S = this.chart, d = this.eventProvider = new D();
          d.addEvent(n, "destroy", function() {
            return y.onSeriesDestroy(this);
          }), d.addEvent(S, "afterApplyDrilldown", function() {
            (function(s) {
              let l = A(s);
              l && l.highlight(!1);
            })(this);
          }), d.addEvent(S, "drilldown", function(s) {
            let l = s.point, b = l.series;
            y.lastDrilledDownPoint = { x: l.x, y: l.y, seriesName: b ? b.name : "" };
          }), d.addEvent(S, "drillupall", function() {
            setTimeout(function() {
              y.onDrillupAll();
            }, 10);
          }), d.addEvent(o, "afterSetState", function() {
            let s = this.graphic && this.graphic.element, l = N.activeElement, b = l && l.getAttribute("class"), u = b && b.indexOf("highcharts-a11y-proxy-element") > -1;
            S.highlightedPoint === this && l !== s && !u && s && s.focus && s.focus();
          });
        }
        onDrillupAll() {
          let y, S = this.lastDrilledDownPoint, d = this.chart, s = S && M(d, S.seriesName);
          S && s && f(S.x) && f(S.y) && (y = x(s, S.x, S.y)), y = y || A(d), d.container && d.container.focus(), y && y.highlight && y.highlight(!1);
        }
        getKeyboardNavigationHandler() {
          let y = this, S = this.keyCodes, d = this.chart, s = d.inverted;
          return new j(d, { keyCodeMap: [[s ? [S.up, S.down] : [S.left, S.right], function(l) {
            return y.onKbdSideways(this, l);
          }], [s ? [S.left, S.right] : [S.up, S.down], function(l) {
            return y.onKbdVertical(this, l);
          }], [[S.enter, S.space], function(l, b) {
            var c;
            let u = d.highlightedPoint;
            if (u) {
              let { plotLeft: h, plotTop: g } = this.chart, { plotX: E = 0, plotY: R = 0 } = u;
              b = { ...b, chartX: h + E, chartY: g + R, point: u, target: ((c = u.graphic) == null ? void 0 : c.element) || b.target }, w(u.series, "click", b), u.firePointEvent("click", b);
            }
            return this.response.success;
          }], [[S.home], function() {
            return H(d), this.response.success;
          }], [[S.end], function() {
            return C(d), this.response.success;
          }], [[S.pageDown, S.pageUp], function(l) {
            return d.highlightAdjacentSeries(l === S.pageDown), this.response.success;
          }]], init: function() {
            return y.onHandlerInit(this);
          }, validate: function() {
            return !!A(d);
          }, terminate: function() {
            return y.onHandlerTerminate();
          } });
        }
        onKbdSideways(y, S) {
          let d = this.keyCodes, s = S === d.right || S === d.down;
          return this.attemptHighlightAdjacentPoint(y, s);
        }
        onHandlerInit(y) {
          let S = this.chart;
          return S.options.accessibility.keyboardNavigation.seriesNavigation.rememberPointFocus && S.highlightedPoint ? S.highlightedPoint.highlight() : H(S), y.response.success;
        }
        onKbdVertical(y, S) {
          let d = this.chart, s = this.keyCodes, l = S === s.down || S === s.right, b = d.options.accessibility.keyboardNavigation.seriesNavigation;
          if (b.mode && b.mode === "serialize") return this.attemptHighlightAdjacentPoint(y, l);
          let u = d.highlightedPoint && d.highlightedPoint.series.keyboardMoveVertical ? "highlightAdjacentPointVertical" : "highlightAdjacentSeries";
          return d[u](l), y.response.success;
        }
        onHandlerTerminate() {
          let y = this.chart, S = y.options.accessibility.keyboardNavigation;
          y.tooltip && y.tooltip.hide(0);
          let d = y.highlightedPoint && y.highlightedPoint.series;
          d && d.onMouseOut && d.onMouseOut(), y.highlightedPoint && y.highlightedPoint.onMouseOut && y.highlightedPoint.onMouseOut(), S.seriesNavigation.rememberPointFocus || delete y.highlightedPoint;
        }
        attemptHighlightAdjacentPoint(y, S) {
          let d = this.chart, s = d.options.accessibility.keyboardNavigation.wrapAround;
          return d.highlightAdjacentPoint(S) || s && (S ? H(d) : C(d)) ? y.response.success : y.response[S ? "next" : "prev"];
        }
        onSeriesDestroy(y) {
          let S = this.chart;
          S.highlightedPoint && S.highlightedPoint.series === y && (delete S.highlightedPoint, S.focusElement && S.focusElement.removeFocusBorder());
        }
        destroy() {
          this.eventProvider.removeAddedEvents();
        }
      }
      return function(P) {
        function y(b) {
          let u, c, h = this.series, g = this.highlightedPoint, E = g && v(g) || 0, R = g && g.series.points || [], L = this.series && this.series[this.series.length - 1], U = L && L.points && L.points[L.points.length - 1];
          if (!h[0] || !h[0].points) return !1;
          if (g) {
            if (u = h[g.series.index + (b ? 1 : -1)], (c = R[E + (b ? 1 : -1)]) || !u || (c = u.points[b ? 0 : u.points.length - 1]), !c) return !1;
          } else c = b ? h[0].points[0] : U;
          return m(c) ? (k(u = c.series) ? this.highlightedPoint = b ? u.points[u.points.length - 1] : u.points[0] : this.highlightedPoint = c, this.highlightAdjacentPoint(b)) : c.highlight();
        }
        function S(b) {
          let u = this.highlightedPoint, c = 1 / 0, h;
          return !!(f(u.plotX) && f(u.plotY)) && (this.series.forEach((g) => {
            k(g) || g.points.forEach((E) => {
              if (!f(E.plotY) || !f(E.plotX) || E === u) return;
              let R = E.plotY - u.plotY, L = Math.abs(E.plotX - u.plotX), U = Math.abs(R) * Math.abs(R) + L * L * 4;
              g.yAxis && g.yAxis.reversed && (R *= -1), !(R <= 0 && b || R >= 0 && !b || U < 5 || m(E)) && U < c && (c = U, h = E);
            });
          }), !!h && h.highlight());
        }
        function d(b) {
          let u, c, h, g = this.highlightedPoint, E = this.series && this.series[this.series.length - 1], R = E && E.points && E.points[E.points.length - 1];
          return this.highlightedPoint ? !!((u = this.series[g.series.index + (b ? -1 : 1)]) && (c = function(L, U, V, q) {
            let Y = 1 / 0, I, _, W, X = U.points.length, z = ($) => !(f($.plotX) && f($.plotY));
            if (!z(L)) {
              for (; X--; ) !z(I = U.points[X]) && (W = (L.plotX - I.plotX) * (L.plotX - I.plotX) * 4 + (L.plotY - I.plotY) * (L.plotY - I.plotY) * 1) < Y && (Y = W, _ = X);
              return f(_) ? U.points[_] : void 0;
            }
          }(g, u))) && (k(u) ? (c.highlight(), (h = this.highlightAdjacentSeries(b)) ? h : (g.highlight(), !1)) : (c.highlight(), c.series.highlightNextValidPoint())) : (u = b ? this.series && this.series[0] : E, !!(c = b ? u && u.points && u.points[0] : R) && c.highlight());
        }
        function s(b = !0) {
          var g, E;
          let u = this.series.chart, c = (E = (g = u.tooltip) == null ? void 0 : g.label) == null ? void 0 : E.element;
          !this.isNull && b ? this.onMouseOver() : u.tooltip && u.tooltip.hide(0), p(this), this.graphic && (u.setFocusToElement(this.graphic), !b && u.focusElement && u.focusElement.removeFocusBorder()), u.highlightedPoint = this;
          let h = c == null ? void 0 : c.getBoundingClientRect().top;
          if (c && h && h < 0) {
            let R = window.scrollY;
            window.scrollTo({ behavior: "smooth", top: R + h });
          }
          return this;
        }
        function l() {
          let b = this.chart.highlightedPoint, u = (b && b.series) === this ? v(b) : 0, c = this.points, h = c.length;
          if (c && h) {
            for (let g = u; g < h; ++g) if (!m(c[g])) return c[g].highlight();
            for (let g = u; g >= 0; --g) if (!m(c[g])) return c[g].highlight();
          }
          return !1;
        }
        P.compose = function(b, u, c) {
          let h = b.prototype, g = u.prototype, E = c.prototype;
          h.highlightAdjacentPoint || (h.highlightAdjacentPoint = y, h.highlightAdjacentPointVertical = S, h.highlightAdjacentSeries = d, g.highlight = s, E.keyboardMoveVertical = !0, ["column", "gantt", "pie"].forEach((R) => {
            B[R] && (B[R].prototype.keyboardMoveVertical = !1);
          }), E.highlightNextValidPoint = l);
        };
      }(G || (G = {})), G;
    }), a(e, "Accessibility/Components/SeriesComponent/SeriesComponent.js", [e["Accessibility/AccessibilityComponent.js"], e["Accessibility/Utils/ChartUtilities.js"], e["Accessibility/Components/SeriesComponent/ForcedMarkers.js"], e["Accessibility/Components/SeriesComponent/NewDataAnnouncer.js"], e["Accessibility/Components/SeriesComponent/SeriesDescriber.js"], e["Accessibility/Components/SeriesComponent/SeriesKeyboardNavigation.js"]], function(o, n, r, T, O, j) {
      let { hideSeriesFromAT: D } = n, { describeSeries: F } = O;
      return class extends o {
        static compose(B, N, f) {
          T.compose(f), r.compose(f), j.compose(B, N, f);
        }
        init() {
          this.newDataAnnouncer = new T(this.chart), this.newDataAnnouncer.init(), this.keyboardNavigation = new j(this.chart, this.keyCodes), this.keyboardNavigation.init(), this.hideTooltipFromATWhenShown(), this.hideSeriesLabelsFromATWhenShown();
        }
        hideTooltipFromATWhenShown() {
          let B = this;
          this.chart.tooltip && this.addEvent(this.chart.tooltip.constructor, "refresh", function() {
            this.chart === B.chart && this.label && this.label.element && this.label.element.setAttribute("aria-hidden", !0);
          });
        }
        hideSeriesLabelsFromATWhenShown() {
          this.addEvent(this.chart, "afterDrawSeriesLabels", function() {
            this.series.forEach(function(B) {
              B.labelBySeries && B.labelBySeries.attr("aria-hidden", !0);
            });
          });
        }
        onChartRender() {
          this.chart.series.forEach(function(B) {
            (B.options.accessibility && B.options.accessibility.enabled) !== !1 && B.visible && B.getPointsCollection().length !== 0 ? F(B) : D(B);
          });
        }
        getKeyboardNavigation() {
          return this.keyboardNavigation.getKeyboardNavigationHandler();
        }
        destroy() {
          this.newDataAnnouncer.destroy(), this.keyboardNavigation.destroy();
        }
      };
    }), a(e, "Accessibility/Components/ZoomComponent.js", [e["Accessibility/AccessibilityComponent.js"], e["Accessibility/Utils/ChartUtilities.js"], e["Accessibility/Utils/HTMLUtilities.js"], e["Accessibility/KeyboardNavigationHandler.js"], e["Core/Utilities.js"]], function(o, n, r, T, O) {
      let { unhideChartElementFromAT: j } = n, { getFakeMouseEvent: D } = r, { attr: F, pick: B } = O;
      return class extends o {
        constructor() {
          super(...arguments), this.focusedMapNavButtonIx = -1;
        }
        init() {
          let N = this, f = this.chart;
          this.proxyProvider.addGroup("zoom", "div"), ["afterShowResetZoom", "afterApplyDrilldown", "drillupall"].forEach((w) => {
            N.addEvent(f, w, function() {
              N.updateProxyOverlays();
            });
          });
        }
        onChartUpdate() {
          let N = this.chart, f = this;
          N.mapNavigation && N.mapNavigation.navButtons.forEach((w, x) => {
            j(N, w.element), f.setMapNavButtonAttrs(w.element, "accessibility.zoom.mapZoom" + (x ? "Out" : "In"));
          });
        }
        setMapNavButtonAttrs(N, f) {
          let w = this.chart;
          F(N, { tabindex: -1, role: "button", "aria-label": w.langFormat(f, { chart: w }) });
        }
        onChartRender() {
          this.updateProxyOverlays();
        }
        updateProxyOverlays() {
          let N = this.chart;
          if (this.proxyProvider.clearGroup("zoom"), N.resetZoomButton && this.createZoomProxyButton(N.resetZoomButton, "resetZoomProxyButton", N.langFormat("accessibility.zoom.resetZoomButton", { chart: N })), N.drillUpButton && N.breadcrumbs && N.breadcrumbs.list) {
            let f = N.breadcrumbs.list[N.breadcrumbs.list.length - 1];
            this.createZoomProxyButton(N.drillUpButton, "drillUpProxyButton", N.langFormat("accessibility.drillUpButton", { chart: N, buttonText: N.breadcrumbs.getButtonText(f) }));
          }
        }
        createZoomProxyButton(N, f, w) {
          this[f] = this.proxyProvider.addProxyElement("zoom", { click: N }, "button", { "aria-label": w, tabindex: -1 });
        }
        getMapZoomNavigation() {
          let N = this.keyCodes, f = this.chart, w = this;
          return new T(f, { keyCodeMap: [[[N.up, N.down, N.left, N.right], function(x) {
            return w.onMapKbdArrow(this, x);
          }], [[N.tab], function(x, M) {
            return w.onMapKbdTab(this, M);
          }], [[N.space, N.enter], function() {
            return w.onMapKbdClick(this);
          }]], validate: function() {
            return !!(f.mapView && f.mapNavigation && f.mapNavigation.navButtons.length);
          }, init: function(x) {
            return w.onMapNavInit(x);
          } });
        }
        onMapKbdArrow(N, f) {
          let w = this.chart, x = this.keyCodes, M = w.container, p = f === x.up || f === x.down, v = f === x.left || f === x.up ? 1 : -1, k = (p ? w.plotHeight : w.plotWidth) / 10 * v, m = 10 * Math.random(), A = { x: M.offsetLeft + w.plotLeft + w.plotWidth / 2 + m, y: M.offsetTop + w.plotTop + w.plotHeight / 2 + m }, C = p ? { x: A.x, y: A.y + k } : { x: A.x + k, y: A.y };
          return [D("mousedown", A), D("mousemove", C), D("mouseup", C)].forEach((H) => M.dispatchEvent(H)), N.response.success;
        }
        onMapKbdTab(N, f) {
          let w = this.chart, x = N.response, M = f.shiftKey, p = M && !this.focusedMapNavButtonIx || !M && this.focusedMapNavButtonIx;
          if (w.mapNavigation.navButtons[this.focusedMapNavButtonIx].setState(0), p) return w.mapView && w.mapView.zoomBy(), x[M ? "prev" : "next"];
          this.focusedMapNavButtonIx += M ? -1 : 1;
          let v = w.mapNavigation.navButtons[this.focusedMapNavButtonIx];
          return w.setFocusToElement(v.box, v.element), v.setState(2), x.success;
        }
        onMapKbdClick(N) {
          let f = this.chart.mapNavigation.navButtons[this.focusedMapNavButtonIx].element;
          return this.fakeClickEvent(f), N.response.success;
        }
        onMapNavInit(N) {
          let f = this.chart, w = f.mapNavigation.navButtons[0], x = f.mapNavigation.navButtons[1], M = N > 0 ? w : x;
          f.setFocusToElement(M.box, M.element), M.setState(2), this.focusedMapNavButtonIx = N > 0 ? 0 : 1;
        }
        simpleButtonNavigation(N, f, w) {
          let x = this.keyCodes, M = this, p = this.chart;
          return new T(p, { keyCodeMap: [[[x.tab, x.up, x.down, x.left, x.right], function(v, k) {
            let m = v === x.tab && k.shiftKey || v === x.left || v === x.up;
            return this.response[m ? "prev" : "next"];
          }], [[x.space, x.enter], function() {
            return B(w(this, p), this.response.success);
          }]], validate: function() {
            return p[N] && p[N].box && M[f].innerElement;
          }, init: function() {
            p.setFocusToElement(p[N].box, M[f].innerElement);
          } });
        }
        getKeyboardNavigation() {
          return [this.simpleButtonNavigation("resetZoomButton", "resetZoomProxyButton", function(N, f) {
            f.zoomOut();
          }), this.simpleButtonNavigation("drillUpButton", "drillUpProxyButton", function(N, f) {
            return f.drillUp(), N.response.prev;
          }), this.getMapZoomNavigation()];
        }
      };
    }), a(e, "Accessibility/HighContrastMode.js", [e["Core/Globals.js"]], function(o) {
      let { doc: n, isMS: r, win: T } = o;
      return { isHighContrastModeActive: function() {
        let O = /(Edg)/.test(T.navigator.userAgent);
        if (T.matchMedia && O) return T.matchMedia("(-ms-high-contrast: active)").matches;
        if (r && T.getComputedStyle) {
          let j = n.createElement("div");
          j.style.backgroundImage = "url(data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==)", n.body.appendChild(j);
          let D = (j.currentStyle || T.getComputedStyle(j)).backgroundImage;
          return n.body.removeChild(j), D === "none";
        }
        return T.matchMedia && T.matchMedia("(forced-colors: active)").matches;
      }, setHighContrastTheme: function(O) {
        var F;
        O.highContrastModeActive = !0;
        let j = O.options.accessibility.highContrastTheme;
        O.update(j, !1);
        let D = ((F = j.colors) == null ? void 0 : F.length) > 1;
        O.series.forEach(function(B) {
          let N = j.plotOptions[B.type] || {}, f = D && B.colorIndex !== void 0 ? j.colors[B.colorIndex] : N.color || "window", w = { color: N.color || "windowText", colors: D ? j.colors : [N.color || "windowText"], borderColor: N.borderColor || "window", fillColor: f };
          B.update(w, !1), B.points && B.points.forEach(function(x) {
            x.options && x.options.color && x.update({ color: N.color || "windowText", borderColor: N.borderColor || "window" }, !1);
          });
        }), O.redraw();
      } };
    }), a(e, "Accessibility/HighContrastTheme.js", [], function() {
      return { chart: { backgroundColor: "window" }, title: { style: { color: "windowText" } }, subtitle: { style: { color: "windowText" } }, colorAxis: { minColor: "windowText", maxColor: "windowText", stops: [], dataClasses: [] }, colors: ["windowText"], xAxis: { gridLineColor: "windowText", labels: { style: { color: "windowText" } }, lineColor: "windowText", minorGridLineColor: "windowText", tickColor: "windowText", title: { style: { color: "windowText" } } }, yAxis: { gridLineColor: "windowText", labels: { style: { color: "windowText" } }, lineColor: "windowText", minorGridLineColor: "windowText", tickColor: "windowText", title: { style: { color: "windowText" } } }, tooltip: { backgroundColor: "window", borderColor: "windowText", style: { color: "windowText" } }, plotOptions: { series: { lineColor: "windowText", fillColor: "window", borderColor: "windowText", edgeColor: "windowText", borderWidth: 1, dataLabels: { connectorColor: "windowText", color: "windowText", style: { color: "windowText", textOutline: "none" } }, marker: { lineColor: "windowText", fillColor: "windowText" } }, pie: { color: "window", colors: ["window"], borderColor: "windowText", borderWidth: 1 }, boxplot: { fillColor: "window" }, candlestick: { lineColor: "windowText", fillColor: "window" }, errorbar: { fillColor: "window" } }, legend: { backgroundColor: "window", itemStyle: { color: "windowText" }, itemHoverStyle: { color: "windowText" }, itemHiddenStyle: { color: "#555" }, title: { style: { color: "windowText" } } }, credits: { style: { color: "windowText" } }, drilldown: { activeAxisLabelStyle: { color: "windowText" }, activeDataLabelStyle: { color: "windowText" } }, navigation: { buttonOptions: { symbolStroke: "windowText", theme: { fill: "window" } } }, rangeSelector: { buttonTheme: { fill: "window", stroke: "windowText", style: { color: "windowText" }, states: { hover: { fill: "window", stroke: "windowText", style: { color: "windowText" } }, select: { fill: "#444", stroke: "windowText", style: { color: "windowText" } } } }, inputBoxBorderColor: "windowText", inputStyle: { backgroundColor: "window", color: "windowText" }, labelStyle: { color: "windowText" } }, navigator: { handles: { backgroundColor: "window", borderColor: "windowText" }, outlineColor: "windowText", maskFill: "transparent", series: { color: "windowText", lineColor: "windowText" }, xAxis: { gridLineColor: "windowText" } }, scrollbar: { barBackgroundColor: "#444", barBorderColor: "windowText", buttonArrowColor: "windowText", buttonBackgroundColor: "window", buttonBorderColor: "windowText", rifleColor: "windowText", trackBackgroundColor: "window", trackBorderColor: "windowText" } };
    }), a(e, "Accessibility/Options/A11yDefaults.js", [], function() {
      return { accessibility: { enabled: !0, screenReaderSection: { beforeChartFormat: "<{headingTagName}>{chartTitle}</{headingTagName}><div>{typeDescription}</div><div>{chartSubtitle}</div><div>{chartLongdesc}</div><div>{playAsSoundButton}</div><div>{viewTableButton}</div><div>{xAxisDescription}</div><div>{yAxisDescription}</div><div>{annotationsTitle}{annotationsList}</div>", afterChartFormat: "{endOfChartMarker}", axisRangeDateFormat: "%Y-%m-%d %H:%M:%S" }, series: { descriptionFormat: "{seriesDescription}{authorDescription}{axisDescription}", describeSingleSeries: !1, pointDescriptionEnabledThreshold: 200 }, point: { valueDescriptionFormat: "{xDescription}{separator}{value}.", describeNull: !0 }, landmarkVerbosity: "all", linkedDescription: '*[data-highcharts-chart="{index}"] + .highcharts-description', highContrastMode: "auto", keyboardNavigation: { enabled: !0, focusBorder: { enabled: !0, hideBrowserFocusOutline: !0, style: { color: "#334eff", lineWidth: 2, borderRadius: 3 }, margin: 2 }, order: ["series", "zoom", "rangeSelector", "navigator", "legend", "chartMenu"], wrapAround: !0, seriesNavigation: { skipNullPoints: !0, pointNavigationEnabledThreshold: !1, rememberPointFocus: !1 } }, announceNewData: { enabled: !1, minAnnounceInterval: 5e3, interruptUser: !1 } }, legend: { accessibility: { enabled: !0, keyboardNavigation: { enabled: !0 } } }, exporting: { accessibility: { enabled: !0 } }, navigator: { accessibility: { enabled: !0 } } };
    }), a(e, "Accessibility/Options/LangDefaults.js", [], function() {
      return { accessibility: { defaultChartTitle: "Chart", chartContainerLabel: "{title}. Highcharts interactive chart.", svgContainerLabel: "Interactive chart", drillUpButton: "{buttonText}", credits: "Chart credits: {creditsStr}", thousandsSep: ",", svgContainerTitle: "", graphicContainerLabel: "", screenReaderSection: { beforeRegionLabel: "", afterRegionLabel: "", annotations: { heading: "Chart annotations summary", descriptionSinglePoint: "{annotationText}. Related to {annotationPoint}", descriptionMultiplePoints: "{annotationText}. Related to {annotationPoint}{#each additionalAnnotationPoints}, also related to {this}{/each}", descriptionNoPoints: "{annotationText}" }, endOfChartMarker: "End of interactive chart." }, sonification: { playAsSoundButtonText: "Play as sound, {chartTitle}", playAsSoundClickAnnouncement: "Play" }, legend: { legendLabelNoTitle: "Toggle series visibility, {chartTitle}", legendLabel: "Chart legend: {legendTitle}", legendItem: "Show {itemName}" }, zoom: { mapZoomIn: "Zoom chart", mapZoomOut: "Zoom out chart", resetZoomButton: "Reset zoom" }, rangeSelector: { dropdownLabel: "{rangeTitle}", minInputLabel: "Select start date.", maxInputLabel: "Select end date.", clickButtonAnnouncement: "Viewing {axisRangeDescription}" }, navigator: { handleLabel: "{#eq handleIx 0}Start, percent{else}End, percent{/eq}", groupLabel: "Axis zoom", changeAnnouncement: "{axisRangeDescription}" }, table: { viewAsDataTableButtonText: "View as data table, {chartTitle}", tableSummary: "Table representation of chart." }, announceNewData: { newDataAnnounce: "Updated data for chart {chartTitle}", newSeriesAnnounceSingle: "New data series: {seriesDesc}", newPointAnnounceSingle: "New data point: {pointDesc}", newSeriesAnnounceMultiple: "New data series in chart {chartTitle}: {seriesDesc}", newPointAnnounceMultiple: "New data point in chart {chartTitle}: {pointDesc}" }, seriesTypeDescriptions: { boxplot: "Box plot charts are typically used to display groups of statistical data. Each data point in the chart can have up to 5 values: minimum, lower quartile, median, upper quartile, and maximum.", arearange: "Arearange charts are line charts displaying a range between a lower and higher value for each point.", areasplinerange: "These charts are line charts displaying a range between a lower and higher value for each point.", bubble: "Bubble charts are scatter charts where each data point also has a size value.", columnrange: "Columnrange charts are column charts displaying a range between a lower and higher value for each point.", errorbar: "Errorbar series are used to display the variability of the data.", funnel: "Funnel charts are used to display reduction of data in stages.", pyramid: "Pyramid charts consist of a single pyramid with item heights corresponding to each point value.", waterfall: "A waterfall chart is a column chart where each column contributes towards a total end value." }, chartTypes: { emptyChart: "Empty chart", mapTypeDescription: "Map of {mapTitle} with {numSeries} data series.", unknownMap: "Map of unspecified region with {numSeries} data series.", combinationChart: "Combination chart with {numSeries} data series.", defaultSingle: "Chart with {numPoints} data {#eq numPoints 1}point{else}points{/eq}.", defaultMultiple: "Chart with {numSeries} data series.", splineSingle: "Line chart with {numPoints} data {#eq numPoints 1}point{else}points{/eq}.", splineMultiple: "Line chart with {numSeries} lines.", lineSingle: "Line chart with {numPoints} data {#eq numPoints 1}point{else}points{/eq}.", lineMultiple: "Line chart with {numSeries} lines.", columnSingle: "Bar chart with {numPoints} {#eq numPoints 1}bar{else}bars{/eq}.", columnMultiple: "Bar chart with {numSeries} data series.", barSingle: "Bar chart with {numPoints} {#eq numPoints 1}bar{else}bars{/eq}.", barMultiple: "Bar chart with {numSeries} data series.", pieSingle: "Pie chart with {numPoints} {#eq numPoints 1}slice{else}slices{/eq}.", pieMultiple: "Pie chart with {numSeries} pies.", scatterSingle: "Scatter chart with {numPoints} {#eq numPoints 1}point{else}points{/eq}.", scatterMultiple: "Scatter chart with {numSeries} data series.", boxplotSingle: "Boxplot with {numPoints} {#eq numPoints 1}box{else}boxes{/eq}.", boxplotMultiple: "Boxplot with {numSeries} data series.", bubbleSingle: "Bubble chart with {numPoints} {#eq numPoints 1}bubbles{else}bubble{/eq}.", bubbleMultiple: "Bubble chart with {numSeries} data series." }, axis: { xAxisDescriptionSingular: "The chart has 1 X axis displaying {names[0]}. {ranges[0]}", xAxisDescriptionPlural: "The chart has {numAxes} X axes displaying {#each names}{#unless @first},{/unless}{#if @last} and{/if} {this}{/each}.", yAxisDescriptionSingular: "The chart has 1 Y axis displaying {names[0]}. {ranges[0]}", yAxisDescriptionPlural: "The chart has {numAxes} Y axes displaying {#each names}{#unless @first},{/unless}{#if @last} and{/if} {this}{/each}.", timeRangeDays: "Data range: {range} days.", timeRangeHours: "Data range: {range} hours.", timeRangeMinutes: "Data range: {range} minutes.", timeRangeSeconds: "Data range: {range} seconds.", rangeFromTo: "Data ranges from {rangeFrom} to {rangeTo}.", rangeCategories: "Data range: {numCategories} categories." }, exporting: { chartMenuLabel: "Chart menu", menuButtonLabel: "View chart menu, {chartTitle}" }, series: { summary: { default: "{series.name}, series {seriesNumber} of {chart.series.length} with {series.points.length} data {#eq series.points.length 1}point{else}points{/eq}.", defaultCombination: "{series.name}, series {seriesNumber} of {chart.series.length} with {series.points.length} data {#eq series.points.length 1}point{else}points{/eq}.", line: "{series.name}, line {seriesNumber} of {chart.series.length} with {series.points.length} data {#eq series.points.length 1}point{else}points{/eq}.", lineCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Line with {series.points.length} data {#eq series.points.length 1}point{else}points{/eq}.", spline: "{series.name}, line {seriesNumber} of {chart.series.length} with {series.points.length} data {#eq series.points.length 1}point{else}points{/eq}.", splineCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Line with {series.points.length} data {#eq series.points.length 1}point{else}points{/eq}.", column: "{series.name}, bar series {seriesNumber} of {chart.series.length} with {series.points.length} {#eq series.points.length 1}bar{else}bars{/eq}.", columnCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Bar series with {series.points.length} {#eq series.points.length 1}bar{else}bars{/eq}.", bar: "{series.name}, bar series {seriesNumber} of {chart.series.length} with {series.points.length} {#eq series.points.length 1}bar{else}bars{/eq}.", barCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Bar series with {series.points.length} {#eq series.points.length 1}bar{else}bars{/eq}.", pie: "{series.name}, pie {seriesNumber} of {chart.series.length} with {series.points.length} {#eq series.points.length 1}slice{else}slices{/eq}.", pieCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Pie with {series.points.length} {#eq series.points.length 1}slice{else}slices{/eq}.", scatter: "{series.name}, scatter plot {seriesNumber} of {chart.series.length} with {series.points.length} {#eq series.points.length 1}point{else}points{/eq}.", scatterCombination: "{series.name}, series {seriesNumber} of {chart.series.length}, scatter plot with {series.points.length} {#eq series.points.length 1}point{else}points{/eq}.", boxplot: "{series.name}, boxplot {seriesNumber} of {chart.series.length} with {series.points.length} {#eq series.points.length 1}box{else}boxes{/eq}.", boxplotCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Boxplot with {series.points.length} {#eq series.points.length 1}box{else}boxes{/eq}.", bubble: "{series.name}, bubble series {seriesNumber} of {chart.series.length} with {series.points.length} {#eq series.points.length 1}bubble{else}bubbles{/eq}.", bubbleCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Bubble series with {series.points.length} {#eq series.points.length 1}bubble{else}bubbles{/eq}.", map: "{series.name}, map {seriesNumber} of {chart.series.length} with {series.points.length} {#eq series.points.length 1}area{else}areas{/eq}.", mapCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Map with {series.points.length} {#eq series.points.length 1}area{else}areas{/eq}.", mapline: "{series.name}, line {seriesNumber} of {chart.series.length} with {series.points.length} data {#eq series.points.length 1}point{else}points{/eq}.", maplineCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Line with {series.points.length} data {#eq series.points.length 1}point{else}points{/eq}.", mapbubble: "{series.name}, bubble series {seriesNumber} of {chart.series.length} with {series.points.length} {#eq series.points.length 1}bubble{else}bubbles{/eq}.", mapbubbleCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Bubble series with {series.points.length} {#eq series.points.length 1}bubble{else}bubbles{/eq}." }, description: "{description}", xAxisDescription: "X axis, {name}", yAxisDescription: "Y axis, {name}", nullPointValue: "No value", pointAnnotationsDescription: "{#each annotations}Annotation: {this}{/each}" } } };
    }), a(e, "Accessibility/Options/DeprecatedOptions.js", [e["Core/Utilities.js"]], function(o) {
      let { error: n, pick: r } = o;
      function T(j, D, F) {
        let B = j, N, f = 0;
        for (; f < D.length - 1; ++f) B = B[N = D[f]] = r(B[N], {});
        B[D[D.length - 1]] = F;
      }
      function O(j, D, F, B) {
        function N(x, M) {
          return M.reduce(function(p, v) {
            return p[v];
          }, x);
        }
        let f = N(j.options, D), w = N(j.options, F);
        Object.keys(B).forEach(function(x) {
          let M = f[x];
          M !== void 0 && (T(w, B[x], M), n(32, !1, j, { [D.join(".") + "." + x]: F.join(".") + "." + B[x].join(".") }));
        });
      }
      return function(j) {
        (function(D) {
          let F = D.options.chart, B = D.options.accessibility || {};
          ["description", "typeDescription"].forEach(function(N) {
            F[N] && (B[N] = F[N], n(32, !1, D, { [`chart.${N}`]: `use accessibility.${N}` }));
          });
        })(j), function(D) {
          D.axes.forEach(function(F) {
            let B = F.options;
            B && B.description && (B.accessibility = B.accessibility || {}, B.accessibility.description = B.description, n(32, !1, D, { "axis.description": "use axis.accessibility.description" }));
          });
        }(j), j.series && function(D) {
          let F = { description: ["accessibility", "description"], exposeElementToA11y: ["accessibility", "exposeAsGroupOnly"], pointDescriptionFormatter: ["accessibility", "point", "descriptionFormatter"], skipKeyboardNavigation: ["accessibility", "keyboardNavigation", "enabled"], "accessibility.pointDescriptionFormatter": ["accessibility", "point", "descriptionFormatter"] };
          D.series.forEach(function(B) {
            Object.keys(F).forEach(function(N) {
              let f = B.options[N];
              N === "accessibility.pointDescriptionFormatter" && (f = B.options.accessibility && B.options.accessibility.pointDescriptionFormatter), f !== void 0 && (T(B.options, F[N], N === "skipKeyboardNavigation" ? !f : f), n(32, !1, D, { [`series.${N}`]: "series." + F[N].join(".") }));
            });
          });
        }(j), O(j, ["accessibility"], ["accessibility"], { pointDateFormat: ["point", "dateFormat"], pointDateFormatter: ["point", "dateFormatter"], pointDescriptionFormatter: ["point", "descriptionFormatter"], pointDescriptionThreshold: ["series", "pointDescriptionEnabledThreshold"], pointNavigationThreshold: ["keyboardNavigation", "seriesNavigation", "pointNavigationEnabledThreshold"], pointValueDecimals: ["point", "valueDecimals"], pointValuePrefix: ["point", "valuePrefix"], pointValueSuffix: ["point", "valueSuffix"], screenReaderSectionFormatter: ["screenReaderSection", "beforeChartFormatter"], describeSingleSeries: ["series", "describeSingleSeries"], seriesDescriptionFormatter: ["series", "descriptionFormatter"], onTableAnchorClick: ["screenReaderSection", "onViewDataTableClick"], axisRangeDateFormat: ["screenReaderSection", "axisRangeDateFormat"] }), O(j, ["accessibility", "keyboardNavigation"], ["accessibility", "keyboardNavigation", "seriesNavigation"], { skipNullPoints: ["skipNullPoints"], mode: ["mode"] }), O(j, ["lang", "accessibility"], ["lang", "accessibility"], { legendItem: ["legend", "legendItem"], legendLabel: ["legend", "legendLabel"], mapZoomIn: ["zoom", "mapZoomIn"], mapZoomOut: ["zoom", "mapZoomOut"], resetZoomButton: ["zoom", "resetZoomButton"], screenReaderRegionLabel: ["screenReaderSection", "beforeRegionLabel"], rangeSelectorButton: ["rangeSelector", "buttonText"], rangeSelectorMaxInput: ["rangeSelector", "maxInputLabel"], rangeSelectorMinInput: ["rangeSelector", "minInputLabel"], svgContainerEnd: ["screenReaderSection", "endOfChartMarker"], viewAsDataTable: ["table", "viewAsDataTableButtonText"], tableSummary: ["table", "tableSummary"] });
      };
    }), a(e, "Accessibility/Accessibility.js", [e["Core/Defaults.js"], e["Core/Globals.js"], e["Core/Utilities.js"], e["Accessibility/Utils/HTMLUtilities.js"], e["Accessibility/A11yI18n.js"], e["Accessibility/Components/ContainerComponent.js"], e["Accessibility/FocusBorder.js"], e["Accessibility/Components/InfoRegionsComponent.js"], e["Accessibility/KeyboardNavigation.js"], e["Accessibility/Components/LegendComponent.js"], e["Accessibility/Components/MenuComponent.js"], e["Accessibility/Components/NavigatorComponent.js"], e["Accessibility/Components/SeriesComponent/NewDataAnnouncer.js"], e["Accessibility/ProxyProvider.js"], e["Accessibility/Components/RangeSelectorComponent.js"], e["Accessibility/Components/SeriesComponent/SeriesComponent.js"], e["Accessibility/Components/ZoomComponent.js"], e["Accessibility/HighContrastMode.js"], e["Accessibility/HighContrastTheme.js"], e["Accessibility/Options/A11yDefaults.js"], e["Accessibility/Options/LangDefaults.js"], e["Accessibility/Options/DeprecatedOptions.js"]], function(o, n, r, T, O, j, D, F, B, N, f, w, x, M, p, v, k, m, A, C, H, G) {
      let { defaultOptions: P } = o, { doc: y } = n, { addEvent: S, extend: d, fireEvent: s, merge: l } = r, { removeElement: b } = T;
      class u {
        constructor(h) {
          this.init(h);
        }
        init(h) {
          if (this.chart = h, !y.addEventListener) {
            this.zombie = !0, this.components = {}, h.renderTo.setAttribute("aria-hidden", !0);
            return;
          }
          G(h), this.proxyProvider = new M(this.chart), this.initComponents(), this.keyboardNavigation = new B(h, this.components);
        }
        initComponents() {
          let h = this.chart, g = this.proxyProvider, E = h.options.accessibility;
          this.components = { container: new j(), infoRegions: new F(), legend: new N(), chartMenu: new f(), rangeSelector: new p(), series: new v(), zoom: new k(), navigator: new w() }, E.customComponents && d(this.components, E.customComponents);
          let R = this.components;
          this.getComponentOrder().forEach(function(L) {
            R[L].initBase(h, g), R[L].init();
          });
        }
        getComponentOrder() {
          return this.components ? this.components.series ? ["series"].concat(Object.keys(this.components).filter((h) => h !== "series")) : Object.keys(this.components) : [];
        }
        update() {
          let h = this.components, g = this.chart, E = g.options.accessibility;
          s(g, "beforeA11yUpdate"), g.types = this.getChartTypes();
          let R = E.keyboardNavigation.order;
          this.proxyProvider.updateGroupOrder(R), this.getComponentOrder().forEach(function(L) {
            h[L].onChartUpdate(), s(g, "afterA11yComponentUpdate", { name: L, component: h[L] });
          }), this.keyboardNavigation.update(R), !g.highContrastModeActive && E.highContrastMode !== !1 && (m.isHighContrastModeActive() || E.highContrastMode === !0) && m.setHighContrastTheme(g), s(g, "afterA11yUpdate", { accessibility: this });
        }
        destroy() {
          let h = this.chart || {}, g = this.components;
          Object.keys(g).forEach(function(E) {
            g[E].destroy(), g[E].destroyBase();
          }), this.proxyProvider && this.proxyProvider.destroy(), h.announcerContainer && b(h.announcerContainer), this.keyboardNavigation && this.keyboardNavigation.destroy(), h.renderTo && h.renderTo.setAttribute("aria-hidden", !0), h.focusElement && h.focusElement.removeFocusBorder();
        }
        getChartTypes() {
          let h = {};
          return this.chart.series.forEach(function(g) {
            h[g.type] = 1;
          }), Object.keys(h);
        }
      }
      return function(c) {
        function h() {
          this.accessibility && this.accessibility.destroy();
        }
        function g() {
          this.a11yDirty && this.renderTo && (delete this.a11yDirty, this.updateA11yEnabled());
          let U = this.accessibility;
          U && !U.zombie && (U.proxyProvider.updateProxyElementPositions(), U.getComponentOrder().forEach(function(V) {
            U.components[V].onChartRender();
          }));
        }
        function E(U) {
          let V = U.options.accessibility;
          V && (V.customComponents && (this.options.accessibility.customComponents = V.customComponents, delete V.customComponents), l(!0, this.options.accessibility, V), this.accessibility && this.accessibility.destroy && (this.accessibility.destroy(), delete this.accessibility)), this.a11yDirty = !0;
        }
        function R() {
          let U = this.accessibility, V = this.options.accessibility, q = this.renderer.boxWrapper.element, Y = this.title;
          if (V && V.enabled) U && !U.zombie ? U.update() : (this.accessibility = U = new c(this), U && !U.zombie && U.update(), q.getAttribute("role") === "img" && q.removeAttribute("role"));
          else if (U) U.destroy && U.destroy(), delete this.accessibility;
          else {
            this.renderTo.setAttribute("role", "img"), this.renderTo.setAttribute("aria-hidden", !1), this.renderTo.setAttribute("aria-label", (Y && Y.element.textContent || "").replace(/</g, "&lt;")), q.setAttribute("aria-hidden", !0);
            let I = document.getElementsByClassName("highcharts-description")[0];
            I && (I.setAttribute("aria-hidden", !1), I.classList.remove("highcharts-linked-description"));
          }
        }
        function L() {
          this.series.chart.accessibility && (this.series.chart.a11yDirty = !0);
        }
        c.i18nFormat = O.i18nFormat, c.compose = function(U, V, q, Y, I, _) {
          B.compose(U), x.compose(Y), N.compose(U, V), f.compose(U), v.compose(U, q, Y), O.compose(U), D.compose(U, I), _ && p.compose(U, _);
          let W = U.prototype;
          W.updateA11yEnabled || (W.updateA11yEnabled = R, S(U, "destroy", h), S(U, "render", g), S(U, "update", E), ["addSeries", "init"].forEach((X) => {
            S(U, X, function() {
              this.a11yDirty = !0;
            });
          }), ["afterApplyDrilldown", "drillupall"].forEach((X) => {
            S(U, X, function() {
              let z = this.accessibility;
              z && !z.zombie && z.update();
            });
          }), S(q, "update", L), ["update", "updatedData", "remove"].forEach((X) => {
            S(Y, X, function() {
              this.chart.accessibility && (this.chart.a11yDirty = !0);
            });
          }));
        };
      }(u || (u = {})), l(!0, P, C, { accessibility: { highContrastTheme: A }, lang: H }), u;
    }), a(e, "masters/modules/accessibility.src.js", [e["Core/Globals.js"], e["Accessibility/Accessibility.js"], e["Accessibility/AccessibilityComponent.js"], e["Accessibility/Utils/ChartUtilities.js"], e["Accessibility/Utils/HTMLUtilities.js"], e["Accessibility/KeyboardNavigationHandler.js"], e["Accessibility/Components/SeriesComponent/SeriesDescriber.js"]], function(o, n, r, T, O, j, D) {
      return o.i18nFormat = n.i18nFormat, o.A11yChartUtilities = T, o.A11yHTMLUtilities = O, o.AccessibilityComponent = r, o.KeyboardNavigationHandler = j, o.SeriesAccessibilityDescriber = D, n.compose(o.Chart, o.Legend, o.Point, o.Series, o.SVGElement, o.RangeSelector), o;
    });
  });
})(rm);
var lA = rm.exports;
const cA = /* @__PURE__ */ fi(lA);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const dA = { attribute: !0, type: String, converter: gl, reflect: !1, hasChanged: rc }, hA = (i = dA, t, e) => {
  const { kind: a, metadata: o } = e;
  let n = globalThis.litPropertyMetadata.get(o);
  if (n === void 0 && globalThis.litPropertyMetadata.set(o, n = /* @__PURE__ */ new Map()), n.set(e.name, i), a === "accessor") {
    const { name: r } = e;
    return { set(T) {
      const O = t.get.call(this);
      t.set.call(this, T), this.requestUpdate(r, O, i);
    }, init(T) {
      return T !== void 0 && this.P(r, void 0, i), T;
    } };
  }
  if (a === "setter") {
    const { name: r } = e;
    return function(T) {
      const O = this[r];
      t.call(this, T), this.requestUpdate(r, O, i);
    };
  }
  throw Error("Unsupported decorator location: " + a);
};
function ue(i) {
  return (t, e) => typeof e == "object" ? hA(i, t, e) : ((a, o, n) => {
    const r = o.hasOwnProperty(n);
    return o.constructor.createProperty(n, r ? { ...a, wrapped: !0 } : a), r ? Object.getOwnPropertyDescriptor(o, n) : void 0;
  })(i, t, e);
}
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function Se(i) {
  return ue({ ...i, state: !0, attribute: !1 });
}
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const lc = (i, t, e) => (e.configurable = !0, e.enumerable = !0, Reflect.decorate && typeof t != "object" && Object.defineProperty(i, t, e), e);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function Ge(i, t) {
  return (e, a, o) => {
    const n = (r) => {
      var T, O;
      return (O = (T = r.renderRoot) == null ? void 0 : T.querySelector(i)) != null ? O : null;
    };
    return lc(e, a, { get() {
      return n(this);
    } });
  };
}
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
let Kc;
function Ts(i) {
  return (t, e) => lc(t, e, { get() {
    var a;
    return ((a = this.renderRoot) != null ? a : Kc != null ? Kc : Kc = document.createDocumentFragment()).querySelectorAll(i);
  } });
}
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function wt(i) {
  return (t, e) => {
    const { slot: a, selector: o } = i != null ? i : {}, n = "slot" + (a ? `[name=${a}]` : ":not([name])");
    return lc(t, e, { get() {
      var O, j;
      const r = (O = this.renderRoot) == null ? void 0 : O.querySelector(n), T = (j = r == null ? void 0 : r.assignedElements(i)) != null ? j : [];
      return o === void 0 ? T : T.filter((D) => D.matches(o));
    } });
  };
}
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function Fo(i) {
  return (t, e) => {
    const { slot: a } = i != null ? i : {}, o = "slot" + (a ? `[name=${a}]` : ":not([name])");
    return lc(t, e, { get() {
      var r, T;
      const n = (r = this.renderRoot) == null ? void 0 : r.querySelector(o);
      return (T = n == null ? void 0 : n.assignedNodes(i)) != null ? T : [];
    } });
  };
}
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const ln = { ATTRIBUTE: 1, CHILD: 2, EVENT: 5, ELEMENT: 6 }, Oa = (i) => (...t) => ({ _$litDirective$: i, values: t });
let Pa = class {
  constructor(t) {
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  _$AT(t, e, a) {
    this._$Ct = t, this._$AM = e, this._$Ci = a;
  }
  _$AS(t, e) {
    return this.update(t, e);
  }
  update(t, e) {
    return this.render(...e);
  }
};
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const Oe = Oa(class extends Pa {
  constructor(i) {
    var t;
    if (super(i), i.type !== ln.ATTRIBUTE || i.name !== "class" || ((t = i.strings) == null ? void 0 : t.length) > 2) throw Error("`classMap()` can only be used in the `class` attribute and must be the only part in the attribute.");
  }
  render(i) {
    return " " + Object.keys(i).filter((t) => i[t]).join(" ") + " ";
  }
  update(i, [t]) {
    var a, o;
    if (this.st === void 0) {
      this.st = /* @__PURE__ */ new Set(), i.strings !== void 0 && (this.nt = new Set(i.strings.join(" ").split(/\s/).filter((n) => n !== "")));
      for (const n in t) t[n] && !((a = this.nt) != null && a.has(n)) && this.st.add(n);
      return this.render(t);
    }
    const e = i.element.classList;
    for (const n of this.st) n in t || (e.remove(n), this.st.delete(n));
    for (const n in t) {
      const r = !!t[n];
      r === this.st.has(n) || (o = this.nt) != null && o.has(n) || (r ? (e.add(n), this.st.add(n)) : (e.remove(n), this.st.delete(n)));
    }
    return Qo;
  }
});
var sm = typeof global == "object" && global && global.Object === Object && global, bA = typeof self == "object" && self && self.Object === Object && self, aa = sm || bA || Function("return this")(), hi = aa.Symbol, lm = Object.prototype, pA = lm.hasOwnProperty, uA = lm.toString, Mr = hi ? hi.toStringTag : void 0;
function gA(i) {
  var t = pA.call(i, Mr), e = i[Mr];
  try {
    i[Mr] = void 0;
    var a = !0;
  } catch {
  }
  var o = uA.call(i);
  return a && (t ? i[Mr] = e : delete i[Mr]), o;
}
var mA = Object.prototype, fA = mA.toString;
function vA(i) {
  return fA.call(i);
}
var AA = "[object Null]", yA = "[object Undefined]", dp = hi ? hi.toStringTag : void 0;
function cn(i) {
  return i == null ? i === void 0 ? yA : AA : dp && dp in Object(i) ? gA(i) : vA(i);
}
function bi(i) {
  return i != null && typeof i == "object";
}
var xA = "[object Symbol]";
function yh(i) {
  return typeof i == "symbol" || bi(i) && cn(i) == xA;
}
function cm(i, t) {
  for (var e = -1, a = i == null ? 0 : i.length, o = Array(a); ++e < a; )
    o[e] = t(i[e], e, i);
  return o;
}
var mo = Array.isArray, hp = hi ? hi.prototype : void 0, bp = hp ? hp.toString : void 0;
function dm(i) {
  if (typeof i == "string")
    return i;
  if (mo(i))
    return cm(i, dm) + "";
  if (yh(i))
    return bp ? bp.call(i) : "";
  var t = i + "";
  return t == "0" && 1 / i == -1 / 0 ? "-0" : t;
}
function Xo(i) {
  var t = typeof i;
  return i != null && (t == "object" || t == "function");
}
function xh(i) {
  return i;
}
var wA = "[object AsyncFunction]", kA = "[object Function]", CA = "[object GeneratorFunction]", SA = "[object Proxy]";
function wh(i) {
  if (!Xo(i))
    return !1;
  var t = cn(i);
  return t == kA || t == CA || t == wA || t == SA;
}
var Gc = aa["__core-js_shared__"], pp = function() {
  var i = /[^.]+$/.exec(Gc && Gc.keys && Gc.keys.IE_PROTO || "");
  return i ? "Symbol(src)_1." + i : "";
}();
function EA(i) {
  return !!pp && pp in i;
}
var TA = Function.prototype, MA = TA.toString;
function dn(i) {
  if (i != null) {
    try {
      return MA.call(i);
    } catch {
    }
    try {
      return i + "";
    } catch {
    }
  }
  return "";
}
var LA = /[\\^$.*+?()[\]{}|]/g, OA = /^\[object .+?Constructor\]$/, PA = Function.prototype, zA = Object.prototype, DA = PA.toString, IA = zA.hasOwnProperty, BA = RegExp(
  "^" + DA.call(IA).replace(LA, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function RA(i) {
  if (!Xo(i) || EA(i))
    return !1;
  var t = wh(i) ? BA : OA;
  return t.test(dn(i));
}
function NA(i, t) {
  return i == null ? void 0 : i[t];
}
function hn(i, t) {
  var e = NA(i, t);
  return RA(e) ? e : void 0;
}
var Id = hn(aa, "WeakMap"), up = Object.create, FA = /* @__PURE__ */ function() {
  function i() {
  }
  return function(t) {
    if (!Xo(t))
      return {};
    if (up)
      return up(t);
    i.prototype = t;
    var e = new i();
    return i.prototype = void 0, e;
  };
}();
function _A(i, t, e) {
  switch (e.length) {
    case 0:
      return i.call(t);
    case 1:
      return i.call(t, e[0]);
    case 2:
      return i.call(t, e[0], e[1]);
    case 3:
      return i.call(t, e[0], e[1], e[2]);
  }
  return i.apply(t, e);
}
function UA(i, t) {
  var e = -1, a = i.length;
  for (t || (t = Array(a)); ++e < a; )
    t[e] = i[e];
  return t;
}
var jA = 800, $A = 16, HA = Date.now;
function KA(i) {
  var t = 0, e = 0;
  return function() {
    var a = HA(), o = $A - (a - e);
    if (e = a, o > 0) {
      if (++t >= jA)
        return arguments[0];
    } else
      t = 0;
    return i.apply(void 0, arguments);
  };
}
function GA(i) {
  return function() {
    return i;
  };
}
var fl = function() {
  try {
    var i = hn(Object, "defineProperty");
    return i({}, "", {}), i;
  } catch {
  }
}(), WA = fl ? function(i, t) {
  return fl(i, "toString", {
    configurable: !0,
    enumerable: !1,
    value: GA(t),
    writable: !0
  });
} : xh, qA = KA(WA), VA = 9007199254740991, YA = /^(?:0|[1-9]\d*)$/;
function cc(i, t) {
  var e = typeof i;
  return t = t == null ? VA : t, !!t && (e == "number" || e != "symbol" && YA.test(i)) && i > -1 && i % 1 == 0 && i < t;
}
function kh(i, t, e) {
  t == "__proto__" && fl ? fl(i, t, {
    configurable: !0,
    enumerable: !0,
    value: e,
    writable: !0
  }) : i[t] = e;
}
function Ms(i, t) {
  return i === t || i !== i && t !== t;
}
var QA = Object.prototype, XA = QA.hasOwnProperty;
function hm(i, t, e) {
  var a = i[t];
  (!(XA.call(i, t) && Ms(a, e)) || e === void 0 && !(t in i)) && kh(i, t, e);
}
function ZA(i, t, e, a) {
  var o = !e;
  e || (e = {});
  for (var n = -1, r = t.length; ++n < r; ) {
    var T = t[n], O = void 0;
    O === void 0 && (O = i[T]), o ? kh(e, T, O) : hm(e, T, O);
  }
  return e;
}
var gp = Math.max;
function JA(i, t, e) {
  return t = gp(t === void 0 ? i.length - 1 : t, 0), function() {
    for (var a = arguments, o = -1, n = gp(a.length - t, 0), r = Array(n); ++o < n; )
      r[o] = a[t + o];
    o = -1;
    for (var T = Array(t + 1); ++o < t; )
      T[o] = a[o];
    return T[t] = e(r), _A(i, this, T);
  };
}
function ey(i, t) {
  return qA(JA(i, t, xh), i + "");
}
var ty = 9007199254740991;
function Ch(i) {
  return typeof i == "number" && i > -1 && i % 1 == 0 && i <= ty;
}
function dc(i) {
  return i != null && Ch(i.length) && !wh(i);
}
function oy(i, t, e) {
  if (!Xo(e))
    return !1;
  var a = typeof t;
  return (a == "number" ? dc(e) && cc(t, e.length) : a == "string" && t in e) ? Ms(e[t], i) : !1;
}
function ay(i) {
  return ey(function(t, e) {
    var a = -1, o = e.length, n = o > 1 ? e[o - 1] : void 0, r = o > 2 ? e[2] : void 0;
    for (n = i.length > 3 && typeof n == "function" ? (o--, n) : void 0, r && oy(e[0], e[1], r) && (n = o < 3 ? void 0 : n, o = 1), t = Object(t); ++a < o; ) {
      var T = e[a];
      T && i(t, T, a, n);
    }
    return t;
  });
}
var iy = Object.prototype;
function Sh(i) {
  var t = i && i.constructor, e = typeof t == "function" && t.prototype || iy;
  return i === e;
}
function ny(i, t) {
  for (var e = -1, a = Array(i); ++e < i; )
    a[e] = t(e);
  return a;
}
var ry = "[object Arguments]";
function mp(i) {
  return bi(i) && cn(i) == ry;
}
var bm = Object.prototype, sy = bm.hasOwnProperty, ly = bm.propertyIsEnumerable, vl = mp(/* @__PURE__ */ function() {
  return arguments;
}()) ? mp : function(i) {
  return bi(i) && sy.call(i, "callee") && !ly.call(i, "callee");
};
function cy() {
  return !1;
}
var pm = typeof exports == "object" && exports && !exports.nodeType && exports, fp = pm && typeof module == "object" && module && !module.nodeType && module, dy = fp && fp.exports === pm, vp = dy ? aa.Buffer : void 0, hy = vp ? vp.isBuffer : void 0, Al = hy || cy, by = "[object Arguments]", py = "[object Array]", uy = "[object Boolean]", gy = "[object Date]", my = "[object Error]", fy = "[object Function]", vy = "[object Map]", Ay = "[object Number]", yy = "[object Object]", xy = "[object RegExp]", wy = "[object Set]", ky = "[object String]", Cy = "[object WeakMap]", Sy = "[object ArrayBuffer]", Ey = "[object DataView]", Ty = "[object Float32Array]", My = "[object Float64Array]", Ly = "[object Int8Array]", Oy = "[object Int16Array]", Py = "[object Int32Array]", zy = "[object Uint8Array]", Dy = "[object Uint8ClampedArray]", Iy = "[object Uint16Array]", By = "[object Uint32Array]", at = {};
at[Ty] = at[My] = at[Ly] = at[Oy] = at[Py] = at[zy] = at[Dy] = at[Iy] = at[By] = !0;
at[by] = at[py] = at[Sy] = at[uy] = at[Ey] = at[gy] = at[my] = at[fy] = at[vy] = at[Ay] = at[yy] = at[xy] = at[wy] = at[ky] = at[Cy] = !1;
function Ry(i) {
  return bi(i) && Ch(i.length) && !!at[cn(i)];
}
function Ny(i) {
  return function(t) {
    return i(t);
  };
}
var um = typeof exports == "object" && exports && !exports.nodeType && exports, Kr = um && typeof module == "object" && module && !module.nodeType && module, Fy = Kr && Kr.exports === um, Wc = Fy && sm.process, Ap = function() {
  try {
    var i = Kr && Kr.require && Kr.require("util").types;
    return i || Wc && Wc.binding && Wc.binding("util");
  } catch {
  }
}(), yp = Ap && Ap.isTypedArray, Eh = yp ? Ny(yp) : Ry, _y = Object.prototype, Uy = _y.hasOwnProperty;
function gm(i, t) {
  var e = mo(i), a = !e && vl(i), o = !e && !a && Al(i), n = !e && !a && !o && Eh(i), r = e || a || o || n, T = r ? ny(i.length, String) : [], O = T.length;
  for (var j in i)
    (t || Uy.call(i, j)) && !(r && // Safari 9 has enumerable `arguments.length` in strict mode.
    (j == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    o && (j == "offset" || j == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    n && (j == "buffer" || j == "byteLength" || j == "byteOffset") || // Skip index properties.
    cc(j, O))) && T.push(j);
  return T;
}
function mm(i, t) {
  return function(e) {
    return i(t(e));
  };
}
var jy = mm(Object.keys, Object), $y = Object.prototype, Hy = $y.hasOwnProperty;
function Ky(i) {
  if (!Sh(i))
    return jy(i);
  var t = [];
  for (var e in Object(i))
    Hy.call(i, e) && e != "constructor" && t.push(e);
  return t;
}
function fm(i) {
  return dc(i) ? gm(i) : Ky(i);
}
function Gy(i) {
  var t = [];
  if (i != null)
    for (var e in Object(i))
      t.push(e);
  return t;
}
var Wy = Object.prototype, qy = Wy.hasOwnProperty;
function Vy(i) {
  if (!Xo(i))
    return Gy(i);
  var t = Sh(i), e = [];
  for (var a in i)
    a == "constructor" && (t || !qy.call(i, a)) || e.push(a);
  return e;
}
function Th(i) {
  return dc(i) ? gm(i, !0) : Vy(i);
}
var Yy = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Qy = /^\w*$/;
function Mh(i, t) {
  if (mo(i))
    return !1;
  var e = typeof i;
  return e == "number" || e == "symbol" || e == "boolean" || i == null || yh(i) ? !0 : Qy.test(i) || !Yy.test(i) || t != null && i in Object(t);
}
var Jr = hn(Object, "create");
function Xy() {
  this.__data__ = Jr ? Jr(null) : {}, this.size = 0;
}
function Zy(i) {
  var t = this.has(i) && delete this.__data__[i];
  return this.size -= t ? 1 : 0, t;
}
var Jy = "__lodash_hash_undefined__", ex = Object.prototype, tx = ex.hasOwnProperty;
function ox(i) {
  var t = this.__data__;
  if (Jr) {
    var e = t[i];
    return e === Jy ? void 0 : e;
  }
  return tx.call(t, i) ? t[i] : void 0;
}
var ax = Object.prototype, ix = ax.hasOwnProperty;
function nx(i) {
  var t = this.__data__;
  return Jr ? t[i] !== void 0 : ix.call(t, i);
}
var rx = "__lodash_hash_undefined__";
function sx(i, t) {
  var e = this.__data__;
  return this.size += this.has(i) ? 0 : 1, e[i] = Jr && t === void 0 ? rx : t, this;
}
function en(i) {
  var t = -1, e = i == null ? 0 : i.length;
  for (this.clear(); ++t < e; ) {
    var a = i[t];
    this.set(a[0], a[1]);
  }
}
en.prototype.clear = Xy;
en.prototype.delete = Zy;
en.prototype.get = ox;
en.prototype.has = nx;
en.prototype.set = sx;
function lx() {
  this.__data__ = [], this.size = 0;
}
function hc(i, t) {
  for (var e = i.length; e--; )
    if (Ms(i[e][0], t))
      return e;
  return -1;
}
var cx = Array.prototype, dx = cx.splice;
function hx(i) {
  var t = this.__data__, e = hc(t, i);
  if (e < 0)
    return !1;
  var a = t.length - 1;
  return e == a ? t.pop() : dx.call(t, e, 1), --this.size, !0;
}
function bx(i) {
  var t = this.__data__, e = hc(t, i);
  return e < 0 ? void 0 : t[e][1];
}
function px(i) {
  return hc(this.__data__, i) > -1;
}
function ux(i, t) {
  var e = this.__data__, a = hc(e, i);
  return a < 0 ? (++this.size, e.push([i, t])) : e[a][1] = t, this;
}
function za(i) {
  var t = -1, e = i == null ? 0 : i.length;
  for (this.clear(); ++t < e; ) {
    var a = i[t];
    this.set(a[0], a[1]);
  }
}
za.prototype.clear = lx;
za.prototype.delete = hx;
za.prototype.get = bx;
za.prototype.has = px;
za.prototype.set = ux;
var es = hn(aa, "Map");
function gx() {
  this.size = 0, this.__data__ = {
    hash: new en(),
    map: new (es || za)(),
    string: new en()
  };
}
function mx(i) {
  var t = typeof i;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? i !== "__proto__" : i === null;
}
function bc(i, t) {
  var e = i.__data__;
  return mx(t) ? e[typeof t == "string" ? "string" : "hash"] : e.map;
}
function fx(i) {
  var t = bc(this, i).delete(i);
  return this.size -= t ? 1 : 0, t;
}
function vx(i) {
  return bc(this, i).get(i);
}
function Ax(i) {
  return bc(this, i).has(i);
}
function yx(i, t) {
  var e = bc(this, i), a = e.size;
  return e.set(i, t), this.size += e.size == a ? 0 : 1, this;
}
function Da(i) {
  var t = -1, e = i == null ? 0 : i.length;
  for (this.clear(); ++t < e; ) {
    var a = i[t];
    this.set(a[0], a[1]);
  }
}
Da.prototype.clear = gx;
Da.prototype.delete = fx;
Da.prototype.get = vx;
Da.prototype.has = Ax;
Da.prototype.set = yx;
var xx = "Expected a function";
function Lh(i, t) {
  if (typeof i != "function" || t != null && typeof t != "function")
    throw new TypeError(xx);
  var e = function() {
    var a = arguments, o = t ? t.apply(this, a) : a[0], n = e.cache;
    if (n.has(o))
      return n.get(o);
    var r = i.apply(this, a);
    return e.cache = n.set(o, r) || n, r;
  };
  return e.cache = new (Lh.Cache || Da)(), e;
}
Lh.Cache = Da;
var wx = 500;
function kx(i) {
  var t = Lh(i, function(a) {
    return e.size === wx && e.clear(), a;
  }), e = t.cache;
  return t;
}
var Cx = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Sx = /\\(\\)?/g, Ex = kx(function(i) {
  var t = [];
  return i.charCodeAt(0) === 46 && t.push(""), i.replace(Cx, function(e, a, o, n) {
    t.push(o ? n.replace(Sx, "$1") : a || e);
  }), t;
});
function Tx(i) {
  return i == null ? "" : dm(i);
}
function pc(i, t) {
  return mo(i) ? i : Mh(i, t) ? [i] : Ex(Tx(i));
}
function Ls(i) {
  if (typeof i == "string" || yh(i))
    return i;
  var t = i + "";
  return t == "0" && 1 / i == -1 / 0 ? "-0" : t;
}
function Oh(i, t) {
  t = pc(t, i);
  for (var e = 0, a = t.length; i != null && e < a; )
    i = i[Ls(t[e++])];
  return e && e == a ? i : void 0;
}
function Mx(i, t, e) {
  var a = i == null ? void 0 : Oh(i, t);
  return a === void 0 ? e : a;
}
function vm(i, t) {
  for (var e = -1, a = t.length, o = i.length; ++e < a; )
    i[o + e] = t[e];
  return i;
}
var Ph = mm(Object.getPrototypeOf, Object), Lx = "[object Object]", Ox = Function.prototype, Px = Object.prototype, Am = Ox.toString, zx = Px.hasOwnProperty, Dx = Am.call(Object);
function Ix(i) {
  if (!bi(i) || cn(i) != Lx)
    return !1;
  var t = Ph(i);
  if (t === null)
    return !0;
  var e = zx.call(t, "constructor") && t.constructor;
  return typeof e == "function" && e instanceof e && Am.call(e) == Dx;
}
function Bx() {
  this.__data__ = new za(), this.size = 0;
}
function Rx(i) {
  var t = this.__data__, e = t.delete(i);
  return this.size = t.size, e;
}
function Nx(i) {
  return this.__data__.get(i);
}
function Fx(i) {
  return this.__data__.has(i);
}
var _x = 200;
function Ux(i, t) {
  var e = this.__data__;
  if (e instanceof za) {
    var a = e.__data__;
    if (!es || a.length < _x - 1)
      return a.push([i, t]), this.size = ++e.size, this;
    e = this.__data__ = new Da(a);
  }
  return e.set(i, t), this.size = e.size, this;
}
function qo(i) {
  var t = this.__data__ = new za(i);
  this.size = t.size;
}
qo.prototype.clear = Bx;
qo.prototype.delete = Rx;
qo.prototype.get = Nx;
qo.prototype.has = Fx;
qo.prototype.set = Ux;
var ym = typeof exports == "object" && exports && !exports.nodeType && exports, xp = ym && typeof module == "object" && module && !module.nodeType && module, jx = xp && xp.exports === ym, wp = jx ? aa.Buffer : void 0;
wp && wp.allocUnsafe;
function $x(i, t) {
  return i.slice();
}
function Hx(i, t) {
  for (var e = -1, a = i == null ? 0 : i.length, o = 0, n = []; ++e < a; ) {
    var r = i[e];
    t(r, e, i) && (n[o++] = r);
  }
  return n;
}
function xm() {
  return [];
}
var Kx = Object.prototype, Gx = Kx.propertyIsEnumerable, kp = Object.getOwnPropertySymbols, wm = kp ? function(i) {
  return i == null ? [] : (i = Object(i), Hx(kp(i), function(t) {
    return Gx.call(i, t);
  }));
} : xm, Wx = Object.getOwnPropertySymbols, qx = Wx ? function(i) {
  for (var t = []; i; )
    vm(t, wm(i)), i = Ph(i);
  return t;
} : xm;
function km(i, t, e) {
  var a = t(i);
  return mo(i) ? a : vm(a, e(i));
}
function Cp(i) {
  return km(i, fm, wm);
}
function Vx(i) {
  return km(i, Th, qx);
}
var Bd = hn(aa, "DataView"), Rd = hn(aa, "Promise"), Nd = hn(aa, "Set"), Sp = "[object Map]", Yx = "[object Object]", Ep = "[object Promise]", Tp = "[object Set]", Mp = "[object WeakMap]", Lp = "[object DataView]", Qx = dn(Bd), Xx = dn(es), Zx = dn(Rd), Jx = dn(Nd), e0 = dn(Id), qa = cn;
(Bd && qa(new Bd(new ArrayBuffer(1))) != Lp || es && qa(new es()) != Sp || Rd && qa(Rd.resolve()) != Ep || Nd && qa(new Nd()) != Tp || Id && qa(new Id()) != Mp) && (qa = function(i) {
  var t = cn(i), e = t == Yx ? i.constructor : void 0, a = e ? dn(e) : "";
  if (a)
    switch (a) {
      case Qx:
        return Lp;
      case Xx:
        return Sp;
      case Zx:
        return Ep;
      case Jx:
        return Tp;
      case e0:
        return Mp;
    }
  return t;
});
var yl = aa.Uint8Array;
function t0(i) {
  var t = new i.constructor(i.byteLength);
  return new yl(t).set(new yl(i)), t;
}
function o0(i, t) {
  var e = t0(i.buffer);
  return new i.constructor(e, i.byteOffset, i.length);
}
function a0(i) {
  return typeof i.constructor == "function" && !Sh(i) ? FA(Ph(i)) : {};
}
var i0 = "__lodash_hash_undefined__";
function n0(i) {
  return this.__data__.set(i, i0), this;
}
function r0(i) {
  return this.__data__.has(i);
}
function xl(i) {
  var t = -1, e = i == null ? 0 : i.length;
  for (this.__data__ = new Da(); ++t < e; )
    this.add(i[t]);
}
xl.prototype.add = xl.prototype.push = n0;
xl.prototype.has = r0;
function s0(i, t) {
  for (var e = -1, a = i == null ? 0 : i.length; ++e < a; )
    if (t(i[e], e, i))
      return !0;
  return !1;
}
function l0(i, t) {
  return i.has(t);
}
var c0 = 1, d0 = 2;
function Cm(i, t, e, a, o, n) {
  var r = e & c0, T = i.length, O = t.length;
  if (T != O && !(r && O > T))
    return !1;
  var j = n.get(i), D = n.get(t);
  if (j && D)
    return j == t && D == i;
  var F = -1, B = !0, N = e & d0 ? new xl() : void 0;
  for (n.set(i, t), n.set(t, i); ++F < T; ) {
    var f = i[F], w = t[F];
    if (a)
      var x = r ? a(w, f, F, t, i, n) : a(f, w, F, i, t, n);
    if (x !== void 0) {
      if (x)
        continue;
      B = !1;
      break;
    }
    if (N) {
      if (!s0(t, function(M, p) {
        if (!l0(N, p) && (f === M || o(f, M, e, a, n)))
          return N.push(p);
      })) {
        B = !1;
        break;
      }
    } else if (!(f === w || o(f, w, e, a, n))) {
      B = !1;
      break;
    }
  }
  return n.delete(i), n.delete(t), B;
}
function h0(i) {
  var t = -1, e = Array(i.size);
  return i.forEach(function(a, o) {
    e[++t] = [o, a];
  }), e;
}
function b0(i) {
  var t = -1, e = Array(i.size);
  return i.forEach(function(a) {
    e[++t] = a;
  }), e;
}
var p0 = 1, u0 = 2, g0 = "[object Boolean]", m0 = "[object Date]", f0 = "[object Error]", v0 = "[object Map]", A0 = "[object Number]", y0 = "[object RegExp]", x0 = "[object Set]", w0 = "[object String]", k0 = "[object Symbol]", C0 = "[object ArrayBuffer]", S0 = "[object DataView]", Op = hi ? hi.prototype : void 0, qc = Op ? Op.valueOf : void 0;
function E0(i, t, e, a, o, n, r) {
  switch (e) {
    case S0:
      if (i.byteLength != t.byteLength || i.byteOffset != t.byteOffset)
        return !1;
      i = i.buffer, t = t.buffer;
    case C0:
      return !(i.byteLength != t.byteLength || !n(new yl(i), new yl(t)));
    case g0:
    case m0:
    case A0:
      return Ms(+i, +t);
    case f0:
      return i.name == t.name && i.message == t.message;
    case y0:
    case w0:
      return i == t + "";
    case v0:
      var T = h0;
    case x0:
      var O = a & p0;
      if (T || (T = b0), i.size != t.size && !O)
        return !1;
      var j = r.get(i);
      if (j)
        return j == t;
      a |= u0, r.set(i, t);
      var D = Cm(T(i), T(t), a, o, n, r);
      return r.delete(i), D;
    case k0:
      if (qc)
        return qc.call(i) == qc.call(t);
  }
  return !1;
}
var T0 = 1, M0 = Object.prototype, L0 = M0.hasOwnProperty;
function O0(i, t, e, a, o, n) {
  var r = e & T0, T = Cp(i), O = T.length, j = Cp(t), D = j.length;
  if (O != D && !r)
    return !1;
  for (var F = O; F--; ) {
    var B = T[F];
    if (!(r ? B in t : L0.call(t, B)))
      return !1;
  }
  var N = n.get(i), f = n.get(t);
  if (N && f)
    return N == t && f == i;
  var w = !0;
  n.set(i, t), n.set(t, i);
  for (var x = r; ++F < O; ) {
    B = T[F];
    var M = i[B], p = t[B];
    if (a)
      var v = r ? a(p, M, B, t, i, n) : a(M, p, B, i, t, n);
    if (!(v === void 0 ? M === p || o(M, p, e, a, n) : v)) {
      w = !1;
      break;
    }
    x || (x = B == "constructor");
  }
  if (w && !x) {
    var k = i.constructor, m = t.constructor;
    k != m && "constructor" in i && "constructor" in t && !(typeof k == "function" && k instanceof k && typeof m == "function" && m instanceof m) && (w = !1);
  }
  return n.delete(i), n.delete(t), w;
}
var P0 = 1, Pp = "[object Arguments]", zp = "[object Array]", Ws = "[object Object]", z0 = Object.prototype, Dp = z0.hasOwnProperty;
function D0(i, t, e, a, o, n) {
  var r = mo(i), T = mo(t), O = r ? zp : qa(i), j = T ? zp : qa(t);
  O = O == Pp ? Ws : O, j = j == Pp ? Ws : j;
  var D = O == Ws, F = j == Ws, B = O == j;
  if (B && Al(i)) {
    if (!Al(t))
      return !1;
    r = !0, D = !1;
  }
  if (B && !D)
    return n || (n = new qo()), r || Eh(i) ? Cm(i, t, e, a, o, n) : E0(i, t, O, e, a, o, n);
  if (!(e & P0)) {
    var N = D && Dp.call(i, "__wrapped__"), f = F && Dp.call(t, "__wrapped__");
    if (N || f) {
      var w = N ? i.value() : i, x = f ? t.value() : t;
      return n || (n = new qo()), o(w, x, e, a, n);
    }
  }
  return B ? (n || (n = new qo()), O0(i, t, e, a, o, n)) : !1;
}
function zh(i, t, e, a, o) {
  return i === t ? !0 : i == null || t == null || !bi(i) && !bi(t) ? i !== i && t !== t : D0(i, t, e, a, zh, o);
}
var I0 = 1, B0 = 2;
function R0(i, t, e, a) {
  var o = e.length, n = o;
  if (i == null)
    return !n;
  for (i = Object(i); o--; ) {
    var r = e[o];
    if (r[2] ? r[1] !== i[r[0]] : !(r[0] in i))
      return !1;
  }
  for (; ++o < n; ) {
    r = e[o];
    var T = r[0], O = i[T], j = r[1];
    if (r[2]) {
      if (O === void 0 && !(T in i))
        return !1;
    } else {
      var D = new qo(), F;
      if (!(F === void 0 ? zh(j, O, I0 | B0, a, D) : F))
        return !1;
    }
  }
  return !0;
}
function Sm(i) {
  return i === i && !Xo(i);
}
function N0(i) {
  for (var t = fm(i), e = t.length; e--; ) {
    var a = t[e], o = i[a];
    t[e] = [a, o, Sm(o)];
  }
  return t;
}
function Em(i, t) {
  return function(e) {
    return e == null ? !1 : e[i] === t && (t !== void 0 || i in Object(e));
  };
}
function F0(i) {
  var t = N0(i);
  return t.length == 1 && t[0][2] ? Em(t[0][0], t[0][1]) : function(e) {
    return e === i || R0(e, i, t);
  };
}
function _0(i, t) {
  return i != null && t in Object(i);
}
function U0(i, t, e) {
  t = pc(t, i);
  for (var a = -1, o = t.length, n = !1; ++a < o; ) {
    var r = Ls(t[a]);
    if (!(n = i != null && e(i, r)))
      break;
    i = i[r];
  }
  return n || ++a != o ? n : (o = i == null ? 0 : i.length, !!o && Ch(o) && cc(r, o) && (mo(i) || vl(i)));
}
function j0(i, t) {
  return i != null && U0(i, t, _0);
}
var $0 = 1, H0 = 2;
function K0(i, t) {
  return Mh(i) && Sm(t) ? Em(Ls(i), t) : function(e) {
    var a = Mx(e, i);
    return a === void 0 && a === t ? j0(e, i) : zh(t, a, $0 | H0);
  };
}
function G0(i) {
  return function(t) {
    return t == null ? void 0 : t[i];
  };
}
function W0(i) {
  return function(t) {
    return Oh(t, i);
  };
}
function q0(i) {
  return Mh(i) ? G0(Ls(i)) : W0(i);
}
function V0(i) {
  return typeof i == "function" ? i : i == null ? xh : typeof i == "object" ? mo(i) ? K0(i[0], i[1]) : F0(i) : q0(i);
}
function Y0(i) {
  return function(t, e, a) {
    for (var o = -1, n = Object(t), r = a(t), T = r.length; T--; ) {
      var O = r[++o];
      if (e(n[O], O, n) === !1)
        break;
    }
    return t;
  };
}
var Q0 = Y0();
function Fd(i, t, e) {
  (e !== void 0 && !Ms(i[t], e) || e === void 0 && !(t in i)) && kh(i, t, e);
}
function X0(i) {
  return bi(i) && dc(i);
}
function _d(i, t) {
  if (!(t === "constructor" && typeof i[t] == "function") && t != "__proto__")
    return i[t];
}
function Z0(i) {
  return ZA(i, Th(i));
}
function J0(i, t, e, a, o, n, r) {
  var T = _d(i, e), O = _d(t, e), j = r.get(O);
  if (j) {
    Fd(i, e, j);
    return;
  }
  var D = n ? n(T, O, e + "", i, t, r) : void 0, F = D === void 0;
  if (F) {
    var B = mo(O), N = !B && Al(O), f = !B && !N && Eh(O);
    D = O, B || N || f ? mo(T) ? D = T : X0(T) ? D = UA(T) : N ? (F = !1, D = $x(O)) : f ? (F = !1, D = o0(O)) : D = [] : Ix(O) || vl(O) ? (D = T, vl(T) ? D = Z0(T) : (!Xo(T) || wh(T)) && (D = a0(O))) : F = !1;
  }
  F && (r.set(O, D), o(D, O, a, n, r), r.delete(O)), Fd(i, e, D);
}
function Tm(i, t, e, a, o) {
  i !== t && Q0(t, function(n, r) {
    if (o || (o = new qo()), Xo(n))
      J0(i, t, r, e, Tm, a, o);
    else {
      var T = a ? a(_d(i, r), n, r + "", i, t, o) : void 0;
      T === void 0 && (T = n), Fd(i, r, T);
    }
  }, Th);
}
var e1 = ay(function(i, t, e, a) {
  Tm(i, t, e, a);
});
function t1(i, t, e, a) {
  if (!Xo(i))
    return i;
  t = pc(t, i);
  for (var o = -1, n = t.length, r = n - 1, T = i; T != null && ++o < n; ) {
    var O = Ls(t[o]), j = e;
    if (O === "__proto__" || O === "constructor" || O === "prototype")
      return i;
    if (o != r) {
      var D = T[O];
      j = void 0, j === void 0 && (j = Xo(D) ? D : cc(t[o + 1]) ? [] : {});
    }
    hm(T, O, j), T = T[O];
  }
  return i;
}
function o1(i, t, e) {
  for (var a = -1, o = t.length, n = {}; ++a < o; ) {
    var r = t[a], T = Oh(i, r);
    e(T, r) && t1(n, pc(r, i), T);
  }
  return n;
}
function a1(i, t) {
  if (i == null)
    return {};
  var e = cm(Vx(i), function(a) {
    return [a];
  });
  return t = V0(t), o1(i, e, function(a, o) {
    return t(a, o[0]);
  });
}
var Ja = /* @__PURE__ */ ((i) => (i.CIRCLE = "circle", i.TRIANGLE = "triangle", i.SQUARE = "square", i.DIAMOND = "diamond", i.TRIANGLE_DOWN = "triangle-down", i))(Ja || {}), Ir = /* @__PURE__ */ ((i) => (i.SINGLE_LINE = "single-line", i.MULTI_LINE = "multi-line", i.MULTI_LEVEL = "multi-level", i))(Ir || {}), Jt = /* @__PURE__ */ ((i) => (i.LINE = "line", i.BAR = "bar", i.COLUMN = "column", i.SCATTER = "scatter", i.PIE = "pie", i.GAUGE = "gauge", i.AREA = "area", i))(Jt || {}), Gr = /* @__PURE__ */ ((i) => (i.HORIZONTAL = "horizontal", i.VERTICAL = "vertical", i))(Gr || {}), wl = /* @__PURE__ */ ((i) => (i[i.HEIGHT = 480] = "HEIGHT", i))(wl || {}), ba = /* @__PURE__ */ ((i) => (i.STANDARD = "standard-set", i.EXTENDED = "extended-set", i))(ba || {});
function qe(i, t, e) {
  const a = i.prerender;
  i.prerender = function(...o) {
    e.value.apply(this, o), a.apply(this, o);
  };
}
function De(i, t, e) {
  const a = i.postrender;
  i.postrender = function(...o) {
    e.value.apply(this, o), a.apply(this, o);
  };
}
function Lt(i, t, e) {
  const a = i.destroy;
  i.destroy = function(...o) {
    e.value.apply(this, o), a.apply(this, o);
  };
}
const je = (i) => (t) => {
  t.mixins && Array.isArray(t.mixins) && (t.mixins = [...t.mixins, i]);
};
function yo(i, t) {
  const e = {
    waitUntilFirstUpdate: !1,
    ...t
  };
  return (a, o) => {
    const { update: n } = a, r = Array.isArray(i) ? i : [i];
    a.update = function(T) {
      r.forEach((O) => {
        const j = O;
        if (T.has(j)) {
          const D = T.get(j), F = this[j];
          D !== F && (!e.waitUntilFirstUpdate || this.hasUpdated) && this[o](
            D,
            F
          );
        }
      }), n.call(this, T);
    };
  };
}
const uc = ({
  finisher: i,
  descriptor: t
}) => (e, a) => {
  var o;
  if (a !== void 0) {
    const n = e.constructor;
    t !== void 0 && Object.defineProperty(e, a, t(a)), i == null || i(n, a);
  } else {
    const n = (o = e.originalKey) != null ? o : e.key, r = t !== void 0 ? {
      kind: "method",
      placement: "prototype",
      key: n,
      descriptor: t(e.key)
    } : { ...e, key: n };
    return i && (r.finisher = function(T) {
      i(T, n);
    }), r;
  }
};
function ts(i, t, e = {}, a = !1) {
  var r;
  const o = `slot${t ? `[name=${t}]` : ":not([name])"}`, n = (r = i.renderRoot) == null ? void 0 : r.querySelector(o);
  return n ? a ? n.assignedNodes(e).filter((T) => T.nodeType !== Node.COMMENT_NODE) : n.assignedElements(e) : [];
}
function Mm(i) {
  return typeof i == "string" ? { version: i } : i.alternateSlot !== void 0 && i.alternateSlot !== null ? {
    alternateSlot: i.alternateSlot,
    version: i.version
  } : {
    alternateAttribute: i.alternateAttribute,
    version: i.version
  };
}
function Pe(i, t = !1) {
  const { slot: e, selector: a, deprecated: o, flatten: n } = i != null ? i : {};
  let r;
  return o && (r = Mm(o)), uc({
    descriptor: (T) => ({
      get() {
        let O = ts(this, e, { flatten: n });
        return O.length === 0 && o && r && r.alternateSlot && (O = ts(this, r.alternateSlot, {
          flatten: n
        })), a ? O == null ? void 0 : O.filter((j) => {
          var D;
          return t ? ((D = j == null ? void 0 : j.nodeName) == null ? void 0 : D.toLowerCase()) === this.getScopedTagName(a) : j.matches(a);
        }) : O;
      },
      set() {
        if (o) {
          const O = e != null ? e : "";
          this.alternateSlots.set(O, r);
        }
      },
      enumerable: !0,
      configurable: !0
    })
  });
}
function et(i) {
  return function(t, e) {
    return Ge(i)(t, e);
  };
}
function bn(i, t) {
  return uc({
    descriptor: (e) => ({
      get() {
        var o;
        return (o = this.querySelector(i)) != null ? o : null;
      },
      enumerable: !0,
      configurable: !0
    })
  });
}
function i1({ slot: i, defaultValue: t }) {
  return uc({
    descriptor: (e) => ({
      get() {
        var n, r, T;
        const o = ts(this, i)[0];
        return (T = (r = (n = o == null ? void 0 : o.textContent) == null ? void 0 : n.trim()) != null ? r : t) != null ? T : "";
      },
      enumerable: !0,
      configurable: !0
    })
  });
}
function n1(i) {
  return function(t, e) {
    return Ts(i)(t, e);
  };
}
function gc(i) {
  const { slot: t, deprecated: e, flatten: a } = i != null ? i : {};
  let o;
  return e && (o = Mm(e)), uc({
    descriptor: (n) => ({
      get() {
        let r = ts(this, t, { flatten: a }, !0);
        return r.length === 0 && e && o && o.alternateSlot && (r = ts(
          this,
          o.alternateSlot,
          { flatten: a },
          !0
        )), r;
      },
      set() {
        if (e) {
          const r = t != null ? t : "";
          this.alternateSlots.set(r, o);
        }
      },
      enumerable: !0,
      configurable: !0
    })
  });
}
function Ia() {
  return `${Math.floor(Math.random() * 1e10)}`.padStart(4, "0");
}
const Mo = class Mo extends Pa {
  constructor() {
    super(...arguments), this.uuid = Ia(), this.slotHasEvent = !1, this.usingParentElement = !1, this.containerSelector = "", this.totalSlottedElements = 0, this.handleSlotchange = (t) => {
      if (t.eventPhase !== 2)
        return;
      const e = t.target, a = e == null ? void 0 : e.assignedElements();
      let o;
      this.totalSlottedElements = a.length, this.containerSelector ? o = this.findContainerElement(e) : o = this.usingParentElement ? e.parentElement : e, this.totalSlottedElements < 1 ? (o == null || o.classList.add(Mo.defaultClassName), o == null || o.classList.remove(this.hasSlottedClassName)) : (o == null || o.classList.remove(Mo.defaultClassName), o == null || o.classList.add(this.hasSlottedClassName));
    };
  }
  get hasSlottedClassName() {
    return `has-slotted-${this.uuid}`;
  }
  findContainerElement(t) {
    if (this.containerSelector)
      return t.closest(this.containerSelector);
  }
  /** Create and append a small set of styles when the directive is used. */
  static createStyleElement(t) {
    const e = document.createElement("style");
    e.innerHTML = `.${Mo.defaultClassName}:not([class*='has-slotted-']) {display: none !important;}`, e.id = Mo.stylesID, t.appendChild(e);
  }
  update(t, [e = { useParent: !1 }]) {
    const { useParent: a, container: o } = e, n = t.element, r = n.getRootNode(), { parentElement: T } = n;
    a && (this.usingParentElement = !0), o && (this.containerSelector = o);
    const O = {};
    return this.containerSelector ? O.element = this.findContainerElement(n) : a && T ? O.element = T : O.element = n, r.querySelector(`#${Mo.stylesID}`) || Mo.createStyleElement(r), this.slotHasEvent || (n.addEventListener("slotchange", this.handleSlotchange), this.slotHasEvent = !0), this.render(O);
  }
  /**
   * The directive takes a single object parameter. If your slot has a parent that dictates styling, then set `useParent` to true. The element to be updated will be handled automatically as either the parent element or the slot directly, but if you have a case where the element you need to hide is higher up, you can pass an HTML element reference into the object.
   *
   * ```ts
   * html`<div class="slot-wrapper">
   *    <slot ${showIfUsed({useParent: true})}></slot>
   * </div>`
   *
   * html`<slot ${showIfUsed()}></slot>`
   * ```
   */
  render({ element: t } = { useParent: !1 }) {
    t && this.totalSlottedElements < 1 && (t.classList.add(Mo.defaultClassName), t.classList.remove(this.hasSlottedClassName)), t && this.totalSlottedElements >= 1 && t.classList.add(this.hasSlottedClassName);
  }
};
Mo.defaultClassName = "hide-slot-area", Mo.stylesID = "show-if-used-directive-styles";
let Ud = Mo;
const Ue = Oa(Ud), Ip = " ";
function Lm(i, t = Ip) {
  return typeof t != "string" && (t = Ip), i == null ? void 0 : i.split(t).map((e) => e.trim());
}
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function* Vo(i, t) {
  if (i !== void 0) {
    let e = 0;
    for (const a of i) yield t(a, e++);
  }
}
(function() {
  (function(i) {
    const t = /* @__PURE__ */ new WeakMap(), e = /* @__PURE__ */ new WeakMap(), a = /* @__PURE__ */ new WeakMap(), o = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakMap(), T = /* @__PURE__ */ new WeakMap(), O = /* @__PURE__ */ new WeakMap(), j = /* @__PURE__ */ new WeakMap(), D = /* @__PURE__ */ new WeakMap(), F = /* @__PURE__ */ new WeakMap(), B = /* @__PURE__ */ new WeakMap(), N = /* @__PURE__ */ new WeakMap(), f = /* @__PURE__ */ new WeakMap(), w = /* @__PURE__ */ new WeakMap(), x = {
      ariaAtomic: "aria-atomic",
      ariaAutoComplete: "aria-autocomplete",
      ariaBusy: "aria-busy",
      ariaChecked: "aria-checked",
      ariaColCount: "aria-colcount",
      ariaColIndex: "aria-colindex",
      ariaColIndexText: "aria-colindextext",
      ariaColSpan: "aria-colspan",
      ariaCurrent: "aria-current",
      ariaDescription: "aria-description",
      ariaDisabled: "aria-disabled",
      ariaExpanded: "aria-expanded",
      ariaHasPopup: "aria-haspopup",
      ariaHidden: "aria-hidden",
      ariaInvalid: "aria-invalid",
      ariaKeyShortcuts: "aria-keyshortcuts",
      ariaLabel: "aria-label",
      ariaLevel: "aria-level",
      ariaLive: "aria-live",
      ariaModal: "aria-modal",
      ariaMultiLine: "aria-multiline",
      ariaMultiSelectable: "aria-multiselectable",
      ariaOrientation: "aria-orientation",
      ariaPlaceholder: "aria-placeholder",
      ariaPosInSet: "aria-posinset",
      ariaPressed: "aria-pressed",
      ariaReadOnly: "aria-readonly",
      ariaRelevant: "aria-relevant",
      ariaRequired: "aria-required",
      ariaRoleDescription: "aria-roledescription",
      ariaRowCount: "aria-rowcount",
      ariaRowIndex: "aria-rowindex",
      ariaRowIndexText: "aria-rowindextext",
      ariaRowSpan: "aria-rowspan",
      ariaSelected: "aria-selected",
      ariaSetSize: "aria-setsize",
      ariaSort: "aria-sort",
      ariaValueMax: "aria-valuemax",
      ariaValueMin: "aria-valuemin",
      ariaValueNow: "aria-valuenow",
      ariaValueText: "aria-valuetext",
      role: "role"
    }, M = (oe, ie) => {
      for (let le in x) {
        ie[le] = null;
        let de = null;
        const be = x[le];
        Object.defineProperty(ie, le, {
          get() {
            return de;
          },
          set(ge) {
            de = ge, oe.isConnected ? P(oe, be, ge) : D.set(oe, ie);
          }
        });
      }
    };
    function p(oe) {
      const ie = o.get(oe), { form: le } = ie;
      E(oe, le, ie), l(oe, ie.labels);
    }
    const v = (oe, ie = !1) => {
      const le = document.createTreeWalker(oe, NodeFilter.SHOW_ELEMENT, {
        acceptNode(ge) {
          return o.has(ge) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        }
      });
      let de = le.nextNode();
      const be = !ie || oe.disabled;
      for (; de; )
        de.formDisabledCallback && be && y(de, oe.disabled), de = le.nextNode();
    }, k = { attributes: !0, attributeFilter: ["disabled", "name"] }, m = q() ? new MutationObserver((oe) => {
      for (const ie of oe) {
        const le = ie.target;
        if (ie.attributeName === "disabled" && (le.constructor.formAssociated ? y(le, le.hasAttribute("disabled")) : le.localName === "fieldset" && v(le)), ie.attributeName === "name" && le.constructor.formAssociated) {
          const de = o.get(le), be = j.get(le);
          de.setFormValue(be);
        }
      }
    }) : {};
    function A(oe) {
      oe.forEach((ie) => {
        const { addedNodes: le, removedNodes: de } = ie, be = Array.from(le), ge = Array.from(de);
        be.forEach((me) => {
          var fe;
          if (o.has(me) && me.constructor.formAssociated && p(me), D.has(me)) {
            const Ae = D.get(me);
            Object.keys(x).filter((xe) => Ae[xe] !== null).forEach((xe) => {
              P(me, x[xe], Ae[xe]);
            }), D.delete(me);
          }
          if (w.has(me)) {
            const Ae = w.get(me);
            P(me, "internals-valid", Ae.validity.valid.toString()), P(me, "internals-invalid", (!Ae.validity.valid).toString()), P(me, "aria-invalid", (!Ae.validity.valid).toString()), w.delete(me);
          }
          if (me.localName === "form") {
            const Ae = O.get(me), ye = document.createTreeWalker(me, NodeFilter.SHOW_ELEMENT, {
              acceptNode(we) {
                return o.has(we) && we.constructor.formAssociated && !(Ae && Ae.has(we)) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
              }
            });
            let xe = ye.nextNode();
            for (; xe; )
              p(xe), xe = ye.nextNode();
          }
          me.localName === "fieldset" && ((fe = m.observe) === null || fe === void 0 || fe.call(m, me, k), v(me, !0));
        }), ge.forEach((me) => {
          const fe = o.get(me);
          fe && a.get(fe) && S(fe), T.has(me) && T.get(me).disconnect();
        });
      });
    }
    function C(oe) {
      oe.forEach((ie) => {
        const { removedNodes: le } = ie;
        le.forEach((de) => {
          const be = N.get(ie.target);
          o.has(de) && V(de), be.disconnect();
        });
      });
    }
    const H = (oe) => {
      var ie, le;
      const de = new MutationObserver(C);
      !((ie = window == null ? void 0 : window.ShadyDOM) === null || ie === void 0) && ie.inUse && oe.mode && oe.host && (oe = oe.host), (le = de.observe) === null || le === void 0 || le.call(de, oe, { childList: !0 }), N.set(oe, de);
    };
    q() && new MutationObserver(A);
    const G = {
      childList: !0,
      subtree: !0
    }, P = (oe, ie, le) => {
      oe.getAttribute(ie) !== le && oe.setAttribute(ie, le);
    }, y = (oe, ie) => {
      oe.toggleAttribute("internals-disabled", ie), ie ? P(oe, "aria-disabled", "true") : oe.removeAttribute("aria-disabled"), oe.formDisabledCallback && oe.formDisabledCallback.apply(oe, [ie]);
    }, S = (oe) => {
      a.get(oe).forEach((le) => {
        le.remove();
      }), a.set(oe, []);
    }, d = (oe, ie) => {
      const le = document.createElement("input");
      return le.type = "hidden", le.name = oe.getAttribute("name"), oe.after(le), a.get(ie).push(le), le;
    }, s = (oe, ie) => {
      var le;
      a.set(ie, []), (le = m.observe) === null || le === void 0 || le.call(m, oe, k);
    }, l = (oe, ie) => {
      if (ie.length) {
        Array.from(ie).forEach((de) => de.addEventListener("click", oe.click.bind(oe)));
        let le = ie[0].id;
        ie[0].id || (le = `${ie[0].htmlFor}_Label`, ie[0].id = le), P(oe, "aria-labelledby", le);
      }
    }, b = (oe) => {
      const ie = Array.from(oe.elements).filter((ge) => !ge.tagName.includes("-") && ge.validity).map((ge) => ge.validity.valid), le = O.get(oe) || [], de = Array.from(le).filter((ge) => ge.isConnected).map((ge) => o.get(ge).validity.valid), be = [...ie, ...de].includes(!1);
      oe.toggleAttribute("internals-invalid", be), oe.toggleAttribute("internals-valid", !be);
    }, u = (oe) => {
      b(R(oe.target));
    }, c = (oe) => {
      b(R(oe.target));
    }, h = (oe) => {
      const ie = ["button[type=submit]", "input[type=submit]", "button:not([type])"].map((le) => `${le}:not([disabled])`).map((le) => `${le}:not([form])${oe.id ? `,${le}[form='${oe.id}']` : ""}`).join(",");
      oe.addEventListener("click", (le) => {
        if (le.target.closest(ie)) {
          const be = O.get(oe);
          if (oe.noValidate)
            return;
          be.size && Array.from(be).reverse().map((fe) => o.get(fe).reportValidity()).includes(!1) && le.preventDefault();
        }
      });
    }, g = (oe) => {
      const ie = O.get(oe.target);
      ie && ie.size && ie.forEach((le) => {
        le.constructor.formAssociated && le.formResetCallback && le.formResetCallback.apply(le);
      });
    }, E = (oe, ie, le) => {
      if (ie) {
        const de = O.get(ie);
        if (de)
          de.add(oe);
        else {
          const be = /* @__PURE__ */ new Set();
          be.add(oe), O.set(ie, be), h(ie), ie.addEventListener("reset", g), ie.addEventListener("input", u), ie.addEventListener("change", c);
        }
        r.set(ie, { ref: oe, internals: le }), oe.constructor.formAssociated && oe.formAssociatedCallback && setTimeout(() => {
          oe.formAssociatedCallback.apply(oe, [ie]);
        }, 0), b(ie);
      }
    }, R = (oe) => {
      let ie = oe.parentNode;
      return ie && ie.tagName !== "FORM" && (ie = R(ie)), ie;
    }, L = (oe, ie, le = DOMException) => {
      if (!oe.constructor.formAssociated)
        throw new le(ie);
    }, U = (oe, ie, le) => {
      const de = O.get(oe);
      return de && de.size && de.forEach((be) => {
        o.get(be)[le]() || (ie = !1);
      }), ie;
    }, V = (oe) => {
      if (oe.constructor.formAssociated) {
        const ie = o.get(oe), { labels: le, form: de } = ie;
        l(oe, le), E(oe, de, ie);
      }
    };
    function q() {
      return typeof MutationObserver < "u";
    }
    class Y {
      constructor() {
        this.badInput = !1, this.customError = !1, this.patternMismatch = !1, this.rangeOverflow = !1, this.rangeUnderflow = !1, this.stepMismatch = !1, this.tooLong = !1, this.tooShort = !1, this.typeMismatch = !1, this.valid = !0, this.valueMissing = !1, Object.seal(this);
      }
    }
    const I = (oe) => (oe.badInput = !1, oe.customError = !1, oe.patternMismatch = !1, oe.rangeOverflow = !1, oe.rangeUnderflow = !1, oe.stepMismatch = !1, oe.tooLong = !1, oe.tooShort = !1, oe.typeMismatch = !1, oe.valid = !0, oe.valueMissing = !1, oe), _ = (oe, ie, le) => (oe.valid = W(ie), Object.keys(ie).forEach((de) => oe[de] = ie[de]), le && b(le), oe), W = (oe) => {
      let ie = !0;
      for (let le in oe)
        le !== "valid" && oe[le] !== !1 && (ie = !1);
      return ie;
    }, X = /* @__PURE__ */ new WeakMap();
    function z(oe, ie) {
      oe.toggleAttribute(ie, !0), oe.part && oe.part.add(ie);
    }
    class $ extends Set {
      static get isPolyfilled() {
        return !0;
      }
      constructor(ie) {
        if (super(), !ie || !ie.tagName || ie.tagName.indexOf("-") === -1)
          throw new TypeError("Illegal constructor");
        X.set(this, ie);
      }
      add(ie) {
        if (!/^--/.test(ie) || typeof ie != "string")
          throw new DOMException(`Failed to execute 'add' on 'CustomStateSet': The specified value ${ie} must start with '--'.`);
        const le = super.add(ie), de = X.get(this), be = `state${ie}`;
        return de.isConnected ? z(de, be) : setTimeout(() => {
          z(de, be);
        }), le;
      }
      clear() {
        for (let [ie] of this.entries())
          this.delete(ie);
        super.clear();
      }
      delete(ie) {
        const le = super.delete(ie), de = X.get(this);
        return de.isConnected ? (de.toggleAttribute(`state${ie}`, !1), de.part && de.part.remove(`state${ie}`)) : setTimeout(() => {
          de.toggleAttribute(`state${ie}`, !1), de.part && de.part.remove(`state${ie}`);
        }), le;
      }
    }
    function K(oe, ie, le, de) {
      if (typeof ie == "function" ? oe !== ie || !0 : !ie.has(oe)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
      return le === "m" ? de : le === "a" ? de.call(oe) : de ? de.value : ie.get(oe);
    }
    function Q(oe, ie, le, de, be) {
      if (typeof ie == "function" ? oe !== ie || !0 : !ie.has(oe)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
      return ie.set(oe, le), le;
    }
    var Z;
    class ee {
      constructor(ie) {
        Z.set(this, void 0), Q(this, Z, ie);
        for (let le = 0; le < ie.length; le++) {
          let de = ie[le];
          this[le] = de, de.hasAttribute("name") && (this[de.getAttribute("name")] = de);
        }
        Object.freeze(this);
      }
      get length() {
        return K(this, Z, "f").length;
      }
      [(Z = /* @__PURE__ */ new WeakMap(), Symbol.iterator)]() {
        return K(this, Z, "f")[Symbol.iterator]();
      }
      item(ie) {
        return this[ie] == null ? null : this[ie];
      }
      namedItem(ie) {
        return this[ie] == null ? null : this[ie];
      }
    }
    function J() {
      const oe = HTMLFormElement.prototype.checkValidity;
      HTMLFormElement.prototype.checkValidity = le;
      const ie = HTMLFormElement.prototype.reportValidity;
      HTMLFormElement.prototype.reportValidity = de;
      function le(...ge) {
        let me = oe.apply(this, ge);
        return U(this, me, "checkValidity");
      }
      function de(...ge) {
        let me = ie.apply(this, ge);
        return U(this, me, "reportValidity");
      }
      const { get: be } = Object.getOwnPropertyDescriptor(HTMLFormElement.prototype, "elements");
      Object.defineProperty(HTMLFormElement.prototype, "elements", {
        get(...ge) {
          const me = be.call(this, ...ge), fe = Array.from(O.get(this) || []);
          if (fe.length === 0)
            return me;
          const Ae = Array.from(me).concat(fe).sort((ye, xe) => ye.compareDocumentPosition ? ye.compareDocumentPosition(xe) & 2 ? 1 : -1 : 0);
          return new ee(Ae);
        }
      });
    }
    class ae {
      static get isPolyfilled() {
        return !0;
      }
      constructor(ie) {
        if (!ie || !ie.tagName || ie.tagName.indexOf("-") === -1)
          throw new TypeError("Illegal constructor");
        const le = ie.getRootNode(), de = new Y();
        this.states = new $(ie), t.set(this, ie), e.set(this, de), o.set(ie, this), M(ie, this), s(ie, this), Object.seal(this), le instanceof DocumentFragment && H(le);
      }
      checkValidity() {
        const ie = t.get(this);
        if (L(ie, "Failed to execute 'checkValidity' on 'ElementInternals': The target element is not a form-associated custom element."), !this.willValidate)
          return !0;
        const le = e.get(this);
        if (!le.valid) {
          const de = new Event("invalid", {
            bubbles: !1,
            cancelable: !0,
            composed: !1
          });
          ie.dispatchEvent(de);
        }
        return le.valid;
      }
      get form() {
        const ie = t.get(this);
        L(ie, "Failed to read the 'form' property from 'ElementInternals': The target element is not a form-associated custom element.");
        let le;
        return ie.constructor.formAssociated === !0 && (le = R(ie)), le;
      }
      get labels() {
        const ie = t.get(this);
        L(ie, "Failed to read the 'labels' property from 'ElementInternals': The target element is not a form-associated custom element.");
        const le = ie.getAttribute("id"), de = ie.getRootNode();
        return de && le ? de.querySelectorAll(`[for="${le}"]`) : [];
      }
      reportValidity() {
        const ie = t.get(this);
        if (L(ie, "Failed to execute 'reportValidity' on 'ElementInternals': The target element is not a form-associated custom element."), !this.willValidate)
          return !0;
        const le = this.checkValidity(), de = B.get(this);
        if (de && !ie.constructor.formAssociated)
          throw new DOMException("Failed to execute 'reportValidity' on 'ElementInternals': The target element is not a form-associated custom element.");
        return !le && de && (ie.focus(), de.focus()), le;
      }
      setFormValue(ie) {
        const le = t.get(this);
        if (L(le, "Failed to execute 'setFormValue' on 'ElementInternals': The target element is not a form-associated custom element."), S(this), ie != null && !(ie instanceof FormData)) {
          if (le.getAttribute("name")) {
            const de = d(le, this);
            de.value = ie;
          }
        } else ie != null && ie instanceof FormData && Array.from(ie).reverse().forEach(([de, be]) => {
          if (typeof be == "string") {
            const ge = d(le, this);
            ge.name = de, ge.value = be;
          }
        });
        j.set(le, ie);
      }
      setValidity(ie, le, de) {
        const be = t.get(this);
        if (L(be, "Failed to execute 'setValidity' on 'ElementInternals': The target element is not a form-associated custom element."), !ie)
          throw new TypeError("Failed to execute 'setValidity' on 'ElementInternals': 1 argument required, but only 0 present.");
        B.set(this, de);
        const ge = e.get(this), me = {};
        for (const ye in ie)
          me[ye] = ie[ye];
        Object.keys(me).length === 0 && I(ge);
        const fe = Object.assign(Object.assign({}, ge), me);
        delete fe.valid;
        const { valid: Ae } = _(ge, fe, this.form);
        if (!Ae && !le)
          throw new DOMException("Failed to execute 'setValidity' on 'ElementInternals': The second argument should not be empty if one or more flags in the first argument are true.");
        n.set(this, Ae ? "" : le), be.isConnected ? (be.toggleAttribute("internals-invalid", !Ae), be.toggleAttribute("internals-valid", Ae), P(be, "aria-invalid", `${!Ae}`)) : w.set(be, this);
      }
      get shadowRoot() {
        const ie = t.get(this), le = F.get(ie);
        return le || null;
      }
      get validationMessage() {
        const ie = t.get(this);
        return L(ie, "Failed to read the 'validationMessage' property from 'ElementInternals': The target element is not a form-associated custom element."), n.get(this);
      }
      get validity() {
        const ie = t.get(this);
        return L(ie, "Failed to read the 'validity' property from 'ElementInternals': The target element is not a form-associated custom element."), e.get(this);
      }
      get willValidate() {
        const ie = t.get(this);
        return L(ie, "Failed to read the 'willValidate' property from 'ElementInternals': The target element is not a form-associated custom element."), !(ie.disabled || ie.hasAttribute("disabled") || ie.hasAttribute("readonly"));
      }
    }
    function re() {
      if (typeof window > "u" || !window.ElementInternals || !HTMLElement.prototype.attachInternals)
        return !1;
      class oe extends HTMLElement {
        constructor() {
          super(), this.internals = this.attachInternals();
        }
      }
      const ie = `element-internals-feature-detection-${Math.random().toString(36).replace(/[^a-z]+/g, "")}`;
      customElements.define(ie, oe);
      const le = new oe();
      return [
        "shadowRoot",
        "form",
        "willValidate",
        "validity",
        "validationMessage",
        "labels",
        "setFormValue",
        "setValidity",
        "checkValidity",
        "reportValidity"
      ].every((de) => de in le.internals);
    }
    let ce = !1, he = !1;
    function ne(oe) {
      he || (he = !0, window.CustomStateSet = $, oe && (HTMLElement.prototype.attachInternals = function(...ie) {
        const le = oe.call(this, ie);
        return le.states = new $(this), le;
      }));
    }
    function te(oe = !0) {
      if (!ce) {
        if (ce = !0, typeof window < "u" && (window.ElementInternals = ae), typeof CustomElementRegistry < "u") {
          const ie = CustomElementRegistry.prototype.define;
          CustomElementRegistry.prototype.define = function(le, de, be) {
            if (de.formAssociated) {
              const ge = de.prototype.connectedCallback;
              de.prototype.connectedCallback = function() {
                f.has(this) || (f.set(this, !0), this.hasAttribute("disabled") && y(this, !0)), ge != null && ge.apply(this), V(this);
              };
            }
            ie.call(this, le, de, be);
          };
        }
        if (typeof HTMLElement < "u" && (HTMLElement.prototype.attachInternals = function() {
          if (this.tagName) {
            if (this.tagName.indexOf("-") === -1)
              throw new Error("Failed to execute 'attachInternals' on 'HTMLElement': Unable to attach ElementInternals to non-custom elements.");
          } else return {};
          if (o.has(this))
            throw new DOMException("DOMException: Failed to execute 'attachInternals' on 'HTMLElement': ElementInternals for the specified element was already attached.");
          return new ae(this);
        }), typeof Element < "u") {
          let ie = function(...de) {
            const be = le.apply(this, de);
            if (F.set(this, be), q()) {
              const ge = new MutationObserver(A);
              window.ShadyDOM ? ge.observe(this, G) : ge.observe(be, G), T.set(this, ge);
            }
            return be;
          };
          const le = Element.prototype.attachShadow;
          Element.prototype.attachShadow = ie;
        }
        q() && typeof document < "u" && new MutationObserver(A).observe(document.documentElement, G), typeof HTMLFormElement < "u" && J(), (oe || typeof window < "u" && !window.CustomStateSet) && ne();
      }
    }
    return !!customElements.polyfillWrapFlushCallback || (re() ? typeof window < "u" && !window.CustomStateSet && ne(HTMLElement.prototype.attachInternals) : te(!1)), i.forceCustomStateSetPolyfill = ne, i.forceElementInternalsPolyfill = te, Object.defineProperty(i, "__esModule", { value: !0 }), i;
  })({});
})();
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const Om = Symbol.for(""), r1 = (i) => {
  if ((i == null ? void 0 : i.r) === Om) return i == null ? void 0 : i._$litStatic$;
}, jd = (i) => ({ _$litStatic$: i, r: Om }), Bp = /* @__PURE__ */ new Map(), s1 = (i) => (t, ...e) => {
  const a = e.length;
  let o, n;
  const r = [], T = [];
  let O, j = 0, D = !1;
  for (; j < a; ) {
    for (O = t[j]; j < a && (n = e[j], (o = r1(n)) !== void 0); ) O += o + t[++j], D = !0;
    j !== a && T.push(n), r.push(O), j++;
  }
  if (j === a && r.push(t[a]), D) {
    const F = r.join("$$lit$$");
    (t = Bp.get(F)) === void 0 && (r.raw = r, Bp.set(F, t = r)), e = T;
  }
  return i(t, ...e);
}, Be = s1(pe);
var cl = /* @__PURE__ */ ((i) => (i.NO_SYNC = "no-sync", i))(cl || {}), Fn = /* @__PURE__ */ ((i) => (i.VISIBLE = "visible", i.IDLE = "idle", i.INTERACTION = "interaction", i.MEDIA = "media", i.DEFINED = "defined", i))(Fn || {}), Ee = /* @__PURE__ */ ((i) => (i.BLUR = "beacon-event-blur", i.CHANGE = "beacon-event-change", i.CLICK = "beacon-event-click", i.FOCUS = "beacon-event-focus", i.HIDE = "beacon-event-hide", i.INPUT = "beacon-event-input", i.KEYDOWN = "beacon-event-keydown", i.MOUSEDOWN = "beacon-event-mousedown", i.MOUSEENTER = "beacon-event-mouseenter", i.MOUSELEAVE = "beacon-event-mouseleave", i.RENDER = "beacon-event-render", i.SORT = "beacon-event-sort", i.DEFERRED_CHILD = "beacon-event-deferred-child", i.RENDER_ACTION_ZONE = "beacon-event-render-action-zone", i.RENDER_TABLE_CARDS = "beacon-event-render-table-cards", i.LANGUAGE_SELECT = "beacon-event-language-select", i.CLOSE = "beacon-event-close", i.OPEN = "beacon-event-open", i.NAV_LANGUAGE_SELECT = "beacon-event-language-selected", i.CLOSE_ACTIVE_NAV_ITEM = "beacon-event-close-active-nav-item", i.ELEMENT_READY = "beacon-event-element-ready", i.ACTIVE_NAV_ITEM = "beacon-event-active-nav-item-change", i.DRILLDOWN = "beacon-event-drilldown", i.DRILLUP = "beacon-event-drillup", i.HEADER_ZONE_CLICK = "beacon-event-navigation-header-zone-click", i.COUNTRY_SELECTOR_CLOSE = "beacon-event-country-selector-close", i.COUNTRY_SELECTOR_OPEN = "beacon-event-country-selector-open", i.COUNTRY_FLAG_CHANGE = "beacon-event-country-flag-change", i.HAS_CURRENT_LINK = "beacon-event-has-current-link", i.REGISTER = "beacon-event-register", i.SKIP_LINK_CLICK = "beacon-event-skip-link-click", i.METRICS_SECTION_CHANGE = "beacon-event-metrics-section-change", i.METRICS_LOCATION_CHANGE = "beacon-event-metrics-location-change", i.METRICS_ID_CHANGE = "beacon-event-metrics-id-change", i.NAVIGATION_LINK_CLICK = "beacon-event-navigation-link-click", i.DISMISS = "beacon-event-dismiss", i.TOGGLE = "beacon-event-toggle", i.CONTROL_SET = "beacon-event-control-set", i.PAGINATE = "beacon-event-paginate", i.VIDEO_BRIGHTCOVE_READY = "beacon-event-video-brightcove-ready", i.ADD_FOOTNOTE = "beacon-event-add-footnote", i.REMOVE_FOOTNOTE = "beacon-event-remove-footnote", i))(Ee || {}), Je = /* @__PURE__ */ ((i) => (i.CLOSE = "close", i.KEYDOWN = "keydown", i.SCROLL = "scroll", i.CLICK = "click", i.FOCUSOUT = "focusout", i))(Je || {});
const l1 = ve`[beacon-tag-name]:not([focus-override]) *:focus-visible:not(.beacon-control__field,.skip-focus-override,a:not([focus-override])){box-shadow:0 0 0 var(--beacon-system-width-border-jumbo) var(--beacon-system-color-border-focus-middle),0 0 0 var(--beacon-system-width-border-maxi) var(--beacon-system-color-border-focus-outer);outline:var(--beacon-system-width-border-normal) solid var(--beacon-system-color-border-focus-inner);outline-offset:0;z-index:1}[beacon-tag-name]:not([focus-override]) *:focus-visible:not(.beacon-control__field,.skip-focus-override,a:not([focus-override])):not(dialog){position:relative}[beacon-tag-name]:not([focus-override]) a:not([focus-override]):focus-visible{background-color:var(--beacon-system-color-background-link-focus)!important;border-block-end-color:unset;box-shadow:0 var(--beacon-system-width-border-jumbo) 0 0 var(--beacon-system-color-border-link-focus);color:var(--beacon-system-color-text-set-navy)!important;outline:none;text-decoration:none}@media (forced-colors: active){[beacon-tag-name]:not([focus-override]) a:not([focus-override]):focus-visible{border-block-end:var(--beacon-system-width-border-jumbo) solid var(--beacon-system-color-border-link-focus)}}`, Pm = ve`:host(:not([focus-override],.skip-focus-override)) *:not(.skip-focus-override,a:not([focus-override])):focus-visible{box-shadow:0 0 0 var(--beacon-system-width-border-jumbo) var(--beacon-system-color-border-focus-middle),0 0 0 var(--beacon-system-width-border-maxi) var(--beacon-system-color-border-focus-outer);outline:var(--beacon-system-width-border-normal) solid var(--beacon-system-color-border-focus-inner);outline-offset:0;z-index:1}:host(:not([focus-override],.skip-focus-override)) *:not(.skip-focus-override,a:not([focus-override])):focus-visible:not(dialog){position:relative}:host(:not([focus-override],.skip-focus-override)) a:not([focus-override]):focus-visible{background-color:var(--beacon-system-color-background-link-focus)!important;border-block-end-color:unset;box-shadow:0 var(--beacon-system-width-border-jumbo) 0 0 var(--beacon-system-color-border-link-focus);color:var(--beacon-system-color-text-set-navy)!important;outline:none;text-decoration:none}@media (forced-colors: active){:host(:not([focus-override],.skip-focus-override)) a:not([focus-override]):focus-visible{border-block-end:var(--beacon-system-width-border-jumbo) solid var(--beacon-system-color-border-link-focus)}}`, c1 = ve`:root{--motion-translate-intro-macro: var(--beacon-system-breakpoint-small);--motion-translate-intro-micro: 3rem}@media (width >= 640px){:root{--motion-translate-intro-macro: var(--beacon-system-breakpoint-medium);--motion-translate-intro-micro: 4rem}}@media (width >= 960px){:root{--motion-translate-intro-macro: var(--beacon-system-breakpoint-large);--motion-translate-intro-micro: 5rem}}@media (width >= 1280px){:root{--motion-translate-intro-macro: var(--beacon-system-breakpoint-x-large);--motion-translate-intro-micro: 6rem}}@media (width >= 1600px){:root{--motion-translate-intro-macro: var(--beacon-system-breakpoint-xx-large);--motion-translate-intro-micro: 8rem}}@media (width >= 1920px){:root{--motion-translate-intro-macro: var(--beacon-system-breakpoint-xxx-large);--motion-translate-intro-micro: 9rem}}`, d1 = ve`[beacon-tag-name]:where([reset-spacing]) *{margin:0;padding:0}`, zm = ve`:host{border:initial;box-sizing:border-box;display:block;font-size:initial;font-style:initial;font-variant:initial;font-weight:initial;line-height:initial;white-space:initial;word-break:break-word;word-spacing:initial;text-align:initial;text-indent:initial;text-transform:initial}:host *,:host *:before,:host *:after{box-sizing:inherit}input,button,textarea,select{font:inherit;letter-spacing:inherit}button{color:inherit;cursor:pointer}ul,ol{list-style-position:initial;list-style-type:revert}::slotted(:is(ul,ol)[role=list]){list-style:none;padding:0}table{caption-side:initial;empty-cells:initial;border-collapse:initial;border-spacing:initial}`, Dm = ve`.has-cell-padding,.has-component-padding{padding-block:var(--beacon-reference-space-3);padding-inline:var(--beacon-reference-space-3)}:host{color:var(--beacon-system-color-text-standard);font-family:var(--beacon-system-font-family-body);-webkit-font-smoothing:antialiased;font-weight:var(--beacon-system-font-weight-light)}a,::slotted(a){color:var(--beacon-system-color-text-link)}a:not([class],:is(:hover,:focus)){text-decoration:none}:host(:not([motion-state=enabled])),:host(:not([motion-state=enabled])) :is(*,*:before,*:after),:host(:not([motion-state=enabled])) ::slotted(*:not([motion-state=enabled])){animation:none;animation-duration:.01ms!important;animation-iteration-count:1!important;scroll-behavior:auto!important;transition:none!important}@media (prefers-reduced-motion: reduce){:host([motion-state=enabled]),:host([motion-state=enabled]) :is(*,*:before,*:after),:host([motion-state]),:host([motion-state]) :is(*,*:before,*:after){animation:none;animation-duration:.01ms!important;animation-iteration-count:1!important;scroll-behavior:auto!important;transition:none!important}}`;
var go = /* @__PURE__ */ ((i) => (i.CLICKABLE = "data-metrics-clickable", i.TYPE = "data-metrics-type", i.TEXT = "data-metrics-link-text", i.LOCATION = "data-metrics-location", i))(go || {});
const Xa = class Xa {
};
Xa.setPropertyOnEvent = (t, e, a, o) => {
  try {
    Object.defineProperty(t, a, {
      value: o || e[`${a}`],
      writable: !1
    });
  } catch (n) {
    console.warn(n);
  }
}, Xa.getAnalyticsEvents = () => {
  const t = ["gesture", "click", "touch", "change"];
  return Object.keys(window).filter((e) => /^on/.test(e) && new RegExp(t.join("|")).test(e) && e !== "onscrollsnapchange");
}, Xa.setHostEventHandlerForAnalytics = (t, e) => {
  var n;
  const a = Xa.getAnalyticsEvents(), o = "beaconVersion";
  for (const r of a) {
    const T = r.slice(2);
    (n = t.shadowRoot) == null || n.addEventListener(
      T,
      (O) => {
        var D;
        const j = new O.constructor(
          T,
          O
        );
        Xa.setPropertyOnEvent(
          j,
          null,
          o,
          e
        );
        for (const F in O)
          F !== "isTrusted" && Xa.setPropertyOnEvent(j, O, F);
        (D = t.shadowRoot) != null && D.contains(O.target) && t.dispatchEvent(j);
      },
      !0
    );
  }
};
let $d = Xa;
function Wr(i, t) {
  !i || !t || i instanceof SVGElement && (i.setAttribute(go.CLICKABLE, "true"), i.setAttribute(go.TYPE, "BTN"), i.getAttribute(go.TEXT) || i.setAttribute(go.TEXT, t));
}
function h1(i) {
  return !!i.updateAnalytics;
}
function Re(i, t, e, a) {
  const o = new CustomEvent(t, {
    bubbles: !0,
    cancelable: !1,
    composed: !0,
    detail: {},
    ...e
  });
  return i.dispatchEvent(o), a && a(), o;
}
const Rp = (i) => !!i.deferrable, b1 = (i) => {
  var t, e;
  return (!!((t = i.deferList) != null && t.includes(Fn.VISIBLE)) || !!((e = i.getAttribute("defer-until")) != null && e.includes(Fn.VISIBLE))) && i.isDeferUntilParent;
}, Np = (i) => !!navigator.vendor && navigator.vendor.indexOf(i) > -1;
function p1(i) {
  return `${i}`.toLowerCase().replace(new RegExp(/[-_]+/, "g"), " ").replace(new RegExp(/[^\w\s]/, "g"), "").replace(
    new RegExp(/\s+(.)(\w*)/, "g"),
    (t, e, a) => `${e.toUpperCase() + a}`
  ).replace(new RegExp(/\w/), (t) => t.toUpperCase());
}
const u1 = "4.3.1", g1 = {
  rootMargin: "1500px",
  threshold: 0
}, da = {
  version: u1,
  hidden: "hidden",
  safari: "Apple",
  deprecatedPropertyKeys: ["alternateAttributes", "sync", "alternateSlot"],
  defaultDeferOptions: g1
}, Vc = (i) => {
  for (const t of i)
    if (t !== void 0) return t;
};
class Yc extends CSSStyleSheet {
  constructor(t, e) {
    super(), this.name = t, this.replaceSync(e);
  }
}
var m1 = Object.defineProperty, vi = (i, t, e, a) => {
  for (var o = void 0, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = r(t, e, o) || o);
  return o && m1(t, e, o), o;
};
const f1 = [zm, Dm, Pm];
var $n, Ft;
const Ba = (Ft = class extends Nn {
  constructor() {
    super();
    Fe(this, $n);
    Ne(this, $n, !1), this.isDeferUntilParent = !1, this.deferrable = !0, this.focusOverride = !1, this.resetSpacing = !1, this.beaconTagName = "", this.version = da.version, this.motionState = "disabled", this.prefersReducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches, this.alternateSlots = /* @__PURE__ */ new Map(), this.onslotchange = (e) => {
      const { target: a } = e, o = a.name;
      this.slotDeprecationWarn(o);
    }, this.resolvedDeferOptions = {
      root: document,
      rootMargin: da.defaultDeferOptions.rootMargin,
      threshold: da.defaultDeferOptions.threshold
    }, this.deferUntilVisible = () => new Promise((e) => {
      if (!("IntersectionObserver" in window))
        e();
      else {
        const a = new IntersectionObserver((o) => {
          const [n] = o;
          n.isIntersecting && (a.disconnect(), e());
        }, this.getResolvedDeferOptions() || null);
        a.observe(this);
      }
    }), this.deferUntilIdle = () => {
      const e = new Promise((a) => {
        document.readyState !== "complete" ? window.addEventListener("load", () => a(), { once: !0 }) : a();
      });
      return "requestIdleCallback" in window ? Promise.all([
        new Promise((a) => {
          requestIdleCallback(() => {
            a();
          });
        }),
        e
      ]) : e;
    }, this.deferredChildEventHandler = (e) => new Promise((a) => {
      var o;
      e instanceof CustomEvent && ((o = e.detail) != null && o.type) ? (this.deferOptions && this.setDeferOptions(this.deferOptions), this.selectDeferUntilHandler(e.detail.type).then(() => a())) : a();
    }), this.renderStyles = (e, a) => {
      const o = [], n = new Set(
        this.constructor[e].flat(1 / 0)
      );
      for (const r of n)
        o.push(r);
      Ri ? o.forEach((r, T) => {
        var F, B, N;
        const O = this.getClosestHost(), j = `${a}-${T}`, D = new Yc(j, r.toString());
        if (O) {
          if (!((F = O.shadowRoot) == null ? void 0 : F.adoptedStyleSheets.find(
            (w) => w.name === j
          )))
            if (D.name.includes("global-light")) {
              const w = parseInt(D.name.slice(-1), 10);
              (B = O.shadowRoot) == null || B.adoptedStyleSheets.splice(
                f1.length + w,
                0,
                D
              );
            } else
              (N = O.shadowRoot) == null || N.adoptedStyleSheets.push(D);
        } else if (!document.adoptedStyleSheets.find(
          (f) => f.name === j
        ))
          if (D.name.includes("global-light")) {
            const f = parseInt(D.name.slice(-1), 10) + 1, w = document.adoptedStyleSheets.findLastIndex(
              (x) => x.name.includes("global-root")
            );
            document.adoptedStyleSheets.splice(w + f, 0, D);
          } else
            document.adoptedStyleSheets.push(D);
      }) : o.toReversed().forEach((r, T) => {
        var D;
        const O = document.createElement("style");
        O.setAttribute("slot", "lightDOM");
        let j = !1;
        if (O.textContent = r.toString(), a) {
          const F = Math.abs(T - o.length), B = `${a}-${F}`, N = this.getClosestHost();
          O.id = B, (N && ((D = N == null ? void 0 : N.shadowRoot) != null && D.querySelector(`#${B}`)) || !N && document.querySelector(`#${B}`)) && (j = !0);
        }
        j || this.prepend(O);
      });
    }, this.renderComponentModeStyles = (e = `${this.beaconTagName}-mode-styles`) => {
      var a, o;
      Ri ? (a = this.componentModeStyles) == null || a.forEach(
        (n, r) => {
          if (!document.adoptedStyleSheets.find(
            (T) => T.name === `${e}-${r}`
          )) {
            const T = new Yc(
              `${e}-${r}`,
              n.toString()
            );
            document.adoptedStyleSheets.push(T);
          }
        }
      ) : (o = this.componentModeStyles) == null || o.forEach((n, r) => {
        const T = document.createElement("style");
        T.textContent = n.toString();
        const O = `${e}-${r}`;
        T.id = O, !document.querySelector(`#${O}`) && document.head.append(T);
      });
    }, this.getScopedTag = (e) => {
      if (!e) return null;
      const a = this.getScopedTagPrefix() ? `${this.getScopedTagPrefix()}-${e}` : e;
      return jd(a);
    }, this._internals = this.attachInternals ? this.attachInternals() : void 0;
  }
  /**
   * Extends Lit's definition of `observedAttributes`.
   *
   * Returns a list of attributes corresponding to the registered properties.
   * @nocollapse
   * @category attributes
   */
  static get observedAttributes() {
    const e = [];
    return this.hasDeprecatedProperties && this.alternateAttributesMap.forEach((a, o) => {
      this.elementProperties.has(a) && e.push(o);
    }), e.push(...super.observedAttributes), e;
  }
  /**
   * Extends Lit's default attributeChangedCallback to support deprecated properties.
   *
   * @param name Attribute name
   * @param _old Old value
   * @param value New value
   */
  attributeChangedCallback(e, a, o) {
    const {
      alternateAttributesMap: n,
      hasDeprecatedProperties: r,
      elementProperties: T
    } = this.constructor;
    if (r && n.size > 0) {
      const O = n.get(e), j = this.getPropertyOptions(e).alternateSlot;
      if (O) {
        const D = T.get(O);
        if (O !== cl.NO_SYNC && (o === null ? this.removeAttribute(
          (D == null ? void 0 : D.attribute) || O
        ) : this.setAttribute(
          (D == null ? void 0 : D.attribute) || O,
          o || ""
        )), j) {
          const F = this.createPropertyDeprecationForSlotMessage(e, j);
          console.warn(F);
        } else
          console.warn(
            this.createPropertyDeprecationMessage(
              e,
              O,
              D == null ? void 0 : D.attribute
            )
          );
      }
    }
    super.attributeChangedCallback(e, a, o);
  }
  /**
   * Generates a console message to log when deprecated properties were used.
   *
   * @param name attribute that triggered the message
   * @param prop property that the attribute aligns to
   * @param attribute correct attribute to use
   */
  createPropertyDeprecationMessage(e, a, o) {
    let n = `Beacon Warning: [${e}] will be deprecated as a prop of <${this.beaconTagName.toLowerCase()}> in a future release.`;
    return a !== cl.NO_SYNC && (n += ` Start using [${o || a}] instead to avoid future disruptions.`), n;
  }
  /**
   * Generates a console message to log when a deprecated property is used
   * and should instead use the designated slot
   * @param property the name of the property being deprecated
   * @param slot the designated slot to use instead
   */
  createPropertyDeprecationForSlotMessage(e, a) {
    return `Beacon Warning: '${e}' will be deprecated as a prop of <${this.beaconTagName.toLowerCase()}> in a future release. Start using the slot: '${a}' instead to avoid future disruptions`;
  }
  /**
   * Extend's Lit's `createProperty` method for our own uses.
   * @param name Property Name
   * @param options Options for the property
   */
  static createProperty(e, a) {
    if (a) {
      const { alternateAttributes: o, attribute: n } = a, r = Object.prototype.hasOwnProperty.call(
        a,
        "sync"
      );
      if (da.deprecatedPropertyKeys.forEach((T) => {
        Object.prototype.hasOwnProperty.call(a, T) && (this.hasDeprecatedProperties = !0);
      }), o && o.forEach((T) => {
        this.alternateAttributesMap.set(T, e);
      }), r && !a.sync) {
        const T = n != null ? n : e;
        this.alternateAttributesMap.set(
          T,
          cl.NO_SYNC
        );
      }
    }
    super.createProperty(e, a);
  }
  /**
   * This is used to return the property options of a property when given only its attribute name,
   * e.g. the property pageTitle with an attribute name of 'page-title' will have no way of accessing its options
   * directly when attempting to grab the options with 'page-title' and elementProperties.get().
   * @param name the resolved attribute name of a `@property()` decorated property
   * @returns the options passed in `@property()` e.g. `{attribute: 'attribute-name', reflect: true}`
   */
  getPropertyOptions(e) {
    var o;
    const { elementProperties: a } = this.constructor;
    return (o = a.get(e)) != null ? o : [...a.values()].find(
      (n) => n.attribute === e
    );
  }
  /**
   * Getter that returns private resolvedDeferOptions
   * @returns resolvedDeferOptions that are passed to an IntersectionObserver
   */
  getResolvedDeferOptions() {
    return this.resolvedDeferOptions;
  }
  /** callback method for the beacon-on-click event*/
  onBeaconClick() {
  }
  /** callback method for the beacon-on-keydown event*/
  onBeaconKeydown() {
  }
  /** callback method for the beacon-on-toggle event*/
  onBeaconToggle() {
  }
  /**
   * Converts space separated list prop of `defer-until` to a DeferUntil enum array
   */
  get deferList() {
    var e, a;
    return (a = (e = this.deferUntil) == null ? void 0 : e.split(" ").map((o) => o).filter((o) => !!o)) != null ? a : [];
  }
  /**
   * Logs a warning based on the slot name provided and details from the alternate slots map
   *
   * @param slotName name of the slot that has changed
   */
  slotDeprecationWarn(e) {
    const a = this.alternateSlots.get(e);
    if (a !== void 0) {
      let o;
      const n = `The '${e}' for for '${this.beaconTagName}'`;
      Object.keys(a).some((r) => r.match("alternate")) ? a.alternateAttribute ? o = `will be replaced by the element property '${a.alternateAttribute}'` : o = `will be replaced by the '${a.alternateSlots}' slot` : o = "will be removed", console.warn(
        `Beacon Deprecation Warning: ${n} ${o} in foundation@${a.version}`
      );
    }
  }
  /**
   * A setter that takes user input deferOptions and resolves them compared to existing deferOptions. Enables the setting
   * of isolated deferOptions and leaves unchanged options previously set intact.
   * @param options the defer-options object used in IntersectionObserver.
   */
  setDeferOptions(e) {
    if (!e) return;
    const a = { ...this.resolvedDeferOptions }, o = Vc([
      e == null ? void 0 : e.root,
      a == null ? void 0 : a.root
    ]), n = Vc([
      e == null ? void 0 : e.rootMargin,
      a == null ? void 0 : a.rootMargin
    ]), r = Vc([
      e == null ? void 0 : e.threshold,
      a == null ? void 0 : a.threshold
    ]);
    this.resolvedDeferOptions = {
      root: o instanceof Document || o instanceof Element ? o : document,
      rootMargin: typeof n == "string" ? n : da.defaultDeferOptions.rootMargin,
      threshold: Array.isArray(r) || typeof r == "number" ? r : da.defaultDeferOptions.threshold
    };
  }
  /**
   * Hides the visibility of the component. Used when component is deferred until specified condition.
   * @returns void
   */
  setDeferVisibilityStyles() {
    Np(da.safari) || (this.style.visibility = da.hidden);
  }
  /**
   * Sets the component styles to visibile. Used when component meets condition specified to defer until.
   * @returns void
   */
  removeDeferVisibilityStyles() {
    Np(da.safari) || this.style.removeProperty("visibility");
  }
  /**
   * Searches for a parent of component with defer-until attribute that is not solely defer-until="defined".
   * @returns closest lightDOM parent with [defer-until] attribute or null
   */
  getClosestDeferredParent() {
    const e = '[defer-until]:not([defer-until="defined"])', a = this.closest(
      e
    );
    if (a && Rp(a))
      return a;
    const o = this.getClosestHost();
    if (o) {
      const n = o.closest(
        e
      );
      if (n && Rp(n))
        return n;
    }
    return null;
  }
  /**
   * Runs in shadowDOM context. This method searches for the ShadowRoot then returns host of ShadowRoot.
   * @returns host element of this component of the shadowDOM
   */
  getClosestHost() {
    let e = this && this.parentNode;
    for (; e; ) {
      if (e instanceof ShadowRoot)
        return e.host;
      e = e.parentNode;
    }
    return null;
  }
  /**
   * Selects which deferUntil handler method to run on component.
   * @param deferUntilCriteria DeferUntil option that determines how component should defer.
   */
  selectDeferUntilHandler(e) {
    return new Promise((a) => {
      e.includes(Fn.VISIBLE) ? (this.setDeferVisibilityStyles(), this.deferUntilVisible().then(() => {
        this.removeDeferVisibilityStyles(), a();
      })) : e.includes(Fn.IDLE) ? (this.setDeferVisibilityStyles(), this.deferUntilIdle().then(() => {
        this.removeDeferVisibilityStyles(), a();
      })) : a();
    });
  }
  /**
   * Method that handles setup of deferUntil handler when deferUntil is configured locally via deferUntil prop on the component.
   */
  handleLocalDeferUntil() {
    return new Promise((e) => {
      this.deferOptions && this.setDeferOptions(this.deferOptions), this.selectDeferUntilHandler(this.deferList).then(() => e());
    });
  }
  /**
   * Method that looks for the closest element to the component with 'defer-until' attribute and either
   * applies the parent's deferUntil logic to the component immediately, if the parent is already registered as `isDeferUntilParent`,
   * or adds an eventListener to toggle parent's deferUntil logic on component once parent has emitted the beacon-event-deferred-child Event.
   * @param closestDeferredParent is the closest element to the component that has the 'defer-until' attribute set.
   */
  handleParentalDeferUntil(e) {
    return new Promise((a) => {
      if (e === null)
        a();
      else if (b1(e))
        this.selectDeferUntilHandler(e.deferList).then(
          () => a()
        );
      else {
        const o = (n) => {
          this.deferredChildEventHandler(n).then(() => {
            e.removeEventListener(
              Ee.DEFERRED_CHILD,
              o
            ), a();
          });
        };
        e.addEventListener(
          Ee.DEFERRED_CHILD,
          o
        );
      }
    });
  }
  /**
   * This method handles defer logic. If component has deferUntil prop set, it calls method to handle deferUntil logic locally.
   * Else if component has a closest element with 'defer-until' attribute set, it handles deferUntil based on closestDeferredParent's deferUntil settings.
   * If neither of the above criteria match, it completes connectedCallback.
   */
  handleDefer() {
    return new Promise((e) => {
      if (!this.deferrable || this.motionState === "enabled")
        e();
      else if (this.deferUntil)
        this.registerAsDeferUntilParent(), this.handleLocalDeferUntil().then(() => e());
      else {
        const a = this.getClosestDeferredParent();
        a ? this.handleParentalDeferUntil(a).then(
          () => e()
        ) : e();
      }
    });
  }
  /**
   * Method that registers a component as parental component that can trigger deferUntil logic in child components. It should be placed in connectedCallback
   * of all components that need to trigger deferUntil logic in child components.
   */
  registerAsDeferUntilParent() {
    if (this.deferOptions && this.setDeferOptions(this.deferOptions), this.deferList.includes(Fn.VISIBLE)) {
      const e = new IntersectionObserver((a) => {
        for (const o of a)
          o.target && (this.isDeferUntilParent = !0, this.emitDeferredChild(), e.disconnect());
      }, this.getResolvedDeferOptions() || null);
      e.observe(this);
    }
  }
  /**
   * @returns the scope prefix from the beginning of the tagName.
   */
  getScopedTagPrefix() {
    const e = this.tagName.toLowerCase().split("-beacon")[0];
    return e.startsWith("beacon") ? "" : e;
  }
  /**
   * Defines this web component in the CustomElementRegistry.
   * @param tagNamePrefix lowercase string that prefixes default component tag names for scoping purposes
   */
  static registerComponent(e) {
    if (this.tagName) {
      const a = `${e ? `${e}-` : ""}${this.tagName}`;
      if (this.nestedComponents.forEach(
        (o) => o.registerComponent(e)
      ), !customElements.get(a)) {
        const o = class extends this {
        };
        Object.defineProperty(o, "name", {
          value: p1(a)
        }), customElements.define(a, o), customElements.whenDefined(a).then(() => {
          const n = new CustomEvent(Ee.REGISTER, {
            detail: a
          });
          document.dispatchEvent(n);
        }).catch((n) => {
          console.error(
            `Error defining Beacon Component ${a} in CustomElementsRegistry: `,
            n
          );
        });
      }
    }
  }
  static renderGlobalRootStyles() {
    Ri ? this.globalRootStyles.forEach(
      (e, a) => {
        if (!document.adoptedStyleSheets.find(
          (o) => o.name === `beacon-global-root-styles-${a}`
        )) {
          const o = new Yc(
            `beacon-global-root-styles-${a}`,
            e.toString()
          );
          document.adoptedStyleSheets.push(o);
        }
      }
    ) : this.globalRootStyles.forEach((e, a) => {
      if (document.getElementById(`beacon-global-root-styles-${a}`))
        return;
      const o = document.createElement("template");
      o.innerHTML = `
        <style id="beacon-global-root-styles-${a}">
          ${e.toString()}
        </style>
      `;
      const n = o.content.cloneNode(!0);
      document.head.append(n);
    });
  }
  /**
   * This will return beacon tag name to scoped tag Name
   * @param tag beaconTagName
   * @returns Scoped tagName
   */
  getScopedTagName(e) {
    return e ? this.getScopedTagPrefix() ? `${this.getScopedTagPrefix()}-${e}` : e : "";
  }
  /**
   * @param event
   * @event {BeaconEvents} beacon-event-click - emits when clicked
   */
  emitClick() {
    Re(this, Ee.CLICK, void 0, this.onBeaconClick);
  }
  /**
   * @param event
   * @event {BeaconEvents} beacon-event-keydown - emits when a keydown event would be fired
   */
  emitKeydown() {
    Re(this, Ee.KEYDOWN, void 0, this.onBeaconKeydown);
  }
  emitToggle() {
    Re(this, Ee.TOGGLE, void 0, this.onBeaconToggle);
  }
  /**
   * Emitter of beacon-event-deferred-child event used by components registered as deferUntilParents.
   * @param event
   * @event {BeaconEvents} beacon-event-deferred-child - signals to children of a deferUntil parent that they should behave as deferUntil components
   */
  emitDeferredChild() {
    Re(this, Ee.DEFERRED_CHILD, {
      detail: {
        element: this,
        type: this.deferList
      }
    });
  }
  /**
   * Emits a beacon-event-keydown event as a default to mousedown handling
   * @param event
   */
  handleKeydown(e) {
    this.emitKeydown();
  }
  /**
   * Check if the component has a specific mixin applied.
   * @param name Name of the mixin to look for.
   * @returns True if the class contains that mixin.
   */
  hasMixin(e) {
    var a;
    try {
      if (!((a = this.constructor().mixins) == null ? void 0 : a.includes(e))) throw new Error(`This class does not implement ${e}.`);
      return !0;
    } catch (o) {
      return console.error(o), !1;
    }
  }
  /**
   * Check for a field with a specific value on the class.
   *
   * Useful when a mixin relies on the existance of another mixin.
   *
   * @param field Class property to check for on the mixin.
   * @param value Value of the given class field to check for.
   * @returns True if the value of the field is the same.
   */
  hasFieldAndValue(e, a) {
    try {
      if (!(e in this))
        throw new Error(`${e} does not exist on this: ${this}`);
      return this[e] === a;
    } catch (o) {
      return console.error(o), !1;
    }
  }
  /**
   * Placeholder method that collects all method functionality that is decorated with @prerender
   * and is called in connectedCallback. This method should not be overridden directly.
   * The goal is to prevent direct overrides of connectedCallback in subclasses
   */
  prerender(...e) {
  }
  /**
   * Placeholder method that collects all method functionality that is decorated with @postrender
   * and is called in firstUpdated. This method should not be overridden directly.
   * The goal is to prevent direct overrides of firstUpdated in subclasses
   */
  postrender(...e) {
  }
  /**
   * Placeholder method that collects all method functionality that is decorated with @destroy
   * and is called in disconnectedCallback. This method should not be overridden directly.
   * The goal is to prevent direct overrides of disconnectedCallback in subclasses
   */
  destroy(...e) {
  }
  /**
   * Enables or disables motion on this component.
   *
   * Looks for the closest element with `[motion-state]` to find its value and set the motion state of the component equal to that.
   *
   * @link https://developer.mozilla.org/en-US/docs/Web/API/Element/closest Element.closest() will return the element itself if it matches the selector.
   */
  setMotionState() {
    if (this.motionState === "enabled")
      return;
    const e = this.closest("[motion-state]"), a = e == null ? void 0 : e.getAttribute("motion-state");
    a && (a === "enabled" || a === "disabled") && (this.motionState = a);
  }
  /**
   * Removes the "defined" string value from defer-until attribute while leaving in place any other subString in the attribute.
   * This is a clean-up function called in connectedCallback that enables usage of applitools UltraFastGrid with defer-until="defined"
   * components.
   */
  removeDeferUntilDefined() {
    const e = this.getAttribute("defer-until");
    if (e) {
      const o = e.split(" ").filter((T) => T), n = o.length;
      if (n === 1 && o.includes("defined") || n === 0)
        this.removeAttribute("defer-until");
      else {
        const T = o.filter((O) => O !== "defined").join(" ");
        this.setAttribute("defer-until", T);
      }
    } else this.hasAttribute("defer-until") && !e && this.removeAttribute("defer-until");
  }
  renderLightDOMStyles() {
    Ri ? (this.renderStyles(
      "globalLightDOMStyles",
      "beacon-global-light-DOM-styles"
    ), this.renderStyles(
      "lightDOMStyles",
      `${this.beaconTagName}-light-DOM-styles`
    )) : (this.renderStyles(
      "lightDOMStyles",
      `${this.beaconTagName}-light-DOM-styles`
    ), this.renderStyles(
      "globalLightDOMStyles",
      "beacon-global-light-DOM-styles"
    ));
  }
  /**
   * Set custom state (using ElementInternals) on a component.
   *
   * A fallback when custom state isn't supported toggles a custom attribute that matches the state.
   *
   * States can be styled in CSS without the need to reflect a property.
   *
   * element-internals-polyfill will do the work of setting fallback attributes.
   *
   * @example
   * ```css
   * :host(:state(--custom-state)),
   * :host([state--custom-state]) {
   *  rule: value;
   * }
   * ```
   */
  setState(e, a = !0) {
    this._internals ? a ? this._internals.states.add(e) : this._internals.states.delete(e) : console.error(
      `Attempted to set state ${Se} on ${this.tagName} but internals are not available.`
    );
  }
  connectedCallback() {
    this.setMotionState(), this.removeDeferUntilDefined(), this.handleDefer().then(() => {
      super.connectedCallback(), ze(this, $n) || ($d.setHostEventHandlerForAnalytics(this, this.version), Ne(this, $n, !0)), Ft.renderGlobalRootStyles(), this.renderLightDOMStyles(), this.prerender();
    });
  }
  firstUpdated() {
    this.postrender(), Re(this, Ee.ELEMENT_READY);
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.destroy();
  }
}, $n = new WeakMap(), Ft.styles = [zm, Dm, Pm], Ft.tagName = "", Ft.nestedComponents = [], Ft.shadowRootOptions = {
  ...Nn.shadowRootOptions,
  delegatesFocus: !0
}, Ft.alternateAttributesMap = /* @__PURE__ */ new Map(), Ft.hasDeprecatedProperties = !1, Ft.mixins = [], Ft.lightDOMStyles = [], Ft.globalLightDOMStyles = [
  d1,
  l1
], Ft.globalRootStyles = [c1], Ft);
vi([
  ue({ attribute: "focus-override", type: Boolean, reflect: !0 })
], Ba.prototype, "focusOverride");
vi([
  ue({ attribute: "reset-spacing", type: Boolean, reflect: !0 })
], Ba.prototype, "resetSpacing");
vi([
  ue({ attribute: "beacon-tag-name", type: String, reflect: !0 })
], Ba.prototype, "beaconTagName");
vi([
  ue({ attribute: "beacon-version", reflect: !0 })
], Ba.prototype, "version");
vi([
  ue({ attribute: "defer-until" })
], Ba.prototype, "deferUntil");
vi([
  ue({ attribute: "defer-options" })
], Ba.prototype, "deferOptions");
vi([
  ue({ attribute: "motion-state", reflect: !0 })
], Ba.prototype, "motionState");
vi([
  Se()
], Ba.prototype, "prefersReducedMotion");
let Le = Ba;
var St = /* @__PURE__ */ ((i) => (i.ONE = "1", i.TWO = "2", i.THREE = "3", i))(St || {}), Wt = /* @__PURE__ */ ((i) => (i.ASCENDING = "ascending", i.DESCENDING = "descending", i))(Wt || {}), Im = /* @__PURE__ */ ((i) => (i.NORMAL = "normal", i.GROUP = "group", i.JUMBO = "jumbo", i))(Im || {}), fa = /* @__PURE__ */ ((i) => (i.TEXT = "text", i.NUMERAL = "numeral", i.DATE = "date", i.ICONS = "icons", i))(fa || {}), dl = /* @__PURE__ */ ((i) => (i.MOVABLE = "movable", i.FIXED = "fixed", i.FLOATING = "floating", i))(dl || {});
const Hd = "__mixwith_appliedMixin", Kd = "__mixwith_wrappedMixin", Fp = "__mixwith_cachedApplications", _p = "__mixwith_instanceOf", v1 = (i, t) => {
  const e = t(i);
  return e.prototype[Hd] = Rm(t), e;
}, A1 = (i, t) => Object.hasOwn(i, Hd) && i[Hd] === Rm(t), Bm = (i, t) => {
  for (; i != null; ) {
    if (A1(i, t)) return !0;
    i = Object.getPrototypeOf(i);
  }
  return !1;
}, Dh = (i, t) => (Object.setPrototypeOf(t, i), i[Kd] || (i[Kd] = i), t), Rm = (i) => i[Kd] || i, y1 = (i) => Dh(i, (t) => {
  let e = t[Fp];
  e || (e = t[Fp] = /* @__PURE__ */ new Map());
  let a = e.get(i);
  return a || (a = i(t), e.set(i, a)), a;
}), x1 = (i) => Dh(i, (e) => Bm(e.prototype, i) ? e : i(e)), w1 = (i) => (i[_p] || (i[_p] = !0, Object.defineProperty(i, Symbol.hasInstance, {
  value(t) {
    return Bm(t, i);
  }
})), i), k1 = (i) => Dh(i, (t) => v1(t, i)), kn = (i) => x1(y1(k1(w1(i)))), Ke = (i) => new C1(i);
class C1 {
  constructor(t) {
    this.superclass = t;
  }
  /**
   * Applies a chain of mixins to a base class. The method supports up to six mixins.
   * The mixins are applied in reverse sequence (e.g. the right most mixin is applied first, etc.)
   *
   * @param {mixin<Base, A>} a - A mixin to apply.
   * @param {mixin<A, B>} [b] - A mixin to apply (optional).
   * @param {mixin<B, C>} [c] - A mixin to apply (optional).
   * @param {mixin<C, D>} [d] - A mixin to apply (optional).
   * @param {mixin<D, E>} [e] - A mixin to apply (optional).
   * @param {mixin<E, F>} [f] - A mixin to apply (optional).
   *
   * @returns {Base & A & B & C & D & E & F} - A new class constructor that includes the functionalities
   *                                           of all mixins and the base class.
   */
  with(t, e, a, o, n, r) {
    var N;
    this.superclass = (N = this.superclass) != null ? N : class {
    };
    const T = kn(t), O = e ? kn(e) : void 0, j = a ? kn(a) : void 0, D = o ? kn(o) : void 0, F = n ? kn(n) : void 0, B = r ? kn(r) : void 0;
    return B && F && D && j && O && T ? B(F(D(j(O(T(this.superclass)))))) : F && D && j && O && T ? F(D(j(O(T(this.superclass))))) : D && j && O && T ? D(j(O(T(this.superclass)))) : j && O && T ? j(O(T(this.superclass))) : O && T ? O(T(this.superclass)) : T(this.superclass);
  }
}
var Zt = ((i) => (i[i.DEFAULT = parseInt(_v, 10)] = "DEFAULT", i[i.MEDIUM = parseInt(fh, 10)] = "MEDIUM", i[i.LARGE = parseInt(Zg, 10)] = "LARGE", i[i.XLARGE = parseInt(Jg, 10)] = "XLARGE", i))(Zt || {}), S1 = Object.defineProperty, E1 = Object.getOwnPropertyDescriptor, Nm = (i) => {
  throw TypeError(i);
}, Cn = (i, t, e, a) => {
  for (var o = a > 1 ? void 0 : a ? E1(t, e) : t, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = (a ? r(t, e, o) : r(o)) || o);
  return a && o && S1(t, e, o), o;
}, T1 = (i, t, e) => t.has(i) || Nm("Cannot " + e), qs = (i, t, e) => (T1(i, t, "read from private field"), e ? e.call(i) : t.get(i)), Vs = (i, t, e) => t.has(i) ? Nm("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(i) : t.set(i, e);
function Ra(i) {
  var t, e, a, o;
  let n = class extends i {
    constructor() {
      super(...arguments), this.smallBreakpointWatcher = window.matchMedia(
        n.createMediaQueryString(Zt.DEFAULT)
      ), this.mediumBreakpointWatcher = window.matchMedia(
        n.createMediaQueryString(Zt.MEDIUM)
      ), this.largeBreakpointWatcher = window.matchMedia(
        n.createMediaQueryString(Zt.LARGE)
      ), this.xLargeBreakpointWatcher = window.matchMedia(
        n.createMediaQueryString(Zt.XLARGE)
      ), this.prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches, this.isSmallBreakpoint = this.smallBreakpointWatcher.matches, this.isMediumBreakpoint = this.mediumBreakpointWatcher.matches, this.isLargeBreakpoint = this.largeBreakpointWatcher.matches, this.isXLargeBreakpoint = this.xLargeBreakpointWatcher.matches, Vs(this, t, ({ matches: r }) => {
        this.isSmallBreakpoint = r;
      }), Vs(this, e, ({ matches: r }) => {
        this.isMediumBreakpoint = r;
      }), Vs(this, a, ({ matches: r }) => {
        this.isLargeBreakpoint = r;
      }), Vs(this, o, ({ matches: r }) => {
        this.isXLargeBreakpoint = r;
      });
    }
    static createMediaQueryString(r) {
      return `(min-width: ${r}px)`;
    }
    /** Matches small but doesn't match medium. */
    get matchesUpToSmall() {
      return !this.isMediumBreakpoint;
    }
    /** Matches small and medium but doesn't match large. */
    get matchesUpToMedium() {
      return !this.isLargeBreakpoint;
    }
    /** Matches small, medium, and large but doesn't match x-large. */
    get matchesUpToLarge() {
      return !this.isXLargeBreakpoint;
    }
    /** Matches all breakpoints up to x-large. */
    get matchesUpToXLarge() {
      return this.isXLargeBreakpoint;
    }
    /** Alias for matching small and medium breakpoints. */
    get isMobile() {
      return this.matchesUpToMedium;
    }
    /** Alias for matching the large (desktop) breakpoint. */
    get isDesktop() {
      return this.isLargeBreakpoint;
    }
    prerenderWatchMediaSetup() {
      this.smallBreakpointWatcher.addEventListener(
        "change",
        qs(this, t)
      ), this.mediumBreakpointWatcher.addEventListener(
        "change",
        qs(this, e)
      ), this.largeBreakpointWatcher.addEventListener(
        "change",
        qs(this, a)
      ), this.xLargeBreakpointWatcher.addEventListener(
        "change",
        qs(this, o)
      );
    }
  };
  return t = /* @__PURE__ */ new WeakMap(), e = /* @__PURE__ */ new WeakMap(), a = /* @__PURE__ */ new WeakMap(), o = /* @__PURE__ */ new WeakMap(), Cn([
    Se()
  ], n.prototype, "isSmallBreakpoint", 2), Cn([
    Se()
  ], n.prototype, "isMediumBreakpoint", 2), Cn([
    Se()
  ], n.prototype, "isLargeBreakpoint", 2), Cn([
    Se()
  ], n.prototype, "isXLargeBreakpoint", 2), Cn([
    qe
  ], n.prototype, "prerenderWatchMediaSetup", 1), n = Cn([
    je("WatchMedia")
  ], n), n;
}
function Wi(i, t, e) {
  const a = i[t];
  if (a !== void 0) return a;
  const o = e();
  return i[t] = o, o;
}
function Up(i, t, e) {
  i != 0 ? t == null || t.classList.add(e) : t == null || t.classList.remove(e);
}
function M1(i, t) {
  if (i) {
    if (t && t.includes(i.localName))
      return i.id;
    if (i.parentElement)
      return i.parentElement.id;
  }
  return "";
}
const L1 = "headers";
function Gd(i, t, e, a, o, n, r) {
  var D, F, B, N, f;
  const T = t ? (f = (N = (B = i == null ? void 0 : i.parentElement) == null ? void 0 : B.parentElement) == null ? void 0 : N.nextElementSibling) == null ? void 0 : f.children : (F = (D = i == null ? void 0 : i.parentElement) == null ? void 0 : D.nextElementSibling) == null ? void 0 : F.children, O = M1(i, a);
  let j;
  if (T && O) {
    const w = Array.from(T);
    if (w && w.length && (j = w.filter((x) => {
      const M = x.getAttribute(L1);
      let p;
      return x && M && M === O && (e && o && o(x), p = x), p;
    })), j)
      return r && r(j, i), n && n(j, i), j;
  }
}
class O1 extends Pa {
  constructor(t) {
    if (super(t), this.observing = !1, this.tabindex = -1, t.type !== ln.ATTRIBUTE || t.name !== "tabindex")
      throw new Error(
        "The `scrollableRegion` directive must be used in the `tabindex` attribute"
      );
    this.part = t, this.resizeObserver = this.setupResizeObserver();
  }
  setupResizeObserver() {
    if (!this.resizeObserver)
      return new ResizeObserver((e) => {
        for (const a of e) {
          const {
            target: { scrollHeight: o, clientHeight: n }
          } = a;
          this.tabindex = Number(o) > Number(n) ? 0 : -1, this.render();
        }
      });
  }
  render() {
    this.part && this.part.name === "tabindex" && (this.part.element.tabIndex = this.tabindex);
  }
  update(t) {
    this.resizeObserver && !this.observing && this.resizeObserver.observe(t.element);
  }
}
const qi = Oa(O1), P1 = "td", z1 = "table";
function D1(i) {
  var r;
  if (!i) return;
  const t = i.closest(P1);
  if (!t) return;
  const e = Array.prototype.indexOf.call(
    (r = t == null ? void 0 : t.parentNode) == null ? void 0 : r.children,
    t
  );
  if (!e) return;
  const a = t.closest(z1);
  if (!a || !a.rows) return;
  let o = 0, n;
  for (n = 0; o <= e; n += 1) {
    const T = a.rows[0].cells[n];
    if (!T) break;
    T.dataset.colSpan ? o += parseInt(T.dataset.colSpan, 10) : o += T.colSpan;
  }
  return a.rows[0].cells[n - 1];
}
var I1 = Object.defineProperty, Fm = (i, t, e, a) => {
  for (var o = void 0, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = r(t, e, o) || o);
  return o && I1(t, e, o), o;
};
const B1 = "beacon-table";
class Os extends Le {
  constructor() {
    super(...arguments), this.isOriginal = !0, this.uuid = Ia();
  }
  /** When using transformed cards, this stores all nodes associated with the current one via their identical UUID. */
  get pairedNodes() {
    const { beaconTagName: t, uuid: e } = this, a = `[uuid="${e}"]`, o = `${this.getScopedTagName(t)}${a}`;
    if (this.isOriginal) {
      const n = this.closest(
        this.getScopedTagName(B1)
      );
      if (!n) return;
      const r = n._transformedCardsContainer;
      return r ? Array.from(r.querySelectorAll(o)) : void 0;
    }
    return Array.from(document.querySelectorAll(o));
  }
  willUpdate(t) {
    t.forEach((e, a) => {
      this.pairedNodes && a !== "isOriginal" && (!this.isOriginal && a === "bold" || this.pairedNodes.forEach((o) => {
        a && (o[a] = e);
      }));
    });
  }
}
Fm([
  Se()
], Os.prototype, "isOriginal");
Fm([
  ue({ reflect: !0 })
], Os.prototype, "uuid");
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const gt = (i) => i != null ? i : _e;
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function _m(i, t, e) {
  return i ? t(i) : e == null ? void 0 : e(i);
}
const R1 = ["id"], jp = [...R1];
var hs, dr, Um, jm;
class mc {
  constructor(t, e) {
    Fe(this, dr);
    Fe(this, hs);
    this.attributes = /* @__PURE__ */ new Map(), (this.host = t).addController(this), Ne(this, hs, e);
  }
  hostConnected() {
    Ze(this, dr, Um).call(this), Ze(this, dr, jm).call(this);
  }
}
hs = new WeakMap(), dr = new WeakSet(), Um = function() {
  var t, e;
  if (this.host instanceof HTMLElement) {
    for (const a of jp)
      this.attributes.set(
        a,
        (e = this.host.getAttribute(a)) != null ? e : (t = ze(this, hs)) == null ? void 0 : t[a]
      );
    this.host.requestUpdate();
  }
}, jm = function() {
  const t = new MutationObserver(
    (e, a) => {
      for (const { attributeName: o, target: n } of e)
        o === "id" && this.attributes.set("id", n.id);
      this.host.requestUpdate();
    }
  );
  this.host instanceof HTMLElement && t.observe(this.host, {
    attributes: !0,
    attributeFilter: jp
  });
};
var Ih = /* @__PURE__ */ ((i) => (i.LOADING = "loading", i.PROGRESS = "progress", i.SUCCESS = "success", i.RESULT = "result", i.NONE = "", i))(Ih || {}), hl = /* @__PURE__ */ ((i) => (i.SUBMIT = "submit", i.BUTTON = "button", i.RESET = "reset", i.MENU = "menu", i))(hl || {}), Bh = /* @__PURE__ */ ((i) => (i.PRIMARY = "primary", i.SECONDARY = "secondary", i.TERTIARY = "tertiary", i.POSITIVE = "positive", i.NEGATIVE = "negative", i))(Bh || {}), N1 = Object.defineProperty, F1 = Object.getOwnPropertyDescriptor, Ys = (i, t, e, a) => {
  for (var o = a > 1 ? void 0 : a ? F1(t, e) : t, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = (a ? r(t, e, o) : r(o)) || o);
  return a && o && N1(t, e, o), o;
};
function $m(i = { clean: !1 }) {
  return function(e) {
    let a = class extends e {
      /**
       * Removes any whitespace from the default slot.
       *
       * Default slots can see whitespace or new line characters as node slotted in, which can cause presentational issues when there's fallback content in the slot's position.
       *
       * This issue is commonly seen in AEM applications but can be a result of any templating syntax that doesn't trim whitespace from HTML nodes the whole way.
       */
      cleanDefaultSlot() {
        this.defaultSlotNodes.forEach((o) => {
          var n;
          !o.slot && !((n = o.textContent) != null && n.trim()) && o.remove();
        });
      }
      /** Sets internal state for slot text and existance of slot content */
      setDefaultSlotText() {
        this.defaultSlotText = this.getDefaultSlotText(), i.clean && this.cleanDefaultSlot();
      }
      /** Grabs slotted text and sets the state defaultSlotText property. */
      getDefaultSlotText() {
        if (this.defaultSlotNodes.length > 0)
          return this.defaultSlotNodes.map((o) => {
            var n, r;
            return (r = (n = o.textContent) == null ? void 0 : n.trim()) != null ? r : "";
          }).join("");
      }
      postrenderSetDefaultSlotText() {
        this.setDefaultSlotText();
      }
    };
    return Ys([
      Se()
    ], a.prototype, "defaultSlotText", 2), Ys([
      gc({ flatten: !0 })
    ], a.prototype, "defaultSlotNodes", 2), Ys([
      De
    ], a.prototype, "postrenderSetDefaultSlotText", 1), a = Ys([
      je("TracksDefaultSlot")
    ], a), a;
  };
}
const _1 = ve`.beacon-button-icon{align-self:var(--beacon-button-icon-align, center);block-size:var(--beacon-reference-space-5);inline-size:var(--beacon-reference-space-5)}.beacon-button-icon .beacon-button-icon--icon{fill:currentcolor}.beacon-button-icon .beacon-button-icon--stroke{stroke:currentcolor}.close-button-wrapper .beacon-button-icon{block-size:unset;inline-size:unset}[beacon-tag-name=beacon-icon-button] .beacon-button-icon{block-size:var(--override-icon-button-block-size, var(--beacon-reference-space-7));inline-size:var(--override-icon-button-inline-size, var(--beacon-reference-space-7))}`, U1 = ve`:host([motion-state=enabled]) a,:host([motion-state=enabled]) button,:host([motion-state=enabled]) .icon-button{--button-base-transition-property: background-color;transition-duration:var(--button-base-transition-duration, 0s);transition-property:var(--button-base-transition-property);transition-timing-function:var(--button-base-transition-timing-function, var(--beacon-system-motion-easing-decelerate-emphasize-1))}:host([motion-state=enabled]) a .contents,:host([motion-state=enabled]) button .contents,:host([motion-state=enabled]) .icon-button .contents{transition-duration:inherit;transition-property:transform;transition-timing-function:inherit}`;
var j1 = Object.getOwnPropertyDescriptor, $1 = (i, t, e, a) => {
  for (var o = a > 1 ? void 0 : a ? j1(t, e) : t, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = r(o) || o);
  return o;
};
function H1(i) {
  let t = class extends i {
    static get ButtonBaseMotionStyles() {
      return [U1];
    }
  };
  return t = $1([
    je("ButtonBaseMotion")
  ], t), t;
}
const K1 = ve`:host(:not(.skip-focus-override)) :is(button,a):focus-visible{box-shadow:0 0 0 var(--beacon-system-width-border-jumbo) var(--beacon-system-color-border-focus-middle),0 0 0 var(--beacon-system-width-border-maxi) var(--beacon-system-color-border-focus-outer);outline:var(--beacon-system-width-border-normal) solid var(--beacon-system-color-border-focus-inner);outline-offset:0;z-index:1}:host(:not(.skip-focus-override)) :is(button,a):focus-visible:not(dialog){position:relative}:host(:not(.skip-focus-override)) :is(button,a).tertiary:focus-visible{--second-ring-width: calc(var(--beacon-system-width-border-jumbo) + var(--beacon-system-width-border-normal));box-shadow:0 0 0 var(--second-ring-width) var(--beacon-system-color-border-focus-outer);outline:var(--beacon-system-width-border-normal) solid var(--beacon-system-color-border-focus-middle);outline-offset:0;position:relative;z-index:1}`;
var G1 = Object.defineProperty, xo = (i, t, e, a) => {
  for (var o = void 0, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = r(t, e, o) || o);
  return o && G1(t, e, o), o;
};
const Lr = {
  icon: "beacon-button-icon",
  strokeFill: "beacon-button-icon--stroke",
  iconFill: "beacon-button-icon--icon"
}, W1 = "stroke";
var ya;
const so = (ya = class extends Ke(Le).with(
  H1,
  $m({ clean: !0 })
) {
  constructor() {
    super(...arguments), this._passthroughs = new mc(this), this.focusOverride = !0, this.SLOTTED_ICON_INDEX = 0, this.type = hl.BUTTON, this.variant = Bh.PRIMARY, this.state = Ih.NONE, this.disabled = !1, this.linkHref = "";
  }
  static get styles() {
    return [super.styles, K1, this.ButtonBaseMotionStyles];
  }
  static get lightDOMStyles() {
    return [super.lightDOMStyles, _1];
  }
  /**
   * Implement `ElementInternals.setValidity()` with default values.
   * @param flags Custom validation flags.
   * @param message Error message used in validation.
   * @param anchor Validation target to receive focus, typically the form control element used in the shadow DOM.
   */
  setValidity(t, e, a = this.formAnchor) {
    this._internals && this._internals.setValidity(t, e, a);
  }
  get prefixIcon() {
    return this.prefixIconElements[this.SLOTTED_ICON_INDEX];
  }
  get suffixIcon() {
    return this.suffixIconElements[this.SLOTTED_ICON_INDEX];
  }
  /**
   * Returns the first element in the icon slot
   */
  get icon() {
    return this.iconElements[this.SLOTTED_ICON_INDEX];
  }
  /**
   * Event listener for internal HTML button that
   * determines click behavior depending on its disabled state
   * and button type.
   * @param event click event
   * @event {BeaconEvents} beacon-event-click - Emits when clicked
   */
  handleClick(t) {
    var e, a;
    if (this.disabled)
      t.preventDefault(), t.stopPropagation(), t.stopImmediatePropagation();
    else if (this.emitClick(), this._internals)
      switch (this.type) {
        case hl.SUBMIT:
          (e = this._internals.form) == null || e.requestSubmit();
          break;
        case hl.RESET:
          (a = this._internals.form) == null || a.reset();
          break;
      }
  }
  /**
   * Applies proper CSS class to slotted SVG such that it renders correctly
   * @param element reference to the slotted SVG
   */
  static applySVGClass(t) {
    t && Array.from(t.children).forEach((e) => {
      if (e) {
        const a = e.getAttribute(W1) ? Lr.strokeFill : Lr.iconFill;
        e.classList.add(a);
      }
    });
  }
  handleIconSlotchange() {
    if (this.iconElements.length > 0)
      for (const t of this.iconElements) {
        t.classList.add(Lr.icon);
        const e = this.defaultSlotText;
        Wr(t, e), ya.applySVGClass(t);
      }
  }
  handleAffixSlotChanges({ target: t }) {
    if (t instanceof HTMLSlotElement) {
      const e = t.name;
      if (e === "suffix" && this.suffixIcon) {
        this.suffixIcon.classList.add(Lr.icon);
        const a = this.defaultSlotText;
        Wr(this.suffixIcon, a), ya.applySVGClass(this.suffixIcon);
      } else if (e === "prefix" && this.prefixIcon) {
        this.prefixIcon.classList.add(Lr.icon);
        const a = this.defaultSlotText;
        Wr(this.prefixIcon, a), ya.applySVGClass(this.prefixIcon);
      }
    }
  }
}, ya.formAssociated = !0, ya);
xo([
  et(".form-anchor")
], so.prototype, "formAnchor");
xo([
  ue({ reflect: !0 })
], so.prototype, "type");
xo([
  ue()
], so.prototype, "variant");
xo([
  ue()
], so.prototype, "state");
xo([
  ue({ type: Boolean })
], so.prototype, "disabled");
xo([
  ue({ attribute: "link-href" })
], so.prototype, "linkHref");
xo([
  ue({ attribute: "link-download" })
], so.prototype, "linkDownload");
xo([
  ue({ attribute: "link-target" })
], so.prototype, "linkTarget");
xo([
  Pe({ flatten: !0, slot: "icon", selector: "svg" })
], so.prototype, "iconElements");
xo([
  Pe({
    flatten: !0,
    slot: "prefix",
    selector: "svg"
  })
], so.prototype, "prefixIconElements");
xo([
  Pe({
    flatten: !0,
    slot: "suffix",
    selector: "svg"
  })
], so.prototype, "suffixIconElements");
xo([
  et("button, a")
], so.prototype, "button");
let Fi = so;
const bl = {
  beaconTagName: "beacon-popover",
  DATA_METRICS_LOCATION_POPOVER: "PU",
  DATA_METRICS_LOCATION_BODY: "BDY"
}, q1 = ve`:host([motion-state=enabled]) .icon-button{--button-base-transition-duration: var(--beacon-reference-motion-duration-5);--scale-value: 1.1;transition-property:var(--button-base-transition-property),transform}:host([motion-state=enabled]) .icon-button:is(:hover,:active){transform:scale(var(--scale-value))}:host([motion-state=enabled]) .icon-button:is(:hover,:active) .contents{transform:scale(calc(1 / var(--scale-value)))}`;
var V1 = Object.getOwnPropertyDescriptor, Y1 = (i, t, e, a) => {
  for (var o = a > 1 ? void 0 : a ? V1(t, e) : t, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = r(o) || o);
  return o;
};
function Q1(i) {
  let t = class extends i {
    static get IconButtonMotionStyles() {
      return [q1];
    }
  };
  return t = Y1([
    je("IconButtonMotion")
  ], t), t;
}
const X1 = ve`.visually-hidden{border:0;clip:rect(0,0,0,0);block-size:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;inline-size:1px}:host{display:var(--override-icon-button-display, inline-block)}.icon-button{--active-bg: var(--beacon-system-color-background-primary-pressed);--active-border: var(--beacon-system-color-border-secondary-pressed);--active-icon: var(--beacon-system-color-icon-secondary-pressed);--bg-color: var(--beacon-system-color-background-primary);--border-color: var(--beacon-system-color-border-secondary);--border-width: var(--beacon-system-width-border-mini);--default-size: var(--beacon-reference-space-9);--disabled-bg: var(--beacon-system-color-background-primary-inactive);--disabled-border: var(--beacon-system-color-border-secondary-inactive);--disabled-icon: var(--beacon-system-color-icon-primary-inactive);--hover-bg: var(--beacon-system-color-background-primary-hover);--hover-border: var(--beacon-system-color-border-secondary-hover);--hover-icon: var(--beacon-system-color-icon-secondary-hover);--icon-color: var(--beacon-system-color-icon-primary);align-items:center;background-color:var(--override-icon-button-bg-color, var(--bg-color));block-size:var(--override-icon-button-wrapper-block-size, var(--beacon-reference-space-10));border:var(--border-width) solid var(--border-color);border-radius:var(--override-icon-button-border-radius, var(--beacon-system-radius-corner-circle));box-shadow:var(--override-icon-button-box-shadow, initial);color:var(--override-icon-button-color, var(--beacon-host-override-icon-button-color, var(--icon-color)));cursor:pointer;display:inline-flex;inline-size:var(--override-icon-button-wrapper-inline-size, var(--beacon-reference-space-10));justify-content:center;outline-offset:var(--override-icon-button-outline-offset);position:relative;padding:var(--override-icon-button-padding, 0)}.icon-button .contents{align-items:inherit;display:inherit;justify-content:inherit;position:inherit}.icon-button[aria-disabled=true]{--icon-color: var(--disabled-icon);background-color:var(--disabled-bg);border-color:var(--disabled-border);color:var(--disabled-icon);cursor:not-allowed}.icon-button svg,.icon-button [beacon-tag-name=beacon-icon]{position:absolute}.icon-button:-webkit-direct-focus{outline:-webkit-focus-ring-color auto 0}.icon-button:hover:not([aria-disabled=true]){--icon-color: var(--hover-icon);background-color:var(--hover-bg);border-color:var(--hover-border);color:var(--hover-icon)}.icon-button:active:not([aria-disabled=true]){--icon-color: var(--active-icon);background-color:var(--active-bg);border-color:var(--active-border);color:var(--active-icon)}.icon-button.primary{--active-bg: var(--override-icon-button-bg-color-pressed, var(--default-active-bg));--active-icon: var(--beacon-system-color-icon-primary);--bg-color: var(--override-icon-button-bg-color, var(--default-bg));--default-active-bg: var(--beacon-system-color-background-primary-pressed);--default-bg: var(--beacon-system-color-background-primary);--default-hover-bg: var(--beacon-system-color-background-primary-hover);--disabled-bg: var(--beacon-system-color-background-primary-inactive);--disabled-icon: var(--beacon-system-color-icon-primary-inactive);--hover-bg: var(--override-icon-button-bg-color-hover, var(--default-hover-bg));--hover-icon: var(--beacon-system-color-icon-primary);--icon-color: var(--beacon-system-color-icon-primary);border:0}.icon-button.secondary{--active-bg: var(--beacon-system-color-background-secondary-pressed);--active-border: var(--beacon-system-color-border-secondary-pressed);--active-icon: var(--beacon-system-color-icon-secondary-pressed);--bg-color: transparent;--border-color: var(--beacon-system-color-border-secondary);--disabled-bg: transparent;--disabled-border: var(--beacon-system-color-border-secondary-inactive);--disabled-icon: var(--beacon-system-color-icon-secondary-inactive);--hover-bg: var(--beacon-system-color-background-secondary-hover);--hover-border: var(--beacon-system-color-border-secondary-hover);--hover-icon: var(--beacon-system-color-icon-secondary-hover);--icon-color: var(--beacon-system-color-icon-secondary)}.icon-button.tertiary{--active-bg: var(--beacon-system-color-background-tertiary-pressed);--active-icon: var(--beacon-system-color-icon-tertiary-pressed);--bg-color: transparent;--default-hover-bg: var(--beacon-system-color-background-tertiary-hover);--default-hover-icon: var(--beacon-system-color-icon-tertiary-hover);--default-icon-color: var(--beacon-system-color-icon-tertiary);--disabled-bg: transparent;--disabled-icon: var(--beacon-system-color-icon-tertiary-inactive);--hover-bg: var(--override-icon-button-hover-bg, var(--default-hover-bg));--hover-icon: var(--override-icon-button-icon-color, var(--default-hover-icon));--icon-color: var(--override-icon-button-icon-color, var(--default-icon-color));border:0}`;
var Z1 = Object.defineProperty, J1 = Object.getOwnPropertyDescriptor, ew = (i, t, e, a) => {
  for (var o = J1(t, e), n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = r(t, e, o) || o);
  return o && Z1(t, e, o), o;
};
const $p = "beacon-icon-button", sb = class sb extends Ke(Fi).with(
  Q1
) {
  constructor() {
    super(...arguments), this.beaconTagName = $p;
  }
  static get styles() {
    return [super.styles, X1, this.IconButtonMotionStyles];
  }
  /**
   * Returns the closest beacon-popover parent to determine if the related data-metrics-location attribute should apply
   */
  get isPopoverChild() {
    return !!this.closest('[beacon-tag-name="beacon-popover"]');
  }
  applyDataMetricsLocation() {
    this.isPopoverChild && this.setAttribute(
      "data-metrics-location",
      bl.DATA_METRICS_LOCATION_BODY
    );
  }
  /**
   * Render function for the default slot that is reused between link and button variants
   *
   * @returns {TemplateResult} slot wrapped in a visually-hidden span
   */
  renderDefaultSlot() {
    return pe`<span class="visually-hidden"><slot></slot></span>`;
  }
  /**
   * Render function for beacon-button if link-href propety is passed in to support links as buttons
   *
   * @returns {TemplateResult} returns an `<a>` tag styled as a button
   */
  renderAnchorTag() {
    return pe` <a
      part="icon-link"
      id="${gt(this._passthroughs.attributes.get("id"))}"
      @click=${this.handleClick}
      href="${this.linkHref}"
      download="${gt(this.linkDownload)}"
      target="${gt(this.linkTarget)}"
      class="icon-button ${this.variant}"
      aria-disabled="${this.disabled}">
      ${this.renderDefaultSlot()}
      <span class="contents">
        <slot name="icon" @slotchange=${this.handleIconSlotchange}></slot>
      </span>
    </a>`;
  }
  /**
   * Render function for beacon-button as a `<button>` element
   *
   * @returns {TemplateResult} returns a `<button>` tag as the template
   */
  renderButtonTag() {
    return pe`
      <button
        part="icon-button"
        id="${gt(this._passthroughs.attributes.get("id"))}"
        @click=${this.handleClick}
        class="icon-button ${this.variant}"
        aria-disabled="${this.disabled}">
        ${this.renderDefaultSlot()}
        <span class="contents">
          <slot name="icon" @slotchange=${this.handleIconSlotchange}></slot>
        </span>
      </button>
    `;
  }
  render() {
    return pe` ${_m(
      this.linkHref,
      () => this.renderAnchorTag(),
      () => this.renderButtonTag()
    )}`;
  }
};
sb.tagName = $p;
let eo = sb;
ew([
  De
], eo.prototype, "applyDataMetricsLocation");
const tw = ve`:root[beacon-tag-name=beacon-table-header],:root [beacon-tag-name=beacon-table-header],[beacon-version="4.3.1"][class*=beacon-on][beacon-tag-name=beacon-table-header],[beacon-version="4.3.1"][class*=beacon-on] [beacon-tag-name=beacon-table-header],[class*=beacon-on] [beacon-version="4.3.1"][beacon-tag-name=beacon-table-header],[class*=beacon-on] [beacon-version="4.3.1"] [beacon-tag-name=beacon-table-header],[beacon-version="4.3.1"][beacon-tag-name=beacon-table-header],[beacon-version="4.3.1"] [beacon-tag-name=beacon-table-header]{--table-header-space-zero-value: 0;--table-header-sort-icon-size: var(--beacon-reference-space-5);--table-header-dropdown-space-padding-block-start-jumbo: 0;--table-header-dropdown-space-padding-block-start-normal: 0;--table-header-nth-cell-space-padding-block-start-jumbo: 5px;--table-header-nth-cell-space-padding-block-start-normal: var(--beacon-reference-space-1);--table-header-sort-wrapper-space-padding-block-start-jumbo: 0;--table-header-sort-wrapper-space-padding-block-start-normal: var(--beacon-reference-space-0);--beacon-table-header-action-zone-space-padding-block-start-jumbo: 0;--table-header-action-zone-space-padding-block-start-normal: var(--beacon-reference-space-0)}@media (width >= 640px){:root[beacon-tag-name=beacon-table-header],:root [beacon-tag-name=beacon-table-header],[beacon-version="4.3.1"][class*=beacon-on][beacon-tag-name=beacon-table-header],[beacon-version="4.3.1"][class*=beacon-on] [beacon-tag-name=beacon-table-header],[class*=beacon-on] [beacon-version="4.3.1"][beacon-tag-name=beacon-table-header],[class*=beacon-on] [beacon-version="4.3.1"] [beacon-tag-name=beacon-table-header],[beacon-version="4.3.1"][beacon-tag-name=beacon-table-header],[beacon-version="4.3.1"] [beacon-tag-name=beacon-table-header]{--table-header-dropdown-space-padding-block-start-jumbo: var(--beacon-reference-space-0);--table-header-dropdown-space-padding-block-start-normal: var(--beacon-reference-space-0);--table-header-nth-cell-space-padding-block-start-jumbo: var(--beacon-reference-space-2);--table-header-nth-cell-space-padding-block-start-normal: var(--beacon-reference-space-2);--table-header-sort-wrapper-space-padding-block-start-jumbo: var(--beacon-reference-space-0);--table-header-sort-wrapper-space-padding-block-start-normal: var(--beacon-reference-space-1);--beacon-table-header-action-zone-space-padding-block-start-jumbo: var(--beacon-reference-space-0);--table-header-action-zone-space-padding-block-start-normal: var(--beacon-reference-space-1)}}@media (width >= 1280px){:root[beacon-tag-name=beacon-table-header],:root [beacon-tag-name=beacon-table-header],[beacon-version="4.3.1"][class*=beacon-on][beacon-tag-name=beacon-table-header],[beacon-version="4.3.1"][class*=beacon-on] [beacon-tag-name=beacon-table-header],[class*=beacon-on] [beacon-version="4.3.1"][beacon-tag-name=beacon-table-header],[class*=beacon-on] [beacon-version="4.3.1"] [beacon-tag-name=beacon-table-header],[beacon-version="4.3.1"][beacon-tag-name=beacon-table-header],[beacon-version="4.3.1"] [beacon-tag-name=beacon-table-header]{--table-header-dropdown-space-padding-block-start-jumbo: var(--beacon-reference-space-1);--table-header-dropdown-space-padding-block-start-normal: 0;--table-header-sort-wrapper-space-padding-block-start-normal: var(--beacon-reference-space-2);--table-header-action-zone-space-padding-block-start-normal: var(--beacon-reference-space-2)}}`, ow = ve`:host{--cell-wrapper-padding-inline-end: 0;--override-icon-button-wrapper-inline-size: var(--table-header-sort-icon-size);--override-icon-button-wrapper-block-size: var(--table-header-sort-icon-size);font:inherit;inline-size:inherit;overflow:inherit;text-align:inherit;text-transform:inherit;word-break:initial}.hide{display:none}.has-cell-padding{padding-block:var(--table-header-space-zero-value);padding-inline:var(--table-header-space-zero-value)}.table-header-wrapper{display:flex;gap:var(--beacon-reference-space-5);inline-size:var(--table-override-header-wrapper-inline-size, inherit);padding-inline-end:var(--cell-wrapper-padding-inline-end)}.table-header-wrapper .text-cell{display:flex;gap:var(--beacon-reference-space-3);inline-size:100%}.table-header-wrapper .text-cell__text{--text-cell-padding-block-start: var(--table-header-nth-cell-space-padding-block-start-normal);color:var(--beacon-system-color-text-standard);display:grid;gap:var(--beacon-reference-space-1);inline-size:inherit;padding-block-start:var(--table-header-space-zero-value);padding-inline-start:var(--table-header-space-zero-value)}.table-header-wrapper .text-cell__text .title{margin:0;font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-caption-200)}.table-header-wrapper .text-cell__text .subtitle{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-200);margin:0}.table-header-wrapper .sort-icon{--sort-icon-padding-block-start: var(--table-header-sort-wrapper-space-padding-block-start-normal);display:var(--table-override-header-sort-icon-display, initial);padding-block-start:var(--table-header-space-zero-value)}.table-header-wrapper ::slotted([slot=action-zone]){--action-zone-padding-block-start: var(--table-header-action-zone-space-padding-block-start-normal);padding-block-start:0}.table-header-wrapper select{-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:transparent;background-origin:content-box;background-position:right center;background-repeat:no-repeat;border:0;cursor:inherit;inline-size:100%;overflow:hidden;padding:0;text-overflow:ellipsis;white-space:break-spaces;word-break:break-word}.table-header-wrapper select:hover{text-decoration:underline}.table-header-wrapper .selected-value{position:absolute;visibility:hidden;white-space:nowrap}.table-header-wrapper.jumbo select,.table-header-wrapper.jumbo .selected-value,.table-header-wrapper.jumbo .title,.table-header-wrapper.jumbo .table-dropdown{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-body-100)}.table-header-wrapper.jumbo .subtitle{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100)}.table-header-wrapper.jumbo .text-cell__text{--text-cell-padding-block-start: var(--table-header-nth-cell-space-padding-block-start-jumbo)}.table-header-wrapper.jumbo .sort-icon{--sort-icon-padding-block-start: var(--table-header-sort-wrapper-space-padding-block-start-jumbo)}.table-header-wrapper.jumbo ::slotted([slot=action-zone]){--action-zone-padding-block-start: var(--table-header-action-zone-space-padding-block-start-jumbo)}.table-header-wrapper .table-dropdown{--dropdown-padding-block-start: var(--table-header-dropdown-space-padding-block-start-normal);font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-caption-200);background-color:transparent;background-image:url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M12 6L8 10L4 6" stroke="%230063AD" stroke-linecap="round" stroke-linejoin="round"/></svg>');color:var(--beacon-system-color-text-link);cursor:pointer;display:var(--table-override-header-dropdown-display, flex);padding-block-start:0}.table-header-wrapper.jumbo .table-dropdown{--dropdown-padding-block-start: var(--table-header-dropdown-space-padding-block-start-jumbo)}`;
var aw = Object.defineProperty, iw = Object.getOwnPropertyDescriptor, $t = (i, t, e, a) => {
  for (var o = a > 1 ? void 0 : a ? iw(t, e) : t, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = (a ? r(t, e, o) : r(o)) || o);
  return a && o && aw(t, e, o), o;
};
const Qc = "beacon-table-header", Hp = "aria-sort", nw = ".beacon-table", rw = ".cell", sw = "has-dropdown", lw = "headers", Kp = "display: none", Sn = "beacon-icon-button", Or = "number-of-headers", Xc = "selected", cw = ".selected-value", Gp = "sorted", dw = "sort-direction", hw = "sort-inactive", Zc = "style";
var lt;
const It = (lt = class extends Os {
  constructor() {
    super(...arguments), this.subtitle = "", this.variant = Im.NORMAL, this.dropdown = !1, this.sortable = !1, this.hasActionZone = !1, this.hasSubtitle = !1, this.sortInactive = !1, this.selectedValue = "select", this.selectedWidth = 0, this.nestedHeaders = [], this.beaconTagName = Qc, this.compare = (t, e) => this.sortDirection === Wt.ASCENDING ? t.value === e.value ? 0 : typeof t.value == "number" && typeof e.value == "number" ? t.value - e.value : t.value < e.value ? -1 : 1 : this.sortDirection === Wt.DESCENDING ? t.value === e.value ? 0 : typeof t.value == "number" && typeof e.value == "number" ? e.value - t.value : t.value > e.value ? -1 : 1 : 0, this.processNestedHeaders = (t) => {
      var e, a;
      if (t) {
        const o = (a = (e = this.parentElement) == null ? void 0 : e.parentElement) == null ? void 0 : a.children, n = o && Array.from(o);
        let r = 0;
        n && (r = this.findStartingIndex(n, t));
        for (const [T, O] of t.entries())
          O.id && this.nestedHeaders.push({
            value: O.id,
            selected: O.hasAttribute(Xc),
            colId: T + r
          });
        r && this.prepStyleObj(this.nestedHeaders);
      }
    }, this.prepStyleObj = (t) => {
      const e = document.querySelector(nw), a = e == null ? void 0 : e.querySelector(
        `${Zc}[${Or}='${this.currentIndex}']`
      );
      a && (e == null || e.removeChild(a));
      const o = `{${Kp}}`;
      let n = "";
      for (const T of t)
        T.selected || (n = `${n + lt.prepareStyleString(T.colId)},`);
      n = lt.removeLastCharacter(n);
      const r = n + o;
      e && (e.classList.contains("beacon-table--has-selected-columns") || e.classList.add("beacon-table--has-selected-columns"), lt.createStyleTag(e, r, this.currentIndex));
    };
  }
  static get styles() {
    return [super.styles, ow];
  }
  static get lightDOMStyles() {
    return [...super.lightDOMStyles, tw];
  }
  postrenderTableHeaderSetup() {
    var t;
    if (this.dropdown) {
      Gd(
        this,
        !0,
        !0,
        void 0,
        lt.setDropdownAttributes,
        lt.setSelectedAttributes,
        lt.siblingCollectionCallback
      );
      const e = (t = this.nestedHeaders.find(
        (a) => a.selected
      )) == null ? void 0 : t.value;
      this.selectedValue = e || this.selectedValue, this.adjustSelectWidth(), this.setColSpanForDropdowns();
      return;
    }
    Gd(
      this,
      !0,
      !1,
      void 0,
      void 0,
      void 0,
      lt.siblingCollectionCallback
    );
  }
  /** Sets a data attribute on the parent element equal to the columns it would span if it wasn't using the dropdown feature. */
  setColSpanForDropdowns() {
    var t;
    this.parentElement && ((t = this.subHeaderNodes) == null ? void 0 : t.length) > 0 && (this.parentElement.dataset.colSpan = this.subHeaderNodes.length.toString());
  }
  /**
   * Process while on column sort happens.
   */
  onSort() {
    var t;
    if (this.sortable) {
      const e = ((t = this.parentElement) == null ? void 0 : t.id) || "", a = lt.getParentElementHeaders(this);
      this.sortDirection === Wt.ASCENDING ? this.sortDirection = Wt.DESCENDING : this.sortDirection = Wt.ASCENDING, Re(this, Ee.SORT, { detail: { id: e, headers: a } }), this.setSortedAttr();
    }
  }
  /**
   * Sets related ARIA_SORT attribute to the parentElement th. This being used when sort happens.
   */
  setSortedAttr() {
    var t, e;
    (t = this.parentElement) == null || t.setAttribute(
      Hp,
      this.sortDirection
    ), (e = this.parentElement) == null || e.classList.add(Gp), this.sortInactive = !1;
  }
  /**
   * When Sorting happens on another columns this removes any sort attributes applied to parentElement th.
   * @param ele HTMLElement| Element
   */
  resetSortedAttr() {
    var t, e;
    this && (this.setAttribute(hw, "true"), this.removeAttribute(dw), (t = this.parentElement) == null || t.removeAttribute(Hp), (e = this.parentElement) == null || e.classList.remove(Gp));
  }
  /**
   * Based on sortInactive returns token value.
   * @returns token value.
   */
  applySvgToken() {
    return this.sortInactive ? "var(--beacon-reference-palette-grayscale-medium-gray-2)" : "var(--beacon-system-color-icon-link)";
  }
  /**
   *
   * @returns TemplateResult
   */
  handleSortIcon() {
    let t;
    return this.sortable && (this.sortDirection === Wt.ASCENDING ? t = Be`<${this.getScopedTag(Sn)}
          @beacon-event-click="${this.onSort}"
          id="${Wt.ASCENDING}"
          variant="tertiary"
          class="sort-icon"
        >
          Sorted Ascending
          <svg slot="icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M8 3L12 8H8.5L8.5 13H7.5L7.5 8H4L8 3Z" style="fill: ${this.applySvgToken()}" />
          </svg>
        </${this.getScopedTag(Sn)}>` : this.sortDirection === Wt.DESCENDING ? t = Be`<${this.getScopedTag(Sn)}
          @beacon-event-click="${this.onSort}"
          id="${Wt.DESCENDING}"
          variant="tertiary"
          class="sort-icon"
        >
          Sorted Descending
          <svg slot="icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M8.5 8L8.5 3H7.5L7.5 8H4L8 13L12 8H8.5Z"
              style="fill: ${this.applySvgToken()}"
            />
          </svg>
        </${this.getScopedTag(Sn)}> ` : t = Be`<${this.getScopedTag(Sn)}
          @beacon-event-click="${this.onSort}"
          id="sort"
          variant="tertiary"
          class="sort-icon"
        >
          Sort
          <svg slot="icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M8 2L11 6H5L8 2ZM8 14L5 10H11L8 14Z" style="fill: ${this.applySvgToken()}" />
          </svg>
        </${this.getScopedTag(Sn)}>`), t || pe``;
  }
  /**
   * Triggers when selection change happens to dropdown.
   * @param event
   */
  async handleSelectChange(t) {
    const { target: e } = t;
    e && (this.selectedValue = e.value), this.resetSortedAttr(), await this.updateComplete.then(() => (this.updateNestedHeaders(), this.prepStyleObj(this.nestedHeaders), this.adjustSelectWidth()));
  }
  /**
   * It processes nestedHeaders based on provided array.
   */
  updateNestedHeaders() {
    this.nestedHeaders && this.nestedHeaders.forEach((t) => {
      t.selected ? t.selected = !1 : t.value === this.selectedValue && (t.selected = !0);
    });
  }
  /**
   * While Dropdown is true, this will update correct spacing for the arrow icon and text.
   */
  async adjustSelectWidth() {
    var a, o, n;
    await this.updateComplete;
    const t = this.shadowRoot && ((a = this.shadowRoot) == null ? void 0 : a.querySelector(cw)), e = this.shadowRoot && ((o = this.shadowRoot) == null ? void 0 : o.querySelector(rw));
    if (t && e) {
      const r = (n = window.getComputedStyle(e)) == null ? void 0 : n.paddingLeft, T = r && parseInt(r, 10) || 0, O = t.offsetWidth;
      O < e.offsetWidth - T ? this.selectedWidth = O + 4 : this.selectedWidth = 0;
    }
  }
  /**
   * Pass collection of below elements to return from what could be the starting index for particular table-header.
   * @param parentElsArr Element[] - Collection of parentElement[]
   * @param currentEl Element[] - Collection of currentElement[]
   * @returns number
   */
  findStartingIndex(t, e) {
    this.setAttribute(Or, e.length.toString()), this.currentIndex = t == null ? void 0 : t.findIndex(
      (o) => o === this.parentElement
    );
    let a = 0;
    for (let o = 0; o < this.currentIndex; o += 1) {
      const n = t[o];
      if (n) {
        const r = n.firstElementChild;
        if (r && r.hasAttribute(Or)) {
          const T = r.getAttribute(Or);
          T && (a = parseInt(T, 10) + a);
        } else
          a = a + 1;
      }
    }
    return a;
  }
  /**
   * Provided string to be checked if it has any extra comma available at the end and it will remove it.
   * @param str string
   * @returns string
   */
  static removeLastCharacter(t) {
    let e = "";
    return t && t.lastIndexOf(",") === t.length - 1 && (e = t.substring(0, t.length - 1)), e;
  }
  /**
   * Based on index will prepare string to hide column.
   * @param index number
   * @returns string
   */
  static prepareStyleString(t) {
    return `.beacon-table--has-selected-columns td:nth-of-type(${t})`;
  }
  /**
   * Sets state variable dependent on slotted action-zone elements
   */
  actionZoneSlotChange() {
    var t;
    this.hasActionZone = !!((t = this.slottedActionZone) != null && t.length);
  }
  /**
   * Action zone render method that conditionally hides padding based on `hasActionZone` state variable
   */
  renderActionZone() {
    const t = {
      "has-cell-padding": !0,
      "action-cell": !0,
      hide: !this.hasActionZone
    };
    return pe`
      <div class=${Oe(t)}>
        <slot
          name="action-zone"
          @slotchange=${this.actionZoneSlotChange}></slot>
      </div>
    `;
  }
  /**
   * Sets state variable dependent on slotted subtitle element or property content
   *
   */
  subtitleSlotChange() {
    var t;
    this.hasSubtitle = !!((t = this.slottedSubtitle) != null && t.length) || !!this.subtitle;
  }
  /**
   * Renders subtitle html with conditional rendering of `.hide` class
   * Need to hide subtitle to prevent css from adding `gap` space within elements of `text-cell__text`
   */
  renderSubtitle() {
    const t = {
      subtitle: !0,
      hide: !this.hasSubtitle
    };
    return pe`
      <p class=${Oe(t)}>
        <slot @slotchange=${this.subtitleSlotChange} name="subtitle"
          >${this.subtitle}</slot
        >
      </p>
    `;
  }
  render() {
    return pe`<div class="table-header-wrapper ${this.variant}">
      <div class="has-cell-padding text-cell" part="text-cell">
        <div class="text-cell__text">
          <p class="title" id="header-title">
            <slot></slot>
          </p>
          ${this.renderSubtitle()}
          ${this.dropdown ? pe`<select
                  id="select"
                  @change="${this.handleSelectChange}"
                  style="background-position: ${this.selectedWidth ? `${this.selectedWidth}px` : "left 100% top 50%"};
                width: ${this.selectedWidth ? "100%" : "calc(100% + 4px)"}"
                  name="dropdown"
                  class="table-dropdown"
                  value=${this.selectedValue}
                  aria-label="${this.selectedValue}">
                  ${this.nestedHeaders ? this.nestedHeaders.map(
      (t) => pe`<option ?selected=${t.selected}>
                            ${t.value}
                          </option>`
    ) : _e}
                </select>
                <span class="selected-value" aria-hidden="true"
                  >${this.selectedValue}</span
                >` : _e}
        </div>
        ${this.sortable ? this.handleSortIcon() : _e}
      </div>
      ${this.renderActionZone()}
    </div> `;
  }
}, lt.tagName = Qc, lt.nestedComponents = [eo], lt.getParentElementHeaders = (t) => {
  let e = "";
  return t && t.parentElement && (e = t.parentElement.getAttribute(lw) || ""), e;
}, lt.getSelectedFromElements = (t) => {
  let e;
  return t && t.length && (e = (t == null ? void 0 : t.find((a) => a.hasAttribute(Xc))) || t[0]), e;
}, lt.createStyleTag = (t, e, a) => {
  if (t) {
    const o = document.createElement(Zc);
    o.innerText = `${e}`, o.setAttribute(Or, a.toString()), t == null || t.appendChild(o);
  }
}, lt.setDropdownAttributes = (t) => {
  var e;
  t.setAttribute(Zc, Kp), (e = t.parentElement) == null || e.setAttribute(sw, "");
}, lt.siblingCollectionCallback = (t, e) => {
  const a = [];
  t.map(
    (n) => n.querySelector(e.getScopedTagName(Qc))
  ).forEach((n) => {
    n && n instanceof lt && a.push(n);
  }), e.subHeaderNodes = a;
}, lt.setSelectedAttributes = (t, e) => {
  const a = lt.getSelectedFromElements(t);
  a == null || a.setAttribute(Xc, ""), e.processNestedHeaders(t);
}, lt);
$t([
  ue({
    reflect: !0,
    alternateSlot: "subtitle",
    sync: !1
  })
], It.prototype, "subtitle", 2);
$t([
  ue({ reflect: !0 })
], It.prototype, "variant", 2);
$t([
  ue({ attribute: "dropdown", type: Boolean, reflect: !0 })
], It.prototype, "dropdown", 2);
$t([
  ue({ attribute: "sortable", type: Boolean, reflect: !0 })
], It.prototype, "sortable", 2);
$t([
  Se()
], It.prototype, "hasActionZone", 2);
$t([
  Se()
], It.prototype, "hasSubtitle", 2);
$t([
  ue({ attribute: "sort-direction", reflect: !0 })
], It.prototype, "sortDirection", 2);
$t([
  ue({ attribute: "sort-inactive", type: Boolean, reflect: !0 })
], It.prototype, "sortInactive", 2);
$t([
  Pe({ flatten: !0, slot: "action-zone" })
], It.prototype, "slottedActionZone", 2);
$t([
  Pe({ flatten: !0, slot: "subtitle" })
], It.prototype, "slottedSubtitle", 2);
$t([
  Se()
], It.prototype, "selectedValue", 2);
$t([
  Se()
], It.prototype, "selectedWidth", 2);
$t([
  Se()
], It.prototype, "subHeaderNodes", 2);
$t([
  Se()
], It.prototype, "nestedHeaders", 2);
$t([
  Se()
], It.prototype, "currentIndex", 2);
$t([
  De
], It.prototype, "postrenderTableHeaderSetup", 1);
let Jc = It;
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
let Wd = class extends Pa {
  constructor(t) {
    if (super(t), this.it = _e, t.type !== ln.CHILD) throw Error(this.constructor.directiveName + "() can only be used in child bindings");
  }
  render(t) {
    if (t === _e || t == null) return this._t = void 0, this.it = t;
    if (t === Qo) return t;
    if (typeof t != "string") throw Error(this.constructor.directiveName + "() called with a non-string value");
    if (t === this.it) return this._t;
    this.it = t;
    const e = [t];
    return e.raw = e, this._t = { _$litType$: this.constructor.resultType, strings: e, values: [] };
  }
};
Wd.directiveName = "unsafeHTML", Wd.resultType = 1;
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
let qd = class extends Wd {
};
qd.directiveName = "unsafeSVG", qd.resultType = 2;
const ut = Oa(qd), bw = `<svg role="img" aria-label="down" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 11.5L3 4L13 4L8 11.5Z" fill="var(--beacon-system-color-icon-error, #DD3636)"/>
</svg>`, pw = `<svg role="img" aria-label="up" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 4L13 11.5H3L8 4Z" fill="var(--beacon-system-color-icon-positive, #248647)"/>
</svg>`, uw = ve`:root[beacon-tag-name=beacon-table-record],:root [beacon-tag-name=beacon-table-record],[beacon-version="4.3.1"][class*=beacon-on][beacon-tag-name=beacon-table-record],[beacon-version="4.3.1"][class*=beacon-on] [beacon-tag-name=beacon-table-record],[class*=beacon-on] [beacon-version="4.3.1"][beacon-tag-name=beacon-table-record],[class*=beacon-on] [beacon-version="4.3.1"] [beacon-tag-name=beacon-table-record],[beacon-version="4.3.1"][beacon-tag-name=beacon-table-record],[beacon-version="4.3.1"] [beacon-tag-name=beacon-table-record]{--table-record-zero-value: 0;--table-record-inline-size-content: fit-content;--table-record-unset: unset;--table-record-numeral-gap: 0 var(--beacon-reference-space-4);--table-record-space-margin-inline-end-default: var(--beacon-reference-space-2);--table-record-space-margin-inline-start-default: var(--beacon-reference-space-1)}@media (width >= 640px){:root[beacon-tag-name=beacon-table-record],:root [beacon-tag-name=beacon-table-record],[beacon-version="4.3.1"][class*=beacon-on][beacon-tag-name=beacon-table-record],[beacon-version="4.3.1"][class*=beacon-on] [beacon-tag-name=beacon-table-record],[class*=beacon-on] [beacon-version="4.3.1"][beacon-tag-name=beacon-table-record],[class*=beacon-on] [beacon-version="4.3.1"] [beacon-tag-name=beacon-table-record],[beacon-version="4.3.1"][beacon-tag-name=beacon-table-record],[beacon-version="4.3.1"] [beacon-tag-name=beacon-table-record]{--table-record-space-margin-inline-start-default: var(--beacon-reference-space-2)}}@media (width >= 960px){:root[beacon-tag-name=beacon-table-record],:root [beacon-tag-name=beacon-table-record],[beacon-version="4.3.1"][class*=beacon-on][beacon-tag-name=beacon-table-record],[beacon-version="4.3.1"][class*=beacon-on] [beacon-tag-name=beacon-table-record],[class*=beacon-on] [beacon-version="4.3.1"][beacon-tag-name=beacon-table-record],[class*=beacon-on] [beacon-version="4.3.1"] [beacon-tag-name=beacon-table-record],[beacon-version="4.3.1"][beacon-tag-name=beacon-table-record],[beacon-version="4.3.1"] [beacon-tag-name=beacon-table-record]{--table-record-space-margin-inline-end-default: var(--beacon-reference-space-4);--table-record-space-margin-inline-start-default: var(--beacon-reference-space-4)}}`, gw = ve`[beacon-tag-name=beacon-table-record][variant=text] :is(h1,h2,h3,h4,h5,h6){font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100)}[beacon-tag-name=beacon-table-record][variant=text] *{margin:0}[beacon-tag-name=beacon-table-record][variant=text]>*+*{margin-block-start:var(--record-text-content-space, var(--beacon-reference-space-5))}[beacon-tag-name=beacon-table-record][variant=text] :last-child{--record-text-content-space: var(--beacon-reference-space-3)}[beacon-tag-name=beacon-table-record] p{margin:0}[beacon-tag-name=beacon-table-record] [beacon-tag-name=beacon-icon-button]{padding:0}[beacon-tag-name=beacon-table-record] [beacon-tag-name=beacon-icon-button]:not(:last-child){margin-inline-end:var(--beacon-reference-space-2)}`, mw = ve`:host{color:var(--beacon-system-color-text-standard);inline-size:inherit;word-break:initial}.has-cell-padding{padding-block:0;padding-inline:0}.record-cell-wrapper{--margin-end: var(--table-record-space-margin-inline-end-default);--margin-start: var(--table-record-space-margin-inline-start-default);display:flex;gap:var(--beacon-reference-space-5);margin-inline:0}:host([variant=numeral]) .record-cell-wrapper,:host([variant=date]) .record-cell-wrapper,:host([variant=icons]) .record-cell-wrapper{--margin-end: var(--table-record-space-margin-inline-end-default);--margin-start: var(--table-record-space-margin-inline-start-default)}:host([sorting][variant=numeral]) .record-cell-wrapper,:host([sorting][variant=date]) .record-cell-wrapper,:host([sorting][variant=icons]) .record-cell-wrapper{--margin-end: var(--beacon-reference-space-7)}.record-numeral{align-items:flex-end;display:flex;flex-wrap:wrap;gap:var(--table-record-numeral-gap);justify-content:end;margin-block-end:0}.no-content{color:var(--beacon-system-color-text-inactive)}.record-na{color:var(--beacon-system-color-text-standard)}.record-cell{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100);flex-grow:1;margin-block-start:0}.record-cell:is(.numeral,.date){display:grid;gap:var(--beacon-reference-space-1);text-align:end}.record-cell.icons{align-items:center;display:flex;justify-content:end}.record-cell.bold .record-na,.record-cell.sorted .record-na{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-body-100)}.record-delta{align-items:center;display:flex;gap:var(--beacon-reference-space-1)}.record-delta-value{color:var(--beacon-system-color-text-standard)}.record-delta-icon{block-size:var(--beacon-reference-space-5);display:inline-block;inline-size:var(--beacon-reference-space-5)}.record-footnote{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-200);color:var(--beacon-system-color-text-standard);margin:0}.empty{display:none}.action-zone:not(.empty){display:var(--table-record-zero-value, grid);grid-template-rows:0;inline-size:var(--table-record-inline-size-content);margin-block-start:0;place-items:center}.hide{display:none}`;
var fw = Object.defineProperty, vw = Object.getOwnPropertyDescriptor, _o = (i, t, e, a) => {
  for (var o = a > 1 ? void 0 : a ? vw(t, e) : t, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = (a ? r(t, e, o) : r(o)) || o);
  return a && o && fw(t, e, o), o;
};
const Wp = "beacon-table-record", Aw = pe`&#8212`;
var ni;
const wo = (ni = class extends Os {
  constructor() {
    super(...arguments), this.beaconTagName = Wp, this.variant = fa.TEXT, this.sorted = !1, this.hasActionZoneContent = !1;
  }
  static get styles() {
    return [super.styles, mw];
  }
  static get lightDOMStyles() {
    return [...super.lightDOMStyles, gw, uw];
  }
  /**
   * Returns sign of delta to determine delta icon styles
   *
   * @returns true/false for positive/negative respectively
   */
  get deltaPositive() {
    return this.slottedDelta > 0;
  }
  setActionZoneStatus() {
    this.hasActionZoneContent = this.actionZone.length > 0;
  }
  deltaSlotChange() {
    let t;
    this.slottedDeltaNodes.length > 0 && (t = this.slottedDeltaNodes.map((e) => {
      var a, o;
      return (o = (a = e.textContent) == null ? void 0 : a.trim()) != null ? o : "";
    }).join("")), t && (this.slottedDelta = parseFloat(t));
  }
  /**
   * Renders slot element with default styles
   * @returns default empty slot styles
   */
  static renderSlot() {
    return pe`<span class="record-na"
      ><slot><span class="no-content">${Aw}</span></slot></span
    >`;
  }
  /**
   * Renders numeral and delta with proper spacing
   * @returns HTML template for numeral element in numeral record
   */
  renderNumeral() {
    const t = this.slottedDelta && !this.hideDeltaIcon ? pe`<span class="record-delta-icon">
            ${this.deltaPositive ? ut(pw) : ut(bw)}
          </span>` : pe``, e = {
      "record-delta-value": !0,
      hide: !this.slottedDelta || this.hideDeltaValue
    };
    return pe` <span class="record-delta"> ${t}<span class=${Oe(e)}><slot name="delta" @slotchange=${this.deltaSlotChange}></span></slot></span>${ni.renderSlot()}`;
  }
  /**
   * Conditionally renders cell contents
   * @returns HTML template according to variant type
   */
  renderCell() {
    switch (this.variant) {
      case fa.NUMERAL:
        return pe`<div class="record-numeral">${this.renderNumeral()}</div>
          <p class="record-footnote"><slot name="footnote"></slot></p>`;
      case fa.DATE:
      case fa.TEXT:
      case fa.ICONS:
      default:
        return ni.renderSlot();
    }
  }
  /**
   * Default render function
   * @returns HTML template for table record component
   */
  render() {
    return pe`<div class="record-cell-wrapper" part="cell-wrapper">
      <div
        class="has-cell-padding record-cell ${this.bold ? "bold" : ""} ${this.sorted ? "sorted" : ""} ${this.variant}"
        part="cell">
        ${this.renderCell()}
      </div>
      ${this.variant === fa.NUMERAL ? pe`<div
            class="action-zone ${Oe({
      empty: !this.hasActionZoneContent
    })}"
            part="action-zone">
            <slot name="action-zone"></slot>
          </div>` : pe``}
    </div>`;
  }
}, ni.tagName = Wp, ni);
_o([
  ue({ reflect: !0 })
], wo.prototype, "variant", 2);
_o([
  Se()
], wo.prototype, "slottedDelta", 2);
_o([
  gc({ flatten: !0, slot: "delta" })
], wo.prototype, "slottedDeltaNodes", 2);
_o([
  ue({ attribute: "sort-value", reflect: !0 })
], wo.prototype, "sortValue", 2);
_o([
  ue({ type: Boolean, reflect: !0 })
], wo.prototype, "bold", 2);
_o([
  ue({ type: Boolean, reflect: !0 })
], wo.prototype, "sorted", 2);
_o([
  ue({ type: Boolean, reflect: !0, attribute: "hide-delta-icon" })
], wo.prototype, "hideDeltaIcon", 2);
_o([
  ue({
    type: Boolean,
    reflect: !0,
    attribute: "hide-delta-value"
  })
], wo.prototype, "hideDeltaValue", 2);
_o([
  Se()
], wo.prototype, "hasActionZoneContent", 2);
_o([
  Pe({ slot: "action-zone" })
], wo.prototype, "actionZone", 2);
_o([
  De
], wo.prototype, "setActionZoneStatus", 1);
let ed = wo;
var Do = /* @__PURE__ */ ((i) => (i.NORMAL = "normal", i.MINI = "mini", i.JUMBO = "jumbo", i.MAXI = "maxi", i))(Do || {}), tn = /* @__PURE__ */ ((i) => (i.NORMAL = "normal", i.MINI = "mini", i.JUMBO = "jumbo", i))(tn || {});
const Hm = `<svg slot="suffix" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
<path d="M12 6L8 10L4 6" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" />
</svg>`, yw = `<svg slot="suffix" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
<path d="M4 10L8 6L12 10" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" />
</svg>`, xw = (i, t, e) => {
  const a = i[t];
  return a ? typeof a == "function" ? a() : Promise.resolve(a) : new Promise((o, n) => {
    (typeof queueMicrotask == "function" ? queueMicrotask : setTimeout)(
      n.bind(
        null,
        new Error(
          "Unknown variable dynamic import: " + t + (t.split("/").length !== e ? ". Note that variables only represent file names one level deep." : "")
        )
      )
    );
  });
};
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const ww = Symbol();
let kw = class {
  get taskComplete() {
    return this.t || (this.i === 1 ? this.t = new Promise((t, e) => {
      this.o = t, this.h = e;
    }) : this.i === 3 ? this.t = Promise.reject(this.l) : this.t = Promise.resolve(this.u)), this.t;
  }
  constructor(t, e, a) {
    var n, r, T;
    this.p = 0, this.i = 0, (this._ = t).addController(this);
    const o = typeof e == "object" ? e : { task: e, args: a };
    this.v = o.task, this.j = o.args, this.m = (n = o.argsEqual) != null ? n : Cw, this.k = o.onComplete, this.A = o.onError, this.autoRun = (r = o.autoRun) != null ? r : !0, "initialValue" in o && (this.u = o.initialValue, this.i = 2, this.O = (T = this.T) == null ? void 0 : T.call(this));
  }
  hostUpdate() {
    this.autoRun === !0 && this.S();
  }
  hostUpdated() {
    this.autoRun === "afterUpdate" && this.S();
  }
  T() {
    if (this.j === void 0) return;
    const t = this.j();
    if (!Array.isArray(t)) throw Error("The args function must return an array");
    return t;
  }
  async S() {
    const t = this.T(), e = this.O;
    this.O = t, t === e || t === void 0 || e !== void 0 && this.m(e, t) || await this.run(t);
  }
  async run(t) {
    var r, T, O, j, D;
    let e, a;
    t != null || (t = this.T()), this.O = t, this.i === 1 ? (r = this.q) == null || r.abort() : (this.t = void 0, this.o = void 0, this.h = void 0), this.i = 1, this.autoRun === "afterUpdate" ? queueMicrotask(() => this._.requestUpdate()) : this._.requestUpdate();
    const o = ++this.p;
    this.q = new AbortController();
    let n = !1;
    try {
      e = await this.v(t, { signal: this.q.signal });
    } catch (F) {
      n = !0, a = F;
    }
    if (this.p === o) {
      if (e === ww) this.i = 0;
      else {
        if (n === !1) {
          try {
            (T = this.k) == null || T.call(this, e);
          } catch {
          }
          this.i = 2, (O = this.o) == null || O.call(this, e);
        } else {
          try {
            (j = this.A) == null || j.call(this, a);
          } catch {
          }
          this.i = 3, (D = this.h) == null || D.call(this, a);
        }
        this.u = e, this.l = a;
      }
      this._.requestUpdate();
    }
  }
  abort(t) {
    var e;
    this.i === 1 && ((e = this.q) == null || e.abort(t));
  }
  get value() {
    return this.u;
  }
  get error() {
    return this.l;
  }
  get status() {
    return this.i;
  }
  render(t) {
    var e, a, o, n;
    switch (this.i) {
      case 0:
        return (e = t.initial) == null ? void 0 : e.call(t);
      case 1:
        return (a = t.pending) == null ? void 0 : a.call(t);
      case 2:
        return (o = t.complete) == null ? void 0 : o.call(t, this.value);
      case 3:
        return (n = t.error) == null ? void 0 : n.call(t, this.error);
      default:
        throw Error("Unexpected status: " + this.i);
    }
  }
};
const Cw = (i, t) => i === t || i.length === t.length && i.every((e, a) => !rc(e, t[a])), Km = /* @__PURE__ */ new Map([["facebook", "social"], ["instagram", "social"], ["linkedin", "social"], ["twitter", "social"], ["x", "social"], ["youtube", "social"], ["account", "functional"], ["add", "functional"], ["alert", "functional"], ["audio", "functional"], ["bookmark", "functional"], ["bookmark_filled", "functional"], ["calculator", "functional"], ["calendar", "functional"], ["card", "functional"], ["chart_area", "functional"], ["chart_bar_horizontal", "functional"], ["chart_bar_vertical", "functional"], ["chart_distribution", "functional"], ["chart_line", "functional"], ["chart_pie", "functional"], ["chat", "functional"], ["chevron_down", "functional"], ["chevron_left", "functional"], ["chevron_left_small", "functional"], ["chevron_right", "functional"], ["chevron_right_small", "functional"], ["chevron_up", "functional"], ["clear", "functional"], ["close", "functional"], ["close_small", "functional"], ["collapse", "functional"], ["correct", "functional"], ["dashboard", "functional"], ["decrease", "functional"], ["download", "functional"], ["edit", "functional"], ["email", "functional"], ["expand", "functional"], ["external_link", "functional"], ["filetype_doc", "functional"], ["filetype_pdf", "functional"], ["filetype_pdf_icon", "functional"], ["filetype_pps", "functional"], ["filetype_ppt", "functional"], ["filetype_rar", "functional"], ["filetype_rtf", "functional"], ["filetype_txt", "functional"], ["filetype_xls", "functional"], ["filetype_zip", "functional"], ["filter", "functional"], ["first", "functional"], ["folder", "functional"], ["full_screen", "functional"], ["full_screen_exit", "functional"], ["globe", "functional"], ["grid", "functional"], ["help", "functional"], ["hide", "functional"], ["home", "functional"], ["incorrect", "functional"], ["increase", "functional"], ["information", "functional"], ["language", "functional"], ["last", "functional"], ["link", "functional"], ["list", "functional"], ["locked", "functional"], ["login", "functional"], ["logout", "functional"], ["menu", "functional"], ["new_window", "functional"], ["notification", "functional"], ["overflow", "functional"], ["overflow_horizontal", "functional"], ["pause", "functional"], ["phone", "functional"], ["pin", "functional"], ["placeholder", "functional"], ["play", "functional"], ["playlist_video", "functional"], ["print", "functional"], ["reload", "functional"], ["remove", "functional"], ["rotate", "functional"], ["save", "functional"], ["search", "functional"], ["settings", "functional"], ["share", "functional"], ["share_ios", "functional"], ["show", "functional"], ["sort", "functional"], ["sorted_down", "functional"], ["sorted_up", "functional"], ["star", "functional"], ["star_filled", "functional"], ["support", "functional"], ["table", "functional"], ["trash", "functional"], ["unlocked", "functional"], ["upload", "functional"], ["user", "functional"], ["validation", "functional"], ["video", "functional"], ["zoom_in", "functional"], ["zoom_out", "functional"], ["apac", "flags"], ["australia", "flags"], ["austria", "flags"], ["belgium", "flags"], ["canada", "flags"], ["chile", "flags"], ["china", "flags"], ["colombia", "flags"], ["denmark", "flags"], ["estonia", "flags"], ["finland", "flags"], ["france", "flags"], ["germany", "flags"], ["greece", "flags"], ["guernsey", "flags"], ["hong_kong", "flags"], ["iceland", "flags"], ["ireland", "flags"], ["italy", "flags"], ["japan", "flags"], ["jersey", "flags"], ["latvia", "flags"], ["liechtenstein", "flags"], ["lithuania", "flags"], ["luxembourg", "flags"], ["malaysia", "flags"], ["mexico", "flags"], ["netherlands", "flags"], ["new_zealand", "flags"], ["norway", "flags"], ["portugal", "flags"], ["singapore", "flags"], ["south_africa", "flags"], ["south_korea", "flags"], ["spain", "flags"], ["sweden", "flags"], ["switzerland", "flags"], ["taiwan", "flags"], ["thailand", "flags"], ["uae", "flags"], ["united_kingdom", "flags"], ["usa", "flags"], ["trusty", "brand"]]), Sw = {
  skipPreRender: !1
};
var Ui, bs, ps, Yd;
const Yr = class Yr extends Pa {
  constructor(e) {
    super(e);
    Fe(this, Ui);
    Fe(this, bs);
    const { type: a, element: o, options: n } = e;
    if (a !== ln.ELEMENT || !(o instanceof HTMLSlotElement))
      throw new Error(
        "The `whiteSpaceSensitive` directive must be used on a `<slot>` element."
      );
    if (Ne(this, Ui, o), ze(this, Ui).name)
      throw new Error(
        "The `whiteSpaceSensitive` directive should only go on default slots."
      );
    n != null && n.host && Ne(this, bs, n.host);
  }
  render(e) {
    var n;
    const a = Object.assign({ ...Sw }, e), { skipPreRender: o } = a;
    o || Ze(n = Yr, ps, Yd).call(n, ze(this, bs).childNodes), ze(this, Ui).addEventListener("slotchange", (r) => {
      var O;
      const T = ze(this, Ui).assignedNodes();
      Ze(O = Yr, ps, Yd).call(O, T);
    });
  }
};
Ui = new WeakMap(), bs = new WeakMap(), ps = new WeakSet(), Yd = function(e) {
  e.forEach((a) => {
    var o;
    a.nodeType !== Node.COMMENT_NODE && (a instanceof HTMLElement && a.slot || !((o = a.textContent) != null && o.trim()) && a instanceof Text && a.remove());
  });
}, Fe(Yr, ps);
let Vd = Yr;
const Rh = Oa(Vd), qp = {
  beaconTagName: "beacon-icon"
}, td = {
  Small: "s",
  Medium: "m",
  Large: "l"
}, Ew = ve`.beacon-on-dark,.beacon-on-dark [beacon-version="4.3.1"][beacon-tag-name=beacon-icon],.beacon-on-dark[beacon-version="4.3.1"][beacon-tag-name=beacon-icon],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark [beacon-version="4.3.1"][beacon-tag-name=beacon-icon],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark[beacon-version="4.3.1"][beacon-tag-name=beacon-icon],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark [beacon-version="4.3.1"][beacon-tag-name=beacon-icon],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark[beacon-version="4.3.1"][beacon-tag-name=beacon-icon],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark [beacon-version="4.3.1"][beacon-tag-name=beacon-icon],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark[beacon-version="4.3.1"][beacon-tag-name=beacon-icon],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark [beacon-version="4.3.1"][beacon-tag-name=beacon-icon],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark[beacon-version="4.3.1"][beacon-tag-name=beacon-icon],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark [beacon-version="4.3.1"][beacon-tag-name=beacon-icon],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark[beacon-version="4.3.1"][beacon-tag-name=beacon-icon],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark [beacon-version="4.3.1"][beacon-tag-name=beacon-icon],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark[beacon-version="4.3.1"][beacon-tag-name=beacon-icon],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark [beacon-version="4.3.1"][beacon-tag-name=beacon-icon],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark[beacon-version="4.3.1"][beacon-tag-name=beacon-icon],[class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark [beacon-version="4.3.1"][beacon-tag-name=beacon-icon],[class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark[beacon-version="4.3.1"][beacon-tag-name=beacon-icon],[class*=beacon-on-] .beacon-on-dark [beacon-version="4.3.1"][beacon-tag-name=beacon-icon],[class*=beacon-on-] .beacon-on-dark[beacon-version="4.3.1"][beacon-tag-name=beacon-icon],.beacon-on-darker,.beacon-on-darker [beacon-version="4.3.1"][beacon-tag-name=beacon-icon],.beacon-on-darker[beacon-version="4.3.1"][beacon-tag-name=beacon-icon],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker [beacon-version="4.3.1"][beacon-tag-name=beacon-icon],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker[beacon-version="4.3.1"][beacon-tag-name=beacon-icon],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker [beacon-version="4.3.1"][beacon-tag-name=beacon-icon],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker[beacon-version="4.3.1"][beacon-tag-name=beacon-icon],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker [beacon-version="4.3.1"][beacon-tag-name=beacon-icon],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker[beacon-version="4.3.1"][beacon-tag-name=beacon-icon],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker [beacon-version="4.3.1"][beacon-tag-name=beacon-icon],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker[beacon-version="4.3.1"][beacon-tag-name=beacon-icon],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker [beacon-version="4.3.1"][beacon-tag-name=beacon-icon],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker[beacon-version="4.3.1"][beacon-tag-name=beacon-icon],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker [beacon-version="4.3.1"][beacon-tag-name=beacon-icon],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker[beacon-version="4.3.1"][beacon-tag-name=beacon-icon],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker [beacon-version="4.3.1"][beacon-tag-name=beacon-icon],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker[beacon-version="4.3.1"][beacon-tag-name=beacon-icon],[class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker [beacon-version="4.3.1"][beacon-tag-name=beacon-icon],[class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker[beacon-version="4.3.1"][beacon-tag-name=beacon-icon],[class*=beacon-on-] .beacon-on-darker [beacon-version="4.3.1"][beacon-tag-name=beacon-icon],[class*=beacon-on-] .beacon-on-darker[beacon-version="4.3.1"][beacon-tag-name=beacon-icon]{--beacon-icon-g-path-1877F2: #fff;--beacon-icon-g-path-fff: none;--beacon-icon-g-path-000: #fff;--beacon-icon-svg-path-ED1D24: #fff;--beacon-icon-g-path-1D9BF0: #fff;--beacon-icon-g-path-0A66C2: #fff;--beacon-icon-g-path-urlg: #fff}`, Tw = ve`:host{--icon-size-small: 16px;--icon-size-medium: 24px;--icon-size-large: 40px;--icon-size-small-pictogram: 48px;--icon-size-large-pictogram: 64px;--icon-size-flag: 20px;color:inherit;display:inline-block;pointer-events:none}.icon{inline-size:var(--icon-size, var(--icon-size-small))}.icon:is(.functional,.brand).sm{--icon-size: var(--icon-size-small)}.icon:is(.functional,.brand).md{--icon-size: var(--icon-size-medium)}.icon:is(.functional,.brand).lg{--icon-size: var(--icon-size-large)}.icon.flags{--icon-size: var(--icon-size-flag)}.icon.social.sm{--icon-size: var(--icon-size-small)}.icon.social:is(.md,.lg){--icon-size: var(--icon-size-medium)}svg{block-size:100%;display:block;fill:currentcolor;inline-size:100%}`;
var Mw = Object.defineProperty, Lw = Object.getOwnPropertyDescriptor, Ps = (i, t, e, a) => {
  for (var o = a > 1 ? void 0 : a ? Lw(t, e) : t, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = (a ? r(t, e, o) : r(o)) || o);
  return a && o && Mw(t, e, o), o;
}, us, Lo;
const ur = (Lo = class extends Le {
  constructor() {
    super(...arguments);
    Fe(this, us);
    this.beaconTagName = qp.beaconTagName, this.componentModeStyles = [Ew], this.label = "", this.size = td.Small, Ne(this, us, new kw(this, {
      args: () => [this.name],
      task: async ([e]) => e ? await xw(/* @__PURE__ */ Object.assign({ "../../icons/assets/brand/trusty.svg": () => import("./trusty-CLxP9xBt.js"), "../../icons/assets/flags/apac.svg": () => import("./apac-fSDtE4Hl.js"), "../../icons/assets/flags/australia.svg": () => import("./australia-gEnerx5I.js"), "../../icons/assets/flags/austria.svg": () => import("./austria-B1Z7YXZA.js"), "../../icons/assets/flags/belgium.svg": () => import("./belgium-Ck5q8G-e.js"), "../../icons/assets/flags/canada.svg": () => import("./canada-DB_gE70m.js"), "../../icons/assets/flags/chile.svg": () => import("./chile-Cv47HTqq.js"), "../../icons/assets/flags/china.svg": () => import("./china-DpsrhAnj.js"), "../../icons/assets/flags/colombia.svg": () => import("./colombia-C2U2OIK0.js"), "../../icons/assets/flags/denmark.svg": () => import("./denmark-tkSciTPR.js"), "../../icons/assets/flags/estonia.svg": () => import("./estonia-DJKWgrWe.js"), "../../icons/assets/flags/finland.svg": () => import("./finland-D162hwnK.js"), "../../icons/assets/flags/france.svg": () => import("./france-B-UVZUom.js"), "../../icons/assets/flags/germany.svg": () => import("./germany-MSzMT8rL.js"), "../../icons/assets/flags/greece.svg": () => import("./greece-BuKtTo2r.js"), "../../icons/assets/flags/guernsey.svg": () => import("./guernsey-B1p49K7f.js"), "../../icons/assets/flags/hong_kong.svg": () => import("./hong_kong-6jw7arc4.js"), "../../icons/assets/flags/iceland.svg": () => import("./iceland-DfSx4Tbt.js"), "../../icons/assets/flags/ireland.svg": () => import("./ireland-BVJXIiF_.js"), "../../icons/assets/flags/italy.svg": () => import("./italy-BYIg_kjJ.js"), "../../icons/assets/flags/japan.svg": () => import("./japan-C0jb46ja.js"), "../../icons/assets/flags/jersey.svg": () => import("./jersey-DUgzd-C3.js"), "../../icons/assets/flags/latvia.svg": () => import("./latvia--0h4WoPQ.js"), "../../icons/assets/flags/liechtenstein.svg": () => import("./liechtenstein-DIbj1820.js"), "../../icons/assets/flags/lithuania.svg": () => import("./lithuania-El_0rTxn.js"), "../../icons/assets/flags/luxembourg.svg": () => import("./luxembourg-Dgtrn686.js"), "../../icons/assets/flags/malaysia.svg": () => import("./malaysia-bFrHGvAn.js"), "../../icons/assets/flags/mexico.svg": () => import("./mexico-CptgWUl0.js"), "../../icons/assets/flags/netherlands.svg": () => import("./netherlands-5emYjBLf.js"), "../../icons/assets/flags/new_zealand.svg": () => import("./new_zealand-EPiaTnTq.js"), "../../icons/assets/flags/norway.svg": () => import("./norway-jRvMHiyq.js"), "../../icons/assets/flags/portugal.svg": () => import("./portugal-BR4bPmOQ.js"), "../../icons/assets/flags/singapore.svg": () => import("./singapore-B4STdeWA.js"), "../../icons/assets/flags/south_africa.svg": () => import("./south_africa-BYePFimX.js"), "../../icons/assets/flags/south_korea.svg": () => import("./south_korea-BvhwmGp1.js"), "../../icons/assets/flags/spain.svg": () => import("./spain-CqwnOkJw.js"), "../../icons/assets/flags/sweden.svg": () => import("./sweden-DapcDvCx.js"), "../../icons/assets/flags/switzerland.svg": () => import("./switzerland-BkfzVz5w.js"), "../../icons/assets/flags/taiwan.svg": () => import("./taiwan-hmIucA5s.js"), "../../icons/assets/flags/thailand.svg": () => import("./thailand-CqnVHFeC.js"), "../../icons/assets/flags/uae.svg": () => import("./uae-BspYiGih.js"), "../../icons/assets/flags/united_kingdom.svg": () => import("./united_kingdom-DCGXWNbA.js"), "../../icons/assets/flags/usa.svg": () => import("./usa-CDNFY5a9.js"), "../../icons/assets/functional/account.svg": () => import("./account-CQ4tbYjx.js"), "../../icons/assets/functional/add.svg": () => import("./add-DCmO1JJ0.js"), "../../icons/assets/functional/alert.svg": () => import("./alert-CcwmXEsq.js"), "../../icons/assets/functional/audio.svg": () => import("./audio-Bx5m4166.js"), "../../icons/assets/functional/bookmark.svg": () => import("./bookmark-DHdqc2Ng.js"), "../../icons/assets/functional/bookmark_filled.svg": () => import("./bookmark_filled-74mn6NIr.js"), "../../icons/assets/functional/calculator.svg": () => import("./calculator-CX5sw0LO.js"), "../../icons/assets/functional/calendar.svg": () => import("./calendar-BbJfaIyx.js"), "../../icons/assets/functional/card.svg": () => import("./card-BFjTTffG.js"), "../../icons/assets/functional/chart_area.svg": () => import("./chart_area--8EuhNuX.js"), "../../icons/assets/functional/chart_bar_horizontal.svg": () => import("./chart_bar_horizontal-CVa4msNE.js"), "../../icons/assets/functional/chart_bar_vertical.svg": () => import("./chart_bar_vertical-dx4dcGiq.js"), "../../icons/assets/functional/chart_distribution.svg": () => import("./chart_distribution-v47m0hr1.js"), "../../icons/assets/functional/chart_line.svg": () => import("./chart_line-AS9EoPZ6.js"), "../../icons/assets/functional/chart_pie.svg": () => import("./chart_pie-hBwadVNA.js"), "../../icons/assets/functional/chat.svg": () => import("./chat-allAfZwG.js"), "../../icons/assets/functional/chevron_down.svg": () => import("./chevron_down-Dl25sPLQ.js"), "../../icons/assets/functional/chevron_left.svg": () => import("./chevron_left-DWWPgwoC.js"), "../../icons/assets/functional/chevron_left_small.svg": () => import("./chevron_left_small-Cv1KlZm1.js"), "../../icons/assets/functional/chevron_right.svg": () => import("./chevron_right-BBCFUnvE.js"), "../../icons/assets/functional/chevron_right_small.svg": () => import("./chevron_right_small-baKK4T0K.js"), "../../icons/assets/functional/chevron_up.svg": () => import("./chevron_up-Bdj8BNLZ.js"), "../../icons/assets/functional/clear.svg": () => import("./clear-Be3aHupx.js"), "../../icons/assets/functional/close.svg": () => import("./close-DWVCPK4a.js"), "../../icons/assets/functional/close_small.svg": () => import("./close_small-BuefwUsD.js"), "../../icons/assets/functional/collapse.svg": () => import("./collapse-Des3hDL7.js"), "../../icons/assets/functional/correct.svg": () => import("./correct-RdBy7HYd.js"), "../../icons/assets/functional/dashboard.svg": () => import("./dashboard-xo3TQCnh.js"), "../../icons/assets/functional/decrease.svg": () => import("./decrease-D5dPCJlG.js"), "../../icons/assets/functional/download.svg": () => import("./download-DV0Ms4Op.js"), "../../icons/assets/functional/edit.svg": () => import("./edit-qpr9H6ut.js"), "../../icons/assets/functional/email.svg": () => import("./email-Dbp04rNr.js"), "../../icons/assets/functional/expand.svg": () => import("./expand-BvWEc8fv.js"), "../../icons/assets/functional/external_link.svg": () => import("./external_link-CLawBAb7.js"), "../../icons/assets/functional/filetype_doc.svg": () => import("./filetype_doc-C92ybn3H.js"), "../../icons/assets/functional/filetype_pdf.svg": () => import("./filetype_pdf-C9Mf-DEG.js"), "../../icons/assets/functional/filetype_pdf_icon.svg": () => import("./filetype_pdf_icon-C6Pd193v.js"), "../../icons/assets/functional/filetype_pps.svg": () => import("./filetype_pps-DHta0pyB.js"), "../../icons/assets/functional/filetype_ppt.svg": () => import("./filetype_ppt-CoSkE4F_.js"), "../../icons/assets/functional/filetype_rar.svg": () => import("./filetype_rar-DCdv8_wt.js"), "../../icons/assets/functional/filetype_rtf.svg": () => import("./filetype_rtf-DQAOn87q.js"), "../../icons/assets/functional/filetype_txt.svg": () => import("./filetype_txt-BVX9K2KM.js"), "../../icons/assets/functional/filetype_xls.svg": () => import("./filetype_xls-B9WNVcU2.js"), "../../icons/assets/functional/filetype_zip.svg": () => import("./filetype_zip-BpEdFczY.js"), "../../icons/assets/functional/filter.svg": () => import("./filter-qFvkKBRv.js"), "../../icons/assets/functional/first.svg": () => import("./first-CQrgQlwW.js"), "../../icons/assets/functional/folder.svg": () => import("./folder-CZkZd2CY.js"), "../../icons/assets/functional/full_screen.svg": () => import("./full_screen-3fy-Nxk7.js"), "../../icons/assets/functional/full_screen_exit.svg": () => import("./full_screen_exit-BOY6HYDs.js"), "../../icons/assets/functional/globe.svg": () => import("./globe-MeDjNXWh.js"), "../../icons/assets/functional/grid.svg": () => import("./grid-BLqTHjrL.js"), "../../icons/assets/functional/help.svg": () => import("./help-KPlEF8kQ.js"), "../../icons/assets/functional/hide.svg": () => import("./hide-5NjakTzs.js"), "../../icons/assets/functional/home.svg": () => import("./home-DDL8vR8u.js"), "../../icons/assets/functional/incorrect.svg": () => import("./incorrect-6JNuovJt.js"), "../../icons/assets/functional/increase.svg": () => import("./increase-57b2Kc-F.js"), "../../icons/assets/functional/information.svg": () => import("./information-DNlfVfHc.js"), "../../icons/assets/functional/language.svg": () => import("./language-LlY7ZUPG.js"), "../../icons/assets/functional/last.svg": () => import("./last-DrhCFJ6V.js"), "../../icons/assets/functional/link.svg": () => import("./link-BPguixX7.js"), "../../icons/assets/functional/list.svg": () => import("./list-rKwwvO0o.js"), "../../icons/assets/functional/locked.svg": () => import("./locked-DDIHOS3J.js"), "../../icons/assets/functional/login.svg": () => import("./login-aek5nlzR.js"), "../../icons/assets/functional/logout.svg": () => import("./logout-CszSu_Jq.js"), "../../icons/assets/functional/menu.svg": () => import("./menu-CtFmPbhC.js"), "../../icons/assets/functional/new_window.svg": () => import("./new_window-DlfgZHbL.js"), "../../icons/assets/functional/notification.svg": () => import("./notification-DQCiQ7la.js"), "../../icons/assets/functional/overflow.svg": () => import("./overflow-Di1X5mMO.js"), "../../icons/assets/functional/overflow_horizontal.svg": () => import("./overflow_horizontal-64-HaJrQ.js"), "../../icons/assets/functional/pause.svg": () => import("./pause-Hn4r0RLJ.js"), "../../icons/assets/functional/phone.svg": () => import("./phone-D7oNx5-g.js"), "../../icons/assets/functional/pin.svg": () => import("./pin-S967QMPt.js"), "../../icons/assets/functional/placeholder.svg": () => import("./placeholder-DW2RIpI5.js"), "../../icons/assets/functional/play.svg": () => import("./play-BLRVUiOH.js"), "../../icons/assets/functional/playlist_video.svg": () => import("./playlist_video-CFi0y8ZR.js"), "../../icons/assets/functional/print.svg": () => import("./print-C0nozzJi.js"), "../../icons/assets/functional/reload.svg": () => import("./reload-GzyOXd2i.js"), "../../icons/assets/functional/remove.svg": () => import("./remove-DbPFAtHS.js"), "../../icons/assets/functional/rotate.svg": () => import("./rotate-CPlos1PY.js"), "../../icons/assets/functional/save.svg": () => import("./save-D-6knrtu.js"), "../../icons/assets/functional/search.svg": () => import("./search-CfWuUnkk.js"), "../../icons/assets/functional/settings.svg": () => import("./settings-CS9FRmf3.js"), "../../icons/assets/functional/share.svg": () => import("./share-D6o1J--q.js"), "../../icons/assets/functional/share_ios.svg": () => import("./share_ios-BIJN0STc.js"), "../../icons/assets/functional/show.svg": () => import("./show-BdVb7QzL.js"), "../../icons/assets/functional/sort.svg": () => import("./sort-3U-jbRjo.js"), "../../icons/assets/functional/sorted_down.svg": () => import("./sorted_down-DhwlMhsc.js"), "../../icons/assets/functional/sorted_up.svg": () => import("./sorted_up-uQndrlYP.js"), "../../icons/assets/functional/star.svg": () => import("./star-4KyWHyO_.js"), "../../icons/assets/functional/star_filled.svg": () => import("./star_filled-CPKrSHqT.js"), "../../icons/assets/functional/support.svg": () => import("./support-CQ08RJTm.js"), "../../icons/assets/functional/table.svg": () => import("./table-BRcbtbUF.js"), "../../icons/assets/functional/trash.svg": () => import("./trash-CRk6Qoh7.js"), "../../icons/assets/functional/unlocked.svg": () => import("./unlocked-qUHpeQBH.js"), "../../icons/assets/functional/upload.svg": () => import("./upload-BMNN9nnp.js"), "../../icons/assets/functional/user.svg": () => import("./user-B4WbhIpQ.js"), "../../icons/assets/functional/validation.svg": () => import("./validation-DCgAc1uK.js"), "../../icons/assets/functional/video.svg": () => import("./video-BUAl5AdS.js"), "../../icons/assets/functional/zoom_in.svg": () => import("./zoom_in-m4h6Va0-.js"), "../../icons/assets/functional/zoom_out.svg": () => import("./zoom_out-DtSN6myF.js"), "../../icons/assets/social/facebook.svg": () => import("./facebook-8SrECXb5.js"), "../../icons/assets/social/instagram.svg": () => import("./instagram-f4C7Xnds.js"), "../../icons/assets/social/linkedin.svg": () => import("./linkedin-mqwQhlm0.js"), "../../icons/assets/social/twitter.svg": () => import("./twitter-BdqIEi_y.js"), "../../icons/assets/social/x.svg": () => import("./x-o9ssdrff.js"), "../../icons/assets/social/youtube.svg": () => import("./youtube-iOBR7GrH.js") }), `../../icons/assets/${this.category}/${e}.svg`, 6).then((o) => o.default) : ""
    })), this.completedFetchIconRender = (e) => pe`
      <div
        class="icon ${this.name} ${this.category} ${Lo.iconSizeClassName(this.size)}"
        part="internal--icon">
        <slot ${Rh()}>${ut(e)}</slot>
      </div>
    `, this.erroredFetchIconRender = (e) => Be`<${this.getScopedTag("beacon-error")}>${e}</${this.getScopedTag("beacon-error")}>`;
  }
  static get styles() {
    return [super.styles, Tw];
  }
  get category() {
    var e;
    return (e = Km.get(this.name)) != null ? e : "functional";
  }
  makePresentational() {
    this.setAttribute("role", "img"), this.setAttribute("aria-label", this.label), this.removeAttribute("aria-hidden");
  }
  makeDecorative() {
    this.removeAttribute("role"), this.removeAttribute("aria-label"), this.setAttribute("aria-hidden", "true");
  }
  static iconSizeClassName(e) {
    return e === td.Medium ? "md" : e === td.Large ? "lg" : "sm";
  }
  _handleLabelChange() {
    typeof this.label == "string" && this.label.length > 0 ? this.makePresentational() : this.makeDecorative();
  }
  loadModeStyles() {
    this.renderComponentModeStyles();
  }
  render() {
    return ze(this, us).render({
      initial: Lo.preFetchIconRender,
      pending: Lo.pendingFetchIconRender,
      complete: this.completedFetchIconRender,
      error: this.erroredFetchIconRender
    });
  }
}, us = new WeakMap(), Lo.tagName = qp.beaconTagName, Lo.preFetchIconRender = () => pe`<slot></slot>`, Lo.pendingFetchIconRender = () => pe`<slot></slot>`, Lo);
Ps([
  ue()
], ur.prototype, "name", 2);
Ps([
  ue()
], ur.prototype, "label", 2);
Ps([
  ue()
], ur.prototype, "size", 2);
Ps([
  yo("label")
], ur.prototype, "_handleLabelChange", 1);
Ps([
  De
], ur.prototype, "loadModeStyles", 1);
let fo = ur;
const Ow = ve`:host([motion-state=enabled]) :is(a,button){--button-base-transition-duration: var(--beacon-reference-motion-duration-3);--scale-x-value: 1.05;--scale-y-value: 1.1;transition-property:var(--button-base-transition-property),transform}:host([motion-state=enabled]) :is(a,button):is(:active,:hover):not(.tertiary){transform:scale(var(--scale-x-value),var(--scale-y-value))}:host([motion-state=enabled]) :is(a,button):is(:active,:hover):not(.tertiary) .contents{transform:scale(calc(1 / var(--scale-x-value)),calc(1 / var(--scale-y-value)))}:host([state=success]){--button-flex-direction: row}:host([state=success]) button{background-color:var(--beacon-system-color-background-positive);border-color:var(--beacon-system-color-background-positive);overflow:hidden}:host([state=success]) button ::slotted([slot=icon]){display:none}:host([state=success]) button .contents{margin-inline-start:-1rem;padding-inline-start:1rem;transition:padding-inline-start var(--beacon-reference-motion-duration-2) ease-in}:host([state=success]) button .checkmark{opacity:1;position:relative;transform:translate(0);transition:opacity var(--beacon-reference-motion-duration-3) ease-in var(--beacon-reference-motion-duration-3),transform var(--beacon-reference-motion-duration-5) ease-in var(--beacon-reference-motion-duration-3);visibility:visible}:host([state=success]) button:hover{--scale-x-value: 1;--scale-y-value: 1;background-color:var(--beacon-system-color-background-positive-hover);border-color:var(--beacon-system-color-background-positive)}:host(:not([state=success])) button .checkmark{max-inline-size:0;opacity:0;position:absolute;transform:translate(-40%);visibility:hidden}`;
var Pw = Object.getOwnPropertyDescriptor, zw = (i, t, e, a) => {
  for (var o = a > 1 ? void 0 : a ? Pw(t, e) : t, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = r(o) || o);
  return o;
};
function Dw(i) {
  let t = class extends i {
    static get ButtonMotionStyles() {
      return [Ow];
    }
  };
  return t = zw([
    je("ButtonMotion")
  ], t), t;
}
const Iw = ve`:host{display:inline-block;inline-size:var(--override-button-inline-size)}a,button{--bg-color: var(--beacon-system-color-background-primary);--border-color: var(--bg-color);--text-color: var(--beacon-system-color-text-primary);--hover-bg-color: var(--beacon-system-color-background-primary-hover);--hover-text-color: var(--hover-bg-color);--disabled-bg-color: var(--beacon-system-color-background-primary-inactive);--disabled-text-color: var(--beacon-system-color-text-primary-inactive);--disabled-border-color: var(--disabled-bg-color);--active-bg-color: var(--beacon-system-color-background-primary-pressed);--active-text-color: var(--beacon-system-color-text-secondary-pressed);--active-border-color: var(--active-bg-color);--border-inline-start-width: var(--beacon-system-width-border-mini);--border-radius: var(--beacon-system-radius-corner-standard);--border-width: var(--beacon-system-width-border-mini);--default-gap: var(--beacon-reference-space-3);--font-weight: var(--beacon-system-font-weight-bold);--font-size: var(--beacon-reference-font-scale-4);--line-height: var(--beacon-reference-font-scale-4);background-color:var(--override-button-bg-color, var(--bg-color));border-color:var(--border-color);border-end-end-radius:var(--override-button-border-radius, var(--border-radius));border-end-start-radius:var(--override-button-border-radius, var(--border-radius));border-inline-start-width:var(--override-button-border-size-inline, var(--border-inline-start-width));border-start-end-radius:var(--override-button-border-radius, var(--border-radius));border-start-start-radius:var(--override-button-border-radius, var(--border-radius));border-style:solid;border-width:var(--override-button-border-width, var(--border-width));color:var(--text-color);display:inline-flex;flex-direction:var(--button-flex-direction, row);font:var(--font-weight) var(--beacon-component-button-normal-font-size-sans-serif-standard);gap:var(--override-button-icon-space-margin, var(--default-gap));inline-size:inherit;justify-content:center;outline-offset:1px;padding-block:var(--beacon-reference-space-4) var(--beacon-reference-space-4);padding-inline:var(--beacon-reference-space-5);text-align:start;text-decoration:none;word-break:initial}a .contents,button .contents{display:inherit;flex-direction:inherit;gap:inherit;justify-content:inherit}a[aria-disabled=true],button[aria-disabled=true]{background-color:var(--disabled-bg-color);border-color:var(--disabled-border-color);color:var(--disabled-text-color);cursor:not-allowed;text-decoration:none}a:is(:hover,:focus-visible):not([aria-disabled=true]),button:is(:hover,:focus-visible):not([aria-disabled=true]){background-color:var(--hover-bg-color);color:var(--hover-text-color);text-decoration:underline}a:active:not([aria-disabled=true]),button:active:not([aria-disabled=true]){background-color:var(--active-bg-color);color:var(--active-text-color);text-decoration:none}.mini{--default-gap: var(--override-button-default-gap, var(--beacon-reference-space-2));--default-font-size: var(--beacon-component-button-mini-font-size-sans-serif-standard);--default-line-height: var(--beacon-component-button-mini-line-height-sans-serif-standard);--font-size: var(--override-button-font-size-mini, var(--default-font-size));--line-height: var(--override-button-font-line-height-mini, var(--default-line-height));font:var(--font-weight) var(--beacon-component-button-mini-font-size-sans-serif-standard);margin-block:var(--beacon-reference-space-2);padding-block:var(--beacon-reference-space-3) var(--beacon-reference-space-3);padding-inline:var(--beacon-reference-space-4)}.normal{--default-padding-block-start: var(--beacon-reference-space-4);--default-padding-block-end: var(--beacon-reference-space-4);--default-padding-inline: var(--beacon-reference-space-5);--normal-font-size: var(--override-button-font-size-normal, var(--font-size));--normal-font-weight: var(--override-button-font-weight-normal, var(--font-weight));--component-font-size: var(--override-button-font-size, var(--beacon-component-button-normal-font-size-sans-serif-standard));font:var(--normal-font-weight) var(--component-font-size, var(--normal-font-size)/var(--line-height) var(--beacon-system-font-family-body));padding-block:var(--override-button-space-padding-block-start-normal, var(--default-padding-block-start)) var(--override-button-space-padding-block-end-normal, var(--default-padding-block-end));padding-inline:var(--override-button-space-padding-inline-normal, var(--default-padding-inline))}.jumbo{--font-size: var(--beacon-component-button-jumbo-font-size-sans-serif-standard);--line-height: var(--beacon-component-button-jumbo-line-height-sans-serif-standard);font:var(--font-weight) var(--beacon-component-button-jumbo-font-size-sans-serif-standard);padding-block:var(--beacon-reference-space-5) var(--beacon-reference-space-5);padding-inline:var(--beacon-reference-space-7)}.primary{--bg-color: var(--beacon-system-color-background-primary);--border-color: var(--override-button-color-border-error, var(--bg-color));--text-color: var(--beacon-system-color-text-primary);--hover-bg-color: var(--beacon-system-color-background-primary-hover);--hover-text-color: var(--text-color);--disabled-bg-color: var(--beacon-system-color-background-primary-inactive);--disabled-text-color: var(--beacon-system-color-text-primary-inactive);--disabled-border-color: var(--disabled-bg-color);--active-bg-color: var(--beacon-system-color-background-primary-pressed);--active-text-color: var(--text-color)}.secondary{--bg-color: transparent;--border-color: var(--beacon-system-color-border-secondary);--text-color: var(--beacon-system-color-text-secondary);--hover-bg-color: var(--beacon-system-color-background-secondary-hover);--hover-border-color: var(--beacon-system-color-border-secondary-hover);--hover-text-color: var(--beacon-system-color-text-secondary-hover);--disabled-bg-color: var(--bg-color);--disabled-text-color: var(--beacon-system-color-text-secondary-inactive);--disabled-border-color: var(--beacon-system-color-border-secondary-inactive);--active-bg-color: var(--beacon-system-color-background-secondary-pressed);--active-text-color: var(--beacon-system-color-text-secondary-pressed)}.tertiary{--standard-default-color: var(--beacon-system-color-text-tertiary);--standard-hover-color: var(--beacon-system-color-text-tertiary-hover);--standard-active-color: var(--beacon-system-color-text-tertiary-pressed);--standard-disabled-color: var(--beacon-system-color-text-tertiary-inactive);--bg-color: var(--override-button-color-background-tertiary-default, transparent);--border-color: var(--override-button-color-border-error, var(--override-button-color-border-tertiary-default, var(--bg-color)));--text-color: var(--override-button-color-text-tertiary-default, var(--standard-default-color));--hover-bg-color: var(--bg-color);--disabled-border-color: var(--bg-color);--hover-text-color: var(--override-button-color-text-tertiary-default, var(--standard-hover-color));--disabled-bg-color: var(--bg-color);--disabled-text-color: var(--override-button-color-text-tertiary-inactive, var(--standard-disabled-color));--active-bg-color: var(--bg-color);--active-text-color: var(--override-button-color-text-tertiary-default, var(--standard-active-color));padding-inline:var(--override-button-space-padding-tertiary, 0)}.positive{--bg-color: var(--beacon-system-color-background-positive);--border-color: var(--bg-color);--text-color: var(--beacon-system-color-text-set-white);--hover-bg-color: var(--beacon-system-color-background-positive-hover);--hover-text-color: var(--text-color);--active-bg-color: var(--beacon-system-color-background-positive-pressed);--active-text-color: var(--text-color)}.negative{--bg-color: var(--beacon-system-color-background-negative);--border-color: var(--bg-color);--text-color: var(--beacon-system-color-text-set-white);--hover-bg-color: var(--beacon-system-color-background-negative-hover);--hover-text-color: var(--text-color);--active-bg-color: var(--beacon-system-color-background-negative-pressed);--active-text-color: var(--text-color)}`;
var Bw = Object.defineProperty, Gm = (i, t, e, a) => {
  for (var o = void 0, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = r(t, e, o) || o);
  return o && Bw(t, e, o), o;
};
const jl = class jl extends Ke(Fi).with(Dw) {
  constructor() {
    super(...arguments), this.beaconTagName = "beacon-button", this.scale = Do.NORMAL, this.state = Ih.NONE;
  }
  static get styles() {
    return [super.styles, Iw, this.ButtonMotionStyles];
  }
  /**
   * Render function for beacon-button if link-href propety is passed in to support links as buttons
   *
   * @returns {TemplateResult} returns an `<a>` tag styled as a button
   */
  renderAnchorTag() {
    var t;
    return pe`<a
      id="${gt(this._passthroughs.attributes.get("id"))}"
      @click=${this.handleClick}
      href="${this.linkHref}"
      download="${gt(this.linkDownload)}"
      target="${gt(this.linkTarget)}"
      class="${this.variant} ${this.scale}"
      aria-disabled="${this.disabled}"
      data-metrics-link-text="${(t = this.defaultSlotText) != null ? t : _e}">
      <span class="contents">
        <slot name="prefix" @slotchange=${this.handleAffixSlotChanges}></slot>
        <slot @slotchange=${this.setDefaultSlotText}>
          ${this.defaultSlotText}
        </slot>
        <slot name="suffix" @slotchange=${this.handleAffixSlotChanges}></slot>
      </span>
    </a>`;
  }
  /**
   * Render function for beacon-button as a `<button>` element
   *
   * @returns {TemplateResult} returns a `<button>` tag as the template
   */
  renderButtonTag() {
    var t;
    return Be`<button
      id="${gt(this._passthroughs.attributes.get("id"))}"
      part="standard-button"
      @click=${this.handleClick}
      class="${this.variant} ${this.scale}"
      aria-disabled="${this.disabled}"
      type="${this.type}"
      data-metrics-link-text="${(t = this.defaultSlotText) != null ? t : _e}">
      <span class="contents">
        <${this.getScopedTag("beacon-icon")} name='correct' class="checkmark"></${this.getScopedTag("beacon-icon")}>
        <slot name="prefix" @slotchange=${this.handleAffixSlotChanges}></slot>
        <slot @slotchange=${this.setDefaultSlotText}></slot>
        <slot name="suffix" @slotchange=${this.handleAffixSlotChanges}></slot>
      </span>
    </button>`;
  }
  render() {
    return pe` ${_m(
      this.linkHref,
      () => this.renderAnchorTag(),
      () => this.renderButtonTag()
    )}`;
  }
};
jl.tagName = "beacon-button", jl.nestedComponents = [fo];
let Zo = jl;
Gm([
  ue({ reflect: !0 })
], Zo.prototype, "scale");
Gm([
  ue({ reflect: !0 })
], Zo.prototype, "state");
const Rw = ve`:root[beacon-tag-name=beacon-table-stub],:root [beacon-tag-name=beacon-table-stub],[beacon-version="4.3.1"][class*=beacon-on][beacon-tag-name=beacon-table-stub],[beacon-version="4.3.1"][class*=beacon-on] [beacon-tag-name=beacon-table-stub],[class*=beacon-on] [beacon-version="4.3.1"][beacon-tag-name=beacon-table-stub],[class*=beacon-on] [beacon-version="4.3.1"] [beacon-tag-name=beacon-table-stub],[beacon-version="4.3.1"][beacon-tag-name=beacon-table-stub],[beacon-version="4.3.1"] [beacon-tag-name=beacon-table-stub]{--table-stub-variable-unset: unset;--table-stub-space-zero-value: 0;--table-stub-category-icon-margin-block-start: 0;--table-stub-title-icon-margin-block-start: 0;--table-stub-space-margin-inline-start: var(--beacon-reference-space-3);--table-stub-space-margin-inline-end: var(--beacon-reference-space-3);--table-base-stub-space-padding-block: var(--beacon-reference-space-2);--table-stub-floating-space-padding-inline: var(--beacon-reference-space-2);--table-stub-category-space-margin-inline: var(--beacon-reference-space-1);--table-stub-category-icon-space-margin-block: 0}@media (width >= 640px){:root[beacon-tag-name=beacon-table-stub],:root [beacon-tag-name=beacon-table-stub],[beacon-version="4.3.1"][class*=beacon-on][beacon-tag-name=beacon-table-stub],[beacon-version="4.3.1"][class*=beacon-on] [beacon-tag-name=beacon-table-stub],[class*=beacon-on] [beacon-version="4.3.1"][beacon-tag-name=beacon-table-stub],[class*=beacon-on] [beacon-version="4.3.1"] [beacon-tag-name=beacon-table-stub],[beacon-version="4.3.1"][beacon-tag-name=beacon-table-stub],[beacon-version="4.3.1"] [beacon-tag-name=beacon-table-stub]{--table-stub-title-icon-margin-block-start: var(--beacon-reference-space-1);--table-stub-space-margin-inline-start: var(--beacon-reference-space-5);--table-base-stub-space-padding-block: var(--beacon-reference-space-3);--table-stub-floating-space-padding-inline: 6px;--table-stub-category-space-margin-inline: var(--beacon-reference-space-2)}}@media (width >= 960px){:root[beacon-tag-name=beacon-table-stub],:root [beacon-tag-name=beacon-table-stub],[beacon-version="4.3.1"][class*=beacon-on][beacon-tag-name=beacon-table-stub],[beacon-version="4.3.1"][class*=beacon-on] [beacon-tag-name=beacon-table-stub],[class*=beacon-on] [beacon-version="4.3.1"][beacon-tag-name=beacon-table-stub],[class*=beacon-on] [beacon-version="4.3.1"] [beacon-tag-name=beacon-table-stub],[beacon-version="4.3.1"][beacon-tag-name=beacon-table-stub],[beacon-version="4.3.1"] [beacon-tag-name=beacon-table-stub]{--table-stub-space-margin-inline-end: var(--beacon-reference-space-4);--table-base-stub-space-padding-block: var(--beacon-reference-space-4)}}@media (width >= 1280px){:root[beacon-tag-name=beacon-table-stub],:root [beacon-tag-name=beacon-table-stub],[beacon-version="4.3.1"][class*=beacon-on][beacon-tag-name=beacon-table-stub],[beacon-version="4.3.1"][class*=beacon-on] [beacon-tag-name=beacon-table-stub],[class*=beacon-on] [beacon-version="4.3.1"][beacon-tag-name=beacon-table-stub],[class*=beacon-on] [beacon-version="4.3.1"] [beacon-tag-name=beacon-table-stub],[beacon-version="4.3.1"][beacon-tag-name=beacon-table-stub],[beacon-version="4.3.1"] [beacon-tag-name=beacon-table-stub]{--table-stub-category-icon-margin-block-start: var(--beacon-reference-space-0);--table-stub-floating-space-padding-inline: var(--beacon-reference-space-3);--table-stub-category-icon-space-margin-block: var(--beacon-reference-space-1)}}`, Nw = ve`[beacon-tag-name=beacon-table-stub] [slot=action-zone-right]{margin:var(--table-override-stub-action-zone-right-space, 0)}[beacon-tag-name=beacon-table-stub] [slot=action-zone-left]{--override-icon-button-wrapper-inline-size: var(--beacon-reference-space-9);--override-icon-button-wrapper-block-size: var(--beacon-reference-space-9);margin-block-start:var(--beacon-reference-space-2)}[beacon-tag-name=beacon-table-stub] .beacon-table-stub__title-icon{margin-block-start:var(--table-stub-title-icon-margin-block-start);margin-inline-start:var(--beacon-reference-space-2);vertical-align:text-top}[beacon-tag-name=beacon-table-stub] .beacon-table-stub__title-icon,[beacon-tag-name=beacon-table-stub] .beacon-table-stub__category-icon{block-size:var(--beacon-reference-space-5);inline-size:var(--beacon-reference-space-5);min-inline-size:fit-content}[beacon-tag-name=beacon-table-stub] .beacon-table-stub__category{--category-text-margin-block-start: var(--beacon-reference-space-2);font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-caption-200);margin-block-start:0}[beacon-tag-name=beacon-table-stub] .beacon-table-stub__category-icon{margin-block:0;margin-block-start:var(--table-stub-category-icon-margin-block-start)}`, Fw = ve`@charset "UTF-8";:host{--override-button-space-padding-tertiary: var(--beacon-reference-space-4);--override-button-font-size-mini: var(--beacon-reference-font-scale-1);--override-button-font-line-height-mini: 1.6;--override-button-color-text-tertiary-default: var(--beacon-system-color-text-link);--override-button-icon-space-margin: var(--beacon-reference-space-2);--content-grid-template: "value-prop" "standard";--content-grid-template-columns: initial;--value-prop-margin-inline-end: 0;--value-prop-margin-block-end: var(--beacon-reference-space-2);--action-zone-left-margin-block-start: var(--beacon-reference-space-3);--stub-content-margin-inline-start: var(--table-stub-space-margin-inline-start);--stub-content-margin-inline-end: var(--table-stub-space-margin-inline-end);color:var(--beacon-system-color-text-standard);inline-size:inherit;word-break:initial}:host([value-prop-left]){--content-grid-template-columns: auto 1fr;--content-grid-template: "value-prop standard";--value-prop-margin-inline-end: var(--beacon-reference-space-3);--value-prop-margin-block-end: 0}p{margin:0}.has-cell-padding{padding-block:0;padding-inline:0}.title{display:flex;grid-area:title}.title-footnote,::slotted(sup){font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-caption-200)}.title-text{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-body-100)}.category{display:flex;grid-area:category}.title,.category{font-weight:var(--beacon-system-font-weight-bold)}.value-prop{grid-area:value-prop;margin-block-end:var(--value-prop-margin-block-end);margin-inline-end:var(--value-prop-margin-inline-end);padding:0}.content{display:grid;grid-template-areas:var(--content-grid-template);grid-template-columns:var(--content-grid-template-columns);inline-size:100%}.content .hide{display:none}.standard{display:grid;grid-template-areas:"category" "title" "attributes" "status" "description" "footnote"}.standard *:not(:last-child){margin-block-end:var(--beacon-reference-space-1)}.standard .title{margin-block-start:0}.standard>*,.standard .category+.title{margin-block-start:0}.standard .status{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-200);background-color:var(--beacon-system-color-background-2);border-radius:var(--beacon-system-radius-corner-standard);grid-area:status;inline-size:fit-content;margin-block:var(--beacon-reference-space-2) var(--beacon-reference-space-2);padding-block:var(--beacon-reference-space-1);padding-inline:var(--beacon-reference-space-3)}.standard .status+*{margin-block-start:0}.content-wrapper{display:flex;gap:var(--beacon-reference-space-3)}.stub{display:grid;margin-inline:0}.stub.level-2 .content{margin-inline-start:var(--table-override-stub-content-space-margin-inline-start, var(--beacon-reference-space-5))}.stub.level-2 .title-text{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-caption-300)}.stub.level-2 ::slotted([slot=title-icon]){--title-icon-margin-block-start: var(--table-stub-category-icon-space-margin-block)}.stub.level-3 .content{margin-inline-start:var(--table-override-stub-content-space-margin-inline-start, var(--beacon-reference-space-5))}.stub.level-3 .title-text{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-300)}.dropdown{display:var(--table-override-stub-dropdown-display, initial);justify-self:end}.attributes{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-300);grid-area:attributes}.category-text{--category-text-margin-block-start: var(--beacon-reference-space-1);font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-caption-200);margin-block-start:var(--category-text-margin-block-start)}.description{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100);grid-area:description;margin-block-start:var(--beacon-reference-space-3)}.footnote{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-200);grid-area:footnote}@media (prefers-reduced-motion){.floating-stub{display:none}}@media (prefers-reduced-motion: no-preference){.floating-stub{background:var(--beacon-system-color-background-2);color:var(--beacon-system-color-text-standard);display:grid;grid-template-areas:"category title";inline-size:max-content;inset-block-start:0;inset-inline-start:var(--table-stub-floating-override-inset-inline-start, 0);margin-block-start:calc(-1 * var(--table-base-stub-space-padding-block));margin-inline-start:var(--table-stub-floating-override-margin-inline-start, -500%);padding-block-start:var(--beacon-reference-space-2);padding-inline:var(--table-stub-floating-space-padding-inline);place-items:center;position:absolute;transform:translateY(-50%);transition:margin-inline-start 1s;z-index:2}.floating-stub .category:after{content:"·";margin-inline:var(--table-stub-category-space-margin-inline)}.floating-stub .category-text{margin:0}.floating-stub .category .category-text{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-caption-200)}.floating-stub .title{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-200)}.floating-stub .category-icon{margin-block:var(--table-stub-category-icon-space-margin-block)}}.wrapper{position:relative}@media (width >= 1280px){.category-text{--category-text-margin-block-start: 0}}`;
var _w = Object.defineProperty, Uw = Object.getOwnPropertyDescriptor, Qe = (i, t, e, a) => {
  for (var o = a > 1 ? void 0 : a ? Uw(t, e) : t, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = (a ? r(t, e, o) : r(o)) || o);
  return a && o && _w(t, e, o), o;
};
const En = "beacon-table-stub", Vp = "1px solid var(--beacon-system-color-border-0)", Qs = "0", jw = "calc(var(--beacon-reference-space-3) + var(--table-row-space-padding))", ja = "th", $w = "tr", Xs = "border-block-end", Hw = "beacon-table", Yp = "display", Kw = "none", Gw = "padding-block-end", Ww = "--inset-divider-border", qw = "--inset-divider-padding-block-start", Vw = "table-row", Qp = "--inset-divider-margin-start", Yw = "calc(var(--beacon-reference-space-3) + var(--beacon-reference-space-5) + var(--table-stub-space-margin-inline-start))", Qw = "calc(var(--beacon-reference-space-3) + var(--beacon-reference-space-5) + var(--table-stub-space-margin-inline-start))", Xp = "--inset-divider-margin-end", Xw = "13px", Zp = "BEACON-CHECKBOX", Zw = "--action-zone-left-margin-block-start", Jw = "checkbox", ek = 'input[type="checkbox"]', tk = "calc(var(--beacon-reference-space-3) + var(--table-stub-space-margin-inline-start))", ok = "calc(var(--beacon-reference-space-3) + var(--table-stub-space-margin-inline-end))";
var xa;
const Ve = (xa = class extends Os {
  constructor() {
    super(...arguments), this.beaconTagName = En, this.nextStub = null, this.level = St.ONE, this.valuePropLeft = !1, this.withDropdown = !1, this.highlighted = !1, this.showDropdown = !1, this.hasCategory = !1, this.hasStatus = !1, this.hasValueProp = !1, this.hasDescription = !1, this.hasFootnote = !1, this.hasAttributeList = !1;
  }
  static get styles() {
    return [super.styles, Fw];
  }
  static get lightDOMStyles() {
    return [...super.lightDOMStyles, Nw, Rw];
  }
  onBeaconRenderActionZone() {
  }
  /**
   * Used when the current instance is a level 2 stub
   * Triggers the visibility of possible level 3 children
   * @param {boolean} show - Boolean parameter that shows children on true
   */
  triggerChildren(t) {
    var a, o, n, r;
    let e = this.next;
    if (t) {
      for (; e; )
        e == null || e.showRow(), e = e.next;
      (o = (a = this.parentTableRow) == null ? void 0 : a.querySelector(ja)) == null || o.style.setProperty(Xs, Qs);
    } else {
      for (; e; )
        e == null || e.hideRow(), e = e.next;
      (r = (n = this.parentTableRow) == null ? void 0 : n.querySelector(ja)) == null || r.style.setProperty(Xs, Vp);
    }
  }
  /**
   * Used to trigger the state of the dropdown and visibility of level 3 children in a level 2 stub instance
   */
  handleClick() {
    this.showDropdown = !this.showDropdown, this.triggerChildren(this.showDropdown);
  }
  /**
   * Use to receive a reference to the next table stub in multi-level context
   *
   * @return {BeaconTableStub} contains a level 2 or level 3 stub
   */
  get next() {
    return this.nextStub;
  }
  /**
   * sets the parentTableRow class variable
   * Searches up the DOM tree to look for the first instance of a table `<tr>` element
   */
  setParentTableRow() {
    const t = this.closest($w);
    t && (this.parentTableRow = t);
  }
  /**
   * sets the nextStub class variable
   * Searches for the current stub sibling to maintain a linked-list between level 2 and level 3 stubs
   */
  setNextStub(t = null) {
    var a, o;
    if (t) {
      this.nextStub = t;
      return;
    }
    const e = (o = (a = this.parentTableRow) == null ? void 0 : a.nextElementSibling) == null ? void 0 : o.querySelector(
      En
    );
    this.level !== St.ONE && (this.level === St.TWO && (e == null ? void 0 : e.level) !== St.THREE || this.level === St.THREE && (e == null ? void 0 : e.level) !== St.THREE || (this.nextStub = e));
  }
  setParentTableRowAndSetNextStub() {
    this.setParentTableRow(), this.setNextStub();
  }
  /**
   * Hides parent table row by setting display to none
   */
  hideRow() {
    var t;
    (t = this.parentTableRow) == null || t.style.setProperty(Yp, Kw);
  }
  /**
   * Shows parent table row by setting display to default table-row
   */
  showRow() {
    var t;
    (t = this.parentTableRow) == null || t.style.setProperty(Yp, Vw);
  }
  /**
   * Sets the hasMultiLevel property of parent beacon-table component to trigger vertical divider styles
   * in multi-level stub context
   */
  setMultiLevelTableProp() {
    const t = this.closest(
      Hw
    );
    t && t._setMultiLevel(!0);
  }
  /**
   * addInsetRowBorders() removes the default full width borders of table header elements and instead adds
   * inset borders in multi-level stub context
   */
  addInsetRowBorders() {
    var e;
    const t = (e = this.parentTableRow) == null ? void 0 : e.querySelector(ja);
    t && (t.style.setProperty(Xs, Qs), t.style.setProperty(Gw, Qs), t.style.setProperty(Ww, Vp), t.style.setProperty(
      qw,
      jw
    ));
  }
  /**
   * Clones passed in childEl and inserts it before the first child of parentEl
   * @param  {HTMLElement} parentEl: Element that will hold childEl
   * @param  {Array<HTMLElement>} childEl: Element to be cloned and prepended to parentEl
   * @returns void
   */
  static cloneAndPrepend(t, e) {
    if (t && (e != null && e.length)) {
      const a = e.find((o) => o);
      if (a) {
        const o = a.cloneNode(!0);
        t.prepend(o);
      }
    }
  }
  /**
   * @param event
   * @event {BeaconEvents} beacon-event-render-action-zone - emits when the action zone is rendered inside a table
   */
  emitRenderActionZone() {
    Re(
      this,
      Ee.RENDER_ACTION_ZONE,
      void 0,
      this.onBeaconRenderActionZone
    );
  }
  /**
   * change action-zone-left slot padding if it contains a checkbox
   */
  handleActionZone() {
    if (this.actionZoneLeft && this.actionZoneLeft.length) {
      this.emitRenderActionZone();
      const t = this.actionZoneLeft.find((o) => o), e = (t == null ? void 0 : t.getAttribute("type")) === Jw || (t == null ? void 0 : t.tagName) === Zp, a = (t == null ? void 0 : t.querySelector(ek)) || (t == null ? void 0 : t.querySelector(Zp));
      (e || a) && this.style.setProperty(
        Zw,
        Xw
      );
    }
  }
  /**
   * Sets stub styles based on level and trailing nextStubs
   */
  setStubStyles() {
    var e;
    const t = (e = this.parentTableRow) == null ? void 0 : e.querySelector(ja);
    t && (this == null ? void 0 : this.level) === St.TWO && this != null && this.showDropdown && (t == null || t.style.setProperty(
      Xs,
      Qs
    )), this.level === St.TWO && this.setLevelOneInsetBorder();
  }
  /**
   * Sets inset borders for sibling level 1 stub if current instance is a level 2 stub
   */
  setLevelOneInsetBorder() {
    var e, a, o, n, r, T;
    const t = (a = (e = this.parentTableRow) == null ? void 0 : e.previousElementSibling) == null ? void 0 : a.querySelector(
      En
    );
    t == null || t.addInsetRowBorders(), (n = (o = t == null ? void 0 : t.parentTableRow) == null ? void 0 : o.querySelector(ja)) == null || n.style.setProperty(
      Qp,
      tk
    ), (T = (r = t == null ? void 0 : t.parentTableRow) == null ? void 0 : r.querySelector(ja)) == null || T.style.setProperty(
      Xp,
      ok
    );
  }
  /**
   * Styles set when current instance is a level 3 stub
   */
  levelThreeStubStyles() {
    var t, e, a, o, n;
    this.nextStub && ((t = this.nextStub) == null ? void 0 : t.level) === (this == null ? void 0 : this.level) && this.addInsetRowBorders(), (a = (e = this.parentTableRow) == null ? void 0 : e.querySelector(ja)) == null || a.style.setProperty(
      Qp,
      Yw
    ), (n = (o = this.parentTableRow) == null ? void 0 : o.querySelector(ja)) == null || n.style.setProperty(
      Xp,
      Qw
    );
  }
  /**
   * Sets the previous stub's next if a new row is inserted into the table
   */
  updatePreviousNext() {
    var e, a;
    const t = (a = (e = this.parentTableRow) == null ? void 0 : e.previousElementSibling) == null ? void 0 : a.querySelector(
      En
    );
    t && t.setNextStub();
  }
  tearDownTableStub() {
    var t, e;
    if (this.level === St.THREE) {
      const a = (e = (t = this.parentTableRow) == null ? void 0 : t.previousElementSibling) == null ? void 0 : e.querySelector(
        En
      );
      a && a.setNextStub(this.nextStub);
    }
  }
  render() {
    return pe`
      <div class="wrapper">
        <div class="floating-stub">
          <div class="title"></div>
        </div>
        <div class="stub level-${this.level}">
          <div class="content-wrapper">
            <slot
              name="action-zone-left"
              @slotchange="${this.handleActionZone}"></slot>
            <div class="content has-cell-padding" part="content">
              ${this.renderValueProp()}
              <div class="standard">
                ${this.renderCategory()}
                <div class="title">
                  <slot></slot>
                  <slot class="title-text" name="title"></slot>
                  <slot class="title-footnote" name="title-footnote"></slot>
                  <slot name="title-icon"></slot>
                </div>
                ${this.renderAttributes()} ${this.renderStatus()}
                ${this.renderDescription()} ${this.renderFootnote()}
              </div>
            </div>
            <slot name="action-zone-right"></slot>
          </div>
          ${this.withDropdown ? pe`${Be`<${this.getScopedTag("beacon-button")}
          class="dropdown"
          @beacon-event-click="${this.handleClick}"
          variant=${Bh.TERTIARY}
          scale="${Do.MINI}">
          ${this.showDropdown ? "Hide Items" : "Show Items"}
          ${this.showDropdown ? pe`${ut(yw)}` : pe`${ut(Hm)}`}</${this.getScopedTag("beacon-button")}>`}` : _e}
        </div>
      </div>
    `;
  }
  categorySlotChange() {
    var t;
    this.hasCategory = !!((t = this.slottedCategory) != null && t.length);
  }
  renderCategory() {
    const t = {
      category: !0,
      hide: !this.hasCategory
    };
    return pe` <div class=${Oe(t)}>
      <slot name="category-icon"></slot>
      <slot name="category" @slotchange=${this.categorySlotChange}></slot>
    </div>`;
  }
  statusSlotChange() {
    var t;
    this.hasStatus = !!((t = this.slottedStatus) != null && t.length);
  }
  renderStatus() {
    const t = {
      status: !0,
      hide: !this.hasStatus
    };
    return pe` <div class=${Oe(t)}>
      <slot name="status" @slotchange=${this.statusSlotChange}></slot>
    </div>`;
  }
  valuePropSlotChange() {
    var t;
    this.hasValueProp = !!((t = this.slottedValueProp) != null && t.length);
  }
  renderValueProp() {
    const t = {
      "value-prop": !0,
      hide: !this.hasValueProp
    };
    return pe` <span
      class=${Oe(t)}
      @slotchange=${this.valuePropSlotChange}
      ><slot name="value-prop"></slot
    ></span>`;
  }
  descriptionSlotChange() {
    var t;
    this.hasDescription = !!((t = this.slottedDescription) != null && t.length);
  }
  renderDescription() {
    const t = {
      description: !0,
      hide: !this.hasDescription
    };
    return pe` <div class=${Oe(t)}>
      <slot name="description" @slotchange=${this.descriptionSlotChange}></slot>
    </div>`;
  }
  footnoteSlotChange() {
    var t;
    this.hasFootnote = !!((t = this.slottedFootnote) != null && t.length);
  }
  renderFootnote() {
    const t = {
      footnote: !0,
      hide: !this.hasFootnote
    };
    return pe` <div class=${Oe(t)}>
      <slot name="footnote" @slotchange=${this.footnoteSlotChange}></slot>
    </div>`;
  }
  attributesSlotChange() {
    var t;
    this.hasAttributeList = !!((t = this.slottedAttributes) != null && t.length);
  }
  renderAttributes() {
    const t = {
      attributes: !0,
      hide: !this.hasAttributeList
    };
    return pe` <div class=${Oe(t)}>
      <slot name="attributes" @slotchange=${this.attributesSlotChange}></slot>
    </div>`;
  }
  postrenderTableStubSetup() {
    xa.cloneAndPrepend(this.floatingTitle, this.titleText), xa.cloneAndPrepend(this.floatingCategory, this.categoryIcon), (this == null ? void 0 : this.level) !== St.ONE && Promise.resolve(this.setNextStub()).then(() => {
      (this == null ? void 0 : this.level) === St.TWO && this.showDropdown && this.triggerChildren(this.showDropdown);
    }), this.level === St.TWO && this.setMultiLevelTableProp(), this.level === St.THREE && (this.levelThreeStubStyles(), this.updatePreviousNext(), this.hideRow());
  }
}, xa.tagName = En, xa.nestedComponents = [Zo], xa);
Qe([
  ue({ reflect: !0 })
], Ve.prototype, "level", 2);
Qe([
  ue({ attribute: "value-prop-left", type: Boolean, reflect: !0 })
], Ve.prototype, "valuePropLeft", 2);
Qe([
  ue({ attribute: "with-dropdown", type: Boolean, reflect: !0 })
], Ve.prototype, "withDropdown", 2);
Qe([
  ue({ type: Boolean, reflect: !0 })
], Ve.prototype, "highlighted", 2);
Qe([
  ue({ attribute: "show-dropdown", type: Boolean, reflect: !0 })
], Ve.prototype, "showDropdown", 2);
Qe([
  ue({ attribute: "sort-value", reflect: !0 })
], Ve.prototype, "sortValue", 2);
Qe([
  Pe({ slot: "title-footnote" })
], Ve.prototype, "titleFootnote", 2);
Qe([
  Pe({ slot: "title-icon" })
], Ve.prototype, "titleIcon", 2);
Qe([
  Pe({ slot: "action-zone-left" })
], Ve.prototype, "actionZoneLeft", 2);
Qe([
  Pe({ slot: "category-icon" })
], Ve.prototype, "categoryIcon", 2);
Qe([
  Pe({ slot: "" })
], Ve.prototype, "titleText", 2);
Qe([
  Ge(".title-text")
], Ve.prototype, "titleElement", 2);
Qe([
  Ge(".floating-stub .category .category-icon")
], Ve.prototype, "floatingCategory", 2);
Qe([
  Ge(".floating-stub .title")
], Ve.prototype, "floatingTitle", 2);
Qe([
  Se()
], Ve.prototype, "hasCategory", 2);
Qe([
  Pe({ flatten: !0, slot: "category" })
], Ve.prototype, "slottedCategory", 2);
Qe([
  Se()
], Ve.prototype, "hasStatus", 2);
Qe([
  Pe({ flatten: !0, slot: "status" })
], Ve.prototype, "slottedStatus", 2);
Qe([
  Se()
], Ve.prototype, "hasValueProp", 2);
Qe([
  Pe({ flatten: !0, slot: "value-prop" })
], Ve.prototype, "slottedValueProp", 2);
Qe([
  Se()
], Ve.prototype, "hasDescription", 2);
Qe([
  Pe({ flatten: !0, slot: "description" })
], Ve.prototype, "slottedDescription", 2);
Qe([
  Se()
], Ve.prototype, "hasFootnote", 2);
Qe([
  Pe({ flatten: !0, slot: "footnote" })
], Ve.prototype, "slottedFootnote", 2);
Qe([
  Se()
], Ve.prototype, "hasAttributeList", 2);
Qe([
  Pe({ flatten: !0, slot: "attributes" })
], Ve.prototype, "slottedAttributes", 2);
Qe([
  De
], Ve.prototype, "setParentTableRowAndSetNextStub", 1);
Qe([
  Lt
], Ve.prototype, "tearDownTableStub", 1);
Qe([
  De
], Ve.prototype, "postrenderTableStubSetup", 1);
let Zs = Ve;
const ak = ve`:root[beacon-tag-name=beacon-table],:root [beacon-tag-name=beacon-table],[beacon-version="4.3.1"][class*=beacon-on][beacon-tag-name=beacon-table],[beacon-version="4.3.1"][class*=beacon-on] [beacon-tag-name=beacon-table],[class*=beacon-on] [beacon-version="4.3.1"][beacon-tag-name=beacon-table],[class*=beacon-on] [beacon-version="4.3.1"] [beacon-tag-name=beacon-table],[beacon-version="4.3.1"][beacon-tag-name=beacon-table],[beacon-version="4.3.1"] [beacon-tag-name=beacon-table]{--table-space-padding: var(--beacon-reference-space-3);--table-caption-summary-spacer: var(--beacon-reference-space-5);--table-caption-spacer-jumbo: var(--beacon-reference-space-5);--table-caption-spacer-normal: var(--beacon-reference-space-3);--table-row-space-padding: var(--beacon-reference-space-2)}@media (width >= 640px){:root[beacon-tag-name=beacon-table],:root [beacon-tag-name=beacon-table],[beacon-version="4.3.1"][class*=beacon-on][beacon-tag-name=beacon-table],[beacon-version="4.3.1"][class*=beacon-on] [beacon-tag-name=beacon-table],[class*=beacon-on] [beacon-version="4.3.1"][beacon-tag-name=beacon-table],[class*=beacon-on] [beacon-version="4.3.1"] [beacon-tag-name=beacon-table],[beacon-version="4.3.1"][beacon-tag-name=beacon-table],[beacon-version="4.3.1"] [beacon-tag-name=beacon-table]{--table-space-padding: var(--beacon-reference-space-4);--table-row-space-padding: var(--beacon-reference-space-3)}}@media (width >= 960px){:root[beacon-tag-name=beacon-table],:root [beacon-tag-name=beacon-table],[beacon-version="4.3.1"][class*=beacon-on][beacon-tag-name=beacon-table],[beacon-version="4.3.1"][class*=beacon-on] [beacon-tag-name=beacon-table],[class*=beacon-on] [beacon-version="4.3.1"][beacon-tag-name=beacon-table],[class*=beacon-on] [beacon-version="4.3.1"] [beacon-tag-name=beacon-table],[beacon-version="4.3.1"][beacon-tag-name=beacon-table],[beacon-version="4.3.1"] [beacon-tag-name=beacon-table]{--table-caption-summary-spacer: var(--beacon-reference-space-7);--table-caption-spacer-jumbo: var(--beacon-reference-space-7);--table-caption-spacer-normal: var(--beacon-reference-space-5);--table-row-space-padding: var(--beacon-reference-space-4)}}@media (width >= 1280px){:root[beacon-tag-name=beacon-table],:root [beacon-tag-name=beacon-table],[beacon-version="4.3.1"][class*=beacon-on][beacon-tag-name=beacon-table],[beacon-version="4.3.1"][class*=beacon-on] [beacon-tag-name=beacon-table],[class*=beacon-on] [beacon-version="4.3.1"][beacon-tag-name=beacon-table],[class*=beacon-on] [beacon-version="4.3.1"] [beacon-tag-name=beacon-table],[beacon-version="4.3.1"][beacon-tag-name=beacon-table],[beacon-version="4.3.1"] [beacon-tag-name=beacon-table]{--table-space-padding: var(--beacon-reference-space-2)}}`, Jp = {
  beaconTagName: "beacon-table"
}, ik = {
  Standard: "standard"
}, nk = ve`[beacon-tag-name=beacon-table]{--layer-base: 1;--layer-headers: calc(var(--layer-base) + 1);--layer-headers-sticky: calc(var(--layer-headers) + 1);--layer-popover: calc(var(--layer-headers-sticky) + 1);--table-thead-position: sticky;background-color:transparent}[beacon-tag-name=beacon-table][static-header]{--table-thead-position: relative;--layer-headers: auto}[beacon-tag-name=beacon-table]:is(.beacon-on-light,.beacon-on-dark){background-color:transparent}[beacon-tag-name=beacon-table] .beacon-table{box-sizing:border-box;border:inherit;color:inherit;letter-spacing:inherit;line-height:inherit;white-space:inherit;word-spacing:inherit;font-family:inherit;font-size:inherit;font-style:inherit;font-variant:inherit;font-weight:inherit;text-align:inherit;text-indent:inherit;text-transform:inherit;background-color:var(--beacon-system-color-background-1);border-collapse:separate;border-spacing:0;min-inline-size:100%;overflow-wrap:break-word;position:relative;table-layout:var(--beacon-table-layout, fixed)}[beacon-tag-name=beacon-table] .beacon-table *,[beacon-tag-name=beacon-table] .beacon-table *:after,[beacon-tag-name=beacon-table] .beacon-table *:before{box-sizing:inherit}[beacon-tag-name=beacon-table] .beacon-table:not(.container-has-border){border-color:var(--beacon-component-table-color-border);border-radius:var(--beacon-system-radius-corner-standard);border-style:var(--border-style, solid);border-width:var(--beacon-system-width-border-mini)}@media (width >= 640px){[beacon-tag-name=beacon-table] .beacon-table:not(.container-has-border){border-radius:var(--beacon-system-radius-corner-standard)}}[beacon-tag-name=beacon-table] .beacon-table.container-has-left-border{border-inline-start:none}[beacon-tag-name=beacon-table] .beacon-table.container-has-right-border{border-inline-end:none}[beacon-tag-name=beacon-table] .beacon-table a{color:var(--beacon-system-color-text-link)}[beacon-tag-name=beacon-table] .beacon-table caption{background-color:var(--beacon-system-color-background-1);padding-block-end:var(--beacon-reference-space-5);text-align:start}[beacon-tag-name=beacon-table] .beacon-table thead{inset-block-start:0;position:var(--table-thead-position);z-index:var(--layer-headers)}[beacon-tag-name=beacon-table] .beacon-table :is(th,td){--cell-color: var(--beacon-system-color-text-standard);--cell-text-alignment: initial;--modern-outlook-table-cell-padding: calc(var(--beacon-component-table-space-cell) + var(--beacon-system-space-cell-contained));background-color:var(--beacon-system-color-background-1);color:var(--cell-color);padding-block:var(--modern-outlook-table-cell-padding);padding-inline:var(--modern-outlook-table-cell-padding);position:relative;text-align:var(--cell-text-alignment);vertical-align:top}[beacon-tag-name=beacon-table] .beacon-table :is(tbody,tfoot){--divider-border-color: var(--beacon-component-table-color-border)}[beacon-tag-name=beacon-table] .beacon-table :is(tbody,tfoot) :is(th,td){font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100)}[beacon-tag-name=beacon-table] .beacon-table :is(tbody,tfoot) th{--cell-text-alignment: start}[beacon-tag-name=beacon-table] .beacon-table tbody th:after{border-block-end:var(--inset-divider-border);content:"";display:block;margin-block:0;margin-inline:var(--inset-divider-margin-start) var(--inset-divider-margin-end);padding-block-start:var(--inset-divider-padding-block-start)}[beacon-tag-name=beacon-table] .beacon-table thead th{--cell-background: var(--beacon-system-color-background-2);--cell-color: var(--beacon-system-color-text-standard);--divider-border-color: var(--beacon-component-table-color-border);background-color:var(--cell-background);font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-caption-200)}[beacon-tag-name=beacon-table] .beacon-table thead th[colspan]{padding-block-end:var(--beacon-reference-space-3)}[beacon-tag-name=beacon-table] .beacon-table thead th:not([colspan]),[beacon-tag-name=beacon-table] .beacon-table thead th[colspan][has-dropdown]{border-block-end-color:var(--divider-border-color);border-block-end-style:var(--border-style);border-block-end-width:var(--beacon-system-width-border-mini)}[beacon-tag-name=beacon-table] .beacon-table thead tr:not(:first-of-type) th,[beacon-tag-name=beacon-table] .beacon-table thead tr:first-of-type th:not(:last-of-type){border-inline-end-color:var(--divider-border-color);border-inline-end-style:var(--border-style);border-inline-end-width:var(--beacon-system-width-border-mini)}[beacon-tag-name=beacon-table] .beacon-table thead tr:first-child th:first-child{border-start-start-radius:var(--beacon-system-radius-corner-standard)}[beacon-tag-name=beacon-table] .beacon-table thead tr:first-child th:last-child{border-start-end-radius:var(--beacon-system-radius-corner-standard)}[beacon-tag-name=beacon-table] .beacon-table tbody tr:last-child th:first-child{border-end-start-radius:var(--beacon-system-radius-corner-standard)}[beacon-tag-name=beacon-table] .beacon-table tbody tr:last-child td:last-child{border-end-end-radius:var(--beacon-system-radius-corner-standard)}[beacon-tag-name=beacon-table] .beacon-table tbody tr:not(:last-of-type)>:is(th,td){border-block-end-color:var(--divider-border-color);border-block-end-style:var(--border-style);border-block-end-width:var(--beacon-system-width-border-mini)}[beacon-tag-name=beacon-table] .beacon-table tfoot tr>:is(th,td){border-block-start-color:var(--divider-border-color);border-block-start-style:var(--border-style);border-block-start-width:var(--beacon-system-width-border-mini)}[beacon-tag-name=beacon-table] .beacon-table tr:is([data-beacon-selected],[data-beacon-highlighted]) th:first-of-type:before{background-color:var(--beacon-system-color-border-brand);block-size:100%;content:"";display:block;inline-size:var(--beacon-system-width-border-jumbo);inset-block-start:0;inset-inline-start:0;position:absolute}[beacon-tag-name=beacon-table] .beacon-table tr[data-beacon-highlighted] :is(th:first-of-type,td){background-color:var(--beacon-component-table-color-background-selected)}[beacon-tag-name=beacon-table] .beacon-table tr[data-beacon-selected] :is(th:first-of-type,td){background-color:var(--beacon-component-table-color-background-selected)}[beacon-tag-name=beacon-table] .beacon-table.has-sticky-stub-column tr[data-beacon-highlighted] th:first-of-type{background-color:var(--beacon-component-table-color-background-selected)}[beacon-tag-name=beacon-table] .beacon-table.has-sticky-stub-column tr[data-beacon-selected] th:first-of-type{background-color:var(--beacon-component-table-color-background-selected)}[beacon-tag-name=beacon-table] .beacon-table.has-sticky-header thead{z-index:var(--layer-headers-sticky)}[beacon-tag-name=beacon-table] .beacon-table tr.remove-border-block-end th,[beacon-tag-name=beacon-table] .beacon-table tr.remove-border-block-end td{border-block-end-color:transparent!important}[beacon-tag-name=beacon-table][multi-level] .beacon-table :is(tbody,tfoot) th{border-inline-end-color:var(--divider-border-color);border-inline-end-style:var(--border-style);border-inline-end-width:var(--beacon-system-width-border-mini)}[beacon-tag-name=beacon-table][variant=fixed] .beacon-table :is(tbody,tfoot) th,[beacon-tag-name=beacon-table][variant=fixed] .beacon-table thead tr:first-of-type th:first-of-type{inset-inline-start:0;position:sticky}[beacon-tag-name=beacon-table][variant=fixed] .beacon-table :is(tbody,tfoot) th{z-index:var(--layer-base)}[beacon-tag-name=beacon-table][variant=fixed] .beacon-table :is(tbody,tfoot) th:has([is-open]){z-index:var(--layer-popover)}[beacon-tag-name=beacon-table][variant=fixed] .beacon-table thead tr:first-of-type th:first-of-type{z-index:var(--layer-headers)}[beacon-tag-name=beacon-table][variant=fixed] .beacon-table.has-sticky-stub-column{--sticky-cell-elevation: auto;--sticky-cell-elevation-stub: auto}[beacon-tag-name=beacon-table][variant=fixed] .beacon-table.has-sticky-stub-column :is(tbody,tfoot) tr th:first-of-type{filter:drop-shadow(var(--sticky-cell-elevation, none))}[beacon-tag-name=beacon-table][variant=fixed] .beacon-table.has-sticky-stub-column thead tr:first-of-type th:first-of-type{border-inline-end:0;filter:drop-shadow(var(--sticky-cell-elevation-stub, none))}[beacon-tag-name=beacon-table][variant=fixed] .beacon-table.has-sticky-stub-column :is(tbody,tfoot) tr th:first-of-type,[beacon-tag-name=beacon-table][variant=fixed] .beacon-table.has-sticky-stub-column thead tr:first-of-type th:first-of-type{border-inline-end-color:var(--divider-border-color);border-inline-end-style:var(--border-style);border-inline-end-width:var(--beacon-system-width-border-mini)}[beacon-tag-name=beacon-table][variant=floating] .beacon-table.floating-stub{--table-stub-floating-override-margin-inline-start: 0%}[beacon-tag-name=beacon-table][variant=floating] .beacon-table.floating-stub :is(tbody,tfoot) th{padding:0}[beacon-tag-name=beacon-table] [data-beacon-sort-state=false] [data-beacon-sort]{display:none}[beacon-tag-name=beacon-table] [data-beacon-sort]{--override-icon-button-wrapper-inline-size: var(--beacon-reference-space-5);--override-icon-button-wrapper-block-size: var(--beacon-reference-space-5)}[beacon-tag-name=beacon-table] [data-beacon-sort] svg{fill:var(--beacon-system-color-icon-tertiary)}[beacon-tag-name=beacon-table] [aria-sort=ascending] [data-beacon-sort] svg:not(.ascending){display:none}[beacon-tag-name=beacon-table] [aria-sort=descending] [data-beacon-sort] svg:not(.descending){display:none}[beacon-tag-name=beacon-table] [aria-sort]:not([aria-sort=none]){background-color:var(--beacon-system-color-background-1)}[beacon-tag-name=beacon-table] th:is(:not([aria-sort]),[aria-sort=none]) [data-beacon-sort] svg:not(.default){display:none}[beacon-tag-name=beacon-table][sortable] .beacon-table :is(td,th)[data-beacon-sorted=true]{font-weight:var(--beacon-system-font-weight-bold)}`, rk = ve`:host{--border-style: solid;word-break:initial}.table-container{block-size:var(--beacon-custom-table-container-block-size, auto);display:var(--table-container-display, block);inline-size:var(--beacon-custom-table-container-inline-size, auto);margin-inline:var(--inline-margin, 0);overflow-x:var(--beacon-custom-table-container-overflow-x, initial);scrollbar-color:var(--beacon-component-scrollbar-color-background-thumb) var(--beacon-component-scrollbar-color-background-track)}.table-container::-webkit-scrollbar{block-size:calc(var(--beacon-reference-space-3) * .75);inline-size:calc(var(--beacon-reference-space-3) * .75)}.table-container::-webkit-scrollbar-thumb{background:var(--beacon-component-scrollbar-color-background-thumb);border-radius:calc(.875 * var(--beacon-reference-space-5))}.table-container::-webkit-scrollbar-track{background:var(--beacon-reference-palette-grayscale-light-gray-1)}.table-container::-webkit-scrollbar-corner{background:var(--beacon-reference-palette-grayscale-light-gray-1)}.table-container.full-bleed{--inline-margin: calc(50% - 50vw) }.table-container.add-full-border{border-color:var(--beacon-component-table-color-border);border-radius:var(--beacon-system-radius-corner-standard);border-style:var(--border-style, solid);border-width:var(--beacon-system-width-border-mini)}@media (width >= 640px){.table-container.add-full-border{border-radius:var(--beacon-system-radius-corner-standard)}}.table-container.add-bottom-border{border-block-end:var(--beacon-system-width-border-mini) var(--border-style, solid) var(--beacon-component-table-color-border)}@media (width >= 640px){.table-container.add-bottom-border{border-end-end-radius:var(--beacon-system-radius-corner-standard);border-end-start-radius:var(--beacon-system-radius-corner-standard)}}.table-container.add-left-border{border-inline-start:var(--beacon-system-width-border-mini) var(--border-style, solid) var(--beacon-component-table-color-border)}@media (width >= 640px){.table-container.add-left-border{border-end-start-radius:var(--beacon-system-radius-corner-standard);border-start-start-radius:var(--beacon-system-radius-corner-standard)}}.table-container.add-right-border{border-inline-end:var(--beacon-system-width-border-mini) var(--border-style, solid) var(--beacon-component-table-color-border)}@media (width >= 640px){.table-container.add-right-border{border-end-end-radius:var(--beacon-system-radius-corner-standard);border-start-end-radius:var(--beacon-system-radius-corner-standard)}}.transformed-cards{--beacon-body-font-size-100: var(--beacon-reference-space-4);--table-override-header-sort-icon-display: none;--table-override-header-wrapper-inline-size: fit-content;--table-override-stub-action-zone-right-space: 0;--table-override-stub-content-space-margin-inline-start: 0;--table-override-stub-dropdown-display: none;--table-override-header-dropdown-display: none;display:var(--transformed-cards-display, none)}.transformed-cards [beacon-tag-name=beacon-table-header]{--text-cell-padding-inline-start: 0;font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-200)}.transformed-cards [beacon-tag-name=beacon-table-header]::part(text-cell){padding:0}.transformed-cards [beacon-tag-name=beacon-table-record]{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-body-100);margin-inline:0}.transformed-cards [beacon-tag-name=beacon-table-record]::part(cell){padding:0}.transformed-cards [beacon-tag-name=beacon-table-record]::part(cell-wrapper){margin-inline:0}.transformed-cards [beacon-tag-name=beacon-table-record]::part(action-zone){margin-inline-start:var(--beacon-reference-space-3)}.transformed-cards [beacon-tag-name=beacon-table-stub]{--stub-content-margin-inline-end: 0;--stub-content-margin-inline-start: 0}.transformed-cards [beacon-tag-name=beacon-table-stub]::part(content){padding:0}.transformed-cards [beacon-tag-name=beacon-table-header],.transformed-cards [beacon-tag-name=beacon-table-record],.transformed-cards .stub,.transformed-cards .header,.transformed-cards .record{color:var(--beacon-system-color-text-standard);font-size:var(--beacon-reference-space-4)}.transformed-cards .card{background-color:var(--beacon-system-color-background-primary);border-radius:var(--beacon-system-radius-corner-circle);display:grid;gap:var(--beacon-reference-space-5);padding:var(--beacon-reference-space-5)}.transformed-cards .card:not(:last-of-type){margin-block-end:var(--beacon-reference-space-5)}.transformed-cards .card .stub{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-body-100)}.transformed-cards .card-data{display:grid;font-size:var(--beacon-reference-space-3);gap:var(--beacon-reference-space-5)}.transformed-cards .card-row{padding-block-end:var(--padding-block-end)}.transformed-cards .card-row .header{flex:1;line-height:1.6}.transformed-cards .card-row .record{font-weight:var(--beacon-system-font-weight-bold);line-height:1.43}.transformed-cards .card-row:not(.grouped){align-items:center}.transformed-cards .card-row.grouped{--padding-block-end: var(--beacon-reference-space-5);display:flex;flex-direction:column}.transformed-cards .card-row:not(:last-of-type){border-block-end:var(--beacon-system-width-border-mini) solid var(--beacon-system-color-border-secondary)}.transformed-cards .card-row.single{--padding-block-end: var(--beacon-reference-space-5)}.transformed-cards .grid{display:grid;grid-template-columns:1fr 1fr}.transformed-cards .grid .record,.transformed-cards .grid [beacon-tag-name=beacon-table-record]{justify-self:end}.transformed-cards .header-children :is(.header,[beacon-tag-name=beacon-table-header]){text-indent:var(--beacon-reference-space-5)}:host([is-scrolling-block]) .table-container{block-size:calc(var(--js-component-size-block) - var(--table-space-padding) * 4)}:host([use-cards]){--table-container-display: none;--transformed-cards-display: block}:host([use-cards]) a{color:var(--beacon-system-color-text-link)}@media (width >= 640px){.table-container.full-bleed{--inline-margin: 0}:host([use-cards]){--table-container-display: block;--transformed-cards-display: none}}`;
var sk = Object.defineProperty, lk = Object.getOwnPropertyDescriptor, qt = (i, t, e, a) => {
  for (var o = a > 1 ? void 0 : a ? lk(t, e) : t, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = (a ? r(t, e, o) : r(o)) || o);
  return a && o && sk(t, e, o), o;
}, va, ei, Hn, La, tt, Wm, qm, sn, Qd, Xd, Vm;
const Ht = (tt = class extends Ke(Le).with(Ra) {
  constructor() {
    super(...arguments);
    Fe(this, sn);
    Fe(this, va);
    Fe(this, ei);
    Fe(this, Hn);
    this.beaconTagName = Jp.beaconTagName, this.deferOptions = { rootMargin: "3000px" }, Ne(this, va, {
      stickyStub: "has-sticky-stub-column",
      stickyHeader: "has-sticky-header",
      lightDOMTable: "beacon-table",
      floatingStub: "floating-stub"
    }), this.variant = dl.MOVABLE, this.sortable = !1, this.useCards = !1, this.hasMultiLevel = !1, this.mobileFullBleed = !1, this.density = ik.Standard, this.staticHeader = !1, this.scrollPositionBlock = 0, this.scrollPositionInline = 0, Ne(this, Hn, !1), this.sortRows = (e) => {
      var T, O, j;
      const { target: a } = e;
      if (!a) return;
      this.mutationObserver.disconnect(), this.querySelectorAll("[aria-sort]").forEach((D) => {
        var F;
        a !== D && Ze(F = tt, La, Xd).call(F, D, "none");
      });
      let n;
      if (a instanceof Jc) {
        const D = a.parentElement, F = (T = this.table) == null ? void 0 : T.querySelector("tbody"), B = D instanceof HTMLTableCellElement;
        if (!D || !F || !B)
          return;
        const N = tt.getOrderedHeaders(this.headers);
        if (a.dropdown && a.selectedValue) {
          const x = a.selectedValue;
          n = N.map((M) => M.id).indexOf(x);
        } else
          n = N.indexOf(
            D
          );
        const f = tt.sortRowData(
          this,
          F,
          a,
          n
        );
        tt.renderSortedRows(F, f);
        const w = e.target instanceof Jc ? (O = e == null ? void 0 : e.detail) == null ? void 0 : O.id : null;
        this.updateSortAttributes(w);
      } else {
        const D = a, F = (j = this.table) == null ? void 0 : j.tBodies[0];
        n = tt.getOrderedHeaders(this.headers).indexOf(
          D
        );
        const N = tt.sortRowData(
          this,
          F,
          D,
          n
        );
        tt.renderSortedRows(F, N);
      }
    }, this.mutationObserver = new MutationObserver(
      (e) => {
        if (this.useCards) {
          const a = ["table", "thead", "tbody", "tr"];
          e.forEach((o) => {
            const { target: n, type: r } = o;
            r === "childList" && (n.assignedSlot || a.includes(n.nodeName.toLowerCase())) && this.renderTransformedCards();
          });
        }
      }
    ), this.compare = (e, a) => ze(this, ei) === Wt.ASCENDING ? e.value === a.value ? 0 : typeof e.value == "number" && typeof a.value == "number" ? e.value - a.value : e.value < a.value ? -1 : 1 : ze(this, ei) === Wt.DESCENDING ? e.value === a.value ? 0 : typeof e.value == "number" && typeof a.value == "number" ? a.value - e.value : e.value > a.value ? -1 : 1 : 0;
  }
  static get styles() {
    return [super.styles, rk];
  }
  static get lightDOMStyles() {
    return [...super.lightDOMStyles, nk, ak];
  }
  get headers() {
    var e;
    return (e = this.table) == null ? void 0 : e.querySelectorAll("thead th");
  }
  get stubs() {
    var e;
    return (e = this.table) == null ? void 0 : e.querySelectorAll("tbody tr th:first-of-type");
  }
  get records() {
    var e;
    return (e = this.table) == null ? void 0 : e.querySelectorAll("td");
  }
  get table() {
    return Wi(
      this,
      "_table",
      () => this.querySelector("table")
    );
  }
  /**
   * @deprecated since version 4.3.0. Prefer to select the table using CSS.
   * It is a slotted element, so this does not need to be public.
   * @todo Remove this getter entirely in the next major version upgrade.
   */
  get slottedTable() {
    return this.table;
  }
  static getSortValue(e) {
    const { firstElementChild: a } = e;
    return a instanceof ed ? Ze(this, La, Wm).call(this, a) : Ze(this, La, qm).call(this, e);
  }
  /**
   * Iterates through a Nodelist of BeaconTableRecords and sets 'bold' prop to false.
   * Otherwise, updates the data attribute from standard table cells.
   * @param tableRecords list of Elements
   */
  static resetRecordBoldSortStyles(e) {
    e.forEach((a) => {
      a.firstElementChild instanceof ed ? a.firstElementChild.sorted = !1 : a.dataset.beaconSorted = "false";
    });
  }
  /**
   * Sorts the `<tr>` 'rowNodes' of a `<tbody>` element. It retrieves sorting criteria from a BeaconTableHeader and sorts all records in a given column.
   * The function has several sorting exceptions for unsortable elements such as level-2 and level-3 BeaconTableStubs and their respective rows which
   * must remain directly below their parental level-1 BeaconTableStub and its row.
   * @param tableBodyElement a `<tbody>` element
   * @param tableHeaderElement a BeaconTableHeader
   * @param columnIndex index of the column where records are sorted
   * @returns a TableSortingData Object that contains a sorted dataCells array, an array of rowNodes and a WeakMap of level-1/level-2 BeaconTableStub relationships
   * to preserve level-2 and level-3 hierarchies under level-1 BeaconTableStub rows.
   *
   * @todo: Need a concrete API decision for how to distinguish the different levels of stubs so native tables can account for them in sorting
   */
  static sortRowData(e, a, o, n) {
    const r = [], T = [], O = /* @__PURE__ */ new WeakMap(), j = /* @__PURE__ */ new WeakMap();
    let D = 0, F = a == null ? void 0 : a.firstElementChild, B = null, N = null, f = [];
    for (; F; ) {
      const M = F.querySelectorAll("th, td"), p = M[0].firstElementChild;
      tt.resetRecordBoldSortStyles(M);
      const v = M[n], k = v.firstElementChild;
      if (k instanceof ed ? k.sorted = !0 : v.dataset.beaconSorted = "true", p instanceof Zs && p.level === St.ONE || !(p instanceof Zs)) {
        N && f.length && (j.set(N, [
          ...f
        ]), N = null, f = []), r.push(F);
        const m = tt.getSortValue(v), A = {
          index: D,
          value: m
        };
        T.push(A), D += 1;
      }
      p instanceof Zs && (p.level === St.ONE && (B = p), p.level === St.TWO && B && (N = p, O.set(
        B,
        p
      )), p.level === St.THREE && N && f.push(p)), F = F.nextElementSibling;
    }
    N && f.length && j.set(N, [
      ...f
    ]);
    const w = {
      levelOne: O,
      levelTwo: j
    }, x = o instanceof Jc ? o.compare : e.compare;
    return T.sort(x), {
      rowNodes: r,
      dataCells: T,
      tableStubMap: w
    };
  }
  /**
   * Rendering function that appends the sorted rowNode `<tr>`s to the `<tbody>`.
   * @param tableBodyElement a `<tbody>` element
   * @param sortData a TableSortingData Object that contains a sorted dataCells array, an array of rowNodes and a WeakMap of level-1/level-2 BeaconTableStub relationships
   * to preserve level-2 and level-3 hierarchies under level-1 BeaconTableStub rows.
   */
  static renderSortedRows(e, a) {
    const { rowNodes: o, dataCells: n, tableStubMap: r } = a;
    !n || !o.length || n.forEach((T) => {
      var O, j;
      if (T) {
        const D = o[T.index], F = (O = D.firstElementChild) == null ? void 0 : O.firstElementChild;
        if (e == null || e.appendChild(D), F instanceof Zs && F.level === St.ONE) {
          const B = r.levelOne.get(
            F
          ), N = (j = B == null ? void 0 : B.parentElement) == null ? void 0 : j.parentElement;
          if (B && N) {
            e == null || e.appendChild(N);
            const f = r.levelTwo.get(B);
            f && f.length && f.forEach(
              (w) => {
                var M;
                const x = (M = w.parentElement) == null ? void 0 : M.parentElement;
                x && (e == null || e.appendChild(
                  x
                ));
              }
            );
          }
        }
      }
    });
  }
  /**
   * A function that takes a NodeList of header TableCellElements sifts through them in search of nested headers.
   * When it finds nestedHeaders it splices them in the appropriate column order so that each header's index matches
   * its corresponding column of tableRecords.
   * @param headersNodeList a Nodelist of `<th>`'s
   * @returns sorted array of headers.
   */
  static getOrderedHeaders(e) {
    const a = [], o = {};
    e == null || e.forEach((n) => {
      n instanceof HTMLTableCellElement && (n.headers ? o[n.headers] ? o[n.headers].push(n) : o[n.headers] = [n] : a.push(n));
    });
    for (const [n, r] of Object.entries(o)) {
      const T = a.map((O) => O.id).indexOf(n);
      a.splice(T, 1, ...r);
    }
    return a;
  }
  /** Attribute triggers vertical-divider styles for `<th>` elements in `<tbody>` in multi-level stub context. */
  _setMultiLevelAttribute() {
    this.toggleAttribute("multi-level", this.hasMultiLevel);
  }
  // this is called by table stubs
  _setMultiLevel(e) {
    this.hasMultiLevel = e;
  }
  /** Receive scroll events on the component and set scroll position states. */
  captureScrollPosition(e) {
    var r, T, O;
    const { target: a } = e, { scrollLeft: o, scrollTop: n } = a;
    if (this.scrollPositionInline = o, this.scrollPositionBlock = n, this.variant === dl.FLOATING) {
      const j = (T = (r = this.table) == null ? void 0 : r.querySelector("thead th")) == null ? void 0 : T.clientWidth, D = Math.abs(this.scrollPositionInline) + "px";
      this.style.setProperty(
        "--table-stub-floating-override-inset-inline-start",
        D
      ), j && j * 0.8 < this.scrollPositionInline ? this.table.classList.add(ze(this, va).floatingStub) : (O = this.table) == null || O.classList.remove(ze(this, va).floatingStub);
    }
    this.variant === dl.FIXED && Up(
      this.scrollPositionInline,
      this.table,
      ze(this, va).stickyStub
    ), Up(
      this.scrollPositionBlock,
      this.table,
      ze(this, va).stickyHeader
    ), this.updateTableBorders();
  }
  getTableAndContainerRects() {
    var B, N, f;
    const e = (N = (B = this.table) == null ? void 0 : B.getBoundingClientRect()) != null ? N : new DOMRect(), a = this.tableContainer.getBoundingClientRect(), o = e.top - a.top, n = e.left - a.left, r = e.right - a.right, T = e.bottom, j = a.bottom - T, D = (f = this.table) == null ? void 0 : f.querySelector("caption");
    let F = 0;
    return D && (F = D.getBoundingClientRect().top - a.top), {
      tableRect: e,
      containerRect: a,
      tableDistanceFromContainerTop: o,
      tableDistanceFromContainerLeft: n,
      tableDistanceFromContainerRight: r,
      distanceFromContainerBottom: j,
      captionElement: D,
      captionDistanceFromContainerTop: F
    };
  }
  addContainerLeftRightBorders({
    tableDistanceFromContainerLeft: e,
    tableDistanceFromContainerRight: a
  }) {
    var o, n;
    this.tableContainer.classList.toggle(
      "add-left-border",
      e < 0
    ), (o = this.table) == null || o.classList.toggle(
      "container-has-left-border",
      e < 0
    ), this.tableContainer.classList.toggle(
      "add-right-border",
      a >= 0
    ), (n = this.table) == null || n.classList.toggle(
      "container-has-right-border",
      a >= 0
    );
  }
  /**
   * Updates the table borders based on the table and container bounding rectangles
   */
  updateTableBorders() {
    var F, B, N, f, w, x, M, p, v;
    const {
      containerRect: e,
      tableDistanceFromContainerTop: a,
      tableDistanceFromContainerLeft: o,
      tableDistanceFromContainerRight: n,
      captionElement: r,
      captionDistanceFromContainerTop: T
    } = this.getTableAndContainerRects(), O = (B = (F = this.table) == null ? void 0 : F.querySelector("thead")) == null ? void 0 : B.getBoundingClientRect(), j = (f = (N = this.table) == null ? void 0 : N.querySelector("tbody")) == null ? void 0 : f.getBoundingClientRect(), D = O ? O.top - e.top : j ? j.top - e.top : 0;
    r ? (T <= 0 && D === 0 && (this.tableContainer.classList.contains("add-full-border") || this.tableContainer.classList.add("add-full-border"), this.tableContainer.classList.remove("add-bottom-border"), (w = this.table) != null && w.classList.contains("container-has-border") || (x = this.table) == null || x.classList.add("container-has-border")), T <= 0 && D > 1 && (this.tableContainer.classList.remove("add-full-border"), this.tableContainer.classList.add("add-bottom-border"), (M = this.table) == null || M.classList.remove("container-has-border"))) : (D <= 0 && a < 0 && (this.tableContainer.classList.add("add-full-border"), this.tableContainer.classList.remove("add-bottom-border"), (p = this.table) == null || p.classList.add("container-has-border")), a >= 0 && (this.tableContainer.classList.remove("add-full-border"), this.tableContainer.classList.add("add-bottom-border"), (v = this.table) == null || v.classList.remove("container-has-border"))), this.addContainerLeftRightBorders({
      tableDistanceFromContainerLeft: o,
      tableDistanceFromContainerRight: n
    });
  }
  /** Adds a bottom, left or right border to the table container on initial load if the table overflows. */
  addContainerBorders() {
    const {
      distanceFromContainerBottom: e,
      tableDistanceFromContainerLeft: a,
      tableDistanceFromContainerRight: o
    } = this.getTableAndContainerRects();
    e < 0 && this.tableContainer.classList.add("add-bottom-border"), this.addContainerLeftRightBorders({
      tableDistanceFromContainerLeft: a,
      tableDistanceFromContainerRight: o
    });
  }
  /** Handler to render transformed cards when table is resized to mobile view. */
  _handleBreakpointChanges() {
    !this.isMediumBreakpoint && this.useCards && (this.renderTransformedCards(), this.table && this.mutationObserver.observe(this.table, {
      childList: !0,
      characterData: !0,
      subtree: !0
    }));
  }
  /**
   * Creates content for the cards from the stub, header, or record parent elements.
   * @param start Element to use as the reference node
   * @param type The type of component the final result is, such as 'stub' or 'header' or 'record'
   * @returns A new element made from the children of the starting element
   */
  static generateCardContent(e, a) {
    const o = document.createElement("div"), n = Array.from(
      e.childNodes,
      (O) => O.cloneNode(!0)
    );
    n && o.append(...n);
    const r = Ia(), T = "uuid";
    return e.setAttribute(T, r), o.setAttribute(T, r), o.classList.add(a), o;
  }
  /**
   * Clones a Beacon Table Cell and changes its state.
   * @param component Beacon Table component to be cloned
   * @returns Clone of the node with its state changed
   */
  static cloneComponent(e) {
    const a = e.cloneNode(!0);
    return a.isOriginal = !1, a;
  }
  /** For mobile card view, iterate over all child components and clone them into cards. */
  async renderTransformedCards() {
    await this.updateComplete;
    const e = "stub", a = "header", o = "record", n = Vo(
      this.stubs,
      (r) => {
        if (!this.records) return;
        const T = Array.from(this.records).filter(
          (D) => {
            var F;
            return (F = r.parentNode) == null ? void 0 : F.contains(D);
          }
        ), O = r.querySelector(
          this.getScopedTagName("beacon-table-stub")
        ), j = O ? tt.cloneComponent(O) : tt.generateCardContent(r, e);
        return pe`
          <div class="card">
            ${j}
            <div class="card-data">
              ${Vo(
          this.headers,
          (D, F) => {
            if (!this.records || F === 0) return;
            let B = pe``, N = "single grid", f;
            const w = Array.from(this.records).filter(
              (m) => D1(m) === D
            );
            if (!w) return B;
            const x = w.find(
              (m) => T.includes(m)
            );
            if (!x) return B;
            const p = Gd(
              D,
              !1,
              !1,
              ["th"]
            ), v = D.querySelector(
              this.getScopedTagName("beacon-table-header")
            ), k = v ? tt.cloneComponent(v) : tt.generateCardContent(D, a);
            if (p && p.length > 0)
              N = "grouped", B = pe`${k}
                    ${Vo(
                p,
                (m, A) => {
                  const C = T.indexOf(x) + A, H = T[C], G = m.querySelector(
                    this.getScopedTagName("beacon-table-header")
                  ), P = G ? tt.cloneComponent(G) : tt.generateCardContent(
                    m,
                    a
                  ), y = H.querySelector(
                    this.getScopedTagName("beacon-table-record")
                  );
                  return f = y ? tt.cloneComponent(y) : tt.generateCardContent(
                    H,
                    o
                  ), pe`
                          <div class="header-children grid">
                            ${P} ${f}
                          </div>
                        `;
                }
              )} `;
            else {
              const m = x.querySelector(
                this.getScopedTagName("beacon-table-record")
              );
              f = m ? tt.cloneComponent(m) : tt.generateCardContent(
                x,
                o
              ), B = pe` ${k} ${f} `;
            }
            return pe`
                    <div class="card-row ${N}">${B}</div>
                  `;
          }
        )}
            </div>
          </div>
        `;
      }
    );
    Es(n, this._transformedCardsContainer), Re(this, Ee.RENDER_TABLE_CARDS), this.triggerRecordActionZoneStatus();
  }
  /**
   * Manually calls `setActionZoneStatus` on each BeaconTableRecord component in the cards to make sure the slot area is visible or hidden as needed.
   */
  async triggerRecordActionZoneStatus() {
    this._transformedCardsContainer.querySelectorAll(
      this.getScopedTagName("beacon-table-record")
    ).forEach(
      async (a) => {
        await a.updateComplete, a.setActionZoneStatus();
      }
    );
  }
  _handleCardChanges() {
    this.isMobile && this.useCards && this.renderTransformedCards();
  }
  _handleSortChanges() {
    this.sortable ? Ze(this, sn, Vm).call(this) : Ze(this, sn, Qd).call(this);
  }
  /**
   * This updates sort-inactive attributes on all BeaconTableHeaders except the one that triggered the sort event.
   * @param targetId Id of BeaconTableHeader that triggered the sort event
   */
  updateSortAttributes(e) {
    var o;
    const a = this.querySelectorAll(
      this.getScopedTagName("beacon-table-header")
    );
    for (const n of a)
      ((o = n.parentElement) == null ? void 0 : o.id) !== e && n.resetSortedAttr();
  }
  // Not using @prerender here because table needs to be able to sort in defer-until=visible context.
  connectedCallback() {
    setTimeout(
      () => this.addEventListener(
        Ee.SORT,
        this.sortRows
      ),
      100
    ), super.connectedCallback();
  }
  async firstUpdated() {
    this.table && (this.table.classList.add(ze(this, va).lightDOMTable), await this.updateComplete, this.useCards && this.isMobile && (this.renderTransformedCards(), this.mutationObserver.observe(this.table, {
      childList: !0,
      characterData: !0,
      subtree: !0
    })), this.addContainerBorders()), super.firstUpdated();
  }
  render() {
    return pe`
      <div class="transformed-cards"></div>
      <div
        class="table-container ${this.mobileFullBleed ? "full-bleed" : "contained"}"
        tabindex=${qi()}
        @scroll=${this.captureScrollPosition}>
        <slot></slot>
      </div>
    `;
  }
}, va = new WeakMap(), ei = new WeakMap(), Hn = new WeakMap(), La = new WeakSet(), Wm = function(e) {
  const { variant: a, sortValue: o } = e;
  return o && (a === fa.NUMERAL || a === fa.DATE) ? parseFloat(o) : o;
}, qm = function(e) {
  var T;
  const {
    innerText: a,
    dataset: { beaconSortValue: o, beaconSortType: n }
  } = e, r = (T = a == null ? void 0 : a.toLowerCase().trim()) != null ? T : "";
  return n === "number" ? parseFloat(o || r) : o != null ? o : r;
}, sn = new WeakSet(), /** Updates the sort state for sortable headers that aren't a BeaconTableHeader. */
Qd = function() {
  const e = this.querySelectorAll(
    "[data-beacon-sort-state]"
  );
  for (const a of e)
    a.dataset.beaconSortState = String(this.sortable);
}, Xd = function(e, a) {
  const o = e.querySelector("[data-beacon-sort]"), n = o == null ? void 0 : o.querySelector(".sort-text");
  if (n) {
    switch (a) {
      case "ascending":
      case "descending":
        n.innerHTML = `Sorted ${a}`;
        break;
      case "none":
        n.innerHTML = "Sort";
        break;
    }
    e.setAttribute("aria-sort", a);
  }
}, Vm = function() {
  if (Ze(this, sn, Qd).call(this), ze(this, Hn)) return;
  const e = this.querySelector("thead"), a = e == null ? void 0 : e.querySelectorAll("th"), o = document.createElement("template");
  o.innerHTML = `
      <style>
        .base {
          display: grid;
          grid-template-columns: 1fr auto;
        }
      </style>
      <div class="base">
        <div class="default-slot"><slot></slot></div>
        <div class="sort-row"><slot name="sort"></slot></div>
      </div>
    `, a == null || a.forEach((n) => {
    if (!("beaconSortable" in n.dataset)) return;
    const r = document.createElement("div");
    r.dataset.beaconSortState = String(this.sortable), n.childNodes.forEach(
      (F) => r.appendChild(F)
    ), n.appendChild(r), r.attachShadow({ mode: "open" }).appendChild(
      o.content.cloneNode(!0)
    );
    const O = document.createElement("template");
    O.innerHTML = `
        <${this.getScopedTagName("beacon-icon-button")} slot="sort" variant="tertiary" data-beacon-sort>
          <svg data-metrics-link-text="Sort ascending" class="ascending" slot="icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M8 3L12 8H8.5L8.5 13H7.5L7.5 8H4L8 3Z"/>
          </svg>
          <svg data-metrics-link-text="Sort descending" class="descending" slot="icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M8.5 8L8.5 3H7.5L7.5 8H4L8 13L12 8H8.5Z"
            />
          </svg>
          <svg class="default" slot="icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M8 2L11 6H5L8 2ZM8 14L5 10H11L8 14Z" />
          </svg>
          <span class="sort-text">Sort</span>
        </${this.getScopedTagName("beacon-icon-button")}>
        `;
    const j = O.content.cloneNode(!0);
    r.appendChild(j);
    const D = r.querySelector(
      this.getScopedTagName("beacon-icon-button")
    );
    D == null || D.addEventListener(Ee.CLICK, () => {
      var F;
      Ne(this, ei, ze(this, ei) === Wt.ASCENDING ? Wt.DESCENDING : Wt.ASCENDING), Ze(F = tt, La, Xd).call(F, n, ze(this, ei)), Re(n, Ee.SORT);
    });
  }), Ne(this, Hn, !0);
}, Fe(tt, La), tt.tagName = Jp.beaconTagName, tt);
qt([
  ue({ reflect: !0 })
], Ht.prototype, "variant", 2);
qt([
  ue({ type: Boolean })
], Ht.prototype, "sortable", 2);
qt([
  ue({ type: Boolean, attribute: "use-cards" })
], Ht.prototype, "useCards", 2);
qt([
  Se()
], Ht.prototype, "hasMultiLevel", 2);
qt([
  ue({ attribute: "mobile-full-bleed", type: Boolean })
], Ht.prototype, "mobileFullBleed", 2);
qt([
  ue({ reflect: !0 })
], Ht.prototype, "density", 2);
qt([
  ue({ attribute: "static-header", type: Boolean, reflect: !0 })
], Ht.prototype, "staticHeader", 2);
qt([
  Se()
], Ht.prototype, "scrollPositionBlock", 2);
qt([
  Se()
], Ht.prototype, "scrollPositionInline", 2);
qt([
  Ge(".table-container")
], Ht.prototype, "tableContainer", 2);
qt([
  Ge(".transformed-cards")
], Ht.prototype, "_transformedCardsContainer", 2);
qt([
  yo("hasMultiLevel")
], Ht.prototype, "_setMultiLevelAttribute", 1);
qt([
  yo("isMediumBreakpoint")
], Ht.prototype, "_handleBreakpointChanges", 1);
qt([
  yo("useCards")
], Ht.prototype, "_handleCardChanges", 1);
qt([
  yo("sortable")
], Ht.prototype, "_handleSortChanges", 1);
let ck = Ht;
var Ym = /* @__PURE__ */ ((i) => (i.HORIZONTAL = "row", i.VERTICAL = "column", i))(Ym || {}), Qm = /* @__PURE__ */ ((i) => (i.CENTER = "center", i.LEFT = "left", i.RIGHT = "right", i))(Qm || {}), Xm = /* @__PURE__ */ ((i) => (i.BOTTOM = "bottom", i.TOP = "top", i.MIDDLE = "middle", i))(Xm || {});
Xm.TOP, Qm.CENTER, Ym.HORIZONTAL;
const dk = `<svg height="12" width="12" viewbox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" class="beacon-legend-item__icon">
    <circle stroke-width="0" cx="6" cy="6" r="2" />
</svg>
`, hk = `<svg height="12" width="12" viewbox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" class="beacon-legend-item__icon">
    <circle stroke-width="0" cx="6" cy="6" r="6" />
</svg>
`, bk = `<svg width="10" height="10" viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg" class="beacon-legend-item__icon">
    <rect y="5" width="7" height="7" transform="rotate(-45 0 5)"/>
</svg>
`, pk = `<svg height="10" width="10" viewbox="0 0 10 10" xmlns="http://www.w3.org/2000/svg" class="beacon-legend-item__icon">
    <rect width="10" height="10"/>
</svg>
`, uk = `<svg width="10" height="8" viewBox="0 0 10 8" xmlns="http://www.w3.org/2000/svg" class="beacon-legend-item__icon">
    <path d="M10 0L5 8L6.99382e-07 -8.74228e-07L10 0Z"/>
</svg>
`, gk = `<svg width="10" height="8" viewBox="0 0 10 8" xmlns="http://www.w3.org/2000/svg" class="beacon-legend-item__icon">
    <path d="M0 8L5 0L10 8H0Z"/>
</svg>
`;
pe` <beacon-table id="datatable">
  <table>
    <thead>
      <tr>
        <th>Year</th>
        <th>Company A</th>
        <th>Company B</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <th>2016</th>
        <td>30386</td>
        <td>28504</td>
      </tr>
      <tr>
        <th>2017</th>
        <td>29173</td>
        <td>27460</td>
      </tr>
      <tr>
        <th>2018</th>
        <td>28430</td>
        <td>26690</td>
      </tr>
      <tr>
        <th>2019</th>
        <td>28042</td>
        <td>26453</td>
      </tr>
      <tr>
        <th>2020</th>
        <td>27063</td>
        <td>25916</td>
      </tr>
      <tr>
        <th>2021</th>
        <td>28684</td>
        <td>27376</td>
      </tr>
    </tbody>
  </table>
</beacon-table>`;
const $a = {
  multiLevel: dk,
  circle: hk,
  triangle: gk,
  square: pk,
  diamond: bk,
  triangleDown: uk
};
function mk(i) {
  const t = [...Object.values(Ja)], e = i % t.length;
  return t[e];
}
function od(i, t, e) {
  if (t)
    return $a.multiLevel;
  const a = [
    Jt.LINE,
    Jt.SCATTER,
    Jt.AREA
  ];
  if (e && a.includes(e))
    switch (mk(i)) {
      case Ja.CIRCLE:
        return $a.circle;
      case Ja.TRIANGLE:
        return $a.triangle;
      case Ja.SQUARE:
        return $a.square;
      case Ja.DIAMOND:
        return $a.diamond;
      case Ja.TRIANGLE_DOWN:
        return $a.triangleDown;
      default:
        return $a.circle;
    }
  else
    return $a.circle;
}
const Js = ve`[beacon-tag-name$=chart] [slot=title]{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-loose-50)}[beacon-tag-name$=chart] [slot=subtitle],[beacon-tag-name$=chart] [slot=caption]{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-loose-300)}.highcharts-tooltip-container{z-index:1200!important}.highcharts-tooltip-container svg{max-inline-size:unset}.beacon-chart-tooltip{background-color:var(--beacon-system-color-background-1);color:var(--beacon-system-color-text-standard);fill:var(--beacon-system-color-background-1)}.beacon-chart-tooltip .highcharts-color-0{fill:var(--beacon-system-color-data-viz-0);stroke:var(--beacon-system-color-data-viz-0)}.beacon-chart-tooltip .highcharts-color-1{fill:var(--beacon-system-color-data-viz-1);stroke:var(--beacon-system-color-data-viz-1)}.beacon-chart-tooltip .highcharts-color-2{fill:var(--beacon-system-color-data-viz-2);stroke:var(--beacon-system-color-data-viz-2)}.beacon-chart-tooltip .highcharts-color-3{fill:var(--beacon-system-color-data-viz-3);stroke:var(--beacon-system-color-data-viz-3)}.beacon-chart-tooltip .highcharts-color-4{fill:var(--beacon-system-color-data-viz-4);stroke:var(--beacon-system-color-data-viz-4)}.beacon-chart-tooltip .highcharts-color-5{fill:var(--beacon-system-color-data-viz-5);stroke:var(--beacon-system-color-data-viz-5)}.beacon-chart-tooltip .highcharts-color-6{fill:var(--beacon-system-color-data-viz-6);stroke:var(--beacon-system-color-data-viz-6)}.beacon-chart-tooltip .highcharts-color-7{fill:var(--beacon-system-color-data-viz-7);stroke:var(--beacon-system-color-data-viz-7)}.beacon-chart-tooltip .highcharts-color-8{fill:var(--beacon-system-color-data-viz-8);stroke:var(--beacon-system-color-data-viz-8)}.beacon-chart-tooltip .highcharts-color-9{fill:var(--beacon-system-color-data-viz-9);stroke:var(--beacon-system-color-data-viz-9)}.beacon-chart-tooltip .highcharts-color-10{fill:var(--beacon-system-color-data-viz-10);stroke:var(--beacon-system-color-data-viz-10)}.beacon-chart-tooltip .highcharts-color-11{fill:var(--beacon-system-color-data-viz-11);stroke:var(--beacon-system-color-data-viz-11)}.beacon-chart-tooltip.area.single-series-chart:not(.stacked-chart) .beacon-chart-tooltip__point.highcharts-color-0.negative{fill:var(--beacon-reference-palette-functional-red-3);stroke:var(--beacon-reference-palette-functional-red-3)}.beacon-chart-tooltip.area.single-series-chart:not(.stacked-chart) .beacon-chart-tooltip__point.highcharts-color-0.positive{fill:var(--beacon-reference-palette-functional-green-3);stroke:var(--beacon-reference-palette-functional-green-3)}.beacon-chart-tooltip__title{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100)}.beacon-chart-tooltip__point,.beacon-chart-tooltip-point__label{align-items:center;display:flex}.beacon-chart-tooltip__point{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-300);gap:var(--beacon-reference-space-3)}.beacon-chart-tooltip__point:not(:first-of-type){margin-block-start:var(--beacon-reference-space-3)}.beacon-chart-tooltip__separator{border:0;border-block-start-color:var(--beacon-system-color-icon-primary-inactive);border-block-start-style:solid;border-block-start-width:var(--beacon-system-width-border-mini)}.beacon-chart-tooltip__point--multi-level .beacon-legend-item__icon{fill:var(--beacon-system-color-icon-primary-inactive)}.beacon-chart-tooltip__footer,.beacon-chart-tooltip__additional-content{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-300);margin-block-start:var(--beacon-reference-space-3)}.beacon-chart-tooltip-point__label{gap:var(--beacon-reference-space-4)}.beacon-chart-tooltip__point-value{font-weight:var(--beacon-system-font-weight-bold)}`, fk = ve`*{margin:0;padding:0}:host{--component-background-color: transparent;--component-gap-space: var(--beacon-system-space-micro-jumbo);background-color:var(--component-background-color)}.base{padding-block:var(--beacon-reference-space-3)}.chart{block-size:var(--beacon-custom-chart-container-size-block, auto)}.header{margin-block-end:var(--component-gap-space);padding-inline:var(--beacon-reference-space-5)}.caption{margin-block-start:var(--component-gap-space);padding-inline:var(--beacon-reference-space-5)}.highcharts-background{fill:var(--component-background-color)}.highcharts-focus-border{stroke:var(--beacon-system-color-border-focus-outer);stroke-width:var(--beacon-system-width-border-jumbo)}.highcharts-container{color:inherit;font-family:inherit}.highcharts-container :not(.highcharts-tooltip,.highcharts-tooltip-box,.highcharts-button)>text{fill:currentcolor}.highcharts-legend-item .highcharts-focus-border{display:none}.highcharts-legend-navigation{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-300);color:var(--beacon-system-color-text-standard)}.highcharts-legend-nav-active{fill:var(--beacon-system-color-icon-secondary)}.highcharts-legend-nav-inactive{fill:var(--beacon-system-color-icon-secondary-inactive)}.beacon-legend-item{--background-color: var(--beacon-system-color-background-1);--legend-item-padding: var(--beacon-system-space-cell-contained);font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-300);align-items:center;background-color:var(--background-color);border-color:transparent;border-radius:var(--beacon-system-radius-corner-standard);border-style:solid;border-width:var(--beacon-system-width-border-normal, 2px);display:flex;gap:var(--beacon-reference-space-3);padding:var(--legend-item-padding)}.beacon-legend-item .beacon-legend-item__label{align-items:center;display:flex;gap:var(--beacon-reference-space-4)}.beacon-legend-item.beacon-legend-item--hover{--background-color: var(--beacon-system-color-background-secondary-hover);border-color:var(--beacon-system-color-border-secondary)}.beacon-legend-item.beacon-legend-item--hover .beacon-legend-item__label-text{text-decoration:underline}.beacon-legend-item.beacon-legend-item--focus{box-shadow:0 0 0 var(--beacon-system-width-border-jumbo) var(--beacon-system-color-border-focus-middle),0 0 0 var(--beacon-system-width-border-maxi) var(--beacon-system-color-border-focus-outer);outline:var(--beacon-system-width-border-normal) solid var(--beacon-system-color-border-focus-inner);outline-offset:0;z-index:1}.beacon-legend-item.beacon-legend-item--focus:not(dialog){position:relative}.beacon-legend-item .beacon-legend-item__value{font-weight:var(--beacon-system-font-weight-bold)}.highcharts-legend-item-hidden *{text-decoration:none}.highcharts-legend-item-hidden .beacon-legend-item{--background-color: transparent}.highcharts-legend-item-hidden .beacon-legend-item.beacon-legend-item--hover{--background-color: var(--beacon-system-color-background-secondary-hover);border-color:var(--beacon-system-color-border-secondary)}.static-legend .highcharts-legend{pointer-events:none}.static-legend .highcharts-a11y-proxy-group-legend button{cursor:default;pointer-events:none}.static-legend .beacon-legend-item{--background-color: transparent;--legend-item-padding: 0;border-radius:0}.static-legend[legend-layout*=horizontal] .highcharts-legend-item:not(:last-of-type) .beacon-legend-item{border-inline-end:var(--beacon-system-width-border-mini) solid var(--beacon-system-color-border-0);padding-inline-end:var(--beacon-system-space-micro-jumbo)}.static-legend[legend-layout*=horizontal] .highcharts-legend-item:not(:first-of-type) .beacon-legend-item:not(.beacon-legend-item--0){padding-inline-start:var(--beacon-system-space-micro-jumbo)}.static-legend[legend-layout*=vertical] .highcharts-legend-item:not(:last-of-type) .beacon-legend-item{border-block-end:var(--beacon-system-width-border-mini) solid var(--beacon-system-color-border-0);padding-block-end:var(--beacon-system-space-micro-normal)}.static-legend[legend-layout*=vertical] .highcharts-legend-item:not(:first-of-type) .beacon-legend-item:not(.beacon-legend-item--0){padding-block-start:var(--beacon-system-space-micro-normal)}.static-legend[legend-layout*=vertical] .beacon-legend-item{min-block-size:var(--beacon-reference-space-10)}@media (width >= 640px){.static-legend[legend-layout*=vertical] .beacon-legend-item{min-block-size:var(--beacon-reference-space-11)}}@media (width >= 960px){.static-legend[legend-layout*=vertical] .beacon-legend-item{min-block-size:var(--beacon-reference-space-12)}}@media (width >= 1280px){.static-legend[legend-layout*=vertical] .beacon-legend-item{min-block-size:var(--beacon-reference-space-13)}}.highcharts-color-0{fill:var(--beacon-system-color-data-viz-0);stroke:var(--beacon-system-color-data-viz-0)}.highcharts-color-1{fill:var(--beacon-system-color-data-viz-1);stroke:var(--beacon-system-color-data-viz-1)}.highcharts-color-2{fill:var(--beacon-system-color-data-viz-2);stroke:var(--beacon-system-color-data-viz-2)}.highcharts-color-3{fill:var(--beacon-system-color-data-viz-3);stroke:var(--beacon-system-color-data-viz-3)}.highcharts-color-4{fill:var(--beacon-system-color-data-viz-4);stroke:var(--beacon-system-color-data-viz-4)}.highcharts-color-5{fill:var(--beacon-system-color-data-viz-5);stroke:var(--beacon-system-color-data-viz-5)}.highcharts-color-6{fill:var(--beacon-system-color-data-viz-6);stroke:var(--beacon-system-color-data-viz-6)}.highcharts-color-7{fill:var(--beacon-system-color-data-viz-7);stroke:var(--beacon-system-color-data-viz-7)}.highcharts-color-8{fill:var(--beacon-system-color-data-viz-8);stroke:var(--beacon-system-color-data-viz-8)}.highcharts-color-9{fill:var(--beacon-system-color-data-viz-9);stroke:var(--beacon-system-color-data-viz-9)}.highcharts-color-10{fill:var(--beacon-system-color-data-viz-10);stroke:var(--beacon-system-color-data-viz-10)}.highcharts-color-11{fill:var(--beacon-system-color-data-viz-11);stroke:var(--beacon-system-color-data-viz-11)}.visually-hidden{border:0;clip:rect(0,0,0,0);block-size:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;inline-size:1px}`;
var vk = Object.defineProperty, Ak = Object.getOwnPropertyDescriptor, Ot = (i, t, e, a) => {
  for (var o = a > 1 ? void 0 : a ? Ak(t, e) : t, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = (a ? r(t, e, o) : r(o)) || o);
  return a && o && vk(t, e, o), o;
};
const yk = ["top", "middle", "bottom"], xk = ["center", "right"], wk = ["horizontal", "vertical"];
function kk(i) {
  return typeof i.legendWidth == "number";
}
function Ck(i) {
  return typeof i.maxLegendWidth == "number";
}
function eu(i) {
  return i.a11yProxyElement !== void 0;
}
function tu(i) {
  return i.a11yProxyElement !== void 0;
}
var We;
const xt = (We = class extends Le {
  constructor() {
    super(...arguments), this.resetSpacing = !0, this._type = Jt.LINE, this.series = [], this.options = {}, this.staticLegend = !1, this.disableLegend = !1, this.hideLegendMetric = !1, this.legendLayout = We.defaultLegendLayout, this.tooltipTitle = "", this.tooltipFooter = "", this.tooltipVariant = Ir.SINGLE_LINE, this.disableMarkers = !1, this.percentage = !1, this.decimal = !1, this.decimalPlaces = 1, this.chart = null, this.filteredOptions = {}, this.colorOrder = ba.STANDARD;
  }
  static get styles() {
    return [super.styles, sA, fk];
  }
  static get lightDOMStyles() {
    return [super.lightDOMStyles, Js];
  }
  /**
   * The type of chart being rendered. Follows Highcharts chart types.
   * @abstract
   */
  get type() {
    return this._type;
  }
  /**
   * Local options defined on the component-level.
   * @abstract
   */
  get localComponentOptions() {
    return {};
  }
  /**
   * This getter ensures that the chart type is included in the series data
   * when it's passed to highcharts. This ensures that data passed to highcharts
   * is type-safe for users in TS contexts.
   */
  get seriesWithChartType() {
    return this.series.map((t) => ({
      ...t,
      type: this.type
    }));
  }
  /**
   * Global chart options applicable to all charts.
   */
  get chartOptions() {
    const t = this.hideLegendMetric, e = this.percentage, a = this.decimal, o = this.decimalPlaces, n = this.type, r = this.addBeaconModeToTooltipContainer.bind(this);
    return {
      accessibility: {
        linkedDescription: this.linkedDescriptionNode
      },
      chart: {
        animation: !1,
        colorCount: 12,
        events: {
          /**
           * @this Chart
           *
           * On redraw, we assign styles and classes to the legend items so they can match our design spec.
           * Since we use custom HTML in the formatter, this is not captured on a persistant basis by Highcharts.
           */
          redraw() {
            var T, O, j;
            if ("hasLoaded" in this && this.hasLoaded) {
              const D = (j = (O = (T = this.userOptions) == null ? void 0 : T.plotOptions) == null ? void 0 : O.custom) == null ? void 0 : j.host;
              if (D && D.staticLegend)
                return !1;
              const { allItems: F } = this.legend;
              F.forEach((B) => {
                if (B instanceof ma.Point && eu(B) || B instanceof ma.Series && tu(B)) {
                  const {
                    a11yProxyElement: {
                      target: { visual: N }
                    }
                  } = B;
                  if (D == null || D.style.setProperty(
                    "--legend-max-width",
                    N.style.getPropertyValue("width")
                  ), N.dataset.beaconRedrawEvent !== "attached") {
                    const f = N.firstElementChild;
                    N.addEventListener(
                      "mouseover",
                      (w) => {
                        f == null || f.classList.add(
                          "beacon-legend-item--hover"
                        ), (!w.x || !w.y) && (f == null || f.classList.add(
                          "beacon-legend-item--focus"
                        ));
                      }
                    ), N.addEventListener("mouseout", () => {
                      F.forEach((w) => {
                        var x;
                        if (w instanceof ma.Point && eu(w) || w instanceof ma.Series && tu(w)) {
                          const {
                            a11yProxyElement: {
                              target: { visual: M }
                            }
                          } = w;
                          (x = M == null ? void 0 : M.firstElementChild) == null || x.classList.remove(
                            "beacon-legend-item--hover",
                            "beacon-legend-item--focus"
                          );
                        }
                      });
                    });
                  }
                  N.dataset.beaconRedrawEvent = "attached", We.setLegendWidthVariable(this);
                }
              });
            }
            this.reflow();
          }
        },
        // Highcharts default is 400
        // Previous version of Charts didn't take Legend height into account
        // We increase the default height to counteract a possible squished chart
        height: wl.HEIGHT,
        styledMode: !0,
        type: this.type
      },
      credits: {
        enabled: !1
      },
      legend: {
        accessibility: {
          keyboardNavigation: {
            enabled: !this.staticLegend
          }
        },
        align: "center",
        alignColumns: !1,
        enabled: !this.disableLegend,
        labelFormatter() {
          return We.legendItemHTML(
            this,
            t,
            e,
            n,
            a,
            o
          );
        },
        itemDistance: parseFloat(Dd) * 16,
        itemMarginBottom: parseFloat(Dd) * 16,
        itemMarginTop: 0,
        layout: this.legendLayout.direction,
        navigation: {
          enabled: !1
        },
        symbolRadius: 0,
        symbolPadding: 0,
        symbolWidth: 0,
        useHTML: !0,
        verticalAlign: "bottom",
        width: "100%",
        events: {
          /**
           * @this Series
           *
           * We reverse click interaction on legend items. Instead of toggling off, we toggle isolation and "on" state.
           */
          itemClick: function(T) {
            var N, f, w;
            T.preventDefault();
            const { chart: O } = this, j = (w = (f = (N = O == null ? void 0 : O.userOptions) == null ? void 0 : N.plotOptions) == null ? void 0 : f.custom) == null ? void 0 : w.host;
            if (j && j.staticLegend)
              return !1;
            const { series: D } = O, F = D.filter((x) => x.visible).length === D.length, B = D.find(
              (x) => T.legendItem instanceof ma.Series && x.name === T.legendItem.name
            );
            B && (D.length > 1 && F ? D.forEach((x) => {
              T.legendItem instanceof ma.Series && x.update(
                {
                  visible: x.name === T.legendItem.name
                },
                !1
              );
            }) : B.update(
              {
                visible: !B.visible
              },
              !1
            ), O.redraw(), O.reflow());
          }
        }
      },
      plotOptions: {
        custom: {
          host: this
        }
      },
      responsive: {
        rules: [
          {
            condition: {
              minWidth: parseInt(fh, 10)
            },
            chartOptions: {
              legend: {
                align: this.legendLayout.horizontal,
                // center, right
                verticalAlign: We.setLegendVerticalAlignment(
                  this.legendLayout
                ),
                width: We.setLegendWidth(this.legendLayout)
              }
            }
          }
        ]
      },
      series: this.seriesWithChartType,
      subtitle: {
        text: void 0
      },
      symbols: [...Object.values(Ja)],
      title: {
        text: void 0
      },
      tooltip: {
        borderRadius: parseFloat(Rv) * 16,
        className: this.getTooltipClasses(),
        footerFormat: We.tooltipFooterHTML(
          We.tooltipFooterContentHTML(this.tooltipFooter)
        ),
        headerFormat: We.tooltipHeaderHTML(this.tooltipTitle),
        outside: !0,
        padding: We.tooltipPadding(this.tooltipVariant),
        pointFormatter() {
          return r(), We.tooltipPointHTML(
            this,
            this.series.name,
            this.y
          );
        },
        shadow: {
          color: Bv
        },
        shared: this.tooltipVariant === Ir.MULTI_LINE,
        useHTML: !0
      }
    };
  }
  /**
   * Adds a beacon mode class to the Highcharts tooltip container.
   */
  addBeaconModeToTooltipContainer() {
    const t = this.closest('[class*="beacon-on"]');
    setTimeout(() => {
      const e = document.querySelector(
        ".highcharts-tooltip-container"
      );
      if (e && t) {
        const a = Array.from(e.classList).find(
          (n) => n.startsWith("beacon-on")
        ), o = Array.from(
          t.classList
        ).find((n) => n.startsWith("beacon-on"));
        a !== o && (a && e.classList.remove(a), o && e.classList.add(o));
      }
    }, 0);
  }
  /** Parses the legend layout from a string of options. */
  static createLegendLayout(t) {
    if (!t)
      return this.defaultLegendLayout;
    const e = Lm(t);
    if (!e)
      return this.defaultLegendLayout;
    const a = e.find(
      (r) => yk.includes(r)
    ) || this.defaultLegendLayout.vertical, o = e.find(
      (r) => xk.includes(r)
    ) || this.defaultLegendLayout.horizontal;
    let n = e.find(
      (r) => wk.includes(r)
    ) || this.defaultLegendLayout.direction;
    return e.includes("row") ? n = "horizontal" : e.includes("column") && (n = "vertical"), {
      vertical: a,
      horizontal: o,
      direction: n
    };
  }
  /**
   * Sets a CSS variable on the host that helps control the width of the legend items in a vertical state.
   *
   * Takes into account the active and max widths of the Legend, as well as what direction the Legend is in.
   */
  static setLegendWidthVariable(t, e = !1) {
    var B, N, f, w, x, M, p, v;
    const a = (N = (B = t.legend) == null ? void 0 : B.options) == null ? void 0 : N.layout, o = (w = (f = t.legend) == null ? void 0 : f.options) == null ? void 0 : w.align, n = kk(t.legend) ? t.legend.legendWidth : 0, r = Ck(t.legend) ? (x = t.legend) == null ? void 0 : x.maxLegendWidth : 0, T = Math.min(r, n), O = (v = (p = (M = t.userOptions) == null ? void 0 : M.plotOptions) == null ? void 0 : p.custom) == null ? void 0 : v.host, j = O == null ? void 0 : O.style.getPropertyValue("--legend-width");
    e && (O == null || O.style.removeProperty("--legend-width"));
    let D = "auto", F;
    a === "vertical" && (F = T, j && (O == null || O.style.setProperty("--legend-width", F + "px")), j && o === "right" ? D = j : D = F ? F + "px" : "auto"), O == null || O.style.setProperty("--legend-width", D);
  }
  /** HTML for the Legend label. */
  static legendItemHTML(t, e, a, o, n, r) {
    var D, F;
    const { name: T, index: O } = t;
    let j = "";
    if (o === Jt.GAUGE && !e) {
      const B = ((D = t == null ? void 0 : t.data[0]) == null ? void 0 : D.y) != null && t.yAxis.userOptions.min != null ? t.data[0].y - t.yAxis.userOptions.min : (F = t == null ? void 0 : t.data[0]) == null ? void 0 : F.y, N = t.yAxis.userOptions.max != null && t.yAxis.userOptions.min != null ? t.yAxis.userOptions.max - t.yAxis.userOptions.min : t.yAxis.userOptions.max;
      j = `<span class="beacon-legend-item__value">${We.percentageFormatter(a, B, N, n, r)}</span>`;
    }
    return o === Jt.PIE && !e && (j = `<span class="beacon-legend-item__value">${We.percentageFormatter(a, t.y, t.total, n, r)}</span>`), `
      <div class="beacon-legend-item beacon-legend-item--${O}" style="inline-size: var(--legend-width); max-inline-size: var(--legend-max-width, none);">
        <div class="beacon-legend-item__label">
          ${od(O, !1, o)}
          <span class="beacon-legend-item__label-text">${T}</span>${j}
        </div>
      </div>
    `;
  }
  /** Forces Legend vertical alignment if necessary, but otherwise will return the requested value. */
  static setLegendVerticalAlignment({
    horizontal: t,
    vertical: e
  }) {
    return t === "center" ? "bottom" : e;
  }
  /** Set the width of the Legend which depends on both alignment and direction. */
  static setLegendWidth({
    horizontal: t,
    vertical: e,
    direction: a
  }) {
    if (a === "horizontal" && e !== "middle")
      return "100%";
    if (a === "vertical")
      return t === "center" ? "100%" : "33%";
  }
  /** HTML classes for the tooltip's elements. */
  getTooltipClasses() {
    return `beacon-chart-tooltip ${this.tooltipVariant} ${this.colorOrder}`.trim();
  }
  /** Sets the padding on the Tooltip based on variant. */
  static tooltipPadding(t) {
    const e = parseFloat(Uv), a = parseFloat(
      Iv
    );
    let o = e;
    return t !== Ir.SINGLE_LINE && (o = e + a), o * 16;
  }
  /**
   * HTML for the chart tooltip point.
   *
   * Can be used as a helper method for overrides to the point formatter.
   *
   * @example
   * ```ts
   * // Format the value before passing it to the tooltip.
   *
   * const options = {
   *   tooltip: {
   *    pointFormatter() {
   *      const { y } = this;
   *      const percentage = y / 100;
   *
   *      return BeaconChartBase.tooltipPointHTML(this, this.series.name, percentage);
   *    }
   *   }
   * }
   * ```
   */
  static tooltipPointHTML(t, e, a, o) {
    let n;
    return a && Number(a) < 0 ? n = "negative" : n = "positive", `
      <div class="beacon-chart-tooltip__point highcharts-color-${t.colorIndex} ${n}">
        <div class="beacon-chart-tooltip-point__label">
          ${o ? "" : od(t.colorIndex || 0)}
          <span class="beacon-chart-tooltip-point__label-text">${e}</span>
        </div>
        ${a ? `<div class="beacon-chart-tooltip__point-value">${a}</div>` : ""}
      </div>
    `;
  }
  /** HTML for the Tooltip Title (Header). */
  static tooltipHeaderHTML(t) {
    return t ? `<div class="beacon-chart-tooltip__title">${t}</div>` : "";
  }
  /** HTML for the Tooltip's additional content slot (Footer). */
  static tooltipFooterContentHTML(t) {
    return t ? `<div class="beacon-chart-tooltip__additional-content">${t}</div>` : "";
  }
  /** HTML for the Tooltip footer that can include both multi-level content and the additional slot content. */
  static tooltipFooterHTML(t, e) {
    return !t && !e ? "" : `
      <div class="beacon-chart-tooltip__footer">
        ${e ? `<hr class="beacon-chart-tooltip__separator"/>${e}` : ""}
        ${t || ""}
      </div>
    `;
  }
  /** HTML for the Tooltip Point belonging to multi-level tooltips. */
  static multiLevelTooltipPointHTML(t, e, a) {
    return `
      <div class="beacon-chart-tooltip__point beacon-chart-tooltip__point--multi-level">
        <div class="beacon-chart-tooltip-point__label">
          ${a ? "" : od(0, !0)}
          <span class="beacon-chart-tooltip-point__label-text">${t}</span>
        </div>
        ${e ? `<div class="beacon-chart-tooltip__point-value">${e}</div>` : ""}
      </div>
    `;
  }
  /** Modify user-supplied options by filtering out keys not leveraged or not accessible by our component. */
  static filterChartOptions(t) {
    return a1(t, (e, a) => !this.disallowedChartOptions.includes(a));
  }
  /** Merge all possible chart options into a single object. */
  static createChartOptions(...t) {
    return e1(
      {},
      ...t,
      function(e, a) {
        if (mo(e))
          return e.concat(a);
      }
    );
  }
  /** Update Highcharts accessibility data when the caption changes. */
  handleCaptionSlotchange() {
    var t;
    (t = this.chart) == null || t.update({
      accessibility: {
        linkedDescription: this.linkedDescriptionNode
      }
    });
  }
  /**
   * Apply modifications and modules to the Highcharts package.
   *
   * @todo Exhaust any options for API-styling before DOM manipulation. Keep in mind the symbol is separate from the button of the text label.
   */
  initializeHighcharts(t) {
    t.AST.allowedAttributes.push("transform", "viewbox", "viewBox", "xmlns"), cA(t), t.addEvent(t.Legend, "afterRender", function() {
      "hasLoaded" in this.chart && this.chart.hasLoaded && (this.chart.reflow(), We.setLegendWidthVariable(this.chart));
    }), t.addEvent(t.Chart, "load", this.onChartLoad), t.addEvent(t.Chart, "redraw", this.onChartRedraw);
  }
  /**
   * Callback when Highcharts initially loads the chart.
   * @abstract
   */
  onChartLoad(t) {
  }
  /**
   * Callback when Highcharts redraws an existing chart.
   * @abstract
   */
  onChartRedraw(t) {
  }
  /**
   * Calculates total series for use in chart modifications or restrictions.
   *
   * Calculation of the series length may vary by type of chart.
   */
  calculateSeriesLength(t) {
    var e;
    return (e = t.series) == null ? void 0 : e.length;
  }
  /** Determines the color order by length of series in the chart. */
  static calculateColorOrder(t) {
    return typeof t == "number" && t > 6 ? ba.EXTENDED : ba.STANDARD;
  }
  /** Sets the class related to the color order on the host component. */
  applyColorOrder(t) {
    var e;
    switch (t) {
      case ba.EXTENDED:
        this.classList.toggle(ba.EXTENDED, !0);
        break;
      case ba.STANDARD:
      default:
        this.classList.toggle(ba.STANDARD, !0);
        break;
    }
    (e = this.chart) == null || e.update({
      tooltip: {
        className: this.getTooltipClasses()
      }
    });
  }
  setChart() {
    try {
      return this.chart = this.createChart(), this.chart;
    } catch (t) {
      return console.error(t), this.chart;
    }
  }
  setFilteredOptions() {
    this.filteredOptions = We.filterChartOptions(this.options);
  }
  createChart() {
    const t = We.createChartOptions(
      this.chartOptions,
      this.localComponentOptions,
      this.filteredOptions
    );
    return zo.chart(this.chartContainer, t);
  }
  updateChart(t) {
    var e;
    (e = this.chart) == null || e.update(t, !0, !0), this.improveChartAccessibility();
  }
  static percentageFormatter(t, e, a, o, n) {
    let r;
    return t && e != null && a != null ? r = `${(100 * (e / (a || 100))).toFixed(o ? n : 0)}%` : e != null ? r = `${Math.round(e)}` : r = "N/A", r;
  }
  /* Since we are rendering highcharts tooltip outside of the shadow DOM, we need to append the lightDOM styles to body.
   */
  static appendLightDOMStyles() {
    var e;
    if (!document.getElementById("beacon-chart-light-DOM-styles")) {
      const a = document.createElement("style");
      a.id = "beacon-chart-light-DOM-styles", a.textContent = Js == null ? void 0 : Js.toString(), (e = document == null ? void 0 : document.body) == null || e.append(a);
    }
  }
  chartBaseInit() {
    this.initializeHighcharts(zo), We.appendLightDOMStyles();
  }
  chartLoaded() {
    var t;
    this.setChart(), (t = this.chart) == null || t.reflow();
  }
  /**
   * Removes tab sequential navigation for a button element rendered from HighChart Accessibility module when using the Export Data HighCharts module.
   * We have a github issue open with HighCharts (https://github.com/highcharts/highcharts/issues/22682).
   * TODO: Remove when HighCharts fixes issue
   */
  improveChartAccessibility() {
    var e;
    const t = (e = this.chartContainer) == null ? void 0 : e.querySelector(
      "[id^=hc-linkto-highcharts-data-table-]"
    );
    t == null || t.setAttribute("tabindex", "-1"), t == null || t.setAttribute("aria-expanded", "false");
  }
  willUpdate(t) {
    var T;
    (T = super.willUpdate) == null || T.call(this, t);
    const e = this.hideLegendMetric, a = this.percentage, o = this.decimal, n = this.decimalPlaces, r = this.type;
    if (this.chart) {
      if (t.has("chart")) {
        const { chartHeight: O, chartWidth: j, plotHeight: D, plotWidth: F } = this.chart;
        this.chartSize = {
          chartHeight: O,
          chartWidth: j,
          plotHeight: D,
          plotWidth: F
        };
      }
      t.has("series") && this.updateChart({ series: this.seriesWithChartType }), this.seriesLength = this.calculateSeriesLength(this.chart), this.colorOrder = We.calculateColorOrder(this.seriesLength), this.applyColorOrder(this.colorOrder), this.chart.reflow();
    }
    t.has("options") && this.options && (this.setFilteredOptions(), this.updateChart(this.filteredOptions)), t.has("legendLayout") && this.legendLayout && this.updateChart({
      legend: {
        align: this.legendLayout.horizontal,
        layout: this.legendLayout.direction,
        labelFormatter() {
          return We.legendItemHTML(
            this,
            e,
            a,
            r,
            o,
            n
          );
        },
        verticalAlign: We.setLegendVerticalAlignment(
          this.legendLayout
        ),
        width: We.setLegendWidth(this.legendLayout)
      }
    }), (t.has("hideLegendMetric") || t.has("percentage") || t.has("decimal") || t.has("decimalPlaces")) && this.updateChart({
      legend: {
        labelFormatter() {
          return We.legendItemHTML(
            this,
            e,
            a,
            r,
            o,
            n
          );
        }
      }
    }), t.has("disableLegend") && this.updateChart({
      legend: { enabled: !this.disableLegend }
    }), t.has("tooltipTitle") && this.updateChart({
      tooltip: {
        headerFormat: We.tooltipHeaderHTML(this.tooltipTitle)
      }
    }), t.has("tooltipFooter") && this.updateChart({
      tooltip: {
        footerFormat: We.tooltipFooterHTML(this.tooltipFooter)
      }
    }), t.has("tooltipVariant") && this.tooltipVariant && this.updateChart({
      tooltip: {
        padding: We.tooltipPadding(this.tooltipVariant),
        shared: this.tooltipVariant === Ir.MULTI_LINE
      }
    });
  }
  render() {
    const t = {
      chart: !0,
      "highcharts-light": !0,
      "static-legend": this.staticLegend
    };
    t["chart--" + this.type] = !0;
    const e = {
      caption: !0
    };
    return pe`
      <figure class="base">
        <div class="header">
          <div class="header-text">
            <div class="title" id="title">
              <slot name="title" ${Ue({ container: ".header" })}></slot>
            </div>
            <div class="subtitle" id="subtitle">
              <slot
                name="subtitle"
                ${Ue({ container: ".header" })}></slot>
            </div>
          </div>
          <div class="menu"></div>
        </div>
        <!-- Force Highcharts light theme -->
        <div
          role="region"
          class=${Oe(t)}
          legend-layout="${Object.values(this.legendLayout).join(" ")}"
          aria-labelledby="title"
          aria-describedby="subtitle"></div>
        <figcaption class=${Oe(e)}>
          <slot
            name="caption"
            @slotchange=${this.handleCaptionSlotchange}
            ${Ue({ useParent: !0 })}></slot>
        </figcaption>
      </figure>
    `;
  }
}, We.nestedComponents = [ck], We.disallowedChartOptions = [
  "colors",
  "title",
  "caption",
  "subtitle"
], We.defaultLegendLayout = {
  direction: "horizontal",
  horizontal: "center",
  vertical: "bottom"
}, We);
Ot([
  ue({
    type: Array
  })
], xt.prototype, "series", 2);
Ot([
  ue({
    type: Object
  })
], xt.prototype, "options", 2);
Ot([
  ue({ attribute: "static-legend", type: Boolean, reflect: !0 })
], xt.prototype, "staticLegend", 2);
Ot([
  ue({ attribute: "disable-legend", type: Boolean })
], xt.prototype, "disableLegend", 2);
Ot([
  ue({ attribute: "hide-legend-metric", type: Boolean })
], xt.prototype, "hideLegendMetric", 2);
Ot([
  ue({
    attribute: "legend-layout",
    converter: (i) => xt.createLegendLayout(i)
  })
], xt.prototype, "legendLayout", 2);
Ot([
  ue({ attribute: "tooltip-title" })
], xt.prototype, "tooltipTitle", 2);
Ot([
  ue({ attribute: "tooltip-footer" })
], xt.prototype, "tooltipFooter", 2);
Ot([
  ue({ attribute: "tooltip-variant" })
], xt.prototype, "tooltipVariant", 2);
Ot([
  ue({ attribute: "disable-markers", type: Boolean })
], xt.prototype, "disableMarkers", 2);
Ot([
  ue({ type: Boolean })
], xt.prototype, "percentage", 2);
Ot([
  ue({ type: Boolean })
], xt.prototype, "decimal", 2);
Ot([
  ue({ attribute: "decimal-places", type: Number })
], xt.prototype, "decimalPlaces", 2);
Ot([
  Se()
], xt.prototype, "chart", 2);
Ot([
  bn('[slot="caption"]')
], xt.prototype, "linkedDescriptionNode", 2);
Ot([
  Ge(".chart")
], xt.prototype, "chartContainer", 2);
Ot([
  qe
], xt.prototype, "chartBaseInit", 1);
Ot([
  De
], xt.prototype, "chartLoaded", 1);
let ct = xt;
var Vi = /* @__PURE__ */ ((i) => (i.HORIZONTAL = "horizontal", i.VERTICAL = "vertical", i.HORIZONTAL_LEFT = "horizontal-left", i.HORIZONTAL_RIGHT = "horizontal-right", i.VERTICAL_TOP = "vertical-top", i.VERTICAL_BOTTOM = "vertical-bottom", i))(Vi || {}), Nh = /* @__PURE__ */ ((i) => (i.STANDARD = "standard", i.WIDE = "wide", i))(Nh || {}), os = /* @__PURE__ */ ((i) => (i.STANDARD = "standard", i.FULL_BLEED = "full-bleed", i.FULL_BLEED_WITH_PADDING = "full-bleed-with-padding", i))(os || {}), Zm = /* @__PURE__ */ ((i) => (i.BLUE = "blue", i.BERRY = "berry", i.GREEN = "green", i.GOLD = "gold", i))(Zm || {});
const Sk = ve`[beacon-tag-name*=tile] [slot=media]>img,[beacon-tag-name*=tile] [slot=media]:not(picture){border-end-end-radius:var(--tile-media-end-end-radius);border-end-start-radius:var(--tile-media-end-start-radius);border-start-end-radius:var(--tile-media-start-end-radius);border-start-start-radius:var(--tile-media-start-start-radius);grid-column:var(--tile-media-grid-column);grid-row:var(--tile-media-grid-row)}[beacon-tag-name*=tile] [slot=header]{margin-block-end:var(--tile-header-margin-block-end);margin-block-start:var(--tile-header-margin-block-start);margin-inline-end:var(--tile-header-margin-inline-end);margin-inline-start:var(--tile-header-margin-inline-start)}[beacon-tag-name*=tile] [slot=header].beacon-tile__header--full-width{--tile-header-margin-inline-start: 0;--tile-header-margin-inline-end: 0}[beacon-tag-name*=tile] [slot=body]{margin-block-end:var(--tile-body-margin-block-end);margin-block-start:var(--tile-body-margin-block-start);margin-inline-end:var(--tile-body-margin-inline-end);margin-inline-start:var(--tile-body-margin-inline-start)}[beacon-tag-name*=tile] [slot=footer]{margin-block-end:var(--tile-footer-margin-block-end);margin-block-start:var(--tile-footer-margin-block-start);margin-inline-end:var(--tile-footer-margin-inline-end);margin-inline-start:var(--tile-footer-margin-inline-start)}[beacon-tag-name*=tile] [slot=footer].beacon-tile__footer--full-width{--tile-footer-margin-inline-start: 0;--tile-footer-margin-inline-end: 0}`, Ek = ve`:host{--tile-content-padding-default: initial;--tile-media-template-padding: initial;--tile-content-padding-inline-start: var(--tile-content-padding-default);--tile-content-padding-inline-end: var(--tile-content-padding-default);--tile-content-padding-block-start: var(--tile-content-padding-default);--tile-content-padding-block-end: var(--tile-content-padding-default);--tile-content-padding-block-start-floating: initial;--tile-content-padding-block-end-floating: initial;--tile-header-margin-inline-start: var(--tile-content-padding-inline-start);--tile-body-margin-inline-start: var(--tile-content-padding-inline-start);--tile-footer-margin-inline-start: var(--tile-content-padding-inline-start);--tile-header-margin-inline-end: var(--tile-content-padding-inline-end);--tile-body-margin-inline-end: var(--tile-content-padding-inline-end);--tile-footer-margin-inline-end: var(--tile-content-padding-inline-end);background-color:var(--tile-full-bleed-background-color, var(--tile-host-background-color, var(--beacon-system-color-background-1)));border-radius:var(--tile-border-radius, var(--beacon-system-radius-corner-standard))}.container{block-size:100%;display:var(--tile-display, flex);flex-direction:var(--tile-flex-direction, column);grid-template-columns:var(--tile-grid-template-columns);grid-template-rows:var(--tile-grid-template-rows);margin-inline:auto;max-inline-size:var(--beacon-system-breakpoint-xxx-large)}.content-zone{align-self:var(--tile-content-align-self);background-color:var(--tile-content-background-color);border-end-end-radius:var(--tile-content-end-end-radius);border-end-start-radius:var(--tile-content-end-start-radius);border-start-end-radius:var(--tile-content-start-end-radius);border-start-start-radius:var(--tile-content-start-start-radius);display:var(--tile-content-display, flex);flex-direction:var(--tile-content-flex-direction, column);grid-column:var(--tile-content-grid-column);grid-row:var(--tile-content-grid-row);justify-content:var(--tile-content-justify-content);padding-block:var(--tile-content-padding-block-start) var(--tile-content-padding-block-end)}:host([media-template=full-bleed]){--tile-display: grid;--tile-grid-template-rows: auto;--tile-grid-template-columns: auto;--tile-media-grid-row: 1/2;--tile-media-grid-column: 1/2;--tile-content-grid-row: 1/2;--tile-content-grid-column: 1/2;--tile-content-align-self: end}:host([media-template=full-bleed-with-padding]){--tile-display: grid;--tile-grid-template-rows: var(--tile-media-template-padding) auto var(--tile-media-template-padding);--tile-grid-template-columns: var(--tile-media-template-padding) auto var(--tile-media-template-padding);--tile-media-grid-row: 1/4;--tile-media-grid-column: 1/4;--tile-content-grid-row: 2/3;--tile-content-grid-column: 2/3;--tile-content-align-self: end}:host([position=horizontal]),:host([position=horizontal-right]),:host([position=horizontal-left]){--tile-flex-direction: row}:host([position=vertical]),:host([position=vertical-bottom]),:host([position=vertical-top]){--tile-flex-direction: column}:host(:is([position=horizontal],[position=horizontal-right])){--tile-media-start-start-radius: var(--beacon-system-radius-corner-standard);--tile-media-end-start-radius: var(--beacon-system-radius-corner-standard);--tile-content-start-end-radius: var(--beacon-system-radius-corner-standard);--tile-content-end-end-radius: var(--beacon-system-radius-corner-standard)}:host([position=horizontal-left]){--tile-content-start-start-radius: var(--beacon-system-radius-corner-standard);--tile-content-end-start-radius: var(--beacon-system-radius-corner-standard);--tile-media-start-end-radius: var(--beacon-system-radius-corner-standard);--tile-media-end-end-radius: var(--beacon-system-radius-corner-standard)}:host(:is([position=vertical],[position=vertical-bottom])){--tile-content-end-start-radius: var(--beacon-system-radius-corner-standard);--tile-content-end-end-radius: var(--beacon-system-radius-corner-standard);--tile-media-start-start-radius: var(--beacon-system-radius-corner-standard);--tile-media-start-end-radius: var(--beacon-system-radius-corner-standard)}:host([position=vertical-top]){--tile-media-end-start-radius: var(--beacon-system-radius-corner-standard);--tile-media-end-end-radius: var(--beacon-system-radius-corner-standard);--tile-content-start-start-radius: var(--beacon-system-radius-corner-standard);--tile-content-start-end-radius: var(--beacon-system-radius-corner-standard)}:host([position=vertical][floating]),:host([position=vertical-bottom][floating]){--tile-content-padding-inline-start: 0;--tile-content-padding-block-start: var(--tile-content-padding-block-start-floating);--tile-content-padding-block-end: 0}:host([position=vertical-top][floating]){--tile-content-padding-inline-start: 0;--tile-content-padding-block-start: 0;--tile-content-padding-block-end: var(--tile-content-padding-block-end-floating)}:host([position=horizontal][floating]),:host([position=horizontal-right][floating]){--tile-content-padding-inline-end: 0;--tile-content-padding-block-start: 0}:host([position=horizontal-left][floating]){--tile-content-padding-inline-start: 0;--tile-content-padding-block-start: 0}:host([media-template=full-bleed-with-padding][floating]){--tile-content-padding-inline-start: 0;--tile-content-padding-inline-end: 0;--tile-padding-block-start: 0;--tile-padding-block-end: 0}:host([content-alignment=flex-start]){--tile-content-justify-content: flex-start}:host([content-alignment=flex-end]){--tile-content-justify-content: flex-end}:host([content-alignment=center]){--tile-content-justify-content: center}`;
var Tk = Object.defineProperty, gr = (i, t, e, a) => {
  for (var o = void 0, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = r(t, e, o) || o);
  return o && Tk(t, e, o), o;
};
class ia extends Le {
  constructor() {
    super(...arguments), this.position = Vi.VERTICAL, this.floating = !1, this.scale = Do.NORMAL, this.layout = Nh.STANDARD, this.mediaTemplate = os.STANDARD;
  }
  static get styles() {
    return [super.styles, Ek];
  }
  static get lightDOMStyles() {
    return [...super.lightDOMStyles, Sk];
  }
  /**
   * Used when overriding renderContentZone.
   * @returns a `slot` containing the header content.
   */
  renderHeader() {
    return pe`<slot name="header"></slot>`;
  }
  /**
   * Used with Render tile and a TilePosition to determine where to render the media slot.
   * @returns a `slot` containing the media content.
   */
  renderMedia() {
    return pe`<slot name="media"></slot>`;
  }
  /**
   * Used when overriding renderContentZone.
   * @returns a `slot` containing the body content.
   */
  renderBody() {
    return pe`<slot name="body"></slot>`;
  }
  /**
   * Used when overriding renderContentZone.
   * @returns a `slot` containing the footer content.
   */
  renderFooter() {
    return pe`<slot name="footer"></slot>`;
  }
  /**
   * Default content zone rendering containing the header, body, and footer slots.
   * Should be overridden from higher level components to remove
   * @returns a `div.content-zone` containing the header, body, and footer slots.
   */
  renderContentZone() {
    return pe`<div class="content-zone">
      ${this.renderHeader()} ${this.renderBody()} ${this.renderFooter()}
    </div>`;
  }
  /**
   * renders the `div.content-zone` and media slot based on the position of the tile,
   * to avoid using row-reverse etc.
   * NOTE: "container" class div element is necessary to cap max-inline-size of tiles at 1920px
   * but still allow for host element to span 100vw with a background color. This aligns with the Beacon Grid Spec.
   * @param position TilePosition with values 'Horizontal', 'Horizontal-Right', 'Horizontal-Left', 'Vertical', 'Vertical-Top', 'Vertical-Bottom'
   * @returns a `div.content-zone` containing the header, body, and footer slots. and
   */
  renderTile(t) {
    return t === Vi.HORIZONTAL_LEFT || t === Vi.VERTICAL_TOP ? pe`<div class="container">
        ${this.renderContentZone()} ${this.renderMedia()}
      </div>` : pe`<div class="container">
      ${this.renderMedia()} ${this.renderContentZone()}
    </div>`;
  }
}
gr([
  ue({ type: Vi, attribute: "position", reflect: !0 })
], ia.prototype, "position");
gr([
  ue({ type: Boolean, reflect: !0 })
], ia.prototype, "floating");
gr([
  ue({ attribute: "content-alignment", reflect: !0 })
], ia.prototype, "contentAlignment");
gr([
  ue({ type: Do, reflect: !0 })
], ia.prototype, "scale");
gr([
  ue({ type: Nh, reflect: !0 })
], ia.prototype, "layout");
gr([
  ue({
    type: os,
    attribute: "media-template",
    reflect: !0
  })
], ia.prototype, "mediaTemplate");
const ou = {
  beaconTagName: "beacon-accordion"
}, Mk = ve`[beacon-tag-name=beacon-accordion]{--accordion-item-grid-space-padding-block: var(--beacon-system-space-progression-normal);--accordion-item-title-space-padding-block-normal: var(--beacon-reference-space-3);--accordion-item-title-space-padding-block-mini: calc(var(--beacon-reference-space-3) + var(--beacon-reference-space-1));--accordion-item-title-space-padding-block-jumbo: calc(var(--beacon-reference-space-2) + var(--beacon-reference-space-1));--accordion-item-title-space-padding-block: var(--accordion-item-title-space-padding-block-normal);--accordion-item-title-font: var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-loose-200);--accordion-item-panel-font: var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-loose-100)}[beacon-tag-name=beacon-accordion]:where([scale=mini]){--accordion-item-grid-space-padding-block: var(--beacon-system-space-progression-mini);--accordion-item-title-space-padding-block: var(--accordion-item-title-space-padding-block-mini);--accordion-item-title-font: var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-loose-100);--accordion-item-panel-font: var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-loose-300)}[beacon-tag-name=beacon-accordion]:where([scale=jumbo]){--accordion-item-grid-space-padding-block: var(--beacon-system-space-progression-jumbo);--accordion-item-title-space-padding-block: var(--accordion-item-title-space-padding-block-jumbo);--accordion-item-title-font: var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-loose-100)}[beacon-tag-name=beacon-accordion] [beacon-tag-name=beacon-accordion-item]{border-block-end:var(--beacon-system-width-border-mini) solid var(--beacon-system-color-border-0)}@media (width >= 640px){[beacon-tag-name=beacon-accordion]{--accordion-item-title-space-padding-block-normal: calc(var(--beacon-reference-space-2) + var(--beacon-reference-space-1));--accordion-item-title-space-padding-block-mini: var(--beacon-reference-space-3);--accordion-item-title-space-padding-block-jumbo: var(--beacon-reference-space-2)}}@media (width >= 1280px){[beacon-tag-name=beacon-accordion]{--accordion-item-title-space-padding-block-normal: var(--beacon-reference-space-2);--accordion-item-title-space-padding-block-mini: calc(var(--beacon-reference-space-2) + var(--beacon-reference-space-1))}}`, Lk = ve`:host{--accordion-item-grid-space-padding-block: var(--beacon-system-space-progression-normal)}:host .hide{display:none}:host([scale=mini]){--accordion-item-grid-space-padding-block: var(--beacon-system-space-progression-mini)}:host([scale=jumbo]){--accordion-item-grid-space-padding-block: var(--beacon-system-space-progression-jumbo)}`;
var Ok = Object.defineProperty, Pk = Object.getOwnPropertyDescriptor, mr = (i, t, e, a) => {
  for (var o = a > 1 ? void 0 : a ? Pk(t, e) : t, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = (a ? r(t, e, o) : r(o)) || o);
  return a && o && Ok(t, e, o), o;
};
const zk = [16, 24, 32, 40];
function Dk(i) {
  return zk.includes(i);
}
var gs;
const lb = class lb extends Le {
  constructor() {
    super(...arguments);
    /** Private property for the icon size. */
    Fe(this, gs);
    this.beaconTagName = ou.beaconTagName, this.singleOpen = !1, this.scale = tn.NORMAL, this._showAll = !0;
  }
  static get styles() {
    return [super.styles, Lk];
  }
  static get lightDOMStyles() {
    return [super.lightDOMStyles, Mk];
  }
  get iconSize() {
    return ze(this, gs);
  }
  set iconSize(e) {
    Dk(e) ? (Ne(this, gs, e), this.style.setProperty(
      "--accordion-icon-column-size",
      String(this.iconSize) + "px"
    )) : this.style.removeProperty("--accordion-icon-column-size");
  }
  get AllAccordionItemsOpen() {
    var e, a;
    return (a = (e = this.slottedAccordionItems) == null ? void 0 : e.every((o) => o.open)) != null ? a : !1;
  }
  get AllAccordionItemsClosed() {
    var e, a;
    return (a = (e = this.slottedAccordionItems) == null ? void 0 : e.every((o) => !o.open)) != null ? a : !1;
  }
  closeAllAccordionItems() {
    this.slottedAccordionItems && !this.singleOpen && (this.slottedAccordionItems.forEach((e) => e.open = !1), this._showAll = !0);
  }
  openAllAccordionItems() {
    this.slottedAccordionItems && !this.singleOpen && (this.slottedAccordionItems.forEach((e) => e.open = !0), this._showAll = !1);
  }
  async setupAccordionItems() {
    await this.initializeShowAll(), this.findInitialOpenAccordionItem();
  }
  async initializeShowAll() {
    var e;
    await Promise.all(
      (e = this.slottedAccordionItems) == null ? void 0 : e.map((a) => a.updateComplete)
    ), this._showAll = !this.AllAccordionItemsOpen;
  }
  findInitialOpenAccordionItem() {
    this.singleOpen && this.slottedAccordionItems.forEach((e) => {
      e.open && (this.currentAccordionItemOpen = e);
    });
  }
  handleShowAllStateOnToggle() {
    this.AllAccordionItemsOpen && (this._showAll = !1), this.AllAccordionItemsClosed && (this._showAll = !0);
  }
  handleSingleOpenClick(e) {
    this.currentAccordionItemOpen && this.currentAccordionItemOpen !== e.target ? (this.currentAccordionItemOpen.removeAttribute("open"), this.currentAccordionItemOpen = e.target) : this.currentAccordionItemOpen = e.target;
  }
  /**
   * When `single-open` is set to true, maintains open/closed state of slotted in `<accordion-item>`'s
   */
  clickHandler(e) {
    this.singleOpen && e.target instanceof HTMLElement && e.target.getAttribute("beacon-tag-name") === "beacon-accordion-item" && this.handleSingleOpenClick(e);
  }
  render() {
    return pe`
      <slot name="action-zone"></slot>
      <slot
        name="show-all"
        class=${this._showAll ? "" : "hide"}
        @beacon-event-click=${this.openAllAccordionItems}></slot>
      <slot
        name="hide-all"
        class=${this._showAll ? "hide" : ""}
        @beacon-event-click=${this.closeAllAccordionItems}></slot>
      <slot
        @beacon-event-click=${this.clickHandler}
        @beacon-event-toggle=${this.handleShowAllStateOnToggle}></slot>
    `;
  }
};
gs = new WeakMap(), lb.tagName = ou.beaconTagName;
let pi = lb;
mr([
  ue({ type: Boolean, attribute: "single-open" })
], pi.prototype, "singleOpen", 2);
mr([
  ue({ type: String, reflect: !0 })
], pi.prototype, "scale", 2);
mr([
  ue({ type: Number, attribute: "icon-size" })
], pi.prototype, "iconSize", 1);
mr([
  wt({
    selector: '[beacon-tag-name="beacon-accordion-item"]'
  })
], pi.prototype, "slottedAccordionItems", 2);
mr([
  ue({ reflect: !0, attribute: "show-all", type: Boolean })
], pi.prototype, "_showAll", 2);
mr([
  De
], pi.prototype, "setupAccordionItems", 1);
const au = {
  beaconTagName: "beacon-accordion-item"
}, Ik = ve`[beacon-tag-name=beacon-accordion-item] [slot=icon],[beacon-tag-name=beacon-accordion-item] [slot=icon]::part(internal--icon){block-size:var(--accordion-icon-column-size);inline-size:var(--accordion-icon-column-size)}[beacon-tag-name=beacon-accordion-item] [beacon-tag-name=beacon-icon]{display:block}[beacon-tag-name=beacon-accordion-item] [slot=title]{--accordion-item-title-margin-inline-start: calc(var(--accordion-icon-column-size) + var(--beacon-reference-space-4))}[beacon-tag-name=beacon-accordion-item] [slot=icon]~[slot=title]{--accordion-item-title-margin-inline-start: 0}`, Bk = ve`:host([motion-state=enabled]) :is(summary){transition-duration:var(--beacon-reference-motion-duration-3);transition-property:background-color;transition-timing-function:var(--beacon-system-motion-easing-decelerate-emphasize-1)}`;
var Rk = Object.getOwnPropertyDescriptor, Nk = (i, t, e, a) => {
  for (var o = a > 1 ? void 0 : a ? Rk(t, e) : t, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = r(o) || o);
  return o;
};
const iu = "cubic-bezier(0.05,0.7,0.1,1)", nu = 50, ru = 150;
function Fk(i) {
  let t = class extends i {
    constructor() {
      super(...arguments), this.isClosing = !1, this.isOpening = !1;
    }
    static get AccordionItemMotionStyles() {
      return [Bk];
    }
    get detailsElement() {
      var e;
      return (e = this.shadowRoot) == null ? void 0 : e.querySelector("details");
    }
    get summaryElement() {
      var e;
      return (e = this.shadowRoot) == null ? void 0 : e.querySelector("summary");
    }
    get panelElement() {
      var e;
      return (e = this.shadowRoot) == null ? void 0 : e.querySelector(
        "details > .accordion-grid"
      );
    }
    /**
     * Calls custom open and collapse methods that manage open state and animations on the `<details>` element
     */
    summaryClickHandler(e) {
      var a, o, n;
      this.getAttribute("motion-state") !== "disabled" && (e.preventDefault(), (a = this.detailsElement) == null || a.style.setProperty("overflow", "hidden"), this.isClosing || !((o = this.detailsElement) != null && o.hasAttribute("open")) ? this.openDetails() : (this.isOpening || (n = this.detailsElement) != null && n.hasAttribute("open")) && this.collapse());
    }
    /**
     * Handles animation of accordion item when it is collapsing
     */
    collapse() {
      var o, n, r;
      this.isClosing = !0;
      const e = `${(o = this.detailsElement) == null ? void 0 : o.offsetHeight}px`, a = `${(n = this.summaryElement) == null ? void 0 : n.offsetHeight}px`;
      this.animation && this.animation.cancel(), this.animation = (r = this.detailsElement) == null ? void 0 : r.animate(
        {
          // Set the keyframes from the startHeight to endHeight
          height: [e, a]
        },
        {
          delay: nu,
          duration: ru,
          easing: iu
        }
      ), this.animation && (this.animation.onfinish = () => this.onAnimationFinish(!1)), this.animation && (this.animation.oncancel = () => this.isClosing = !1);
    }
    /**
     * Sets open attribute on `<details>` element and set's block-size to current height of `<details>` element in order for animations to occur
     */
    openDetails() {
      var e, a, o;
      (a = this.detailsElement) == null || a.style.setProperty(
        "block-size",
        `${(e = this.detailsElement) == null ? void 0 : e.offsetHeight}px`
      ), (o = this.detailsElement) == null || o.setAttribute("open", ""), window.requestAnimationFrame(() => this.expandDetails());
    }
    /**
     * Handles animation of accordion item when it is expanding
     */
    expandDetails() {
      var o, n, r, T;
      this.isOpening = !0;
      const e = `${(o = this.detailsElement) == null ? void 0 : o.offsetHeight}px`, a = `${((n = this.summaryElement) == null ? void 0 : n.offsetHeight) + ((r = this.panelElement) == null ? void 0 : r.offsetHeight)}px`;
      this.animation && this.animation.cancel(), this.animation = (T = this.detailsElement) == null ? void 0 : T.animate(
        {
          // Set the keyframes from the startHeight to endHeight
          height: [e, a]
        },
        {
          delay: nu,
          duration: ru,
          easing: iu
        }
      ), this.animation && (this.animation.onfinish = () => this.onAnimationFinish(!0)), this.animation && (this.animation.oncancel = () => this.isOpening = !1);
    }
    /**
     * Handles state of `<details>` element after expand/collapse animations have ocurred and resets animation state of component
     */
    onAnimationFinish(e) {
      var a, o, n, r;
      e ? (a = this.detailsElement) == null || a.setAttribute("open", "") : (o = this.detailsElement) == null || o.removeAttribute("open"), this.animation = void 0, this.isClosing = !1, this.isOpening = !1, (n = this.detailsElement) == null || n.style.setProperty("overflow", ""), (r = this.detailsElement) == null || r.style.setProperty("block-size", "");
    }
  };
  return t = Nk([
    je("AccordionItemMotion")
  ], t), t;
}
const _k = ve`:host{--accordion-chevron-color: var(--beacon-system-color-icon-secondary)}.accordion-grid{align-items:center;display:grid;grid-template-areas:"icon content chevron";grid-template-columns:auto 1fr auto;padding-block:var(--accordion-item-grid-space-padding-block);padding-inline-start:var(--beacon-reference-space-3)}.title{font:var(--accordion-item-title-font);margin-inline-end:var(--beacon-reference-space-4);padding-block:var(--accordion-item-title-space-padding-block)}::slotted([slot=title]){margin-inline-start:var(--accordion-item-title-margin-inline-start, initial)}details{color:var(--beacon-system-color-text-standard)}[open] summary{background:var(--beacon-system-color-background-secondary-hover)}[open] summary:active{background:var(--beacon-system-color-background-secondary-pressed)}[open] .chevron{transform:rotate(180deg)}summary{border-inline-start:var(--beacon-system-width-border-normal) solid transparent;cursor:pointer;list-style:none}summary:hover{--accordion-chevron-color: var(--beacon-system-color-icon-secondary-hover);background:var(--beacon-system-color-background-secondary-hover);border-inline-start:var(--beacon-system-width-border-normal) solid var(--beacon-system-color-border-link)}summary:active{--accordion-chevron-color: var(--beacon-system-color-icon-secondary-pressed);background:var(--beacon-system-color-background-secondary-pressed)}summary::-webkit-details-marker{display:none}.icon{grid-area:icon;margin-inline-end:var(--beacon-reference-space-4)}.chevron{align-self:start;color:var(--accordion-chevron-color);display:flex;grid-area:chevron;margin-inline-start:auto;padding:var(--beacon-reference-space-4);transform:rotate(0);transition-duration:var(--beacon-reference-motion-duration-3);transition-property:transform}.panel{font:var(--accordion-item-panel-font);grid-area:content;margin-inline:calc(var(--accordion-icon-column-size) + var(--beacon-reference-space-4)) var(--beacon-reference-space-10);padding-block:var(--beacon-reference-space-3)}.hide{display:none}`;
var Uk = Object.defineProperty, jk = Object.getOwnPropertyDescriptor, pn = (i, t, e, a) => {
  for (var o = a > 1 ? void 0 : a ? jk(t, e) : t, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = (a ? r(t, e, o) : r(o)) || o);
  return a && o && Uk(t, e, o), o;
}, Ko;
const Ai = (Ko = class extends Ke(Le).with(
  Fk
) {
  constructor() {
    super(...arguments), this.beaconTagName = au.beaconTagName, this.deferrable = !1, this.open = !1, this.hasIcon = !1;
  }
  static get styles() {
    return [super.styles, _k, this.AccordionItemMotionStyles];
  }
  static get lightDOMStyles() {
    return [super.lightDOMStyles, Ik];
  }
  /**
   * Sets the `open` property based on the `open` attribute of the `<details>` element
   * and emits the state of the accordion-item after being toggled
   */
  toggleEventHandler() {
    this.open = this.details.hasAttribute("open"), this.emitToggle();
  }
  /**
   * Handles summary clicks and emits a beacon-event-click
   * to be used by parent beacon-accordion component to manage
   * state on single-open mode
   */
  clickEventHandler(t) {
    this.summaryClickHandler(t), this.emitClick();
  }
  iconSlotChange() {
    var t;
    this.hasIcon = !!((t = this.slottedIcon) != null && t.length), Ko.addAnalyticsAttributes(
      this.slottedIcon.find(
        (e) => typeof e < "u" && !(e instanceof fo)
      )
    );
  }
  titleSlotChange() {
    const t = this.slottedTitle.find(
      (e) => typeof e < "u"
    );
    Ko.addAnalyticsAttributes(t), t.textContent && this.summary.setAttribute(
      go.TEXT,
      t.textContent
    );
  }
  renderIcon() {
    const t = {
      icon: !0,
      hide: !this.hasIcon
    };
    return pe`<div class=${Oe(t)}>
      <slot @slotchange=${this.iconSlotChange} name="icon"></slot>
    </div>`;
  }
  /**
   * Analytics attributes added to the `<summary>`, slotted in icon and slotted title element for analytics to capture tracking
   */
  static addAnalyticsAttributes(t) {
    t && (t.setAttribute(go.TYPE, "EC"), t.setAttribute(go.CLICKABLE, "true"));
  }
  addAnalytics() {
    Ko.addAnalyticsAttributes(this.summary);
  }
  render() {
    return Be`
      <details
        @toggle=${this.toggleEventHandler}
        ?open=${this.open}>
        <summary @click=${this.clickEventHandler}>
          <div class="accordion-grid">
            ${this.renderIcon()}
            <div class="title">
              <slot @slotchange=${this.titleSlotChange} name="title"></slot>
            </div>
            <div class="chevron">
              <${this.getScopedTag("beacon-icon")} name='expand' size='s'></${this.getScopedTag("beacon-icon")}>  
            </div>
          </div>
        </summary>
        <div class="accordion-grid">
          <div class="panel">
            <slot name="panel"></slot>
          </div>
        </div>
      </details>
    `;
  }
}, Ko.tagName = au.beaconTagName, Ko.nestedComponents = [fo], Ko);
pn([
  ue({ type: Boolean, reflect: !0 })
], Ai.prototype, "open", 2);
pn([
  et("details")
], Ai.prototype, "details", 2);
pn([
  et("summary")
], Ai.prototype, "summary", 2);
pn([
  Se()
], Ai.prototype, "hasIcon", 2);
pn([
  Pe({ flatten: !0, slot: "icon" })
], Ai.prototype, "slottedIcon", 2);
pn([
  Pe({ flatten: !0, slot: "title" })
], Ai.prototype, "slottedTitle", 2);
pn([
  De
], Ai.prototype, "addAnalytics", 1);
let W3 = Ai;
const su = {
  beaconTagName: "beacon-action-bar"
}, $k = ve`:host{background-color:var(--beacon-system-color-background-0);inline-size:100%;inset-block-end:0;position:sticky;z-index:3000}:host([inactive]){display:none}.base{align-items:center;display:flex;flex-wrap:wrap;justify-content:space-between;margin-inline:auto;max-inline-size:var(--beacon-system-breakpoint-xxx-large);padding-block:var(--beacon-reference-space-5);padding-inline:var(--beacon-system-space-organism-maxi)}`;
var Hk = Object.defineProperty, Kk = Object.getOwnPropertyDescriptor, Fh = (i, t, e, a) => {
  for (var o = a > 1 ? void 0 : a ? Kk(t, e) : t, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = (a ? r(t, e, o) : r(o)) || o);
  return a && o && Hk(t, e, o), o;
};
const cb = class cb extends Le {
  constructor() {
    super(...arguments), this.beaconTagName = su.beaconTagName, this.inactive = !1, this.activeAtObserverEnter = new IntersectionObserver(
      (t, e) => {
        t.forEach((a) => {
          const {
            isIntersecting: o,
            boundingClientRect: { top: n }
          } = a;
          o && (this.inactive = !1), !o && n >= 0 && (this.inactive = !0);
        });
      }
    );
  }
  static get styles() {
    return [super.styles, $k];
  }
  get activeAtPoint() {
    var e;
    const t = this.getClosestHost();
    return t ? (e = t.shadowRoot) == null ? void 0 : e.querySelector(this.activeAt) : document.querySelector(this.activeAt);
  }
  handleActivation() {
    this.activeAtPoint && (this.inactive = !0, this.activeAtObserverEnter.observe(this.activeAtPoint));
  }
  render() {
    return pe`
      <div class="base" part="base">
        <div class="start">
          <slot name="start"></slot>
        </div>
        <div class="end">
          <slot name="end"></slot>
        </div>
      </div>
    `;
  }
};
cb.tagName = su.beaconTagName;
let as = cb;
Fh([
  ue({ type: Boolean, reflect: !0 })
], as.prototype, "inactive", 2);
Fh([
  ue({ attribute: "active-at", reflect: !0 })
], as.prototype, "activeAt", 2);
Fh([
  De
], as.prototype, "handleActivation", 1);
var Aa = /* @__PURE__ */ ((i) => (i.DOWN = "ArrowDown", i.UP = "ArrowUp", i.RIGHT = "ArrowRight", i.LEFT = "ArrowLeft", i))(Aa || {}), Ea = /* @__PURE__ */ ((i) => (i.ESCAPE = "Escape", i.TAB = "Tab", i.ENTER = "Enter", i.SPACE = " ", i))(Ea || {});
const Io = (i, t) => {
  let e;
  return function(...o) {
    const n = () => {
      clearTimeout(e), i(...o);
    };
    clearTimeout(e), e = setTimeout(n, t);
  };
};
typeof process == "object" && process && process.env && process.env.UNIT_TESTING_ENV;
const lu = {
  beaconTagName: "beacon-anchor-navigation"
}, Gk = ve`[beacon-tag-name=beacon-anchor-navigation] :is(ul,ol)[slot=tabs]{display:flex;inline-size:100%;justify-content:space-between;list-style:none;margin:0;padding:0}[beacon-tag-name=beacon-anchor-navigation] :is(ul,ol)[slot=tabs] li{display:grid;inline-size:100%}[beacon-tag-name=beacon-anchor-navigation] :is(ul,ol)[slot=tabs] li>*{grid-area:1/-1}[beacon-tag-name=beacon-anchor-navigation] :is(ul,ol)[slot=tabs] li a{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-300);align-items:start;block-size:100%;display:grid;inline-size:100%;background-color:var(--beacon-system-color-background-primary);color:var(--beacon-system-color-text-primary);padding:calc(2 * var(--beacon-system-space-cell-contained))}[beacon-tag-name=beacon-anchor-navigation] :is(ul,ol)[slot=tabs] li a:not(:hover,:focus){text-decoration:none}[beacon-tag-name=beacon-anchor-navigation] :is(ul,ol)[slot=tabs] li a:hover{background-color:var(--beacon-system-color-background-primary-hover)}[beacon-tag-name=beacon-anchor-navigation] :is(ul,ol)[slot=tabs] li a:active{background:var(--beacon-system-color-background-primary-pressed);text-decoration:none}[beacon-tag-name=beacon-anchor-navigation] :is(ul,ol)[slot=tabs] li a:focus-visible{box-shadow:0 0 0 var(--beacon-system-width-border-jumbo) var(--beacon-system-color-border-focus-middle),0 0 0 var(--beacon-system-width-border-maxi) var(--beacon-system-color-border-focus-outer);outline:var(--beacon-system-width-border-normal) solid var(--beacon-system-color-border-focus-inner);outline-offset:0;z-index:1;text-decoration:none}[beacon-tag-name=beacon-anchor-navigation] :is(ul,ol)[slot=tabs] li a:focus-visible:not(dialog){position:relative}@media (width >= 960px){[beacon-tag-name=beacon-anchor-navigation] :is(ul,ol)[slot=tabs] li a{align-items:center;text-align:center}}[beacon-tag-name=beacon-anchor-navigation] :is(ul,ol)[slot=tabs] li[active] a{--active-tab-background-color: var(--beacon-reference-palette-grayscale-white);--active-tab-color: var(--beacon-reference-palette-primary-midnight-navy-1);background-color:var(--active-tab-background-color);color:var(--active-tab-color);font-weight:700}@media (width >= 640px){[beacon-tag-name=beacon-anchor-navigation] :is(ul,ol)[slot=tabs] li[active] a:not([has-overflow-menu]){--active-tab-background-color: var(--beacon-system-color-background-1);--active-tab-color: var(--beacon-system-color-text-standard)}}[beacon-tag-name=beacon-anchor-navigation] :is(ul,ol)[slot=tabs] li:not([active]){display:var(--inactive-tab-display, none)}[beacon-tag-name=beacon-anchor-navigation] :is(ul,ol)[slot=tabs] li:not([active]) .progress-container{display:none}[beacon-tag-name=beacon-anchor-navigation] :is(ul,ol)[slot=tabs] li .progress-container{align-self:end;display:grid;padding-block-end:var(--beacon-system-space-cell-contained);padding-inline:calc(2 * var(--beacon-system-space-cell-contained));pointer-events:none;z-index:1}[beacon-tag-name=beacon-anchor-navigation] :is(ul,ol)[slot=tabs] li .progress-container .progress-outer{block-size:var(--beacon-system-width-border-normal);display:grid}[beacon-tag-name=beacon-anchor-navigation] :is(ul,ol)[slot=tabs] li .progress-container .progress-outer>*{grid-area:1/-1}[beacon-tag-name=beacon-anchor-navigation] :is(ul,ol)[slot=tabs] li .progress-container .progress-bar{--progress-bar-background: var(--beacon-reference-palette-grayscale-light-gray-2);background:var(--progress-bar-background);inline-size:100%}@media (width >= 640px){[beacon-tag-name=beacon-anchor-navigation] :is(ul,ol)[slot=tabs] li .progress-container .progress-bar:not([has-overflow-menu]){--progress-bar-background: var(--beacon-system-color-border-0)}}[beacon-tag-name=beacon-anchor-navigation] :is(ul,ol)[slot=tabs] li .progress-container .progress-value{background-color:var(--beacon-system-color-background-primary);inline-size:var(--reading-progress, 0)}[beacon-tag-name=beacon-anchor-navigation] :is(ul,ol)[slot=tabs] li.cta-item{background-color:var(--beacon-reference-palette-primary-midnight-navy-2);inline-size:auto;padding-block:var(--beacon-reference-space-4);padding-inline:var(--beacon-reference-space-4)}[beacon-tag-name=beacon-anchor-navigation] .cta-desktop-container{align-items:center;display:flex;inline-size:max-content}[beacon-tag-name=beacon-anchor-navigation] .cta-desktop-container a,[beacon-tag-name=beacon-anchor-navigation] .cta-desktop-container button{inline-size:100%}@media (width >= 640px){[beacon-tag-name=beacon-anchor-navigation]:not([has-overflow-menu]) :is(ul,ol)[slot=tabs] li:not([active]){--inactive-tab-display: grid}[beacon-tag-name=beacon-anchor-navigation]:not([has-overflow-menu]) :is(ul,ol)[slot=tabs] li[active] a{background-color:var(--beacon-system-color-background-0)}[beacon-tag-name=beacon-anchor-navigation]:not([has-overflow-menu]) :is(ul,ol)[slot=tabs] li a{align-items:center;text-align:center}}@media (width >= 960px){[beacon-tag-name=beacon-anchor-navigation] :is(ul,ol)[slot=tabs] li:not([active]){--inactive-tab-display: grid}[beacon-tag-name=beacon-anchor-navigation] :is(ul,ol)[slot=tabs] li[active] a{background-color:var(--beacon-system-color-background-0)}}`, Wk = ve`@media (prefers-reduced-motion: no-preference){:host([motion-state=enabled]) .menu-container .cta-mobile-container{transform:translateY(0);transition-duration:var(--beacon-reference-motion-duration-7);transition-property:transform;transition-timing-function:var(--beacon-system-motion-easing-decelerate-emphasize-1)}:host([motion-state=enabled]) .menu-container.is-scrolling .cta-mobile-container,:host([motion-state=enabled]) .menu-container.menu-open .cta-mobile-container,:host([motion-state=enabled]) .menu-container.not-active .cta-mobile-container{transform:translateY(100%)}}`;
var qk = Object.getOwnPropertyDescriptor, Vk = (i, t, e, a) => {
  for (var o = a > 1 ? void 0 : a ? qk(t, e) : t, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = r(o) || o);
  return o;
};
function Yk(i) {
  let t = class extends i {
    static get AnchorNavigationMotionStyles() {
      return [Wk];
    }
  };
  return t = Vk([
    je("AnchorNavigationMotion")
  ], t), t;
}
const Qk = ve`:host{inline-size:100%;margin:auto;position:relative;z-index:1000}.tab-bar-wrapper{background-color:var(--beacon-reference-palette-primary-midnight-navy-2);border:var(--beacon-system-width-border-mini) solid var(--beacon-reference-palette-primary-midnight-navy-2);display:flex;flex-direction:column;gap:var(--beacon-reference-space-3);inset-block-start:0;padding:var(--beacon-reference-space-3);position:sticky;z-index:2}.jump-to-section{color:var(--beacon-reference-palette-grayscale-white);margin-block:0;font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-caption-300)}.jump-to-section.hidden{display:none}@media (width >= 640px){:host(:not([has-overflow-menu])) .tab-bar-wrapper{border:0;padding:0}:host(:not([has-overflow-menu])) .jump-to-section{display:none}}@media (width >= 960px){.tab-bar-wrapper{background-color:inherit;border:0;padding:0}.tab-bar{inline-size:100%;margin:auto;max-inline-size:var(--beacon-system-breakpoint-xxx-large)}.jump-to-section{display:none}}.tab-bar{align-items:center;display:grid;grid-template-columns:1fr auto;inset-block-start:0}.tabs{inline-size:100%;z-index:1}.content{position:relative;z-index:1}.menu-button{-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:var(--beacon-system-color-background-primary);block-size:100%;border:0;display:grid;inline-size:var(--beacon-reference-space-11);padding:0;place-items:center}.menu-button[aria-expanded=true] [beacon-tag-name=beacon-icon]{transform:rotate(180deg)}.menu-button [beacon-tag-name=beacon-icon]{color:var(--beacon-system-color-icon-primary)}.menu-button:focus-visible{box-shadow:0 0 0 var(--beacon-system-width-border-jumbo) var(--beacon-system-color-border-focus-middle),0 0 0 var(--beacon-system-width-border-maxi) var(--beacon-system-color-border-focus-outer);outline:var(--beacon-system-width-border-normal) solid var(--beacon-system-color-border-focus-inner);outline-offset:0;z-index:1}.menu-button:focus-visible:not(dialog){position:relative}.menu{background:var(--beacon-system-color-background-primary);box-shadow:0 var(--beacon-reference-space-5) var(--beacon-reference-space-7) calc(-1 * var(--beacon-reference-space-5)) var(--beacon-reference-palette-grayscale-shadow-3);color:var(--beacon-system-color-text-primary);inset-inline-end:var(--beacon-reference-space-3);inset-inline-start:var(--beacon-reference-space-3);padding-block:var(--beacon-system-space-organism-jumbo);position:absolute;text-align:center}.menu:not(.open){display:none}.menu .menu-title-wrapper{padding:var(--beacon-system-space-cell-free-floating)}.menu .menu-title-wrapper>.menu-title{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-caption-300);display:inline-block;padding:var(--beacon-system-space-cell-contained)}.menu .menu-list{list-style:none;margin:0;padding:0}.menu a{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-300);display:block;background-color:var(--beacon-system-color-background-primary);color:var(--beacon-system-color-text-primary);padding:calc(2 * var(--beacon-system-space-cell-contained))}.menu a:not(:hover,:focus){text-decoration:none}.menu a:hover{background-color:var(--beacon-system-color-background-primary-hover)}.menu a:active{background:var(--beacon-system-color-background-primary-pressed);text-decoration:none}.menu a:focus-visible{box-shadow:0 0 0 var(--beacon-system-width-border-jumbo) var(--beacon-system-color-border-focus-middle),0 0 0 var(--beacon-system-width-border-maxi) var(--beacon-system-color-border-focus-outer);outline:var(--beacon-system-width-border-normal) solid var(--beacon-system-color-border-focus-inner);outline-offset:0;z-index:1;text-decoration:none}.menu a:focus-visible:not(dialog){position:relative}.menu [active] a{background-color:var(--beacon-component-tab-menu-color-background-primary-active);font-weight:700}.menu-container{block-size:100%;z-index:2}.menu-container .cta-mobile-container{--override-button-inline-size: 100%;background:var(--beacon-reference-palette-primary-midnight-navy-2);inline-size:100%;inset-block-end:0;inset-inline-start:0;padding:var(--beacon-reference-space-3);position:fixed;visibility:visible}.menu-container .cta-mobile-container a,.menu-container .cta-mobile-container button{inline-size:100%}.menu-container.is-scrolling .cta-mobile-container,.menu-container.menu-open .cta-mobile-container,.menu-container.not-active .cta-mobile-container{visibility:hidden}@media (width >= 640px){:host(:not([has-overflow-menu])) .menu-container{display:none}}@media (width >= 960px){.menu-container{display:none}}.visually-hidden{border:0;clip:rect(0,0,0,0);block-size:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;inline-size:1px}`;
var Xk = Object.defineProperty, Zk = Object.getOwnPropertyDescriptor, kt = (i, t, e, a) => {
  for (var o = a > 1 ? void 0 : a ? Zk(t, e) : t, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = (a ? r(t, e, o) : r(o)) || o);
  return a && o && Xk(t, e, o), o;
}, no;
const vt = (no = class extends Ke(Le).with(
  Yk
) {
  constructor() {
    super(...arguments), this.beaconTagName = lu.beaconTagName, this._hasOverflowMenu = !1, this.debounceOnScroll = !1, this.menuIsOpen = !1, this.isScrolling = !1, this.isActive = !1, this.tabs = void 0, this.currentScrollPosition = window.scrollY, this.handleScrollStop = Io(() => {
      this.isScrolling = !1;
      const { top: t } = this.tabBar.getBoundingClientRect();
      t >= 0 && t < 100 ? this.isActive = !0 : this.isActive = !1;
    }, 800), this.handleWindowScrollDebounced = Io(() => {
      this.handleWindowScroll();
    }, 100), this.handleMenuKeydown = (t) => {
      const { key: e, target: a } = t;
      e === Ea.ESCAPE && (a !== this.menuButton && this.menuButton.focus(), this.closeMenu());
    };
  }
  static get styles() {
    return [super.styles, Qk, this.AnchorNavigationMotionStyles];
  }
  static get lightDOMStyles() {
    return [super.lightDOMStyles, Gk];
  }
  get activeProgress() {
    var t, e;
    return (e = (t = this.activeTab) == null ? void 0 : t.parentElement) == null ? void 0 : e.querySelector(".progress-value");
  }
  static createProgressElement() {
    const t = document.createElement("template");
    return t.innerHTML = `
      <div class="progress-container">
        <div class="progress-outer">
          <div class="progress-bar"></div>
          <div class="progress-value"></div>
        </div>
      </div>
    `, t.content.cloneNode(!0);
  }
  static appendProgressIndicators(t) {
    t.forEach((e) => {
      const a = this.createProgressElement();
      e.after(a);
    });
  }
  overrideTabFocusStyles() {
    var t;
    (t = this.tabs) == null || t.forEach(
      (e) => e.setAttribute("focus-override", "")
    );
  }
  setFirstTabToActive() {
    var t, e, a;
    this.tabs && ((e = (t = this.tabs[0]) == null ? void 0 : t.closest("li")) == null || e.setAttribute("active", "")), (a = this.overflowMenu.querySelector("li")) == null || a.setAttribute("active", "");
  }
  handleSlottedCta() {
    if (this.slottedCta.length > 0) {
      const t = this.slottedCta[0], e = document.createElement("li");
      e.classList.add("cta-item");
      const a = document.createElement("div");
      a.classList.add("cta-desktop-container"), a.appendChild(t.cloneNode(!0)), e.appendChild(a), this.slottedTabLists[0].appendChild(e);
      const o = document.createElement("div");
      o.classList.add("cta-mobile-container"), o.appendChild(t), this.menuContainer.appendChild(o);
    }
  }
  handleSlottedTabs() {
    this.tabs = Array.from(this.slottedTabLists[0].querySelectorAll("a[href]")), this._hasOverflowMenu = this.tabs.length > no.overflowMenuTabThreshold, no.appendProgressIndicators(this.tabs), this.overrideTabFocusStyles(), this.setFirstTabToActive(), this.handleSlottedCta();
  }
  toggleMenu() {
    this.menuIsOpen = !this.menuIsOpen;
  }
  closeMenu() {
    this.menuIsOpen = !1;
  }
  removeActiveAttributeFromTabs() {
    const t = Array.from(
      this.slottedTabLists[0].querySelectorAll("li[active]")
    ), e = this.overflowMenu.querySelector("li[active]");
    [...t, e].forEach((o) => o == null ? void 0 : o.removeAttribute("active"));
  }
  addActiveAttributeToTabs() {
    var o, n, r;
    const t = (o = this.activeTab) == null ? void 0 : o.closest("li"), e = (r = this.overflowMenu.querySelector(`a[href="${(n = this.activeTab) == null ? void 0 : n.hash}"]`)) == null ? void 0 : r.closest("li");
    [t, e].forEach((T) => T == null ? void 0 : T.setAttribute("active", ""));
  }
  getCurrentVisibleSections() {
    var a;
    this.currentScrollPosition = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;
    const t = (a = this.offset) != null ? a : this.tabBar ? this.tabBar.offsetHeight : 0;
    return this.sections.filter(
      (o) => {
        const { top: n } = o.getBoundingClientRect();
        return n + this.currentScrollPosition - no.overflowScrollThreshold - t <= this.currentScrollPosition;
      }
    );
  }
  setActiveSection() {
    const t = this.getCurrentVisibleSections(), e = t[t.length - 1];
    this.activeSection = e;
  }
  setActiveTabAttributes() {
    var e;
    const t = (e = this.tabs) == null ? void 0 : e.find(
      (a) => {
        var o;
        return a.hash === `#${(o = this.activeSection) == null ? void 0 : o.id}`;
      }
    );
    this.activeTab !== t && (this.removeActiveAttributeFromTabs(), this.activeTab = t, this.addActiveAttributeToTabs()), this.activeTab === void 0 && this.setFirstTabToActive();
  }
  setActiveProgressValue() {
    if (this.activeProgress && this.activeTab && this.activeSection) {
      const { top: t, height: e } = this.activeSection.getBoundingClientRect(), a = t + this.currentScrollPosition - no.overflowScrollThreshold, n = Math.abs(t) / e * 100, r = Math.floor(n);
      this.currentScrollPosition >= a && Number.isInteger(r) && this.activeProgress.style.setProperty(
        "--reading-progress",
        `${r}%`
      );
    }
  }
  // Hide the jumpToSection when the tabBar is stuck to the top of the page.
  toggleJumpToSectionDisplay() {
    const { top: t } = this.tabBarWrapper.getBoundingClientRect();
    t <= 2 ? this.jumpToSection.classList.add("hidden") : this.jumpToSection.classList.remove("hidden");
  }
  // Delay for 800ms before showing CTA button to avoid rapid toggling.
  handleWindowScroll() {
    this.isScrolling = !0, this.toggleJumpToSectionDisplay(), this.setActiveSection(), this.setActiveTabAttributes(), this.setActiveProgressValue(), this.handleScrollStop();
  }
  intersectionObserverCallback(t) {
    for (const e of t)
      e.isIntersecting ? this.debounceOnScroll ? window.addEventListener("scroll", this.handleWindowScrollDebounced) : window.addEventListener("scroll", this.handleWindowScroll) : this.debounceOnScroll ? window.removeEventListener(
        "scroll",
        this.handleWindowScrollDebounced
      ) : window.removeEventListener("scroll", this.handleWindowScroll);
  }
  renderOverflowMenu() {
    return pe`
      <ol class="menu-list" @keydown=${this.handleMenuKeydown}>
        ${Vo(
      this.tabs,
      (t, e) => pe`
            <li class="menu-list-item" ?active=${e === 0} tabindex="0">
              <a focus-override @click=${this.closeMenu} href="${t == null ? void 0 : t.hash}"
                >${t == null ? void 0 : t.textContent}</a
              >
            </li>
          `
    )}
      </ol>
    `;
  }
  observeSelf() {
    this.observer = new IntersectionObserver(this.intersectionObserverCallback), this.observer.observe(this);
  }
  bindMethods() {
    this.intersectionObserverCallback = this.intersectionObserverCallback.bind(this), this.handleWindowScroll = this.handleWindowScroll.bind(this);
  }
  unobserveSelf() {
    var t;
    (t = this.observer) == null || t.disconnect();
  }
  render() {
    const t = this.menuIsOpen ? "Close" : "Open", e = {
      open: this.menuIsOpen,
      menu: !0
    }, a = {
      "menu-open": this.menuIsOpen,
      "is-scrolling": this.isScrolling,
      "not-active": !this.isActive,
      "menu-container": !0
    };
    return Be`
      <div class="tab-bar-wrapper">
        <p class="jump-to-section">
          <slot name="menu-title">Jump to a section:</slot>
        </p>
        <div class="tab-bar">
          <nav class="tabs" aria-label="on page">
            <slot name="tabs" @slotchange=${this.handleSlottedTabs}></slot>
            <slot name="cta" @slotchange=${this.handleSlottedCta}></slot>
          </nav>
          <div class="${Oe(a)}">
            <button
              class="menu-button"
              aria-controls="menu"
              aria-expanded="${this.menuIsOpen}"
              aria-label="Open navigation menu"
              @click=${this.toggleMenu}
              @keydown=${this.handleMenuKeydown}>
              <div class="visually-hidden">
                <slot name="visually-hidden-button-label"
                  >${t} Menu</slot
                >
              </div>
              <${this.getScopedTag("beacon-icon")} name='expand' size='s'></${this.getScopedTag("beacon-icon")}>
            </button>
            <nav
              id="menu"
              aria-describedby="menu-title"
              class="${Oe(e)}">
              ${this.renderOverflowMenu()}
            </nav>
          </div>
        </div>
      </div>
      <div class="content">
        <slot></slot>
      </div>
    `;
  }
}, no.nestedComponents = [fo], no.tagName = lu.beaconTagName, no.overflowMenuTabThreshold = 4, no.overflowScrollThreshold = 10, no);
kt([
  ue({ attribute: "has-overflow-menu", reflect: !0, type: Boolean })
], vt.prototype, "_hasOverflowMenu", 2);
kt([
  ue({ attribute: "debounce-on-scroll", type: Boolean })
], vt.prototype, "debounceOnScroll", 2);
kt([
  ue({ attribute: "offset", type: Number })
], vt.prototype, "offset", 2);
kt([
  Se()
], vt.prototype, "menuIsOpen", 2);
kt([
  Se()
], vt.prototype, "isScrolling", 2);
kt([
  Se()
], vt.prototype, "isActive", 2);
kt([
  wt({ slot: "tabs", flatten: !0 })
], vt.prototype, "slottedTabLists", 2);
kt([
  wt({ selector: "[id]", flatten: !0 })
], vt.prototype, "sections", 2);
kt([
  wt({ slot: "cta", flatten: !0 })
], vt.prototype, "slottedCta", 2);
kt([
  Ge(".menu-container")
], vt.prototype, "menuContainer", 2);
kt([
  Ge(".cta-mobile-container")
], vt.prototype, "ctaMobileContainer", 2);
kt([
  Ge(".menu")
], vt.prototype, "overflowMenu", 2);
kt([
  Ge(".menu-button")
], vt.prototype, "menuButton", 2);
kt([
  Ge(".tab-bar")
], vt.prototype, "tabBar", 2);
kt([
  Ge(".tab-bar-wrapper")
], vt.prototype, "tabBarWrapper", 2);
kt([
  Ge(".jump-to-section")
], vt.prototype, "jumpToSection", 2);
kt([
  Se()
], vt.prototype, "tabs", 2);
kt([
  qe
], vt.prototype, "observeSelf", 1);
kt([
  qe
], vt.prototype, "bindMethods", 1);
kt([
  Lt
], vt.prototype, "unobserveSelf", 1);
let q3 = vt;
function Jk(i, t = " ") {
  if (i)
    return Lm(i, t);
}
const eC = ve`.highcharts-axis-title{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-caption-200)}.highcharts-axis-labels{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-200)}.highcharts-axis-line,.highcharts-grid-line,.highcharts-plot-line.origin-line,.highcharts-tick{stroke-width:var(--beacon-system-width-border-mini)}.highcharts-graph{stroke-width:var(--beacon-system-width-border-normal)}.highcharts-grid-line,.highcharts-axis-line{stroke:var(--beacon-component-data-viz-color-border-minor)}.highcharts-navigator-xaxis .highcharts-grid-line{stroke:var(--beacon-component-data-viz-color-border-minor);stroke-width:var(--beacon-system-width-border-mini)}.highcharts-plot-line.origin-line,.highcharts-tick{stroke:var(--beacon-component-data-viz-color-border-major)}.highcharts-plot-band.negative-area{fill:var(--beacon-system-color-background-1);fill-opacity:1}`;
var tC = Object.defineProperty, oC = Object.getOwnPropertyDescriptor, Tn = (i, t, e, a) => {
  for (var o = a > 1 ? void 0 : a ? oC(t, e) : t, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = (a ? r(t, e, o) : r(o)) || o);
  return a && o && tC(t, e, o), o;
};
function zs(i) {
  let t = class extends i {
    constructor() {
      super(...arguments), this.yAxisLabel = "", this.xAxisLabel = "";
    }
    static get chartAreaStyles() {
      return eC;
    }
    get totalChartCategories() {
      var o, n, r, T, O;
      const e = (n = (o = this.chart) == null ? void 0 : o.series) == null ? void 0 : n.map(
        (j) => {
          var D;
          return (D = j == null ? void 0 : j.data) == null ? void 0 : D.length;
        }
      );
      if (!(e != null && e.length)) return;
      const a = Math.max(...e);
      return (O = (T = (r = this.categories) == null ? void 0 : r.length) != null ? T : a) != null ? O : void 0;
    }
    willUpdate(e) {
      var a;
      (a = super.willUpdate) == null || a.call(this, e), e.has("xAxisLabel") && this.updateChart({ xAxis: { title: { text: this.xAxisLabel } } }), e.has("yAxisLabel") && this.updateChart({ yAxis: { title: { text: this.yAxisLabel } } }), e.has("categories") && this.updateChart({ xAxis: { categories: this.categories } }), e.has("chart") && this._addPlotBands(), e.has("stacking") && this.updateChart({
        plotOptions: { series: { stacking: this.stacking } }
      });
    }
    // Apply the negative area of the chart after we can access the min of the y axis
    _addPlotBands() {
      var e;
      this.updateChart({
        yAxis: {
          plotBands: [
            {
              className: "negative-area",
              from: 0,
              to: (e = this.chart) == null ? void 0 : e.yAxis[0].min
            }
          ]
        }
      });
    }
    get localComponentOptions() {
      return ct.createChartOptions(super.localComponentOptions, {
        xAxis: {
          categories: this.categories,
          labels: {
            y: 24
          },
          tickLength: 4,
          title: {
            margin: 16,
            text: this.xAxisLabel
          }
        },
        yAxis: {
          labels: {
            formatter() {
              const { value: e } = this;
              return typeof e == "number" ? e < 1e3 ? `${e}` : e < 1e6 ? `${e / 1e3}k` : `${Math.round(e / 1e4) / 100}M` : e;
            }
          },
          plotLines: [
            // Origin Line
            {
              className: "origin-line",
              value: 0,
              zIndex: 5
              // Layers it over the other grid lines
            }
          ],
          title: {
            margin: 16,
            text: this.yAxisLabel
          }
        }
      });
    }
    getTooltipClasses() {
      var e;
      return `beacon-chart-tooltip ${this.colorOrder} ${this.type} ${((e = this.series) == null ? void 0 : e.length) === 1 ? "single-series-chart" : ""} ${this.stacking ? "stacked-chart" : ""}`.trim();
    }
  };
  return Tn([
    ue({ attribute: "y-axis-label" })
  ], t.prototype, "yAxisLabel", 2), Tn([
    ue({ attribute: "x-axis-label" })
  ], t.prototype, "xAxisLabel", 2), Tn([
    ue({
      converter: (e) => Jk(e, ",")
    })
  ], t.prototype, "categories", 2), Tn([
    ue({ reflect: !0 })
  ], t.prototype, "stacking", 2), Tn([
    yo("series")
  ], t.prototype, "_addPlotBands", 1), t = Tn([
    je("ChartArea")
  ], t), t;
}
var Jm = { exports: {} };
(function(i) {
  /**
  * Highcharts JS v11.4.8 (2024-08-29)
  *
  * Data module
  *
  * (c) 2012-2024 Torstein Honsi
  *
  * License: www.highcharts.com/license
  */
  (function(t) {
    i.exports ? (t.default = t, i.exports = t) : t(typeof Highcharts < "u" ? Highcharts : void 0);
  })(function(t) {
    var e = t ? t._modules : {};
    function a(o, n, r, T) {
      o.hasOwnProperty(n) || (o[n] = T.apply(null, r), typeof CustomEvent == "function" && t.win.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", { detail: { path: n, module: o[n] } })));
    }
    a(e, "Core/HttpUtilities.js", [e["Core/Globals.js"], e["Core/Utilities.js"]], function(o, n) {
      let { win: r } = o, { discardElement: T, objectEach: O } = n, j = { ajax: function(D) {
        let F = { json: "application/json", xml: "application/xml", text: "text/plain", octet: "application/octet-stream" }, B = new XMLHttpRequest();
        function N(f, w) {
          D.error && D.error(f, w);
        }
        if (!D.url) return !1;
        B.open((D.type || "get").toUpperCase(), D.url, !0), D.headers && D.headers["Content-Type"] || B.setRequestHeader("Content-Type", F[D.dataType || "json"] || F.text), O(D.headers, function(f, w) {
          B.setRequestHeader(w, f);
        }), D.responseType && (B.responseType = D.responseType), B.onreadystatechange = function() {
          let f;
          if (B.readyState === 4) {
            if (B.status === 200) {
              if (D.responseType !== "blob" && (f = B.responseText, D.dataType === "json")) try {
                f = JSON.parse(f);
              } catch (w) {
                if (w instanceof Error) return N(B, w);
              }
              return D.success && D.success(f, B);
            }
            N(B, B.responseText);
          }
        }, D.data && typeof D.data != "string" && (D.data = JSON.stringify(D.data)), B.send(D.data);
      }, getJSON: function(D, F) {
        j.ajax({ url: D, success: F, dataType: "json", headers: { "Content-Type": "text/plain" } });
      }, post: function(D, F, B) {
        let N = new r.FormData();
        O(F, function(x, M) {
          N.append(M, x);
        }), N.append("b64", "true");
        let { filename: f, type: w } = F;
        return r.fetch(D, { method: "POST", body: N, ...B }).then((x) => {
          x.ok && x.text().then((M) => {
            let p = document.createElement("a");
            p.href = `data:${w};base64,${M}`, p.download = f, p.click(), T(p);
          });
        });
      } };
      return j;
    }), a(e, "Extensions/Data.js", [e["Core/Axis/Axis.js"], e["Core/Chart/Chart.js"], e["Core/Defaults.js"], e["Core/Globals.js"], e["Core/HttpUtilities.js"], e["Core/Series/Point.js"], e["Core/Series/SeriesRegistry.js"], e["Core/Utilities.js"]], function(o, n, r, T, O, j, D, F) {
      let { getOptions: B } = r, { doc: N } = T, { ajax: f } = O, { seriesTypes: w } = D, { addEvent: x, defined: M, extend: p, fireEvent: v, isNumber: k, merge: m, objectEach: A, pick: C, splat: H } = F;
      function G(S) {
        return !!(S && (S.rowsURL || S.csvURL || S.columnsURL));
      }
      class P {
        static data(d, s = {}, l) {
          return new P(d, s, l);
        }
        static rowsToColumns(d) {
          let s, l, b, u, c;
          if (d) for (s = 0, c = [], l = d.length; s < l; s++) for (b = 0, u = d[s].length; b < u; b++) c[b] || (c[b] = []), c[b][s] = d[s][b];
          return c;
        }
        constructor(d, s = {}, l) {
          this.rowsToColumns = P.rowsToColumns, this.dateFormats = { "YYYY/mm/dd": { regex: /^(\d{4})[\-\/\.](\d{1,2})[\-\/\.](\d{1,2})$/, parser: function(b) {
            return b ? Date.UTC(+b[1], +b[2] - 1, +b[3]) : NaN;
          } }, "dd/mm/YYYY": { regex: /^(\d{1,2})[\-\/\.](\d{1,2})[\-\/\.](\d{4})$/, parser: function(b) {
            return b ? Date.UTC(+b[3], +b[2] - 1, +b[1]) : NaN;
          }, alternative: "mm/dd/YYYY" }, "mm/dd/YYYY": { regex: /^(\d{1,2})[\-\/\.](\d{1,2})[\-\/\.](\d{4})$/, parser: function(b) {
            return b ? Date.UTC(+b[3], +b[1] - 1, +b[2]) : NaN;
          } }, "dd/mm/YY": { regex: /^(\d{1,2})[\-\/\.](\d{1,2})[\-\/\.](\d{2})$/, parser: function(b) {
            if (!b) return NaN;
            let u = /* @__PURE__ */ new Date(), c = +b[3];
            return c > u.getFullYear() - 2e3 ? c += 1900 : c += 2e3, Date.UTC(c, +b[2] - 1, +b[1]);
          }, alternative: "mm/dd/YY" }, "mm/dd/YY": { regex: /^(\d{1,2})[\-\/\.](\d{1,2})[\-\/\.](\d{2})$/, parser: function(b) {
            return b ? Date.UTC(+b[3] + 2e3, +b[1] - 1, +b[2]) : NaN;
          } } }, this.chart = l, this.chartOptions = s, this.options = d, this.rawColumns = [], this.init(d, s, l);
        }
        init(d, s, l) {
          let b = d.decimalPoint, u;
          s && (this.chartOptions = s), l && (this.chart = l), b !== "." && b !== "," && (b = void 0), this.options = d, this.columns = d.columns || this.rowsToColumns(d.rows) || [], this.firstRowAsNames = C(d.firstRowAsNames, this.firstRowAsNames, !0), this.decimalRegex = b && RegExp("^(-?[0-9]+)" + b + "([0-9]+)$"), this.liveDataTimeout !== void 0 && clearTimeout(this.liveDataTimeout), this.rawColumns = [], this.columns.length && (this.dataFound(), u = !G(d)), u || (u = this.fetchLiveData()), u || (u = !!this.parseCSV().length), u || (u = !!this.parseTable().length), u || (u = this.parseGoogleSpreadsheet()), !u && d.afterComplete && d.afterComplete(this);
        }
        getColumnDistribution() {
          var U, V;
          let d = this.chartOptions, s = this.options, l = [], b = function(q = "line") {
            return (w[q].prototype.pointArrayMap || [0]).length;
          }, u = function(q = "line") {
            return w[q].prototype.pointArrayMap;
          }, c = (U = d == null ? void 0 : d.chart) == null ? void 0 : U.type, h = [], g = [], E = (s == null ? void 0 : s.seriesMapping) || ((V = d == null ? void 0 : d.series) == null ? void 0 : V.map(function() {
            return { x: 0 };
          })) || [], R = 0;
          ((d == null ? void 0 : d.series) || []).forEach((q) => {
            h.push(b(q.type || c));
          }), E.forEach((q) => {
            l.push(q.x || 0);
          }), l.length === 0 && l.push(0), E.forEach((q) => {
            var z, $;
            let Y = new y(), I = h[R] || b(c), _ = ($ = ((z = d == null ? void 0 : d.series) != null ? z : [])[R]) != null ? $ : {}, W = u(_.type || c), X = W != null ? W : ["y"];
            (M(q.x) || _.isCartesian || !W) && Y.addColumnReader(q.x, "x"), A(q, function(K, Q) {
              Q !== "x" && Y.addColumnReader(K, Q);
            });
            for (let K = 0; K < I; K++) Y.hasReader(X[K]) || Y.addColumnReader(void 0, X[K]);
            g.push(Y), R++;
          });
          let L = u(c);
          L === void 0 && (L = ["y"]), this.valueCount = { global: b(c), xColumns: l, individual: h, seriesBuilders: g, globalPointArrayMap: L };
        }
        dataFound() {
          this.options.switchRowsAndColumns && (this.columns = this.rowsToColumns(this.columns)), this.getColumnDistribution(), this.parseTypes(), this.parsed() !== !1 && this.complete();
        }
        parseCSV(d) {
          let s = this, l = this.columns = [], b = d || this.options, u = b.startColumn || 0, c = b.endColumn || Number.MAX_VALUE, h = [], g = { ",": 0, ";": 0, "	": 0 }, E = b.csv, R = b.startRow || 0, L = b.endRow || Number.MAX_VALUE, U, V, q = 0;
          if (E && b.beforeParse && (E = b.beforeParse.call(this, E)), E) {
            if (V = E.replace(/\r\n/g, `
`).replace(/\r/g, `
`).split(b.lineDelimiter || `
`), (!R || R < 0) && (R = 0), (!L || L >= V.length) && (L = V.length - 1), b.itemDelimiter) U = b.itemDelimiter;
            else {
              let I, _, W;
              I = 0, _ = 0, W = !1, V.some(function(X, z) {
                let $ = !1, K, Q, Z, ee = "";
                if (z > 13) return !0;
                for (let J = 0; J < X.length; J++) {
                  if (K = X[J], Q = X[J + 1], Z = X[J - 1], K === "#") return;
                  if (K === '"')
                    if ($) {
                      if (Z !== '"' && Q !== '"') {
                        for (; Q === " " && J < X.length; ) Q = X[++J];
                        g[Q] !== void 0 && g[Q]++, $ = !1;
                      }
                    } else $ = !0;
                  else g[K] !== void 0 ? (isNaN(Date.parse(ee = ee.trim())) ? (isNaN(ee) || !isFinite(ee)) && g[K]++ : g[K]++, ee = "") : ee += K;
                  K === "," && _++, K === "." && I++;
                }
              }), g[";"] > g[","] ? W = ";" : (g[","], g[";"], W = ","), b.decimalPoint || (I > _ ? b.decimalPoint = "." : b.decimalPoint = ",", s.decimalRegex = RegExp("^(-?[0-9]+)" + b.decimalPoint + "([0-9]+)$")), U = W;
            }
            let Y = 0;
            for (q = R; q <= L; q++) V[q][0] === "#" ? Y++ : function(I, _, W, X) {
              let z = 0, $ = "", K = "", Q = "", Z = "", ee = 0, J = 0;
              function ae(he) {
                $ = I[he], K = I[he - 1], Q = I[he + 1];
              }
              function re(he) {
                h.length < J + 1 && h.push([he]), h[J][h[J].length - 1] !== he && h[J].push(he);
              }
              function ce() {
                if (u > ee || ee > c) {
                  ++ee, Z = "";
                  return;
                }
                b.columnTypes || (!isNaN(parseFloat(Z)) && isFinite(Z) ? (Z = parseFloat(Z), re("number")) : isNaN(Date.parse(Z)) ? re("string") : (Z = Z.replace(/\//g, "-"), re("date"))), l.length < J + 1 && l.push([]), l[J][_] = Z, Z = "", ++J, ++ee;
              }
              if (I.trim().length && I.trim()[0] !== "#") {
                for (; z < I.length; z++) if (ae(z), $ === '"') for (ae(++z); z < I.length && ($ !== '"' || K === '"' || Q === '"'); ) ($ !== '"' || $ === '"' && K !== '"') && (Z += $), ae(++z);
                else $ === U ? ce() : Z += $;
                ce();
              }
            }(V[q], q - R - Y);
            (!b.columnTypes || b.columnTypes.length === 0) && h.length && h[0].length && h[0][1] === "date" && !b.dateFormat && (b.dateFormat = function(I, _) {
              var ae;
              let W = "YYYY/mm/dd", X = [], z = [], $, K = [], Q, Z = 0, ee = !1, J;
              for ((!_ || _ > I.length) && (_ = I.length); Z < _; Z++) if (I[Z] !== void 0 && ((ae = I[Z]) != null && ae.length)) for (J = 0, $ = I[Z].trim().replace(/\//g, " ").replace(/\-/g, " ").replace(/\./g, " ").split(" "), K = ["", "", ""]; J < $.length; J++) J < K.length && ($[J] = parseInt($[J], 10), $[J] && (z[J] = !z[J] || z[J] < $[J] ? $[J] : z[J], X[J] !== void 0 ? X[J] !== $[J] && (X[J] = !1) : X[J] = $[J], $[J] > 31 ? $[J] < 100 ? K[J] = "YY" : K[J] = "YYYY" : $[J] > 12 && $[J] <= 31 ? (K[J] = "dd", ee = !0) : K[J].length || (K[J] = "mm")));
              if (ee) {
                for (J = 0; J < X.length; J++) X[J] !== !1 ? z[J] > 12 && K[J] !== "YY" && K[J] !== "YYYY" && (K[J] = "YY") : z[J] > 12 && K[J] === "mm" && (K[J] = "dd");
                return K.length === 3 && K[1] === "dd" && K[2] === "dd" && (K[2] = "YY"), Q = K.join("/"), (b.dateFormats || s.dateFormats)[Q] ? Q : (v(s, "deduceDateFailed"), W);
              }
              return W;
            }(l[0])), this.dataFound();
          }
          return l;
        }
        parseTable() {
          let d = this.options, s = this.columns || [], l = d.startRow || 0, b = d.endRow || Number.MAX_VALUE, u = d.startColumn || 0, c = d.endColumn || Number.MAX_VALUE;
          if (d.table) {
            let h = d.table;
            typeof h == "string" && (h = N.getElementById(h)), [].forEach.call(h.getElementsByTagName("tr"), (g, E) => {
              E >= l && E <= b && [].forEach.call(g.children, (R, L) => {
                let U = s[L - u], V = 1;
                if ((R.tagName === "TD" || R.tagName === "TH") && L >= u && L <= c) for (s[L - u] || (s[L - u] = []), s[L - u][E - l] = R.innerHTML; E - l >= V && U[E - l - V] === void 0; ) U[E - l - V] = null, V++;
              });
            }), this.dataFound();
          }
          return s;
        }
        fetchLiveData() {
          let d = this, s = this.chart, l = this.options, b = l.enablePolling, u = m(l), c = 0, h = 1e3 * (l.dataRefreshRate || 2);
          return !!G(l) && (h < 1e3 && (h = 1e3), delete l.csvURL, delete l.rowsURL, delete l.columnsURL, function g(E) {
            function R(L, U, V) {
              if (!L || !/^(http|\/|\.\/|\.\.\/)/.test(L)) return L && l.error && l.error("Invalid URL"), !1;
              function q() {
                b && s.liveDataURL === L && (d.liveDataTimeout = setTimeout(g, h));
              }
              return E && (clearTimeout(d.liveDataTimeout), s.liveDataURL = L), f({ url: L, dataType: V || "json", success: function(Y) {
                s != null && s.series && U(Y), q();
              }, error: function(Y, I) {
                var _;
                return ++c < 3 && q(), (_ = l.error) == null ? void 0 : _.call(l, I, Y);
              } }), !0;
            }
            R(u.csvURL, function(L) {
              s.update({ data: { csv: L } });
            }, "text") || R(u.rowsURL, function(L) {
              s.update({ data: { rows: L } });
            }) || R(u.columnsURL, function(L) {
              s.update({ data: { columns: L } });
            });
          }(!0), G(l));
        }
        parseGoogleSpreadsheet() {
          let d = this, s = this.options, l = s.googleSpreadsheetKey, b = this.chart, u = Math.max(1e3 * (s.dataRefreshRate || 2), 4e3), c = () => {
            if (s.googleSpreadsheetRange) return s.googleSpreadsheetRange;
            let h = "ABCDEFGHIJKLMNOPQRSTUVWXYZ", g = (h.charAt(s.startColumn || 0) || "A") + ((s.startRow || 0) + 1), E = h.charAt(C(s.endColumn, -1)) || "ZZ";
            return M(s.endRow) && (E += s.endRow + 1), `${g}:${E}`;
          };
          return l && (delete s.googleSpreadsheetKey, function h(g) {
            f({ url: ["https://sheets.googleapis.com/v4/spreadsheets", l, "values", c(), "?alt=json&majorDimension=COLUMNS&valueRenderOption=UNFORMATTED_VALUE&dateTimeRenderOption=FORMATTED_STRING&key=" + s.googleAPIKey].join("/"), dataType: "json", success: function(E) {
              g(E), s.enablePolling && (d.liveDataTimeout = setTimeout(function() {
                h(g);
              }, u));
            }, error: function(E, R) {
              var L;
              return (L = s.error) == null ? void 0 : L.call(s, R, E);
            } });
          }(function(h) {
            let g = h.values;
            if (!g || g.length === 0) return !1;
            let E = g.reduce((R, L) => Math.max(R, L.length), 0);
            g.forEach((R) => {
              for (let L = 0; L < E; L++) R[L] === void 0 && (R[L] = null);
            }), b != null && b.series ? b.update({ data: { columns: g } }) : (d.columns = g, d.dataFound());
          })), !1;
        }
        trim(d, s) {
          return typeof d == "string" && (d = d.replace(/^\s+|\s+$/g, ""), s && /[\d\s]+/.test(d) && (d = d.replace(/\s/g, "")), this.decimalRegex && (d = d.replace(this.decimalRegex, "$1.$2"))), d;
        }
        parseTypes() {
          let d = this.columns || [], s = d.length;
          for (; s--; ) this.parseColumn(d[s], s);
        }
        parseColumn(d, s) {
          var z;
          let l = this.rawColumns, b = this.columns = this.columns || [], u = this.firstRowAsNames, c = ((z = this.valueCount) == null ? void 0 : z.xColumns.indexOf(s)) !== -1, h = [], g = this.chartOptions, E = (this.options.columnTypes || [])[s], R = c && (g == null ? void 0 : g.xAxis) && H(g.xAxis)[0].type === "category" || E === "string", L = M(d.name), U = d.length, V, q, Y, I, _, W, X;
          for (l[s] || (l[s] = []); U--; ) V = h[U] || d[U], Y = this.trim(V), q = parseFloat(I = this.trim(V, !0)), l[s][U] === void 0 && (l[s][U] = Y), R || U === 0 && u && !L ? d[U] = "" + Y : +I === q ? (d[U] = q, q > 31536e6 && E !== "float" ? d.isDatetime = !0 : d.isNumeric = !0, d[U + 1] !== void 0 && (X = q > d[U + 1])) : (Y != null && Y.length && (_ = this.parseDate(V)), c && k(_) && E !== "float" ? (h[U] = V, d[U] = _, d.isDatetime = !0, d[U + 1] !== void 0 && ((W = _ > d[U + 1]) !== X && X !== void 0 && (this.alternativeFormat ? (this.dateFormat = this.alternativeFormat, U = d.length, this.alternativeFormat = this.dateFormats[this.dateFormat].alternative) : d.unsorted = !0), X = W)) : (d[U] = Y === "" ? null : Y, U !== 0 && (d.isDatetime || d.isNumeric) && (d.mixed = !0)));
          if (c && d.mixed && (b[s] = l[s]), c && X && this.options.sort) {
            for (s = 0; s < b.length; s++) if (b[s].reverse(), u) {
              let $ = b[s].pop();
              $ && b[s].unshift($);
            }
          }
        }
        parseDate(d) {
          let s = this.options.parseDate, l, b, u, c = this.options.dateFormat || this.dateFormat, h;
          if (s) l = s(d);
          else if (typeof d == "string") {
            if (c) (u = this.dateFormats[c]) || (u = this.dateFormats["YYYY/mm/dd"]), (h = d.match(u.regex)) && (l = u.parser(h));
            else for (b in this.dateFormats) if (u = this.dateFormats[b], h = d.match(u.regex)) {
              this.dateFormat = c = b, this.alternativeFormat = u.alternative, l = u.parser(h);
              break;
            }
            !h && (d.match(/:.+(GMT|UTC|[Z+\-])/) && (d = d.replace(/\s*(?:GMT|UTC)?([+\-])(\d\d)(\d\d)$/, "$1$2:$3").replace(/(?:\s+|GMT|UTC)([+\-])/, "$1").replace(/(\d)\s*(?:GMT|UTC|Z)$/, "$1+00:00")), typeof (h = Date.parse(d)) == "object" && h !== null && h.getTime ? l = h.getTime() - 6e4 * h.getTimezoneOffset() : k(h) && (l = h - 6e4 * new Date(h).getTimezoneOffset()));
          }
          return l;
        }
        getData() {
          var d;
          if (this.columns) return (d = this.rowsToColumns(this.columns)) == null ? void 0 : d.slice(1);
        }
        parsed() {
          if (this.options.parsed) return this.options.parsed.call(this, this.columns);
        }
        complete() {
          var I, _, W, X, z;
          let d = this.columns = this.columns || [], s = this.options, l = [], b = "linear", u, c, h, g, E, R, L, U, V, q, Y;
          if (d.length, s.complete || s.afterComplete) {
            if (this.firstRowAsNames) for (h = 0; h < d.length; h++) {
              let $ = d[h];
              M($.name) || ($.name = C($.shift(), "").toString());
            }
            for (R = 0, u = [], V = function($, K) {
              let Q, Z, ee, J = [], ae = [];
              for (Z = 0; Z < $; Z += 1) J.push(!0);
              for (Q = 0; Q < K.length; Q += 1) for (Z = 0, ee = K[Q].getReferencedColumnIndexes(); Z < ee.length; Z += 1) J[ee[Z]] = !1;
              for (Z = 0; Z < J.length; Z += 1) J[Z] && ae.push(Z);
              return ae;
            }((d == null ? void 0 : d.length) || 0, this.valueCount.seriesBuilders); R < this.valueCount.seriesBuilders.length; R++) (U = this.valueCount.seriesBuilders[R]).populateColumns(V) && l.push(U);
            for (; V.length > 0; ) {
              for ((U = new y()).addColumnReader(0, "x"), (Y = V.indexOf(0)) !== -1 && V.splice(Y, 1), h = 0; h < this.valueCount.global; h++) U.addColumnReader(void 0, this.valueCount.globalPointArrayMap[h]);
              U.populateColumns(V) && l.push(U);
            }
            if (l.length > 0 && l[0].readers.length > 0 && (q = d == null ? void 0 : d[(I = l[0].readers[0].columnIndex) != null ? I : -1]) !== void 0 && (q.isDatetime ? b = "datetime" : q.isNumeric || (b = "category")), b === "category") for (R = 0; R < l.length; R++) for (E = 0, U = l[R]; E < U.readers.length; E++) U.readers[E].configName === "x" && (U.readers[E].configName = "name");
            for (R = 0; R < l.length; R++) {
              for (g = 0, U = l[R], c = []; g < d[0].length; g++) c[g] = U.read(d, g);
              u[R] = { data: c, pointStart: c[0] && (U.pointIsArray ? (_ = c[0]) == null ? void 0 : _[0] : (W = c[0]) == null ? void 0 : W.x) || void 0 }, U.name && (u[R].name = U.name), b === "category" && (u[R].turboThreshold = 0, u[R].pointStart = 0);
            }
            L = { series: u }, b !== "linear" || this.xAxisOptions && this.xAxisOptions.type !== b ? (this.xAxisOptions = { type: b }, b === "category" && (this.xAxisOptions.uniqueNames = !1)) : b = this.xAxisOptions = void 0, this.chart || m(!0, L, { xAxis: this.xAxisOptions || {} }), (X = s.complete) == null || X.call(s, L), (z = s.afterComplete) == null || z.call(s, this, L);
          }
        }
        xAxisUpdateHandler(d) {
          let s = this.xAxisOptions;
          s && (!d.options.type && s.type && (d.type = s.type), d.options.uniqueNames || s.uniqueNames !== !1 || (d.uniqueNames = s.uniqueNames));
        }
        update(d, s) {
          var u;
          let l = this.chart, b = l.options;
          d && (d.afterComplete = function(c, h) {
            if (!h) return;
            let g = l.xAxis[0], E = c.xAxisOptions;
            E && g && (g.type !== E.type && !g.options.type || g.uniqueNames && E.uniqueNames === !1 && g.options.uniqueNames === void 0) ? g.update({}, !1) : ((h == null ? void 0 : h.series) || []).forEach(function(R) {
              delete R.pointStart;
            }), l.update(h, s, !0);
          }, m(!0, b.data, d), (u = b.data) != null && u.googleSpreadsheetKey && !d.columns && delete b.data.columns, this.init(b.data || {}, b));
        }
      }
      x(o, "afterSetOptions", function() {
        var S;
        this.isXAxis && (!this.chart.xAxis.length || this.chart.xAxis[0] === this) && ((S = this.chart.data) == null || S.xAxisUpdateHandler(this));
      }), x(n, "init", function(S) {
        let d = this, s = S.args[1], l = B().data, b = S.args[0] || {};
        if ((l || b && b.data) && !d.hasDataDef) {
          d.hasDataDef = !0;
          let u = m(l, b.data);
          d.data = new P(p(u, { afterComplete: function(c, h) {
            var R, L, U, V;
            let g, E;
            if (Object.hasOwnProperty.call(b, "series"))
              if (typeof b.series == "object") for (g = Math.max(b.series.length, (L = (R = h == null ? void 0 : h.series) == null ? void 0 : R.length) != null ? L : 0); g--; ) E = b.series[g] || {}, b.series[g] = m(E, (V = (U = h == null ? void 0 : h.series) == null ? void 0 : U[g]) != null ? V : {});
              else delete b.series;
            b = m(h, b), d.data = c, d.init(b, s);
          } }), b, d), S.preventDefault();
        }
      });
      class y {
        constructor() {
          this.readers = [], this.pointIsArray = !0;
        }
        populateColumns(d) {
          let s = !0;
          return this.readers.forEach((l) => {
            l.columnIndex === void 0 && (l.columnIndex = d.shift());
          }), this.readers.forEach((l) => {
            l.columnIndex === void 0 && (s = !1);
          }), s;
        }
        read(d, s) {
          let l = this.pointIsArray, b = l ? [] : {};
          if (this.readers.forEach((u) => {
            let c = d[u.columnIndex][s];
            l ? b.push(c) : u.configName.indexOf(".") > 0 ? j.prototype.setNestedProperty(b, c, u.configName) : b[u.configName] = c;
          }), this.name === void 0 && this.readers.length >= 2) {
            let u = [];
            this.readers.forEach(function(c) {
              (c.configName === "x" || c.configName === "name" || c.configName === "y") && c.columnIndex !== void 0 && u.push(c.columnIndex);
            }), u.length >= 2 && (u.shift(), u.sort(function(c, h) {
              return c - h;
            })), this.name = d[C(u.shift(), 0)].name;
          }
          return b;
        }
        addColumnReader(d, s) {
          this.readers.push({ columnIndex: d, configName: s }), s === "x" || s === "y" || s === void 0 || (this.pointIsArray = !1);
        }
        getReferencedColumnIndexes() {
          let d, s, l = [];
          for (d = 0; d < this.readers.length; d += 1) (s = this.readers[d]).columnIndex !== void 0 && l.push(s.columnIndex);
          return l;
        }
        hasReader(d) {
          let s;
          for (s = 0; s < this.readers.length; s += 1) if (this.readers[s].configName === d) return !0;
        }
      }
      return P;
    }), a(e, "masters/modules/data.src.js", [e["Core/Globals.js"], e["Core/HttpUtilities.js"], e["Extensions/Data.js"]], function(o, n, r) {
      return o.Data = o.Data || r, o.HttpUtilities = o.HttpUtilities || n, o.ajax = o.HttpUtilities.ajax, o.data = o.Data.data, o.getJSON = o.HttpUtilities.getJSON, o.post = o.HttpUtilities.post, o;
    });
  });
})(Jm);
var aC = Jm.exports;
const iC = /* @__PURE__ */ fi(aC);
var ef = { exports: {} };
(function(i) {
  /**
  * Highcharts JS v11.4.8 (2024-08-29)
  *
  * Exporting module
  *
  * (c) 2010-2024 Torstein Honsi
  *
  * License: www.highcharts.com/license
  */
  (function(t) {
    i.exports ? (t.default = t, i.exports = t) : t(typeof Highcharts < "u" ? Highcharts : void 0);
  })(function(t) {
    var e = t ? t._modules : {};
    function a(o, n, r, T) {
      o.hasOwnProperty(n) || (o[n] = T.apply(null, r), typeof CustomEvent == "function" && t.win.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", { detail: { path: n, module: o[n] } })));
    }
    a(e, "Extensions/DownloadURL.js", [e["Core/Globals.js"]], function(o) {
      let { isSafari: n, win: r, win: { document: T } } = o, O = r.URL || r.webkitURL || r;
      function j(D) {
        let F = D.replace(/filename=.*;/, "").match(/data:([^;]*)(;base64)?,([A-Z+\d\/]+)/i);
        if (F && F.length > 3 && r.atob && r.ArrayBuffer && r.Uint8Array && r.Blob && O.createObjectURL) {
          let B = r.atob(F[3]), N = new r.ArrayBuffer(B.length), f = new r.Uint8Array(N);
          for (let w = 0; w < f.length; ++w) f[w] = B.charCodeAt(w);
          return O.createObjectURL(new r.Blob([f], { type: F[1] }));
        }
      }
      return { dataURLtoBlob: j, downloadURL: function(D, F) {
        let B = r.navigator, N = T.createElement("a");
        if (typeof D != "string" && !(D instanceof String) && B.msSaveOrOpenBlob) {
          B.msSaveOrOpenBlob(D, F);
          return;
        }
        if (D = "" + D, B.userAgent.length > 1e3) throw Error("Input too long");
        let f = /Edge\/\d+/.test(B.userAgent);
        if ((n && typeof D == "string" && D.indexOf("data:application/pdf") === 0 || f || D.length > 2e6) && !(D = j(D) || "")) throw Error("Failed to convert to blob");
        if (N.download !== void 0) N.href = D, N.download = F, T.body.appendChild(N), N.click(), T.body.removeChild(N);
        else try {
          if (!r.open(D, "chart")) throw Error("Failed to open window");
        } catch {
          r.location.href = D;
        }
      } };
    }), a(e, "Extensions/ExportData/ExportDataDefaults.js", [], function() {
      return { exporting: { csv: { annotations: { itemDelimiter: "; ", join: !1 }, columnHeaderFormatter: null, dateFormat: "%Y-%m-%d %H:%M:%S", decimalPoint: null, itemDelimiter: null, lineDelimiter: `
` }, showTable: !1, useMultiLevelHeaders: !0, useRowspanHeaders: !0, showExportInProgress: !0 }, lang: { downloadCSV: "Download CSV", downloadXLS: "Download XLS", exportData: { annotationHeader: "Annotations", categoryHeader: "Category", categoryDatetimeHeader: "DateTime" }, viewData: "View data table", hideData: "Hide data table", exportInProgress: "Exporting..." } };
    }), a(e, "Extensions/ExportData/ExportData.js", [e["Core/Renderer/HTML/AST.js"], e["Core/Defaults.js"], e["Extensions/DownloadURL.js"], e["Extensions/ExportData/ExportDataDefaults.js"], e["Core/Globals.js"], e["Core/Utilities.js"]], function(o, n, r, T, O, j) {
      let { getOptions: D, setOptions: F } = n, { downloadURL: B } = r, { doc: N, win: f } = O, { addEvent: w, defined: x, extend: M, find: p, fireEvent: v, isNumber: k, pick: m } = j;
      function A(g) {
        var L;
        let E = !!((L = this.options.exporting) != null && L.showExportInProgress), R = f.requestAnimationFrame || setTimeout;
        R(() => {
          E && this.showLoading(this.options.lang.exportInProgress), R(() => {
            try {
              g.call(this);
            } finally {
              E && this.hideLoading();
            }
          });
        });
      }
      function C() {
        A.call(this, () => {
          let g = this.getCSV(!0);
          B(b(g, "text/csv") || "data:text/csv,\uFEFF" + encodeURIComponent(g), this.getFilename() + ".csv");
        });
      }
      function H() {
        A.call(this, () => {
          let g = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>Ark1</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><style>td{border:none;font-family: Calibri, sans-serif;} .number{mso-number-format:"0.00";} .text{ mso-number-format:"@";}</style><meta name=ProgId content=Excel.Sheet><meta charset=UTF-8></head><body>' + this.getTable(!0) + "</body></html>";
          B(b(g, "application/vnd.ms-excel") || "data:application/vnd.ms-excel;base64," + f.btoa(unescape(encodeURIComponent(g))), this.getFilename() + ".xls");
        });
      }
      function G(g) {
        let E = "", R = this.getDataRows(), L = this.options.exporting.csv, U = m(L.decimalPoint, L.itemDelimiter !== "," && g ? 1.1.toLocaleString()[1] : "."), V = m(L.itemDelimiter, U === "," ? ";" : ","), q = L.lineDelimiter;
        return R.forEach((Y, I) => {
          let _ = "", W = Y.length;
          for (; W--; ) typeof (_ = Y[W]) == "string" && (_ = `"${_}"`), typeof _ == "number" && U !== "." && (_ = _.toString().replace(".", U)), Y[W] = _;
          Y.length = R.length ? R[0].length : 0, E += Y.join(V), I < R.length - 1 && (E += q);
        }), E;
      }
      function P(g) {
        let E, R, L = this.hasParallelCoordinates, U = this.time, V = this.options.exporting && this.options.exporting.csv || {}, q = this.xAxis, Y = {}, I = [], _ = [], W = [], X = this.options.lang.exportData, z = X.categoryHeader, $ = X.categoryDatetimeHeader, K = function(te, se, oe) {
          if (V.columnHeaderFormatter) {
            let ie = V.columnHeaderFormatter(te, se, oe);
            if (ie !== !1) return ie;
          }
          return te ? te.bindAxes ? g ? { columnTitle: oe > 1 ? se : te.name, topLevelColumnTitle: te.name } : te.name + (oe > 1 ? " (" + se + ")" : "") : te.options.title && te.options.title.text || (te.dateTime ? $ : z) : z;
        }, Q = function(te, se, oe) {
          let ie = {}, le = {};
          return se.forEach(function(de) {
            let be = (te.keyToAxis && te.keyToAxis[de] || de) + "Axis", ge = k(oe) ? te.chart[be][oe] : te[be];
            ie[de] = ge && ge.categories || [], le[de] = ge && ge.dateTime;
          }), { categoryMap: ie, dateTimeValueAxisMap: le };
        }, Z = function(te, se) {
          let oe = te.pointArrayMap || ["y"];
          return te.data.some((ie) => ie.y !== void 0 && ie.name) && se && !se.categories && te.exportKey !== "name" ? ["x", ...oe] : oe;
        }, ee = [], J, ae, re, ce = 0, he, ne;
        for (he in this.series.forEach(function(te) {
          let se = te.options.keys, oe = te.xAxis, ie = se || Z(te, oe), le = ie.length, de = !te.requireSorting && {}, be = q.indexOf(oe), ge = Q(te, ie), me, fe;
          if (te.options.includeInDataExport !== !1 && !te.options.isInternal && te.visible !== !1) {
            for (p(ee, function(Ae) {
              return Ae[0] === be;
            }) || ee.push([be, ce]), fe = 0; fe < le; ) re = K(te, ie[fe], ie.length), W.push(re.columnTitle || re), g && _.push(re.topLevelColumnTitle || re), fe++;
            me = { chart: te.chart, autoIncrement: te.autoIncrement, options: te.options, pointArrayMap: te.pointArrayMap, index: te.index }, te.options.data.forEach(function(Ae, ye) {
              var Ie;
              let xe, we, ke, Me = { series: me };
              L && (ge = Q(te, ie, ye)), te.pointClass.prototype.applyOptions.apply(Me, [Ae]);
              let Te = te.data[ye] && te.data[ye].name;
              if (xe = ((Ie = Me.x) != null ? Ie : "") + "," + Te, fe = 0, (!oe || te.exportKey === "name" || !L && oe && oe.hasNames && Te) && (xe = Te), de && (de[xe] && (xe += "|" + ye), de[xe] = !0), Y[xe]) {
                let He = `${xe},${Y[xe].pointers[te.index]}`, $e = xe;
                Y[xe].pointers[te.index] && (Y[He] || (Y[He] = [], Y[He].xValues = [], Y[He].pointers = []), xe = He), Y[$e].pointers[te.index] += 1;
              } else {
                Y[xe] = [], Y[xe].xValues = [];
                let He = [];
                for (let $e = 0; $e < te.chart.series.length; $e++) He[$e] = 0;
                Y[xe].pointers = He, Y[xe].pointers[te.index] = 1;
              }
              for (Y[xe].x = Me.x, Y[xe].name = Te, Y[xe].xValues[be] = Me.x; fe < le; ) ke = Me[we = ie[fe]], Y[xe][ce + fe] = m(ge.categoryMap[we][ke], ge.dateTimeValueAxisMap[we] ? U.dateFormat(V.dateFormat, ke) : null, ke), fe++;
            }), ce += fe;
          }
        }), Y) Object.hasOwnProperty.call(Y, he) && I.push(Y[he]);
        for (ae = g ? [_, W] : [W], ce = ee.length; ce--; ) E = ee[ce][0], R = ee[ce][1], J = q[E], I.sort(function(te, se) {
          return te.xValues[E] - se.xValues[E];
        }), ne = K(J), ae[0].splice(R, 0, ne), g && ae[1] && ae[1].splice(R, 0, ne), I.forEach(function(te) {
          let se = te.name;
          J && !x(se) && (J.dateTime ? (te.x instanceof Date && (te.x = te.x.getTime()), se = U.dateFormat(V.dateFormat, te.x)) : se = J.categories ? m(J.names[te.x], J.categories[te.x], te.x) : te.x), te.splice(R, 0, se);
        });
        return v(this, "exportData", { dataRows: ae = ae.concat(I) }), ae;
      }
      function y(g) {
        let E = (R) => {
          if (!R.tagName || R.tagName === "#text") return R.textContent || "";
          let L = R.attributes, U = `<${R.tagName}`;
          return L && Object.keys(L).forEach((V) => {
            let q = L[V];
            U += ` ${V}="${q}"`;
          }), U += ">" + (R.textContent || ""), (R.children || []).forEach((V) => {
            U += E(V);
          }), U += `</${R.tagName}>`;
        };
        return E(this.getTableAST(g));
      }
      function S(g) {
        let E = 0, R = [], L = this.options, U = g ? 1.1.toLocaleString()[1] : ".", V = m(L.exporting.useMultiLevelHeaders, !0), q = this.getDataRows(V), Y = V ? q.shift() : null, I = q.shift(), _ = function($, K) {
          let Q = $.length;
          if (K.length !== Q) return !1;
          for (; Q--; ) if ($[Q] !== K[Q]) return !1;
          return !0;
        }, W = function($, K, Q, Z) {
          let ee = m(Z, ""), J = "highcharts-text" + (K ? " " + K : "");
          return typeof ee == "number" ? (ee = ee.toString(), U === "," && (ee = ee.replace(".", U)), J = "highcharts-number") : Z || (J = "highcharts-empty"), { tagName: $, attributes: Q = M({ class: J }, Q), textContent: ee };
        };
        L.exporting.tableCaption !== !1 && R.push({ tagName: "caption", attributes: { class: "highcharts-table-caption" }, textContent: m(L.exporting.tableCaption, L.title.text ? L.title.text : "Chart") });
        for (let $ = 0, K = q.length; $ < K; ++$) q[$].length > E && (E = q[$].length);
        R.push(function($, K, Q) {
          let Z = [], ee = 0, J = Q || K && K.length, ae, re = 0, ce;
          if (V && $ && K && !_($, K)) {
            let he = [];
            for (; ee < J; ++ee) if ((ae = $[ee]) === $[ee + 1]) ++re;
            else if (re) he.push(W("th", "highcharts-table-topheading", { scope: "col", colspan: re + 1 }, ae)), re = 0;
            else {
              ae === K[ee] ? L.exporting.useRowspanHeaders ? (ce = 2, delete K[ee]) : (ce = 1, K[ee] = "") : ce = 1;
              let ne = W("th", "highcharts-table-topheading", { scope: "col" }, ae);
              ce > 1 && ne.attributes && (ne.attributes.valign = "top", ne.attributes.rowspan = ce), he.push(ne);
            }
            Z.push({ tagName: "tr", children: he });
          }
          if (K) {
            let he = [];
            for (ee = 0, J = K.length; ee < J; ++ee) K[ee] !== void 0 && he.push(W("th", null, { scope: "col" }, K[ee]));
            Z.push({ tagName: "tr", children: he });
          }
          return { tagName: "thead", children: Z };
        }(Y, I, Math.max(E, I.length)));
        let X = [];
        q.forEach(function($) {
          let K = [];
          for (let Q = 0; Q < E; Q++) K.push(W(Q ? "td" : "th", null, Q ? {} : { scope: "row" }, $[Q]));
          X.push({ tagName: "tr", children: K });
        }), R.push({ tagName: "tbody", children: X });
        let z = { tree: { tagName: "table", id: `highcharts-data-table-${this.index}`, children: R } };
        return v(this, "aftergetTableAST", z), z.tree;
      }
      function d() {
        this.toggleDataTable(!1);
      }
      function s(g) {
        let E = (g = m(g, !this.isDataTableVisible)) && !this.dataTableDiv;
        if (E && (this.dataTableDiv = N.createElement("div"), this.dataTableDiv.className = "highcharts-data-table", this.renderTo.parentNode.insertBefore(this.dataTableDiv, this.renderTo.nextSibling)), this.dataTableDiv) {
          let q = this.dataTableDiv.style, Y = q.display;
          q.display = g ? "block" : "none", g ? (this.dataTableDiv.innerHTML = o.emptyHTML, new o([this.getTableAST()]).addToDOM(this.dataTableDiv), v(this, "afterViewData", { element: this.dataTableDiv, wasHidden: E || Y !== q.display })) : v(this, "afterHideData");
        }
        this.isDataTableVisible = g;
        let R = this.exportDivElements, L = this.options.exporting, U = L && L.buttons && L.buttons.contextButton.menuItems, V = this.options.lang;
        if (L && L.menuItemDefinitions && V && V.viewData && V.hideData && U && R) {
          let q = R[U.indexOf("viewData")];
          q && o.setElementHTML(q, this.isDataTableVisible ? V.hideData : V.viewData);
        }
      }
      function l() {
        this.toggleDataTable(!0);
      }
      function b(g, E) {
        let R = f.navigator, L = f.URL || f.webkitURL || f;
        try {
          if (R.msSaveOrOpenBlob && f.MSBlobBuilder) {
            let U = new f.MSBlobBuilder();
            return U.append(g), U.getBlob("image/svg+xml");
          }
          return L.createObjectURL(new f.Blob(["\uFEFF" + g], { type: E }));
        } catch {
        }
      }
      function u() {
        let g = this, E = g.dataTableDiv, R = (U, V) => U.children[V].textContent, L = (U, V) => (q, Y) => {
          let I, _;
          return I = R(V ? q : Y, U), _ = R(V ? Y : q, U), I === "" || _ === "" || isNaN(I) || isNaN(_) ? I.toString().localeCompare(_) : I - _;
        };
        if (E && g.options.exporting && g.options.exporting.allowTableSorting) {
          let U = E.querySelector("thead tr");
          U && U.childNodes.forEach((V) => {
            let q = V.closest("table");
            V.addEventListener("click", function() {
              let Y = [...E.querySelectorAll("tr:not(thead tr)")], I = [...V.parentNode.children];
              Y.sort(L(I.indexOf(V), g.ascendingOrderInTable = !g.ascendingOrderInTable)).forEach((_) => {
                q.appendChild(_);
              }), I.forEach((_) => {
                ["highcharts-sort-ascending", "highcharts-sort-descending"].forEach((W) => {
                  _.classList.contains(W) && _.classList.remove(W);
                });
              }), V.classList.add(g.ascendingOrderInTable ? "highcharts-sort-ascending" : "highcharts-sort-descending");
            });
          });
        }
      }
      function c() {
        this.options && this.options.exporting && this.options.exporting.showTable && !this.options.chart.forExport && this.viewData();
      }
      function h() {
        var g;
        (g = this.dataTableDiv) == null || g.remove();
      }
      return { compose: function(g, E) {
        let R = g.prototype;
        if (!R.getCSV) {
          let L = D().exporting;
          w(g, "afterViewData", u), w(g, "render", c), w(g, "destroy", h), R.downloadCSV = C, R.downloadXLS = H, R.getCSV = G, R.getDataRows = P, R.getTable = y, R.getTableAST = S, R.hideData = d, R.toggleDataTable = s, R.viewData = l, L && (M(L.menuItemDefinitions, { downloadCSV: { textKey: "downloadCSV", onclick: function() {
            this.downloadCSV();
          } }, downloadXLS: { textKey: "downloadXLS", onclick: function() {
            this.downloadXLS();
          } }, viewData: { textKey: "viewData", onclick: function() {
            A.call(this, this.toggleDataTable);
          } } }), L.buttons && L.buttons.contextButton.menuItems && L.buttons.contextButton.menuItems.push("separator", "downloadCSV", "downloadXLS", "viewData")), F(T);
          let { arearange: U, gantt: V, map: q, mapbubble: Y, treemap: I, xrange: _ } = E.types;
          U && (U.prototype.keyToAxis = { low: "y", high: "y" }), V && (V.prototype.exportKey = "name", V.prototype.keyToAxis = { start: "x", end: "x" }), q && (q.prototype.exportKey = "name"), Y && (Y.prototype.exportKey = "name"), I && (I.prototype.exportKey = "name"), _ && (_.prototype.keyToAxis = { x2: "x" });
        }
      } };
    }), a(e, "masters/modules/export-data.src.js", [e["Core/Globals.js"], e["Extensions/DownloadURL.js"], e["Extensions/ExportData/ExportData.js"]], function(o, n, r) {
      return o.dataURLtoBlob = o.dataURLtoBlob || n.dataURLtoBlob, o.downloadURL = o.downloadURL || n.downloadURL, r.compose(o.Chart, o.Series), o;
    });
  });
})(ef);
var nC = ef.exports;
const rC = /* @__PURE__ */ fi(nC);
var tf = { exports: {} };
(function(i) {
  /**
  * Highcharts JS v11.4.8 (2024-08-29)
  *
  * Exporting module
  *
  * (c) 2010-2024 Torstein Honsi
  *
  * License: www.highcharts.com/license
  */
  (function(t) {
    i.exports ? (t.default = t, i.exports = t) : t(typeof Highcharts < "u" ? Highcharts : void 0);
  })(function(t) {
    var e = t ? t._modules : {};
    function a(o, n, r, T) {
      o.hasOwnProperty(n) || (o[n] = T.apply(null, r), typeof CustomEvent == "function" && t.win.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", { detail: { path: n, module: o[n] } })));
    }
    a(e, "Core/Chart/ChartNavigationComposition.js", [], function() {
      var o;
      return function(n) {
        n.compose = function(T) {
          return T.navigation || (T.navigation = new r(T)), T;
        };
        class r {
          constructor(O) {
            this.updates = [], this.chart = O;
          }
          addUpdate(O) {
            this.chart.navigation.updates.push(O);
          }
          update(O, j) {
            this.updates.forEach((D) => {
              D.call(this.chart, O, j);
            });
          }
        }
        n.Additions = r;
      }(o || (o = {})), o;
    }), a(e, "Extensions/Exporting/ExportingDefaults.js", [e["Core/Globals.js"]], function(o) {
      let { isTouchDevice: n } = o;
      return { exporting: { allowTableSorting: !0, type: "image/png", url: "https://export.highcharts.com/", pdfFont: { normal: void 0, bold: void 0, bolditalic: void 0, italic: void 0 }, printMaxWidth: 780, scale: 2, buttons: { contextButton: { className: "highcharts-contextbutton", menuClassName: "highcharts-contextmenu", symbol: "menu", titleKey: "contextButtonTitle", menuItems: ["viewFullscreen", "printChart", "separator", "downloadPNG", "downloadJPEG", "downloadPDF", "downloadSVG"] } }, menuItemDefinitions: { viewFullscreen: { textKey: "viewFullscreen", onclick: function() {
        this.fullscreen && this.fullscreen.toggle();
      } }, printChart: { textKey: "printChart", onclick: function() {
        this.print();
      } }, separator: { separator: !0 }, downloadPNG: { textKey: "downloadPNG", onclick: function() {
        this.exportChart();
      } }, downloadJPEG: { textKey: "downloadJPEG", onclick: function() {
        this.exportChart({ type: "image/jpeg" });
      } }, downloadPDF: { textKey: "downloadPDF", onclick: function() {
        this.exportChart({ type: "application/pdf" });
      } }, downloadSVG: { textKey: "downloadSVG", onclick: function() {
        this.exportChart({ type: "image/svg+xml" });
      } } } }, lang: { viewFullscreen: "View in full screen", exitFullscreen: "Exit from full screen", printChart: "Print chart", downloadPNG: "Download PNG image", downloadJPEG: "Download JPEG image", downloadPDF: "Download PDF document", downloadSVG: "Download SVG vector image", contextButtonTitle: "Chart context menu" }, navigation: { buttonOptions: { symbolSize: 14, symbolX: 14.5, symbolY: 13.5, align: "right", buttonSpacing: 3, height: 28, verticalAlign: "top", width: 28, symbolFill: "#666666", symbolStroke: "#666666", symbolStrokeWidth: 3, theme: { fill: "#ffffff", padding: 5, stroke: "none", "stroke-linecap": "round" } }, menuStyle: { border: "none", borderRadius: "3px", background: "#ffffff", padding: "0.5em" }, menuItemStyle: { background: "none", borderRadius: "3px", color: "#333333", padding: "0.5em", fontSize: n ? "0.9em" : "0.8em", transition: "background 250ms, color 250ms" }, menuItemHoverStyle: { background: "#f2f2f2" } } };
    }), a(e, "Extensions/Exporting/ExportingSymbols.js", [], function() {
      var o;
      return function(n) {
        let r = [];
        function T(j, D, F, B) {
          return [["M", j, D + 2.5], ["L", j + F, D + 2.5], ["M", j, D + B / 2 + 0.5], ["L", j + F, D + B / 2 + 0.5], ["M", j, D + B - 1.5], ["L", j + F, D + B - 1.5]];
        }
        function O(j, D, F, B) {
          let N = B / 3 - 2;
          return [].concat(this.circle(F - N, D, N, N), this.circle(F - N, D + N + 4, N, N), this.circle(F - N, D + 2 * (N + 4), N, N));
        }
        n.compose = function(j) {
          if (r.indexOf(j) === -1) {
            r.push(j);
            let D = j.prototype.symbols;
            D.menu = T, D.menuball = O.bind(D);
          }
        };
      }(o || (o = {})), o;
    }), a(e, "Extensions/Exporting/Fullscreen.js", [e["Core/Renderer/HTML/AST.js"], e["Core/Globals.js"], e["Core/Utilities.js"]], function(o, n, r) {
      let { composed: T } = n, { addEvent: O, fireEvent: j, pushUnique: D } = r;
      function F() {
        this.fullscreen = new B(this);
      }
      class B {
        static compose(f) {
          D(T, "Fullscreen") && O(f, "beforeRender", F);
        }
        constructor(f) {
          this.chart = f, this.isOpen = !1;
          let w = f.renderTo;
          !this.browserProps && (typeof w.requestFullscreen == "function" ? this.browserProps = { fullscreenChange: "fullscreenchange", requestFullscreen: "requestFullscreen", exitFullscreen: "exitFullscreen" } : w.mozRequestFullScreen ? this.browserProps = { fullscreenChange: "mozfullscreenchange", requestFullscreen: "mozRequestFullScreen", exitFullscreen: "mozCancelFullScreen" } : w.webkitRequestFullScreen ? this.browserProps = { fullscreenChange: "webkitfullscreenchange", requestFullscreen: "webkitRequestFullScreen", exitFullscreen: "webkitExitFullscreen" } : w.msRequestFullscreen && (this.browserProps = { fullscreenChange: "MSFullscreenChange", requestFullscreen: "msRequestFullscreen", exitFullscreen: "msExitFullscreen" }));
        }
        close() {
          let f = this, w = f.chart, x = w.options.chart;
          j(w, "fullscreenClose", null, function() {
            f.isOpen && f.browserProps && w.container.ownerDocument instanceof Document && w.container.ownerDocument[f.browserProps.exitFullscreen](), f.unbindFullscreenEvent && (f.unbindFullscreenEvent = f.unbindFullscreenEvent()), w.setSize(f.origWidth, f.origHeight, !1), f.origWidth = void 0, f.origHeight = void 0, x.width = f.origWidthOption, x.height = f.origHeightOption, f.origWidthOption = void 0, f.origHeightOption = void 0, f.isOpen = !1, f.setButtonText();
          });
        }
        open() {
          let f = this, w = f.chart, x = w.options.chart;
          j(w, "fullscreenOpen", null, function() {
            if (x && (f.origWidthOption = x.width, f.origHeightOption = x.height), f.origWidth = w.chartWidth, f.origHeight = w.chartHeight, f.browserProps) {
              let M = O(w.container.ownerDocument, f.browserProps.fullscreenChange, function() {
                f.isOpen ? (f.isOpen = !1, f.close()) : (w.setSize(null, null, !1), f.isOpen = !0, f.setButtonText());
              }), p = O(w, "destroy", M);
              f.unbindFullscreenEvent = () => {
                M(), p();
              };
              let v = w.renderTo[f.browserProps.requestFullscreen]();
              v && v.catch(function() {
                alert("Full screen is not supported inside a frame.");
              });
            }
          });
        }
        setButtonText() {
          let f = this.chart, w = f.exportDivElements, x = f.options.exporting, M = x && x.buttons && x.buttons.contextButton.menuItems, p = f.options.lang;
          if (x && x.menuItemDefinitions && p && p.exitFullscreen && p.viewFullscreen && M && w) {
            let v = w[M.indexOf("viewFullscreen")];
            v && o.setElementHTML(v, this.isOpen ? p.exitFullscreen : x.menuItemDefinitions.viewFullscreen.text || p.viewFullscreen);
          }
        }
        toggle() {
          this.isOpen ? this.close() : this.open();
        }
      }
      return B;
    }), a(e, "Core/HttpUtilities.js", [e["Core/Globals.js"], e["Core/Utilities.js"]], function(o, n) {
      let { win: r } = o, { discardElement: T, objectEach: O } = n, j = { ajax: function(D) {
        let F = { json: "application/json", xml: "application/xml", text: "text/plain", octet: "application/octet-stream" }, B = new XMLHttpRequest();
        function N(f, w) {
          D.error && D.error(f, w);
        }
        if (!D.url) return !1;
        B.open((D.type || "get").toUpperCase(), D.url, !0), D.headers && D.headers["Content-Type"] || B.setRequestHeader("Content-Type", F[D.dataType || "json"] || F.text), O(D.headers, function(f, w) {
          B.setRequestHeader(w, f);
        }), D.responseType && (B.responseType = D.responseType), B.onreadystatechange = function() {
          let f;
          if (B.readyState === 4) {
            if (B.status === 200) {
              if (D.responseType !== "blob" && (f = B.responseText, D.dataType === "json")) try {
                f = JSON.parse(f);
              } catch (w) {
                if (w instanceof Error) return N(B, w);
              }
              return D.success && D.success(f, B);
            }
            N(B, B.responseText);
          }
        }, D.data && typeof D.data != "string" && (D.data = JSON.stringify(D.data)), B.send(D.data);
      }, getJSON: function(D, F) {
        j.ajax({ url: D, success: F, dataType: "json", headers: { "Content-Type": "text/plain" } });
      }, post: function(D, F, B) {
        let N = new r.FormData();
        O(F, function(x, M) {
          N.append(M, x);
        }), N.append("b64", "true");
        let { filename: f, type: w } = F;
        return r.fetch(D, { method: "POST", body: N, ...B }).then((x) => {
          x.ok && x.text().then((M) => {
            let p = document.createElement("a");
            p.href = `data:${w};base64,${M}`, p.download = f, p.click(), T(p);
          });
        });
      } };
      return j;
    }), a(e, "Extensions/Exporting/Exporting.js", [e["Core/Renderer/HTML/AST.js"], e["Core/Chart/Chart.js"], e["Core/Chart/ChartNavigationComposition.js"], e["Core/Defaults.js"], e["Extensions/Exporting/ExportingDefaults.js"], e["Extensions/Exporting/ExportingSymbols.js"], e["Extensions/Exporting/Fullscreen.js"], e["Core/Globals.js"], e["Core/HttpUtilities.js"], e["Core/Utilities.js"]], function(o, n, r, T, O, j, D, F, B, N) {
      var f;
      let { defaultOptions: w } = T, { doc: x, SVG_NS: M, win: p } = F, { addEvent: v, css: k, createElement: m, discardElement: A, extend: C, find: H, fireEvent: G, isObject: P, merge: y, objectEach: S, pick: d, removeEvent: s, uniqueKey: l } = N;
      return function(b) {
        let u, c = [/-/, /^(clipPath|cssText|d|height|width)$/, /^font$/, /[lL]ogical(Width|Height)$/, /^parentRule$/, /^(cssRules|ownerRules)$/, /perspective/, /TapHighlightColor/, /^transition/, /^length$/, /^\d+$/], h = ["fill", "stroke", "strokeLinecap", "strokeLinejoin", "strokeWidth", "textAnchor", "x", "y"];
        b.inlineAllowlist = [];
        let g = ["clipPath", "defs", "desc"];
        function E(J) {
          let ae, re, ce = this, he = ce.renderer, ne = y(ce.options.navigation.buttonOptions, J), te = ne.onclick, se = ne.menuItems, oe = ne.symbolSize || 12;
          if (ce.btnCount || (ce.btnCount = 0), ce.exportDivElements || (ce.exportDivElements = [], ce.exportSVGElements = []), ne.enabled === !1 || !ne.theme) return;
          let ie = ce.styledMode ? {} : ne.theme;
          te ? re = function(de) {
            de && de.stopPropagation(), te.call(ce, de);
          } : se && (re = function(de) {
            de && de.stopPropagation(), ce.contextMenu(le.menuClassName, se, le.translateX || 0, le.translateY || 0, le.width || 0, le.height || 0, le), le.setState(2);
          }), ne.text && ne.symbol ? ie.paddingLeft = d(ie.paddingLeft, 30) : ne.text || C(ie, { width: ne.width, height: ne.height, padding: 0 });
          let le = he.button(ne.text, 0, 0, re, ie, void 0, void 0, void 0, void 0, ne.useHTML).addClass(J.className).attr({ title: d(ce.options.lang[ne._titleKey || ne.titleKey], "") });
          le.menuClassName = J.menuClassName || "highcharts-menu-" + ce.btnCount++, ne.symbol && (ae = he.symbol(ne.symbol, Math.round((ne.symbolX || 0) - oe / 2), Math.round((ne.symbolY || 0) - oe / 2), oe, oe, { width: oe, height: oe }).addClass("highcharts-button-symbol").attr({ zIndex: 1 }).add(le), ce.styledMode || ae.attr({ stroke: ne.symbolStroke, fill: ne.symbolFill, "stroke-width": ne.symbolStrokeWidth || 1 })), le.add(ce.exportingGroup).align(C(ne, { width: le.width, x: d(ne.x, ce.buttonOffset) }), !0, "spacingBox"), ce.buttonOffset += ((le.width || 0) + ne.buttonSpacing) * (ne.align === "right" ? -1 : 1), ce.exportSVGElements.push(le, ae);
        }
        function R() {
          if (!this.printReverseInfo) return;
          let { childNodes: J, origDisplay: ae, resetParams: re } = this.printReverseInfo;
          this.moveContainers(this.renderTo), [].forEach.call(J, function(ce, he) {
            ce.nodeType === 1 && (ce.style.display = ae[he] || "");
          }), this.isPrinting = !1, re && this.setSize.apply(this, re), delete this.printReverseInfo, u = void 0, G(this, "afterPrint");
        }
        function L() {
          var ce;
          let J = x.body, ae = this.options.exporting.printMaxWidth, re = { childNodes: J.childNodes, origDisplay: [], resetParams: void 0 };
          this.isPrinting = !0, (ce = this.pointer) == null || ce.reset(void 0, 0), G(this, "beforePrint"), ae && this.chartWidth > ae && (re.resetParams = [this.options.chart.width, void 0, !1], this.setSize(ae, void 0, !1)), [].forEach.call(re.childNodes, function(he, ne) {
            he.nodeType === 1 && (re.origDisplay[ne] = he.style.display, he.style.display = "none");
          }), this.moveContainers(J), this.printReverseInfo = re;
        }
        function U(J) {
          J.renderExporting(), v(J, "redraw", J.renderExporting), v(J, "destroy", J.destroyExport);
        }
        function V(J, ae, re, ce, he, ne, te) {
          var Ae, ye;
          let se = this, oe = se.options.navigation, ie = se.chartWidth, le = se.chartHeight, de = "cache-" + J, be = Math.max(he, ne), ge, me = se[de];
          me || (se.exportContextMenu = se[de] = me = m("div", { className: J }, { position: "absolute", zIndex: 1e3, padding: be + "px", pointerEvents: "auto", ...se.renderer.style }, ((Ae = se.scrollablePlotArea) == null ? void 0 : Ae.fixedDiv) || se.container), ge = m("ul", { className: "highcharts-menu" }, se.styledMode ? {} : { listStyle: "none", margin: 0, padding: 0 }, me), se.styledMode || k(ge, C({ MozBoxShadow: "3px 3px 10px #888", WebkitBoxShadow: "3px 3px 10px #888", boxShadow: "3px 3px 10px #888" }, oe.menuStyle)), me.hideMenu = function() {
            k(me, { display: "none" }), te && te.setState(0), se.openMenu = !1, k(se.renderTo, { overflow: "hidden" }), k(se.container, { overflow: "hidden" }), N.clearTimeout(me.hideTimer), G(se, "exportMenuHidden");
          }, se.exportEvents.push(v(me, "mouseleave", function() {
            me.hideTimer = p.setTimeout(me.hideMenu, 500);
          }), v(me, "mouseenter", function() {
            N.clearTimeout(me.hideTimer);
          }), v(x, "mouseup", function(xe) {
            var we;
            (we = se.pointer) != null && we.inClass(xe.target, J) || me.hideMenu();
          }), v(me, "click", function() {
            se.openMenu && me.hideMenu();
          })), ae.forEach(function(xe) {
            if (typeof xe == "string" && (xe = se.options.exporting.menuItemDefinitions[xe]), P(xe, !0)) {
              let we;
              xe.separator ? we = m("hr", void 0, void 0, ge) : (xe.textKey === "viewData" && se.isDataTableVisible && (xe.textKey = "hideData"), we = m("li", { className: "highcharts-menu-item", onclick: function(ke) {
                ke && ke.stopPropagation(), me.hideMenu(), typeof xe != "string" && xe.onclick && xe.onclick.apply(se, arguments);
              } }, void 0, ge), o.setElementHTML(we, xe.text || se.options.lang[xe.textKey]), se.styledMode || (we.onmouseover = function() {
                k(this, oe.menuItemHoverStyle);
              }, we.onmouseout = function() {
                k(this, oe.menuItemStyle);
              }, k(we, C({ cursor: "pointer" }, oe.menuItemStyle || {})))), se.exportDivElements.push(we);
            }
          }), se.exportDivElements.push(ge, me), se.exportMenuWidth = me.offsetWidth, se.exportMenuHeight = me.offsetHeight);
          let fe = { display: "block" };
          re + (se.exportMenuWidth || 0) > ie ? fe.right = ie - re - he - be + "px" : fe.left = re - be + "px", ce + ne + (se.exportMenuHeight || 0) > le && ((ye = te.alignOptions) == null ? void 0 : ye.verticalAlign) !== "top" ? fe.bottom = le - ce - be + "px" : fe.top = ce + ne - be + "px", k(me, fe), k(se.renderTo, { overflow: "" }), k(se.container, { overflow: "" }), se.openMenu = !0, G(se, "exportMenuShown");
        }
        function q(J) {
          let ae, re = J ? J.target : this, ce = re.exportSVGElements, he = re.exportDivElements, ne = re.exportEvents;
          ce && (ce.forEach((te, se) => {
            te && (te.onclick = te.ontouchstart = null, re[ae = "cache-" + te.menuClassName] && delete re[ae], ce[se] = te.destroy());
          }), ce.length = 0), re.exportingGroup && (re.exportingGroup.destroy(), delete re.exportingGroup), he && (he.forEach(function(te, se) {
            te && (N.clearTimeout(te.hideTimer), s(te, "mouseleave"), he[se] = te.onmouseout = te.onmouseover = te.ontouchstart = te.onclick = null, A(te));
          }), he.length = 0), ne && (ne.forEach(function(te) {
            te();
          }), ne.length = 0);
        }
        function Y(J, ae) {
          let re = this.getSVGForExport(J, ae);
          J = y(this.options.exporting, J), B.post(J.url, { filename: J.filename ? J.filename.replace(/\//g, "-") : this.getFilename(), type: J.type, width: J.width, scale: J.scale, svg: re }, J.fetchOptions);
        }
        function I() {
          return this.styledMode && this.inlineStyles(), this.container.innerHTML;
        }
        function _() {
          let J = this.userOptions.title && this.userOptions.title.text, ae = this.options.exporting.filename;
          return ae ? ae.replace(/\//g, "-") : (typeof J == "string" && (ae = J.toLowerCase().replace(/<\/?[^>]+(>|$)/g, "").replace(/[\s_]+/g, "-").replace(/[^a-z\d\-]/g, "").replace(/^[\-]+/g, "").replace(/[\-]+/g, "-").substr(0, 24).replace(/[\-]+$/g, "")), (!ae || ae.length < 5) && (ae = "chart"), ae);
        }
        function W(J) {
          let ae, re, ce = y(this.options, J);
          ce.plotOptions = y(this.userOptions.plotOptions, J && J.plotOptions), ce.time = y(this.userOptions.time, J && J.time);
          let he = m("div", null, { position: "absolute", top: "-9999em", width: this.chartWidth + "px", height: this.chartHeight + "px" }, x.body), ne = this.renderTo.style.width, te = this.renderTo.style.height, se = ce.exporting.sourceWidth || ce.chart.width || /px$/.test(ne) && parseInt(ne, 10) || (ce.isGantt ? 800 : 600), oe = ce.exporting.sourceHeight || ce.chart.height || /px$/.test(te) && parseInt(te, 10) || 400;
          C(ce.chart, { animation: !1, renderTo: he, forExport: !0, renderer: "SVGRenderer", width: se, height: oe }), ce.exporting.enabled = !1, delete ce.data, ce.series = [], this.series.forEach(function(de) {
            (re = y(de.userOptions, { animation: !1, enableMouseTracking: !1, showCheckbox: !1, visible: de.visible })).isInternal || ce.series.push(re);
          });
          let ie = {};
          this.axes.forEach(function(de) {
            de.userOptions.internalKey || (de.userOptions.internalKey = l()), de.options.isInternal || (ie[de.coll] || (ie[de.coll] = !0, ce[de.coll] = []), ce[de.coll].push(y(de.userOptions, { visible: de.visible, type: de.type, uniqueNames: de.uniqueNames })));
          }), ce.colorAxis = this.userOptions.colorAxis;
          let le = new this.constructor(ce, this.callback);
          return J && ["xAxis", "yAxis", "series"].forEach(function(de) {
            let be = {};
            J[de] && (be[de] = J[de], le.update(be));
          }), this.axes.forEach(function(de) {
            let be = H(le.axes, function(Ae) {
              return Ae.options.internalKey === de.userOptions.internalKey;
            }), ge = de.getExtremes(), me = ge.userMin, fe = ge.userMax;
            be && (me !== void 0 && me !== be.min || fe !== void 0 && fe !== be.max) && be.setExtremes(me, fe, !0, !1);
          }), ae = le.getChartHTML(), G(this, "getSVG", { chartCopy: le }), ae = this.sanitizeSVG(ae, ce), ce = null, le.destroy(), A(he), ae;
        }
        function X(J, ae) {
          let re = this.options.exporting;
          return this.getSVG(y({ chart: { borderRadius: 0 } }, re.chartOptions, ae, { exporting: { sourceWidth: J && J.sourceWidth || re.sourceWidth, sourceHeight: J && J.sourceHeight || re.sourceHeight } }));
        }
        function z() {
          let J, ae = b.inlineAllowlist, re = {}, ce = x.createElement("iframe");
          k(ce, { width: "1px", height: "1px", visibility: "hidden" }), x.body.appendChild(ce);
          let he = ce.contentWindow && ce.contentWindow.document;
          he && he.body.appendChild(he.createElementNS(M, "svg")), function ne(te) {
            let se, oe, ie, le, de, be, ge = {};
            if (he && te.nodeType === 1 && g.indexOf(te.nodeName) === -1) {
              if (se = p.getComputedStyle(te, null), oe = te.nodeName === "svg" ? {} : p.getComputedStyle(te.parentNode, null), !re[te.nodeName]) {
                J = he.getElementsByTagName("svg")[0], ie = he.createElementNS(te.namespaceURI, te.nodeName), J.appendChild(ie);
                let me = p.getComputedStyle(ie, null), fe = {};
                for (let Ae in me) Ae.length < 1e3 && typeof me[Ae] == "string" && !/^\d+$/.test(Ae) && (fe[Ae] = me[Ae]);
                re[te.nodeName] = fe, te.nodeName === "text" && delete re.text.fill, J.removeChild(ie);
              }
              for (let me in se) (F.isFirefox || F.isMS || F.isSafari || Object.hasOwnProperty.call(se, me)) && function(fe, Ae) {
                if (le = de = !1, ae.length) {
                  for (be = ae.length; be-- && !de; ) de = ae[be].test(Ae);
                  le = !de;
                }
                for (Ae === "transform" && fe === "none" && (le = !0), be = c.length; be-- && !le; ) {
                  if (Ae.length > 1e3) throw Error("Input too long");
                  le = c[be].test(Ae) || typeof fe == "function";
                }
                !le && (oe[Ae] !== fe || te.nodeName === "svg") && re[te.nodeName][Ae] !== fe && (h && h.indexOf(Ae) === -1 ? ge[Ae] = fe : fe && te.setAttribute(Ae.replace(/[A-Z]/g, function(ye) {
                  return "-" + ye.toLowerCase();
                }), fe));
              }(se[me], me);
              if (k(te, ge), te.nodeName === "svg" && te.setAttribute("stroke-width", "1px"), te.nodeName === "text") return;
              [].forEach.call(te.children || te.childNodes, ne);
            }
          }(this.container.querySelector("svg")), J.parentNode.removeChild(J), ce.parentNode.removeChild(ce);
        }
        function $(J) {
          let { scrollablePlotArea: ae } = this;
          (ae ? [ae.fixedDiv, ae.scrollingContainer] : [this.container]).forEach(function(re) {
            J.appendChild(re);
          });
        }
        function K() {
          let J = this, ae = (re, ce, he) => {
            J.isDirtyExporting = !0, y(!0, J.options[re], ce), d(he, !0) && J.redraw();
          };
          J.exporting = { update: function(re, ce) {
            ae("exporting", re, ce);
          } }, r.compose(J).navigation.addUpdate((re, ce) => {
            ae("navigation", re, ce);
          });
        }
        function Q() {
          let J = this;
          J.isPrinting || (u = J, F.isSafari || J.beforePrint(), setTimeout(() => {
            p.focus(), p.print(), F.isSafari || setTimeout(() => {
              J.afterPrint();
            }, 1e3);
          }, 1));
        }
        function Z() {
          let J = this, ae = J.options.exporting, re = ae.buttons, ce = J.isDirtyExporting || !J.exportSVGElements;
          J.buttonOffset = 0, J.isDirtyExporting && J.destroyExport(), ce && ae.enabled !== !1 && (J.exportEvents = [], J.exportingGroup = J.exportingGroup || J.renderer.g("exporting-group").attr({ zIndex: 3 }).add(), S(re, function(he) {
            J.addButton(he);
          }), J.isDirtyExporting = !1);
        }
        function ee(J, ae) {
          let re = J.indexOf("</svg>") + 6, ce = J.substr(re);
          return J = J.substr(0, re), ae && ae.exporting && ae.exporting.allowHTML && ce && (ce = '<foreignObject x="0" y="0" width="' + ae.chart.width + '" height="' + ae.chart.height + '"><body xmlns="http://www.w3.org/1999/xhtml">' + ce.replace(/(<(?:img|br).*?(?=\>))>/g, "$1 />") + "</body></foreignObject>", J = J.replace("</svg>", ce + "</svg>")), J = J.replace(/zIndex="[^"]+"/g, "").replace(/symbolName="[^"]+"/g, "").replace(/jQuery\d+="[^"]+"/g, "").replace(/url\(("|&quot;)(.*?)("|&quot;)\;?\)/g, "url($2)").replace(/url\([^#]+#/g, "url(#").replace(/<svg /, '<svg xmlns:xlink="http://www.w3.org/1999/xlink" ').replace(/ (NS\d+\:)?href=/g, " xlink:href=").replace(/\n+/g, " ").replace(/(fill|stroke)="rgba\(([ \d]+,[ \d]+,[ \d]+),([ \d\.]+)\)"/g, '$1="rgb($2)" $1-opacity="$3"').replace(/&nbsp;/g, " ").replace(/&shy;/g, "­");
        }
        b.compose = function(J, ae) {
          j.compose(ae), D.compose(J);
          let re = J.prototype;
          re.exportChart || (re.afterPrint = R, re.exportChart = Y, re.inlineStyles = z, re.print = Q, re.sanitizeSVG = ee, re.getChartHTML = I, re.getSVG = W, re.getSVGForExport = X, re.getFilename = _, re.moveContainers = $, re.beforePrint = L, re.contextMenu = V, re.addButton = E, re.destroyExport = q, re.renderExporting = Z, re.callbacks.push(U), v(J, "init", K), F.isSafari && p.matchMedia("print").addListener(function(ce) {
            u && (ce.matches ? u.beforePrint() : u.afterPrint());
          }), w.exporting = y(O.exporting, w.exporting), w.lang = y(O.lang, w.lang), w.navigation = y(O.navigation, w.navigation));
        };
      }(f || (f = {})), f;
    }), a(e, "masters/modules/exporting.src.js", [e["Core/Globals.js"], e["Extensions/Exporting/Exporting.js"], e["Core/HttpUtilities.js"]], function(o, n, r) {
      return o.HttpUtilities = o.HttpUtilities || r, o.ajax = o.HttpUtilities.ajax, o.getJSON = o.HttpUtilities.getJSON, o.post = o.HttpUtilities.post, n.compose(o.Chart, o.Renderer), o;
    });
  });
})(tf);
var sC = tf.exports;
const lC = /* @__PURE__ */ fi(sC);
var cC = Object.defineProperty, dC = Object.getOwnPropertyDescriptor, ad = (i, t, e, a) => {
  for (var o = a > 1 ? void 0 : a ? dC(t, e) : t, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = (a ? r(t, e, o) : r(o)) || o);
  return a && o && cC(t, e, o), o;
};
function hC(i) {
  return !!(i.custom && i.custom.tableElement);
}
function un(i) {
  let t = class extends i {
    constructor() {
      super(...arguments), this.tableId = void 0, this.disableExporting = !1;
    }
    get localComponentOptions() {
      var e, a;
      return ct.createChartOptions(super.localComponentOptions, {
        data: {
          table: this.tableId
        },
        exporting: {
          buttons: {
            contextButton: {
              menuItems: this.tableId ? t.exportMenuItemsLimited : t.exportMenuItemsDefault
            }
          },
          chartOptions: {
            chart: {
              styledMode: !1
              // Turned off because the exported images don't know the styles we apply
            }
          },
          enabled: !this.disableExporting,
          sourceHeight: (e = this.chartSize) == null ? void 0 : e.chartHeight,
          sourceWidth: (a = this.chartSize) == null ? void 0 : a.chartWidth
        },
        plotOptions: {
          custom: {
            tableElement: this.getScopedTagName("beacon-table")
          }
        }
      });
    }
    initializeHighcharts(e) {
      super.initializeHighcharts(e), lC(e), rC(e), iC(e), e.addEvent(e.Chart, "afterViewData", function() {
        const a = this, o = a.dataTableDiv.querySelector("table");
        if (!o) return;
        const {
          userOptions: { plotOptions: n }
        } = a;
        if (n && hC(n)) {
          const r = document.createElement(
            n.custom.tableElement
          );
          a.dataTableDiv.appendChild(r), r.appendChild(o);
        }
      });
    }
    willUpdate(e) {
      var a, o;
      (a = super.willUpdate) == null || a.call(this, e), e.has("disableExporting") && ((o = this.chart) == null || o.update({
        exporting: {
          enabled: !this.disableExporting
        }
      }));
    }
  };
  return t.exportMenuItemsDefault = [
    "viewFullscreen",
    "separator",
    "downloadCSV",
    "viewData"
  ], t.exportMenuItemsLimited = [
    "viewFullscreen",
    "separator",
    "downloadCSV"
  ], ad([
    ue({ attribute: "table-id" })
  ], t.prototype, "tableId", 2), ad([
    ue({ type: Boolean, attribute: "disable-exporting" })
  ], t.prototype, "disableExporting", 2), t = ad([
    je("Exporting")
  ], t), t;
}
var of = { exports: {} };
(function(i) {
  /**
  * Highstock JS v11.4.8 (2024-08-29)
  *
  * Highcharts Stock as a plugin for Highcharts
  *
  * (c) 2010-2024 Torstein Honsi
  *
  * License: www.highcharts.com/license
  */
  (function(t) {
    i.exports ? (t.default = t, i.exports = t) : t(typeof Highcharts < "u" ? Highcharts : void 0);
  })(function(t) {
    var e = t ? t._modules : {};
    function a(o, n, r, T) {
      o.hasOwnProperty(n) || (o[n] = T.apply(null, r), typeof CustomEvent == "function" && t.win.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", { detail: { path: n, module: o[n] } })));
    }
    a(e, "Series/DataModifyComposition.js", [e["Core/Axis/Axis.js"], e["Core/Series/Point.js"], e["Core/Series/Series.js"], e["Core/Utilities.js"]], function(o, n, r, T) {
      var O;
      let { tooltipFormatter: j } = n.prototype, { addEvent: D, arrayMax: F, arrayMin: B, correctFloat: N, defined: f, isArray: w, isNumber: x, isString: M, pick: p } = T;
      return function(v) {
        function k(s, l, b) {
          !this.isXAxis && (this.series.forEach(function(u) {
            s === "compare" && typeof l != "boolean" ? u.setCompare(l, !1) : s !== "cumulative" || M(l) || u.setCumulative(l, !1);
          }), p(b, !0) && this.chart.redraw());
        }
        function m(s) {
          let l = this, { numberFormatter: b } = l.series.chart, u = function(c) {
            s = s.replace("{point." + c + "}", (l[c] > 0 && c === "change" ? "+" : "") + b(l[c], p(l.series.tooltipOptions.changeDecimals, 2)));
          };
          return f(l.change) && u("change"), f(l.cumulativeSum) && u("cumulativeSum"), j.apply(this, [s]);
        }
        function A() {
          let s, l = this.options.compare;
          (l === "percent" || l === "value" || this.options.cumulative) && (s = new d(this), l === "percent" || l === "value" ? s.initCompare(l) : s.initCumulative()), this.dataModify = s;
        }
        function C(s) {
          let l = s.dataExtremes, b = l.activeYData;
          if (this.dataModify && l) {
            let u;
            this.options.compare ? u = [this.dataModify.modifyValue(l.dataMin), this.dataModify.modifyValue(l.dataMax)] : this.options.cumulative && w(b) && b.length >= 2 && (u = d.getCumulativeExtremes(b)), u && (l.dataMin = B(u), l.dataMax = F(u));
          }
        }
        function H(s, l) {
          this.options.compare = this.userOptions.compare = s, this.update({}, p(l, !0)), this.dataModify && (s === "value" || s === "percent") ? this.dataModify.initCompare(s) : this.points.forEach((b) => {
            delete b.change;
          });
        }
        function G() {
          if (this.xAxis && this.processedYData && this.dataModify) {
            let s = this.processedXData, l = this.processedYData, b = l.length, u = this.options.compareStart === !0 ? 0 : 1, c = -1, h;
            for (this.pointArrayMap && (c = this.pointArrayMap.indexOf(this.options.pointValKey || this.pointValKey || "y")), h = 0; h < b - u; h++) {
              let g = l[h] && c > -1 ? l[h][c] : l[h];
              if (x(g) && g !== 0 && s[h + u] >= (this.xAxis.min || 0)) {
                this.dataModify.compareValue = g;
                break;
              }
            }
          }
        }
        function P(s, l) {
          this.setModifier("compare", s, l);
        }
        function y(s, l) {
          s = p(s, !1), this.options.cumulative = this.userOptions.cumulative = s, this.update({}, p(l, !0)), this.dataModify ? this.dataModify.initCumulative() : this.points.forEach((b) => {
            delete b.cumulativeSum;
          });
        }
        function S(s, l) {
          this.setModifier("cumulative", s, l);
        }
        v.compose = function(s, l, b) {
          let u = l.prototype, c = b.prototype, h = s.prototype;
          return h.setCompare || (h.setCompare = H, h.setCumulative = y, D(s, "afterInit", A), D(s, "afterGetExtremes", C), D(s, "afterProcessData", G)), u.setCompare || (u.setCompare = P, u.setModifier = k, u.setCumulative = S, c.tooltipFormatter = m), s;
        };
        class d {
          constructor(l) {
            this.series = l;
          }
          modifyValue() {
            return 0;
          }
          static getCumulativeExtremes(l) {
            let b = 1 / 0, u = -1 / 0;
            return l.reduce((c, h) => {
              let g = c + h;
              return b = Math.min(b, g, c), u = Math.max(u, g, c), g;
            }), [b, u];
          }
          initCompare(l) {
            this.modifyValue = function(b, u) {
              b === null && (b = 0);
              let c = this.compareValue;
              if (b !== void 0 && c !== void 0) {
                if (l === "value" ? b -= c : b = b / c * 100 - (this.series.options.compareBase === 100 ? 0 : 100), u !== void 0) {
                  let h = this.series.points[u];
                  h && (h.change = b);
                }
                return b;
              }
              return 0;
            };
          }
          initCumulative() {
            this.modifyValue = function(l, b) {
              if (l === null && (l = 0), l !== void 0 && b !== void 0) {
                let u = b > 0 ? this.series.points[b - 1] : null;
                u && u.cumulativeSum && (l = N(u.cumulativeSum + l));
                let c = this.series.points[b], h = c.series.options.cumulativeStart, g = c.x <= this.series.xAxis.max && c.x >= this.series.xAxis.min;
                return c && (!h || g ? c.cumulativeSum = l : c.cumulativeSum = void 0), l;
              }
              return 0;
            };
          }
        }
        v.Additions = d;
      }(O || (O = {})), O;
    }), a(e, "Stock/Navigator/ChartNavigatorComposition.js", [e["Core/Globals.js"], e["Core/Utilities.js"]], function(o, n) {
      let r, { isTouchDevice: T } = o, { addEvent: O, merge: j, pick: D } = n, F = [];
      function B() {
        this.navigator && this.navigator.setBaseSeries(null, !1);
      }
      function N() {
        var H;
        let v, k, m, A = this.legend, C = this.navigator;
        if (C) {
          v = A && A.options, k = C.xAxis, m = C.yAxis;
          let { scrollbarHeight: G, scrollButtonSize: P } = C;
          this.inverted ? (C.left = C.opposite ? this.chartWidth - G - C.height : this.spacing[3] + G, C.top = this.plotTop + P) : (C.left = D(k.left, this.plotLeft + P), C.top = C.navigatorOptions.top || this.chartHeight - C.height - G - (((H = this.scrollbar) == null ? void 0 : H.options.margin) || 0) - this.spacing[2] - (this.rangeSelector && this.extraBottomMargin ? this.rangeSelector.getHeight() : 0) - (v && v.verticalAlign === "bottom" && v.layout !== "proximate" && v.enabled && !v.floating ? A.legendHeight + D(v.margin, 10) : 0) - (this.titleOffset ? this.titleOffset[2] : 0)), k && m && (this.inverted ? k.options.left = m.options.left = C.left : k.options.top = m.options.top = C.top, k.setAxisSize(), m.setAxisSize());
        }
      }
      function f(v) {
        !this.navigator && !this.scroller && (this.options.navigator.enabled || this.options.scrollbar.enabled) && (this.scroller = this.navigator = new r(this), D(v.redraw, !0) && this.redraw(v.animation));
      }
      function w() {
        let v = this.options;
        (v.navigator.enabled || v.scrollbar.enabled) && (this.scroller = this.navigator = new r(this));
      }
      function x() {
        let v = this.options, k = v.navigator, m = v.rangeSelector;
        if ((k && k.enabled || m && m.enabled) && (!T && this.zooming.type === "x" || T && this.zooming.pinchType === "x")) return !1;
      }
      function M(v) {
        let k = v.navigator;
        if (k && v.xAxis[0]) {
          let m = v.xAxis[0].getExtremes();
          k.render(m.min, m.max);
        }
      }
      function p(v) {
        let k = v.options.navigator || {}, m = v.options.scrollbar || {};
        !this.navigator && !this.scroller && (k.enabled || m.enabled) && (j(!0, this.options.navigator, k), j(!0, this.options.scrollbar, m), delete v.options.navigator, delete v.options.scrollbar);
      }
      return { compose: function(v, k) {
        if (n.pushUnique(F, v)) {
          let m = v.prototype;
          r = k, m.callbacks.push(M), O(v, "afterAddSeries", B), O(v, "afterSetChartSize", N), O(v, "afterUpdate", f), O(v, "beforeRender", w), O(v, "beforeShowResetZoom", x), O(v, "update", p);
        }
      } };
    }), a(e, "Core/Axis/NavigatorAxisComposition.js", [e["Core/Globals.js"], e["Core/Utilities.js"]], function(o, n) {
      let { isTouchDevice: r } = o, { addEvent: T, correctFloat: O, defined: j, isNumber: D, pick: F } = n;
      function B() {
        this.navigatorAxis || (this.navigatorAxis = new f(this));
      }
      function N(w) {
        let x, M = this.chart, p = M.options, v = p.navigator, k = this.navigatorAxis, m = M.zooming.pinchType, A = p.rangeSelector, C = M.zooming.type;
        if (this.isXAxis && (v != null && v.enabled || A != null && A.enabled)) {
          if (C === "y" && w.trigger === "zoom") x = !1;
          else if ((w.trigger === "zoom" && C === "xy" || r && m === "xy") && this.options.range) {
            let H = k.previousZoom;
            j(w.min) ? k.previousZoom = [this.min, this.max] : H && (w.min = H[0], w.max = H[1], k.previousZoom = void 0);
          }
        }
        x !== void 0 && w.preventDefault();
      }
      class f {
        static compose(x) {
          x.keepProps.includes("navigatorAxis") || (x.keepProps.push("navigatorAxis"), T(x, "init", B), T(x, "setExtremes", N));
        }
        constructor(x) {
          this.axis = x;
        }
        destroy() {
          this.axis = void 0;
        }
        toFixedRange(x, M, p, v) {
          let k = this.axis, m = (k.pointRange || 0) / 2, A = F(p, k.translate(x, !0, !k.horiz)), C = F(v, k.translate(M, !0, !k.horiz));
          return j(p) || (A = O(A + m)), j(v) || (C = O(C - m)), D(A) && D(C) || (A = C = void 0), { min: A, max: C };
        }
      }
      return f;
    }), a(e, "Stock/Navigator/NavigatorDefaults.js", [e["Core/Color/Color.js"], e["Core/Series/SeriesRegistry.js"]], function(o, n) {
      let { parse: r } = o, { seriesTypes: T } = n;
      return { height: 40, margin: 25, maskInside: !0, handles: { width: 7, borderRadius: 0, height: 15, symbols: ["navigator-handle", "navigator-handle"], enabled: !0, lineWidth: 1, backgroundColor: "#f2f2f2", borderColor: "#999999" }, maskFill: r("#667aff").setOpacity(0.3).get(), outlineColor: "#999999", outlineWidth: 1, series: { type: T.areaspline === void 0 ? "line" : "areaspline", fillOpacity: 0.05, lineWidth: 1, compare: null, sonification: { enabled: !1 }, dataGrouping: { approximation: "average", enabled: !0, groupPixelWidth: 2, firstAnchor: "firstPoint", anchor: "middle", lastAnchor: "lastPoint", units: [["millisecond", [1, 2, 5, 10, 20, 25, 50, 100, 200, 500]], ["second", [1, 2, 5, 10, 15, 30]], ["minute", [1, 2, 5, 10, 15, 30]], ["hour", [1, 2, 3, 4, 6, 8, 12]], ["day", [1, 2, 3, 4]], ["week", [1, 2, 3]], ["month", [1, 3, 6]], ["year", null]] }, dataLabels: { enabled: !1, zIndex: 2 }, id: "highcharts-navigator-series", className: "highcharts-navigator-series", lineColor: null, marker: { enabled: !1 }, threshold: null }, xAxis: { className: "highcharts-navigator-xaxis", tickLength: 0, lineWidth: 0, gridLineColor: "#e6e6e6", id: "navigator-x-axis", gridLineWidth: 1, tickPixelInterval: 200, labels: { align: "left", style: { color: "#000000", fontSize: "0.7em", opacity: 0.6, textOutline: "2px contrast" }, x: 3, y: -4 }, crosshair: !1 }, yAxis: { className: "highcharts-navigator-yaxis", gridLineWidth: 0, startOnTick: !1, endOnTick: !1, minPadding: 0.1, id: "navigator-y-axis", maxPadding: 0.1, labels: { enabled: !1 }, crosshair: !1, title: { text: null }, tickLength: 0, tickWidth: 0 } };
    }), a(e, "Stock/Navigator/NavigatorSymbols.js", [e["Core/Renderer/SVG/Symbols.js"], e["Core/Utilities.js"]], function(o, n) {
      let { relativeLength: r } = n;
      return { "navigator-handle": function(T, O, j, D, F = {}) {
        let B = F.width ? F.width / 2 : j, N = r(F.borderRadius || 0, Math.min(2 * B, D));
        return [["M", -1.5, (D = F.height || D) / 2 - 3.5], ["L", -1.5, D / 2 + 4.5], ["M", 0.5, D / 2 - 3.5], ["L", 0.5, D / 2 + 4.5], ...o.rect(-B - 1, 0.5, 2 * B + 1, D, { r: N })];
      } };
    }), a(e, "Stock/Utilities/StockUtilities.js", [e["Core/Utilities.js"]], function(o) {
      let { defined: n } = o;
      return { setFixedRange: function(r) {
        let T = this.xAxis[0];
        n(T.dataMax) && n(T.dataMin) && r ? this.fixedRange = Math.min(r, T.dataMax - T.dataMin) : this.fixedRange = r;
      } };
    }), a(e, "Stock/Navigator/NavigatorComposition.js", [e["Core/Defaults.js"], e["Core/Globals.js"], e["Core/Axis/NavigatorAxisComposition.js"], e["Stock/Navigator/NavigatorDefaults.js"], e["Stock/Navigator/NavigatorSymbols.js"], e["Core/Renderer/RendererRegistry.js"], e["Stock/Utilities/StockUtilities.js"], e["Core/Utilities.js"]], function(o, n, r, T, O, j, D, F) {
      let { setOptions: B } = o, { composed: N } = n, { getRendererType: f } = j, { setFixedRange: w } = D, { addEvent: x, extend: M, pushUnique: p } = F;
      function v() {
        this.chart.navigator && !this.options.isInternal && this.chart.navigator.setBaseSeries(null, !1);
      }
      return { compose: function(k, m, A) {
        r.compose(m), p(N, "Navigator") && (k.prototype.setFixedRange = w, M(f().prototype.symbols, O), x(A, "afterUpdate", v), B({ navigator: T }));
      } };
    }), a(e, "Core/Axis/ScrollbarAxis.js", [e["Core/Globals.js"], e["Core/Utilities.js"]], function(o, n) {
      var r;
      let { composed: T } = o, { addEvent: O, defined: j, pick: D, pushUnique: F } = n;
      return function(B) {
        let N;
        function f(p) {
          let v = D(p.options && p.options.min, p.min), k = D(p.options && p.options.max, p.max);
          return { axisMin: v, axisMax: k, scrollMin: j(p.dataMin) ? Math.min(v, p.min, p.dataMin, D(p.threshold, 1 / 0)) : v, scrollMax: j(p.dataMax) ? Math.max(k, p.max, p.dataMax, D(p.threshold, -1 / 0)) : k };
        }
        function w() {
          let p = this.scrollbar, v = p && !p.options.opposite, k = this.horiz ? 2 : v ? 3 : 1;
          p && (this.chart.scrollbarsOffsets = [0, 0], this.chart.axisOffset[k] += p.size + (p.options.margin || 0));
        }
        function x() {
          let p = this;
          p.options && p.options.scrollbar && p.options.scrollbar.enabled && (p.options.scrollbar.vertical = !p.horiz, p.options.startOnTick = p.options.endOnTick = !1, p.scrollbar = new N(p.chart.renderer, p.options.scrollbar, p.chart), O(p.scrollbar, "changed", function(v) {
            let k, m, { axisMin: A, axisMax: C, scrollMin: H, scrollMax: G } = f(p), P = G - H;
            if (j(A) && j(C))
              if (p.horiz && !p.reversed || !p.horiz && p.reversed ? (k = H + P * this.to, m = H + P * this.from) : (k = H + P * (1 - this.from), m = H + P * (1 - this.to)), this.shouldUpdateExtremes(v.DOMType)) {
                let y = v.DOMType !== "mousemove" && v.DOMType !== "touchmove" && void 0;
                p.setExtremes(m, k, !0, y, v);
              } else this.setRange(this.from, this.to);
          }));
        }
        function M() {
          let p, v, k, { scrollMin: m, scrollMax: A } = f(this), C = this.scrollbar, H = this.axisTitleMargin + (this.titleOffset || 0), G = this.chart.scrollbarsOffsets, P = this.options.margin || 0;
          if (C && G) {
            if (this.horiz) this.opposite || (G[1] += H), C.position(this.left, this.top + this.height + 2 + G[1] - (this.opposite ? P : 0), this.width, this.height), this.opposite || (G[1] += P), p = 1;
            else {
              let y;
              this.opposite && (G[0] += H), y = C.options.opposite ? this.left + this.width + 2 + G[0] - (this.opposite ? 0 : P) : this.opposite ? 0 : P, C.position(y, this.top, this.width, this.height), this.opposite && (G[0] += P), p = 0;
            }
            if (G[p] += C.size + (C.options.margin || 0), isNaN(m) || isNaN(A) || !j(this.min) || !j(this.max) || this.dataMin === this.dataMax) C.setRange(0, 1);
            else if (this.min === this.max) {
              let y = this.pointRange / (this.dataMax + 1);
              v = y * this.min, k = y * (this.max + 1), C.setRange(v, k);
            } else v = (this.min - m) / (A - m), k = (this.max - m) / (A - m), this.horiz && !this.reversed || !this.horiz && this.reversed ? C.setRange(v, k) : C.setRange(1 - k, 1 - v);
          }
        }
        B.compose = function(p, v) {
          F(T, "Axis.Scrollbar") && (N = v, O(p, "afterGetOffset", w), O(p, "afterInit", x), O(p, "afterRender", M));
        };
      }(r || (r = {})), r;
    }), a(e, "Stock/Scrollbar/ScrollbarDefaults.js", [], function() {
      return { height: 10, barBorderRadius: 5, buttonBorderRadius: 0, buttonsEnabled: !1, liveRedraw: void 0, margin: void 0, minWidth: 6, opposite: !0, step: 0.2, zIndex: 3, barBackgroundColor: "#cccccc", barBorderWidth: 0, barBorderColor: "#cccccc", buttonArrowColor: "#333333", buttonBackgroundColor: "#e6e6e6", buttonBorderColor: "#cccccc", buttonBorderWidth: 1, rifleColor: "none", trackBackgroundColor: "rgba(255, 255, 255, 0.001)", trackBorderColor: "#cccccc", trackBorderRadius: 5, trackBorderWidth: 1 };
    }), a(e, "Stock/Scrollbar/Scrollbar.js", [e["Core/Defaults.js"], e["Core/Globals.js"], e["Core/Axis/ScrollbarAxis.js"], e["Stock/Scrollbar/ScrollbarDefaults.js"], e["Core/Utilities.js"]], function(o, n, r, T, O) {
      let { defaultOptions: j } = o, { addEvent: D, correctFloat: F, crisp: B, defined: N, destroyObjectProperties: f, fireEvent: w, merge: x, pick: M, removeEvent: p } = O;
      class v {
        static compose(m) {
          r.compose(m, v);
        }
        static swapXY(m, A) {
          return A && m.forEach((C) => {
            let H, G = C.length;
            for (let P = 0; P < G; P += 2) typeof (H = C[P + 1]) == "number" && (C[P + 1] = C[P + 2], C[P + 2] = H);
          }), m;
        }
        constructor(m, A, C) {
          this._events = [], this.chartX = 0, this.chartY = 0, this.from = 0, this.scrollbarButtons = [], this.scrollbarLeft = 0, this.scrollbarStrokeWidth = 1, this.scrollbarTop = 0, this.size = 0, this.to = 0, this.trackBorderWidth = 1, this.x = 0, this.y = 0, this.init(m, A, C);
        }
        addEvents() {
          let m = this.options.inverted ? [1, 0] : [0, 1], A = this.scrollbarButtons, C = this.scrollbarGroup.element, H = this.track.element, G = this.mouseDownHandler.bind(this), P = this.mouseMoveHandler.bind(this), y = this.mouseUpHandler.bind(this), S = [[A[m[0]].element, "click", this.buttonToMinClick.bind(this)], [A[m[1]].element, "click", this.buttonToMaxClick.bind(this)], [H, "click", this.trackClick.bind(this)], [C, "mousedown", G], [C.ownerDocument, "mousemove", P], [C.ownerDocument, "mouseup", y], [C, "touchstart", G], [C.ownerDocument, "touchmove", P], [C.ownerDocument, "touchend", y]];
          S.forEach(function(d) {
            D.apply(null, d);
          }), this._events = S;
        }
        buttonToMaxClick(m) {
          let A = (this.to - this.from) * M(this.options.step, 0.2);
          this.updatePosition(this.from + A, this.to + A), w(this, "changed", { from: this.from, to: this.to, trigger: "scrollbar", DOMEvent: m });
        }
        buttonToMinClick(m) {
          let A = F(this.to - this.from) * M(this.options.step, 0.2);
          this.updatePosition(F(this.from - A), F(this.to - A)), w(this, "changed", { from: this.from, to: this.to, trigger: "scrollbar", DOMEvent: m });
        }
        cursorToScrollbarPosition(m) {
          let A = this.options, C = A.minWidth > this.calculatedWidth ? A.minWidth : 0;
          return { chartX: (m.chartX - this.x - this.xOffset) / (this.barWidth - C), chartY: (m.chartY - this.y - this.yOffset) / (this.barWidth - C) };
        }
        destroy() {
          let m = this, A = m.chart.scroller;
          m.removeEvents(), ["track", "scrollbarRifles", "scrollbar", "scrollbarGroup", "group"].forEach(function(C) {
            m[C] && m[C].destroy && (m[C] = m[C].destroy());
          }), A && m === A.scrollbar && (A.scrollbar = null, f(A.scrollbarButtons));
        }
        drawScrollbarButton(m) {
          let A = this.renderer, C = this.scrollbarButtons, H = this.options, G = this.size, P = A.g().add(this.group);
          if (C.push(P), H.buttonsEnabled) {
            let y = A.rect().addClass("highcharts-scrollbar-button").add(P);
            this.chart.styledMode || y.attr({ stroke: H.buttonBorderColor, "stroke-width": H.buttonBorderWidth, fill: H.buttonBackgroundColor }), y.attr(y.crisp({ x: -0.5, y: -0.5, width: G, height: G, r: H.buttonBorderRadius }, y.strokeWidth()));
            let S = A.path(v.swapXY([["M", G / 2 + (m ? -1 : 1), G / 2 - 3], ["L", G / 2 + (m ? -1 : 1), G / 2 + 3], ["L", G / 2 + (m ? 2 : -2), G / 2]], H.vertical)).addClass("highcharts-scrollbar-arrow").add(C[m]);
            this.chart.styledMode || S.attr({ fill: H.buttonArrowColor });
          }
        }
        init(m, A, C) {
          this.scrollbarButtons = [], this.renderer = m, this.userOptions = A, this.options = x(T, j.scrollbar, A), this.options.margin = M(this.options.margin, 10), this.chart = C, this.size = M(this.options.size, this.options.height), A.enabled && (this.render(), this.addEvents());
        }
        mouseDownHandler(m) {
          var H;
          let A = ((H = this.chart.pointer) == null ? void 0 : H.normalize(m)) || m, C = this.cursorToScrollbarPosition(A);
          this.chartX = C.chartX, this.chartY = C.chartY, this.initPositions = [this.from, this.to], this.grabbedCenter = !0;
        }
        mouseMoveHandler(m) {
          var P;
          let A, C = ((P = this.chart.pointer) == null ? void 0 : P.normalize(m)) || m, H = this.options.vertical ? "chartY" : "chartX", G = this.initPositions || [];
          this.grabbedCenter && (!m.touches || m.touches[0][H] !== 0) && (A = this.cursorToScrollbarPosition(C)[H] - this[H], this.hasDragged = !0, this.updatePosition(G[0] + A, G[1] + A), this.hasDragged && w(this, "changed", { from: this.from, to: this.to, trigger: "scrollbar", DOMType: m.type, DOMEvent: m }));
        }
        mouseUpHandler(m) {
          this.hasDragged && w(this, "changed", { from: this.from, to: this.to, trigger: "scrollbar", DOMType: m.type, DOMEvent: m }), this.grabbedCenter = this.hasDragged = this.chartX = this.chartY = null;
        }
        position(m, A, C, H) {
          let { buttonsEnabled: G, margin: P = 0, vertical: y } = this.options, S = this.rendered ? "animate" : "attr", d = H, s = 0;
          this.group.show(), this.x = m, this.y = A + this.trackBorderWidth, this.width = C, this.height = H, this.xOffset = d, this.yOffset = s, y ? (this.width = this.yOffset = C = s = this.size, this.xOffset = d = 0, this.yOffset = s = G ? this.size : 0, this.barWidth = H - (G ? 2 * C : 0), this.x = m += P) : (this.height = H = this.size, this.xOffset = d = G ? this.size : 0, this.barWidth = C - (G ? 2 * H : 0), this.y = this.y + P), this.group[S]({ translateX: m, translateY: this.y }), this.track[S]({ width: C, height: H }), this.scrollbarButtons[1][S]({ translateX: y ? 0 : C - d, translateY: y ? H - s : 0 });
        }
        removeEvents() {
          this._events.forEach(function(m) {
            p.apply(null, m);
          }), this._events.length = 0;
        }
        render() {
          let m = this.renderer, A = this.options, C = this.size, H = this.chart.styledMode, G = m.g("scrollbar").attr({ zIndex: A.zIndex }).hide().add();
          this.group = G, this.track = m.rect().addClass("highcharts-scrollbar-track").attr({ r: A.trackBorderRadius || 0, height: C, width: C }).add(G), H || this.track.attr({ fill: A.trackBackgroundColor, stroke: A.trackBorderColor, "stroke-width": A.trackBorderWidth });
          let P = this.trackBorderWidth = this.track.strokeWidth();
          this.track.attr({ x: -B(0, P), y: -B(0, P) }), this.scrollbarGroup = m.g().add(G), this.scrollbar = m.rect().addClass("highcharts-scrollbar-thumb").attr({ height: C - P, width: C - P, r: A.barBorderRadius || 0 }).add(this.scrollbarGroup), this.scrollbarRifles = m.path(v.swapXY([["M", -3, C / 4], ["L", -3, 2 * C / 3], ["M", 0, C / 4], ["L", 0, 2 * C / 3], ["M", 3, C / 4], ["L", 3, 2 * C / 3]], A.vertical)).addClass("highcharts-scrollbar-rifles").add(this.scrollbarGroup), H || (this.scrollbar.attr({ fill: A.barBackgroundColor, stroke: A.barBorderColor, "stroke-width": A.barBorderWidth }), this.scrollbarRifles.attr({ stroke: A.rifleColor, "stroke-width": 1 })), this.scrollbarStrokeWidth = this.scrollbar.strokeWidth(), this.scrollbarGroup.translate(-B(0, this.scrollbarStrokeWidth), -B(0, this.scrollbarStrokeWidth)), this.drawScrollbarButton(0), this.drawScrollbarButton(1);
        }
        setRange(m, A) {
          let C, H, G = this.options, P = G.vertical, y = G.minWidth, S = this.barWidth, d = !this.rendered || this.hasDragged || this.chart.navigator && this.chart.navigator.hasDragged ? "attr" : "animate";
          if (!N(S)) return;
          let s = S * Math.min(A, 1);
          C = Math.ceil(S * (m = Math.max(m, 0))), this.calculatedWidth = H = F(s - C), H < y && (C = (S - y + H) * m, H = y);
          let l = Math.floor(C + this.xOffset + this.yOffset), b = H / 2 - 0.5;
          this.from = m, this.to = A, P ? (this.scrollbarGroup[d]({ translateY: l }), this.scrollbar[d]({ height: H }), this.scrollbarRifles[d]({ translateY: b }), this.scrollbarTop = l, this.scrollbarLeft = 0) : (this.scrollbarGroup[d]({ translateX: l }), this.scrollbar[d]({ width: H }), this.scrollbarRifles[d]({ translateX: b }), this.scrollbarLeft = l, this.scrollbarTop = 0), H <= 12 ? this.scrollbarRifles.hide() : this.scrollbarRifles.show(), G.showFull === !1 && (m <= 0 && A >= 1 ? this.group.hide() : this.group.show()), this.rendered = !0;
        }
        shouldUpdateExtremes(m) {
          return M(this.options.liveRedraw, n.svg && !n.isTouchDevice && !this.chart.boosted) || m === "mouseup" || m === "touchend" || !N(m);
        }
        trackClick(m) {
          var P;
          let A = ((P = this.chart.pointer) == null ? void 0 : P.normalize(m)) || m, C = this.to - this.from, H = this.y + this.scrollbarTop, G = this.x + this.scrollbarLeft;
          this.options.vertical && A.chartY > H || !this.options.vertical && A.chartX > G ? this.updatePosition(this.from + C, this.to + C) : this.updatePosition(this.from - C, this.to - C), w(this, "changed", { from: this.from, to: this.to, trigger: "scrollbar", DOMEvent: m });
        }
        update(m) {
          this.destroy(), this.init(this.chart.renderer, x(!0, this.options, m), this.chart);
        }
        updatePosition(m, A) {
          A > 1 && (m = F(1 - F(A - m)), A = 1), m < 0 && (A = F(A - m), m = 0), this.from = m, this.to = A;
        }
      }
      return v.defaultOptions = T, j.scrollbar = x(!0, v.defaultOptions, j.scrollbar), v;
    }), a(e, "Stock/Navigator/Navigator.js", [e["Core/Axis/Axis.js"], e["Stock/Navigator/ChartNavigatorComposition.js"], e["Core/Defaults.js"], e["Core/Globals.js"], e["Core/Axis/NavigatorAxisComposition.js"], e["Stock/Navigator/NavigatorComposition.js"], e["Stock/Scrollbar/Scrollbar.js"], e["Core/Renderer/SVG/SVGRenderer.js"], e["Core/Utilities.js"]], function(o, n, r, T, O, j, D, F, B) {
      let { defaultOptions: N } = r, { isTouchDevice: f } = T, { prototype: { symbols: w } } = F, { addEvent: x, clamp: M, correctFloat: p, defined: v, destroyObjectProperties: k, erase: m, extend: A, find: C, fireEvent: H, isArray: G, isNumber: P, merge: y, pick: S, removeEvent: d, splat: s } = B;
      function l(u, ...c) {
        let h = [].filter.call(c, P);
        if (h.length) return Math[u].apply(0, h);
      }
      class b {
        static compose(c, h, g) {
          n.compose(c, b), j.compose(c, h, g);
        }
        constructor(c) {
          this.isDirty = !1, this.scrollbarHeight = 0, this.init(c);
        }
        drawHandle(c, h, g, E) {
          let R = this.navigatorOptions.handles.height;
          this.handles[h][E](g ? { translateX: Math.round(this.left + this.height / 2), translateY: Math.round(this.top + parseInt(c, 10) + 0.5 - R) } : { translateX: Math.round(this.left + parseInt(c, 10)), translateY: Math.round(this.top + this.height / 2 - R / 2 - 1) });
        }
        drawOutline(c, h, g, E) {
          let R = this.navigatorOptions.maskInside, L = this.outline.strokeWidth(), U = L / 2, V = L % 2 / 2, q = this.scrollButtonSize, Y = this.size, I = this.top, _ = this.height, W = I - U, X = I + _, z = this.left, $, K;
          g ? ($ = I + h + V, h = I + c + V, K = [["M", z + _, I - q - V], ["L", z + _, $], ["L", z, $], ["M", z, h], ["L", z + _, h], ["L", z + _, I + Y + q]], R && K.push(["M", z + _, $ - U], ["L", z + _, h + U])) : (z -= q, c += z + q - V, h += z + q - V, K = [["M", z, W], ["L", c, W], ["L", c, X], ["M", h, X], ["L", h, W], ["L", z + Y + 2 * q, W]], R && K.push(["M", c - U, W], ["L", h + U, W])), this.outline[E]({ d: K });
        }
        drawMasks(c, h, g, E) {
          let R, L, U, V, q = this.left, Y = this.top, I = this.height;
          g ? (U = [q, q, q], V = [Y, Y + c, Y + h], L = [I, I, I], R = [c, h - c, this.size - h]) : (U = [q, q + c, q + h], V = [Y, Y, Y], L = [c, h - c, this.size - h], R = [I, I, I]), this.shades.forEach((_, W) => {
            _[E]({ x: U[W], y: V[W], width: L[W], height: R[W] });
          });
        }
        renderElements() {
          var q, Y;
          let c = this, h = c.navigatorOptions, g = h.maskInside, E = c.chart, R = E.inverted, L = E.renderer, U = { cursor: R ? "ns-resize" : "ew-resize" }, V = (q = c.navigatorGroup) != null ? q : c.navigatorGroup = L.g("navigator").attr({ zIndex: 8, visibility: "hidden" }).add();
          if ([!g, g, !g].forEach((I, _) => {
            var X;
            let W = (X = c.shades[_]) != null ? X : c.shades[_] = L.rect().addClass("highcharts-navigator-mask" + (_ === 1 ? "-inside" : "-outside")).add(V);
            E.styledMode || (W.attr({ fill: I ? h.maskFill : "rgba(0,0,0,0)" }), _ === 1 && W.css(U));
          }), c.outline || (c.outline = L.path().addClass("highcharts-navigator-outline").add(V)), E.styledMode || c.outline.attr({ "stroke-width": h.outlineWidth, stroke: h.outlineColor }), (Y = h.handles) == null ? void 0 : Y.enabled) {
            let I = h.handles, { height: _, width: W } = I;
            [0, 1].forEach((X) => {
              var $;
              let z = I.symbols[X];
              if (c.handles[X] && c.handles[X].symbolUrl === z) {
                if (!c.handles[X].isImg && c.handles[X].symbolName !== z) {
                  let K = w[z].call(w, -W / 2 - 1, 0, W, _);
                  c.handles[X].attr({ d: K }), c.handles[X].symbolName = z;
                }
              } else ($ = c.handles[X]) == null || $.destroy(), c.handles[X] = L.symbol(z, -W / 2 - 1, 0, W, _, I), c.handles[X].attr({ zIndex: 7 - X }).addClass("highcharts-navigator-handle highcharts-navigator-handle-" + ["left", "right"][X]).add(V), c.addMouseEvents();
              E.inverted && c.handles[X].attr({ rotation: 90, rotationOriginX: Math.floor(-W / 2), rotationOriginY: (_ + W) / 2 }), E.styledMode || c.handles[X].attr({ fill: I.backgroundColor, stroke: I.borderColor, "stroke-width": I.lineWidth, width: I.width, height: I.height, x: -W / 2 - 1, y: 0 }).css(U);
            });
          }
        }
        update(c, h = !1) {
          var R, L;
          let g = this.chart, E = g.options.chart.inverted !== ((R = g.scrollbar) == null ? void 0 : R.options.vertical);
          if (y(!0, g.options.navigator, c), this.navigatorOptions = g.options.navigator || {}, this.setOpposite(), v(c.enabled) || E) return this.destroy(), this.navigatorEnabled = c.enabled || this.navigatorEnabled, this.init(g);
          if (this.navigatorEnabled && (this.isDirty = !0, c.adaptToUpdatedData === !1 && this.baseSeries.forEach((U) => {
            d(U, "updatedData", this.updatedDataHandler);
          }, this), c.adaptToUpdatedData && this.baseSeries.forEach((U) => {
            U.eventsToUnbind.push(x(U, "updatedData", this.updatedDataHandler));
          }, this), (c.series || c.baseSeries) && this.setBaseSeries(void 0, !1), c.height || c.xAxis || c.yAxis)) {
            this.height = (L = c.height) != null ? L : this.height;
            let U = this.getXAxisOffsets();
            this.xAxis.update({ ...c.xAxis, offsets: U, [g.inverted ? "width" : "height"]: this.height, [g.inverted ? "height" : "width"]: void 0 }, !1), this.yAxis.update({ ...c.yAxis, [g.inverted ? "width" : "height"]: this.height }, !1);
          }
          h && g.redraw();
        }
        render(c, h, g, E) {
          let R = this.chart, L = this.xAxis, U = L.pointRange || 0, V = L.navigatorAxis.fake ? R.xAxis[0] : L, q = this.navigatorEnabled, Y = this.rendered, I = R.inverted, _ = R.xAxis[0].minRange, W = R.xAxis[0].options.maxRange, X = this.scrollButtonSize, z, $, K, Q = this.scrollbarHeight, Z, ee;
          if (this.hasDragged && !v(g)) return;
          if (this.isDirty && this.renderElements(), c = p(c - U / 2), h = p(h + U / 2), !P(c) || !P(h)) {
            if (!Y) return;
            g = 0, E = S(L.width, V.width);
          }
          this.left = S(L.left, R.plotLeft + X + (I ? R.plotWidth : 0));
          let J = this.size = Z = S(L.len, (I ? R.plotHeight : R.plotWidth) - 2 * X);
          z = I ? Q : Z + 2 * X, g = S(g, L.toPixels(c, !0)), E = S(E, L.toPixels(h, !0)), P(g) && Math.abs(g) !== 1 / 0 || (g = 0, E = z);
          let ae = L.toValue(g, !0), re = L.toValue(E, !0), ce = Math.abs(p(re - ae));
          ce < _ ? this.grabbedLeft ? g = L.toPixels(re - _ - U, !0) : this.grabbedRight && (E = L.toPixels(ae + _ + U, !0)) : v(W) && p(ce - U) > W && (this.grabbedLeft ? g = L.toPixels(re - W - U, !0) : this.grabbedRight && (E = L.toPixels(ae + W + U, !0))), this.zoomedMax = M(Math.max(g, E), 0, J), this.zoomedMin = M(this.fixedWidth ? this.zoomedMax - this.fixedWidth : Math.min(g, E), 0, J), this.range = this.zoomedMax - this.zoomedMin, J = Math.round(this.zoomedMax);
          let he = Math.round(this.zoomedMin);
          q && (this.navigatorGroup.attr({ visibility: "inherit" }), ee = Y && !this.hasDragged ? "animate" : "attr", this.drawMasks(he, J, I, ee), this.drawOutline(he, J, I, ee), this.navigatorOptions.handles.enabled && (this.drawHandle(he, 0, I, ee), this.drawHandle(J, 1, I, ee))), this.scrollbar && (I ? (K = this.top - X, $ = this.left - Q + (q || !V.opposite ? 0 : (V.titleOffset || 0) + V.axisTitleMargin), Q = Z + 2 * X) : (K = this.top + (q ? this.height : -Q), $ = this.left - X), this.scrollbar.position($, K, z, Q), this.scrollbar.setRange(this.zoomedMin / (Z || 1), this.zoomedMax / (Z || 1))), this.rendered = !0, this.isDirty = !1, H(this, "afterRender");
        }
        addMouseEvents() {
          let c = this, h = c.chart, g = h.container, E = [], R, L;
          c.mouseMoveHandler = R = function(U) {
            c.onMouseMove(U);
          }, c.mouseUpHandler = L = function(U) {
            c.onMouseUp(U);
          }, (E = c.getPartsEvents("mousedown")).push(x(h.renderTo, "mousemove", R), x(g.ownerDocument, "mouseup", L), x(h.renderTo, "touchmove", R), x(g.ownerDocument, "touchend", L)), E.concat(c.getPartsEvents("touchstart")), c.eventsToUnbind = E, c.series && c.series[0] && E.push(x(c.series[0].xAxis, "foundExtremes", function() {
            h.navigator.modifyNavigatorAxisExtremes();
          }));
        }
        getPartsEvents(c) {
          let h = this, g = [];
          return ["shades", "handles"].forEach(function(E) {
            h[E].forEach(function(R, L) {
              g.push(x(R.element, c, function(U) {
                h[E + "Mousedown"](U, L);
              }));
            });
          }), g;
        }
        shadesMousedown(c, h) {
          var X;
          c = ((X = this.chart.pointer) == null ? void 0 : X.normalize(c)) || c;
          let g = this.chart, E = this.xAxis, R = this.zoomedMin, L = this.size, U = this.range, V = this.left, q = c.chartX, Y, I, _, W;
          g.inverted && (q = c.chartY, V = this.top), h === 1 ? (this.grabbedCenter = q, this.fixedWidth = U, this.dragOffset = q - R) : (W = q - V - U / 2, h === 0 ? W = Math.max(0, W) : h === 2 && W + U >= L && (W = L - U, this.reversedExtremes ? (W -= U, I = this.getUnionExtremes().dataMin) : Y = this.getUnionExtremes().dataMax), W !== R && (this.fixedWidth = U, v((_ = E.navigatorAxis.toFixedRange(W, W + U, I, Y)).min) && H(this, "setRange", { min: Math.min(_.min, _.max), max: Math.max(_.min, _.max), redraw: !0, eventArguments: { trigger: "navigator" } })));
        }
        handlesMousedown(c, h) {
          var L;
          c = ((L = this.chart.pointer) == null ? void 0 : L.normalize(c)) || c;
          let g = this.chart, E = g.xAxis[0], R = this.reversedExtremes;
          h === 0 ? (this.grabbedLeft = !0, this.otherHandlePos = this.zoomedMax, this.fixedExtreme = R ? E.min : E.max) : (this.grabbedRight = !0, this.otherHandlePos = this.zoomedMin, this.fixedExtreme = R ? E.max : E.min), g.setFixedRange(void 0);
        }
        onMouseMove(c) {
          var Y;
          let h = this, g = h.chart, E = h.navigatorSize, R = h.range, L = h.dragOffset, U = g.inverted, V = h.left, q;
          (!c.touches || c.touches[0].pageX !== 0) && (q = (c = ((Y = g.pointer) == null ? void 0 : Y.normalize(c)) || c).chartX, U && (V = h.top, q = c.chartY), h.grabbedLeft ? (h.hasDragged = !0, h.render(0, 0, q - V, h.otherHandlePos)) : h.grabbedRight ? (h.hasDragged = !0, h.render(0, 0, h.otherHandlePos, q - V)) : h.grabbedCenter && (h.hasDragged = !0, q < L ? q = L : q > E + L - R && (q = E + L - R), h.render(0, 0, q - L, q - L + R)), h.hasDragged && h.scrollbar && S(h.scrollbar.options.liveRedraw, !f && !this.chart.boosted) && (c.DOMType = c.type, setTimeout(function() {
            h.onMouseUp(c);
          }, 0)));
        }
        onMouseUp(c) {
          let h, g, E, R, L, U, V = this.chart, q = this.xAxis, Y = this.scrollbar, I = c.DOMEvent || c, _ = V.inverted, W = this.rendered && !this.hasDragged ? "animate" : "attr";
          (this.hasDragged && (!Y || !Y.hasDragged) || c.trigger === "scrollbar") && (E = this.getUnionExtremes(), this.zoomedMin === this.otherHandlePos ? R = this.fixedExtreme : this.zoomedMax === this.otherHandlePos && (L = this.fixedExtreme), this.zoomedMax === this.size && (L = this.reversedExtremes ? E.dataMin : E.dataMax), this.zoomedMin === 0 && (R = this.reversedExtremes ? E.dataMax : E.dataMin), v((U = q.navigatorAxis.toFixedRange(this.zoomedMin, this.zoomedMax, R, L)).min) && H(this, "setRange", { min: Math.min(U.min, U.max), max: Math.max(U.min, U.max), redraw: !0, animation: !this.hasDragged && null, eventArguments: { trigger: "navigator", triggerOp: "navigator-drag", DOMEvent: I } })), c.DOMType !== "mousemove" && c.DOMType !== "touchmove" && (this.grabbedLeft = this.grabbedRight = this.grabbedCenter = this.fixedWidth = this.fixedExtreme = this.otherHandlePos = this.hasDragged = this.dragOffset = null), this.navigatorEnabled && P(this.zoomedMin) && P(this.zoomedMax) && (g = Math.round(this.zoomedMin), h = Math.round(this.zoomedMax), this.shades && this.drawMasks(g, h, _, W), this.outline && this.drawOutline(g, h, _, W), this.navigatorOptions.handles.enabled && Object.keys(this.handles).length === this.handles.length && (this.drawHandle(g, 0, _, W), this.drawHandle(h, 1, _, W)));
        }
        removeEvents() {
          this.eventsToUnbind && (this.eventsToUnbind.forEach(function(c) {
            c();
          }), this.eventsToUnbind = void 0), this.removeBaseSeriesEvents();
        }
        removeBaseSeriesEvents() {
          let c = this.baseSeries || [];
          this.navigatorEnabled && c[0] && (this.navigatorOptions.adaptToUpdatedData !== !1 && c.forEach(function(h) {
            d(h, "updatedData", this.updatedDataHandler);
          }, this), c[0].xAxis && d(c[0].xAxis, "foundExtremes", this.modifyBaseAxisExtremes));
        }
        getXAxisOffsets() {
          return this.chart.inverted ? [this.scrollButtonSize, 0, -this.scrollButtonSize, 0] : [0, -this.scrollButtonSize, 0, this.scrollButtonSize];
        }
        init(c) {
          var z;
          let h = c.options, g = h.navigator || {}, E = g.enabled, R = h.scrollbar || {}, L = R.enabled, U = E && g.height || 0, V = L && R.height || 0, q = R.buttonsEnabled && V || 0;
          this.handles = [], this.shades = [], this.chart = c, this.setBaseSeries(), this.height = U, this.scrollbarHeight = V, this.scrollButtonSize = q, this.scrollbarEnabled = L, this.navigatorEnabled = E, this.navigatorOptions = g, this.scrollbarOptions = R, this.setOpposite();
          let Y = this, I = Y.baseSeries, _ = c.xAxis.length, W = c.yAxis.length, X = I && I[0] && I[0].xAxis || c.xAxis[0] || { options: {} };
          if (c.isDirtyBox = !0, Y.navigatorEnabled) {
            let $ = this.getXAxisOffsets();
            Y.xAxis = new o(c, y({ breaks: X.options.breaks, ordinal: X.options.ordinal, overscroll: X.options.overscroll }, g.xAxis, { type: "datetime", yAxis: (z = g.yAxis) == null ? void 0 : z.id, index: _, isInternal: !0, offset: 0, keepOrdinalPadding: !0, startOnTick: !1, endOnTick: !1, minPadding: X.options.ordinal ? 0 : X.options.minPadding, maxPadding: X.options.ordinal ? 0 : X.options.maxPadding, zoomEnabled: !1 }, c.inverted ? { offsets: $, width: U } : { offsets: $, height: U }), "xAxis"), Y.yAxis = new o(c, y(g.yAxis, { alignTicks: !1, offset: 0, index: W, isInternal: !0, reversed: S(g.yAxis && g.yAxis.reversed, c.yAxis[0] && c.yAxis[0].reversed, !1), zoomEnabled: !1 }, c.inverted ? { width: U } : { height: U }), "yAxis"), I || g.series.data ? Y.updateNavigatorSeries(!1) : c.series.length === 0 && (Y.unbindRedraw = x(c, "beforeRedraw", function() {
              c.series.length > 0 && !Y.series && (Y.setBaseSeries(), Y.unbindRedraw());
            })), Y.reversedExtremes = c.inverted && !Y.xAxis.reversed || !c.inverted && Y.xAxis.reversed, Y.renderElements(), Y.addMouseEvents();
          } else Y.xAxis = { chart: c, navigatorAxis: { fake: !0 }, translate: function($, K) {
            let Q = c.xAxis[0], Z = Q.getExtremes(), ee = Q.len - 2 * q, J = l("min", Q.options.min, Z.dataMin), ae = l("max", Q.options.max, Z.dataMax) - J;
            return K ? $ * ae / ee + J : ee * ($ - J) / ae;
          }, toPixels: function($) {
            return this.translate($);
          }, toValue: function($) {
            return this.translate($, !0);
          } }, Y.xAxis.navigatorAxis.axis = Y.xAxis, Y.xAxis.navigatorAxis.toFixedRange = O.prototype.toFixedRange.bind(Y.xAxis.navigatorAxis);
          if (c.options.scrollbar.enabled) {
            let $ = y(c.options.scrollbar, { vertical: c.inverted });
            !P($.margin) && Y.navigatorEnabled && ($.margin = c.inverted ? -3 : 3), c.scrollbar = Y.scrollbar = new D(c.renderer, $, c), x(Y.scrollbar, "changed", function(K) {
              let Q = Y.size, Z = Q * this.to, ee = Q * this.from;
              Y.hasDragged = Y.scrollbar.hasDragged, Y.render(0, 0, ee, Z), this.shouldUpdateExtremes(K.DOMType) && setTimeout(function() {
                Y.onMouseUp(K);
              });
            });
          }
          Y.addBaseSeriesEvents(), Y.addChartEvents();
        }
        setOpposite() {
          let c = this.navigatorOptions, h = this.navigatorEnabled, g = this.chart;
          this.opposite = S(c.opposite, !!(!h && g.inverted));
        }
        getUnionExtremes(c) {
          let h, g = this.chart.xAxis[0], E = this.xAxis, R = E.options, L = g.options;
          return c && g.dataMin === null || (h = { dataMin: S(R && R.min, l("min", L.min, g.dataMin, E.dataMin, E.min)), dataMax: S(R && R.max, l("max", L.max, g.dataMax, E.dataMax, E.max)) }), h;
        }
        setBaseSeries(c, h) {
          let g = this.chart, E = this.baseSeries = [];
          c = c || g.options && g.options.navigator.baseSeries || (g.series.length ? C(g.series, (R) => !R.options.isInternal).index : 0), (g.series || []).forEach((R, L) => {
            !R.options.isInternal && (R.options.showInNavigator || (L === c || R.options.id === c) && R.options.showInNavigator !== !1) && E.push(R);
          }), this.xAxis && !this.xAxis.navigatorAxis.fake && this.updateNavigatorSeries(!0, h);
        }
        updateNavigatorSeries(c, h) {
          var _, W;
          let g = this, E = g.chart, R = g.baseSeries, L = { enableMouseTracking: !1, index: null, linkedTo: null, group: "nav", padXAxis: !1, xAxis: (_ = this.navigatorOptions.xAxis) == null ? void 0 : _.id, yAxis: (W = this.navigatorOptions.yAxis) == null ? void 0 : W.id, showInLegend: !1, stacking: void 0, isInternal: !0, states: { inactive: { opacity: 1 } } }, U = g.series = (g.series || []).filter((X) => {
            let z = X.baseSeries;
            return !(0 > R.indexOf(z)) || (z && (d(z, "updatedData", g.updatedDataHandler), delete z.navigatorSeries), X.chart && X.destroy(), !1);
          }), V, q, Y = g.navigatorOptions.series, I;
          R && R.length && R.forEach((X) => {
            let z = X.navigatorSeries, $ = A({ color: X.color, visible: X.visible }, G(Y) ? N.navigator.series : Y);
            if (z && g.navigatorOptions.adaptToUpdatedData === !1) return;
            L.name = "Navigator " + R.length, I = (V = X.options || {}).navigatorOptions || {}, $.dataLabels = s($.dataLabels), (q = y(V, L, $, I)).pointRange = S($.pointRange, I.pointRange, N.plotOptions[q.type || "line"].pointRange);
            let K = I.data || $.data;
            g.hasNavigatorData = g.hasNavigatorData || !!K, q.data = K || V.data && V.data.slice(0), z && z.options ? z.update(q, h) : (X.navigatorSeries = E.initSeries(q), E.setSortedData(), X.navigatorSeries.baseSeries = X, U.push(X.navigatorSeries));
          }), (Y.data && !(R && R.length) || G(Y)) && (g.hasNavigatorData = !1, (Y = s(Y)).forEach((X, z) => {
            L.name = "Navigator " + (U.length + 1), (q = y(N.navigator.series, { color: E.series[z] && !E.series[z].options.isInternal && E.series[z].color || E.options.colors[z] || E.options.colors[0] }, L, X)).data = X.data, q.data && (g.hasNavigatorData = !0, U.push(E.initSeries(q)));
          })), c && this.addBaseSeriesEvents();
        }
        addBaseSeriesEvents() {
          let c = this, h = c.baseSeries || [];
          h[0] && h[0].xAxis && h[0].eventsToUnbind.push(x(h[0].xAxis, "foundExtremes", this.modifyBaseAxisExtremes)), h.forEach((g) => {
            g.eventsToUnbind.push(x(g, "show", function() {
              this.navigatorSeries && this.navigatorSeries.setVisible(!0, !1);
            })), g.eventsToUnbind.push(x(g, "hide", function() {
              this.navigatorSeries && this.navigatorSeries.setVisible(!1, !1);
            })), this.navigatorOptions.adaptToUpdatedData !== !1 && g.xAxis && g.eventsToUnbind.push(x(g, "updatedData", this.updatedDataHandler)), g.eventsToUnbind.push(x(g, "remove", function() {
              h && m(h, g), this.navigatorSeries && (m(c.series, this.navigatorSeries), v(this.navigatorSeries.options) && this.navigatorSeries.remove(!1), delete this.navigatorSeries);
            }));
          });
        }
        getBaseSeriesMin(c) {
          return this.baseSeries.reduce(function(h, g) {
            return Math.min(h, g.xData && g.xData.length ? g.xData[0] : h);
          }, c);
        }
        modifyNavigatorAxisExtremes() {
          let c = this.xAxis;
          if (c.getExtremes !== void 0) {
            let h = this.getUnionExtremes(!0);
            h && (h.dataMin !== c.min || h.dataMax !== c.max) && (c.min = h.dataMin, c.max = h.dataMax);
          }
        }
        modifyBaseAxisExtremes() {
          var z;
          let c, h, g = this.chart.navigator, E = this.getExtremes(), R = E.min, L = E.max, U = E.dataMin, V = E.dataMax, q = L - R, Y = g.stickToMin, I = g.stickToMax, _ = S((z = this.ordinal) == null ? void 0 : z.convertOverscroll(this.options.overscroll), 0), W = g.series && g.series[0], X = !!this.setExtremes;
          !(this.eventArgs && this.eventArgs.trigger === "rangeSelectorButton") && (Y && (c = (h = U) + q), I && (c = V + _, Y || (h = Math.max(U, c - q, g.getBaseSeriesMin(W && W.xData ? W.xData[0] : -Number.MAX_VALUE)))), X && (Y || I) && P(h) && (this.min = this.userMin = h, this.max = this.userMax = c)), g.stickToMin = g.stickToMax = null;
        }
        updatedDataHandler() {
          let c = this.chart.navigator, h = this.navigatorSeries, g = c.reversedExtremes ? Math.round(c.zoomedMin) === 0 : Math.round(c.zoomedMax) >= Math.round(c.size);
          c.stickToMax = S(this.chart.options.navigator && this.chart.options.navigator.stickToMax, g), c.stickToMin = c.shouldStickToMin(this, c), h && !c.hasNavigatorData && (h.options.pointStart = this.xData[0], h.setData(this.options.data, !1, null, !1));
        }
        shouldStickToMin(c, h) {
          let g = h.getBaseSeriesMin(c.xData[0]), E = c.xAxis, R = E.max, L = E.min, U = E.options.range;
          return !!(P(R) && P(L)) && (U && R - g > 0 ? R - g < U : L <= g);
        }
        addChartEvents() {
          this.eventsToUnbind || (this.eventsToUnbind = []), this.eventsToUnbind.push(x(this.chart, "redraw", function() {
            let c = this.navigator, h = c && (c.baseSeries && c.baseSeries[0] && c.baseSeries[0].xAxis || this.xAxis[0]);
            h && c.render(h.min, h.max);
          }), x(this.chart, "getMargins", function() {
            let c = this.navigator, h = c.opposite ? "plotTop" : "marginBottom";
            this.inverted && (h = c.opposite ? "marginRight" : "plotLeft"), this[h] = (this[h] || 0) + (c.navigatorEnabled || !this.inverted ? c.height + c.scrollbarHeight : 0) + c.navigatorOptions.margin;
          }), x(b, "setRange", function(c) {
            this.chart.xAxis[0].setExtremes(c.min, c.max, c.redraw, c.animation, c.eventArguments);
          }));
        }
        destroy() {
          this.removeEvents(), this.xAxis && (m(this.chart.xAxis, this.xAxis), m(this.chart.axes, this.xAxis)), this.yAxis && (m(this.chart.yAxis, this.yAxis), m(this.chart.axes, this.yAxis)), (this.series || []).forEach((c) => {
            c.destroy && c.destroy();
          }), ["series", "xAxis", "yAxis", "shades", "outline", "scrollbarTrack", "scrollbarRifles", "scrollbarGroup", "scrollbar", "navigatorGroup", "rendered"].forEach((c) => {
            this[c] && this[c].destroy && this[c].destroy(), this[c] = null;
          }), [this.handles].forEach((c) => {
            k(c);
          }), this.navigatorEnabled = !1;
        }
      }
      return b;
    }), a(e, "Core/Axis/OrdinalAxis.js", [e["Core/Axis/Axis.js"], e["Core/Globals.js"], e["Core/Series/Series.js"], e["Core/Utilities.js"]], function(o, n, r, T) {
      var O;
      let { addEvent: j, correctFloat: D, css: F, defined: B, error: N, isNumber: f, pick: w, timeUnits: x, isString: M } = T;
      return function(p) {
        function v(l, b, u, c, h = [], g = 0, E) {
          let R = {}, L = this.options.tickPixelInterval, U = this.chart.time, V = [], q, Y, I, _, W, X = 0, z = [], $ = -Number.MAX_VALUE;
          if (!this.options.ordinal && !this.options.breaks || !h || h.length < 3 || b === void 0) return U.getTimeTicks.apply(U, arguments);
          let K = h.length;
          for (q = 0; q < K; q++) {
            if (W = q && h[q - 1] > u, h[q] < b && (X = q), q === K - 1 || h[q + 1] - h[q] > 5 * g || W) {
              if (h[q] > $) {
                for (Y = U.getTimeTicks(l, h[X], h[q], c); Y.length && Y[0] <= $; ) Y.shift();
                Y.length && ($ = Y[Y.length - 1]), V.push(z.length), z = z.concat(Y);
              }
              X = q + 1;
            }
            if (W) break;
          }
          if (Y) {
            if (_ = Y.info, E && _.unitRange <= x.hour) {
              for (X = 1, q = z.length - 1; X < q; X++) U.dateFormat("%d", z[X]) !== U.dateFormat("%d", z[X - 1]) && (R[z[X]] = "day", I = !0);
              I && (R[z[0]] = "day"), _.higherRanks = R;
            }
            _.segmentStarts = V, z.info = _;
          } else N(12, !1, this.chart);
          if (E && B(L)) {
            let Q = z.length, Z = [], ee = [], J, ae, re, ce, he, ne = Q;
            for (; ne--; ) ae = this.translate(z[ne]), re && (ee[ne] = re - ae), Z[ne] = re = ae;
            for (ee.sort((te, se) => te - se), (ce = ee[Math.floor(ee.length / 2)]) < 0.6 * L && (ce = null), ne = z[Q - 1] > u ? Q - 1 : Q, re = void 0; ne--; ) he = Math.abs(re - (ae = Z[ne])), re && he < 0.8 * L && (ce === null || he < 0.8 * ce) ? (R[z[ne]] && !R[z[ne + 1]] ? (J = ne + 1, re = ae) : J = ne, z.splice(J, 1)) : re = ae;
          }
          return z;
        }
        function k(l) {
          let b = this.ordinal.positions;
          if (!b) return l;
          let u = b.length - 1, c;
          return l < 0 ? l = b[0] : l > u ? l = b[u] : (u = Math.floor(l), c = l - u), c !== void 0 && b[u] !== void 0 ? b[u] + (c ? c * (b[u + 1] - b[u]) : 0) : l;
        }
        function m(l) {
          let b = this.ordinal, u = this.old ? this.old.min : this.min, c = this.old ? this.old.transA : this.transA, h = b.getExtendedPositions();
          if (h && h.length) {
            let g = D((l - u) * c + this.minPixelPadding), E = D(b.getIndexOfPoint(g, h)), R = D(E % 1);
            if (E >= 0 && E <= h.length - 1) {
              let L = h[Math.floor(E)], U = h[Math.ceil(E)];
              return h[Math.floor(E)] + R * (U - L);
            }
          }
          return l;
        }
        function A(l, b) {
          let u = p.Additions.findIndexOf(l, b, !0);
          if (l[u] === b) return u;
          let c = (b - l[u]) / (l[u + 1] - l[u]);
          return u + c;
        }
        function C() {
          this.ordinal || (this.ordinal = new p.Additions(this));
        }
        function H() {
          let { eventArgs: l, options: b } = this;
          if (this.isXAxis && B(b.overscroll) && b.overscroll !== 0 && f(this.max) && f(this.min) && (this.options.ordinal && !this.ordinal.originalOrdinalRange && this.ordinal.getExtendedPositions(!1), this.max === this.dataMax && ((l == null ? void 0 : l.trigger) !== "pan" || this.isInternal) && (l == null ? void 0 : l.trigger) !== "navigator")) {
            let u = this.ordinal.convertOverscroll(b.overscroll);
            this.max += u, !this.isInternal && B(this.userMin) && (l == null ? void 0 : l.trigger) !== "mousewheel" && (this.min += u);
          }
        }
        function G() {
          this.horiz && !this.isDirty && (this.isDirty = this.isOrdinal && this.chart.navigator && !this.chart.navigator.adaptToUpdatedData);
        }
        function P() {
          this.ordinal && (this.ordinal.beforeSetTickPositions(), this.tickInterval = this.ordinal.postProcessTickInterval(this.tickInterval));
        }
        function y(l) {
          let b = this.xAxis[0], u = b.ordinal.convertOverscroll(b.options.overscroll), c = l.originalEvent.chartX, h = this.options.chart.panning, g = !1;
          if (h && h.type !== "y" && b.options.ordinal && b.series.length && (!l.touches || l.touches.length <= 1)) {
            let E, R, L = this.mouseDownX, U = b.getExtremes(), V = U.dataMin, q = U.dataMax, Y = U.min, I = U.max, _ = this.hoverPoints, W = b.closestPointRange || b.ordinal && b.ordinal.overscrollPointsRange, X = Math.round((L - c) / (b.translationSlope * (b.ordinal.slope || W))), z = b.ordinal.getExtendedPositions(), $ = { ordinal: { positions: z, extendedOrdinalPositions: z } }, K = b.index2val, Q = b.val2lin;
            if (Y <= V && X < 0 || I + u >= q && X > 0) return;
            $.ordinal.positions ? Math.abs(X) > 1 && (_ && _.forEach(function(Z) {
              Z.setState();
            }), q > (R = $.ordinal.positions)[R.length - 1] && R.push(q), this.setFixedRange(I - Y), (E = b.navigatorAxis.toFixedRange(void 0, void 0, K.apply($, [Q.apply($, [Y, !0]) + X]), K.apply($, [Q.apply($, [I, !0]) + X]))).min >= Math.min(U.dataMin, Y) && E.max <= Math.max(q, I) + u && b.setExtremes(E.min, E.max, !0, !1, { trigger: "pan" }), this.mouseDownX = c, F(this.container, { cursor: "move" })) : g = !0;
          } else g = !0;
          g || h && /y/.test(h.type) ? u && (b.max = b.dataMax + u) : l.preventDefault();
        }
        function S() {
          let l = this.xAxis;
          l && l.options.ordinal && (delete l.ordinal.index, delete l.ordinal.originalOrdinalRange);
        }
        function d(l, b) {
          let u, c = this.ordinal, h = c.positions, g = c.slope, E;
          if (!h) return l;
          let R = h.length;
          if (h[0] <= l && h[R - 1] >= l) u = A(h, l);
          else {
            if (!((E = c.getExtendedPositions && c.getExtendedPositions()) && E.length)) return l;
            let L = E.length;
            g || (g = (E[L - 1] - E[0]) / L);
            let U = A(E, h[0]);
            if (l >= E[0] && l <= E[L - 1]) u = A(E, l) - U;
            else {
              if (!b) return l;
              u = l < E[0] ? -U - (E[0] - l) / g : (l - E[L - 1]) / g + L - U;
            }
          }
          return b ? u : g * (u || 0) + c.offset;
        }
        p.compose = function(l, b, u) {
          let c = l.prototype;
          return c.ordinal2lin || (c.getTimeTicks = v, c.index2val = k, c.lin2val = m, c.val2lin = d, c.ordinal2lin = c.val2lin, j(l, "afterInit", C), j(l, "foundExtremes", H), j(l, "afterSetScale", G), j(l, "initialAxisTranslation", P), j(u, "pan", y), j(u, "touchpan", y), j(b, "updatedData", S)), l;
        };
        class s {
          constructor(b) {
            this.index = {}, this.axis = b;
          }
          beforeSetTickPositions() {
            var Q;
            let b = this.axis, u = b.ordinal, c = b.getExtremes(), h = c.min, g = c.max, E = (Q = b.brokenAxis) == null ? void 0 : Q.hasBreaks, R = b.options.ordinal, L, U, V, q, Y, I, _, W = [], X = Number.MAX_VALUE, z = !1, $ = !1, K = !1;
            if (R || E) {
              let Z = 0;
              if (b.series.forEach(function(ee, J) {
                if (U = [], J > 0 && ee.options.id !== "highcharts-navigator-series" && ee.processedXData.length > 1 && ($ = Z !== ee.processedXData[1] - ee.processedXData[0]), Z = ee.processedXData[1] - ee.processedXData[0], ee.boosted && (K = ee.boosted), ee.reserveSpace() && (ee.takeOrdinalPosition !== !1 || E) && (L = (W = W.concat(ee.processedXData)).length, W.sort(function(ae, re) {
                  return ae - re;
                }), X = Math.min(X, w(ee.closestPointRange, X)), L)) {
                  for (J = 0; J < L - 1; ) W[J] !== W[J + 1] && U.push(W[J + 1]), J++;
                  U[0] !== W[0] && U.unshift(W[0]), W = U;
                }
              }), b.ordinal.originalOrdinalRange || (b.ordinal.originalOrdinalRange = (W.length - 1) * X), $ && K && (W.pop(), W.shift()), (L = W.length) > 2) {
                for (V = W[1] - W[0], _ = L - 1; _-- && !z; ) W[_ + 1] - W[_] !== V && (z = !0);
                !b.options.keepOrdinalPadding && (W[0] - h > V || g - W[W.length - 1] > V) && (z = !0);
              } else b.options.overscroll && (L === 2 ? X = W[1] - W[0] : L === 1 ? (X = b.ordinal.convertOverscroll(b.options.overscroll), W = [W[0], W[0] + X]) : X = u.overscrollPointsRange);
              z || b.forceOrdinal ? (b.options.overscroll && (u.overscrollPointsRange = X, W = W.concat(u.getOverscrollPositions())), u.positions = W, q = b.ordinal2lin(Math.max(h, W[0]), !0), Y = Math.max(b.ordinal2lin(Math.min(g, W[W.length - 1]), !0), 1), u.slope = I = (g - h) / (Y - q), u.offset = h - q * I) : (u.overscrollPointsRange = w(b.closestPointRange, u.overscrollPointsRange), u.positions = b.ordinal.slope = u.offset = void 0);
            }
            b.isOrdinal = R && z, u.groupIntervalFactor = null;
          }
          static findIndexOf(b, u, c) {
            let h = 0, g = b.length - 1, E;
            for (; h < g; ) b[E = Math.ceil((h + g) / 2)] <= u ? h = E : g = E - 1;
            return b[h] === u || c ? h : -1;
          }
          getExtendedPositions(b = !0) {
            var I;
            let u = this, c = u.axis, h = c.constructor.prototype, g = c.chart, E = (I = c.series[0]) == null ? void 0 : I.currentDataGrouping, R = E ? E.count + E.unitName : "raw", L = b ? c.ordinal.convertOverscroll(c.options.overscroll) : 0, U = c.getExtremes(), V, q, Y = u.index;
            return Y || (Y = u.index = {}), Y[R] || ((V = { series: [], chart: g, forceOrdinal: !1, getExtremes: function() {
              return { min: U.dataMin, max: U.dataMax + L };
            }, applyGrouping: h.applyGrouping, getGroupPixelWidth: h.getGroupPixelWidth, getTimeTicks: h.getTimeTicks, options: { ordinal: !0 }, ordinal: { getGroupIntervalFactor: this.getGroupIntervalFactor }, ordinal2lin: h.ordinal2lin, getIndexOfPoint: h.getIndexOfPoint, val2lin: h.val2lin }).ordinal.axis = V, c.series.forEach(function(_) {
              var W, X, z;
              q = { xAxis: V, xData: _.xData.slice(), chart: g, groupPixelWidth: _.groupPixelWidth, destroyGroupedData: n.noop, getProcessedData: r.prototype.getProcessedData, applyGrouping: r.prototype.applyGrouping, reserveSpace: r.prototype.reserveSpace, visible: _.visible }, b && (q.xData = q.xData.concat(u.getOverscrollPositions())), q.options = { dataGrouping: E ? { firstAnchor: (W = _.options.dataGrouping) == null ? void 0 : W.firstAnchor, anchor: (X = _.options.dataGrouping) == null ? void 0 : X.anchor, lastAnchor: (z = _.options.dataGrouping) == null ? void 0 : z.firstAnchor, enabled: !0, forced: !0, approximation: "open", units: [[E.unitName, [E.count]]] } : { enabled: !1 } }, V.series.push(q), _.processData.apply(q);
            }), V.applyGrouping({ hasExtremesChanged: !0 }), (q == null ? void 0 : q.closestPointRange) !== (q == null ? void 0 : q.basePointRange) && q.currentDataGrouping && (V.forceOrdinal = !0), c.ordinal.beforeSetTickPositions.apply({ axis: V }), !c.ordinal.originalOrdinalRange && V.ordinal.originalOrdinalRange && (c.ordinal.originalOrdinalRange = V.ordinal.originalOrdinalRange), Y[R] = V.ordinal.positions), Y[R];
          }
          getGroupIntervalFactor(b, u, c) {
            let h = c.processedXData, g = h.length, E = [], R, L, U = this.groupIntervalFactor;
            if (!U) {
              for (L = 0; L < g - 1; L++) E[L] = h[L + 1] - h[L];
              E.sort(function(V, q) {
                return V - q;
              }), R = E[Math.floor(g / 2)], b = Math.max(b, h[0]), u = Math.min(u, h[g - 1]), this.groupIntervalFactor = U = g * R / (u - b);
            }
            return U;
          }
          getIndexOfPoint(b, u) {
            let c, h = this.axis, g = 0, E = function(U) {
              let { min: V, max: q } = h;
              return !!(B(V) && B(q)) && U.points.some((Y) => Y.x >= V && Y.x <= q);
            };
            h.series.forEach((U) => {
              var q;
              let V = (q = U.points) == null ? void 0 : q[0];
              B(V == null ? void 0 : V.plotX) && (V.plotX < c || !B(c)) && E(U) && (c = V.plotX, g = V.x);
            }), c != null || (c = h.minPixelPadding);
            let R = h.translationSlope * (this.slope || h.closestPointRange || this.overscrollPointsRange), L = D((b - c) / R);
            return s.findIndexOf(u, g, !0) + L;
          }
          getOverscrollPositions() {
            let b = this.axis, u = this.convertOverscroll(b.options.overscroll), c = this.overscrollPointsRange, h = [], g = b.dataMax;
            if (B(c)) for (; g <= b.dataMax + u; ) h.push(g += c);
            return h;
          }
          postProcessTickInterval(b) {
            let u = this.axis, c = this.slope;
            return c ? u.options.breaks ? u.closestPointRange || b : b / (c / u.closestPointRange) : b;
          }
          convertOverscroll(b = 0) {
            let u = this, c = u.axis, h = function(g) {
              return w(u.originalOrdinalRange, B(c.dataMax) && B(c.dataMin) ? c.dataMax - c.dataMin : 0) * g;
            };
            if (M(b)) {
              let g = parseInt(b, 10);
              if (/%$/.test(b)) return h(g / 100);
              if (/px/.test(b)) {
                let E = Math.min(g, 0.9 * c.len) / c.len;
                return h(E / (1 - E));
              }
              return 0;
            }
            return b;
          }
        }
        p.Additions = s;
      }(O || (O = {})), O;
    }), a(e, "Stock/RangeSelector/RangeSelectorDefaults.js", [], function() {
      return { lang: { rangeSelectorZoom: "Zoom", rangeSelectorFrom: "", rangeSelectorTo: "→" }, rangeSelector: { allButtonsEnabled: !1, buttons: void 0, buttonSpacing: 5, dropdown: "responsive", enabled: void 0, verticalAlign: "top", buttonTheme: { width: 28, height: 18, padding: 2, zIndex: 7 }, floating: !1, x: 0, y: 0, height: void 0, inputBoxBorderColor: "none", inputBoxHeight: 17, inputBoxWidth: void 0, inputDateFormat: "%e %b %Y", inputDateParser: void 0, inputEditDateFormat: "%Y-%m-%d", inputEnabled: !0, inputPosition: { align: "right", x: 0, y: 0 }, inputSpacing: 5, selected: void 0, buttonPosition: { align: "left", x: 0, y: 0 }, inputStyle: { color: "#334eff", cursor: "pointer", fontSize: "0.8em" }, labelStyle: { color: "#666666", fontSize: "0.8em" } } };
    }), a(e, "Stock/RangeSelector/RangeSelectorComposition.js", [e["Core/Defaults.js"], e["Core/Globals.js"], e["Stock/RangeSelector/RangeSelectorDefaults.js"], e["Core/Utilities.js"]], function(o, n, r, T) {
      let O, { defaultOptions: j } = o, { composed: D } = n, { addEvent: F, defined: B, extend: N, isNumber: f, merge: w, pick: x, pushUnique: M } = T, p = [];
      function v() {
        let P, y, S = this.range, d = S.type, s = this.max, l = this.chart.time, b = function(c, h) {
          let g = d === "year" ? "FullYear" : "Month", E = new l.Date(c), R = l.get(g, E);
          return l.set(g, E, R + h), R === l.get(g, E) && l.set("Date", E, 0), E.getTime() - c;
        };
        f(S) ? (P = s - S, y = S) : S && (P = s + b(s, -(S.count || 1)), this.chart && this.chart.setFixedRange(s - P));
        let u = x(this.dataMin, Number.MIN_VALUE);
        return f(P) || (P = u), P <= u && (P = u, y === void 0 && (y = b(P, S.count)), this.newMax = Math.min(P + y, x(this.dataMax, Number.MAX_VALUE))), f(s) ? !f(S) && S && S._offsetMin && (P += S._offsetMin) : P = void 0, P;
      }
      function k() {
        this.options.rangeSelector && this.options.rangeSelector.enabled && (this.rangeSelector = new O(this));
      }
      function m() {
        let P = this.rangeSelector;
        if (P) {
          f(P.deferredYTDClick) && (P.clickButton(P.deferredYTDClick), delete P.deferredYTDClick);
          let y = P.options.verticalAlign;
          P.options.floating || (y === "bottom" ? this.extraBottomMargin = !0 : y === "middle" || (this.extraTopMargin = !0));
        }
      }
      function A() {
        let P, y = this.rangeSelector;
        if (!y) return;
        let S = this.xAxis[0].getExtremes(), d = this.legend, s = y && y.options.verticalAlign;
        f(S.min) && y.render(S.min, S.max), d.display && s === "top" && s === d.options.verticalAlign && (P = w(this.spacingBox), d.options.layout === "vertical" ? P.y = this.plotTop : P.y += y.getHeight(), d.group.placed = !1, d.align(P));
      }
      function C() {
        for (let P = 0, y = p.length; P < y; ++P) {
          let S = p[P];
          if (S[0] === this) {
            S[1].forEach((d) => d()), p.splice(P, 1);
            return;
          }
        }
      }
      function H() {
        let P = this.rangeSelector;
        if (P) {
          let y = P.getHeight();
          this.extraTopMargin && (this.plotTop += y), this.extraBottomMargin && (this.marginBottom += y);
        }
      }
      function G(P) {
        let y = P.options.rangeSelector, S = this.extraBottomMargin, d = this.extraTopMargin, s = this.rangeSelector;
        if (y && y.enabled && !B(s) && this.options.rangeSelector && (this.options.rangeSelector.enabled = !0, this.rangeSelector = s = new O(this)), this.extraBottomMargin = !1, this.extraTopMargin = !1, s) {
          let l = y && y.verticalAlign || s.options && s.options.verticalAlign;
          s.options.floating || (l === "bottom" ? this.extraBottomMargin = !0 : l === "middle" || (this.extraTopMargin = !0)), (this.extraBottomMargin !== S || this.extraTopMargin !== d) && (this.isDirtyBox = !0);
        }
      }
      return { compose: function(P, y, S) {
        if (O = S, M(D, "RangeSelector")) {
          let d = y.prototype;
          P.prototype.minFromRange = v, F(y, "afterGetContainer", k), F(y, "beforeRender", m), F(y, "destroy", C), F(y, "getMargins", H), F(y, "redraw", A), F(y, "update", G), d.callbacks.push(A), N(j, { rangeSelector: r.rangeSelector }), N(j.lang, r.lang);
        }
      } };
    }), a(e, "Stock/RangeSelector/RangeSelector.js", [e["Core/Axis/Axis.js"], e["Core/Defaults.js"], e["Core/Globals.js"], e["Stock/RangeSelector/RangeSelectorComposition.js"], e["Core/Renderer/SVG/SVGElement.js"], e["Core/Utilities.js"], e["Core/Axis/OrdinalAxis.js"]], function(o, n, r, T, O, j, D) {
      let { defaultOptions: F } = n, { addEvent: B, createElement: N, css: f, defined: w, destroyObjectProperties: x, discardElement: M, extend: p, fireEvent: v, isNumber: k, merge: m, objectEach: A, pad: C, pick: H, pInt: G, splat: P } = j;
      class y {
        static compose(d, s) {
          T.compose(d, s, y);
        }
        constructor(d) {
          this.buttonOptions = y.prototype.defaultButtons, this.initialButtonGroupWidth = 0, this.init(d);
        }
        clickButton(d, s) {
          let l = this.chart, b = this.buttonOptions[d], u = l.xAxis[0], c = l.scroller && l.scroller.getUnionExtremes() || u || {}, h = b.type, g = b.dataGrouping, E = c.dataMin, R = c.dataMax, L, U = u && Math.round(Math.min(u.max, H(R, u.max))), V, q = b._range, Y, I, _, W = !0;
          if (E !== null && R !== null) {
            if (this.setSelected(d), g && (this.forcedDataGrouping = !0, o.prototype.setDataGrouping.call(u || { chart: this.chart }, g, !1), this.frozenStates = b.preserveDataGrouping), h === "month" || h === "year") u ? (I = { range: b, max: U, chart: l, dataMin: E, dataMax: R }, L = u.minFromRange.call(I), k(I.newMax) && (U = I.newMax), W = !1) : q = b;
            else if (q) U = Math.min((L = Math.max(U - q, E)) + q, R), W = !1;
            else if (h === "ytd")
              if (u) (R === void 0 || E === void 0) && (E = Number.MAX_VALUE, R = Number.MIN_VALUE, l.series.forEach((X) => {
                let z = X.xData;
                z && (E = Math.min(z[0], E), R = Math.max(z[z.length - 1], R));
              }), s = !1), L = Y = (_ = this.getYTDExtremes(R, E, l.time.useUTC)).min, U = _.max;
              else {
                this.deferredYTDClick = d;
                return;
              }
            else h === "all" && u && (l.navigator && l.navigator.baseSeries[0] && (l.navigator.baseSeries[0].xAxis.options.range = void 0), L = E, U = R);
            if (W && b._offsetMin && w(L) && (L += b._offsetMin), b._offsetMax && w(U) && (U += b._offsetMax), this.dropdown && (this.dropdown.selectedIndex = d + 1), u) u.setExtremes(L, U, H(s, !0), void 0, { trigger: "rangeSelectorButton", rangeSelectorButton: b }), l.setFixedRange(b._range);
            else {
              V = P(l.options.xAxis)[0];
              let X = B(l, "afterGetAxes", function() {
                let z = l.xAxis[0];
                z.range = z.options.range = q, z.min = z.options.min = Y;
              });
              B(l, "load", function() {
                let z = l.xAxis[0];
                l.setFixedRange(b._range), z.options.range = V.range, z.options.min = V.min, X();
              });
            }
            v(this, "afterBtnClick");
          }
        }
        setSelected(d) {
          this.selected = this.options.selected = d;
        }
        init(d) {
          let s = this, l = d.options.rangeSelector, b = l.buttons || s.defaultButtons.slice(), u = l.selected, c = function() {
            let h = s.minInput, g = s.maxInput;
            h && h.blur && v(h, "blur"), g && g.blur && v(g, "blur");
          };
          s.chart = d, s.options = l, s.buttons = [], s.buttonOptions = b, this.eventsToUnbind = [], this.eventsToUnbind.push(B(d.container, "mousedown", c)), this.eventsToUnbind.push(B(d, "resize", c)), b.forEach(s.computeButtonRange), u !== void 0 && b[u] && this.clickButton(u, !1), this.eventsToUnbind.push(B(d, "load", function() {
            d.xAxis && d.xAxis[0] && B(d.xAxis[0], "setExtremes", function(h) {
              k(this.max) && k(this.min) && this.max - this.min !== d.fixedRange && h.trigger !== "rangeSelectorButton" && h.trigger !== "updatedData" && s.forcedDataGrouping && !s.frozenStates && this.setDataGrouping(!1, !1);
            });
          })), this.createElements();
        }
        updateButtonStates() {
          let d = this, s = this.chart, l = this.dropdown, b = this.dropdownLabel, u = s.xAxis[0], c = Math.round(u.max - u.min), h = !u.hasVisibleSeries, g = 24 * 36e5, E = s.scroller && s.scroller.getUnionExtremes() || u, R = E.dataMin, L = E.dataMax, U = d.getYTDExtremes(L, R, s.time.useUTC), V = U.min, q = U.max, Y = d.selected, I = d.options.allButtonsEnabled, _ = Array(d.buttonOptions.length).fill(0), W = k(Y), X = d.buttons, z = !1, $ = null;
          d.buttonOptions.forEach((K, Q) => {
            var ie;
            let Z = K._range, ee = K.type, J = K.count || 1, ae = K._offsetMax - K._offsetMin, re = Q === Y, ce = Z > L - R, he = Z < u.minRange, ne = !1, te = Z === c;
            if (re && ce && (z = !0), u.isOrdinal && ((ie = u.ordinal) == null ? void 0 : ie.positions) && Z && c < Z) {
              let le = u.ordinal.positions, de = D.Additions.findIndexOf(le, u.min, !0), be = Math.min(D.Additions.findIndexOf(le, u.max, !0) + 1, le.length - 1);
              le[be] - le[de] > Z && (te = !0);
            } else (ee === "month" || ee === "year") && c + 36e5 >= { month: 28, year: 365 }[ee] * g * J - ae && c - 36e5 <= { month: 31, year: 366 }[ee] * g * J + ae ? te = !0 : ee === "ytd" ? (te = q - V + ae === c, ne = !re) : ee === "all" && (te = u.max - u.min >= L - R);
            let se = !I && !(z && ee === "all") && (ce || he || h), oe = z && ee === "all" || !ne && te || re && d.frozenStates;
            se ? _[Q] = 3 : oe && (!W || Q === Y) && ($ = Q);
          }), $ !== null ? (_[$] = 2, d.setSelected($)) : (d.setSelected(), b && (b.setState(0), b.attr({ text: (F.lang.rangeSelectorZoom || "") + " ▾" })));
          for (let K = 0; K < _.length; K++) {
            let Q = _[K], Z = X[K];
            if (Z.state !== Q && (Z.setState(Q), l)) {
              l.options[K + 1].disabled = Q === 3, Q === 2 && (b && (b.setState(2), b.attr({ text: d.buttonOptions[K].text + " ▾" })), l.selectedIndex = K + 1);
              let ee = b.getBBox();
              f(l, { width: `${ee.width}px`, height: `${ee.height}px` });
            }
          }
        }
        computeButtonRange(d) {
          let s = d.type, l = d.count || 1, b = { millisecond: 1, second: 1e3, minute: 6e4, hour: 36e5, day: 864e5, week: 6048e5 };
          b[s] ? d._range = b[s] * l : (s === "month" || s === "year") && (d._range = 24 * { month: 30, year: 365 }[s] * 36e5 * l), d._offsetMin = H(d.offsetMin, 0), d._offsetMax = H(d.offsetMax, 0), d._range += d._offsetMax - d._offsetMin;
        }
        getInputValue(d) {
          let s = d === "min" ? this.minInput : this.maxInput, l = this.chart.options.rangeSelector, b = this.chart.time;
          return s ? (s.type === "text" && l.inputDateParser || this.defaultInputDateParser)(s.value, b.useUTC, b) : 0;
        }
        setInputValue(d, s) {
          let l = this.options, b = this.chart.time, u = d === "min" ? this.minInput : this.maxInput, c = d === "min" ? this.minDateBox : this.maxDateBox;
          if (u) {
            let h = u.getAttribute("data-hc-time"), g = w(h) ? Number(h) : void 0;
            if (w(s)) {
              let E = g;
              w(E) && u.setAttribute("data-hc-time-previous", E), u.setAttribute("data-hc-time", s), g = s;
            }
            u.value = b.dateFormat(this.inputTypeFormats[u.type] || l.inputEditDateFormat, g), c && c.attr({ text: b.dateFormat(l.inputDateFormat, g) });
          }
        }
        setInputExtremes(d, s, l) {
          let b = d === "min" ? this.minInput : this.maxInput;
          if (b) {
            let u = this.inputTypeFormats[b.type], c = this.chart.time;
            if (u) {
              let h = c.dateFormat(u, s);
              b.min !== h && (b.min = h);
              let g = c.dateFormat(u, l);
              b.max !== g && (b.max = g);
            }
          }
        }
        showInput(d) {
          let s = d === "min" ? this.minDateBox : this.maxDateBox, l = d === "min" ? this.minInput : this.maxInput;
          if (l && s && this.inputGroup) {
            let b = l.type === "text", { translateX: u = 0, translateY: c = 0 } = this.inputGroup, { x: h = 0, width: g = 0, height: E = 0 } = s, { inputBoxWidth: R } = this.options;
            f(l, { width: b ? g + (R ? -2 : 20) + "px" : "auto", height: E - 2 + "px", border: "2px solid silver" }), b && R ? f(l, { left: u + h + "px", top: c + "px" }) : f(l, { left: Math.min(Math.round(h + u - (l.offsetWidth - g) / 2), this.chart.chartWidth - l.offsetWidth) + "px", top: c - (l.offsetHeight - E) / 2 + "px" });
          }
        }
        hideInput(d) {
          let s = d === "min" ? this.minInput : this.maxInput;
          s && f(s, { top: "-9999em", border: 0, width: "1px", height: "1px" });
        }
        defaultInputDateParser(d, s, l) {
          let b = d.split("/").join("-").split(" ").join("T");
          if (b.indexOf("T") === -1 && (b += "T00:00"), s) b += "Z";
          else {
            let c;
            if (r.isSafari && !((c = b).length > 6 && (c.lastIndexOf("-") === c.length - 6 || c.lastIndexOf("+") === c.length - 6))) {
              let h = new Date(b).getTimezoneOffset() / 60;
              b += h <= 0 ? `+${C(-h)}:00` : `-${C(h)}:00`;
            }
          }
          let u = Date.parse(b);
          if (!k(u)) {
            let c = d.split("-");
            u = Date.UTC(G(c[0]), G(c[1]) - 1, G(c[2]));
          }
          return l && s && k(u) && (u += l.getTimezoneOffset(u)), u;
        }
        drawInput(d) {
          let { chart: s, div: l, inputGroup: b } = this, u = this, c = s.renderer.style || {}, h = s.renderer, g = s.options.rangeSelector, E = F.lang, R = d === "min";
          function L(_) {
            var J;
            let { maxInput: W, minInput: X } = u, z = s.xAxis[0], $ = ((J = s.scroller) == null ? void 0 : J.getUnionExtremes()) || z, K = $.dataMin, Q = $.dataMax, Z = s.xAxis[0].getExtremes()[_], ee = u.getInputValue(_);
            k(ee) && ee !== Z && (R && W && k(K) ? ee > Number(W.getAttribute("data-hc-time")) ? ee = void 0 : ee < K && (ee = K) : X && k(Q) && (ee < Number(X.getAttribute("data-hc-time")) ? ee = void 0 : ee > Q && (ee = Q)), ee !== void 0 && z.setExtremes(R ? ee : z.min, R ? z.max : ee, void 0, void 0, { trigger: "rangeSelectorInput" }));
          }
          let U = E[R ? "rangeSelectorFrom" : "rangeSelectorTo"] || "", V = h.label(U, 0).addClass("highcharts-range-label").attr({ padding: U ? 2 : 0, height: U ? g.inputBoxHeight : 0 }).add(b), q = h.label("", 0).addClass("highcharts-range-input").attr({ padding: 2, width: g.inputBoxWidth, height: g.inputBoxHeight, "text-align": "center" }).on("click", function() {
            u.showInput(d), u[d + "Input"].focus();
          });
          s.styledMode || q.attr({ stroke: g.inputBoxBorderColor, "stroke-width": 1 }), q.add(b);
          let Y = N("input", { name: d, className: "highcharts-range-selector" }, void 0, l);
          Y.setAttribute("type", function(_) {
            if (_.indexOf("%L") !== -1) return "text";
            let W = ["a", "A", "d", "e", "w", "b", "B", "m", "o", "y", "Y"].some((z) => _.indexOf("%" + z) !== -1), X = ["H", "k", "I", "l", "M", "S"].some((z) => _.indexOf("%" + z) !== -1);
            return W && X ? "datetime-local" : W ? "date" : X ? "time" : "text";
          }(g.inputDateFormat || "%e %b %Y")), s.styledMode || (V.css(m(c, g.labelStyle)), q.css(m({ color: "#333333" }, c, g.inputStyle)), f(Y, p({ position: "absolute", border: 0, boxShadow: "0 0 15px rgba(0,0,0,0.3)", width: "1px", height: "1px", padding: 0, textAlign: "center", fontSize: c.fontSize, fontFamily: c.fontFamily, top: "-9999em" }, g.inputStyle))), Y.onfocus = () => {
            u.showInput(d);
          }, Y.onblur = () => {
            Y === r.doc.activeElement && L(d), u.hideInput(d), u.setInputValue(d), Y.blur();
          };
          let I = !1;
          return Y.onchange = () => {
            I || (L(d), u.hideInput(d), Y.blur());
          }, Y.onkeypress = (_) => {
            _.keyCode === 13 && L(d);
          }, Y.onkeydown = (_) => {
            I = !0, (_.key === "ArrowUp" || _.key === "ArrowDown" || _.key === "Tab") && L(d);
          }, Y.onkeyup = () => {
            I = !1;
          }, { dateBox: q, input: Y, label: V };
        }
        getPosition() {
          let d = this.chart, s = d.options.rangeSelector, l = s.verticalAlign === "top" ? d.plotTop - d.axisOffset[0] : 0;
          return { buttonTop: l + s.buttonPosition.y, inputTop: l + s.inputPosition.y - 10 };
        }
        getYTDExtremes(d, s, l) {
          let b = this.chart.time, u = new b.Date(d), c = b.get("FullYear", u), h = Math.max(s, l ? b.Date.UTC(c, 0, 1) : +new b.Date(c, 0, 1)), g = u.getTime();
          return { max: Math.min(d || g, g), min: h };
        }
        createElements() {
          var g;
          let d = this.chart, s = d.renderer, l = d.container, b = d.options, u = b.rangeSelector, c = u.inputEnabled, h = H((g = b.chart.style) == null ? void 0 : g.zIndex, 0) + 1;
          if (u.enabled !== !1 && (this.group = s.g("range-selector-group").attr({ zIndex: 7 }).add(), this.div = N("div", void 0, { position: "relative", height: 0, zIndex: h }), this.buttonOptions.length && this.renderButtons(), l.parentNode && l.parentNode.insertBefore(this.div, l), c)) {
            this.inputGroup = s.g("input-group").add(this.group);
            let E = this.drawInput("min");
            this.minDateBox = E.dateBox, this.minLabel = E.label, this.minInput = E.input;
            let R = this.drawInput("max");
            this.maxDateBox = R.dateBox, this.maxLabel = R.label, this.maxInput = R.input;
          }
        }
        render(d, s) {
          let l = this.chart, b = l.options.rangeSelector, u = b.inputEnabled;
          if (b.enabled !== !1) {
            if (u) {
              this.setInputValue("min", d), this.setInputValue("max", s);
              let c = l.scroller && l.scroller.getUnionExtremes() || l.xAxis[0] || {};
              if (w(c.dataMin) && w(c.dataMax)) {
                let h = l.xAxis[0].minRange || 0;
                this.setInputExtremes("min", c.dataMin, Math.min(c.dataMax, this.getInputValue("max")) - h), this.setInputExtremes("max", Math.max(c.dataMin, this.getInputValue("min")) + h, c.dataMax);
              }
              if (this.inputGroup) {
                let h = 0;
                [this.minLabel, this.minDateBox, this.maxLabel, this.maxDateBox].forEach((g) => {
                  if (g) {
                    let { width: E } = g.getBBox();
                    E && (g.attr({ x: h }), h += E + b.inputSpacing);
                  }
                });
              }
            }
            this.alignElements(), this.updateButtonStates();
          }
        }
        renderButtons() {
          var V;
          let { buttons: d, chart: s, options: l } = this, b = F.lang, u = s.renderer, c = m(l.buttonTheme), h = c && c.states, g = c.width || 28;
          delete c.width, delete c.states, this.buttonGroup = u.g("range-selector-buttons").add(this.group);
          let E = this.dropdown = N("select", void 0, { position: "absolute", padding: 0, border: 0, cursor: "pointer", opacity: 1e-4 }, this.div), R = (V = s.userOptions.rangeSelector) == null ? void 0 : V.buttonTheme;
          this.dropdownLabel = u.button("", 0, 0, () => {
          }, m(c, { "stroke-width": H(c["stroke-width"], 0), width: "auto", paddingLeft: H(l.buttonTheme.paddingLeft, R == null ? void 0 : R.padding, 8), paddingRight: H(l.buttonTheme.paddingRight, R == null ? void 0 : R.padding, 8) }), h && h.hover, h && h.select, h && h.disabled).hide().add(this.group), B(E, "touchstart", () => {
            E.style.fontSize = "16px";
          });
          let L = r.isMS ? "mouseover" : "mouseenter", U = r.isMS ? "mouseout" : "mouseleave";
          B(E, L, () => {
            v(this.dropdownLabel.element, L);
          }), B(E, U, () => {
            v(this.dropdownLabel.element, U);
          }), B(E, "change", () => {
            v(this.buttons[E.selectedIndex - 1].element, "click");
          }), this.zoomText = u.label(b.rangeSelectorZoom || "", 0).attr({ padding: l.buttonTheme.padding, height: l.buttonTheme.height, paddingLeft: 0, paddingRight: 0 }).add(this.buttonGroup), this.chart.styledMode || (this.zoomText.css(l.labelStyle), c["stroke-width"] = H(c["stroke-width"], 0)), N("option", { textContent: this.zoomText.textStr, disabled: !0 }, void 0, E), this.buttonOptions.forEach((q, Y) => {
            N("option", { textContent: q.title || q.text }, void 0, E), d[Y] = u.button(q.text, 0, 0, (I) => {
              let _, W = q.events && q.events.click;
              W && (_ = W.call(q, I)), _ !== !1 && this.clickButton(Y), this.isActive = !0;
            }, c, h && h.hover, h && h.select, h && h.disabled).attr({ "text-align": "center", width: g }).add(this.buttonGroup), q.title && d[Y].attr("title", q.title);
          });
        }
        alignElements() {
          var Y;
          let { buttonGroup: d, buttons: s, chart: l, group: b, inputGroup: u, options: c, zoomText: h } = this, g = l.options, E = g.exporting && g.exporting.enabled !== !1 && g.navigation && g.navigation.buttonOptions, { buttonPosition: R, inputPosition: L, verticalAlign: U } = c, V = (I, _) => E && this.titleCollision(l) && U === "top" && _.align === "right" && _.y - I.getBBox().height - 12 < (E.y || 0) + (E.height || 0) + l.spacing[0] ? -40 : 0, q = l.plotLeft;
          if (b && R && L) {
            let I = R.x - l.spacing[3];
            if (d) {
              if (this.positionButtons(), !this.initialButtonGroupWidth) {
                let ee = 0;
                h && (ee += h.getBBox().width + 5), s.forEach((J, ae) => {
                  ee += J.width || 0, ae !== s.length - 1 && (ee += c.buttonSpacing);
                }), this.initialButtonGroupWidth = ee;
              }
              q -= l.spacing[3];
              let Z = V(d, R);
              this.alignButtonGroup(Z), (Y = this.buttonGroup) != null && Y.translateY && this.dropdownLabel.attr({ y: this.buttonGroup.translateY }), b.placed = d.placed = l.hasLoaded;
            }
            let _ = 0;
            u && (_ = V(u, L), L.align === "left" ? I = q : L.align === "right" && (I = -Math.max(l.axisOffset[1], -_)), u.align({ y: L.y, width: u.getBBox().width, align: L.align, x: L.x + I - 2 }, !0, l.spacingBox), u.placed = l.hasLoaded), this.handleCollision(_), b.align({ verticalAlign: U }, !0, l.spacingBox);
            let W = b.alignAttr.translateY, X = b.getBBox().height + 20, z = 0;
            if (U === "bottom") {
              let Z = l.legend && l.legend.options;
              z = W - (X = X + (Z && Z.verticalAlign === "bottom" && Z.enabled && !Z.floating ? l.legend.legendHeight + H(Z.margin, 10) : 0) - 20) - (c.floating ? 0 : c.y) - (l.titleOffset ? l.titleOffset[2] : 0) - 10;
            }
            U === "top" ? (c.floating && (z = 0), l.titleOffset && l.titleOffset[0] && (z = l.titleOffset[0]), z += l.margin[0] - l.spacing[0] || 0) : U === "middle" && (L.y === R.y ? z = W : (L.y || R.y) && (L.y < 0 || R.y < 0 ? z -= Math.min(L.y, R.y) : z = W - X)), b.translate(c.x, c.y + Math.floor(z));
            let { minInput: $, maxInput: K, dropdown: Q } = this;
            c.inputEnabled && $ && K && ($.style.marginTop = b.translateY + "px", K.style.marginTop = b.translateY + "px"), Q && (Q.style.marginTop = b.translateY + "px");
          }
        }
        alignButtonGroup(d, s) {
          let { chart: l, options: b, buttonGroup: u } = this, { buttonPosition: c } = b, h = l.plotLeft - l.spacing[3], g = c.x - l.spacing[3];
          c.align === "right" ? g += d - h : c.align === "center" && (g -= h / 2), u && u.align({ y: c.y, width: H(s, this.initialButtonGroupWidth), align: c.align, x: g }, !0, l.spacingBox);
        }
        positionButtons() {
          let { buttons: d, chart: s, options: l, zoomText: b } = this, u = s.hasLoaded ? "animate" : "attr", { buttonPosition: c } = l, h = s.plotLeft, g = h;
          b && b.visibility !== "hidden" && (b[u]({ x: H(h + c.x, h) }), g += c.x + b.getBBox().width + 5);
          for (let E = 0, R = this.buttonOptions.length; E < R; ++E) d[E].visibility !== "hidden" ? (d[E][u]({ x: g }), g += (d[E].width || 0) + l.buttonSpacing) : d[E][u]({ x: h });
        }
        handleCollision(d) {
          let { chart: s, buttonGroup: l, inputGroup: b } = this, { buttonPosition: u, dropdown: c, inputPosition: h } = this.options, g = () => {
            let L = 0;
            return this.buttons.forEach((U) => {
              let V = U.getBBox();
              V.width > L && (L = V.width);
            }), L;
          }, E = (L) => {
            if (b != null && b.alignOptions && l) {
              let U = b.alignAttr.translateX + b.alignOptions.x - d + b.getBBox().x + 2, V = b.alignOptions.width || 0, q = l.alignAttr.translateX + l.getBBox().x;
              return q + L > U && U + V > q && u.y < h.y + b.getBBox().height;
            }
            return !1;
          }, R = () => {
            b && l && b.attr({ translateX: b.alignAttr.translateX + (s.axisOffset[1] >= -d ? 0 : -d), translateY: b.alignAttr.translateY + l.getBBox().height + 10 });
          };
          if (l) {
            if (c === "always") {
              this.collapseButtons(), E(g()) && R();
              return;
            }
            c === "never" && this.expandButtons();
          }
          b && l ? h.align === u.align || E(this.initialButtonGroupWidth + 20) ? c === "responsive" ? (this.collapseButtons(), E(g()) && R()) : R() : c === "responsive" && this.expandButtons() : l && c === "responsive" && (this.initialButtonGroupWidth > s.plotWidth ? this.collapseButtons() : this.expandButtons());
        }
        collapseButtons() {
          let { buttons: d, zoomText: s } = this;
          this.isCollapsed !== !0 && (this.isCollapsed = !0, s.hide(), d.forEach((l) => void l.hide()), this.showDropdown());
        }
        expandButtons() {
          let { buttons: d, zoomText: s } = this;
          this.isCollapsed !== !1 && (this.isCollapsed = !1, this.hideDropdown(), s.show(), d.forEach((l) => void l.show()), this.positionButtons());
        }
        showDropdown() {
          let { buttonGroup: d, chart: s, dropdownLabel: l, dropdown: b } = this;
          if (d && b) {
            let { translateX: u = 0, translateY: c = 0 } = d, h = s.plotLeft + u;
            l.attr({ x: h, y: c }).show(), f(b, { left: h + "px", top: c + "px", visibility: "inherit" }), this.hasVisibleDropdown = !0;
          }
        }
        hideDropdown() {
          let { dropdown: d } = this;
          d && (this.dropdownLabel.hide(), f(d, { visibility: "hidden", width: "1px", height: "1px" }), this.hasVisibleDropdown = !1);
        }
        getHeight() {
          let d = this.options, s = this.group, l = d.inputPosition, b = d.buttonPosition, u = d.y, c = b.y, h = l.y, g = 0;
          if (d.height) return d.height;
          this.alignElements(), g = s ? s.getBBox(!0).height + 13 + u : 0;
          let E = Math.min(h, c);
          return (h < 0 && c < 0 || h > 0 && c > 0) && (g += Math.abs(E)), g;
        }
        titleCollision(d) {
          return !(d.options.title.text || d.options.subtitle.text);
        }
        update(d, s = !0) {
          let l = this.chart;
          m(!0, l.options.rangeSelector, d), this.destroy(), this.init(l), s && this.render();
        }
        destroy() {
          let d = this, s = d.minInput, l = d.maxInput;
          d.eventsToUnbind && (d.eventsToUnbind.forEach((b) => b()), d.eventsToUnbind = void 0), x(d.buttons), s && (s.onfocus = s.onblur = s.onchange = null), l && (l.onfocus = l.onblur = l.onchange = null), A(d, function(b, u) {
            b && u !== "chart" && (b instanceof O ? b.destroy() : b instanceof window.HTMLElement && M(b)), b !== y.prototype[u] && (d[u] = null);
          }, this);
        }
      }
      return p(y.prototype, { defaultButtons: [{ type: "month", count: 1, text: "1m", title: "View 1 month" }, { type: "month", count: 3, text: "3m", title: "View 3 months" }, { type: "month", count: 6, text: "6m", title: "View 6 months" }, { type: "ytd", text: "YTD", title: "View year to date" }, { type: "year", count: 1, text: "1y", title: "View 1 year" }, { type: "all", text: "All", title: "View all" }], inputTypeFormats: { "datetime-local": "%Y-%m-%dT%H:%M:%S", date: "%Y-%m-%d", time: "%H:%M:%S" } }), y;
    }), a(e, "Core/Chart/StockChart.js", [e["Core/Chart/Chart.js"], e["Core/Templating.js"], e["Core/Defaults.js"], e["Stock/Navigator/NavigatorDefaults.js"], e["Stock/RangeSelector/RangeSelectorDefaults.js"], e["Stock/Scrollbar/ScrollbarDefaults.js"], e["Stock/Utilities/StockUtilities.js"], e["Core/Utilities.js"]], function(o, n, r, T, O, j, D, F) {
      let { format: B } = n, { getOptions: N } = r, { setFixedRange: f } = D, { addEvent: w, clamp: x, crisp: M, defined: p, extend: v, find: k, isNumber: m, isString: A, merge: C, pick: H, splat: G } = F;
      function P(d, s, l) {
        var b, u, c, h;
        return d === "xAxis" ? { minPadding: 0, maxPadding: 0, overscroll: 0, ordinal: !0 } : d === "yAxis" ? { labels: { y: -2 }, opposite: (u = (b = l.opposite) != null ? b : s.opposite) != null ? u : !0, showLastLabel: !!(s.categories || s.type === "category"), title: { text: ((c = l.title) == null ? void 0 : c.text) !== "Values" ? (h = l.title) == null ? void 0 : h.text : null } } : {};
      }
      function y(d, s) {
        if (d === "xAxis") {
          let l = H(s.navigator && s.navigator.enabled, T.enabled, !0), b = { type: "datetime", categories: void 0 };
          return l && (b.startOnTick = !1, b.endOnTick = !1), b;
        }
        return {};
      }
      class S extends o {
        init(s, l) {
          let b = N(), u = s.xAxis, c = s.yAxis, h = H(s.navigator && s.navigator.enabled, T.enabled, !0);
          s.xAxis = s.yAxis = void 0;
          let g = C({ chart: { panning: { enabled: !0, type: "x" }, zooming: { pinchType: "x", mouseWheel: { type: "x" } } }, navigator: { enabled: h }, scrollbar: { enabled: H(j.enabled, !0) }, rangeSelector: { enabled: H(O.rangeSelector.enabled, !0) }, title: { text: null }, tooltip: { split: H(b.tooltip && b.tooltip.split, !0), crosshairs: !0 }, legend: { enabled: !1 } }, s, { isStock: !0 });
          s.xAxis = u, s.yAxis = c, g.xAxis = G(s.xAxis || {}).map((E) => C(P("xAxis", E, b.xAxis), E, y("xAxis", s))), g.yAxis = G(s.yAxis || {}).map((E) => C(P("yAxis", E, b.yAxis), E)), super.init(g, l);
        }
        createAxis(s, l) {
          return l.axis = C(P(s, l.axis, N()[s]), l.axis, y(s, this.userOptions)), super.createAxis(s, l);
        }
      }
      return w(o, "update", function(d) {
        let s = d.options;
        "scrollbar" in s && this.navigator && (C(!0, this.options.scrollbar, s.scrollbar), this.navigator.update({ enabled: !!this.navigator.navigatorEnabled }), delete s.scrollbar);
      }), function(d) {
        function s(R) {
          if (!this.crosshair || !this.crosshair.label || !this.crosshair.label.enabled || !this.cross || !m(this.min) || !m(this.max)) return;
          let L = this.chart, U = this.logarithmic, V = this.crosshair.label, q = this.horiz, Y = this.opposite, I = this.left, _ = this.top, W = this.width, X = this.options.tickPosition === "inside", z = this.crosshair.snap !== !1, $ = R.e || this.cross && this.cross.e, K = R.point, Q = this.crossLabel, Z, ee, J = V.format, ae = "", re, ce = 0, he = this.min, ne = this.max;
          U && (he = U.lin2log(this.min), ne = U.lin2log(this.max));
          let te = q ? "center" : Y ? this.labelAlign === "right" ? "right" : "left" : this.labelAlign === "left" ? "left" : "center";
          Q || (Q = this.crossLabel = L.renderer.label("", 0, void 0, V.shape || "callout").addClass("highcharts-crosshair-label highcharts-color-" + (K && K.series ? K.series.colorIndex : this.series[0] && this.series[0].colorIndex)).attr({ align: V.align || te, padding: H(V.padding, 8), r: H(V.borderRadius, 3), zIndex: 2 }).add(this.labelGroup), L.styledMode || Q.attr({ fill: V.backgroundColor || K && K.series && K.series.color || "#666666", stroke: V.borderColor || "", "stroke-width": V.borderWidth || 0 }).css(v({ color: "#ffffff", fontWeight: "normal", fontSize: "0.7em", textAlign: "center" }, V.style || {}))), q ? (Z = z ? (K.plotX || 0) + I : $.chartX, ee = _ + (Y ? 0 : this.height)) : (Z = I + this.offset + (Y ? W : 0), ee = z ? (K.plotY || 0) + _ : $.chartY), J || V.formatter || (this.dateTime && (ae = "%b %d, %Y"), J = "{value" + (ae ? ":" + ae : "") + "}");
          let se = z ? this.isXAxis ? K.x : K.y : this.toValue(q ? $.chartX : $.chartY), oe = K && K.series ? K.series.isPointInside(K) : m(se) && se > he && se < ne, ie = "";
          J ? ie = B(J, { value: se }, L) : V.formatter && m(se) && (ie = V.formatter.call(this, se)), Q.attr({ text: ie, x: Z, y: ee, visibility: oe ? "inherit" : "hidden" });
          let le = Q.getBBox();
          !m(Q.x) || q || Y || (Z = Q.x - le.width / 2), m(Q.y) && (q ? (X && !Y || !X && Y) && (ee = Q.y - le.height) : ee = Q.y - le.height / 2), re = q ? { left: I, right: I + this.width } : { left: this.labelAlign === "left" ? I : 0, right: this.labelAlign === "right" ? I + this.width : L.chartWidth };
          let de = Q.translateX || 0;
          de < re.left && (ce = re.left - de), de + le.width >= re.right && (ce = -(de + le.width - re.right)), Q.attr({ x: Z + ce, y: ee, anchorX: q ? Z : this.opposite ? 0 : L.chartWidth, anchorY: q ? this.opposite ? L.chartHeight : 0 : ee + le.height / 2 });
        }
        function l() {
          this.crossLabel && (this.crossLabel = this.crossLabel.hide());
        }
        function b(R) {
          let L = this.chart, U = this.options, V = L._labelPanes = L._labelPanes || {}, q = U.labels;
          if (L.options.isStock && this.coll === "yAxis") {
            let Y = U.top + "," + U.height;
            !V[Y] && q.enabled && (q.distance === 15 && this.side === 1 && (q.distance = 0), q.align === void 0 && (q.align = "right"), V[Y] = this, R.align = "right", R.preventDefault());
          }
        }
        function u() {
          let R = this.chart, L = this.options && this.options.top + "," + this.options.height;
          L && R._labelPanes && R._labelPanes[L] === this && delete R._labelPanes[L];
        }
        function c(R) {
          let L = this, U = L.isLinked && !L.series && L.linkedParent ? L.linkedParent.series : L.series, V = L.chart, q = V.renderer, Y = L.left, I = L.top, _ = [], W = R.translatedValue, X = R.value, z = R.force, $, K, Q, Z, ee = [], J, ae;
          if (V.options.isStock && R.acrossPanes !== !1 && L.coll === "xAxis" || L.coll === "yAxis") {
            for (let re of (R.preventDefault(), ee = ((ce) => {
              let he = ce === "xAxis" ? "yAxis" : "xAxis", ne = L.options[he];
              return m(ne) ? [V[he][ne]] : A(ne) ? [V.get(ne)] : U.map((te) => te[he]);
            })(L.coll), L.isXAxis ? V.yAxis : V.xAxis)) if (!re.options.isInternal) {
              let ce = re.isXAxis ? "yAxis" : "xAxis";
              L === (p(re.options[ce]) ? V[ce][re.options[ce]] : V[ce][0]) && ee.push(re);
            }
            for (let re of (J = ee.length ? [] : [L.isXAxis ? V.yAxis[0] : V.xAxis[0]], ee)) J.indexOf(re) !== -1 || k(J, (ce) => ce.pos === re.pos && ce.len === re.len) || J.push(re);
            if (m(ae = H(W, L.translate(X || 0, void 0, void 0, R.old))))
              if (L.horiz) for (let re of J) {
                let ce;
                Z = (K = re.pos) + re.len, $ = Q = Math.round(ae + L.transB), z !== "pass" && ($ < Y || $ > Y + L.width) && (z ? $ = Q = x($, Y, Y + L.width) : ce = !0), ce || _.push(["M", $, K], ["L", Q, Z]);
              }
              else for (let re of J) {
                let ce;
                Q = ($ = re.pos) + re.len, K = Z = Math.round(I + L.height - ae), z !== "pass" && (K < I || K > I + L.height) && (z ? K = Z = x(K, I, I + L.height) : ce = !0), ce || _.push(["M", $, K], ["L", Q, Z]);
              }
            R.path = _.length > 0 ? q.crispPolyLine(_, R.lineWidth || 1) : void 0;
          }
        }
        function h(R) {
          if (this.chart.options.isStock) {
            let L;
            this.is("column") || this.is("columnrange") ? L = { borderWidth: 0, shadow: !1 } : this.is("scatter") || this.is("sma") || (L = { marker: { enabled: !1, radius: 2 } }), L && (R.plotOptions[this.type] = C(R.plotOptions[this.type], L));
          }
        }
        function g() {
          let R = this.chart, L = this.options.dataGrouping;
          return this.allowDG !== !1 && L && H(L.enabled, R.options.isStock);
        }
        function E(R, L) {
          for (let U = 0; U < R.length; U += 2) {
            let V = R[U], q = R[U + 1];
            p(V[1]) && V[1] === q[1] && (V[1] = q[1] = M(V[1], L)), p(V[2]) && V[2] === q[2] && (V[2] = q[2] = M(V[2], L));
          }
          return R;
        }
        d.compose = function(R, L, U, V) {
          let q = U.prototype;
          q.forceCropping || (w(L, "afterDrawCrosshair", s), w(L, "afterHideCrosshair", l), w(L, "autoLabelAlign", b), w(L, "destroy", u), w(L, "getPlotLinePath", c), R.prototype.setFixedRange = f, q.forceCropping = g, w(U, "setOptions", h), V.prototype.crispPolyLine = E);
        }, d.stockChart = function(R, L, U) {
          return new d(R, L, U);
        };
      }(S || (S = {})), S;
    }), a(e, "Series/HLC/HLCPoint.js", [e["Core/Series/SeriesRegistry.js"]], function(o) {
      let { column: { prototype: { pointClass: n } } } = o.seriesTypes;
      return class extends n {
      };
    }), a(e, "Series/HLC/HLCSeriesDefaults.js", [], function() {
      return { lineWidth: 1, tooltip: { pointFormat: '<span style="color:{point.color}">●</span> <b> {series.name}</b><br/>High: {point.high}<br/>Low: {point.low}<br/>Close: {point.close}<br/>' }, threshold: null, states: { hover: { lineWidth: 3 } }, stickyTracking: !0 };
    }), a(e, "Series/HLC/HLCSeries.js", [e["Series/HLC/HLCPoint.js"], e["Series/HLC/HLCSeriesDefaults.js"], e["Core/Series/SeriesRegistry.js"], e["Core/Utilities.js"]], function(o, n, r, T) {
      let { column: O } = r.seriesTypes, { crisp: j, extend: D, merge: F } = T;
      class B extends O {
        extendStem(f, w, x) {
          let M = f[0], p = f[1];
          typeof M[2] == "number" && (M[2] = Math.max(x + w, M[2])), typeof p[2] == "number" && (p[2] = Math.min(x - w, p[2]));
        }
        getPointPath(f, w) {
          let x = w.strokeWidth(), M = f.series, p = j(f.plotX || 0, x), v = Math.round(f.shapeArgs.width / 2), k = [["M", p, Math.round(f.yBottom)], ["L", p, Math.round(f.plotHigh)]];
          if (f.close !== null) {
            let m = j(f.plotClose, x);
            k.push(["M", p, m], ["L", p + v, m]), M.extendStem(k, x / 2, m);
          }
          return k;
        }
        drawSinglePoint(f) {
          let w = f.series, x = w.chart, M, p = f.graphic;
          f.plotY !== void 0 && (p || (f.graphic = p = x.renderer.path().add(w.group)), x.styledMode || p.attr(w.pointAttribs(f, f.selected && "select")), M = w.getPointPath(f, p), p[p ? "animate" : "attr"]({ d: M }).addClass(f.getClassName(), !0));
        }
        drawPoints() {
          this.points.forEach(this.drawSinglePoint);
        }
        init() {
          super.init.apply(this, arguments), this.options.stacking = void 0;
        }
        pointAttribs(f, w) {
          let x = super.pointAttribs.call(this, f, w);
          return delete x.fill, x;
        }
        toYData(f) {
          return [f.high, f.low, f.close];
        }
        translate() {
          let f = this, w = f.yAxis, x = this.pointArrayMap && this.pointArrayMap.slice() || [], M = x.map((p) => `plot${p.charAt(0).toUpperCase() + p.slice(1)}`);
          M.push("yBottom"), x.push("low"), super.translate.apply(f), f.points.forEach(function(p) {
            x.forEach(function(v, k) {
              let m = p[v];
              m !== null && (f.dataModify && (m = f.dataModify.modifyValue(m)), p[M[k]] = w.toPixels(m, !0));
            }), p.tooltipPos[1] = p.plotHigh + w.pos - f.chart.plotTop;
          });
        }
      }
      return B.defaultOptions = F(O.defaultOptions, n), D(B.prototype, { pointClass: o, animate: null, directTouch: !1, pointArrayMap: ["high", "low", "close"], pointAttrToOptions: { stroke: "color", "stroke-width": "lineWidth" }, pointValKey: "close" }), r.registerSeriesType("hlc", B), B;
    }), a(e, "Series/OHLC/OHLCPoint.js", [e["Core/Series/SeriesRegistry.js"]], function(o) {
      let { seriesTypes: { hlc: n } } = o;
      class r extends n.prototype.pointClass {
        getClassName() {
          return super.getClassName.call(this) + (this.open < this.close ? " highcharts-point-up" : " highcharts-point-down");
        }
        resolveUpColor() {
          this.open < this.close && !this.options.color && this.series.options.upColor && (this.color = this.series.options.upColor);
        }
        resolveColor() {
          super.resolveColor(), this.series.is("heikinashi") || this.resolveUpColor();
        }
        getZone() {
          let O = super.getZone();
          return this.resolveUpColor(), O;
        }
        applyOptions() {
          return super.applyOptions.apply(this, arguments), this.resolveColor && this.resolveColor(), this;
        }
      }
      return r;
    }), a(e, "Series/OHLC/OHLCSeriesDefaults.js", [], function() {
      return { tooltip: { pointFormat: '<span style="color:{point.color}">●</span> <b> {series.name}</b><br/>Open: {point.open}<br/>High: {point.high}<br/>Low: {point.low}<br/>Close: {point.close}<br/>' } };
    }), a(e, "Series/OHLC/OHLCSeries.js", [e["Core/Globals.js"], e["Series/OHLC/OHLCPoint.js"], e["Series/OHLC/OHLCSeriesDefaults.js"], e["Core/Series/SeriesRegistry.js"], e["Core/Utilities.js"]], function(o, n, r, T, O) {
      let { composed: j } = o, { hlc: D } = T.seriesTypes, { addEvent: F, crisp: B, extend: N, merge: f, pushUnique: w } = O;
      function x(v) {
        let k = v.options, m = k.dataGrouping;
        m && k.useOhlcData && k.id !== "highcharts-navigator-series" && (m.approximation = "ohlc");
      }
      function M(v) {
        let k = v.options;
        k.useOhlcData && k.id !== "highcharts-navigator-series" && N(this, { pointValKey: p.prototype.pointValKey, pointArrayMap: p.prototype.pointArrayMap, toYData: p.prototype.toYData });
      }
      class p extends D {
        static compose(k, ...m) {
          w(j, "OHLCSeries") && (F(k, "afterSetOptions", x), F(k, "init", M));
        }
        getPointPath(k, m) {
          let A = super.getPointPath(k, m), C = m.strokeWidth(), H = B(k.plotX || 0, C), G = Math.round(k.shapeArgs.width / 2);
          if (k.open !== null) {
            let P = B(k.plotOpen, C);
            A.push(["M", H, P], ["L", H - G, P]), super.extendStem(A, C / 2, P);
          }
          return A;
        }
        pointAttribs(k, m) {
          let A = super.pointAttribs.call(this, k, m), C = this.options;
          return delete A.fill, !k.options.color && C.upColor && k.open < k.close && (A.stroke = C.upColor), A;
        }
        toYData(k) {
          return [k.open, k.high, k.low, k.close];
        }
      }
      return p.defaultOptions = f(D.defaultOptions, r), N(p.prototype, { pointClass: n, pointArrayMap: ["open", "high", "low", "close"] }), T.registerSeriesType("ohlc", p), p;
    }), a(e, "Series/Candlestick/CandlestickSeriesDefaults.js", [], function() {
      return { states: { hover: { lineWidth: 2 } }, threshold: null, lineColor: "#000000", lineWidth: 1, upColor: "#ffffff", stickyTracking: !0 };
    }), a(e, "Series/Candlestick/CandlestickSeries.js", [e["Series/Candlestick/CandlestickSeriesDefaults.js"], e["Core/Series/SeriesRegistry.js"], e["Core/Utilities.js"]], function(o, n, r) {
      let { column: T, ohlc: O } = n.seriesTypes, { crisp: j, merge: D } = r;
      class F extends O {
        pointAttribs(N, f) {
          let w = T.prototype.pointAttribs.call(this, N, f), x = this.options, M = N.open < N.close, p = x.lineColor || this.color, v = N.color || this.color;
          if (w["stroke-width"] = x.lineWidth, w.fill = N.options.color || M && x.upColor || v, w.stroke = N.options.lineColor || M && x.upLineColor || p, f) {
            let k = x.states[f];
            w.fill = k.color || w.fill, w.stroke = k.lineColor || w.stroke, w["stroke-width"] = k.lineWidth || w["stroke-width"];
          }
          return w;
        }
        drawPoints() {
          let N = this.points, f = this.chart, w = this.yAxis.reversed;
          for (let x of N) {
            let M = x.graphic, p, v, k, m, A, C, H, G, P, y = !M;
            if (x.plotY !== void 0) {
              M || (x.graphic = M = f.renderer.path().add(this.group)), this.chart.styledMode || M.attr(this.pointAttribs(x, x.selected && "select")).shadow(this.options.shadow);
              let S = M.strokeWidth();
              H = j(x.plotX || 0, S), k = Math.min(p = x.plotOpen, v = x.plotClose), m = Math.max(p, v), P = Math.round(x.shapeArgs.width / 2), A = w ? m !== x.yBottom : Math.round(k) !== Math.round(x.plotHigh || 0), C = w ? Math.round(k) !== Math.round(x.plotHigh || 0) : m !== x.yBottom, k = j(k, S), m = j(m, S), (G = []).push(["M", H - P, m], ["L", H - P, k], ["L", H + P, k], ["L", H + P, m], ["Z"], ["M", H, k], ["L", H, A ? Math.round(w ? x.yBottom : x.plotHigh) : k], ["M", H, m], ["L", H, C ? Math.round(w ? x.plotHigh : x.yBottom) : m]), M[y ? "attr" : "animate"]({ d: G }).addClass(x.getClassName(), !0);
            }
          }
        }
      }
      return F.defaultOptions = D(O.defaultOptions, { tooltip: O.defaultOptions.tooltip }, o), n.registerSeriesType("candlestick", F), F;
    }), a(e, "Series/Flags/FlagsPoint.js", [e["Core/Series/SeriesRegistry.js"], e["Core/Utilities.js"]], function(o, n) {
      let { column: { prototype: { pointClass: r } } } = o.seriesTypes, { isNumber: T } = n;
      return class extends r {
        constructor() {
          super(...arguments), this.ttBelow = !1;
        }
        isValid() {
          return T(this.y) || this.y === void 0;
        }
        hasNewShapeType() {
          let O = this.options.shape || this.series.options.shape;
          return this.graphic && O && O !== this.graphic.symbolKey;
        }
      };
    }), a(e, "Series/Flags/FlagsSeriesDefaults.js", [], function() {
      return { borderRadius: 0, pointRange: 0, allowOverlapX: !1, shape: "flag", stackDistance: 12, textAlign: "center", tooltip: { pointFormat: "{point.text}" }, threshold: null, y: -30, fillColor: "#ffffff", lineWidth: 1, states: { hover: { lineColor: "#000000", fillColor: "#ccd3ff" } }, style: { fontSize: "0.7em", fontWeight: "bold" } };
    }), a(e, "Series/Flags/FlagsSymbols.js", [e["Core/Renderer/RendererRegistry.js"]], function(o) {
      var n;
      return function(r) {
        let T = [];
        function O(D, F, B, N, f) {
          let w = f && f.anchorX || D, x = f && f.anchorY || F, M = this.circle(w - 1, x - 1, 2, 2);
          return M.push(["M", w, x], ["L", D, F + N], ["L", D, F], ["L", D + B, F], ["L", D + B, F + N], ["L", D, F + N], ["Z"]), M;
        }
        function j(D, F) {
          D[F + "pin"] = function(B, N, f, w, x) {
            let M, p = x && x.anchorX, v = x && x.anchorY;
            if (F === "circle" && w > f && (B -= Math.round((w - f) / 2), f = w), M = D[F](B, N, f, w, x), p && v) {
              let k = p;
              if (F === "circle") k = B + f / 2;
              else {
                let A = M[0], C = M[1];
                A[0] === "M" && C[0] === "L" && (k = (A[1] + C[1]) / 2);
              }
              let m = N > v ? N : N + w;
              M.push(["M", k, m], ["L", p, v]), M = M.concat(D.circle(p - 1, v - 1, 2, 2));
            }
            return M;
          };
        }
        r.compose = function(D) {
          if (T.indexOf(D) === -1) {
            T.push(D);
            let B = D.prototype.symbols;
            B.flag = O, j(B, "circle"), j(B, "square");
          }
          let F = o.getRendererType();
          T.indexOf(F) && T.push(F);
        };
      }(n || (n = {})), n;
    }), a(e, "Series/OnSeriesComposition.js", [e["Series/Column/ColumnSeries.js"], e["Core/Globals.js"], e["Core/Series/Series.js"], e["Core/Utilities.js"]], function(o, n, r, T) {
      var O;
      let { composed: j } = n, { prototype: D } = o, { prototype: F } = r, { defined: B, pushUnique: N, stableSort: f } = T;
      return function(w) {
        function x(p) {
          return F.getPlotBox.call(this.options.onSeries && this.chart.get(this.options.onSeries) || this, p);
        }
        function M() {
          var U, V;
          D.translate.apply(this);
          let p = this, v = p.options, k = p.chart, m = p.points, A = v.onSeries, C = A && k.get(A), H = C && C.options.step, G = C && C.points, P = k.inverted, y = p.xAxis, S = p.yAxis, d = m.length - 1, s, l, b = v.onKey || "y", u = G && G.length, c = 0, h, g, E, R, L;
          if (C && C.visible && u) {
            for (c = (C.pointXOffset || 0) + (C.barW || 0) / 2, R = C.currentDataGrouping, g = G[u - 1].x + (R ? R.totalRange : 0), f(m, (q, Y) => q.x - Y.x), b = "plot" + b[0].toUpperCase() + b.substr(1); u-- && m[d]; ) if (h = G[u], (s = m[d]).y = h.y, h.x <= s.x && h[b] !== void 0) {
              if (s.x <= g && (s.plotY = h[b], h.x < s.x && !H && (E = G[u + 1]) && E[b] !== void 0))
                if (B(s.plotX) && C.is("spline")) {
                  let q = [h.plotX || 0, h.plotY || 0], Y = [E.plotX || 0, E.plotY || 0], I = ((U = h.controlPoints) == null ? void 0 : U.high) || q, _ = ((V = E.controlPoints) == null ? void 0 : V.low) || Y, W = (K, Q) => Math.pow(1 - K, 3) * q[Q] + 3 * (1 - K) * (1 - K) * K * I[Q] + 3 * (1 - K) * K * K * _[Q] + K * K * K * Y[Q], X = 0, z = 1, $;
                  for (let K = 0; K < 100; K++) {
                    let Q = (X + z) / 2, Z = W(Q, 0);
                    if (Z === null) break;
                    if (0.25 > Math.abs(Z - s.plotX)) {
                      $ = Q;
                      break;
                    }
                    Z < s.plotX ? X = Q : z = Q;
                  }
                  B($) && (s.plotY = W($, 1), s.y = S.toValue(s.plotY, !0));
                } else L = (s.x - h.x) / (E.x - h.x), s.plotY += L * (E[b] - h[b]), s.y += L * (E.y - h.y);
              if (d--, u++, d < 0) break;
            }
          }
          m.forEach((q, Y) => {
            let I;
            q.plotX += c, (q.plotY === void 0 || P) && (q.plotX >= 0 && q.plotX <= y.len ? P ? (q.plotY = y.translate(q.x, 0, 1, 0, 1), q.plotX = B(q.y) ? S.translate(q.y, 0, 0, 0, 1) : 0) : q.plotY = (y.opposite ? 0 : p.yAxis.len) + y.offset : q.shapeArgs = {}), (l = m[Y - 1]) && l.plotX === q.plotX && (l.stackIndex === void 0 && (l.stackIndex = 0), I = l.stackIndex + 1), q.stackIndex = I;
          }), this.onSeries = C;
        }
        w.compose = function(p) {
          if (N(j, "OnSeries")) {
            let v = p.prototype;
            v.getPlotBox = x, v.translate = M;
          }
          return p;
        }, w.getPlotBox = x, w.translate = M;
      }(O || (O = {})), O;
    }), a(e, "Series/Flags/FlagsSeries.js", [e["Series/Flags/FlagsPoint.js"], e["Series/Flags/FlagsSeriesDefaults.js"], e["Series/Flags/FlagsSymbols.js"], e["Core/Globals.js"], e["Series/OnSeriesComposition.js"], e["Core/Renderer/RendererUtilities.js"], e["Core/Series/SeriesRegistry.js"], e["Core/Renderer/SVG/SVGElement.js"], e["Core/Utilities.js"]], function(o, n, r, T, O, j, D, F, B) {
      let { noop: N } = T, { distribute: f } = j, { series: w, seriesTypes: { column: x } } = D, { addEvent: M, defined: p, extend: v, isNumber: k, merge: m, objectEach: A, wrap: C } = B;
      class H extends x {
        animate(P) {
          P && this.setClip();
        }
        drawPoints() {
          var X, z;
          let P, y, S, d, s, l, b, u, c, h, g, E = this.points, R = this.chart, L = R.renderer, U = R.inverted, V = this.options, q = V.y, Y = this.yAxis, I = {}, _ = [], W = k(V.borderRadius) ? V.borderRadius : 0;
          for (d = E.length; d--; ) s = E[d], h = (U ? s.plotY : s.plotX) > this.xAxis.len, P = s.plotX, b = s.stackIndex, S = s.options.shape || V.shape, (y = s.plotY) !== void 0 && (y = s.plotY + q - (b !== void 0 && b * V.stackDistance)), s.anchorX = b ? void 0 : s.plotX, u = b ? void 0 : s.plotY, g = S !== "flag", l = s.graphic, y !== void 0 && P >= 0 && !h ? (l && s.hasNewShapeType() && (l = l.destroy()), l || (l = s.graphic = L.label("", 0, void 0, S, void 0, void 0, V.useHTML).addClass("highcharts-point").add(this.markerGroup), s.graphic.div && (s.graphic.div.point = s), l.isNew = !0), l.attr({ align: g ? "center" : "left", width: V.width, height: V.height, "text-align": V.textAlign, r: W }), R.styledMode || l.attr(this.pointAttribs(s)).css(m(V.style, s.style)).shadow(V.shadow), P > 0 && (P -= l.strokeWidth() % 2), c = { y, anchorY: u }, V.allowOverlapX && (c.x = P, c.anchorX = s.anchorX), l.attr({ text: (z = (X = s.options.title) != null ? X : V.title) != null ? z : "A" })[l.isNew ? "attr" : "animate"](c), V.allowOverlapX || (I[s.plotX] ? I[s.plotX].size = Math.max(I[s.plotX].size, l.width || 0) : I[s.plotX] = { align: g ? 0.5 : 0, size: l.width || 0, target: P, anchorX: P }), s.tooltipPos = [P, y + Y.pos - R.plotTop]) : l && (s.graphic = l.destroy());
          if (!V.allowOverlapX) {
            let $ = 100;
            for (let K of (A(I, function(Q) {
              Q.plotX = Q.anchorX, _.push(Q), $ = Math.max(Q.size, $);
            }), f(_, U ? Y.len : this.xAxis.len, $), E)) {
              let Q = K.plotX, Z = K.graphic, ee = Z && I[Q];
              ee && Z && (p(ee.pos) ? Z[Z.isNew ? "attr" : "animate"]({ x: ee.pos + (ee.align || 0) * ee.size, anchorX: K.anchorX }).show().isNew = !1 : Z.hide().isNew = !0);
            }
          }
          V.useHTML && this.markerGroup && C(this.markerGroup, "on", function($) {
            return F.prototype.on.apply($.apply(this, [].slice.call(arguments, 1)), [].slice.call(arguments, 1));
          });
        }
        drawTracker() {
          let P = this.points;
          for (let y of (super.drawTracker(), P)) {
            let S = y.graphic;
            S && (y.unbindMouseOver && y.unbindMouseOver(), y.unbindMouseOver = M(S.element, "mouseover", function() {
              for (let d of (y.stackIndex > 0 && !y.raised && (y._y = S.y, S.attr({ y: y._y - 8 }), y.raised = !0), P)) d !== y && d.raised && d.graphic && (d.graphic.attr({ y: d._y }), d.raised = !1);
            }));
          }
        }
        pointAttribs(P, y) {
          let S = this.options, d = P && P.color || this.color, s = S.lineColor, l = P && P.lineWidth, b = P && P.fillColor || S.fillColor;
          return y && (b = S.states[y].fillColor, s = S.states[y].lineColor, l = S.states[y].lineWidth), { fill: b || d, stroke: s || d, "stroke-width": l || S.lineWidth || 0 };
        }
        setClip() {
          w.prototype.setClip.apply(this, arguments), this.options.clip !== !1 && this.sharedClipKey && this.markerGroup && this.markerGroup.clip(this.chart.sharedClips[this.sharedClipKey]);
        }
      }
      return H.compose = r.compose, H.defaultOptions = m(x.defaultOptions, n), O.compose(H), v(H.prototype, { allowDG: !1, forceCrop: !0, invertible: !1, noSharedTooltip: !0, pointClass: o, sorted: !1, takeOrdinalPosition: !1, trackerGroups: ["markerGroup"], buildKDTree: N, init: w.prototype.init }), D.registerSeriesType("flags", H), H;
    }), a(e, "Core/Axis/BrokenAxis.js", [e["Core/Axis/Stacking/StackItem.js"], e["Core/Utilities.js"]], function(o, n) {
      var r;
      let { addEvent: T, find: O, fireEvent: j, isArray: D, isNumber: F, pick: B } = n;
      return function(N) {
        function f() {
          this.brokenAxis !== void 0 && this.brokenAxis.setBreaks(this.options.breaks, !1);
        }
        function w() {
          var C;
          (C = this.brokenAxis) != null && C.hasBreaks && (this.options.ordinal = !1);
        }
        function x() {
          let C = this.brokenAxis;
          if (C != null && C.hasBreaks) {
            let H = this.tickPositions, G = this.tickPositions.info, P = [];
            for (let y = 0; y < H.length; y++) C.isInAnyBreak(H[y]) || P.push(H[y]);
            this.tickPositions = P, this.tickPositions.info = G;
          }
        }
        function M() {
          this.brokenAxis || (this.brokenAxis = new A(this));
        }
        function p() {
          var S, d;
          let { isDirty: C, options: { connectNulls: H }, points: G, xAxis: P, yAxis: y } = this;
          if (C) {
            let s = G.length;
            for (; s--; ) {
              let l = G[s], b = !(l.y === null && H === !1) && (((S = P == null ? void 0 : P.brokenAxis) == null ? void 0 : S.isInAnyBreak(l.x, !0)) || ((d = y == null ? void 0 : y.brokenAxis) == null ? void 0 : d.isInAnyBreak(l.y, !0)));
              l.visible = !b && l.options.visible !== !1;
            }
          }
        }
        function v() {
          this.drawBreaks(this.xAxis, ["x"]), this.drawBreaks(this.yAxis, B(this.pointArrayMap, ["y"]));
        }
        function k(C, H) {
          var s;
          let G, P, y, S = this, d = S.points;
          if ((s = C == null ? void 0 : C.brokenAxis) != null && s.hasBreaks) {
            let l = C.brokenAxis;
            H.forEach(function(b) {
              var c, h;
              G = (l == null ? void 0 : l.breakArray) || [], P = C.isXAxis ? C.min : B(S.options.threshold, C.min);
              let u = (h = (c = C == null ? void 0 : C.options) == null ? void 0 : c.breaks) == null ? void 0 : h.filter(function(g) {
                let E = !0;
                for (let R = 0; R < G.length; R++) {
                  let L = G[R];
                  if (L.from === g.from && L.to === g.to) {
                    E = !1;
                    break;
                  }
                }
                return E;
              });
              d.forEach(function(g) {
                y = B(g["stack" + b.toUpperCase()], g[b]), G.forEach(function(E) {
                  if (F(P) && F(y)) {
                    let R = "";
                    P < E.from && y > E.to || P > E.from && y < E.from ? R = "pointBreak" : (P < E.from && y > E.from && y < E.to || P > E.from && y > E.to && y < E.from) && (R = "pointInBreak"), R && j(C, R, { point: g, brk: E });
                  }
                }), u == null || u.forEach(function(E) {
                  j(C, "pointOutsideOfBreak", { point: g, brk: E });
                });
              });
            });
          }
        }
        function m() {
          let C = this.currentDataGrouping, H = C == null ? void 0 : C.gapSize, G = this.points.slice(), P = this.yAxis, y = this.options.gapSize, S = G.length - 1;
          if (y && S > 0) {
            let d, s;
            for (this.options.gapUnit !== "value" && (y *= this.basePointRange), H && H > y && H >= this.basePointRange && (y = H); S--; ) if (s && s.visible !== !1 || (s = G[S + 1]), d = G[S], s.visible !== !1 && d.visible !== !1) {
              if (s.x - d.x > y) {
                let l = (d.x + s.x) / 2;
                G.splice(S + 1, 0, { isNull: !0, x: l }), P.stacking && this.options.stacking && ((P.stacking.stacks[this.stackKey][l] = new o(P, P.options.stackLabels, !1, l, this.stack)).total = 0);
              }
              s = d;
            }
          }
          return this.getGraphPath(G);
        }
        N.compose = function(C, H) {
          if (!C.keepProps.includes("brokenAxis")) {
            C.keepProps.push("brokenAxis"), T(C, "init", M), T(C, "afterInit", f), T(C, "afterSetTickPositions", x), T(C, "afterSetOptions", w);
            let G = H.prototype;
            G.drawBreaks = k, G.gappedPath = m, T(H, "afterGeneratePoints", p), T(H, "afterRender", v);
          }
          return C;
        };
        class A {
          static isInBreak(H, G) {
            let P = H.repeat || 1 / 0, y = H.from, S = H.to - H.from, d = G >= y ? (G - y) % P : P - (y - G) % P;
            return H.inclusive ? d <= S : d < S && d !== 0;
          }
          static lin2Val(H) {
            let G = this.brokenAxis, P = G && G.breakArray;
            if (!P || !F(H)) return H;
            let y = H, S, d;
            for (d = 0; d < P.length && !((S = P[d]).from >= y); d++) (S.to < y || A.isInBreak(S, y)) && (y += S.len);
            return y;
          }
          static val2Lin(H) {
            let G = this.brokenAxis, P = G && G.breakArray;
            if (!P || !F(H)) return H;
            let y = H, S, d;
            for (d = 0; d < P.length; d++) if ((S = P[d]).to <= H) y -= S.len;
            else {
              if (S.from >= H) break;
              if (A.isInBreak(S, H)) {
                y -= H - S.from;
                break;
              }
            }
            return y;
          }
          constructor(H) {
            this.hasBreaks = !1, this.axis = H;
          }
          findBreakAt(H, G) {
            return O(G, function(P) {
              return P.from < H && H < P.to;
            });
          }
          isInAnyBreak(H, G) {
            let P = this.axis, y = P.options.breaks || [], S = y.length, d, s, l;
            if (S && F(H)) {
              for (; S--; ) A.isInBreak(y[S], H) && (d = !0, s || (s = B(y[S].showPoints, !P.isXAxis)));
              l = d && G ? d && !s : d;
            }
            return l;
          }
          setBreaks(H, G) {
            let P = this, y = P.axis, S = D(H) && !!H.length && !!Object.keys(H[0]).length;
            y.isDirty = P.hasBreaks !== S, P.hasBreaks = S, H !== y.options.breaks && (y.options.breaks = y.userOptions.breaks = H), y.forceRedraw = !0, y.series.forEach(function(d) {
              d.isDirty = !0;
            }), S || y.val2lin !== A.val2Lin || (delete y.val2lin, delete y.lin2val), S && (y.userOptions.ordinal = !1, y.lin2val = A.lin2Val, y.val2lin = A.val2Lin, y.setExtremes = function(d, s, l, b, u) {
              if (P.hasBreaks) {
                let c, h = this.options.breaks || [];
                for (; c = P.findBreakAt(d, h); ) d = c.to;
                for (; c = P.findBreakAt(s, h); ) s = c.from;
                s < d && (s = d);
              }
              y.constructor.prototype.setExtremes.call(this, d, s, l, b, u);
            }, y.setAxisTranslation = function() {
              if (y.constructor.prototype.setAxisTranslation.call(this), P.unitLength = void 0, P.hasBreaks) {
                let d = y.options.breaks || [], s = [], l = [], b = B(y.pointRangePadding, 0), u = 0, c, h, g = y.userMin || y.min, E = y.userMax || y.max, R, L;
                d.forEach(function(U) {
                  h = U.repeat || 1 / 0, F(g) && F(E) && (A.isInBreak(U, g) && (g += U.to % h - g % h), A.isInBreak(U, E) && (E -= E % h - U.from % h));
                }), d.forEach(function(U) {
                  if (R = U.from, h = U.repeat || 1 / 0, F(g) && F(E)) {
                    for (; R - h > g; ) R -= h;
                    for (; R < g; ) R += h;
                    for (L = R; L < E; L += h) s.push({ value: L, move: "in" }), s.push({ value: L + U.to - U.from, move: "out", size: U.breakSize });
                  }
                }), s.sort(function(U, V) {
                  return U.value === V.value ? (U.move === "in" ? 0 : 1) - (V.move === "in" ? 0 : 1) : U.value - V.value;
                }), c = 0, R = g, s.forEach(function(U) {
                  (c += U.move === "in" ? 1 : -1) === 1 && U.move === "in" && (R = U.value), c === 0 && F(R) && (l.push({ from: R, to: U.value, len: U.value - R - (U.size || 0) }), u += U.value - R - (U.size || 0));
                }), P.breakArray = l, F(g) && F(E) && F(y.min) && (P.unitLength = E - g - u + b, j(y, "afterBreaks"), y.staticScale ? y.transA = y.staticScale : P.unitLength && (y.transA *= (E - y.min + b) / P.unitLength), b && (y.minPixelPadding = y.transA * (y.minPointOffset || 0)), y.min = g, y.max = E);
              }
            }), B(G, !0) && y.chart.redraw();
          }
        }
        N.Additions = A;
      }(r || (r = {})), r;
    }), a(e, "masters/modules/broken-axis.src.js", [e["Core/Globals.js"], e["Core/Axis/BrokenAxis.js"]], function(o, n) {
      return o.BrokenAxis = o.BrokenAxis || n, o.BrokenAxis.compose(o.Axis, o.Series), o;
    }), a(e, "Extensions/DataGrouping/ApproximationRegistry.js", [], function() {
      return {};
    }), a(e, "Extensions/DataGrouping/ApproximationDefaults.js", [e["Extensions/DataGrouping/ApproximationRegistry.js"], e["Core/Utilities.js"]], function(o, n) {
      let { arrayMax: r, arrayMin: T, correctFloat: O, extend: j, isNumber: D } = n;
      function F(f) {
        let w = f.length, x = B(f);
        return D(x) && w && (x = O(x / w)), x;
      }
      function B(f) {
        let w = f.length, x;
        if (!w && f.hasNulls) x = null;
        else if (w) for (x = 0; w--; ) x += f[w];
        return x;
      }
      let N = { average: F, averages: function() {
        let f = [];
        return [].forEach.call(arguments, function(w) {
          f.push(F(w));
        }), f[0] === void 0 ? void 0 : f;
      }, close: function(f) {
        return f.length ? f[f.length - 1] : f.hasNulls ? null : void 0;
      }, high: function(f) {
        return f.length ? r(f) : f.hasNulls ? null : void 0;
      }, hlc: function(f, w, x) {
        if (f = o.high(f), w = o.low(w), x = o.close(x), D(f) || D(w) || D(x)) return [f, w, x];
      }, low: function(f) {
        return f.length ? T(f) : f.hasNulls ? null : void 0;
      }, ohlc: function(f, w, x, M) {
        if (f = o.open(f), w = o.high(w), x = o.low(x), M = o.close(M), D(f) || D(w) || D(x) || D(M)) return [f, w, x, M];
      }, open: function(f) {
        return f.length ? f[0] : f.hasNulls ? null : void 0;
      }, range: function(f, w) {
        return f = o.low(f), w = o.high(w), D(f) || D(w) ? [f, w] : f === null && w === null ? null : void 0;
      }, sum: B };
      return j(o, N), N;
    }), a(e, "Extensions/DataGrouping/DataGroupingDefaults.js", [], function() {
      return { common: { groupPixelWidth: 2, dateTimeLabelFormats: { millisecond: ["%A, %e %b, %H:%M:%S.%L", "%A, %e %b, %H:%M:%S.%L", "-%H:%M:%S.%L"], second: ["%A, %e %b, %H:%M:%S", "%A, %e %b, %H:%M:%S", "-%H:%M:%S"], minute: ["%A, %e %b, %H:%M", "%A, %e %b, %H:%M", "-%H:%M"], hour: ["%A, %e %b, %H:%M", "%A, %e %b, %H:%M", "-%H:%M"], day: ["%A, %e %b %Y", "%A, %e %b", "-%A, %e %b %Y"], week: ["Week from %A, %e %b %Y", "%A, %e %b", "-%A, %e %b %Y"], month: ["%B %Y", "%B", "-%B %Y"], year: ["%Y", "%Y", "-%Y"] } }, seriesSpecific: { line: {}, spline: {}, area: {}, areaspline: {}, arearange: {}, column: { groupPixelWidth: 10 }, columnrange: { groupPixelWidth: 10 }, candlestick: { groupPixelWidth: 10 }, ohlc: { groupPixelWidth: 5 }, hlc: { groupPixelWidth: 5 }, heikinashi: { groupPixelWidth: 10 } }, units: [["millisecond", [1, 2, 5, 10, 20, 25, 50, 100, 200, 500]], ["second", [1, 2, 5, 10, 15, 30]], ["minute", [1, 2, 5, 10, 15, 30]], ["hour", [1, 2, 3, 4, 6, 8, 12]], ["day", [1]], ["week", [1]], ["month", [1, 3, 6]], ["year", null]] };
    }), a(e, "Extensions/DataGrouping/DataGroupingAxisComposition.js", [e["Extensions/DataGrouping/DataGroupingDefaults.js"], e["Core/Utilities.js"]], function(o, n) {
      let r, { addEvent: T, extend: O, merge: j, pick: D } = n;
      function F(w) {
        let x = this, M = x.series;
        M.forEach(function(p) {
          p.groupPixelWidth = void 0;
        }), M.forEach(function(p) {
          p.groupPixelWidth = x.getGroupPixelWidth && x.getGroupPixelWidth(), p.groupPixelWidth && (p.hasProcessed = !0), p.applyGrouping(!!w.hasExtremesChanged);
        });
      }
      function B() {
        let w = this.series, x = w.length, M = 0, p = !1, v, k;
        for (; x--; ) (k = w[x].options.dataGrouping) && (M = Math.max(M, D(k.groupPixelWidth, o.common.groupPixelWidth)), v = (w[x].processedXData || w[x].data).length, (w[x].groupPixelWidth || v > this.chart.plotSizeX / M || v && k.forced) && (p = !0));
        return p ? M : 0;
      }
      function N() {
        this.series.forEach(function(w) {
          w.hasProcessed = !1;
        });
      }
      function f(w, x) {
        let M;
        if (x = D(x, !0), w || (w = { forced: !1, units: null }), this instanceof r) for (M = this.series.length; M--; ) this.series[M].update({ dataGrouping: w }, !1);
        else this.chart.options.series.forEach(function(p) {
          p.dataGrouping = typeof w == "boolean" ? w : j(w, p.dataGrouping);
        });
        this.ordinal && (this.ordinal.slope = void 0), x && this.chart.redraw();
      }
      return { compose: function(w) {
        r = w;
        let x = w.prototype;
        x.applyGrouping || (T(w, "afterSetScale", N), T(w, "postProcessData", F), O(x, { applyGrouping: F, getGroupPixelWidth: B, setDataGrouping: f }));
      } };
    }), a(e, "Extensions/DataGrouping/DataGroupingSeriesComposition.js", [e["Extensions/DataGrouping/ApproximationRegistry.js"], e["Extensions/DataGrouping/DataGroupingDefaults.js"], e["Core/Axis/DateTimeAxis.js"], e["Core/Defaults.js"], e["Core/Series/SeriesRegistry.js"], e["Core/Utilities.js"]], function(o, n, r, T, O, j) {
      let { series: { prototype: D } } = O, { addEvent: F, defined: B, error: N, extend: f, isNumber: w, merge: x, pick: M } = j, p = D.generatePoints;
      function v(G) {
        var P;
        let y, S, d = this.chart, s = this.options.dataGrouping, l = this.allowDG !== !1 && s && M(s.enabled, d.options.isStock), b = this.reserveSpace(), u = this.currentDataGrouping, c, h, g = !1;
        l && !this.requireSorting && (this.requireSorting = g = !0);
        let E = !!(this.isCartesian && !this.isDirty && !this.xAxis.isDirty && !this.yAxis.isDirty && !G) || !l;
        if (g && (this.requireSorting = !1), E) return;
        this.destroyGroupedData();
        let R = s.groupAll ? this.xData : this.processedXData, L = s.groupAll ? this.yData : this.processedYData, U = d.plotSizeX, V = this.xAxis, q = V.options.ordinal, Y = this.groupPixelWidth;
        if (Y && R && R.length && U) {
          S = !0, this.isDirty = !0, this.points = null;
          let I = V.getExtremes(), _ = I.min, W = I.max, X = q && V.ordinal && V.ordinal.getGroupIntervalFactor(_, W, this) || 1, z = Y * (W - _) / U * X, $ = V.getTimeTicks(r.Additions.prototype.normalizeTimeTickInterval(z, s.units || n.units), Math.min(_, R[0]), Math.max(W, R[R.length - 1]), V.options.startOfWeek, R, this.closestPointRange), K = D.groupData.apply(this, [R, L, $, s.approximation]), Q = K.groupedXData, Z = K.groupedYData, ee = 0;
          for (s && s.smoothed && Q.length && (s.firstAnchor = "firstPoint", s.anchor = "middle", s.lastAnchor = "lastPoint", N(32, !1, d, { "dataGrouping.smoothed": "use dataGrouping.anchor" })), y = 1; y < $.length; y++) $.info.segmentStarts && $.info.segmentStarts.indexOf(y) !== -1 || (ee = Math.max($[y] - $[y - 1], ee));
          (c = $.info).gapSize = ee, this.closestPointRange = $.info.totalRange, this.groupMap = K.groupMap, this.currentDataGrouping = c, function(J, ae, re) {
            let ce = J.options.dataGrouping, he = J.currentDataGrouping && J.currentDataGrouping.gapSize;
            if (!(ce && J.xData && he && J.groupMap)) return;
            let ne = ae.length - 1, te = ce.anchor, se = ce.firstAnchor, oe = ce.lastAnchor, ie = ae.length - 1, le = 0;
            if (se && J.xData[0] >= ae[0]) {
              let de;
              le++;
              let be = J.groupMap[0].start, ge = J.groupMap[0].length;
              w(be) && w(ge) && (de = be + (ge - 1)), ae[0] = { start: ae[0], middle: ae[0] + 0.5 * he, end: ae[0] + he, firstPoint: J.xData[0], lastPoint: de && J.xData[de] }[se];
            }
            if (ne > 0 && oe && he && ae[ne] >= re - he) {
              ie--;
              let de = J.groupMap[J.groupMap.length - 1].start;
              ae[ne] = { start: ae[ne], middle: ae[ne] + 0.5 * he, end: ae[ne] + he, firstPoint: de && J.xData[de], lastPoint: J.xData[J.xData.length - 1] }[oe];
            }
            if (te && te !== "start") {
              let de = he * { middle: 0.5, end: 1 }[te];
              for (; ie >= le; ) ae[ie] += de, ie--;
            }
          }(this, Q, W), b && (B((P = Q)[0]) && w(V.min) && w(V.dataMin) && P[0] < V.min && ((!B(V.options.min) && V.min <= V.dataMin || V.min === V.dataMin) && (V.min = Math.min(P[0], V.min)), V.dataMin = Math.min(P[0], V.dataMin)), B(P[P.length - 1]) && w(V.max) && w(V.dataMax) && P[P.length - 1] > V.max && ((!B(V.options.max) && w(V.dataMax) && V.max >= V.dataMax || V.max === V.dataMax) && (V.max = Math.max(P[P.length - 1], V.max)), V.dataMax = Math.max(P[P.length - 1], V.dataMax))), s.groupAll && (this.allGroupedData = Z, Q = (h = this.cropData(Q, Z, V.min, V.max)).xData, Z = h.yData, this.cropStart = h.start), this.processedXData = Q, this.processedYData = Z;
        } else this.groupMap = null, this.currentDataGrouping = void 0;
        this.hasGroupedData = S, this.preventGraphAnimation = (u && u.totalRange) !== (c && c.totalRange);
      }
      function k() {
        this.groupedData && (this.groupedData.forEach(function(G, P) {
          G && (this.groupedData[P] = G.destroy ? G.destroy() : null);
        }, this), this.groupedData.length = 0, delete this.allGroupedData);
      }
      function m() {
        p.apply(this), this.destroyGroupedData(), this.groupedData = this.hasGroupedData ? this.points : null;
      }
      function A() {
        return this.is("arearange") ? "range" : this.is("ohlc") ? "ohlc" : this.is("hlc") ? "hlc" : this.is("column") || this.options.cumulative ? "sum" : "average";
      }
      function C(G, P, y, S) {
        let d = this, s = d.data, l = d.options && d.options.data, b = [], u = [], c = [], h = G.length, g = !!P, E = [], R = d.pointArrayMap, L = R && R.length, U = ["x"].concat(R || ["y"]), V = this.options.dataGrouping && this.options.dataGrouping.groupAll, q, Y, I, _ = 0, W = 0, X = typeof S == "function" ? S : S && o[S] ? o[S] : o[d.getDGApproximation && d.getDGApproximation() || "average"];
        if (L) {
          let $ = R.length;
          for (; $--; ) E.push([]);
        } else E.push([]);
        let z = L || 1;
        for (let $ = 0; $ <= h; $++) if (!(G[$] < y[0])) {
          for (; y[_ + 1] !== void 0 && G[$] >= y[_ + 1] || $ === h; ) {
            q = y[_], d.dataGroupInfo = { start: V ? W : d.cropStart + W, length: E[0].length, groupStart: q }, I = X.apply(d, E), d.pointClass && !B(d.dataGroupInfo.options) && (d.dataGroupInfo.options = x(d.pointClass.prototype.optionsToObject.call({ series: d }, d.options.data[d.cropStart + W])), U.forEach(function(K) {
              delete d.dataGroupInfo.options[K];
            })), I !== void 0 && (b.push(q), u.push(I), c.push(d.dataGroupInfo)), W = $;
            for (let K = 0; K < z; K++) E[K].length = 0, E[K].hasNulls = !1;
            if (_ += 1, $ === h) break;
          }
          if ($ === h) break;
          if (R) {
            let K, Q = d.options.dataGrouping && d.options.dataGrouping.groupAll ? $ : d.cropStart + $, Z = s && s[Q] || d.pointClass.prototype.applyOptions.apply({ series: d }, [l[Q]]);
            for (let ee = 0; ee < L; ee++) w(K = Z[R[ee]]) ? E[ee].push(K) : K === null && (E[ee].hasNulls = !0);
          } else w(Y = g ? P[$] : null) ? E[0].push(Y) : Y === null && (E[0].hasNulls = !0);
        }
        return { groupedXData: b, groupedYData: u, groupMap: c };
      }
      function H(G) {
        let P = G.options, y = this.type, S = this.chart.options.plotOptions, d = this.useCommonDataGrouping && n.common, s = n.seriesSpecific, l = T.defaultOptions.plotOptions[y].dataGrouping;
        if (S && (s[y] || d)) {
          let b = this.chart.rangeSelector;
          l || (l = x(n.common, s[y])), P.dataGrouping = x(d, l, S.series && S.series.dataGrouping, S[y].dataGrouping, this.userOptions.dataGrouping, !P.isInternal && b && w(b.selected) && b.buttonOptions[b.selected].dataGrouping);
        }
      }
      return { compose: function(G) {
        let P = G.prototype;
        P.applyGrouping || (F(G.prototype.pointClass, "update", function() {
          if (this.dataGroup) return N(24, !1, this.series.chart), !1;
        }), F(G, "afterSetOptions", H), F(G, "destroy", k), f(P, { applyGrouping: v, destroyGroupedData: k, generatePoints: m, getDGApproximation: A, groupData: C }));
      }, groupData: C };
    }), a(e, "Extensions/DataGrouping/DataGrouping.js", [e["Extensions/DataGrouping/DataGroupingAxisComposition.js"], e["Extensions/DataGrouping/DataGroupingDefaults.js"], e["Extensions/DataGrouping/DataGroupingSeriesComposition.js"], e["Core/Templating.js"], e["Core/Globals.js"], e["Core/Utilities.js"]], function(o, n, r, T, O, j) {
      let { format: D } = T, { composed: F } = O, { addEvent: B, extend: N, isNumber: f, pick: w, pushUnique: x } = j;
      function M(p) {
        var h;
        let v = this.chart, k = v.time, m = p.labelConfig, A = m.series, C = m.point, H = A.options, G = A.tooltipOptions, P = H.dataGrouping, y = A.xAxis, S = G.xDateFormat, d, s, l, b, u, c = G[p.isFooter ? "footerFormat" : "headerFormat"];
        if (y && y.options.type === "datetime" && P && f(m.key)) {
          s = A.currentDataGrouping, l = P.dateTimeLabelFormats || n.common.dateTimeLabelFormats, s ? (b = l[s.unitName], s.count === 1 ? S = b[0] : (S = b[1], d = b[2])) : !S && l && y.dateTime && (S = y.dateTime.getXDateFormat(m.x, G.dateTimeLabelFormats));
          let g = w((h = A.groupMap) == null ? void 0 : h[C.index].groupStart, m.key), E = g + (s == null ? void 0 : s.totalRange) - 1;
          u = k.dateFormat(S, g), d && (u += k.dateFormat(d, E)), A.chart.styledMode && (c = this.styledModeFormat(c)), p.text = D(c, { point: N(m.point, { key: u }), series: A }, v), p.preventDefault();
        }
      }
      return { compose: function(p, v, k) {
        o.compose(p), r.compose(v), k && x(F, "DataGrouping") && B(k, "headerFormatter", M);
      }, groupData: r.groupData };
    }), a(e, "masters/modules/datagrouping.src.js", [e["Core/Globals.js"], e["Extensions/DataGrouping/ApproximationDefaults.js"], e["Extensions/DataGrouping/ApproximationRegistry.js"], e["Extensions/DataGrouping/DataGrouping.js"]], function(o, n, r, T) {
      return o.dataGrouping = o.dataGrouping || {}, o.dataGrouping.approximationDefaults = o.dataGrouping.approximationDefaults || n, o.dataGrouping.approximations = o.dataGrouping.approximations || r, T.compose(o.Axis, o.Series, o.Tooltip), o;
    }), a(e, "Extensions/Annotations/NavigationBindingsUtilities.js", [e["Core/Utilities.js"]], function(o) {
      let { defined: n, isNumber: r, pick: T } = o, O = { backgroundColor: "string", borderColor: "string", borderRadius: "string", color: "string", fill: "string", fontSize: "string", labels: "string", name: "string", stroke: "string", title: "string" };
      return { annotationsFieldsTypes: O, getAssignedAxis: function(j) {
        return j.filter((D) => {
          let F = D.axis.getExtremes(), B = F.min, N = F.max, f = T(D.axis.minPointOffset, 0);
          return r(B) && r(N) && D.value >= B - f && D.value <= N + f && !D.axis.options.isInternal;
        })[0];
      }, getFieldType: function(j, D) {
        let F = O[j], B = typeof D;
        return n(F) && (B = F), { string: "text", number: "number", boolean: "checkbox" }[B];
      } };
    }), a(e, "Extensions/MouseWheelZoom/MouseWheelZoom.js", [e["Core/Utilities.js"], e["Extensions/Annotations/NavigationBindingsUtilities.js"]], function(o, n) {
      let r, { addEvent: T, isObject: O, pick: j, defined: D, merge: F } = o, { getAssignedAxis: B } = n, N = [], f = { enabled: !0, sensitivity: 1.1 }, w = (p) => (O(p) || (p = { enabled: p != null ? p : !0 }), F(f, p)), x = function(p, v, k, m, A, C, H) {
        let G = j(H.type, p.zooming.type, ""), P = [];
        G === "x" ? P = k : G === "y" ? P = m : G === "xy" && (P = p.axes);
        let y = p.transform({ axes: P, to: { x: A - 5, y: C - 5, width: 10, height: 10 }, from: { x: A - 5 * v, y: C - 5 * v, width: 10 * v, height: 10 * v }, trigger: "mousewheel" });
        return y && (D(r) && clearTimeout(r), r = setTimeout(() => {
          var S;
          (S = p.pointer) == null || S.drop();
        }, 400)), y;
      };
      function M() {
        let p = w(this.zooming.mouseWheel);
        p.enabled && T(this.container, "wheel", (v) => {
          var A, C;
          v = ((A = this.pointer) == null ? void 0 : A.normalize(v)) || v;
          let { pointer: k } = this, m = k && !k.inClass(v.target, "highcharts-no-mousewheel");
          if (this.isInsidePlot(v.chartX - this.plotLeft, v.chartY - this.plotTop) && m) {
            let H = p.sensitivity || 1.1, G = v.detail || (v.deltaY || 0) / 120, P = B(k.getCoordinates(v).xAxis), y = B(k.getCoordinates(v).yAxis);
            x(this, Math.pow(H, G), P ? [P.axis] : this.xAxis, y ? [y.axis] : this.yAxis, v.chartX, v.chartY, p) && ((C = v.preventDefault) == null || C.call(v));
          }
        });
      }
      return { compose: function(p) {
        N.indexOf(p) === -1 && (N.push(p), T(p, "afterGetContainer", M));
      } };
    }), a(e, "masters/modules/mouse-wheel-zoom.src.js", [e["Core/Globals.js"], e["Extensions/MouseWheelZoom/MouseWheelZoom.js"]], function(o, n) {
      return o.MouseWheelZoom = o.MouseWheelZoom || n, o.MouseWheelZoom.compose(o.Chart), o;
    }), a(e, "masters/modules/stock.src.js", [e["Core/Globals.js"], e["Series/DataModifyComposition.js"], e["Stock/Navigator/Navigator.js"], e["Core/Axis/OrdinalAxis.js"], e["Stock/RangeSelector/RangeSelector.js"], e["Stock/Scrollbar/Scrollbar.js"], e["Core/Chart/StockChart.js"], e["Series/OHLC/OHLCSeries.js"], e["Series/Flags/FlagsSeries.js"]], function(o, n, r, T, O, j, D, F, B) {
      return o.Navigator = o.Navigator || r, o.OrdinalAxis = o.OrdinalAxis || T, o.RangeSelector = o.RangeSelector || O, o.Scrollbar = o.Scrollbar || j, o.stockChart = o.stockChart || D.stockChart, o.StockChart = o.StockChart || o.stockChart, o.extend(o.StockChart, D), n.compose(o.Series, o.Axis, o.Point), B.compose(o.Renderer), F.compose(o.Series), o.Navigator.compose(o.Chart, o.Axis, o.Series), o.OrdinalAxis.compose(o.Axis, o.Series, o.Chart), o.RangeSelector.compose(o.Axis, o.Chart), o.Scrollbar.compose(o.Axis), o.StockChart.compose(o.Chart, o.Axis, o.Series, o.SVGRenderer), o;
    });
  });
})(of);
var bC = of.exports;
const cu = /* @__PURE__ */ fi(bC), pC = ve`.highcharts-navigator-handle,.highcharts-navigator-mask-inside,.highcharts-navigator-series{fill:var(--beacon-system-color-background-primary)}.highcharts-navigator-handle:hover{fill:var(--beacon-system-color-background-primary-hover)}.highcharts-navigator-mask-inside{fill:var(--beacon-system-color-background-secondary-hover);fill-opacity:1;stroke:var(--beacon-system-color-background-primary);stroke-width:var(--beacon-system-width-border-normal)}.highcharts-navigator-mask-outside{stroke:var(--beacon-component-data-viz-color-border-minor);stroke-width:var(--beacon-system-width-border-mini)}.highcharts-navigator-series{stroke:var(--beacon-system-color-data-viz-standard-1)}.highcharts-scrollbar-thumb{--thumb-color: var(--beacon-component-scrollbar-color-background-thumb);fill:var(--thumb-color);stroke:var(--thumb-color)}.highcharts-scrollbar-thumb:hover{--thumb-color: var(--beacon-component-scrollbar-color-background-thumb-hover)}.highcharts-scrollbar-track{--track-color: var(--beacon-component-scrollbar-color-background-track);fill:var(--track-color);stroke:var(--track-color)}.highcharts-range-input,.highcharts-navigator-outline{stroke:none}.highcharts-navigator-series .highcharts-area{fill-opacity:.08}`;
var uC = Object.defineProperty, gC = Object.getOwnPropertyDescriptor, el = (i, t, e, a) => {
  for (var o = a > 1 ? void 0 : a ? gC(t, e) : t, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = (a ? r(t, e, o) : r(o)) || o);
  return a && o && uC(t, e, o), o;
};
function Ds(i) {
  let t = class extends i {
    constructor() {
      super(...arguments), this.navigator = !1, this.stockChart = !1, this.hideNavigator = !1;
    }
    static get navigatorStyles() {
      return pC;
    }
    /**
     * SVG path of the left handle at non-small breakpoints
     */
    static leftHandlePath(e, a, o, n) {
      return [
        "M",
        0,
        0,
        "H",
        16,
        "V",
        n,
        "H",
        0,
        "V",
        a,
        "Z",
        "M",
        9,
        n / 2 + 4,
        "l",
        -4,
        -4,
        4,
        -4,
        "v",
        8,
        "Z"
      ];
    }
    /**
     * SVG path of the right handle at non-small breakpoints
     */
    static rightHandlePath(e, a, o, n) {
      return [
        "M",
        -16,
        0,
        "H",
        0,
        "V",
        n,
        "H",
        -16,
        "V",
        a,
        "Z",
        "M",
        -9,
        n / 2 + 4,
        "l",
        4,
        -4,
        -4,
        -4,
        "v",
        8,
        "Z"
      ];
    }
    get localComponentOptions() {
      return ct.createChartOptions(super.localComponentOptions, {
        navigator: {
          enabled: (this.navigator || this.stockChart) && !this.hideNavigator,
          handles: t.handleOptionsDefault
        },
        responsive: {
          rules: [
            {
              condition: {
                minWidth: parseInt(fh, 10)
              },
              chartOptions: {
                navigator: {
                  height: 44,
                  handles: {
                    height: 44
                  }
                }
              }
            },
            {
              condition: {
                minWidth: parseInt(Zg, 10)
              },
              chartOptions: {
                navigator: {
                  height: 56,
                  handles: {
                    height: 56
                  }
                }
              }
            },
            {
              condition: {
                minWidth: parseInt(Jg, 10)
              },
              chartOptions: {
                navigator: {
                  height: 64,
                  handles: {
                    height: 64
                  }
                }
              }
            }
          ]
        },
        plotOptions: {
          series: {
            marker: {
              enabled: this.navigator ? !1 : !this.disableMarkers
            }
          }
        }
      });
    }
    initializeHighcharts(e) {
      super.initializeHighcharts(e), cu(zo), e.SVGRenderer.prototype.symbols.righthandle = t.rightHandlePath, e.SVGRenderer.prototype.symbols.lefthandle = t.leftHandlePath;
    }
    createChart() {
      const e = ct.createChartOptions(
        this.chartOptions,
        this.localComponentOptions,
        this.filteredOptions
      );
      return this.navigator || this.stockChart ? (cu(zo), zo.stockChart(this.chartContainer, e)) : zo.chart(this.chartContainer, e);
    }
    willUpdate(e) {
      var a;
      super.willUpdate(e), e.has("disableMarkers") && !this.navigator && ((a = this.chart) == null || a.update({
        plotOptions: {
          series: { marker: { enabled: !this.disableMarkers } }
        }
      }));
    }
  };
  return t.handleHeight = 40, t.handleOptionsDefault = {
    height: t.handleHeight,
    lineWidth: 0,
    symbols: ["lefthandle", "righthandle"],
    width: 16
  }, el([
    ue({ type: Boolean })
  ], t.prototype, "navigator", 2), el([
    ue({ type: Boolean, attribute: "stock-chart" })
  ], t.prototype, "stockChart", 2), el([
    ue({ type: Boolean, attribute: "hide-navigator" })
  ], t.prototype, "hideNavigator", 2), t = el([
    je("Navigator")
  ], t), t;
}
const id = {
  beaconTagName: "beacon-area-chart",
  crosshairZIndex: 3
}, mC = ve`.highcharts-navigator-handle,.highcharts-navigator-mask-inside,.highcharts-navigator-series{fill:var(--beacon-system-color-background-primary)}.highcharts-navigator-handle:hover{fill:var(--beacon-system-color-background-primary-hover)}.highcharts-navigator-mask-inside{fill:var(--beacon-system-color-background-secondary-hover);fill-opacity:1;stroke:var(--beacon-system-color-background-primary);stroke-width:var(--beacon-system-width-border-normal)}.highcharts-navigator-mask-outside{stroke:var(--beacon-component-data-viz-color-border-minor);stroke-width:var(--beacon-system-width-border-mini)}.highcharts-navigator-series{stroke:var(--beacon-system-color-data-viz-standard-1)}.highcharts-scrollbar-thumb{--thumb-color: var(--beacon-component-scrollbar-color-background-thumb);fill:var(--thumb-color);stroke:var(--thumb-color)}.highcharts-scrollbar-thumb:hover{--thumb-color: var(--beacon-component-scrollbar-color-background-thumb-hover)}.highcharts-scrollbar-track{--track-color: var(--beacon-component-scrollbar-color-background-track);fill:var(--track-color);stroke:var(--track-color)}.highcharts-range-input,.highcharts-navigator-outline{stroke:none}.highcharts-navigator-series .highcharts-area{fill-opacity:.08}.highcharts-point{stroke:var(--beacon-system-color-border-0);stroke-width:var(--beacon-system-width-border-mini)}.highcharts-crosshair{stroke:var(--beacon-component-data-viz-color-border-major);stroke-opacity:1;stroke-width:1px}.highcharts-series .highcharts-graph{stroke-width:var(--beacon-system-width-border-mini)}.highcharts-area{fill-opacity:1}.highcharts-area-series{stroke:var(--beacon-system-color-border-0)}:host(:not([stacking])) .highcharts-area-series .highcharts-negative{stroke:var(--beacon-reference-palette-functional-red-3)}:host(:not([stacking])) .highcharts-area-series .highcharts-negative.highcharts-point{fill:var(--beacon-reference-palette-functional-red-3);stroke:transparent}:host(:not([stacking])) .highcharts-area.highcharts-negative{fill:var(--beacon-reference-palette-functional-red-3)}:host(:not([stacking])) .highcharts-area{fill:var(--beacon-reference-palette-functional-green-3);stroke:var(--beacon-reference-palette-functional-green-3)}:host(:not([stacking])) .highcharts-area-series{stroke:var(--beacon-reference-palette-functional-green-3)}:host(:not([stacking])) .highcharts-area-series .highcharts-point{fill:var(--beacon-reference-palette-functional-green-3)}`;
var fC = Object.defineProperty, vC = (i, t, e, a) => {
  for (var o = void 0, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = r(t, e, o) || o);
  return o && fC(t, e, o), o;
};
const db = class db extends Ke(ct).with(
  zs,
  Ds,
  un
) {
  constructor() {
    super(...arguments), this.beaconTagName = id.beaconTagName, this.yThreshold = 0, this._type = Jt.AREA;
  }
  static get styles() {
    return [super.styles, mC, this.chartAreaStyles, this.navigatorStyles];
  }
  /**
   * @returns Constants
   * local component options for area chart
   */
  get localComponentOptions() {
    return ct.createChartOptions(super.localComponentOptions, {
      chart: {
        styledMode: !0
      },
      plotOptions: {
        series: {
          // @ts-expect-error: Hightcharts documentation says in styled mode negativeColor can be boolean(true/false), but it throws error
          negativeColor: !0,
          threshold: this.stacking ? 0 : this.yThreshold,
          stickyTracking: !0,
          stacking: this.stacking
        }
      },
      xAxis: {
        crosshair: {
          zIndex: id.crosshairZIndex
          // enables the crosshair to overlay the chart
        }
      }
    });
  }
};
db.tagName = id.beaconTagName;
let Zd = db;
vC([
  ue({ attribute: "y-threshold" })
], Zd.prototype, "yThreshold");
const du = {
  beaconTagName: "beacon-article-tile"
}, AC = ve`@charset "UTF-8";[beacon-tag-name=beacon-article-tile] .beacon-article-tile__eyebrow{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-caption-300);display:inline-block;padding-block-end:var(--beacon-reference-space-5)}[beacon-tag-name=beacon-article-tile] .beacon-article-tile__eyebrow+.beacon-article-tile__eyebrow:before{content:"·";display:inline;margin-inline-end:.25rem}[beacon-tag-name=beacon-article-tile] .beacon-article-tile__title{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-100);color:var(--beacon-system-color-text-standard);margin:0;padding:0}[beacon-tag-name=beacon-article-tile] .beacon-article-tile__title a,[beacon-tag-name=beacon-article-tile] a.beacon-article-tile__title{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-100);color:var(--beacon-system-color-text-link);text-decoration:none}[beacon-tag-name=beacon-article-tile] .beacon-article-tile__title a:is(:focus,:hover),[beacon-tag-name=beacon-article-tile] a:is(:focus,:hover).beacon-article-tile__title{text-decoration:underline}[beacon-tag-name=beacon-article-tile] .beacon-article-tile__description{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-200);color:var(--beacon-system-color-text-standard);margin:0;padding-block-start:var(--beacon-reference-space-5)}[beacon-tag-name=beacon-article-tile] .beacon-article-tile__footer{--beacon-color-hyperlink-default: var(--beacon-system-color-text-link);padding:var(--beacon-system-space-cell-contained)}[beacon-tag-name=beacon-article-tile] .beacon-action-zone{display:flex;flex-wrap:wrap;gap:var(--beacon-system-space-micro-jumbo);padding:var(--beacon-system-space-cell-contained)}[beacon-tag-name=beacon-article-tile] .beacon-article-tile__footer .beacon-action-zone{padding:0}[beacon-tag-name=beacon-article-tile] [slot=body]{padding:var(--article-tile-content-body-padding);padding-block:var(--article-tile-content-body-padding-block-start, var(--article-tile-content-body-padding)) var(--article-tile-content-body-padding-block-end, var(--article-tile-content-body-padding));padding-inline:var(--article-tile-content-body-padding-inline-start, var(--article-tile-content-body-padding)) var(--article-tile-content-body-padding-inline-end, var(--article-tile-content-body-padding))}[beacon-tag-name=beacon-article-tile].beacon-article-tile__vertical-fill{--article-tile-content-block-size: 100%;--tile-footer-margin-block-start: auto}[class*=b-grid-item] [beacon-tag-name=beacon-article-tile].beacon-article-tile__vertical-fill{block-size:100%}[beacon-tag-name=beacon-article-tile][scale=mini] .beacon-article-tile__title,[beacon-tag-name=beacon-article-tile][scale=mini] .beacon-article-tile__title a{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-body-100);display:var(--article-tile-mini-floating-display, block);margin:0;overflow:var(--article-tile-mini-floating-overflow, initial)}[beacon-tag-name=beacon-article-tile][scale=mini] .beacon-article-tile__eyebrow{padding-block-end:var(--beacon-reference-space-3)}@supports (-webkit-line-clamp: 1){[beacon-tag-name=beacon-article-tile][scale=mini] .beacon-article-tile__title,[beacon-tag-name=beacon-article-tile][scale=mini] .beacon-article-tile__title a{-webkit-box-orient:var(--article-tile-mini-floating-box-orient, initial);-webkit-line-clamp:var(--article-tile-mini-floating-line-clamp, initial)}[beacon-tag-name=beacon-article-tile][scale=mini]:is([position=horizontal],[position=horizontal-right],[position=horizontal-left]) .beacon-article-tile__title{--article-tile-mini-floating-display: -webkit-box;--article-tile-mini-floating-line-clamp: 3;--article-tile-mini-floating-box-orient: vertical;--article-tile-mini-floating-overflow: hidden}@media (width >= 640px){[beacon-tag-name=beacon-article-tile][scale=mini]:is([position=horizontal],[position=horizontal-right],[position=horizontal-left]) .beacon-article-tile__title{--article-tile-mini-floating-line-clamp: 4}}@media (width >= 960px){[beacon-tag-name=beacon-article-tile][scale=mini]:is([position=horizontal],[position=horizontal-right],[position=horizontal-left]) .beacon-article-tile__title{--article-tile-mini-floating-line-clamp: 2}}@media (width >= 1280px){[beacon-tag-name=beacon-article-tile][scale=mini]:is([position=horizontal],[position=horizontal-right],[position=horizontal-left]) .beacon-article-tile__title{--article-tile-mini-floating-line-clamp: 3}}}@media (width >= 640px){[beacon-tag-name=beacon-article-tile] .beacon-article-tile__eyebrow{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-caption-200)}}@media (width >= 960px){[beacon-tag-name=beacon-article-tile][layout=wide][scale=normal]:is([position=horizontal],[position=horizontal-right],[position=horizontal-left]).beacon-article-tile__wide-aspect-ratio-alternate{--article-tile-media-aspect-ratio: 3/2}[beacon-tag-name=beacon-article-tile][scale=maxi]:is([position=horizontal],[position=horizontal-left],[position=horizontal-right]) .beacon-article-tile__title,[beacon-tag-name=beacon-article-tile][scale=maxi]:is([position=horizontal],[position=horizontal-left],[position=horizontal-right]) .beacon-article-tile__title a{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-display-100)}}[beacon-tag-name=beacon-article-tile] [slot=media]>img,[beacon-tag-name=beacon-article-tile] [slot=media]:not(picture){align-self:var(--article-tile-media-align-self, initial);aspect-ratio:var(--article-tile-media-aspect-ratio, initial);block-size:var(--article-tile-media-block-size);flex:var(--article-tile-media-flex, initial);max-inline-size:min(var(--article-tile-media-inline-size, 100%));object-fit:var(--article-tile-media-object-fit, cover)}[beacon-tag-name=beacon-article-tile] picture[slot=media]{aspect-ratio:var(--article-tile-media-aspect-ratio, initial)}[beacon-tag-name=beacon-article-tile]:is([position=vertical]) [beacon-tag-name=beacon-video]{--override-video-aspect-ratio: var(--article-tile-media-aspect-ratio);--override-video-block-size: var(--article-tile-media-block-size);--override-video-inline-size: var(--article-tile-media-inline-size);--override-video-object-fit: var(--article-tile-media-object-fit);--override-video-border-start-start-radius: var(--tile-media-start-start-radius);--override-video-border-start-end-radius: var(--tile-start-end-radius);--override-video-border-end-start-radius: var(--tile-end-start-radius);--override-video-border-end-end-radius: var(--tile-end-end-radius)}`, yC = ve`:host{--article-tile-content-body-padding: var(--beacon-system-space-cell-contained);--article-tile-content-padding: var(--beacon-system-space-organism-normal);--tile-content-background-color: var(--beacon-system-color-background-1);--tile-end-end-radius: var(--beacon-system-radius-corner-standard);--tile-end-start-radius: var(--beacon-system-radius-corner-standard);--tile-start-end-radius: var(--beacon-system-radius-corner-standard);--tile-start-start-radius: var(--beacon-system-radius-corner-standard);--override-video-block-size: var(--article-tile-media-block-size);--override-video-inline-size: var(--article-tile-media-inline-size);--override-video-vertical-inline-size: var(--article-tile-inline-size);--override-video-object-fit: var(--article-tile-media-object-fit);--override-video-aspect-ratio: var(--article-tile-media-aspect-ratio);block-size:var(--article-tile-block-size);color:var(--beacon-system-color-text-standard);inline-size:min(var(--article-tile-inline-size),100%)}.container{padding:var(--article-tile-container-padding)}.content-zone{block-size:var(--article-tile-content-block-size);flex:var(--article-tile-content-flex, initial);inline-size:min(var(--article-tile-content-inline-size),100%);padding:var(--article-tile-content-padding)}.content-zone ::slotted([slot=body]){padding:var(--article-tile-content-body-padding);padding-block:var(--article-tile-content-body-padding-block-start, var(--article-tile-content-body-padding)) var(--article-tile-content-body-padding-block-end, var(--article-tile-content-body-padding));padding-inline:var(--article-tile-content-body-padding-inline-start, var(--article-tile-content-body-padding)) var(--article-tile-content-body-padding-inline-end, var(--article-tile-content-body-padding))}:host(:is([scale=maxi],[layout=wide]):is([position=vertical],[position=vertical-top],[position=vertical-bottom])),:host([layout=standard][scale=normal]:is([position=horizontal],[position=horizontal-right],[position=horizontal-left])),:host([layout=standard][scale=normal]:is([position=vertical],[position=vertical-top],[position=vertical-bottom])){--article-tile-inline-size: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 6 + var(--beacon-system-space-gutter) * 5);--article-tile-media-aspect-ratio: 2;--tile-body-margin-block-end: var(--beacon-system-space-micro-normal)}:host(:is([position=horizontal],[position=horizontal-right],[position=horizontal-left])){--tile-flex-direction: column}:host([position=horizontal-left]),:host([position=vertical-top]){--tile-media-end-start-radius: var(--beacon-system-radius-corner-standard);--tile-media-end-end-radius: var(--beacon-system-radius-corner-standard);--tile-media-start-start-radius: 0;--tile-media-start-end-radius: 0;--tile-content-start-start-radius: var(--beacon-system-radius-corner-standard);--tile-content-start-end-radius: var(--beacon-system-radius-corner-standard);--tile-content-end-end-radius: 0;--tile-content-end-start-radius: 0;--tile-flex-direction: column-reverse}:host(:is([position=horizontal],[position=horizontal-right])),:host(:is([position=vertical],[position=vertical-bottom])){--tile-media-start-start-radius: var(--beacon-system-radius-corner-standard);--tile-media-start-end-radius: var(--beacon-system-radius-corner-standard);--tile-media-end-start-radius: 0;--tile-content-start-end-radius: 0;--tile-content-end-start-radius: var(--beacon-system-radius-corner-standard);--tile-content-end-end-radius: var(--beacon-system-radius-corner-standard)}:host([scale=mini]){--article-tile-content-padding: 0;--tile-media-end-start-radius: 0;--tile-media-end-end-radius: 0;--tile-media-start-start-radius: 0;--tile-media-start-end-radius: 0;--tile-content-end-start-radius: 0;--tile-content-end-end-radius: 0;--tile-content-start-start-radius: 0;--tile-content-start-end-radius: 0;--tile-border-radius: 0}:host([scale=mini][floating]){--tile-host-background-color: transparent;--tile-content-background-color: transparent}:host([scale=mini]:not([floating])){--article-tile-container-padding: var(--beacon-system-space-cell-contained)}:host([scale=mini]:is([position=vertical],[position=vertical-top],[position=vertical-bottom])){--article-tile-inline-size: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 6 + var(--beacon-system-space-gutter) * 5);--article-tile-media-aspect-ratio: 2;--article-tile-content-body-padding-inline-end: 0;--article-tile-content-body-padding-inline-start: 0}:host([scale=mini]:is([position=horizontal],[position=horizontal-right],[position=horizontal-left])){--tile-flex-direction: row;--article-tile-inline-size: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 6 + var(--beacon-system-space-gutter) * 5);--article-tile-media-aspect-ratio: 1;--article-tile-block-size: 100px;--tile-content-justify-content: center}:host([scale=mini][position*=horizontal][floating]){--article-tile-media-block-size: 80px;--article-tile-media-align-self: center}:host([scale=mini]:is([position=horizontal],[position=horizontal-right])){--article-tile-content-body-padding-inline-start: var(--beacon-reference-space-5);--article-tile-content-body-padding-inline-end: 0}:host([scale=mini][position=horizontal-left]){--article-tile-content-body-padding-inline-start: 0}:host([scale=mini]:is([position=vertical],[position=vertical-bottom])){--article-tile-content-body-padding-block-start: var(--beacon-system-space-micro-normal);--article-tile-content-body-padding-block-end: 0}:host([scale=mini]:is([position=vertical-top])){--article-tile-content-body-padding-block-start: 0;--article-tile-content-body-padding-block-end: var(--beacon-system-space-micro-normal)}@media (width >= 640px){:host(:is([position=horizontal],[position=horizontal-right])){--tile-media-start-start-radius: var(--beacon-system-radius-corner-standard);--tile-media-end-start-radius: var(--beacon-system-radius-corner-standard);--tile-media-end-end-radius: 0;--tile-media-start-end-radius: 0;--tile-content-start-end-radius: var(--beacon-system-radius-corner-standard);--tile-content-end-end-radius: var(--beacon-system-radius-corner-standard);--tile-content-start-start-radius: 0;--tile-content-end-start-radius: 0}:host([position=horizontal-left]){--tile-content-start-start-radius: var(--beacon-system-radius-corner-standard);--tile-content-end-start-radius: var(--beacon-system-radius-corner-standard);--tile-content-start-end-radius: 0;--tile-content-end-end-radius: 0;--tile-media-start-end-radius: var(--beacon-system-radius-corner-standard);--tile-media-end-end-radius: var(--beacon-system-radius-corner-standard);--tile-media-start-start-radius: 0;--tile-media-end-start-radius: 0}:host(:is([position=vertical],[position=vertical-bottom])){--tile-content-end-start-radius: var(--beacon-system-radius-corner-standard);--tile-content-end-end-radius: var(--beacon-system-radius-corner-standard);--tile-content-start-start-radius: 0;--tile-content-start-end-radius: 0;--tile-media-start-start-radius: var(--beacon-system-radius-corner-standard);--tile-media-start-end-radius: var(--beacon-system-radius-corner-standard);--tile-media-end-end-radius: 0;--tile-media-end-start-radius: 0}:host([position=vertical-top]){--tile-media-end-start-radius: var(--beacon-system-radius-corner-standard);--tile-media-end-end-radius: var(--beacon-system-radius-corner-standard);--tile-media-start-start-radius: 0;--tile-media-start-end-radius: 0;--tile-content-start-start-radius: var(--beacon-system-radius-corner-standard);--tile-content-start-end-radius: var(--beacon-system-radius-corner-standard);--tile-content-end-end-radius: 0;--tile-content-end-start-radius: 0;--tile-flex-direction: column}:host([position=horizontal]),:host([position=horizontal-right]),:host([position=horizontal-left]){--tile-flex-direction: row;--tile-footer-margin-block-start: auto;--tile-body-margin-block-end: initial}:host([layout=wide]:is([position=horizontal],[position=horizontal-right],[position=horizontal-left])),:host([layout=standard]:is([scale=normal],[scale=maxi]):is([position=horizontal],[position=horizontal-right],[position=horizontal-left])){--article-tile-inline-size: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 12 + var(--beacon-system-space-gutter) * 11);--article-tile-content-inline-size: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 6 + var(--beacon-system-space-gutter) * 5);--article-tile-media-inline-size: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 6 + var(--beacon-system-space-gutter) * 6);--article-tile-media-aspect-ratio: 1}:host([scale=mini]:is([position=horizontal],[position=horizontal-right],[position=horizontal-left])){--article-tile-inline-size: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 12 + var(--beacon-system-space-gutter) * 11);--article-tile-media-aspect-ratio: 2;--article-tile-block-size: 140px}:host([scale=mini][position*=horizontal][floating]){--article-tile-media-block-size: initial;--article-tile-media-align-self: initial}:host([scale=mini]){--tile-media-end-start-radius: 0;--tile-media-end-end-radius: 0;--tile-media-start-start-radius: 0;--tile-media-start-end-radius: 0;--tile-content-end-start-radius: 0;--tile-content-end-end-radius: 0;--tile-content-start-start-radius: 0;--tile-content-start-end-radius: 0;--tile-border-radius: 0}}@media (width >= 960px){:host(:is([scale=maxi],[layout=wide]):is([position=vertical],[position=vertical-top],[position=vertical-bottom])),:host([layout=standard][scale=normal]:is([position=vertical],[position=vertical-top],[position=vertical-bottom])){--article-tile-inline-size: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 4 + var(--beacon-system-space-gutter) * 3)}:host([layout=standard][scale=normal]:is([position=horizontal],[position=horizontal-right],[position=horizontal-left])){--article-tile-inline-size: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 8 + var(--beacon-system-space-gutter) * 7);--article-tile-content-inline-size: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 4 + var(--beacon-system-space-gutter) * 3);--article-tile-media-inline-size: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 4 + var(--beacon-system-space-gutter) * 4)}:host([layout=standard][scale=maxi]:is([position=horizontal],[position=horizontal-right],[position=horizontal-left])){--article-tile-inline-size: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 12 + var(--beacon-system-space-gutter) * 11);--article-tile-content-inline-size: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 6 + var(--beacon-system-space-gutter) * 5);--article-tile-media-inline-size: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 6 + var(--beacon-system-space-gutter) * 6);--article-tile-media-flex: 1;--article-tile-content-flex: 1;--article-tile-media-block-size: 100%}:host([layout=wide][scale=normal]:is([position=horizontal],[position=horizontal-right],[position=horizontal-left])){--article-tile-inline-size: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 12 + var(--beacon-system-space-gutter) * 11);--article-tile-content-inline-size: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 4 + var(--beacon-system-space-gutter) * 3);--article-tile-media-inline-size: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 8 + var(--beacon-system-space-gutter) * 8);--article-tile-media-aspect-ratio: 1}:host([scale=mini]:is([position=vertical],[position=vertical-top],[position=vertical-bottom])){--article-tile-inline-size: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 4 + var(--beacon-system-space-gutter) * 3)}:host([scale=mini]:is([position=horizontal],[position=horizontal-right],[position=horizontal-left])){--article-tile-inline-size: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 4 + var(--beacon-system-space-gutter) * 3);--article-tile-media-aspect-ratio: 1;--article-tile-block-size: 88px}:host([scale=mini][position*=horizontal][floating]){--article-tile-media-block-size: 80px;--article-tile-media-align-self: center}}@media (width >= 1280px){:host([scale=mini]:is([position=horizontal],[position=horizontal-right],[position=horizontal-left])){--article-tile-block-size: 116px}:host([scale=mini][position*=horizontal][floating]){--article-tile-media-block-size: 104px}}`, hb = class hb extends ia {
  constructor() {
    super(...arguments), this.beaconTagName = du.beaconTagName;
  }
  static get styles() {
    return [super.styles, yC];
  }
  static get lightDOMStyles() {
    return [...super.lightDOMStyles, AC];
  }
  renderContentZone() {
    return pe`<div class="content-zone">
      ${this.renderBody()} ${this.renderFooter()}
    </div>`;
  }
  render() {
    return pe`${this.renderTile(this.position)}`;
  }
};
hb.tagName = du.beaconTagName;
let hu = hb;
class _n extends Le {
  // Brightcove components don't have named slots, so we can skip the need for waiting on slotchanges
  // which come with the queryAssigned decorators
  get video() {
    return this.querySelector("video-js");
  }
  get brightcovePlayer() {
    return Wi(this, "_brightcovePlayer", () => {
      var t, e;
      if (this.video) {
        const a = this.video.id;
        return (e = (t = window.videojs) == null ? void 0 : t.getPlayer(a)) != null ? e : void 0;
      }
    });
  }
  static buildPlayerScriptURL({
    brightcoveBaseURL: t = "https://players.brightcove.net/",
    brightcoveScriptURL: e = "/index.min.js",
    accountNum: a = "0",
    dataPlayerID: o = "default",
    dataEmbed: n = "default"
  }) {
    return `${t}${a}/${o}_${n}${e}`;
  }
  static formatDuration(t) {
    if (!t) return "";
    const e = Math.floor(t / 3600), a = Math.floor(t % 3600 / 60), o = Math.floor(t % 60);
    let n = "";
    e > 0 && (n += `${e}`.padStart(2, "0") + ":");
    let r = `${a}`.padStart(2, "0");
    return e > 0 && a === 0 && (r = "00"), n += `${r}:${o < 10 ? "0" : ""}${o}`, n;
  }
  applyPlayerScript(t = this.video) {
    return new Promise((e) => {
      if (t) {
        const a = t.dataset.account, o = t.dataset.player, n = t.dataset.embed;
        if (!this.querySelector(
          "script#beacon-brightcove-player-script"
        )) {
          const T = _n.buildPlayerScriptURL({
            accountNum: a,
            dataPlayerID: o,
            dataEmbed: n
          }), O = document.createElement("script");
          O.id = "beacon-brightcove-player-script", O.src = T, O.onload = () => e(), this.appendChild(O);
        }
      }
    });
  }
  applyVideoPlayerClass() {
    var t;
    (t = this.video) == null || t.classList.add(this.videoCSSClass);
  }
  brightcoveDefaultSlotchange() {
    this.applyPlayerScript(), this.applyVideoPlayerClass();
  }
  // opting for connectedCallback over firstUpdated so functionality happens as soon as possible
  // if we wait for firstUpdated, the component has to render before state changes may result in a re-render
  async connectedCallback() {
    super.connectedCallback(), await this.brightcoveInit();
  }
  renderBrightcoveDefaultSlot() {
    return pe`<slot @slotchange=${this.brightcoveDefaultSlotchange}></slot>`;
  }
}
const bu = {
  beaconTagName: "beacon-audio"
}, xC = ve`[beacon-tag-name=beacon-audio] [slot=title]{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-200)}[beacon-tag-name=beacon-audio] .video-js,[beacon-tag-name=beacon-audio] .vjs-control-bar{background-color:transparent}[beacon-tag-name=beacon-audio] .video-js .vjs-progress-holder{background-color:var(--beacon-system-color-background-0)}[beacon-tag-name=beacon-audio] .video-js .vjs-play-progress{background-color:var(--beacon-system-color-background-primary)}[beacon-tag-name=beacon-audio] .vjs-icon-placeholder,[beacon-tag-name=beacon-audio] .vjs-volume-panel,[beacon-tag-name=beacon-audio] .vjs-volume-level{color:var(--beacon-system-color-icon-secondary)}[beacon-tag-name=beacon-audio] .vjs-volume-level{background-color:var(--beacon-system-color-icon-secondary)}[beacon-tag-name=beacon-audio] .video-js :is(.vjs-progress-control,.vjs-current-time,.vjs-time-control):not(.vjs-remaining-time){color:var(--beacon-system-color-text-standard);display:flex}[beacon-tag-name=beacon-audio] .video-js .vjs-time-control{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-200)}[beacon-tag-name=beacon-audio] .vjs-control-bar{block-size:var(--beacon-reference-space-12)}[beacon-tag-name=beacon-audio] .vjs-play-control,[beacon-tag-name=beacon-audio] .vjs-mute-control,[beacon-tag-name=beacon-audio] .vjs-volume-panel{block-size:var(--beacon-reference-space-12);inline-size:var(--beacon-reference-space-12)}[beacon-tag-name=beacon-audio] .video-js .vjs-current-time{margin-inline-start:0;padding-inline-end:0;padding-inline-start:var(--beacon-reference-space-4)}[beacon-tag-name=beacon-audio] .video-js .vjs-duration{padding-inline-start:0}[beacon-tag-name=beacon-audio] .vjs-time-control,[beacon-tag-name=beacon-audio] .vjs-volume-panel{align-items:center;display:flex}[beacon-tag-name=beacon-audio] .vjs-icon-placeholder:before{display:grid;font-size:var(--beacon-reference-font-scale-6);place-items:center}[beacon-tag-name=beacon-audio] .video-js .vjs-title-bar,[beacon-tag-name=beacon-audio] .video-js .vjs-playback-rate,[beacon-tag-name=beacon-audio] .video-js .vjs-remaining-time,[beacon-tag-name=beacon-audio] .video-js .vjs-big-play-button{display:none}`, wC = ve`.base{background-color:var(--beacon-system-color-background-1)}.title,.description{padding-block:var(--beacon-reference-space-2)}.description{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100)}.title{color:var(--beacon-system-color-text-title)}.transcript{border-block-start:var(--beacon-system-width-border-mini) solid var(--beacon-system-color-border-2);padding-inline-end:var(--beacon-system-space-cell-contained);padding-inline-start:calc(var(--beacon-system-space-cell-contained) + var(--beacon-reference-space-5))}.media{flex-shrink:0;inline-size:var(--image-size, 96px)}@media (width >= 1280px){.media{--image-size: 120px}}.metadata{display:flex;flex-direction:var(--metadata-flex-direction, column);gap:var(--beacon-system-space-organism-normal);padding-block:var(--beacon-system-space-organism-normal);padding-inline:var(--beacon-system-space-organism-normal)}@media (width >= 640px){.metadata{--metadata-flex-direction: row}}.audio-player{padding-inline:var(--beacon-system-space-organism-normal)}`, bb = class bb extends _n {
  constructor() {
    super(...arguments), this.beaconTagName = bu.beaconTagName, this.resetSpacing = !0, this.videoCSSClass = "beacon-audio-player";
  }
  static get styles() {
    return [super.styles, wC];
  }
  static get lightDOMStyles() {
    return [super.lightDOMStyles, xC];
  }
  async brightcoveInit() {
    var t;
    await this.applyPlayerScript(), (t = this.brightcovePlayer) == null || t.ready(() => {
      var e;
      (e = this.brightcovePlayer) == null || e.audioOnlyMode(!0);
    });
  }
  render() {
    return pe`
      <div class="base">
        <div class="metadata">
          <div class="media">
            <slot name="media" ${Ue({ useParent: !0 })}></slot>
          </div>
          <div class="text-content">
            <div class="title">
              <slot name="title"></slot>
            </div>
            <div class="description">
              <slot
                name="description"
                ${Ue({ useParent: !0 })}></slot>
            </div>
          </div>
        </div>
        <div class="audio-player">${this.renderBrightcoveDefaultSlot()}</div>
        <div class="transcript">
          <slot name="transcript" ${Ue({ useParent: !0 })}></slot>
        </div>
      </div>
    `;
  }
};
bb.tagName = bu.beaconTagName;
let pu = bb;
const uu = {
  beaconTagName: "beacon-bar-chart"
}, nd = {
  small: 531,
  medium: 795,
  large: 1051
}, _i = {
  small: {
    end: 3,
    max: 468
  },
  medium: {
    end: 6,
    max: 768,
    start: 4
  },
  large: {
    max: 980
  },
  xLarge: {
    max: 1024
  }
}, kC = 3 * 4 + 48, CC = 2 * 4 + 36, SC = 38, EC = 3 * 4 + 32, TC = 2 * 4 + 24, MC = 28, LC = 3 * 4 + 16, OC = 2 * 4 + 12, PC = 20, zC = 3 * 8 + 64, DC = 2 * 8 + 48, IC = 58, BC = 3 * 6 + 40, RC = 2 * 6 + 30, NC = 38, FC = 3 * 6 + 24, _C = 2 * 6 + 18, UC = 30, jC = 3 * 10 + 80, $C = 2 * 10 + 60, HC = 68, KC = 3 * 8 + 48, GC = 2 * 8 + 36, WC = 48, qC = 3 * 8 + 32, VC = 2 * 8 + 24, YC = 40, QC = 3 * 12 + 80, XC = 2 * 12 + 60, ZC = 68, JC = 3 * 8 + 48, eS = 2 * 8 + 36, tS = 48, oS = 3 * 8 + 32, aS = 2 * 8 + 24, iS = 40, rd = 20, sd = 16, ld = 12, cd = 28, dd = 24, hd = 24, bd = 32, pd = 28, ud = 28, gd = 36, md = 32, fd = 32, Ce = {
  small: {
    height: {
      groupMultiplier: {
        normal: {
          smallRange: {
            fourBars: kC,
            threeBars: CC,
            twoBars: SC
          },
          mediumRange: {
            fourBars: EC,
            threeBars: TC,
            twoBars: MC
          },
          largeRange: {
            fourBars: LC,
            threeBars: OC,
            twoBars: PC
          }
        },
        minusOne: {
          smallRange: {
            fourBars: rd,
            threeBars: rd,
            twoBars: rd
          },
          mediumRange: {
            fourBars: sd,
            threeBars: sd,
            twoBars: sd
          },
          largeRange: {
            fourBars: ld,
            threeBars: ld,
            twoBars: ld
          }
        }
      },
      max: _i.small.max
    },
    width: nd.small
  },
  medium: {
    height: {
      groupMultiplier: {
        normal: {
          smallRange: {
            fourBars: zC,
            threeBars: DC,
            twoBars: IC
          },
          mediumRange: {
            fourBars: BC,
            threeBars: RC,
            twoBars: NC
          },
          largeRange: {
            fourBars: FC,
            threeBars: _C,
            twoBars: UC
          }
        },
        minusOne: {
          smallRange: {
            fourBars: cd,
            threeBars: cd,
            twoBars: cd
          },
          mediumRange: {
            fourBars: dd,
            threeBars: dd,
            twoBars: dd
          },
          largeRange: {
            fourBars: hd,
            threeBars: hd,
            twoBars: hd
          }
        }
      },
      max: _i.medium.max
    },
    width: nd.medium
  },
  large: {
    height: {
      groupMultiplier: {
        normal: {
          smallRange: {
            fourBars: jC,
            threeBars: $C,
            twoBars: HC
          },
          mediumRange: {
            fourBars: KC,
            threeBars: GC,
            twoBars: WC
          },
          largeRange: {
            fourBars: qC,
            threeBars: VC,
            twoBars: YC
          }
        },
        minusOne: {
          smallRange: {
            fourBars: bd,
            threeBars: bd,
            twoBars: bd
          },
          mediumRange: {
            fourBars: pd,
            threeBars: pd,
            twoBars: pd
          },
          largeRange: {
            fourBars: ud,
            threeBars: ud,
            twoBars: ud
          }
        }
      },
      max: _i.large.max
    },
    width: nd.large
  },
  xLarge: {
    height: {
      groupMultiplier: {
        normal: {
          smallRange: {
            fourBars: QC,
            threeBars: XC,
            twoBars: ZC
          },
          mediumRange: {
            fourBars: JC,
            threeBars: eS,
            twoBars: tS
          },
          largeRange: {
            fourBars: oS,
            threeBars: aS,
            twoBars: iS
          }
        },
        minusOne: {
          smallRange: {
            fourBars: gd,
            threeBars: gd,
            twoBars: gd
          },
          mediumRange: {
            fourBars: md,
            threeBars: md,
            twoBars: md
          },
          largeRange: {
            fourBars: fd,
            threeBars: fd,
            twoBars: fd
          }
        }
      },
      max: _i.xLarge.max
    }
  }
}, nS = ve`:is(.highcharts-column-series,.highcharts-bar-series) .highcharts-point{stroke:inherit}.highcharts-legend .highcharts-legend-item .highcharts-point{display:none}:host([stacking]) :is(.highcharts-column-series,.highcharts-bar-series) .highcharts-point{stroke:var(--beacon-system-color-background-1)}.highcharts-point:hover{fill-opacity:1}`;
var rS = Object.defineProperty, sS = (i, t, e, a) => {
  for (var o = void 0, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = r(t, e, o) || o);
  return o && rS(t, e, o), o;
};
const pb = class pb extends Ke(ct).with(
  zs,
  Ds,
  un
) {
  constructor() {
    super(...arguments), this.beaconTagName = uu.beaconTagName, this.variant = Gr.HORIZONTAL;
  }
  static get styles() {
    return [super.styles, nS, this.chartAreaStyles, this.navigatorStyles];
  }
  /** The type of chart being rendered. */
  get type() {
    return this.variant === Gr.HORIZONTAL ? Jt.BAR : Jt.COLUMN;
  }
  /** Options specific to the Bar chart. */
  get localComponentOptions() {
    return ct.createChartOptions(super.localComponentOptions, {
      xAxis: {
        labels: {
          /**
           * @todo No clue why this works. It's the wrong type. Switching it to undefined or zero
           * breaks bar chart styles for the labels in either vertical or horizontal variant.
           *  */
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          y: null
        },
        tickLength: 0
      },
      plotOptions: {
        bar: {
          borderRadius: 0
        },
        column: {
          borderRadius: 0
        }
      }
    });
  }
  willUpdate(t) {
    var e;
    (e = super.willUpdate) == null || e.call(this, t), t.has("stacking") && this.updateChart({
      chart: { height: this.height },
      plotOptions: { series: { stacking: this.stacking } }
    }), t.has("variant") && this.updateChart({ chart: { type: this.type, height: this.height } }), t.has("tableId") && this.updateChart({ series: this.seriesWithChartType }), t.has("chart") && this.setLoadedChartOptions();
  }
  /** Size of the plotbox (not including axes). */
  get componentWidth() {
    var t;
    return (t = this.chartSize) == null ? void 0 : t.plotWidth;
  }
  /**
   * Updates chart options that depend on chartSize being initialized in chartBase
   */
  setLoadedChartOptions() {
    this.updateChart({
      chart: { type: this.type, height: this.height },
      plotOptions: { series: { stacking: this.stacking } }
    });
  }
  /**
   * Resolves the chart's height value based on the number of series. Charts are forced into a stacked variant at 5+ series, so conditions only check for variations in bar amount before stacking is enabled.
   *
   * @param heightValues Array of possible height values based on the numbers of bars, in order of 4, 3, 2
   * @returns The height value for the chart
   */
  determineHeightReturnValues(t) {
    if (this.seriesLength === 4) return t[0];
    if (this.seriesLength === 3) return t[1];
    if (this.seriesLength === 2) return t[2];
  }
  /**
   * Passes the available height values to a separate function based on total chart categories
   *
   * @see determineHeightReturnValues
   *
   * @param smallValues Possible values in the small range
   * @param mediumValues Possible values in the medium range
   * @param largeValues Possible values in the large range
   */
  determineHeightCutoffRoute(t, e, a) {
    if (this.totalChartCategories)
      return this.totalChartCategories <= _i.small.end ? this.determineHeightReturnValues(t) : this.totalChartCategories >= _i.medium.start && this.totalChartCategories <= _i.medium.end ? this.determineHeightReturnValues(e) : this.determineHeightReturnValues(a);
  }
  /** Collection of heights based on small, medium, large, or xLarge charts. */
  get chartHeightValues() {
    if (this.variant !== Gr.VERTICAL)
      return {
        small: this.determineHeightCutoffRoute(
          [
            this.calculateChartHeight(
              Ce.small.height.groupMultiplier.normal.smallRange.fourBars,
              Ce.small.height.groupMultiplier.minusOne.smallRange.fourBars,
              Ce.small.height.max
            ),
            this.calculateChartHeight(
              Ce.small.height.groupMultiplier.normal.smallRange.threeBars,
              Ce.small.height.groupMultiplier.minusOne.smallRange.threeBars,
              Ce.small.height.max
            ),
            this.calculateChartHeight(
              Ce.small.height.groupMultiplier.normal.smallRange.twoBars,
              Ce.small.height.groupMultiplier.minusOne.smallRange.twoBars,
              Ce.small.height.max
            )
          ],
          [
            this.calculateChartHeight(
              Ce.small.height.groupMultiplier.normal.mediumRange.fourBars,
              Ce.small.height.groupMultiplier.minusOne.mediumRange.fourBars,
              Ce.small.height.max
            ),
            this.calculateChartHeight(
              Ce.small.height.groupMultiplier.normal.mediumRange.threeBars,
              Ce.small.height.groupMultiplier.minusOne.mediumRange.threeBars,
              Ce.small.height.max
            ),
            this.calculateChartHeight(
              Ce.small.height.groupMultiplier.normal.mediumRange.twoBars,
              Ce.small.height.groupMultiplier.minusOne.mediumRange.twoBars,
              Ce.small.height.max
            )
          ],
          [
            this.calculateChartHeight(
              Ce.small.height.groupMultiplier.normal.largeRange.fourBars,
              Ce.small.height.groupMultiplier.minusOne.largeRange.fourBars,
              Ce.small.height.max
            ),
            this.calculateChartHeight(
              Ce.small.height.groupMultiplier.normal.largeRange.threeBars,
              Ce.small.height.groupMultiplier.minusOne.largeRange.threeBars,
              Ce.small.height.max
            ),
            this.calculateChartHeight(
              Ce.small.height.groupMultiplier.normal.largeRange.twoBars,
              Ce.small.height.groupMultiplier.minusOne.largeRange.twoBars,
              Ce.small.height.max
            )
          ]
        ),
        medium: this.determineHeightCutoffRoute(
          [
            this.calculateChartHeight(
              Ce.medium.height.groupMultiplier.normal.smallRange.fourBars,
              Ce.medium.height.groupMultiplier.minusOne.smallRange.fourBars,
              Ce.medium.height.max
            ),
            this.calculateChartHeight(
              Ce.medium.height.groupMultiplier.normal.smallRange.threeBars,
              Ce.medium.height.groupMultiplier.minusOne.smallRange.threeBars,
              Ce.medium.height.max
            ),
            this.calculateChartHeight(
              Ce.medium.height.groupMultiplier.normal.smallRange.twoBars,
              Ce.medium.height.groupMultiplier.minusOne.smallRange.twoBars,
              Ce.medium.height.max
            )
          ],
          [
            this.calculateChartHeight(
              Ce.medium.height.groupMultiplier.normal.mediumRange.fourBars,
              Ce.medium.height.groupMultiplier.minusOne.mediumRange.fourBars,
              Ce.medium.height.max
            ),
            this.calculateChartHeight(
              Ce.medium.height.groupMultiplier.normal.mediumRange.threeBars,
              Ce.medium.height.groupMultiplier.minusOne.mediumRange.threeBars,
              Ce.medium.height.max
            ),
            this.calculateChartHeight(
              Ce.medium.height.groupMultiplier.normal.mediumRange.twoBars,
              Ce.medium.height.groupMultiplier.minusOne.mediumRange.twoBars,
              Ce.medium.height.max
            )
          ],
          [
            this.calculateChartHeight(
              Ce.medium.height.groupMultiplier.normal.largeRange.fourBars,
              Ce.medium.height.groupMultiplier.minusOne.largeRange.fourBars,
              Ce.medium.height.max
            ),
            this.calculateChartHeight(
              Ce.medium.height.groupMultiplier.normal.largeRange.threeBars,
              Ce.medium.height.groupMultiplier.minusOne.largeRange.threeBars,
              Ce.medium.height.max
            ),
            this.calculateChartHeight(
              Ce.medium.height.groupMultiplier.normal.largeRange.twoBars,
              Ce.medium.height.groupMultiplier.minusOne.largeRange.twoBars,
              Ce.medium.height.max
            )
          ]
        ),
        large: this.determineHeightCutoffRoute(
          [
            this.calculateChartHeight(
              Ce.large.height.groupMultiplier.normal.smallRange.fourBars,
              Ce.large.height.groupMultiplier.minusOne.smallRange.fourBars,
              Ce.large.height.max
            ),
            this.calculateChartHeight(
              Ce.large.height.groupMultiplier.normal.smallRange.threeBars,
              Ce.large.height.groupMultiplier.minusOne.smallRange.threeBars,
              Ce.large.height.max
            ),
            this.calculateChartHeight(
              Ce.large.height.groupMultiplier.normal.smallRange.twoBars,
              Ce.large.height.groupMultiplier.minusOne.smallRange.twoBars,
              Ce.large.height.max
            )
          ],
          [
            this.calculateChartHeight(
              Ce.large.height.groupMultiplier.normal.mediumRange.fourBars,
              Ce.large.height.groupMultiplier.minusOne.mediumRange.fourBars,
              Ce.large.height.max
            ),
            this.calculateChartHeight(
              Ce.large.height.groupMultiplier.normal.mediumRange.threeBars,
              Ce.large.height.groupMultiplier.minusOne.mediumRange.threeBars,
              Ce.large.height.max
            ),
            this.calculateChartHeight(
              Ce.large.height.groupMultiplier.normal.mediumRange.twoBars,
              Ce.large.height.groupMultiplier.minusOne.mediumRange.twoBars,
              Ce.large.height.max
            )
          ],
          [
            this.calculateChartHeight(
              Ce.large.height.groupMultiplier.normal.largeRange.fourBars,
              Ce.large.height.groupMultiplier.minusOne.largeRange.fourBars,
              Ce.large.height.max
            ),
            this.calculateChartHeight(
              Ce.large.height.groupMultiplier.normal.largeRange.threeBars,
              Ce.large.height.groupMultiplier.minusOne.largeRange.threeBars,
              Ce.large.height.max
            ),
            this.calculateChartHeight(
              Ce.large.height.groupMultiplier.normal.largeRange.twoBars,
              Ce.large.height.groupMultiplier.minusOne.largeRange.twoBars,
              Ce.large.height.max
            )
          ]
        ),
        xLarge: this.determineHeightCutoffRoute(
          [
            this.calculateChartHeight(
              Ce.xLarge.height.groupMultiplier.normal.smallRange.fourBars,
              Ce.xLarge.height.groupMultiplier.minusOne.smallRange.fourBars,
              Ce.xLarge.height.max
            ),
            this.calculateChartHeight(
              Ce.xLarge.height.groupMultiplier.normal.smallRange.threeBars,
              Ce.xLarge.height.groupMultiplier.minusOne.smallRange.threeBars,
              Ce.xLarge.height.max
            ),
            this.calculateChartHeight(
              Ce.xLarge.height.groupMultiplier.normal.smallRange.twoBars,
              Ce.xLarge.height.groupMultiplier.minusOne.smallRange.twoBars,
              Ce.xLarge.height.max
            )
          ],
          [
            this.calculateChartHeight(
              Ce.xLarge.height.groupMultiplier.normal.mediumRange.fourBars,
              Ce.xLarge.height.groupMultiplier.minusOne.mediumRange.fourBars,
              Ce.xLarge.height.max
            ),
            this.calculateChartHeight(
              Ce.xLarge.height.groupMultiplier.normal.mediumRange.threeBars,
              Ce.xLarge.height.groupMultiplier.minusOne.mediumRange.threeBars,
              Ce.xLarge.height.max
            ),
            this.calculateChartHeight(
              Ce.xLarge.height.groupMultiplier.normal.mediumRange.twoBars,
              Ce.xLarge.height.groupMultiplier.minusOne.mediumRange.twoBars,
              Ce.xLarge.height.max
            )
          ],
          [
            this.calculateChartHeight(
              Ce.xLarge.height.groupMultiplier.normal.largeRange.fourBars,
              Ce.xLarge.height.groupMultiplier.minusOne.largeRange.fourBars,
              Ce.xLarge.height.max
            ),
            this.calculateChartHeight(
              Ce.xLarge.height.groupMultiplier.normal.largeRange.threeBars,
              Ce.xLarge.height.groupMultiplier.minusOne.largeRange.threeBars,
              Ce.xLarge.height.max
            ),
            this.calculateChartHeight(
              Ce.xLarge.height.groupMultiplier.normal.largeRange.twoBars,
              Ce.xLarge.height.groupMultiplier.minusOne.largeRange.twoBars,
              Ce.xLarge.height.max
            )
          ]
        )
      };
  }
  /** The height of the chart. */
  get height() {
    var e, a, o, n;
    let t;
    return (this.stacking || !this.totalChartCategories || !this.seriesLength || !this.componentWidth) && (t = void 0), this.componentWidth <= Ce.small.width && (t = (e = this.chartHeightValues) == null ? void 0 : e.small), this.componentWidth > Ce.small.width && this.componentWidth <= Ce.medium.width && (t = (a = this.chartHeightValues) == null ? void 0 : a.medium), this.componentWidth > Ce.medium.width && this.componentWidth <= Ce.large.width && (t = (o = this.chartHeightValues) == null ? void 0 : o.large), this.componentWidth > Ce.large.width && (t = (n = this.chartHeightValues) == null ? void 0 : n.xLarge), t || void 0;
  }
  /**
   * Calculates the height a chart should be at given its categories, number of series, and the width of the chart.
   *
   * @param normalMultiplier Number to mulitply the total group count by
   * @param minusOneMultiplier Number to multiply (total group count - 1) by
   * @returns A height in pixels
   */
  calculateChartHeight(t, e, a) {
    var j, D;
    if (!((j = this.chartSize) != null && j.chartHeight) || !((D = this.chartSize) != null && D.plotHeight) || !this.totalChartCategories)
      return;
    const { chartHeight: o, plotHeight: n } = this.chartSize, r = o - n, T = this.totalChartCategories * t + (this.totalChartCategories - 1) * e, O = T > a ? a : T;
    return r + O;
  }
};
pb.tagName = uu.beaconTagName;
let Jd = pb;
sS([
  ue()
], Jd.prototype, "variant");
var pa = /* @__PURE__ */ ((i) => (i.VERTICAL = "vertical", i.HORIZONTAL = "horizontal", i.HORIZONTAL_WIDE = "horizontal-wide", i))(pa || {}), jo = /* @__PURE__ */ ((i) => (i.VERTICAL = "vertical", i.SPLIT = "split", i.HORIZONTAL = "horizontal", i))(jo || {}), _h = /* @__PURE__ */ ((i) => (i.LEFT = "left", i.RIGHT = "right", i.TOP = "top", i.BOTTOM = "bottom", i))(_h || {}), Br = /* @__PURE__ */ ((i) => (i.STANDARD = "standard", i.HERO = "hero", i))(Br || {});
const lS = ve`:root[beacon-tag-name=beacon-data-list],:root [beacon-tag-name=beacon-data-list],[beacon-version="4.3.1"][class*=beacon-on][beacon-tag-name=beacon-data-list],[beacon-version="4.3.1"][class*=beacon-on] [beacon-tag-name=beacon-data-list],[class*=beacon-on] [beacon-version="4.3.1"][beacon-tag-name=beacon-data-list],[class*=beacon-on] [beacon-version="4.3.1"] [beacon-tag-name=beacon-data-list],[beacon-version="4.3.1"][beacon-tag-name=beacon-data-list],[beacon-version="4.3.1"] [beacon-tag-name=beacon-data-list]{--data-list-padding-block: var(--beacon-reference-space-3);--data-list-accolade-image-size-max-block-size: var(--beacon-reference-space-7);--data-list-accolade-image-size-max-inline-size: var(--beacon-reference-space-15);--data-list-size-block-vertical: var(--beacon-reference-space-10)}@media (width >= 640px){:root[beacon-tag-name=beacon-data-list],:root [beacon-tag-name=beacon-data-list],[beacon-version="4.3.1"][class*=beacon-on][beacon-tag-name=beacon-data-list],[beacon-version="4.3.1"][class*=beacon-on] [beacon-tag-name=beacon-data-list],[class*=beacon-on] [beacon-version="4.3.1"][beacon-tag-name=beacon-data-list],[class*=beacon-on] [beacon-version="4.3.1"] [beacon-tag-name=beacon-data-list],[beacon-version="4.3.1"][beacon-tag-name=beacon-data-list],[beacon-version="4.3.1"] [beacon-tag-name=beacon-data-list]{--data-list-padding-block: var(--beacon-reference-space-4);--data-list-size-block-vertical: var(--beacon-reference-space-11)}}@media (width >= 960px){:root[beacon-tag-name=beacon-data-list],:root [beacon-tag-name=beacon-data-list],[beacon-version="4.3.1"][class*=beacon-on][beacon-tag-name=beacon-data-list],[beacon-version="4.3.1"][class*=beacon-on] [beacon-tag-name=beacon-data-list],[class*=beacon-on] [beacon-version="4.3.1"][beacon-tag-name=beacon-data-list],[class*=beacon-on] [beacon-version="4.3.1"] [beacon-tag-name=beacon-data-list],[beacon-version="4.3.1"][beacon-tag-name=beacon-data-list],[beacon-version="4.3.1"] [beacon-tag-name=beacon-data-list]{--data-list-padding-block: var(--beacon-reference-space-5);--data-list-accolade-image-size-max-block-size: 50px;--data-list-accolade-image-size-max-inline-size: 115px;--data-list-size-block-horizontal: var(--beacon-reference-space-12);--data-list-size-block-split: var(--beacon-reference-space-12);--data-list-size-block-vertical: var(--beacon-reference-space-12)}}@media (width >= 1280px){:root[beacon-tag-name=beacon-data-list],:root [beacon-tag-name=beacon-data-list],[beacon-version="4.3.1"][class*=beacon-on][beacon-tag-name=beacon-data-list],[beacon-version="4.3.1"][class*=beacon-on] [beacon-tag-name=beacon-data-list],[class*=beacon-on] [beacon-version="4.3.1"][beacon-tag-name=beacon-data-list],[class*=beacon-on] [beacon-version="4.3.1"] [beacon-tag-name=beacon-data-list],[beacon-version="4.3.1"][beacon-tag-name=beacon-data-list],[beacon-version="4.3.1"] [beacon-tag-name=beacon-data-list]{--data-list-padding-block: var(--beacon-reference-space-6);--data-list-size-block-horizontal: var(--beacon-reference-space-13);--data-list-size-block-split: 65px;--data-list-size-block-vertical: 65px}}`, gu = {
  beaconTagName: "beacon-data-list"
}, cS = ve`[beacon-tag-name=beacon-data-list]{--padding-block: var(--data-list-padding-block);--padding-inline: 0;--border-inline: 0;--border-block: var(--beacon-system-width-border-mini) solid var(--beacon-system-color-border-1);--default-spacing: var(--beacon-reference-space-3);--padding-grid-block: 0;--block-size: var(--data-list-size-block-vertical)}[beacon-tag-name=beacon-data-list] [slot=list-item]{align-items:center;align-self:stretch;border-block-end:var(--border-block);border-inline-end:var(--border-inline);box-sizing:border-box;display:flex;justify-content:space-between;min-block-size:var(--block-size);padding-block:var(--padding-block);padding-inline:var(--padding-inline)}[beacon-tag-name=beacon-data-list] [slot=list-item]:last-child{border:0;padding-inline-end:var(--padding-grid-block)}[beacon-tag-name=beacon-data-list] dd{align-items:center;display:flex;font-weight:var(--beacon-system-font-weight-bold);margin-inline-start:var(--default-spacing);text-align:end}[beacon-tag-name=beacon-data-list] dd img,[beacon-tag-name=beacon-data-list] dd svg{max-block-size:var(--override-data-list-list-item-accolade-image-max-block-size, var(--data-list-accolade-image-size-max-block-size));max-inline-size:var(--override-data-list-list-item-accolade-image-max-inline-size, var(--data-list-accolade-image-size-max-inline-size))}@media (width >= 960px){[beacon-tag-name=beacon-data-list][orientation=horizontal]{--padding-inline: var(--beacon-reference-space-7);--border-inline: var(--beacon-system-width-border-mini) solid var(--beacon-system-color-border-1);--border-block: 0;--padding-block: 0;--block-size: var(--data-list-size-block-horizontal)}[beacon-tag-name=beacon-data-list][orientation=horizontal] [slot=list-item]:nth-of-type(2){grid-row:2/3}[beacon-tag-name=beacon-data-list][orientation=horizontal] [slot=list-item]:nth-of-type(odd){padding-block-start:var(--padding-grid-block)}[beacon-tag-name=beacon-data-list][orientation=horizontal] [slot=list-item]:nth-of-type(2n){padding-block-end:var(--padding-grid-block)}[beacon-tag-name=beacon-data-list][orientation=horizontal] [slot=list-item]:first-of-type{padding-inline-start:var(--padding-grid-block)}[beacon-tag-name=beacon-data-list][orientation=horizontal] [slot=list-item]:last-of-type{border:0;padding-inline-end:var(--padding-grid-block)}[beacon-tag-name=beacon-data-list][orientation=split]{--border-block: 0;--padding-inline: var(--default-spacing);--padding-grid-block: var(--default-spacing);--block-size: var(--data-list-size-block-split)}[beacon-tag-name=beacon-data-list][orientation=split] [slot=list-item]:nth-of-type(odd){margin-block:var(--default-spacing) 0;margin-inline:var(--default-spacing)}[beacon-tag-name=beacon-data-list][orientation=split] [slot=list-item]:nth-of-type(2n){margin-block:0 var(--default-spacing);margin-inline:var(--default-spacing)}[beacon-tag-name=beacon-data-list][orientation=split] [slot=list-item]:nth-of-type(odd):not(:last-of-type){border-block-end:var(--beacon-system-width-border-mini) solid var(--beacon-system-color-border-1)}}`, dS = ve`dl{--cell-contained: var(--beacon-system-space-cell-contained);--flex: column;font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-300);display:flex;flex-direction:var(--flex);margin:0;padding:var(--cell-contained);word-break:normal}@media (width >= 960px){.horizontal{--flex: row}.split{--cell-contained: 0;--padding-grid-block: var(--default-spacing);--flex: row;display:grid;grid-auto-flow:column;grid-column-gap:var(--beacon-reference-space-7);grid-template-rows:1fr 1fr}}`;
var hS = Object.defineProperty, af = (i, t, e, a) => {
  for (var o = void 0, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = r(t, e, o) || o);
  return o && hS(t, e, o), o;
};
const ub = class ub extends Le {
  constructor() {
    super(...arguments), this.beaconTagName = gu.beaconTagName, this.orientation = jo.HORIZONTAL;
  }
  static get styles() {
    return [super.styles, dS];
  }
  static get lightDOMStyles() {
    return [super.lightDOMStyles, cS, lS];
  }
  /** Callback Method for beacon-event-render Event */
  onBeaconRender() {
  }
  /**
   * @param event
   * @event {BeaconEvents} beacon-event-render - emits when a component is rendered
   */
  emitRender() {
    Re(this, Ee.RENDER, void 0, this.onBeaconRender);
  }
  render() {
    return pe`<dl class=${this.orientation}>
      <slot name="list-item" @slotchange=${this.emitRender}></slot>
    </dl>`;
  }
};
ub.tagName = gu.beaconTagName;
let Yi = ub;
af([
  wt({ slot: "list-item" })
], Yi.prototype, "listItems");
af([
  ue({ reflect: !0 })
], Yi.prototype, "orientation");
const bS = ve`:root[beacon-tag-name=beacon-id-card],:root [beacon-tag-name=beacon-id-card],[beacon-version="4.3.1"][class*=beacon-on][beacon-tag-name=beacon-id-card],[beacon-version="4.3.1"][class*=beacon-on] [beacon-tag-name=beacon-id-card],[class*=beacon-on] [beacon-version="4.3.1"][beacon-tag-name=beacon-id-card],[class*=beacon-on] [beacon-version="4.3.1"] [beacon-tag-name=beacon-id-card],[beacon-version="4.3.1"][beacon-tag-name=beacon-id-card],[beacon-version="4.3.1"] [beacon-tag-name=beacon-id-card]{--id-card-display-name-space-padding-block-start: 0;--id-card-avatar-size-mini: var(--beacon-reference-space-9);--id-card-description-padding-after: var(--beacon-reference-space-3);--id-card-name-space-padding-jumbo: calc(.75 * var(--beacon-reference-space-3));--id-card-name-space-padding-normal: var(--beacon-reference-space-1);--id-card-name-space-padding-mini: var(--beacon-reference-space-1)}@media (width >= 640px){:root[beacon-tag-name=beacon-id-card],:root [beacon-tag-name=beacon-id-card],[beacon-version="4.3.1"][class*=beacon-on][beacon-tag-name=beacon-id-card],[beacon-version="4.3.1"][class*=beacon-on] [beacon-tag-name=beacon-id-card],[class*=beacon-on] [beacon-version="4.3.1"][beacon-tag-name=beacon-id-card],[class*=beacon-on] [beacon-version="4.3.1"] [beacon-tag-name=beacon-id-card],[beacon-version="4.3.1"][beacon-tag-name=beacon-id-card],[beacon-version="4.3.1"] [beacon-tag-name=beacon-id-card]{--id-card-avatar-size-mini: var(--beacon-reference-space-11);--id-card-name-space-padding-jumbo: calc(var(--beacon-reference-space-2));--id-card-name-space-padding-mini: var(--beacon-reference-space-2)}}@media (width >= 960px){:root[beacon-tag-name=beacon-id-card],:root [beacon-tag-name=beacon-id-card],[beacon-version="4.3.1"][class*=beacon-on][beacon-tag-name=beacon-id-card],[beacon-version="4.3.1"][class*=beacon-on] [beacon-tag-name=beacon-id-card],[class*=beacon-on] [beacon-version="4.3.1"][beacon-tag-name=beacon-id-card],[class*=beacon-on] [beacon-version="4.3.1"] [beacon-tag-name=beacon-id-card],[beacon-version="4.3.1"][beacon-tag-name=beacon-id-card],[beacon-version="4.3.1"] [beacon-tag-name=beacon-id-card]{--id-card-description-padding-after: var(--beacon-reference-space-4);--id-card-name-space-padding-jumbo: calc(var(--beacon-reference-space-2))}}@media (width >= 1280px){:root[beacon-tag-name=beacon-id-card],:root [beacon-tag-name=beacon-id-card],[beacon-version="4.3.1"][class*=beacon-on][beacon-tag-name=beacon-id-card],[beacon-version="4.3.1"][class*=beacon-on] [beacon-tag-name=beacon-id-card],[class*=beacon-on] [beacon-version="4.3.1"][beacon-tag-name=beacon-id-card],[class*=beacon-on] [beacon-version="4.3.1"] [beacon-tag-name=beacon-id-card],[beacon-version="4.3.1"][beacon-tag-name=beacon-id-card],[beacon-version="4.3.1"] [beacon-tag-name=beacon-id-card]{--id-card-name-space-padding-normal: 0;--id-card-name-space-padding-jumbo: calc(var(--beacon-reference-space-1));--id-card-name-space-padding-mini: var(--beacon-reference-space-1)}}`, vd = {
  beaconTagName: "beacon-id-card",
  DEFAULT_NAME: "T. Rowe Price"
}, pS = ve`[beacon-tag-name=beacon-id-card] :is([slot=name]){color:var(--bio-card-override-id-card-name-color-text, var(--beacon-system-color-text-standard));font:var(--override-id-card-display-name-font, var(--display-name-font));margin:var(--id-card-space-margin, 0);padding-block-start:var(--id-card-display-name-space-padding-block-start, var(--display-name-space-padding-block-start))}[beacon-tag-name=beacon-id-card] :is([slot=name]):is(a),[beacon-tag-name=beacon-id-card] :is([slot=name]) a{color:var(--bio-card-override-id-card-name-color-text, var(--beacon-system-color-text-link))}[beacon-tag-name=beacon-id-card] :is([slot=name]):is(a):not(:is(:hover,:focus)),[beacon-tag-name=beacon-id-card] :is([slot=name]) a:not(:is(:hover,:focus)){text-decoration:none}[beacon-tag-name=beacon-id-card] [slot=description]{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-300);margin-block-end:var(--override-description-margin-end, --id-card-description-padding-after);padding-block:var(--beacon-system-space-cell-contained);padding-inline:var(--beacon-system-space-cell-contained)}[beacon-tag-name=beacon-id-card] img[slot=avatar],[beacon-tag-name=beacon-id-card] [slot=avatar] img{aspect-ratio:var(--id-card-avatar-ratio, 1/1);background-color:var(--beacon-reference-palette-grayscale-white);block-size:var(--avatar-size);border-block-end:var(--id-card-avatar-border-block-end, 0);border-radius:var(--avatar-border-radius, 0);display:var(--id-card-avatar-display, grid);inline-size:var(--avatar-inline-size, var(--avatar-size));margin-inline:var(--avatar-inline-margin);object-fit:contain;object-position:right;place-items:center}[beacon-tag-name=beacon-id-card] .job-title,[beacon-tag-name=beacon-id-card] [slot=job-title]{font:var(--job-title-font)}[beacon-tag-name=beacon-id-card][free-floating] [slot=description]{padding:var(--beacon-system-space-cell-free-floating) 0}`, uS = ve`:host{--display-name-font: var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-body-200);--display-name-space-padding-block-start: var(--id-card-name-space-padding-normal);--avatar-size: var(--beacon-reference-space-11);--avatar-space-margin: var(--beacon-reference-space-3);--job-title-font: var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-300);--id-card-component-padding: 0;padding:var(--id-card-component-padding)}:host p{margin:0}.id-card{background-color:var(--id-card-background-color, initial);color:var(--beacon-system-color-text-standard);column-gap:var(--avatar-space-margin);display:flex;flex-direction:var(--override-id-card-flex-direction, initial);margin:var(--id-card-space-margin, 0);margin-block-end:var(--override-id-card-margin-block-end, 0);padding:var(--bio-card-override-id-card-space-padding, var(--beacon-system-space-cell-contained));position:relative}.avatar{border:var(--id-card-avatar-border, var(--beacon-system-width-border-mini) solid var(--beacon-system-color-border-2));display:var(--id-card-avatar-display, flex)}:host([free-floating]) .id-card{padding:var(--beacon-system-space-cell-free-floating) 0}.display-name{font:var(--override-id-card-display-name-font, var(--display-name-font));padding-block-start:var(--id-card-display-name-space-padding-block-start, var(--display-name-space-padding-block-start))}.display-name a{color:var(--bio-card-override-id-card-name-color-text, var(--beacon-system-color-text-link))}.text-content{align-self:var(--override-id-card-text-content-align-self, center);display:flex;flex-direction:column;inset-block-start:var(--id-card-top-position, unset);padding:var(--id-card-text-content-space-padding, 0);padding-block-start:var(--id-card-text-content-space-padding-block-start, 0);position:var(--id-card-content-position, static)}.multi-line{margin-block-start:calc(-1 * var(--beacon-reference-space-1))}.multi-line .display-name{padding-block-start:0}.job-title{font:var(--job-title-font)}::part(internal--icon){background-color:var(--beacon-component-avatar-icon-color-background);block-size:var(--avatar-size);color:var(--beacon-component-avatar-icon-color-avatar);inline-size:var(--avatar-size)}:host([scale=mini]){--display-name-font: var(--bio-card-override-id-card-name-font, var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-caption-300));--display-name-space-padding-block-start: var(--id-card-name-space-padding-mini);--avatar-size: var(--bio-card-override-id-card-avatar-size-mini, var(--id-card-avatar-size-mini))}:host([scale=jumbo]){--display-name-font: var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-headline-200);--display-name-space-padding-block-start: var(--id-card-name-space-padding-jumbo);--avatar-size: var(--beacon-reference-space-13);--avatar-space-margin: var(--beacon-reference-space-5);--job-title-font: var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-200)}:host([scale=maxi]){--avatar-size: var(--beacon-reference-space-15);--display-name-font: var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-headline-200);--display-name-space-padding-block-start: var(--id-card-name-space-padding-jumbo);--avatar-space-margin: var(--beacon-reference-space-5);--job-title-font: var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-200)}:host([scale=maxi]) .base,.base:has(.commentary-tile){border:var(--id-card-border, var(--beacon-system-width-border-mini) solid var(--beacon-system-color-border-2))}:host([scale=maxi]:not([free-floating])){--id-card-background-color: var(--beacon-system-color-background-1)}@media (width >= 640px){:host([scale=maxi]){--avatar-size: var(--beacon-reference-space-20)}}@media (width >= 1280px){:host([scale=maxi]){--beacon-reference-space-25: 10rem;--avatar-size: var(--beacon-reference-space-25)}}`;
var gS = Object.defineProperty, gn = (i, t, e, a) => {
  for (var o = void 0, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = r(t, e, o) || o);
  return o && gS(t, e, o), o;
}, hr, nf, rf;
const $l = class $l extends Le {
  constructor() {
    super(...arguments);
    Fe(this, hr);
    this.beaconTagName = vd.beaconTagName, this.scale = Do.NORMAL, this.freeFloating = !1, this.noAvatar = !1, this._hasAuthor = !1, this._hasDescription = !1;
  }
  static get styles() {
    return [super.styles, uS];
  }
  static get lightDOMStyles() {
    return [super.lightDOMStyles, pS, bS];
  }
  get slottedAvatar() {
    return Wi(
      this,
      "_slottedAvatar",
      () => {
        var e;
        return (e = this.querySelector('[slot="avatar"]')) != null ? e : void 0;
      }
    );
  }
  get slottedAvatarUrl() {
    var a, o;
    let e;
    return this.slottedAvatar instanceof HTMLPictureElement && (e = this.slottedAvatar.querySelector("img")), this.slottedAvatar instanceof HTMLImageElement && (e = this.slottedAvatar), !e && this.slottedAvatar && (e = (a = this.slottedAvatar) == null ? void 0 : a.querySelector("img")), (o = e == null ? void 0 : e.src) != null ? o : "";
  }
  get slottedFullName() {
    var e;
    return this.slottedName && ((e = this.slottedName[0]) == null ? void 0 : e.innerText);
  }
  render() {
    const e = {
      "commentary-tile": this._hasDescription,
      "id-card": !0
    };
    return pe`
      <div class="base">
        <div class="${Oe(e)}">
          ${this.noAvatar ? _e : pe`
                <div class="avatar">
                  <slot name="avatar">
                    ${Be`<${this.getScopedTag("beacon-icon")} name="${this._hasAuthor ? "user" : "trusty"}"></${this.getScopedTag("beacon-icon")}>`}
                  </slot>
                </div>
              `}
          <div class="text-content">
            <p id="display-name" class="display-name">
              <slot name="name" @slotchange=${Ze(this, hr, nf)}
                >${vd.DEFAULT_NAME}</slot
              >
            </p>
            <slot name="job-title"></slot>
          </div>
        </div>
        <slot
          name="description"
          @slotchange=${Ze(this, hr, rf)}></slot>
      </div>
    `;
  }
};
hr = new WeakSet(), nf = function() {
  this._hasAuthor = this.slottedName.length > 0;
}, rf = function() {
  this._hasDescription = this.slottedDescription.length > 0;
}, $l.tagName = vd.beaconTagName, $l.nestedComponents = [fo];
let Bo = $l;
gn([
  ue({ reflect: !0 })
], Bo.prototype, "scale");
gn([
  ue({ attribute: "free-floating", type: Boolean })
], Bo.prototype, "freeFloating");
gn([
  ue({ attribute: "no-avatar", type: Boolean })
], Bo.prototype, "noAvatar");
gn([
  Se()
], Bo.prototype, "_hasAuthor");
gn([
  Se()
], Bo.prototype, "_hasDescription");
gn([
  Pe({ slot: "description" })
], Bo.prototype, "slottedDescription");
gn([
  wt({ slot: "name" })
], Bo.prototype, "slottedName");
const mS = ve`:root[beacon-tag-name=beacon-bio-card],:root [beacon-tag-name=beacon-bio-card],[beacon-version="4.3.1"][class*=beacon-on][beacon-tag-name=beacon-bio-card],[beacon-version="4.3.1"][class*=beacon-on] [beacon-tag-name=beacon-bio-card],[class*=beacon-on] [beacon-version="4.3.1"][beacon-tag-name=beacon-bio-card],[class*=beacon-on] [beacon-version="4.3.1"] [beacon-tag-name=beacon-bio-card],[beacon-version="4.3.1"][beacon-tag-name=beacon-bio-card],[beacon-version="4.3.1"] [beacon-tag-name=beacon-bio-card]{--avatar-border-radius: var(--beacon-system-radius-corner-standard) var(--beacon-system-radius-corner-standard) 0 0;--bio-card-avatar-size-inline-normal: auto;--bio-card-avatar-size-inline-wide: auto}:root[beacon-tag-name=beacon-bio-card]:not([template=hero]),:root [beacon-tag-name=beacon-bio-card]:not([template=hero]),[beacon-version="4.3.1"][class*=beacon-on][beacon-tag-name=beacon-bio-card]:not([template=hero]),[beacon-version="4.3.1"][class*=beacon-on] [beacon-tag-name=beacon-bio-card]:not([template=hero]),[class*=beacon-on] [beacon-version="4.3.1"][beacon-tag-name=beacon-bio-card]:not([template=hero]),[class*=beacon-on] [beacon-version="4.3.1"] [beacon-tag-name=beacon-bio-card]:not([template=hero]),[beacon-version="4.3.1"][beacon-tag-name=beacon-bio-card]:not([template=hero]),[beacon-version="4.3.1"] [beacon-tag-name=beacon-bio-card]:not([template=hero]){--avatar-border-radius: 0}:root[beacon-tag-name=beacon-bio-card]:is([layout=horizontal],[layout=horizontal-wide]),:root [beacon-tag-name=beacon-bio-card]:is([layout=horizontal],[layout=horizontal-wide]),[beacon-version="4.3.1"][class*=beacon-on][beacon-tag-name=beacon-bio-card]:is([layout=horizontal],[layout=horizontal-wide]),[beacon-version="4.3.1"][class*=beacon-on] [beacon-tag-name=beacon-bio-card]:is([layout=horizontal],[layout=horizontal-wide]),[class*=beacon-on] [beacon-version="4.3.1"][beacon-tag-name=beacon-bio-card]:is([layout=horizontal],[layout=horizontal-wide]),[class*=beacon-on] [beacon-version="4.3.1"] [beacon-tag-name=beacon-bio-card]:is([layout=horizontal],[layout=horizontal-wide]),[beacon-version="4.3.1"][beacon-tag-name=beacon-bio-card]:is([layout=horizontal],[layout=horizontal-wide]),[beacon-version="4.3.1"] [beacon-tag-name=beacon-bio-card]:is([layout=horizontal],[layout=horizontal-wide]){--aspect-ratio: 2/3}:root[beacon-tag-name=beacon-bio-card]:is([layout=horizontal],[layout=horizontal-wide])[template=hero][hero-position=right],:root [beacon-tag-name=beacon-bio-card]:is([layout=horizontal],[layout=horizontal-wide])[template=hero][hero-position=right],[beacon-version="4.3.1"][class*=beacon-on][beacon-tag-name=beacon-bio-card]:is([layout=horizontal],[layout=horizontal-wide])[template=hero][hero-position=right],[beacon-version="4.3.1"][class*=beacon-on] [beacon-tag-name=beacon-bio-card]:is([layout=horizontal],[layout=horizontal-wide])[template=hero][hero-position=right],[class*=beacon-on] [beacon-version="4.3.1"][beacon-tag-name=beacon-bio-card]:is([layout=horizontal],[layout=horizontal-wide])[template=hero][hero-position=right],[class*=beacon-on] [beacon-version="4.3.1"] [beacon-tag-name=beacon-bio-card]:is([layout=horizontal],[layout=horizontal-wide])[template=hero][hero-position=right],[beacon-version="4.3.1"][beacon-tag-name=beacon-bio-card]:is([layout=horizontal],[layout=horizontal-wide])[template=hero][hero-position=right],[beacon-version="4.3.1"] [beacon-tag-name=beacon-bio-card]:is([layout=horizontal],[layout=horizontal-wide])[template=hero][hero-position=right]{--avatar-border-radius: 0 var(--beacon-system-radius-corner-standard) var(--beacon-system-radius-corner-standard) 0}@media (width >= 640px){:root[beacon-tag-name=beacon-bio-card]:is([layout=horizontal],[layout=horizontal-wide])[template=hero],:root [beacon-tag-name=beacon-bio-card]:is([layout=horizontal],[layout=horizontal-wide])[template=hero],[beacon-version="4.3.1"][class*=beacon-on][beacon-tag-name=beacon-bio-card]:is([layout=horizontal],[layout=horizontal-wide])[template=hero],[beacon-version="4.3.1"][class*=beacon-on] [beacon-tag-name=beacon-bio-card]:is([layout=horizontal],[layout=horizontal-wide])[template=hero],[class*=beacon-on] [beacon-version="4.3.1"][beacon-tag-name=beacon-bio-card]:is([layout=horizontal],[layout=horizontal-wide])[template=hero],[class*=beacon-on] [beacon-version="4.3.1"] [beacon-tag-name=beacon-bio-card]:is([layout=horizontal],[layout=horizontal-wide])[template=hero],[beacon-version="4.3.1"][beacon-tag-name=beacon-bio-card]:is([layout=horizontal],[layout=horizontal-wide])[template=hero],[beacon-version="4.3.1"] [beacon-tag-name=beacon-bio-card]:is([layout=horizontal],[layout=horizontal-wide])[template=hero]{--avatar-border-radius: var(--beacon-system-radius-corner-standard) 0 0 var(--beacon-system-radius-corner-standard)}}@media (width >= 960px){:root[beacon-tag-name=beacon-bio-card],:root [beacon-tag-name=beacon-bio-card],[beacon-version="4.3.1"][class*=beacon-on][beacon-tag-name=beacon-bio-card],[beacon-version="4.3.1"][class*=beacon-on] [beacon-tag-name=beacon-bio-card],[class*=beacon-on] [beacon-version="4.3.1"][beacon-tag-name=beacon-bio-card],[class*=beacon-on] [beacon-version="4.3.1"] [beacon-tag-name=beacon-bio-card],[beacon-version="4.3.1"][beacon-tag-name=beacon-bio-card],[beacon-version="4.3.1"] [beacon-tag-name=beacon-bio-card]{--bio-card-avatar-size-inline-normal: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 4 + var(--beacon-system-space-gutter) * 3);--bio-card-avatar-size-inline-wide: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 3 + var(--beacon-system-space-gutter) * 2)}}@media (width >= 1280px){:root[beacon-tag-name=beacon-bio-card],:root [beacon-tag-name=beacon-bio-card],[beacon-version="4.3.1"][class*=beacon-on][beacon-tag-name=beacon-bio-card],[beacon-version="4.3.1"][class*=beacon-on] [beacon-tag-name=beacon-bio-card],[class*=beacon-on] [beacon-version="4.3.1"][beacon-tag-name=beacon-bio-card],[class*=beacon-on] [beacon-version="4.3.1"] [beacon-tag-name=beacon-bio-card],[beacon-version="4.3.1"][beacon-tag-name=beacon-bio-card],[beacon-version="4.3.1"] [beacon-tag-name=beacon-bio-card]{--bio-card-avatar-size-inline-normal: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 3 + var(--beacon-system-space-gutter) * 2)}}`, Ha = {
  beaconTagName: "beacon-bio-card",
  dataListNodeName: "BEACON-DATA-LIST",
  dataListElement: "dl",
  dataListItemLimit: 3,
  bioCardLayoutProperty: "layout"
}, fS = ve`[beacon-tag-name=beacon-bio-card] [beacon-tag-name=beacon-id-card]{--override-padding: 0;--override-description-margin-end: 0;--override-id-card-margin-block-end: var(--beacon-reference-space-3);--override-id-card-text-content-align-self: start}[beacon-tag-name=beacon-bio-card] [beacon-tag-name=beacon-id-card] :where(img){max-inline-size:var(--override-id-card-img-max-inline-size, 100%)}[beacon-tag-name=beacon-bio-card][template=hero] [beacon-tag-name=beacon-id-card]{--id-card-top-position: 0;--avatar-inline-size: var(--bio-card-max-inline-size);--avatar-inline-margin: calc(var(--beacon-system-space-organism-normal) * -1);--override-id-card-display-name-font: var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-100);--override-id-card-img-max-inline-size: calc(100% + calc(var(--beacon-system-space-organism-normal) * 2))}[beacon-tag-name=beacon-bio-card][template=hero] [beacon-tag-name=beacon-id-card] [slot=name]:is(a):not(:is(:hover,:focus)),[beacon-tag-name=beacon-bio-card][template=hero] [beacon-tag-name=beacon-id-card] [slot=name] a:not(:is(:hover,:focus)){text-decoration:none}[beacon-tag-name=beacon-bio-card][template=hero][layout=vertical] [beacon-tag-name=beacon-id-card]{--avatar-inline-size: var(--bio-card-max-inline-size);--avatar-inline-margin: calc(var(--beacon-system-space-organism-normal) * -1);--override-id-card-margin-block-end: 0;--override-id-card-img-max-inline-size: calc(100% + calc(var(--beacon-system-space-organism-normal) * 2))}@media (width >= 960px){[beacon-tag-name=beacon-bio-card][template=hero][layout=vertical] [beacon-tag-name=beacon-id-card]{--override-id-card-margin-block-end: var(--beacon-system-space-micro-mini)}}@media (width >= 640px){[beacon-tag-name=beacon-bio-card][template=hero]:not([layout=vertical]) [beacon-tag-name=beacon-id-card]{--id-card-text-content-space-padding: 0;--id-card-text-content-space-padding-block-start: 0;--override-id-card-margin-block-end: 0}[beacon-tag-name=beacon-bio-card][template=hero]:not([layout=vertical]) [beacon-tag-name=beacon-id-card] [slot=name]:is(a),[beacon-tag-name=beacon-bio-card][template=hero]:not([layout=vertical]) [beacon-tag-name=beacon-id-card] [slot=name] a{color:var(--beacon-system-color-text-link)}}[beacon-tag-name=beacon-bio-card] .footnote,[beacon-tag-name=beacon-bio-card] [slot=footnote]{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-200);margin:0;padding:var(--beacon-system-space-cell-contained)}`, vS = ve`:host{--bio-card-max-inline-size: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 6 + var(--beacon-system-space-gutter) * 5);--hero-direction: row;background-color:var(--beacon-system-color-background-1);border:var(--beacon-system-width-border-mini) solid var(--beacon-system-color-border-2);border-radius:var(--beacon-system-radius-corner-standard, 0);max-inline-size:var(--bio-card-max-inline-size);padding:var(--beacon-system-space-organism-normal)}.avatar{--avatar-aspect-ratio: 1 / 2;--avatar-column: 50%;--avatar-inline-margin: calc(var(--beacon-system-space-organism-normal) * -1) 0;border-radius:var(--avatar-border-radius)}:host([template=hero]){--id-card-avatar-ratio: 2 / 1;--bio-card-override-id-card-avatar-size-mini: 100%;--bio-card-override-id-card-color-text: var(--beacon-reference-palette-greyscale-white);--override-id-card-flex-direction: column;--id-card-text-content-space-padding: var(--beacon-system-space-cell-contained);--id-card-text-content-space-padding-block-start: calc(var(--beacon-system-space-organism-normal) + var(--beacon-system-space-cell-contained));--id-card-avatar-border: 0;--bio-card-override-id-card-name-color-text: var(--beacon-custom-id-card-name-color-text, var(--beacon-system-color-text-link));--bio-card-override-id-card-name-font: var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-body-100);--bio-card-override-id-card-name-font-line-height-mini: 1.43;--bio-card-override-id-card-name-font-size-mini: var(--beacon-reference-font-scale-3);--bio-card-override-id-card-space-padding: 0;--border-radius: var(--beacon-system-radius-corner-standard);padding-block-start:0}:host([template=hero]) .avatar{display:none}:host([hero-position=right]){--hero-direction: row-reverse}:host([hero-position=right]) .avatar{--avatar-inline-margin: 0 calc(var(--beacon-system-space-organism-normal) * -1)}.content{--content-column: 50%}.footnote,::slotted([slot=footnote]){font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-200);margin:0;padding:var(--beacon-system-space-cell-contained)}::slotted([beacon-tag-name=beacon-id-card]){--id-card-border: 0;--id-card-avatar-border-block-end: var(--beacon-system-width-border-mini) solid var(--beacon-system-color-border-2)}@media (width >= 640px){:host([layout=vertical]){--bio-card-max-inline-size: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 6 + var(--beacon-system-space-gutter) * 5);--avatar-size: var(--bio-card-max-inline-size)}:host([template=hero]:not([layout=vertical])){--bio-card-max-inline-size: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 10 + var(--beacon-system-space-gutter) * 9);--id-card-avatar-display: none;--avatar-block-size: inherit;--id-card-content-position: relative;--bio-card-override-id-card-name-font: var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-caption-300);--bio-card-override-id-card-space-padding: var(--beacon-reference-space-3);display:flex;flex-direction:var(--hero-direction);padding:0}:host([template=hero]:not([layout=vertical])) .avatar{aspect-ratio:var(--aspect-ratio, var(--avatar-aspect-ratio));block-size:var(--avatar-block-size);display:block;inline-size:var(--avatar-column);object-fit:cover}:host([template=hero]:not([layout=vertical])) .avatar.left{border-inline-end:var(--beacon-system-width-border-mini) solid var(--beacon-system-color-border-2)}:host([template=hero]:not([layout=vertical])) .avatar.right{border-inline-start:var(--beacon-system-width-border-mini) solid var(--beacon-system-color-border-2)}:host([template=hero]:not([layout=vertical])) .content{display:flex;flex-direction:column;inline-size:var(--content-column);padding:var(--beacon-system-space-organism-normal)}:host([template=hero]:not([layout=vertical])) ::slotted([beacon-tag-name=beacon-id-card]){--id-card-avatar-border-block-end: 0}:host([template=hero]:not([layout=vertical][hero-position=left])){--border-radius: 100px 20px 40px 60px}}@media (width >= 960px){:host([layout=vertical]){--bio-card-max-inline-size: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 4 + var(--beacon-system-space-gutter) * 3)}:host([layout=horizontal]){--bio-card-max-inline-size: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 10 + var(--beacon-system-space-gutter) * 9)}:host([template=hero]:not([layout=vertical])) .content{--content-column: auto}:host([template=hero]:not([layout=vertical])) .avatar{--avatar-column: var(--bio-card-avatar-size-inline-normal)}:host([template=hero][layout=horizontal-wide]) .avatar{--avatar-column: var(--bio-card-avatar-size-inline-wide)}:host([layout=horizontal-wide]){--bio-card-max-inline-size: 100%}:host([layout=horizontal-wide]) .content{column-gap:var(--beacon-reference-space-7);display:grid;grid-template-columns:8fr 4fr}}@media (width >= 1280px){.avatar{--avatar-aspect-ratio: 1 / 1}}`;
var AS = Object.defineProperty, yi = (i, t, e, a) => {
  for (var o = void 0, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = r(t, e, o) || o);
  return o && AS(t, e, o), o;
};
const gb = class gb extends Le {
  constructor() {
    var t, e;
    super(...arguments), this.beaconTagName = Ha.beaconTagName, this.layout = pa.HORIZONTAL, this.template = Br.STANDARD, this.heroPosition = _h.LEFT, this.DataList = this.SlottedDataList, this.ListItemsContainer = (t = this.DataList) == null ? void 0 : t.renderRoot.querySelector(Ha.dataListElement), this.ListItems = (e = this.DataList) == null ? void 0 : e.listItems;
  }
  static get styles() {
    return [super.styles, vS];
  }
  static get lightDOMStyles() {
    return [super.lightDOMStyles, mS, fS];
  }
  /** The first element in the @beaconQueryAssignedElements array */
  get SlottedIdCard() {
    return this.IdCard[0];
  }
  set SlottedIdCard(t) {
    this.IdCard = Array(t);
  }
  /** The first element in the @beaconQueryAssignedElements array */
  get SlottedDataList() {
    return this.DataLists[0];
  }
  /**
   * @returns null on initial load
   * @returns The avatar URL of the slotted Commentary Tile after firstUpdated()
   */
  get Avatar() {
    var t;
    return (t = this.SlottedIdCard) == null ? void 0 : t.slottedAvatarUrl;
  }
  /**
   * returns the Updated Data-List after being set in firstUpdated()
   */
  get BeaconDataList() {
    return this.DataList;
  }
  /** Extract the data list from the slot, either alone or from a containing `<div>` */
  set BeaconDataList(t) {
    var a;
    const e = this.getScopedTagName(Ha.dataListNodeName);
    (t == null ? void 0 : t.nodeName) !== e ? this.DataList = (a = this.SlottedDataList) == null ? void 0 : a.querySelector(
      e.toLowerCase()
    ) : this.DataList = t;
  }
  /**
   * called any time the data list re-renders (i.e. if new items are added)
   */
  changeDataListOrientation() {
    if (this.BeaconDataList instanceof Yi) {
      const t = this.BeaconDataList.listItems.length;
      if (this.template === Br.STANDARD)
        switch (this.layout) {
          case pa.VERTICAL:
          case pa.HORIZONTAL_WIDE:
            this.BeaconDataList.orientation = jo.VERTICAL;
            break;
          case pa.HORIZONTAL:
          default:
            this.BeaconDataList.orientation = t && t > Ha.dataListItemLimit ? jo.SPLIT : jo.HORIZONTAL;
            break;
        }
      else if (this.template === Br.HERO)
        switch (this.layout) {
          case pa.VERTICAL:
            this.BeaconDataList.orientation = jo.VERTICAL;
            break;
          case pa.HORIZONTAL_WIDE:
            this.BeaconDataList.orientation = t && t > Ha.dataListItemLimit ? jo.SPLIT : jo.HORIZONTAL;
            break;
          case pa.HORIZONTAL:
          default:
            this.BeaconDataList.orientation = t && t > Ha.dataListItemLimit ? jo.SPLIT : jo.VERTICAL;
            break;
        }
    }
  }
  /**
   * Updates the data-list when the slotted component fires a render event.
   * @param event takes a custom Render event emitted by the data-list
   */
  handleRender() {
    this.updateDataList();
  }
  /**
   * Safely updates the data-list orientation by waiting for update completion to the Datalist
   * and updates the updated data list's orientation.
   */
  async updateDataList() {
    this.BeaconDataList instanceof Yi && (await this.BeaconDataList.updateComplete, this.changeDataListOrientation());
  }
  /**
   * overrides updated and checks to see if layout was changed after an update then, updated
   * then safely updated the data-list orientation.
   * @param changedProperties Internal Map object of changed properties during an update
   */
  updated(t) {
    t.has(Ha.bioCardLayoutProperty) && this.updateDataList();
  }
  /**
   * Checks to see if slotted Commentary tiles and Data-lists
   * are finished updated, then sets the bio-cards reference properties
   * to the Commentary Tile and Data-List. Updates Data-List orientation
   * also after waiting for its rendering.
   */
  async firstUpdated() {
    var t, e;
    this.SlottedIdCard instanceof Bo && (this.SlottedIdCard.scale = Do.MINI, await this.requestUpdate("SlottedIdCard"), await ((t = this.SlottedIdCard) == null ? void 0 : t.updateComplete), await this.updateComplete), this.BeaconDataList = this.SlottedDataList, this.BeaconDataList instanceof Yi && (await ((e = this.BeaconDataList) == null ? void 0 : e.updateComplete), this.changeDataListOrientation()), super.firstUpdated();
  }
  render() {
    return pe`
      ${this.template === Br.HERO && this.layout !== pa.VERTICAL ? pe`<img
            class="avatar ${this.heroPosition}"
            src="${this.Avatar}"
            alt="" />` : _e}
      <div class="content">
        <slot name="id-card"></slot>
        <div class="list-content">
          <slot
            name="data-list"
            @beacon-event-render=${this.handleRender}></slot>
          <slot name="footnote" class="footnote"></slot>
        </div>
      </div>
    `;
  }
};
gb.tagName = Ha.beaconTagName;
let Jo = gb;
yi([
  ue({ reflect: !0 })
], Jo.prototype, "layout");
yi([
  ue({ reflect: !0 })
], Jo.prototype, "template");
yi([
  ue({ attribute: "hero-position" })
], Jo.prototype, "heroPosition");
yi([
  Pe({ flatten: !0, slot: "id-card" })
], Jo.prototype, "IdCard");
yi([
  Pe({ flatten: !0, slot: "data-list" })
], Jo.prototype, "DataLists");
yi([
  Se()
], Jo.prototype, "DataList");
yi([
  Se()
], Jo.prototype, "ListItemsContainer");
yi([
  Se()
], Jo.prototype, "ListItems");
class Uh extends Pa {
  constructor(t) {
    if (super(t), t.type !== ln.EVENT || t.name !== "slotchange" || t.tagName !== "SLOT")
      throw new Error(
        "The `addListRole` directive must be used on a `<slot>` and the `slotchange` event"
      );
    this.part = t;
  }
  /**
   * Adds the list role to any <ul> or <ol> elements slotted into this slot
   * @param part
   */
  static addListRoleToSlotted(t) {
    if (t) {
      const e = (t == null ? void 0 : t.element).assignedElements();
      e == null || e.forEach((a) => {
        (a.tagName === "UL" || a.tagName === "OL") && (a.role = "list");
      });
    }
  }
  /**
   * Takes in a secondary function to be executed on slotchange. This is so that the user can still listen for slotchange
   * events when using this directive.
   * @param otherSlotChangeFunction Secondary slot change function to be called alongside this directive
   * @returns Empty string. When there is no return value, the event listeners are never properly attached.
   */
  render(t = void 0) {
    return this.part && (this.part.handleEvent = (e) => {
      this.part && Uh.addListRoleToSlotted(this.part), t && t(e);
    }), "";
  }
}
const Is = Oa(Uh);
function yS(i) {
  return parseFloat(i) * 16;
}
const mu = {
  beaconTagName: "beacon-menu"
}, xS = ve`[beacon-tag-name=beacon-menu] :is(li),[beacon-tag-name=beacon-menu] :is(li)>*{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-body-100);inline-size:auto;text-decoration:none;white-space:inherit}[beacon-tag-name=beacon-menu] :is(li):hover a{color:var(--beacon-system-color-text-link);text-decoration:underline}[beacon-tag-name=beacon-menu] :is(li){align-items:center;display:flex;flex-direction:row;gap:var(--beacon-reference-space-2)}[beacon-tag-name=beacon-menu] :is(li) :is(svg){block-size:var(--beacon-reference-space-5);inline-size:var(--beacon-reference-space-5);stroke:var(--beacon-system-color-border-link)}[beacon-tag-name=beacon-menu] :is(li,h1,h2,h3,h4,h5,h6){padding:var(--beacon-system-space-cell-contained)}[beacon-tag-name=beacon-menu] [slot=title],[beacon-tag-name=beacon-menu] [slot=title]>*{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-body-200)}`, wS = ve`:host ::slotted(ul),:host ::slotted(ol){display:flex;flex-direction:column;gap:var(--beacon-reference-space-3);inline-size:auto;list-style:none;margin:0;padding:0}`;
var kS = Object.defineProperty, sf = (i, t, e, a) => {
  for (var o = void 0, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = r(t, e, o) || o);
  return o && kS(t, e, o), o;
};
const mb = class mb extends Le {
  constructor() {
    super(...arguments), this.beaconTagName = mu.beaconTagName;
  }
  static get styles() {
    return [super.styles, wS];
  }
  static get lightDOMStyles() {
    return [super.lightDOMStyles, xS];
  }
  handleSlotChange() {
    if (this.slottedMenu) {
      const t = this.slottedMenu[0];
      t == null || t.setAttribute("role", "menu"), t == null || t.querySelectorAll("li").forEach((e) => {
        e.setAttribute("role", "menuitem");
      });
    }
  }
  /**
   * Assigns an ID to the slotted title, and applies
   * the ID to the menu as `aria-labelledby`.
   */
  handleTitleSlotChange() {
    var t, e;
    if ((t = this.slottedTitle) != null && t.length) {
      const a = this.slottedTitle[0], o = (e = this.slottedMenu) == null ? void 0 : e[0];
      if (o) {
        const n = Ia();
        o.setAttribute("aria-labelledby", a.id || n), a.id = a.id || n;
      }
    }
  }
  render() {
    return pe`<slot
        name="title"
        @slotchange=${this.handleTitleSlotChange}></slot>
      <slot @slotchange=${this.handleSlotChange}></slot>`;
  }
};
mb.tagName = mu.beaconTagName;
let is = mb;
sf([
  wt({ slot: "", selector: "ul, ol" })
], is.prototype, "slottedMenu");
sf([
  wt({ slot: "title" })
], is.prototype, "slottedTitle");
/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
var lf = ["input:not([inert])", "select:not([inert])", "textarea:not([inert])", "a[href]:not([inert])", "button:not([inert])", "[tabindex]:not(slot):not([inert])", "audio[controls]:not([inert])", "video[controls]:not([inert])", '[contenteditable]:not([contenteditable="false"]):not([inert])', "details>summary:first-of-type:not([inert])", "details:not([inert])"], kl = /* @__PURE__ */ lf.join(","), cf = typeof Element > "u", on = cf ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, Cl = !cf && Element.prototype.getRootNode ? function(i) {
  var t;
  return i == null || (t = i.getRootNode) === null || t === void 0 ? void 0 : t.call(i);
} : function(i) {
  return i == null ? void 0 : i.ownerDocument;
}, Sl = function i(t, e) {
  var a;
  e === void 0 && (e = !0);
  var o = t == null || (a = t.getAttribute) === null || a === void 0 ? void 0 : a.call(t, "inert"), n = o === "" || o === "true", r = n || e && t && i(t.parentNode);
  return r;
}, CS = function(t) {
  var e, a = t == null || (e = t.getAttribute) === null || e === void 0 ? void 0 : e.call(t, "contenteditable");
  return a === "" || a === "true";
}, df = function(t, e, a) {
  if (Sl(t))
    return [];
  var o = Array.prototype.slice.apply(t.querySelectorAll(kl));
  return e && on.call(t, kl) && o.unshift(t), o = o.filter(a), o;
}, hf = function i(t, e, a) {
  for (var o = [], n = Array.from(t); n.length; ) {
    var r = n.shift();
    if (!Sl(r, !1))
      if (r.tagName === "SLOT") {
        var T = r.assignedElements(), O = T.length ? T : r.children, j = i(O, !0, a);
        a.flatten ? o.push.apply(o, j) : o.push({
          scopeParent: r,
          candidates: j
        });
      } else {
        var D = on.call(r, kl);
        D && a.filter(r) && (e || !t.includes(r)) && o.push(r);
        var F = r.shadowRoot || // check for an undisclosed shadow
        typeof a.getShadowRoot == "function" && a.getShadowRoot(r), B = !Sl(F, !1) && (!a.shadowRootFilter || a.shadowRootFilter(r));
        if (F && B) {
          var N = i(F === !0 ? r.children : F.children, !0, a);
          a.flatten ? o.push.apply(o, N) : o.push({
            scopeParent: r,
            candidates: N
          });
        } else
          n.unshift.apply(n, r.children);
      }
  }
  return o;
}, bf = function(t) {
  return !isNaN(parseInt(t.getAttribute("tabindex"), 10));
}, Ii = function(t) {
  if (!t)
    throw new Error("No node provided");
  return t.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(t.tagName) || CS(t)) && !bf(t) ? 0 : t.tabIndex;
}, SS = function(t, e) {
  var a = Ii(t);
  return a < 0 && e && !bf(t) ? 0 : a;
}, ES = function(t, e) {
  return t.tabIndex === e.tabIndex ? t.documentOrder - e.documentOrder : t.tabIndex - e.tabIndex;
}, pf = function(t) {
  return t.tagName === "INPUT";
}, TS = function(t) {
  return pf(t) && t.type === "hidden";
}, MS = function(t) {
  var e = t.tagName === "DETAILS" && Array.prototype.slice.apply(t.children).some(function(a) {
    return a.tagName === "SUMMARY";
  });
  return e;
}, LS = function(t, e) {
  for (var a = 0; a < t.length; a++)
    if (t[a].checked && t[a].form === e)
      return t[a];
}, OS = function(t) {
  if (!t.name)
    return !0;
  var e = t.form || Cl(t), a = function(T) {
    return e.querySelectorAll('input[type="radio"][name="' + T + '"]');
  }, o;
  if (typeof window < "u" && typeof window.CSS < "u" && typeof window.CSS.escape == "function")
    o = a(window.CSS.escape(t.name));
  else
    try {
      o = a(t.name);
    } catch (r) {
      return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", r.message), !1;
    }
  var n = LS(o, t.form);
  return !n || n === t;
}, PS = function(t) {
  return pf(t) && t.type === "radio";
}, zS = function(t) {
  return PS(t) && !OS(t);
}, DS = function(t) {
  var e, a = t && Cl(t), o = (e = a) === null || e === void 0 ? void 0 : e.host, n = !1;
  if (a && a !== t) {
    var r, T, O;
    for (n = !!((r = o) !== null && r !== void 0 && (T = r.ownerDocument) !== null && T !== void 0 && T.contains(o) || t != null && (O = t.ownerDocument) !== null && O !== void 0 && O.contains(t)); !n && o; ) {
      var j, D, F;
      a = Cl(o), o = (j = a) === null || j === void 0 ? void 0 : j.host, n = !!((D = o) !== null && D !== void 0 && (F = D.ownerDocument) !== null && F !== void 0 && F.contains(o));
    }
  }
  return n;
}, fu = function(t) {
  var e = t.getBoundingClientRect(), a = e.width, o = e.height;
  return a === 0 && o === 0;
}, IS = function(t, e) {
  var a = e.displayCheck, o = e.getShadowRoot;
  if (getComputedStyle(t).visibility === "hidden")
    return !0;
  var n = on.call(t, "details>summary:first-of-type"), r = n ? t.parentElement : t;
  if (on.call(r, "details:not([open]) *"))
    return !0;
  if (!a || a === "full" || a === "legacy-full") {
    if (typeof o == "function") {
      for (var T = t; t; ) {
        var O = t.parentElement, j = Cl(t);
        if (O && !O.shadowRoot && o(O) === !0)
          return fu(t);
        t.assignedSlot ? t = t.assignedSlot : !O && j !== t.ownerDocument ? t = j.host : t = O;
      }
      t = T;
    }
    if (DS(t))
      return !t.getClientRects().length;
    if (a !== "legacy-full")
      return !0;
  } else if (a === "non-zero-area")
    return fu(t);
  return !1;
}, BS = function(t) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(t.tagName))
    for (var e = t.parentElement; e; ) {
      if (e.tagName === "FIELDSET" && e.disabled) {
        for (var a = 0; a < e.children.length; a++) {
          var o = e.children.item(a);
          if (o.tagName === "LEGEND")
            return on.call(e, "fieldset[disabled] *") ? !0 : !o.contains(t);
        }
        return !0;
      }
      e = e.parentElement;
    }
  return !1;
}, El = function(t, e) {
  return !(e.disabled || // we must do an inert look up to filter out any elements inside an inert ancestor
  //  because we're limited in the type of selectors we can use in JSDom (see related
  //  note related to `candidateSelectors`)
  Sl(e) || TS(e) || IS(e, t) || // For a details element with a summary, the summary element gets the focus
  MS(e) || BS(e));
}, eh = function(t, e) {
  return !(zS(e) || Ii(e) < 0 || !El(t, e));
}, RS = function(t) {
  var e = parseInt(t.getAttribute("tabindex"), 10);
  return !!(isNaN(e) || e >= 0);
}, NS = function i(t) {
  var e = [], a = [];
  return t.forEach(function(o, n) {
    var r = !!o.scopeParent, T = r ? o.scopeParent : o, O = SS(T, r), j = r ? i(o.candidates) : T;
    O === 0 ? r ? e.push.apply(e, j) : e.push(T) : a.push({
      documentOrder: n,
      tabIndex: O,
      item: o,
      isScope: r,
      content: j
    });
  }), a.sort(ES).reduce(function(o, n) {
    return n.isScope ? o.push.apply(o, n.content) : o.push(n.content), o;
  }, []).concat(e);
}, uf = function(t, e) {
  e = e || {};
  var a;
  return e.getShadowRoot ? a = hf([t], e.includeContainer, {
    filter: eh.bind(null, e),
    flatten: !1,
    getShadowRoot: e.getShadowRoot,
    shadowRootFilter: RS
  }) : a = df(t, e.includeContainer, eh.bind(null, e)), NS(a);
}, FS = function(t, e) {
  e = e || {};
  var a;
  return e.getShadowRoot ? a = hf([t], e.includeContainer, {
    filter: El.bind(null, e),
    flatten: !0,
    getShadowRoot: e.getShadowRoot
  }) : a = df(t, e.includeContainer, El.bind(null, e)), a;
}, Mn = function(t, e) {
  if (e = e || {}, !t)
    throw new Error("No node provided");
  return on.call(t, kl) === !1 ? !1 : eh(e, t);
}, _S = /* @__PURE__ */ lf.concat("iframe").join(","), Ad = function(t, e) {
  if (e = e || {}, !t)
    throw new Error("No node provided");
  return on.call(t, _S) === !1 ? !1 : El(e, t);
}, ns = /* @__PURE__ */ ((i) => (i.ENABLED = "enabled", i.DISABLED = "disabled", i))(ns || {}), jh = /* @__PURE__ */ ((i) => (i.VIEWED = "b-motion-viewed", i))(jh || {}), US = Object.getOwnPropertyDescriptor, jS = (i, t, e, a) => {
  for (var o = a > 1 ? void 0 : a ? US(t, e) : t, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = r(o) || o);
  return o;
};
function $h(i) {
  let t = class extends i {
    /**
     * Keyboard event handler for arrow control. Uses the element that we are currently
     * focused on to find order which removes any complexity that comes from tracking
     * the current index.
     *
     * To use the mixin, attach this event listener to each of the events to be
     * controlled with arrow control, then pass an array of those elements as arrowControlElements
     *
     * @param event
     * @param arrowControlElements elements to move focus between, in order
     * @param layoutDirection 'horizontal', 'vertical', or 'any' depending on which arrow keys should be used
     * @param focusCallback callback to when an element is focused. Allows element to autoselect or defer focus to a child
     */
    handleArrowControlKeydown(e, a, o, n) {
      let r = !1;
      if (e && e.isTrusted) {
        const T = t.calculateArrowIncrement(
          e,
          o
        );
        if (T != 0) {
          const O = a.indexOf(
            e.currentTarget
          );
          if (O != -1) {
            const j = t.ensureFocusIndexInRange(
              O + T,
              a.length
            );
            n.call(this, a[j]), r = !0;
          }
        }
      }
      return r;
    }
    /**
     * Calculates the index increment based on the input keys.
     * @param event
     * @param layoutDirection
     * @returns
     */
    static calculateArrowIncrement(e, a) {
      return e.key === Aa.LEFT && (a === "horizontal" || a === "any") || e.key === Aa.UP && (a === "vertical" || a === "any") ? -1 : e.key === Aa.RIGHT && (a === "horizontal" || a === "any") || e.key === Aa.DOWN && (a === "vertical" || a === "any") ? 1 : 0;
    }
    /**
     * Wraps the focus index around the ends of the array
     * @param focusIndex
     * @param numberOfElements
     * @returns
     */
    static ensureFocusIndexInRange(e, a) {
      return e < 0 ? a - 1 : e >= a ? 0 : e;
    }
  };
  return t = jS([
    je("ArrowControl")
  ], t), t;
}
var gf = /* @__PURE__ */ ((i) => (i.Anchor = "a", i.Button = "button", i.BeaconButton = '[beacon-tag-name="beacon-button"]', i.BeaconIconButton = '[beacon-tag-name="beacon-icon-button"]', i.tabIndex = '[tabindex]:not([tabindex="-1"])', i))(gf || {});
function $S(i) {
  class t extends i {
    constructor() {
      super(...arguments), this._firstFocusableElement = null, this._lastFocusableElement = null, this._triggerElement = null, this._nextFocusableElement = null, this.handleFirstFocusableKeydown = (a) => {
        this.triggerElement && this.forwardFocusToPrevious(a, this.triggerElement);
      }, this.handleLastFocusableKeydown = (a) => {
        this.nextFocusableElement && this.forwardFocusToNext(a, this.nextFocusableElement);
      }, this.handleNextFocusableKeydown = (a) => {
        this.lastFocusableElement && this.forwardFocusToPrevious(a, this.lastFocusableElement);
      }, this.handleTriggerKeydown = (a) => {
        this.firstFocusableElement && this.forwardFocusToNext(a, this.firstFocusableElement);
      };
    }
    get firstFocusableElement() {
      return this._firstFocusableElement;
    }
    set firstFocusableElement(a) {
      this.firstFocusableElement && this.firstFocusableElement.removeEventListener(
        Je.KEYDOWN,
        this.handleFirstFocusableKeydown
      ), this._firstFocusableElement = a;
    }
    get lastFocusableElement() {
      return this._lastFocusableElement;
    }
    set lastFocusableElement(a) {
      this.lastFocusableElement && this.lastFocusableElement.removeEventListener(
        Je.KEYDOWN,
        this.handleLastFocusableKeydown
      ), this._lastFocusableElement = a;
    }
    get triggerElement() {
      return this._triggerElement;
    }
    set triggerElement(a) {
      this.triggerElement && this.triggerElement.removeEventListener(
        Je.KEYDOWN,
        this.handleTriggerKeydown
      ), this._triggerElement = a;
    }
    get nextFocusableElement() {
      return this._nextFocusableElement;
    }
    set nextFocusableElement(a) {
      this.nextFocusableElement && this.nextFocusableElement.removeEventListener(
        Je.KEYDOWN,
        this.handleNextFocusableKeydown
      ), this._nextFocusableElement = a;
    }
    internalFocusableElements() {
      return Array.from(
        this.querySelectorAll(this.generateFocusableElementsSelector())
      );
    }
    forwardFocusToNext(a, o) {
      a.key === "Tab" && !a.shiftKey && (a.preventDefault(), o.focus());
    }
    forwardFocusToPrevious(a, o) {
      a.key === "Tab" && a.shiftKey && (a.preventDefault(), o.focus());
    }
    /**
     * Callback to initialize the focusable elements within the overlay
     * and set the first and last focusable elements for focus forwarding.
     */
    initializeInternalFocusableElements() {
    }
    /**
     * Callback to initialize the focusable elements outside of the overlay
     * and set the trigger element and next focusable element for focus forwarding.
     * @returns
     */
    initializeExternalFocusableElements() {
    }
    attachFocusableElementListeners() {
      this.firstFocusableElement && this.firstFocusableElement.addEventListener(
        Je.KEYDOWN,
        this.handleFirstFocusableKeydown
      ), this.lastFocusableElement && this.lastFocusableElement.addEventListener(
        Je.KEYDOWN,
        this.handleLastFocusableKeydown
      ), this.nextFocusableElement && this.nextFocusableElement.addEventListener(
        Je.KEYDOWN,
        this.handleNextFocusableKeydown
      ), this.triggerElement && this.triggerElement.addEventListener(
        Je.KEYDOWN,
        this.handleTriggerKeydown
      );
    }
    removeFocusableElementListeners() {
      this.firstFocusableElement && this.firstFocusableElement.removeEventListener(
        Je.KEYDOWN,
        this.handleFirstFocusableKeydown
      ), this.lastFocusableElement && this.lastFocusableElement.removeEventListener(
        Je.KEYDOWN,
        this.handleLastFocusableKeydown
      ), this.nextFocusableElement && this.nextFocusableElement.removeEventListener(
        Je.KEYDOWN,
        this.handleNextFocusableKeydown
      ), this.triggerElement && this.triggerElement.removeEventListener(
        Je.KEYDOWN,
        this.handleTriggerKeydown
      );
    }
    /**
     * Queries the closest shadowRoot to the popover, if it exists,
     * or the document if the popover is at the document level, and returns the first matching element.
     * Note that this does not cross different shadowDOM boundaries, and logic is dependent upon being
     * within the same lightDOM or shadowDOM contexts.
     * @param selector
     * @returns The first found element or null
     */
    DOMContextQuerySelector(a, o = this.getClosestHost()) {
      return o ? o.shadowRoot.querySelector(
        a
      ) : document.querySelector(a);
    }
    /**
     * Queries the closest shadowRoot to the popover, if it exists,
     * or the document if the popover is at the document level, and returns all matching
     * @param selector
     * @returns A list of elements that match the selector, or undefined if none are found.
     */
    DOMContextQuerySelectorAll(a, o = this.getClosestHost()) {
      return o ? o.shadowRoot.querySelectorAll(a) : document.querySelectorAll(a);
    }
    generateFocusableElementsSelector() {
      return `:is(${Object.values(gf).join(", ")})`;
    }
    /**
     * Returns a focusable element that follows the selector in the DOM as a sibling,
     * also includes focusable elements nested within a container, which are not direct siblings.
     * @param selector
     * @returns
     */
    siblingFocusableElements(a) {
      const o = `${a} ~ ${this.generateFocusableElementsSelector()}`, n = `:has(${a}) ~ :has(${this.generateFocusableElementsSelector()}) ${this.generateFocusableElementsSelector()}`;
      return {
        directSibling: this.DOMContextQuerySelector(
          o
        ),
        indirectSibling: this.DOMContextQuerySelector(
          n
        )
      };
    }
  }
  return t;
}
var HS = Object.getOwnPropertyDescriptor, KS = (i, t, e, a) => {
  for (var o = a > 1 ? void 0 : a ? HS(t, e) : t, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = r(o) || o);
  return o;
};
function GS(i) {
  let t = class extends i {
    extendFocus(e) {
      if (e) {
        const a = e.focus.bind(e);
        e.focus = function(o) {
          o != null && o.override && (e.classList.add("skip-focus-override"), e.addEventListener(
            "blur",
            () => {
              e.classList.remove("skip-focus-override");
            },
            { once: !0 }
          )), a(o);
        };
      } else
        console.log("Element is null");
    }
    overrideFocus(e) {
      e.forEach((a) => {
        this.extendFocus(a);
      });
    }
  };
  return t = KS([
    je("FocusOptions")
  ], t), t;
}
const WS = ve`[class*=b-motion]{--b-motion-delay-default: 0ms;--b-motion-duration-default: var(--beacon-reference-motion-duration-9);--b-motion-fill-mode-default: both;--b-motion-iteration-count-default: 1;--b-motion-timing-function-default: var(--beacon-system-motion-easing-decelerate-emphasize-1);animation-delay:var(--b-motion-delay, var(--b-motion-delay-default));animation-duration:var(--b-motion-duration, var(--b-motion-duration-default));animation-fill-mode:var(--b-motion-fill-mode, var(--b-motion-fill-mode-default));animation-iteration-count:var(--b-motion-iteration-count, var(--b-motion-iteration-count-default));animation-timing-function:var(--b-motion-timing-function, var(--b-motion-timing-function-default))}.b-motion-duration--short-1{--b-motion-duration: var(--beacon-reference-motion-duration-1)}.b-motion-duration--short-2{--b-motion-duration: var(--beacon-reference-motion-duration-2)}.b-motion-duration--short-3{--b-motion-duration: var(--beacon-reference-motion-duration-3)}.b-motion-duration--medium-1{--b-motion-duration: var(--beacon-reference-motion-duration-4)}.b-motion-duration--medium-2{--b-motion-duration: var(--beacon-reference-motion-duration-5)}.b-motion-duration--medium-3{--b-motion-duration: var(--beacon-reference-motion-duration-6)}.b-motion-duration--long-1{--b-motion-duration: var(--beacon-reference-motion-duration-7)}.b-motion-duration--long-2{--b-motion-duration: var(--beacon-reference-motion-duration-8)}.b-motion-duration--long-3{--b-motion-duration: var(--beacon-reference-motion-duration-9)}.b-motion-duration--x-long-1{--b-motion-duration: var(--beacon-reference-motion-duration-10)}.b-motion-duration--x-long-2{--b-motion-duration: var(--beacon-reference-motion-duration-11)}.b-motion-duration--x-long-3{--b-motion-duration: var(--beacon-reference-motion-duration-12)}.b-motion-delay--short-1{--b-motion-delay: var(--beacon-reference-motion-duration-1)}.b-motion-delay--short-2{--b-motion-delay: var(--beacon-reference-motion-duration-2)}.b-motion-delay--short-3{--b-motion-delay: var(--beacon-reference-motion-duration-3)}.b-motion-delay--medium-1{--b-motion-delay: var(--beacon-reference-motion-duration-4)}.b-motion-delay--medium-2{--b-motion-delay: var(--beacon-reference-motion-duration-5)}.b-motion-delay--medium-3{--b-motion-delay: var(--beacon-reference-motion-duration-6)}.b-motion-delay--long-1{--b-motion-delay: var(--beacon-reference-motion-duration-7)}.b-motion-delay--long-2{--b-motion-delay: var(--beacon-reference-motion-duration-8)}.b-motion-delay--long-3{--b-motion-delay: var(--beacon-reference-motion-duration-9)}.b-motion-delay--x-long-1{--b-motion-delay: var(--beacon-reference-motion-duration-10)}.b-motion-delay--x-long-2{--b-motion-delay: var(--beacon-reference-motion-duration-11)}.b-motion-delay--x-long-3{--b-motion-delay: var(--beacon-reference-motion-duration-12)}.b-motion-ease--accelerate--standard-1{--b-motion-timing-function: var(--beacon-system-motion-easing-accelerate-standard-1)}.b-motion-ease--accelerate--standard-2{--b-motion-timing-function: var(--beacon-system-motion-easing-accelerate-standard-2)}.b-motion-ease--accelerate--emphasize-1{--b-motion-timing-function: var(--beacon-system-motion-easing-accelerate-emphasize-1)}.b-motion-ease--accelerate--emphasize-2{--b-motion-timing-function: var(--beacon-system-motion-easing-accelerate-emphasize-2)}.b-motion-ease--decelerate--standard-1{--b-motion-timing-function: var(--beacon-system-motion-easing-decelerate-standard-1)}.b-motion-ease--decelerate--emphasize-1{--b-motion-timing-function: var(--beacon-system-motion-easing-decelerate-emphasize-1)}.b-motion-ease--linear{--b-motion-timing-function: var(--beacon-system-motion-easing-linear)}.b-motion-iteration--1{--b-motion-iteration-count: 1}.b-motion-iteration--2{--b-motion-iteration-count: 2}.b-motion-iteration--3{--b-motion-iteration-count: 3}.b-motion-iteration--4{--b-motion-iteration-count: 4}.b-motion-iteration--5{--b-motion-iteration-count: 5}@media (width >= 320px){[class*=b-motion-duration--].b-sm\\:duration--short-1{--b-motion-duration: var(--beacon-reference-motion-duration-1)}[class*=b-motion-duration--].b-sm\\:duration--short-2{--b-motion-duration: var(--beacon-reference-motion-duration-2)}[class*=b-motion-duration--].b-sm\\:duration--short-3{--b-motion-duration: var(--beacon-reference-motion-duration-3)}[class*=b-motion-duration--].b-sm\\:duration--medium-1{--b-motion-duration: var(--beacon-reference-motion-duration-4)}[class*=b-motion-duration--].b-sm\\:duration--medium-2{--b-motion-duration: var(--beacon-reference-motion-duration-5)}[class*=b-motion-duration--].b-sm\\:duration--medium-3{--b-motion-duration: var(--beacon-reference-motion-duration-6)}[class*=b-motion-duration--].b-sm\\:duration--long-1{--b-motion-duration: var(--beacon-reference-motion-duration-7)}[class*=b-motion-duration--].b-sm\\:duration--long-2{--b-motion-duration: var(--beacon-reference-motion-duration-8)}[class*=b-motion-duration--].b-sm\\:duration--long-3{--b-motion-duration: var(--beacon-reference-motion-duration-9)}[class*=b-motion-duration--].b-sm\\:duration--x-long-1{--b-motion-duration: var(--beacon-reference-motion-duration-10)}[class*=b-motion-duration--].b-sm\\:duration--x-long-2{--b-motion-duration: var(--beacon-reference-motion-duration-11)}[class*=b-motion-duration--].b-sm\\:duration--x-long-3{--b-motion-duration: var(--beacon-reference-motion-duration-12)}[class*=b-motion-delay--].b-sm\\:delay--short-1{--b-motion-delay: var(--beacon-reference-motion-duration-1)}[class*=b-motion-delay--].b-sm\\:delay--short-2{--b-motion-delay: var(--beacon-reference-motion-duration-2)}[class*=b-motion-delay--].b-sm\\:delay--short-3{--b-motion-delay: var(--beacon-reference-motion-duration-3)}[class*=b-motion-delay--].b-sm\\:delay--medium-1{--b-motion-delay: var(--beacon-reference-motion-duration-4)}[class*=b-motion-delay--].b-sm\\:delay--medium-2{--b-motion-delay: var(--beacon-reference-motion-duration-5)}[class*=b-motion-delay--].b-sm\\:delay--medium-3{--b-motion-delay: var(--beacon-reference-motion-duration-6)}[class*=b-motion-delay--].b-sm\\:delay--long-1{--b-motion-delay: var(--beacon-reference-motion-duration-7)}[class*=b-motion-delay--].b-sm\\:delay--long-2{--b-motion-delay: var(--beacon-reference-motion-duration-8)}[class*=b-motion-delay--].b-sm\\:delay--long-3{--b-motion-delay: var(--beacon-reference-motion-duration-9)}[class*=b-motion-delay--].b-sm\\:delay--x-long-1{--b-motion-delay: var(--beacon-reference-motion-duration-10)}[class*=b-motion-delay--].b-sm\\:delay--x-long-2{--b-motion-delay: var(--beacon-reference-motion-duration-11)}[class*=b-motion-delay--].b-sm\\:delay--x-long-3{--b-motion-delay: var(--beacon-reference-motion-duration-12)}[class*=b-motion-ease--].b-sm\\:ease--accelerate--standard-1{--b-motion-timing-function: var(--beacon-system-motion-easing-accelerate-standard-1)}[class*=b-motion-ease--].b-sm\\:ease--accelerate--standard-2{--b-motion-timing-function: var(--beacon-system-motion-easing-accelerate-standard-2)}[class*=b-motion-ease--].b-sm\\:ease--accelerate--emphasize-1{--b-motion-timing-function: var(--beacon-system-motion-easing-accelerate-emphasize-1)}[class*=b-motion-ease--].b-sm\\:ease--accelerate--emphasize-2{--b-motion-timing-function: var(--beacon-system-motion-easing-accelerate-emphasize-2)}[class*=b-motion-ease--].b-sm\\:ease--decelerate--standard-1{--b-motion-timing-function: var(--beacon-system-motion-easing-decelerate-standard-1)}[class*=b-motion-ease--].b-sm\\:ease--decelerate--emphasize-1{--b-motion-timing-function: var(--beacon-system-motion-easing-decelerate-emphasize-1)}[class*=b-motion-ease--].b-sm\\:ease--linear{--b-motion-timing-function: var(--beacon-system-motion-easing-linear)}}@media (width >= 640px){[class*=b-motion-duration--].b-md\\:duration--short-1{--b-motion-duration: var(--beacon-reference-motion-duration-1)}[class*=b-motion-duration--].b-md\\:duration--short-2{--b-motion-duration: var(--beacon-reference-motion-duration-2)}[class*=b-motion-duration--].b-md\\:duration--short-3{--b-motion-duration: var(--beacon-reference-motion-duration-3)}[class*=b-motion-duration--].b-md\\:duration--medium-1{--b-motion-duration: var(--beacon-reference-motion-duration-4)}[class*=b-motion-duration--].b-md\\:duration--medium-2{--b-motion-duration: var(--beacon-reference-motion-duration-5)}[class*=b-motion-duration--].b-md\\:duration--medium-3{--b-motion-duration: var(--beacon-reference-motion-duration-6)}[class*=b-motion-duration--].b-md\\:duration--long-1{--b-motion-duration: var(--beacon-reference-motion-duration-7)}[class*=b-motion-duration--].b-md\\:duration--long-2{--b-motion-duration: var(--beacon-reference-motion-duration-8)}[class*=b-motion-duration--].b-md\\:duration--long-3{--b-motion-duration: var(--beacon-reference-motion-duration-9)}[class*=b-motion-duration--].b-md\\:duration--x-long-1{--b-motion-duration: var(--beacon-reference-motion-duration-10)}[class*=b-motion-duration--].b-md\\:duration--x-long-2{--b-motion-duration: var(--beacon-reference-motion-duration-11)}[class*=b-motion-duration--].b-md\\:duration--x-long-3{--b-motion-duration: var(--beacon-reference-motion-duration-12)}[class*=b-motion-delay--].b-md\\:delay--short-1{--b-motion-delay: var(--beacon-reference-motion-duration-1)}[class*=b-motion-delay--].b-md\\:delay--short-2{--b-motion-delay: var(--beacon-reference-motion-duration-2)}[class*=b-motion-delay--].b-md\\:delay--short-3{--b-motion-delay: var(--beacon-reference-motion-duration-3)}[class*=b-motion-delay--].b-md\\:delay--medium-1{--b-motion-delay: var(--beacon-reference-motion-duration-4)}[class*=b-motion-delay--].b-md\\:delay--medium-2{--b-motion-delay: var(--beacon-reference-motion-duration-5)}[class*=b-motion-delay--].b-md\\:delay--medium-3{--b-motion-delay: var(--beacon-reference-motion-duration-6)}[class*=b-motion-delay--].b-md\\:delay--long-1{--b-motion-delay: var(--beacon-reference-motion-duration-7)}[class*=b-motion-delay--].b-md\\:delay--long-2{--b-motion-delay: var(--beacon-reference-motion-duration-8)}[class*=b-motion-delay--].b-md\\:delay--long-3{--b-motion-delay: var(--beacon-reference-motion-duration-9)}[class*=b-motion-delay--].b-md\\:delay--x-long-1{--b-motion-delay: var(--beacon-reference-motion-duration-10)}[class*=b-motion-delay--].b-md\\:delay--x-long-2{--b-motion-delay: var(--beacon-reference-motion-duration-11)}[class*=b-motion-delay--].b-md\\:delay--x-long-3{--b-motion-delay: var(--beacon-reference-motion-duration-12)}[class*=b-motion-ease--].b-md\\:ease--accelerate--standard-1{--b-motion-timing-function: var(--beacon-system-motion-easing-accelerate-standard-1)}[class*=b-motion-ease--].b-md\\:ease--accelerate--standard-2{--b-motion-timing-function: var(--beacon-system-motion-easing-accelerate-standard-2)}[class*=b-motion-ease--].b-md\\:ease--accelerate--emphasize-1{--b-motion-timing-function: var(--beacon-system-motion-easing-accelerate-emphasize-1)}[class*=b-motion-ease--].b-md\\:ease--accelerate--emphasize-2{--b-motion-timing-function: var(--beacon-system-motion-easing-accelerate-emphasize-2)}[class*=b-motion-ease--].b-md\\:ease--decelerate--standard-1{--b-motion-timing-function: var(--beacon-system-motion-easing-decelerate-standard-1)}[class*=b-motion-ease--].b-md\\:ease--decelerate--emphasize-1{--b-motion-timing-function: var(--beacon-system-motion-easing-decelerate-emphasize-1)}[class*=b-motion-ease--].b-md\\:ease--linear{--b-motion-timing-function: var(--beacon-system-motion-easing-linear)}}@media (width >= 960px){[class*=b-motion-duration--].b-lg\\:duration--short-1{--b-motion-duration: var(--beacon-reference-motion-duration-1)}[class*=b-motion-duration--].b-lg\\:duration--short-2{--b-motion-duration: var(--beacon-reference-motion-duration-2)}[class*=b-motion-duration--].b-lg\\:duration--short-3{--b-motion-duration: var(--beacon-reference-motion-duration-3)}[class*=b-motion-duration--].b-lg\\:duration--medium-1{--b-motion-duration: var(--beacon-reference-motion-duration-4)}[class*=b-motion-duration--].b-lg\\:duration--medium-2{--b-motion-duration: var(--beacon-reference-motion-duration-5)}[class*=b-motion-duration--].b-lg\\:duration--medium-3{--b-motion-duration: var(--beacon-reference-motion-duration-6)}[class*=b-motion-duration--].b-lg\\:duration--long-1{--b-motion-duration: var(--beacon-reference-motion-duration-7)}[class*=b-motion-duration--].b-lg\\:duration--long-2{--b-motion-duration: var(--beacon-reference-motion-duration-8)}[class*=b-motion-duration--].b-lg\\:duration--long-3{--b-motion-duration: var(--beacon-reference-motion-duration-9)}[class*=b-motion-duration--].b-lg\\:duration--x-long-1{--b-motion-duration: var(--beacon-reference-motion-duration-10)}[class*=b-motion-duration--].b-lg\\:duration--x-long-2{--b-motion-duration: var(--beacon-reference-motion-duration-11)}[class*=b-motion-duration--].b-lg\\:duration--x-long-3{--b-motion-duration: var(--beacon-reference-motion-duration-12)}[class*=b-motion-delay--].b-lg\\:delay--short-1{--b-motion-delay: var(--beacon-reference-motion-duration-1)}[class*=b-motion-delay--].b-lg\\:delay--short-2{--b-motion-delay: var(--beacon-reference-motion-duration-2)}[class*=b-motion-delay--].b-lg\\:delay--short-3{--b-motion-delay: var(--beacon-reference-motion-duration-3)}[class*=b-motion-delay--].b-lg\\:delay--medium-1{--b-motion-delay: var(--beacon-reference-motion-duration-4)}[class*=b-motion-delay--].b-lg\\:delay--medium-2{--b-motion-delay: var(--beacon-reference-motion-duration-5)}[class*=b-motion-delay--].b-lg\\:delay--medium-3{--b-motion-delay: var(--beacon-reference-motion-duration-6)}[class*=b-motion-delay--].b-lg\\:delay--long-1{--b-motion-delay: var(--beacon-reference-motion-duration-7)}[class*=b-motion-delay--].b-lg\\:delay--long-2{--b-motion-delay: var(--beacon-reference-motion-duration-8)}[class*=b-motion-delay--].b-lg\\:delay--long-3{--b-motion-delay: var(--beacon-reference-motion-duration-9)}[class*=b-motion-delay--].b-lg\\:delay--x-long-1{--b-motion-delay: var(--beacon-reference-motion-duration-10)}[class*=b-motion-delay--].b-lg\\:delay--x-long-2{--b-motion-delay: var(--beacon-reference-motion-duration-11)}[class*=b-motion-delay--].b-lg\\:delay--x-long-3{--b-motion-delay: var(--beacon-reference-motion-duration-12)}[class*=b-motion-ease--].b-lg\\:ease--accelerate--standard-1{--b-motion-timing-function: var(--beacon-system-motion-easing-accelerate-standard-1)}[class*=b-motion-ease--].b-lg\\:ease--accelerate--standard-2{--b-motion-timing-function: var(--beacon-system-motion-easing-accelerate-standard-2)}[class*=b-motion-ease--].b-lg\\:ease--accelerate--emphasize-1{--b-motion-timing-function: var(--beacon-system-motion-easing-accelerate-emphasize-1)}[class*=b-motion-ease--].b-lg\\:ease--accelerate--emphasize-2{--b-motion-timing-function: var(--beacon-system-motion-easing-accelerate-emphasize-2)}[class*=b-motion-ease--].b-lg\\:ease--decelerate--standard-1{--b-motion-timing-function: var(--beacon-system-motion-easing-decelerate-standard-1)}[class*=b-motion-ease--].b-lg\\:ease--decelerate--emphasize-1{--b-motion-timing-function: var(--beacon-system-motion-easing-decelerate-emphasize-1)}[class*=b-motion-ease--].b-lg\\:ease--linear{--b-motion-timing-function: var(--beacon-system-motion-easing-linear)}}@media (width >= 1280px){[class*=b-motion-duration--].b-xl\\:duration--short-1{--b-motion-duration: var(--beacon-reference-motion-duration-1)}[class*=b-motion-duration--].b-xl\\:duration--short-2{--b-motion-duration: var(--beacon-reference-motion-duration-2)}[class*=b-motion-duration--].b-xl\\:duration--short-3{--b-motion-duration: var(--beacon-reference-motion-duration-3)}[class*=b-motion-duration--].b-xl\\:duration--medium-1{--b-motion-duration: var(--beacon-reference-motion-duration-4)}[class*=b-motion-duration--].b-xl\\:duration--medium-2{--b-motion-duration: var(--beacon-reference-motion-duration-5)}[class*=b-motion-duration--].b-xl\\:duration--medium-3{--b-motion-duration: var(--beacon-reference-motion-duration-6)}[class*=b-motion-duration--].b-xl\\:duration--long-1{--b-motion-duration: var(--beacon-reference-motion-duration-7)}[class*=b-motion-duration--].b-xl\\:duration--long-2{--b-motion-duration: var(--beacon-reference-motion-duration-8)}[class*=b-motion-duration--].b-xl\\:duration--long-3{--b-motion-duration: var(--beacon-reference-motion-duration-9)}[class*=b-motion-duration--].b-xl\\:duration--x-long-1{--b-motion-duration: var(--beacon-reference-motion-duration-10)}[class*=b-motion-duration--].b-xl\\:duration--x-long-2{--b-motion-duration: var(--beacon-reference-motion-duration-11)}[class*=b-motion-duration--].b-xl\\:duration--x-long-3{--b-motion-duration: var(--beacon-reference-motion-duration-12)}[class*=b-motion-delay--].b-xl\\:delay--short-1{--b-motion-delay: var(--beacon-reference-motion-duration-1)}[class*=b-motion-delay--].b-xl\\:delay--short-2{--b-motion-delay: var(--beacon-reference-motion-duration-2)}[class*=b-motion-delay--].b-xl\\:delay--short-3{--b-motion-delay: var(--beacon-reference-motion-duration-3)}[class*=b-motion-delay--].b-xl\\:delay--medium-1{--b-motion-delay: var(--beacon-reference-motion-duration-4)}[class*=b-motion-delay--].b-xl\\:delay--medium-2{--b-motion-delay: var(--beacon-reference-motion-duration-5)}[class*=b-motion-delay--].b-xl\\:delay--medium-3{--b-motion-delay: var(--beacon-reference-motion-duration-6)}[class*=b-motion-delay--].b-xl\\:delay--long-1{--b-motion-delay: var(--beacon-reference-motion-duration-7)}[class*=b-motion-delay--].b-xl\\:delay--long-2{--b-motion-delay: var(--beacon-reference-motion-duration-8)}[class*=b-motion-delay--].b-xl\\:delay--long-3{--b-motion-delay: var(--beacon-reference-motion-duration-9)}[class*=b-motion-delay--].b-xl\\:delay--x-long-1{--b-motion-delay: var(--beacon-reference-motion-duration-10)}[class*=b-motion-delay--].b-xl\\:delay--x-long-2{--b-motion-delay: var(--beacon-reference-motion-duration-11)}[class*=b-motion-delay--].b-xl\\:delay--x-long-3{--b-motion-delay: var(--beacon-reference-motion-duration-12)}[class*=b-motion-ease--].b-xl\\:ease--accelerate--standard-1{--b-motion-timing-function: var(--beacon-system-motion-easing-accelerate-standard-1)}[class*=b-motion-ease--].b-xl\\:ease--accelerate--standard-2{--b-motion-timing-function: var(--beacon-system-motion-easing-accelerate-standard-2)}[class*=b-motion-ease--].b-xl\\:ease--accelerate--emphasize-1{--b-motion-timing-function: var(--beacon-system-motion-easing-accelerate-emphasize-1)}[class*=b-motion-ease--].b-xl\\:ease--accelerate--emphasize-2{--b-motion-timing-function: var(--beacon-system-motion-easing-accelerate-emphasize-2)}[class*=b-motion-ease--].b-xl\\:ease--decelerate--standard-1{--b-motion-timing-function: var(--beacon-system-motion-easing-decelerate-standard-1)}[class*=b-motion-ease--].b-xl\\:ease--decelerate--emphasize-1{--b-motion-timing-function: var(--beacon-system-motion-easing-decelerate-emphasize-1)}[class*=b-motion-ease--].b-xl\\:ease--linear{--b-motion-timing-function: var(--beacon-system-motion-easing-linear)}}@media (width >= 1600px){[class*=b-motion-duration--].b-xxl\\:duration--short-1{--b-motion-duration: var(--beacon-reference-motion-duration-1)}[class*=b-motion-duration--].b-xxl\\:duration--short-2{--b-motion-duration: var(--beacon-reference-motion-duration-2)}[class*=b-motion-duration--].b-xxl\\:duration--short-3{--b-motion-duration: var(--beacon-reference-motion-duration-3)}[class*=b-motion-duration--].b-xxl\\:duration--medium-1{--b-motion-duration: var(--beacon-reference-motion-duration-4)}[class*=b-motion-duration--].b-xxl\\:duration--medium-2{--b-motion-duration: var(--beacon-reference-motion-duration-5)}[class*=b-motion-duration--].b-xxl\\:duration--medium-3{--b-motion-duration: var(--beacon-reference-motion-duration-6)}[class*=b-motion-duration--].b-xxl\\:duration--long-1{--b-motion-duration: var(--beacon-reference-motion-duration-7)}[class*=b-motion-duration--].b-xxl\\:duration--long-2{--b-motion-duration: var(--beacon-reference-motion-duration-8)}[class*=b-motion-duration--].b-xxl\\:duration--long-3{--b-motion-duration: var(--beacon-reference-motion-duration-9)}[class*=b-motion-duration--].b-xxl\\:duration--x-long-1{--b-motion-duration: var(--beacon-reference-motion-duration-10)}[class*=b-motion-duration--].b-xxl\\:duration--x-long-2{--b-motion-duration: var(--beacon-reference-motion-duration-11)}[class*=b-motion-duration--].b-xxl\\:duration--x-long-3{--b-motion-duration: var(--beacon-reference-motion-duration-12)}[class*=b-motion-delay--].b-xxl\\:delay--short-1{--b-motion-delay: var(--beacon-reference-motion-duration-1)}[class*=b-motion-delay--].b-xxl\\:delay--short-2{--b-motion-delay: var(--beacon-reference-motion-duration-2)}[class*=b-motion-delay--].b-xxl\\:delay--short-3{--b-motion-delay: var(--beacon-reference-motion-duration-3)}[class*=b-motion-delay--].b-xxl\\:delay--medium-1{--b-motion-delay: var(--beacon-reference-motion-duration-4)}[class*=b-motion-delay--].b-xxl\\:delay--medium-2{--b-motion-delay: var(--beacon-reference-motion-duration-5)}[class*=b-motion-delay--].b-xxl\\:delay--medium-3{--b-motion-delay: var(--beacon-reference-motion-duration-6)}[class*=b-motion-delay--].b-xxl\\:delay--long-1{--b-motion-delay: var(--beacon-reference-motion-duration-7)}[class*=b-motion-delay--].b-xxl\\:delay--long-2{--b-motion-delay: var(--beacon-reference-motion-duration-8)}[class*=b-motion-delay--].b-xxl\\:delay--long-3{--b-motion-delay: var(--beacon-reference-motion-duration-9)}[class*=b-motion-delay--].b-xxl\\:delay--x-long-1{--b-motion-delay: var(--beacon-reference-motion-duration-10)}[class*=b-motion-delay--].b-xxl\\:delay--x-long-2{--b-motion-delay: var(--beacon-reference-motion-duration-11)}[class*=b-motion-delay--].b-xxl\\:delay--x-long-3{--b-motion-delay: var(--beacon-reference-motion-duration-12)}[class*=b-motion-ease--].b-xxl\\:ease--accelerate--standard-1{--b-motion-timing-function: var(--beacon-system-motion-easing-accelerate-standard-1)}[class*=b-motion-ease--].b-xxl\\:ease--accelerate--standard-2{--b-motion-timing-function: var(--beacon-system-motion-easing-accelerate-standard-2)}[class*=b-motion-ease--].b-xxl\\:ease--accelerate--emphasize-1{--b-motion-timing-function: var(--beacon-system-motion-easing-accelerate-emphasize-1)}[class*=b-motion-ease--].b-xxl\\:ease--accelerate--emphasize-2{--b-motion-timing-function: var(--beacon-system-motion-easing-accelerate-emphasize-2)}[class*=b-motion-ease--].b-xxl\\:ease--decelerate--standard-1{--b-motion-timing-function: var(--beacon-system-motion-easing-decelerate-standard-1)}[class*=b-motion-ease--].b-xxl\\:ease--decelerate--emphasize-1{--b-motion-timing-function: var(--beacon-system-motion-easing-decelerate-emphasize-1)}[class*=b-motion-ease--].b-xxl\\:ease--linear{--b-motion-timing-function: var(--beacon-system-motion-easing-linear)}}@media (width >= 1920px){[class*=b-motion-duration--].b-xxxl\\:duration--short-1{--b-motion-duration: var(--beacon-reference-motion-duration-1)}[class*=b-motion-duration--].b-xxxl\\:duration--short-2{--b-motion-duration: var(--beacon-reference-motion-duration-2)}[class*=b-motion-duration--].b-xxxl\\:duration--short-3{--b-motion-duration: var(--beacon-reference-motion-duration-3)}[class*=b-motion-duration--].b-xxxl\\:duration--medium-1{--b-motion-duration: var(--beacon-reference-motion-duration-4)}[class*=b-motion-duration--].b-xxxl\\:duration--medium-2{--b-motion-duration: var(--beacon-reference-motion-duration-5)}[class*=b-motion-duration--].b-xxxl\\:duration--medium-3{--b-motion-duration: var(--beacon-reference-motion-duration-6)}[class*=b-motion-duration--].b-xxxl\\:duration--long-1{--b-motion-duration: var(--beacon-reference-motion-duration-7)}[class*=b-motion-duration--].b-xxxl\\:duration--long-2{--b-motion-duration: var(--beacon-reference-motion-duration-8)}[class*=b-motion-duration--].b-xxxl\\:duration--long-3{--b-motion-duration: var(--beacon-reference-motion-duration-9)}[class*=b-motion-duration--].b-xxxl\\:duration--x-long-1{--b-motion-duration: var(--beacon-reference-motion-duration-10)}[class*=b-motion-duration--].b-xxxl\\:duration--x-long-2{--b-motion-duration: var(--beacon-reference-motion-duration-11)}[class*=b-motion-duration--].b-xxxl\\:duration--x-long-3{--b-motion-duration: var(--beacon-reference-motion-duration-12)}[class*=b-motion-delay--].b-xxxl\\:delay--short-1{--b-motion-delay: var(--beacon-reference-motion-duration-1)}[class*=b-motion-delay--].b-xxxl\\:delay--short-2{--b-motion-delay: var(--beacon-reference-motion-duration-2)}[class*=b-motion-delay--].b-xxxl\\:delay--short-3{--b-motion-delay: var(--beacon-reference-motion-duration-3)}[class*=b-motion-delay--].b-xxxl\\:delay--medium-1{--b-motion-delay: var(--beacon-reference-motion-duration-4)}[class*=b-motion-delay--].b-xxxl\\:delay--medium-2{--b-motion-delay: var(--beacon-reference-motion-duration-5)}[class*=b-motion-delay--].b-xxxl\\:delay--medium-3{--b-motion-delay: var(--beacon-reference-motion-duration-6)}[class*=b-motion-delay--].b-xxxl\\:delay--long-1{--b-motion-delay: var(--beacon-reference-motion-duration-7)}[class*=b-motion-delay--].b-xxxl\\:delay--long-2{--b-motion-delay: var(--beacon-reference-motion-duration-8)}[class*=b-motion-delay--].b-xxxl\\:delay--long-3{--b-motion-delay: var(--beacon-reference-motion-duration-9)}[class*=b-motion-delay--].b-xxxl\\:delay--x-long-1{--b-motion-delay: var(--beacon-reference-motion-duration-10)}[class*=b-motion-delay--].b-xxxl\\:delay--x-long-2{--b-motion-delay: var(--beacon-reference-motion-duration-11)}[class*=b-motion-delay--].b-xxxl\\:delay--x-long-3{--b-motion-delay: var(--beacon-reference-motion-duration-12)}[class*=b-motion-ease--].b-xxxl\\:ease--accelerate--standard-1{--b-motion-timing-function: var(--beacon-system-motion-easing-accelerate-standard-1)}[class*=b-motion-ease--].b-xxxl\\:ease--accelerate--standard-2{--b-motion-timing-function: var(--beacon-system-motion-easing-accelerate-standard-2)}[class*=b-motion-ease--].b-xxxl\\:ease--accelerate--emphasize-1{--b-motion-timing-function: var(--beacon-system-motion-easing-accelerate-emphasize-1)}[class*=b-motion-ease--].b-xxxl\\:ease--accelerate--emphasize-2{--b-motion-timing-function: var(--beacon-system-motion-easing-accelerate-emphasize-2)}[class*=b-motion-ease--].b-xxxl\\:ease--decelerate--standard-1{--b-motion-timing-function: var(--beacon-system-motion-easing-decelerate-standard-1)}[class*=b-motion-ease--].b-xxxl\\:ease--decelerate--emphasize-1{--b-motion-timing-function: var(--beacon-system-motion-easing-decelerate-emphasize-1)}[class*=b-motion-ease--].b-xxxl\\:ease--linear{--b-motion-timing-function: var(--beacon-system-motion-easing-linear)}}[class*=b-motion--intro-from-]{--b-motion-duration-default: var(--beacon-reference-motion-duration-9);--b-motion-timing-function-default: var(--beacon-system-motion-easing-decelerate-emphasize-1)}[class*=b-motion--intro-from-offscreen]{--b-motion-duration-default: var(--beacon-reference-motion-duration-12);--b-motion-timing-function-default: var(--beacon-system-motion-easing-decelerate-emphasize-1)}@media screen and (prefers-reduced-motion: reduce){.b-motion--intro-from-left{animation:none}}@keyframes intro-from-left{0%{opacity:0;transform:translate(calc(-1 * var(--motion-translate-intro-override, var(--motion-translate-intro-micro))))}to{opacity:1;transform:translate(0)}}.b-motion--intro-from-left{animation-name:intro-from-left}@media screen and (prefers-reduced-motion: reduce){.b-motion--intro-from-right{animation:none}}@keyframes intro-from-right{0%{opacity:0;transform:translate(calc(1 * var(--motion-translate-intro-override, var(--motion-translate-intro-micro))))}to{opacity:1;transform:translate(0)}}.b-motion--intro-from-right{animation-name:intro-from-right}@media screen and (prefers-reduced-motion: reduce){.b-motion--intro-from-top{animation:none}}@keyframes intro-from-top{0%{opacity:0;transform:translateY(calc(-1 * var(--motion-translate-intro-override, var(--motion-translate-intro-micro))))}to{opacity:1;transform:translateY(0)}}.b-motion--intro-from-top{animation-name:intro-from-top}@media screen and (prefers-reduced-motion: reduce){.b-motion--intro-from-bottom{animation:none}}@keyframes intro-from-bottom{0%{opacity:0;transform:translateY(calc(1 * var(--motion-translate-intro-override, var(--motion-translate-intro-micro))))}to{opacity:1;transform:translateY(0)}}.b-motion--intro-from-bottom{animation-name:intro-from-bottom}@keyframes intro-from-offscreen-left{0%{opacity:0;transform:translate(calc(-1 * var(--motion-translate-intro-macro)))}to{opacity:1;transform:translate(0)}}.b-motion--intro-from-offscreen-left{animation-name:intro-from-offscreen-left}@keyframes intro-from-offscreen-right{0%{opacity:0;transform:translate(calc(1 * var(--motion-translate-intro-macro)))}to{opacity:1;transform:translate(0)}}.b-motion--intro-from-offscreen-right{animation-name:intro-from-offscreen-right}@keyframes intro-from-offscreen-top{0%{opacity:0;transform:translateY(calc(-1 * var(--motion-translate-intro-macro)))}to{opacity:1;transform:translateY(0)}}.b-motion--intro-from-offscreen-top{animation-name:intro-from-offscreen-top}@keyframes intro-from-offscreen-bottom{0%{opacity:0;transform:translateY(calc(1 * var(--motion-translate-intro-macro)))}to{opacity:1;transform:translateY(0)}}.b-motion--intro-from-offscreen-bottom{animation-name:intro-from-offscreen-bottom}@media (prefers-reduced-motion: reduce){*,*:before,*:after{animation:none;animation-duration:.01ms!important;animation-iteration-count:1!important;scroll-behavior:auto!important;transition:none!important}html{scroll-behavior:auto}}`;
var qS = Object.defineProperty, VS = Object.getOwnPropertyDescriptor, mf = (i) => {
  throw TypeError(i);
}, Po = (i, t, e, a) => {
  for (var o = a > 1 ? void 0 : a ? VS(t, e) : t, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = (a ? r(t, e, o) : r(o)) || o);
  return a && o && qS(t, e, o), o;
}, YS = (i, t, e) => t.has(i) || mf("Cannot " + e), Ka = (i, t, e) => (YS(i, t, "read from private field"), e ? e.call(i) : t.get(i)), QS = (i, t, e) => t.has(i) ? mf("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(i) : t.set(i, e);
function fr(i = { autoRemoveMotionClasses: !0 }) {
  return function(e) {
    var a;
    let o = class extends e {
      constructor() {
        super(...arguments), this.inMotion = !1, this.motionMap = /* @__PURE__ */ new Map(), QS(this, a, ({ type: n, target: r }) => {
          if (!this.prefersReducedMotion) {
            if (this !== r && this.contains(r))
              return;
            (n === "animationstart" || n === "transitionstart") && this.motionMap.set(r, !0), (n === "animationend" || n === "transitionend") && this.motionMap.set(r, !1), Array.from(this.motionMap.values()).includes(!0) ? this.inMotion = !0 : this.inMotion = !1;
          }
        });
      }
      /**
       * Imports motion utility class stylesheet to enable usage of utility classes in shadowDOM
       */
      static get motionStyles() {
        return [WS];
      }
      /**
       * Empty function used to apply component-specific motion logic
       */
      applyMotionStyles() {
      }
      /**
       * Empty function used to handle animationstart events when listened from the root node.
       *
       * @abstract
       * @param e animationstart event object
       */
      hostAnimationStart(n) {
      }
      /**
       * Empty function used to handle animationend events when listened from the root node.
       *
       * @abstract
       * @param e animationend event object
       */
      hostAnimationEnd(n) {
      }
      /**
       * Empty function used to handle animationstart events when listened from the shadow root.
       *
       * @abstract
       * @param e animationstart event object
       */
      shadowRootAnimationStart(n) {
      }
      /**
       * Empty function used to handle animationend events when listened from the shadow root.
       *
       * @abstract
       * @param e animationend event object
       */
      shadowRootAnimationEnd(n) {
      }
      /**
       * Filter an element's classList property for all classes that use `b-motion`.
       *
       * @param element HTML element that finished an animation
       * @returns All class names with `b-motion` in the name
       */
      static findMotionClassesOnElement(n) {
        return Array.from(n.classList).filter(
          (r) => r.includes("b-motion")
        );
      }
      /**
       * Remove all `b-motion` classes from a given element.
       *
       * @param element HTML element that finished an animation
       */
      static removeMotionClassesFromElement(n) {
        n.classList.remove(
          ...o.findMotionClassesOnElement(n)
        );
      }
      /**
       * Called on host Animation End or ShadowRootAnimationEnd if this.
       * Motion class auto removal is enabled
       */
      cleanupClasses(n) {
        n.target instanceof HTMLElement && o.removeMotionClassesFromElement(n.target);
      }
      /*
       * Sets the animationEnd events to instead cleanupClasses if autoRemoval is enabled
       */
      autoRemoveClasses(n) {
        n && (this.hostAnimationEnd = this.cleanupClasses, this.shadowRootAnimationEnd = this.cleanupClasses);
      }
      bindMethods() {
        i && (i != null && i.autoRemoveMotionClasses) && this.autoRemoveClasses(i.autoRemoveMotionClasses), this.hostAnimationStart = this.hostAnimationStart.bind(this), this.hostAnimationEnd = this.hostAnimationEnd.bind(this), this.shadowRootAnimationStart = this.shadowRootAnimationStart.bind(this), this.shadowRootAnimationEnd = this.shadowRootAnimationEnd.bind(this);
      }
      prerenderAddHostEventListeners() {
        this.bindMethods(), this.addEventListener("animationstart", this.hostAnimationStart), this.addEventListener("animationstart", Ka(this, a)), this.addEventListener("animationend", this.hostAnimationEnd), this.addEventListener("animationend", Ka(this, a)), this.addEventListener("transitionstart", Ka(this, a)), this.addEventListener("transitionend", Ka(this, a));
      }
      postrenderAddShadowRootListeners() {
        var n, r, T, O, j, D;
        (n = this.shadowRoot) == null || n.addEventListener(
          "animationstart",
          this.shadowRootAnimationStart
        ), (r = this.shadowRoot) == null || r.addEventListener(
          "animationstart",
          Ka(this, a)
        ), (T = this.shadowRoot) == null || T.addEventListener(
          "animationend",
          this.shadowRootAnimationEnd
        ), (O = this.shadowRoot) == null || O.addEventListener("animationend", Ka(this, a)), (j = this.shadowRoot) == null || j.addEventListener(
          "transitionstart",
          Ka(this, a)
        ), (D = this.shadowRoot) == null || D.addEventListener(
          "transitionend",
          Ka(this, a)
        );
      }
    };
    return a = /* @__PURE__ */ new WeakMap(), Po([
      ue({
        reflect: !0,
        attribute: "in-motion",
        type: Boolean
      })
    ], o.prototype, "inMotion", 2), Po([
      Se()
    ], o.prototype, "motionMap", 2), Po([
      qe
    ], o.prototype, "prerenderAddHostEventListeners", 1), Po([
      De
    ], o.prototype, "postrenderAddShadowRootListeners", 1), o = Po([
      je("Motionable")
    ], o), o;
  };
}
function ff(i = { autoRemoveMotionClasses: !0, threshold: 1 }) {
  return function(e) {
    const a = fr(i)(e);
    let o = class extends a {
      constructor() {
        var n;
        super(...arguments), this.handleMotionStylesOnView = (r) => {
          for (const T of r)
            T.isIntersecting && (this.applyMotionStyles(), this.removeMotionIntersectionObserver());
        }, this.motionIntersectionObserverOptions = {
          threshold: (n = i.threshold) != null ? n : 1
        }, this.motionIntersectionObserver = new IntersectionObserver(
          this.handleMotionStylesOnView,
          this.motionIntersectionObserverOptions
        );
      }
      /**
       * Disconnects the motionInterSectionObserver.
       * Invoked after component comes into view and has triggered motion styles.
       * Also invoked during disconnectedCallback.
       */
      removeMotionIntersectionObserver() {
        this.motionIntersectionObserver.disconnect();
      }
      applyMotionIntersectionObserver() {
        this.motionIntersectionObserver.observe(this);
      }
      motionOnViewDestroy() {
        this.removeMotionIntersectionObserver();
      }
    };
    return Po([
      De
    ], o.prototype, "applyMotionIntersectionObserver", 1), Po([
      Lt
    ], o.prototype, "motionOnViewDestroy", 1), o = Po([
      je("MotionableOnView")
    ], o), o;
  };
}
function vf(i) {
  class t extends i {
    constructor() {
      super(...arguments), this.closing = !1, this.removeMotionHidingState = () => {
        this.closing && (this.closing = !1, this.closingAnimationCallback());
      };
    }
    /** @abstract */
    closingAnimationCallback() {
    }
    applyMotionEventListener() {
      var a;
      (a = this.shadowRoot) == null || a.addEventListener(
        "transitionend",
        this.removeMotionHidingState
      ), this.addEventListener("transitionend", this.removeMotionHidingState);
    }
    removeMotionEventListener() {
      var a;
      (a = this.shadowRoot) == null || a.removeEventListener(
        "transitionend",
        this.removeMotionHidingState
      ), this.removeEventListener("transitionend", this.removeMotionHidingState);
    }
  }
  return Po([
    ue({ reflect: !0, type: Boolean })
  ], t.prototype, "closing", 2), Po([
    qe
  ], t.prototype, "applyMotionEventListener", 1), Po([
    Lt
  ], t.prototype, "removeMotionEventListener", 1), t;
}
var XS = Object.defineProperty, ZS = Object.getOwnPropertyDescriptor, tl = (i, t, e, a) => {
  for (var o = a > 1 ? void 0 : a ? ZS(t, e) : t, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = (a ? r(t, e, o) : r(o)) || o);
  return a && o && XS(t, e, o), o;
};
function Hh(i) {
  let t = class extends i {
    constructor() {
      super(...arguments), this.opensBy = "";
    }
    get opensByElements() {
      if (this.opensBy) {
        const e = this.opensBy.split(" "), a = /* @__PURE__ */ new Map();
        return e.forEach((o) => {
          const n = this.getClosestHost();
          n ? Array.from(
            n.shadowRoot.querySelectorAll(o)
          ).forEach(
            (T) => a.set(T, !0)
          ) : Array.from(document.querySelectorAll(o)).forEach(
            (T) => a.set(T, !0)
          );
        }), a;
      }
    }
    /** @abstract */
    runOpensBySetup() {
    }
    /** @abstract */
    runOpensByClean() {
    }
    setupOpensByElements() {
      this.opensByElements && this.opensByElements.size > 0 && this.runOpensBySetup();
    }
    cleanOpensByElements() {
      this.opensByElements && this.opensByElements.size > 0 && this.runOpensByClean();
    }
    /**
     * Public-facing API method to refresh opens-by elements.
     * Some apps do not have control over the order of loading the trigger element vs. the popover.
     * This allows discovery of trigger elements after page load.
     */
    refreshOpensByElements() {
      this.cleanOpensByElements(), this.setupOpensByElements();
    }
  };
  return tl([
    ue({ attribute: "opens-by" })
  ], t.prototype, "opensBy", 2), tl([
    De
  ], t.prototype, "setupOpensByElements", 1), tl([
    Lt
  ], t.prototype, "cleanOpensByElements", 1), t = tl([
    je("OpensBy")
  ], t), t;
}
const Zn = Math.min, Qi = Math.max, Tl = Math.round, ol = Math.floor, Yo = (i) => ({
  x: i,
  y: i
}), JS = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, eE = {
  start: "end",
  end: "start"
};
function th(i, t, e) {
  return Qi(i, Zn(t, e));
}
function Bs(i, t) {
  return typeof i == "function" ? i(t) : i;
}
function an(i) {
  return i.split("-")[0];
}
function Rs(i) {
  return i.split("-")[1];
}
function Af(i) {
  return i === "x" ? "y" : "x";
}
function Kh(i) {
  return i === "y" ? "height" : "width";
}
function Jn(i) {
  return ["top", "bottom"].includes(an(i)) ? "y" : "x";
}
function Gh(i) {
  return Af(Jn(i));
}
function tE(i, t, e) {
  e === void 0 && (e = !1);
  const a = Rs(i), o = Gh(i), n = Kh(o);
  let r = o === "x" ? a === (e ? "end" : "start") ? "right" : "left" : a === "start" ? "bottom" : "top";
  return t.reference[n] > t.floating[n] && (r = Ml(r)), [r, Ml(r)];
}
function oE(i) {
  const t = Ml(i);
  return [oh(i), t, oh(t)];
}
function oh(i) {
  return i.replace(/start|end/g, (t) => eE[t]);
}
function aE(i, t, e) {
  const a = ["left", "right"], o = ["right", "left"], n = ["top", "bottom"], r = ["bottom", "top"];
  switch (i) {
    case "top":
    case "bottom":
      return e ? t ? o : a : t ? a : o;
    case "left":
    case "right":
      return t ? n : r;
    default:
      return [];
  }
}
function iE(i, t, e, a) {
  const o = Rs(i);
  let n = aE(an(i), e === "start", a);
  return o && (n = n.map((r) => r + "-" + o), t && (n = n.concat(n.map(oh)))), n;
}
function Ml(i) {
  return i.replace(/left|right|bottom|top/g, (t) => JS[t]);
}
function nE(i) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...i
  };
}
function yf(i) {
  return typeof i != "number" ? nE(i) : {
    top: i,
    right: i,
    bottom: i,
    left: i
  };
}
function Ll(i) {
  const {
    x: t,
    y: e,
    width: a,
    height: o
  } = i;
  return {
    width: a,
    height: o,
    top: e,
    left: t,
    right: t + a,
    bottom: e + o,
    x: t,
    y: e
  };
}
function vu(i, t, e) {
  let {
    reference: a,
    floating: o
  } = i;
  const n = Jn(t), r = Gh(t), T = Kh(r), O = an(t), j = n === "y", D = a.x + a.width / 2 - o.width / 2, F = a.y + a.height / 2 - o.height / 2, B = a[T] / 2 - o[T] / 2;
  let N;
  switch (O) {
    case "top":
      N = {
        x: D,
        y: a.y - o.height
      };
      break;
    case "bottom":
      N = {
        x: D,
        y: a.y + a.height
      };
      break;
    case "right":
      N = {
        x: a.x + a.width,
        y: F
      };
      break;
    case "left":
      N = {
        x: a.x - o.width,
        y: F
      };
      break;
    default:
      N = {
        x: a.x,
        y: a.y
      };
  }
  switch (Rs(t)) {
    case "start":
      N[r] -= B * (e && j ? -1 : 1);
      break;
    case "end":
      N[r] += B * (e && j ? -1 : 1);
      break;
  }
  return N;
}
const rE = async (i, t, e) => {
  const {
    placement: a = "bottom",
    strategy: o = "absolute",
    middleware: n = [],
    platform: r
  } = e, T = n.filter(Boolean), O = await (r.isRTL == null ? void 0 : r.isRTL(t));
  let j = await r.getElementRects({
    reference: i,
    floating: t,
    strategy: o
  }), {
    x: D,
    y: F
  } = vu(j, a, O), B = a, N = {}, f = 0;
  for (let w = 0; w < T.length; w++) {
    const {
      name: x,
      fn: M
    } = T[w], {
      x: p,
      y: v,
      data: k,
      reset: m
    } = await M({
      x: D,
      y: F,
      initialPlacement: a,
      placement: B,
      strategy: o,
      middlewareData: N,
      rects: j,
      platform: r,
      elements: {
        reference: i,
        floating: t
      }
    });
    D = p != null ? p : D, F = v != null ? v : F, N = {
      ...N,
      [x]: {
        ...N[x],
        ...k
      }
    }, m && f <= 50 && (f++, typeof m == "object" && (m.placement && (B = m.placement), m.rects && (j = m.rects === !0 ? await r.getElementRects({
      reference: i,
      floating: t,
      strategy: o
    }) : m.rects), {
      x: D,
      y: F
    } = vu(j, B, O)), w = -1);
  }
  return {
    x: D,
    y: F,
    placement: B,
    strategy: o,
    middlewareData: N
  };
};
async function xf(i, t) {
  var e;
  t === void 0 && (t = {});
  const {
    x: a,
    y: o,
    platform: n,
    rects: r,
    elements: T,
    strategy: O
  } = i, {
    boundary: j = "clippingAncestors",
    rootBoundary: D = "viewport",
    elementContext: F = "floating",
    altBoundary: B = !1,
    padding: N = 0
  } = Bs(t, i), f = yf(N), x = T[B ? F === "floating" ? "reference" : "floating" : F], M = Ll(await n.getClippingRect({
    element: (e = await (n.isElement == null ? void 0 : n.isElement(x))) == null || e ? x : x.contextElement || await (n.getDocumentElement == null ? void 0 : n.getDocumentElement(T.floating)),
    boundary: j,
    rootBoundary: D,
    strategy: O
  })), p = F === "floating" ? {
    x: a,
    y: o,
    width: r.floating.width,
    height: r.floating.height
  } : r.reference, v = await (n.getOffsetParent == null ? void 0 : n.getOffsetParent(T.floating)), k = await (n.isElement == null ? void 0 : n.isElement(v)) ? await (n.getScale == null ? void 0 : n.getScale(v)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, m = Ll(n.convertOffsetParentRelativeRectToViewportRelativeRect ? await n.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: T,
    rect: p,
    offsetParent: v,
    strategy: O
  }) : p);
  return {
    top: (M.top - m.top + f.top) / k.y,
    bottom: (m.bottom - M.bottom + f.bottom) / k.y,
    left: (M.left - m.left + f.left) / k.x,
    right: (m.right - M.right + f.right) / k.x
  };
}
const sE = (i) => ({
  name: "arrow",
  options: i,
  async fn(t) {
    const {
      x: e,
      y: a,
      placement: o,
      rects: n,
      platform: r,
      elements: T,
      middlewareData: O
    } = t, {
      element: j,
      padding: D = 0
    } = Bs(i, t) || {};
    if (j == null)
      return {};
    const F = yf(D), B = {
      x: e,
      y: a
    }, N = Gh(o), f = Kh(N), w = await r.getDimensions(j), x = N === "y", M = x ? "top" : "left", p = x ? "bottom" : "right", v = x ? "clientHeight" : "clientWidth", k = n.reference[f] + n.reference[N] - B[N] - n.floating[f], m = B[N] - n.reference[N], A = await (r.getOffsetParent == null ? void 0 : r.getOffsetParent(j));
    let C = A ? A[v] : 0;
    (!C || !await (r.isElement == null ? void 0 : r.isElement(A))) && (C = T.floating[v] || n.floating[f]);
    const H = k / 2 - m / 2, G = C / 2 - w[f] / 2 - 1, P = Zn(F[M], G), y = Zn(F[p], G), S = P, d = C - w[f] - y, s = C / 2 - w[f] / 2 + H, l = th(S, s, d), b = !O.arrow && Rs(o) != null && s !== l && n.reference[f] / 2 - (s < S ? P : y) - w[f] / 2 < 0, u = b ? s < S ? s - S : s - d : 0;
    return {
      [N]: B[N] + u,
      data: {
        [N]: l,
        centerOffset: s - l - u,
        ...b && {
          alignmentOffset: u
        }
      },
      reset: b
    };
  }
}), lE = function(i) {
  return i === void 0 && (i = {}), {
    name: "flip",
    options: i,
    async fn(t) {
      var e, a;
      const {
        placement: o,
        middlewareData: n,
        rects: r,
        initialPlacement: T,
        platform: O,
        elements: j
      } = t, {
        mainAxis: D = !0,
        crossAxis: F = !0,
        fallbackPlacements: B,
        fallbackStrategy: N = "bestFit",
        fallbackAxisSideDirection: f = "none",
        flipAlignment: w = !0,
        ...x
      } = Bs(i, t);
      if ((e = n.arrow) != null && e.alignmentOffset)
        return {};
      const M = an(o), p = Jn(T), v = an(T) === T, k = await (O.isRTL == null ? void 0 : O.isRTL(j.floating)), m = B || (v || !w ? [Ml(T)] : oE(T)), A = f !== "none";
      !B && A && m.push(...iE(T, w, f, k));
      const C = [T, ...m], H = await xf(t, x), G = [];
      let P = ((a = n.flip) == null ? void 0 : a.overflows) || [];
      if (D && G.push(H[M]), F) {
        const s = tE(o, r, k);
        G.push(H[s[0]], H[s[1]]);
      }
      if (P = [...P, {
        placement: o,
        overflows: G
      }], !G.every((s) => s <= 0)) {
        var y, S;
        const s = (((y = n.flip) == null ? void 0 : y.index) || 0) + 1, l = C[s];
        if (l)
          return {
            data: {
              index: s,
              overflows: P
            },
            reset: {
              placement: l
            }
          };
        let b = (S = P.filter((u) => u.overflows[0] <= 0).sort((u, c) => u.overflows[1] - c.overflows[1])[0]) == null ? void 0 : S.placement;
        if (!b)
          switch (N) {
            case "bestFit": {
              var d;
              const u = (d = P.filter((c) => {
                if (A) {
                  const h = Jn(c.placement);
                  return h === p || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  h === "y";
                }
                return !0;
              }).map((c) => [c.placement, c.overflows.filter((h) => h > 0).reduce((h, g) => h + g, 0)]).sort((c, h) => c[1] - h[1])[0]) == null ? void 0 : d[0];
              u && (b = u);
              break;
            }
            case "initialPlacement":
              b = T;
              break;
          }
        if (o !== b)
          return {
            reset: {
              placement: b
            }
          };
      }
      return {};
    }
  };
};
async function cE(i, t) {
  const {
    placement: e,
    platform: a,
    elements: o
  } = i, n = await (a.isRTL == null ? void 0 : a.isRTL(o.floating)), r = an(e), T = Rs(e), O = Jn(e) === "y", j = ["left", "top"].includes(r) ? -1 : 1, D = n && O ? -1 : 1, F = Bs(t, i);
  let {
    mainAxis: B,
    crossAxis: N,
    alignmentAxis: f
  } = typeof F == "number" ? {
    mainAxis: F,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: F.mainAxis || 0,
    crossAxis: F.crossAxis || 0,
    alignmentAxis: F.alignmentAxis
  };
  return T && typeof f == "number" && (N = T === "end" ? f * -1 : f), O ? {
    x: N * D,
    y: B * j
  } : {
    x: B * j,
    y: N * D
  };
}
const dE = function(i) {
  return i === void 0 && (i = 0), {
    name: "offset",
    options: i,
    async fn(t) {
      var e, a;
      const {
        x: o,
        y: n,
        placement: r,
        middlewareData: T
      } = t, O = await cE(t, i);
      return r === ((e = T.offset) == null ? void 0 : e.placement) && (a = T.arrow) != null && a.alignmentOffset ? {} : {
        x: o + O.x,
        y: n + O.y,
        data: {
          ...O,
          placement: r
        }
      };
    }
  };
}, hE = function(i) {
  return i === void 0 && (i = {}), {
    name: "shift",
    options: i,
    async fn(t) {
      const {
        x: e,
        y: a,
        placement: o
      } = t, {
        mainAxis: n = !0,
        crossAxis: r = !1,
        limiter: T = {
          fn: (x) => {
            let {
              x: M,
              y: p
            } = x;
            return {
              x: M,
              y: p
            };
          }
        },
        ...O
      } = Bs(i, t), j = {
        x: e,
        y: a
      }, D = await xf(t, O), F = Jn(an(o)), B = Af(F);
      let N = j[B], f = j[F];
      if (n) {
        const x = B === "y" ? "top" : "left", M = B === "y" ? "bottom" : "right", p = N + D[x], v = N - D[M];
        N = th(p, N, v);
      }
      if (r) {
        const x = F === "y" ? "top" : "left", M = F === "y" ? "bottom" : "right", p = f + D[x], v = f - D[M];
        f = th(p, f, v);
      }
      const w = T.fn({
        ...t,
        [B]: N,
        [F]: f
      });
      return {
        ...w,
        data: {
          x: w.x - e,
          y: w.y - a,
          enabled: {
            [B]: n,
            [F]: r
          }
        }
      };
    }
  };
};
function fc() {
  return typeof window < "u";
}
function vr(i) {
  return wf(i) ? (i.nodeName || "").toLowerCase() : "#document";
}
function ro(i) {
  var t;
  return (i == null || (t = i.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function na(i) {
  var t;
  return (t = (wf(i) ? i.ownerDocument : i.document) || window.document) == null ? void 0 : t.documentElement;
}
function wf(i) {
  return fc() ? i instanceof Node || i instanceof ro(i).Node : !1;
}
function Ro(i) {
  return fc() ? i instanceof Element || i instanceof ro(i).Element : !1;
}
function ea(i) {
  return fc() ? i instanceof HTMLElement || i instanceof ro(i).HTMLElement : !1;
}
function Au(i) {
  return !fc() || typeof ShadowRoot > "u" ? !1 : i instanceof ShadowRoot || i instanceof ro(i).ShadowRoot;
}
function Ns(i) {
  const {
    overflow: t,
    overflowX: e,
    overflowY: a,
    display: o
  } = No(i);
  return /auto|scroll|overlay|hidden|clip/.test(t + a + e) && !["inline", "contents"].includes(o);
}
function bE(i) {
  return ["table", "td", "th"].includes(vr(i));
}
function vc(i) {
  return [":popover-open", ":modal"].some((t) => {
    try {
      return i.matches(t);
    } catch {
      return !1;
    }
  });
}
function Wh(i) {
  const t = qh(), e = Ro(i) ? No(i) : i;
  return ["transform", "translate", "scale", "rotate", "perspective"].some((a) => e[a] ? e[a] !== "none" : !1) || (e.containerType ? e.containerType !== "normal" : !1) || !t && (e.backdropFilter ? e.backdropFilter !== "none" : !1) || !t && (e.filter ? e.filter !== "none" : !1) || ["transform", "translate", "scale", "rotate", "perspective", "filter"].some((a) => (e.willChange || "").includes(a)) || ["paint", "layout", "strict", "content"].some((a) => (e.contain || "").includes(a));
}
function pE(i) {
  let t = ui(i);
  for (; ea(t) && !er(t); ) {
    if (Wh(t))
      return t;
    if (vc(t))
      return null;
    t = ui(t);
  }
  return null;
}
function qh() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function er(i) {
  return ["html", "body", "#document"].includes(vr(i));
}
function No(i) {
  return ro(i).getComputedStyle(i);
}
function Ac(i) {
  return Ro(i) ? {
    scrollLeft: i.scrollLeft,
    scrollTop: i.scrollTop
  } : {
    scrollLeft: i.scrollX,
    scrollTop: i.scrollY
  };
}
function ui(i) {
  if (vr(i) === "html")
    return i;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    i.assignedSlot || // DOM Element detected.
    i.parentNode || // ShadowRoot detected.
    Au(i) && i.host || // Fallback.
    na(i)
  );
  return Au(t) ? t.host : t;
}
function kf(i) {
  const t = ui(i);
  return er(t) ? i.ownerDocument ? i.ownerDocument.body : i.body : ea(t) && Ns(t) ? t : kf(t);
}
function rs(i, t, e) {
  var a;
  t === void 0 && (t = []), e === void 0 && (e = !0);
  const o = kf(i), n = o === ((a = i.ownerDocument) == null ? void 0 : a.body), r = ro(o);
  if (n) {
    const T = ah(r);
    return t.concat(r, r.visualViewport || [], Ns(o) ? o : [], T && e ? rs(T) : []);
  }
  return t.concat(o, rs(o, [], e));
}
function ah(i) {
  return i.parent && Object.getPrototypeOf(i.parent) ? i.frameElement : null;
}
function Cf(i) {
  const t = No(i);
  let e = parseFloat(t.width) || 0, a = parseFloat(t.height) || 0;
  const o = ea(i), n = o ? i.offsetWidth : e, r = o ? i.offsetHeight : a, T = Tl(e) !== n || Tl(a) !== r;
  return T && (e = n, a = r), {
    width: e,
    height: a,
    $: T
  };
}
function Vh(i) {
  return Ro(i) ? i : i.contextElement;
}
function Un(i) {
  const t = Vh(i);
  if (!ea(t))
    return Yo(1);
  const e = t.getBoundingClientRect(), {
    width: a,
    height: o,
    $: n
  } = Cf(t);
  let r = (n ? Tl(e.width) : e.width) / a, T = (n ? Tl(e.height) : e.height) / o;
  return (!r || !Number.isFinite(r)) && (r = 1), (!T || !Number.isFinite(T)) && (T = 1), {
    x: r,
    y: T
  };
}
const uE = /* @__PURE__ */ Yo(0);
function Sf(i) {
  const t = ro(i);
  return !qh() || !t.visualViewport ? uE : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function gE(i, t, e) {
  return t === void 0 && (t = !1), !e || t && e !== ro(i) ? !1 : t;
}
function nn(i, t, e, a) {
  t === void 0 && (t = !1), e === void 0 && (e = !1);
  const o = i.getBoundingClientRect(), n = Vh(i);
  let r = Yo(1);
  t && (a ? Ro(a) && (r = Un(a)) : r = Un(i));
  const T = gE(n, e, a) ? Sf(n) : Yo(0);
  let O = (o.left + T.x) / r.x, j = (o.top + T.y) / r.y, D = o.width / r.x, F = o.height / r.y;
  if (n) {
    const B = ro(n), N = a && Ro(a) ? ro(a) : a;
    let f = B, w = ah(f);
    for (; w && a && N !== f; ) {
      const x = Un(w), M = w.getBoundingClientRect(), p = No(w), v = M.left + (w.clientLeft + parseFloat(p.paddingLeft)) * x.x, k = M.top + (w.clientTop + parseFloat(p.paddingTop)) * x.y;
      O *= x.x, j *= x.y, D *= x.x, F *= x.y, O += v, j += k, f = ro(w), w = ah(f);
    }
  }
  return Ll({
    width: D,
    height: F,
    x: O,
    y: j
  });
}
function Yh(i, t) {
  const e = Ac(i).scrollLeft;
  return t ? t.left + e : nn(na(i)).left + e;
}
function Ef(i, t, e) {
  e === void 0 && (e = !1);
  const a = i.getBoundingClientRect(), o = a.left + t.scrollLeft - (e ? 0 : (
    // RTL <body> scrollbar.
    Yh(i, a)
  )), n = a.top + t.scrollTop;
  return {
    x: o,
    y: n
  };
}
function mE(i) {
  let {
    elements: t,
    rect: e,
    offsetParent: a,
    strategy: o
  } = i;
  const n = o === "fixed", r = na(a), T = t ? vc(t.floating) : !1;
  if (a === r || T && n)
    return e;
  let O = {
    scrollLeft: 0,
    scrollTop: 0
  }, j = Yo(1);
  const D = Yo(0), F = ea(a);
  if ((F || !F && !n) && ((vr(a) !== "body" || Ns(r)) && (O = Ac(a)), ea(a))) {
    const N = nn(a);
    j = Un(a), D.x = N.x + a.clientLeft, D.y = N.y + a.clientTop;
  }
  const B = r && !F && !n ? Ef(r, O, !0) : Yo(0);
  return {
    width: e.width * j.x,
    height: e.height * j.y,
    x: e.x * j.x - O.scrollLeft * j.x + D.x + B.x,
    y: e.y * j.y - O.scrollTop * j.y + D.y + B.y
  };
}
function fE(i) {
  return Array.from(i.getClientRects());
}
function vE(i) {
  const t = na(i), e = Ac(i), a = i.ownerDocument.body, o = Qi(t.scrollWidth, t.clientWidth, a.scrollWidth, a.clientWidth), n = Qi(t.scrollHeight, t.clientHeight, a.scrollHeight, a.clientHeight);
  let r = -e.scrollLeft + Yh(i);
  const T = -e.scrollTop;
  return No(a).direction === "rtl" && (r += Qi(t.clientWidth, a.clientWidth) - o), {
    width: o,
    height: n,
    x: r,
    y: T
  };
}
function AE(i, t) {
  const e = ro(i), a = na(i), o = e.visualViewport;
  let n = a.clientWidth, r = a.clientHeight, T = 0, O = 0;
  if (o) {
    n = o.width, r = o.height;
    const j = qh();
    (!j || j && t === "fixed") && (T = o.offsetLeft, O = o.offsetTop);
  }
  return {
    width: n,
    height: r,
    x: T,
    y: O
  };
}
function yE(i, t) {
  const e = nn(i, !0, t === "fixed"), a = e.top + i.clientTop, o = e.left + i.clientLeft, n = ea(i) ? Un(i) : Yo(1), r = i.clientWidth * n.x, T = i.clientHeight * n.y, O = o * n.x, j = a * n.y;
  return {
    width: r,
    height: T,
    x: O,
    y: j
  };
}
function yu(i, t, e) {
  let a;
  if (t === "viewport")
    a = AE(i, e);
  else if (t === "document")
    a = vE(na(i));
  else if (Ro(t))
    a = yE(t, e);
  else {
    const o = Sf(i);
    a = {
      x: t.x - o.x,
      y: t.y - o.y,
      width: t.width,
      height: t.height
    };
  }
  return Ll(a);
}
function Tf(i, t) {
  const e = ui(i);
  return e === t || !Ro(e) || er(e) ? !1 : No(e).position === "fixed" || Tf(e, t);
}
function xE(i, t) {
  const e = t.get(i);
  if (e)
    return e;
  let a = rs(i, [], !1).filter((T) => Ro(T) && vr(T) !== "body"), o = null;
  const n = No(i).position === "fixed";
  let r = n ? ui(i) : i;
  for (; Ro(r) && !er(r); ) {
    const T = No(r), O = Wh(r);
    !O && T.position === "fixed" && (o = null), (n ? !O && !o : !O && T.position === "static" && !!o && ["absolute", "fixed"].includes(o.position) || Ns(r) && !O && Tf(i, r)) ? a = a.filter((D) => D !== r) : o = T, r = ui(r);
  }
  return t.set(i, a), a;
}
function wE(i) {
  let {
    element: t,
    boundary: e,
    rootBoundary: a,
    strategy: o
  } = i;
  const r = [...e === "clippingAncestors" ? vc(t) ? [] : xE(t, this._c) : [].concat(e), a], T = r[0], O = r.reduce((j, D) => {
    const F = yu(t, D, o);
    return j.top = Qi(F.top, j.top), j.right = Zn(F.right, j.right), j.bottom = Zn(F.bottom, j.bottom), j.left = Qi(F.left, j.left), j;
  }, yu(t, T, o));
  return {
    width: O.right - O.left,
    height: O.bottom - O.top,
    x: O.left,
    y: O.top
  };
}
function kE(i) {
  const {
    width: t,
    height: e
  } = Cf(i);
  return {
    width: t,
    height: e
  };
}
function CE(i, t, e) {
  const a = ea(t), o = na(t), n = e === "fixed", r = nn(i, !0, n, t);
  let T = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const O = Yo(0);
  if (a || !a && !n)
    if ((vr(t) !== "body" || Ns(o)) && (T = Ac(t)), a) {
      const B = nn(t, !0, n, t);
      O.x = B.x + t.clientLeft, O.y = B.y + t.clientTop;
    } else o && (O.x = Yh(o));
  const j = o && !a && !n ? Ef(o, T) : Yo(0), D = r.left + T.scrollLeft - O.x - j.x, F = r.top + T.scrollTop - O.y - j.y;
  return {
    x: D,
    y: F,
    width: r.width,
    height: r.height
  };
}
function yd(i) {
  return No(i).position === "static";
}
function xu(i, t) {
  if (!ea(i) || No(i).position === "fixed")
    return null;
  if (t)
    return t(i);
  let e = i.offsetParent;
  return na(i) === e && (e = e.ownerDocument.body), e;
}
function Mf(i, t) {
  const e = ro(i);
  if (vc(i))
    return e;
  if (!ea(i)) {
    let o = ui(i);
    for (; o && !er(o); ) {
      if (Ro(o) && !yd(o))
        return o;
      o = ui(o);
    }
    return e;
  }
  let a = xu(i, t);
  for (; a && bE(a) && yd(a); )
    a = xu(a, t);
  return a && er(a) && yd(a) && !Wh(a) ? e : a || pE(i) || e;
}
const SE = async function(i) {
  const t = this.getOffsetParent || Mf, e = this.getDimensions, a = await e(i.floating);
  return {
    reference: CE(i.reference, await t(i.floating), i.strategy),
    floating: {
      x: 0,
      y: 0,
      width: a.width,
      height: a.height
    }
  };
};
function EE(i) {
  return No(i).direction === "rtl";
}
const TE = {
  convertOffsetParentRelativeRectToViewportRelativeRect: mE,
  getDocumentElement: na,
  getClippingRect: wE,
  getOffsetParent: Mf,
  getElementRects: SE,
  getClientRects: fE,
  getDimensions: kE,
  getScale: Un,
  isElement: Ro,
  isRTL: EE
};
function Lf(i, t) {
  return i.x === t.x && i.y === t.y && i.width === t.width && i.height === t.height;
}
function ME(i, t) {
  let e = null, a;
  const o = na(i);
  function n() {
    var T;
    clearTimeout(a), (T = e) == null || T.disconnect(), e = null;
  }
  function r(T, O) {
    T === void 0 && (T = !1), O === void 0 && (O = 1), n();
    const j = i.getBoundingClientRect(), {
      left: D,
      top: F,
      width: B,
      height: N
    } = j;
    if (T || t(), !B || !N)
      return;
    const f = ol(F), w = ol(o.clientWidth - (D + B)), x = ol(o.clientHeight - (F + N)), M = ol(D), v = {
      rootMargin: -f + "px " + -w + "px " + -x + "px " + -M + "px",
      threshold: Qi(0, Zn(1, O)) || 1
    };
    let k = !0;
    function m(A) {
      const C = A[0].intersectionRatio;
      if (C !== O) {
        if (!k)
          return r();
        C ? r(!1, C) : a = setTimeout(() => {
          r(!1, 1e-7);
        }, 1e3);
      }
      C === 1 && !Lf(j, i.getBoundingClientRect()) && r(), k = !1;
    }
    try {
      e = new IntersectionObserver(m, {
        ...v,
        // Handle <iframe>s
        root: o.ownerDocument
      });
    } catch {
      e = new IntersectionObserver(m, v);
    }
    e.observe(i);
  }
  return r(!0), n;
}
function LE(i, t, e, a) {
  a === void 0 && (a = {});
  const {
    ancestorScroll: o = !0,
    ancestorResize: n = !0,
    elementResize: r = typeof ResizeObserver == "function",
    layoutShift: T = typeof IntersectionObserver == "function",
    animationFrame: O = !1
  } = a, j = Vh(i), D = o || n ? [...j ? rs(j) : [], ...rs(t)] : [];
  D.forEach((M) => {
    o && M.addEventListener("scroll", e, {
      passive: !0
    }), n && M.addEventListener("resize", e);
  });
  const F = j && T ? ME(j, e) : null;
  let B = -1, N = null;
  r && (N = new ResizeObserver((M) => {
    let [p] = M;
    p && p.target === j && N && (N.unobserve(t), cancelAnimationFrame(B), B = requestAnimationFrame(() => {
      var v;
      (v = N) == null || v.observe(t);
    })), e();
  }), j && !O && N.observe(j), N.observe(t));
  let f, w = O ? nn(i) : null;
  O && x();
  function x() {
    const M = nn(i);
    w && !Lf(w, M) && e(), w = M, f = requestAnimationFrame(x);
  }
  return e(), () => {
    var M;
    D.forEach((p) => {
      o && p.removeEventListener("scroll", e), n && p.removeEventListener("resize", e);
    }), F == null || F(), (M = N) == null || M.disconnect(), N = null, O && cancelAnimationFrame(f);
  };
}
const OE = dE, PE = hE, zE = lE, DE = sE, IE = (i, t, e) => {
  const a = /* @__PURE__ */ new Map(), o = {
    platform: TE,
    ...e
  }, n = {
    ...o.platform,
    _c: a
  };
  return rE(i, t, {
    ...o,
    platform: n
  });
};
var yc = class extends Event {
  constructor(t, { oldState: e = "", newState: a = "", ...o } = {}) {
    super(t, o);
    Fc(this, "oldState");
    Fc(this, "newState");
    this.oldState = String(e || ""), this.newState = String(a || "");
  }
}, wu = /* @__PURE__ */ new WeakMap();
function Of(i, t, e) {
  wu.set(
    i,
    setTimeout(() => {
      wu.has(i) && i.dispatchEvent(
        new yc("toggle", {
          cancelable: !1,
          oldState: t,
          newState: e
        })
      );
    }, 0)
  );
}
var Qh = globalThis.ShadowRoot || function() {
}, BE = globalThis.HTMLDialogElement || function() {
}, pl = /* @__PURE__ */ new WeakMap(), Sa = /* @__PURE__ */ new WeakMap(), Fs = /* @__PURE__ */ new WeakMap();
function Ol(i) {
  return Fs.get(i) || "hidden";
}
var Pl = /* @__PURE__ */ new WeakMap();
function RE(i) {
  const t = i.popoverTargetElement;
  if (!(t instanceof HTMLElement))
    return;
  const e = Ol(t);
  i.popoverTargetAction === "show" && e === "showing" || i.popoverTargetAction === "hide" && e === "hidden" || (e === "showing" ? ss(t, !0, !0) : Xi(t, !1) && (Pl.set(t, i), ih(t)));
}
function Xi(i, t) {
  return !(i.popover !== "auto" && i.popover !== "manual" || !i.isConnected || t && Ol(i) !== "showing" || !t && Ol(i) !== "hidden" || i instanceof BE && i.hasAttribute("open") || document.fullscreenElement === i);
}
function ku(i) {
  return i ? Array.from(Sa.get(i.ownerDocument) || []).indexOf(
    i
  ) + 1 : 0;
}
function NE(i) {
  const t = Pf(i), e = FE(i);
  return ku(t) > ku(e) ? t : e;
}
function zl(i) {
  const t = Sa.get(i);
  for (const e of t || [])
    if (!e.isConnected)
      t.delete(e);
    else
      return e;
  return null;
}
function tr(i) {
  return typeof i.getRootNode == "function" ? i.getRootNode() : i.parentNode ? tr(i.parentNode) : i;
}
function Pf(i) {
  for (; i; ) {
    if (i instanceof HTMLElement && i.popover === "auto" && Fs.get(i) === "showing")
      return i;
    if (i = i instanceof Element && i.assignedSlot || i.parentElement || tr(i), i instanceof Qh && (i = i.host), i instanceof Document) return;
  }
}
function FE(i) {
  for (; i; ) {
    const t = i.popoverTargetElement;
    if (t instanceof HTMLElement) return t;
    if (i = i.parentElement || tr(i), i instanceof Qh && (i = i.host), i instanceof Document) return;
  }
}
function _E(i) {
  const t = /* @__PURE__ */ new Map();
  let e = 0;
  for (const n of Sa.get(i.ownerDocument) || [])
    t.set(n, e), e += 1;
  t.set(i, e), e += 1;
  let a = null;
  function o(n) {
    const r = Pf(n);
    if (r === null) return null;
    const T = t.get(r);
    (a === null || t.get(a) < T) && (a = r);
  }
  return o(i.parentElement || tr(i)), a;
}
function UE(i) {
  return i.hidden || i instanceof Qh || (i instanceof HTMLButtonElement || i instanceof HTMLInputElement || i instanceof HTMLSelectElement || i instanceof HTMLTextAreaElement || i instanceof HTMLOptGroupElement || i instanceof HTMLOptionElement || i instanceof HTMLFieldSetElement) && i.disabled || i instanceof HTMLInputElement && i.type === "hidden" || i instanceof HTMLAnchorElement && i.href === "" ? !1 : typeof i.tabIndex == "number" && i.tabIndex !== -1;
}
function jE(i) {
  if (i.shadowRoot && i.shadowRoot.delegatesFocus !== !0)
    return null;
  let t = i;
  t.shadowRoot && (t = t.shadowRoot);
  let e = t.querySelector("[autofocus]");
  if (e)
    return e;
  {
    const n = t.querySelectorAll("slot");
    for (const r of n) {
      const T = r.assignedElements({ flatten: !0 });
      for (const O of T) {
        if (O.hasAttribute("autofocus"))
          return O;
        if (e = O.querySelector("[autofocus]"), e)
          return e;
      }
    }
  }
  const a = i.ownerDocument.createTreeWalker(
    t,
    NodeFilter.SHOW_ELEMENT
  );
  let o = a.currentNode;
  for (; o; ) {
    if (UE(o))
      return o;
    o = a.nextNode();
  }
}
function $E(i) {
  var t;
  (t = jE(i)) == null || t.focus();
}
var Dl = /* @__PURE__ */ new WeakMap();
function ih(i) {
  if (!Xi(i, !1))
    return;
  const t = i.ownerDocument;
  if (!i.dispatchEvent(
    new yc("beforetoggle", {
      cancelable: !0,
      oldState: "closed",
      newState: "open"
    })
  ) || !Xi(i, !1))
    return;
  let e = !1;
  if (i.popover === "auto") {
    const o = i.getAttribute("popover"), n = _E(i) || t;
    if (xc(n, !1, !0), o !== i.getAttribute("popover") || !Xi(i, !1))
      return;
  }
  zl(t) || (e = !0), Dl.delete(i);
  const a = t.activeElement;
  i.classList.add(":popover-open"), Fs.set(i, "showing"), pl.has(t) || pl.set(t, /* @__PURE__ */ new Set()), pl.get(t).add(i), $E(i), i.popover === "auto" && (Sa.has(t) || Sa.set(t, /* @__PURE__ */ new Set()), Sa.get(t).add(i), zf(Pl.get(i), !0)), e && a && i.popover === "auto" && Dl.set(i, a), Of(i, "closed", "open");
}
function ss(i, t = !1, e = !1) {
  var n, r;
  if (!Xi(i, !0))
    return;
  const a = i.ownerDocument;
  if (i.popover === "auto" && (xc(i, t, e), !Xi(i, !0)) || (zf(Pl.get(i), !1), Pl.delete(i), e && (i.dispatchEvent(
    new yc("beforetoggle", {
      oldState: "open",
      newState: "closed"
    })
  ), !Xi(i, !0))))
    return;
  (n = pl.get(a)) == null || n.delete(i), (r = Sa.get(a)) == null || r.delete(i), i.classList.remove(":popover-open"), Fs.set(i, "hidden"), e && Of(i, "open", "closed");
  const o = Dl.get(i);
  o && (Dl.delete(i), t && o.focus());
}
function Cu(i, t = !1, e = !1) {
  let a = zl(i);
  for (; a; )
    ss(a, t, e), a = zl(i);
}
function xc(i, t, e) {
  var r;
  const a = i.ownerDocument || i;
  if (i instanceof Document)
    return Cu(a, t, e);
  let o = null, n = !1;
  for (const T of Sa.get(a) || [])
    if (T === i)
      n = !0;
    else if (n) {
      o = T;
      break;
    }
  if (!n)
    return Cu(a, t, e);
  for (; o && Ol(o) === "showing" && ((r = Sa.get(a)) != null && r.size); )
    ss(o, t, e);
}
var xd = /* @__PURE__ */ new WeakMap();
function Su(i) {
  if (!i.isTrusted) return;
  const t = i.composedPath()[0];
  if (!t) return;
  const e = t.ownerDocument;
  if (!zl(e)) return;
  const o = NE(t);
  if (o && i.type === "pointerdown")
    xd.set(e, o);
  else if (i.type === "pointerup") {
    const n = xd.get(e) === o;
    xd.delete(e), n && xc(o || e, !1, !0);
  }
}
var wd = /* @__PURE__ */ new WeakMap();
function zf(i, t = !1) {
  if (!i) return;
  wd.has(i) || wd.set(i, i.getAttribute("aria-expanded"));
  const e = i.popoverTargetElement;
  if (e instanceof HTMLElement && e.popover === "auto")
    i.setAttribute("aria-expanded", String(t));
  else {
    const a = wd.get(i);
    a ? i.setAttribute("aria-expanded", a) : i.removeAttribute("aria-expanded");
  }
}
var Eu = globalThis.ShadowRoot || function() {
};
function HE() {
  return typeof HTMLElement < "u" && typeof HTMLElement.prototype == "object" && "popover" in HTMLElement.prototype;
}
function Mi(i, t, e) {
  const a = i[t];
  Object.defineProperty(i, t, {
    value(o) {
      return a.call(this, e(o));
    }
  });
}
var KE = /(^|[^\\]):popover-open\b/g;
function GE() {
  return typeof globalThis.CSSLayerBlockRule == "function";
}
function WE() {
  const i = GE();
  return `
${i ? "@layer popover-polyfill {" : ""}
  :where([popover]) {
    position: fixed;
    z-index: 2147483647;
    inset: 0;
    padding: 0.25em;
    width: fit-content;
    height: fit-content;
    border-width: initial;
    border-color: initial;
    border-image: initial;
    border-style: solid;
    background-color: canvas;
    color: canvastext;
    overflow: auto;
    margin: auto;
  }

  :where([popover]:not(.\\:popover-open)) {
    display: none;
  }

  :where(dialog[popover].\\:popover-open) {
    display: block;
  }

  :where(dialog[popover][open]) {
    display: revert;
  }

  :where([anchor].\\:popover-open) {
    inset: auto;
  }

  :where([anchor]:popover-open) {
    inset: auto;
  }

  @supports not (background-color: canvas) {
    :where([popover]) {
      background-color: white;
      color: black;
    }
  }

  @supports (width: -moz-fit-content) {
    :where([popover]) {
      width: -moz-fit-content;
      height: -moz-fit-content;
    }
  }

  @supports not (inset: 0) {
    :where([popover]) {
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
    }
  }
${i ? "}" : ""}
`;
}
var Ln = null;
function kd(i) {
  const t = WE();
  if (Ln === null)
    try {
      Ln = new CSSStyleSheet(), Ln.replaceSync(t);
    } catch {
      Ln = !1;
    }
  if (Ln === !1) {
    const e = document.createElement("style");
    e.textContent = t, i instanceof Document ? i.head.prepend(e) : i.prepend(e);
  } else
    i.adoptedStyleSheets = [Ln, ...i.adoptedStyleSheets];
}
function qE() {
  if (typeof window > "u") return;
  window.ToggleEvent = window.ToggleEvent || yc;
  function i(O) {
    return O != null && O.includes(":popover-open") && (O = O.replace(
      KE,
      "$1.\\:popover-open"
    )), O;
  }
  Mi(Document.prototype, "querySelector", i), Mi(Document.prototype, "querySelectorAll", i), Mi(Element.prototype, "querySelector", i), Mi(Element.prototype, "querySelectorAll", i), Mi(Element.prototype, "matches", i), Mi(Element.prototype, "closest", i), Mi(
    DocumentFragment.prototype,
    "querySelectorAll",
    i
  ), Object.defineProperties(HTMLElement.prototype, {
    popover: {
      enumerable: !0,
      configurable: !0,
      get() {
        if (!this.hasAttribute("popover")) return null;
        const O = (this.getAttribute("popover") || "").toLowerCase();
        return O === "" || O == "auto" ? "auto" : "manual";
      },
      set(O) {
        O === null ? this.removeAttribute("popover") : this.setAttribute("popover", O);
      }
    },
    showPopover: {
      enumerable: !0,
      configurable: !0,
      value() {
        ih(this);
      }
    },
    hidePopover: {
      enumerable: !0,
      configurable: !0,
      value() {
        ss(this, !0, !0);
      }
    },
    togglePopover: {
      enumerable: !0,
      configurable: !0,
      value(O) {
        Fs.get(this) === "showing" && O === void 0 || O === !1 ? ss(this, !0, !0) : (O === void 0 || O === !0) && ih(this);
      }
    }
  });
  const t = Element.prototype.attachShadow;
  t && Object.defineProperties(Element.prototype, {
    attachShadow: {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value(O) {
        const j = t.call(this, O);
        return kd(j), j;
      }
    }
  });
  const e = HTMLElement.prototype.attachInternals;
  e && Object.defineProperties(HTMLElement.prototype, {
    attachInternals: {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value() {
        const O = e.call(this);
        return O.shadowRoot && kd(O.shadowRoot), O;
      }
    }
  });
  const a = /* @__PURE__ */ new WeakMap();
  function o(O) {
    Object.defineProperties(O.prototype, {
      popoverTargetElement: {
        enumerable: !0,
        configurable: !0,
        set(j) {
          if (j === null)
            this.removeAttribute("popovertarget"), a.delete(this);
          else if (j instanceof Element)
            this.setAttribute("popovertarget", ""), a.set(this, j);
          else
            throw new TypeError(
              "popoverTargetElement must be an element or null"
            );
        },
        get() {
          if (this.localName !== "button" && this.localName !== "input" || this.localName === "input" && this.type !== "reset" && this.type !== "image" && this.type !== "button" || this.disabled || this.form && this.type === "submit")
            return null;
          const j = a.get(this);
          if (j && j.isConnected)
            return j;
          if (j && !j.isConnected)
            return a.delete(this), null;
          const D = tr(this), F = this.getAttribute("popovertarget");
          return (D instanceof Document || D instanceof Eu) && F && D.getElementById(F) || null;
        }
      },
      popoverTargetAction: {
        enumerable: !0,
        configurable: !0,
        get() {
          const j = (this.getAttribute("popovertargetaction") || "").toLowerCase();
          return j === "show" || j === "hide" ? j : "toggle";
        },
        set(j) {
          this.setAttribute("popovertargetaction", j);
        }
      }
    });
  }
  o(HTMLButtonElement), o(HTMLInputElement);
  const n = (O) => {
    const j = O.composedPath(), D = j[0];
    if (!(D instanceof Element) || D != null && D.shadowRoot)
      return;
    const F = tr(D);
    if (!(F instanceof Eu || F instanceof Document))
      return;
    const B = j.find(
      (N) => {
        var f;
        return (f = N.matches) == null ? void 0 : f.call(N, "[popovertargetaction],[popovertarget]");
      }
    );
    if (B) {
      RE(B), O.preventDefault();
      return;
    }
  }, r = (O) => {
    const j = O.key, D = O.target;
    !O.defaultPrevented && D && (j === "Escape" || j === "Esc") && xc(D.ownerDocument, !0, !0);
  };
  ((O) => {
    O.addEventListener("click", n), O.addEventListener("keydown", r), O.addEventListener("pointerdown", Su), O.addEventListener("pointerup", Su);
  })(document), kd(document);
}
const VE = ve`:host{background-color:var(--beacon-system-color-background-1);border:0;border-radius:var(--beacon-system-radius-corner-standard);color:var(--beacon-system-color-text-standard);display:revert;inset:unset;margin:unset;overflow:unset;padding:var(--beacon-system-space-cell-contained);position:absolute}.arrow{position:absolute}`;
var YE = Object.defineProperty, QE = Object.getOwnPropertyDescriptor, Df = (i) => {
  throw TypeError(i);
}, ho = (i, t, e, a) => {
  for (var o = a > 1 ? void 0 : a ? QE(t, e) : t, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = (a ? r(t, e, o) : r(o)) || o);
  return a && o && YE(t, e, o), o;
}, If = (i, t, e) => t.has(i) || Df("Cannot " + e), Cd = (i, t, e) => (If(i, t, "read from private field"), e ? e.call(i) : t.get(i)), Tu = (i, t, e) => t.has(i) ? Df("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(i) : t.set(i, e), Sd = (i, t, e, a) => (If(i, t, "write to private field"), t.set(i, e), e);
function Bf(i) {
  var t, e;
  let a = class extends i {
    constructor() {
      super(...arguments), Tu(this, t), this.popover = "manual", this.placement = "top", this.fallbackPlacements = void 0, this.arrowPadding = void 0, this.popupTimeout = null, Tu(this, e, !1), this.show = (o) => {
        this.showCallback(o);
      }, this.showCallback = (o) => {
        this.open = !0, this.handleInteractionEvent(o), this.start();
      }, this.hide = (o) => {
        this.hideCallback(o);
      }, this.hideCallback = (o) => {
        this.open = !1, this.handleInteractionEvent(o), this.stop();
      }, this.toggle = (o) => {
        this.popupTimeout && (clearTimeout(this.popupTimeout), this.popupTimeout = null), this.open ? this.hide(o) : this.show(o), this.handleInteractionEvent(o);
      }, this.closeOnEscape = (o) => {
        o.key === "Escape" && this.open && this.hide(o);
      };
    }
    static get popupStyles() {
      return [VE];
    }
    get open() {
      return Cd(this, e);
    }
    set open(o) {
      Sd(this, e, o), this.open ? this.showPopover() : this.hidePopover();
    }
    // The use of the event for setting the active trigger is why popups differ from modal in that you need to call show, hide, or toggle directly over the open prop
    handleInteractionEvent(o) {
      if (o) {
        const { target: n } = o;
        n instanceof HTMLElement && (this._activeTrigger = n);
      }
    }
    start() {
      this._activeTrigger && (Sd(this, t, LE(
        this._activeTrigger,
        this,
        () => this.position()
      )), this.runOnStart());
    }
    stop() {
      Cd(this, t) && (Cd(this, t).call(this), Sd(this, t, null)), this.runOnStop();
    }
    /** @abstract */
    runOnStart() {
    }
    /** @abstract */
    runOnStop() {
    }
    getOffset(o) {
      return o.offsetHeight / 2;
    }
    getStaticSideArrowOffset(o, n) {
      return `-${o.offsetWidth}px`;
    }
    /**
     * @link https://codesandbox.io/s/mystifying-kare-ee3hmh?file=/src/index.js - examples of arrow positioning
     */
    position() {
      const o = this.arrow;
      IE(this._activeTrigger, this, {
        placement: this.placement,
        middleware: [
          OE(this.getOffset(o)),
          // fallback to the starting position of each axis first when flipping
          zE({
            fallbackAxisSideDirection: "start",
            fallbackPlacements: this.fallbackPlacements
          }),
          // specifying a padding will allow it to move with your screen the specified distance before it flips
          PE({ padding: 8 }),
          // Optional Arrow Padding override for the menu-popover to align with internal padding;
          DE({
            element: o,
            padding: this.arrowPadding ? parseInt(this.arrowPadding) : void 0
          })
        ]
      }).then(
        ({ x: n, y: r, middlewareData: T, placement: O }) => {
          Object.assign(this.style, {
            top: r + "px",
            left: n + "px"
          });
          const j = O.split("-")[0], D = {
            top: "bottom",
            right: "left",
            bottom: "top",
            left: "right"
          }[j];
          if (T.arrow) {
            const { x: F, y: B } = T.arrow;
            Object.assign(o.style, {
              left: F != null ? `${F}px` : "",
              top: B != null ? `${B}px` : "",
              [D]: this.getStaticSideArrowOffset(o, D)
            }), o == null || o.setAttribute("data-side", j);
          }
        }
      );
    }
    _renderArrowHTML() {
      return pe`<div class="arrow"></div>`;
    }
    /** We need an ID to associate the popup as the describing element for triggers that aren't Beacon buttons. */
    assignAutoID() {
      this.id || (this.id = Ia());
    }
    applyPopoverPolyfill() {
      HE() || qE();
    }
    handleEscapeToHide() {
      window.addEventListener("keydown", this.closeOnEscape);
    }
    removeEscapeToHide() {
      window.removeEventListener("keydown", this.closeOnEscape);
    }
  };
  return t = /* @__PURE__ */ new WeakMap(), e = /* @__PURE__ */ new WeakMap(), ho([
    ue({ reflect: !0 })
  ], a.prototype, "popover", 2), ho([
    ue()
  ], a.prototype, "placement", 2), ho([
    Se()
  ], a.prototype, "fallbackPlacements", 2), ho([
    Se()
  ], a.prototype, "arrowPadding", 2), ho([
    ue({ type: Boolean, reflect: !0 })
  ], a.prototype, "open", 1), ho([
    Se()
  ], a.prototype, "_activeTrigger", 2), ho([
    Ge(".arrow")
  ], a.prototype, "arrow", 2), ho([
    qe
  ], a.prototype, "assignAutoID", 1), ho([
    qe
  ], a.prototype, "applyPopoverPolyfill", 1), ho([
    De
  ], a.prototype, "handleEscapeToHide", 1), ho([
    Lt
  ], a.prototype, "removeEscapeToHide", 1), a = ho([
    je("Popup")
  ], a), a;
}
function XE(i, t = "keys") {
  if (!i) return;
  let e;
  switch (t) {
    case "entries":
      e = i.entries().next().value;
      break;
    case "values":
      e = i.values().next().value;
      break;
    case "keys":
    default:
      e = i.keys().next().value;
  }
  return e;
}
const ZE = ve`[beacon-tag-name=beacon-popover] :is(h1,h2,h3,h4,h5,h6,p,ul,ol,blockquote){max-inline-size:85cqi}[beacon-tag-name=beacon-popover] :is(h1,h2,h3,h4,h5,h6){font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-body-200);margin:0}[beacon-tag-name=beacon-popover]>:is(*):not([beacon-tag-name=beacon-menu]){font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100);margin:0;padding:var(--beacon-system-space-cell-contained)}[beacon-tag-name=beacon-popover] :is([slot=action-zone]){padding:0}[beacon-tag-name=beacon-popover]:not(:has([slot=action-zone])){--bottom-padding: var(--beacon-system-space-micro-jumbo)}[beacon-tag-name=beacon-popover] .media{inline-size:100%;max-block-size:20cqb;object-fit:cover;padding:var(--beacon-system-space-cell-contained)}`, JE = ve`@media (prefers-reduced-motion: no-preference){:host([motion-state=enabled]){transition-duration:var(--beacon-reference-motion-duration-3);transition-property:opacity;transition-timing-function:var(--popover-transition-timing-function, var(--beacon-system-motion-easing-decelerate-standard-1))}:host([motion-state=enabled]:not([open])){opacity:0}:host([motion-state=enabled][open]){opacity:1}:host([motion-state=enabled][open][closing]){--popover-transition-timing-function: var(--beacon-system-motion-easing-accelerate-emphasize-1);opacity:0}}`;
var e2 = Object.getOwnPropertyDescriptor, t2 = (i, t, e, a) => {
  for (var o = a > 1 ? void 0 : a ? e2(t, e) : t, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = r(o) || o);
  return o;
};
function o2(i) {
  let t = class extends i {
    static get PopoverMotionStyles() {
      return [JE];
    }
  };
  return t = t2([
    je("PopoverMotion")
  ], t), t;
}
const a2 = ve`:host{container-type:inline-size;inline-size:100%;max-inline-size:var(--popover-max-inline-size, 17rem);min-inline-size:var(--popover-min-inline-size, 14rem);padding:initial;filter:drop-shadow(0rem 0rem var(--beacon-reference-space-1) var(--beacon-reference-palette-grayscale-shadow-1));--bottom-padding: 0}.popover{display:grid;grid-template-rows:1fr auto;max-block-size:400px}.header{inset-block-start:var(--beacon-reference-space-3);inset-inline-end:var(--beacon-reference-space-3);position:absolute}.body{overflow-y:auto;padding-inline:var(--beacon-system-space-micro-jumbo);padding-block-start:var(--beacon-system-space-micro-jumbo);padding-block-end:var(--bottom-padding);scrollbar-color:var(--beacon-component-scrollbar-color-background-thumb) var(--beacon-component-scrollbar-color-background-track);scrollbar-gutter:stable;scrollbar-width:thin}.footer{padding-block-end:var(--beacon-system-space-micro-jumbo);margin-block-start:var(--beacon-system-space-organism-normal);padding-inline:var(--beacon-system-space-micro-jumbo)}.action-zone{display:flex;gap:var(--beacon-system-space-micro-jumbo);justify-content:end;padding:var(--beacon-system-space-cell-contained)}.arrow{background-color:initial;display:flex;block-size:var(--beacon-reference-space-4);inline-size:var(--beacon-reference-space-8);--arrow-inline-size: var(--beacon-reference-space-8);--arrow-block-size: var(--beacon-reference-space-4);--mask-block-size: 8px;--drop-shadow-filter-radius: var(--beacon-reference-space-1);--mask-inline-size: calc(var(--arrow-inline-size) + calc(4 * var(--drop-shadow-filter-radius)))}.arrow[data-side=left]{transform:rotate(90deg)}.arrow[data-side=right]{transform:rotate(-90deg)}.arrow[data-side=top]{transform:rotate(180deg)}.arrow .arrow-vector{background-color:initial;position:absolute;block-size:var(--arrow-block-size);fill:var(--beacon-system-color-background-1);inline-size:var(--arrow-inline-size);bottom:-1px}@media (width >= 640px){:host{--popover-max-inline-size: 17.5rem;--popover-min-inline-size: 11.38rem}}@media (width >= 960px){:host{--popover-max-inline-size: 21.19rem;--popover-min-inline-size: 12.12rem}}@media (width >= 1280px){:host{--popover-max-inline-size: 29.56rem;--popover-min-inline-size: 17.06rem}}`;
var i2 = Object.defineProperty, n2 = Object.getOwnPropertyDescriptor, Na = (i, t, e, a) => {
  for (var o = a > 1 ? void 0 : a ? n2(t, e) : t, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = (a ? r(t, e, o) : r(o)) || o);
  return a && o && i2(t, e, o), o;
};
class r2 extends Ke(Le).with(
  GS,
  $S,
  $h
) {
}
const Hl = class Hl extends Ke(r2).with(
  o2,
  vf,
  Bf,
  Hh
) {
  constructor() {
    super(...arguments), this.beaconTagName = bl.beaconTagName, this.hasCloseButton = !0, this.handleKeydown = (t) => {
      t.isTrusted && this.slottedMenu && this.handleArrowControlKeydown(
        t,
        this.getArrowControlElements(),
        "vertical",
        (e) => {
          e == null || e.focus();
        }
      );
    }, this.show = (t) => {
      this.attachPopoverPageListener(), !this.prefersReducedMotion && this.motionState === ns.ENABLED ? (this.closing = !1, this.showCallback(t)) : this.showCallback(t);
    }, this.handleCloseOnClickOut = (t) => {
      var a, o;
      const { isTrusted: e } = t;
      this.triggerElement && e && !((a = t == null ? void 0 : t.composedPath()) != null && a.includes(this)) && !((o = t == null ? void 0 : t.composedPath()) != null && o.includes(this.triggerElement)) && this.open && this.hide();
    }, this.hide = (t) => {
      !this.prefersReducedMotion && this.motionState === ns.ENABLED ? this.closing = !0 : this.hideCallback(t);
    }, this.onFocusOut = (t) => {
      var a;
      const { relatedTarget: e } = t;
      this.open && !this.contains(e) && !((a = this.shadowRoot) != null && a.contains(e)) && (this.popupTimeout = setTimeout(() => {
        this.hide();
      }, 200));
    }, this.closeOnEscape = (t) => {
      var e;
      t.key === "Escape" && this.open && (this.hide(t), (e = this.triggerElement) == null || e.focus({
        override: !0
      }));
    }, this.onCloseButtonKeyPress = (t) => {
      var e;
      (t.key === "Enter" || t.code === "Space") && !this.closing && ((e = this.triggerElement) == null || e.focus({
        override: !0
      }));
    };
  }
  static get styles() {
    return [super.styles, this.popupStyles, this.PopoverMotionStyles, a2];
  }
  static get lightDOMStyles() {
    return [super.lightDOMStyles, ZE];
  }
  getArrowControlElements() {
    return [this.closeButton, ...this.internalFocusableElements()];
  }
  attachArrowControlKeyboardListeners() {
    this.slottedMenu && this.getArrowControlElements().forEach((t) => {
      t.addEventListener(Je.KEYDOWN, this.handleKeydown);
    });
  }
  runOpensBySetup() {
    this.opensByElements.forEach((t, e) => {
      e instanceof Fi && e.addEventListener("beacon-event-click", this.toggle), e instanceof Fi || e.addEventListener("click", this.toggle);
    });
  }
  runOpensByClean() {
    this.opensByElements.forEach((t, e) => {
      (e instanceof HTMLButtonElement || e instanceof HTMLInputElement) && e.removeEventListener("click", this.toggle), e instanceof Fi && e.removeEventListener("beacon-event-click", this.toggle);
    });
  }
  _renderArrowHTML() {
    return pe`<div class="arrow">
      <svg
        aria-hidden="true"
        width="24"
        height="12"
        viewBox="0 0 24 12"
        xmlns="http://www.w3.org/2000/svg"
        class="arrow-vector">
        <path d="M24 12L12 0L0 12H24Z" />
      </svg>
    </div>`;
  }
  getOffset(t) {
    return t.offsetHeight;
  }
  getStaticSideArrowOffset(t, e) {
    return `-${e === "bottom" || e === "top" ? t.offsetHeight : t.offsetHeight + 8}px`;
  }
  setAriaExpanded() {
    var t;
    this._activeTrigger instanceof Fi ? this._activeTrigger.updateComplete.then(() => {
      var e;
      (e = this._activeTrigger.button) == null || e.setAttribute(
        "aria-expanded",
        String(this.open)
      );
    }) : (t = this._activeTrigger) == null || t.setAttribute("aria-expanded", String(this.open));
  }
  focusOnTrigger() {
    var t;
    (t = this._activeTrigger) == null || t.focus({ override: !0 });
  }
  focusOnCloseButton() {
    setTimeout(() => {
      var t;
      (t = this.closeButton) == null || t.focus({ override: !0 });
    }, 0);
  }
  initializeExternalFocusableElements() {
    this.triggerElement = this._activeTrigger;
  }
  initializeInternalFocusableElements() {
    var e, a;
    const t = this.internalFocusableElements();
    this.lastFocusableElement = (e = t[t.length - 1]) != null ? e : this.closeButton, this.firstFocusableElement = (a = this.closeButton) != null ? a : t[0];
  }
  runOnStart() {
    this.setAriaExpanded(), this.initializeInternalFocusableElements(), this.initializeExternalFocusableElements(), this.attachFocusableElementListeners(), this.overrideFocusableElements(), this.focusOnCloseButton(), this.findNextFocusableElement();
  }
  getShadowRootHost(t) {
    const e = t.getRootNode();
    return e instanceof ShadowRoot ? e.host : null;
  }
  isInShadowDOM(t) {
    return t.getRootNode() instanceof ShadowRoot;
  }
  /**
   * Tabbable will find all the elements from host and which can be nested through shadowDOM
   * This method is to filter out those elements and find the next focusable element
   */
  findNextFocusableElement() {
    var n;
    const a = uf(
      (n = this.getShadowRootHost(this.triggerElement)) != null ? n : document.body,
      {
        getShadowRoot: !0,
        includeContainer: !0
      }
    ).filter((r) => {
      const T = this.getShadowRootHost(r);
      let O;
      return T && (O = this.getShadowRootHost(T)), !this.contains(T) && !this.contains(r) && O !== this;
    }).map((r) => this.getShadowRootHost(r) === this.triggerElement ? this.triggerElement : r), o = a.indexOf(this.triggerElement);
    o + 1 < a.length && (this.nextFocusableElement = a[o + 1]);
  }
  runOnStop() {
    this.setAriaExpanded(), this.removeFocusableElementListeners();
  }
  setAriaHasPopup() {
    var t, e, a;
    (t = this.slottedMenu) != null && t.length ? (e = this._activeTrigger) == null || e.setAttribute("aria-haspopup", "menu") : (a = this._activeTrigger) == null || a.setAttribute("aria-haspopup", "true");
  }
  attachPopoverPageListener() {
    document.addEventListener("click", this.handleCloseOnClickOut);
  }
  removePopoverPageListener() {
    document.removeEventListener("click", this.handleCloseOnClickOut);
  }
  closingAnimationCallback() {
    this.hideCallback();
  }
  renderCloseButton() {
    return Be`
      <${this.getScopedTag("beacon-icon-button")} class="close-button" variant="tertiary" @beacon-event-click=${this.hide}
      @keypress=${this.onCloseButtonKeyPress}>
        <svg
          class="icon--close"
          slot="icon"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M18.4697 19.5303C18.7626 19.8232 19.2374 19.8232 19.5303 19.5303C19.8232 19.2374 19.8232 18.7626 19.5303 18.4697L13.0607 12L19.5303 5.53033C19.8232 5.23744 19.8232 4.76256 19.5303 4.46967C19.2374 4.17678 18.7626 4.17678 18.4697 4.46967L12 10.9393L5.53033 4.46967C5.23744 4.17678 4.76256 4.17678 4.46967 4.46967C4.17678 4.76256 4.17678 5.23744 4.46967 5.53033L10.9393 12L4.46967 18.4697C4.17678 18.7626 4.17678 19.2374 4.46967 19.5303C4.76256 19.8232 5.23744 19.8232 5.53033 19.5303L12 13.0607L18.4697 19.5303Z"
            fill="#0063AD"
          />
        </svg>
        <slot name="close-button-text">Close</slot>
      </${this.getScopedTag("beacon-icon-button")}>
    `;
  }
  overrideFocusableElements() {
    this.overrideFocus([
      this.closeButton,
      ...this.internalFocusableElements(),
      this.triggerElement
    ]);
  }
  openByDefault() {
    this._activeTrigger = XE(this.opensByElements), this.open && (this.show(), this.focusOnTrigger());
  }
  applyDatatMetricsLocation() {
    this.setAttribute(
      "data-metrics-location",
      bl.DATA_METRICS_LOCATION_POPOVER
    );
  }
  async updateCloseButtonState() {
    var t;
    await this.updateComplete, (t = this.slottedMenu) != null && t.length && (this.hasCloseButton = !1);
  }
  render() {
    return pe`
      <div class="popover" @focusout=${this.onFocusOut}>
        <div class="header">
          ${this.hasCloseButton ? this.renderCloseButton() : _e}
        </div>
        <div class="body" tabindex=${qi()}>
          <slot ${Ue({ useParent: !0 })}></slot>
        </div>
        <div class="footer">
          <div class="action-zone">
            <slot
              name="action-zone"
              ${Ue({ container: ".footer" })}></slot>
          </div>
        </div>
        ${this._renderArrowHTML()}
      </div>
    `;
  }
};
Hl.nestedComponents = [eo], Hl.tagName = bl.beaconTagName;
let vo = Hl;
Na([
  et(".close-button")
], vo.prototype, "closeButton", 2);
Na([
  Se()
], vo.prototype, "hasCloseButton", 2);
Na([
  Pe({
    slot: "",
    selector: '[beacon-tag-name="beacon-menu"]'
  })
], vo.prototype, "slottedMenu", 2);
Na([
  De
], vo.prototype, "attachArrowControlKeyboardListeners", 1);
Na([
  De
], vo.prototype, "setAriaHasPopup", 1);
Na([
  Lt
], vo.prototype, "removePopoverPageListener", 1);
Na([
  De
], vo.prototype, "openByDefault", 1);
Na([
  qe
], vo.prototype, "applyDatatMetricsLocation", 1);
Na([
  De
], vo.prototype, "updateCloseButtonState", 1);
const Mu = {
  beaconTagName: "beacon-breadcrumbs"
}, s2 = ve`[beacon-tag-name=beacon-breadcrumbs]{--background-color: var(--beacon-system-color-background-0);background-color:var(--background-color);padding-block:var(--beacon-system-space-cell-free-floating);font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-300)}[beacon-tag-name=beacon-breadcrumbs] [beacon-tag-name=beacon-popover]{inline-size:auto}[beacon-tag-name=beacon-breadcrumbs] [beacon-tag-name=beacon-menu]{padding:0}[beacon-tag-name=beacon-breadcrumbs] [beacon-tag-name=beacon-menu] ol.beacon-breadcrumbs__popover-menu [beacon-tag-name=beacon-icon]{display:none;flex-shrink:0}[beacon-tag-name=beacon-breadcrumbs] [beacon-tag-name=beacon-menu] ol.beacon-breadcrumbs__popover-menu li,[beacon-tag-name=beacon-breadcrumbs] [beacon-tag-name=beacon-menu] ol.beacon-breadcrumbs__popover-menu li>*{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-300)}@media (width >= 640px){[beacon-tag-name=beacon-breadcrumbs] ol>li:nth-child(1)>[beacon-tag-name=beacon-icon]{display:none}}[beacon-tag-name=beacon-breadcrumbs] .beacon-breadcrumbs__popover-trigger{background:none;border-style:none;display:flex;margin:0;padding:0;position:relative;white-space:nowrap}[beacon-tag-name=beacon-breadcrumbs] .beacon-breadcrumbs__popover-trigger:before{block-size:var(--beacon-reference-space-7);content:"";inline-size:var(--beacon-reference-space-7);inset-block-start:calc(-3 * var(--beacon-reference-space-1));inset-inline-start:calc(-1 * var(--beacon-reference-space-1));position:absolute}[beacon-tag-name=beacon-breadcrumbs] .beacon-breadcrumbs__popover-trigger span.ellipses-wrapper{align-items:center;align-self:center;block-size:var(--beacon-reference-space-4);display:flex;justify-content:center;padding-inline:var(--beacon-reference-space-2)}[beacon-tag-name=beacon-breadcrumbs] .beacon-breadcrumbs__popover-trigger:hover span{background-color:var(--beacon-system-color-background-secondary-hover)}[beacon-tag-name=beacon-breadcrumbs] .beacon-breadcrumbs__popover-trigger [beacon-tag-name=beacon-icon]{color:var(--beacon-system-color-icon-link)}[beacon-tag-name=beacon-breadcrumbs] .beacon-breadcrumbs__popover-trigger [beacon-tag-name=beacon-icon]::part(internal--icon){block-size:var(--beacon-reference-space-4)}[beacon-tag-name=beacon-breadcrumbs]>ol{column-gap:var(--beacon-reference-space-3)}[beacon-tag-name=beacon-breadcrumbs]>ol>li{align-items:center;display:flex;flex-shrink:0;gap:var(--beacon-reference-space-3)}[beacon-tag-name=beacon-breadcrumbs]>ol>li:last-child{overflow-x:hidden;text-overflow:ellipsis;flex-shrink:1;font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-caption-300)}[beacon-tag-name=beacon-breadcrumbs]>ol>li:last-child>a,[beacon-tag-name=beacon-breadcrumbs]>ol>li:last-child>span{overflow-x:hidden;text-overflow:ellipsis}[beacon-tag-name=beacon-breadcrumbs]>ol li>[beacon-tag-name=beacon-icon]{flex-shrink:0;stroke:var(--beacon-system-color-icon-standard)}[beacon-tag-name=beacon-breadcrumbs]>ol li>[beacon-tag-name=beacon-icon]::part(internal--icon){block-size:var(--beacon-reference-space-4)}@media (width < 640px){[beacon-tag-name=beacon-breadcrumbs]>ol>li:nth-last-child(2){overflow-x:hidden;text-overflow:ellipsis;flex-shrink:1}[beacon-tag-name=beacon-breadcrumbs]>ol>li:nth-last-child(2)>a{overflow-x:hidden;text-overflow:ellipsis}[beacon-tag-name=beacon-breadcrumbs]>ol>li:not(:nth-last-child(2)){display:none}[beacon-tag-name=beacon-breadcrumbs]>ol>li>[beacon-tag-name=beacon-icon]{transform:rotate(180deg)}}[beacon-tag-name=beacon-breadcrumbs]>ol:has(.beacon-breadcrumbs__popover-container)>li:not(:first-child,:last-child,:nth-child(2),:nth-last-child(2)){display:none}[beacon-tag-name=beacon-breadcrumbs] li:not(:last-child) a{color:var(--beacon-system-color-text-link)}[beacon-tag-name=beacon-breadcrumbs] a:not(:hover,:focus){text-decoration:none}[beacon-tag-name=beacon-breadcrumbs] [aria-current=page]{color:var(--beacon-system-color-text-standard)}@media (width >= 640px){[beacon-tag-name=beacon-breadcrumbs][use-extra-truncation-on-medium-breakpoint]>ol>.beacon-breadcrumbs__popover-container~li:nth-last-child(2){display:none}}@media (width >= 960px){[beacon-tag-name=beacon-breadcrumbs][use-extra-truncation-on-medium-breakpoint] [beacon-tag-name=beacon-menu]>ol>li:nth-last-child(1){display:none}[beacon-tag-name=beacon-breadcrumbs][use-extra-truncation-on-medium-breakpoint]>ol>.beacon-breadcrumbs__popover-container~li:nth-last-child(2){display:flex}[beacon-tag-name=beacon-breadcrumbs][use-extra-truncation-on-medium-breakpoint] li.minimal-breadcrumbs-popover{display:none}[beacon-tag-name=beacon-breadcrumbs][use-extra-truncation-on-medium-breakpoint] li.minimal-breadcrumbs-popover+li{display:flex}}`, l2 = ve`::slotted(ol){align-items:center;display:flex;gap:var(--beacon-reference-space-3);white-space:nowrap}`;
var c2 = Object.defineProperty, d2 = Object.getOwnPropertyDescriptor, Ar = (i, t, e, a) => {
  for (var o = a > 1 ? void 0 : a ? d2(t, e) : t, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = (a ? r(t, e, o) : r(o)) || o);
  return a && o && c2(t, e, o), o;
}, Go;
const mn = (Go = class extends Le {
  constructor() {
    super(...arguments), this.beaconTagName = Mu.beaconTagName, this.label = "Breadcrumb", this.useExtraTruncationOnMediumBreakpoint = !1;
  }
  static get styles() {
    return [super.styles, l2];
  }
  static get lightDOMStyles() {
    return [super.lightDOMStyles, s2];
  }
  get linkListItems() {
    return Wi(
      this,
      "_linkListItems",
      () => Array.from(this.linkList.children).filter((t) => t instanceof HTMLLIElement).filter(
        (t) => !t.classList.contains("beacon-breadcrumbs__popover-container")
      )
    );
  }
  get links() {
    return Wi(
      this,
      "_links",
      () => Array.from(this.querySelectorAll("a"))
    );
  }
  get overflowListItems() {
    return Wi(this, "_overflowListItems", () => {
      if (this.useExtraTruncationOnMediumBreakpoint) {
        if (this.linkListItems.length > Go.maxVisibleLinks - 1)
          return this.linkListItems.slice(1, this.linkListItems.length - 1);
      } else if (this.linkListItems.length > Go.maxVisibleLinks)
        return this.linkListItems.slice(1, this.linkListItems.length - 2);
      return [];
    });
  }
  /**
   * @note doesn't use icon button because the styles differ significantly enough
   */
  createPopover(t) {
    return Be`
      <button class="beacon-breadcrumbs__popover-trigger" id="menu" aria-label="Open nested links">
        <span class="ellipses-wrapper">
          <${this.getScopedTag("beacon-icon")} name='overflow_horizontal' scale='s'></${this.getScopedTag("beacon-icon")}>
        </span>
      </button>
      <${this.getScopedTag("beacon-popover")} opens-by="#menu" class="beacon-breadcrumbs__popover" placement="bottom-start" .arrowPadding=${yS(Fv)} .fallbackPlacements=${["top-start"]}>
        <${this.getScopedTag("beacon-menu")}>
          <ol class="beacon-breadcrumbs__popover-menu">
            ${Vo(t, (e) => pe`${e.cloneNode(!0)}`)}
          </ol>
        </${this.getScopedTag("beacon-menu")}>
      </${this.getScopedTag("beacon-popover")}>
    `;
  }
  insertPopover() {
    var t;
    this.overflowListItems.length > 0 && (this.linkListItems[0].insertAdjacentHTML(
      "afterend",
      `<li class="beacon-breadcrumbs__popover-container ${this.linkListItems.length === 4 ? "minimal-breadcrumbs-popover" : ""}"></li>`
    ), Es(this.createPopover(this.overflowListItems), this.popoverContainer), (t = this.querySelector("button")) == null || t.insertAdjacentHTML(
      "beforebegin",
      this.chevronIcon()
    ));
  }
  addAriaCurrent() {
    this.links.length === this.linkListItems.length && this.links[this.links.length - 1].setAttribute("aria-current", "page");
  }
  /**
   * Wraps a text node inside of the last <li> in a <span> element to ensure text truncation behavior.
   * This function must come before injectSVGSeparators or else it will break the functionality.
   */
  wrapLastNodeInSpan() {
    if (this.links.length !== this.linkListItems.length) {
      const t = this.linkListItems[this.linkListItems.length - 1];
      t.innerHTML = `<span>${t.innerHTML}</span>`;
    }
  }
  injectSVGSeparators() {
    this.linkListItems.forEach((t) => {
      t.insertAdjacentHTML("afterbegin", this.chevronIcon());
    });
  }
  chevronIcon() {
    return `<${this.getScopedTagName("beacon-icon")} name='chevron_right_small' scale='s'></${this.getScopedTagName("beacon-icon")}>`;
  }
  modifyDOMElements() {
    this.wrapLastNodeInSpan(), this.injectSVGSeparators(), this.addAriaCurrent(), this.insertPopover();
  }
  render() {
    return pe`
      <nav class="base" aria-label="${this.label}">
        <slot @slotchange=${Is()}></slot>
      </nav>
    `;
  }
}, Go.nestedComponents = [vo, is, fo], Go.tagName = Mu.beaconTagName, Go.maxVisibleLinks = 4, Go);
Ar([
  ue()
], mn.prototype, "label", 2);
Ar([
  bn(".beacon-breadcrumbs__popover")
], mn.prototype, "beaconPopover", 2);
Ar([
  bn(".beacon-breadcrumbs__popover-container")
], mn.prototype, "popoverContainer", 2);
Ar([
  bn("ol")
], mn.prototype, "linkList", 2);
Ar([
  ue({
    type: Boolean,
    reflect: !0,
    attribute: "use-extra-truncation-on-medium-breakpoint"
  })
], mn.prototype, "useExtraTruncationOnMediumBreakpoint", 2);
Ar([
  De
], mn.prototype, "modifyDOMElements", 1);
let V3 = mn;
const Ed = {
  beaconTagName: "beacon-byline",
  zeroAuthorText: "T.Rowe Price"
}, h2 = ve`[beacon-tag-name=beacon-byline] :is([slot=author]){font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-300);color:var(--beacon-system-color-text-standard)}[beacon-tag-name=beacon-byline] :is([slot=author]) a{color:var(--beacon-system-color-text-link);font-weight:var(--beacon-system-font-weight-bold)}[beacon-tag-name=beacon-byline] :is([slot=author]) a:not(:is(:hover,:focus)){text-decoration:none}[beacon-tag-name=beacon-byline] [slot=attribution-text]{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-300);display:block;white-space:nowrap}`, b2 = ve`:host{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-300);display:flex;margin:var(--hero-override-byline-margin, 0);margin-block:var(--beacon-system-space-cell-free-floating);padding-block-start:var(--hero-override-byline-padding-block-start, 0)}::slotted([slot=attribution-text]){font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-300);display:block;white-space:nowrap}p{margin:0}.beacon-attribution-tag{display:block;margin-inline-end:var(--beacon-reference-space-2);white-space:nowrap}.beacon-author-list{display:block;list-style:none;margin:0;padding-inline-start:0}.beacon-author-list li{display:inline;font-weight:var(--beacon-system-font-weight-bold)}.beacon-author-list li:not(:last-of-type):after{content:", "}`;
var p2 = Object.defineProperty, Rf = (i, t, e, a) => {
  for (var o = void 0, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = r(t, e, o) || o);
  return o && p2(t, e, o), o;
};
const fb = class fb extends Le {
  constructor() {
    super(...arguments), this.beaconTagName = Ed.beaconTagName;
  }
  static get styles() {
    return [super.styles, b2];
  }
  static get lightDOMStyles() {
    return [super.lightDOMStyles, h2];
  }
  /** slotChange handler  */
  attributionTextSlotChange() {
    this.requestUpdate("slottedAttributionText");
  }
  /** slotChange handler  */
  authorSlotChange() {
    this.requestUpdate("slottedAuthor");
  }
  render() {
    return pe` <slot
        @slotchange=${this.attributionTextSlotChange}
        name="attribution-text">
        By&nbsp
      </slot>
      <slot @slotchange=${this.authorSlotChange} name="author">
        <p>${Ed.zeroAuthorText}</p>
      </slot>`;
  }
};
fb.tagName = Ed.beaconTagName;
let Il = fb;
Rf([
  Pe({ slot: "attribution-text", flatten: !0 })
], Il.prototype, "slottedAttributionText");
Rf([
  Pe({ slot: "author", flatten: !0 })
], Il.prototype, "slottedAuthor");
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const { I: u2 } = rA, Lu = (i, t) => (i == null ? void 0 : i._$litType$) !== void 0, g2 = (i) => {
  var t;
  return ((t = i == null ? void 0 : i._$litType$) == null ? void 0 : t.h) != null;
}, Ou = () => document.createComment(""), Bi = (i, t, e) => {
  var n;
  const a = i._$AA.parentNode, o = t === void 0 ? i._$AB : t._$AA;
  if (e === void 0) {
    const r = a.insertBefore(Ou(), o), T = a.insertBefore(Ou(), o);
    e = new u2(r, T, i, i.options);
  } else {
    const r = e._$AB.nextSibling, T = e._$AM, O = T !== i;
    if (O) {
      let j;
      (n = e._$AQ) == null || n.call(e, i), e._$AM = i, e._$AP !== void 0 && (j = i._$AU) !== T._$AU && e._$AP(j);
    }
    if (r !== o || O) {
      let j = e._$AA;
      for (; j !== r; ) {
        const D = j.nextSibling;
        a.insertBefore(j, o), j = D;
      }
    }
  }
  return e;
}, Li = (i, t, e = i) => (i._$AI(t, e), i), m2 = {}, nh = (i, t = m2) => i._$AH = t, rh = (i) => i._$AH, Td = (i) => {
  var a;
  (a = i._$AP) == null || a.call(i, !1, !0);
  let t = i._$AA;
  const e = i._$AB.nextSibling;
  for (; t !== e; ) {
    const o = t.nextSibling;
    t.remove(), t = o;
  }
}, f2 = (i) => {
  i._$AR();
};
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const Pu = (i, t, e) => {
  const a = /* @__PURE__ */ new Map();
  for (let o = t; o <= e; o++) a.set(i[o], o);
  return a;
}, Nf = Oa(class extends Pa {
  constructor(i) {
    if (super(i), i.type !== ln.CHILD) throw Error("repeat() can only be used in text expressions");
  }
  dt(i, t, e) {
    let a;
    e === void 0 ? e = t : t !== void 0 && (a = t);
    const o = [], n = [];
    let r = 0;
    for (const T of i) o[r] = a ? a(T, r) : r, n[r] = e(T, r), r++;
    return { values: n, keys: o };
  }
  render(i, t, e) {
    return this.dt(i, t, e).values;
  }
  update(i, [t, e, a]) {
    var w;
    const o = rh(i), { values: n, keys: r } = this.dt(t, e, a);
    if (!Array.isArray(o)) return this.ut = r, n;
    const T = (w = this.ut) != null ? w : this.ut = [], O = [];
    let j, D, F = 0, B = o.length - 1, N = 0, f = n.length - 1;
    for (; F <= B && N <= f; ) if (o[F] === null) F++;
    else if (o[B] === null) B--;
    else if (T[F] === r[N]) O[N] = Li(o[F], n[N]), F++, N++;
    else if (T[B] === r[f]) O[f] = Li(o[B], n[f]), B--, f--;
    else if (T[F] === r[f]) O[f] = Li(o[F], n[f]), Bi(i, O[f + 1], o[F]), F++, f--;
    else if (T[B] === r[N]) O[N] = Li(o[B], n[N]), Bi(i, o[F], o[B]), B--, N++;
    else if (j === void 0 && (j = Pu(r, N, f), D = Pu(T, F, B)), j.has(T[F])) if (j.has(T[B])) {
      const x = D.get(r[N]), M = x !== void 0 ? o[x] : null;
      if (M === null) {
        const p = Bi(i, o[F]);
        Li(p, n[N]), O[N] = p;
      } else O[N] = Li(M, n[N]), Bi(i, o[F], M), o[x] = null;
      N++;
    } else Td(o[B]), B--;
    else Td(o[F]), F++;
    for (; N <= f; ) {
      const x = Bi(i, O[f + 1]);
      Li(x, n[N]), O[N++] = x;
    }
    for (; F <= B; ) {
      const x = o[F++];
      x !== null && Td(x);
    }
    return this.ut = r, nh(i, O), Qo;
  }
}), Rt = {
  BEACON_TAG_NAME: "beacon-carousel",
  DEFAULT_ACCESSIBLE_LABEL: "carousel",
  BEACON_ICON_BUTTON: "beacon-icon-button",
  CSS_VAR_STARTING_MASK: "--starting-mask-value",
  CSS_VAR_ENDING_MASK: "--ending-mask-value",
  CSS_ZERO_PERCENTAGE: "0%",
  CSS_MASK_VALUE: "calc(var(--grid-column-size-inline) + var(--beacon-system-space-gutter))",
  DATA_METRICS_LOCATION_CAROUSEL: "CAR"
}, v2 = ve`[beacon-tag-name=beacon-carousel]{--carousel-container-scroll-padding-inline: var(--organism-inline-padding)}[beacon-tag-name=beacon-carousel] [beacon-tag-name*=tile],[beacon-tag-name=beacon-carousel] .carousel-wrapper a{inline-size:var(--tile-inline-size)}[beacon-tag-name=beacon-carousel] .beacon-scroll-snap-item{scroll-snap-align:start}[beacon-tag-name=beacon-carousel] [slot=carousel-title]{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-200);color:var(--beacon-system-color-text-standard);margin:0}`, A2 = ve`.visually-hidden{border:0;clip:rect(0,0,0,0);block-size:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;inline-size:1px}:host{--modern-outlook-organism-padding: var(--beacon-system-space-organism-maxi);--modern-outlook-indicator-nav-gap: var(--beacon-reference-space-3);--modern-outlook-dot-size: var(--beacon-reference-space-3);--organism-inline-padding: var(--modern-outlook-organism-padding);--organism-block-padding: var(--beacon-system-space-organism-jumbo);--carousel-wrapper-space-gap: var(--beacon-system-space-gutter);--override-icon-button-outline-offset: var(--beacon-reference-space-2);--tile-inline-size: calc(100dvw - (2 * var(--organism-inline-padding)));background-color:var(--beacon-system-color-background-0)}:host .visually-hidden .visually-hidden{border:0;clip:rect(0,0,0,0);block-size:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;inline-size:1px}.header{align-items:end;display:flex;gap:var(--beacon-reference-space-3);justify-content:space-between;margin-inline:auto;padding-block:var(--beacon-system-space-cell-free-floating);padding-inline:var(--organism-inline-padding)}.title-area{align-items:center;display:flex;flex-wrap:wrap}.component-shell{margin:auto;max-inline-size:var(--beacon-system-breakpoint-xxx-large);padding-block:var(--organism-block-padding)}.component-shell.small .footer{align-items:center;display:flex;gap:var(--beacon-reference-space-3);justify-content:space-between;padding-inline:var(--organism-inline-padding)}.component-shell.small .carousel-indicator{margin:0}.description-area{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100);margin-block-start:var(--beacon-reference-space-4)}.description-area ::slotted(*){margin:0;padding:0}.action-zone{margin-block-start:var(--beacon-reference-space-4)}.item-count{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-headline-50)}.title-text{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-200);color:var(--beacon-system-color-text-standard);margin:0;padding-inline-end:var(--beacon-reference-space-3)}.incremental-nav{align-items:center;display:flex;gap:var(--beacon-reference-space-3)}.carousel-container{--mask-gradient: linear-gradient(90deg, rgb(0 0 0 / 0%) 0%, rgb(0 0 0 / 100%) calc(0% + (var(--organism-inline-padding) / 2)), rgb(0 0 0 / 100%) calc(100% - (var(--organism-inline-padding) / 2)), rgb(0 0 0 / 0%) 100%);-webkit-mask-image:var(--mask-gradient);mask-image:var(--mask-gradient);overflow:auto;-ms-overflow-style:none;scroll-behavior:smooth;scroll-padding-inline:var(--carousel-container-scroll-padding-inline, initial);scroll-snap-type:x mandatory;scrollbar-width:none}.carousel-container::-webkit-scrollbar{display:none}.carousel-wrapper{display:flex;gap:var(--carousel-wrapper-space-gap);inline-size:fit-content;padding-block:var(--beacon-system-space-micro-jumbo) var(--beacon-system-space-micro-maxi);padding-inline:var(--organism-inline-padding)}.carousel-indicator{display:flex;gap:var(--modern-outlook-indicator-nav-gap);justify-content:center;margin-inline:auto;padding-block:var(--beacon-system-space-cell-free-floating)}.carousel-indicator-dot{background:none;block-size:var(--modern-outlook-dot-size);border:var(--beacon-system-width-border-mini) solid var(--beacon-system-color-icon-secondary);border-radius:var(--beacon-system-radius-corner-circle);cursor:pointer;inline-size:var(--modern-outlook-dot-size);outline-offset:var(--beacon-reference-space-2);padding:0}.carousel-indicator-dot[aria-current=true]{background:var(--beacon-system-color-icon-secondary)}.carousel-indicator-dot:hover:not([aria-current=true]){background-clip:padding-box;background-color:var(--beacon-system-color-icon-secondary);border:3px double var(--beacon-system-color-icon-secondary)}@media (width >= 640px){:host{--tile-inline-size: calc(50dvw - (var(--organism-inline-padding) + (.5 * var(--carousel-wrapper-space-gap))))}}@media (width >= 960px){:host{--modern-outlook-dot-size: var(--beacon-reference-space-4);--modern-outlook-indicator-nav-gap: var(--beacon-reference-space-4)}}@media (width >= 1280px){:host{--tile-inline-size: calc((100dvw - (2 * (var(--organism-inline-padding) + var(--carousel-wrapper-space-gap)))) / 3)}}@media (width >= 1920px){:host{--modern-outlook-organism-padding: 10rem;--tile-inline-size: calc((var(--beacon-system-breakpoint-xxx-large) - (2 * (var(--organism-inline-padding) + var(--carousel-wrapper-space-gap)))) / 3)}}`;
var y2 = Object.defineProperty, x2 = Object.getOwnPropertyDescriptor, Bt = (i, t, e, a) => {
  for (var o = a > 1 ? void 0 : a ? x2(t, e) : t, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = (a ? r(t, e, o) : r(o)) || o);
  return a && o && y2(t, e, o), o;
}, Wo;
const Pt = (Wo = class extends Ke(Le).with(Ra) {
  constructor() {
    super(...arguments), this.beaconTagName = Rt.BEACON_TAG_NAME, this.deferrable = !1, this.carouselPageMap = /* @__PURE__ */ new Map(), this.currentNavigatorIndex = 0, this.carouselTitle = "", this.accessibleLabel = Rt.DEFAULT_ACCESSIBLE_LABEL, this.dataMetricsLocation = Rt.DATA_METRICS_LOCATION_CAROUSEL, this.hideItemCount = !1, this.itemCount = 0, this.scrolling = !1, this.navButtonScrolling = !1, this.applyScrollBehavior = () => {
      this.toggleCarouselAlphaMasking(), this.navButtonScrolling || this.handleLiteralScrolling(), this.scrolling = !1;
    }, this.updateCarouselMap = () => {
      const t = this.createCarouselMap();
      (t == null ? void 0 : t.size) !== this.carouselPageMap.size && (this.carouselPageMap.clear(), this.carouselPageMap = new Map(t), this.currentNavigatorIndex = 0, this.removeCurrentlySelected(), this.addAriaCurrentRole(0), this.carouselContainer.scroll({ left: 0 }), this.requestUpdate());
    }, this.carouselResizeObserver = new ResizeObserver(
      this.updateCarouselMap
    ), this.carouselIntersectionObserver = new IntersectionObserver(
      (t) => {
        for (const e of t) {
          const a = e.target;
          e.intersectionRatio < 1 ? Wo.toggleCarouselItemAccessibility(a, !0) : Wo.toggleCarouselItemAccessibility(a, !1);
        }
      },
      { threshold: [0, 1], root: this }
    );
  }
  static get styles() {
    return [super.styles, A2];
  }
  static get lightDOMStyles() {
    return [...super.lightDOMStyles, v2];
  }
  clearSnapClasses() {
    this.scrollSnapCarouselItems && this.scrollSnapCarouselItems.forEach((t) => {
      t.classList.remove("beacon-scroll-snap-item");
    });
  }
  static applySnapClass(t) {
    t.classList.add("beacon-scroll-snap-item");
  }
  /** Update itemCount and HTML on addition or removal of carousel objects. */
  handleCarouselSlotChange() {
    this.itemCount = this.slottedCarouselItems.length;
  }
  /**
   * Keeps the percentage values of the masking gradient to be aligned with the inline padding of the target ~ `carousel-container`.
   * Toggles the masking when scroll bar is at the start or end.
   */
  toggleCarouselAlphaMasking() {
    this.carouselContainer && (this.carouselContainer.scrollLeft !== 0 ? this.style.setProperty(
      Rt.CSS_VAR_STARTING_MASK,
      Rt.CSS_MASK_VALUE
    ) : this.style.setProperty(
      Rt.CSS_VAR_STARTING_MASK,
      Rt.CSS_ZERO_PERCENTAGE
    ), this.carouselContainer.scrollLeft + this.carouselContainer.clientWidth >= this.carouselContainer.scrollWidth ? this.style.setProperty(
      Rt.CSS_VAR_ENDING_MASK,
      Rt.CSS_ZERO_PERCENTAGE
    ) : this.style.setProperty(
      Rt.CSS_VAR_ENDING_MASK,
      Rt.CSS_MASK_VALUE
    ));
  }
  /**
   * When scrolling is not triggered by a nav button, perform the scroll logic below.
   * This logic is for when the user literally scrolls.
   * It checks where the scrollbar is (scrollLeft property) and creates
   * a currentScrolledRatio that is a percent of the total possible scrollable area.
   * This currentScrolledRatio is compared against the scrollZoneUpperLimit of a given
   * page of tiles to determine whether or not to update the currentNavigatorIndex.
   */
  handleLiteralScrolling() {
    var n, r, T;
    const t = ((n = this.carouselContainer) == null ? void 0 : n.scrollLeft) || 0, e = (((r = this.carouselContainer) == null ? void 0 : r.scrollWidth) || 0) - (((T = this.carouselContainer) == null ? void 0 : T.clientWidth) || 0), a = t / e;
    let o = this.currentNavigatorIndex;
    for (let O = 0; O < this.carouselPageMap.size; O += 1) {
      const j = this.carouselPageMap.get(O);
      if (j != null && j.startTile && j.scrollZoneUpperLimit && a <= j.scrollZoneUpperLimit) {
        o = O;
        break;
      }
    }
    this.currentNavigatorIndex = o, this.updateSelectedNavButton();
  }
  /**
   /* Scroll event listener applied to the carouselContainer.
   * It toggles alpha masking of peripheral carousel content,
   * updates scroll to appropriate page and updates selected nav buttons
   * when user scrolls literally.
   */
  handleCarouselScroll() {
    this.scrolling || (window.requestAnimationFrame(this.applyScrollBehavior), this.scrolling = !0);
  }
  /**
   * Click event handler to update scroll to appropriate page and update selected nav button
   * @param {number} index: index of carouselItem
   */
  carouselIndicatorClickHandler(t) {
    this.currentNavigatorIndex = t || 0, this.scrollToNavIndex(), this.updateSelectedNavButton();
  }
  /**
   * Sets an indicator nav dot element's `aria-current` label attribute to `true`
   *
   * @param {number} buttonIndex: index of the button to set
   */
  addAriaCurrentRole(t) {
    var e, a;
    (a = (e = this.carouselNavigator) == null ? void 0 : e.children[t]) == null || a.setAttribute(
      "aria-current",
      "true"
    );
  }
  /**
   * Click handler for increment navigation button.
   * Increases `currentNavigatorIndex` to the next page if available
   */
  incrementNavIndex() {
    this.currentNavigatorIndex >= this.carouselPageMap.size - 1 || (this.currentNavigatorIndex += 1, this.updateSelectedNavButton(), this.scrollToNavIndex());
  }
  /**
   * Click handler for decrement navigation button.
   * Decreases `currentNavigatorIndex` to the previous page if available
   */
  decrementNavIndex() {
    this.currentNavigatorIndex <= 0 || (this.currentNavigatorIndex -= 1, this.updateSelectedNavButton(), this.scrollToNavIndex());
  }
  /**
   * Removes the `aria-current` attribute from all navigation buttons
   */
  removeCurrentlySelected() {
    var e;
    const t = ((e = this.carouselNavigator) == null ? void 0 : e.children) || [];
    for (const a of t)
      a.removeAttribute("aria-current");
  }
  /**
   * triggered when a new navigation button is selected
   */
  updateSelectedNavButton() {
    this.removeCurrentlySelected(), this.addAriaCurrentRole(this.currentNavigatorIndex), this.updateAriaLiveRegion();
  }
  updateAriaLiveRegion() {
    var t;
    this.liveRegion.textContent = `Carousel page ${this.currentNavigatorIndex + 1} of ${(t = this.carouselNavigator) == null ? void 0 : t.children.length}`;
  }
  /**
   * Scrolls the appropriate card into view instead of using scrollIntoView(),
   * since scrollIntoView() can cause unintended scrolling on larger pages
   */
  scrollToNavIndex() {
    var t, e, a, o;
    if (this.currentNavigatorIndex === 0)
      (t = this.carouselContainer) == null || t.scroll({ left: 0, behavior: "smooth" });
    else {
      const n = (a = (e = this.carouselPageMap.get(
        this.currentNavigatorIndex
      )) == null ? void 0 : e.startTile) == null ? void 0 : a.offsetLeft;
      if (n !== void 0) {
        const r = getComputedStyle(
          this.carouselWrapper
        ).getPropertyValue("padding-inline");
        (o = this.carouselContainer) == null || o.scroll({
          left: n - parseInt(r, 10),
          behavior: "smooth"
        });
      }
    }
  }
  /**
   * Dot indicators.
   *
   * @date 2024-11-11: Change `<nav>` to `<div>` and removes `aria-label`.
   * @link https://rally1.rallydev.com/#/?detail=/defect/732798274309&fdp=true
   */
  renderCarouselNavigator() {
    return pe`
      <div class="carousel-indicator">
        ${Nf(
      this.carouselPageMap,
      (t) => t[0],
      (t, e) => pe`
            <button
              class="carousel-indicator-dot"
              aria-current=${e === 0 ? "true" : _e}
              aria-label="${this.navigatorButtonIndexPrefix} ${e + 1}"
              @click="${() => this.carouselIndicatorClickHandler(e)}"></button>
          `
    )}
      </div>
    `;
  }
  /**
   * Toggles the `inert` html attribute on the passed in `carouselItem`
   *
   * @param {HTMLElement} carouselItem Element to toggle `inert` attribute on
   * @param {boolean} hide boolean to add or remove `inert` attribute
   */
  static toggleCarouselItemAccessibility(t, e) {
    t.toggleAttribute("inert", e);
  }
  /**
   * Creates and populates a new `Map<number, { startTile: HTMLElement; scrollZoneUpperLimit: number }` object by comparing page views against the `containerWidth`
   * @returns {Map<number, { startTile: HTMLElement; scrollZoneUpperLimit: number }>} Map containing page numbers as keys and the startTile instances and the upper limit of the scroll zone for a give page as values.
   */
  createCarouselMap() {
    var o;
    const t = ((o = this.carouselContainer) == null ? void 0 : o.clientWidth) || 0, e = /* @__PURE__ */ new Map(), a = this.slottedCarouselItems.length;
    if (this.clearSnapClasses(), t < Zt.MEDIUM)
      this.slottedCarouselItems.forEach((n, r) => {
        e.set(r, {
          startTile: n,
          scrollZoneUpperLimit: (r + 1) / this.slottedCarouselItems.length
        });
      });
    else if (t < Zt.XLARGE) {
      const n = a % 2, r = n ? this.slottedCarouselItems.length : this.slottedCarouselItems.length / 2, T = n ? 2 : 1;
      let O = 0;
      for (let j = 0; j < a - n; j += 2)
        e.set(O, {
          startTile: this.slottedCarouselItems[j],
          scrollZoneUpperLimit: (O + 1) * T / r
        }), O += 1;
      n && e.set(O, {
        startTile: this.slottedCarouselItems[a - 1],
        scrollZoneUpperLimit: 1
      });
    } else {
      let n = 0;
      const r = a % 3, T = r ? this.slottedCarouselItems.length : this.slottedCarouselItems.length / 3, O = r ? 3 : 1;
      for (let j = 0; j < a - r; j += 3)
        e.set(n, {
          startTile: this.slottedCarouselItems[j],
          scrollZoneUpperLimit: (n + 1) * O / T
        }), n += 1;
      r && (r > 1 ? e.set(n, {
        startTile: this.slottedCarouselItems[a - 2],
        scrollZoneUpperLimit: 1
      }) : e.set(n, {
        startTile: this.slottedCarouselItems[a - 1],
        scrollZoneUpperLimit: 1
      }));
    }
    return e.forEach((n) => {
      Wo.applySnapClass(n.startTile);
    }), e;
  }
  postRenderCarouselSetup() {
    this.slottedCarouselItems && (this.itemCount = this.slottedCarouselItems.length), this.toggleCarouselAlphaMasking(), this.carouselResizeObserver.observe(this.carouselContainer);
    for (const t of this.slottedCarouselItems)
      this.carouselIntersectionObserver.observe(t);
  }
  renderHeaderTextAreas() {
    return pe`
      <div class="header-text">
        <div class="title-area">
          <span class="title-text"
            ><slot name="carousel-title">${this.carouselTitle}</slot></span
          >
          ${this.hideItemCount ? pe`` : pe`
                <span class="item-count"
                  >(${this.itemCount}
                  <slot name="item-label">items</slot>)</span
                >
              `}
        </div>
        <div class="description-area">
          <slot name="description" ${Ue({ useParent: !0 })}></slot>
        </div>
        <div class="action-zone">
          <slot name="action-zone" ${Ue({ useParent: !0 })}></slot>
        </div>
      </div>
    `;
  }
  renderIncrementalNav() {
    return pe`
      <nav aria-label="Carousel Pages" class="incremental-nav">
        ${Be`
          <${this.getScopedTag(Rt.BEACON_ICON_BUTTON)}
            @beacon-event-click=${this.decrementNavIndex}
            ?disabled=${this.currentNavigatorIndex === 0}
            class="increment-left" variant="secondary">
            <slot name="previous-button-text">Go to previous page</slot>
            <svg slot="icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M13 16.5L9 12.5L13 8.5" stroke="#086EA1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </${this.getScopedTag(Rt.BEACON_ICON_BUTTON)}>
        `} ${Be`
          <${this.getScopedTag(Rt.BEACON_ICON_BUTTON)}
            @beacon-event-click=${this.incrementNavIndex}
            ?disabled=${this.currentNavigatorIndex === this.carouselPageMap.size - 1}
            class="increment-right" variant="secondary">
            <slot name="next-button-text">Go to next page</slot>
            <svg slot="icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M11 8.5L15 12.5L11 16.5" stroke="#086EA1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </${this.getScopedTag(Rt.BEACON_ICON_BUTTON)}>
        `}
      </nav>
    `;
  }
  render() {
    const t = {
      "component-shell": !0,
      small: this.matchesUpToSmall
    };
    return pe`
      <section
        aria-label="${this.accessibleLabel}"
        role="group"
        aria-roledescription="carousel"
        class="${Oe(t)}">
        <header class="header">
          ${this.matchesUpToSmall ? pe`${this.renderHeaderTextAreas()}` : pe`
                ${this.renderHeaderTextAreas()}
                ${this.carouselPageMap.size !== 1 ? pe` ${this.renderIncrementalNav()}` : _e}
              `}
        </header>
        <div class="carousel-container" @scroll="${this.handleCarouselScroll}">
          <div
            class="carousel-wrapper"
            tabindex="${this.carouselPageMap.size > 1 ? "0" : _e}">
            <slot @slotchange=${this.handleCarouselSlotChange}></slot>
          </div>
        </div>
        <footer class="footer">
          ${this.matchesUpToSmall ? pe`
                ${this.carouselPageMap.size !== 1 ? pe`${this.renderCarouselNavigator()}
                    ${this.renderIncrementalNav()}` : _e}
              ` : pe`
                ${this.carouselPageMap.size !== 1 ? pe`${this.renderCarouselNavigator()}` : _e}
              `}
        </footer>
        <div
          aria-live="polite"
          aria-atomic="true"
          class="live-region visually-hidden"></div>
      </section>
      <output class="visually-hidden announcement"
        >${this.navigatorButtonIndexPrefix}
        ${this.currentNavigatorIndex + 1}</output
      >
      <slot style="display: none;" name="navigator-button-text"></slot>
    `;
  }
}, Wo.tagName = Rt.BEACON_TAG_NAME, Wo.nestedComponents = [eo], Wo);
Bt([
  Se()
], Pt.prototype, "carouselPageMap", 2);
Bt([
  Se()
], Pt.prototype, "currentNavigatorIndex", 2);
Bt([
  ue({ attribute: "carousel-title" })
], Pt.prototype, "carouselTitle", 2);
Bt([
  ue({ attribute: "accessible-label" })
], Pt.prototype, "accessibleLabel", 2);
Bt([
  ue({ attribute: "data-metrics-location", reflect: !0 })
], Pt.prototype, "dataMetricsLocation", 2);
Bt([
  ue({ attribute: "hide-item-count", type: Boolean })
], Pt.prototype, "hideItemCount", 2);
Bt([
  Se()
], Pt.prototype, "itemCount", 2);
Bt([
  Pe({ selector: ":not(style)" })
], Pt.prototype, "slottedCarouselItems", 2);
Bt([
  et(".carousel-container")
], Pt.prototype, "carouselContainer", 2);
Bt([
  et(".carousel-wrapper")
], Pt.prototype, "carouselWrapper", 2);
Bt([
  et(".component-shell")
], Pt.prototype, "componentShell", 2);
Bt([
  et(".header")
], Pt.prototype, "header", 2);
Bt([
  et(".carousel-indicator")
], Pt.prototype, "carouselNavigator", 2);
Bt([
  et(".live-region")
], Pt.prototype, "liveRegion", 2);
Bt([
  Pe({ selector: ".beacon-scroll-snap-item" })
], Pt.prototype, "scrollSnapCarouselItems", 2);
Bt([
  i1({
    slot: "navigator-button-text",
    defaultValue: "View Page"
  })
], Pt.prototype, "navigatorButtonIndexPrefix", 2);
Bt([
  De
], Pt.prototype, "postRenderCarouselSetup", 1);
let Y3 = Pt;
const zu = {
  beaconTagName: "beacon-collection-tile"
}, w2 = ve`@charset "UTF-8";[beacon-tag-name=beacon-collection-tile][beacon-version] .beacon-collection-tile__title{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-100);margin:0}[beacon-tag-name=beacon-collection-tile][beacon-version] .beacon-collection-tile__description{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-200);margin:0;padding-block-start:var(--beacon-reference-space-5)}[beacon-tag-name=beacon-collection-tile][beacon-version] .beacon-collection-tile__collection-icon{block-size:16px;inline-size:16px}[beacon-tag-name=beacon-collection-tile][beacon-version] .beacon-collection-tile__collection-label{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-caption-300);padding-inline-start:var(--beacon-reference-space-3)}[beacon-tag-name=beacon-collection-tile][beacon-version] .beacon-collection-tile__tag{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-300)}[beacon-tag-name=beacon-collection-tile][beacon-version] .beacon-collection-tile__tag:not(:last-child):after{content:"•";padding-inline:var(--beacon-reference-space-2)}[beacon-tag-name=beacon-collection-tile][beacon-version] [slot=body]{display:block;margin:var(--beacon-system-space-cell-contained);margin-block-end:calc(var(--beacon-system-space-cell-contained) + var(--beacon-system-space-micro-normal));min-block-size:var(--beacon-reference-space-14)}[beacon-tag-name=beacon-collection-tile][beacon-version] [slot=footer]{align-items:center;border-block-start:1px solid var(--beacon-collection-tile-footer-color);display:grid;grid-template-columns:auto 1fr auto auto;margin:var(--beacon-system-space-cell-contained);padding-block:var(--beacon-reference-space-7) var(--beacon-reference-space-3)}[beacon-tag-name=beacon-collection-tile].beacon-collection-tile__vertical-fill{--collection-tile-content-block-size: 100%;block-size:100%}[class*=b-grid-item] [beacon-tag-name=beacon-collection-tile].beacon-collection-tile__vertical-fill{block-size:100%}a:focus-visible [beacon-tag-name=beacon-collection-tile]{box-shadow:0 0 0 var(--beacon-system-width-border-jumbo) var(--beacon-system-color-border-focus-middle),0 0 0 var(--beacon-system-width-border-maxi) var(--beacon-system-color-border-focus-outer);outline:var(--beacon-system-width-border-normal) solid var(--beacon-system-color-border-focus-inner);outline-offset:0;z-index:1}a:focus-visible [beacon-tag-name=beacon-collection-tile]:not(dialog){position:relative}a [beacon-tag-name=beacon-collection-tile]:hover .beacon-collection-tile__title,a [beacon-tag-name=beacon-collection-tile]:focus .beacon-collection-tile__title{text-decoration:underline}@media (width >= 640px){[beacon-tag-name=beacon-collection-tile][beacon-version] .beacon-collection-tile__collection-label{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-caption-200)}[beacon-tag-name=beacon-collection-tile][beacon-version] .beacon-collection-tile__tag{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-200)}[beacon-tag-name=beacon-collection-tile][beacon-version] [slot=footer]{padding-block:var(--beacon-reference-space-6) 0}[beacon-tag-name=beacon-collection-tile][beacon-version] [slot=body]{min-block-size:84px}[beacon-tag-name=beacon-collection-tile][beacon-version][position=horizontal] [slot=media],[beacon-tag-name=beacon-collection-tile][beacon-version][position=horizontal-left] [slot=media],[beacon-tag-name=beacon-collection-tile][beacon-version][position=horizontal-right] [slot=media]{--collection-tile-aspect-ratio: 1/1;flex:1}}@media (width >= 960px){[beacon-tag-name=beacon-collection-tile][beacon-version][position=horizontal] .beacon-collection-tile__title,[beacon-tag-name=beacon-collection-tile][beacon-version][position=horizontal-left] .beacon-collection-tile__title,[beacon-tag-name=beacon-collection-tile][beacon-version][position=horizontal-right] .beacon-collection-tile__title{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-display-100)}[beacon-tag-name=beacon-collection-tile][beacon-version] [slot=footer]{padding-block:var(--beacon-reference-space-8) 0}[beacon-tag-name=beacon-collection-tile][beacon-version] [slot=body]{min-block-size:var(--beacon-reference-space-12)}}@media (width >= 1280px){[beacon-tag-name=beacon-collection-tile] [slot=body]{min-block-size:96px}}[beacon-tag-name=beacon-collection-tile] [slot=media]>img,[beacon-tag-name=beacon-collection-tile] [slot=media]:not(picture){aspect-ratio:var(--collection-tile-aspect-ratio, 3/2);inline-size:var(--collection-tile-media-inline-size, 100%);object-fit:cover}`, k2 = ve`:host{--collection-tile-inline-size: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 6 + var(--beacon-system-space-gutter) * 5);--collection-tile-color: var(--beacon-reference-palette-grayscale-white);--tile-content-display: flex;--tile-content-justify-content: space-between;--beacon-collection-tile-background-color: var(--beacon-component-tile-collection-color-background-blue);--beacon-collection-tile-footer-color: var(--beacon-component-tile-collection-color-border-blue);background-color:var(--beacon-collection-tile-background-color);border-radius:var(--beacon-system-radius-corner-standard);color:var(--collection-tile-color);inline-size:min(var(--collection-tile-inline-size),100%);text-decoration:none}.content-zone{block-size:var(--collection-tile-content-block-size);inline-size:var(--collection-tile-content-inline-size);padding:var(--beacon-system-space-organism-normal)}:host([position=horizontal-right]),:host([position=horizontal]){--tile-flex-direction: column}:host([position=horizontal-left]),:host([position=vertical-top]){--tile-flex-direction: column-reverse}:host([color-mode=green]){--beacon-collection-tile-background-color: var(--beacon-component-tile-collection-color-background-green);--beacon-collection-tile-footer-color: var(--beacon-component-tile-collection-color-border-green)}:host([color-mode=berry]){--beacon-collection-tile-background-color: var(--beacon-component-tile-collection-color-background-berry);--beacon-collection-tile-footer-color: var(--beacon-component-tile-collection-color-border-berry)}:host([color-mode=gold]){--beacon-collection-tile-background-color: var(--beacon-component-tile-collection-color-background-gold);--beacon-collection-tile-footer-color: var(--beacon-component-tile-collection-color-border-gold)}@media (width >= 640px){:host([position=horizontal-left]){--tile-flex-direction: row}:host([position=horizontal]),:host([position=horizontal-left]),:host([position=horizontal-right]){--tile-flex-direction: row;--collection-tile-inline-size: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 12 + var(--beacon-system-space-gutter) * 11);--collection-tile-media-inline-size: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 6 + var(--beacon-system-space-gutter) * 6);--collection-tile-content-inline-size: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 6 + var(--beacon-system-space-gutter) * 5)}:host([position=horizontal]) .content-zone,:host([position=horizontal-left]) .content-zone,:host([position=horizontal-right]) .content-zone{display:var(--tile-content-display);justify-content:var(--tile-content-justify-content)}}@media (width >= 1280px){:host{--collection-tile-inline-size: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 4 + var(--beacon-system-space-gutter) * 3)}}`;
var C2 = Object.defineProperty, S2 = Object.getOwnPropertyDescriptor, Ff = (i, t, e, a) => {
  for (var o = a > 1 ? void 0 : a ? S2(t, e) : t, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = (a ? r(t, e, o) : r(o)) || o);
  return a && o && C2(t, e, o), o;
};
const vb = class vb extends ia {
  constructor() {
    super(...arguments), this.beaconTagName = zu.beaconTagName, this.focusOverride = !0, this.colorMode = Zm.BLUE;
  }
  static get styles() {
    return [super.styles, k2];
  }
  static get lightDOMStyles() {
    return [...super.lightDOMStyles, w2];
  }
  /**
   * Slot override to attach a click listener to the slot for Omnibug analytics purposes
   */
  renderMedia() {
    return pe`<slot name="media"></slot>`;
  }
  /**
   * Slot override to attach a click listener to the slot for Omnibug analytics purposes
   */
  renderBody() {
    return pe`<slot name="body"></slot>`;
  }
  /**
   * Slot override to attach a click listener to the slot for Omnibug analytics purposes
   */
  renderFooter() {
    return pe`<slot name="footer"></slot>`;
  }
  renderHeader() {
    return pe``;
  }
  updateAnchorStyle() {
    this.onClosestAnchorElement();
  }
  /**
   * @description does checks if parent Element is <a> tag then apply text-decoration:none.
   * @todo Once we have support for `:has` then need to remove this and add below in lightDOM.
   * ```a:has([beacon-collection-tile]) {text-decoration:none}```
   */
  onClosestAnchorElement() {
    const t = this.closest("a");
    t && (t.style.textDecoration = "none");
  }
  renderTile(t) {
    return super.renderTile(t);
  }
  render() {
    return this.renderTile(this.position);
  }
};
vb.tagName = zu.beaconTagName;
let Bl = vb;
Ff([
  ue({ attribute: "color-mode", reflect: !0 })
], Bl.prototype, "colorMode", 2);
Ff([
  qe
], Bl.prototype, "updateAnchorStyle", 1);
const Du = {
  beaconTagName: "beacon-contact-tile"
}, E2 = ve`[beacon-tag-name=beacon-contact-tile] .beacon-contact-tile__icon{--contact-tile-icon-size: var(--beacon-reference-space-11);block-size:var(--contact-tile-icon-size);inline-size:var(--contact-tile-icon-size);margin-block-end:var(--beacon-reference-space-5)}[beacon-tag-name=beacon-contact-tile] .beacon-contact-tile__title,[beacon-tag-name=beacon-contact-tile] .beacon-contact-tile__title>*{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-100);display:block;margin:0;text-decoration:none}[beacon-tag-name=beacon-contact-tile] a.beacon-contact-tile__title,[beacon-tag-name=beacon-contact-tile] .beacon-contact-tile__title>a{color:var(--beacon-system-color-text-link)}[beacon-tag-name=beacon-contact-tile] a.beacon-contact-tile__title:is(:focus,:hover),[beacon-tag-name=beacon-contact-tile] .beacon-contact-tile__title>a:is(:focus,:hover){text-decoration:underline}[beacon-tag-name=beacon-contact-tile] .beacon-contact-tile__job-title{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-caption-300);display:block;margin-block-start:var(--beacon-reference-space-2);text-decoration:none}[beacon-tag-name=beacon-contact-tile] .beacon-contact-tile__description{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-200);display:block;margin-block-start:var(--beacon-reference-space-5);text-decoration:none}[beacon-tag-name=beacon-contact-tile] [slot=body]{padding:var(--beacon-system-space-cell-contained)}[beacon-tag-name=beacon-contact-tile] [slot=footer]{display:grid;grid-auto-flow:row;padding:var(--beacon-system-space-cell-contained);row-gap:var(--beacon-reference-space-3)}[beacon-tag-name=beacon-contact-tile].beacon-contact-tile__vertical-fill{--contact-tile-content-zone-block-size: 100%;--tile-footer-margin-block-start: auto}[class*=b-grid-item] [beacon-tag-name=beacon-contact-tile].beacon-contact-tile__vertical-fill{block-size:100%}@media (width >= 1280px){[beacon-tag-name=beacon-contact-tile] .beacon-contact-tile__icon{--contact-tile-icon-size: var(--beacon-reference-space-13)}}`, T2 = ve`:host{--contact-tile-inline-size: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 6 + var(--beacon-system-space-gutter) * 5);--tile-footer-margin-block-start: var(--beacon-system-space-micro-normal);color:var(--beacon-system-color-text-standard);inline-size:min(var(--contact-tile-inline-size),100%)}.content-zone{--tile-content-start-start-radius: var(--beacon-system-radius-corner-standard);--tile-content-start-end-radius: var(--beacon-system-radius-corner-standard);background-color:var(--beacon-system-color-background-1);block-size:var(--contact-tile-content-zone-block-size);padding:var(--beacon-system-space-organism-normal)}@media (width >= 960px){:host{--contact-tile-inline-size: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 4 + var(--beacon-system-space-gutter) * 3)}}`, Ab = class Ab extends ia {
  constructor() {
    super(...arguments), this.beaconTagName = Du.beaconTagName;
  }
  static get styles() {
    return [super.styles, T2];
  }
  static get lightDOMStyles() {
    return [super.lightDOMStyles, E2];
  }
  /**
   * renderContentZone override to remove `header` from the render
   */
  renderContentZone() {
    return pe`<div class="content-zone">
      ${this.renderBody()} ${this.renderFooter()}
    </div>`;
  }
  render() {
    return pe`${this.renderContentZone()}`;
  }
};
Ab.tagName = Du.beaconTagName;
let Iu = Ab;
var _f = /* @__PURE__ */ ((i) => (i.PRIMARY = "primary", i.SECONDARY = "secondary", i))(_f || {}), M2 = Object.defineProperty, L2 = Object.getOwnPropertyDescriptor, Bu = (i, t, e, a) => {
  for (var o = a > 1 ? void 0 : a ? L2(t, e) : t, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = (a ? r(t, e, o) : r(o)) || o);
  return a && o && M2(t, e, o), o;
};
function Xh(i) {
  let t = class extends i {
    constructor() {
      super(...arguments), this.disabled = !1, this.allowableInteractiveKeys = ["Shift", "Tab"], this.preventDisabledEvents = (e) => {
        if (this.disabled)
          if (e instanceof KeyboardEvent) {
            const { key: a } = e;
            this.allowableInteractiveKeys.includes(a) || e.preventDefault();
          } else
            e.preventDefault();
      };
    }
    preventDisabledEventsOnElement(e, a = ["click", "keydown"]) {
      for (const o of a)
        e == null || e.addEventListener(o, this.preventDisabledEvents);
    }
  };
  return Bu([
    ue({ type: Boolean, reflect: !0 })
  ], t.prototype, "disabled", 2), t = Bu([
    je("Disablable")
  ], t), t;
}
var O2 = Object.defineProperty, P2 = Object.getOwnPropertyDescriptor, Uf = (i) => {
  throw TypeError(i);
}, Md = (i, t, e, a) => {
  for (var o = a > 1 ? void 0 : a ? P2(t, e) : t, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = (a ? r(t, e, o) : r(o)) || o);
  return a && o && O2(t, e, o), o;
}, jf = (i, t, e) => t.has(i) || Uf("Cannot " + e), z2 = (i, t, e) => (jf(i, t, "read from private field"), e ? e.call(i) : t.get(i)), D2 = (i, t, e) => t.has(i) ? Uf("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(i) : t.set(i, e), I2 = (i, t, e, a) => (jf(i, t, "write to private field"), t.set(i, e), e);
function $f(i) {
  var t;
  let e = class extends i {
    constructor() {
      super(...arguments), this.invalid = !1, D2(this, t);
    }
    get errorElement() {
      return z2(this, t);
    }
    set errorElement(a) {
      I2(this, t, a), this.errorElement && !this.errorElement.id && (this.errorElement.id = Ia()), this.postSetErrorElement();
    }
    postSetErrorElement() {
    }
    handleErrorSlotchange() {
      this.errorElement = this.errorElements[0];
    }
    renderErrorTemplate() {
      const a = {
        error: !0,
        visible: this.invalid
      };
      return Be`
        <${this.getScopedTag("beacon-error")} id="error" class="${Oe(a)}" role="alert">
          <slot name="error" @slotchange=${this.handleErrorSlotchange} ${Ue({ useParent: !0 })}></slot>
        </${this.getScopedTag("beacon-error")}>
      `;
    }
  };
  return t = /* @__PURE__ */ new WeakMap(), Md([
    wt({ flatten: !0, slot: "error" })
  ], e.prototype, "errorElements", 2), Md([
    ue({ type: Boolean, reflect: !0 })
  ], e.prototype, "invalid", 2), e = Md([
    je("Errorable")
  ], e), e;
}
var B2 = Object.defineProperty, R2 = Object.getOwnPropertyDescriptor, Hf = (i) => {
  throw TypeError(i);
}, Ld = (i, t, e, a) => {
  for (var o = a > 1 ? void 0 : a ? R2(t, e) : t, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = (a ? r(t, e, o) : r(o)) || o);
  return a && o && B2(t, e, o), o;
}, Kf = (i, t, e) => t.has(i) || Hf("Cannot " + e), N2 = (i, t, e) => (Kf(i, t, "read from private field"), e ? e.call(i) : t.get(i)), F2 = (i, t, e) => t.has(i) ? Hf("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(i) : t.set(i, e), _2 = (i, t, e, a) => (Kf(i, t, "write to private field"), t.set(i, e), e);
function Gf(i) {
  var t;
  let e = class extends i {
    constructor() {
      super(...arguments), F2(this, t);
    }
    get fieldElement() {
      return N2(this, t);
    }
    set fieldElement(a) {
      _2(this, t, a), this.postSetFormControlElement();
    }
    get currentInputType() {
      if (this.fieldElement)
        return this.fieldElement.type;
    }
    postSetFormControlElement() {
    }
    postFormControlSlotchange() {
    }
    handleFormControlSlotchange() {
      this.fieldElement = this.fieldElements[0], this.postFormControlSlotchange();
    }
    setInputType() {
      this.fieldElement instanceof HTMLInputElement ? this._inputType = this.fieldElement.type : this._inputType = this.fieldElement.localName;
    }
    renderFormControlTemplate() {
      return pe`<slot
        @slotchange=${this.handleFormControlSlotchange}></slot>`;
    }
  };
  return t = /* @__PURE__ */ new WeakMap(), Ld([
    wt({ flatten: !0 })
  ], e.prototype, "fieldElements", 2), Ld([
    Se()
  ], e.prototype, "_inputType", 2), e = Ld([
    je("FormControl")
  ], e), e;
}
var U2 = Object.defineProperty, j2 = Object.getOwnPropertyDescriptor, Wf = (i) => {
  throw TypeError(i);
}, Ru = (i, t, e, a) => {
  for (var o = a > 1 ? void 0 : a ? j2(t, e) : t, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = (a ? r(t, e, o) : r(o)) || o);
  return a && o && U2(t, e, o), o;
}, qf = (i, t, e) => t.has(i) || Wf("Cannot " + e), $2 = (i, t, e) => (qf(i, t, "read from private field"), e ? e.call(i) : t.get(i)), H2 = (i, t, e) => t.has(i) ? Wf("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(i) : t.set(i, e), K2 = (i, t, e, a) => (qf(i, t, "write to private field"), t.set(i, e), e);
function Zh(i) {
  var t;
  let e = class extends i {
    constructor() {
      super(...arguments), H2(this, t);
    }
    get hintElement() {
      return $2(this, t);
    }
    set hintElement(a) {
      K2(this, t, a), this.hintElement && !this.hintElement.id && (this.hintElement.id = Ia()), this.postSetHintElement();
    }
    postSetHintElement() {
    }
    handleHintSlotchange() {
      this.hintElement = this.hintElements[0];
    }
    renderHintTemplate() {
      return pe`
        <div id="hint" class="hint">
          <slot
            name="hint"
            @slotchange=${this.handleHintSlotchange}
            ${Ue({ useParent: !0 })}></slot>
        </div>
      `;
    }
  };
  return t = /* @__PURE__ */ new WeakMap(), Ru([
    wt({ flatten: !0, slot: "hint" })
  ], e.prototype, "hintElements", 2), e = Ru([
    je("Hintable")
  ], e), e;
}
const Nu = {
  beaconTagName: "beacon-error"
}, G2 = ve`:host{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-caption-300);align-items:center;display:grid;gap:var(--beacon-reference-space-3);grid-template-columns:auto 1fr}.error{align-self:start}`, Kl = class Kl extends Le {
  constructor() {
    super(...arguments), this.beaconTagName = Nu.beaconTagName;
  }
  static get styles() {
    return [super.styles, G2];
  }
  static renderIcon() {
    return pe`
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="error"
        role="img"
        aria-label="Error">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M1.57752 10.9999C1.22025 11.6187 1.22025 12.3811 1.57752 12.9999L5.92282 20.5262C6.28009 21.145 6.94034 21.5262 7.65487 21.5262H16.3455C17.06 21.5262 17.7203 21.145 18.0775 20.5262L22.4228 12.9999C22.7801 12.3811 22.7801 11.6187 22.4228 10.9999L18.0775 3.47363C17.7203 2.85483 17.06 2.47363 16.3455 2.47363H7.65487C6.94034 2.47363 6.28008 2.85483 5.92282 3.47363L1.57752 10.9999ZM11.2502 7.74989C11.2502 7.33568 11.586 6.99989 12.0002 6.99989C12.4144 6.99989 12.7502 7.33568 12.7502 7.74989V12.2499C12.7502 12.6641 12.4144 12.9999 12.0002 12.9999C11.586 12.9999 11.2502 12.6641 11.2502 12.2499V7.74989ZM13.0002 15.9999C13.0002 16.5522 12.5525 16.9999 12.0002 16.9999C11.4479 16.9999 11.0002 16.5522 11.0002 15.9999C11.0002 15.4476 11.4479 14.9999 12.0002 14.9999C12.5525 14.9999 13.0002 15.4476 13.0002 15.9999Z"
          fill="var(--beacon-system-color-icon-error, #DD3636)" />
      </svg>
    `;
  }
  render() {
    return pe`
      <slot name="icon">${Kl.renderIcon()}</slot>
      <slot></slot>
    `;
  }
};
Kl.tagName = Nu.beaconTagName;
let Rl = Kl;
const Fu = {
  beaconTagName: "beacon-control"
}, W2 = ve`[beacon-tag-name=beacon-control]:has([type=hidden]){display:none}[beacon-tag-name=beacon-control] input:is(:-webkit-autofill,:autofill){border-radius:var(--beacon-system-radius-corner-standard)}[beacon-tag-name=beacon-control]:has(input:checked)::part(field){--hover-outline-color: var(--beacon-system-color-background-primary)}[beacon-tag-name=beacon-control]:has(input:checked)[invalid]::part(field){border-color:var(--beacon-system-color-border-error)}[beacon-tag-name=beacon-control]:has(input:checked)[disabled]:not([invalid])::part(field){border-color:transparent}[beacon-tag-name=beacon-control]:has(input:checked) label{font-weight:var(--beacon-system-font-weight-bold)}[beacon-tag-name=beacon-control]:not([stepper-variant=none]):has([type=number]) input{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-body-100);-webkit-appearance:textfield;-moz-appearance:textfield;appearance:textfield;border:var(--beacon-system-width-border-mini) solid var(--beacon-component-form-color-border-standard);border-radius:var(--beacon-system-radius-corner-standard);gap:var(--beacon-reference-space-4);inline-size:36px;min-block-size:var(--beacon-reference-space-10);padding-block:var(--beacon-reference-space-3);padding-inline:var(--beacon-reference-space-4)}[beacon-tag-name=beacon-control]:not([stepper-variant=none]):has([type=number]) input::-webkit-inner-spin-button{-webkit-appearance:none;-moz-appearance:none;appearance:none;margin:0}[beacon-tag-name=beacon-control]:not([stepper-variant=none]):has([type=number]) input.invalid{outline:var(--beacon-system-color-border-error)}[beacon-tag-name=beacon-control]:not([stepper-variant=none]):has([type=number]) input:hover{outline:var(--beacon-system-width-border-mini) solid var(--beacon-component-form-color-border-standard)}[beacon-tag-name=beacon-control]:not([stepper-variant=none]):has([type=number]) input:focus-visible{outline:var(--beacon-system-width-border-normal) solid var(--beacon-system-color-border-focus-middle);outline-offset:var(--beacon-system-width-border-normal);position:relative;z-index:1}[beacon-tag-name=beacon-control] .option-label{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100)}[beacon-tag-name=beacon-control]:has(input)[toggle-switch] [type=checkbox].beacon-control__field{-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:transparent;background-image:none;block-size:100%;border:var(--beacon-system-width-border-mini) solid var(--beacon-component-form-color-border-standard);border-radius:var(--beacon-system-radius-corner-round);cursor:pointer;inline-size:100%;inset-block-start:0;inset-inline-start:0;position:absolute}[beacon-tag-name=beacon-control]:has(input)[toggle-switch] [type=checkbox].beacon-control__field[aria-disabled=true],[beacon-tag-name=beacon-control]:has(input)[toggle-switch] [type=checkbox].beacon-control__field[disabled]{border:0}[beacon-tag-name=beacon-control]:has(input)[toggle-switch]::part(field){block-size:var(--beacon-reference-space-8);border-radius:var(--beacon-system-radius-corner-round);inline-size:var(--beacon-reference-space-12);position:relative}[beacon-tag-name=beacon-control]:has(input)[toggle-switch]::part(field):before{background-color:var(--beacon-system-color-background-2);block-size:var(--beacon-reference-space-5);border:var(--beacon-system-width-border-mini) solid var(--beacon-component-form-color-border-standard);border-radius:50%;content:"";inline-size:var(--beacon-reference-space-5);inset-block-start:50%;inset-inline-start:var(--beacon-reference-space-2);pointer-events:none;position:absolute;transform:translateY(-50%)}[beacon-tag-name=beacon-control]:has(input)[toggle-switch]:has(input:checked)::part(field){background-color:var(--beacon-system-color-background-primary)}[beacon-tag-name=beacon-control]:has(input)[toggle-switch]:has(input:checked)::part(field):hover{--hover-outline-color: transparent;background-color:var(--beacon-system-color-background-primary-hover)}[beacon-tag-name=beacon-control]:has(input)[toggle-switch]:has(input:checked)::part(field):before{block-size:var(--beacon-reference-space-6);border:0;inline-size:var(--beacon-reference-space-6);inset-inline-start:calc(100% - var(--beacon-reference-space-6) - var(--beacon-reference-space-2))}[beacon-tag-name=beacon-control]:has(input)[toggle-switch][disabled] label{color:var(--beacon-system-color-text-inactive)}[beacon-tag-name=beacon-control]:has(input)[toggle-switch][disabled]::part(field):before{border-color:var(--beacon-component-form-color-foreground-inactive)}[beacon-tag-name=beacon-control]:has(input)[toggle-switch]:has(input:checked)[aria-disabled=true]::part(field),[beacon-tag-name=beacon-control]:has(input)[toggle-switch]:has(input:checked)[disabled]::part(field){background-color:var(--beacon-component-form-color-foreground-inactive);cursor:not-allowed}[beacon-tag-name=beacon-control]:has(textarea){--control-overflow: hidden}[beacon-tag-name=beacon-control]:has(textarea):not([non-resizable]){--control-resize: both}[beacon-tag-name=beacon-control]:has(textarea) textarea{block-size:100%;inline-size:100%;resize:none}[beacon-tag-name=beacon-control]:has([slot=prefix]){--control-padding-inline-start: var(--beacon-reference-space-3)}[beacon-tag-name=beacon-control]:has([slot=suffix]),[beacon-tag-name=beacon-control]:has([type=password]):not([disable-password-toggle]){--control-padding-inline-end: var(--beacon-reference-space-3)}[beacon-tag-name=beacon-control]:has([aria-disabled=true]) label{pointer-events:none}[beacon-tag-name=beacon-control] label{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-headline-50)}[beacon-tag-name=beacon-control]:not([stepper-variant=none]) .beacon-control__field:is([type=number]){background-color:var(--beacon-system-color-background-1);block-size:var(--beacon-reference-space-8)}[beacon-tag-name=beacon-control]:not([stepper-variant=none]) .beacon-control__field:is([type=number]):is([aria-disabled=true],:disabled){background-color:var(--beacon-component-form-color-background-inactive);border:0}[beacon-tag-name=beacon-control]:not([stepper-variant=none]) .beacon-control__field:is([type=number]):is([aria-invalid=true],:invalid){border:var(--beacon-system-width-border-normal) solid var(--beacon-system-color-border-error)}[beacon-tag-name=beacon-control] .beacon-control__field{background-color:transparent;border:0;color:var(--beacon-system-color-text-standard);inline-size:100%;outline:0}[beacon-tag-name=beacon-control] .beacon-control__field:not([type=checkbox],[type=radio],select){padding-block:var(--beacon-reference-space-3);padding-inline:var(--control-padding-inline-start, var(--beacon-reference-space-4)) var(--control-padding-inline-end, var(--beacon-reference-space-4))}[beacon-tag-name=beacon-control] .beacon-control__field[aria-disabled=true],[beacon-tag-name=beacon-control] .beacon-control__field:disabled{caret-color:transparent;color:var(--beacon-system-color-text-inactive);cursor:not-allowed}[beacon-tag-name=beacon-control] .beacon-control__field:is([type=checkbox],[type=radio]){-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:var(--beacon-system-color-background-1);block-size:var(--beacon-reference-space-8);cursor:pointer;inline-size:var(--beacon-reference-space-8)}[beacon-tag-name=beacon-control] .beacon-control__field:is([type=checkbox],[type=radio]):is([aria-disabled=true],:disabled){background-color:var(--beacon-component-form-color-background-inactive);border:0}@supports (hanging-punctuation: first) and (font: -apple-system-body) and (-webkit-appearance: none){[beacon-tag-name=beacon-control] .beacon-control__field[type=date]{block-size:var(--beacon-reference-space-10)}}[beacon-tag-name=beacon-control] .beacon-control__field[type=checkbox]{border:var(--beacon-system-width-border-mini) solid var(--beacon-component-form-color-border-standard);border-radius:var(--beacon-system-radius-corner-standard)}[beacon-tag-name=beacon-control] .beacon-control__field[type=checkbox]:checked{accent-color:var(--beacon-system-color-background-primary);-webkit-appearance:revert;-moz-appearance:revert;appearance:revert}[beacon-tag-name=beacon-control] .beacon-control__field[type=checkbox]:checked:is([aria-disabled=true],:disabled){accent-color:var(--beacon-component-form-color-foreground-inactive)}[beacon-tag-name=beacon-control] .beacon-control__field[type=checkbox]:checked:is([aria-invalid=true],:invalid){accent-color:var(--beacon-system-color-icon-error)}@supports (hanging-punctuation: first) and (font: -apple-system-body) and (-webkit-appearance: none){[beacon-tag-name=beacon-control] .beacon-control__field[type=checkbox]:checked{-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:var(--beacon-system-color-background-primary);background-image:url("data:image/svg+xml,%3Csvg width='15' height='13' viewBox='0 0 15 13' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 7.51852L5.78947 12L14 1' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A");background-position:center;background-repeat:no-repeat;border-radius:unset}[beacon-tag-name=beacon-control] .beacon-control__field[type=checkbox]:checked:is([aria-disabled=true],:disabled){background-color:var(--beacon-component-form-color-foreground-inactive);border:0}[beacon-tag-name=beacon-control] .beacon-control__field[type=checkbox]:checked:is([aria-invalid=true],:invalid){background-color:var(--beacon-system-color-icon-error);border:0}}[beacon-tag-name=beacon-control] .beacon-control__field[type=checkbox]:is([aria-invalid=true]){border:var(--beacon-system-width-border-normal) solid var(--beacon-system-color-border-error)}[beacon-tag-name=beacon-control] .beacon-control__field[type=checkbox]:is([aria-invalid=true]):hover{border-color:var(--beacon-system-color-border-error)}[beacon-tag-name=beacon-control] .beacon-control__field[type=checkbox]:focus-within{border-color:var(--beacon-system-color-background-primary)}[beacon-tag-name=beacon-control] .beacon-control__field[type=checkbox]:hover{border:2px solid var(--beacon-component-form-color-border-standard)}[beacon-tag-name=beacon-control] .beacon-control__field[type=radio]{border-radius:50%;padding:var(--beacon-reference-space-2)}[beacon-tag-name=beacon-control] .beacon-control__field[type=radio]:checked{background-clip:content-box;background-color:var(--beacon-system-color-background-primary)}[beacon-tag-name=beacon-control] .beacon-control__field[type=radio]:checked:is([aria-disabled=true],:disabled){background-color:var(--beacon-component-form-color-foreground-inactive);border:0}[beacon-tag-name=beacon-control] .beacon-control__field[type=radio]:checked:is([aria-invalid=true],:invalid){background-color:var(--beacon-system-color-icon-error);border:0}[beacon-tag-name=beacon-control] .beacon-control__field:is(select){-webkit-appearance:none;-moz-appearance:none;appearance:none;cursor:pointer;padding-block:var(--beacon-reference-space-3);padding-inline:var(--control-padding-inline-start, var(--beacon-reference-space-4)) var(--control-padding-inline-end, var(--beacon-reference-space-9))}[beacon-tag-name=beacon-control] .beacon-control__field:is(select) option{color:var(--beacon-reference-palette-grayscale-dark-gray-3)}[beacon-tag-name=beacon-control] .beacon-control__field:is(select)[disabled],[beacon-tag-name=beacon-control] .beacon-control__field:is(select)[aria-disabled=true]{opacity:.7}[beacon-tag-name=beacon-control][data-mode=dark] :is(input,textarea,select){color-scheme:dark}`, q2 = ve`:host{display:flex;flex-direction:column}.inline-wrapper{display:contents}.group{align-items:var(--control-alignment, start);display:flex;flex-direction:var(--beacon-custom-control-flex-direction, var(--control-direction, column));gap:var(--beacon-reference-space-3);inline-size:var(--control-group-inline-size, 100%);justify-content:start}.group.inline{--control-direction: row-reverse}.group.inline .field{flex-shrink:0}.group:has(.radio,.checkbox){--control-alignment: center;gap:var(--beacon-reference-space-4)}.group:has(.date){--control-group-inline-size: fit-content}.inline-wrapper.active:not(:has(.radio,.checkbox)){align-items:center;column-gap:var(--beacon-reference-space-4);display:grid;grid-template-columns:auto 1fr}.inline-wrapper.active:not(:has(.radio,.checkbox)) .group{display:contents}.inline-wrapper.active:not(:has(.radio,.checkbox)) .label{grid-column:1/2}.inline-wrapper.active:not(:has(.radio,.checkbox)) .field,.inline-wrapper.active:not(:has(.radio,.checkbox)) .hint,.inline-wrapper.active:not(:has(.radio,.checkbox)) .error{grid-column:2/3}.inline-wrapper.active:not(:has(.radio,.checkbox)) :where(.date){--control-inline-size: fit-content}.field{align-items:center;background-color:var(--beacon-system-color-background-1);border:var(--beacon-system-width-border-mini) solid var(--beacon-component-form-color-border-standard);border-radius:var(--beacon-system-radius-corner-standard);display:flex;font:var(--beacon-system-font-weight-light) var(--beacon-component-form-font-size-sans-serif-standard);overflow:var(--control-overflow, initial);resize:var(--control-resize, none)}.field:not(.radio,.checkbox){inline-size:var(--beacon-custom-control-inline-size, var(--control-inline-size, 100%))}.field.select{position:relative}.field.select .dropdown-icon{color:var(--beacon-system-color-icon-link);inset-inline-end:var(--beacon-reference-space-3);position:absolute}.field.disabled{background-color:var(--beacon-component-form-color-background-inactive);border-color:transparent;pointer-events:none}.field.disabled .dropdown-icon{color:var(--beacon-reference-palette-grayscale-light-gray-2)}.field.readonly{background-color:var(--beacon-system-color-background-0);border-color:var(--beacon-system-color-border-0)}.field.invalid{border-color:var(--beacon-system-color-border-error)}.field.invalid:not(.checkbox){outline:var(--beacon-system-width-border-mini) solid var(--beacon-system-color-border-error)}.field.invalid:where(.number.stepper){outline:none}.field:hover:not(.invalid,:focus-within,.checkbox){outline:var(--beacon-system-width-border-mini) solid var(--hover-outline-color, var(--beacon-component-form-color-border-standard))}.field:focus-within{border-color:var(--beacon-system-color-border-primary)}.field:focus-within:not(:has([name=prefix]:focus-within)){outline:var(--beacon-system-width-border-normal) solid var(--beacon-system-color-border-focus-middle);outline-offset:var(--beacon-system-width-border-normal);position:relative;z-index:1}.field:focus-within.invalid{border-color:var(--beacon-system-color-border-error)}.field:focus-within.disabled{border-color:var(--beacon-system-color-border-primary)}.field:focus-within.readonly{border-color:var(--beacon-system-color-border-0)}.field:where(.date){--control-inline-size: 100%}.field:where(.select){--control-inline-size: 100%}@media (width >= 640px){.field:where(.select){--control-inline-size: fit-content}}.field:where(.radio){border-radius:50%}.field.number.stepper{background:transparent;border:0;gap:var(--beacon-reference-space-3)}.field.number.stepper:is(:hover,:focus-within){outline:none}.field.checkbox{border:0}.prefix,.suffix{flex-shrink:0}.prefix{margin-inline-start:var(--beacon-reference-space-4)}.suffix{margin-inline-end:var(--beacon-reference-space-4)}.suffix.password:not(.password-visible) .hide-password{display:none}.suffix.password.password-visible .show-password{display:none}.suffix.password ::part(standard-button){margin:0;padding:0;position:relative}.suffix.password ::part(standard-button):before{block-size:var(--beacon-reference-space-10);content:"";inline-size:var(--beacon-reference-space-10);inset-block-start:calc(-1 * var(--beacon-reference-space-4));position:absolute}.toggle-switch-label:not(.checkbox-checked) .switch-on-label{display:none}.toggle-switch-label.checkbox-checked .switch-off-label{display:none}.stepper{margin-inline:0}.hint{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100)}.error:not(.visible){display:none}.hint,.error{margin-block-start:var(--beacon-reference-space-2)}.beacon-stepper-button{--override-icon-button-wrapper-block-size: var(--beacon-reference-space-9);--override-icon-button-wrapper-inline-size: var(--beacon-reference-space-9);align-items:flex-start;display:flex;padding:var(--beacon-reference-space-2)}`;
var V2 = Object.defineProperty, Y2 = Object.getOwnPropertyDescriptor, Vt = (i, t, e, a) => {
  for (var o = a > 1 ? void 0 : a ? Y2(t, e) : t, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = (a ? r(t, e, o) : r(o)) || o);
  return a && o && V2(t, e, o), o;
}, ji, ms, wa;
const Kt = (wa = class extends Ke(Le).with(
  Zh,
  $f,
  Gf,
  Xh
) {
  constructor() {
    super();
    Fe(this, ji);
    Fe(this, ms);
    this.beaconTagName = Fu.beaconTagName, this.resetSpacing = !0, this.focusOverride = !0, this.inline = !1, this.disablePasswordToggle = !1, this.disableToggleSwitchLabel = !1, this.nonResizable = !1, this.toggleSwitch = !1, this.readOnly = !1, this.stepperVariant = _f.PRIMARY, this.passwordVisible = !1, this.isCheckboxChecked = !1, Ne(this, ji, void 0), this.handleFieldElementInvalid = this.handleFieldElementInvalid.bind(this), this.handleFieldElementOnChange = this.handleFieldElementOnChange.bind(this);
  }
  static get styles() {
    return [super.styles, q2];
  }
  static get lightDOMStyles() {
    return [super.lightDOMStyles, W2];
  }
  get labelElement() {
    return ze(this, ms);
  }
  set labelElement(e) {
    Ne(this, ms, e);
  }
  postSetFormControlElement() {
    this.fieldElement && (wa.applyClassNameToField(this.fieldElement), Re(this, Ee.CONTROL_SET), this.setInputType(), this.setupSlottedFieldEventListeners(), this.setDisabledState(), this.setInvalidState(), this.setReadOnlyState(), this.setSwitchRole(), this.applyFieldElementObserver(), this.initializeIsCheckboxChecked());
  }
  get isStepper() {
    return this._inputType === "number" && this.stepperVariant !== "none";
  }
  get controlGroup() {
    return Wi(
      this,
      "_controlGroup",
      () => this.closest(this.getScopedTagName("beacon-control-group"))
    );
  }
  getAriaDescribedByIds() {
    var a, o;
    const e = [this.dataset.hintId || ((a = this.hintElement) == null ? void 0 : a.id)];
    return this.invalid && e.push(this.dataset.errorId || ((o = this.errorElement) == null ? void 0 : o.id)), e;
  }
  postSetHintElement() {
    this.setFieldAriaDescribedBy();
  }
  postSetErrorElement() {
    this.associateErrorWithField();
  }
  setFieldAriaDescribedBy(e = this.getAriaDescribedByIds()) {
    if (!this.fieldElement) return;
    const a = e.filter((n) => n);
    if (a.length === 0) {
      this.fieldElement.removeAttribute("aria-describedby");
      return;
    }
    const o = a.join(" ");
    this.fieldElement.setAttribute("aria-describedby", o);
  }
  associateErrorWithField(e = ((a) => (a = this.errorElement) == null ? void 0 : a.id)()) {
    if (!this.fieldElement) return;
    const o = this.dataset.errorId || e;
    this.invalid ? o && this.fieldElement.setAttribute("aria-errormessage", o) : this.fieldElement.removeAttribute("aria-errormessage"), this.setFieldAriaDescribedBy();
  }
  handleLabelSlotchange() {
    this.labelElement = wa.setElementFromQuery(
      this.labelElements
    );
  }
  setupSlottedFieldEventListeners() {
    var e, a;
    this.preventDisabledEventsOnElement(this.fieldElement), (e = this.fieldElement) == null || e.addEventListener(
      "invalid",
      this.handleFieldElementInvalid
    ), (a = this.fieldElement) == null || a.addEventListener(
      "change",
      this.handleFieldElementOnChange
    );
  }
  postFormControlSlotchange() {
    this.isStepper && this.fieldElement instanceof HTMLInputElement && (this.updateStepperSlottedInputValue(), this.fieldElement.value || (this.fieldElement.value = this.fieldElement.min || "1"), this.disabledMinusValue = this.setMinusButtonState(), this.disabledPlusValue = this.setPlusButtonState());
  }
  handleFieldElementInvalid(e) {
    var a;
    (a = this.fieldElement) == null || a.setAttribute("aria-invalid", "true");
  }
  handleFieldElementOnChange(e) {
    const a = e == null ? void 0 : e.target;
    a && (a == null ? void 0 : a.type) === "checkbox" && (this.isCheckboxChecked = a == null ? void 0 : a.checked);
  }
  applyFieldElementObserver() {
    this.fieldElement && !ze(this, ji) && (Ne(this, ji, new MutationObserver(
      (e) => {
        e.find(
          (r) => r.attributeName === "aria-disabled" || r.attributeName === "disabled"
        ) && this.setDisabledState(), e.find(
          (r) => r.attributeName === "aria-invalid"
        ) && this.setInvalidState(), e.find(
          (r) => r.attributeName === "readonly"
        ) && this.setReadOnlyState();
      }
    )), ze(this, ji).observe(this.fieldElement, {
      attributes: !0
    }));
  }
  updateStepperSlottedInputValue() {
    this.fieldElement instanceof HTMLInputElement && this.fieldElement.addEventListener("input", (a) => {
      const o = a.target;
      o && (this.fieldElement.value = o.value, this.validatedStepper());
    });
  }
  validatedStepper() {
    var e, a;
    if (this.isStepper && this.fieldElement instanceof HTMLInputElement) {
      const o = this.fieldElement.value, n = new CustomEvent("change", {
        bubbles: !0,
        cancelable: !0,
        detail: {
          value: o
        }
      });
      this.fieldElement.dispatchEvent(n), o.length > 1 ? this.fieldElement.style.inlineSize = o.length + 3 + "ch" : this.fieldElement.style.inlineSize = "36px", (e = this.fieldElement.parentElement) != null && e.clientWidth && ((a = this.fieldElement.parentElement) == null ? void 0 : a.clientWidth) <= Zt.DEFAULT && (this.fieldElement.style.inlineSize = o.length + 3.5 + "ch"), this.fieldElement.setAttribute(
        "aria-invalid",
        String(this.setStepperValidity())
      ), this.disabledMinusValue = this.setMinusButtonState(), this.disabledPlusValue = this.setPlusButtonState();
    }
  }
  setStepperValidity() {
    if (this.fieldElement instanceof HTMLInputElement) {
      const { min: e, max: a, value: o } = this.fieldElement;
      return !!(e && Number(o) < Number(e) || a && Number(o) > Number(a));
    }
    return !1;
  }
  setMinusButtonState() {
    if (this.fieldElement instanceof HTMLInputElement) {
      if (this.fieldElement.min)
        return Number(this.fieldElement.min) >= Number(this.fieldElement.value);
      if (this.fieldElement.value === "0")
        return !0;
    }
    return !1;
  }
  setPlusButtonState() {
    return this.fieldElement instanceof HTMLInputElement && this.fieldElement.max ? Number(this.fieldElement.max) <= Number(this.fieldElement.value) : !1;
  }
  incrementStepper(e) {
    var a;
    if (this.fieldElement) {
      ((a = this.fieldElement) == null ? void 0 : a.value) === "" && (this.fieldElement.value = "0");
      const o = String(this.fieldElement.value), n = Number(o != null ? o : 0) + 1;
      this.fieldElement.value = String(n), this.fieldElement.defaultValue = this.fieldElement.value, this.validatedStepper();
    }
  }
  decrementStepper(e) {
    var a;
    if (this.fieldElement) {
      ((a = this.fieldElement) == null ? void 0 : a.value) === "" && (this.fieldElement.value = "0");
      const o = String(this.fieldElement.value), n = Number(o != null ? o : 0) - 1;
      this.fieldElement.value = String(n), this.fieldElement.defaultValue = this.fieldElement.value, this.validatedStepper();
    }
  }
  setDisabledState() {
    if (this.fieldElement) {
      if (this.fieldElement.disabled) {
        this.disabled = this.fieldElement.disabled;
        return;
      }
      const e = this.fieldElement.getAttribute("aria-disabled");
      e === null ? this.disabled = this.fieldElement.disabled : this.disabled = e === "true";
    }
  }
  setInvalidState() {
    if (this.fieldElement) {
      const e = this.fieldElement.getAttribute("aria-invalid");
      this.invalid = e === "true", this.associateErrorWithField(), this.controlGroup && (this.controlGroup.invalid = this.invalid);
    }
  }
  setReadOnlyState() {
    (this.fieldElement instanceof HTMLInputElement || this.fieldElement instanceof HTMLTextAreaElement) && (this.readOnly = this.fieldElement.readOnly);
  }
  // Initialize `isCheckboxChecked` to match the actual checked state
  initializeIsCheckboxChecked() {
    this.fieldElement instanceof HTMLInputElement && this.fieldElement.type === "checkbox" && (this.isCheckboxChecked = this.fieldElement.checked);
  }
  setSwitchRole() {
    this.fieldElement instanceof HTMLInputElement && this.fieldElement.type === "checkbox" && (this.toggleSwitch ? this.fieldElement.setAttribute("role", "switch") : this.fieldElement.removeAttribute("role"));
  }
  static setElementFromQuery(e) {
    return e[0];
  }
  static applyClassNameToField(e) {
    e && e.classList.add("beacon-control__field");
  }
  renderLabelSlot() {
    if (this.toggleSwitch) {
      const e = {
        "checkbox-checked": this.isCheckboxChecked,
        "toggle-switch-label": !0,
        label: !0
      };
      return pe`
        <span class=${Oe(e)}>
          <slot name="label">
            <span class="switch-on-label">
              <slot name="switch-on-label"></slot>
            </span>
            <span class="switch-off-label">
              <slot name="switch-off-label"></slot>
            </span>
          </slot>
        </span>
      `;
    }
    return pe`
      <div class="label" part="label">
        <slot
          name="label"
          @slotchange=${this.handleLabelSlotchange}
          ${Ue({ useParent: !0 })}></slot>
      </div>
    `;
  }
  renderIcon(e) {
    return e && e === "select" ? Be`<${this.getScopedTag("beacon-icon")} name="sorted_down" size="m" class="dropdown-icon"></${this.getScopedTag("beacon-icon")}>` : _e;
  }
  renderPrefix() {
    return this.isStepper ? Be`
      <div class="${Oe({
      stepper: !0,
      prefix: !0
    })}">
        <slot name="prefix">
          <${this.getScopedTag("beacon-icon-button")} 
          class="beacon-stepper-button" 
          variant="${this.stepperVariant}" 
          id="decrement"
          @beacon-event-click=${this.decrementStepper}
          ?disabled=${this.disabled || this.disabledMinusValue}>
          <${this.getScopedTag("beacon-icon")} name="remove" size="s" slot="icon"></${this.getScopedTag("beacon-icon")}> decrement button
          </${this.getScopedTag("beacon-icon-button")}>
        </slot>
      </div>
      ` : pe`
        <div class="prefix">
          <slot name="prefix" ${Ue({ useParent: !0 })}></slot>
        </div>
      `;
  }
  renderSuffix() {
    const e = this.disablePasswordToggle || this.disabled || this.readOnly;
    if (this._inputType === "password" && !e) {
      const a = {
        password: !0,
        "password-visible": this.passwordVisible,
        suffix: !0
      };
      return Be`
        <div class="${Oe(a)}">
          <slot name="suffix">
            <${this.getScopedTag("beacon-button")} class="password-toggle" variant="tertiary" scale="mini" @beacon-event-click=${this.handleTogglePassword}>
              <span class="show-password">
                <slot name="show-password">Show</slot>
              </span>
              <span class="hide-password">
                <slot name="hide-password">Hide</slot>
              </span>
            </${this.getScopedTag("beacon-button")}>
          </slot>
        </div>
      `;
    }
    return this.isStepper ? Be`
      <div class="${Oe({
      stepper: !0,
      suffix: !0
    })}">
        <slot name="suffix">
          <${this.getScopedTag("beacon-icon-button")} 
          class="beacon-stepper-button" 
          variant="${this.stepperVariant}"
          id="increment" 
          @beacon-event-click=${this.incrementStepper}
          ?disabled=${this.disabled || this.disabledPlusValue}>
          <${this.getScopedTag("beacon-icon")} name="add" size="s" slot="icon"></${this.getScopedTag("beacon-icon")}> increment button
          </${this.getScopedTag("beacon-icon-button")}>
        </slot>
      </div>
      ` : pe`
        <div class="suffix">
          <slot name="suffix" ${Ue({ useParent: !0 })}></slot>
        </div>
      `;
  }
  handleTogglePassword(e) {
    var a, o;
    this.passwordVisible = !this.passwordVisible, this.passwordVisible ? (a = this.fieldElement) == null || a.setAttribute("type", "text") : (o = this.fieldElement) == null || o.setAttribute("type", "password");
  }
  // helps with syncing the browser UI with our modes
  setColorSchemeCSS() {
    const e = this.closest('[class*="beacon-on"]');
    if (e) {
      const a = Array.from(
        e.classList
      ).find((o) => o.startsWith("beacon-on"));
      a != null && a.includes("dark") && (this.dataset.mode = "dark");
    }
  }
  render() {
    const e = {
      active: this.inline,
      "inline-wrapper": !0
    }, a = {
      group: !0,
      inline: this.inline
    }, o = {
      disabled: this.disabled,
      field: !0,
      readonly: this.readOnly,
      invalid: this.invalid,
      stepper: this.isStepper
    };
    return this._inputType && (o[this._inputType] = !0), pe`
      <div class="${Oe(e)}">
        <div class="${Oe(a)}">
          ${this.renderLabelSlot()}
          <!-- prettier-ignore -->
          <div class="${Oe(o)}" part="field">
          ${this.renderPrefix()}
          ${this.renderFormControlTemplate()}
          ${this.renderIcon(this._inputType)}
          ${this.renderSuffix()}
        </div>
        </div>
        ${this.renderHintTemplate()} ${this.renderErrorTemplate()}
      </div>
    `;
  }
}, ji = new WeakMap(), ms = new WeakMap(), wa.tagName = Fu.beaconTagName, wa.nestedComponents = [
  Rl,
  Zo,
  fo,
  eo
], wa);
Vt([
  ue({ type: Boolean })
], Kt.prototype, "inline", 2);
Vt([
  ue({ type: Boolean, attribute: "disable-password-toggle" })
], Kt.prototype, "disablePasswordToggle", 2);
Vt([
  ue({ type: Boolean, attribute: "disable-toggle-switch-label" })
], Kt.prototype, "disableToggleSwitchLabel", 2);
Vt([
  ue({ type: Boolean, reflect: !0, attribute: "non-resizable" })
], Kt.prototype, "nonResizable", 2);
Vt([
  ue({ type: Boolean, reflect: !0, attribute: "toggle-switch" })
], Kt.prototype, "toggleSwitch", 2);
Vt([
  ue({ type: Boolean, reflect: !0 })
], Kt.prototype, "readOnly", 2);
Vt([
  ue({ type: String, reflect: !0, attribute: "stepper-variant" })
], Kt.prototype, "stepperVariant", 2);
Vt([
  Se()
], Kt.prototype, "disabledMinusValue", 2);
Vt([
  Se()
], Kt.prototype, "disabledPlusValue", 2);
Vt([
  Se()
], Kt.prototype, "passwordVisible", 2);
Vt([
  Se()
], Kt.prototype, "isCheckboxChecked", 2);
Vt([
  Ge("[toggle-password]")
], Kt.prototype, "passwordToggleButton", 2);
Vt([
  wt({ flatten: !0, slot: "label" })
], Kt.prototype, "labelElements", 2);
Vt([
  wt({
    flatten: !0,
    slot: "suffix",
    selector: "[toggle-password]"
  })
], Kt.prototype, "togglePasswordButtons", 2);
Vt([
  De
], Kt.prototype, "setColorSchemeCSS", 1);
let wc = Kt;
const _u = {
  beaconTagName: "beacon-control-group"
}, Q2 = ve`[beacon-tag-name=beacon-control-group] [slot=label]:not(label){font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-headline-50)}[beacon-tag-name=beacon-control-group] [beacon-tag-name=beacon-control] label{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100)}[beacon-tag-name=beacon-control-group] [beacon-tag-name=beacon-control]:has(input)[toggle-switch] label{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-body-100)}[beacon-tag-name=beacon-control-group] [beacon-tag-name=beacon-control]:has(input[aria-disabled=true],:disabled) label{color:var(--beacon-system-color-text-inactive)}[beacon-tag-name=beacon-control-group] [beacon-tag-name=beacon-control]:has([type=radio],[type=checkbox]){padding-block:var(--beacon-reference-space-3);padding-inline-end:var(--beacon-reference-space-3)}`, X2 = ve`fieldset{border:0;margin:0;padding:0}legend{margin-block-end:var(--beacon-reference-space-3);padding:0}.error:not(.visible){display:none}.hint{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100)}.hint,.error{margin-block-start:var(--beacon-reference-space-3)}`;
var Z2 = Object.defineProperty, J2 = Object.getOwnPropertyDescriptor, kc = (i, t, e, a) => {
  for (var o = J2(t, e), n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = r(t, e, o) || o);
  return o && Z2(t, e, o), o;
}, Kn, Gn;
const Gl = class Gl extends Ke(Le).with(
  Zh,
  $f,
  Xh
) {
  constructor() {
    super(...arguments);
    Fe(this, Kn);
    Fe(this, Gn);
    this.beaconTagName = _u.beaconTagName, this.resetSpacing = !0, this.focusOverride = !0, Ne(this, Kn, !1), Ne(this, Gn, "false");
  }
  static get styles() {
    return [super.styles, X2];
  }
  static get lightDOMStyles() {
    return [super.lightDOMStyles, Q2];
  }
  get required() {
    return ze(this, Kn);
  }
  set required(e) {
    Ne(this, Kn, e), this.controls.length > 0 && this.controls.forEach((a) => this.setRequiredToField(a));
  }
  _postSetDisabled() {
    this.controls.length > 0 && this.controls.forEach((e) => this.setDisabledToField(e));
  }
  get isAriaDisabled() {
    return ze(this, Gn);
  }
  set isAriaDisabled(e) {
    Ne(this, Gn, e), this.controls.length > 0 && this.controls.forEach((a) => this.setDisabledToField(a, "aria"));
  }
  _postSetInvalid() {
    this.controls.length > 0 && this.controls.forEach((e) => this.setInvalidToField(e));
  }
  get controls() {
    return Array.from(
      this.querySelectorAll('[beacon-tag-name="beacon-control"]')
    );
  }
  getAriaDescribedByIds() {
    var a, o;
    const e = [(a = this.hintElement) == null ? void 0 : a.id];
    return this.invalid && e.push((o = this.errorElement) == null ? void 0 : o.id), e;
  }
  handleSlottedControlFieldSet(e) {
    const { target: a } = e;
    a && (this.disabled && this.setDisabledToField(a), this.isAriaDisabled && this.setDisabledToField(a, "aria"), this.invalid && this.setInvalidToField(a), this.required && this.setRequiredToField(a), this.setHintDataId(a), a.setFieldAriaDescribedBy(
      this.getAriaDescribedByIds()
    ));
  }
  setRequiredToField(e) {
    e.fieldElement && (e.fieldElement.required = this.required);
  }
  setDisabledToField(e, a = "boolean") {
    e.fieldElement && (a === "boolean" && (e.fieldElement.disabled = this.disabled), a === "aria" && e.fieldElement.setAttribute(
      "aria-disabled",
      String(this.isAriaDisabled)
    ));
  }
  setInvalidToField(e) {
    var a;
    e.fieldElement && (e.dataset.errorId = (a = this.errorElement) == null ? void 0 : a.id, e.fieldElement.setAttribute("aria-invalid", String(this.invalid)));
  }
  setHintDataId(e) {
    var a, o;
    e.fieldElement && ((a = this.hintElement) != null && a.id) && (e.dataset.hintId = (o = this.hintElement) == null ? void 0 : o.id);
  }
  render() {
    return pe`
      <fieldset>
        <legend>
          <slot name="label" ${Ue({ useParent: !0 })}></slot>
        </legend>
        <div class="controls">
          <slot
            @beacon-event-control-set=${this.handleSlottedControlFieldSet}></slot>
        </div>
        ${this.renderHintTemplate()} ${this.renderErrorTemplate()}
      </fieldset>
    `;
  }
};
Kn = new WeakMap(), Gn = new WeakMap(), Gl.tagName = _u.beaconTagName, Gl.nestedComponents = [Rl];
let or = Gl;
kc([
  ue({ type: Boolean, reflect: !0 })
], or.prototype, "required");
kc([
  yo("disabled")
], or.prototype, "_postSetDisabled");
kc([
  ue({ attribute: "aria-disabled" })
], or.prototype, "isAriaDisabled");
kc([
  yo("invalid")
], or.prototype, "_postSetInvalid");
const eT = /* @__PURE__ */ new Map([
  ["united_states", "usa"],
  ["mainland_china", "china"],
  ["asia_regional", "apac"]
]), tT = {
  irregularFlagNamesMap: eT
}, oT = ve`::slotted([slot=icon]),svg{block-size:var(--beacon-reference-space-5);inline-size:var(--beacon-reference-space-6)}`;
var aT = Object.defineProperty, iT = Object.getOwnPropertyDescriptor, al = (i, t, e, a) => {
  for (var o = a > 1 ? void 0 : a ? iT(t, e) : t, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = (a ? r(t, e, o) : r(o)) || o);
  return a && o && aT(t, e, o), o;
};
function nT(i) {
  let t = class extends i {
    static get flagStyles() {
      return [oT];
    }
    /** The text inside the element that is in the title slot */
    get title() {
      const e = this.querySelector('[slot="title"]');
      return e && e instanceof HTMLElement ? e.innerText : "";
    }
    get flagSVG() {
      var e;
      return (e = this.slottedFlag) != null ? e : this.shadowFlag;
    }
    /** Callback for on beacon-event-country-flag-change */
    onBeaconCountryFlagChange() {
    }
    emitFlagChange() {
      Re(
        this,
        Ee.COUNTRY_FLAG_CHANGE,
        void 0,
        this.onBeaconCountryFlagChange
      );
    }
    handleFlagSlotchange() {
      this.emitFlagChange();
    }
    static createFlagName(e) {
      e = e.toLowerCase().replace(" ", "_");
      const a = tT.irregularFlagNamesMap.get(e);
      return Km.get(e) === "flags" ? e : a !== void 0 ? a : "usa";
    }
    renderFlagContainer() {
      const e = this.title, a = t.createFlagName(e);
      return Be`<slot name="icon" @slotchange=${this.handleFlagSlotchange}
        ><${this.getScopedTag("beacon-icon")} name="${a}" id="${a}"></${this.getScopedTag("beacon-icon")}></slot
      >`;
    }
    /** HTML for the title container. */
    renderTitleContainer() {
      return pe`<div class="title">
        <slot name="title"></slot>
      </div>`;
    }
    postrenderFlagChange() {
      this.emitFlagChange();
    }
  };
  return al([
    Ge('slot[name="icon"] > *')
  ], t.prototype, "shadowFlag", 2), al([
    bn('[slot="icon"]')
  ], t.prototype, "slottedFlag", 2), al([
    De
  ], t.prototype, "postrenderFlagChange", 1), t = al([
    je("Flags")
  ], t), t;
}
function yr(i, t) {
  return i.has(t) && typeof i.get(t) < "u";
}
function Vf(i) {
  if (!i)
    return [];
  const t = [i];
  return i.children.length === 0 || Array.from(i.children).forEach((e) => {
    const a = Vf(e);
    a && t.push(...a);
  }), t;
}
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const Uu = (i) => g2(i) ? i._$litType$.h : i.strings, rT = Oa(class extends Pa {
  constructor(i) {
    super(i), this.et = /* @__PURE__ */ new WeakMap();
  }
  render(i) {
    return [i];
  }
  update(i, [t]) {
    const e = Lu(this.it) ? Uu(this.it) : null, a = Lu(t) ? Uu(t) : null;
    if (e !== null && (a === null || e !== a)) {
      const o = rh(i).pop();
      let n = this.et.get(e);
      if (n === void 0) {
        const r = document.createDocumentFragment();
        n = Es(_e, r), n.setConnected(!1), this.et.set(e, n);
      }
      nh(n, [o]), Bi(n, void 0, o);
    }
    if (a !== null) {
      if (e === null || e !== a) {
        const o = this.et.get(a);
        if (o !== void 0) {
          const n = rh(o).pop();
          f2(i), Bi(i, void 0, n), nh(i, [n]);
        }
      }
      this.it = t;
    } else this.it = void 0;
    return this.render(t);
  }
});
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const Yf = "important", sT = " !" + Yf, Qf = Oa(class extends Pa {
  constructor(i) {
    var t;
    if (super(i), i.type !== ln.ATTRIBUTE || i.name !== "style" || ((t = i.strings) == null ? void 0 : t.length) > 2) throw Error("The `styleMap` directive must be used in the `style` attribute and must be the only part in the attribute.");
  }
  render(i) {
    return Object.keys(i).reduce((t, e) => {
      const a = i[e];
      return a == null ? t : t + `${e = e.includes("-") ? e : e.replace(/(?:^(webkit|moz|ms|o)|)(?=[A-Z])/g, "-$&").toLowerCase()}:${a};`;
    }, "");
  }
  update(i, [t]) {
    const { style: e } = i.element;
    if (this.ft === void 0) return this.ft = new Set(Object.keys(t)), this.render(t);
    for (const a of this.ft) t[a] == null && (this.ft.delete(a), a.includes("-") ? e.removeProperty(a) : e[a] = null);
    for (const a in t) {
      const o = t[a];
      if (o != null) {
        this.ft.add(a);
        const n = typeof o == "string" && o.endsWith(sT);
        a.includes("-") || n ? e.setProperty(a, n ? o.slice(0, -11) : o, n ? Yf : "") : e[a] = o;
      }
    }
    return Qo;
  }
}), lT = ve`:root,.beacon-on-light{--beacon-system-color-background-tertiary-pressed: #0063AD1F;--beacon-system-color-background-tertiary-hover: #0063AD14;--beacon-system-color-background-secondary-pressed: #0063AD1F;--beacon-system-color-background-secondary-hover: #0063AD14;--beacon-system-color-background-blanket: #061937A3;--beacon-component-table-color-background-selected: #8ff1ff29;--beacon-component-form-color-background-inactive: #FFFFFFE0;--beacon-system-color-text-title: var(--beacon-reference-palette-primary-midnight-navy-1);--beacon-system-color-text-tertiary-pressed: var(--beacon-reference-palette-functional-blue-1);--beacon-system-color-text-tertiary-inactive: var(--beacon-reference-palette-grayscale-medium-gray-3);--beacon-system-color-text-tertiary-hover: var(--beacon-reference-palette-functional-blue-2);--beacon-system-color-text-tertiary: var(--beacon-reference-palette-functional-blue-3);--beacon-system-color-text-standard: var(--beacon-reference-palette-primary-midnight-navy-1);--beacon-system-color-text-set-white: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-text-set-navy: var(--beacon-reference-palette-primary-midnight-navy-1);--beacon-system-color-text-secondary-pressed: var(--beacon-reference-palette-functional-blue-1);--beacon-system-color-text-secondary-inactive: var(--beacon-reference-palette-grayscale-medium-gray-3);--beacon-system-color-text-secondary-hover: var(--beacon-reference-palette-functional-blue-2);--beacon-system-color-text-secondary: var(--beacon-reference-palette-functional-blue-3);--beacon-system-color-text-primary-inactive: var(--beacon-reference-palette-grayscale-light-gray-2);--beacon-system-color-text-primary: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-text-link: var(--beacon-reference-palette-functional-blue-3);--beacon-system-color-text-link-active: var(--beacon-reference-palette-primary-midnight-navy-1);--beacon-system-color-text-inactive: var(--beacon-reference-palette-grayscale-medium-gray-3);--beacon-system-color-text-error: var(--beacon-reference-palette-functional-red-3);--beacon-system-color-shadow-low: 0rem 0rem var(--beacon-reference-space-2) 0rem var(--beacon-reference-palette-grayscale-shadow-1);--beacon-system-color-shadow-high: 0rem 0rem var(--beacon-reference-space-7) 0rem var(--beacon-reference-palette-grayscale-shadow-3);--beacon-system-color-shadow-medium: 0rem 0rem var(--beacon-reference-space-4) 0rem var(--beacon-reference-palette-grayscale-shadow-2);--beacon-system-color-icon-tertiary-pressed: var(--beacon-reference-palette-functional-blue-1);--beacon-system-color-icon-tertiary-inactive: var(--beacon-reference-palette-grayscale-medium-gray-3);--beacon-system-color-icon-tertiary-hover: var(--beacon-reference-palette-functional-blue-2);--beacon-system-color-icon-tertiary: var(--beacon-reference-palette-functional-blue-3);--beacon-system-color-icon-standard: var(--beacon-reference-palette-primary-midnight-navy-1);--beacon-system-color-icon-set-white: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-icon-set-navy: var(--beacon-reference-palette-primary-midnight-navy-1);--beacon-system-color-icon-secondary-pressed: var(--beacon-reference-palette-functional-blue-1);--beacon-system-color-icon-secondary-inactive: var(--beacon-reference-palette-grayscale-medium-gray-3);--beacon-system-color-icon-secondary-hover: var(--beacon-reference-palette-functional-blue-2);--beacon-system-color-icon-secondary: var(--beacon-reference-palette-functional-blue-3);--beacon-system-color-icon-primary-inactive: var(--beacon-reference-palette-grayscale-light-gray-2);--beacon-system-color-icon-primary: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-icon-positive: var(--beacon-reference-palette-functional-green-3);--beacon-system-color-icon-link: var(--beacon-reference-palette-functional-blue-3);--beacon-system-color-icon-link-active: var(--beacon-reference-palette-primary-midnight-navy-1);--beacon-system-color-icon-highlight: var(--beacon-reference-palette-primary-bright-blue-2);--beacon-system-color-icon-error: var(--beacon-reference-palette-functional-red-3);--beacon-system-color-data-viz-11: var(--beacon-reference-palette-charts-gray-lt-5);--beacon-system-color-data-viz-10: var(--beacon-reference-palette-charts-gray-lt-3);--beacon-system-color-data-viz-9: var(--beacon-reference-palette-charts-orange-lt-5);--beacon-system-color-data-viz-8: var(--beacon-reference-palette-charts-orange-lt-3);--beacon-system-color-data-viz-7: var(--beacon-reference-palette-charts-berry-lt-5);--beacon-system-color-data-viz-6: var(--beacon-reference-palette-charts-berry-lt-2);--beacon-system-color-border-secondary-pressed: var(--beacon-reference-palette-functional-blue-1);--beacon-system-color-border-secondary-inactive: var(--beacon-reference-palette-grayscale-medium-gray-3);--beacon-system-color-border-secondary-hover: var(--beacon-reference-palette-functional-blue-2);--beacon-system-color-border-secondary: var(--beacon-reference-palette-functional-blue-3);--beacon-system-color-border-primary: var(--beacon-reference-palette-functional-blue-3);--beacon-system-color-border-positive: var(--beacon-reference-palette-functional-green-3);--beacon-system-color-border-link-focus: var(--beacon-reference-palette-grayscale-black);--beacon-system-color-border-link: var(--beacon-reference-palette-functional-blue-3);--beacon-system-color-border-focus-outer: var(--beacon-reference-palette-secondary-gold-2);--beacon-system-color-border-focus-middle: var(--beacon-reference-palette-grayscale-black);--beacon-system-color-border-focus-inner: var(--beacon-reference-palette-grayscale-light-gray-4);--beacon-system-color-border-error: var(--beacon-reference-palette-functional-red-3);--beacon-system-color-border-brand: var(--beacon-reference-palette-primary-bright-blue-2);--beacon-system-color-border-active: var(--beacon-reference-palette-functional-blue-3);--beacon-system-color-border-2: var(--beacon-reference-palette-grayscale-light-gray-2);--beacon-system-color-border-1: var(--beacon-reference-palette-grayscale-light-gray-3);--beacon-system-color-border-0: var(--beacon-reference-palette-grayscale-light-gray-2);--beacon-system-color-background-primary-pressed: var(--beacon-reference-palette-functional-blue-1);--beacon-system-color-background-primary-inactive: var(--beacon-reference-palette-grayscale-medium-gray-3);--beacon-system-color-background-primary-hover: var(--beacon-reference-palette-functional-blue-2);--beacon-system-color-background-primary: var(--beacon-reference-palette-functional-blue-3);--beacon-system-color-background-positive-pressed: var(--beacon-reference-palette-functional-green-1);--beacon-system-color-background-positive-hover: var(--beacon-reference-palette-functional-green-2);--beacon-system-color-background-positive: var(--beacon-reference-palette-functional-green-3);--beacon-system-color-background-negative-pressed: var(--beacon-reference-palette-functional-red-1);--beacon-system-color-background-negative-hover: var(--beacon-reference-palette-functional-red-2);--beacon-system-color-background-negative: var(--beacon-reference-palette-functional-red-3);--beacon-system-color-background-link-focus: var(--beacon-reference-palette-secondary-gold-2);--beacon-system-color-background-brand: var(--beacon-reference-palette-primary-bright-blue-2);--beacon-system-color-background-2: var(--beacon-reference-palette-grayscale-light-gray-4);--beacon-system-color-background-1: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-background-0: var(--beacon-reference-palette-grayscale-light-gray-4);--beacon-component-tile-collection-color-border-green: var(--beacon-reference-palette-secondary-green-3);--beacon-component-tile-collection-color-border-gold: var(--beacon-reference-palette-secondary-gold-3);--beacon-component-tile-collection-color-border-blue: var(--beacon-reference-palette-secondary-ocean-3);--beacon-component-tile-collection-color-border-berry: var(--beacon-reference-palette-secondary-berry-3);--beacon-component-tile-collection-color-background-green: var(--beacon-reference-palette-secondary-green-1);--beacon-component-tile-collection-color-background-gold: var(--beacon-reference-palette-secondary-gold-1);--beacon-component-tile-collection-color-background-blue: var(--beacon-reference-palette-functional-blue-2);--beacon-component-tile-collection-color-background-berry: var(--beacon-reference-palette-secondary-berry-1);--beacon-component-table-color-border: var(--beacon-reference-palette-grayscale-light-gray-1);--beacon-component-tab-menu-color-background-primary-active: var(--beacon-reference-palette-functional-blue-6);--beacon-component-scrollbar-color-background-track: var(--beacon-reference-palette-grayscale-light-gray-2);--beacon-component-scrollbar-color-background-thumb-pressed: var(--beacon-reference-palette-grayscale-dark-gray-1);--beacon-component-scrollbar-color-background-thumb-hover: var(--beacon-reference-palette-grayscale-dark-gray-2);--beacon-component-scrollbar-color-background-thumb: var(--beacon-reference-palette-grayscale-dark-gray-3);--beacon-component-progress-indicator-color-background-incomplete: var(--beacon-reference-palette-functional-blue-9);--beacon-component-progress-indicator-color-background-complete: var(--beacon-reference-palette-functional-blue-1);--beacon-component-notification-color-border-informational: var(--beacon-reference-palette-functional-blue-3);--beacon-component-notification-color-background-standard: var(--beacon-reference-palette-grayscale-white);--beacon-component-primary-navigation-site-menu-color-text-link: var(--beacon-reference-palette-functional-blue-3);--beacon-component-primary-navigation-header-color-text-link: var(--beacon-reference-palette-functional-blue-3);--beacon-component-form-color-foreground-inactive: var(--beacon-reference-palette-grayscale-medium-gray-3);--beacon-component-form-color-border-standard: var(--beacon-reference-palette-grayscale-medium-gray-2);--beacon-component-data-viz-color-border-minor: var(--beacon-reference-palette-grayscale-medium-gray-4);--beacon-component-data-viz-color-border-major: var(--beacon-reference-palette-grayscale-medium-gray-1);--beacon-component-control-chip-color-background-default: var(--beacon-reference-palette-grayscale-light-gray-3);--beacon-component-avatar-icon-color-background: var(--beacon-reference-palette-grayscale-light-gray-5);--beacon-component-avatar-icon-color-avatar: var(--beacon-reference-palette-grayscale-light-gray-2)}.beacon-on-lighter{--beacon-system-color-background-tertiary-pressed: #0063AD1F;--beacon-system-color-background-tertiary-hover: #0063AD14;--beacon-system-color-background-secondary-pressed: #0063AD1F;--beacon-system-color-background-secondary-hover: #0063AD14;--beacon-system-color-background-blanket: #061937A3;--beacon-component-table-color-background-selected: #8ff1ff33;--beacon-component-form-color-background-inactive: #F4F5F6B8;--beacon-system-color-text-title: var(--beacon-reference-palette-primary-midnight-navy-1);--beacon-system-color-text-tertiary-pressed: var(--beacon-reference-palette-functional-blue-1);--beacon-system-color-text-tertiary-inactive: var(--beacon-reference-palette-grayscale-medium-gray-3);--beacon-system-color-text-tertiary-hover: var(--beacon-reference-palette-functional-blue-2);--beacon-system-color-text-tertiary: var(--beacon-reference-palette-functional-blue-3);--beacon-system-color-text-standard: var(--beacon-reference-palette-primary-midnight-navy-1);--beacon-system-color-text-set-white: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-text-set-navy: var(--beacon-reference-palette-primary-midnight-navy-1);--beacon-system-color-text-secondary-pressed: var(--beacon-reference-palette-functional-blue-1);--beacon-system-color-text-secondary-inactive: var(--beacon-reference-palette-grayscale-medium-gray-3);--beacon-system-color-text-secondary-hover: var(--beacon-reference-palette-functional-blue-2);--beacon-system-color-text-secondary: var(--beacon-reference-palette-functional-blue-3);--beacon-system-color-text-primary-inactive: var(--beacon-reference-palette-grayscale-light-gray-2);--beacon-system-color-text-primary: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-text-link: var(--beacon-reference-palette-functional-blue-3);--beacon-system-color-text-link-active: var(--beacon-reference-palette-primary-midnight-navy-1);--beacon-system-color-text-inactive: var(--beacon-reference-palette-grayscale-medium-gray-3);--beacon-system-color-text-error: var(--beacon-reference-palette-functional-red-3);--beacon-system-color-shadow-low: 0rem 0rem var(--beacon-reference-space-2) 0rem var(--beacon-reference-palette-grayscale-shadow-1);--beacon-system-color-shadow-high: 0rem 0rem var(--beacon-reference-space-7) 0rem var(--beacon-reference-palette-grayscale-shadow-3);--beacon-system-color-shadow-medium: 0rem 0rem var(--beacon-reference-space-4) 0rem var(--beacon-reference-palette-grayscale-shadow-2);--beacon-system-color-icon-tertiary-pressed: var(--beacon-reference-palette-functional-blue-1);--beacon-system-color-icon-tertiary-inactive: var(--beacon-reference-palette-grayscale-medium-gray-3);--beacon-system-color-icon-tertiary-hover: var(--beacon-reference-palette-functional-blue-2);--beacon-system-color-icon-tertiary: var(--beacon-reference-palette-functional-blue-3);--beacon-system-color-icon-standard: var(--beacon-reference-palette-primary-midnight-navy-1);--beacon-system-color-icon-set-white: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-icon-set-navy: var(--beacon-reference-palette-primary-midnight-navy-1);--beacon-system-color-icon-secondary-pressed: var(--beacon-reference-palette-functional-blue-1);--beacon-system-color-icon-secondary-inactive: var(--beacon-reference-palette-grayscale-medium-gray-3);--beacon-system-color-icon-secondary-hover: var(--beacon-reference-palette-functional-blue-2);--beacon-system-color-icon-secondary: var(--beacon-reference-palette-functional-blue-3);--beacon-system-color-icon-primary-inactive: var(--beacon-reference-palette-grayscale-light-gray-2);--beacon-system-color-icon-primary: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-icon-positive: var(--beacon-reference-palette-functional-green-3);--beacon-system-color-icon-link: var(--beacon-reference-palette-functional-blue-3);--beacon-system-color-icon-link-active: var(--beacon-reference-palette-primary-midnight-navy-1);--beacon-system-color-icon-highlight: var(--beacon-reference-palette-primary-bright-blue-2);--beacon-system-color-icon-error: var(--beacon-reference-palette-functional-red-3);--beacon-system-color-data-viz-11: var(--beacon-reference-palette-charts-gray-lt-5);--beacon-system-color-data-viz-10: var(--beacon-reference-palette-charts-gray-lt-3);--beacon-system-color-data-viz-9: var(--beacon-reference-palette-charts-orange-lt-5);--beacon-system-color-data-viz-8: var(--beacon-reference-palette-charts-orange-lt-3);--beacon-system-color-data-viz-7: var(--beacon-reference-palette-charts-berry-lt-5);--beacon-system-color-data-viz-6: var(--beacon-reference-palette-charts-berry-lt-2);--beacon-system-color-border-secondary-pressed: var(--beacon-reference-palette-functional-blue-1);--beacon-system-color-border-secondary-inactive: var(--beacon-reference-palette-grayscale-medium-gray-3);--beacon-system-color-border-secondary-hover: var(--beacon-reference-palette-functional-blue-2);--beacon-system-color-border-secondary: var(--beacon-reference-palette-functional-blue-3);--beacon-system-color-border-primary: var(--beacon-reference-palette-functional-blue-3);--beacon-system-color-border-positive: var(--beacon-reference-palette-functional-green-3);--beacon-system-color-border-link-focus: var(--beacon-reference-palette-grayscale-black);--beacon-system-color-border-link: var(--beacon-reference-palette-functional-blue-3);--beacon-system-color-border-focus-outer: var(--beacon-reference-palette-secondary-gold-2);--beacon-system-color-border-focus-middle: var(--beacon-reference-palette-grayscale-black);--beacon-system-color-border-focus-inner: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-border-error: var(--beacon-reference-palette-functional-red-3);--beacon-system-color-border-brand: var(--beacon-reference-palette-primary-bright-blue-2);--beacon-system-color-border-active: var(--beacon-reference-palette-functional-blue-3);--beacon-system-color-border-2: var(--beacon-reference-palette-grayscale-light-gray-3);--beacon-system-color-border-1: var(--beacon-reference-palette-grayscale-light-gray-2);--beacon-system-color-border-0: var(--beacon-reference-palette-grayscale-light-gray-3);--beacon-system-color-background-primary-pressed: var(--beacon-reference-palette-functional-blue-1);--beacon-system-color-background-primary-inactive: var(--beacon-reference-palette-grayscale-medium-gray-3);--beacon-system-color-background-primary-hover: var(--beacon-reference-palette-functional-blue-2);--beacon-system-color-background-primary: var(--beacon-reference-palette-functional-blue-3);--beacon-system-color-background-positive-pressed: var(--beacon-reference-palette-functional-green-1);--beacon-system-color-background-positive-hover: var(--beacon-reference-palette-functional-green-2);--beacon-system-color-background-positive: var(--beacon-reference-palette-functional-green-3);--beacon-system-color-background-negative-pressed: var(--beacon-reference-palette-functional-red-1);--beacon-system-color-background-negative-hover: var(--beacon-reference-palette-functional-red-2);--beacon-system-color-background-negative: var(--beacon-reference-palette-functional-red-3);--beacon-system-color-background-link-focus: var(--beacon-reference-palette-secondary-gold-2);--beacon-system-color-background-brand: var(--beacon-reference-palette-primary-bright-blue-2);--beacon-system-color-background-2: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-background-1: var(--beacon-reference-palette-grayscale-light-gray-4);--beacon-system-color-background-0: var(--beacon-reference-palette-grayscale-white);--beacon-component-tile-collection-color-border-green: var(--beacon-reference-palette-secondary-green-3);--beacon-component-tile-collection-color-border-gold: var(--beacon-reference-palette-secondary-gold-3);--beacon-component-tile-collection-color-border-blue: var(--beacon-reference-palette-secondary-ocean-3);--beacon-component-tile-collection-color-border-berry: var(--beacon-reference-palette-secondary-berry-3);--beacon-component-tile-collection-color-background-green: var(--beacon-reference-palette-secondary-green-1);--beacon-component-tile-collection-color-background-gold: var(--beacon-reference-palette-secondary-gold-1);--beacon-component-tile-collection-color-background-blue: var(--beacon-reference-palette-functional-blue-2);--beacon-component-tile-collection-color-background-berry: var(--beacon-reference-palette-secondary-berry-1);--beacon-component-table-color-border: var(--beacon-reference-palette-grayscale-light-gray-1);--beacon-component-tab-menu-color-background-primary-active: var(--beacon-reference-palette-functional-blue-6);--beacon-component-scrollbar-color-background-track: var(--beacon-reference-palette-grayscale-light-gray-2);--beacon-component-scrollbar-color-background-thumb-pressed: var(--beacon-reference-palette-grayscale-dark-gray-1);--beacon-component-scrollbar-color-background-thumb-hover: var(--beacon-reference-palette-grayscale-dark-gray-2);--beacon-component-scrollbar-color-background-thumb: var(--beacon-reference-palette-grayscale-dark-gray-3);--beacon-component-progress-indicator-color-background-incomplete: var(--beacon-reference-palette-functional-blue-9);--beacon-component-progress-indicator-color-background-complete: var(--beacon-reference-palette-functional-blue-1);--beacon-component-notification-color-border-informational: var(--beacon-reference-palette-functional-blue-3);--beacon-component-notification-color-background-standard: var(--beacon-reference-palette-grayscale-light-gray-4);--beacon-component-primary-navigation-site-menu-color-text-link: var(--beacon-reference-palette-functional-blue-3);--beacon-component-primary-navigation-header-color-text-link: var(--beacon-reference-palette-functional-blue-3);--beacon-component-form-color-foreground-inactive: var(--beacon-reference-palette-grayscale-medium-gray-3);--beacon-component-form-color-border-standard: var(--beacon-reference-palette-grayscale-medium-gray-2);--beacon-component-data-viz-color-border-minor: var(--beacon-reference-palette-grayscale-medium-gray-4);--beacon-component-data-viz-color-border-major: var(--beacon-reference-palette-grayscale-medium-gray-1);--beacon-component-control-chip-color-background-default: var(--beacon-reference-palette-grayscale-light-gray-3);--beacon-component-avatar-icon-color-background: var(--beacon-reference-palette-grayscale-light-gray-5);--beacon-component-avatar-icon-color-avatar: var(--beacon-reference-palette-grayscale-light-gray-2)}.beacon-on-dark{--beacon-system-color-background-tertiary-pressed: #FFFFFF1F;--beacon-system-color-background-tertiary-hover: #FFFFFF14;--beacon-system-color-background-secondary-pressed: #FFFFFF1F;--beacon-system-color-background-secondary-hover: #FFFFFF14;--beacon-system-color-background-blanket: #061937A3;--beacon-component-table-color-background-selected: #8ff1ff29;--beacon-component-form-color-background-inactive: #061937B8;--beacon-system-color-text-title: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-text-tertiary-pressed: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-text-tertiary-inactive: var(--beacon-reference-palette-grayscale-medium-gray-1);--beacon-system-color-text-tertiary-hover: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-text-tertiary: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-text-standard: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-text-set-white: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-text-set-navy: var(--beacon-reference-palette-primary-midnight-navy-1);--beacon-system-color-text-secondary-pressed: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-text-secondary-inactive: var(--beacon-reference-palette-grayscale-medium-gray-1);--beacon-system-color-text-secondary-hover: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-text-secondary: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-text-primary-inactive: var(--beacon-reference-palette-grayscale-medium-gray-4);--beacon-system-color-text-primary: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-text-link: var(--beacon-reference-palette-functional-blue-9);--beacon-system-color-text-link-active: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-text-inactive: var(--beacon-reference-palette-grayscale-medium-gray-1);--beacon-system-color-text-error: var(--beacon-reference-palette-functional-red-3);--beacon-system-color-shadow-low: 0rem 0rem var(--beacon-reference-space-2) 0rem var(--beacon-reference-palette-primary-shadow-1);--beacon-system-color-shadow-high: 0rem 0rem var(--beacon-reference-space-7) 0rem var(--beacon-reference-palette-primary-shadow-3);--beacon-system-color-shadow-medium: 0rem 0rem var(--beacon-reference-space-4) 0rem var(--beacon-reference-palette-primary-shadow-2);--beacon-system-color-icon-tertiary-pressed: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-icon-tertiary-inactive: var(--beacon-reference-palette-grayscale-medium-gray-1);--beacon-system-color-icon-tertiary-hover: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-icon-tertiary: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-icon-standard: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-icon-set-white: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-icon-set-navy: var(--beacon-reference-palette-primary-midnight-navy-1);--beacon-system-color-icon-secondary-pressed: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-icon-secondary-inactive: var(--beacon-reference-palette-grayscale-medium-gray-1);--beacon-system-color-icon-secondary-hover: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-icon-secondary: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-icon-primary-inactive: var(--beacon-reference-palette-grayscale-medium-gray-4);--beacon-system-color-icon-primary: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-icon-positive: var(--beacon-reference-palette-functional-green-3);--beacon-system-color-icon-link: var(--beacon-reference-palette-functional-blue-9);--beacon-system-color-icon-link-active: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-icon-highlight: var(--beacon-reference-palette-primary-bright-blue-2);--beacon-system-color-icon-error: var(--beacon-reference-palette-functional-red-3);--beacon-system-color-data-viz-11: var(--beacon-reference-palette-charts-gray-dt-4);--beacon-system-color-data-viz-10: var(--beacon-reference-palette-charts-gray-dt-1);--beacon-system-color-data-viz-9: var(--beacon-reference-palette-charts-orange-dt-4);--beacon-system-color-data-viz-8: var(--beacon-reference-palette-charts-orange-dt-1);--beacon-system-color-data-viz-7: var(--beacon-reference-palette-charts-berry-dt-4);--beacon-system-color-data-viz-6: var(--beacon-reference-palette-charts-berry-dt-1);--beacon-system-color-border-secondary-pressed: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-border-secondary-inactive: var(--beacon-reference-palette-grayscale-medium-gray-1);--beacon-system-color-border-secondary-hover: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-border-secondary: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-border-primary: var(--beacon-reference-palette-functional-blue-6);--beacon-system-color-border-positive: var(--beacon-reference-palette-functional-green-3);--beacon-system-color-border-link-focus: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-border-link: var(--beacon-reference-palette-functional-blue-9);--beacon-system-color-border-focus-outer: var(--beacon-reference-palette-secondary-gold-2);--beacon-system-color-border-focus-middle: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-border-focus-inner: var(--beacon-reference-palette-primary-midnight-navy-2);--beacon-system-color-border-error: var(--beacon-reference-palette-functional-red-3);--beacon-system-color-border-brand: var(--beacon-reference-palette-primary-bright-blue-2);--beacon-system-color-border-active: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-border-2: #FFFFFF33;--beacon-system-color-border-1: var(--beacon-reference-palette-primary-midnight-navy-2);--beacon-system-color-border-0: var(--beacon-reference-palette-primary-midnight-navy-1);--beacon-system-color-background-primary-pressed: var(--beacon-reference-palette-functional-blue-4);--beacon-system-color-background-primary-inactive: var(--beacon-reference-palette-grayscale-medium-gray-1);--beacon-system-color-background-primary-hover: var(--beacon-reference-palette-functional-blue-5);--beacon-system-color-background-primary: var(--beacon-reference-palette-functional-blue-6);--beacon-system-color-background-positive-pressed: var(--beacon-reference-palette-functional-green-1);--beacon-system-color-background-positive-hover: var(--beacon-reference-palette-functional-green-2);--beacon-system-color-background-positive: var(--beacon-reference-palette-functional-green-3);--beacon-system-color-background-negative-pressed: var(--beacon-reference-palette-functional-red-1);--beacon-system-color-background-negative-hover: var(--beacon-reference-palette-functional-red-2);--beacon-system-color-background-negative: var(--beacon-reference-palette-functional-red-3);--beacon-system-color-background-link-focus: var(--beacon-reference-palette-secondary-gold-2);--beacon-system-color-background-brand: var(--beacon-reference-palette-primary-bright-blue-2);--beacon-system-color-background-2: var(--beacon-reference-palette-primary-midnight-navy-2);--beacon-system-color-background-1: var(--beacon-reference-palette-primary-midnight-navy-1);--beacon-system-color-background-0: var(--beacon-reference-palette-primary-midnight-navy-2);--beacon-component-tile-collection-color-border-green: var(--beacon-reference-palette-secondary-green-3);--beacon-component-tile-collection-color-border-gold: var(--beacon-reference-palette-secondary-gold-3);--beacon-component-tile-collection-color-border-blue: var(--beacon-reference-palette-secondary-ocean-3);--beacon-component-tile-collection-color-border-berry: var(--beacon-reference-palette-secondary-berry-3);--beacon-component-tile-collection-color-background-green: var(--beacon-reference-palette-secondary-green-1);--beacon-component-tile-collection-color-background-gold: var(--beacon-reference-palette-secondary-gold-1);--beacon-component-tile-collection-color-background-blue: var(--beacon-reference-palette-functional-blue-2);--beacon-component-tile-collection-color-background-berry: var(--beacon-reference-palette-secondary-berry-1);--beacon-component-table-color-border: var(--beacon-reference-palette-grayscale-dark-gray-4);--beacon-component-tab-menu-color-background-primary-active: var(--beacon-reference-palette-functional-blue-3);--beacon-component-scrollbar-color-background-track: var(--beacon-reference-palette-grayscale-dark-gray-3);--beacon-component-scrollbar-color-background-thumb-pressed: var(--beacon-reference-palette-grayscale-light-gray-4);--beacon-component-scrollbar-color-background-thumb-hover: var(--beacon-reference-palette-grayscale-light-gray-3);--beacon-component-scrollbar-color-background-thumb: var(--beacon-reference-palette-grayscale-light-gray-2);--beacon-component-progress-indicator-color-background-incomplete: var(--beacon-reference-palette-grayscale-dark-gray-3);--beacon-component-progress-indicator-color-background-complete: var(--beacon-reference-palette-functional-blue-9);--beacon-component-notification-color-border-informational: var(--beacon-reference-palette-functional-blue-6);--beacon-component-notification-color-background-standard: var(--beacon-reference-palette-primary-midnight-navy-1);--beacon-component-primary-navigation-site-menu-color-text-link: var(--beacon-reference-palette-grayscale-white);--beacon-component-primary-navigation-header-color-text-link: var(--beacon-reference-palette-grayscale-white);--beacon-component-form-color-foreground-inactive: var(--beacon-reference-palette-grayscale-medium-gray-1);--beacon-component-form-color-border-standard: var(--beacon-reference-palette-grayscale-medium-gray-3);--beacon-component-data-viz-color-border-minor: var(--beacon-reference-palette-grayscale-medium-gray-1);--beacon-component-data-viz-color-border-major: var(--beacon-reference-palette-grayscale-medium-gray-4);--beacon-component-control-chip-color-background-default: var(--beacon-reference-palette-grayscale-dark-gray-4);--beacon-component-avatar-icon-color-background: var(--beacon-reference-palette-grayscale-light-gray-1);--beacon-component-avatar-icon-color-avatar: var(--beacon-reference-palette-grayscale-medium-gray-3)}.beacon-on-darker{--beacon-system-color-background-tertiary-pressed: #FFFFFF1F;--beacon-system-color-background-tertiary-hover: #FFFFFF14;--beacon-system-color-background-secondary-pressed: #FFFFFF1F;--beacon-system-color-background-secondary-hover: #FFFFFF14;--beacon-system-color-background-blanket: #061937A3;--beacon-component-table-color-background-selected: #8ff1ff14;--beacon-component-form-color-background-inactive: #0C2A4DB8;--beacon-system-color-text-title: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-text-tertiary-pressed: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-text-tertiary-inactive: var(--beacon-reference-palette-grayscale-medium-gray-1);--beacon-system-color-text-tertiary-hover: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-text-tertiary: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-text-standard: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-text-set-white: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-text-set-navy: var(--beacon-reference-palette-primary-midnight-navy-1);--beacon-system-color-text-secondary-pressed: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-text-secondary-inactive: var(--beacon-reference-palette-grayscale-medium-gray-1);--beacon-system-color-text-secondary-hover: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-text-secondary: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-text-primary-inactive: var(--beacon-reference-palette-grayscale-medium-gray-4);--beacon-system-color-text-primary: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-text-link: var(--beacon-reference-palette-functional-blue-9);--beacon-system-color-text-link-active: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-text-inactive: var(--beacon-reference-palette-grayscale-medium-gray-1);--beacon-system-color-text-error: var(--beacon-reference-palette-functional-red-3);--beacon-system-color-shadow-low: 0rem 0rem var(--beacon-reference-space-2) 0rem var(--beacon-reference-palette-primary-shadow-1);--beacon-system-color-shadow-high: 0rem 0rem var(--beacon-reference-space-7) 0rem var(--beacon-reference-palette-primary-shadow-3);--beacon-system-color-shadow-medium: 0rem 0rem var(--beacon-reference-space-4) 0rem var(--beacon-reference-palette-primary-shadow-2);--beacon-system-color-icon-tertiary-pressed: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-icon-tertiary-inactive: var(--beacon-reference-palette-grayscale-medium-gray-1);--beacon-system-color-icon-tertiary-hover: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-icon-tertiary: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-icon-standard: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-icon-set-white: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-icon-set-navy: var(--beacon-reference-palette-primary-midnight-navy-1);--beacon-system-color-icon-secondary-pressed: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-icon-secondary-inactive: var(--beacon-reference-palette-grayscale-medium-gray-1);--beacon-system-color-icon-secondary-hover: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-icon-secondary: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-icon-primary-inactive: var(--beacon-reference-palette-grayscale-medium-gray-4);--beacon-system-color-icon-primary: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-icon-positive: var(--beacon-reference-palette-functional-green-3);--beacon-system-color-icon-link: var(--beacon-reference-palette-functional-blue-9);--beacon-system-color-icon-link-active: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-icon-highlight: var(--beacon-reference-palette-primary-bright-blue-2);--beacon-system-color-icon-error: var(--beacon-reference-palette-functional-red-3);--beacon-system-color-data-viz-11: var(--beacon-reference-palette-charts-gray-dt-4);--beacon-system-color-data-viz-10: var(--beacon-reference-palette-charts-gray-dt-1);--beacon-system-color-data-viz-9: var(--beacon-reference-palette-charts-orange-dt-4);--beacon-system-color-data-viz-8: var(--beacon-reference-palette-charts-orange-dt-1);--beacon-system-color-data-viz-7: var(--beacon-reference-palette-charts-berry-dt-4);--beacon-system-color-data-viz-6: var(--beacon-reference-palette-charts-berry-dt-1);--beacon-system-color-border-secondary-pressed: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-border-secondary-inactive: var(--beacon-reference-palette-grayscale-medium-gray-1);--beacon-system-color-border-secondary-hover: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-border-secondary: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-border-primary: var(--beacon-reference-palette-functional-blue-6);--beacon-system-color-border-positive: var(--beacon-reference-palette-functional-green-3);--beacon-system-color-border-link-focus: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-border-link: var(--beacon-reference-palette-functional-blue-9);--beacon-system-color-border-focus-outer: var(--beacon-reference-palette-secondary-gold-2);--beacon-system-color-border-focus-middle: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-border-focus-inner: var(--beacon-reference-palette-primary-midnight-navy-1);--beacon-system-color-border-error: var(--beacon-reference-palette-functional-red-3);--beacon-system-color-border-brand: var(--beacon-reference-palette-primary-bright-blue-2);--beacon-system-color-border-active: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-border-2: #FFFFFF33;--beacon-system-color-border-1: var(--beacon-reference-palette-primary-midnight-navy-1);--beacon-system-color-border-0: var(--beacon-reference-palette-primary-midnight-navy-2);--beacon-system-color-background-primary-pressed: var(--beacon-reference-palette-functional-blue-4);--beacon-system-color-background-primary-inactive: var(--beacon-reference-palette-grayscale-medium-gray-1);--beacon-system-color-background-primary-hover: var(--beacon-reference-palette-functional-blue-5);--beacon-system-color-background-primary: var(--beacon-reference-palette-functional-blue-6);--beacon-system-color-background-positive-pressed: var(--beacon-reference-palette-functional-green-1);--beacon-system-color-background-positive-hover: var(--beacon-reference-palette-functional-green-2);--beacon-system-color-background-positive: var(--beacon-reference-palette-functional-green-3);--beacon-system-color-background-negative-pressed: var(--beacon-reference-palette-functional-red-1);--beacon-system-color-background-negative-hover: var(--beacon-reference-palette-functional-red-2);--beacon-system-color-background-negative: var(--beacon-reference-palette-functional-red-3);--beacon-system-color-background-link-focus: var(--beacon-reference-palette-secondary-gold-2);--beacon-system-color-background-brand: var(--beacon-reference-palette-primary-bright-blue-2);--beacon-system-color-background-2: var(--beacon-reference-palette-primary-midnight-navy-1);--beacon-system-color-background-1: var(--beacon-reference-palette-primary-midnight-navy-2);--beacon-system-color-background-0: var(--beacon-reference-palette-primary-midnight-navy-1);--beacon-component-tile-collection-color-border-green: var(--beacon-reference-palette-secondary-green-3);--beacon-component-tile-collection-color-border-gold: var(--beacon-reference-palette-secondary-gold-3);--beacon-component-tile-collection-color-border-blue: var(--beacon-reference-palette-secondary-ocean-3);--beacon-component-tile-collection-color-border-berry: var(--beacon-reference-palette-secondary-berry-3);--beacon-component-tile-collection-color-background-green: var(--beacon-reference-palette-secondary-green-1);--beacon-component-tile-collection-color-background-gold: var(--beacon-reference-palette-secondary-gold-1);--beacon-component-tile-collection-color-background-blue: var(--beacon-reference-palette-functional-blue-2);--beacon-component-tile-collection-color-background-berry: var(--beacon-reference-palette-secondary-berry-1);--beacon-component-table-color-border: var(--beacon-reference-palette-grayscale-dark-gray-4);--beacon-component-tab-menu-color-background-primary-active: var(--beacon-reference-palette-functional-blue-3);--beacon-component-scrollbar-color-background-track: var(--beacon-reference-palette-grayscale-dark-gray-3);--beacon-component-scrollbar-color-background-thumb-pressed: var(--beacon-reference-palette-grayscale-light-gray-4);--beacon-component-scrollbar-color-background-thumb-hover: var(--beacon-reference-palette-grayscale-light-gray-3);--beacon-component-scrollbar-color-background-thumb: var(--beacon-reference-palette-grayscale-light-gray-2);--beacon-component-progress-indicator-color-background-incomplete: var(--beacon-reference-palette-grayscale-dark-gray-3);--beacon-component-progress-indicator-color-background-complete: var(--beacon-reference-palette-functional-blue-9);--beacon-component-notification-color-border-informational: var(--beacon-reference-palette-functional-blue-6);--beacon-component-notification-color-background-standard: var(--beacon-reference-palette-primary-midnight-navy-2);--beacon-component-primary-navigation-site-menu-color-text-link: var(--beacon-reference-palette-grayscale-white);--beacon-component-primary-navigation-header-color-text-link: var(--beacon-reference-palette-grayscale-white);--beacon-component-form-color-foreground-inactive: var(--beacon-reference-palette-grayscale-medium-gray-1);--beacon-component-form-color-border-standard: var(--beacon-reference-palette-grayscale-medium-gray-3);--beacon-component-data-viz-color-border-minor: var(--beacon-reference-palette-grayscale-medium-gray-1);--beacon-component-data-viz-color-border-major: var(--beacon-reference-palette-grayscale-medium-gray-4);--beacon-component-control-chip-color-background-default: var(--beacon-reference-palette-grayscale-dark-gray-4);--beacon-component-avatar-icon-color-background: var(--beacon-reference-palette-grayscale-light-gray-1);--beacon-component-avatar-icon-color-avatar: var(--beacon-reference-palette-grayscale-medium-gray-3)}`;
var cT = Object.defineProperty, dT = Object.getOwnPropertyDescriptor, Xf = (i) => {
  throw TypeError(i);
}, il = (i, t, e, a) => {
  for (var o = a > 1 ? void 0 : a ? dT(t, e) : t, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = (a ? r(t, e, o) : r(o)) || o);
  return a && o && cT(t, e, o), o;
}, hT = (i, t, e) => t.has(i) || Xf("Cannot " + e), Pr = (i, t, e) => (hT(i, t, "read from private field"), e ? e.call(i) : t.get(i)), nl = (i, t, e) => t.has(i) ? Xf("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(i) : t.set(i, e);
const Zf = '[beacon-tag-name="beacon-navigation"]', ju = () => {
  throw new Error(
    "Component does not implement WatchMedia. Please use the WatchMedia mixin to correctly apply this method."
  );
}, bT = {
  onReady: !0,
  removeLargeEvent: !1,
  selector: Zf
};
function pT(i) {
  return !!(i && i.currentMode);
}
function Jh({
  onReady: i,
  removeLargeEvent: t,
  selector: e
} = bT) {
  const a = e != null ? e : Zf;
  return function(o) {
    var n, r, T, O;
    let j = class extends o {
      constructor() {
        super(...arguments), this.innerModeClass = "beacon-on-light", this.modeClasses = {
          "beacon-on-light": "beacon-on-darker",
          "beacon-on-lighter": "beacon-on-dark",
          "beacon-on-dark": "beacon-on-lighter",
          "beacon-on-darker": "beacon-on-light"
        }, this.setInverseModeState = () => {
          if (this.modeStoreComponent instanceof HTMLElement && "currentMode" in this.modeStoreComponent) {
            const { currentMode: D } = this.modeStoreComponent;
            this.innerModeClass = this.determineModeClass(D);
          }
        }, nl(this, n, () => {
          this.innerModeClass && this.classList.add(this.innerModeClass);
        }), nl(this, r, () => {
          this.innerModeClass && this.classList.remove(this.innerModeClass);
        }), nl(this, T, ({ target: D }) => {
          D instanceof HTMLElement && this === D && (this.modeStoreComponent = this.findModeStore(this), this.setInverseModeState(), "isDesktop" in this ? this.isDesktop && i && Pr(this, n).call(this) : ju());
        }), nl(this, O, ({ matches: D }) => {
          "isDesktop" in this && (D ? Pr(this, n).call(this) : Pr(this, r).call(this));
        });
      }
      static get inverseStyles() {
        return [lT];
      }
      /** Recursive method for finding the parent `<beacon-navigation>` component. */
      findModeStore(D) {
        var B;
        const F = D.closest(a) || ((B = this.getClosestHost()) == null ? void 0 : B.closest(a));
        return pT(F) ? F : null;
      }
      /** Return the opposite mode based on the current mode. */
      determineModeClass(D) {
        return this.modeClasses[D] || "beacon-on-light";
      }
      /** Returns only light mode opposites of the innerModeClass */
      determineModeClassOfOnlyLightModeOpposites() {
        return this.innerModeClass === "beacon-on-light" ? "beacon-on-light" : this.innerModeClass === "beacon-on-lighter" ? "beacon-on-lighter" : this.innerModeClass === "beacon-on-dark" ? "beacon-on-light" : "beacon-on-lighter";
      }
      prerenderInverseModeSetup() {
        this.addEventListener(
          Ee.ELEMENT_READY,
          Pr(this, T)
        ), "largeBreakpointWatcher" in this ? t || this.largeBreakpointWatcher.addEventListener(
          "change",
          Pr(this, O)
        ) : ju();
      }
    };
    return n = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakMap(), T = /* @__PURE__ */ new WeakMap(), O = /* @__PURE__ */ new WeakMap(), il([
      Se()
    ], j.prototype, "innerModeClass", 2), il([
      Se()
    ], j.prototype, "modeStoreComponent", 2), il([
      qe
    ], j.prototype, "prerenderInverseModeSetup", 1), j = il([
      je("InverseMode")
    ], j), j;
  };
}
const uT = [
  "beacon-on-light",
  "beacon-on-lighter",
  "beacon-on-dark",
  "beacon-on-darker"
];
function gT(i) {
  return uT.includes(i);
}
var mT = Object.defineProperty, fT = Object.getOwnPropertyDescriptor, Od = (i, t, e, a) => {
  for (var o = a > 1 ? void 0 : a ? fT(t, e) : t, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = (a ? r(t, e, o) : r(o)) || o);
  return a && o && mT(t, e, o), o;
};
function vT(i) {
  let t = class extends i {
    constructor() {
      super(...arguments), this.currentMode = "beacon-on-light";
    }
    setCurrentMode() {
      const e = '[class*="beacon-on-"]', a = this.getClosestHost();
      let o = null, n;
      return a ? o = a.closest(e) : o = this.closest(e), o && (n = Array.from(o.classList).find(
        (T) => T.startsWith("beacon-on-")
      )), n && gT(n) ? n : "beacon-on-light";
    }
    setCurrentContext({ target: e }) {
      e instanceof HTMLElement && this === e && (this.currentMode = this.setCurrentMode());
    }
    modeStoreInit() {
      this.setCurrentContext = this.setCurrentContext.bind(this), this.addEventListener(Ee.ELEMENT_READY, this.setCurrentContext);
    }
  };
  return Od([
    Se()
  ], t.prototype, "currentMode", 2), Od([
    qe
  ], t.prototype, "modeStoreInit", 1), t = Od([
    je("ModeStore")
  ], t), t;
}
const $o = {
  header: "HDR",
  siteNav: "TN"
}, Wa = {
  0: "Hdr_lvl0",
  1: "Hdr_lvl1"
}, jn = {
  level_1: "TN_lvl1",
  level_2: "TN_lvl2",
  level_3: "TN_lvl3",
  level_4: "TN_lvl4"
}, zt = {
  prefix: "data-metrics",
  get location() {
    return `${this.prefix}-location`;
  },
  get section() {
    return `${this.prefix}-section`;
  }
}, Ho = {
  selectedLink: "Site_lvl0",
  links: "Site_lvl1_SiteSelector",
  level1LangSelector: "Site_lvl1_LocLangSelector",
  level2LangSelector: "Site_lvl2_LocLangSelector"
};
function $u(i) {
  switch (i) {
    case 1:
      return jn.level_2;
    case 2:
      return jn.level_3;
    case 3:
      return jn.level_4;
    default:
      return null;
  }
}
const AT = `<svg xmlns="http://www.w3.org/2000/svg" width="2" height="16" viewBox="0 0 1 16" class="vertical-divider-brand" fill="none">
<rect width="2" height="16" fill="var(--beacon-system-color-border-brand)"/>
</svg>`, yT = `<svg xmlns="http://www.w3.org/2000/svg" width="1" height="16" viewBox="0 0 1 16" class="vertical-divider" fill="none">
<rect width="1" height="16" fill="var(--beacon-system-color-border-0)"/>
</svg>`, Hu = `<svg width="132" height="24" viewBox="0 0 132 24" fill="currentcolor" xmlns="http://www.w3.org/2000/svg">
  <title>T. Rowe Price</title>
  <path d="M30.0123 1C33.5023 1 35.1214 2.61256 35.1214 5.21501C35.1214 8.95902 32.3506 9.95762 30.9819 10.3299C32.1888 11.5767 36.6237 19.1932 36.6237 19.1932C37.0076 19.8703 37.5432 20.4915 38.6695 20.4915L38.766 21.2317C38.4053 21.3138 37.9227 21.4894 36.8349 21.4894C34.5525 21.4894 33.236 20.9727 31.0073 17.3252C29.3664 14.6385 28.3439 12.3634 26.6624 9.79288H27.3634C29.6625 9.79288 31.2381 8.55624 31.2381 5.83695C31.2381 3.64672 30.6357 2.30195 27.9346 2.30195H26.2248C25.9171 2.30195 25.8184 2.43766 25.8184 2.75408V18.3216C25.8184 18.9406 26.5006 18.9559 27.4846 19.1417L27.7829 19.998H20.1069L20.4052 19.1417C21.3922 18.9559 22.0715 18.9406 22.0715 18.3216V2.68295C22.0715 2.06101 21.3922 2.04577 20.4052 1.85708L20.1069 1H30.0123ZM125.807 7.0344C130.506 7.0344 131.292 11.2857 131.39 12.7234L130.67 13.3917H123.341C123.341 16.5138 124.785 18.8202 127.503 18.8202C128.753 18.8202 129.777 18.2033 130.101 17.9994L130.199 18.8956C129.724 19.3093 128.393 20.4545 125.815 20.4545C121.567 20.4545 119.851 17.2519 119.851 13.743C119.851 11.5295 120.504 7.0344 125.807 7.0344ZM72.5122 7.0344C77.2149 7.0344 78.0067 11.2857 78.101 12.7234L77.3847 13.3917H70.0527C70.0527 16.5138 71.4948 18.8202 74.2162 18.8202C75.4645 18.8202 76.4834 18.2033 76.8158 17.9994L76.9108 18.8956C76.4362 19.3093 75.1023 20.4545 72.5296 20.4545C68.2791 20.4545 66.5598 17.2519 66.5598 13.743C66.5598 11.5295 67.2108 7.0344 72.5122 7.0344ZM43.3178 7.0344C47.3905 7.0344 49.5742 9.84876 49.5742 13.7372C49.5742 17.4631 47.5183 20.4545 43.3178 20.4545C39.1187 20.4545 37.0671 17.4957 37.0671 13.7372C37.0344 10.0984 39.0752 7.0344 43.3178 7.0344ZM115 7.0344C117.29 7.0344 118.76 7.57434 118.917 7.62078L118.274 11.6471H117.382C117.076 9.39954 116.397 8.25071 114.786 8.25071C112.671 8.25071 111.989 10.7385 111.989 13.2444C111.989 16.3542 113.669 18.8202 116.477 18.8202C117.591 18.8202 118.745 18.2352 119.119 17.9994L119.215 18.8956C118.797 19.2324 117.334 20.4509 114.977 20.4509C110.454 20.4509 108.485 17.1212 108.485 13.5507C108.485 9.15061 111.161 7.0344 115 7.0344ZM16 16.6024C16.9761 16.6024 17.7744 17.3934 17.7744 18.3746C17.7744 19.3565 16.9761 20.149 16 20.149C15.0116 20.149 14.2206 19.3565 14.2206 18.3746C14.2206 17.3934 15.0116 16.6024 16 16.6024ZM106.583 7.10044L106.578 18.5074C106.75 19.0263 107.57 18.9936 108.082 19.1417C108.269 19.4813 108.251 19.4174 108.446 19.998H101.612C101.882 19.5517 101.868 19.4682 102.048 19.1417C102.537 18.9087 103.2 18.9276 103.306 18.294V7.60119C104.356 7.40452 105.488 7.29276 106.583 7.10044ZM15.4957 1L15.7047 5.89574H14.7823C14.3403 3.82525 14.2481 2.70981 12.8802 2.70981H9.72616V18.3216C9.72616 18.9406 10.4054 18.9559 11.3888 19.1417L11.6907 19.998H4.01326L4.31298 19.1417C5.29344 18.9559 5.97852 18.9406 5.97852 18.3216V2.70981H2.81871C1.45217 2.70981 1.35856 3.82525 0.918041 5.89574H0L0.206831 1H15.4957ZM55.7487 7.48798L55.4454 8.34433C54.5542 8.50181 54.3277 8.74638 54.3277 9.17746C54.3277 9.47211 54.4431 9.92351 54.5505 10.3887L54.5823 10.5217C54.8805 11.7744 54.9399 12.1122 55.5832 14.6981L57.8199 7.48798H59.9485L62.1177 14.7496C62.1177 14.7496 62.9203 11.4657 63.3855 9.53597C63.4494 9.28415 63.4871 9.08094 63.4871 8.90241C63.4871 8.55624 63.1424 8.47787 62.4428 8.34433L62.1423 7.48798H67.2892L66.9909 8.34433C66.2013 8.48367 65.5743 8.52867 65.2884 9.47719L62.5067 19.998H60.3861L58.0115 12.5412L55.7342 19.998H53.6949L50.6694 9.0091C50.5462 8.59062 49.9835 8.48553 49.3897 8.38703L49.1345 8.34433L48.8318 7.48798H55.7487ZM90.0182 1C93.5706 1 95.1251 2.64739 95.1251 5.31588C95.1251 6.37762 94.8145 7.30219 94.5568 7.72529L97.3066 6.96546V9.37704C98.2 8.20935 99.7719 6.95094 101.849 7.03367L101.114 11.6471H100.225C100.043 10.3829 99.6681 9.67168 98.8821 9.67168C98.0127 9.67168 97.5657 10.343 97.3095 10.7131L97.311 18.3216C97.311 18.9406 97.9939 18.9559 98.9765 19.1417L99.2755 19.998H92.0705L92.3709 19.1417C93.355 18.9559 94.0401 18.9406 94.0401 18.3216V9.98447C94.0401 9.41115 93.8122 9.16876 93.4748 9.09183C92.9189 9.60274 90.7918 10.9881 88.6509 10.9881C88.0565 10.9881 87.5231 10.9105 87.3555 10.8887L86.6653 9.79288H87.4295C89.8411 9.79288 91.2388 8.36102 91.2388 5.81881C91.2388 3.63293 90.6292 2.30195 87.8461 2.30195H86.2313C85.9062 2.30195 85.8235 2.45725 85.8235 2.76206V18.3216C85.8235 18.9406 86.5027 18.9559 87.4897 19.1417L87.7865 19.998H80.1069L80.4103 19.1417C81.3922 18.9559 82.0715 18.9406 82.0715 18.3216V2.68295C82.0715 2.06101 81.3922 2.04577 80.4103 1.85708L80.1069 1H90.0182ZM43.3178 8.25071C41.0513 8.25071 40.7284 10.835 40.7284 13.7372C40.7284 17.6801 41.4831 19.236 43.3178 19.236C45.1916 19.236 45.913 17.5683 45.913 13.7372C45.913 10.0215 45.2605 8.25071 43.3178 8.25071ZM125.751 8.25071C123.689 8.25071 123.407 10.8648 123.407 12.2074H128.098C128.098 10.7247 127.736 8.25071 125.751 8.25071ZM72.4643 8.25071C70.4062 8.25071 70.121 10.8648 70.121 12.2074H74.8062C74.8062 10.7247 74.4514 8.25071 72.4643 8.25071ZM105 2.51459C105.991 2.51459 106.791 3.31796 106.791 4.3064C106.791 5.29266 105.991 6.09604 105 6.09604C104.011 6.09604 103.207 5.29266 103.207 4.3064C103.207 3.31796 104.011 2.51459 105 2.51459Z"/>
</svg>`;
var xT = Object.defineProperty, wT = Object.getOwnPropertyDescriptor, ha = (i, t, e, a) => {
  for (var o = a > 1 ? void 0 : a ? wT(t, e) : t, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = (a ? r(t, e, o) : r(o)) || o);
  return a && o && xT(t, e, o), o;
};
const kT = {
  skipFirstUpdated: !1,
  runOnSlotchange: !1
};
function _s({
  skipFirstUpdated: i,
  runOnSlotchange: t
} = kT) {
  return function(e) {
    let a = class extends e {
      /**
       * @abstract
       */
      updateAnalytics() {
      }
      prerenderAnalyticsSetup() {
        t && this.addEventListener("slotchange", this.updateAnalytics);
      }
      postrenderAnalyticsSetup() {
        i || this.updateAnalytics();
      }
      willUpdate(o) {
        super.willUpdate(o), o.has("metricsSection") && this.metricsSection && Re(
          this,
          Ee.METRICS_SECTION_CHANGE,
          !!this.onBeaconAnalyticsSectionChange && this.onBeaconAnalyticsSectionChange()
        ), o.has("metricsLocation") && this.metricsLocation && Re(
          this,
          Ee.METRICS_LOCATION_CHANGE,
          !!this.onBeaconAnalyticsLocationChange && this.onBeaconAnalyticsLocationChange()
        ), o.has("metricsID") && this.metricsID && Re(
          this,
          Ee.METRICS_ID_CHANGE,
          !!this.onBeaconAnalyticsIdChange && this.onBeaconAnalyticsIdChange()
        );
      }
    };
    return ha([
      ue({ attribute: "data-metrics-section", reflect: !0 })
    ], a.prototype, "metricsSection", 2), ha([
      ue({ attribute: "data-metrics-location" })
    ], a.prototype, "metricsLocation", 2), ha([
      ue({ attribute: "data-id" })
    ], a.prototype, "metricsID", 2), ha([
      ue({ type: Function })
    ], a.prototype, "onBeaconAnalyticsSectionChange", 2), ha([
      ue({ type: Function })
    ], a.prototype, "onBeaconAnalyticsIdChange", 2), ha([
      ue({ type: Function })
    ], a.prototype, "onBeaconAnalyticsLocationChange", 2), ha([
      qe
    ], a.prototype, "prerenderAnalyticsSetup", 1), ha([
      De
    ], a.prototype, "postrenderAnalyticsSetup", 1), a = ha([
      je("Analytics")
    ], a), a;
  };
}
const Ku = (i, t, e) => !e || i < e.left || i > e.right || t < e.top || t > e.bottom;
function sh(i, t = 50) {
  i instanceof HTMLElement && setTimeout(() => {
    i.focus();
  }, t);
}
const Rr = "beacon-scroll-block";
function eb() {
  var i;
  if (!document.getElementById(Rr)) {
    const t = document.createElement("style");
    t.setAttribute("id", Rr), t.innerHTML = `.${Rr}{
      block-size: 100dvh !important;
      overflow: hidden !important;
    }`, (i = document.querySelector("head")) == null || i.appendChild(t);
  }
  document.body.classList.add(Rr);
}
function ls() {
  document.body.classList.remove(Rr);
}
var CT = Object.defineProperty, ST = Object.getOwnPropertyDescriptor, On = (i, t, e, a) => {
  for (var o = a > 1 ? void 0 : a ? ST(t, e) : t, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = (a ? r(t, e, o) : r(o)) || o);
  return a && o && CT(t, e, o), o;
};
function Jf(i) {
  let t = class extends i {
    constructor() {
      super(...arguments), this.isOpen = !1, this.handleActiveNavItemChange = ({ target: e }) => {
        this.associatedNavTrigger instanceof it && e instanceof it && this.associatedNavTrigger.isEqualNode(e) && (this.isOpen = !!this.associatedNavTrigger.active);
      }, this.updateNavItemOnEscape = ({ key: e }) => {
        e === Ea.ESCAPE && this.associatedNavTrigger instanceof it && this.associatedNavTrigger.active && this.handleMenuClose(!0);
      }, this.handleMenuCloseButton = ({ target: e }) => {
        e instanceof HTMLElement && this.isEqualNode(e) && this.associatedNavTrigger instanceof it && this.handleMenuClose(!0);
      };
    }
    /** The outermost parent element to look for the associated navigation item. */
    get navItemRoot() {
      return this.closest('[beacon-tag-name="beacon-navigation"]');
    }
    /** The navigation button that triggers this popover. */
    get associatedNavTrigger() {
      var e;
      return (e = this.navItemRoot) == null ? void 0 : e.querySelector(`[opens="${this.opensBy}"]`);
    }
    /** Return a given expanded nav by its index in the slotted elements. */
    findExpandedNav(e = 0) {
      return this.slottedExpandedNavItems[e];
    }
    /** Handles closing of components that inherit this class. */
    handleMenuClose(e = !1) {
      this.associatedNavTrigger instanceof it && (this.associatedNavTrigger.active = !1, e && this.associatedNavTrigger.button.focus());
    }
    /** Sets the nav item active state when focusing out of the popover. */
    handleFocusOut({ relatedTarget: e }) {
      e instanceof HTMLElement && this.associatedNavTrigger instanceof it && !this.associatedNavTrigger.isEqualNode(e) && !this.contains(e) && this.associatedNavTrigger.isDesktop && this.associatedNavTrigger.active && this.handleMenuClose();
    }
    prerenderNavigationButtonTriggeredSetup() {
      document.addEventListener(
        Ee.ACTIVE_NAV_ITEM,
        this.handleActiveNavItemChange
      ), document.addEventListener(Je.KEYDOWN, this.updateNavItemOnEscape), this.addEventListener(
        Ee.CLOSE_ACTIVE_NAV_ITEM,
        this.handleMenuCloseButton
      ), this.addEventListener(Je.FOCUSOUT, this.handleFocusOut);
    }
    teardownNavibationButtonTriggered() {
      document.removeEventListener(
        Ee.ACTIVE_NAV_ITEM,
        this.handleActiveNavItemChange
      ), document.removeEventListener(Je.KEYDOWN, this.updateNavItemOnEscape);
    }
  };
  return On([
    ue({ attribute: "opens-by", reflect: !0 })
  ], t.prototype, "opensBy", 2), On([
    ue({ type: Boolean, reflect: !0, attribute: "is-open" })
  ], t.prototype, "isOpen", 2), On([
    Pe(
      { flatten: !0, selector: "beacon-navigation-expanded" },
      !0
    )
  ], t.prototype, "slottedExpandedNavItems", 2), On([
    qe
  ], t.prototype, "prerenderNavigationButtonTriggeredSetup", 1), On([
    Lt
  ], t.prototype, "teardownNavibationButtonTriggered", 1), t = On([
    je("NavigationButtonTriggered")
  ], t), t;
}
const ET = ve`:is([beacon-tag-name=beacon-navigation-expanded],[beacon-tag-name=beacon-navigation-footer]) :is(h1,h2,h3,h4,h5,h6,p){margin:0;padding:0}:is([beacon-tag-name=beacon-navigation-expanded],[beacon-tag-name=beacon-navigation-footer]) ::part(button){text-align:inherit}:is([beacon-tag-name=beacon-navigation-expanded],[beacon-tag-name=beacon-navigation-footer]) ul{margin-block:0}:is([beacon-tag-name=beacon-navigation-expanded],[beacon-tag-name=beacon-navigation-footer]) ul>li{display:block;inline-size:fit-content;padding-block:var(--beacon-system-space-cell-free-floating)}:is([beacon-tag-name=beacon-navigation-expanded],[beacon-tag-name=beacon-navigation-footer])>:is(a,[beacon-tag-name=beacon-navigation-button]){display:block;inline-size:fit-content;padding-block:var(--beacon-system-space-cell-free-floating)}`, TT = ve`:host{color:var(--beacon-system-color-text-standard);inline-size:100%}[beacon-tag-name=beacon-navigation-button]{display:block;inline-size:fit-content;padding-block:var(--beacon-system-space-cell-free-floating)}::slotted([slot=title]){color:var(--beacon-system-color-text-title);font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-300)}::slotted([slot=description]){font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100);color:var(--beacon-system-color-text-standard)}.title-area{padding-block:var(--beacon-system-space-cell-free-floating)}.title-area>*+*{margin-block-start:var(--navigation-expanded-title-area-gap)}.slot-container{display:grid;gap:var(--beacon-reference-space-2)}@media (width >= 960px){.level-2 .slot-container{columns:var(--expanded-nav-grid-template);display:block}.level-2,.level-3{padding-inline-end:var(--beacon-reference-space-7)}}`;
var MT = Object.defineProperty, LT = Object.getOwnPropertyDescriptor, fn = (i, t, e, a) => {
  for (var o = a > 1 ? void 0 : a ? LT(t, e) : t, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = (a ? r(t, e, o) : r(o)) || o);
  return a && o && MT(t, e, o), o;
};
const xi = class Nr extends Le {
  constructor() {
    super(...arguments), this.level = 1, this.splitColumns = "true", this.hasNestedExpandedNavigations = !1, this.handleCurrentLink = () => {
      this.currentLink && Re(
        this,
        Ee.HAS_CURRENT_LINK,
        void 0,
        this.onBeaconCurrentLink
      );
    };
  }
  static get styles() {
    return [super.styles, TT];
  }
  static get lightDOMStyles() {
    return [...super.lightDOMStyles, ET];
  }
  /** Callback for on beacon-event-has-current-link */
  onBeaconCurrentLink() {
  }
  /** Anchor link representing the current page. */
  get currentLink() {
    return this.querySelector('a[aria-current="page"]');
  }
  get hasValidNestedItems() {
    return this.links.filter(
      (t) => (t instanceof Nr || t instanceof HTMLAnchorElement) && !(t instanceof HTMLStyleElement)
    );
  }
  postrenderHandleCurrentLink() {
    this.handleCurrentLink();
  }
  /** Set the level property. Runs on slotchange as it is dependent on nested menus. */
  setLevel() {
    this.level = 1 + (this.parentElement instanceof Nr ? this.parentElement.level : 0);
  }
  /** Updates based on this component having nested expanded navigations. */
  setNestedState() {
    this.hasValidNestedItems.length > 0 ? this.hasNestedExpandedNavigations = !0 : this.hasNestedExpandedNavigations = !1;
  }
  /** Calculate a number of CSS columns based on how many links are to be shown. */
  static calculateCSSColumns(t) {
    let e = "";
    return t < 6 ? e = "1" : t < 11 ? e = "2" : t < 22 ? e = "3" : e = "4", e;
  }
  /** Calculate the grid template based on how many sections are shown. */
  static calculateGridColumnTemplate(t) {
    let e = "";
    return t === 1 ? e = "1fr" : t === 2 ? e = "1fr 1fr" : t === 3 ? e = "1fr 1fr 1fr" : t >= 4 && (e = "1fr 1fr 1fr 1fr"), e;
  }
  setColumnsCSSProperty(t) {
    this.style.setProperty("--expanded-nav-grid-template", t);
  }
  setNestedGridTemplates(t) {
    const e = Nr.calculateCSSColumns(t);
    this.setColumnsCSSProperty(e);
  }
  setLevel1GridTemplate(t) {
    const e = Nr.calculateGridColumnTemplate(t);
    this.setColumnsCSSProperty(e);
  }
  setLevel2GridTemplate(t) {
    this.setNestedGridTemplates(t);
  }
  setGridTemplates() {
    let t = this.links.length;
    this.splitColumns === "false" && (t = 1), this.level === 1 ? this.setLevel1GridTemplate(t) : this.level === 2 ? this.setLevel2GridTemplate(t) : this.level === 3 && this.setNestedGridTemplates(t);
  }
  handleTitleSlotchange() {
    var t;
    this.titleSlotVal = (t = this.titleNodes) != null && t.length && this.titleNodes[0] instanceof HTMLElement ? this.titleNodes[0].innerText : "";
  }
  handleDefaultSlotchange() {
    this.setNestedState(), this.setLevel(), this.setGridTemplates();
  }
  renderExpanded() {
    return pe`
      <section class="header-zone">
        <div class="title-area">
          <div class="title-container">
            <slot
              name="title"
              part="title"
              @slotchange=${this.handleTitleSlotchange}></slot>
          </div>
        </div>
      </section>
      <section class="slot-container">
        <slot
          @slotchange=${Is(
      this.handleDefaultSlotchange.bind(this)
    )}></slot>
      </section>
    `;
  }
  render() {
    return pe`<div class="level-${this.level}">
      ${this.renderExpanded()}
    </div> `;
  }
};
fn([
  ue({ reflect: !0 })
], xi.prototype, "level", 2);
fn([
  ue({ attribute: "split-columns", reflect: !0 })
], xi.prototype, "splitColumns", 2);
fn([
  Se()
], xi.prototype, "titleSlotVal", 2);
fn([
  Se()
], xi.prototype, "hasNestedExpandedNavigations", 2);
fn([
  Pe({ slot: "", flatten: !0 })
], xi.prototype, "links", 2);
fn([
  Pe({ slot: "title", flatten: !0 })
], xi.prototype, "titleNodes", 2);
fn([
  De
], xi.prototype, "postrenderHandleCurrentLink", 1);
let ev = xi;
var ga = /* @__PURE__ */ ((i) => (i.CLICK = "click", i.HOVER = "hover", i.MANUAL = "manual", i))(ga || {}), _t = /* @__PURE__ */ ((i) => (i.START = "start", i.CENTER = "center", i.END = "end", i))(_t || {}), Di = /* @__PURE__ */ ((i) => (i.HORIZONTAL = "horizontal", i.VERTICAL = "vertical", i))(Di || {}), st = /* @__PURE__ */ ((i) => (i.BlockStart = "block-start", i.InlineStart = "inline-start", i.BlockEnd = "block-end", i.InlineEnd = "inline-end", i))(st || {});
const tv = {
  DOWN: pe`<svg
    class="tooltip-arrow arrow--down"
    viewBox="0 0 12 6"
    xmlns="http://www.w3.org/2000/svg"
    style="transform: rotate(180deg);">
    <path d="M6 0.998535L12 6.99854L0 6.99854L6 0.998535Z"></path>
  </svg>`,
  LEFT: pe`<svg
    class="tooltip-arrow arrow--left"
    viewBox="0 0 12 6"
    xmlns="http://www.w3.org/2000/svg"
    style="transform: rotate(270deg) scale(2);">
    <path d="M6 0.998535L12 6.99854L0 6.99854L6 0.998535Z"></path>
  </svg>`,
  RIGHT: pe`<svg
    class="tooltip-arrow arrow--right"
    viewBox="0 0 12 6"
    xmlns="http://www.w3.org/2000/svg"
    style="transform: rotate(90deg) scale(2);">
    <path d="M6 0.998535L12 6.99854L0 6.99854L6 0.998535Z"></path>
  </svg>`,
  UP: pe`<svg
    class="tooltip-arrow arrow--up"
    viewBox="0 0 12 6"
    xmlns="http://www.w3.org/2000/svg">
    <path d="M6 0.998535L12 6.99854L0 6.99854L6 0.998535Z"></path>
  </svg>`
};
var OT = Object.defineProperty, PT = Object.getOwnPropertyDescriptor, bt = (i, t, e, a) => {
  for (var o = a > 1 ? void 0 : a ? PT(t, e) : t, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = (a ? r(t, e, o) : r(o)) || o);
  return a && o && OT(t, e, o), o;
};
function zT(i = { disableDebounceOpen: !1 }) {
  return function(t) {
    let e = class extends t {
      constructor() {
        super(...arguments), this.orientation = Di.VERTICAL, this.trigger = ga.HOVER, this.isOpen = !1, this.content = "", this.alignment = _t.CENTER, this.direction = st.InlineStart, this.topOffset = 0, this.leftOffset = 0, this.RTL = !1, this.marginAdjust = 0, this.targetSelectorString = ".overlay-target", this.overlaySelector = ".overlay-wrapper", this.overlayName = "overlay", this.debouncedCalculateOffset = Io(this.calculateOffset.bind(this), 100), this.toggleClick = (a) => {
          a && a.isTrusted && (this.isOpen ? this.close() : this.open());
        }, this.intersectionObserver = new IntersectionObserver(
          this.debouncedCalculateOffset,
          { threshold: 1 }
        ), this.resizeObserver = new ResizeObserver(this.debouncedCalculateOffset), this.open = i && !i.disableDebounceOpen ? Io(async () => {
          this.calculateOffset(), this.isOpen = !0, this.attachOpenEventListeners(), await this.updateComplete, this.emitOpen();
        }, 100) : async () => {
          this.calculateOffset(), this.isOpen = !0, this.attachOpenEventListeners(), await this.updateComplete, this.emitOpen();
        }, this.handleKeydown = (a) => {
          a.isTrusted && this.isOpen && (super.handleKeydown(), this.closeOnEscape(a));
        }, this.handleExternalClick = (a) => {
          a.isTrusted && !a.composedPath().includes(this.overlayEl) && this.isOpen && this.close();
        };
      }
      /** Callback for on beacon-event-close */
      onBeaconClose() {
      }
      /** Callback for on beacon-event-open */
      onBeaconOpen() {
      }
      get targetSelector() {
        return this.targetSelectorString;
      }
      set targetSelector(a) {
        this.targetSelectorString = a;
      }
      get viewportRect() {
        return {
          width: window.innerWidth || document.documentElement.clientWidth,
          height: window.innerHeight || document.documentElement.clientHeight
        };
      }
      set targetRect(a) {
        this.targetRectObj = a;
      }
      get scrollListeningContainer() {
        var a;
        return (a = this.scrollListeningContainerObj) != null ? a : window;
      }
      set scrollListeningContainer(a) {
        this.scrollListeningContainerObj = a;
      }
      get externalClickNode() {
        return this.getRootNode();
      }
      /**
       * Calculates margin adjustment for when the overlay component is visible
       * @param marginToken token representing the margin of the overlay component
       * @param arrowSizeToken token representing the size of the arrow on the overlay
       */
      computeMarginAdjustment(a, o) {
        this.marginAdjust = parseInt(a, 10) + parseInt(o, 10) / 2;
      }
      /**
       * Used to determine if the preferred direction and orientation are compatible,
       * when dynamically calculating the direction of the overlay with the preferred direction
       * @param direction The current direction of the overlay
       * @returns
       */
      static computeDirectionOrientation(a) {
        return a === st.BlockStart || a === st.BlockEnd ? Di.VERTICAL : Di.HORIZONTAL;
      }
      /**
       * Evaluate Alignment and Direction based on the Target and Overlay DOMRect.
       * @param target DOMRect of the target element
       * @param overlay DOMRect of the overlay element
       */
      computeDirection(a, o) {
        this.orientation === Di.VERTICAL ? (this.computeVerticalDirection(a), this.computeAlignment(a)) : this.computeHorizontalDirection(a, o);
      }
      /**
       * Computes the vertical direction based on available space,
       * and a user provided preferred direction.
       * @param target DOMRect of the target element
       */
      computeVerticalDirection(a) {
        const o = this.viewportRect.height / 4, n = this.viewportRect, r = a.top < o, T = a.bottom > n.height - o, O = r ? st.BlockStart : st.BlockEnd;
        this.preferredDirection && e.computeDirectionOrientation(this.preferredDirection) === Di.VERTICAL ? !r && this.preferredDirection == st.BlockEnd ? this.direction = st.BlockEnd : !T && this.preferredDirection == st.BlockStart ? this.direction = st.BlockStart : this.direction = O : this.direction = O;
      }
      /**
       * Computes the horizontal direction based on available space,
       * prioritizing the preferred-direction over default dynamic calculations
       * if it exists
       * @param target
       * @param overlay
       */
      computeHorizontalDirection(a, o) {
        this.alignment = _t.CENTER;
        const n = a.x + a.width + o.width < this.viewportRect.width, r = a.x - o.width > 0, T = this.viewportRect.width < a.x, O = n ? st.InlineStart : st.InlineEnd;
        this.RTL ? T ? this.direction = st.InlineEnd : this.direction = st.InlineStart : this.preferredDirection && e.computeDirectionOrientation(
          this.preferredDirection
        ) === Di.HORIZONTAL ? (n && this.preferredDirection === st.InlineStart && (this.direction = st.InlineStart), r && this.preferredDirection === st.InlineEnd ? this.direction = st.InlineEnd : this.direction = O) : this.direction = O;
      }
      /**
       * Aligns the arrow of the popover when vertically oriented, to ensure most
       * of the popover is visible in the viewport.
       * @param target
       */
      computeAlignment(a) {
        const o = a.x < this.viewportRect.width / 4, n = a.x > this.viewportRect.width * 3 / 4;
        o ? this.alignment = _t.START : n ? this.alignment = _t.END : this.alignment = _t.CENTER;
      }
      /**
       * @param overlayWidth Width of the Overlay element
       * @param targetWidth Width of the Target Element
       * @returns Based on Alignment, will return leftOffset as number.
       */
      calculateHorizontalOffset(a, o) {
        const n = o - a, r = a / 2 - this.marginAdjust;
        switch (this.alignment) {
          case _t.START:
            return n / 2 + r;
          case _t.CENTER:
            return n / 2;
          case _t.END:
            return n / 2 - r;
          default:
            return 0;
        }
      }
      /**
       * Evaluate the Overlay Leftoffset and topOffset based on targetSelector and Overlay Selector.
       * @abstract
       */
      calculateOffset() {
        var n, r, T;
        const a = (n = this.shadowRoot) == null ? void 0 : n.querySelector(this.targetSelector), o = (r = this.shadowRoot) == null ? void 0 : r.querySelector(this.overlaySelector);
        if (o && (a || this.targetRectObj)) {
          const O = (T = this.targetRectObj) != null ? T : a == null ? void 0 : a.getBoundingClientRect(), j = o.getBoundingClientRect();
          this.computeDirection(O, j);
          const { height: D, width: F } = O, { height: B, width: N } = j;
          switch (this.topOffset = 0, this.leftOffset = F, this.direction) {
            case st.BlockEnd:
              this.topOffset = -1 * (D + B), this.leftOffset = this.calculateHorizontalOffset(
                N,
                F
              );
              break;
            case st.BlockStart:
              this.leftOffset = this.calculateHorizontalOffset(
                N,
                F
              );
              break;
            case st.InlineEnd:
              this.leftOffset = -1 * N, this.topOffset = -1 * (B + (D - B) / 2);
              break;
            case st.InlineStart:
              this.topOffset = -1 * (B + (D - B) / 2);
              break;
          }
        }
      }
      /**
       * Enables overlay surface to reposition and reorient based on:
       * 1. When overlayWrapper is intersecting with viewport border
       * 2. When document body is resized
       * 3. When user scrolls
       */
      engageDynamicOverlayPositioning() {
        this.intersectionObserver.observe(this.overlayWrapper), this.resizeObserver.observe(document.body), this.scrollListeningContainer.addEventListener(
          "scroll",
          this.debouncedCalculateOffset
        );
      }
      /**
       * Disengages dynamic overlay positioning by unobserving by:
       * 1. Unobserving overlayWrapper intersections with viewport
       * 2. Unobserving resize of the document body
       * 3. Removing scroll event listener from scrollListeningContainer
       */
      disengageDynamicOverlayPositioning() {
        this.intersectionObserver.unobserve(this.overlayWrapper), this.resizeObserver.unobserve(document.body), this.scrollListeningContainer.removeEventListener(
          "scroll",
          this.debouncedCalculateOffset
        );
      }
      /**
       * Destroys dynamic overlay positioning by:
       * 1. Disconnecting intersection observer
       * 2. Disconnecting resize observer
       * 3. Removing scroll event listener from scrollListeningContainer
       * This method is intended for use when disconnecting component.
       */
      destroyDynamicOverlayPositioning() {
        this.intersectionObserver.disconnect(), this.resizeObserver.disconnect(), this.scrollListeningContainer.removeEventListener(
          "scroll",
          this.debouncedCalculateOffset
        );
      }
      /**
       * Adds event listener to the document to close the overlay when clicked outside
       */
      attachOpenEventListeners() {
        setTimeout(() => {
          this.trigger === ga.CLICK && document.addEventListener(Je.CLICK, this.handleExternalClick);
        }, 100);
      }
      /**
       * Makes the overlay hidden.
       */
      close() {
        this.isOpen = !1, this.removeOpenEventListeners(), this.trigger === ga.MANUAL && this.focusOnTrigger();
      }
      /**
       * Focuses on the element that opened the overlay,
       * used when the overlay is closed and the trigger is manual.
       */
      focusOnTrigger() {
        var o, n;
        const a = document.querySelector(this.targetSelector) || ((n = (o = this.getClosestHost()) == null ? void 0 : o.shadowRoot) == null ? void 0 : n.querySelector(this.targetSelector));
        a && a.focus();
      }
      removeOpenEventListeners() {
        this.trigger === ga.CLICK && document.removeEventListener(Je.CLICK, this.handleExternalClick);
      }
      /** Closes the popover when the key pressed is the escape key. */
      closeOnEscape(a) {
        a.key === Ea.ESCAPE && this.close();
      }
      /**
       * @event {BeaconEvents} beacon-events-close - emits when the overlay is closed with the close() method.
       */
      emitClose() {
        Re(this, Ee.CLOSE, void 0, this.onBeaconClose);
      }
      /**
       * @event {BeaconEvents} beacon-events-open - emits when the overlay is closed with the open() method.
       */
      emitOpen() {
        Re(this, Ee.OPEN, void 0, this.onBeaconOpen);
      }
      /**
       * Lit lifecycle hook to handle changing of properties
       */
      updated(a) {
        yr(a, "isOpen") && (this.isOpen ? (this.open(), this.emitOpen()) : (this.close(), this.emitClose()));
      }
      overlayPrerender() {
        this.isOpen && this.open(), this.externalClickNode.addEventListener(
          Je.KEYDOWN,
          this.handleKeydown
        );
      }
      overlayPostrender() {
        this.calculateOffset();
      }
      overlayDestroy() {
        this.destroyDynamicOverlayPositioning(), this.externalClickNode.removeEventListener(
          Je.KEYDOWN,
          this.handleKeydown
        ), this.externalClickNode.removeEventListener(
          Je.CLICK,
          this.handleExternalClick
        );
      }
      /**
       * Render template: slotted element
       */
      renderSlot() {
        return this.trigger === ga.HOVER ? pe`<slot
            @mouseover=${this.open}
            @mouseout=${this.close}
            @focusin=${this.open}
            @focusout=${this.close}></slot>` : this.trigger === ga.CLICK ? pe`<slot @click=${this.toggleClick}></slot>` : pe`<slot></slot>`;
      }
      /**
       * Render template: overlay content
       */
      renderOverlayContent() {
        return pe`<p>${this.content}</p>`;
      }
      /**
       * Render template: overlay content skeleton
       */
      renderContentWrapper() {
        return pe`<div class="tooltip-content">
          ${this.renderOverlayContent()}
        </div>`;
      }
      /**
       * Render template: arrow
       * @todo align the arrow implementation with the navigation popover arrow
       */
      renderArrow() {
        return pe`<span
          class="overlay-arrow ${this.alignment}"
          aria-hidden="true"
          >${tv.UP}</span
        >`;
      }
      /**
       * Render template: entire overlay skeleton
       */
      renderOverlayWrapper() {
        return this.style.setProperty("--left-offset", `${this.leftOffset}px`), this.style.setProperty("--top-offset", `${this.topOffset}px`), this.topScreenOffset && this.style.setProperty(
          "--screen-offset-top",
          `${this.topScreenOffset}px`
        ), this.leftScreenOffset && this.style.setProperty(
          "--screen-offset-left",
          `${this.leftScreenOffset}px`
        ), pe`<div
          id="${this.overlayName}"
          aria-hidden="${gt(this.isOpen ? void 0 : "true")}"
          class="overlay-wrapper 
            ${this.direction}">
          ${this.renderArrow()} ${this.renderContentWrapper()}
        </div>`;
      }
      /**
       * Render template: overlay and target
       */
      render() {
        return pe`${this.trigger === ga.MANUAL ? _e : pe`<div
              class="overlay-target"
              aria-describedBy="${this.overlayName}">
              ${this.renderSlot()}
            </div>`}
        ${this.renderOverlayWrapper()}`;
      }
    };
    return bt([
      ue()
    ], e.prototype, "orientation", 2), bt([
      ue({ attribute: "preferred-direction" })
    ], e.prototype, "preferredDirection", 2), bt([
      ue({ reflect: !0 })
    ], e.prototype, "trigger", 2), bt([
      ue({ type: Boolean, reflect: !0, attribute: "is-open" })
    ], e.prototype, "isOpen", 2), bt([
      ue()
    ], e.prototype, "content", 2), bt([
      Se()
    ], e.prototype, "alignment", 2), bt([
      Se()
    ], e.prototype, "direction", 2), bt([
      Se()
    ], e.prototype, "topOffset", 2), bt([
      Se()
    ], e.prototype, "leftOffset", 2), bt([
      Se()
    ], e.prototype, "topScreenOffset", 2), bt([
      Se()
    ], e.prototype, "leftScreenOffset", 2), bt([
      Se()
    ], e.prototype, "RTL", 2), bt([
      et("div#tooltip")
    ], e.prototype, "overlayEl", 2), bt([
      Ge(".overlay-wrapper")
    ], e.prototype, "overlayWrapper", 2), bt([
      qe
    ], e.prototype, "overlayPrerender", 1), bt([
      De
    ], e.prototype, "overlayPostrender", 1), bt([
      Lt
    ], e.prototype, "overlayDestroy", 1), e = bt([
      je("Overlay")
    ], e), e;
  };
}
function DT(i = { disableDebounceOpen: !1 }) {
  return function(e) {
    const a = zT(i)(e);
    let o = class extends a {
      constructor() {
        super(...arguments), this.open = i && !i.disableDebounceOpen ? Io(async () => {
          this.calculateOffset(), this.engageDynamicOverlayPositioning(), this.activeElement = document.activeElement, await this.updateComplete, this.isOpen = !0, this.attachOpenEventListeners();
        }, 100) : async () => {
          this.calculateOffset(), this.engageDynamicOverlayPositioning(), this.activeElement = document.activeElement, await this.updateComplete, this.isOpen = !0, this.attachOpenEventListeners();
        };
      }
      /**
       * Handle close and return focus to active element.
       * Also removes listener and observer logic when overlay closed for better performance.
       */
      close() {
        super.close(), this.disengageDynamicOverlayPositioning(), this.focusOnActiveElement();
      }
      /**
       * Handle dark mode theming in action zone
       */
      setActionZoneDarkMode() {
        this.slottedActionzone && this.slottedActionzone.length && this.slottedActionzone.forEach((n) => {
          n.classList.contains("beacon-on-dark") || n.classList.add("beacon-on-dark");
        });
      }
      /**
       * Focuses on the previously active element
       */
      focusOnActiveElement() {
        var n;
        (n = this.activeElement) == null || n.focus();
      }
      /**
       * Render template: close icon button
       */
      renderCloseButton() {
        return Be`<${this.getScopedTag("beacon-icon-button")}
                        variant="tertiary"
                        class="beacon-popover-close-button beacon-on-dark"
                        @beacon-event-click="${this.close}"
                        >
                        Close Button
                        <svg slot="icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M18.4697 19.5303C18.7626 19.8232 19.2374 19.8232 19.5303 19.5303C19.8232 19.2374 19.8232 18.7626 19.5303 18.4697L13.0607 12L19.5303 5.53033C19.8232 5.23744 19.8232 4.76256 19.5303 4.46967C19.2374 4.17678 18.7626 4.17678 18.4697 4.46967L12 10.9393L5.53033 4.46967C5.23744 4.17678 4.76256 4.17678 4.46967 4.46967C4.17678 4.76256 4.17678 5.23744 4.46967 5.53033L10.9393 12L4.46967 18.4697C4.17678 18.7626 4.17678 19.2374 4.46967 19.5303C4.76256 19.8232 5.23744 19.8232 5.53033 19.5303L12 13.0607L18.4697 19.5303Z"/>
                        </svg>
                        </${this.getScopedTag("beacon-icon-button")}>
                        `;
      }
      /**
       * Render template: adjusts content wrapper
       */
      renderContentWrapper() {
        return pe`<div class="beacon-popover-surface">
          ${this.renderCloseButton()}
          <div class="beacon-popover-zones-wrapper">
            ${this.renderOverlayContent()}
          </div>
        </div>`;
      }
      /**
       * Render template: slot with only click event
       */
      renderSlot() {
        return pe`<slot @click=${this.toggleClick}></slot>`;
      }
    };
    return bt([
      et("div#overlay")
    ], o.prototype, "overlayEl", 2), bt([
      Se()
    ], o.prototype, "activeElement", 2), bt([
      Pe({ flatten: !0, slot: "actionzone" })
    ], o.prototype, "slottedActionzone", 2), o = bt([
      je("OverlayInteractive")
    ], o), o;
  };
}
const rl = {
  beaconTagName: "beacon-navigation-popover",
  arrowSpaceMargin: "24px",
  arrowSizeInline: "12px"
}, IT = ve`[beacon-tag-name=beacon-navigation-popover]{--navigation-popover-link-color: var(--beacon-system-color-text-link-active)}@media (width >= 960px){[beacon-tag-name=beacon-navigation-popover]{--navigation-popover-link-color: var(--beacon-system-color-text-link-active)}[beacon-tag-name=beacon-navigation-popover] [beacon-tag-name=beacon-navigation-expanded][level="1"] [beacon-tag-name=beacon-navigation-expanded]:not(:last-of-type){border-block-end:var(--beacon-system-width-border-mini) solid var(--beacon-system-color-border-1);padding-block-end:var(--beacon-system-space-micro-jumbo)}}[beacon-tag-name=beacon-navigation-popover][slot=site-selector] [beacon-tag-name=beacon-navigation-expanded] [selected-site]{align-items:center;color:var(--beacon-system-color-text-link-active);display:inline-flex;font-weight:var(--beacon-system-font-weight-bold);gap:var(--beacon-reference-space-3)}[beacon-tag-name=beacon-navigation-popover][slot=site-selector] [beacon-tag-name=beacon-navigation-expanded] [selected-site]:after{block-size:1em;content:url('data:image/svg+xml,<svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 9.01852L6.78947 13.5L15 2.5" stroke="%23248647" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');inline-size:1em}`, BT = ve`@media (width >= 960px){:host([motion-state=enabled]){--popover-motion-easing: var(--beacon-system-motion-easing-decelerate-emphasize-1);--popover-motion-duration: var(--beacon-reference-motion-duration-7);display:grid;grid-template-columns:min-content;transition-duration:var(--popover-motion-duration);transition-property:grid-template-rows;transition-timing-function:var(--popover-motion-easing)}:host([motion-state=enabled]) .overlay-wrapper{overflow:hidden;visibility:visible}:host([motion-state=enabled]) .beacon-popover-zones-wrapper{opacity:0;transition:opacity var(--popover-motion-duration) var(--popover-motion-easing) var(--popover-motion-duration)}}@media (width >= 960px) and (prefers-reduced-motion: reduce){:host([motion-state=enabled]) .beacon-popover-zones-wrapper{opacity:1}}@media (width >= 960px){:host([motion-state=enabled]:not([is-open])){display:grid;grid-template-rows:0fr}:host([is-open][motion-state=enabled]){grid-template-rows:1fr}:host([is-open][motion-state=enabled]) .beacon-popover-zones-wrapper{opacity:1}}`, RT = ve`:host{--popover-color: var(--beacon-system-color-text-standard);--popover-visibility: hidden;color:var(--popover-color);inline-size:100%}@media (width >= 960px){:host{inline-size:unset;inset-block-start:var(--top-offset);inset-inline-start:var(--left-offset);position:absolute;z-index:var(--beacon-custom-popover-z-index, 1000)}}:host(:not([is-open])){display:none}::part(icon-button){--icon-color: var(--popover-color);--hover-icon: var(--popover-color);--active-icon: var(--popover-color)}:host([is-open]){--popover-visibility: visible}.overlay-wrapper{display:flex;flex-direction:var(--direction);visibility:var(--popover-visibility)}@media (width >= 960px){.overlay-wrapper{--arrow-block-size: 6px;--arrow-inline-size: var(--beacon-reference-space-4);--direction: column;inline-size:fit-content;max-inline-size:var(--navigation-popover-size-inline)}}.overlay-wrapper.block-start{--direction: column}.overlay-wrapper.block-end{--direction: column-reverse}.overlay-wrapper .overlay-arrow{--arrow-margin: var(--beacon-reference-space-7);display:flex}.overlay-wrapper .overlay-arrow.start{align-self:start;margin-inline-start:var(--arrow-margin)}.overlay-wrapper .overlay-arrow.center{align-self:center;margin:0}.overlay-wrapper .overlay-arrow.end{align-self:end;margin-inline-end:var(--arrow-margin)}.overlay-wrapper .overlay-arrow .tooltip-arrow{block-size:var(--arrow-block-size);fill:var(--beacon-system-color-background-1);inline-size:var(--arrow-inline-size)}@media (width >= 960px){.overlay-wrapper .beacon-popover-surface{background-color:var(--beacon-system-color-background-1);border-radius:var(--beacon-system-radius-corner-standard);box-shadow:var(--beacon-elevation-block-end-level-1);inline-size:var(--navigation-popover-content-size-inline);max-inline-size:var(--navigation-popover-content-size-inline);padding:var(--beacon-reference-space-7);position:relative}}.overlay-wrapper .beacon-popover-surface .beacon-popover-close-button{display:none}.overlay-wrapper .beacon-popover-surface .beacon-popover-zones-wrapper{display:flex;flex-direction:column}`;
var NT = Object.defineProperty, FT = Object.getOwnPropertyDescriptor, Cc = (i, t, e, a) => {
  for (var o = a > 1 ? void 0 : a ? FT(t, e) : t, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = (a ? r(t, e, o) : r(o)) || o);
  return a && o && NT(t, e, o), o;
};
const yb = class yb extends Ke(Le).with(
  DT({ disableDebounceOpen: !0 }),
  Jf,
  Jh(),
  Ra,
  fr(),
  _s({ skipFirstUpdated: !0 })
) {
  constructor() {
    super(...arguments), this.beaconTagName = rl.beaconTagName, this.trigger = ga.MANUAL, this.direction = st.BlockStart, this.overflowOffset = 0;
  }
  static get styles() {
    return [super.styles, RT, BT];
  }
  static get lightDOMStyles() {
    return [super.lightDOMStyles, IT];
  }
  /** @override Only set Alignment in direction computation. */
  computeDirection(t, e) {
    if (this.slot === tb.ACTION) {
      this.alignment = _t.END;
      return;
    }
    const a = (t.left + t.right) / 2, o = e.width / 2;
    a + o > this.viewportRect.width ? this.alignment = _t.END : a - o < 0 ? this.alignment = _t.START : this.alignment = _t.CENTER;
  }
  /**
   * @override Sets a different targetRectObj from the primitive.
   * @override Changes calculation to take into account the popover not being a wrapper of the target.
   */
  calculateOffset() {
    var a;
    this.associatedNavTrigger instanceof it && (this.targetRectObj = this.associatedNavTrigger.getBoundingClientRect());
    const t = this.associatedNavTrigger, e = (a = this.shadowRoot) == null ? void 0 : a.querySelector(".overlay-arrow");
    if (t && e) {
      const o = t.getBoundingClientRect(), n = this.getBoundingClientRect(), r = e.getBoundingClientRect(), T = document.body.getBoundingClientRect();
      this.computeDirection(o, n), this.topOffset = o.y + o.height;
      const O = o.x - n.width / 2 + o.width / 2, j = r.x - (n.x + n.width / 2) + r.width / 2, { width: D } = T, F = D > 1920 ? (D - 1920) / 2 : 0;
      switch (this.alignment) {
        case _t.END:
        case _t.START:
          this.leftOffset = O - j - F;
          break;
        case _t.CENTER:
        default:
          this.leftOffset = O - F;
          break;
      }
    }
  }
  /** @override Focus returning is handled externally from this popover. */
  focusOnActiveElement() {
  }
  /** @override Includes SVG arrow in the markup instead of styling using CSS backgrounds. */
  renderArrow() {
    return pe`<span class="overlay-arrow ${this.alignment}" aria-hidden="true"
      >${tv.UP}</span
    >`;
  }
  /** @override Close buttons don't exist here. */
  renderCloseButton() {
    return pe``;
  }
  /** @override Only a default slot is available. */
  renderOverlayContent() {
    return pe`<slot></slot>`;
  }
  prerenderNavigationPopoverSetup() {
    this.computeMarginAdjustment(
      rl.arrowSpaceMargin,
      rl.arrowSizeInline
    );
  }
  willUpdate(t) {
    if (t.has("motionState") && this.motionState === "enabled" && !this.prefersReducedMotion && this.setAttribute("inert", ""), yr(t, "isOpen")) {
      const e = t.get("isOpen");
      this.motionState === "enabled" && !this.prefersReducedMotion && (e ? this.setAttribute("inert", "") : this.removeAttribute("inert"));
    }
    super.willUpdate(t);
  }
};
yb.tagName = rl.beaconTagName;
let gi = yb;
Cc([
  ue()
], gi.prototype, "trigger", 2);
Cc([
  ue()
], gi.prototype, "direction", 2);
Cc([
  Se()
], gi.prototype, "overflowOffset", 2);
Cc([
  qe
], gi.prototype, "prerenderNavigationPopoverSetup", 1);
const _T = ve`:root[beacon-tag-name=beacon-navigation-expanded],:root [beacon-tag-name=beacon-navigation-expanded],[beacon-version="4.3.1"][class*=beacon-on][beacon-tag-name=beacon-navigation-expanded],[beacon-version="4.3.1"][class*=beacon-on] [beacon-tag-name=beacon-navigation-expanded],[class*=beacon-on] [beacon-version="4.3.1"][beacon-tag-name=beacon-navigation-expanded],[class*=beacon-on] [beacon-version="4.3.1"] [beacon-tag-name=beacon-navigation-expanded],[beacon-version="4.3.1"][beacon-tag-name=beacon-navigation-expanded],[beacon-version="4.3.1"] [beacon-tag-name=beacon-navigation-expanded]{--navigation-expanded-title-area-gap: var(--beacon-system-space-micro-normal);--navigation-expanded-header-zone-spacing: var(--beacon-reference-space-5);--navigation-expanded-popover-header-zone-spacing: var(--beacon-system-space-micro-jumbo)}@media (width >= 960px){:root[beacon-tag-name=beacon-navigation-expanded],:root [beacon-tag-name=beacon-navigation-expanded],[beacon-version="4.3.1"][class*=beacon-on][beacon-tag-name=beacon-navigation-expanded],[beacon-version="4.3.1"][class*=beacon-on] [beacon-tag-name=beacon-navigation-expanded],[class*=beacon-on] [beacon-version="4.3.1"][beacon-tag-name=beacon-navigation-expanded],[class*=beacon-on] [beacon-version="4.3.1"] [beacon-tag-name=beacon-navigation-expanded],[beacon-version="4.3.1"][beacon-tag-name=beacon-navigation-expanded],[beacon-version="4.3.1"] [beacon-tag-name=beacon-navigation-expanded]{--navigation-expanded-header-zone-spacing: var(--beacon-reference-space-9)}}`, Bn = {
  beaconTagName: "beacon-navigation-expanded",
  beaconFooterNavTagName: "beacon-navigation-footer",
  navItemTagName: "beacon-navigation-button"
}, UT = ve`[beacon-tag-name=beacon-navigation-expanded] a{color:var(--beacon-system-color-text-link)}[beacon-tag-name=beacon-navigation-expanded] .expanded__search{align-items:baseline;display:flex;flex-direction:column;gap:var(--beacon-reference-space-3)}[beacon-tag-name=beacon-navigation-expanded] .expanded__search :first-child{flex:1;inline-size:100%}@media (width >= 1280px){[beacon-tag-name=beacon-navigation-expanded] .expanded__search :first-child{flex:unset;inline-size:calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi),var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 8 + var(--beacon-system-space-gutter) * 7)}}@media (width >= 640px){[beacon-tag-name=beacon-navigation-expanded] .expanded__search{align-items:end;flex-direction:row}}[beacon-tag-name=beacon-navigation-expanded]>[slot=title]{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-300)}[beacon-tag-name=beacon-navigation-expanded]>[slot=description]{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100)}[beacon-tag-name=beacon-navigation-expanded]>[slot=promo]{border-block-start:var(--beacon-system-width-border-mini) solid var(--beacon-system-color-border-1);padding-block-start:var(--beacon-reference-space-5)}[beacon-tag-name=beacon-navigation-expanded][show-drilldown]>:is([beacon-tag-name=beacon-navigation-expanded]:not([is-active],[show-drilldown]),[beacon-tag-name=beacon-navigation-button],a){display:none}@media (width >= 960px){[beacon-tag-name=beacon-navigation-expanded]:is([level="2"],[level="3"])>[slot=title]{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-50)}[beacon-tag-name=beacon-navigation-expanded]>[slot=promo]{border:0;padding-block-start:0}}`, jT = ve`:host([show-drilldown]) .promo-slot{display:none}.hide{display:none}.default-slot{display:contents}.header-zone.has-nested-expanded{border-block-end:var(--beacon-system-width-border-mini) solid var(--beacon-system-color-border-1);margin-block-end:var(--navigation-expanded-header-zone-spacing);padding-block-end:var(--navigation-expanded-header-zone-spacing)}.header-zone.no-content{display:none}:host([show-drilldown]) .header-zone{display:none}.popover{color:var(--beacon-system-color-text-standard)}.collapsed-title-button{all:unset}@media (width >= 960px){:host([level="2"]){grid-column:span var(--expanded-nav-grid-span)}.expanded ::slotted([beacon-tag-name=beacon-navigation-button]),.expanded ::slotted(a){--font-weight: var(--beacon-system-font-weight-normal)}.expanded:is(.level-1,.level-2,.level-3) .slot-container{--grid-layout-gap: var(--beacon-system-space-micro-jumbo);--grid-column-count: 4;--gap-count: calc(var(--grid-column-count) - 1);--total-gap-width: calc(var(--gap-count) * var(--grid-layout-gap));--grid-item-max-width: calc((100% - var(--total-gap-width)) / var(--grid-column-count));display:grid;gap:calc(var(--navigation-expanded-header-zone-spacing) * 2) var(--grid-layout-gap);grid-template-columns:repeat(auto-fit,minmax(var(--grid-item-max-width),1fr))}.expanded:not(.level-1) .header-zone{border:0;margin:0;padding:0}.expanded.level-2 .default-slot{columns:var(--expanded-nav-grid-template)}.expanded:is(.level-2,.level-3) .default-slot{columns:var(--expanded-nav-grid-template);display:block}.popover{color:var(--beacon-system-color-text-standard)}.popover.level-1 .header-zone.has-nested-expanded{margin-block-end:var(--navigation-expanded-popover-header-zone-spacing);padding-block-end:var(--navigation-expanded-popover-header-zone-spacing)}.popover.level-1 .title-area .primary-link-container{margin-block-start:var(--beacon-system-space-micro-mini)}.popover.level-1 .slot-container{gap:var(--beacon-system-space-micro-jumbo)}.popover:not(.level-1) ::slotted([slot=title]){font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-50)}.popover:not(.level-1) .header-zone{border:0;margin:0;padding:0}}`;
var $T = Object.defineProperty, HT = Object.getOwnPropertyDescriptor, Uo = (i, t, e, a) => {
  for (var o = a > 1 ? void 0 : a ? HT(t, e) : t, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = (a ? r(t, e, o) : r(o)) || o);
  return a && o && $T(t, e, o), o;
};
const KT = ["title", "description", "primary-link"];
function GT(i) {
  const t = i, e = KT.find(
    (a) => a === t
  );
  if (e)
    return e;
  throw new Error(`${i} is not a valid slot name in Expanded Navigation.`);
}
var po;
const ko = (po = class extends Ke(
  ev
).with(Ra, _s({ skipFirstUpdated: !0 })) {
  constructor() {
    super(...arguments), this.beaconTagName = Bn.beaconTagName, this.showDrilldown = !1, this.isActive = !1, this.hasPrimaryLink = !1, this.hasDescription = !1, this.hasTitle = !1, this.hasPromo = !1, this.handleDrillup = (t) => {
      var e;
      if (t.target instanceof qr && this.activeExpandedNav instanceof po) {
        this.activeExpandedNav.drillup(!0), (e = this.toolbelt) == null || e.handleDrillup();
        return;
      }
      this.showDrilldown && this.drillup();
    }, this.handleCloseEvents = ({ target: t }) => {
      t instanceof qr && this.parentExpanded && (this.parentExpanded.titleSlotVal ? (this.parentExpanded.isActive = !0, this.parentExpanded.showDrilldown = !1) : this.parentExpanded.drillup());
    }, this.handleAnalyticsChange = ({ target: t }) => {
      t === this.menuContext && this.updateAnalytics();
    };
  }
  static get styles() {
    return [super.styles, jT];
  }
  static get lightDOMStyles() {
    return [super.lightDOMStyles, UT, _T];
  }
  get hasOnlyLinks() {
    return !this.hasPrimaryLink && !this.hasDescription && !this.titleSlotVal;
  }
  get parentExpanded() {
    return this.parentElement instanceof po ? this.parentElement : null;
  }
  /** The level value of whichever expanded navigation is currently active. */
  get activeLevel() {
    return this.isActive ? this.level : this.parentElement instanceof po ? this.parentElement.activeLevel : 1;
  }
  /** True when an expanded navigation is somewhere inside a Navigation Popover. */
  get isInPopover() {
    return this.parentElement instanceof gi ? !0 : this.parentElement instanceof po ? this.parentElement.isInPopover : !1;
  }
  get navPopover() {
    return this.closest('[beacon-tag-name="beacon-navigation-popover"]');
  }
  get toolbelt() {
    return this.closest('[beacon-tag-name="beacon-navigation-toolbelt"]');
  }
  get menuContext() {
    return this.navPopover ? this.navPopover : this.toolbelt ? this.toolbelt : null;
  }
  /** Collapsed expanded navigations are only true when it can be drilled into. */
  get isCollapsed() {
    if (this.isMobile && !this.isActive && !this.showDrilldown) {
      if (this.level > this.activeLevel)
        return !0;
    } else if (!this.isMobile && this.level > 2 && !this.isActive)
      return !0;
    return !1;
  }
  get activeExpandedNav() {
    return this.querySelector(
      '[beacon-tag-name="beacon-navigation-expanded"][is-active]'
    );
  }
  /** Runs when nested expanded navigations fire dirlldown events. */
  handleInternalDrilldown(t) {
    this.showDrilldown = !0, this.isActive = !1, this.setGridTemplates(), Re(this, Ee.DRILLDOWN, t);
  }
  /** Runs when the navigation is requested to drilldown. */
  drilldown(t) {
    this.isActive = !0, Re(this, Ee.DRILLDOWN, t);
  }
  /** Runs when the navigation is requested to drill up. */
  drillup(t = !1) {
    var e;
    t && this.parentExpanded && (this.parentExpanded.titleSlotVal ? (this.parentExpanded.isActive = !0, this.parentExpanded.showDrilldown = !1) : this.parentExpanded.hasOnlyLinks ? (this.parentExpanded.showDrilldown = !1, (e = this.parentExpanded.parentExpanded) == null || e.drillup()) : this.parentExpanded.drillup()), this.showDrilldown = !1, this.isActive = !1, this.links.filter((a) => a instanceof po).forEach(
      (a) => a instanceof po && (a.showDrilldown || a.isActive) && a.drillup(t)
    ), this.setGridTemplates();
  }
  /** Maps the name of the slot that changes to a state property for if it has nodes. */
  checkSlotForContent({ target: t }) {
    if (t instanceof HTMLSlotElement) {
      const a = t.assignedNodes().length > 0;
      switch (GT(t.name)) {
        case "title":
          this.hasTitle = a;
          break;
        case "description":
          this.hasDescription = a;
          break;
        case "primary-link":
          this.hasPrimaryLink = a;
          break;
      }
    }
  }
  handlePromoSlotchange() {
    this.hasPromo = !!this.promo.length;
  }
  updateAnalytics() {
    var t, e, a, o, n;
    if (super.updateAnalytics(), ((t = this.menuContext) == null ? void 0 : t.metricsLocation) === $o.header && ((e = this.menuContext) == null ? void 0 : e.metricsSection) !== Ho.links) {
      ((a = this.menuContext) == null ? void 0 : a.metricsSection) === Ho.level1LangSelector ? this.metricsSection = Ho.level2LangSelector : this.metricsSection = Wa[1];
      return;
    }
    if (((o = this.menuContext) == null ? void 0 : o.metricsSection) === Ho.links && !this.hasAttribute("country-selector")) {
      this.metricsSection = Ho.links;
      return;
    }
    if (this.hasAttribute("country-selector")) {
      this.metricsSection = Ho.level1LangSelector;
      return;
    }
    if (((n = this.menuContext) == null ? void 0 : n.metricsLocation) === $o.siteNav) {
      this.metricsSection = $u(this.level);
      return;
    }
  }
  expandedNavPrerender() {
    document.addEventListener(Ee.DRILLUP, this.handleDrillup), document.addEventListener(Ee.CLOSE, this.handleCloseEvents), document.addEventListener(
      Ee.METRICS_LOCATION_CHANGE,
      this.handleAnalyticsChange
    ), document.addEventListener(
      Ee.METRICS_SECTION_CHANGE,
      this.handleAnalyticsChange
    ), document.addEventListener(
      Ee.METRICS_ID_CHANGE,
      this.handleAnalyticsChange
    );
  }
  expandedNavDestroy() {
    document.removeEventListener(Ee.DRILLUP, this.handleDrillup), document.removeEventListener(Ee.CLOSE, this.handleCloseEvents), document.removeEventListener(
      Ee.METRICS_LOCATION_CHANGE,
      this.handleAnalyticsChange
    ), document.removeEventListener(
      Ee.METRICS_SECTION_CHANGE,
      this.handleAnalyticsChange
    ), document.removeEventListener(
      Ee.METRICS_ID_CHANGE,
      this.handleAnalyticsChange
    );
  }
  /** Collapsed view differs based on the existence of content in the title slot. */
  renderCollapsed() {
    return this.titleSlotVal ? pe`
          ${Be`
          <${this.getScopedTag(Bn.navItemTagName)}
            @beacon-event-click=${this.drilldown}
            data-metrics-section="${gt($u(this.level - 1))}"
            expanded-anchor>
            <button class="collapsed-title-button">
              <slot name="collapsed-title">${this.titleSlotVal}</slot>
            </button>
          </${this.getScopedTag(Bn.navItemTagName)}>`}
          <div class="hide">
            <slot name="title" @slotchange=${this.handleTitleSlotchange}></slot>
            <!-- this slot holds any links and other expanded navs, but it is hidden and so it doesn't need to listen for drilldown events -->
            <slot></slot>
          </div>
        ` : pe`
          <slot
            class="hide"
            name="title"
            @slotchange=${this.handleTitleSlotchange}></slot>
          <section class="slot-container">
            <slot
              @beacon-event-drilldown=${this.handleInternalDrilldown}></slot>
          </section>
        `;
  }
  setGridSpanForPromoTiles() {
    this.style.setProperty(
      "--expanded-nav-grid-span",
      `calc(${String(this.promo.length)} + var(--expanded-nav-grid-template))`
    );
  }
  setLevel1GridTemplate() {
  }
  setLevel2GridTemplate(t) {
    this.showDrilldown ? this.setColumnsCSSProperty("1") : (super.setLevel2GridTemplate(t), this.setGridSpanForPromoTiles());
  }
  renderExpanded() {
    const t = {
      "has-nested-expanded": this.hasNestedExpandedNavigations,
      "header-zone": !0,
      "no-content": !this.hasPrimaryLink && !this.hasDescription && !this.hasTitle
    };
    return pe` <section class=${Oe(t)}>
        <div class="title-area">
          <div class="title-container">
            <slot
              name="title"
              part="title"
              ${Ue({ useParent: !0 })}
              @slotchange=${this.checkSlotForContent}></slot>
          </div>
          <div class="description-container">
            <slot
              name="description"
              ${Ue({ useParent: !0 })}
              @slotchange=${this.checkSlotForContent}></slot>
          </div>
          <div class="primary-link-container">
            <slot
              name="primary-link"
              role="list"
              ${Ue({ useParent: !0 })}
              @slotchange=${this.checkSlotForContent}></slot>
          </div>
        </div>
      </section>
      <section class="slot-container">
        <div class="default-slot">
          <slot
            @beacon-event-drilldown=${this.handleInternalDrilldown}
            @slotchange="${Is(
      this.handleDefaultSlotchange.bind(this)
    )}"></slot>
        </div>
        <slot
          class="promo-slot"
          name="promo"
          @slotchange=${this.handlePromoSlotchange}></slot>
      </section>`;
  }
  render() {
    const t = {
      popover: this.isInPopover,
      expanded: !this.isInPopover
    };
    return t[`level-${this.level}`] = !0, pe`<div class=${Oe(t)}>
      ${this.isCollapsed ? this.renderCollapsed() : this.renderExpanded()}
    </div> `;
  }
}, po.tagName = Bn.beaconTagName, po);
Uo([
  ue({ type: Boolean, reflect: !0, attribute: "show-drilldown" })
], ko.prototype, "showDrilldown", 2);
Uo([
  ue({ type: Boolean, reflect: !0, attribute: "is-active" })
], ko.prototype, "isActive", 2);
Uo([
  Se()
], ko.prototype, "hasPrimaryLink", 2);
Uo([
  Se()
], ko.prototype, "hasDescription", 2);
Uo([
  Se()
], ko.prototype, "hasTitle", 2);
Uo([
  Se()
], ko.prototype, "hasPromo", 2);
Uo([
  Pe({ slot: "description", flatten: !0 })
], ko.prototype, "descriptionNodes", 2);
Uo([
  Pe({ slot: "primary-link", flatten: !0 })
], ko.prototype, "primaryLinkNodes", 2);
Uo([
  Pe({ slot: "promo", flatten: !0 })
], ko.prototype, "promo", 2);
Uo([
  qe
], ko.prototype, "expandedNavPrerender", 1);
Uo([
  Lt
], ko.prototype, "expandedNavDestroy", 1);
let ov = ko;
const Pn = {
  beaconTagName: "beacon-navigation-toolbelt",
  buttonTagName: "beacon-button"
}, WT = ve`@media (width >= 960px){:host([motion-state=enabled]){display:grid;transition-duration:var(--beacon-reference-motion-duration-9);transition-property:grid-template-rows;transition-timing-function:var(--beacon-system-motion-easing-decelerate-emphasize-1)}:host([motion-state=enabled]) .content-wrapper{overflow:hidden}:host([motion-state=enabled]:not([is-open])){display:grid;grid-template-rows:0fr}:host([is-open][motion-state=enabled]){grid-template-rows:1fr}:host([is-open][motion-state=enabled]) .content-wrapper:focus-within{overflow:visible}}`;
var qT = Object.getOwnPropertyDescriptor, VT = (i, t, e, a) => {
  for (var o = a > 1 ? void 0 : a ? qT(t, e) : t, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = r(o) || o);
  return o;
};
function YT(i) {
  let t = class extends i {
    static get navigationToolbeltMotionStyles() {
      return [WT];
    }
    willUpdate(e) {
      if (e.has("motionState") && this.motionState === "enabled" && !this.prefersReducedMotion && this.setAttribute("inert", ""), yr(e, "isOpen")) {
        const a = e.get("isOpen");
        this.motionState === "enabled" && !this.prefersReducedMotion && (a ? this.setAttribute("inert", "") : this.removeAttribute("inert"));
      }
      super.willUpdate(e);
    }
  };
  return t = VT([
    je("NavigationToolbeltMotion")
  ], t), t;
}
const QT = ve`:host{inline-size:100%}:host(:not([is-open])){display:none}.container{background-color:var(--beacon-system-color-background-1)}.container :first-child{position:relative}@media (width >= 960px){.container{box-shadow:0 16px 24px -16px #002f48;margin:auto;max-inline-size:var(--beacon-system-breakpoint-xxx-large);padding-block:var(--beacon-reference-space-10) var(--beacon-system-space-organism-jumbo);padding-inline:var(--beacon-system-space-organism-maxi)}.container.is-drilldown{background-color:var(--beacon-system-color-background-2)}}@media (width >= 1280px){.container{padding-block-start:var(--beacon-reference-space-12)}}.back-button [beacon-tag-name=beacon-icon]{align-self:center;margin-inline-end:var(--beacon-reference-space-3)}.close-button-wrapper{display:none}@media (width >= 960px){.close-button-wrapper{display:block}.close-button-wrapper:not(.action-wrapper){inset-inline-end:0;position:absolute}.close-button-wrapper.action-wrapper{align-items:center;border-block-end:var(--beacon-system-width-border-mini) solid var(--beacon-system-color-border-0);display:flex;justify-content:space-between;margin-block-end:var(--beacon-reference-space-9);padding-block-end:var(--beacon-reference-space-9)}}.close-button [beacon-tag-name=beacon-icon]{padding-inline-start:var(--beacon-reference-space-2)}::part(standard-button){font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-body-100);align-items:center;color:var(--beacon-system-color-text-link);gap:0}@media (width >= 960px){:host{inset-block-start:100%;inset-inline-start:0;position:absolute;z-index:1001}:host([site-navigation]){z-index:0}}`;
var XT = Object.defineProperty, ZT = Object.getOwnPropertyDescriptor, av = (i, t, e, a) => {
  for (var o = a > 1 ? void 0 : a ? ZT(t, e) : t, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = (a ? r(t, e, o) : r(o)) || o);
  return a && o && XT(t, e, o), o;
};
const Wl = class Wl extends Ke(Le).with(
  Jf,
  Ra,
  Jh(),
  _s({ skipFirstUpdated: !0 }),
  YT,
  fr()
) {
  constructor() {
    super(...arguments), this.beaconTagName = Pn.beaconTagName, this.isDrilldown = !1;
  }
  static get styles() {
    return [super.styles, QT, this.navigationToolbeltMotionStyles];
  }
  static get lightDOMStyles() {
    return [super.lightDOMStyles];
  }
  /** Drills up from nested menus. */
  get backButton() {
    var t;
    return (t = this.shadowRoot) == null ? void 0 : t.querySelector("#menu");
  }
  /** Closes the menu entirely while maintaining the current drilldown state when re-opening. */
  get closeButton() {
    var t;
    return (t = this.shadowRoot) == null ? void 0 : t.querySelector("#close");
  }
  prerenderNavigationToolbeltSetup() {
    this.addEventListener(Ee.DRILLDOWN, this.handleDrilldown), this.addEventListener(Ee.DRILLUP, this.handleDrillup);
  }
  updated(t) {
    yr(t, "isOpen") && !this.isOpen && this.opensBy === "country-selector" && Re(this, Ee.COUNTRY_SELECTOR_CLOSE);
  }
  /** Handles drilldown events from child navigations. */
  handleDrilldown({ target: t }) {
    t instanceof ov && (this.isDesktop ? (t.level === 2 && (this.isDrilldown = !0), sh(this.backButton)) : t.level === 3 && (this.isDrilldown = !0));
  }
  /** Handles drillup events when pressing the back button. */
  handleDrillup() {
    this.isDrilldown = !1, sh(this.closeButton);
  }
  // In the case of the toolbelt there's only one level to drill down so the drill up occurs at the highest level
  handleBack() {
    this.backButton instanceof HTMLElement && Re(this.backButton, Ee.DRILLUP);
  }
  /**
   * Fires an event dedicated to closing the active nav item that is separate from toggling its state.
   *
   * This event helps issues in the popover that was capturing duplicate close events.
   *
   * @event beacon-event-close-active-nav-item
   */
  handleClose() {
    Re(this, Ee.CLOSE_ACTIVE_NAV_ITEM);
  }
  renderBackButton() {
    return this.isDrilldown ? Be`
        <${this.getScopedTag(Pn.buttonTagName)} 
          variant="tertiary" 
          id="menu"
          class="back-button"
          data-metrics-section="${jn.level_4}"
          @beacon-event-click=${this.handleBack}>
          Back 
          <${this.getScopedTag("beacon-icon")} name="chevron_left_small" size="s" slot="prefix"></${this.getScopedTag("beacon-icon")}>
        </${this.getScopedTag(Pn.buttonTagName)}>` : pe``;
  }
  renderCloseButton() {
    return Be`
      <${this.getScopedTag(Pn.buttonTagName)} 
        variant="tertiary" 
        id="close"
        class="close-button"
        @beacon-event-click=${this.handleClose}>
        Close <${this.getScopedTag("beacon-icon")} name='close_small' size='m' slot='suffix'></${this.getScopedTag("beacon-icon")}>
      </${this.getScopedTag(Pn.buttonTagName)}>
    `;
  }
  render() {
    const t = {
      "action-wrapper": this.isDrilldown,
      "close-button-wrapper": !0
    }, e = {
      container: !0,
      "is-drilldown": this.isDrilldown
    };
    return pe`
      <div class="content-wrapper">
        <div class=${Oe(e)} part="toolbelt-container">
          <div class="content-wrapper">
            <div class=${Oe(t)}>
              ${this.renderBackButton()} ${this.renderCloseButton()}
            </div>
            <slot></slot>
          </div>
        </div>
      </div>
    `;
  }
};
Wl.tagName = Pn.beaconTagName, Wl.nestedComponents = [Zo, fo];
let ar = Wl;
av([
  ue()
], ar.prototype, "isDrilldown", 2);
av([
  qe
], ar.prototype, "prerenderNavigationToolbeltSetup", 1);
const JT = ve`:root[beacon-tag-name=beacon-navigation],:root [beacon-tag-name=beacon-navigation],[beacon-version="4.3.1"][class*=beacon-on][beacon-tag-name=beacon-navigation],[beacon-version="4.3.1"][class*=beacon-on] [beacon-tag-name=beacon-navigation],[class*=beacon-on] [beacon-version="4.3.1"][beacon-tag-name=beacon-navigation],[class*=beacon-on] [beacon-version="4.3.1"] [beacon-tag-name=beacon-navigation],[beacon-version="4.3.1"][beacon-tag-name=beacon-navigation],[beacon-version="4.3.1"] [beacon-tag-name=beacon-navigation]{--navigation-action-zone-size: var(--beacon-reference-space-12);--navigation-wrapper-block-size: var(--beacon-reference-space-13);--navigation-brand-zone-padding-inline-start: var(--beacon-reference-space-7);--navigation-brand-zone-padding-inline-end: var(--beacon-reference-space-5);--navigation-header-zone-padding-inline: 0;--navigation-wordmark-inline-size: 118px;--navigation-skip-link-outline: none;--navigation-popover-size-inline: calc(18 * var(--beacon-reference-space-5));--navigation-popover-content-size-inline: calc(17 * var(--beacon-reference-space-5))}@media (width >= 640px){:root[beacon-tag-name=beacon-navigation],:root [beacon-tag-name=beacon-navigation],[beacon-version="4.3.1"][class*=beacon-on][beacon-tag-name=beacon-navigation],[beacon-version="4.3.1"][class*=beacon-on] [beacon-tag-name=beacon-navigation],[class*=beacon-on] [beacon-version="4.3.1"][beacon-tag-name=beacon-navigation],[class*=beacon-on] [beacon-version="4.3.1"] [beacon-tag-name=beacon-navigation],[beacon-version="4.3.1"][beacon-tag-name=beacon-navigation],[beacon-version="4.3.1"] [beacon-tag-name=beacon-navigation]{--navigation-brand-zone-padding-inline-start: var(--beacon-reference-space-9);--navigation-brand-zone-padding-inline-end: var(--beacon-reference-space-7);--navigation-popover-size-inline: calc(21.25 * var(--beacon-reference-space-5));--navigation-popover-content-size-inline: calc(18 * var(--beacon-reference-space-5))}}@media (width >= 960px){:root[beacon-tag-name=beacon-navigation],:root [beacon-tag-name=beacon-navigation],[beacon-version="4.3.1"][class*=beacon-on][beacon-tag-name=beacon-navigation],[beacon-version="4.3.1"][class*=beacon-on] [beacon-tag-name=beacon-navigation],[class*=beacon-on] [beacon-version="4.3.1"][beacon-tag-name=beacon-navigation],[class*=beacon-on] [beacon-version="4.3.1"] [beacon-tag-name=beacon-navigation],[beacon-version="4.3.1"][beacon-tag-name=beacon-navigation],[beacon-version="4.3.1"] [beacon-tag-name=beacon-navigation]{--navigation-wrapper-block-size: var(--beacon-reference-space-14);--navigation-brand-zone-padding-inline-start: 0;--navigation-brand-zone-padding-inline-end: 0;--navigation-popover-size-inline: calc(18 * var(--beacon-reference-space-5))}}@media (width >= 1280px){:root[beacon-tag-name=beacon-navigation],:root [beacon-tag-name=beacon-navigation],[beacon-version="4.3.1"][class*=beacon-on][beacon-tag-name=beacon-navigation],[beacon-version="4.3.1"][class*=beacon-on] [beacon-tag-name=beacon-navigation],[class*=beacon-on] [beacon-version="4.3.1"][beacon-tag-name=beacon-navigation],[class*=beacon-on] [beacon-version="4.3.1"] [beacon-tag-name=beacon-navigation],[beacon-version="4.3.1"][beacon-tag-name=beacon-navigation],[beacon-version="4.3.1"] [beacon-tag-name=beacon-navigation]{--navigation-wordmark-inline-size: 132px;--navigation-popover-size-inline: calc(24.75 * var(--beacon-reference-space-5));--navigation-popover-content-size-inline: calc(21.75 * var(--beacon-reference-space-5))}}`, Gt = {
  // Tag Names
  beaconTagName: "beacon-navigation",
  buttonTagName: "beacon-button",
  iconButtonTagName: "beacon-icon-button",
  // Slot Name
  localSlot: "local-zone",
  globalSlot: "global-zone",
  actionSlot: "action-zone",
  brandMarkSlot: "brandmark",
  wordMarkSlot: "wordmark",
  wordMarkAriaLabel: "T. Rowe Price - Home"
};
function zn(i) {
  const t = [
    "beacon-navigation-popover",
    "beacon-navigation-toolbelt"
  ];
  return i.hasAttribute("beacon-tag-name") && t.includes(i.getAttribute("beacon-tag-name"));
}
const eM = ve`[beacon-tag-name=beacon-navigation][menu-expanded] ::part(icon-button){color:var(--beacon-system-color-text-link)}[beacon-tag-name=beacon-navigation] a{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100);color:var(--beacon-component-primary-navigation-header-color-text-link)}[beacon-tag-name=beacon-navigation] a:not(:hover,:focus){text-decoration:none}@media (width < 960px){[beacon-tag-name=beacon-navigation] a:not([slot=skip-link]):focus-visible{background-color:var(--beacon-system-color-background-link-focus)!important;border-block-end-color:unset;box-shadow:0 var(--beacon-system-width-border-jumbo) 0 0 var(--beacon-system-color-border-link-focus);color:var(--beacon-system-color-text-set-navy)!important;outline:none;text-decoration:none}}@media (width < 960px) and (forced-colors: active){[beacon-tag-name=beacon-navigation] a:not([slot=skip-link]):focus-visible{border-block-end:var(--beacon-system-width-border-jumbo) solid var(--beacon-system-color-border-link-focus)}}@media (width >= 960px){[beacon-tag-name=beacon-navigation] a:not([slot=skip-link]):focus-visible{box-shadow:0 0 0 var(--beacon-system-width-border-jumbo) var(--beacon-system-color-border-focus-middle),0 0 0 var(--beacon-system-width-border-maxi) var(--beacon-system-color-border-focus-outer);outline:var(--beacon-system-width-border-normal) solid var(--beacon-system-color-border-focus-inner);outline-offset:0;z-index:1}[beacon-tag-name=beacon-navigation] a:not([slot=skip-link]):focus-visible:not(dialog){position:relative}}@media (width >= 960px){[beacon-tag-name=beacon-navigation] a[aria-current=page]{border-block-end:var(--beacon-system-width-border-normal) solid var(--beacon-system-color-border-brand)}}[beacon-tag-name=beacon-navigation] a[slot=wordmark]{color:inherit}[beacon-tag-name=beacon-navigation] a[slot=skip-link]{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100);border:0;clip:rect(0,0,0,0);block-size:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;inline-size:1px;color:var(--beacon-system-color-text-set-navy);display:inline-block;text-decoration:none;z-index:-1}[beacon-tag-name=beacon-navigation] a[slot=skip-link]:focus-visible{border:revert;clip:revert;block-size:revert;margin:revert;overflow:revert;padding:revert;position:revert;inline-size:revert;border-block-end:var(--beacon-system-width-border-jumbo) solid var(--beacon-system-color-border-link-focus);margin:var(--beacon-system-space-cell-contained);outline:var(--navigation-skip-link-outline, revert);z-index:auto}[beacon-tag-name=beacon-navigation] [slot=header-zone] svg{color:var(--beacon-system-color-icon-link, currentColor)}[beacon-tag-name=beacon-navigation] [slot=media]{max-inline-size:100%}[beacon-tag-name=beacon-navigation] [slot=media]>*{max-inline-size:100%}[beacon-tag-name=beacon-navigation][drilldown-expanded] :is([slot=local-zone],[slot=global-zone],[slot=header-zone],[slot=site-selector],[slot=action-zone],[site-navigation]):not([beacon-tag-name=beacon-navigation-popover],[beacon-tag-name=beacon-navigation-toolbelt],div),[beacon-tag-name=beacon-navigation][drilldown-expanded] div:is([slot=local-zone],[slot=global-zone],[slot=header-zone],[slot=site-selector],[slot=action-zone],[site-navigation])>:is([beacon-tag-name=beacon-navigation-button],a):not([active]),[beacon-tag-name=beacon-navigation][drilldown-expanded] div:is([slot],[site-navigation]) [active],[beacon-tag-name=beacon-navigation][drilldown-expanded] [country-selector]{display:none}[beacon-tag-name=beacon-navigation] div[slot=action-zone]>*{inline-size:100%}@media (width >= 960px){[beacon-tag-name=beacon-navigation] div[site-navigation]>[beacon-tag-name=beacon-navigation-button]{block-size:100%;display:grid}[beacon-tag-name=beacon-navigation] div[site-navigation]>[beacon-tag-name=beacon-navigation-toolbelt]{z-index:0}[beacon-tag-name=beacon-navigation] a[slot=local-zone],[beacon-tag-name=beacon-navigation] [slot=local-zone]>a{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-300)}[beacon-tag-name=beacon-navigation] :is([slot=local-zone],[slot=global-zone]):not([beacon-tag-name=beacon-navigation-toolbelt],[beacon-tag-name=beacon-navigation-popover]){inline-size:max-content}[beacon-tag-name=beacon-navigation] div:is([slot=local-zone],[slot=global-zone])>*:not([beacon-tag-name=beacon-navigation-toolbelt]){inline-size:inherit}[beacon-tag-name=beacon-navigation] :is(a,[beacon-tag-name=beacon-icon-button]):is([slot=local-zone],[slot=global-zone]),[beacon-tag-name=beacon-navigation] :is([slot=local-zone],[slot=global-zone]) a{padding-block-end:var(--beacon-system-space-cell-free-floating);padding-block-start:var(--beacon-system-space-cell-free-floating)}[beacon-tag-name=beacon-navigation]>a:not([slot],[data-has-beacon-language-event],[selected-language]){align-items:center;block-size:100%;color:var(--beacon-component-primary-navigation-header-color-text-link);display:grid;font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-300);padding-block-end:var(--beacon-system-space-cell-free-floating);padding-block-start:var(--beacon-system-space-cell-free-floating)}}div[site-navigation].aem-edit-mode{display:flex;flex-direction:row;gap:var(--beacon-reference-space-9)}`, tM = ve`@media (width >= 960px){:host{z-index:2000}.primary-wrapper{position:relative}:host([in-motion]) .primary-wrapper{z-index:-1}.sitenav-ul-wrapper{background-color:inherit}}`;
var oM = Object.defineProperty, aM = Object.getOwnPropertyDescriptor, Gu = (i, t, e, a) => {
  for (var o = a > 1 ? void 0 : a ? aM(t, e) : t, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = (a ? r(t, e, o) : r(o)) || o);
  return a && o && oM(t, e, o), o;
};
function iM(i) {
  let t = class extends i {
    static get navigationMotionStyles() {
      return [tM];
    }
    get siteNavWrapper() {
      var e;
      return (e = this.shadowRoot) == null ? void 0 : e.querySelector(".primary-wrapper");
    }
    get headerWrapper() {
      var e;
      return (e = this.shadowRoot) == null ? void 0 : e.querySelector(".header-wrapper");
    }
    /**
     * Applies custom motion classes to the header and site nav wrappers.
     *
     * @param layer The layer order this element should appear where higher numbers are higher `z-index` values.
     * @param additionalClasses Arbitrary number of extra classes to apply to the class set.
     */
    generateMotionClasses(...e) {
      const a = [];
      return this.hasFieldAndValue("isMobile", !1) && a.push(
        "b-motion--intro-from-top",
        "b-motion-ease--decelerate--emphasize-1",
        "b-motion-duration--extra-long-2",
        ...e
      ), a;
    }
    applyNavigationMotionStyles({ target: e }) {
      var a, o;
      e === this && !this.prefersReducedMotion && ((a = this.headerWrapper) == null || a.classList.add(...this.generateMotionClasses()), (o = this.siteNavWrapper) == null || o.classList.add(
        ...this.generateMotionClasses("b-motion-delay--medium-2")
      ));
    }
    /**
     * Removes custom motion classes from the header and site nav wrappers.
     *
     * It gets triggered from site nav because these classes add `z-index` styles and prematurely removing those classes from the header - since it finishes animating first - cause visual overlap as the site nav fades in.
     *
     * To avoid that, site nav finishes animating first so the two elements remove their classes together.
     *
     * @param target Event target.
     */
    static removeNavigationMotionClasses({ target: e }) {
      e instanceof HTMLElement && e.previousElementSibling instanceof HTMLElement && [e, e.previousElementSibling].forEach(
        (a) => a.classList.remove(
          ...Array.from(a.classList).filter(
            (o) => o.includes("b-motion")
          )
        )
      );
    }
    attachAnimationendListener({ target: e }) {
      this.siteNavWrapper && e === this && this.siteNavWrapper.addEventListener(
        "animationend",
        t.removeNavigationMotionClasses
      );
    }
    prerenderNavigationMotionSetup() {
      this.addEventListener(
        Ee.ELEMENT_READY,
        this.applyNavigationMotionStyles
      ), this.addEventListener(
        Ee.ELEMENT_READY,
        this.attachAnimationendListener
      );
    }
  };
  return Gu([
    qe
  ], t.prototype, "prerenderNavigationMotionSetup", 1), t = Gu([
    je("NavigationMotion")
  ], t), t;
}
const nM = ve`:host{--bg: var(--beacon-system-color-background-0);background-color:var(--bg);position:relative;z-index:2000}.skip-link-wrapper{background-color:var(--beacon-system-color-background-link-focus);inline-size:100%}.skip-link-wrapper .skip-link-container{margin-inline:auto;max-inline-size:var(--beacon-system-breakpoint-xxx-large)}ul{margin:0;padding:0}.wordmark-container{color:var(--beacon-system-color-text-title);display:flex;padding-block:var(--beacon-system-space-cell-free-floating)}.wordmark-container svg,.wordmark-container ::slotted(svg){max-inline-size:var(--navigation-wordmark-inline-size)}.brand-zone-container{align-items:center;background-color:var(--beacon-system-color-background-0, );display:flex;justify-content:space-between;min-block-size:var(--navigation-wrapper-block-size);padding-inline-end:var(--navigation-brand-zone-padding-inline-end);padding-inline-start:var(--navigation-brand-zone-padding-inline-start)}.brand-zone-container ::slotted(svg){flex-shrink:0}.wordmark-container a,.brand-zone-container a{color:inherit;display:inline-flex}@media (width < 960px){.wordmark-container a:focus-visible,.brand-zone-container a:focus-visible{background-color:var(--beacon-system-color-background-link-focus)!important;border-block-end-color:unset;box-shadow:0 var(--beacon-system-width-border-jumbo) 0 0 var(--beacon-system-color-border-link-focus);color:var(--beacon-system-color-text-set-navy)!important;outline:none;text-decoration:none}}@media (width < 960px) and (forced-colors: active){.wordmark-container a:focus-visible,.brand-zone-container a:focus-visible{border-block-end:var(--beacon-system-width-border-jumbo) solid var(--beacon-system-color-border-link-focus)}}@media (width >= 960px){.wordmark-container a:focus-visible,.brand-zone-container a:focus-visible{box-shadow:0 0 0 var(--beacon-system-width-border-jumbo) var(--beacon-system-color-border-focus-middle),0 0 0 var(--beacon-system-width-border-maxi) var(--beacon-system-color-border-focus-outer);outline:var(--beacon-system-width-border-normal) solid var(--beacon-system-color-border-focus-inner);outline-offset:0;z-index:1}.wordmark-container a:focus-visible:not(dialog),.brand-zone-container a:focus-visible:not(dialog){position:relative}}[name=trusty]::part(internal--icon){inline-size:100%;max-inline-size:72px}.local-header-global-container{inline-size:100%}.action-zone-wrapper{align-items:center;background-color:var(--beacon-system-color-background-2);display:flex;gap:var(--beacon-reference-space-5);inline-size:100%;inset-block-end:0;inset-inline-start:0;padding-block:var(--beacon-system-space-cell-free-floating);padding-inline:var(--beacon-system-space-organism-jumbo);position:fixed;z-index:var(--navigation-action-zone-z-index, 2)}::slotted([slot=action-zone]){inline-size:100%}.menu{background-color:var(--beacon-system-color-background-1);block-size:calc(100dvh - var(--navigation-wrapper-block-size) - var(--action-zone-size, 0))}.menu .action-zone-wrapper{min-block-size:var(--action-zone-size, auto)}.vertical-divider{display:none;inline-size:var(--beacon-system-width-border-mini)}.header-zone-wrapper{align-items:center;display:flex;gap:var(--beacon-reference-space-3);padding-block:var(--beacon-system-space-cell-free-floating);padding-inline:var(--navigation-header-zone-padding-inline)}.local-zone-container,.global-zone-container,.sitenav-ul-wrapper{align-items:start;border-block-end:var(--beacon-system-width-border-mini) solid var(--beacon-system-color-border-1);display:flex;flex-direction:column;gap:var(--beacon-reference-space-5);padding-block:var(--beacon-reference-space-5)}.partner-logo-wrapper{border-block-end:var(--beacon-system-width-border-mini) solid var(--beacon-system-color-border-1);margin-block-end:var(--beacon-system-space-micro-jumbo);padding-block-end:var(--beacon-system-space-micro-jumbo)}.partner-logo{--partner-logo-max-inline-size: 92px;max-inline-size:var(--beacon-custom-navigation-partner-logo-max-inline-size, var(--partner-logo-max-inline-size))}.site-selector-slot{border-block-end:var(--beacon-system-width-border-mini) solid var(--beacon-system-color-border-1);padding-block-end:var(--beacon-reference-space-5)}.country-selector-slot{padding-block-start:var(--beacon-reference-space-5)}::part(icon-button){color:var(--beacon-system-color-icon-link)}.drill-up::part(standard-button){font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-body-100);--beacon-button-icon-align: center;align-items:center;color:var(--beacon-component-primary-navigation-header-color-text-link);gap:0}.drill-up [beacon-tag-name=beacon-icon]{align-self:center;margin-inline-end:var(--beacon-reference-space-3)}:host([drilldown-expanded]) .local-zone-container,:host([drilldown-expanded]) .global-zone-container,:host([drilldown-expanded]) .sitenav-ul-wrapper,:host([drilldown-expanded]) .site-selector-slot{border:0}:host([drilldown-expanded]) .site-selector-slot{padding-block-start:var(--beacon-reference-space-5)}:host([menu-expanded]){--navigation-menu-expanded-navigation-button-color: var(--beacon-system-color-text-link)}:host([menu-expanded]) ::part(icon-button){color:var(--beacon-system-color-icon-link)}:host([menu-expanded]) .menu-zone-container{overflow-y:auto;padding-block:var(--beacon-system-space-organism-jumbo);padding-inline:var(--beacon-system-space-organism-maxi)}:host([menu-expanded]) .menu-zone-container::-webkit-scrollbar{block-size:calc(var(--beacon-reference-space-3) * .75);inline-size:calc(var(--beacon-reference-space-3) * .75)}:host([menu-expanded]) .menu-zone-container::-webkit-scrollbar-thumb{background:var(--beacon-component-scrollbar-color-background-thumb);border-radius:calc(.875 * var(--beacon-reference-space-5))}:host([menu-expanded]) .menu-zone-container::-webkit-scrollbar-track{background:var(--beacon-reference-palette-grayscale-light-gray-1)}:host([menu-expanded]) .menu-zone-container::-webkit-scrollbar-corner{background:var(--beacon-reference-palette-grayscale-light-gray-1)}:host([menu-expanded]) .action .action-zone-wrapper{background-color:transparent;padding-block:var(--beacon-reference-space-5);padding-inline:0;position:static}.hide{display:none}::slotted(div[site-navigation]),::slotted(div[slot]){display:contents}.menu-closed.header-zone-only{display:none}.nav-dialog-overlay{block-size:100%;border:0;inline-size:100%;max-block-size:none;max-inline-size:none;padding:0;position:fixed}.skip-link{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100);border:0;clip:rect(0,0,0,0);block-size:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;inline-size:1px;color:var(--beacon-system-color-text-set-navy);display:inline-block;text-decoration:none;z-index:-1}.skip-link:focus-visible{border:revert;clip:revert;block-size:revert;margin:revert;overflow:revert;padding:revert;position:revert;inline-size:revert;border-block-end:var(--beacon-system-width-border-jumbo) solid var(--beacon-system-color-border-link-focus);margin:var(--beacon-system-space-cell-contained);outline:var(--navigation-skip-link-outline, revert);z-index:auto}.a11y-skip-navigation-links{border:0;outline:0}@media (width >= 960px){.header-wrapper{background-color:var(--bg);display:flex;justify-content:space-between;margin:auto;max-inline-size:var(--beacon-system-breakpoint-xxx-large);min-block-size:var(--navigation-wrapper-block-size);position:relative}.brand-zone-container{block-size:fit-content;gap:var(--beacon-reference-space-7)}.menu-zone-container:not(.hide){align-items:center;display:flex;min-block-size:inherit;padding-inline-end:var(--beacon-system-space-cell-contained)}.wordmark-container{padding:var(--beacon-system-space-cell-contained)}.action-zone-wrapper{background-color:inherit;margin-inline-start:var(--beacon-reference-space-5);padding:var(--beacon-system-space-cell-contained);padding-inline-end:0;position:static;z-index:auto}.global-zone-container,.local-zone-container{align-items:center;border:0;flex-direction:row;padding-block:var(--beacon-system-space-cell-contained);padding-inline:var(--beacon-system-space-cell-contained)}.site-selector-slot{display:contents}.ul-wrapper{align-items:center;display:flex;gap:var(--beacon-reference-space-5)}::slotted([slot=action-zone]){inline-size:initial}::slotted([beacon-tag-name=beacon-button]){min-inline-size:max-content;word-break:keep-all}.primary-wrapper{background-color:var(--beacon-system-color-background-0);display:grid;gap:var(--beacon-reference-space-9);grid-template-columns:1fr auto 1fr;margin-inline:auto;max-inline-size:var(--beacon-system-breakpoint-xxx-large)}.partner-logo-wrapper{border:0;grid-column:3/4;margin:0;padding-block:0;padding-inline-end:var(--beacon-reference-space-5);place-self:center end}.sitenav-ul-wrapper{align-items:center;block-size:var(--beacon-reference-space-13);border-block-end:0;flex-direction:row;gap:var(--beacon-reference-space-9);grid-column:2/3;justify-content:center;padding:0}.sitenav-ul-wrapper ::slotted([beacon-tag-name=beacon-navigation-button]){block-size:100%;display:grid}.vertical-divider{display:block}}@media (width >= 1280px){.partner-logo{--partner-logo-max-inline-size: 115px}}`;
var rM = Object.defineProperty, sM = Object.getOwnPropertyDescriptor, Xe = (i, t, e, a) => {
  for (var o = a > 1 ? void 0 : a ? sM(t, e) : t, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = (a ? r(t, e, o) : r(o)) || o);
  return a && o && rM(t, e, o), o;
};
const lM = (i) => !!i && i.level === 2, cM = (i) => "isDrilldown" in i;
var Xt;
const Ye = (Xt = class extends Ke(Le).with(
  vT,
  fr({ autoRemoveMotionClasses: !1 }),
  iM,
  Ra,
  Jh({ onReady: !1, removeLargeEvent: !0 }),
  _s({ skipFirstUpdated: !1, runOnSlotchange: !0 })
) {
  constructor() {
    super(...arguments), this.beaconTagName = Gt.beaconTagName, this.focusOverride = !0, this.deferrable = !1, this.isDrilldownExpanded = !1, this.wordmarkUrl = "", this.isMenuExpanded = !1, this.currentOpenSlot = Nt.DEFAULT, this.isCustomWordmark = !1, this.isActionZone = !1, this.isGlobalZone = !1, this.isLocalZone = !1, this.isSiteNav = !1, this.isSiteSelector = !1, this.activeNavItem = null, this.activeNavItemClickAwayHandler = ({ x: t, y: e, target: a }) => {
      var o, n, r, T, O, j, D, F, B;
      if (this.activeNavItem) {
        const N = this.activeNavItem.getBoundingClientRect(), f = (n = (o = this.activeNavItem) == null ? void 0 : o.expandingElement) == null ? void 0 : n.getBoundingClientRect(), w = Ku(t, e, N) && Ku(t, e, f), x = this.activeNavItem.contains(a) || ((T = (r = this.activeNavItem) == null ? void 0 : r.expandingElement) == null ? void 0 : T.contains(a)) || ((j = (O = this.activeNavItem) == null ? void 0 : O.shadowRoot) == null ? void 0 : j.contains(a)) || ((B = (F = (D = this.activeNavItem) == null ? void 0 : D.expandingElement) == null ? void 0 : F.shadowRoot) == null ? void 0 : B.contains(
          a
        ));
        w && !x && Re(this, Ee.CLOSE_ACTIVE_NAV_ITEM);
      }
    }, this.handleBreakpointChanges = ({ matches: t }) => {
      var e, a, o, n;
      if (!t)
        this.setHeaderZoneElement("header-zone"), this.currentOpenSlot === Nt.COUNTRY && Xt.resetOpenCountrySelector();
      else {
        this.isMenuExpanded = !1, this.isDrilldownExpanded = !1, ls(), this.setHeaderZoneElement("global-zone"), this.removeOnLightClasses(), this.invertOpenMenuMode(), ((a = Array.from((e = this.renderRoot) == null ? void 0 : e.children)) == null ? void 0 : a.find(
          (O) => O === this.headerEl
        )) || this.appendHeaderToRoot(), sh(this.activeNavItem);
        const T = this.querySelector("[is-active]");
        if (lM(T)) {
          const O = T.closest(
            '[beacon-tag-name="beacon-navigation-toolbelt"]'
          );
          cM(O) && (O.isDrilldown = !1), (o = T.parentExpanded) == null || o.drillup(), (n = T.parentExpanded) == null || n.setGridTemplates();
        }
      }
      this.updateActionZoneScale();
    }, this.handleActiveNavItemChange = ({ target: t }) => {
      t instanceof it && (this.activeNavItem = this.querySelector(
        '[beacon-tag-name="beacon-navigation-button"][active]'
      ), this.isMobile && this.updateDrilldownExpanded(t.active), this.currentOpenSlot = this.activeNavItem instanceof it ? this.activeNavItem.navType : Nt.DEFAULT);
    }, this.addEventToSkipLink = () => {
      var e, a;
      const t = ((e = this.skipLink[0]) == null ? void 0 : e.matches("a")) && this.skipLink[0] || ((a = this.skipLink[0]) == null ? void 0 : a.querySelector("a"));
      t == null || t.addEventListener("click", () => {
        Re(t, Ee.SKIP_LINK_CLICK);
      });
    }, this.handleSkipLinkClick = () => {
      this.isMenuExpanded && this.updateMenuExpanded();
    }, this.handleClickFromAnyLink = () => {
      this.isMenuExpanded && this.updateMenuExpanded(), Re(this, Ee.CLOSE_ACTIVE_NAV_ITEM);
    }, this.onNavKeyDown = (t) => {
      t.key === Ea.ESCAPE && this.isMobile && this.isMenuExpanded && this.updateMenuExpanded();
    };
  }
  static get styles() {
    return [
      super.styles,
      this.motionStyles,
      this.inverseStyles,
      nM,
      this.navigationMotionStyles
    ];
  }
  static get lightDOMStyles() {
    return [super.lightDOMStyles, eM, JT];
  }
  // Excludes skip link and wordmark
  // Excludes _skip-link-anchor because vitest picks it up for some unknown reason
  get allSlottedContent() {
    return [...this.slottedZoneContent, ...this.slottedSiteNavigation].filter(
      (t) => t.localName !== "style" && t.slot !== "_skip-link-anchor"
    );
  }
  get slottedZoneContent() {
    return [
      ...this.slottedActionZone,
      ...this.slottedLocalZone,
      ...this.slottedGlobalZone,
      ...this.slottedHeaderZone
    ].filter((t) => t.localName !== "style");
  }
  /** Text to use as the ARIA label for the mobile menu button. */
  get menuAriaLabel() {
    return this.isMenuExpanded ? "Close Menu" : "Open Menu";
  }
  /** The header maintains some views as light-only, and this getter returns the correct light mode to use based on the current mode of the parent. */
  get lightModeClass() {
    var t;
    return ((t = this.modeStoreComponent) == null ? void 0 : t.currentMode) === "beacon-on-lighter" ? "beacon-on-lighter" : "beacon-on-light";
  }
  /** Query for the brand zone section. */
  get brandZoneContainer() {
    var t;
    return (t = this.shadowRoot) == null ? void 0 : t.querySelector(".brand-zone-container");
  }
  /** Query for the TRP Wordmark. */
  get defaultWordmark() {
    var t;
    return (t = this.shadowRoot) == null ? void 0 : t.querySelector(".wordmark");
  }
  get allLinks() {
    return Array.from(this.querySelectorAll("a"));
  }
  setCustomWordmarkState() {
    var t;
    this.isCustomWordmark = !!((t = this.slottedWordmark) != null && t.length);
  }
  setActionZoneState() {
    var t;
    this.isActionZone = !!((t = this.slottedActionZone) != null && t.length);
  }
  setGlobalZoneState() {
    const t = this.slottedGlobalZone.find(
      (e) => e.getAttribute("beacon-tag-name") !== "beacon-navigation-toolbelt" || e.getAttribute("beacon-tag-name") !== "beacon-navigation-popover"
    );
    this.isGlobalZone = !!t;
  }
  setLocalZoneState() {
    var t;
    this.isLocalZone = !!((t = this.slottedLocalZone) != null && t.length);
  }
  setSiteNavigationState() {
    var t, e;
    this.isSiteNav = !!((t = this.slottedSiteNavigation) != null && t.length), (e = this.slottedSiteNavigation) == null || e.forEach(
      (a) => a.setAttribute("site-navigation", "")
    );
  }
  setSiteSelectorState() {
    var t;
    this.isSiteSelector = !!((t = this.slottedSiteSelector) != null && t.length);
  }
  /**
   * Actions taken when pressing the back button.
   *
   * @fires BeaconEvents beacon-event-drillup
   */
  handleBackButton() {
    Re(this, Ee.DRILLUP);
  }
  /** Updates header state when the header zone item is clicked. */
  handleHeaderZoneClick() {
    this.updateMenuExpanded(), this.updateDrilldownExpanded(!0), this.invertOpenMenuMode();
  }
  /**
   * Appends the header to the dialog.
   */
  appendHeaderToDialog() {
    this.navigationDialogElement.appendChild(this.headerEl), this.navigationDialogElement.showModal();
  }
  /**
   * Appends the header to the root.
   */
  appendHeaderToRoot() {
    var t, e;
    (t = this.skipLinWrapperEl) == null || t.insertAdjacentElement("afterend", this.headerEl), (e = this.navigationDialogElement) == null || e.close();
  }
  /** Performed when the menu icon is interacted with. */
  handleMenuClick() {
    this.isMenuExpanded && this.handleBackButton(), this.updateMenuExpanded(), this.toggleActionZoneLightMode(), this.invertOpenMenuMode();
  }
  /**
   * Handles changes when the expanded menu opens or closes.
   *
   * @todo implement focus trapping when opening the menu so you can't tab into other elements on the page. could look at a dialog.showModal solution, adding `inert` to all non-this elements, maybe our focus-trap mixin, etc.
   */
  updateMenuExpanded() {
    if (this.isMenuExpanded = !this.isMenuExpanded, this.isMenuExpanded) {
      Re(this, Ee.OPEN), eb(), this.activeNavItem && this.updateDrilldownExpanded(!0);
      return;
    }
    Re(this, Ee.CLOSE), ls(), this.updateDrilldownExpanded();
  }
  /** Sets the drilldown expanded state based on a supplied condition. */
  updateDrilldownExpanded(t = !1) {
    this.isDrilldownExpanded = t;
  }
  /** Forces slotted action zone elements into light mode when the menu opens. */
  toggleActionZoneLightMode() {
    this.slottedActionZone.length > 0 && this.slottedActionZone.forEach((t) => {
      this.isMenuExpanded ? t.classList.add(this.lightModeClass) : t.classList.remove(this.lightModeClass);
    });
  }
  /** Applies a light theme to the expanded menu. The menu is always light theme. */
  invertOpenMenuMode() {
    var e, a, o, n;
    let t;
    ((e = this.modeStoreComponent) == null ? void 0 : e.currentMode) === "beacon-on-darker" || ((a = this.modeStoreComponent) == null ? void 0 : a.currentMode) === "beacon-on-lighter" ? t = "beacon-on-lighter" : t = "beacon-on-light", this.isMenuExpanded && this.modeStoreComponent ? ((o = this.brandZoneContainer) == null || o.classList.add(
      this.modeStoreComponent.currentMode
    ), this.classList.add(t)) : this.modeStoreComponent && ((n = this.brandZoneContainer) == null || n.classList.remove(
      this.modeStoreComponent.currentMode
    ), this.classList.remove(t));
  }
  /** Sets the location of the header zone element. */
  setHeaderZoneElement(t) {
    const e = t === "header-zone" ? this.slottedGlobalZone.find((a) => a.hasAttribute("header-zone")) : this.slottedHeaderZone.find((a) => a.hasAttribute("header-zone"));
    e == null || e.setAttribute("slot", t);
  }
  /**
   * Due to the nature of cloning country components, we want to force the country selector closed when going from a desktop view to mobile view with the country selector active.
   */
  static resetOpenCountrySelector() {
    const t = document.querySelector(
      '[beacon-tag-name="beacon-navigation-toolbelt"][is-open]'
    ), e = document.querySelector(
      '[beacon-tag-name="beacon-navigation-button"][active]'
    );
    t instanceof ar && e instanceof it && (t.isOpen = !1, e.active = !1);
  }
  /**
   * Remove onLight Classes
   */
  removeOnLightClasses() {
    var t, e;
    this.slottedHeaderZone && ((t = this.slottedHeaderZone) != null && t.length) && this.slottedHeaderZone.forEach(
      (a) => a.classList.remove(this.lightModeClass)
    ), this.slottedActionZone && ((e = this.slottedActionZone) != null && e.length) && this.slottedActionZone.forEach(
      (a) => a.classList.remove(this.lightModeClass)
    );
  }
  /**
   * Update slottedActionZone Button scales based on breakpoint.
   */
  updateActionZoneScale() {
    var t;
    this.isMobile && ((t = this.slottedActionZone) != null && t.length) ? this.slottedActionZone.forEach((e) => e.setAttribute("scale", "mini")) : this.slottedActionZone.forEach((e) => e.setAttribute("scale", "normal"));
  }
  updateAnalytics() {
    super.updateAnalytics(), this.defaultWordmark && this.defaultWordmark.setAttribute(
      zt.location,
      $o.header
    ), this.isCustomWordmark && this.slottedWordmark.forEach((t) => {
      t.setAttribute(
        zt.location,
        $o.header
      );
    }), this.isLocalZone && this.slottedLocalZone.forEach((t) => {
      t.setAttribute(
        zt.location,
        $o.header
      ), zn(t) ? t.setAttribute(
        zt.section,
        Wa[1]
      ) : t.setAttribute(
        zt.section,
        Wa[0]
      );
    }), this.isGlobalZone && this.slottedGlobalZone.forEach((t) => {
      t.setAttribute(
        zt.location,
        $o.header
      ), zn(t) ? t.setAttribute(
        zt.section,
        Wa[1]
      ) : t.setAttribute(
        zt.section,
        Wa[0]
      );
    }), this.isActionZone && this.slottedActionZone.forEach((t) => {
      t.setAttribute(
        zt.location,
        $o.header
      ), zn(t) ? t.setAttribute(
        zt.section,
        Wa[1]
      ) : t.setAttribute(
        zt.section,
        Wa[0]
      );
    }), this.isSiteSelector && this.slottedSiteSelector.forEach((t) => {
      t.setAttribute(
        zt.location,
        $o.header
      ), zn(t) ? t.setAttribute(
        zt.section,
        t.getAttribute("opens-by") === "country-selector" ? Ho.level1LangSelector : Ho.links
      ) : t.setAttribute(
        zt.section,
        Ho.selectedLink
      );
    }), this.isSiteNav && this.slottedSiteNavigation.forEach((t) => {
      t.setAttribute(
        zt.location,
        $o.siteNav
      ), zn(t) ? t.setAttribute(
        zt.section,
        jn.level_2
      ) : t.setAttribute(
        zt.section,
        jn.level_1
      );
    }), this.allSlottedContent.forEach((t) => {
      zn(t) && h1(t) && t.updateAnalytics();
    });
  }
  /**
   * Appends aria role to be listitem
   */
  appendAriaRole() {
    this.allSlottedContent.forEach(
      (t) => Xt.setListItemRole(t)
    ), this.slottedSiteSelector.forEach(
      (t) => Xt.setListItemRole(t)
    );
  }
  /** Shorthand method for setting the listitem role on elements. */
  static setListItemRole(t) {
    t.setAttribute("role", "listitem");
  }
  calculateActionZoneSize() {
    return this.isActionZone ? this.isDrilldownExpanded ? "0px" : "var(--header-action-zone-size, 56px)" : "0px";
  }
  addClickEventsToAllLinks() {
    this.allLinks.length > 0 && this.allLinks.forEach((t) => {
      t.addEventListener("click", (e) => {
        Re(t, Ee.NAVIGATION_LINK_CLICK, e);
      });
    });
  }
  updated(t) {
    var e, a;
    t.has("isMenuExpanded") && this.isMobile && (this.isMenuExpanded ? (this.appendHeaderToDialog(), (e = this.hamburgerIconButton) == null || e.button.focus()) : (this.appendHeaderToRoot(), (a = this.hamburgerIconButton) == null || a.button.focus()));
  }
  navigationPrerender() {
    this.addEventListener(
      Ee.ACTIVE_NAV_ITEM,
      this.handleActiveNavItemChange
    ), this.addEventListener(
      Ee.HEADER_ZONE_CLICK,
      this.handleHeaderZoneClick
    ), this.largeBreakpointWatcher.addEventListener(
      "change",
      this.handleBreakpointChanges
    ), window.addEventListener("click", this.activeNavItemClickAwayHandler), document.addEventListener(
      Ee.SKIP_LINK_CLICK,
      this.handleSkipLinkClick
    ), document.addEventListener(
      Ee.NAVIGATION_LINK_CLICK,
      this.handleClickFromAnyLink
    ), document.addEventListener(Je.KEYDOWN, this.onNavKeyDown);
  }
  navigationPostRender() {
    this.appendAriaRole(), this.isMobile && this.setHeaderZoneElement("header-zone"), this.updateActionZoneScale(), this.addEventToSkipLink(), this.addClickEventsToAllLinks();
  }
  addBuiltInSkipLink() {
    const t = document.createElement("template");
    t.innerHTML = '<div slot="_skip-link-anchor" class="a11y-skip-navigation-links" id="a11y-skip-navigation-links"></div>';
    const e = t.content.cloneNode(!0);
    this.append(e);
  }
  setCurrentPage() {
    const { href: t } = window.location, e = this.allLinks.find(
      (a) => t.includes(a.href) ? a : void 0
    );
    e && (e.ariaCurrent = "page");
  }
  navigationDestroy() {
    window.removeEventListener("click", this.activeNavItemClickAwayHandler), document.removeEventListener(
      Ee.SKIP_LINK_CLICK,
      this.handleSkipLinkClick
    ), document.removeEventListener(
      Ee.NAVIGATION_LINK_CLICK,
      this.handleClickFromAnyLink
    ), document.removeEventListener(Je.KEYDOWN, this.onNavKeyDown);
  }
  /**
   * Renders the brandmark slot with the appropriate default logo.
   */
  renderBrandMarkSlot() {
    const t = {
      "brandmark-slot": !0,
      hide: this.isMobile
    }, e = Be`<${this.getScopedTag("beacon-icon")} name="trusty" label="T. Rowe Price"></${this.getScopedTag("beacon-icon")}>`;
    return pe`<slot
      class=${Oe(t)}
      name="${Gt.brandMarkSlot}">
      ${this.wordmarkUrl ? pe`<a href="${this.wordmarkUrl}" class="trusty-link">${e}</a>` : pe`${e}`}</slot
    >`;
  }
  /**
   * Render the wordmark Slot or drill-up button.
   */
  renderWordMarkSlot() {
    return this.isMobile && this.isDrilldownExpanded && this.currentOpenSlot !== Nt.HEADER ? Be`
      <${this.getScopedTag(Gt.buttonTagName)} variant="tertiary" class="drill-up" @beacon-event-click=${this.handleBackButton}>
        <${this.getScopedTag("beacon-icon")} name="chevron_left_small" size="s" slot="prefix"></${this.getScopedTag("beacon-icon")}>
        Back
      </${this.getScopedTag(Gt.buttonTagName)}>` : pe`
      <slot
        name="${Gt.wordMarkSlot}"
        class="wordmark-container"
        @slotchange=${this.setCustomWordmarkState}>
        ${this.wordmarkUrl ? pe`<a
              class="wordmark"
              href="${this.wordmarkUrl}"
              aria-label="${Gt.wordMarkAriaLabel}"
              >${ut(Hu)}</a
            >` : pe`${ut(Hu)}`}
      </slot>
    `;
  }
  /** Render the brand-colored vertical divider. */
  renderVerticalDividerBrand(t) {
    return this.isDesktop && t ? pe`<span aria-hidden="true"
        >${ut(AT)}</span
      >` : pe``;
  }
  /**
   * Render Vertical Divider based on any boolean condition.
   */
  static renderVerticalDivider(t) {
    return t ? pe`${ut(yT)}` : pe``;
  }
  /** Render the site selector slot. */
  renderSiteSelectorSlot() {
    let t = !1;
    this.currentOpenSlot === Nt.SITE_SELECTOR && (t = !0), this.currentOpenSlot === Nt.COUNTRY && (t = !0);
    const e = {
      hide: this.isDrilldownExpanded && !t,
      "site-selector-slot": !0
    };
    return pe`
      <div class=${Oe(e)} role="list">
        <slot
          name="site-selector"
          @slotchange=${this.setSiteSelectorState}
          ${Ue({ useParent: !0 })}></slot>
      </div>
    `;
  }
  /**
   * Render the menu button area which also includes the header zone.
   */
  renderMenuButtonArea() {
    const t = this.slottedHeaderZone.length === 1 && this.slottedZoneContent.length <= 2, e = this.allSlottedContent.length > 0 || this.isSiteSelector, a = {
      hide: this.slottedHeaderZone.length === 0 || this.isMenuExpanded
    }, o = {
      "header-zone-wrapper": !0,
      hide: this.isDesktop
    };
    return pe`
      <div class=${Oe(o)}>
        <div role="list" class=${Oe(a)}>
          <slot name="header-zone"></slot>
        </div>
        ${e ? this.renderMenuButton(this.isMenuExpanded, t) : pe``}
      </div>
    `;
  }
  /**
   * Renders a cached version of the appropriate icon for the menu button.
   */
  renderMenuButtonIcon(t) {
    return Be`${rT(
      t ? Be`<${this.getScopedTag("beacon-icon")} name='close_small' size='m' slot='icon'></${this.getScopedTag("beacon-icon")}> Close Menu` : Be`<${this.getScopedTag("beacon-icon")} name='menu' size='s' slot='icon'></${this.getScopedTag("beacon-icon")}> Open Menu`
    )}`;
  }
  /** Renders the Icon Button component used to trigger the opening or closing of the mobile menu. */
  renderMenuButton(t, e) {
    const n = `${t ? "menu-open" : "menu-closed"} ${e ? "header-zone-only" : ""}`;
    return Be`
      <${this.getScopedTag(Gt.iconButtonTagName)}
        class="${n}"
        variant="tertiary" 
        id="menu"
        data-metrics-section="${Wa[0]}"
        data-metrics-location="${$o.header}" 
        @beacon-event-click=${this.handleMenuClick}>
          ${this.renderMenuButtonIcon(t)};
      </${this.getScopedTag(Gt.iconButtonTagName)}>
    `;
  }
  // prettier-ignore
  renderMenuZone() {
    return pe`
      ${this.isMobile ? Xt.renderPartnerLogoSlot() : pe``}
      ${this.isMobile ? this.renderSiteSelectorSlot() : pe``}
      ${this.isMobile ? pe`<div class="sitenav-wrapper">${this.renderSiteNav()}</div>` : pe``}
      ${this.renderLocalHeaderGlobalSlots()}
      ${this.isMobile ? this.renderCountrySelector() : pe``}
      ${this.renderActionZone()}
    `;
  }
  /** Render the site navigation. */
  renderSiteNav() {
    const t = {
      "sitenav-ul-wrapper": !0,
      hide: this.isDrilldownExpanded && this.currentOpenSlot !== Nt.PRIMARY
    };
    return pe`
      <nav class="primary-wrapper">
        <ul class=${Oe(t)}>
          <slot
            @slotchange=${this.setSiteNavigationState}
            ${Ue({ useParent: !0 })}></slot>
        </ul>
        ${this.isDesktop ? Xt.renderPartnerLogoSlot() : pe``}
      </nav>
    `;
  }
  static renderPartnerLogoSlot() {
    return pe`
      <div class="partner-logo-wrapper">
        <div class="partner-logo">
          <slot
            name="media"
            ${Ue({ container: ".partner-logo-wrapper" })}></slot>
        </div>
      </div>
    `;
  }
  setGlobalZoneVisibility() {
    return this.isMobile && this.isDrilldownExpanded ? this.currentOpenSlot === Nt.HEADER || this.currentOpenSlot === Nt.GLOBAL : this.isGlobalZone;
  }
  /**
   * Render slots for the local, header, and global zones.
   *
   * Users should not interact with the header-zone directly.
   */
  renderLocalHeaderGlobalSlots() {
    const t = {
      "local-zone-container": !0,
      hide: !this.isLocalZone || this.isDrilldownExpanded && this.currentOpenSlot !== Nt.LOCAL
    }, e = {
      "global-zone-container": !0,
      hide: !this.setGlobalZoneVisibility()
    }, a = {
      "header-zone-container": !0,
      hide: this.isDrilldownExpanded && this.currentOpenSlot !== Nt.HEADER
    }, o = this.isLocalZone && this.isGlobalZone, n = this.isLocalZone && this.isActionZone && !this.isGlobalZone || this.isActionZone && this.isGlobalZone;
    return pe`
      <nav class="local-header-global-container">
        <div class="ul-wrapper" role="list">
          <slot
            name="${Gt.localSlot}"
            class=${Oe(t)}
            @slotchange=${this.setLocalZoneState}></slot>
          ${Xt.renderVerticalDivider(o)}
          <slot name="header-zone" class=${Oe(a)}></slot>
          <slot
            name="${Gt.globalSlot}"
            class=${Oe(e)}
            @slotchange=${this.setGlobalZoneState}></slot>
          ${Xt.renderVerticalDivider(n)}
        </div>
      </nav>
    `;
  }
  /**
   * Render action-zone slot.
   */
  renderActionZone() {
    const t = {
      "action-zone-wrapper": !0,
      hide: !this.isActionZone || this.isDrilldownExpanded && this.currentOpenSlot !== Nt.ACTION
    };
    return pe`
      <div role="list" class="${Oe(t)}">
        <slot
          name="${Gt.actionSlot}"
          @slotchange=${this.setActionZoneState}></slot>
      </div>
    `;
  }
  /**
   * Renders the mobile country selector.
   *
   * Users should not interact with this slot directly.
   */
  renderCountrySelector() {
    const t = {
      "country-selector-slot": !0,
      hide: this.isDrilldownExpanded
    };
    return pe`
      <div class=${Oe(t)}>
        <slot name="country-selector"></slot>
      </div>
    `;
  }
  render() {
    const t = {
      hide: this.slottedZoneContent.length === 0 && !this.slottedSiteSelector || !this.isMenuExpanded && this.isMobile,
      menu: this.isMenuExpanded && this.isMobile,
      "menu-zone-container": !0
    }, e = {
      "header-wrapper": !0
    };
    e[this.currentOpenSlot] = !0;
    const a = {
      "--action-zone-size": this.calculateActionZoneSize()
    };
    return pe`
      <div class="skip-link-wrapper">
        <div class="skip-link-container">
          <slot name="skip-link"><a class="skip-link" href="#a11y-skip-navigation-links">Skip navigation links.</a></slot>
        </div>
      </div>
      <header class=${Oe(e)}>
        <section class="brand-zone-container">
          ${this.renderBrandMarkSlot()}
          ${this.renderWordMarkSlot()}
          ${this.renderVerticalDividerBrand(this.isSiteSelector)}
          ${this.isDesktop ? this.renderSiteSelectorSlot() : pe``}
          ${this.renderMenuButtonArea()}
        </section>
        <section class=${Oe(t)} style=${Qf(a)}>
          ${this.renderMenuZone()}
        </section>
      </header>
      ${this.isDesktop ? this.renderSiteNav() : pe``}
      <dialog id="nav-dialog" class="nav-dialog-overlay" aria-modal="true" aria-labelledby="header-wrapper"></dialog>
      <slot name="_skip-link-anchor"></slot>
    `;
  }
}, Xt.tagName = Gt.beaconTagName, Xt.nestedComponents = [Zo, eo, fo], Xt);
Xe([
  ue({ type: Boolean, reflect: !0, attribute: "drilldown-expanded" })
], Ye.prototype, "isDrilldownExpanded", 2);
Xe([
  ue({ attribute: "wordmark-href" })
], Ye.prototype, "wordmarkUrl", 2);
Xe([
  ue({ type: Boolean, reflect: !0, attribute: "menu-expanded" })
], Ye.prototype, "isMenuExpanded", 2);
Xe([
  Se()
], Ye.prototype, "currentOpenSlot", 2);
Xe([
  Se()
], Ye.prototype, "isCustomWordmark", 2);
Xe([
  Se()
], Ye.prototype, "isActionZone", 2);
Xe([
  Se()
], Ye.prototype, "isGlobalZone", 2);
Xe([
  Se()
], Ye.prototype, "isLocalZone", 2);
Xe([
  Se()
], Ye.prototype, "isSiteNav", 2);
Xe([
  Se()
], Ye.prototype, "isSiteSelector", 2);
Xe([
  Se()
], Ye.prototype, "activeNavItem", 2);
Xe([
  Pe({ flatten: !0, slot: "wordmark" })
], Ye.prototype, "slottedWordmark", 2);
Xe([
  Pe({ flatten: !0, slot: Gt.localSlot })
], Ye.prototype, "slottedLocalZone", 2);
Xe([
  Pe({ flatten: !0, slot: Gt.globalSlot })
], Ye.prototype, "slottedGlobalZone", 2);
Xe([
  Pe({ flatten: !0, slot: Gt.actionSlot })
], Ye.prototype, "slottedActionZone", 2);
Xe([
  Pe({ flatten: !0, slot: "header-zone" })
], Ye.prototype, "slottedHeaderZone", 2);
Xe([
  Pe({ flatten: !0 })
], Ye.prototype, "slottedSiteNavigation", 2);
Xe([
  Pe({ flatten: !0, slot: "site-selector" })
], Ye.prototype, "slottedSiteSelector", 2);
Xe([
  Pe({ flatten: !0, slot: "skip-link" })
], Ye.prototype, "skipLink", 2);
Xe([
  et("dialog#nav-dialog")
], Ye.prototype, "navigationDialogElement", 2);
Xe([
  et(".skip-link-wrapper")
], Ye.prototype, "skipLinWrapperEl", 2);
Xe([
  et("[beacon-tag-name='beacon-icon-button']#menu")
], Ye.prototype, "hamburgerIconButton", 2);
Xe([
  et("header")
], Ye.prototype, "headerEl", 2);
Xe([
  Ge("#a11y-skip-navigation-links")
], Ye.prototype, "skipLinkAnchor", 2);
Xe([
  qe
], Ye.prototype, "navigationPrerender", 1);
Xe([
  De
], Ye.prototype, "navigationPostRender", 1);
Xe([
  De
], Ye.prototype, "addBuiltInSkipLink", 1);
Xe([
  De
], Ye.prototype, "setCurrentPage", 1);
Xe([
  Lt
], Ye.prototype, "navigationDestroy", 1);
let qr = Ye;
var dM = Object.defineProperty, hM = Object.getOwnPropertyDescriptor, iv = (i) => {
  throw TypeError(i);
}, Ga = (i, t, e, a) => {
  for (var o = a > 1 ? void 0 : a ? hM(t, e) : t, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = (a ? r(t, e, o) : r(o)) || o);
  return a && o && dM(t, e, o), o;
}, bM = (i, t, e) => t.has(i) || iv("Cannot " + e), Wu = (i, t, e) => (bM(i, t, "read from private field"), e ? e.call(i) : t.get(i)), pM = (i, t, e) => t.has(i) ? iv("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(i) : t.set(i, e), Nt = /* @__PURE__ */ ((i) => (i.GLOBAL = "global", i.PRIMARY = "site-nav", i.LOCAL = "local", i.DEFAULT = "default", i.HEADER = "header", i.ACTION = "action", i.SITE_SELECTOR = "site-selector", i.COUNTRY = "country-selector", i))(Nt || {}), tb = /* @__PURE__ */ ((i) => (i.GLOBAL = "global-zone", i.PRIMARY = "site-navigation", i.LOCAL = "local-zone", i.HEADER = "header-zone", i.ACTION = "action-zone", i.SITE_SELECTOR = "site-selector", i.COUNTRY_SELECTOR = "country-navigation-button", i))(tb || {});
const uM = /* @__PURE__ */ new Map([
  [
    "global-zone",
    "global"
    /* GLOBAL */
  ],
  [
    "local-zone",
    "local"
    /* LOCAL */
  ],
  [
    "site-navigation",
    "site-nav"
    /* PRIMARY */
  ],
  [
    "header-zone",
    "header"
    /* HEADER */
  ],
  [
    "site-selector",
    "site-selector"
    /* SITE_SELECTOR */
  ],
  [
    "country-navigation-button",
    "country-selector"
    /* COUNTRY */
  ],
  [
    "action-zone",
    "action"
    /* ACTION */
  ]
]);
function gM(i) {
  var t;
  let e = class extends i {
    constructor() {
      super(...arguments), this.active = !1, this.hasExpandedAnchor = !1, this.activeInStyleOnly = !1, this.toggleActive = ({ target: a }) => {
        a instanceof Element && (this.active = !this.active);
      }, this.handleFocusOut = ({ relatedTarget: a }) => {
        a instanceof HTMLElement && (this.expandingElement instanceof gi || this.expandingElement instanceof ar) && !this.expandingElement.contains(a) && !this.isEqualNode(a) && this.hasFieldAndValue("isDesktop", !0) && this.active && (this.active = !1);
      }, this.handleDrillupEvent = ({ target: a }) => {
        a instanceof qr && this.expandingElement instanceof HTMLElement && Vf(
          this.expandingElement
        ).filter((n) => n instanceof ov && n.isActive).length < 1 && this.active && (this.active = !1);
      }, this.handleHeaderClose = ({ target: a }) => {
        a instanceof qr && (this.active = !1);
      }, this.closeOnActiveChange = ({ target: a }) => {
        a && "active" in a && a.active && this !== a && this.active && (this.active = !1);
      }, this.handleClickAway = ({ target: a }) => {
        a instanceof qr && this.hasFieldAndValue("isDesktop", !0) && (this.active = !1);
      }, pM(this, t, /* @__PURE__ */ new Map([
        [Ee.DRILLUP, this.handleDrillupEvent],
        [Ee.CLOSE, this.handleHeaderClose],
        [Ee.ACTIVE_NAV_ITEM, this.closeOnActiveChange],
        [Ee.CLOSE_ACTIVE_NAV_ITEM, this.handleClickAway]
      ]));
    }
    /** Callback for on beacon-event-active-nav-item-change */
    onBeaconActiveNavItemChange() {
    }
    /** Reference to the internal button element. */
    get button() {
      var a;
      return (a = this.shadowRoot) == null ? void 0 : a.querySelector(".button");
    }
    get expandingElementRoot() {
      return this.closest('[beacon-tag-name="beacon-navigation"]');
    }
    /** The Popover or Toolbelt that this navigation button triggers. */
    get expandingElement() {
      return (this.expandingElementRoot ? this.expandingElementRoot : document).querySelector(`[opens-by="${this.opens}"]`);
    }
    get closestSlot() {
      var a, o;
      return (o = (a = this.closest("[slot]")) == null ? void 0 : a.slot) != null ? o : "";
    }
    /** Sets a type to the component based on what slot it is in. */
    get navType() {
      var a;
      return this.hasExpandedAnchor && this.closestSlot !== "country-navigation-button" ? "default" : (a = uM.get(this.closestSlot)) != null ? a : "site-nav";
    }
    prerenderNavigationMenuTriggerSetup() {
      this.addEventListener(Ee.CLICK, this.toggleActive), Wu(this, t).forEach((a, o) => {
        document.addEventListener(o, a);
      });
    }
    postrenderAddFocusOutListener() {
      var a;
      (a = this.button) == null || a.addEventListener(
        "focusout",
        this.handleFocusOut
      );
    }
    updated(a) {
      yr(a, "active") && Re(
        this,
        Ee.ACTIVE_NAV_ITEM,
        void 0,
        this.onBeaconActiveNavItemChange
      );
    }
    tearDownNavigationMenuTrigger() {
      Wu(this, t).forEach((a, o) => {
        document.removeEventListener(o, a);
      });
    }
  };
  return t = /* @__PURE__ */ new WeakMap(), Ga([
    ue({ type: Boolean, reflect: !0 })
  ], e.prototype, "active", 2), Ga([
    ue({ type: Boolean, attribute: "expanded-anchor", reflect: !0 })
  ], e.prototype, "hasExpandedAnchor", 2), Ga([
    ue({ reflect: !0 })
  ], e.prototype, "opens", 2), Ga([
    Se()
  ], e.prototype, "activeInStyleOnly", 2), Ga([
    qe
  ], e.prototype, "prerenderNavigationMenuTriggerSetup", 1), Ga([
    De
  ], e.prototype, "postrenderAddFocusOutListener", 1), Ga([
    Lt
  ], e.prototype, "tearDownNavigationMenuTrigger", 1), e = Ga([
    je("NavigationMenuTrigger")
  ], e), e;
}
var mM = Object.defineProperty, fM = Object.getOwnPropertyDescriptor, qu = (i, t, e, a) => {
  for (var o = a > 1 ? void 0 : a ? fM(t, e) : t, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = (a ? r(t, e, o) : r(o)) || o);
  return a && o && mM(t, e, o), o;
};
function vM(i) {
  let t = class extends i {
  };
  return qu([
    ue({ attribute: "beacon-aria-label", reflect: !0 })
  ], t.prototype, "beaconAriaLabel", 2), t = qu([
    je("Aria")
  ], t), t;
}
const Vu = {
  // Tag Names
  beaconTagName: "beacon-navigation-button"
}, AM = ve`[beacon-tag-name=beacon-navigation-button] [slot=flag]{margin-inline-end:var(--beacon-reference-space-2)}[beacon-tag-name=beacon-navigation-button] svg{pointer-events:none}@media (width >= 960px){[beacon-tag-name=beacon-navigation-button] .button:not(.beacon-button):is(.global,.site-nav) *{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-300)}}`, yM = ve`@media (width >= 960px){:host([motion-state=enabled]) .motion-underline--grow-out{--border-color: var(--beacon-system-color-border-secondary);--link-transform: scaleX(0);position:relative}:host([motion-state=enabled]) .motion-underline--grow-out:after,:host([motion-state=enabled]) .motion-underline--grow-out:before{--underline-opacity: 0;--underline-size: 50%;background-color:var(--border-color);block-size:var(--beacon-system-width-border-normal);content:"";inline-size:var(--underline-size);inset-block-end:0;opacity:var(--underline-opacity);position:absolute;transform:var(--link-transform);transform-origin:var(--link-transform-origin);transition-duration:var(--beacon-reference-motion-duration-5);transition-property:transform,opacity;transition-timing-function:var(--beacon-system-motion-easing-decelerate-emphasize-1)}:host([motion-state=enabled]) .motion-underline--grow-out:before{--link-transform-origin: right;inset-inline-end:var(--underline-size)}:host([motion-state=enabled]) .motion-underline--grow-out:after{--link-transform-origin: left;inset-inline-start:var(--underline-size)}:host([motion-state=enabled]) .motion-underline--grow-out:hover,:host([motion-state=enabled]) .motion-underline--grow-out:focus-visible,:host([motion-state=enabled]) .motion-underline--grow-out.active,:host([motion-state=enabled]) .motion-underline--grow-out.current{--link-transform: scaleX(1);text-decoration:none}:host([motion-state=enabled]) .motion-underline--grow-out:hover:after,:host([motion-state=enabled]) .motion-underline--grow-out:hover:before,:host([motion-state=enabled]) .motion-underline--grow-out:focus-visible:after,:host([motion-state=enabled]) .motion-underline--grow-out:focus-visible:before,:host([motion-state=enabled]) .motion-underline--grow-out.active:after,:host([motion-state=enabled]) .motion-underline--grow-out.active:before,:host([motion-state=enabled]) .motion-underline--grow-out.current:after,:host([motion-state=enabled]) .motion-underline--grow-out.current:before{--underline-opacity: 1}:host([motion-state=enabled]) .motion-underline--grow-out.current:not(.active){--border-color: var(--beacon-system-color-border-brand)}}`;
var xM = Object.defineProperty, wM = Object.getOwnPropertyDescriptor, Yu = (i, t, e, a) => {
  for (var o = a > 1 ? void 0 : a ? wM(t, e) : t, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = (a ? r(t, e, o) : r(o)) || o);
  return a && o && xM(t, e, o), o;
};
function kM(i) {
  let t = class extends i {
    static get navigationButtonMotionStyles() {
      return [yM];
    }
    /** Sets the motion class on the button element if it meets the condition of being a primary nav item. */
    static activeItemMotionClasses({ target: e }) {
      var a;
      if (e instanceof HTMLElement) {
        const o = (a = e.shadowRoot) == null ? void 0 : a.querySelector(
          t.activeElementQuery
        );
        if (o instanceof HTMLButtonElement) {
          const { classList: n } = o;
          Array.from(n).includes(Nt.PRIMARY) && o.classList.add("motion-underline--grow-out");
        }
      }
    }
    prerenderNavigationButtonMotionSetup() {
      this.addEventListener(
        Ee.ELEMENT_READY,
        t.activeItemMotionClasses
      );
    }
  };
  return t.activeElementQuery = ".button", Yu([
    qe
  ], t.prototype, "prerenderNavigationButtonMotionSetup", 1), t = Yu([
    je("NavigationButtonMotion")
  ], t), t;
}
const CM = ve`:host{inline-size:fit-content}@media (width < 960px){:host(:not([expanded-anchor])) :not(a):focus-visible{background-color:var(--beacon-system-color-background-link-focus)!important;border-block-end-color:unset;box-shadow:0 var(--beacon-system-width-border-jumbo) 0 0 var(--beacon-system-color-border-link-focus);color:var(--beacon-system-color-text-set-navy)!important;outline:none;text-decoration:none}}@media (width < 960px) and (forced-colors: active){:host(:not([expanded-anchor])) :not(a):focus-visible{border-block-end:var(--beacon-system-width-border-jumbo) solid var(--beacon-system-color-border-link-focus)}}@media (width >= 960px){:host(:not([expanded-anchor])) :not(a):focus-visible{box-shadow:0 0 0 var(--beacon-system-width-border-jumbo) var(--beacon-system-color-border-focus-middle),0 0 0 var(--beacon-system-width-border-maxi) var(--beacon-system-color-border-focus-outer);outline:var(--beacon-system-width-border-normal) solid var(--beacon-system-color-border-focus-inner);outline-offset:0;z-index:1}:host(:not([expanded-anchor])) :not(a):focus-visible:not(dialog){position:relative}}:host([expanded-anchor]) :not(a):focus-visible{background-color:var(--beacon-system-color-background-link-focus)!important;border-block-end-color:unset;box-shadow:0 var(--beacon-system-width-border-jumbo) 0 0 var(--beacon-system-color-border-link-focus);color:var(--beacon-system-color-text-set-navy)!important;outline:none;text-decoration:none}@media (forced-colors: active){:host([expanded-anchor]) :not(a):focus-visible{border-block-end:var(--beacon-system-width-border-jumbo) solid var(--beacon-system-color-border-link-focus)}}:host([show-popover]){position:relative}.flag{display:none}::slotted([slot=flag]){margin-inline-end:var(--beacon-reference-space-2)}.mobile-site-selector-title{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-50);color:var(--beacon-system-color-text-title);padding-block:var(--beacon-system-space-cell-free-floating)}.plain-text{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100);align-items:center;color:var(--beacon-system-color-text-standard);cursor:not-allowed;display:flex;gap:var(--beacon-reference-space-2)}.plain-text .icon--default{display:flex}.plain-text svg{fill:var(--beacon-system-color-text-standard)}.chevron{--chevron-transform: 90deg;transform:rotate(var(--chevron-transform))}.icon--restricted{color:var(--beacon-system-color-text-standard);margin-block-end:var(--beacon-reference-space-0)}.icon--restricted::part(icon){inline-size:var(--beacon-reference-space-4)}:host([variant=standard]) [beacon-tag-name=beacon-icon]:not(.icon--restricted){color:var(--beacon-system-color-icon-link)}.button.beacon-button{--bg-color: var(--beacon-system-color-background-primary);--border-color: var(--bg-color);--text-color: var(--beacon-system-color-text-primary);--hover-bg-color: var(--beacon-system-color-background-primary-hover);--hover-text-color: var(--hover-bg-color);--disabled-bg-color: var(--beacon-system-color-background-primary-inactive);--disabled-text-color: var(--beacon-system-color-text-primary-inactive);--disabled-border-color: var(--disabled-bg-color);--active-bg-color: var(--beacon-system-color-background-primary-pressed);--active-text-color: var(--beacon-system-color-text-secondary-pressed);--active-border-color: var(--active-bg-color);--border-inline-start-width: var(--beacon-system-width-border-mini);--border-radius: var(--beacon-system-radius-corner-standard);--border-width: var(--beacon-system-width-border-mini);--default-gap: var(--beacon-reference-space-3);--font-weight: var(--beacon-system-font-weight-bold);--font-size: var(--beacon-reference-font-scale-4);--line-height: var(--beacon-reference-font-scale-4);background-color:var(--override-button-bg-color, var(--bg-color));border-color:var(--border-color);border-end-end-radius:var(--override-button-border-radius, var(--border-radius));border-end-start-radius:var(--override-button-border-radius, var(--border-radius));border-inline-start-width:var(--override-button-border-size-inline, var(--border-inline-start-width));border-start-end-radius:var(--override-button-border-radius, var(--border-radius));border-start-start-radius:var(--override-button-border-radius, var(--border-radius));border-style:solid;border-width:var(--override-button-border-width, var(--border-width));color:var(--text-color);display:inline-flex;flex-direction:var(--button-flex-direction, row);font:var(--font-weight) var(--beacon-component-button-normal-font-size-sans-serif-standard);gap:var(--override-button-icon-space-margin, var(--default-gap));inline-size:inherit;justify-content:center;outline-offset:1px;padding-block:var(--beacon-reference-space-4) var(--beacon-reference-space-4);padding-inline:var(--beacon-reference-space-5);text-align:start;text-decoration:none;word-break:initial;align-items:center}.button.beacon-button .contents{display:inherit;flex-direction:inherit;gap:inherit;justify-content:inherit}.button.beacon-button[aria-disabled=true]{background-color:var(--disabled-bg-color);border-color:var(--disabled-border-color);color:var(--disabled-text-color);cursor:not-allowed;text-decoration:none}.button.beacon-button:is(:hover,:focus-visible):not([aria-disabled=true]){background-color:var(--hover-bg-color);color:var(--hover-text-color);text-decoration:underline}.button.beacon-button:active:not([aria-disabled=true]){background-color:var(--active-bg-color);color:var(--active-text-color);text-decoration:none}.button.beacon-button.primary{--bg-color: var(--beacon-system-color-background-primary);--border-color: var(--override-button-color-border-error, var(--bg-color));--text-color: var(--beacon-system-color-text-primary);--hover-bg-color: var(--beacon-system-color-background-primary-hover);--hover-text-color: var(--text-color);--disabled-bg-color: var(--beacon-system-color-background-primary-inactive);--disabled-text-color: var(--beacon-system-color-text-primary-inactive);--disabled-border-color: var(--disabled-bg-color);--active-bg-color: var(--beacon-system-color-background-primary-pressed);--active-text-color: var(--text-color)}.button.beacon-button.secondary{--bg-color: transparent;--border-color: var(--beacon-system-color-border-secondary);--text-color: var(--beacon-system-color-text-secondary);--hover-bg-color: var(--beacon-system-color-background-secondary-hover);--hover-border-color: var(--beacon-system-color-border-secondary-hover);--hover-text-color: var(--beacon-system-color-text-secondary-hover);--disabled-bg-color: var(--bg-color);--disabled-text-color: var(--beacon-system-color-text-secondary-inactive);--disabled-border-color: var(--beacon-system-color-border-secondary-inactive);--active-bg-color: var(--beacon-system-color-background-secondary-pressed);--active-text-color: var(--beacon-system-color-text-secondary-pressed)}.button.beacon-button.mini{--default-gap: var(--override-button-default-gap, var(--beacon-reference-space-2));--default-font-size: var(--beacon-component-button-mini-font-size-sans-serif-standard);--default-line-height: var(--beacon-component-button-mini-line-height-sans-serif-standard);--font-size: var(--override-button-font-size-mini, var(--default-font-size));--line-height: var(--override-button-font-line-height-mini, var(--default-line-height));font:var(--font-weight) var(--beacon-component-button-mini-font-size-sans-serif-standard);margin-block:var(--beacon-reference-space-2);padding-block:var(--beacon-reference-space-3) var(--beacon-reference-space-3);padding-inline:var(--beacon-reference-space-4)}.button.beacon-button.normal{--default-padding-block-start: var(--beacon-reference-space-4);--default-padding-block-end: var(--beacon-reference-space-4);--default-padding-inline: var(--beacon-reference-space-5);--normal-font-size: var(--override-button-font-size-normal, var(--font-size));--normal-font-weight: var(--override-button-font-weight-normal, var(--font-weight));--component-font-size: var(--override-button-font-size, var(--beacon-component-button-normal-font-size-sans-serif-standard));font:var(--normal-font-weight) var(--component-font-size, var(--normal-font-size)/var(--line-height) var(--beacon-system-font-family-body));padding-block:var(--override-button-space-padding-block-start-normal, var(--default-padding-block-start)) var(--override-button-space-padding-block-end-normal, var(--default-padding-block-end));padding-inline:var(--override-button-space-padding-inline-normal, var(--default-padding-inline))}.button.beacon-button.jumbo{--font-size: var(--beacon-component-button-jumbo-font-size-sans-serif-standard);--line-height: var(--beacon-component-button-jumbo-line-height-sans-serif-standard);font:var(--font-weight) var(--beacon-component-button-jumbo-font-size-sans-serif-standard);padding-block:var(--beacon-reference-space-5) var(--beacon-reference-space-5);padding-inline:var(--beacon-reference-space-7)}.button.beacon-button .site-selector-slot{display:none}:host([is-icon-button]) .icon--default{display:none}.button:not(.beacon-button){font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100);align-items:center;background-color:transparent;border:0;color:var(--beacon-system-color-text-link);display:flex;gap:var(--beacon-reference-space-2);padding:0;text-align:start}.button:not(.beacon-button) .icon--default svg{color:var(--chevron-fill-color, var(--beacon-system-color-icon-link))}.button:not(.beacon-button):is(.global,.site-nav,.local,.site-selector){color:var(--header-menu-expanded-navigation-button-color, var(--beacon-component-primary-navigation-header-color-text-link))}.button:not(.beacon-button):is(.local,.site-nav){--chevron-fill-color: var(--beacon-system-color-icon-link)}.button:not(.beacon-button).beacon-icon-button{--active-bg: var(--beacon-system-color-background-primary-pressed);--active-border: var(--beacon-system-color-border-secondary-pressed);--active-icon: var(--beacon-system-color-icon-secondary-pressed);--bg-color: var(--beacon-system-color-background-primary);--border-color: var(--beacon-system-color-border-secondary);--border-width: var(--beacon-system-width-border-mini);--default-size: var(--beacon-reference-space-9);--disabled-bg: var(--beacon-system-color-background-primary-inactive);--disabled-border: var(--beacon-system-color-border-secondary-inactive);--disabled-icon: var(--beacon-system-color-icon-primary-inactive);--hover-bg: var(--beacon-system-color-background-primary-hover);--hover-border: var(--beacon-system-color-border-secondary-hover);--hover-icon: var(--beacon-system-color-icon-secondary-hover);--icon-color: var(--beacon-system-color-icon-primary);align-items:center;background-color:var(--override-icon-button-bg-color, var(--bg-color));block-size:var(--override-icon-button-wrapper-block-size, var(--beacon-reference-space-10));border:var(--border-width) solid var(--border-color);border-radius:var(--override-icon-button-border-radius, var(--beacon-system-radius-corner-circle));box-shadow:var(--override-icon-button-box-shadow, initial);color:var(--override-icon-button-color, var(--beacon-host-override-icon-button-color, var(--icon-color)));cursor:pointer;display:inline-flex;inline-size:var(--override-icon-button-wrapper-inline-size, var(--beacon-reference-space-10));justify-content:center;outline-offset:var(--override-icon-button-outline-offset);position:relative}.button:not(.beacon-button).beacon-icon-button .contents{align-items:inherit;display:inherit;justify-content:inherit;position:inherit}.button:not(.beacon-button).beacon-icon-button[aria-disabled=true]{--icon-color: var(--disabled-icon);background-color:var(--disabled-bg);border-color:var(--disabled-border);color:var(--disabled-icon);cursor:not-allowed}.button:not(.beacon-button).beacon-icon-button svg,.button:not(.beacon-button).beacon-icon-button [beacon-tag-name=beacon-icon]{position:absolute}.button:not(.beacon-button).beacon-icon-button:-webkit-direct-focus{outline:-webkit-focus-ring-color auto 0}.button:not(.beacon-button).beacon-icon-button:hover:not([aria-disabled=true]){--icon-color: var(--hover-icon);background-color:var(--hover-bg);border-color:var(--hover-border);color:var(--hover-icon)}.button:not(.beacon-button).beacon-icon-button:active:not([aria-disabled=true]){--icon-color: var(--active-icon);background-color:var(--active-bg);border-color:var(--active-border);color:var(--active-icon)}.button:not(.beacon-button).beacon-icon-button svg{position:static}.button:not(.beacon-button).beacon-icon-button.tertiary{--active-bg: var(--beacon-system-color-background-tertiary-pressed);--active-icon: var(--beacon-system-color-icon-tertiary-pressed);--bg-color: transparent;--default-hover-bg: var(--beacon-system-color-background-tertiary-hover);--default-hover-icon: var(--beacon-system-color-icon-tertiary-hover);--default-icon-color: var(--beacon-system-color-icon-tertiary);--disabled-bg: transparent;--disabled-icon: var(--beacon-system-color-icon-tertiary-inactive);--hover-bg: var(--override-icon-button-hover-bg, var(--default-hover-bg));--hover-icon: var(--override-icon-button-icon-color, var(--default-hover-icon));--icon-color: var(--override-icon-button-icon-color, var(--default-icon-color));border:0}.button:not(.beacon-button).site-selector .default-slot{display:none}.button:not(.beacon-button).header .default-slot{border:0;clip:rect(0,0,0,0);block-size:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;inline-size:1px;display:block}.button:not(.beacon-button).header .icon--default{border:0;clip:rect(0,0,0,0);block-size:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;inline-size:1px}.button:not(.beacon-button):not(.site-selector) .site-selector-slot{display:none}.button:not(.beacon-button):is(:hover,:focus){text-decoration:underline}:host(:not([is-icon-button])) .button:not(.beacon-button) .icon--default{display:flex}:host(:not([slot=header-zone])) .button:not(.beacon-button).active{display:flex}:host(:not([slot=header-zone])) .active .chevron{--chevron-transform: 0deg}@media (width >= 960px){:host([is-icon-button]){padding-block:var(--beacon-system-space-cell-free-floating) var(--beacon-system-space-cell-free-floating)}.mobile-site-selector-title{display:none}.flag{display:contents}.plain-text{gap:var(--beacon-reference-space-3)}.button:not(.beacon-button){gap:var(--beacon-reference-space-3);word-break:keep-all}.button:not(.beacon-button):is(.global,.site-nav,.local){padding-block:var(--beacon-system-space-cell-free-floating) var(--beacon-system-space-cell-free-floating)}.button:not(.beacon-button):is(.local,.site-selector){font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-300);color:var(--beacon-component-primary-navigation-header-color-text-link);gap:var(--beacon-reference-space-2)}.button:not(.beacon-button).site-selector{padding:var(--beacon-system-space-cell-contained)}.button:not(.beacon-button).site-selector .default-slot{display:contents}.button:not(.beacon-button).site-selector .site-selector-slot{display:none}.button:not(.beacon-button):is(.global,.site-nav),.button:not(.beacon-button):is(.global,.site-nav) ::slotted(*){font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-300)}.button:not(.beacon-button).site-nav{border:0;color:var(--beacon-component-primary-navigation-header-color-text-link);gap:var(--beacon-reference-space-2)}.button:not(.beacon-button).global{color:var(--beacon-component-primary-navigation-header-color-text-link);font-weight:var(--beacon-system-font-weight-bold)}.button:not(.beacon-button).active{color:var(--beacon-system-color-text-link-active);font-weight:var(--beacon-system-font-weight-bold)}:host([motion-state=disabled]) .button:not(.beacon-button).site-nav{border-block-end:var(--beacon-system-width-border-normal) solid var(--navigation-button-border-color)}:host([motion-state=disabled]) .button:not(.beacon-button).site-nav.current{--navigation-button-border-color: var(--beacon-system-color-border-brand)}:host([motion-state=disabled]) .button:not(.beacon-button).site-nav.active{--navigation-button-border-color: var(--beacon-system-color-border-secondary)}.chevron{--chevron-transform: 180deg}:host([site-navigation]) .plain-text{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-300)}}`;
var SM = Object.defineProperty, EM = Object.getOwnPropertyDescriptor, Co = (i, t, e, a) => {
  for (var o = a > 1 ? void 0 : a ? EM(t, e) : t, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = (a ? r(t, e, o) : r(o)) || o);
  return a && o && SM(t, e, o), o;
}, Wn;
const ql = class ql extends Ke(Le).with(
  vM,
  kM,
  fr(),
  Ra,
  gM,
  $m({ clean: !0 })
) {
  constructor() {
    super(...arguments);
    Fe(this, Wn);
    this.beaconTagName = Vu.beaconTagName, this.focusOverride = !0, this.restricted = !1, this.variant = "standard", this.scale = tn.NORMAL, this.hasIcon = !1, this.hasCountryFlag = !1, this.current = !1, this.handleCountrySelector = ({ type: e }) => {
      e === Ee.COUNTRY_SELECTOR_OPEN && this.closestSlot === tb.SITE_SELECTOR && (this.activeInStyleOnly = !0), e === Ee.COUNTRY_SELECTOR_CLOSE && this.activeInStyleOnly && (this.activeInStyleOnly = !1);
    }, this.applyCurrentStyling = ({ target: e }) => {
      var a;
      (a = this.expandingElement) != null && a.contains(e) && (this.current = !0);
    }, Ne(this, Wn, /* @__PURE__ */ new Map([
      [Ee.COUNTRY_SELECTOR_OPEN, this.handleCountrySelector],
      [Ee.COUNTRY_SELECTOR_CLOSE, this.handleCountrySelector],
      [Ee.HAS_CURRENT_LINK, this.applyCurrentStyling]
    ]));
  }
  static get styles() {
    return [super.styles, this.navigationButtonMotionStyles, CM];
  }
  static get lightDOMStyles() {
    return [...super.lightDOMStyles, AM];
  }
  get icon() {
    return this.iconSlotNodes[0];
  }
  get flag() {
    return this.flagSlotNodes[0];
  }
  /** Reference to the built-in icon element. */
  get builtInIcon() {
    var e;
    return (e = this.shadowRoot) == null ? void 0 : e.querySelector(".icon--default");
  }
  /**
   * onClick handler to maintain active state
   * @param event
   */
  toggleOnClick() {
    this.emitClick(), this.navType === Nt.HEADER && Re(this, Ee.HEADER_ZONE_CLICK);
  }
  /** Applies a specific class for nav items that are only an icon to account for changes in CSS. */
  setIconSlotState() {
    this.iconSlotNodes.length > 0 && (this.hasIcon = !0);
  }
  /** Adds attribute to the flag slot to enable analytics tracking by attaching a data-metrics-text attribute */
  handleFlagSlotchange() {
    var a;
    const e = (a = this.beaconAriaLabel) != null ? a : this.defaultSlotText;
    Wr(this.flag, e);
  }
  /**
   * Selects an internal icon based on the context the nav item is in.
   *
   * Could be a lock for restricted items, or chevrons based on expanded state.
   */
  buildIcon() {
    return this.restricted ? this.renderBuiltInIcon("locked", "icon--restricted") : this.hasExpandedAnchor ? this.renderBuiltInIcon("chevron_right_small", "icon--expanded") : this.renderBuiltInIcon("collapse", "icon--standard chevron");
  }
  renderBuiltInIcon(e, a) {
    return Be`<${this.getScopedTag("beacon-icon")}
      class="icon--default ${a}"
      aria-hidden="true"
      name='${e}'
      ></${this.getScopedTag("beacon-icon")}
    >`;
  }
  navItemPrerender() {
    ze(this, Wn).forEach((e, a) => {
      document.addEventListener(a, e);
    });
  }
  navItemDestroy() {
    ze(this, Wn).forEach((e, a) => {
      document.removeEventListener(a, e);
    });
  }
  renderSiteSelectorContent() {
    return this.navType === Nt.SITE_SELECTOR ? pe`<div class="mobile-site-selector-title">
        ${this.defaultSlotText}
      </div>` : pe``;
  }
  render() {
    var o;
    const e = this.hasIcon && !this.defaultSlotText, a = {
      active: this.active || this.activeInStyleOnly,
      button: !0,
      "beacon-icon-button": e,
      "beacon-button": !e && this.variant !== "standard",
      current: this.current,
      tertiary: e,
      restricted: this.restricted
    };
    return a[this.navType] = !0, a[this.variant] = !0, a[this.scale] = !0, e ? this.setAttribute("is-icon-button", "") : this.removeAttribute("is-icon-button"), pe`
      ${this.renderSiteSelectorContent()}
      ${this.restricted ? pe`
            <div class="plain-text">
              <slot class="default-slot"></slot>
              ${this.buildIcon()}
            </div>
          ` : pe`
            <button
              aria-expanded="${this.active.toString()}"
              aria-label="${gt(this.beaconAriaLabel)}"
              data-metrics-link-text="${gt(
      (o = this.beaconAriaLabel) != null ? o : this.defaultSlotText
    )}"
              aria-haspopup="true"
              class="${Oe(a)}"
              id="${gt(this.metricsID)}"
              part="button"
              @click=${this.toggleOnClick}>
              <slot name="icon" @slotchange=${this.setIconSlotState}></slot>
              <slot
                class="flag"
                name="flag"
                @slotchange=${this.handleFlagSlotchange}
                aria-hidden="true"></slot>
              <slot
                class="default-slot"
                @slotchange=${this.setDefaultSlotText}></slot>
              <slot name="site-selector-text" class="site-selector-slot"
                >Change Site</slot
              >
              ${this.buildIcon()}
            </button>
          `}
    `;
  }
};
Wn = new WeakMap(), ql.tagName = Vu.beaconTagName, ql.nestedComponents = [fo];
let it = ql;
Co([
  ue({ type: Boolean, reflect: !0 })
], it.prototype, "restricted", 2);
Co([
  ue({ reflect: !0 })
], it.prototype, "variant", 2);
Co([
  ue({ reflect: !0 })
], it.prototype, "scale", 2);
Co([
  Se()
], it.prototype, "hasIcon", 2);
Co([
  Se()
], it.prototype, "hasCountryFlag", 2);
Co([
  Se()
], it.prototype, "current", 2);
Co([
  gc({ flatten: !0, slot: "icon" })
], it.prototype, "iconSlotNodes", 2);
Co([
  gc({ flatten: !0, slot: "flag" })
], it.prototype, "flagSlotNodes", 2);
Co([
  et("button")
], it.prototype, "button", 2);
Co([
  ue({ attribute: "data-id" })
], it.prototype, "metricsID", 2);
Co([
  qe
], it.prototype, "navItemPrerender", 1);
Co([
  Lt
], it.prototype, "navItemDestroy", 1);
const Qu = {
  beaconTagName: "beacon-country"
}, TM = ve`[beacon-tag-name=beacon-country]{--country-link-color: var(--navigation-popover-country-color, var(--beacon-system-color-text-link));font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100)}[beacon-tag-name=beacon-country] [slot=title]{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100)}[beacon-tag-name=beacon-country] [slot=title] :is(h1,h2,h3,h4,h5,h6){font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100)}[beacon-tag-name=beacon-country] [slot=icon][beacon-tag-name=beacon-icon]::part(internal--icon){block-size:var(--beacon-reference-space-5);margin:auto}[beacon-tag-name=beacon-country] a{color:var(--country-link-color)}[beacon-tag-name=beacon-country] a:not([selected-language]){text-decoration:underline}[beacon-tag-name=beacon-country] [selected-language]{color:var(--beacon-system-color-text-link-active);text-decoration:none}`, MM = ve`:host{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100)}.header,.languages{align-items:center;display:flex;padding-block:var(--beacon-system-space-cell-free-floating)}.header{align-items:center;gap:var(--beacon-reference-space-3)}.languages{gap:var(--beacon-reference-space-5)}.title{color:var(--beacon-system-color-text-standard)}`;
var LM = Object.defineProperty, OM = Object.getOwnPropertyDescriptor, ra = (i, t, e, a) => {
  for (var o = a > 1 ? void 0 : a ? OM(t, e) : t, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = (a ? r(t, e, o) : r(o)) || o);
  return a && o && LM(t, e, o), o;
};
const Vl = class Vl extends Ke(Le).with(
  nT,
  Ra
) {
  constructor() {
    super(...arguments), this.beaconTagName = Qu.beaconTagName, this.reestSpacing = !0, this.isExpanded = !1, this.current = !1, this.clonedLocation = "", this.cloned = !1, this.eventAddedToNavItem = !1, this.currentCountryCreated = !1, this.handleBreakpointChanges = ({ matches: t }) => {
      t ? (this.clonedLocation === "popover" && this.slottedNavigationItem.setAttribute("opens", "country-selector"), this.clonedLocation === "navigation" && this.slottedNavigationItem.removeAttribute("opens")) : (this.clonedLocation === "navigation" && this.slottedNavigationItem.setAttribute("opens", "country-selector"), this.clonedLocation === "popover" && this.slottedNavigationItem.removeAttribute("opens"));
    }, this.addCurrentCountryFlag = () => {
      window.customElements.whenDefined(this.getScopedTagName("beacon-navigation-button")).then(() => {
        var a;
        const t = document.querySelector(
          '[opens="site-selector"]'
        ), e = t == null ? void 0 : t.querySelector('[slot="flag"]');
        if (t instanceof it && !t.hasCountryFlag) {
          if (!e) {
            const o = (a = this.flagSVG) == null ? void 0 : a.cloneNode(!0);
            o == null || o.setAttribute("slot", "flag"), t == null || t.appendChild(o);
          }
          t.hasCountryFlag = !0;
        }
      });
    };
  }
  static get styles() {
    return [super.styles, this.flagStyles, MM];
  }
  static get lightDOMStyles() {
    return [super.lightDOMStyles, TM];
  }
  /** Callback for on beacon-event-language-select */
  onBeaconLanguageSelect() {
  }
  get selectedLanguage() {
    return this.selectedLanguages[0];
  }
  get slottedNavigationItem() {
    return this.navigationItems[0];
  }
  countryPreRender() {
    this.largeBreakpointWatcher.addEventListener(
      "change",
      this.handleBreakpointChanges
    );
  }
  /** Emits `beacon-event-language-select` from the given element. */
  emitLanguageSelect(t) {
    Re(
      t,
      Ee.LANGUAGE_SELECT,
      void 0,
      this.onBeaconLanguageSelect
    );
  }
  /**
   * When countries are added to the default slot, we add click event listeners to each language link to emit a custom event.
   *
   * @see emitLanguageSelect
   */
  handleSlotchange() {
    var t;
    (t = this.languages) == null || t.forEach((e) => {
      e.dataset.hasBeaconLanguageEvent || (e.addEventListener("click", () => {
        this.emitLanguageSelect(e);
      }), e.dataset.hasBeaconLanguageEvent = "");
    }), this.selectedLanguage && !this.current && (Re(this, Ee.NAV_LANGUAGE_SELECT, {
      detail: {
        country: this
      }
    }), this.current = !0);
  }
  createCurrentCountry(t) {
    if (t)
      return;
    const e = document.createElement("template");
    e.innerHTML = `
    <${this.getScopedTagName("beacon-navigation-button")}
      expanded-anchor
      slot="country-navigation-button"
      opens="country-selector">
      ${this.title}
    </${this.getScopedTagName("beacon-navigation-button")}>
    `, this.querySelector('[opens="country-selector"]') || this.appendChild(e.content.cloneNode(!0)), this.cloned || (this.moveCurrentCountry(), this.alterCanonicalCountryAttributes()), this.currentCountryCreated = !0;
  }
  moveCurrentCountry() {
    const t = document.querySelector("[country-selector]"), e = document.querySelector(
      this.getScopedTagName("beacon-navigation")
    );
    if (t && !t.querySelector('[opens="country-selector"]')) {
      const a = this.cloneNode(!0);
      a.cloned = !0, a.clonedLocation = "popover", t.appendChild(a), this.addCurrentCountryFlag();
    }
    if (e) {
      const a = this.cloneNode(!0);
      a.cloned = !0, a.setAttribute("slot", "country-selector"), a.clonedLocation = "navigation", e.appendChild(a);
    }
  }
  alterCanonicalCountryAttributes() {
    var t;
    this.style.display = "none", (t = this.slottedNavigationItem) == null || t.removeAttribute("opens");
  }
  /**
   * Updates attributes on slotted cloned navigation buttons to maintain open and close functionality across breakpoints.
   *
   * We directly remove attributes instead of setting values with their props because the property route was not working as intended.
   */
  handleNavItemSlotchange() {
    var t;
    this.slottedNavigationItem && (this.cloned || this.slottedNavigationItem.removeAttribute("opens"), this.isMobile && this.clonedLocation === "popover" && this.slottedNavigationItem.removeAttribute("opens"), this.isDesktop && this.clonedLocation === "navigation" && this.slottedNavigationItem.removeAttribute("opens"), this.eventAddedToNavItem || (t = this.slottedNavigationItem.button) == null || t.addEventListener("click", () => {
      Re(
        this.slottedNavigationItem.button,
        Ee.COUNTRY_SELECTOR_OPEN
      ), this.eventAddedToNavItem = !0;
    }));
  }
  renderTitleContainer() {
    return this.current && !this.isExpanded ? (this.createCurrentCountry(this.currentCountryCreated), pe`
        <slot name="title" style="display: none;"></slot>
        <slot
          class="navigation-button-slot"
          name="country-navigation-button"
          @slotchange=${this.handleNavItemSlotchange}></slot>
      `) : super.renderTitleContainer();
  }
  render() {
    return pe`
      <div class="header">
        ${this.renderFlagContainer()} ${this.renderTitleContainer()}
      </div>
      <div class="languages">
        <slot @slotchange=${this.handleSlotchange}></slot>
      </div>
    `;
  }
};
Vl.tagName = Qu.beaconTagName, Vl.nestedComponents = [fo];
let Ao = Vl;
ra([
  ue({ type: Boolean, reflect: !0, attribute: "is-expanded" })
], Ao.prototype, "isExpanded", 2);
ra([
  ue({ type: Boolean, reflect: !0 })
], Ao.prototype, "current", 2);
ra([
  Se()
], Ao.prototype, "clonedLocation", 2);
ra([
  Se()
], Ao.prototype, "cloned", 2);
ra([
  Se()
], Ao.prototype, "eventAddedToNavItem", 2);
ra([
  Se()
], Ao.prototype, "currentCountryCreated", 2);
ra([
  Pe({ selector: "a", flatten: !0 })
], Ao.prototype, "languages", 2);
ra([
  Pe({
    selector: "[selected-language]",
    flatten: !0
  })
], Ao.prototype, "selectedLanguages", 2);
ra([
  Pe({
    slot: "country-navigation-button",
    flatten: !0
  })
], Ao.prototype, "navigationItems", 2);
ra([
  qe
], Ao.prototype, "countryPreRender", 1);
const Xu = {
  beaconTagName: "beacon-country-selector"
}, PM = ve`[beacon-tag-name=beacon-country-selector] [slot=title]{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-50)}[beacon-tag-name=beacon-country-selector] [slot=title] :is(h1,h2,h3,h4,h5,h6){font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-50)}[beacon-tag-name=beacon-country-selector] [beacon-tag-name=beacon-region-selector]{border-block-start:var(--beacon-system-width-border-mini) solid var(--beacon-system-color-border-1);padding-block-start:var(--beacon-system-space-micro-jumbo)}@media (width >= 960px){[beacon-tag-name=beacon-country-selector] [beacon-tag-name=beacon-region-selector]{padding-block-start:var(--beacon-reference-space-9)}}`, zM = ve`:host{display:grid;gap:var(--beacon-system-space-micro-jumbo);inline-size:100%}@media (width >= 960px){:host{gap:var(--beacon-reference-space-9)}}.current-selection{display:grid;gap:var(--beacon-system-space-micro-normal)}.current{padding-block:var(--beacon-system-space-cell-free-floating)}.current :is(h1,h2,h3,h4,h5,h6),.current ::slotted(*){font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-50);color:var(--beacon-system-color-text-title);margin:0}@media (width >= 960px){a,::slotted(a){color:var(--beacon-system-color-text-link)}}`;
var DM = Object.defineProperty, IM = Object.getOwnPropertyDescriptor, Sc = (i, t, e, a) => {
  for (var o = a > 1 ? void 0 : a ? IM(t, e) : t, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = (a ? r(t, e, o) : r(o)) || o);
  return a && o && DM(t, e, o), o;
};
const xb = class xb extends Ke(Le).with(
  _s({ skipFirstUpdated: !1 })
) {
  constructor() {
    super(...arguments), this.beaconTagName = Xu.beaconTagName, this.expanded = !1, this.setSelectedCountry = ({ detail: t }) => {
      if (!this.selectedCountry) {
        const e = t.country.cloneNode(!0);
        this.selectedCountry = e, this.selectedCountry.isExpanded = !0, this.selectedCountry.setAttribute("slot", "current-country"), this.appendChild(this.selectedCountry);
      }
    };
  }
  static get styles() {
    return [super.styles, zM];
  }
  static get lightDOMStyles() {
    return [...super.lightDOMStyles, PM];
  }
  countrySelectorPrerender() {
    this.addEventListener(
      Ee.NAV_LANGUAGE_SELECT,
      this.setSelectedCountry
    );
  }
  updateAnalytics() {
    super.updateAnalytics(), this.metricsSection = Ho.level2LangSelector;
  }
  render() {
    return pe`
      <div class="current-selection">
        <div class="current">
          <slot name="title"><h3>Current selection</h3></slot>
        </div>
        <slot name="current-country"></slot>
      </div>
      <slot class="regions"></slot>
    `;
  }
};
xb.tagName = Xu.beaconTagName;
let ir = xb;
Sc([
  Pe(
    { selector: "beacon-region-selector", flatten: !0 },
    !0
  )
], ir.prototype, "regions", 2);
Sc([
  ue({ type: Boolean, reflect: !0 })
], ir.prototype, "expanded", 2);
Sc([
  Se()
], ir.prototype, "selectedCountry", 2);
Sc([
  qe
], ir.prototype, "countrySelectorPrerender", 1);
const BM = {
  Vertical: "vertical"
}, Zu = {
  beaconTagName: "beacon-divider"
}, nv = {
  Thin: "thin",
  Thick: "thick"
}, rv = {
  Neutral: "neutral",
  Strong: "strong"
}, Va = {
  Horizontal: "horizontal",
  Vertical: "vertical"
}, RM = ve`:host{--divider-color: var(--beacon-system-color-border-2);--divider-size: var(--beacon-system-width-border-mini);background-color:var(--divider-color);block-size:var(--vertical-divider-block-size, var(--divider-size))!important;inline-size:var(--vertical-divider-inline-size, 100%)}:host([weight=thick]){--divider-size: var(--beacon-system-width-border-normal)}:host([color-mode=strong]){--divider-color: var(--beacon-system-color-border-brand)}:host([orientation=vertical][small-sectioning-mode=vertical]){--vertical-divider-block-size: var(--beacon-override-vertical-divider-block-size, auto);--vertical-divider-inline-size: var(--divider-size);align-self:stretch;display:inline-block}@media (width >= 640px){:host([orientation=vertical]){--vertical-divider-block-size: var(--beacon-override-vertical-divider-block-size, auto);--vertical-divider-inline-size: var(--divider-size);align-self:stretch;display:inline-block}}`;
var NM = Object.defineProperty, FM = Object.getOwnPropertyDescriptor, xr = (i, t, e, a) => {
  for (var o = a > 1 ? void 0 : a ? FM(t, e) : t, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = (a ? r(t, e, o) : r(o)) || o);
  return a && o && NM(t, e, o), o;
};
const wb = class wb extends Ke(Le).with(Ra) {
  constructor() {
    super(...arguments), this.beaconTagName = Zu.beaconTagName, this.weight = nv.Thin, this.colorMode = rv.Neutral, this.orientation = Va.Horizontal, this.smallSectioningMode = Va.Horizontal;
  }
  // TODO: use element internals when footnotes are merged
  setDividerARIA() {
    this.setAttribute("role", "separator");
  }
  _setAriaOrientation() {
    let t = Va.Horizontal;
    this.orientation === Va.Vertical && !(this.smallSectioningMode === Va.Horizontal && !this.isMediumBreakpoint) && (t = Va.Vertical), this.setAttribute("aria-orientation", t);
  }
  static get styles() {
    return [super.styles, RM];
  }
};
wb.tagName = Zu.beaconTagName;
let ta = wb;
xr([
  ue({ reflect: !0 })
], ta.prototype, "weight", 2);
xr([
  ue({ attribute: "color-mode", reflect: !0 })
], ta.prototype, "colorMode", 2);
xr([
  ue({ reflect: !0 })
], ta.prototype, "orientation", 2);
xr([
  ue({ attribute: "small-sectioning-mode", reflect: !0 })
], ta.prototype, "smallSectioningMode", 2);
xr([
  qe
], ta.prototype, "setDividerARIA", 1);
xr([
  yo("isMediumBreakpoint")
], ta.prototype, "_setAriaOrientation", 1);
const Ju = {
  beaconTagName: "beacon-divided-list-item"
}, _M = ve`:host{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100);display:flex;flex-flow:column;justify-content:space-between;word-break:normal}.wrapper{padding-block:var(--item-space, var(--beacon-reference-space-3))}@media (width >= 640px){.wrapper{--item-space: var(--beacon-reference-space-4)}}@media (width >= 960px){.wrapper{--item-space: var(--beacon-reference-space-5)}}@media (width >= 1280px){.wrapper{--item-space: var(--beacon-reference-space-6)}}.content{display:flex;gap:var(--beacon-reference-space-5);justify-content:space-between}.content ::slotted(*){flex-grow:1}.data-point{font-weight:var(--beacon-system-font-weight-bold)}.divider{display:var(--divider-display, block)}:host(:first-of-type) .content{position:relative}:host(:first-of-type) .content:after{background-color:var(--beacon-system-color-border-2);block-size:100%;content:"";display:var(--vertical-divider-display, none);inline-size:var(--beacon-system-width-border-mini);inset-block-start:0;inset-inline-start:calc(100% + var(--beacon-reference-space-7) / 2);position:absolute;z-index:1}`, Yl = class Yl extends Le {
  constructor() {
    super(), this.beaconTagName = Ju.beaconTagName, this._internals && (this._internals.role = "listitem");
  }
  static get styles() {
    return [super.styles, _M];
  }
  render() {
    return pe`
      <div class="wrapper">
        <div class="content">
          <slot ${Rh()}>
            <div class="supporting-text">
              <slot name="supporting-text"></slot>
            </div>
            <div class="data-point">
              <slot name="data-point"></slot>
            </div>
          </slot>
        </div>
      </div>
      ${Be`<${this.getScopedTag("beacon-divider")} class="divider"></${this.getScopedTag("beacon-divider")}>`}
    `;
  }
};
Yl.tagName = Ju.beaconTagName, Yl.nestedComponents = [ta];
let lh = Yl;
const eg = {
  beaconTagName: "beacon-divided-list"
}, UM = ve`:host{container:divided-list/inline-size}.base{padding-block:var(--beacon-system-space-cell-contained)}@container divided-list (inline-size >= 640px){.horizontal{column-gap:var(--beacon-reference-space-7);display:grid;grid-template-columns:1fr 1fr}@supports selector(:state(--customstate)){:host(:state(--divided-vertically)) .horizontal ::slotted([beacon-tag-name=beacon-divided-list-item]:first-of-type){--vertical-divider-display: block}}@supports not selector(:state(--customstate)){:host([state----divided-vertically]) .horizontal ::slotted([beacon-tag-name=beacon-divided-list-item]:first-of-type){--vertical-divider-display: block}}@supports selector(:state(--customstate)){:host(:state(--even-items)) .horizontal ::slotted([beacon-tag-name=beacon-divided-list-item]:nth-last-child(-n+2)){--divider-display: none}}@supports not selector(:state(--customstate)){:host([state----even-items]) .horizontal ::slotted([beacon-tag-name=beacon-divided-list-item]:nth-last-child(-n+2)){--divider-display: none}}}:is(.vertical,.horizontal) ::slotted([beacon-tag-name=beacon-divided-list-item]:last-of-type){--divider-display: none}`;
var jM = Object.defineProperty, $M = Object.getOwnPropertyDescriptor, wr = (i, t, e, a) => {
  for (var o = a > 1 ? void 0 : a ? $M(t, e) : t, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = (a ? r(t, e, o) : r(o)) || o);
  return a && o && jM(t, e, o), o;
}, Ql, sv;
const Xl = class Xl extends Le {
  constructor() {
    super();
    Fe(this, Ql);
    this.beaconTagName = eg.beaconTagName, this.orientation = BM.Vertical, this._dividedVertically = !1, this._hasEvenNumberOfItems = !1, this._internals && (this._internals.role = "list");
  }
  static get styles() {
    return [super.styles, UM];
  }
  _updateDividedState() {
    this.setState("--divided-vertically", this._dividedVertically);
  }
  _updateItemCountState() {
    this.setState("--even-items", this._hasEvenNumberOfItems);
  }
  render() {
    return pe`
      <div class="base ${this.orientation}">
        <slot @slotchange=${Ze(this, Ql, sv)}></slot>
      </div>
    `;
  }
};
Ql = new WeakSet(), sv = function() {
  this._dividedVertically = this._slottedListItems.length === 2, this._hasEvenNumberOfItems = this._slottedListItems.length % 2 == 0;
}, Xl.tagName = eg.beaconTagName, Xl.nestedComponents = [lh];
let mi = Xl;
wr([
  ue({ reflect: !0 })
], mi.prototype, "orientation", 2);
wr([
  Se()
], mi.prototype, "_dividedVertically", 2);
wr([
  Se()
], mi.prototype, "_hasEvenNumberOfItems", 2);
wr([
  yo("_dividedVertically")
], mi.prototype, "_updateDividedState", 1);
wr([
  yo("_hasEvenNumberOfItems")
], mi.prototype, "_updateItemCountState", 1);
wr([
  wt({
    selector: '[beacon-tag-name="beacon-divided-list-item"]'
  })
], mi.prototype, "_slottedListItems", 2);
const HM = ve`:root[beacon-tag-name=beacon-donut-chart][scale=mini],:root [beacon-tag-name=beacon-donut-chart][scale=mini],[beacon-version="4.3.1"][class*=beacon-on][beacon-tag-name=beacon-donut-chart][scale=mini],[beacon-version="4.3.1"][class*=beacon-on] [beacon-tag-name=beacon-donut-chart][scale=mini],[class*=beacon-on] [beacon-version="4.3.1"][beacon-tag-name=beacon-donut-chart][scale=mini],[class*=beacon-on] [beacon-version="4.3.1"] [beacon-tag-name=beacon-donut-chart][scale=mini],[beacon-version="4.3.1"][beacon-tag-name=beacon-donut-chart][scale=mini],[beacon-version="4.3.1"] [beacon-tag-name=beacon-donut-chart][scale=mini]{--donut-chart-metric-total-font: var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-200)}:root[beacon-tag-name=beacon-donut-chart][scale=normal],:root [beacon-tag-name=beacon-donut-chart][scale=normal],[beacon-version="4.3.1"][class*=beacon-on][beacon-tag-name=beacon-donut-chart][scale=normal],[beacon-version="4.3.1"][class*=beacon-on] [beacon-tag-name=beacon-donut-chart][scale=normal],[class*=beacon-on] [beacon-version="4.3.1"][beacon-tag-name=beacon-donut-chart][scale=normal],[class*=beacon-on] [beacon-version="4.3.1"] [beacon-tag-name=beacon-donut-chart][scale=normal],[beacon-version="4.3.1"][beacon-tag-name=beacon-donut-chart][scale=normal],[beacon-version="4.3.1"] [beacon-tag-name=beacon-donut-chart][scale=normal]{--donut-chart-metric-total-font: var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-400)}:root[beacon-tag-name=beacon-donut-chart][scale=jumbo],:root [beacon-tag-name=beacon-donut-chart][scale=jumbo],[beacon-version="4.3.1"][class*=beacon-on][beacon-tag-name=beacon-donut-chart][scale=jumbo],[beacon-version="4.3.1"][class*=beacon-on] [beacon-tag-name=beacon-donut-chart][scale=jumbo],[class*=beacon-on] [beacon-version="4.3.1"][beacon-tag-name=beacon-donut-chart][scale=jumbo],[class*=beacon-on] [beacon-version="4.3.1"] [beacon-tag-name=beacon-donut-chart][scale=jumbo],[beacon-version="4.3.1"][beacon-tag-name=beacon-donut-chart][scale=jumbo],[beacon-version="4.3.1"] [beacon-tag-name=beacon-donut-chart][scale=jumbo]{--donut-chart-metric-total-font: var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-600)}`, pt = {
  beaconTagName: "beacon-donut-chart",
  pieSizePercentage: "80%",
  minimumSizeJumbo: 180,
  // @MISSING_SYSTEM_TOKEN was Heritage Token: beaconDonutChartSizeWidthJumbo
  minimumSizeDefault: 160,
  attributes: {
    metricTotal: "metric-total",
    metricDescription: "metric-description",
    hideChartMetric: "hide-chart-metric",
    labelDistance: "label-distance",
    hideDataLabelConnectors: "hide-data-label-connectors",
    hideDataLabels: "hide-data-labels"
  },
  properties: {
    metricTotal: "metricTotal",
    metricDescription: "metricDescription",
    series: "series",
    disableLegend: "disableLegend"
  },
  metricWrapperClass: "metric-wrapper"
}, KM = ve`.metric-wrapper{display:var(--beacon-donut-chart-metric-display, block);inline-size:var(--metric-total-inline-size);overflow:hidden;text-align:center;white-space:initial;word-break:break-word}.metric-wrapper p{margin:0}.metric-wrapper .metric-total{font:var(--donut-chart-metric-total-font, var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-headline-600))}.metric-wrapper .metric-description{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-light-headline-100)}:host[scale=mini]{--donut-chart-metric-total-font: var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-headline-200)}:host[scale=normal]{--donut-chart-metric-total-font: var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-headline-400)}:host[scale=jumbo]{--donut-chart-metric-total-font: var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-headline-600)}.highcharts-data-labels{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-300)}.highcharts-data-labels text{fill:var(--beacon-system-color-text-standard)}.highcharts-data-label-connector{fill:none;stroke:var(--beacon-reference-palette-grayscale-light-gray-1)}.highcharts-point{stroke:var(--beacon-reference-palette-grayscale-dark-gray-2)}.highcharts-point.highcharts-point-hover{fill-opacity:1}.transparent-connector.highcharts-data-label-connector{stroke:transparent}.deselected .metric-wrapper,.highcharts-legend .highcharts-legend-item .highcharts-point{display:none}.highcharts-custom-circles circle{stroke:var(--beacon-component-data-viz-color-border-minor);stroke-width:var(--beacon-system-width-border-mini, 1px)}:host([hide-data-label-connectors]) .highcharts-data-label-connector{display:none}.highcharts-pie-series .highcharts-point{stroke:var(--beacon-system-color-background-1)}`;
var GM = Object.defineProperty, Fa = (i, t, e, a) => {
  for (var o = void 0, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = r(t, e, o) || o);
  return o && GM(t, e, o), o;
};
function WM(i) {
  return typeof i.itemHeight == "number";
}
function qM(i) {
  return typeof i.itemHeight == "number";
}
var Zi;
const sa = (Zi = class extends Ke(ct).with(un) {
  constructor() {
    super(), this.beaconTagName = pt.beaconTagName, this.internalMetricTotal = "", this.metricTotal = "", this.metricDescription = "", this.scale = Do.NORMAL, this.hideChartMetric = !1, this.labelDistance = 30, this.hideDataLabelConnectors = !1, this.hideDataLabels = !1, this.staticLegend = !0, this._type = Jt.PIE, this.resizeObserver = new ResizeObserver(
      Io(() => {
        this.chart && (this.updateChartMetricOptions(), this.updateChartHeight());
      }, 200)
    ), this.updateChartMetricTotal = this.updateChartMetricTotal.bind(this);
  }
  static get styles() {
    return [super.styles, KM];
  }
  static get lightDOMStyles() {
    return [...super.lightDOMStyles, HM];
  }
  /** Minimum size for the donut itself to be. */
  get minimumDonutSize() {
    return this.scale === Do.JUMBO && !this.hideChartMetric ? pt.minimumSizeJumbo : pt.minimumSizeDefault;
  }
  /**
   * Setting Pie Chart related Configuration
   */
  get localComponentOptions() {
    const t = this;
    return ct.createChartOptions(super.localComponentOptions, {
      chart: {
        events: {
          render() {
            const e = this.series[0];
            if (e.center) {
              const [, a] = e.center, o = this.container.querySelector(
                `.${pt.metricWrapperClass}`
              );
              if (o) {
                const n = o.getBoundingClientRect().height;
                if (e && e.options) {
                  const r = e.options, O = parseInt(
                    r.innerSize || "0",
                    10
                  ) / 2;
                  this.subtitle.attr({
                    y: a - n / 2 + O / 2
                  });
                }
              }
            }
            t.updateChartMetricTotal(this), t.resizeObserver.observe(t), Zi.createCustomCircles(this);
          }
        }
      },
      plotOptions: {
        pie: {
          center: ["50%", "50%"],
          borderRadius: 0,
          innerSize: `${pt.pieSizePercentage}`,
          minSize: this.minimumDonutSize,
          dataLabels: {
            enabled: !this.hideDataLabels,
            padding: 0,
            distance: this.labelDistance,
            formatter: function() {
              return ct.percentageFormatter(
                t.percentage,
                this.point.y,
                this.total,
                t.decimal,
                t.decimalPlaces
              );
            }
          }
        },
        series: {
          states: {
            hover: {
              halo: null
            }
          },
          // Displays the legend in the chart
          showInLegend: !0
        }
      },
      /**
       * Renders the chart metric with the subtitle instead,
       * to utilize default centering when the legend isn't rendered.
       */
      subtitle: {
        useHTML: !0,
        text: this.renderChartMetric(),
        floating: !0,
        verticalAlign: "middle",
        align: "center",
        y: 0
      },
      responsive: {
        rules: [
          {
            // Currently does nothing but can be used to dynamically adjust subtitle's y value, see this highcharts doc page
            // https://www.highcharts.com/docs/chart-concepts/responsive
            condition: {
              callback() {
                return window.innerWidth >= Zt.MEDIUM;
              }
            }
          }
        ]
      },
      tooltip: {
        headerFormat: "",
        pointFormatter() {
          const e = ct.percentageFormatter(
            t.percentage,
            this.options.y,
            this.total,
            t.decimal,
            t.decimalPlaces
          );
          return ct.tooltipPointHTML(this, this.name, e || "");
        }
      }
    });
  }
  /*
   * Metric width to be calculated as 64% of pie chart
   **/
  get MetricTotalInlineSize() {
    if (this.chart) {
      const t = this.chart.series[0].center[2];
      if (this.metricWrapper)
        return t * 0.64;
    }
    return 120;
  }
  /**
   * Non Lit Templated HTML render method used to render the chartMetric as the chart option's subtitle text.
   */
  renderChartMetric() {
    return this.internalMetricTotal && !this.hideChartMetric ? `
      <div class="${pt.metricWrapperClass}" style="inline-size: ${this.MetricTotalInlineSize}px">
      <p class="${pt.attributes.metricTotal}" aria-describedby="${pt.attributes.metricDescription}">
      ${this.internalMetricTotal}
    </p>
    <p class="${pt.attributes.metricDescription}" id="${pt.attributes.metricDescription}">
      ${this.metricDescription}
    </p></div>` : "";
  }
  /**
   * Overrides how color order is calculated, since donut charts only have one series,
   * you need the length of the data in that series for calculating the color-order
   */
  calculateSeriesLength(t) {
    var e;
    return (e = t.series[0]) == null ? void 0 : e.data.length;
  }
  /**
   * Updates the chart metric total value on chart load and redraw events,
   * as well as willUpdate. Extracted from the metric rendering method.
   * @param chart
   */
  updateChartMetricTotal(t) {
    if (this.metricTotal) {
      this.internalMetricTotal = this.metricTotal;
      return;
    }
    const a = t.series[0].total;
    a && (this.internalMetricTotal = a.toFixed(0));
  }
  /**
   * Used to update the metric chart options in willUpdate
   * when this.metricTotal is updated
   */
  updateChartMetricOptions() {
    this.updateChart({
      subtitle: {
        useHTML: !0,
        text: this.renderChartMetric(),
        verticalAlign: "middle",
        align: "center"
      }
    });
  }
  /**
   * This method changes the height of the chart based on the legend layout
   */
  updateChartHeight() {
    var t, e;
    if (this.chart) {
      const a = isNaN(Number((t = this.options.chart) == null ? void 0 : t.height)) ? void 0 : Number((e = this.options.chart) == null ? void 0 : e.height);
      if (this.legendLayout.direction === "vertical" || window.innerWidth < Zt.MEDIUM) {
        let o = 20;
        if (this.chart.legend.allItems.length > 0) {
          const j = this.chart.legend.allItems[0];
          (j instanceof ma.Point && qM(j) || j instanceof ma.Series && WM(j)) && (o = j.itemHeight);
        }
        const n = this.chart.legend.allItems.length, r = o * n, O = (a != null ? a : wl.HEIGHT) + r;
        this.chart.update({
          chart: {
            height: O
          }
        });
      } else
        this.chart.update({
          chart: {
            height: a != null ? a : wl.HEIGHT
          }
        });
      this.updateChartMetricOptions();
    }
  }
  /**
   * This method is to create custom circles (outer and inner) for the donut chart, so that we can apply border to both of them to meet design requirements
   */
  static createCustomCircles(t) {
    var r, T, O, j, D, F;
    t.customCircles && (t.customCircles.destroy(), t.customCircles = void 0);
    const e = t.renderer, a = t.plotLeft + (t == null ? void 0 : t.plotWidth) / 2, o = t.plotTop + (t == null ? void 0 : t.plotHeight) / 2, n = [
      (O = (T = (r = t.series[0]) == null ? void 0 : r.data[0]) == null ? void 0 : T.shapeArgs) == null ? void 0 : O.r,
      (F = (D = (j = t.series[0]) == null ? void 0 : j.data[0]) == null ? void 0 : D.shapeArgs) == null ? void 0 : F.innerR
    ];
    t.customCircles = t.renderer.g("custom-circles").add(), n.forEach((B) => {
      var N;
      e.circle(a, o, B).attr({
        fill: "none"
      }).add(t.customCircles), (N = t.customCircles) == null || N.attr({
        zIndex: 10
        // Adjust this value as needed
      }).add();
    });
  }
  /**
   * On Chart Load called on load event callback. Adds Metric Text and discription after chart load.
   * @param chart Highcharts.Chart
   */
  onChartLoad(t) {
    this.chart && (this.updateChartMetricTotal(t), this.updateChartMetricOptions());
  }
  /**
   * On Resizes updates the center text element of the chart.
   * @param chart Highcharts.Chart
   */
  onChartRedraw() {
    this.chart && this.updateChartMetricTotal(this.chart);
  }
  willUpdate(t) {
    var r;
    (r = super.willUpdate) == null || r.call(this, t);
    const e = this.hideLegendMetric, a = this.type, o = this.decimal, n = this.decimalPlaces;
    t.has(pt.properties.metricTotal) && this.updateChartMetricOptions(), t.has(pt.properties.metricDescription) && this.updateChartMetricOptions(), t.has(pt.properties.series) && this.chart && this.onChartLoad(this.chart), (t.has(pt.properties.disableLegend) || t.has("hideChartMetric")) && this.chart && this.updateChartMetricOptions(), t.has("legendLayout") && this.updateChart({
      legend: {
        labelFormatter() {
          return ct.legendItemHTML(
            this,
            e,
            !1,
            a,
            o,
            n
          );
        }
      }
    }), t.has("labelDistance") && this.updateChart({
      plotOptions: {
        pie: {
          dataLabels: {
            distance: this.labelDistance
          }
        }
      }
    }), t.has("hideDataLabels") && this.updateChart({
      plotOptions: {
        pie: {
          dataLabels: {
            enabled: !this.hideDataLabels
          }
        }
      }
    });
  }
}, Zi.tagName = pt.beaconTagName, Zi);
Fa([
  Se()
], sa.prototype, "internalMetricTotal");
Fa([
  ue({ attribute: pt.attributes.metricTotal })
], sa.prototype, "metricTotal");
Fa([
  ue({ attribute: pt.attributes.metricDescription })
], sa.prototype, "metricDescription");
Fa([
  ue({ reflect: !0 })
], sa.prototype, "scale");
Fa([
  ue({ attribute: pt.attributes.hideChartMetric, type: Boolean })
], sa.prototype, "hideChartMetric");
Fa([
  Ge(`.${pt.metricWrapperClass}`)
], sa.prototype, "metricWrapper");
Fa([
  ue({ type: Number, attribute: pt.attributes.labelDistance })
], sa.prototype, "labelDistance");
Fa([
  ue({
    attribute: pt.attributes.hideDataLabelConnectors,
    type: Boolean
  })
], sa.prototype, "hideDataLabelConnectors");
Fa([
  ue({ attribute: pt.attributes.hideDataLabels, type: Boolean })
], sa.prototype, "hideDataLabels");
let Q3 = sa;
/*!
* focus-trap 7.6.4
* @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
*/
function ch(i, t) {
  (t == null || t > i.length) && (t = i.length);
  for (var e = 0, a = Array(t); e < t; e++) a[e] = i[e];
  return a;
}
function VM(i) {
  if (Array.isArray(i)) return ch(i);
}
function YM(i, t, e) {
  return (t = eL(t)) in i ? Object.defineProperty(i, t, {
    value: e,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : i[t] = e, i;
}
function QM(i) {
  if (typeof Symbol < "u" && i[Symbol.iterator] != null || i["@@iterator"] != null) return Array.from(i);
}
function XM() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function tg(i, t) {
  var e = Object.keys(i);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(i);
    t && (a = a.filter(function(o) {
      return Object.getOwnPropertyDescriptor(i, o).enumerable;
    })), e.push.apply(e, a);
  }
  return e;
}
function og(i) {
  for (var t = 1; t < arguments.length; t++) {
    var e = arguments[t] != null ? arguments[t] : {};
    t % 2 ? tg(Object(e), !0).forEach(function(a) {
      YM(i, a, e[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(i, Object.getOwnPropertyDescriptors(e)) : tg(Object(e)).forEach(function(a) {
      Object.defineProperty(i, a, Object.getOwnPropertyDescriptor(e, a));
    });
  }
  return i;
}
function ZM(i) {
  return VM(i) || QM(i) || tL(i) || XM();
}
function JM(i, t) {
  if (typeof i != "object" || !i) return i;
  var e = i[Symbol.toPrimitive];
  if (e !== void 0) {
    var a = e.call(i, t);
    if (typeof a != "object") return a;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(i);
}
function eL(i) {
  var t = JM(i, "string");
  return typeof t == "symbol" ? t : t + "";
}
function tL(i, t) {
  if (i) {
    if (typeof i == "string") return ch(i, t);
    var e = {}.toString.call(i).slice(8, -1);
    return e === "Object" && i.constructor && (e = i.constructor.name), e === "Map" || e === "Set" ? Array.from(i) : e === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e) ? ch(i, t) : void 0;
  }
}
var ag = {
  activateTrap: function(t, e) {
    if (t.length > 0) {
      var a = t[t.length - 1];
      a !== e && a._setPausedState(!0);
    }
    var o = t.indexOf(e);
    o === -1 || t.splice(o, 1), t.push(e);
  },
  deactivateTrap: function(t, e) {
    var a = t.indexOf(e);
    a !== -1 && t.splice(a, 1), t.length > 0 && !t[t.length - 1]._isManuallyPaused() && t[t.length - 1]._setPausedState(!1);
  }
}, oL = function(t) {
  return t.tagName && t.tagName.toLowerCase() === "input" && typeof t.select == "function";
}, aL = function(t) {
  return (t == null ? void 0 : t.key) === "Escape" || (t == null ? void 0 : t.key) === "Esc" || (t == null ? void 0 : t.keyCode) === 27;
}, Vr = function(t) {
  return (t == null ? void 0 : t.key) === "Tab" || (t == null ? void 0 : t.keyCode) === 9;
}, iL = function(t) {
  return Vr(t) && !t.shiftKey;
}, nL = function(t) {
  return Vr(t) && t.shiftKey;
}, ig = function(t) {
  return setTimeout(t, 0);
}, zr = function(t) {
  for (var e = arguments.length, a = new Array(e > 1 ? e - 1 : 0), o = 1; o < e; o++)
    a[o - 1] = arguments[o];
  return typeof t == "function" ? t.apply(void 0, a) : t;
}, sl = function(t) {
  return t.target.shadowRoot && typeof t.composedPath == "function" ? t.composedPath()[0] : t.target;
}, rL = [], lv = function(t, e) {
  var a = (e == null ? void 0 : e.document) || document, o = (e == null ? void 0 : e.trapStack) || rL, n = og({
    returnFocusOnDeactivate: !0,
    escapeDeactivates: !0,
    delayInitialFocus: !0,
    isKeyForward: iL,
    isKeyBackward: nL
  }, e), r = {
    // containers given to createFocusTrap()
    // @type {Array<HTMLElement>}
    containers: [],
    // list of objects identifying tabbable nodes in `containers` in the trap
    // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
    //  is active, but the trap should never get to a state where there isn't at least one group
    //  with at least one tabbable node in it (that would lead to an error condition that would
    //  result in an error being thrown)
    // @type {Array<{
    //   container: HTMLElement,
    //   tabbableNodes: Array<HTMLElement>, // empty if none
    //   focusableNodes: Array<HTMLElement>, // empty if none
    //   posTabIndexesFound: boolean,
    //   firstTabbableNode: HTMLElement|undefined,
    //   lastTabbableNode: HTMLElement|undefined,
    //   firstDomTabbableNode: HTMLElement|undefined,
    //   lastDomTabbableNode: HTMLElement|undefined,
    //   nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
    // }>}
    containerGroups: [],
    // same order/length as `containers` list
    // references to objects in `containerGroups`, but only those that actually have
    //  tabbable nodes in them
    // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
    //  the same length
    tabbableGroups: [],
    nodeFocusedBeforeActivation: null,
    mostRecentlyFocusedNode: null,
    active: !1,
    paused: !1,
    manuallyPaused: !1,
    // timer ID for when delayInitialFocus is true and initial focus in this trap
    //  has been delayed during activation
    delayInitialFocusTimer: void 0,
    // the most recent KeyboardEvent for the configured nav key (typically [SHIFT+]TAB), if any
    recentNavEvent: void 0
  }, T, O = function(d, s, l) {
    return d && d[s] !== void 0 ? d[s] : n[l || s];
  }, j = function(d, s) {
    var l = typeof (s == null ? void 0 : s.composedPath) == "function" ? s.composedPath() : void 0;
    return r.containerGroups.findIndex(function(b) {
      var u = b.container, c = b.tabbableNodes;
      return u.contains(d) || // fall back to explicit tabbable search which will take into consideration any
      //  web components if the `tabbableOptions.getShadowRoot` option was used for
      //  the trap, enabling shadow DOM support in tabbable (`Node.contains()` doesn't
      //  look inside web components even if open)
      (l == null ? void 0 : l.includes(u)) || c.find(function(h) {
        return h === d;
      });
    });
  }, D = function(d) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, l = s.hasFallback, b = l === void 0 ? !1 : l, u = s.params, c = u === void 0 ? [] : u, h = n[d];
    if (typeof h == "function" && (h = h.apply(void 0, ZM(c))), h === !0 && (h = void 0), !h) {
      if (h === void 0 || h === !1)
        return h;
      throw new Error("`".concat(d, "` was specified but was not a node, or did not return a node"));
    }
    var g = h;
    if (typeof h == "string") {
      try {
        g = a.querySelector(h);
      } catch (E) {
        throw new Error("`".concat(d, '` appears to be an invalid selector; error="').concat(E.message, '"'));
      }
      if (!g && !b)
        throw new Error("`".concat(d, "` as selector refers to no known node"));
    }
    return g;
  }, F = function() {
    var d = D("initialFocus", {
      hasFallback: !0
    });
    if (d === !1)
      return !1;
    if (d === void 0 || d && !Ad(d, n.tabbableOptions))
      if (j(a.activeElement) >= 0)
        d = a.activeElement;
      else {
        var s = r.tabbableGroups[0], l = s && s.firstTabbableNode;
        d = l || D("fallbackFocus");
      }
    else d === null && (d = D("fallbackFocus"));
    if (!d)
      throw new Error("Your focus-trap needs to have at least one focusable element");
    return d;
  }, B = function() {
    if (r.containerGroups = r.containers.map(function(d) {
      var s = uf(d, n.tabbableOptions), l = FS(d, n.tabbableOptions), b = s.length > 0 ? s[0] : void 0, u = s.length > 0 ? s[s.length - 1] : void 0, c = l.find(function(E) {
        return Mn(E);
      }), h = l.slice().reverse().find(function(E) {
        return Mn(E);
      }), g = !!s.find(function(E) {
        return Ii(E) > 0;
      });
      return {
        container: d,
        tabbableNodes: s,
        focusableNodes: l,
        /** True if at least one node with positive `tabindex` was found in this container. */
        posTabIndexesFound: g,
        /** First tabbable node in container, __tabindex__ order; `undefined` if none. */
        firstTabbableNode: b,
        /** Last tabbable node in container, __tabindex__ order; `undefined` if none. */
        lastTabbableNode: u,
        // NOTE: DOM order is NOT NECESSARILY "document position" order, but figuring that out
        //  would require more than just https://developer.mozilla.org/en-US/docs/Web/API/Node/compareDocumentPosition
        //  because that API doesn't work with Shadow DOM as well as it should (@see
        //  https://github.com/whatwg/dom/issues/320) and since this first/last is only needed, so far,
        //  to address an edge case related to positive tabindex support, this seems like a much easier,
        //  "close enough most of the time" alternative for positive tabindexes which should generally
        //  be avoided anyway...
        /** First tabbable node in container, __DOM__ order; `undefined` if none. */
        firstDomTabbableNode: c,
        /** Last tabbable node in container, __DOM__ order; `undefined` if none. */
        lastDomTabbableNode: h,
        /**
         * Finds the __tabbable__ node that follows the given node in the specified direction,
         *  in this container, if any.
         * @param {HTMLElement} node
         * @param {boolean} [forward] True if going in forward tab order; false if going
         *  in reverse.
         * @returns {HTMLElement|undefined} The next tabbable node, if any.
         */
        nextTabbableNode: function(R) {
          var L = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, U = s.indexOf(R);
          return U < 0 ? L ? l.slice(l.indexOf(R) + 1).find(function(V) {
            return Mn(V);
          }) : l.slice(0, l.indexOf(R)).reverse().find(function(V) {
            return Mn(V);
          }) : s[U + (L ? 1 : -1)];
        }
      };
    }), r.tabbableGroups = r.containerGroups.filter(function(d) {
      return d.tabbableNodes.length > 0;
    }), r.tabbableGroups.length <= 0 && !D("fallbackFocus"))
      throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
    if (r.containerGroups.find(function(d) {
      return d.posTabIndexesFound;
    }) && r.containerGroups.length > 1)
      throw new Error("At least one node with a positive tabindex was found in one of your focus-trap's multiple containers. Positive tabindexes are only supported in single-container focus-traps.");
  }, N = function(d) {
    var s = d.activeElement;
    if (s)
      return s.shadowRoot && s.shadowRoot.activeElement !== null ? N(s.shadowRoot) : s;
  }, f = function(d) {
    if (d !== !1 && d !== N(document)) {
      if (!d || !d.focus) {
        f(F());
        return;
      }
      d.focus({
        preventScroll: !!n.preventScroll
      }), r.mostRecentlyFocusedNode = d, oL(d) && d.select();
    }
  }, w = function(d) {
    var s = D("setReturnFocus", {
      params: [d]
    });
    return s || (s === !1 ? !1 : d);
  }, x = function(d) {
    var s = d.target, l = d.event, b = d.isBackward, u = b === void 0 ? !1 : b;
    s = s || sl(l), B();
    var c = null;
    if (r.tabbableGroups.length > 0) {
      var h = j(s, l), g = h >= 0 ? r.containerGroups[h] : void 0;
      if (h < 0)
        u ? c = r.tabbableGroups[r.tabbableGroups.length - 1].lastTabbableNode : c = r.tabbableGroups[0].firstTabbableNode;
      else if (u) {
        var E = r.tabbableGroups.findIndex(function(Y) {
          var I = Y.firstTabbableNode;
          return s === I;
        });
        if (E < 0 && (g.container === s || Ad(s, n.tabbableOptions) && !Mn(s, n.tabbableOptions) && !g.nextTabbableNode(s, !1)) && (E = h), E >= 0) {
          var R = E === 0 ? r.tabbableGroups.length - 1 : E - 1, L = r.tabbableGroups[R];
          c = Ii(s) >= 0 ? L.lastTabbableNode : L.lastDomTabbableNode;
        } else Vr(l) || (c = g.nextTabbableNode(s, !1));
      } else {
        var U = r.tabbableGroups.findIndex(function(Y) {
          var I = Y.lastTabbableNode;
          return s === I;
        });
        if (U < 0 && (g.container === s || Ad(s, n.tabbableOptions) && !Mn(s, n.tabbableOptions) && !g.nextTabbableNode(s)) && (U = h), U >= 0) {
          var V = U === r.tabbableGroups.length - 1 ? 0 : U + 1, q = r.tabbableGroups[V];
          c = Ii(s) >= 0 ? q.firstTabbableNode : q.firstDomTabbableNode;
        } else Vr(l) || (c = g.nextTabbableNode(s));
      }
    } else
      c = D("fallbackFocus");
    return c;
  }, M = function(d) {
    var s = sl(d);
    if (!(j(s, d) >= 0)) {
      if (zr(n.clickOutsideDeactivates, d)) {
        T.deactivate({
          // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
          //  which will result in the outside click setting focus to the node
          //  that was clicked (and if not focusable, to "nothing"); by setting
          //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
          //  on activation (or the configured `setReturnFocus` node), whether the
          //  outside click was on a focusable node or not
          returnFocus: n.returnFocusOnDeactivate
        });
        return;
      }
      zr(n.allowOutsideClick, d) || d.preventDefault();
    }
  }, p = function(d) {
    var s = sl(d), l = j(s, d) >= 0;
    if (l || s instanceof Document)
      l && (r.mostRecentlyFocusedNode = s);
    else {
      d.stopImmediatePropagation();
      var b, u = !0;
      if (r.mostRecentlyFocusedNode)
        if (Ii(r.mostRecentlyFocusedNode) > 0) {
          var c = j(r.mostRecentlyFocusedNode), h = r.containerGroups[c].tabbableNodes;
          if (h.length > 0) {
            var g = h.findIndex(function(E) {
              return E === r.mostRecentlyFocusedNode;
            });
            g >= 0 && (n.isKeyForward(r.recentNavEvent) ? g + 1 < h.length && (b = h[g + 1], u = !1) : g - 1 >= 0 && (b = h[g - 1], u = !1));
          }
        } else
          r.containerGroups.some(function(E) {
            return E.tabbableNodes.some(function(R) {
              return Ii(R) > 0;
            });
          }) || (u = !1);
      else
        u = !1;
      u && (b = x({
        // move FROM the MRU node, not event-related node (which will be the node that is
        //  outside the trap causing the focus escape we're trying to fix)
        target: r.mostRecentlyFocusedNode,
        isBackward: n.isKeyBackward(r.recentNavEvent)
      })), f(b || r.mostRecentlyFocusedNode || F());
    }
    r.recentNavEvent = void 0;
  }, v = function(d) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    r.recentNavEvent = d;
    var l = x({
      event: d,
      isBackward: s
    });
    l && (Vr(d) && d.preventDefault(), f(l));
  }, k = function(d) {
    (n.isKeyForward(d) || n.isKeyBackward(d)) && v(d, n.isKeyBackward(d));
  }, m = function(d) {
    aL(d) && zr(n.escapeDeactivates, d) !== !1 && (d.preventDefault(), T.deactivate());
  }, A = function(d) {
    var s = sl(d);
    j(s, d) >= 0 || zr(n.clickOutsideDeactivates, d) || zr(n.allowOutsideClick, d) || (d.preventDefault(), d.stopImmediatePropagation());
  }, C = function() {
    if (r.active)
      return ag.activateTrap(o, T), r.delayInitialFocusTimer = n.delayInitialFocus ? ig(function() {
        f(F());
      }) : f(F()), a.addEventListener("focusin", p, !0), a.addEventListener("mousedown", M, {
        capture: !0,
        passive: !1
      }), a.addEventListener("touchstart", M, {
        capture: !0,
        passive: !1
      }), a.addEventListener("click", A, {
        capture: !0,
        passive: !1
      }), a.addEventListener("keydown", k, {
        capture: !0,
        passive: !1
      }), a.addEventListener("keydown", m), T;
  }, H = function() {
    if (r.active)
      return a.removeEventListener("focusin", p, !0), a.removeEventListener("mousedown", M, !0), a.removeEventListener("touchstart", M, !0), a.removeEventListener("click", A, !0), a.removeEventListener("keydown", k, !0), a.removeEventListener("keydown", m), T;
  }, G = function(d) {
    var s = d.some(function(l) {
      var b = Array.from(l.removedNodes);
      return b.some(function(u) {
        return u === r.mostRecentlyFocusedNode;
      });
    });
    s && f(F());
  }, P = typeof window < "u" && "MutationObserver" in window ? new MutationObserver(G) : void 0, y = function() {
    P && (P.disconnect(), r.active && !r.paused && r.containers.map(function(d) {
      P.observe(d, {
        subtree: !0,
        childList: !0
      });
    }));
  };
  return T = {
    get active() {
      return r.active;
    },
    get paused() {
      return r.paused;
    },
    activate: function(d) {
      if (r.active)
        return this;
      var s = O(d, "onActivate"), l = O(d, "onPostActivate"), b = O(d, "checkCanFocusTrap");
      b || B(), r.active = !0, r.paused = !1, r.nodeFocusedBeforeActivation = a.activeElement, s == null || s();
      var u = function() {
        b && B(), C(), y(), l == null || l();
      };
      return b ? (b(r.containers.concat()).then(u, u), this) : (u(), this);
    },
    deactivate: function(d) {
      if (!r.active)
        return this;
      var s = og({
        onDeactivate: n.onDeactivate,
        onPostDeactivate: n.onPostDeactivate,
        checkCanReturnFocus: n.checkCanReturnFocus
      }, d);
      clearTimeout(r.delayInitialFocusTimer), r.delayInitialFocusTimer = void 0, H(), r.active = !1, r.paused = !1, y(), ag.deactivateTrap(o, T);
      var l = O(s, "onDeactivate"), b = O(s, "onPostDeactivate"), u = O(s, "checkCanReturnFocus"), c = O(s, "returnFocus", "returnFocusOnDeactivate");
      l == null || l();
      var h = function() {
        ig(function() {
          c && f(w(r.nodeFocusedBeforeActivation)), b == null || b();
        });
      };
      return c && u ? (u(w(r.nodeFocusedBeforeActivation)).then(h, h), this) : (h(), this);
    },
    pause: function(d) {
      return r.active ? (r.manuallyPaused = !0, this._setPausedState(!0, d)) : this;
    },
    unpause: function(d) {
      return r.active ? (r.manuallyPaused = !1, o[o.length - 1] !== this ? this : this._setPausedState(!1, d)) : this;
    },
    updateContainerElements: function(d) {
      var s = [].concat(d).filter(Boolean);
      return r.containers = s.map(function(l) {
        return typeof l == "string" ? a.querySelector(l) : l;
      }), r.active && B(), y(), this;
    }
  }, Object.defineProperties(T, {
    _isManuallyPaused: {
      value: function() {
        return r.manuallyPaused;
      }
    },
    _setPausedState: {
      value: function(d, s) {
        if (r.paused === d)
          return this;
        if (r.paused = d, d) {
          var l = O(s, "onPause"), b = O(s, "onPostPause");
          l == null || l(), H(), y(), b == null || b();
        } else {
          var u = O(s, "onUnpause"), c = O(s, "onPostUnpause");
          u == null || u(), B(), C(), y(), c == null || c();
        }
        return this;
      }
    }
  }), T.updateContainerElements(t), T;
};
function sL(i) {
  return typeof i == "function" && i.length === 1;
}
const lL = ve`:host(:not([focus-override])) .non-modal-dialog-background-wrapper+dialog:focus-visible{position:fixed;z-index:2}dialog{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-200);background-color:var(--beacon-system-color-background-1);border:0;color:unset;inline-size:var(--beacon-modal-override-width, var(--default-width, 100%));max-inline-size:var(--beacon-modal-override-max-width, var(--max-width));min-inline-size:var(--min-width);padding:0}dialog::backdrop{background-color:var(--beacon-system-color-background-blanket)}.block-size-wrapper{block-size:var(--beacon-modal-override-height, auto)}.non-modal-dialog-background-wrapper+dialog{position:fixed;z-index:2}.non-modal-dialog-background-wrapper{background-color:var(--beacon-system-color-background-blanket);block-size:100%;inline-size:100%;top:0;right:0;bottom:0;left:0;position:fixed;z-index:1}.wrapper{block-size:100%;display:grid;grid-template-rows:auto 1fr auto}.header{border-block-end:var(--beacon-system-width-border-mini) solid var(--beacon-system-color-border-1);display:flex;justify-content:var(--header-justification, end);padding:var(--beacon-system-space-cell-contained)}.body{overflow-y:auto;scrollbar-color:var(--beacon-component-scrollbar-color-background-thumb) var(--beacon-component-scrollbar-color-background-track);scrollbar-gutter:stable}.action-zone{display:flex;gap:var(--beacon-system-space-micro-jumbo);justify-content:end}.footer{border-block-start:var(--beacon-system-width-border-mini) solid var(--beacon-system-color-border-1);padding:var(--beacon-system-space-cell-contained)}`;
var cL = Object.defineProperty, dL = Object.getOwnPropertyDescriptor, So = (i, t, e, a) => {
  for (var o = a > 1 ? void 0 : a ? dL(t, e) : t, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = (a ? r(t, e, o) : r(o)) || o);
  return a && o && cL(t, e, o), o;
}, qn;
const kb = class kb extends Ke(Le).with(Hh) {
  constructor() {
    super(...arguments);
    Fe(this, qn);
    this._passthroughs = new mc(this), this.closeOnClickOut = !1, this.persist = !1, Ne(this, qn, !1);
  }
  static get styles() {
    return [super.styles, lL];
  }
  get open() {
    return ze(this, qn);
  }
  set open(e) {
    Ne(this, qn, e), this.dialog && (this.open ? this.openModal() : this.closeModal());
  }
  handleEvent(e) {
    const a = this[`handle${e.type}`];
    sL(a) && a.bind(this)(e);
  }
  /**
   * External click handler used for the handleEvent method.
   *
   * @see handleEvent
   * @see setupOpensByListeners
   */
  handleclick({ target: e }) {
    var a;
    e instanceof HTMLElement && (a = this.opensByElements) != null && a.has(e) && this.show();
  }
  show() {
    this.open = !0;
  }
  close() {
    this.open = !1;
  }
  activateFocusTrap() {
    this.focusTrapObject && this.focusTrapObject.activate();
  }
  /*
   * TODO: Remove the OneTrust workaround.
   * We have worked with the Enterprise team to use dialog.show() instead of dialog.showModal() so that
   * they can have a separate modal pop above our modal. This is all a wacky workaround, so we will prefer
   * to find a different solution in the future. This change has resulted in the below if statement, as well
   * as the activateFocusTrap() method, and assorted CSS changes. For specific changes, look to MR 1900 in Beacon Foundation:
   * https://gitlab.awstrp.net/ui-kit/foundation/-/merge_requests/1900
   */
  openModal() {
    this.anyComputedZIndex ? this.dialog.show() : (this.dialog.showModal(), this.activateFocusTrap()), eb(), Re(this, Ee.OPEN);
  }
  closeModal() {
    this.focusTrapObject && this.focusTrapObject.deactivate(), this.dialog.close(), ls(), Re(this, Ee.CLOSE);
  }
  renderCloseButton() {
    return this.persist ? pe`` : Be`
      <${this.getScopedTag("beacon-icon-button")} class="close-button" variant="tertiary" @click=${this.close} id="${gt(this._passthroughs.attributes.get("id"))}">
        <svg
          class="icon--close"
          slot="icon"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M18.4697 19.5303C18.7626 19.8232 19.2374 19.8232 19.5303 19.5303C19.8232 19.2374 19.8232 18.7626 19.5303 18.4697L13.0607 12L19.5303 5.53033C19.8232 5.23744 19.8232 4.76256 19.5303 4.46967C19.2374 4.17678 18.7626 4.17678 18.4697 4.46967L12 10.9393L5.53033 4.46967C5.23744 4.17678 4.76256 4.17678 4.46967 4.46967C4.17678 4.76256 4.17678 5.23744 4.46967 5.53033L10.9393 12L4.46967 18.4697C4.17678 18.7626 4.17678 19.2374 4.46967 19.5303C4.76256 19.8232 5.23744 19.8232 5.53033 19.5303L12 13.0607L18.4697 19.5303Z"
            fill="#0063AD"
          />
        </svg>
        <slot name="close-button-text">Close</slot>
      </${this.getScopedTag("beacon-icon-button")}>
    `;
  }
  handleDialogClick(e) {
    if (this.persist || !this.closeOnClickOut) return;
    e.composedPath().includes(this.contentWrapper) || this.close();
  }
  runOpensBySetup() {
    this.opensByElements.forEach(
      (e, a) => a.addEventListener(
        "click",
        this
      )
    );
  }
  runOpensByClean() {
    this.opensByElements.forEach(
      (e, a) => a.removeEventListener(
        "click",
        this
      )
    );
  }
  setupAnalyticsAttributes() {
    this.dataset.metricsLocation = "PU";
  }
  initializeAnyComputedZIndex() {
    this.anyComputedZIndex = window.getComputedStyle(this).getPropertyValue("z-index") !== "auto";
  }
  openModalOnLoad() {
    this.open && this.openModal();
  }
  initializeFocusTrap() {
    window.__beaconTrapStack || (window.__beaconTrapStack = []), this.focusTrapObject = lv(this, {
      /** This global var enables multiple layers of focusTraps to determine which focusTrap takes precendence.
       * focus-trap will dynamically pause lower focusTrap layers in the stack.
       * https://github.com/focus-trap/focus-trap/blob/master/docs/js/global-trap-stack.js#L13
       * */
      trapStack: window.__beaconTrapStack,
      fallbackFocus: this.dialog,
      // focusTrap needs a fallbackFocus node if there are no focusable nodes found in the host element
      tabbableOptions: {
        getShadowRoot: !0
        // option that allows focusTrap to penetrate closed shadowRoot's and grab focusable nodes
      },
      // this is where escape key properly sets properties
      escapeDeactivates: () => (this.close(), !0)
    });
  }
  removeOpensByListeners() {
    this.opensByElements && this.opensByElements.size > 0 && this.opensByElements.forEach(
      (e, a) => a.removeEventListener(
        "click",
        this
      )
    );
  }
  closeWhenDisconnected() {
    this.open && (this.focusTrapObject && this.focusTrapObject.deactivate(), ls());
  }
};
qn = new WeakMap(), kb.nestedComponents = [eo];
let Ut = kb;
So([
  ue({ attribute: "close-on-click-out", type: Boolean })
], Ut.prototype, "closeOnClickOut", 2);
So([
  ue({ type: Boolean })
], Ut.prototype, "persist", 2);
So([
  ue({ type: Boolean, reflect: !0 })
], Ut.prototype, "open", 1);
So([
  Ge("dialog")
], Ut.prototype, "dialog", 2);
So([
  Ge(".wrapper")
], Ut.prototype, "contentWrapper", 2);
So([
  Se()
], Ut.prototype, "anyComputedZIndex", 2);
So([
  qe
], Ut.prototype, "setupAnalyticsAttributes", 1);
So([
  qe
], Ut.prototype, "initializeAnyComputedZIndex", 1);
So([
  De
], Ut.prototype, "openModalOnLoad", 1);
So([
  De
], Ut.prototype, "initializeFocusTrap", 1);
So([
  Lt
], Ut.prototype, "removeOpensByListeners", 1);
So([
  Lt
], Ut.prototype, "closeWhenDisconnected", 1);
const ng = {
  beaconTagName: "beacon-drawer"
}, hL = ve`@keyframes intro-from-offscreen-right{0%{opacity:0;transform:translate(calc(1 * var(--motion-translate-intro-macro)))}to{opacity:1;transform:translate(0)}}:host([motion-state=enabled]) .show{animation-name:intro-from-offscreen-right;animation-duration:var(--beacon-reference-motion-duration-5);animation-timing-function:var(--beacon-system-motion-easing-decelerate-emphasize-1)}:host([motion-state=enabled]) .show::backdrop{animation-duration:var(--beacon-reference-motion-duration-5);animation-name:backdrop-fade;animation-timing-function:var(--beacon-system-motion-easing-decelerate-emphasize-1)}:host([motion-state=enabled]) .close{animation-name:intro-from-offscreen-right;animation-direction:reverse;animation-duration:var(--beacon-reference-motion-duration-4);animation-timing-function:var(--beacon-system-motion-easing-accelerate-emphasize-1)}:host([motion-state=enabled]) .close::backdrop{animation-direction:reverse;animation-duration:var(--beacon-reference-motion-duration-4);animation-name:backdrop-fade;animation-timing-function:var(--beacon-system-motion-easing-accelerate-emphasize-1)}@keyframes backdrop-fade{0%{opacity:0}to{opacity:1}}`;
var bL = Object.defineProperty, pL = Object.getOwnPropertyDescriptor, rg = (i, t, e, a) => {
  for (var o = a > 1 ? void 0 : a ? pL(t, e) : t, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = (a ? r(t, e, o) : r(o)) || o);
  return a && o && bL(t, e, o), o;
};
function uL(i) {
  let t = class extends i {
    static get drawerMotionStyles() {
      return [hL];
    }
    /**
     * Overrides the default showModal and close methods of the dialog element with extra features.
     *
     * Calls the original methods when our extra features are completed.
     *
     * @link https://stackoverflow.com/questions/71744072/how-to-animate-css-backdrop-behind-html-dialog
     */
    drawerMotion() {
      if (this.motionState === "enabled") {
        const e = this.dialog, a = e.showModal, o = e.close;
        e.showModal = () => {
          e.classList.add("show"), a.call(e), e.addEventListener(
            "animationend",
            () => {
              e.classList.remove("show");
            },
            { once: !0 }
          );
        }, e.close = () => {
          e.classList.add("close"), e.addEventListener(
            "animationend",
            () => {
              o.call(e), e.classList.remove("close");
            },
            { once: !0 }
          );
        };
      }
    }
  };
  return rg([
    De
  ], t.prototype, "drawerMotion", 1), t = rg([
    je("DrawerMotion")
  ], t), t;
}
const gL = ve`dialog{--max-width: 100%;--min-width: 100%;block-size:100dvh;max-block-size:none}@media (width < 640px){dialog{margin-block:0}}@media (width >= 640px){dialog{--max-width: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 10 + var(--beacon-system-space-gutter) * 9);--min-width: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 10 + var(--beacon-system-space-gutter) * 9);margin-inline-end:0}}@media (width >= 960px){dialog{--max-width: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 8 + var(--beacon-system-space-gutter) * 7);--min-width: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 8 + var(--beacon-system-space-gutter) * 7)}}@media (width >= 1280px){dialog{--max-width: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 6 + var(--beacon-system-space-gutter) * 5);--min-width: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 6 + var(--beacon-system-space-gutter) * 5)}}.wrapper{block-size:100dvh;max-block-size:100dvh}.body{padding:var(--beacon-system-space-organism-jumbo)}`, Cb = class Cb extends Ke(Ut).with(uL) {
  constructor() {
    super(...arguments), this.beaconTagName = ng.beaconTagName;
  }
  static get styles() {
    return [super.styles, gL, this.drawerMotionStyles];
  }
  render() {
    return pe`
      <dialog @click=${this.handleDialogClick}>
        <div class="wrapper">
          <div class="header">${this.renderCloseButton()}</div>
          <div class="body" tabindex=${qi()}>
            <slot></slot>
          </div>
          <div class="footer">
            <div class="action-zone">
              <slot
                name="action-zone"
                ${Ue({ container: ".footer" })}></slot>
            </div>
          </div>
        </div>
      </dialog>
    `;
  }
};
Cb.tagName = ng.beaconTagName;
let sg = Cb;
const lg = {
  beaconTagName: "beacon-filter-chip"
}, mL = {
  Normal: "normal"
}, fL = ve`[beacon-tag-name=beacon-filter-chip]:not(:has([slot=icon])){--filter-chip-transition-property: inline-size, opacity}`, vL = ve`@media (prefers-reduced-motion: no-preference){:host([motion-state=enabled]) .filter-chip{transition-duration:var(--beacon-reference-motion-duration-3);transition-property:background-color,color;transition-timing-function:var(--beacon-system-motion-easing-decelerate-emphasize-1)}:host([motion-state=enabled]) .filter-chip .selected-icon{transition-duration:var(--beacon-reference-motion-duration-3),var(--beacon-reference-motion-duration-6);transition-property:var(--filter-chip-transition-property, none);transition-timing-function:var(--beacon-system-motion-easing-decelerate-emphasize-1)}}`;
var AL = Object.getOwnPropertyDescriptor, yL = (i, t, e, a) => {
  for (var o = a > 1 ? void 0 : a ? AL(t, e) : t, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = r(o) || o);
  return o;
};
function xL(i) {
  let t = class extends i {
    static get FilterChipMotionStyles() {
      return [vL];
    }
  };
  return t = yL([
    je("FilterChipMotion")
  ], t), t;
}
const wL = ve`:host{display:inline-block;position:relative}.filter-chip{--icon-color: var(--beacon-system-color-icon-secondary);--label-background: transparent;--label-border: var(--beacon-system-color-border-secondary);--label-color: var(--beacon-system-color-text-link);--label-font: var(--beacon-system-font-weight-bold) var(--beacon-component-button-normal-font-size-sans-serif-standard);--label-padding-block: var(--beacon-reference-space-4);--label-padding-inline: var(--beacon-reference-space-5);align-items:center;background-color:var(--label-background);border-color:var(--label-border);border-radius:var(--beacon-system-radius-corner-round);border-style:solid;border-width:var(--beacon-system-width-border-mini);color:var(--label-color);display:flex;font:var(--label-font);inline-size:fit-content;padding-block:var(--label-padding-block);padding-inline:var(--label-padding-inline)}.filter-chip.mini{--label-font: var(--beacon-system-font-weight-bold) var(--beacon-component-button-mini-font-size-sans-serif-standard);--label-padding-block: var(--beacon-reference-space-3);--label-padding-inline: var(--beacon-reference-space-4)}.filter-chip svg,.filter-chip ::slotted(svg){block-size:var(--beacon-reference-space-5);color:var(--icon-color);display:block;fill:currentcolor;inline-size:var(--beacon-reference-space-5)}.filter-chip .icon{flex-shrink:0}input{opacity:0;pointer-events:none;position:absolute}input:focus-visible+label{box-shadow:0 0 0 var(--beacon-system-width-border-jumbo) var(--beacon-system-color-border-focus-middle),0 0 0 var(--beacon-system-width-border-maxi) var(--beacon-system-color-border-focus-outer);outline:var(--beacon-system-width-border-normal) solid var(--beacon-system-color-border-focus-inner);outline-offset:0;z-index:1}input:focus-visible+label:not(dialog){position:relative}input:not(:disabled)+label{cursor:pointer}input:not(:disabled,:checked)+label:hover{--label-background: var(--beacon-system-color-background-secondary-hover)}input:disabled+label{--icon-color: var(--beacon-system-color-icon-secondary-inactive);--label-border: var(--beacon-system-color-border-secondary-inactive);--label-color: var(--beacon-system-color-text-secondary-inactive);cursor:not-allowed}input:active:not(:disabled,:checked)+label{--label-background: var(--beacon-system-color-background-secondary-pressed)}input:not(:checked)+label .custom-icon{inline-size:var(--beacon-reference-space-5);margin-inline-end:var(--beacon-reference-space-3);opacity:1}input:not(:checked)+label .selected-icon{inline-size:0;opacity:0;overflow:hidden}input:checked+label{--icon-color: var(--beacon-system-color-icon-primary);--label-background: var(--beacon-system-color-background-primary);--label-border: var(--beacon-system-color-border-primary);--label-color: var(--beacon-system-color-text-primary)}input:checked+label .custom-icon{inline-size:0;opacity:0;overflow:hidden}input:checked+label .selected-icon{inline-size:var(--beacon-reference-space-5);margin-inline-end:var(--beacon-reference-space-3)}input:checked+label:hover{--label-background: var(--beacon-system-color-background-primary-hover)}input:checked:active+label{--label-background: var(--beacon-system-color-background-primary-pressed)}input:checked:disabled+label{--icon-color: var(--beacon-system-color-icon-primary-inactive);--label-background: var(--beacon-system-color-background-primary-inactive);--label-border: var(--beacon-system-color-border-secondary-inactive);--label-color: var(--beacon-system-color-text-primary-inactive)}`;
var kL = Object.defineProperty, ob = (i, t, e, a) => {
  for (var o = void 0, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = r(t, e, o) || o);
  return o && kL(t, e, o), o;
}, $i;
const Sb = class Sb extends Ke(Le).with(
  xL
) {
  constructor() {
    super(...arguments);
    Fe(this, $i);
    this.beaconTagName = lg.beaconTagName, this.focusOverride = !0, this._passthroughs = new mc(this, {
      id: "filter"
    }), this.scale = mL.Normal, this.disabled = !1, this.selected = !1, Ne(this, $i, !1);
  }
  static get styles() {
    return [super.styles, wL, this.FilterChipMotionStyles];
  }
  static get lightDOMStyles() {
    return [super.lightDOMStyles, fL];
  }
  toggleSelectedFromInput({ target: e }) {
    e instanceof HTMLInputElement && (Ne(this, $i, !0), this.selected = e.checked);
  }
  emitInputEvent() {
    ze(this, $i) || Re(this, "input"), Ne(this, $i, !1);
  }
  willUpdate(e) {
    yr(e, "selected") && this.emitInputEvent();
  }
  render() {
    return pe`
      <input
        type="checkbox"
        id="${this._passthroughs.attributes.get("id")}"
        name="filter"
        ?disabled=${this.disabled}
        aria-disabled="${this.disabled}"
        .checked=${this.selected}
        @change=${this.toggleSelectedFromInput} />
      <label
        class="${this.scale} filter-chip"
        for="${this._passthroughs.attributes.get("id")}">
        <div class="icon selected-icon">
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_198_2093)">
              <path
                d="M15.5826 0.187467C15.1338 -0.134495 14.5091 -0.0314642 14.1873 0.4176L4.83073 13.4705L1.70743 10.3427C1.45484 10.0898 1.08663 9.99099 0.741488 10.0834C0.396348 10.1759 0.126716 10.4455 0.0341606 10.7908C-0.058395 11.1361 0.040187 11.5046 0.292772 11.7575L4.24941 15.7157C4.45954 15.9181 4.74638 16.0204 5.03704 15.9966C5.32769 15.9729 5.59416 15.8254 5.76873 15.5917L15.8126 1.5836C16.1344 1.13452 16.0314 0.509462 15.5826 0.187467Z" />
            </g>
            <defs>
              <clipPath id="clip0_198_2093">
                <rect width="16" height="16" />
              </clipPath>
            </defs>
          </svg>
        </div>
        <div class="icon custom-icon">
          <slot name="icon" ${Ue({ useParent: !0 })}></slot>
        </div>
        <div class="label">
          <slot></slot>
        </div>
      </label>
    `;
  }
};
$i = new WeakMap(), Sb.tagName = lg.beaconTagName;
let cs = Sb;
ob([
  ue()
], cs.prototype, "scale");
ob([
  ue({ type: Boolean })
], cs.prototype, "disabled");
ob([
  ue({ type: Boolean, reflect: !0 })
], cs.prototype, "selected");
const CL = ve`:root[beacon-tag-name=beacon-footer],:root [beacon-tag-name=beacon-footer],[beacon-version="4.3.1"][class*=beacon-on][beacon-tag-name=beacon-footer],[beacon-version="4.3.1"][class*=beacon-on] [beacon-tag-name=beacon-footer],[class*=beacon-on] [beacon-version="4.3.1"][beacon-tag-name=beacon-footer],[class*=beacon-on] [beacon-version="4.3.1"] [beacon-tag-name=beacon-footer],[beacon-version="4.3.1"][beacon-tag-name=beacon-footer],[beacon-version="4.3.1"] [beacon-tag-name=beacon-footer]{--footer-disclaimer-content-padding-inline-end: 0;--footer-links-padding-block: 0;--footer-links-gap: var(--beacon-system-space-micro-jumbo);--footer-mission-padding-block-end: var(--beacon-reference-space-5);--footer-mission-padding-block-start: 0;--footer-mission-zone-grid-gap: var(--beacon-system-space-micro-jumbo);--footer-socials-padding-block-start: var(--beacon-reference-space-5)}@media (width >= 960px){:root[beacon-tag-name=beacon-footer],:root [beacon-tag-name=beacon-footer],[beacon-version="4.3.1"][class*=beacon-on][beacon-tag-name=beacon-footer],[beacon-version="4.3.1"][class*=beacon-on] [beacon-tag-name=beacon-footer],[class*=beacon-on] [beacon-version="4.3.1"][beacon-tag-name=beacon-footer],[class*=beacon-on] [beacon-version="4.3.1"] [beacon-tag-name=beacon-footer],[beacon-version="4.3.1"][beacon-tag-name=beacon-footer],[beacon-version="4.3.1"] [beacon-tag-name=beacon-footer]{--footer-disclaimer-content-padding-inline-end: var(--beacon-reference-space-7);--footer-mission-padding-block-end: var(--beacon-reference-space-9);--footer-mission-zone-grid-gap: var(--beacon-reference-space-9);--footer-socials-padding-block-start: var(--beacon-reference-space-9)}}@media (width >= 1920px){:root[beacon-tag-name=beacon-footer],:root [beacon-tag-name=beacon-footer],[beacon-version="4.3.1"][class*=beacon-on][beacon-tag-name=beacon-footer],[beacon-version="4.3.1"][class*=beacon-on] [beacon-tag-name=beacon-footer],[class*=beacon-on] [beacon-version="4.3.1"][beacon-tag-name=beacon-footer],[class*=beacon-on] [beacon-version="4.3.1"] [beacon-tag-name=beacon-footer],[beacon-version="4.3.1"][beacon-tag-name=beacon-footer],[beacon-version="4.3.1"] [beacon-tag-name=beacon-footer]{--footer-links-gap: var(--beacon-reference-space-9)}}`, Pd = {
  beaconTagName: "beacon-footer",
  metricsLocationFooter: "FTR"
}, SL = ve`[beacon-tag-name=beacon-footer] :is([slot=disclaimer],[slot=copyright]) p{margin-block:var(--beacon-system-font-paragraph-spacing-loose)}[beacon-tag-name=beacon-footer] :is([slot=disclaimer],[slot=copyright]) :first-child{margin-block-start:0}[beacon-tag-name=beacon-footer] :is([slot=disclaimer],[slot=copyright]) :last-child{margin-block-end:0}[beacon-tag-name=beacon-footer] :is([slot=disclaimer],[slot=copyright]) a{color:var(--beacon-system-color-text-link)}[beacon-tag-name=beacon-footer] sup{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-300);vertical-align:super}`, EL = ve`.b-grid{--b-default-auto-layout: calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns));--b-default-grid-gap: var(--b-grid-gap, var(--beacon-system-space-gutter));--b-default-column-count: var(--b-grid-columns, var(--beacon-system-grid-columns));display:grid;gap:var(--b-default-grid-gap);grid-template-columns:var(--b-grid-template-col, repeat(var(--b-default-column-count), minmax(0, 1fr)));grid-template-rows:var(--b-grid-template-row, repeat(var(--b-grid-rows, 1), 1fr));inline-size:100%;margin-inline:auto;max-inline-size:var(--beacon-system-breakpoint-xx-large)}.b-grid.b-full-bleed{max-inline-size:none}.b-grid.b-auto-fill{--b-grid-template-col: repeat(auto-fill, minmax(min(var(--b-grid-auto-fill, var(--b-default-auto-layout)), 100%), 1fr))}.b-grid.b-auto-fit{--b-grid-template-col: repeat(auto-fit, minmax(min(var(--b-grid-auto-fit, var(--b-default-auto-layout)), 100%), 1fr))}.b-grid.b-vertical-fill [class*=b-grid-item] :first-child:not([class*=b-grid-item] [beacon-tag-name] *){block-size:100%}@media (width >= 320px){[class*=b-grid-item].b-sm\\:order-1{order:1}[class*=b-grid-item].b-sm\\:order-2{order:2}[class*=b-grid-item].b-sm\\:order-3{order:3}[class*=b-grid-item].b-sm\\:order-4{order:4}[class*=b-grid-item].b-sm\\:order-5{order:5}[class*=b-grid-item].b-sm\\:order-6{order:6}[class*=b-grid-item].b-sm\\:order-7{order:7}[class*=b-grid-item].b-sm\\:order-8{order:8}[class*=b-grid-item].b-sm\\:order-9{order:9}[class*=b-grid-item].b-sm\\:order-10{order:10}[class*=b-grid-item].b-sm\\:order-11{order:11}[class*=b-grid-item].b-sm\\:order-12{order:12}[class*=b-grid-item].b-sm\\:order-13{order:13}[class*=b-grid-item].b-sm\\:order-14{order:14}[class*=b-grid-item].b-sm\\:order-15{order:15}[class*=b-grid-item].b-sm\\:order-16{order:16}[class*=b-grid-item].b-sm\\:order-17{order:17}[class*=b-grid-item].b-sm\\:order-18{order:18}[class*=b-grid-item].b-sm\\:order-19{order:19}[class*=b-grid-item].b-sm\\:order-20{order:20}[class*=b-grid-item][class*="b-sm:vertical-divider"]{position:relative}[class*=b-grid-item][class*="b-sm:vertical-divider"]:after{background-color:var(--b-grid-divider-color, var(--beacon-system-color-border-2));block-size:100%;content:"";inline-size:var(--b-grid-divider-size, var(--beacon-system-width-border-mini));inset-block-start:0;inset-inline-start:calc(100% + var(--b-default-grid-gap) / 2);position:absolute;z-index:1}[class*=b-grid-item].b-sm\\:vertical-divider--thin--neutral{--b-grid-divider-size: var(--beacon-system-width-border-mini);--b-grid-divider-color: var(--beacon-system-color-border-2)}[class*=b-grid-item].b-sm\\:vertical-divider--thin--strong{--b-grid-divider-size: var(--beacon-system-width-border-mini);--b-grid-divider-color: var(--beacon-system-color-border-brand)}[class*=b-grid-item].b-sm\\:vertical-divider--thick--neutral{--b-grid-divider-size: var(--beacon-system-width-border-normal);--b-grid-divider-color: var(--beacon-system-color-border-2)}[class*=b-grid-item].b-sm\\:vertical-divider--thick--strong{--b-grid-divider-size: var(--beacon-system-width-border-normal);--b-grid-divider-color: var(--beacon-system-color-border-brand)}}@media (width >= 640px){[class*=b-grid-item].b-md\\:order-1{order:1}[class*=b-grid-item].b-md\\:order-2{order:2}[class*=b-grid-item].b-md\\:order-3{order:3}[class*=b-grid-item].b-md\\:order-4{order:4}[class*=b-grid-item].b-md\\:order-5{order:5}[class*=b-grid-item].b-md\\:order-6{order:6}[class*=b-grid-item].b-md\\:order-7{order:7}[class*=b-grid-item].b-md\\:order-8{order:8}[class*=b-grid-item].b-md\\:order-9{order:9}[class*=b-grid-item].b-md\\:order-10{order:10}[class*=b-grid-item].b-md\\:order-11{order:11}[class*=b-grid-item].b-md\\:order-12{order:12}[class*=b-grid-item].b-md\\:order-13{order:13}[class*=b-grid-item].b-md\\:order-14{order:14}[class*=b-grid-item].b-md\\:order-15{order:15}[class*=b-grid-item].b-md\\:order-16{order:16}[class*=b-grid-item].b-md\\:order-17{order:17}[class*=b-grid-item].b-md\\:order-18{order:18}[class*=b-grid-item].b-md\\:order-19{order:19}[class*=b-grid-item].b-md\\:order-20{order:20}[class*=b-grid-item][class*="b-md:vertical-divider"]{position:relative}[class*=b-grid-item][class*="b-md:vertical-divider"]:after{background-color:var(--b-grid-divider-color, var(--beacon-system-color-border-2));block-size:100%;content:"";inline-size:var(--b-grid-divider-size, var(--beacon-system-width-border-mini));inset-block-start:0;inset-inline-start:calc(100% + var(--b-default-grid-gap) / 2);position:absolute;z-index:1}[class*=b-grid-item].b-md\\:vertical-divider--thin--neutral{--b-grid-divider-size: var(--beacon-system-width-border-mini);--b-grid-divider-color: var(--beacon-system-color-border-2)}[class*=b-grid-item].b-md\\:vertical-divider--thin--strong{--b-grid-divider-size: var(--beacon-system-width-border-mini);--b-grid-divider-color: var(--beacon-system-color-border-brand)}[class*=b-grid-item].b-md\\:vertical-divider--thick--neutral{--b-grid-divider-size: var(--beacon-system-width-border-normal);--b-grid-divider-color: var(--beacon-system-color-border-2)}[class*=b-grid-item].b-md\\:vertical-divider--thick--strong{--b-grid-divider-size: var(--beacon-system-width-border-normal);--b-grid-divider-color: var(--beacon-system-color-border-brand)}}@media (width >= 960px){[class*=b-grid-item].b-lg\\:order-1{order:1}[class*=b-grid-item].b-lg\\:order-2{order:2}[class*=b-grid-item].b-lg\\:order-3{order:3}[class*=b-grid-item].b-lg\\:order-4{order:4}[class*=b-grid-item].b-lg\\:order-5{order:5}[class*=b-grid-item].b-lg\\:order-6{order:6}[class*=b-grid-item].b-lg\\:order-7{order:7}[class*=b-grid-item].b-lg\\:order-8{order:8}[class*=b-grid-item].b-lg\\:order-9{order:9}[class*=b-grid-item].b-lg\\:order-10{order:10}[class*=b-grid-item].b-lg\\:order-11{order:11}[class*=b-grid-item].b-lg\\:order-12{order:12}[class*=b-grid-item].b-lg\\:order-13{order:13}[class*=b-grid-item].b-lg\\:order-14{order:14}[class*=b-grid-item].b-lg\\:order-15{order:15}[class*=b-grid-item].b-lg\\:order-16{order:16}[class*=b-grid-item].b-lg\\:order-17{order:17}[class*=b-grid-item].b-lg\\:order-18{order:18}[class*=b-grid-item].b-lg\\:order-19{order:19}[class*=b-grid-item].b-lg\\:order-20{order:20}[class*=b-grid-item][class*="b-lg:vertical-divider"]{position:relative}[class*=b-grid-item][class*="b-lg:vertical-divider"]:after{background-color:var(--b-grid-divider-color, var(--beacon-system-color-border-2));block-size:100%;content:"";inline-size:var(--b-grid-divider-size, var(--beacon-system-width-border-mini));inset-block-start:0;inset-inline-start:calc(100% + var(--b-default-grid-gap) / 2);position:absolute;z-index:1}[class*=b-grid-item].b-lg\\:vertical-divider--thin--neutral{--b-grid-divider-size: var(--beacon-system-width-border-mini);--b-grid-divider-color: var(--beacon-system-color-border-2)}[class*=b-grid-item].b-lg\\:vertical-divider--thin--strong{--b-grid-divider-size: var(--beacon-system-width-border-mini);--b-grid-divider-color: var(--beacon-system-color-border-brand)}[class*=b-grid-item].b-lg\\:vertical-divider--thick--neutral{--b-grid-divider-size: var(--beacon-system-width-border-normal);--b-grid-divider-color: var(--beacon-system-color-border-2)}[class*=b-grid-item].b-lg\\:vertical-divider--thick--strong{--b-grid-divider-size: var(--beacon-system-width-border-normal);--b-grid-divider-color: var(--beacon-system-color-border-brand)}}@media (width >= 1280px){[class*=b-grid-item].b-xl\\:order-1{order:1}[class*=b-grid-item].b-xl\\:order-2{order:2}[class*=b-grid-item].b-xl\\:order-3{order:3}[class*=b-grid-item].b-xl\\:order-4{order:4}[class*=b-grid-item].b-xl\\:order-5{order:5}[class*=b-grid-item].b-xl\\:order-6{order:6}[class*=b-grid-item].b-xl\\:order-7{order:7}[class*=b-grid-item].b-xl\\:order-8{order:8}[class*=b-grid-item].b-xl\\:order-9{order:9}[class*=b-grid-item].b-xl\\:order-10{order:10}[class*=b-grid-item].b-xl\\:order-11{order:11}[class*=b-grid-item].b-xl\\:order-12{order:12}[class*=b-grid-item].b-xl\\:order-13{order:13}[class*=b-grid-item].b-xl\\:order-14{order:14}[class*=b-grid-item].b-xl\\:order-15{order:15}[class*=b-grid-item].b-xl\\:order-16{order:16}[class*=b-grid-item].b-xl\\:order-17{order:17}[class*=b-grid-item].b-xl\\:order-18{order:18}[class*=b-grid-item].b-xl\\:order-19{order:19}[class*=b-grid-item].b-xl\\:order-20{order:20}[class*=b-grid-item][class*="b-xl:vertical-divider"]{position:relative}[class*=b-grid-item][class*="b-xl:vertical-divider"]:after{background-color:var(--b-grid-divider-color, var(--beacon-system-color-border-2));block-size:100%;content:"";inline-size:var(--b-grid-divider-size, var(--beacon-system-width-border-mini));inset-block-start:0;inset-inline-start:calc(100% + var(--b-default-grid-gap) / 2);position:absolute;z-index:1}[class*=b-grid-item].b-xl\\:vertical-divider--thin--neutral{--b-grid-divider-size: var(--beacon-system-width-border-mini);--b-grid-divider-color: var(--beacon-system-color-border-2)}[class*=b-grid-item].b-xl\\:vertical-divider--thin--strong{--b-grid-divider-size: var(--beacon-system-width-border-mini);--b-grid-divider-color: var(--beacon-system-color-border-brand)}[class*=b-grid-item].b-xl\\:vertical-divider--thick--neutral{--b-grid-divider-size: var(--beacon-system-width-border-normal);--b-grid-divider-color: var(--beacon-system-color-border-2)}[class*=b-grid-item].b-xl\\:vertical-divider--thick--strong{--b-grid-divider-size: var(--beacon-system-width-border-normal);--b-grid-divider-color: var(--beacon-system-color-border-brand)}}@media (width >= 1600px){[class*=b-grid-item].b-xxl\\:order-1{order:1}[class*=b-grid-item].b-xxl\\:order-2{order:2}[class*=b-grid-item].b-xxl\\:order-3{order:3}[class*=b-grid-item].b-xxl\\:order-4{order:4}[class*=b-grid-item].b-xxl\\:order-5{order:5}[class*=b-grid-item].b-xxl\\:order-6{order:6}[class*=b-grid-item].b-xxl\\:order-7{order:7}[class*=b-grid-item].b-xxl\\:order-8{order:8}[class*=b-grid-item].b-xxl\\:order-9{order:9}[class*=b-grid-item].b-xxl\\:order-10{order:10}[class*=b-grid-item].b-xxl\\:order-11{order:11}[class*=b-grid-item].b-xxl\\:order-12{order:12}[class*=b-grid-item].b-xxl\\:order-13{order:13}[class*=b-grid-item].b-xxl\\:order-14{order:14}[class*=b-grid-item].b-xxl\\:order-15{order:15}[class*=b-grid-item].b-xxl\\:order-16{order:16}[class*=b-grid-item].b-xxl\\:order-17{order:17}[class*=b-grid-item].b-xxl\\:order-18{order:18}[class*=b-grid-item].b-xxl\\:order-19{order:19}[class*=b-grid-item].b-xxl\\:order-20{order:20}[class*=b-grid-item][class*="b-xxl:vertical-divider"]{position:relative}[class*=b-grid-item][class*="b-xxl:vertical-divider"]:after{background-color:var(--b-grid-divider-color, var(--beacon-system-color-border-2));block-size:100%;content:"";inline-size:var(--b-grid-divider-size, var(--beacon-system-width-border-mini));inset-block-start:0;inset-inline-start:calc(100% + var(--b-default-grid-gap) / 2);position:absolute;z-index:1}[class*=b-grid-item].b-xxl\\:vertical-divider--thin--neutral{--b-grid-divider-size: var(--beacon-system-width-border-mini);--b-grid-divider-color: var(--beacon-system-color-border-2)}[class*=b-grid-item].b-xxl\\:vertical-divider--thin--strong{--b-grid-divider-size: var(--beacon-system-width-border-mini);--b-grid-divider-color: var(--beacon-system-color-border-brand)}[class*=b-grid-item].b-xxl\\:vertical-divider--thick--neutral{--b-grid-divider-size: var(--beacon-system-width-border-normal);--b-grid-divider-color: var(--beacon-system-color-border-2)}[class*=b-grid-item].b-xxl\\:vertical-divider--thick--strong{--b-grid-divider-size: var(--beacon-system-width-border-normal);--b-grid-divider-color: var(--beacon-system-color-border-brand)}}@media (width >= 1920px){[class*=b-grid-item].b-xxxl\\:order-1{order:1}[class*=b-grid-item].b-xxxl\\:order-2{order:2}[class*=b-grid-item].b-xxxl\\:order-3{order:3}[class*=b-grid-item].b-xxxl\\:order-4{order:4}[class*=b-grid-item].b-xxxl\\:order-5{order:5}[class*=b-grid-item].b-xxxl\\:order-6{order:6}[class*=b-grid-item].b-xxxl\\:order-7{order:7}[class*=b-grid-item].b-xxxl\\:order-8{order:8}[class*=b-grid-item].b-xxxl\\:order-9{order:9}[class*=b-grid-item].b-xxxl\\:order-10{order:10}[class*=b-grid-item].b-xxxl\\:order-11{order:11}[class*=b-grid-item].b-xxxl\\:order-12{order:12}[class*=b-grid-item].b-xxxl\\:order-13{order:13}[class*=b-grid-item].b-xxxl\\:order-14{order:14}[class*=b-grid-item].b-xxxl\\:order-15{order:15}[class*=b-grid-item].b-xxxl\\:order-16{order:16}[class*=b-grid-item].b-xxxl\\:order-17{order:17}[class*=b-grid-item].b-xxxl\\:order-18{order:18}[class*=b-grid-item].b-xxxl\\:order-19{order:19}[class*=b-grid-item].b-xxxl\\:order-20{order:20}[class*=b-grid-item][class*="b-xxxl:vertical-divider"]{position:relative}[class*=b-grid-item][class*="b-xxxl:vertical-divider"]:after{background-color:var(--b-grid-divider-color, var(--beacon-system-color-border-2));block-size:100%;content:"";inline-size:var(--b-grid-divider-size, var(--beacon-system-width-border-mini));inset-block-start:0;inset-inline-start:calc(100% + var(--b-default-grid-gap) / 2);position:absolute;z-index:1}[class*=b-grid-item].b-xxxl\\:vertical-divider--thin--neutral{--b-grid-divider-size: var(--beacon-system-width-border-mini);--b-grid-divider-color: var(--beacon-system-color-border-2)}[class*=b-grid-item].b-xxxl\\:vertical-divider--thin--strong{--b-grid-divider-size: var(--beacon-system-width-border-mini);--b-grid-divider-color: var(--beacon-system-color-border-brand)}[class*=b-grid-item].b-xxxl\\:vertical-divider--thick--neutral{--b-grid-divider-size: var(--beacon-system-width-border-normal);--b-grid-divider-color: var(--beacon-system-color-border-2)}[class*=b-grid-item].b-xxxl\\:vertical-divider--thick--strong{--b-grid-divider-size: var(--beacon-system-width-border-normal);--b-grid-divider-color: var(--beacon-system-color-border-brand)}}@media (width < 640px){[class*=b-grid-item].b-sm-only\\:order-1{order:1}[class*=b-grid-item].b-sm-only\\:order-2{order:2}[class*=b-grid-item].b-sm-only\\:order-3{order:3}[class*=b-grid-item].b-sm-only\\:order-4{order:4}[class*=b-grid-item].b-sm-only\\:order-5{order:5}[class*=b-grid-item].b-sm-only\\:order-6{order:6}[class*=b-grid-item].b-sm-only\\:order-7{order:7}[class*=b-grid-item].b-sm-only\\:order-8{order:8}[class*=b-grid-item].b-sm-only\\:order-9{order:9}[class*=b-grid-item].b-sm-only\\:order-10{order:10}[class*=b-grid-item].b-sm-only\\:order-11{order:11}[class*=b-grid-item].b-sm-only\\:order-12{order:12}[class*=b-grid-item].b-sm-only\\:order-13{order:13}[class*=b-grid-item].b-sm-only\\:order-14{order:14}[class*=b-grid-item].b-sm-only\\:order-15{order:15}[class*=b-grid-item].b-sm-only\\:order-16{order:16}[class*=b-grid-item].b-sm-only\\:order-17{order:17}[class*=b-grid-item].b-sm-only\\:order-18{order:18}[class*=b-grid-item].b-sm-only\\:order-19{order:19}[class*=b-grid-item].b-sm-only\\:order-20{order:20}[class*=b-grid-item][class*="b-sm-only:vertical-divider"]{position:relative}[class*=b-grid-item][class*="b-sm-only:vertical-divider"]:after{background-color:var(--b-grid-divider-color, var(--beacon-system-color-border-2));block-size:100%;content:"";inline-size:var(--b-grid-divider-size, var(--beacon-system-width-border-mini));inset-block-start:0;inset-inline-start:calc(100% + var(--b-default-grid-gap) / 2);position:absolute;z-index:1}[class*=b-grid-item].b-sm-only\\:vertical-divider--thin--neutral{--b-grid-divider-size: var(--beacon-system-width-border-mini);--b-grid-divider-color: var(--beacon-system-color-border-2)}[class*=b-grid-item].b-sm-only\\:vertical-divider--thin--strong{--b-grid-divider-size: var(--beacon-system-width-border-mini);--b-grid-divider-color: var(--beacon-system-color-border-brand)}[class*=b-grid-item].b-sm-only\\:vertical-divider--thick--neutral{--b-grid-divider-size: var(--beacon-system-width-border-normal);--b-grid-divider-color: var(--beacon-system-color-border-2)}[class*=b-grid-item].b-sm-only\\:vertical-divider--thick--strong{--b-grid-divider-size: var(--beacon-system-width-border-normal);--b-grid-divider-color: var(--beacon-system-color-border-brand)}}@media (640px <= width < 960px){[class*=b-grid-item].b-md-only\\:order-1{order:1}[class*=b-grid-item].b-md-only\\:order-2{order:2}[class*=b-grid-item].b-md-only\\:order-3{order:3}[class*=b-grid-item].b-md-only\\:order-4{order:4}[class*=b-grid-item].b-md-only\\:order-5{order:5}[class*=b-grid-item].b-md-only\\:order-6{order:6}[class*=b-grid-item].b-md-only\\:order-7{order:7}[class*=b-grid-item].b-md-only\\:order-8{order:8}[class*=b-grid-item].b-md-only\\:order-9{order:9}[class*=b-grid-item].b-md-only\\:order-10{order:10}[class*=b-grid-item].b-md-only\\:order-11{order:11}[class*=b-grid-item].b-md-only\\:order-12{order:12}[class*=b-grid-item].b-md-only\\:order-13{order:13}[class*=b-grid-item].b-md-only\\:order-14{order:14}[class*=b-grid-item].b-md-only\\:order-15{order:15}[class*=b-grid-item].b-md-only\\:order-16{order:16}[class*=b-grid-item].b-md-only\\:order-17{order:17}[class*=b-grid-item].b-md-only\\:order-18{order:18}[class*=b-grid-item].b-md-only\\:order-19{order:19}[class*=b-grid-item].b-md-only\\:order-20{order:20}[class*=b-grid-item][class*="b-md-only:vertical-divider"]{position:relative}[class*=b-grid-item][class*="b-md-only:vertical-divider"]:after{background-color:var(--b-grid-divider-color, var(--beacon-system-color-border-2));block-size:100%;content:"";inline-size:var(--b-grid-divider-size, var(--beacon-system-width-border-mini));inset-block-start:0;inset-inline-start:calc(100% + var(--b-default-grid-gap) / 2);position:absolute;z-index:1}[class*=b-grid-item].b-md-only\\:vertical-divider--thin--neutral{--b-grid-divider-size: var(--beacon-system-width-border-mini);--b-grid-divider-color: var(--beacon-system-color-border-2)}[class*=b-grid-item].b-md-only\\:vertical-divider--thin--strong{--b-grid-divider-size: var(--beacon-system-width-border-mini);--b-grid-divider-color: var(--beacon-system-color-border-brand)}[class*=b-grid-item].b-md-only\\:vertical-divider--thick--neutral{--b-grid-divider-size: var(--beacon-system-width-border-normal);--b-grid-divider-color: var(--beacon-system-color-border-2)}[class*=b-grid-item].b-md-only\\:vertical-divider--thick--strong{--b-grid-divider-size: var(--beacon-system-width-border-normal);--b-grid-divider-color: var(--beacon-system-color-border-brand)}}.b-grid-item--vertical-divider--thin--neutral{--b-grid-divider-size: var(--beacon-system-width-border-mini);--b-grid-divider-color: var(--beacon-system-color-border-2)}.b-grid-item--vertical-divider--thin--strong{--b-grid-divider-size: var(--beacon-system-width-border-mini);--b-grid-divider-color: var(--beacon-system-color-border-brand)}.b-grid-item--vertical-divider--thick--neutral{--b-grid-divider-size: var(--beacon-system-width-border-normal);--b-grid-divider-color: var(--beacon-system-color-border-2)}.b-grid-item--vertical-divider--thick--strong{--b-grid-divider-size: var(--beacon-system-width-border-normal);--b-grid-divider-color: var(--beacon-system-color-border-brand)}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item]{grid-column:var(--b-grid-start, auto)/span var(--b-grid-offset-column, var(--b-grid-span, 1))}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--full-col{--b-grid-span: var(--b-default-column-count)}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item--offset]{--b-grid-offset-column: calc(var(--b-grid-offset) + var(--b-grid-offset-span));margin-inline-start:calc((100% + var(--b-default-grid-gap)) / (var(--b-grid-offset-span) + var(--b-grid-offset)) * var(--b-grid-offset))}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--1-col{--b-grid-offset-span: 1;--b-grid-span: 1}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--start-1:not([class*=b-grid-item--offset]){--b-grid-start: 1}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--offset-1{--b-grid-offset: 1}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--2-col{--b-grid-offset-span: 2;--b-grid-span: 2}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--start-2:not([class*=b-grid-item--offset]){--b-grid-start: 2}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--offset-2{--b-grid-offset: 2}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--3-col{--b-grid-offset-span: 3;--b-grid-span: 3}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--start-3:not([class*=b-grid-item--offset]){--b-grid-start: 3}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--offset-3{--b-grid-offset: 3}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--4-col{--b-grid-offset-span: 4;--b-grid-span: 4}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--start-4:not([class*=b-grid-item--offset]){--b-grid-start: 4}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--offset-4{--b-grid-offset: 4}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--5-col{--b-grid-offset-span: 5;--b-grid-span: 5}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--start-5:not([class*=b-grid-item--offset]){--b-grid-start: 5}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--offset-5{--b-grid-offset: 5}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--6-col{--b-grid-offset-span: 6;--b-grid-span: 6}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--start-6:not([class*=b-grid-item--offset]){--b-grid-start: 6}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--offset-6{--b-grid-offset: 6}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--7-col{--b-grid-offset-span: 7;--b-grid-span: 7}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--start-7:not([class*=b-grid-item--offset]){--b-grid-start: 7}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--offset-7{--b-grid-offset: 7}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--8-col{--b-grid-offset-span: 8;--b-grid-span: 8}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--start-8:not([class*=b-grid-item--offset]){--b-grid-start: 8}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--offset-8{--b-grid-offset: 8}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--9-col{--b-grid-offset-span: 9;--b-grid-span: 9}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--start-9:not([class*=b-grid-item--offset]){--b-grid-start: 9}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--offset-9{--b-grid-offset: 9}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--10-col{--b-grid-offset-span: 10;--b-grid-span: 10}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--start-10:not([class*=b-grid-item--offset]){--b-grid-start: 10}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--offset-10{--b-grid-offset: 10}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--11-col{--b-grid-offset-span: 11;--b-grid-span: 11}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--start-11:not([class*=b-grid-item--offset]){--b-grid-start: 11}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--offset-11{--b-grid-offset: 11}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--12-col{--b-grid-offset-span: 12;--b-grid-span: 12}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--start-12:not([class*=b-grid-item--offset]){--b-grid-start: 12}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--offset-12{--b-grid-offset: 12}@media (width >= 320px){:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:1-col{--b-grid-span: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:start-1{--b-grid-start: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:offset-1{--b-grid-offset: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:2-col{--b-grid-span: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:start-2{--b-grid-start: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:offset-2{--b-grid-offset: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:3-col{--b-grid-span: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:start-3{--b-grid-start: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:offset-3{--b-grid-offset: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:4-col{--b-grid-span: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:start-4{--b-grid-start: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:offset-4{--b-grid-offset: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:5-col{--b-grid-span: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:start-5{--b-grid-start: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:offset-5{--b-grid-offset: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:6-col{--b-grid-span: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:start-6{--b-grid-start: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:offset-6{--b-grid-offset: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:7-col{--b-grid-span: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:start-7{--b-grid-start: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:offset-7{--b-grid-offset: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:8-col{--b-grid-span: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:start-8{--b-grid-start: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:offset-8{--b-grid-offset: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:9-col{--b-grid-span: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:start-9{--b-grid-start: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:offset-9{--b-grid-offset: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:10-col{--b-grid-span: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:start-10{--b-grid-start: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:offset-10{--b-grid-offset: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:11-col{--b-grid-span: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:start-11{--b-grid-start: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:offset-11{--b-grid-offset: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:12-col{--b-grid-span: 12}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:start-12{--b-grid-start: 12}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:offset-12{--b-grid-offset: 12}}@media (width >= 640px){:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:1-col{--b-grid-span: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:start-1{--b-grid-start: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:offset-1{--b-grid-offset: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:2-col{--b-grid-span: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:start-2{--b-grid-start: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:offset-2{--b-grid-offset: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:3-col{--b-grid-span: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:start-3{--b-grid-start: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:offset-3{--b-grid-offset: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:4-col{--b-grid-span: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:start-4{--b-grid-start: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:offset-4{--b-grid-offset: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:5-col{--b-grid-span: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:start-5{--b-grid-start: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:offset-5{--b-grid-offset: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:6-col{--b-grid-span: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:start-6{--b-grid-start: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:offset-6{--b-grid-offset: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:7-col{--b-grid-span: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:start-7{--b-grid-start: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:offset-7{--b-grid-offset: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:8-col{--b-grid-span: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:start-8{--b-grid-start: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:offset-8{--b-grid-offset: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:9-col{--b-grid-span: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:start-9{--b-grid-start: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:offset-9{--b-grid-offset: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:10-col{--b-grid-span: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:start-10{--b-grid-start: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:offset-10{--b-grid-offset: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:11-col{--b-grid-span: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:start-11{--b-grid-start: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:offset-11{--b-grid-offset: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:12-col{--b-grid-span: 12}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:start-12{--b-grid-start: 12}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:offset-12{--b-grid-offset: 12}}@media (width >= 960px){:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:1-col{--b-grid-span: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:start-1{--b-grid-start: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:offset-1{--b-grid-offset: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:2-col{--b-grid-span: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:start-2{--b-grid-start: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:offset-2{--b-grid-offset: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:3-col{--b-grid-span: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:start-3{--b-grid-start: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:offset-3{--b-grid-offset: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:4-col{--b-grid-span: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:start-4{--b-grid-start: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:offset-4{--b-grid-offset: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:5-col{--b-grid-span: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:start-5{--b-grid-start: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:offset-5{--b-grid-offset: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:6-col{--b-grid-span: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:start-6{--b-grid-start: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:offset-6{--b-grid-offset: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:7-col{--b-grid-span: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:start-7{--b-grid-start: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:offset-7{--b-grid-offset: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:8-col{--b-grid-span: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:start-8{--b-grid-start: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:offset-8{--b-grid-offset: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:9-col{--b-grid-span: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:start-9{--b-grid-start: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:offset-9{--b-grid-offset: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:10-col{--b-grid-span: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:start-10{--b-grid-start: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:offset-10{--b-grid-offset: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:11-col{--b-grid-span: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:start-11{--b-grid-start: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:offset-11{--b-grid-offset: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:12-col{--b-grid-span: 12}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:start-12{--b-grid-start: 12}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:offset-12{--b-grid-offset: 12}}@media (width >= 1280px){:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:1-col{--b-grid-span: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:start-1{--b-grid-start: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:offset-1{--b-grid-offset: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:2-col{--b-grid-span: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:start-2{--b-grid-start: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:offset-2{--b-grid-offset: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:3-col{--b-grid-span: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:start-3{--b-grid-start: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:offset-3{--b-grid-offset: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:4-col{--b-grid-span: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:start-4{--b-grid-start: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:offset-4{--b-grid-offset: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:5-col{--b-grid-span: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:start-5{--b-grid-start: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:offset-5{--b-grid-offset: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:6-col{--b-grid-span: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:start-6{--b-grid-start: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:offset-6{--b-grid-offset: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:7-col{--b-grid-span: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:start-7{--b-grid-start: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:offset-7{--b-grid-offset: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:8-col{--b-grid-span: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:start-8{--b-grid-start: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:offset-8{--b-grid-offset: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:9-col{--b-grid-span: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:start-9{--b-grid-start: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:offset-9{--b-grid-offset: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:10-col{--b-grid-span: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:start-10{--b-grid-start: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:offset-10{--b-grid-offset: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:11-col{--b-grid-span: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:start-11{--b-grid-start: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:offset-11{--b-grid-offset: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:12-col{--b-grid-span: 12}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:start-12{--b-grid-start: 12}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:offset-12{--b-grid-offset: 12}}@media (width >= 1600px){:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:1-col{--b-grid-span: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:start-1{--b-grid-start: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:offset-1{--b-grid-offset: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:2-col{--b-grid-span: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:start-2{--b-grid-start: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:offset-2{--b-grid-offset: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:3-col{--b-grid-span: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:start-3{--b-grid-start: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:offset-3{--b-grid-offset: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:4-col{--b-grid-span: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:start-4{--b-grid-start: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:offset-4{--b-grid-offset: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:5-col{--b-grid-span: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:start-5{--b-grid-start: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:offset-5{--b-grid-offset: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:6-col{--b-grid-span: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:start-6{--b-grid-start: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:offset-6{--b-grid-offset: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:7-col{--b-grid-span: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:start-7{--b-grid-start: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:offset-7{--b-grid-offset: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:8-col{--b-grid-span: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:start-8{--b-grid-start: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:offset-8{--b-grid-offset: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:9-col{--b-grid-span: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:start-9{--b-grid-start: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:offset-9{--b-grid-offset: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:10-col{--b-grid-span: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:start-10{--b-grid-start: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:offset-10{--b-grid-offset: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:11-col{--b-grid-span: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:start-11{--b-grid-start: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:offset-11{--b-grid-offset: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:12-col{--b-grid-span: 12}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:start-12{--b-grid-start: 12}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:offset-12{--b-grid-offset: 12}}@media (width >= 1920px){:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:1-col{--b-grid-span: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:start-1{--b-grid-start: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:offset-1{--b-grid-offset: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:2-col{--b-grid-span: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:start-2{--b-grid-start: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:offset-2{--b-grid-offset: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:3-col{--b-grid-span: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:start-3{--b-grid-start: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:offset-3{--b-grid-offset: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:4-col{--b-grid-span: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:start-4{--b-grid-start: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:offset-4{--b-grid-offset: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:5-col{--b-grid-span: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:start-5{--b-grid-start: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:offset-5{--b-grid-offset: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:6-col{--b-grid-span: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:start-6{--b-grid-start: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:offset-6{--b-grid-offset: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:7-col{--b-grid-span: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:start-7{--b-grid-start: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:offset-7{--b-grid-offset: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:8-col{--b-grid-span: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:start-8{--b-grid-start: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:offset-8{--b-grid-offset: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:9-col{--b-grid-span: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:start-9{--b-grid-start: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:offset-9{--b-grid-offset: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:10-col{--b-grid-span: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:start-10{--b-grid-start: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:offset-10{--b-grid-offset: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:11-col{--b-grid-span: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:start-11{--b-grid-start: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:offset-11{--b-grid-offset: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:12-col{--b-grid-span: 12}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:start-12{--b-grid-start: 12}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:offset-12{--b-grid-offset: 12}}@media (width >= 1600px){:root{--beacon-grid-layout-space-margin: 10rem;--beacon-grid-gutter-size-inline: 2rem}}*,::slotted(*){margin:0}.zone{--fallback-grid-gap: var(--beacon-system-space-gutter);background-color:var(--zone-bg-color);padding-block:var(--beacon-system-space-organism-jumbo);padding-inline:var(--beacon-system-space-organism-maxi)}.zone--mission-and-links{--b-grid-gap: var(--footer-mission-zone-grid-gap);--zone-bg-color: var(--beacon-system-color-background-0)}.zone--disclaimer{--zone-bg-color: var(--beacon-system-color-background-1);font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-loose-100)}.brand-wrapper,.socials{--container-border: var(--beacon-system-width-border-mini) solid var(--beacon-system-color-border-0)}.brand-wrapper{border-block-end:var(--container-border)}.brand,.disclaimer,.copyright{padding-block:var(--beacon-system-space-cell-free-floating)}.disclaimer,.copyright{padding-inline-end:var(--footer-disclaimer-content-padding-inline-end)}.trademark{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-body-100);font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-caption-300);letter-spacing:var(--beacon-reference-font-letter-spacing-trademark);text-transform:uppercase}.keyline{background-color:var(--beacon-system-color-border-brand);block-size:var(--beacon-system-width-border-normal);border:0;inline-size:var(--beacon-reference-space-7);margin-block:var(--beacon-reference-space-5)}.mission{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-loose-300);color:var(--beacon-system-color-text-title);padding-block:var(--footer-mission-padding-block-start) var(--footer-mission-padding-block-end)}.links{display:flex;flex-direction:var(--links-flex-direction, column);gap:var(--footer-links-gap, 0);padding-block:var(--footer-links-padding-block)}.socials{border-block-start:var(--container-border);padding-block-start:var(--footer-socials-padding-block-start)}.hide{display:none}@media (width >= 960px){.links{--links-flex-direction: row}}`;
var TL = Object.defineProperty, Us = (i, t, e, a) => {
  for (var o = void 0, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = r(t, e, o) || o);
  return o && TL(t, e, o), o;
};
const Eb = class Eb extends Le {
  constructor() {
    super(...arguments), this.beaconTagName = Pd.beaconTagName, this.showKeyline = !1, this.hideBrandWrapper = !0, this.dataMetricsLocation = Pd.metricsLocationFooter;
  }
  static get styles() {
    return [super.styles, EL];
  }
  static get lightDOMStyles() {
    return [super.lightDOMStyles, SL, CL];
  }
  checkForSlot() {
    this.showKeyline = !!this.slottedMissionContent.length && !!this.slottedTrademark.length, this.hideBrandWrapper = !this.slottedMissionContent.length && !this.slottedTrademark.length;
  }
  render() {
    return pe`<div class="zone zone--mission-and-links">
        <div class="b-grid">
          <div
            class="brand-wrapper b-grid b-grid-item--full-col ${this.hideBrandWrapper ? "hide" : ""}">
            <div class="brand b-grid-item--full-col b-md:10-col b-lg:8-col">
              <div class="trademark">
                <slot name="trademark" @slotchange=${this.checkForSlot}></slot>
              </div>
              <hr
                class=${this.showKeyline ? "keyline" : "hide"}
                aria-hidden="true" />
              <div class="mission">
                <slot name="mission" @slotchange=${this.checkForSlot}></slot>
              </div>
            </div>
          </div>
          <div class="links b-grid-item--full-col">
            <slot name="links" ${Ue({ useParent: !0 })}></slot>
          </div>
          <div class="socials b-grid-item--full-col">
            <slot name="socials" ${Ue({ useParent: !0 })}></slot>
          </div>
        </div>
      </div>
      <div class="zone zone--disclaimer">
        <div class="b-grid">
          <div class="disclaimer b-grid-item--full-col b-md:10-col b-lg:6-col">
            <slot name="disclaimer"></slot>
          </div>
          <div
            class="copyright b-grid-item--full-col b-md:10-col b-lg:5-col b-lg:start-8">
            <slot name="copyright"></slot>
          </div>
        </div>
      </div>`;
  }
};
Eb.tagName = Pd.beaconTagName;
let rn = Eb;
Us([
  Pe({ flatten: !0, slot: "mission" })
], rn.prototype, "slottedMissionContent");
Us([
  Pe({ flatten: !0, slot: "trademark" })
], rn.prototype, "slottedTrademark");
Us([
  Se()
], rn.prototype, "showKeyline");
Us([
  Se()
], rn.prototype, "hideBrandWrapper");
Us([
  ue({ attribute: "data-metrics-location", reflect: !0 })
], rn.prototype, "dataMetricsLocation");
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
let cv = class extends Event {
  constructor(t, e, a, o) {
    super("context-request", { bubbles: !0, composed: !0 }), this.context = t, this.contextTarget = e, this.callback = a, this.subscribe = o != null ? o : !1;
  }
};
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
let ML = class {
  constructor(t, e, a, o) {
    var n;
    if (this.subscribe = !1, this.provided = !1, this.value = void 0, this.t = (r, T) => {
      this.unsubscribe && (this.unsubscribe !== T && (this.provided = !1, this.unsubscribe()), this.subscribe || this.unsubscribe()), this.value = r, this.host.requestUpdate(), this.provided && !this.subscribe || (this.provided = !0, this.callback && this.callback(r, T)), this.unsubscribe = T;
    }, this.host = t, e.context !== void 0) {
      const r = e;
      this.context = r.context, this.callback = r.callback, this.subscribe = (n = r.subscribe) != null ? n : !1;
    } else this.context = e, this.callback = a, this.subscribe = o != null ? o : !1;
    this.host.addController(this);
  }
  hostConnected() {
    this.dispatchRequest();
  }
  hostDisconnected() {
    this.unsubscribe && (this.unsubscribe(), this.unsubscribe = void 0);
  }
  dispatchRequest() {
    this.host.dispatchEvent(new cv(this.context, this.host, this.t, this.subscribe));
  }
};
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
class LL {
  get value() {
    return this.o;
  }
  set value(t) {
    this.setValue(t);
  }
  setValue(t, e = !1) {
    const a = e || !Object.is(t, this.o);
    this.o = t, a && this.updateObservers();
  }
  constructor(t) {
    this.subscriptions = /* @__PURE__ */ new Map(), this.updateObservers = () => {
      for (const [e, { disposer: a }] of this.subscriptions) e(this.o, a);
    }, t !== void 0 && (this.value = t);
  }
  addCallback(t, e, a) {
    if (!a) return void t(this.value);
    this.subscriptions.has(t) || this.subscriptions.set(t, { disposer: () => {
      this.subscriptions.delete(t);
    }, consumerHost: e });
    const { disposer: o } = this.subscriptions.get(t);
    t(this.value, o);
  }
  clearCallbacks() {
    this.subscriptions.clear();
  }
}
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
class OL extends Event {
  constructor(t, e) {
    super("context-provider", { bubbles: !0, composed: !0 }), this.context = t, this.contextTarget = e;
  }
}
class PL extends LL {
  constructor(t, e, a) {
    var o, n;
    super(e.context !== void 0 ? e.initialValue : a), this.onContextRequest = (r) => {
      var O;
      if (r.context !== this.context) return;
      const T = (O = r.contextTarget) != null ? O : r.composedPath()[0];
      T !== this.host && (r.stopPropagation(), this.addCallback(r.callback, T, r.subscribe));
    }, this.onProviderRequest = (r) => {
      var O;
      if (r.context !== this.context || ((O = r.contextTarget) != null ? O : r.composedPath()[0]) === this.host) return;
      const T = /* @__PURE__ */ new Set();
      for (const [j, { consumerHost: D }] of this.subscriptions) T.has(j) || (T.add(j), D.dispatchEvent(new cv(this.context, D, j, !0)));
      r.stopPropagation();
    }, this.host = t, e.context !== void 0 ? this.context = e.context : this.context = e, this.attachListeners(), (n = (o = this.host).addController) == null || n.call(o, this);
  }
  attachListeners() {
    this.host.addEventListener("context-request", this.onContextRequest), this.host.addEventListener("context-provider", this.onProviderRequest);
  }
  hostConnected() {
    this.host.dispatchEvent(new OL(this.context, this.host));
  }
}
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function* cg(i, t) {
  const e = typeof t == "function";
  if (i !== void 0) {
    let a = -1;
    for (const o of i) a > -1 && (yield e ? t(a) : t), a++, yield o;
  }
}
const dv = Symbol("footnotes"), dg = {
  beaconTagName: "beacon-footnote-list"
}, hg = {
  beaconTagName: "beacon-footnote"
}, zL = ve`@supports selector(:state(--customstate)){:host(:state(--inactive)){display:none}}@supports not selector(:state(--customstate)){:host([state----inactive]){display:none}}:host{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-300)}.shadow-anchor:focus-visible{border:0!important;box-shadow:none!important;outline:none!important}`;
var DL = Object.defineProperty, hv = (i, t, e, a) => {
  for (var o = void 0, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = r(t, e, o) || o);
  return o && DL(t, e, o), o;
}, fs, ft, Fr, Vn, Zl, ai, bv, pv, uv, ul, gv, mv, fv;
const ab = (ai = class extends Le {
  constructor() {
    super();
    Fe(this, ft);
    Fe(this, fs);
    Fe(this, Vn);
    this.beaconTagName = hg.beaconTagName, Ne(this, fs, new ML(this, {
      context: dv,
      subscribe: !0,
      callback: (e) => {
        Ze(this, ft, pv).call(this), Ze(this, ft, uv).call(this), Ze(this, ft, gv).call(this, this._refs);
      }
    })), Ne(this, Vn, 0), this._refs = /* @__PURE__ */ new Map(), this._internals && (this._internals.role = "listitem");
  }
  static get styles() {
    return [super.styles, zL];
  }
  get _ref() {
    return ze(this, Vn);
  }
  set _ref(e) {
    Ne(this, Vn, e), this.setState("--inactive", e === 0);
  }
  render() {
    return pe`
      <span id="shadow-anchor" class="shadow-anchor" tabindex="-1"></span>
      ${cg(
      Vo(
        Ze(this, ft, fv).call(this),
        (e) => e
      ),
      pe`, `
    )}
      <slot></slot>
      <slot name="return-text">Return to</slot>
      ${cg(
      Vo(
        Ze(this, ft, mv).call(this),
        (e) => e
      ),
      pe`, `
    )}
    `;
  }
}, fs = new WeakMap(), ft = new WeakSet(), Fr = function() {
  return ze(this, fs).value;
}, Vn = new WeakMap(), Zl = new WeakSet(), bv = function(e, a) {
  e.id || (e.id = e.hash.replace("#", "") + "_fn" + String.fromCharCode(a + 97));
}, pv = function() {
  var e;
  this._ref = [...((e = ze(this, ft, Fr)) == null ? void 0 : e.uniqueIds) || /* @__PURE__ */ new Set()].findIndex(
    (a) => a === `#${this.id}`
  ) + 1 || 0;
}, uv = function() {
  var o;
  const e = (o = ze(this, ft, Fr)) == null ? void 0 : o.sources.filter(
    (n) => n.hash === `#${this.id}`
  ), a = /* @__PURE__ */ new Map();
  e == null || e.forEach(
    (n, r) => {
      var T;
      Ze(T = ai, Zl, bv).call(T, n, r), a.set(
        n,
        String.fromCharCode(r + 97)
      );
    }
  ), this._refs = a;
}, ul = function(e) {
  var a;
  return ((a = ze(this, ft, Fr)) == null ? void 0 : a.sourceCounts.get(`#${this.id}`)) === 1 ? "" : e;
}, gv = function(e) {
  e.forEach((a, o) => {
    o.dataset.beaconFootnote || (o.innerHTML = "", o.style.setProperty("text-decoration-line", "none"), o.style.setProperty("color", "var(--beacon-system-color-text-link)"), o.addEventListener("click", (T) => {
      this.scrollIntoView(), this._shadowAnchor.focus();
    }));
    const n = Ze(this, ft, ul).call(this, a), r = `${this._ref}${n}`;
    Es(
      pe`<sup
          style="color: inherit; text-decoration: underline;"
          aria-label="Go to footnote ${r}"
          >${r}</sup
        >`,
      o
    ), o.dataset.beaconFootnote = r;
  });
}, mv = function() {
  const e = [];
  return this._refs.forEach((a, o) => {
    var O;
    const n = Ze(this, ft, ul).call(this, a), r = `${this._ref}${n}`;
    ((O = ze(this, ft, Fr)) == null ? void 0 : O.sourceHosts.get(o)) ? e.push(
      pe`<a
            href="#${o.id}"
            class="backlink"
            @click=${() => {
        o.scrollIntoView(), o.focus();
      }}>
            ${r}
          </a>`
    ) : e.push(
      pe`<a class="backlink" href="#${o.id}">${r}</a>`
    );
  }), e;
}, fv = function() {
  const e = [];
  return this._refs.forEach((a, o) => {
    const n = Ze(this, ft, ul).call(this, a);
    e.push(pe`${this._ref}${n}.`);
  }), e;
}, Fe(ai, Zl), ai.tagName = hg.beaconTagName, ai);
hv([
  Se()
], ab.prototype, "_refs");
hv([
  Ge("#shadow-anchor")
], ab.prototype, "_shadowAnchor");
let J3 = ab;
var vs, As, br, vv, ys, xs, Av;
class IL extends PL {
  constructor() {
    super(...arguments);
    Fe(this, br);
    Fe(this, vs);
    Fe(this, As, []);
    Fe(this, ys, (e) => {
      const { detail: a } = e, { source: o } = a;
      o instanceof HTMLAnchorElement ? this.sources = [...this.sources, o] : console.error(
        `Attempted to add ${o} to the Footnote List but it is not an HTMLAnchorElement.`
      );
    });
    Fe(this, xs, (e) => {
      const { detail: a } = e, { source: o } = a;
      o instanceof HTMLAnchorElement ? this.sources = this.sources.filter(
        (n) => n !== o
      ) : console.error(
        `Attempted to remove ${o} from the Footnote List but it is not an HTMLAnchorElement.`
      );
    });
  }
  get sources() {
    return ze(this, As);
  }
  set sources(e) {
    const a = e.toSorted(
      (O, j) => {
        const D = O.getBoundingClientRect(), F = j.getBoundingClientRect();
        return D.y === F.y ? D.x - F.x : D.y - F.y;
      }
    ), n = a.map(
      (O) => O.hash
    ).reduce(
      (O, j) => O.set(j, (O.get(j) || 0) + 1),
      /* @__PURE__ */ new Map()
    ), r = new Set(n.keys()), T = a.reduce(
      (O, j) => O.set(j, this.host.getClosestHost.call(j)),
      /* @__PURE__ */ new Map()
    );
    Ne(this, As, a), this.setValue(
      {
        sources: a,
        uniqueIds: r,
        sourceCounts: n,
        sourceHosts: T,
        listHost: ze(this, vs)
      },
      !0
    ), this.host.requestUpdate();
  }
  hostConnected() {
    Ze(this, br, Av).call(this), Ne(this, vs, this.host.getClosestHost.call(this.host)), window.addEventListener(
      Ee.ADD_FOOTNOTE,
      ze(this, ys)
    ), window.addEventListener(
      Ee.REMOVE_FOOTNOTE,
      ze(this, xs)
    );
  }
  hostUpdated() {
    Ze(this, br, vv).call(this);
  }
  hostDisconnected() {
    window.removeEventListener(
      Ee.ADD_FOOTNOTE,
      ze(this, ys)
    ), window.removeEventListener(
      Ee.REMOVE_FOOTNOTE,
      ze(this, xs)
    );
  }
}
vs = new WeakMap(), As = new WeakMap(), br = new WeakSet(), vv = function() {
  const a = [...this.host.querySelectorAll(
    this.host.getScopedTagName("beacon-footnote")
  )].toSorted(
    (o, n) => o._ref - n._ref
  );
  this.host.append(...a);
}, ys = new WeakMap(), xs = new WeakMap(), Av = function() {
  const e = [
    .../* @__PURE__ */ new Set([
      ...document.querySelectorAll(
        this.host.getScopedTagName("beacon-footnote")
      ),
      ...this.host.querySelectorAll(
        this.host.getScopedTagName("beacon-footnote")
      )
    ])
  ].map((o) => o.id), a = [];
  for (const o of e) {
    const n = document.querySelectorAll(
      `a[href="#${o}"]`
    );
    n && a.push(...n);
  }
  this.sources = a;
};
const BL = ve`.list{display:flex;flex-flow:column;gap:var(--beacon-component-footnote-space)}`, Tb = class Tb extends Le {
  constructor() {
    super(), this.beaconTagName = dg.beaconTagName, this._footnotes = new IL(this, {
      context: dv
    }), this._internals && (this._internals.role = "list");
  }
  static get styles() {
    return [super.styles, BL];
  }
  /**
   * Emit event signalling that a given footnote should be added to or removed from the source list.
   *
   * If your footnote source is in the shadow root of a custom element, this method is necessary for adding them to the list.
   *
   * This method is always necessary when you have a footnote that should no longer participate in the overall collection.
   *
   * @example
   * ```js
   * // Get reference to the element acting as the footnote source.
   * const myFootnote = myComponent.querySelector('a[href="#footnote"]');
   *
   * // Get reference to footnote list
   * const list = document.querySelector('beacon-footnote-list');
   *
   * // Add footnote to collection
   * list.updateFootnotes({source: myFootnote, type: "add"});
   *
   * // Remove footnote from collection
   * list.updateFootnotes({source: myFootnote, type: "remove"});
   * ```
   */
  updateFootnotes({
    source: t,
    type: e = "add"
  }) {
    Re(
      this,
      e === "remove" ? Ee.REMOVE_FOOTNOTE : Ee.ADD_FOOTNOTE,
      {
        detail: {
          source: t
        }
      }
    );
  }
  render() {
    return pe`
      <div class="list">
        <slot></slot>
      </div>
    `;
  }
};
Tb.tagName = dg.beaconTagName;
let bg = Tb;
var yv = { exports: {} };
(function(i) {
  /**
  * Highcharts JS v11.4.8 (2024-08-29)
  *
  * (c) 2009-2024 Torstein Honsi
  *
  * License: www.highcharts.com/license
  */
  (function(t) {
    i.exports ? (t.default = t, i.exports = t) : t(typeof Highcharts < "u" ? Highcharts : void 0);
  })(function(t) {
    var e = t ? t._modules : {};
    function a(o, n, r, T) {
      o.hasOwnProperty(n) || (o[n] = T.apply(null, r), typeof CustomEvent == "function" && t.win.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", { detail: { path: n, module: o[n] } })));
    }
    a(e, "Extensions/Pane/PaneComposition.js", [e["Core/Utilities.js"]], function(o) {
      let { addEvent: n, correctFloat: r, defined: T, pick: O } = o;
      function j(f) {
        let w, x = this;
        return f && x.pane.forEach((M) => {
          D(f.chartX - x.plotLeft, f.chartY - x.plotTop, M.center) && (w = M);
        }), w;
      }
      function D(f, w, x, M, p) {
        let v = !0, k = x[0], m = x[1], A = Math.sqrt(Math.pow(f - k, 2) + Math.pow(w - m, 2));
        if (T(M) && T(p)) {
          let C = Math.atan2(r(w - m, 8), r(f - k, 8));
          p !== M && (v = M > p ? C >= M && C <= Math.PI || C <= p && C >= -Math.PI : C >= M && C <= r(p, 8));
        }
        return A <= Math.ceil(x[2] / 2) && v;
      }
      function F(f) {
        this.polar && (f.options.inverted && ([f.x, f.y] = [f.y, f.x]), f.isInsidePlot = this.pane.some((w) => D(f.x, f.y, w.center, w.axis && w.axis.normalizedStartAngleRad, w.axis && w.axis.normalizedEndAngleRad)));
      }
      function B(f) {
        let w = this.chart;
        f.hoverPoint && f.hoverPoint.plotX && f.hoverPoint.plotY && w.hoverPane && !D(f.hoverPoint.plotX, f.hoverPoint.plotY, w.hoverPane.center) && (f.hoverPoint = void 0);
      }
      function N(f) {
        let w = this.chart;
        w.polar ? (w.hoverPane = w.getHoverPane(f), f.filter = function(x) {
          return x.visible && !(!f.shared && x.directTouch) && O(x.options.enableMouseTracking, !0) && (!w.hoverPane || x.xAxis.pane === w.hoverPane);
        }) : w.hoverPane = void 0;
      }
      return { compose: function(f, w) {
        let x = f.prototype;
        x.getHoverPane || (x.collectionsWithUpdate.push("pane"), x.getHoverPane = j, n(f, "afterIsInsidePlot", F), n(w, "afterGetHoverData", B), n(w, "beforeGetHoverData", N));
      } };
    }), a(e, "Extensions/Pane/PaneDefaults.js", [], function() {
      return { pane: { center: ["50%", "50%"], size: "85%", innerSize: "0%", startAngle: 0 }, background: { shape: "circle", borderRadius: 0, borderWidth: 1, borderColor: "#cccccc", backgroundColor: { linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 }, stops: [[0, "#ffffff"], [1, "#e6e6e6"]] }, from: -Number.MAX_VALUE, innerRadius: 0, to: Number.MAX_VALUE, outerRadius: "105%" } };
    }), a(e, "Extensions/Pane/Pane.js", [e["Series/CenteredUtilities.js"], e["Extensions/Pane/PaneComposition.js"], e["Extensions/Pane/PaneDefaults.js"], e["Core/Utilities.js"]], function(o, n, r, T) {
      let { extend: O, merge: j, splat: D } = T;
      class F {
        constructor(N, f) {
          this.coll = "pane", this.init(N, f);
        }
        init(N, f) {
          this.chart = f, this.background = [], f.pane.push(this), this.setOptions(N);
        }
        setOptions(N) {
          this.options = N = j(r.pane, this.chart.angular ? { background: {} } : void 0, N);
        }
        render() {
          let N = this.options, f = this.chart.renderer;
          this.group || (this.group = f.g("pane-group").attr({ zIndex: N.zIndex || 0 }).add()), this.updateCenter();
          let w = this.options.background;
          if (w) {
            let x = Math.max((w = D(w)).length, this.background.length || 0);
            for (let M = 0; M < x; M++) w[M] && this.axis ? this.renderBackground(j(r.background, w[M]), M) : this.background[M] && (this.background[M] = this.background[M].destroy(), this.background.splice(M, 1));
          }
        }
        renderBackground(N, f) {
          let w = { class: "highcharts-pane " + (N.className || "") }, x = "animate";
          this.chart.styledMode || O(w, { fill: N.backgroundColor, stroke: N.borderColor, "stroke-width": N.borderWidth }), this.background[f] || (this.background[f] = this.chart.renderer.path().add(this.group), x = "attr"), this.background[f][x]({ d: this.axis.getPlotBandPath(N.from, N.to, N) }).attr(w);
        }
        updateCenter(N) {
          this.center = (N || this.axis || {}).center = o.getCenter.call(this);
        }
        update(N, f) {
          j(!0, this.options, N), this.setOptions(this.options), this.render(), this.chart.axes.forEach(function(w) {
            w.pane === this && (w.pane = null, w.update({}, f));
          }, this);
        }
      }
      return F.compose = n.compose, F;
    }), a(e, "Series/AreaRange/AreaRangePoint.js", [e["Core/Series/SeriesRegistry.js"], e["Core/Utilities.js"]], function(o, n) {
      let { area: { prototype: { pointClass: r, pointClass: { prototype: T } } } } = o.seriesTypes, { defined: O, isNumber: j } = n;
      return class extends r {
        setState() {
          let D = this.state, F = this.series, B = F.chart.polar;
          O(this.plotHigh) || (this.plotHigh = F.yAxis.toPixels(this.high, !0)), O(this.plotLow) || (this.plotLow = this.plotY = F.yAxis.toPixels(this.low, !0)), F.lowerStateMarkerGraphic = F.stateMarkerGraphic, F.stateMarkerGraphic = F.upperStateMarkerGraphic, this.graphic = this.graphics && this.graphics[1], this.plotY = this.plotHigh, B && j(this.plotHighX) && (this.plotX = this.plotHighX), T.setState.apply(this, arguments), this.state = D, this.plotY = this.plotLow, this.graphic = this.graphics && this.graphics[0], B && j(this.plotLowX) && (this.plotX = this.plotLowX), F.upperStateMarkerGraphic = F.stateMarkerGraphic, F.stateMarkerGraphic = F.lowerStateMarkerGraphic, F.lowerStateMarkerGraphic = void 0;
          let N = F.modifyMarkerSettings();
          T.setState.apply(this, arguments), F.restoreMarkerSettings(N);
        }
        haloPath() {
          let D = this.series.chart.polar, F = [];
          return this.plotY = this.plotLow, D && j(this.plotLowX) && (this.plotX = this.plotLowX), this.isInside && (F = T.haloPath.apply(this, arguments)), this.plotY = this.plotHigh, D && j(this.plotHighX) && (this.plotX = this.plotHighX), this.isTopInside && (F = F.concat(T.haloPath.apply(this, arguments))), F;
        }
        isValid() {
          return j(this.low) && j(this.high);
        }
      };
    }), a(e, "Series/AreaRange/AreaRangeSeries.js", [e["Series/AreaRange/AreaRangePoint.js"], e["Core/Globals.js"], e["Core/Series/SeriesRegistry.js"], e["Core/Utilities.js"]], function(o, n, r, T) {
      let { noop: O } = n, { area: j, area: { prototype: D }, column: { prototype: F } } = r.seriesTypes, { addEvent: B, defined: N, extend: f, isArray: w, isNumber: x, pick: M, merge: p } = T;
      class v extends j {
        toYData(m) {
          return [m.low, m.high];
        }
        highToXY(m) {
          let A = this.chart, C = this.xAxis.postTranslate(m.rectPlotX || 0, this.yAxis.len - (m.plotHigh || 0));
          m.plotHighX = C.x - A.plotLeft, m.plotHigh = C.y - A.plotTop, m.plotLowX = m.plotX;
        }
        getGraphPath(m) {
          let A = [], C = [], H = D.getGraphPath, G = this.options, P = this.chart.polar, y = P && G.connectEnds !== !1, S = G.connectNulls, d, s, l, b = G.step;
          for (d = (m = m || this.points).length; d--; ) {
            s = m[d];
            let E = P ? { plotX: s.rectPlotX, plotY: s.yBottom, doCurve: !1 } : { plotX: s.plotX, plotY: s.plotY, doCurve: !1 };
            s.isNull || y || S || m[d + 1] && !m[d + 1].isNull || C.push(E), l = { polarPlotY: s.polarPlotY, rectPlotX: s.rectPlotX, yBottom: s.yBottom, plotX: M(s.plotHighX, s.plotX), plotY: s.plotHigh, isNull: s.isNull }, C.push(l), A.push(l), s.isNull || y || S || m[d - 1] && !m[d - 1].isNull || C.push(E);
          }
          let u = H.call(this, m);
          b && (b === !0 && (b = "left"), G.step = { left: "right", center: "center", right: "left" }[b]);
          let c = H.call(this, A), h = H.call(this, C);
          G.step = b;
          let g = [].concat(u, c);
          return !this.chart.polar && h[0] && h[0][0] === "M" && (h[0] = ["L", h[0][1], h[0][2]]), this.graphPath = g, this.areaPath = u.concat(h), g.isArea = !0, g.xMap = u.xMap, this.areaPath.xMap = u.xMap, g;
        }
        drawDataLabels() {
          var l, b;
          let m, A, C, H, G, P = this.points, y = P.length, S = [], d = this.options.dataLabels, s = this.chart.inverted;
          if (d) {
            if (w(d) ? (H = d[0] || { enabled: !1 }, G = d[1] || { enabled: !1 }) : ((H = f({}, d)).x = d.xHigh, H.y = d.yHigh, (G = f({}, d)).x = d.xLow, G.y = d.yLow), H.enabled || ((l = this.hasDataLabels) == null ? void 0 : l.call(this))) {
              for (m = y; m--; ) if (A = P[m]) {
                let { plotHigh: u = 0, plotLow: c = 0 } = A;
                C = H.inside ? u < c : u > c, A.y = A.high, A._plotY = A.plotY, A.plotY = u, S[m] = A.dataLabel, A.dataLabel = A.dataLabelUpper, A.below = C, s ? H.align || (H.align = C ? "right" : "left") : H.verticalAlign || (H.verticalAlign = C ? "top" : "bottom");
              }
              for (this.options.dataLabels = H, D.drawDataLabels && D.drawDataLabels.apply(this, arguments), m = y; m--; ) (A = P[m]) && (A.dataLabelUpper = A.dataLabel, A.dataLabel = S[m], delete A.dataLabels, A.y = A.low, A.plotY = A._plotY);
            }
            if (G.enabled || (b = this.hasDataLabels) != null && b.call(this)) {
              for (m = y; m--; ) if (A = P[m]) {
                let { plotHigh: u = 0, plotLow: c = 0 } = A;
                C = G.inside ? u < c : u > c, A.below = !C, s ? G.align || (G.align = C ? "left" : "right") : G.verticalAlign || (G.verticalAlign = C ? "bottom" : "top");
              }
              this.options.dataLabels = G, D.drawDataLabels && D.drawDataLabels.apply(this, arguments);
            }
            if (H.enabled) for (m = y; m--; ) (A = P[m]) && (A.dataLabels = [A.dataLabelUpper, A.dataLabel].filter(function(u) {
              return !!u;
            }));
            this.options.dataLabels = d;
          }
        }
        alignDataLabel() {
          F.alignDataLabel.apply(this, arguments);
        }
        modifyMarkerSettings() {
          let m = { marker: this.options.marker, symbol: this.symbol };
          if (this.options.lowMarker) {
            let { options: { marker: A, lowMarker: C } } = this;
            this.options.marker = p(A, C), C.symbol && (this.symbol = C.symbol);
          }
          return m;
        }
        restoreMarkerSettings(m) {
          this.options.marker = m.marker, this.symbol = m.symbol;
        }
        drawPoints() {
          let m, A, C = this.points.length, H = this.modifyMarkerSettings();
          for (D.drawPoints.apply(this, arguments), this.restoreMarkerSettings(H), m = 0; m < C; ) (A = this.points[m]).graphics = A.graphics || [], A.origProps = { plotY: A.plotY, plotX: A.plotX, isInside: A.isInside, negative: A.negative, zone: A.zone, y: A.y }, (A.graphic || A.graphics[0]) && (A.graphics[0] = A.graphic), A.graphic = A.graphics[1], A.plotY = A.plotHigh, N(A.plotHighX) && (A.plotX = A.plotHighX), A.y = M(A.high, A.origProps.y), A.negative = A.y < (this.options.threshold || 0), this.zones.length && (A.zone = A.getZone()), this.chart.polar || (A.isInside = A.isTopInside = A.plotY !== void 0 && A.plotY >= 0 && A.plotY <= this.yAxis.len && A.plotX >= 0 && A.plotX <= this.xAxis.len), m++;
          for (D.drawPoints.apply(this, arguments), m = 0; m < C; ) (A = this.points[m]).graphics = A.graphics || [], (A.graphic || A.graphics[1]) && (A.graphics[1] = A.graphic), A.graphic = A.graphics[0], A.origProps && (f(A, A.origProps), delete A.origProps), m++;
        }
        hasMarkerChanged(m, A) {
          let C = m.lowMarker, H = A.lowMarker || {};
          return C && (C.enabled === !1 || H.symbol !== C.symbol || H.height !== C.height || H.width !== C.width) || super.hasMarkerChanged(m, A);
        }
      }
      return v.defaultOptions = p(j.defaultOptions, { lineWidth: 1, threshold: null, tooltip: { pointFormat: '<span style="color:{series.color}">●</span> {series.name}: <b>{point.low}</b> - <b>{point.high}</b><br/>' }, trackByArea: !0, dataLabels: { align: void 0, verticalAlign: void 0, xLow: 0, xHigh: 0, yLow: 0, yHigh: 0 } }), B(v, "afterTranslate", function() {
        this.pointArrayMap.join(",") === "low,high" && this.points.forEach((k) => {
          let m = k.high, A = k.plotY;
          k.isNull ? k.plotY = void 0 : (k.plotLow = A, k.plotHigh = x(m) ? this.yAxis.translate(this.dataModify ? this.dataModify.modifyValue(m) : m, !1, !0, void 0, !0) : void 0, this.dataModify && (k.yBottom = k.plotHigh));
        });
      }, { order: 0 }), B(v, "afterTranslate", function() {
        this.points.forEach((k) => {
          if (this.chart.polar) this.highToXY(k), k.plotLow = k.plotY, k.tooltipPos = [((k.plotHighX || 0) + (k.plotLowX || 0)) / 2, ((k.plotHigh || 0) + (k.plotLow || 0)) / 2];
          else {
            let m = k.pos(!1, k.plotLow), A = k.pos(!1, k.plotHigh);
            m && A && (m[0] = (m[0] + A[0]) / 2, m[1] = (m[1] + A[1]) / 2), k.tooltipPos = m;
          }
        });
      }, { order: 3 }), f(v.prototype, { deferTranslatePolar: !0, pointArrayMap: ["low", "high"], pointClass: o, pointValKey: "low", setStackedPoints: O }), r.registerSeriesType("arearange", v), v;
    }), a(e, "Series/AreaSplineRange/AreaSplineRangeSeries.js", [e["Series/AreaRange/AreaRangeSeries.js"], e["Core/Series/SeriesRegistry.js"], e["Core/Utilities.js"]], function(o, n, r) {
      let { spline: { prototype: T } } = n.seriesTypes, { merge: O, extend: j } = r;
      class D extends o {
      }
      return D.defaultOptions = O(o.defaultOptions), j(D.prototype, { getPointSpline: T.getPointSpline }), n.registerSeriesType("areasplinerange", D), D;
    }), a(e, "Series/BoxPlot/BoxPlotSeriesDefaults.js", [], function() {
      return { threshold: null, tooltip: { pointFormat: '<span style="color:{point.color}">●</span> <b>{series.name}</b><br/>Maximum: {point.high}<br/>Upper quartile: {point.q3}<br/>Median: {point.median}<br/>Lower quartile: {point.q1}<br/>Minimum: {point.low}<br/>' }, whiskerLength: "50%", fillColor: "#ffffff", lineWidth: 1, medianWidth: 2, whiskerWidth: 2 };
    }), a(e, "Series/BoxPlot/BoxPlotSeries.js", [e["Series/BoxPlot/BoxPlotSeriesDefaults.js"], e["Series/Column/ColumnSeries.js"], e["Core/Globals.js"], e["Core/Series/SeriesRegistry.js"], e["Core/Utilities.js"]], function(o, n, r, T, O) {
      let { noop: j } = r, { crisp: D, extend: F, merge: B, pick: N } = O;
      class f extends n {
        pointAttribs() {
          return {};
        }
        translate() {
          let x = this.yAxis, M = this.pointArrayMap;
          super.translate.apply(this), this.points.forEach(function(p) {
            M.forEach(function(v) {
              p[v] !== null && (p[v + "Plot"] = x.translate(p[v], 0, 1, 0, 1));
            }), p.plotHigh = p.highPlot;
          });
        }
        drawPoints() {
          let x, M, p, v, k, m, A, C, H, G, P, y, S, d = this.points, s = this.options, l = this.chart, b = l.renderer, u = this.doQuartiles !== !1, c = this.options.whiskerLength;
          for (let h of d) {
            let g = (C = h.graphic) ? "animate" : "attr", E = h.shapeArgs, R = {}, L = {}, U = {}, V = {}, q = h.color || this.color;
            if (h.plotY !== void 0) {
              let Y;
              H = E.width, P = (G = E.x) + H, y = H / 2, x = u ? h.q1Plot : h.lowPlot, M = u ? h.q3Plot : h.lowPlot, p = h.highPlot, v = h.lowPlot, C || (h.graphic = C = b.g("point").add(this.group), h.stem = b.path().addClass("highcharts-boxplot-stem").add(C), c && (h.whiskers = b.path().addClass("highcharts-boxplot-whisker").add(C)), u && (h.box = b.path(A).addClass("highcharts-boxplot-box").add(C)), h.medianShape = b.path(m).addClass("highcharts-boxplot-median").add(C)), l.styledMode || (L.stroke = h.stemColor || s.stemColor || q, L["stroke-width"] = N(h.stemWidth, s.stemWidth, s.lineWidth), L.dashstyle = h.stemDashStyle || s.stemDashStyle || s.dashStyle, h.stem.attr(L), c && (U.stroke = h.whiskerColor || s.whiskerColor || q, U["stroke-width"] = N(h.whiskerWidth, s.whiskerWidth, s.lineWidth), U.dashstyle = h.whiskerDashStyle || s.whiskerDashStyle || s.dashStyle, h.whiskers.attr(U)), u && (R.fill = h.fillColor || s.fillColor || q, R.stroke = s.lineColor || q, R["stroke-width"] = s.lineWidth || 0, R.dashstyle = h.boxDashStyle || s.boxDashStyle || s.dashStyle, h.box.attr(R)), V.stroke = h.medianColor || s.medianColor || q, V["stroke-width"] = N(h.medianWidth, s.medianWidth, s.lineWidth), V.dashstyle = h.medianDashStyle || s.medianDashStyle || s.dashStyle, h.medianShape.attr(V));
              let I = D((h.plotX || 0) + (this.pointXOffset || 0) + (this.barW || 0) / 2, h.stem.strokeWidth());
              if (Y = [["M", I, M], ["L", I, p], ["M", I, x], ["L", I, v]], h.stem[g]({ d: Y }), u) {
                let _ = h.box.strokeWidth();
                x = D(x, _), M = D(M, _), Y = [["M", G = D(G, _), M], ["L", G, x], ["L", P = D(P, _), x], ["L", P, M], ["L", G, M], ["Z"]], h.box[g]({ d: Y });
              }
              if (c) {
                let _ = h.whiskers.strokeWidth();
                p = D(h.highPlot, _), v = D(h.lowPlot, _), Y = [["M", D(I - (S = typeof c == "string" && /%$/.test(c) ? y * parseFloat(c) / 100 : Number(c) / 2)), p], ["L", D(I + S), p], ["M", D(I - S), v], ["L", D(I + S), v]], h.whiskers[g]({ d: Y });
              }
              Y = [["M", G, k = D(h.medianPlot, h.medianShape.strokeWidth())], ["L", P, k]], h.medianShape[g]({ d: Y });
            }
          }
        }
        toYData(x) {
          return [x.low, x.q1, x.median, x.q3, x.high];
        }
      }
      return f.defaultOptions = B(n.defaultOptions, o), F(f.prototype, { pointArrayMap: ["low", "q1", "median", "q3", "high"], pointValKey: "high", drawDataLabels: j, setStackedPoints: j }), T.registerSeriesType("boxplot", f), f;
    }), a(e, "Series/Bubble/BubbleLegendDefaults.js", [], function() {
      return { borderColor: void 0, borderWidth: 2, className: void 0, color: void 0, connectorClassName: void 0, connectorColor: void 0, connectorDistance: 60, connectorWidth: 1, enabled: !1, labels: { className: void 0, allowOverlap: !1, format: "", formatter: void 0, align: "right", style: { fontSize: "0.9em", color: "#000000" }, x: 0, y: 0 }, maxSize: 60, minSize: 10, legendIndex: 0, ranges: { value: void 0, borderColor: void 0, color: void 0, connectorColor: void 0 }, sizeBy: "area", sizeByAbsoluteValue: !1, zIndex: 1, zThreshold: 0 };
    }), a(e, "Series/Bubble/BubbleLegendItem.js", [e["Core/Color/Color.js"], e["Core/Templating.js"], e["Core/Globals.js"], e["Core/Utilities.js"]], function(o, n, r, T) {
      let { parse: O } = o, { noop: j } = r, { arrayMax: D, arrayMin: F, isNumber: B, merge: N, pick: f, stableSort: w } = T;
      return class {
        constructor(x, M) {
          this.setState = j, this.init(x, M);
        }
        init(x, M) {
          this.options = x, this.visible = !0, this.chart = M.chart, this.legend = M;
        }
        addToLegend(x) {
          x.splice(this.options.legendIndex, 0, this);
        }
        drawLegendSymbol(x) {
          let M, p = f(x.options.itemDistance, 20), v = this.legendItem || {}, k = this.options, m = k.ranges, A = k.connectorDistance;
          if (!m || !m.length || !B(m[0].value)) {
            x.options.bubbleLegend.autoRanges = !0;
            return;
          }
          w(m, function(P, y) {
            return y.value - P.value;
          }), this.ranges = m, this.setOptions(), this.render();
          let C = this.getMaxLabelSize(), H = this.ranges[0].radius, G = 2 * H;
          M = (M = A - H + C.width) > 0 ? M : 0, this.maxLabel = C, this.movementX = k.labels.align === "left" ? M : 0, v.labelWidth = G + M + p, v.labelHeight = G + C.height / 2;
        }
        setOptions() {
          let x = this.ranges, M = this.options, p = this.chart.series[M.seriesIndex], v = this.legend.baseline, k = { zIndex: M.zIndex, "stroke-width": M.borderWidth }, m = { zIndex: M.zIndex, "stroke-width": M.connectorWidth }, A = { align: this.legend.options.rtl || M.labels.align === "left" ? "right" : "left", zIndex: M.zIndex }, C = p.options.marker.fillOpacity, H = this.chart.styledMode;
          x.forEach(function(G, P) {
            H || (k.stroke = f(G.borderColor, M.borderColor, p.color), k.fill = f(G.color, M.color, C !== 1 ? O(p.color).setOpacity(C).get("rgba") : p.color), m.stroke = f(G.connectorColor, M.connectorColor, p.color)), x[P].radius = this.getRangeRadius(G.value), x[P] = N(x[P], { center: x[0].radius - x[P].radius + v }), H || N(!0, x[P], { bubbleAttribs: N(k), connectorAttribs: N(m), labelAttribs: A });
          }, this);
        }
        getRangeRadius(x) {
          let M = this.options, p = this.options.seriesIndex, v = this.chart.series[p], k = M.ranges[0].value, m = M.ranges[M.ranges.length - 1].value, A = M.minSize, C = M.maxSize;
          return v.getRadius.call(this, m, k, A, C, x);
        }
        render() {
          let x = this.legendItem || {}, M = this.chart.renderer, p = this.options.zThreshold;
          for (let v of (this.symbols || (this.symbols = { connectors: [], bubbleItems: [], labels: [] }), x.symbol = M.g("bubble-legend"), x.label = M.g("bubble-legend-item").css(this.legend.itemStyle || {}), x.symbol.translateX = 0, x.symbol.translateY = 0, x.symbol.add(x.label), x.label.add(x.group), this.ranges)) v.value >= p && this.renderRange(v);
          this.hideOverlappingLabels();
        }
        renderRange(x) {
          let M = this.ranges[0], p = this.legend, v = this.options, k = v.labels, m = this.chart, A = m.series[v.seriesIndex], C = m.renderer, H = this.symbols, G = H.labels, P = x.center, y = Math.abs(x.radius), S = v.connectorDistance || 0, d = k.align, s = p.options.rtl, l = v.borderWidth, b = v.connectorWidth, u = M.radius || 0, c = P - y - l / 2 + b / 2, h = (c % 1 ? 1 : 0.5) - (b % 2 ? 0 : 0.5), g = C.styledMode, E = s || d === "left" ? -S : S;
          d === "center" && (E = 0, v.connectorDistance = 0, x.labelAttribs.align = "center"), H.bubbleItems.push(C.circle(u, P + h, y).attr(g ? {} : x.bubbleAttribs).addClass((g ? "highcharts-color-" + A.colorIndex + " " : "") + "highcharts-bubble-legend-symbol " + (v.className || "")).add(this.legendItem.symbol)), H.connectors.push(C.path(C.crispLine([["M", u, c], ["L", u + E, c]], v.connectorWidth)).attr(g ? {} : x.connectorAttribs).addClass((g ? "highcharts-color-" + this.options.seriesIndex + " " : "") + "highcharts-bubble-legend-connectors " + (v.connectorClassName || "")).add(this.legendItem.symbol));
          let R = C.text(this.formatLabel(x)).attr(g ? {} : x.labelAttribs).css(g ? {} : k.style).addClass("highcharts-bubble-legend-labels " + (v.labels.className || "")).add(this.legendItem.symbol), L = { x: u + E + v.labels.x, y: c + v.labels.y + 0.4 * R.getBBox().height };
          R.attr(L), G.push(R), R.placed = !0, R.alignAttr = L;
        }
        getMaxLabelSize() {
          let x, M;
          return this.symbols.labels.forEach(function(p) {
            M = p.getBBox(!0), x = x ? M.width > x.width ? M : x : M;
          }), x || {};
        }
        formatLabel(x) {
          let M = this.options, p = M.labels.formatter, v = M.labels.format, { numberFormatter: k } = this.chart;
          return v ? n.format(v, x) : p ? p.call(x) : k(x.value, 1);
        }
        hideOverlappingLabels() {
          let x = this.chart, M = this.options.labels.allowOverlap, p = this.symbols;
          !M && p && (x.hideOverlappingLabels(p.labels), p.labels.forEach(function(v, k) {
            v.newOpacity ? v.newOpacity !== v.oldOpacity && p.connectors[k].show() : p.connectors[k].hide();
          }));
        }
        getRanges() {
          let x = this.legend.bubbleLegend, M = x.chart.series, p = x.options.ranges, v, k, m = Number.MAX_VALUE, A = -Number.MAX_VALUE;
          return M.forEach(function(C) {
            C.isBubble && !C.ignoreSeries && (k = C.zData.filter(B)).length && (m = f(C.options.zMin, Math.min(m, Math.max(F(k), C.options.displayNegative === !1 ? C.options.zThreshold : -Number.MAX_VALUE))), A = f(C.options.zMax, Math.max(A, D(k))));
          }), v = m === A ? [{ value: A }] : [{ value: m }, { value: (m + A) / 2 }, { value: A, autoRanges: !0 }], p.length && p[0].radius && v.reverse(), v.forEach(function(C, H) {
            p && p[H] && (v[H] = N(p[H], C));
          }), v;
        }
        predictBubbleSizes() {
          let x = this.chart, M = x.legend.options, p = M.floating, v = M.layout === "horizontal", k = v ? x.legend.lastLineHeight : 0, m = x.plotSizeX, A = x.plotSizeY, C = x.series[this.options.seriesIndex], H = C.getPxExtremes(), G = Math.ceil(H.minPxSize), P = Math.ceil(H.maxPxSize), y = Math.min(A, m), S, d = C.options.maxSize;
          return p || !/%$/.test(d) ? S = P : (S = (y + k) * (d = parseFloat(d)) / 100 / (d / 100 + 1), (v && A - S >= m || !v && m - S >= A) && (S = P)), [G, Math.ceil(S)];
        }
        updateRanges(x, M) {
          let p = this.legend.options.bubbleLegend;
          p.minSize = x, p.maxSize = M, p.ranges = this.getRanges();
        }
        correctSizes() {
          let x = this.legend, M = this.chart.series[this.options.seriesIndex].getPxExtremes();
          Math.abs(Math.ceil(M.maxPxSize) - this.options.maxSize) > 1 && (this.updateRanges(this.options.minSize, M.maxPxSize), x.render());
        }
      };
    }), a(e, "Series/Bubble/BubbleLegendComposition.js", [e["Series/Bubble/BubbleLegendDefaults.js"], e["Series/Bubble/BubbleLegendItem.js"], e["Core/Defaults.js"], e["Core/Globals.js"], e["Core/Utilities.js"]], function(o, n, r, T, O) {
      let { setOptions: j } = r, { composed: D } = T, { addEvent: F, objectEach: B, pushUnique: N, wrap: f } = O;
      function w(m, A, C) {
        let H, G, P, y = this.legend, S = x(this) >= 0;
        y && y.options.enabled && y.bubbleLegend && y.options.bubbleLegend.autoRanges && S ? (H = y.bubbleLegend.options, G = y.bubbleLegend.predictBubbleSizes(), y.bubbleLegend.updateRanges(G[0], G[1]), H.placed || (y.group.placed = !1, y.allItems.forEach((d) => {
          (P = d.legendItem || {}).group && (P.group.translateY = void 0);
        })), y.render(), H.placed || (this.getMargins(), this.axes.forEach(function(d) {
          d.visible && d.render(), H.placed || (d.setScale(), d.updateNames(), B(d.ticks, function(s) {
            s.isNew = !0, s.isNewLabel = !0;
          }));
        }), this.getMargins()), H.placed = !0, m.call(this, A, C), y.bubbleLegend.correctSizes(), k(y, M(y))) : (m.call(this, A, C), y && y.options.enabled && y.bubbleLegend && (y.render(), k(y, M(y))));
      }
      function x(m) {
        let A = m.series, C = 0;
        for (; C < A.length; ) {
          if (A[C] && A[C].isBubble && A[C].visible && A[C].zData.length) return C;
          C++;
        }
        return -1;
      }
      function M(m) {
        let A = m.allItems, C = [], H = A.length, G, P, y, S = 0, d = 0;
        for (S = 0; S < H; S++) if (P = A[S].legendItem || {}, y = (A[S + 1] || {}).legendItem || {}, P.labelHeight && (A[S].itemHeight = P.labelHeight), A[S] === A[H - 1] || P.y !== y.y) {
          for (C.push({ height: 0 }), G = C[C.length - 1]; d <= S; d++) A[d].itemHeight > G.height && (G.height = A[d].itemHeight);
          G.step = S;
        }
        return C;
      }
      function p(m) {
        let A = this.bubbleLegend, C = this.options, H = C.bubbleLegend, G = x(this.chart);
        A && A.ranges && A.ranges.length && (H.ranges.length && (H.autoRanges = !!H.ranges[0].autoRanges), this.destroyItem(A)), G >= 0 && C.enabled && H.enabled && (H.seriesIndex = G, this.bubbleLegend = new n(H, this), this.bubbleLegend.addToLegend(m.allItems));
      }
      function v(m) {
        let A;
        if (m.defaultPrevented) return !1;
        let C = m.legendItem, H = this.chart, G = C.visible;
        this && this.bubbleLegend && (C.visible = !G, C.ignoreSeries = G, A = x(H) >= 0, this.bubbleLegend.visible !== A && (this.update({ bubbleLegend: { enabled: A } }), this.bubbleLegend.visible = A), C.visible = G);
      }
      function k(m, A) {
        let C = m.allItems, H = m.options.rtl, G, P, y, S, d = 0;
        C.forEach((s, l) => {
          (S = s.legendItem || {}).group && (G = S.group.translateX || 0, P = S.y || 0, ((y = s.movementX) || H && s.ranges) && (y = H ? G - s.options.maxSize / 2 : G + y, S.group.attr({ translateX: y })), l > A[d].step && d++, S.group.attr({ translateY: Math.round(P + A[d].height / 2) }), S.y = P + A[d].height / 2);
        });
      }
      return { compose: function(m, A) {
        N(D, "Series.BubbleLegend") && (j({ legend: { bubbleLegend: o } }), f(m.prototype, "drawChartBox", w), F(A, "afterGetAllItems", p), F(A, "itemClick", v));
      } };
    }), a(e, "Series/Bubble/BubblePoint.js", [e["Core/Series/Point.js"], e["Core/Series/SeriesRegistry.js"], e["Core/Utilities.js"]], function(o, n, r) {
      let { seriesTypes: { scatter: { prototype: { pointClass: T } } } } = n, { extend: O } = r;
      class j extends T {
        haloPath(F) {
          let B = (F && this.marker && this.marker.radius || 0) + F;
          if (this.series.chart.inverted) {
            let N = this.pos() || [0, 0], { xAxis: f, yAxis: w, chart: x } = this.series;
            return x.renderer.symbols.circle(f.len - N[1] - B, w.len - N[0] - B, 2 * B, 2 * B);
          }
          return o.prototype.haloPath.call(this, B);
        }
      }
      return O(j.prototype, { ttBelow: !1 }), j;
    }), a(e, "Series/Bubble/BubbleSeries.js", [e["Series/Bubble/BubbleLegendComposition.js"], e["Series/Bubble/BubblePoint.js"], e["Core/Color/Color.js"], e["Core/Globals.js"], e["Core/Series/SeriesRegistry.js"], e["Core/Utilities.js"]], function(o, n, r, T, O, j) {
      let { parse: D } = r, { composed: F, noop: B } = T, { series: N, seriesTypes: { column: { prototype: f }, scatter: w } } = O, { addEvent: x, arrayMax: M, arrayMin: p, clamp: v, extend: k, isNumber: m, merge: A, pick: C, pushUnique: H } = j;
      function G() {
        let y = this.len, { coll: S, isXAxis: d, min: s } = this, l = d ? "xData" : "yData", b = (this.max || 0) - (s || 0), u = 0, c = y, h = y / b, g;
        (S === "xAxis" || S === "yAxis") && (this.series.forEach((E) => {
          if (E.bubblePadding && E.reserveSpace()) {
            this.allowZoomOutside = !0, g = !0;
            let R = E[l];
            if (d && ((E.onPoint || E).getRadii(0, 0, E), E.onPoint && (E.radii = E.onPoint.radii)), b > 0) {
              let L = R.length;
              for (; L--; ) if (m(R[L]) && this.dataMin <= R[L] && R[L] <= this.max) {
                let U = E.radii && E.radii[L] || 0;
                u = Math.min((R[L] - s) * h - U, u), c = Math.max((R[L] - s) * h + U, c);
              }
            }
          }
        }), g && b > 0 && !this.logarithmic && (c -= y, h *= (y + Math.max(0, u) - Math.min(c, y)) / y, [["min", "userMin", u], ["max", "userMax", c]].forEach((E) => {
          C(this.options[E[0]], this[E[1]]) === void 0 && (this[E[0]] += E[2] / h);
        })));
      }
      class P extends w {
        static compose(S, d, s) {
          o.compose(d, s), H(F, "Series.Bubble") && x(S, "foundExtremes", G);
        }
        animate(S) {
          !S && this.points.length < this.options.animationLimit && this.points.forEach(function(d) {
            let { graphic: s, plotX: l = 0, plotY: b = 0 } = d;
            s && s.width && (this.hasRendered || s.attr({ x: l, y: b, width: 1, height: 1 }), s.animate(this.markerAttribs(d), this.options.animation));
          }, this);
        }
        getRadii() {
          let S = this.zData, d = this.yData, s = [], l, b, u, c = this.chart.bubbleZExtremes, { minPxSize: h, maxPxSize: g } = this.getPxExtremes();
          if (!c) {
            let E, R = Number.MAX_VALUE, L = -Number.MAX_VALUE;
            this.chart.series.forEach((U) => {
              if (U.bubblePadding && U.reserveSpace()) {
                let V = (U.onPoint || U).getZExtremes();
                V && (R = Math.min(C(R, V.zMin), V.zMin), L = Math.max(C(L, V.zMax), V.zMax), E = !0);
              }
            }), E ? (c = { zMin: R, zMax: L }, this.chart.bubbleZExtremes = c) : c = { zMin: 0, zMax: 0 };
          }
          for (b = 0, l = S.length; b < l; b++) u = S[b], s.push(this.getRadius(c.zMin, c.zMax, h, g, u, d && d[b]));
          this.radii = s;
        }
        getRadius(S, d, s, l, b, u) {
          let c = this.options, h = c.sizeBy !== "width", g = c.zThreshold, E = d - S, R = 0.5;
          if (u === null || b === null) return null;
          if (m(b)) {
            if (c.sizeByAbsoluteValue && (b = Math.abs(b - g), d = E = Math.max(d - g, Math.abs(S - g)), S = 0), b < S) return s / 2 - 1;
            E > 0 && (R = (b - S) / E);
          }
          return h && R >= 0 && (R = Math.sqrt(R)), Math.ceil(s + R * (l - s)) / 2;
        }
        hasData() {
          return !!this.processedXData.length;
        }
        markerAttribs(S, d) {
          let s = super.markerAttribs(S, d), { height: l = 0, width: b = 0 } = s;
          return this.chart.inverted ? k(s, { x: (S.plotX || 0) - b / 2, y: (S.plotY || 0) - l / 2 }) : s;
        }
        pointAttribs(S, d) {
          let s = this.options.marker.fillOpacity, l = N.prototype.pointAttribs.call(this, S, d);
          return s !== 1 && (l.fill = D(l.fill).setOpacity(s).get("rgba")), l;
        }
        translate() {
          super.translate.call(this), this.getRadii(), this.translateBubble();
        }
        translateBubble() {
          let { data: S, options: d, radii: s } = this, { minPxSize: l } = this.getPxExtremes(), b = S.length;
          for (; b--; ) {
            let u = S[b], c = s ? s[b] : 0;
            this.zoneAxis === "z" && (u.negative = (u.z || 0) < (d.zThreshold || 0)), m(c) && c >= l / 2 ? (u.marker = k(u.marker, { radius: c, width: 2 * c, height: 2 * c }), u.dlBox = { x: u.plotX - c, y: u.plotY - c, width: 2 * c, height: 2 * c }) : (u.shapeArgs = u.plotY = u.dlBox = void 0, u.isInside = !1);
          }
        }
        getPxExtremes() {
          let S = Math.min(this.chart.plotWidth, this.chart.plotHeight), d = (b) => {
            let u;
            return typeof b == "string" && (u = /%$/.test(b), b = parseInt(b, 10)), u ? S * b / 100 : b;
          }, s = d(C(this.options.minSize, 8)), l = Math.max(d(C(this.options.maxSize, "20%")), s);
          return { minPxSize: s, maxPxSize: l };
        }
        getZExtremes() {
          let S = this.options, d = (this.zData || []).filter(m);
          if (d.length) {
            let s = C(S.zMin, v(p(d), S.displayNegative === !1 ? S.zThreshold || 0 : -Number.MAX_VALUE, Number.MAX_VALUE)), l = C(S.zMax, M(d));
            if (m(s) && m(l)) return { zMin: s, zMax: l };
          }
        }
      }
      return P.defaultOptions = A(w.defaultOptions, { dataLabels: { formatter: function() {
        let { numberFormatter: y } = this.series.chart, { z: S } = this.point;
        return m(S) ? y(S, -1) : "";
      }, inside: !0, verticalAlign: "middle" }, animationLimit: 250, marker: { lineColor: null, lineWidth: 1, fillOpacity: 0.5, radius: null, states: { hover: { radiusPlus: 0 } }, symbol: "circle" }, minSize: 8, maxSize: "20%", softThreshold: !1, states: { hover: { halo: { size: 5 } } }, tooltip: { pointFormat: "({point.x}, {point.y}), Size: {point.z}" }, turboThreshold: 0, zThreshold: 0, zoneAxis: "z" }), k(P.prototype, { alignDataLabel: f.alignDataLabel, applyZones: B, bubblePadding: !0, isBubble: !0, pointArrayMap: ["y", "z"], pointClass: n, parallelArrays: ["x", "y", "z"], trackerGroups: ["group", "dataLabelsGroup"], specialGroup: "group", zoneAxis: "z" }), x(P, "updatedData", (y) => {
        delete y.target.chart.bubbleZExtremes;
      }), x(P, "remove", (y) => {
        delete y.target.chart.bubbleZExtremes;
      }), O.registerSeriesType("bubble", P), P;
    }), a(e, "Series/ColumnRange/ColumnRangePoint.js", [e["Core/Series/SeriesRegistry.js"], e["Core/Utilities.js"]], function(o, n) {
      let { seriesTypes: { column: { prototype: { pointClass: { prototype: r } } }, arearange: { prototype: { pointClass: T } } } } = o, { extend: O, isNumber: j } = n;
      class D extends T {
        isValid() {
          return j(this.low);
        }
      }
      return O(D.prototype, { setState: r.setState }), D;
    }), a(e, "Series/ColumnRange/ColumnRangeSeries.js", [e["Series/ColumnRange/ColumnRangePoint.js"], e["Core/Globals.js"], e["Core/Series/SeriesRegistry.js"], e["Core/Utilities.js"]], function(o, n, r, T) {
      let { noop: O } = n, { seriesTypes: { arearange: j, column: D, column: { prototype: F } } } = r, { addEvent: B, clamp: N, extend: f, isNumber: w, merge: x, pick: M } = T;
      class p extends j {
        setOptions() {
          return x(!0, arguments[0], { stacking: void 0 }), j.prototype.setOptions.apply(this, arguments);
        }
        translate() {
          return F.translate.apply(this);
        }
        pointAttribs() {
          return F.pointAttribs.apply(this, arguments);
        }
        translate3dPoints() {
          return F.translate3dPoints.apply(this, arguments);
        }
        translate3dShapes() {
          return F.translate3dShapes.apply(this, arguments);
        }
        afterColumnTranslate() {
          let k, m, A, C, H = this.yAxis, G = this.xAxis, P = G.startAngleRad, y = this.chart, S = this.xAxis.isRadial, d = Math.max(y.chartWidth, y.chartHeight) + 999;
          this.points.forEach((s) => {
            let l = s.shapeArgs || {}, b = this.options.minPointLength, u = s.plotY, c = H.translate(s.high, 0, 1, 0, 1);
            if (w(c) && w(u))
              if (s.plotHigh = N(c, -d, d), s.plotLow = N(u, -d, d), C = s.plotHigh, Math.abs(k = M(s.rectPlotY, s.plotY) - s.plotHigh) < b ? (m = b - k, k += m, C -= m / 2) : k < 0 && (k *= -1, C -= k), S && this.polar) A = s.barX + P, s.shapeType = "arc", s.shapeArgs = this.polar.arc(C + k, C, A, A + s.pointWidth);
              else {
                l.height = k, l.y = C;
                let { x: h = 0, width: g = 0 } = l;
                s.shapeArgs = x(s.shapeArgs, this.crispCol(h, C, g, k)), s.tooltipPos = y.inverted ? [H.len + H.pos - y.plotLeft - C - k / 2, G.len + G.pos - y.plotTop - h - g / 2, k] : [G.left - y.plotLeft + h + g / 2, H.pos - y.plotTop + C + k / 2, k];
              }
          });
        }
      }
      return p.defaultOptions = x(D.defaultOptions, j.defaultOptions, { borderRadius: { where: "all" }, pointRange: null, legendSymbol: "rectangle", marker: null, states: { hover: { halo: !1 } } }), B(p, "afterColumnTranslate", function() {
        p.prototype.afterColumnTranslate.apply(this);
      }, { order: 5 }), f(p.prototype, { directTouch: !0, pointClass: o, trackerGroups: ["group", "dataLabelsGroup"], adjustForMissingColumns: F.adjustForMissingColumns, animate: F.animate, crispCol: F.crispCol, drawGraph: O, drawPoints: F.drawPoints, getSymbol: O, drawTracker: F.drawTracker, getColumnMetrics: F.getColumnMetrics }), r.registerSeriesType("columnrange", p), p;
    }), a(e, "Series/ColumnPyramid/ColumnPyramidSeriesDefaults.js", [], function() {
      return {};
    }), a(e, "Series/ColumnPyramid/ColumnPyramidSeries.js", [e["Series/ColumnPyramid/ColumnPyramidSeriesDefaults.js"], e["Core/Series/SeriesRegistry.js"], e["Core/Utilities.js"]], function(o, n, r) {
      let { column: T } = n.seriesTypes, { clamp: O, merge: j, pick: D } = r;
      class F extends T {
        translate() {
          let N = this.chart, f = this.options, w = this.dense = this.closestPointRange * this.xAxis.transA < 2, x = this.borderWidth = D(f.borderWidth, w ? 0 : 1), M = this.yAxis, p = f.threshold, v = D(f.minPointLength, 5), k = this.getColumnMetrics(), m = k.width, A = this.pointXOffset = k.offset, C = this.translatedThreshold = M.getThreshold(p), H = this.barW = Math.max(m, 1 + 2 * x);
          for (let G of (N.inverted && (C -= 0.5), f.pointPadding && (H = Math.ceil(H)), super.translate(), this.points)) {
            let P = D(G.yBottom, C), y = 999 + Math.abs(P), S = O(G.plotY, -y, M.len + y), d = H / 2, s = Math.min(S, P), l = Math.max(S, P) - s, b = G.plotX + A, u, c, h, g, E, R, L, U, V, q, Y;
            f.centerInCategory && (b = this.adjustForMissingColumns(b, m, G, k)), G.barX = b, G.pointWidth = m, G.tooltipPos = N.inverted ? [M.len + M.pos - N.plotLeft - S, this.xAxis.len - b - d, l] : [b + d, S + M.pos - N.plotTop, l], u = p + (G.total || G.y), f.stacking === "percent" && (u = p + (G.y < 0) ? -100 : 100);
            let I = M.toPixels(u, !0);
            h = (c = N.plotHeight - I - (N.plotHeight - C)) ? d * (s - I) / c : 0, g = c ? d * (s + l - I) / c : 0, R = b - h + d, L = b + h + d, U = b + g + d, V = b - g + d, q = s - v, Y = s + l, G.y < 0 && (q = s, Y = s + l + v), N.inverted && (E = M.width - s, c = I - (M.width - C), h = d * (I - E) / c, g = d * (I - (E - l)) / c, L = (R = b + d + h) - 2 * h, U = b - g + d, V = b + g + d, q = s, Y = s + l - v, G.y < 0 && (Y = s + l + v)), G.shapeType = "path", G.shapeArgs = { x: R, y: q, width: L - R, height: l, d: [["M", R, q], ["L", L, q], ["L", U, Y], ["L", V, Y], ["Z"]] };
          }
        }
      }
      return F.defaultOptions = j(T.defaultOptions, o), n.registerSeriesType("columnpyramid", F), F;
    }), a(e, "Series/ErrorBar/ErrorBarSeriesDefaults.js", [], function() {
      return { color: "#000000", grouping: !1, linkedTo: ":previous", tooltip: { pointFormat: '<span style="color:{point.color}">●</span> {series.name}: <b>{point.low}</b> - <b>{point.high}</b><br/>' }, whiskerWidth: null };
    }), a(e, "Series/ErrorBar/ErrorBarSeries.js", [e["Series/BoxPlot/BoxPlotSeries.js"], e["Series/Column/ColumnSeries.js"], e["Series/ErrorBar/ErrorBarSeriesDefaults.js"], e["Core/Series/SeriesRegistry.js"], e["Core/Utilities.js"]], function(o, n, r, T, O) {
      let { arearange: j } = T.seriesTypes, { addEvent: D, merge: F, extend: B } = O;
      class N extends o {
        getColumnMetrics() {
          return this.linkedParent && this.linkedParent.columnMetrics || n.prototype.getColumnMetrics.call(this);
        }
        drawDataLabels() {
          let w = this.pointValKey;
          if (j) for (let x of (j.prototype.drawDataLabels.call(this), this.points)) x.y = x[w];
        }
        toYData(w) {
          return [w.low, w.high];
        }
      }
      return N.defaultOptions = F(o.defaultOptions, r), D(N, "afterTranslate", function() {
        for (let f of this.points) f.plotLow = f.plotY;
      }, { order: 0 }), B(N.prototype, { pointArrayMap: ["low", "high"], pointValKey: "high", doQuartiles: !1 }), T.registerSeriesType("errorbar", N), N;
    }), a(e, "Series/Gauge/GaugePoint.js", [e["Core/Series/SeriesRegistry.js"]], function(o) {
      let { series: { prototype: { pointClass: n } } } = o;
      return class extends n {
        setState(r) {
          this.state = r;
        }
      };
    }), a(e, "Series/Gauge/GaugeSeries.js", [e["Series/Gauge/GaugePoint.js"], e["Core/Globals.js"], e["Core/Series/SeriesRegistry.js"], e["Core/Utilities.js"]], function(o, n, r, T) {
      let { noop: O } = n, { series: j, seriesTypes: { column: D } } = r, { clamp: F, isNumber: B, extend: N, merge: f, pick: w, pInt: x, defined: M } = T;
      class p extends j {
        translate() {
          let k = this.yAxis, m = this.options, A = k.center;
          this.generatePoints(), this.points.forEach((C) => {
            let H = f(m.dial, C.dial), G = x(H.radius) * A[2] / 200, P = x(H.baseLength) * G / 100, y = x(H.rearLength) * G / 100, S = H.baseWidth, d = H.topWidth, s = m.overshoot, l = k.startAngleRad + k.translate(C.y, void 0, void 0, void 0, !0);
            (B(s) || m.wrap === !1) && (s = B(s) ? s / 180 * Math.PI : 0, l = F(l, k.startAngleRad - s, k.endAngleRad + s)), l = 180 * l / Math.PI, C.shapeType = "path";
            let b = H.path || [["M", -y, -S / 2], ["L", P, -S / 2], ["L", G, -d / 2], ["L", G, d / 2], ["L", P, S / 2], ["L", -y, S / 2], ["Z"]];
            C.shapeArgs = { d: b, translateX: A[0], translateY: A[1], rotation: l }, C.plotX = A[0], C.plotY = A[1], M(C.y) && k.max - k.min && (C.percentage = (C.y - k.min) / (k.max - k.min) * 100);
          });
        }
        drawPoints() {
          let k = this, m = k.chart, A = k.yAxis.center, C = k.pivot, H = k.options, G = H.pivot, P = m.renderer;
          k.points.forEach((y) => {
            let S = y.graphic, d = y.shapeArgs, s = d.d, l = f(H.dial, y.dial);
            S ? (S.animate(d), d.d = s) : y.graphic = P[y.shapeType](d).addClass("highcharts-dial").add(k.group), m.styledMode || y.graphic[S ? "animate" : "attr"]({ stroke: l.borderColor, "stroke-width": l.borderWidth, fill: l.backgroundColor });
          }), C ? C.animate({ translateX: A[0], translateY: A[1] }) : G && (k.pivot = P.circle(0, 0, G.radius).attr({ zIndex: 2 }).addClass("highcharts-pivot").translate(A[0], A[1]).add(k.group), m.styledMode || k.pivot.attr({ fill: G.backgroundColor, stroke: G.borderColor, "stroke-width": G.borderWidth }));
        }
        animate(k) {
          let m = this;
          k || m.points.forEach((A) => {
            let C = A.graphic;
            C && (C.attr({ rotation: 180 * m.yAxis.startAngleRad / Math.PI }), C.animate({ rotation: A.shapeArgs.rotation }, m.options.animation));
          });
        }
        render() {
          this.group = this.plotGroup("group", "series", this.visible ? "inherit" : "hidden", this.options.zIndex, this.chart.seriesGroup), j.prototype.render.call(this), this.group.clip(this.chart.clipRect);
        }
        setData(k, m) {
          j.prototype.setData.call(this, k, !1), this.processData(), this.generatePoints(), w(m, !0) && this.chart.redraw();
        }
        hasData() {
          return !!this.points.length;
        }
      }
      return p.defaultOptions = f(j.defaultOptions, { dataLabels: { borderColor: "#cccccc", borderRadius: 3, borderWidth: 1, crop: !1, defer: !1, enabled: !0, verticalAlign: "top", y: 15, zIndex: 2 }, dial: { backgroundColor: "#000000", baseLength: "70%", baseWidth: 3, borderColor: "#cccccc", borderWidth: 0, radius: "80%", rearLength: "10%", topWidth: 1 }, pivot: { radius: 5, borderWidth: 0, borderColor: "#cccccc", backgroundColor: "#000000" }, tooltip: { headerFormat: "" }, showInLegend: !1 }), N(p.prototype, { angular: !0, directTouch: !0, drawGraph: O, drawTracker: D.prototype.drawTracker, fixedBox: !0, forceDL: !0, noSharedTooltip: !0, pointClass: o, trackerGroups: ["group", "dataLabelsGroup"] }), r.registerSeriesType("gauge", p), p;
    }), a(e, "Series/DragNodesComposition.js", [e["Core/Globals.js"], e["Core/Utilities.js"]], function(o, n) {
      let { composed: r } = o, { addEvent: T, pushUnique: O } = n;
      function j() {
        let D, F, B, N = this;
        N.container && (D = T(N.container, "mousedown", (f) => {
          let w = N.hoverPoint;
          w && w.series && w.series.hasDraggableNodes && w.series.options.draggable && (w.series.onMouseDown(w, f), F = T(N.container, "mousemove", (x) => w && w.series && w.series.onMouseMove(w, x)), B = T(N.container.ownerDocument, "mouseup", (x) => (F(), B(), w && w.series && w.series.onMouseUp(w, x))));
        })), T(N, "destroy", function() {
          D();
        });
      }
      return { compose: function(D) {
        O(r, "DragNodes") && T(D, "load", j);
      }, onMouseDown: function(D, F) {
        var N;
        let B = ((N = this.chart.pointer) == null ? void 0 : N.normalize(F)) || F;
        D.fixedPosition = { chartX: B.chartX, chartY: B.chartY, plotX: D.plotX, plotY: D.plotY }, D.inDragMode = !0;
      }, onMouseMove: function(D, F) {
        var B;
        if (D.fixedPosition && D.inDragMode) {
          let N, f, w = this.chart, x = ((B = w.pointer) == null ? void 0 : B.normalize(F)) || F, M = D.fixedPosition.chartX - x.chartX, p = D.fixedPosition.chartY - x.chartY, v = w.graphLayoutsLookup;
          (Math.abs(M) > 5 || Math.abs(p) > 5) && (N = D.fixedPosition.plotX - M, f = D.fixedPosition.plotY - p, w.isInsidePlot(N, f) && (D.plotX = N, D.plotY = f, D.hasDragged = !0, this.redrawHalo(D), v.forEach((k) => {
            k.restartSimulation();
          })));
        }
      }, onMouseUp: function(D) {
        D.fixedPosition && (D.hasDragged && (this.layout.enableSimulation ? this.layout.start() : this.chart.redraw()), D.inDragMode = D.hasDragged = !1, this.options.fixedDraggable || delete D.fixedPosition);
      }, redrawHalo: function(D) {
        D && this.halo && this.halo.attr({ d: D.haloPath(this.options.states.hover.halo.size) });
      } };
    }), a(e, "Series/GraphLayoutComposition.js", [e["Core/Animation/AnimationUtilities.js"], e["Core/Globals.js"], e["Core/Utilities.js"]], function(o, n, r) {
      let { setAnimation: T } = o, { composed: O } = n, { addEvent: j, pushUnique: D } = r;
      function F() {
        this.graphLayoutsLookup && (this.graphLayoutsLookup.forEach((w) => {
          w.updateSimulation();
        }), this.redraw());
      }
      function B() {
        this.graphLayoutsLookup && (this.graphLayoutsLookup.forEach((w) => {
          w.updateSimulation(!1);
        }), this.redraw());
      }
      function N() {
        this.graphLayoutsLookup && this.graphLayoutsLookup.forEach((w) => {
          w.stop();
        });
      }
      function f() {
        let w, x = !1, M = (p) => {
          p.maxIterations-- && isFinite(p.temperature) && !p.isStable() && !p.enableSimulation && (p.beforeStep && p.beforeStep(), p.step(), w = !1, x = !0);
        };
        if (this.graphLayoutsLookup) {
          for (T(!1, this), this.graphLayoutsLookup.forEach((p) => p.start()); !w; ) w = !0, this.graphLayoutsLookup.forEach(M);
          x && this.series.forEach((p) => {
            p && p.layout && p.render();
          });
        }
      }
      return { compose: function(w) {
        D(O, "GraphLayout") && (j(w, "afterPrint", F), j(w, "beforePrint", B), j(w, "predraw", N), j(w, "render", f));
      }, integrations: {}, layouts: {} };
    }), a(e, "Series/PackedBubble/PackedBubblePoint.js", [e["Core/Chart/Chart.js"], e["Core/Series/Point.js"], e["Core/Series/SeriesRegistry.js"]], function(o, n, r) {
      let { seriesTypes: { bubble: { prototype: { pointClass: T } } } } = r;
      return class extends T {
        destroy() {
          var O;
          return (O = this.series) != null && O.layout && this.series.layout.removeElementFromCollection(this, this.series.layout.nodes), n.prototype.destroy.apply(this, arguments);
        }
        firePointEvent() {
          let O = this.series.options;
          if (this.isParentNode && O.parentNode) {
            let j = O.allowPointSelect;
            O.allowPointSelect = O.parentNode.allowPointSelect, n.prototype.firePointEvent.apply(this, arguments), O.allowPointSelect = j;
          } else n.prototype.firePointEvent.apply(this, arguments);
        }
        select() {
          let O = this.series.chart;
          this.isParentNode ? (O.getSelectedPoints = O.getSelectedParentNodes, n.prototype.select.apply(this, arguments), O.getSelectedPoints = o.prototype.getSelectedPoints) : n.prototype.select.apply(this, arguments);
        }
      };
    }), a(e, "Series/PackedBubble/PackedBubbleSeriesDefaults.js", [e["Core/Utilities.js"]], function(o) {
      let { isNumber: n } = o;
      return { minSize: "10%", maxSize: "50%", sizeBy: "area", zoneAxis: "y", crisp: !1, tooltip: { pointFormat: "Value: {point.value}" }, draggable: !0, useSimulation: !0, parentNode: { allowPointSelect: !1 }, dataLabels: { formatter: function() {
        let { numberFormatter: r } = this.series.chart, { value: T } = this.point;
        return n(T) ? r(T, -1) : "";
      }, parentNodeFormatter: function() {
        return this.name;
      }, parentNodeTextPath: { enabled: !0 }, padding: 0, style: { transition: "opacity 2000ms" } }, layoutAlgorithm: { initialPositions: "circle", initialPositionRadius: 20, bubblePadding: 5, parentNodeLimit: !1, seriesInteraction: !0, dragBetweenSeries: !1, parentNodeOptions: { maxIterations: 400, gravitationalConstant: 0.03, maxSpeed: 50, initialPositionRadius: 100, seriesInteraction: !0, marker: { fillColor: null, fillOpacity: 1, lineWidth: null, lineColor: null, symbol: "circle" } }, enableSimulation: !0, type: "packedbubble", integration: "packedbubble", maxIterations: 1e3, splitSeries: !1, maxSpeed: 5, gravitationalConstant: 0.01, friction: -0.981 } };
    }), a(e, "Series/Networkgraph/VerletIntegration.js", [], function() {
      return { attractive: function(o, n, r) {
        let T = o.getMass(), O = -r.x * n * this.diffTemperature, j = -r.y * n * this.diffTemperature;
        o.fromNode.fixedPosition || (o.fromNode.plotX -= O * T.fromNode / o.fromNode.degree, o.fromNode.plotY -= j * T.fromNode / o.fromNode.degree), o.toNode.fixedPosition || (o.toNode.plotX += O * T.toNode / o.toNode.degree, o.toNode.plotY += j * T.toNode / o.toNode.degree);
      }, attractiveForceFunction: function(o, n) {
        return (n - o) / o;
      }, barycenter: function() {
        let o = this.options.gravitationalConstant || 0, n = (this.barycenter.xFactor - (this.box.left + this.box.width) / 2) * o, r = (this.barycenter.yFactor - (this.box.top + this.box.height) / 2) * o;
        this.nodes.forEach(function(T) {
          T.fixedPosition || (T.plotX -= n / T.mass / T.degree, T.plotY -= r / T.mass / T.degree);
        });
      }, getK: function(o) {
        return Math.pow(o.box.width * o.box.height / o.nodes.length, 0.5);
      }, integrate: function(o, n) {
        let r = -o.options.friction, T = o.options.maxSpeed, O = n.prevX, j = n.prevY, D = (n.plotX + n.dispX - O) * r, F = (n.plotY + n.dispY - j) * r, B = Math.abs, N = B(D) / (D || 1), f = B(F) / (F || 1), w = N * Math.min(T, Math.abs(D)), x = f * Math.min(T, Math.abs(F));
        n.prevX = n.plotX + n.dispX, n.prevY = n.plotY + n.dispY, n.plotX += w, n.plotY += x, n.temperature = o.vectorLength({ x: w, y: x });
      }, repulsive: function(o, n, r) {
        let T = n * this.diffTemperature / o.mass / o.degree;
        o.fixedPosition || (o.plotX += r.x * T, o.plotY += r.y * T);
      }, repulsiveForceFunction: function(o, n) {
        return (n - o) / o * (n > o ? 1 : 0);
      } };
    }), a(e, "Series/PackedBubble/PackedBubbleIntegration.js", [e["Core/Globals.js"], e["Series/Networkgraph/VerletIntegration.js"]], function(o, n) {
      let { noop: r } = o;
      return { barycenter: function() {
        let T, O, j = this.options.gravitationalConstant, D = this.box, F = this.nodes;
        for (let B of F) this.options.splitSeries && !B.isParentNode ? (T = B.series.parentNode.plotX, O = B.series.parentNode.plotY) : (T = D.width / 2, O = D.height / 2), B.fixedPosition || (B.plotX -= (B.plotX - T) * j / (B.mass * Math.sqrt(F.length)), B.plotY -= (B.plotY - O) * j / (B.mass * Math.sqrt(F.length)));
      }, getK: r, integrate: n.integrate, repulsive: function(T, O, j, D) {
        let F = O * this.diffTemperature / T.mass / T.degree, B = j.x * F, N = j.y * F;
        T.fixedPosition || (T.plotX += B, T.plotY += N), D.fixedPosition || (D.plotX -= B, D.plotY -= N);
      }, repulsiveForceFunction: function(T, O, j, D) {
        return Math.min(T, (j.marker.radius + D.marker.radius) / 2);
      } };
    }), a(e, "Series/Networkgraph/EulerIntegration.js", [], function() {
      return { attractive: function(o, n, r, T) {
        let O = o.getMass(), j = r.x / T * n, D = r.y / T * n;
        o.fromNode.fixedPosition || (o.fromNode.dispX -= j * O.fromNode / o.fromNode.degree, o.fromNode.dispY -= D * O.fromNode / o.fromNode.degree), o.toNode.fixedPosition || (o.toNode.dispX += j * O.toNode / o.toNode.degree, o.toNode.dispY += D * O.toNode / o.toNode.degree);
      }, attractiveForceFunction: function(o, n) {
        return o * o / n;
      }, barycenter: function() {
        let o = this.options.gravitationalConstant, n = this.barycenter.xFactor, r = this.barycenter.yFactor;
        this.nodes.forEach(function(T) {
          if (!T.fixedPosition) {
            let O = T.getDegree(), j = O * (1 + O / 2);
            T.dispX += (n - T.plotX) * o * j / T.degree, T.dispY += (r - T.plotY) * o * j / T.degree;
          }
        });
      }, getK: function(o) {
        return Math.pow(o.box.width * o.box.height / o.nodes.length, 0.3);
      }, integrate: function(o, n) {
        n.dispX += n.dispX * o.options.friction, n.dispY += n.dispY * o.options.friction;
        let r = n.temperature = o.vectorLength({ x: n.dispX, y: n.dispY });
        r !== 0 && (n.plotX += n.dispX / r * Math.min(Math.abs(n.dispX), o.temperature), n.plotY += n.dispY / r * Math.min(Math.abs(n.dispY), o.temperature));
      }, repulsive: function(o, n, r, T) {
        o.dispX += r.x / T * n / o.degree, o.dispY += r.y / T * n / o.degree;
      }, repulsiveForceFunction: function(o, n) {
        return n * n / o;
      } };
    }), a(e, "Series/Networkgraph/QuadTreeNode.js", [], function() {
      class o {
        constructor(r) {
          this.body = !1, this.isEmpty = !1, this.isInternal = !1, this.nodes = [], this.box = r, this.boxSize = Math.min(r.width, r.height);
        }
        divideBox() {
          let r = this.box.width / 2, T = this.box.height / 2;
          this.nodes[0] = new o({ left: this.box.left, top: this.box.top, width: r, height: T }), this.nodes[1] = new o({ left: this.box.left + r, top: this.box.top, width: r, height: T }), this.nodes[2] = new o({ left: this.box.left + r, top: this.box.top + T, width: r, height: T }), this.nodes[3] = new o({ left: this.box.left, top: this.box.top + T, width: r, height: T });
        }
        getBoxPosition(r) {
          let T = r.plotX < this.box.left + this.box.width / 2, O = r.plotY < this.box.top + this.box.height / 2;
          return T ? O ? 0 : 3 : O ? 1 : 2;
        }
        insert(r, T) {
          let O;
          this.isInternal ? this.nodes[this.getBoxPosition(r)].insert(r, T - 1) : (this.isEmpty = !1, this.body ? T ? (this.isInternal = !0, this.divideBox(), this.body !== !0 && (this.nodes[this.getBoxPosition(this.body)].insert(this.body, T - 1), this.body = !0), this.nodes[this.getBoxPosition(r)].insert(r, T - 1)) : ((O = new o({ top: r.plotX || NaN, left: r.plotY || NaN, width: 0.1, height: 0.1 })).body = r, O.isInternal = !1, this.nodes.push(O)) : (this.isInternal = !1, this.body = r));
        }
        updateMassAndCenter() {
          let r = 0, T = 0, O = 0;
          if (this.isInternal) {
            for (let j of this.nodes) j.isEmpty || (r += j.mass, T += j.plotX * j.mass, O += j.plotY * j.mass);
            T /= r, O /= r;
          } else this.body && (r = this.body.mass, T = this.body.plotX, O = this.body.plotY);
          this.mass = r, this.plotX = T, this.plotY = O;
        }
      }
      return o;
    }), a(e, "Series/Networkgraph/QuadTree.js", [e["Series/Networkgraph/QuadTreeNode.js"]], function(o) {
      return class {
        constructor(n, r, T, O) {
          this.box = { left: n, top: r, width: T, height: O }, this.maxDepth = 25, this.root = new o(this.box), this.root.isInternal = !0, this.root.isRoot = !0, this.root.divideBox();
        }
        calculateMassAndCenter() {
          this.visitNodeRecursive(null, null, function(n) {
            n.updateMassAndCenter();
          });
        }
        insertNodes(n) {
          for (let r of n) this.root.insert(r, this.maxDepth);
        }
        visitNodeRecursive(n, r, T) {
          let O;
          if (n || (n = this.root), n === this.root && r && (O = r(n)), O !== !1) {
            for (let j of n.nodes) {
              if (j.isInternal) {
                if (r && (O = r(j)), O === !1) continue;
                this.visitNodeRecursive(j, r, T);
              } else j.body && r && r(j.body);
              T && T(j);
            }
            n === this.root && T && T(n);
          }
        }
      };
    }), a(e, "Series/Networkgraph/ReingoldFruchtermanLayout.js", [e["Series/Networkgraph/EulerIntegration.js"], e["Core/Globals.js"], e["Series/GraphLayoutComposition.js"], e["Series/Networkgraph/QuadTree.js"], e["Core/Utilities.js"], e["Series/Networkgraph/VerletIntegration.js"]], function(o, n, r, T, O, j) {
      let { win: D } = n, { clamp: F, defined: B, isFunction: N, fireEvent: f, pick: w } = O;
      class x {
        constructor() {
          this.box = {}, this.currentStep = 0, this.initialRendering = !0, this.links = [], this.nodes = [], this.series = [], this.simulation = !1;
        }
        static compose(p) {
          r.compose(p), r.integrations.euler = o, r.integrations.verlet = j, r.layouts["reingold-fruchterman"] = x;
        }
        init(p) {
          this.options = p, this.nodes = [], this.links = [], this.series = [], this.box = { x: 0, y: 0, width: 0, height: 0 }, this.setInitialRendering(!0), this.integration = r.integrations[p.integration], this.enableSimulation = p.enableSimulation, this.attractiveForce = w(p.attractiveForce, this.integration.attractiveForceFunction), this.repulsiveForce = w(p.repulsiveForce, this.integration.repulsiveForceFunction), this.approximation = p.approximation;
        }
        updateSimulation(p) {
          this.enableSimulation = w(p, this.options.enableSimulation);
        }
        start() {
          let p = this.series, v = this.options;
          this.currentStep = 0, this.forces = p[0] && p[0].forces || [], this.chart = p[0] && p[0].chart, this.initialRendering && (this.initPositions(), p.forEach(function(k) {
            k.finishedAnimating = !0, k.render();
          })), this.setK(), this.resetSimulation(v), this.enableSimulation && this.step();
        }
        step() {
          let p = this.series;
          for (let v of (this.currentStep++, this.approximation === "barnes-hut" && (this.createQuadTree(), this.quadTree.calculateMassAndCenter()), this.forces || [])) this[v + "Forces"](this.temperature);
          if (this.applyLimits(), this.temperature = this.coolDown(this.startTemperature, this.diffTemperature, this.currentStep), this.prevSystemTemperature = this.systemTemperature, this.systemTemperature = this.getSystemTemperature(), this.enableSimulation) {
            for (let v of p) v.chart && v.render();
            this.maxIterations-- && isFinite(this.temperature) && !this.isStable() ? (this.simulation && D.cancelAnimationFrame(this.simulation), this.simulation = D.requestAnimationFrame(() => this.step())) : (this.simulation = !1, this.series.forEach((v) => {
              f(v, "afterSimulation");
            }));
          }
        }
        stop() {
          this.simulation && D.cancelAnimationFrame(this.simulation);
        }
        setArea(p, v, k, m) {
          this.box = { left: p, top: v, width: k, height: m };
        }
        setK() {
          this.k = this.options.linkLength || this.integration.getK(this);
        }
        addElementsToCollection(p, v) {
          for (let k of p) v.indexOf(k) === -1 && v.push(k);
        }
        removeElementFromCollection(p, v) {
          let k = v.indexOf(p);
          k !== -1 && v.splice(k, 1);
        }
        clear() {
          this.nodes.length = 0, this.links.length = 0, this.series.length = 0, this.resetSimulation();
        }
        resetSimulation() {
          this.forcedStop = !1, this.systemTemperature = 0, this.setMaxIterations(), this.setTemperature(), this.setDiffTemperature();
        }
        restartSimulation() {
          this.simulation ? this.resetSimulation() : (this.setInitialRendering(!1), this.enableSimulation ? this.start() : this.setMaxIterations(1), this.chart && this.chart.redraw(), this.setInitialRendering(!0));
        }
        setMaxIterations(p) {
          this.maxIterations = w(p, this.options.maxIterations);
        }
        setTemperature() {
          this.temperature = this.startTemperature = Math.sqrt(this.nodes.length);
        }
        setDiffTemperature() {
          this.diffTemperature = this.startTemperature / (this.options.maxIterations + 1);
        }
        setInitialRendering(p) {
          this.initialRendering = p;
        }
        createQuadTree() {
          this.quadTree = new T(this.box.left, this.box.top, this.box.width, this.box.height), this.quadTree.insertNodes(this.nodes);
        }
        initPositions() {
          let p = this.options.initialPositions;
          if (N(p)) for (let v of (p.call(this), this.nodes)) B(v.prevX) || (v.prevX = v.plotX), B(v.prevY) || (v.prevY = v.plotY), v.dispX = 0, v.dispY = 0;
          else p === "circle" ? this.setCircularPositions() : this.setRandomPositions();
        }
        setCircularPositions() {
          let p, v = this.box, k = this.nodes, m = 2 * Math.PI / (k.length + 1), A = k.filter(function(y) {
            return y.linksTo.length === 0;
          }), C = {}, H = this.options.initialPositionRadius, G = (y) => {
            for (let S of y.linksFrom || []) C[S.toNode.id] || (C[S.toNode.id] = !0, P.push(S.toNode), G(S.toNode));
          }, P = [];
          for (let y of A) P.push(y), G(y);
          if (P.length) for (let y of k) P.indexOf(y) === -1 && P.push(y);
          else P = k;
          for (let y = 0, S = P.length; y < S; ++y) (p = P[y]).plotX = p.prevX = w(p.plotX, v.width / 2 + H * Math.cos(y * m)), p.plotY = p.prevY = w(p.plotY, v.height / 2 + H * Math.sin(y * m)), p.dispX = 0, p.dispY = 0;
        }
        setRandomPositions() {
          let p, v = this.box, k = this.nodes, m = k.length + 1, A = (C) => {
            let H = C * C / Math.PI;
            return H - Math.floor(H);
          };
          for (let C = 0, H = k.length; C < H; ++C) (p = k[C]).plotX = p.prevX = w(p.plotX, v.width * A(C)), p.plotY = p.prevY = w(p.plotY, v.height * A(m + C)), p.dispX = 0, p.dispY = 0;
        }
        force(p, ...v) {
          this.integration[p].apply(this, v);
        }
        barycenterForces() {
          this.getBarycenter(), this.force("barycenter");
        }
        getBarycenter() {
          let p = 0, v = 0, k = 0;
          for (let m of this.nodes) v += m.plotX * m.mass, k += m.plotY * m.mass, p += m.mass;
          return this.barycenter = { x: v, y: k, xFactor: v / p, yFactor: k / p }, this.barycenter;
        }
        barnesHutApproximation(p, v) {
          let k, m, A = this.getDistXY(p, v), C = this.vectorLength(A);
          return p !== v && C !== 0 && (v.isInternal ? v.boxSize / C < this.options.theta && C !== 0 ? (m = this.repulsiveForce(C, this.k), this.force("repulsive", p, m * v.mass, A, C), k = !1) : k = !0 : (m = this.repulsiveForce(C, this.k), this.force("repulsive", p, m * v.mass, A, C))), k;
        }
        repulsiveForces() {
          if (this.approximation === "barnes-hut") for (let p of this.nodes) this.quadTree.visitNodeRecursive(null, (v) => this.barnesHutApproximation(p, v));
          else {
            let p, v, k;
            for (let m of this.nodes) for (let A of this.nodes) m === A || m.fixedPosition || (k = this.getDistXY(m, A), (v = this.vectorLength(k)) !== 0 && (p = this.repulsiveForce(v, this.k), this.force("repulsive", m, p * A.mass, k, v)));
          }
        }
        attractiveForces() {
          let p, v, k;
          for (let m of this.links) m.fromNode && m.toNode && (p = this.getDistXY(m.fromNode, m.toNode), (v = this.vectorLength(p)) !== 0 && (k = this.attractiveForce(v, this.k), this.force("attractive", m, k, p, v)));
        }
        applyLimits() {
          for (let p of this.nodes) p.fixedPosition || (this.integration.integrate(this, p), this.applyLimitBox(p, this.box), p.dispX = 0, p.dispY = 0);
        }
        applyLimitBox(p, v) {
          let k = p.radius;
          p.plotX = F(p.plotX, v.left + k, v.width - k), p.plotY = F(p.plotY, v.top + k, v.height - k);
        }
        coolDown(p, v, k) {
          return p - v * k;
        }
        isStable() {
          return 1e-5 > Math.abs(this.systemTemperature - this.prevSystemTemperature) || this.temperature <= 0;
        }
        getSystemTemperature() {
          let p = 0;
          for (let v of this.nodes) p += v.temperature;
          return p;
        }
        vectorLength(p) {
          return Math.sqrt(p.x * p.x + p.y * p.y);
        }
        getDistR(p, v) {
          let k = this.getDistXY(p, v);
          return this.vectorLength(k);
        }
        getDistXY(p, v) {
          let k = p.plotX - v.plotX, m = p.plotY - v.plotY;
          return { x: k, y: m, absX: Math.abs(k), absY: Math.abs(m) };
        }
      }
      return x;
    }), a(e, "Series/PackedBubble/PackedBubbleLayout.js", [e["Series/GraphLayoutComposition.js"], e["Series/PackedBubble/PackedBubbleIntegration.js"], e["Series/Networkgraph/ReingoldFruchtermanLayout.js"], e["Core/Utilities.js"]], function(o, n, r, T) {
      let { addEvent: O, pick: j } = T;
      function D() {
        let N = this.series, f = [];
        return N.forEach((w) => {
          w.parentNode && w.parentNode.selected && f.push(w.parentNode);
        }), f;
      }
      function F() {
        this.allDataPoints && delete this.allDataPoints;
      }
      class B extends r {
        constructor() {
          super(...arguments), this.index = NaN, this.nodes = [], this.series = [];
        }
        static compose(f) {
          r.compose(f), o.integrations.packedbubble = n, o.layouts.packedbubble = B;
          let w = f.prototype;
          w.getSelectedParentNodes || (O(f, "beforeRedraw", F), w.getSelectedParentNodes = D);
        }
        beforeStep() {
          this.options.marker && this.series.forEach((f) => {
            f && f.calculateParentRadius();
          });
        }
        isStable() {
          let f = Math.abs(this.prevSystemTemperature - this.systemTemperature);
          return 1 > Math.abs(10 * this.systemTemperature / Math.sqrt(this.nodes.length)) && f < 1e-5 || this.temperature <= 0;
        }
        setCircularPositions() {
          let f = this.box, w = this.nodes, x = 2 * Math.PI / (w.length + 1), M = this.options.initialPositionRadius, p, v, k = 0;
          for (let m of w) this.options.splitSeries && !m.isParentNode ? (p = m.series.parentNode.plotX, v = m.series.parentNode.plotY) : (p = f.width / 2, v = f.height / 2), m.plotX = m.prevX = j(m.plotX, p + M * Math.cos(m.index || k * x)), m.plotY = m.prevY = j(m.plotY, v + M * Math.sin(m.index || k * x)), m.dispX = 0, m.dispY = 0, k++;
        }
        repulsiveForces() {
          let f, w, x, M = this, p = M.options.bubblePadding, v = M.nodes;
          v.forEach((k) => {
            k.degree = k.mass, k.neighbours = 0, v.forEach((m) => {
              f = 0, k !== m && !k.fixedPosition && (M.options.seriesInteraction || k.series === m.series) && (x = M.getDistXY(k, m), (w = M.vectorLength(x) - (k.marker.radius + m.marker.radius + p)) < 0 && (k.degree += 0.01, k.neighbours++, f = M.repulsiveForce(-w / Math.sqrt(k.neighbours), M.k, k, m)), M.force("repulsive", k, f * m.mass, x, m, w));
            });
          });
        }
        applyLimitBox(f, w) {
          let x, M;
          this.options.splitSeries && !f.isParentNode && this.options.parentNodeLimit && (x = this.getDistXY(f, f.series.parentNode), (M = f.series.parentNodeRadius - f.marker.radius - this.vectorLength(x)) < 0 && M > -2 * f.marker.radius && (f.plotX -= 0.01 * x.x, f.plotY -= 0.01 * x.y)), super.applyLimitBox(f, w);
        }
      }
      return o.layouts.packedbubble = B, B;
    }), a(e, "Series/SimulationSeriesUtilities.js", [e["Core/Utilities.js"], e["Core/Animation/AnimationUtilities.js"]], function(o, n) {
      let { merge: r, syncTimeout: T } = o, { animObject: O } = n;
      return { initDataLabels: function() {
        let j = this.options.dataLabels;
        if (!this.dataLabelsGroup) {
          let D = this.initDataLabelsGroup();
          return !this.chart.styledMode && (j != null && j.style) && D.css(j.style), D.attr({ opacity: 0 }), this.visible && D.show(), D;
        }
        return this.dataLabelsGroup.attr(r({ opacity: 1 }, this.getPlotBox("data-labels"))), this.dataLabelsGroup;
      }, initDataLabelsDefer: function() {
        var D;
        let j = this.options.dataLabels;
        j != null && j.defer && ((D = this.options.layoutAlgorithm) != null && D.enableSimulation) ? T(() => {
          this.deferDataLabels = !1;
        }, j ? O(j.animation).defer : 0) : this.deferDataLabels = !1;
      } };
    }), a(e, "Extensions/TextPath.js", [e["Core/Globals.js"], e["Core/Utilities.js"]], function(o, n) {
      let { deg2rad: r } = o, { addEvent: T, merge: O, uniqueKey: j, defined: D, extend: F } = n;
      function B(w, x) {
        x = O(!0, { enabled: !0, attributes: { dy: -5, startOffset: "50%", textAnchor: "middle" } }, x);
        let M = this.renderer.url, p = this.text || this, v = p.textPath, { attributes: k, enabled: m } = x;
        if (w = w || v && v.path, v && v.undo(), w && m) {
          let A = T(p, "afterModifyTree", (C) => {
            if (w && m) {
              let H = w.attr("id");
              H || w.attr("id", H = j());
              let G = { x: 0, y: 0 };
              D(k.dx) && (G.dx = k.dx, delete k.dx), D(k.dy) && (G.dy = k.dy, delete k.dy), p.attr(G), this.attr({ transform: "" }), this.box && (this.box = this.box.destroy());
              let P = C.nodes.slice(0);
              C.nodes.length = 0, C.nodes[0] = { tagName: "textPath", attributes: F(k, { "text-anchor": k.textAnchor, href: `${M}#${H}` }), children: P };
            }
          });
          p.textPath = { path: w, undo: A };
        } else p.attr({ dx: 0, dy: 0 }), delete p.textPath;
        return this.added && (p.textCache = "", this.renderer.buildText(p)), this;
      }
      function N(w) {
        var p;
        let x = w.bBox, M = (p = this.element) == null ? void 0 : p.querySelector("textPath");
        if (M) {
          let v = [], { b: k, h: m } = this.renderer.fontMetrics(this.element), A = m - k, C = RegExp('(<tspan>|<tspan(?!\\sclass="highcharts-br")[^>]*>|<\\/tspan>)', "g"), H = M.innerHTML.replace(C, "").split(/<tspan class="highcharts-br"[^>]*>/), G = H.length, P = (y, S) => {
            let { x: d, y: s } = S, l = (M.getRotationOfChar(y) - 90) * r, b = Math.cos(l), u = Math.sin(l);
            return [[d - A * b, s - A * u], [d + k * b, s + k * u]];
          };
          for (let y = 0, S = 0; S < G; S++) {
            let d = H[S].length;
            for (let s = 0; s < d; s += 5) try {
              let l = y + s + S, [b, u] = P(l, M.getStartPositionOfChar(l));
              s === 0 ? (v.push(u), v.push(b)) : (S === 0 && v.unshift(u), S === G - 1 && v.push(b));
            } catch {
              break;
            }
            y += d - 1;
            try {
              let s = y + S, l = M.getEndPositionOfChar(s), [b, u] = P(s, l);
              v.unshift(u), v.unshift(b);
            } catch {
              break;
            }
          }
          v.length && v.push(v[0].slice()), x.polygon = v;
        }
        return x;
      }
      function f(w) {
        var v;
        let x = w.labelOptions, M = w.point, p = x[M.formatPrefix + "TextPath"] || x.textPath;
        p && !x.useHTML && (this.setTextPath(((v = M.getDataLabelPath) == null ? void 0 : v.call(M, this)) || M.graphic, p), M.dataLabelPath && !p.enabled && (M.dataLabelPath = M.dataLabelPath.destroy()));
      }
      return { compose: function(w) {
        T(w, "afterGetBBox", N), T(w, "beforeAddingDataLabel", f);
        let x = w.prototype;
        x.setTextPath || (x.setTextPath = B);
      } };
    }), a(e, "Series/PackedBubble/PackedBubbleSeries.js", [e["Core/Color/Color.js"], e["Series/DragNodesComposition.js"], e["Series/GraphLayoutComposition.js"], e["Core/Globals.js"], e["Series/PackedBubble/PackedBubblePoint.js"], e["Series/PackedBubble/PackedBubbleSeriesDefaults.js"], e["Series/PackedBubble/PackedBubbleLayout.js"], e["Core/Series/SeriesRegistry.js"], e["Series/SimulationSeriesUtilities.js"], e["Core/Utilities.js"], e["Core/Renderer/SVG/SVGElement.js"], e["Extensions/TextPath.js"]], function(o, n, r, T, O, j, D, F, B, N, f, w) {
      let { parse: x } = o, { noop: M } = T, { series: { prototype: p }, seriesTypes: { bubble: v } } = F, { initDataLabels: k, initDataLabelsDefer: m } = B, { addEvent: A, clamp: C, defined: H, extend: G, fireEvent: P, isArray: y, isNumber: S, merge: d, pick: s } = N;
      w.compose(f);
      class l extends v {
        constructor() {
          super(...arguments), this.parentNodeMass = 0, this.deferDataLabels = !0;
        }
        static compose(u, c, h) {
          v.compose(u, c, h), n.compose(c), D.compose(c);
        }
        accumulateAllPoints() {
          let u, c = this.chart, h = [];
          for (let g of c.series) if (g.is("packedbubble") && g.reserveSpace()) {
            u = g.yData || [];
            for (let E = 0; E < u.length; E++) h.push([null, null, u[E], g.index, E, { id: E, marker: { radius: 0 } }]);
          }
          return h;
        }
        addLayout() {
          let u = this.options.layoutAlgorithm = this.options.layoutAlgorithm || {}, c = u.type || "packedbubble", h = this.chart.options.chart, g = this.chart.graphLayoutsStorage, E = this.chart.graphLayoutsLookup, R;
          g || (this.chart.graphLayoutsStorage = g = {}, this.chart.graphLayoutsLookup = E = []), (R = g[c]) || (u.enableSimulation = H(h.forExport) ? !h.forExport : u.enableSimulation, g[c] = R = new r.layouts[c](), R.init(u), E.splice(R.index, 0, R)), this.layout = R, this.points.forEach((L) => {
            L.mass = 2, L.degree = 1, L.collisionNmb = 1;
          }), R.setArea(0, 0, this.chart.plotWidth, this.chart.plotHeight), R.addElementsToCollection([this], R.series), R.addElementsToCollection(this.points, R.nodes);
        }
        addSeriesLayout() {
          let u = this.options.layoutAlgorithm = this.options.layoutAlgorithm || {}, c = u.type || "packedbubble", h = this.chart.graphLayoutsStorage, g = this.chart.graphLayoutsLookup, E = d(u, u.parentNodeOptions, { enableSimulation: this.layout.options.enableSimulation }), R = h[c + "-series"];
          R || (h[c + "-series"] = R = new r.layouts[c](), R.init(E), g.splice(R.index, 0, R)), this.parentNodeLayout = R, this.createParentNodes();
        }
        calculateParentRadius() {
          let u = this.seriesBox();
          this.parentNodeRadius = C(Math.sqrt(2 * this.parentNodeMass / Math.PI) + 20, 20, u ? Math.max(Math.sqrt(Math.pow(u.width, 2) + Math.pow(u.height, 2)) / 2 + 20, 20) : Math.sqrt(2 * this.parentNodeMass / Math.PI) + 20), this.parentNode && (this.parentNode.marker.radius = this.parentNode.radius = this.parentNodeRadius);
        }
        calculateZExtremes() {
          let u = this.chart.series, c = this.options.zMin, h = this.options.zMax, g = 1 / 0, E = -1 / 0;
          return c && h ? [c, h] : (u.forEach((R) => {
            R.yData.forEach((L) => {
              H(L) && (L > E && (E = L), L < g && (g = L));
            });
          }), [c = s(c, g), h = s(h, E)]);
        }
        checkOverlap(u, c) {
          let h = u[0] - c[0], g = u[1] - c[1];
          return Math.sqrt(h * h + g * g) - Math.abs(u[2] + c[2]) < -1e-3;
        }
        createParentNodes() {
          let u = this.pointClass, c = this.chart, h = this.parentNodeLayout, g = this.layout.options, E, R = this.parentNode, L = { radius: this.parentNodeRadius, lineColor: this.color, fillColor: x(this.color).brighten(0.4).get() };
          g.parentNodeOptions && (L = d(g.parentNodeOptions.marker || {}, L)), this.parentNodeMass = 0, this.points.forEach((U) => {
            this.parentNodeMass += Math.PI * Math.pow(U.marker.radius, 2);
          }), this.calculateParentRadius(), h.nodes.forEach((U) => {
            U.seriesIndex === this.index && (E = !0);
          }), h.setArea(0, 0, c.plotWidth, c.plotHeight), E || (R || (R = new u(this, { mass: this.parentNodeRadius / 2, marker: L, dataLabels: { inside: !1 }, states: { normal: { marker: L }, hover: { marker: L } }, dataLabelOnNull: !0, degree: this.parentNodeRadius, isParentNode: !0, seriesIndex: this.index })), this.parentNode && (R.plotX = this.parentNode.plotX, R.plotY = this.parentNode.plotY), this.parentNode = R, h.addElementsToCollection([this], h.series), h.addElementsToCollection([R], h.nodes));
        }
        deferLayout() {
          let u = this.options.layoutAlgorithm;
          this.visible && (this.addLayout(), u.splitSeries && this.addSeriesLayout());
        }
        destroy() {
          this.chart.graphLayoutsLookup && this.chart.graphLayoutsLookup.forEach((u) => {
            u.removeElementFromCollection(this, u.series);
          }, this), this.parentNode && this.parentNodeLayout && (this.parentNodeLayout.removeElementFromCollection(this.parentNode, this.parentNodeLayout.nodes), this.parentNode.dataLabel && (this.parentNode.dataLabel = this.parentNode.dataLabel.destroy())), p.destroy.apply(this, arguments);
        }
        drawDataLabels() {
          !this.deferDataLabels && (p.drawDataLabels.call(this, this.points), this.parentNode && (this.parentNode.formatPrefix = "parentNode", p.drawDataLabels.call(this, [this.parentNode])));
        }
        drawGraph() {
          var E;
          if (!this.layout || !this.layout.options.splitSeries) return;
          let u = this.chart, c = this.layout.options.parentNodeOptions.marker, h = { fill: c.fillColor || x(this.color).brighten(0.4).get(), opacity: c.fillOpacity, stroke: c.lineColor || this.color, "stroke-width": s(c.lineWidth, this.options.lineWidth) }, g = {};
          this.parentNodesGroup = this.plotGroup("parentNodesGroup", "parentNode", this.visible ? "inherit" : "hidden", 0.1, u.seriesGroup), (E = this.group) == null || E.attr({ zIndex: 2 }), this.calculateParentRadius(), this.parentNode && H(this.parentNode.plotX) && H(this.parentNode.plotY) && H(this.parentNodeRadius) && (g = d({ x: this.parentNode.plotX - this.parentNodeRadius, y: this.parentNode.plotY - this.parentNodeRadius, width: 2 * this.parentNodeRadius, height: 2 * this.parentNodeRadius }, h), this.parentNode.graphic || (this.graph = this.parentNode.graphic = u.renderer.symbol(h.symbol).add(this.parentNodesGroup)), this.parentNode.graphic.attr(g));
        }
        drawTracker() {
          let u, c = this.parentNode;
          super.drawTracker(), c && (u = y(c.dataLabels) ? c.dataLabels : c.dataLabel ? [c.dataLabel] : [], c.graphic && (c.graphic.element.point = c), u.forEach((h) => {
            (h.div || h.element).point = c;
          }));
        }
        getPointRadius() {
          let u, c, h, g, E = this.chart, R = E.plotWidth, L = E.plotHeight, U = this.options, V = U.useSimulation, q = Math.min(R, L), Y = {}, I = [], _ = E.allDataPoints || [], W = _.length;
          ["minSize", "maxSize"].forEach((z) => {
            let $ = parseInt(U[z], 10), K = /%$/.test(U[z]);
            Y[z] = K ? q * $ / 100 : $ * Math.sqrt(W);
          }), E.minRadius = u = Y.minSize / Math.sqrt(W), E.maxRadius = c = Y.maxSize / Math.sqrt(W);
          let X = V ? this.calculateZExtremes() : [u, c];
          _.forEach((z, $) => {
            h = V ? C(z[2], X[0], X[1]) : z[2], (g = this.getRadius(X[0], X[1], u, c, h)) === 0 && (g = null), _[$][2] = g, I.push(g);
          }), this.radii = I;
        }
        init() {
          return p.init.apply(this, arguments), m.call(this), this.eventsToUnbind.push(A(this, "updatedData", function() {
            this.chart.series.forEach((u) => {
              u.type === this.type && (u.isDirty = !0);
            }, this);
          })), this;
        }
        onMouseUp(u) {
          if (u.fixedPosition && !u.removed) {
            let c, h = this.layout, g = this.parentNodeLayout;
            g && h.options.dragBetweenSeries && g.nodes.forEach((E) => {
              u && u.marker && E !== u.series.parentNode && (c = h.getDistXY(u, E), h.vectorLength(c) - E.marker.radius - u.marker.radius < 0 && (E.series.addPoint(d(u.options, { plotX: u.plotX, plotY: u.plotY }), !1), h.removeElementFromCollection(u, h.nodes), u.remove()));
            }), n.onMouseUp.apply(this, arguments);
          }
        }
        placeBubbles(u) {
          let c = this.checkOverlap, h = this.positionBubble, g = [], E = 1, R = 0, L = 0, U, V = [], q, Y = u.sort((I, _) => _[2] - I[2]);
          if (Y.length) {
            if (g.push([[0, 0, Y[0][2], Y[0][3], Y[0][4]]]), Y.length > 1) for (g.push([[0, 0 - Y[1][2] - Y[0][2], Y[1][2], Y[1][3], Y[1][4]]]), q = 2; q < Y.length; q++) Y[q][2] = Y[q][2] || 1, c(U = h(g[E][R], g[E - 1][L], Y[q]), g[E][0]) ? (g.push([]), L = 0, g[E + 1].push(h(g[E][R], g[E][0], Y[q])), E++, R = 0) : E > 1 && g[E - 1][L + 1] && c(U, g[E - 1][L + 1]) ? (L++, g[E].push(h(g[E][R], g[E - 1][L], Y[q])), R++) : (R++, g[E].push(U));
            this.chart.stages = g, this.chart.rawPositions = [].concat.apply([], g), this.resizeRadius(), V = this.chart.rawPositions;
          }
          return V;
        }
        pointAttribs(u, c) {
          let h = this.options, g = u && u.isParentNode, E = h.marker;
          g && h.layoutAlgorithm && h.layoutAlgorithm.parentNodeOptions && (E = h.layoutAlgorithm.parentNodeOptions.marker);
          let R = E.fillOpacity, L = p.pointAttribs.call(this, u, c);
          return R !== 1 && (L["fill-opacity"] = R), L;
        }
        positionBubble(u, c, h) {
          let g = Math.asin, E = Math.acos, R = Math.pow, L = Math.abs, U = (0, Math.sqrt)(R(u[0] - c[0], 2) + R(u[1] - c[1], 2)), V = E((R(U, 2) + R(h[2] + c[2], 2) - R(h[2] + u[2], 2)) / (2 * (h[2] + c[2]) * U)), q = g(L(u[0] - c[0]) / U), Y = (u[1] - c[1] < 0 ? 0 : Math.PI) + V + q * ((u[0] - c[0]) * (u[1] - c[1]) < 0 ? 1 : -1), I = Math.cos(Y), _ = Math.sin(Y);
          return [c[0] + (c[2] + h[2]) * _, c[1] - (c[2] + h[2]) * I, h[2], h[3], h[4]];
        }
        render() {
          let u = [];
          p.render.apply(this, arguments), !this.options.dataLabels.allowOverlap && (this.data.forEach((c) => {
            y(c.dataLabels) && c.dataLabels.forEach((h) => {
              u.push(h);
            });
          }), this.options.useSimulation && this.chart.hideOverlappingLabels(u));
        }
        resizeRadius() {
          let u, c, h, g, E, R = this.chart, L = R.rawPositions, U = Math.min, V = Math.max, q = R.plotLeft, Y = R.plotTop, I = R.plotHeight, _ = R.plotWidth;
          for (let $ of (u = h = Number.POSITIVE_INFINITY, c = g = Number.NEGATIVE_INFINITY, L)) E = $[2], u = U(u, $[0] - E), c = V(c, $[0] + E), h = U(h, $[1] - E), g = V(g, $[1] + E);
          let W = [c - u, g - h], X = [(_ - q) / W[0], (I - Y) / W[1]], z = U.apply([], X);
          if (Math.abs(z - 1) > 1e-10) {
            for (let $ of L) $[2] *= z;
            this.placeBubbles(L);
          } else R.diffY = I / 2 + Y - h - (g - h) / 2, R.diffX = _ / 2 + q - u - (c - u) / 2;
        }
        seriesBox() {
          let u, c = this.chart, h = this.data, g = Math.max, E = Math.min, R = [c.plotLeft, c.plotLeft + c.plotWidth, c.plotTop, c.plotTop + c.plotHeight];
          return h.forEach((L) => {
            H(L.plotX) && H(L.plotY) && L.marker.radius && (u = L.marker.radius, R[0] = E(R[0], L.plotX - u), R[1] = g(R[1], L.plotX + u), R[2] = E(R[2], L.plotY - u), R[3] = g(R[3], L.plotY + u));
          }), S(R.width / R.height) ? R : null;
        }
        setVisible() {
          let u = this;
          p.setVisible.apply(u, arguments), u.parentNodeLayout && u.graph ? u.visible ? (u.graph.show(), u.parentNode.dataLabel && u.parentNode.dataLabel.show()) : (u.graph.hide(), u.parentNodeLayout.removeElementFromCollection(u.parentNode, u.parentNodeLayout.nodes), u.parentNode.dataLabel && u.parentNode.dataLabel.hide()) : u.layout && (u.visible ? u.layout.addElementsToCollection(u.points, u.layout.nodes) : u.points.forEach((c) => {
            u.layout.removeElementFromCollection(c, u.layout.nodes);
          }));
        }
        translate() {
          let u, c, h, g = this.chart, E = this.data, R = this.index, L = this.options.useSimulation;
          for (let U of (this.processedXData = this.xData, this.generatePoints(), H(g.allDataPoints) || (g.allDataPoints = this.accumulateAllPoints(), this.getPointRadius()), L ? h = g.allDataPoints : (h = this.placeBubbles(g.allDataPoints), this.options.draggable = !1), h)) U[3] === R && (u = E[U[4]], c = s(U[2], void 0), L || (u.plotX = U[0] - g.plotLeft + g.diffX, u.plotY = U[1] - g.plotTop + g.diffY), S(c) && (u.marker = G(u.marker, { radius: c, width: 2 * c, height: 2 * c }), u.radius = c));
          L && this.deferLayout(), P(this, "afterTranslate");
        }
      }
      return l.defaultOptions = d(v.defaultOptions, j), G(l.prototype, { pointClass: O, axisTypes: [], directTouch: !0, forces: ["barycenter", "repulsive"], hasDraggableNodes: !0, invertible: !1, isCartesian: !1, noSharedTooltip: !0, pointArrayMap: ["value"], pointValKey: "value", requireSorting: !1, trackerGroups: ["group", "dataLabelsGroup", "parentNodesGroup"], initDataLabels: k, alignDataLabel: p.alignDataLabel, indexateNodes: M, onMouseDown: n.onMouseDown, onMouseMove: n.onMouseMove, redrawHalo: n.redrawHalo, searchPoint: M }), F.registerSeriesType("packedbubble", l), l;
    }), a(e, "Series/Polygon/PolygonSeriesDefaults.js", [], function() {
      return { marker: { enabled: !1, states: { hover: { enabled: !1 } } }, stickyTracking: !1, tooltip: { followPointer: !0, pointFormat: "" }, trackByArea: !0, legendSymbol: "rectangle" };
    }), a(e, "Series/Polygon/PolygonSeries.js", [e["Core/Globals.js"], e["Series/Polygon/PolygonSeriesDefaults.js"], e["Core/Series/SeriesRegistry.js"], e["Core/Utilities.js"]], function(o, n, r, T) {
      let { noop: O } = o, { area: j, line: D, scatter: F } = r.seriesTypes, { extend: B, merge: N } = T;
      class f extends F {
        getGraphPath() {
          let x = D.prototype.getGraphPath.call(this), M = x.length + 1;
          for (; M--; ) (M === x.length || x[M][0] === "M") && M > 0 && x.splice(M, 0, ["Z"]);
          return this.areaPath = x, x;
        }
        drawGraph() {
          this.options.fillColor = this.color, j.prototype.drawGraph.call(this);
        }
      }
      return f.defaultOptions = N(F.defaultOptions, n), B(f.prototype, { type: "polygon", drawTracker: D.prototype.drawTracker, setStackedPoints: O }), r.registerSeriesType("polygon", f), f;
    }), a(e, "Core/Axis/RadialAxisDefaults.js", [], function() {
      return { circular: { gridLineWidth: 1, labels: { align: void 0, x: 0, y: void 0, style: { textOverflow: "none" } }, maxPadding: 0, minPadding: 0, showLastLabel: !1, tickLength: 0 }, radial: { gridLineInterpolation: "circle", gridLineWidth: 1, labels: { align: "right", padding: 5, x: -3, y: -2 }, showLastLabel: !1, title: { x: 4, text: null, rotation: 90 } }, radialGauge: { endOnTick: !1, gridLineWidth: 0, labels: { align: "center", distance: -25, x: 0, y: void 0 }, lineWidth: 1, minorGridLineWidth: 0, minorTickInterval: "auto", minorTickLength: 10, minorTickPosition: "inside", minorTickWidth: 1, startOnTick: !1, tickLength: 10, tickPixelInterval: 100, tickPosition: "inside", tickWidth: 2, title: { rotation: 0, text: "" }, zIndex: 2 } };
    }), a(e, "Core/Axis/RadialAxis.js", [e["Core/Axis/RadialAxisDefaults.js"], e["Core/Defaults.js"], e["Core/Globals.js"], e["Core/Utilities.js"]], function(o, n, r, T) {
      var O;
      let { defaultOptions: j } = n, { composed: D, noop: F } = r, { addEvent: B, correctFloat: N, defined: f, extend: w, fireEvent: x, isObject: M, merge: p, pick: v, pushUnique: k, relativeLength: m, wrap: A } = T;
      return function(C) {
        function H() {
          this.autoConnect = this.isCircular && v(this.userMax, this.options.max) === void 0 && N(this.endAngleRad - this.startAngleRad) === N(2 * Math.PI), !this.isCircular && this.chart.inverted && this.max++, this.autoConnect && (this.max += this.categories && 1 || this.pointRange || this.closestPointRange || 0);
        }
        function G() {
          return () => {
            if (this.isRadial && this.tickPositions && this.options.labels && this.options.labels.allowOverlap !== !0) return this.tickPositions.map(($) => this.ticks[$] && this.ticks[$].label).filter(($) => !!$);
          };
        }
        function P() {
          return F;
        }
        function y($, K, Q) {
          let Z = this.pane.center, ee = $.value, J, ae, re;
          return this.isCircular ? (f(ee) ? $.point && ($.point.shapeArgs || {}).start && (ee = this.chart.inverted ? this.translate($.point.rectPlotY, !0) : $.point.x) : (ae = $.chartX || 0, re = $.chartY || 0, ee = this.translate(Math.atan2(re - Q, ae - K) - this.startAngleRad, !0)), ae = (J = this.getPosition(ee)).x, re = J.y) : (f(ee) || (ae = $.chartX, re = $.chartY), f(ae) && f(re) && (Q = Z[1] + this.chart.plotTop, ee = this.translate(Math.min(Math.sqrt(Math.pow(ae - K, 2) + Math.pow(re - Q, 2)), Z[2] / 2) - Z[3] / 2, !0))), [ee, ae || 0, re || 0];
        }
        function S($, K, Q) {
          let Z = this.pane.center, ee = this.chart, J = this.left || 0, ae = this.top || 0, re, ce = v(K, Z[2] / 2 - this.offset), he;
          return Q === void 0 && (Q = this.horiz ? 0 : this.center && -this.center[3] / 2), Q && (ce += Q), this.isCircular || K !== void 0 ? ((he = this.chart.renderer.symbols.arc(J + Z[0], ae + Z[1], ce, ce, { start: this.startAngleRad, end: this.endAngleRad, open: !0, innerR: 0 })).xBounds = [J + Z[0]], he.yBounds = [ae + Z[1] - ce]) : (re = this.postTranslate(this.angleRad, ce), he = [["M", this.center[0] + ee.plotLeft, this.center[1] + ee.plotTop], ["L", re.x, re.y]]), he;
        }
        function d() {
          this.constructor.prototype.getOffset.call(this), this.chart.axisOffset[this.side] = 0;
        }
        function s($, K, Q) {
          let Z = this.chart, ee = (ye) => {
            if (typeof ye == "string") {
              let xe = parseInt(ye, 10);
              return te.test(ye) && (xe = xe * re / 100), xe;
            }
            return ye;
          }, J = this.center, ae = this.startAngleRad, re = J[2] / 2, ce = Math.min(this.offset, 0), he = this.left || 0, ne = this.top || 0, te = /%$/, se = this.isCircular, oe, ie, le, de, be, ge, me = v(ee(Q.outerRadius), re), fe = ee(Q.innerRadius), Ae = v(ee(Q.thickness), 10);
          if (this.options.gridLineInterpolation === "polygon") ge = this.getPlotLinePath({ value: $ }).concat(this.getPlotLinePath({ value: K, reverse: !0 }));
          else {
            $ = Math.max($, this.min), K = Math.min(K, this.max);
            let ye = this.translate($), xe = this.translate(K);
            se || (me = ye || 0, fe = xe || 0), Q.shape !== "circle" && se ? (oe = ae + (ye || 0), ie = ae + (xe || 0)) : (oe = -Math.PI / 2, ie = 1.5 * Math.PI, be = !0), me -= ce, Ae -= ce, ge = Z.renderer.symbols.arc(he + J[0], ne + J[1], me, me, { start: Math.min(oe, ie), end: Math.max(oe, ie), innerR: v(fe, me - Ae), open: be, borderRadius: Q.borderRadius }), se && (le = (ie + oe) / 2, de = he + J[0] + J[2] / 2 * Math.cos(le), ge.xBounds = le > -Math.PI / 2 && le < Math.PI / 2 ? [de, Z.plotWidth] : [0, de], ge.yBounds = [ne + J[1] + J[2] / 2 * Math.sin(le)], ge.yBounds[0] += le > -Math.PI && le < 0 || le > Math.PI ? -10 : 10);
          }
          return ge;
        }
        function l($) {
          let K = this.pane.center, Q = this.chart, Z = Q.inverted, ee = $.reverse, J = this.pane.options.background ? this.pane.options.background[0] || this.pane.options.background : {}, ae = J.innerRadius || "0%", re = J.outerRadius || "100%", ce = K[0] + Q.plotLeft, he = K[1] + Q.plotTop, ne = this.height, te = $.isCrosshair, se = K[3] / 2, oe = $.value, ie, le, de, be, ge, me, fe, Ae, ye, xe = this.getPosition(oe), we = xe.x, ke = xe.y;
          if (te && (oe = (Ae = this.getCrosshairPosition($, ce, he))[0], we = Ae[1], ke = Ae[2]), this.isCircular) le = Math.sqrt(Math.pow(we - ce, 2) + Math.pow(ke - he, 2)), de = typeof ae == "string" ? m(ae, 1) : ae / le, be = typeof re == "string" ? m(re, 1) : re / le, K && se && (de < (ie = se / le) && (de = ie), be < ie && (be = ie)), ye = [["M", ce + de * (we - ce), he - de * (he - ke)], ["L", we - (1 - be) * (we - ce), ke + (1 - be) * (he - ke)]];
          else if ((oe = this.translate(oe)) && (oe < 0 || oe > ne) && (oe = 0), this.options.gridLineInterpolation === "circle") ye = this.getLinePath(0, oe, se);
          else if (ye = [], Q[Z ? "yAxis" : "xAxis"].forEach((Me) => {
            Me.pane === this.pane && (ge = Me);
          }), ge) {
            fe = ge.tickPositions, ge.autoConnect && (fe = fe.concat([fe[0]])), ee && (fe = fe.slice().reverse()), oe && (oe += se);
            for (let Me = 0; Me < fe.length; Me++) me = ge.getPosition(fe[Me], oe), ye.push(Me ? ["L", me.x, me.y] : ["M", me.x, me.y]);
          }
          return ye;
        }
        function b($, K) {
          let Q = this.translate($);
          return this.postTranslate(this.isCircular ? Q : this.angleRad, v(this.isCircular ? K : Q < 0 ? 0 : Q, this.center[2] / 2) - this.offset);
        }
        function u() {
          let $ = this.center, K = this.chart, Q = this.options.title;
          return { x: K.plotLeft + $[0] + (Q.x || 0), y: K.plotTop + $[1] - { high: 0.5, middle: 0.25, low: 0 }[Q.align] * $[2] + (Q.y || 0) };
        }
        function c($) {
          $.beforeSetTickPositions = H, $.createLabelCollector = G, $.getCrosshairPosition = y, $.getLinePath = S, $.getOffset = d, $.getPlotBandPath = s, $.getPlotLinePath = l, $.getPosition = b, $.getTitlePosition = u, $.postTranslate = Y, $.setAxisSize = _, $.setAxisTranslation = W, $.setOptions = X;
        }
        function h() {
          let $ = this.chart, K = this.options, Q = $.angular && this.isXAxis, Z = this.pane, ee = Z && Z.options;
          if (!Q && Z && ($.angular || $.polar)) {
            let J = 2 * Math.PI, ae = (v(ee.startAngle, 0) - 90) * Math.PI / 180, re = (v(ee.endAngle, v(ee.startAngle, 0) + 360) - 90) * Math.PI / 180;
            this.angleRad = (K.angle || 0) * Math.PI / 180, this.startAngleRad = ae, this.endAngleRad = re, this.offset = K.offset || 0;
            let ce = (ae % J + J) % J, he = (re % J + J) % J;
            ce > Math.PI && (ce -= J), he > Math.PI && (he -= J), this.normalizedStartAngleRad = ce, this.normalizedEndAngleRad = he;
          }
        }
        function g($) {
          this.isRadial && ($.align = void 0, $.preventDefault());
        }
        function E() {
          if (this.chart && this.chart.labelCollectors) {
            let $ = this.labelCollector ? this.chart.labelCollectors.indexOf(this.labelCollector) : -1;
            $ >= 0 && this.chart.labelCollectors.splice($, 1);
          }
        }
        function R($) {
          let K, Q = this.chart, Z = Q.angular, ee = Q.polar, J = this.isXAxis, ae = this.coll, re = $.userOptions.pane || 0, ce = this.pane = Q.pane && Q.pane[re];
          if (ae === "colorAxis") {
            this.isRadial = !1;
            return;
          }
          Z ? (Z && J ? (this.isHidden = !0, this.createLabelCollector = P, this.getOffset = F, this.redraw = I, this.render = I, this.setScale = F, this.setCategories = F, this.setTitle = F) : c(this), K = !J) : ee && (c(this), K = this.horiz), Z || ee ? (this.isRadial = !0, this.labelCollector || (this.labelCollector = this.createLabelCollector()), this.labelCollector && Q.labelCollectors.push(this.labelCollector)) : this.isRadial = !1, ce && K && (ce.axis = this), this.isCircular = K;
        }
        function L() {
          this.isRadial && this.beforeSetTickPositions();
        }
        function U($) {
          let K = this.label;
          if (!K) return;
          let Q = this.axis, Z = K.getBBox(), ee = Q.options.labels, J = (Q.translate(this.pos) + Q.startAngleRad + Math.PI / 2) / Math.PI * 180 % 360, ae = Math.round(J), re = f(ee.y) ? 0 : -(0.3 * Z.height), ce = ee.y, he, ne = 20, te = ee.align, se = "end", oe = ae < 0 ? ae + 360 : ae, ie = oe, le = 0, de = 0;
          Q.isRadial && (he = Q.getPosition(this.pos, Q.center[2] / 2 + m(v(ee.distance, -25), Q.center[2] / 2, -Q.center[2] / 2)), ee.rotation === "auto" ? K.attr({ rotation: J }) : f(ce) || (ce = Q.chart.renderer.fontMetrics(K).b - Z.height / 2), f(te) || (Q.isCircular ? (Z.width > Q.len * Q.tickInterval / (Q.max - Q.min) && (ne = 0), te = J > ne && J < 180 - ne ? "left" : J > 180 + ne && J < 360 - ne ? "right" : "center") : te = "center", K.attr({ align: te })), te === "auto" && Q.tickPositions.length === 2 && Q.isCircular && (oe > 90 && oe < 180 ? oe = 180 - oe : oe > 270 && oe <= 360 && (oe = 540 - oe), ie > 180 && ie <= 360 && (ie = 360 - ie), (Q.pane.options.startAngle === ae || Q.pane.options.startAngle === ae + 360 || Q.pane.options.startAngle === ae - 360) && (se = "start"), te = ae >= -90 && ae <= 90 || ae >= -360 && ae <= -270 || ae >= 270 && ae <= 360 ? se === "start" ? "right" : "left" : se === "start" ? "left" : "right", ie > 70 && ie < 110 && (te = "center"), oe < 15 || oe >= 180 && oe < 195 ? le = 0.3 * Z.height : oe >= 15 && oe <= 35 ? le = se === "start" ? 0 : 0.75 * Z.height : oe >= 195 && oe <= 215 ? le = se === "start" ? 0.75 * Z.height : 0 : oe > 35 && oe <= 90 ? le = se === "start" ? -(0.25 * Z.height) : Z.height : oe > 215 && oe <= 270 && (le = se === "start" ? Z.height : -(0.25 * Z.height)), ie < 15 ? de = se === "start" ? -(0.15 * Z.height) : 0.15 * Z.height : ie > 165 && ie <= 180 && (de = se === "start" ? 0.15 * Z.height : -(0.15 * Z.height)), K.attr({ align: te }), K.translate(de, le + re)), $.pos.x = he.x + (ee.x || 0), $.pos.y = he.y + (ce || 0));
        }
        function V($) {
          this.axis.getPosition && w($.pos, this.axis.getPosition(this.pos));
        }
        function q({ options: $ }) {
          $.xAxis && p(!0, C.radialDefaultOptions.circular, $.xAxis), $.yAxis && p(!0, C.radialDefaultOptions.radialGauge, $.yAxis);
        }
        function Y($, K) {
          let Q = this.chart, Z = this.center;
          return $ = this.startAngleRad + $, { x: Q.plotLeft + Z[0] + Math.cos($) * K, y: Q.plotTop + Z[1] + Math.sin($) * K };
        }
        function I() {
          this.isDirty = !1;
        }
        function _() {
          let $, K;
          this.constructor.prototype.setAxisSize.call(this), this.isRadial && (this.pane.updateCenter(this), $ = this.center = this.pane.center.slice(), this.isCircular ? this.sector = this.endAngleRad - this.startAngleRad : (K = this.postTranslate(this.angleRad, $[3] / 2), $[0] = K.x - this.chart.plotLeft, $[1] = K.y - this.chart.plotTop), this.len = this.width = this.height = ($[2] - $[3]) * v(this.sector, 1) / 2);
        }
        function W() {
          this.constructor.prototype.setAxisTranslation.call(this), this.center && (this.isCircular ? this.transA = (this.endAngleRad - this.startAngleRad) / (this.max - this.min || 1) : this.transA = (this.center[2] - this.center[3]) / 2 / (this.max - this.min || 1), this.isXAxis ? this.minPixelPadding = this.transA * this.minPointOffset : this.minPixelPadding = 0);
        }
        function X($) {
          let { coll: K } = this, { angular: Q, inverted: Z, polar: ee } = this.chart, J = {};
          Q ? this.isXAxis || (J = p(j.yAxis, C.radialDefaultOptions.radialGauge)) : ee && (J = this.horiz ? p(j.xAxis, C.radialDefaultOptions.circular) : p(K === "xAxis" ? j.xAxis : j.yAxis, C.radialDefaultOptions.radial)), Z && K === "yAxis" && (J.stackLabels = M(j.yAxis, !0) ? j.yAxis.stackLabels : {}, J.reversedStacks = !0);
          let ae = this.options = p(J, $);
          ae.plotBands || (ae.plotBands = []), x(this, "afterSetOptions");
        }
        function z($, K, Q, Z, ee, J, ae) {
          let re, ce = this.axis;
          return ce.isRadial ? ["M", K, Q, "L", (re = ce.getPosition(this.pos, ce.center[2] / 2 + Z)).x, re.y] : $.call(this, K, Q, Z, ee, J, ae);
        }
        C.radialDefaultOptions = p(o), C.compose = function($, K) {
          return k(D, "Axis.Radial") && (B($, "afterInit", h), B($, "autoLabelAlign", g), B($, "destroy", E), B($, "init", R), B($, "initialAxisTranslation", L), B(K, "afterGetLabelPosition", U), B(K, "afterGetPosition", V), B(r, "setOptions", q), A(K.prototype, "getMarkPath", z)), $;
        };
      }(O || (O = {})), O;
    }), a(e, "Series/PolarComposition.js", [e["Core/Animation/AnimationUtilities.js"], e["Core/Globals.js"], e["Core/Series/Series.js"], e["Extensions/Pane/Pane.js"], e["Core/Axis/RadialAxis.js"], e["Core/Utilities.js"]], function(o, n, r, T, O, j) {
      let { animObject: D } = o, { composed: F } = n, { addEvent: B, defined: N, find: f, isNumber: w, merge: x, pick: M, pushUnique: p, relativeLength: v, splat: k, uniqueKey: m, wrap: A } = j;
      function C() {
        (this.pane || []).forEach((q) => {
          q.render();
        });
      }
      function H(q) {
        let Y = q.args[0].xAxis, I = q.args[0].yAxis, _ = q.args[0].chart;
        Y && I && (I.gridLineInterpolation === "polygon" ? (Y.startOnTick = !0, Y.endOnTick = !0) : Y.gridLineInterpolation === "polygon" && _.inverted && (I.startOnTick = !0, I.endOnTick = !0));
      }
      function G() {
        this.pane || (this.pane = []), this.options.pane = k(this.options.pane), this.options.pane.forEach((q) => {
          new T(q, this);
        }, this);
      }
      function P(q) {
        let Y = q.args.marker, I = this.chart.xAxis[0], _ = this.chart.yAxis[0], W = this.chart.inverted, X = W ? _ : I, z = W ? I : _;
        if (this.chart.polar) {
          q.preventDefault();
          let $ = (Y.attr ? Y.attr("start") : Y.start) - X.startAngleRad, K = Y.attr ? Y.attr("r") : Y.r, Q = (Y.attr ? Y.attr("end") : Y.end) - X.startAngleRad, Z = Y.attr ? Y.attr("innerR") : Y.innerR;
          q.result.x = $ + X.pos, q.result.width = Q - $, q.result.y = z.len + z.pos - K, q.result.height = K - Z;
        }
      }
      function y(q) {
        let Y = this.chart;
        if (Y.polar && Y.hoverPane && Y.hoverPane.axis) {
          q.preventDefault();
          let I = Y.hoverPane.center, _ = Y.mouseDownX || 0, W = Y.mouseDownY || 0, X = q.args.chartY, z = q.args.chartX, $ = 2 * Math.PI, K = Y.hoverPane.axis.startAngleRad, Q = Y.hoverPane.axis.endAngleRad, Z = Y.inverted ? Y.xAxis[0] : Y.yAxis[0], ee = {}, J = "arc";
          if (ee.x = I[0] + Y.plotLeft, ee.y = I[1] + Y.plotTop, this.zoomHor) {
            let ae = K > 0 ? Q - K : Math.abs(K) + Math.abs(Q), re = Math.atan2(W - Y.plotTop - I[1], _ - Y.plotLeft - I[0]) - K, ce = Math.atan2(X - Y.plotTop - I[1], z - Y.plotLeft - I[0]) - K;
            ee.r = I[2] / 2, ee.innerR = I[3] / 2, re <= 0 && (re += $), ce <= 0 && (ce += $), ce < re && (ce = [re, re = ce][0]), ae < $ && K + ce > Q + ($ - ae) / 2 && (ce = re, re = K <= 0 ? K : 0);
            let he = ee.start = Math.max(re + K, K), ne = ee.end = Math.min(ce + K, Q);
            if (Z.options.gridLineInterpolation === "polygon") {
              let te = Y.hoverPane.axis, se = he - te.startAngleRad + te.pos, oe = Z.getPlotLinePath({ value: Z.max }), ie = te.toValue(se), le = te.toValue(se + (ne - he));
              if (ie < te.getExtremes().min) {
                let { min: de, max: be } = te.getExtremes();
                ie = be - (de - ie);
              }
              if (le < te.getExtremes().min) {
                let { min: de, max: be } = te.getExtremes();
                le = be - (de - le);
              }
              le < ie && (le = [ie, ie = le][0]), (oe = l(oe, ie, le, te)).push(["L", I[0] + Y.plotLeft, Y.plotTop + I[1]]), ee.d = oe, J = "path";
            }
          }
          if (this.zoomVert) {
            let ae = Y.inverted ? Y.xAxis[0] : Y.yAxis[0], re = Math.sqrt(Math.pow(_ - Y.plotLeft - I[0], 2) + Math.pow(W - Y.plotTop - I[1], 2)), ce = Math.sqrt(Math.pow(z - Y.plotLeft - I[0], 2) + Math.pow(X - Y.plotTop - I[1], 2));
            if (ce < re && (re = [ce, ce = re][0]), ce > I[2] / 2 && (ce = I[2] / 2), re < I[3] / 2 && (re = I[3] / 2), this.zoomHor || (ee.start = K, ee.end = Q), ee.r = ce, ee.innerR = re, ae.options.gridLineInterpolation === "polygon") {
              let he = ae.toValue(ae.len + ae.pos - re), ne = ae.toValue(ae.len + ae.pos - ce), te = ae.getPlotLinePath({ value: ne }).concat(ae.getPlotLinePath({ value: he, reverse: !0 }));
              ee.d = te, J = "path";
            }
          }
          if (this.zoomHor && this.zoomVert && Z.options.gridLineInterpolation === "polygon") {
            let ae = Y.hoverPane.axis, re = ee.start || 0, ce = ee.end || 0, he = re - ae.startAngleRad + ae.pos, ne = ae.toValue(he), te = ae.toValue(he + (ce - re));
            if (ee.d instanceof Array) {
              let se = ee.d.slice(0, ee.d.length / 2), oe = ee.d.slice(ee.d.length / 2, ee.d.length);
              oe = [...oe].reverse();
              let ie = Y.hoverPane.axis;
              se = l(se, ne, te, ie), (oe = l(oe, ne, te, ie)) && (oe[0][0] = "L"), oe = [...oe].reverse(), ee.d = se.concat(oe), J = "path";
            }
          }
          q.attrs = ee, q.shapeType = J;
        }
      }
      function S() {
        let q = this.chart;
        q.polar && (this.polar = new V(this), q.inverted && (this.isRadialSeries = !0, this.is("column") && (this.isRadialBar = !0)));
      }
      function d() {
        if (this.chart.polar && this.xAxis) {
          let { xAxis: q, yAxis: Y } = this, I = this.chart;
          this.kdByAngle = I.tooltip && I.tooltip.shared, this.kdByAngle || I.inverted ? this.searchPoint = s : this.options.findNearestPointBy = "xy";
          let _ = this.points, W = _.length;
          for (; W--; ) this.is("column") || this.is("columnrange") || this.polar.toXY(_[W]), I.hasParallelCoordinates || this.yAxis.reversed || (M(_[W].y, Number.MIN_VALUE) < Y.min || _[W].x < q.min || _[W].x > q.max ? (_[W].isNull = !0, _[W].plotY = NaN) : _[W].isNull = _[W].isValid && !_[W].isValid());
          this.hasClipCircleSetter || (this.hasClipCircleSetter = !!this.eventsToUnbind.push(B(this, "afterRender", function() {
            let X;
            I.polar && this.options.clip !== !1 && (X = this.yAxis.pane.center, this.clipCircle ? this.clipCircle.animate({ x: X[0], y: X[1], r: X[2] / 2, innerR: X[3] / 2 }) : this.clipCircle = function(z, $, K, Q, Z) {
              let ee = m(), J = z.createElement("clipPath").attr({ id: ee }).add(z.defs), ae = Z ? z.arc($, K, Q, Z, 0, 2 * Math.PI).add(J) : z.circle($, K, Q).add(J);
              return ae.id = ee, ae.clipPath = J, ae;
            }(I.renderer, X[0], X[1], X[2] / 2, X[3] / 2), this.group.clip(this.clipCircle), this.setClip = n.noop);
          })));
        }
      }
      function s(q) {
        let Y = this.chart, I = this.xAxis, _ = this.yAxis, W = I.pane && I.pane.center, X = q.chartX - (W && W[0] || 0) - Y.plotLeft, z = q.chartY - (W && W[1] || 0) - Y.plotTop, $ = Y.inverted ? { clientX: q.chartX - _.pos, plotY: q.chartY - I.pos } : { clientX: 180 + -180 / Math.PI * Math.atan2(X, z) };
        return this.searchKDTree($);
      }
      function l(q, Y, I, _) {
        let W = _.tickInterval, X = _.tickPositions, z = f(X, (K) => K >= I), $ = f([...X].reverse(), (K) => K <= Y);
        return N(z) || (z = X[X.length - 1]), N($) || ($ = X[0], z += W, q[0][0] = "L", q.unshift(q[q.length - 3])), (q = q.slice(X.indexOf($), X.indexOf(z) + 1))[0][0] = "M", q;
      }
      function b(q, Y) {
        return f(this.pane || [], (I) => I.options.id === Y) || q.call(this, Y);
      }
      function u(q, Y, I, _, W, X) {
        let z, $, K, Q = this.chart, Z = M(_.inside, !!this.options.stacking);
        if (Q.polar) {
          if (z = Y.rectPlotX / Math.PI * 180, Q.inverted) this.forceDL = Q.isInsidePlot(Y.plotX, Y.plotY), Z && Y.shapeArgs ? ($ = Y.shapeArgs, W = x(W, { x: (K = this.yAxis.postTranslate((($.start || 0) + ($.end || 0)) / 2 - this.xAxis.startAngleRad, Y.barX + Y.pointWidth / 2)).x - Q.plotLeft, y: K.y - Q.plotTop })) : Y.tooltipPos && (W = x(W, { x: Y.tooltipPos[0], y: Y.tooltipPos[1] })), _.align = M(_.align, "center"), _.verticalAlign = M(_.verticalAlign, "middle");
          else {
            var ee;
            let J, ae;
            (ee = _).align === null && (J = z > 20 && z < 160 ? "left" : z > 200 && z < 340 ? "right" : "center", ee.align = J), ee.verticalAlign === null && (ae = z < 45 || z > 315 ? "bottom" : z > 135 && z < 225 ? "top" : "middle", ee.verticalAlign = ae), _ = ee;
          }
          r.prototype.alignDataLabel.call(this, Y, I, _, W, X), this.isRadialBar && Y.shapeArgs && Y.shapeArgs.start === Y.shapeArgs.end ? I.hide() : I.show();
        } else q.call(this, Y, I, _, W, X);
      }
      function c() {
        let q = this.options, Y = q.stacking, I = this.chart, _ = this.xAxis, W = this.yAxis, X = W.reversed, z = W.center, $ = _.startAngleRad, K = _.endAngleRad - $, Q = q.threshold, Z = 0, ee, J, ae, re, ce, he = 0, ne = 0, te, se, oe, ie, le, de, be, ge;
        if (_.isRadial) for (ae = (ee = this.points).length, re = W.translate(W.min), ce = W.translate(W.max), Q = q.threshold || 0, I.inverted && w(Q) && N(Z = W.translate(Q)) && (Z < 0 ? Z = 0 : Z > K && (Z = K), this.translatedThreshold = Z + $); ae--; ) {
          if (de = (J = ee[ae]).barX, se = J.x, oe = J.y, J.shapeType = "arc", I.inverted) {
            J.plotY = W.translate(oe), Y && W.stacking ? (le = W.stacking.stacks[(oe < 0 ? "-" : "") + this.stackKey], this.visible && le && le[se] && !J.isNull && (ie = le[se].points[this.getStackIndicator(void 0, se, this.index).key], he = W.translate(ie[0]), ne = W.translate(ie[1]), N(he) && (he = j.clamp(he, 0, K)))) : (he = Z, ne = J.plotY), he > ne && (ne = [he, he = ne][0]), X ? ne > re ? ne = re : he < ce ? he = ce : (he > re || ne < ce) && (he = ne = K) : he < re ? he = re : ne > ce ? ne = ce : (ne < re || he > ce) && (he = ne = 0), W.min > W.max && (he = ne = X ? K : 0), he += $, ne += $, z && (J.barX = de += z[3] / 2), be = Math.max(de, 0), ge = Math.max(de + J.pointWidth, 0);
            let me = q.borderRadius, fe = v((typeof me == "object" ? me.radius : me) || 0, ge - be);
            J.shapeArgs = { x: z[0], y: z[1], r: ge, innerR: be, start: he, end: ne, borderRadius: fe }, J.opacity = he === ne ? 0 : void 0, J.plotY = (N(this.translatedThreshold) && (he < this.translatedThreshold ? he : ne)) - $;
          } else he = de + $, J.shapeArgs = this.polar.arc(J.yBottom, J.plotY, he, he + J.pointWidth), J.shapeArgs.borderRadius = 0;
          this.polar.toXY(J), I.inverted ? (te = W.postTranslate(J.rectPlotY, de + J.pointWidth / 2), J.tooltipPos = [te.x - I.plotLeft, te.y - I.plotTop]) : J.tooltipPos = [J.plotX, J.plotY], z && (J.ttBelow = J.plotY > z[1]);
        }
      }
      function h(q, Y) {
        let I, _, W = this;
        if (this.chart.polar) {
          Y = Y || this.points;
          for (let z = 0; z < Y.length; z++) if (!Y[z].isNull) {
            I = z;
            break;
          }
          this.options.connectEnds !== !1 && I !== void 0 && (this.connectEnds = !0, Y.splice(Y.length, 0, Y[I]), _ = !0), Y.forEach((z) => {
            z.polarPlotY === void 0 && W.polar.toXY(z);
          });
        }
        let X = q.apply(this, [].slice.call(arguments, 1));
        return _ && Y.pop(), X;
      }
      function g(q, Y) {
        let I = this.chart, _ = { xAxis: [], yAxis: [] };
        return I.polar ? I.axes.forEach((W) => {
          if (W.coll === "colorAxis") return;
          let X = W.isXAxis, z = W.center, $ = Y.chartX - z[0] - I.plotLeft, K = Y.chartY - z[1] - I.plotTop;
          _[X ? "xAxis" : "yAxis"].push({ axis: W, value: W.translate(X ? Math.PI - Math.atan2($, K) : Math.sqrt(Math.pow($, 2) + Math.pow(K, 2)), !0) });
        }) : _ = q.call(this, Y), _;
      }
      function E(q, Y) {
        this.chart.polar || q.call(this, Y);
      }
      function R(q, Y) {
        let I = this, _ = this.chart, W = this.group, X = this.markerGroup, z = this.xAxis && this.xAxis.center, $ = _.plotLeft, K = _.plotTop, Q = this.options.animation, Z, ee, J, ae, re, ce;
        _.polar ? I.isRadialBar ? Y || (I.startAngleRad = M(I.translatedThreshold, I.xAxis.startAngleRad), n.seriesTypes.pie.prototype.animate.call(I, Y)) : (Q = D(Q), I.is("column") ? Y || (ee = z[3] / 2, I.points.forEach((he) => {
          J = he.graphic, re = (ae = he.shapeArgs) && ae.r, ce = ae && ae.innerR, J && ae && (J.attr({ r: ee, innerR: ee }), J.animate({ r: re, innerR: ce }, I.options.animation));
        })) : Y ? (Z = { translateX: z[0] + $, translateY: z[1] + K, scaleX: 1e-3, scaleY: 1e-3 }, W.attr(Z), X && X.attr(Z)) : (Z = { translateX: $, translateY: K, scaleX: 1, scaleY: 1 }, W.animate(Z, Q), X && X.animate(Z, Q))) : q.call(this, Y);
      }
      function L(q, Y, I, _) {
        let W, X;
        if (this.chart.polar)
          if (_) {
            let z = (X = function K(Q, Z, ee, J) {
              let ae, re, ce, he, ne, te, se = J ? 1 : 0, oe = (ae = Z >= 0 && Z <= Q.length - 1 ? Z : Z < 0 ? Q.length - 1 + Z : 0) - 1 < 0 ? Q.length - (1 + se) : ae - 1, ie = ae + 1 > Q.length - 1 ? se : ae + 1, le = Q[oe], de = Q[ie], be = le.plotX, ge = le.plotY, me = de.plotX, fe = de.plotY, Ae = Q[ae].plotX, ye = Q[ae].plotY;
              re = (1.5 * Ae + be) / 2.5, ce = (1.5 * ye + ge) / 2.5, he = (1.5 * Ae + me) / 2.5, ne = (1.5 * ye + fe) / 2.5;
              let xe = Math.sqrt(Math.pow(re - Ae, 2) + Math.pow(ce - ye, 2)), we = Math.sqrt(Math.pow(he - Ae, 2) + Math.pow(ne - ye, 2)), ke = Math.atan2(ce - ye, re - Ae);
              te = Math.PI / 2 + (ke + Math.atan2(ne - ye, he - Ae)) / 2, Math.abs(ke - te) > Math.PI / 2 && (te -= Math.PI), re = Ae + Math.cos(te) * xe, ce = ye + Math.sin(te) * xe;
              let Me = { rightContX: he = Ae + Math.cos(Math.PI + te) * we, rightContY: ne = ye + Math.sin(Math.PI + te) * we, leftContX: re, leftContY: ce, plotX: Ae, plotY: ye };
              return ee && (Me.prevPointCont = K(Q, oe, !1, J)), Me;
            }(Y, _, !0, this.connectEnds)).prevPointCont && X.prevPointCont.rightContX, $ = X.prevPointCont && X.prevPointCont.rightContY;
            W = ["C", w(z) ? z : X.plotX, w($) ? $ : X.plotY, w(X.leftContX) ? X.leftContX : X.plotX, w(X.leftContY) ? X.leftContY : X.plotY, X.plotX, X.plotY];
          } else W = ["M", I.plotX, I.plotY];
        else W = q.call(this, Y, I, _);
        return W;
      }
      function U(q, Y, I = this.plotY) {
        if (!this.destroyed) {
          let { plotX: _, series: W } = this, { chart: X } = W;
          return X.polar && w(_) && w(I) ? [_ + (Y ? X.plotLeft : 0), I + (Y ? X.plotTop : 0)] : q.call(this, Y, I);
        }
      }
      class V {
        static compose(Y, I, _, W, X, z, $, K, Q, Z) {
          if (T.compose(I, _), O.compose(Y, X), p(F, "Polar")) {
            let ee = I.prototype, J = z.prototype, ae = _.prototype, re = W.prototype;
            if (B(I, "afterDrawChartBox", C), B(I, "getAxes", G), B(I, "init", H), A(ee, "get", b), A(ae, "getCoordinates", g), A(ae, "pinch", E), B(_, "getSelectionMarkerAttrs", y), B(_, "getSelectionBox", P), B(W, "afterInit", S), B(W, "afterTranslate", d, { order: 2 }), B(W, "afterColumnTranslate", c, { order: 4 }), A(re, "animate", R), A(J, "pos", U), K) {
              let ce = K.prototype;
              A(ce, "alignDataLabel", u), A(ce, "animate", R);
            }
            if (Q && A(Q.prototype, "getGraphPath", h), Z) {
              let ce = Z.prototype;
              A(ce, "getPointSpline", L), $ && ($.prototype.getPointSpline = ce.getPointSpline);
            }
          }
        }
        constructor(Y) {
          this.series = Y;
        }
        arc(Y, I, _, W) {
          let X = this.series, z = X.xAxis.center, $ = X.yAxis.len, K = z[3] / 2, Q = $ - I + K, Z = $ - M(Y, $) + K;
          return X.yAxis.reversed && (Q < 0 && (Q = K), Z < 0 && (Z = K)), { x: z[0], y: z[1], r: Q, innerR: Z, start: _, end: W };
        }
        toXY(Y) {
          let I = this.series, _ = I.chart, W = I.xAxis, X = I.yAxis, z = Y.plotX, $ = _.inverted, K = Y.y, Q = Y.plotY, Z = $ ? z : X.len - Q, ee;
          if ($ && I && !I.isRadialBar && (Y.plotY = Q = w(K) ? X.translate(K) : 0), Y.rectPlotX = z, Y.rectPlotY = Q, X.center && (Z += X.center[3] / 2), w(Q)) {
            let J = $ ? X.postTranslate(Q, Z) : W.postTranslate(z, Z);
            Y.plotX = Y.polarPlotX = J.x - _.plotLeft, Y.plotY = Y.polarPlotY = J.y - _.plotTop;
          }
          I.kdByAngle ? ((ee = (z / Math.PI * 180 + W.pane.options.startAngle) % 360) < 0 && (ee += 360), Y.clientX = ee) : Y.clientX = Y.plotX;
        }
      }
      return V;
    }), a(e, "Core/Axis/WaterfallAxis.js", [e["Core/Globals.js"], e["Core/Axis/Stacking/StackItem.js"], e["Core/Utilities.js"]], function(o, n, r) {
      var T;
      let { composed: O } = o, { addEvent: j, objectEach: D, pushUnique: F } = r;
      return function(B) {
        function N() {
          let p = this.waterfall.stacks;
          p && (p.changed = !1, delete p.alreadyChanged);
        }
        function f() {
          let p = this.options.stackLabels;
          p && p.enabled && this.waterfall.stacks && this.waterfall.renderStackTotals();
        }
        function w() {
          this.waterfall || (this.waterfall = new M(this));
        }
        function x() {
          let p = this.axes;
          for (let v of this.series) if (v.options.stacking) {
            for (let k of p) k.isXAxis || (k.waterfall.stacks.changed = !0);
            break;
          }
        }
        B.compose = function(p, v) {
          F(O, "Axis.Waterfall") && (j(p, "init", w), j(p, "afterBuildStacks", N), j(p, "afterRender", f), j(v, "beforeRedraw", x));
        };
        class M {
          constructor(v) {
            this.axis = v, this.stacks = { changed: !1 };
          }
          renderStackTotals() {
            let v = this.axis, k = v.waterfall.stacks, m = v.stacking && v.stacking.stackTotalGroup, A = new n(v, v.options.stackLabels || {}, !1, 0, void 0);
            this.dummyStackItem = A, m && D(k, (C) => {
              D(C, (H, G) => {
                A.total = H.stackTotal, A.x = +G, H.label && (A.label = H.label), n.prototype.render.call(A, m), H.label = A.label, delete A.label;
              });
            }), A.total = null;
          }
        }
        B.Composition = M;
      }(T || (T = {})), T;
    }), a(e, "Series/Waterfall/WaterfallPoint.js", [e["Series/Column/ColumnSeries.js"], e["Core/Series/Point.js"], e["Core/Utilities.js"]], function(o, n, r) {
      let { isNumber: T } = r;
      class O extends o.prototype.pointClass {
        getClassName() {
          let D = n.prototype.getClassName.call(this);
          return this.isSum ? D += " highcharts-sum" : this.isIntermediateSum && (D += " highcharts-intermediate-sum"), D;
        }
        isValid() {
          return T(this.y) || this.isSum || !!this.isIntermediateSum;
        }
      }
      return O;
    }), a(e, "Series/Waterfall/WaterfallSeriesDefaults.js", [], function() {
      return { dataLabels: { inside: !0 }, lineWidth: 1, lineColor: "#333333", dashStyle: "Dot", borderColor: "#333333", states: { hover: { lineWidthPlus: 0 } } };
    }), a(e, "Series/Waterfall/WaterfallSeries.js", [e["Core/Series/SeriesRegistry.js"], e["Core/Utilities.js"], e["Core/Axis/WaterfallAxis.js"], e["Series/Waterfall/WaterfallPoint.js"], e["Series/Waterfall/WaterfallSeriesDefaults.js"]], function(o, n, r, T, O) {
      let { column: j, line: D } = o.seriesTypes, { addEvent: F, arrayMax: B, arrayMin: N, correctFloat: f, crisp: w, extend: x, isNumber: M, merge: p, objectEach: v, pick: k } = n;
      function m(C, H) {
        return Object.hasOwnProperty.call(C, H);
      }
      class A extends j {
        generatePoints() {
          j.prototype.generatePoints.apply(this);
          for (let H = 0, G = this.points.length; H < G; H++) {
            let P = this.points[H], y = this.processedYData[H];
            M(y) && (P.isIntermediateSum || P.isSum) && (P.y = f(y));
          }
        }
        processData(H) {
          let G, P, y, S, d, s, l = this.options, b = this.yData, u = l.data, c = b.length, h = l.threshold || 0;
          y = P = S = d = 0;
          for (let g = 0; g < c; g++) s = b[g], G = u && u[g] ? u[g] : {}, s === "sum" || G.isSum ? b[g] = f(y) : s === "intermediateSum" || G.isIntermediateSum ? (b[g] = f(P), P = 0) : (y += s, P += s), S = Math.min(y, S), d = Math.max(y, d);
          super.processData.call(this, H), l.stacking || (this.dataMin = S + h, this.dataMax = d);
        }
        toYData(H) {
          return H.isSum ? "sum" : H.isIntermediateSum ? "intermediateSum" : H.y;
        }
        updateParallelArrays(H, G) {
          super.updateParallelArrays.call(this, H, G), (this.yData[0] === "sum" || this.yData[0] === "intermediateSum") && (this.yData[0] = null);
        }
        pointAttribs(H, G) {
          let P = this.options.upColor;
          P && !H.options.color && M(H.y) && (H.color = H.y > 0 ? P : void 0);
          let y = j.prototype.pointAttribs.call(this, H, G);
          return delete y.dashstyle, y;
        }
        getGraphPath() {
          return [["M", 0, 0]];
        }
        getCrispPath() {
          var b;
          let H = this.data.filter((u) => M(u.y)), G = this.yAxis, P = H.length, y = ((b = this.graph) == null ? void 0 : b.strokeWidth()) || 0, S = this.xAxis.reversed, d = this.yAxis.reversed, s = this.options.stacking, l = [];
          for (let u = 1; u < P; u++) {
            if (!(this.options.connectNulls || M(this.data[H[u].index - 1].y))) continue;
            let c = H[u].box, h = H[u - 1], g = h.y || 0, E = H[u - 1].box;
            if (!c || !E) continue;
            let R = G.waterfall.stacks[this.stackKey], L = g > 0 ? -E.height : 0;
            if (R && E && c) {
              let U, V = R[u - 1];
              if (s) {
                let q = V.connectorThreshold;
                U = w(G.translate(q, !1, !0, !1, !0) + (d ? L : 0), y);
              } else U = w(E.y + (h.minPointLengthOffset || 0), y);
              l.push(["M", (E.x || 0) + (S ? 0 : E.width || 0), U], ["L", (c.x || 0) + (S && c.width || 0), U]);
            }
            if (E && l.length && (!s && g < 0 && !d || g > 0 && d)) {
              let U = l[l.length - 2];
              U && typeof U[2] == "number" && (U[2] += E.height || 0);
              let V = l[l.length - 1];
              V && typeof V[2] == "number" && (V[2] += E.height || 0);
            }
          }
          return l;
        }
        drawGraph() {
          D.prototype.drawGraph.call(this), this.graph && this.graph.attr({ d: this.getCrispPath() });
        }
        setStackedPoints(H) {
          var W;
          let G = this.options, P = (W = H.waterfall) == null ? void 0 : W.stacks, y = G.threshold || 0, S = this.stackKey, d = this.xData, s = d.length, l = y, b = l, u, c = 0, h = 0, g = 0, E, R, L, U, V, q, Y, I, _ = (X, z, $, K) => {
            if (u) {
              if (E) for (; $ < E; $++) u.stackState[$] += K;
              else u.stackState[0] = X, E = u.stackState.length;
              u.stackState.push(u.stackState[E - 1] + z);
            }
          };
          if (H.stacking && P && this.reserveSpace()) {
            I = P.changed, (Y = P.alreadyChanged) && 0 > Y.indexOf(S) && (I = !0), P[S] || (P[S] = {});
            let X = P[S];
            if (X) for (let z = 0; z < s; z++) (!X[q = d[z]] || I) && (X[q] = { negTotal: 0, posTotal: 0, stackTotal: 0, threshold: 0, stateIndex: 0, stackState: [], label: I && X[q] ? X[q].label : void 0 }), u = X[q], (V = this.yData[z]) >= 0 ? u.posTotal += V : u.negTotal += V, U = G.data[z], R = u.absolutePos = u.posTotal, L = u.absoluteNeg = u.negTotal, u.stackTotal = R + L, E = u.stackState.length, U && U.isIntermediateSum ? (_(g, h, 0, g), g = h, h = y, l ^= b, b ^= l, l ^= b) : U && U.isSum ? (_(y, c, E, 0), l = y) : (_(l, V, 0, c), U && (c += V, h += V)), u.stateIndex++, u.threshold = l, l += u.stackTotal;
            P.changed = !1, P.alreadyChanged || (P.alreadyChanged = []), P.alreadyChanged.push(S);
          }
        }
        getExtremes() {
          let H, G, P, y = this.options.stacking;
          return y ? (H = this.yAxis.waterfall.stacks, G = this.stackedYNeg = [], P = this.stackedYPos = [], y === "overlap" ? v(H[this.stackKey], function(S) {
            G.push(N(S.stackState)), P.push(B(S.stackState));
          }) : v(H[this.stackKey], function(S) {
            G.push(S.negTotal + S.threshold), P.push(S.posTotal + S.threshold);
          }), { dataMin: N(G), dataMax: B(P) }) : { dataMin: this.dataMin, dataMax: this.dataMax };
        }
      }
      return A.defaultOptions = p(j.defaultOptions, O), A.compose = r.compose, x(A.prototype, { pointValKey: "y", showLine: !0, pointClass: T }), F(A, "afterColumnTranslate", function() {
        let { options: C, points: H, yAxis: G } = this, P = k(C.minPointLength, 5), y = P / 2, S = C.threshold || 0, d = C.stacking, s = G.waterfall.stacks[this.stackKey], l = S, b = S, u, c, h, g;
        for (let E = 0; E < H.length; E++) {
          let R = H[E], L = this.processedYData[E], U = x({ x: 0, y: 0, width: 0, height: 0 }, R.shapeArgs || {});
          R.box = U;
          let V = [0, L], q = R.y || 0;
          if (d) {
            if (s) {
              let _ = s[E];
              d === "overlap" ? (c = _.stackState[_.stateIndex--], u = q >= 0 ? c : c - q, m(_, "absolutePos") && delete _.absolutePos, m(_, "absoluteNeg") && delete _.absoluteNeg) : (q >= 0 ? (c = _.threshold + _.posTotal, _.posTotal -= q, u = c) : (c = _.threshold + _.negTotal, _.negTotal -= q, u = c - q), !_.posTotal && M(_.absolutePos) && m(_, "absolutePos") && (_.posTotal = _.absolutePos, delete _.absolutePos), !_.negTotal && M(_.absoluteNeg) && m(_, "absoluteNeg") && (_.negTotal = _.absoluteNeg, delete _.absoluteNeg)), R.isSum || (_.connectorThreshold = _.threshold + _.stackTotal), G.reversed ? (h = q >= 0 ? u - q : u + q, g = u) : (h = u, g = u - q), R.below = h <= S, U.y = G.translate(h, !1, !0, !1, !0), U.height = Math.abs(U.y - G.translate(g, !1, !0, !1, !0));
              let W = G.waterfall.dummyStackItem;
              W && (W.x = E, W.label = s[E].label, W.setOffset(this.pointXOffset || 0, this.barW || 0, this.stackedYNeg[E], this.stackedYPos[E], void 0, this.xAxis));
            }
          } else u = Math.max(b, b + q) + V[0], U.y = G.translate(u, !1, !0, !1, !0), R.isSum ? (U.y = G.translate(V[1], !1, !0, !1, !0), U.height = Math.min(G.translate(V[0], !1, !0, !1, !0), G.len) - U.y, R.below = V[1] <= S) : R.isIntermediateSum ? (q >= 0 ? (h = V[1] + l, g = l) : (h = l, g = V[1] + l), G.reversed && (h ^= g, g ^= h, h ^= g), U.y = G.translate(h, !1, !0, !1, !0), U.height = Math.abs(U.y - Math.min(G.translate(g, !1, !0, !1, !0), G.len)), l += V[1], R.below = h <= S) : (U.height = L > 0 ? G.translate(b, !1, !0, !1, !0) - U.y : G.translate(b, !1, !0, !1, !0) - G.translate(b - L, !1, !0, !1, !0), b += L, R.below = b < S), U.height < 0 && (U.y += U.height, U.height *= -1);
          R.plotY = U.y, R.yBottom = U.y + U.height, U.height <= P && !R.isNull ? (U.height = P, U.y -= y, R.yBottom = U.y + U.height, R.plotY = U.y, q < 0 ? R.minPointLengthOffset = -y : R.minPointLengthOffset = y) : (R.isNull && (U.width = 0), R.minPointLengthOffset = 0);
          let Y = R.plotY + (R.negative ? U.height : 0);
          R.below && (R.plotY += U.height), R.tooltipPos && (this.chart.inverted ? R.tooltipPos[0] = G.len - Y : R.tooltipPos[1] = Y), R.isInside = this.isPointInside(R);
          let I = w(R.yBottom, this.borderWidth);
          U.y = w(U.y, this.borderWidth), U.height = I - U.y, p(!0, R.shapeArgs, U);
        }
      }, { order: 2 }), o.registerSeriesType("waterfall", A), A;
    }), a(e, "masters/highcharts-more.src.js", [e["Core/Globals.js"], e["Core/Series/SeriesRegistry.js"], e["Extensions/Pane/Pane.js"], e["Series/Bubble/BubbleSeries.js"], e["Series/PackedBubble/PackedBubbleSeries.js"], e["Series/PolarComposition.js"], e["Core/Axis/RadialAxis.js"], e["Series/Waterfall/WaterfallSeries.js"]], function(o, n, r, T, O, j, D, F) {
      return o.RadialAxis = D, T.compose(o.Axis, o.Chart, o.Legend), O.compose(o.Axis, o.Chart, o.Legend), r.compose(o.Chart, o.Pointer), j.compose(o.Axis, o.Chart, o.Pointer, o.Series, o.Tick, o.Point, n.seriesTypes.areasplinerange, n.seriesTypes.column, n.seriesTypes.line, n.seriesTypes.spline), F.compose(o.Axis, o.Chart), o;
    });
  });
})(yv);
var RL = yv.exports;
const NL = /* @__PURE__ */ fi(RL);
var xv = { exports: {} };
(function(i) {
  /**
  * Highcharts JS v11.4.8 (2024-08-29)
  *
  * Solid angular gauge module
  *
  * (c) 2010-2024 Torstein Honsi
  *
  * License: www.highcharts.com/license
  */
  (function(t) {
    i.exports ? (t.default = t, i.exports = t) : t(typeof Highcharts < "u" ? Highcharts : void 0);
  })(function(t) {
    var e = t ? t._modules : {};
    function a(o, n, r, T) {
      o.hasOwnProperty(n) || (o[n] = T.apply(null, r), typeof CustomEvent == "function" && t.win.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", { detail: { path: n, module: o[n] } })));
    }
    a(e, "Core/Axis/Color/ColorAxisLike.js", [e["Core/Color/Color.js"], e["Core/Utilities.js"]], function(o, n) {
      var r, T;
      let { parse: O } = o, { merge: j } = n;
      return (T = r || (r = {})).initDataClasses = function(D) {
        let F = this.chart, B = this.legendItem = this.legendItem || {}, N = this.options, f = D.dataClasses || [], w, x, M = F.options.chart.colorCount, p = 0, v;
        this.dataClasses = x = [], B.labels = [];
        for (let k = 0, m = f.length; k < m; ++k) w = j(w = f[k]), x.push(w), (F.styledMode || !w.color) && (N.dataClassColor === "category" ? (F.styledMode || (M = (v = F.options.colors || []).length, w.color = v[p]), w.colorIndex = p, ++p === M && (p = 0)) : w.color = O(N.minColor).tweenTo(O(N.maxColor), m < 2 ? 0.5 : k / (m - 1)));
      }, T.initStops = function() {
        let D = this.options, F = this.stops = D.stops || [[0, D.minColor || ""], [1, D.maxColor || ""]];
        for (let B = 0, N = F.length; B < N; ++B) F[B].color = O(F[B][1]);
      }, T.normalizedValue = function(D) {
        let F = this.max || 0, B = this.min || 0;
        return this.logarithmic && (D = this.logarithmic.log2lin(D)), 1 - (F - D) / (F - B || 1);
      }, T.toColor = function(D, F) {
        let B, N, f, w, x, M, p = this.dataClasses, v = this.stops;
        if (p) {
          for (M = p.length; M--; ) if (N = (x = p[M]).from, f = x.to, (N === void 0 || D >= N) && (f === void 0 || D <= f)) {
            w = x.color, F && (F.dataClass = M, F.colorIndex = x.colorIndex);
            break;
          }
        } else {
          for (B = this.normalizedValue(D), M = v.length; M-- && !(B > v[M][0]); ) ;
          N = v[M] || v[M + 1], B = 1 - ((f = v[M + 1] || N)[0] - B) / (f[0] - N[0] || 1), w = N.color.tweenTo(f.color, B);
        }
        return w;
      }, r;
    }), a(e, "Core/Axis/SolidGaugeAxis.js", [e["Core/Axis/Color/ColorAxisLike.js"], e["Core/Utilities.js"]], function(o, n) {
      let { extend: r } = n;
      return { init: function(T) {
        r(T, o);
      } };
    }), a(e, "Series/SolidGauge/SolidGaugeSeriesDefaults.js", [], function() {
      return { colorByPoint: !0, dataLabels: { y: 0 } };
    }), a(e, "Series/SolidGauge/SolidGaugeSeries.js", [e["Extensions/BorderRadius.js"], e["Core/Series/SeriesRegistry.js"], e["Core/Axis/SolidGaugeAxis.js"], e["Series/SolidGauge/SolidGaugeSeriesDefaults.js"], e["Core/Utilities.js"]], function(o, n, r, T, O) {
      let { gauge: j, pie: D } = n.seriesTypes, { clamp: F, extend: B, isNumber: N, merge: f, pick: w, pInt: x } = O;
      class M extends j {
        translate() {
          let v = this.yAxis;
          r.init(v), !v.dataClasses && v.options.dataClasses && v.initDataClasses(v.options), v.initStops(), j.prototype.translate.call(this);
        }
        drawPoints() {
          let v, k = this.yAxis, m = k.center, A = this.options, C = this.chart.renderer, H = A.overshoot, G = A.rounded && A.borderRadius === void 0, P = N(H) ? H / 180 * Math.PI : 0;
          for (let y of (N(A.threshold) && (v = k.startAngleRad + k.translate(A.threshold, void 0, void 0, void 0, !0)), this.thresholdAngleRad = w(v, k.startAngleRad), this.points)) if (!y.isNull) {
            let S = x(w(y.options.radius, A.radius, 100)) * m[2] / 200, d = x(w(y.options.innerRadius, A.innerRadius, 60)) * m[2] / 200, s = Math.min(k.startAngleRad, k.endAngleRad), l = Math.max(k.startAngleRad, k.endAngleRad), b = y.graphic, u = k.startAngleRad + k.translate(y.y, void 0, void 0, void 0, !0), c, h, g = k.toColor(y.y, y);
            g === "none" && (g = y.color || this.color || "none"), g !== "none" && (y.color = g), u = F(u, s - P, l + P), A.wrap === !1 && (u = F(u, s, l));
            let E = G ? (S - d) / 2 / S : 0, R = Math.min(u, this.thresholdAngleRad) - E, L = Math.max(u, this.thresholdAngleRad) + E;
            L - R > 2 * Math.PI && (L = R + 2 * Math.PI);
            let U = G ? "50%" : 0;
            A.borderRadius && (U = o.optionsToObject(A.borderRadius).radius), y.shapeArgs = c = { x: m[0], y: m[1], r: S, innerR: d, start: R, end: L, borderRadius: U }, y.startR = S, b ? (h = c.d, b.animate(B({ fill: g }, c)), h && (c.d = h)) : y.graphic = b = C.arc(c).attr({ fill: g, "sweep-flag": 0 }).add(this.group), this.chart.styledMode || (A.linecap !== "square" && b.attr({ "stroke-linecap": "round", "stroke-linejoin": "round" }), b.attr({ stroke: A.borderColor || "none", "stroke-width": A.borderWidth || 0 })), b && b.addClass(y.getClassName(), !0);
          }
        }
        animate(v) {
          v || (this.startAngleRad = this.thresholdAngleRad, D.prototype.animate.call(this, v));
        }
      }
      return M.defaultOptions = f(j.defaultOptions, T), n.registerSeriesType("solidgauge", M), M;
    }), a(e, "masters/modules/solid-gauge.src.js", [e["Core/Globals.js"]], function(o) {
      return o;
    });
  });
})(xv);
var FL = xv.exports;
const _L = /* @__PURE__ */ fi(FL);
var ua = /* @__PURE__ */ ((i) => (i.STANDARD = "standard", i.TARGET = "target", i.SUBDIVIDED = "subdivided", i))(ua || {}), _r = /* @__PURE__ */ ((i) => (i.NORMAL = "normal", i.TINTED = "tinted", i.FUNCTIONAL = "functional", i))(_r || {});
const ot = {
  beaconTagName: "beacon-gauge-chart",
  attribute: {
    name: "name",
    value: "value",
    valueSuffix: "value-suffix",
    valuePrefix: "value-prefix",
    metricDescription: "metric-description",
    gaugeTarget: "target",
    targetRange: "target-range",
    gaugeMin: "min",
    gaugeMax: "max",
    metricScale: "metric-scale",
    colorType: "color-type",
    hideMetric: "hide-metric",
    disableSort: "disable-sort",
    gaugeLabels: "gauge-labels",
    subdividedBands: "subdivided-bands",
    labelDistance: "label-distance",
    sections: "sections",
    hideLabels: "hide-labels"
  },
  plotBandThickness: "20%",
  minimumSizeJumbo: 272,
  // Minimum width of gauge chart for jumbo variant
  minimumSizeDefault: 198,
  // Minimum width of gauge chart for mini and normal variant
  margin: 20
  //margin is to make sure the gauge chart is not touching the edge of the container
}, UL = ve`.highcharts-grid-line{display:none}.highcharts-yaxis .highcharts-tick{stroke:var(--beacon-component-data-viz-color-border-minor);stroke-width:var(--beacon-system-width-border-mini)}.highcharts-dial,.highcharts-pivot,.highcharts-minor-grid-line,.highcharts-plot-lines-10,.hide-grid>.highcharts-grid-line{display:none}.gauge-value,.gauge-background,.gauge-target{cursor:pointer;fill-opacity:1}.gauge-tint-100{fill:var(--beacon-reference-palette-charts-dark-blue-dt-1)}.gauge-tint-legend-100{--beacon-chart-override-drilldown-series-color-0: $color}.gauge-tint-200{fill:var(--beacon-reference-palette-charts-dark-blue-dt-2)}.gauge-tint-legend-200{--beacon-chart-override-drilldown-series-color-0: $color}.gauge-tint-300{fill:var(--beacon-reference-palette-charts-dark-blue-dt-3)}.gauge-tint-legend-300{--beacon-chart-override-drilldown-series-color-0: $color}.gauge-tint-400{fill:var(--beacon-reference-palette-charts-dark-blue-dt-4)}.gauge-tint-legend-400{--beacon-chart-override-drilldown-series-color-0: $color}.gauge-tint-500{fill:var(--beacon-reference-palette-charts-dark-blue-dt-5)}.gauge-tint-legend-500{--beacon-chart-override-drilldown-series-color-0: $color}:host(*){--gauge-chart-functional-color-fill-1: var(--beacon-reference-palette-functional-red-3);--gauge-chart-functional-color-fill-2: #ed6e11;--gauge-chart-functional-color-fill-3: #ffad00;--gauge-chart-functional-color-fill-4: #248647}:host(*) .gauge-functional-100{fill:var(--gauge-chart-functional-color-fill-1)}:host(*) .gauge-functional-legend-100{--beacon-chart-override-drilldown-series-color-0: $color}:host(*) .gauge-functional-200{fill:var(--gauge-chart-functional-color-fill-2)}:host(*) .gauge-functional-legend-200{--beacon-chart-override-drilldown-series-color-0: $color}:host(*) .gauge-functional-300{fill:var(--gauge-chart-functional-color-fill-3)}:host(*) .gauge-functional-legend-300{--beacon-chart-override-drilldown-series-color-0: $color}:host(*) .gauge-functional-400{fill:var(--gauge-chart-functional-color-fill-4)}:host(*) .gauge-functional-legend-400{--beacon-chart-override-drilldown-series-color-0: $color}.gauge-target{fill:var(--beacon-component-scrollbar-color-background-track)}.gauge-background{fill:var(--beacon-system-color-background-1);stroke:var(--beacon-component-data-viz-color-border-minor);stroke-width:var(--beacon-system-width-border-mini)}.highcharts-axis-labels{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-300)}.key-fact{text-align:center;transform:translateY(calc(-1 * var(--key-fact-transform)));white-space:normal;word-wrap:break-word}.key-fact.jumbo{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-600);--key-fact-transform: var(--beacon-reference-font-scale-13)}.key-fact.mini{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-200);--key-fact-transform: var(--beacon-reference-font-scale-7)}.key-fact.normal{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-400);--key-fact-transform: var(--beacon-reference-font-scale-9)}.key-fact-description{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-headline-100);overflow-wrap:break-word;white-space:pre-wrap;word-wrap:break-word}.highcharts-legend .highcharts-legend-item .highcharts-point{display:none}.highcharts-color-0{fill:var(--beacon-system-color-data-viz-0)}`;
var jL = Object.defineProperty, Et = (i, t, e, a) => {
  for (var o = void 0, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = r(t, e, o) || o);
  return o && jL(t, e, o), o;
};
function $L(i) {
  return !!Array.isArray(i.plotLinesAndBands);
}
function HL(i) {
  return typeof i.pane == "number";
}
function pg(i) {
  return "metricHTML" in i;
}
function KL(i) {
  return i.html !== void 0;
}
const { beaconTagName: ug } = ot;
NL(zo);
_L(zo);
var yt;
const Ct = (yt = class extends Ke(ct).with(
  un,
  Ds
) {
  constructor() {
    super(...arguments), this.beaconTagName = ug, this.gaugeName = "Standard", this.gaugeValueProp = 0, this.valueSuffix = "", this.valuePrefix = "", this.metricDescription = "", this.gaugeTarget = 0, this.targetRange = 0, this.gaugeMin = 0, this.gaugeMax = 100, this.variant = ua.STANDARD, this.metricScale = tn.NORMAL, this.colorType = _r.NORMAL, this.hideMetric = !1, this.disableSort = !1, this.gaugeLabels = [], this.subdividedBandsProp = [], this.labelDistance = 12, this.sections = 2, this.hideLabels = !1, this.staticLegend = !0, this.isChartUpdated = !1, this.resizeObserver = new ResizeObserver(
      Io(() => {
        this.chart && (this.isChartUpdated || (this.chart.update({
          chart: {
            marginTop: this.calculateChartMarginTop()
          }
        }), this.isChartUpdated = !0), this.setMinimumGaugeSize(this.chart), this.renderMetric(this.chart), yt.renderTicks(this.chart, this.variant), this.chart.redraw(), this.variant === ua.SUBDIVIDED && yt.plotBandHover(this.chart));
      }, 200)
      // The debounce function delays the execution of the function by 200 milliseconds to avoid excessive computations when the size of the chart changes rapidly
    ), this._type = Jt.GAUGE;
  }
  static get styles() {
    return [super.styles, UL];
  }
  /**
   * Hover state for plot band for Subdivided variant only
   */
  static plotBandHover(t) {
    const e = t.yAxis[0];
    $L(e) && e.plotLinesAndBands.forEach(function(a) {
      zo.addEvent(a.svgElem.element, "mouseover", function() {
        e.plotLinesAndBands.forEach(function(o) {
          o !== a && o.svgElem.element.classList.contains("gauge-value") && o.svgElem.attr({
            opacity: 0.2
          });
        });
      }), zo.addEvent(a.svgElem.element, "mouseout", function() {
        e.plotLinesAndBands.forEach(function(o) {
          o.svgElem.attr({
            opacity: 1
            // Restore the original opacity
          });
        });
      });
    });
  }
  /**
   * Sets the gauge value to the sum of the subdivided bands otherwise returns what is passed via the prop
   */
  get gaugeValue() {
    let t = 0;
    return this.variant === ua.SUBDIVIDED ? t = this.subdividedBands.reduce((e, a) => e + a[1], 0) : t = this.gaugeValueProp, t <= this.gaugeMax && t >= this.gaugeMin ? t : t > this.gaugeMax ? (console.error("Gauge value too large"), this.gaugeMax) : (console.error("Gauge value too small"), this.gaugeMin);
  }
  /**
   * Generates the series based on the variant, so that gauge chart can have multiple legends
   */
  generateSeries() {
    return this.variant === ua.SUBDIVIDED ? this.subdividedBands.map((t) => ({
      name: t[0],
      // use the first element of the band array as the name
      type: this.type,
      showInLegend: !0,
      data: [t[1]],
      // assuming band[1] is the band's value
      dataLabels: {
        enabled: !1
      }
    })) : [
      {
        name: this.variant.charAt(0).toUpperCase() + this.variant.slice(1),
        type: this.type,
        showInLegend: !0,
        data: [this.gaugeValue],
        dataLabels: {
          enabled: !1
        }
      }
    ];
  }
  /**
   * Calculates the interval between ticks based on the number of  sections.
   */
  get tickInterval() {
    return (this.gaugeMax - this.gaugeMin) / this.labelSections;
  }
  /**
   * Auto-sorts subdivided bands unless disableSort prop is set
   */
  get subdividedBands() {
    return this.disableSort ? this.subdividedBandsProp : [...this.subdividedBandsProp].sort((t, e) => e[1] - t[1]);
  }
  /**
   * Returns padded label array for Highcharts API
   */
  get labels() {
    return ["", ...this.gaugeLabels, ""];
  }
  formatLabels(t) {
    if (this.gaugeLabels.length > 0) {
      const e = Math.round(t.pos / this.tickInterval);
      return this.labels[e];
    } else
      return Math.round(t.pos).toString();
  }
  /**
   * When labels are more than 2 digit, then it overlaps the gauge chart.
   * To avoid this, we are setting the text-anchor attribute based on label position.
   * if label is on left side of the chart, then text-anchor will be 'end'
   * if
   */
  static setTextAnchor(t) {
    var a;
    const e = t.yAxis[0];
    for (const o in e.ticks) {
      const r = (a = e.ticks[o].label) == null ? void 0 : a.element;
      if (!r)
        return;
      const T = r.getBBox();
      let O = "middle";
      T.x < t.plotWidth / 2 ? O = "end" : T.x > t.plotWidth / 2 && (O = "start"), r.setAttribute("text-anchor", O);
    }
  }
  /**
   * This method adjusts the minimum size of the gauge chart based on the current chart size.
   * It calculates the chart width (which is the same as the pane size) and sets a minimum pane size.
   * If the size of the pane is less than the minimum size, it adjusts the size of the pane.
   * This ensures that the gauge chart is always displayed at an appropriate size, regardless of the size of the chart container.
   * @param chart - The Highcharts.Chart instance for which the minimum gauge size is to be set.
   */
  setMinimumGaugeSize(t) {
    const e = t.plotWidth, a = this.minimumGaugeSize;
    t.update({
      pane: {
        size: e < a ? a : "85%"
        // Diameter of the pane
      }
    });
  }
  /**
   * Set plot bands based on variant and band values
   */
  get plotBands() {
    const t = [
      yt.plotBandObject(
        this.gaugeMin,
        this.gaugeMax,
        "gauge-background"
      )
    ];
    return this.variant !== ua.SUBDIVIDED ? t.push(...this.singleColorMode()) : t.push(...this.subdividedColorMode()), t;
  }
  /**
   * Sets a tint based on the relative value of the gauge
   */
  get tintIndex() {
    let t;
    this.variant === ua.TARGET && this.gaugeTarget > this.gaugeValue ? t = (this.gaugeTarget - this.gaugeMin) / this.sections : t = (this.gaugeMax - this.gaugeMin) / this.sections;
    const e = Math.ceil((this.gaugeValue - this.gaugeMin) / t);
    return e > 4 ? 4 : e;
  }
  /**
   * Sets text labels sections when provided
   */
  get labelSections() {
    return this.gaugeLabels.length ? this.gaugeLabels.length + 1 : this.sections;
  }
  /**
   * Queries the plot band SVG element to find the center of the chart
   */
  get chartCenter() {
    var a;
    const t = (a = this.shadowRoot) == null ? void 0 : a.querySelector(
      ".highcharts-plot-bands-0"
    );
    if (!t)
      return { x: 0, y: 0 };
    const e = t.getBBox();
    return {
      x: e.x + e.width / 2,
      y: e.y + e.height
    };
  }
  /**
   * This getter method retrieves the width of the gauge chart.
   * It queries the SVG element of the gauge chart and retrieves its bounding box.
   * The width of the bounding box is then returned as the width of the gauge chart.
   * @returns The width of the gauge chart, or 0 if the SVG element of the gauge chart cannot be found.
   */
  get chartWidth() {
    var a;
    const t = (a = this.shadowRoot) == null ? void 0 : a.querySelector(
      ".highcharts-plot-bands-0"
    );
    if (!t)
      return 0;
    const e = t.getBBox();
    return Math.round(e.width);
  }
  /**
   * This getter method retrieves the height of the gauge chart.
   * It queries the SVG element of the gauge chart and retrieves its bounding box.
   * The height of the bounding box is then returned as the height of the gauge chart.
   * @returns The height of the gauge chart, or 0 if the SVG element of the gauge chart cannot be found.
   */
  get chartHeight() {
    var a;
    const t = (a = this.shadowRoot) == null ? void 0 : a.querySelector(
      ".highcharts-plot-bands-0"
    );
    if (!t)
      return 0;
    const e = t.getBBox();
    return Math.round(e.height);
  }
  /**
   * Formats display string for gauge metric value based on props provided
   */
  metricDisplayValue() {
    if (this.gaugeValue != null) {
      if (this.percentage) {
        const t = this.gaugeValue - this.gaugeMin, e = this.gaugeMax - this.gaugeMin;
        return (t / e * 100).toFixed(
          this.decimal ? this.decimalPlaces : 0
        ) + "%";
      }
      return `${this.valuePrefix}${this.gaugeValue.toFixed(this.decimal ? this.decimalPlaces : 0)}${this.valueSuffix}`;
    }
    return "N/A";
  }
  /**
   * Template string of the metric placed in the center of the chart
   */
  metricHTML(t) {
    return `<div class="key-fact ${this.metricScale}" style="width: ${t}px">
    <div class="key-fact-main">${this.metricDisplayValue()}</div>
    ${this.metricDescription ? `<div class="key-fact-description">${this.metricDescription}</div>` : ""}
  </div>`;
  }
  /**
   * Gauge specific component Highcharts API options
   */
  get localComponentOptions() {
    const t = this.variant, e = this;
    return ct.createChartOptions(super.localComponentOptions, {
      chart: {
        plotBorderWidth: 0,
        margin: ot.margin,
        // this margin is to make sure the gauge chart is not touching the edge of the container
        events: {
          load: function() {
            yt.renderTicks(this, t), yt.setTextAnchor(this), e.resizeObserver.observe(e);
          },
          redraw: function() {
            yt.setTextAnchor(this);
          }
        }
      },
      series: this.generateSeries(),
      pane: {
        startAngle: -90,
        endAngle: 90,
        background: void 0,
        center: ["50%", "50%"],
        size: "85%"
        // The 'size' property sets the diameter of the gauge chart as a percentage of the total plot area. Here, it is set to '85%', meaning the gauge chart will occupy 85% of the total plot area.
      },
      yAxis: {
        min: this.gaugeMin,
        max: this.gaugeMax,
        labels: {
          enabled: !this.hideLabels,
          distance: this.labelDistance,
          formatter: this.formatLabels.bind(this)
        },
        plotBands: this.plotBands,
        tickInterval: this.tickInterval,
        tickLength: 0
      }
    });
  }
  /**
   * This function calculates the top margin for the chart. It is specifically designed to handle the positioning of the gauge chart within its container.
   * The function calculates the difference between the current position of the gauge chart and the position of the container.
   * For smaller screens, the function adjusts the top margin to ensure that there is no overlap between the export button and the gauge chart.
   * The calculated margin is then applied to the chart to position it correctly within the container.
   */
  calculateChartMarginTop() {
    var t, e, a, o;
    if (this.chart) {
      const n = (t = this.chart) == null ? void 0 : t.legend;
      n && n.update({
        x: 0,
        y: 0
      });
      const r = (e = this.chartContainer) == null ? void 0 : e.querySelector(
        ".highcharts-plot-bands-0"
      ), T = r ? r.getBoundingClientRect().top : 0, O = (a = this.chartContainer) == null ? void 0 : a.getBoundingClientRect().top;
      let j = 0;
      return ((o = this.chartContainer) == null ? void 0 : o.clientWidth) < Zt.MEDIUM && (j = T - O + ot.margin), this.calculateLegendOffset(this.chart), -j;
    } else
      return 0;
  }
  /**
   * This method calculates the offset required to correctly position the legend in the chart.
   * It is executed with a delay to ensure that all elements in the chart are fully rendered before the calculation.
   * It retrieves the current positions of the legend and the gauge chart, calculates the required offset,
   * and then updates the y property of the legend with the calculated offset.
   * Finally, it calls the `calculateChartBlockSize` function to adjust the size of the chart block based on the new position of the legends.
   * @param chart - The Highcharts.Chart instance for which the legend offset is to be calculated.
   */
  calculateLegendOffset(t) {
    t && setTimeout(() => {
      var T, O, j;
      const e = (O = (T = t == null ? void 0 : t.legend) == null ? void 0 : T.group) == null ? void 0 : O.element, a = e ? e.getBoundingClientRect().top : 0, o = (j = this.chartContainer) == null ? void 0 : j.querySelector(
        ".highcharts-plot-bands-0"
      ), n = o ? o.getBoundingClientRect().bottom : 0, r = a - n - ot.margin;
      this.updateChart({
        legend: {
          y: -r
        }
      }), this.calculateChartBlockSize(t);
    }, 100);
  }
  /**
   * This method calculates the total height of the chart block and sets it as the block size of the chart.
   * The method first checks if the legend exists in the chart. If it does, it calculates the bottom position of the legends and the top position of the container,
   * and sets the difference as the block size of the chart. If the legend does not exist, it calculates the bottom position of the gauge chart and the top position of the container,
   * adds an offset of 20, and sets this value as the block size of the chart.
   * @param chart - The Highcharts.Chart instance for which the block size is to be calculated.
   */
  calculateChartBlockSize(t) {
    var o, n, r, T, O;
    if (!t) return;
    let e;
    const a = ((o = this.chartContainer) == null ? void 0 : o.getBoundingClientRect().top) || 0;
    if ((r = (n = t.legend) == null ? void 0 : n.group) != null && r.element) {
      const j = (T = this.chartContainer) == null ? void 0 : T.querySelector(
        ".highcharts-legend-box"
      );
      e = (j ? j.getBoundingClientRect().bottom : 0) - a;
    } else {
      const j = (O = this.chartContainer) == null ? void 0 : O.querySelector(
        ".highcharts-plot-bands-0"
      );
      e = (j ? j.getBoundingClientRect().bottom : 0) - a + ot.margin;
    }
    this.chartContainer.style.blockSize = e + "px";
  }
  /**
   * This getter method retrieves the minimum size of the gauge chart.
   * The minimum size is determined based on the metric scale and whether the metric is hidden.
   * If the metric scale is 'JUMBO' and the metric is not hidden, the minimum size is set to the constant 'minimumSizeJumbo'.
   * Otherwise, the minimum size is set to the constant 'minimumSizeDefault'.
   * @returns The minimum size of the gauge chart.
   */
  get minimumGaugeSize() {
    return this.metricScale === tn.JUMBO && !this.hideMetric ? ot.minimumSizeJumbo : ot.minimumSizeDefault;
  }
  /**
   * Helper function to define gauge plot bands
   *
   * TODO: Add tooltip interaction in this function
   * @param from start of plot band
   * @param to end of plot band
   * @param className CSS class name applied to plot band
   * @param label to name the band
   * @returns object of plot band with tooltip data and positioning logic
   */
  static plotBandObject(t, e, a) {
    return {
      from: t,
      to: e,
      className: a,
      thickness: ot.plotBandThickness
    };
  }
  /**
   * Logic to identify which plot bands are applied based on the gauge
   *
   * @returns plot band array for single color gauge
   */
  singleColorMode() {
    const t = [], e = (a) => yt.plotBandObject(
      this.gaugeMin,
      this.gaugeValue,
      a
    );
    switch (this.variant === ua.TARGET && (this.targetRange > 0 ? t.push(
      yt.plotBandObject(
        this.gaugeTarget,
        this.gaugeTarget + this.targetRange,
        "gauge-target"
      )
    ) : t.push(
      yt.plotBandObject(
        this.gaugeValue,
        this.gaugeTarget,
        "gauge-target"
      )
    )), this.colorType) {
      case _r.NORMAL:
        t.push(e("gauge-value highcharts-color-0"));
        break;
      case _r.TINTED:
        t.push(e(`gauge-value gauge-tint-${this.tintIndex}00`));
        break;
      case _r.FUNCTIONAL:
        t.push(
          e(`gauge-value gauge-functional-${this.tintIndex}00`)
        );
        break;
      default:
        t.push(e("gauge-value highcharts-color-0"));
        break;
    }
    return t;
  }
  /**
   * Logic to identify which plot bands are applied based on the gauge
   *
   * @returns plot band array for subdivided color gauge
   */
  subdividedColorMode() {
    const t = [];
    let e = this.gaugeMin;
    const a = parseFloat(Dd);
    for (const o in this.subdividedBands) {
      const n = this.subdividedBands[o];
      t.push(
        yt.plotBandObject(
          e,
          e + n[1] - a,
          `subdivided gauge-value highcharts-color-${o}`
        )
      ), e += n[1];
    }
    return t;
  }
  /**
   * Renders the ticks on the gauge chart
   * @param chart
   */
  static renderTicks(t, e) {
    var a, o;
    if (t && HL(t)) {
      let n = 0;
      const r = Array.isArray(t.pane) ? t.pane[0] : t.pane, { center: T } = r;
      T && T.length && (typeof T[2] == "number" ? n = T[2] / 2 : typeof T[2] == "string" && (n = parseInt(T[2], 10) / 2));
      let O = n * 0.2;
      e === ua.SUBDIVIDED && (O = 0), t.update({ yAxis: { tickLength: O } });
      const { ticks: j } = t.yAxis[0].ticks, D = Object.entries(j);
      D.length && ((a = D[0][1]) == null || a.mark.hide(), (o = D[D.length - 1][1]) == null || o.mark.hide());
    }
  }
  /**
   * Renders the metric based on the center of the chart
   *
   * @param chart Highcharts chart
   */
  renderMetric(t) {
    var e, a, o, n;
    if (this.hideMetric)
      pg(t) && ((n = t.metricHTML) == null || n.css({
        display: "none"
      }));
    else {
      const { x: r, y: T } = this.chartCenter, O = this.metricDescription ? this.metricDescription.length : 0, j = (e = this.shadowRoot) == null ? void 0 : e.querySelector(
        ".highcharts-plot-bands-0"
      );
      let D = 0;
      const F = this.chartWidth * 0.64;
      j && (D = j.getBBox().height);
      const B = D * (this.metricDescription ? 0.05 : 0.07), N = (a = this.shadowRoot) == null ? void 0 : a.querySelector(
        ".key-fact-description"
      );
      let f = 0, w = 0;
      if (N) {
        const k = N.getBoundingClientRect();
        f = k.width, w = k.height;
      }
      let x = 0, M = 6;
      O >= 28 && (x = w > 28 ? f / O : 0, M = Math.min(O, 50));
      const p = O == 0 ? 0 : 24 + x, v = T + B - M - p;
      pg(t) && t.metricHTML !== null ? t.metricHTML.attr({
        text: this.metricHTML(F),
        x: r,
        y: v,
        width: F
        // Set the width here
      }).css({
        display: "initial"
      }) : KL(t.renderer) && (t.metricHTML = (o = t.renderer) == null ? void 0 : o.html(this.metricHTML(F), r, v).attr({
        align: "center",
        width: F
        // Set the width here
      }).add());
    }
  }
  /**
   * Chart redraw lifecycle hook to render metric
   *
   * @param chart Highcharts chart
   */
  onChartRedraw() {
    this.chart && (this.renderMetric(this.chart), yt.renderTicks(this.chart, this.variant), yt.setTextAnchor(this.chart));
  }
  /**
   * Chart load lifecycle hook to render metric
   *
   * @param chart Highcharts chart
   */
  onChartLoad() {
    this.chart && (this.renderMetric(this.chart), yt.renderTicks(this.chart, this.variant));
  }
  willUpdate(t) {
    var e;
    (e = super.willUpdate) == null || e.call(this, t), this.chart && ((t.has("metricDescription") || t.has("hideMetric") || t.has("metricScale") || t.has("disableLegend") || t.has("percentage") || t.has("decimal") || t.has("valuePrefix") || t.has("valueSuffix") || t.has("gaugeValueProp") || t.has("decimalPlaces")) && this.renderMetric(this.chart), (t.has("colorType") || t.has("variant") || t.has("gaugeTarget") || t.has("targetRange") || t.has("gaugeValueProp") || t.has("sections")) && this.updateChart({
      yAxis: { plotBands: this.plotBands, tickInterval: this.tickInterval }
    }), (t.has("disableLegend") || t.has("variant")) && yt.renderTicks(this.chart, this.variant), t.has("disableSort") && this.updateChart({
      yAxis: { plotBands: this.plotBands },
      series: this.generateSeries()
    }), t.has("labelDistance") && this.updateChart({
      yAxis: { labels: { distance: this.labelDistance } }
    }), t.has("labels") && this.updateChart({
      yAxis: { labels: { formatter: this.formatLabels.bind(this) } }
    }), t.has("hideLabels") && this.updateChart({ yAxis: { labels: { enabled: !this.hideLabels } } }));
  }
}, yt.tagName = ug, yt);
Et([
  ue({ attribute: ot.attribute.name })
], Ct.prototype, "gaugeName");
Et([
  ue({ attribute: ot.attribute.value, type: Number })
], Ct.prototype, "gaugeValueProp");
Et([
  ue({ attribute: ot.attribute.valueSuffix })
], Ct.prototype, "valueSuffix");
Et([
  ue({ attribute: ot.attribute.valuePrefix })
], Ct.prototype, "valuePrefix");
Et([
  ue({ attribute: ot.attribute.metricDescription })
], Ct.prototype, "metricDescription");
Et([
  ue({ attribute: ot.attribute.gaugeTarget, type: Number })
], Ct.prototype, "gaugeTarget");
Et([
  ue({ attribute: ot.attribute.targetRange, type: Number })
], Ct.prototype, "targetRange");
Et([
  ue({ attribute: ot.attribute.gaugeMin, type: Number })
], Ct.prototype, "gaugeMin");
Et([
  ue({ attribute: ot.attribute.gaugeMax, type: Number })
], Ct.prototype, "gaugeMax");
Et([
  ue()
], Ct.prototype, "variant");
Et([
  ue({ attribute: ot.attribute.metricScale })
], Ct.prototype, "metricScale");
Et([
  ue({ attribute: ot.attribute.colorType })
], Ct.prototype, "colorType");
Et([
  ue({ type: Boolean, attribute: ot.attribute.hideMetric })
], Ct.prototype, "hideMetric");
Et([
  ue({ type: Boolean, attribute: ot.attribute.disableSort })
], Ct.prototype, "disableSort");
Et([
  ue({ attribute: ot.attribute.gaugeLabels, type: Object })
], Ct.prototype, "gaugeLabels");
Et([
  ue({ attribute: ot.attribute.subdividedBands, type: Object })
], Ct.prototype, "subdividedBandsProp");
Et([
  ue({ type: Number, attribute: ot.attribute.labelDistance })
], Ct.prototype, "labelDistance");
Et([
  ue({ type: Number, attribute: ot.attribute.sections })
], Ct.prototype, "sections");
Et([
  ue({ type: Boolean, attribute: ot.attribute.hideLabels })
], Ct.prototype, "hideLabels");
let ez = Ct;
var wv = /* @__PURE__ */ ((i) => (i.STANDARD = "standard", i.SIDE_BLOCK = "side-block", i.TABBED = "tabbed", i.SPLIT_MEDIA = "split-media", i))(wv || {});
const kv = (i, t = []) => {
  if (!i)
    return;
  for (const a of t) {
    const o = i.querySelector(a);
    if (o)
      return o;
  }
  const e = Array.from(i.children);
  if (e.length)
    for (const a of e) {
      const o = kv(
        a,
        t
      );
      if (o)
        return o;
    }
}, GL = (i, t, e) => {
  if (i) {
    e();
    {
      const a = {
        childList: !0,
        subtree: !0
      };
      new MutationObserver(() => {
        e();
      }).observe(i, a);
    }
    return !1;
  }
  return !0;
}, WL = ve`:root[beacon-tag-name=beacon-hero],:root [beacon-tag-name=beacon-hero],[beacon-version="4.3.1"][class*=beacon-on][beacon-tag-name=beacon-hero],[beacon-version="4.3.1"][class*=beacon-on] [beacon-tag-name=beacon-hero],[class*=beacon-on] [beacon-version="4.3.1"][beacon-tag-name=beacon-hero],[class*=beacon-on] [beacon-version="4.3.1"] [beacon-tag-name=beacon-hero],[beacon-version="4.3.1"][beacon-tag-name=beacon-hero],[beacon-version="4.3.1"] [beacon-tag-name=beacon-hero]{--hero-media-inline-size-media-sizing: 100%;--hero-color-background: var(--beacon-system-color-background-0);--hero-content-padding-block-end: var(--beacon-system-space-organism-jumbo);--hero-content-padding-inline: var(--beacon-system-space-organism-jumbo);--hero-content-padding-block-start: var(--beacon-system-space-organism-jumbo);--hero-content-backdrop-filter: none;--hero-title-font: var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-loose-500);--hero-standfirst-font: var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-headline-loose-300);--hero-info-font: var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-loose-300);--hero-eyebrow-text-transform: none;--hero-container-padding: calc(var(--hero-content-padding-inline) * 2);--hero-notch-size: var(--beacon-system-radius-corner-standard);--hero-content-color-background: var(--beacon-system-color-background-0);--hero-space-overlap: initial;--hero-media-space-grid-rows: initial;--hero-title-space-margin: 0;--hero-media-space-grid-columns: initial;--hero-cta-space-gap: var(--beacon-reference-space-5);--hero-size-min-block-size: initial;--hero-notch-space: 0;--hero-no-notch-space-padding-block-end: 0;--hero-no-notch-space-padding-block-start: 0;--hero-media-size-jumbo: auto;--hero-media-size-normal: auto;--hero-media-size-mini: auto}:root[beacon-tag-name=beacon-hero][variant=split-media],:root [beacon-tag-name=beacon-hero][variant=split-media],[beacon-version="4.3.1"][class*=beacon-on][beacon-tag-name=beacon-hero][variant=split-media],[beacon-version="4.3.1"][class*=beacon-on] [beacon-tag-name=beacon-hero][variant=split-media],[class*=beacon-on] [beacon-version="4.3.1"][beacon-tag-name=beacon-hero][variant=split-media],[class*=beacon-on] [beacon-version="4.3.1"] [beacon-tag-name=beacon-hero][variant=split-media],[beacon-version="4.3.1"][beacon-tag-name=beacon-hero][variant=split-media],[beacon-version="4.3.1"] [beacon-tag-name=beacon-hero][variant=split-media]{--hero-title-font: var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-loose-400);--hero-standfirst-font: var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-loose-200)}:root[beacon-tag-name=beacon-hero]:not(:is([no-notch],[no-media])),:root [beacon-tag-name=beacon-hero]:not(:is([no-notch],[no-media])),[beacon-version="4.3.1"][class*=beacon-on][beacon-tag-name=beacon-hero]:not(:is([no-notch],[no-media])),[beacon-version="4.3.1"][class*=beacon-on] [beacon-tag-name=beacon-hero]:not(:is([no-notch],[no-media])),[class*=beacon-on] [beacon-version="4.3.1"][beacon-tag-name=beacon-hero]:not(:is([no-notch],[no-media])),[class*=beacon-on] [beacon-version="4.3.1"] [beacon-tag-name=beacon-hero]:not(:is([no-notch],[no-media])),[beacon-version="4.3.1"][beacon-tag-name=beacon-hero]:not(:is([no-notch],[no-media])),[beacon-version="4.3.1"] [beacon-tag-name=beacon-hero]:not(:is([no-notch],[no-media])){--hero-content-max-inline-size: calc(var(--beacon-system-breakpoint-xx-large) + var(--hero-container-padding))}@media screen and (width >= 375px){:root[beacon-tag-name=beacon-hero][variant=side-block],:root [beacon-tag-name=beacon-hero][variant=side-block],[beacon-version="4.3.1"][class*=beacon-on][beacon-tag-name=beacon-hero][variant=side-block],[beacon-version="4.3.1"][class*=beacon-on] [beacon-tag-name=beacon-hero][variant=side-block],[class*=beacon-on] [beacon-version="4.3.1"][beacon-tag-name=beacon-hero][variant=side-block],[class*=beacon-on] [beacon-version="4.3.1"] [beacon-tag-name=beacon-hero][variant=side-block],[beacon-version="4.3.1"][beacon-tag-name=beacon-hero][variant=side-block],[beacon-version="4.3.1"] [beacon-tag-name=beacon-hero][variant=side-block]{--hero-standfirst-font: var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-loose-200)}}@media (width >= 640px){:root[beacon-tag-name=beacon-hero],:root [beacon-tag-name=beacon-hero],[beacon-version="4.3.1"][class*=beacon-on][beacon-tag-name=beacon-hero],[beacon-version="4.3.1"][class*=beacon-on] [beacon-tag-name=beacon-hero],[class*=beacon-on] [beacon-version="4.3.1"][beacon-tag-name=beacon-hero],[class*=beacon-on] [beacon-version="4.3.1"] [beacon-tag-name=beacon-hero],[beacon-version="4.3.1"][beacon-tag-name=beacon-hero],[beacon-version="4.3.1"] [beacon-tag-name=beacon-hero]{--hero-title-font: var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-loose-600)}:root[beacon-tag-name=beacon-hero][variant=side-block],:root [beacon-tag-name=beacon-hero][variant=side-block],[beacon-version="4.3.1"][class*=beacon-on][beacon-tag-name=beacon-hero][variant=side-block],[beacon-version="4.3.1"][class*=beacon-on] [beacon-tag-name=beacon-hero][variant=side-block],[class*=beacon-on] [beacon-version="4.3.1"][beacon-tag-name=beacon-hero][variant=side-block],[class*=beacon-on] [beacon-version="4.3.1"] [beacon-tag-name=beacon-hero][variant=side-block],[beacon-version="4.3.1"][beacon-tag-name=beacon-hero][variant=side-block],[beacon-version="4.3.1"] [beacon-tag-name=beacon-hero][variant=side-block]{--hero-standfirst-margin-block-start: var(--beacon-system-space-micro-mini)}}@media (width >= 960px){:root[beacon-tag-name=beacon-hero],:root [beacon-tag-name=beacon-hero],[beacon-version="4.3.1"][class*=beacon-on][beacon-tag-name=beacon-hero],[beacon-version="4.3.1"][class*=beacon-on] [beacon-tag-name=beacon-hero],[class*=beacon-on] [beacon-version="4.3.1"][beacon-tag-name=beacon-hero],[class*=beacon-on] [beacon-version="4.3.1"] [beacon-tag-name=beacon-hero],[beacon-version="4.3.1"][beacon-tag-name=beacon-hero],[beacon-version="4.3.1"] [beacon-tag-name=beacon-hero]{--hero-content-padding-block-end: var(--beacon-reference-space-9);--hero-content-padding-inline: var(--beacon-reference-space-9);--hero-content-padding-block-start: var(--beacon-reference-space-7);--hero-space-overlap: 68px;--hero-media-space-grid-rows: 56px;--hero-title-space-margin: 1.5rem;--hero-media-space-grid-columns: 56px;--hero-size-min-block-size: 468px;--hero-notch-size: var(--beacon-reference-space-2);--hero-notch-space: 4.25rem;--hero-no-notch-space-padding-block-end: var(--beacon-reference-space-9);--hero-no-notch-space-padding-block-start: var(--beacon-reference-space-16);--hero-media-size-jumbo: 29.25rem;--hero-media-size-normal: 24.25rem;--hero-media-size-mini: 19.25rem}:root[beacon-tag-name=beacon-hero][variant=side-block],:root [beacon-tag-name=beacon-hero][variant=side-block],[beacon-version="4.3.1"][class*=beacon-on][beacon-tag-name=beacon-hero][variant=side-block],[beacon-version="4.3.1"][class*=beacon-on] [beacon-tag-name=beacon-hero][variant=side-block],[class*=beacon-on] [beacon-version="4.3.1"][beacon-tag-name=beacon-hero][variant=side-block],[class*=beacon-on] [beacon-version="4.3.1"] [beacon-tag-name=beacon-hero][variant=side-block],[beacon-version="4.3.1"][beacon-tag-name=beacon-hero][variant=side-block],[beacon-version="4.3.1"] [beacon-tag-name=beacon-hero][variant=side-block]{--hero-additional-content-padding-inline: var(--beacon-system-space-cell-free-floating);--hero-content-color-background: var(--beacon-system-color-background-0);--hero-standfirst-padding-inline: var(--beacon-system-space-cell-free-floating);--hero-info-padding-inline: var(--beacon-system-space-cell-free-floating);--hero-title-padding-inline: var(--beacon-system-space-cell-free-floating);--hero-eyebrow-padding-inline: var(--beacon-system-space-cell-free-floating);--hero-cta-padding-inline: var(--beacon-system-space-cell-free-floating);--hero-content-padding-block-end: calc(var(--beacon-system-space-organism-normal) + var(--beacon-reference-space-7));--hero-content-padding-inline: calc(var(--beacon-system-space-organism-normal) + var(--beacon-reference-space-7));--hero-content-padding-block-start: calc(var(--beacon-system-space-organism-normal) + var(--beacon-reference-space-7))}:root[beacon-tag-name=beacon-hero][variant=side-block]:not([contained]),:root [beacon-tag-name=beacon-hero][variant=side-block]:not([contained]),[beacon-version="4.3.1"][class*=beacon-on][beacon-tag-name=beacon-hero][variant=side-block]:not([contained]),[beacon-version="4.3.1"][class*=beacon-on] [beacon-tag-name=beacon-hero][variant=side-block]:not([contained]),[class*=beacon-on] [beacon-version="4.3.1"][beacon-tag-name=beacon-hero][variant=side-block]:not([contained]),[class*=beacon-on] [beacon-version="4.3.1"] [beacon-tag-name=beacon-hero][variant=side-block]:not([contained]),[beacon-version="4.3.1"][beacon-tag-name=beacon-hero][variant=side-block]:not([contained]),[beacon-version="4.3.1"] [beacon-tag-name=beacon-hero][variant=side-block]:not([contained]){--hero-content-color-background: var(--beacon-system-color-background-1)}}@media (width >= 1280px){:root[beacon-tag-name=beacon-hero],:root [beacon-tag-name=beacon-hero],[beacon-version="4.3.1"][class*=beacon-on][beacon-tag-name=beacon-hero],[beacon-version="4.3.1"][class*=beacon-on] [beacon-tag-name=beacon-hero],[class*=beacon-on] [beacon-version="4.3.1"][beacon-tag-name=beacon-hero],[class*=beacon-on] [beacon-version="4.3.1"] [beacon-tag-name=beacon-hero],[beacon-version="4.3.1"][beacon-tag-name=beacon-hero],[beacon-version="4.3.1"] [beacon-tag-name=beacon-hero]{--hero-content-padding-block-end: var(--beacon-reference-space-13);--hero-content-padding-inline: var(--beacon-reference-space-13);--hero-content-padding-block-start: var(--beacon-reference-space-12);--hero-space-overlap: 104px;--hero-media-space-grid-rows: 88px;--hero-media-space-grid-columns: 88px;--hero-cta-space-gap: var(--beacon-reference-space-7);--hero-size-min-block-size: 584px;--hero-notch-space: var(--beacon-reference-space-18);--hero-no-notch-space-padding-block-end: var(--beacon-reference-space-13);--hero-media-size-jumbo: 36.5rem;--hero-media-size-normal: 29rem;--hero-media-size-mini: 21.5rem}:root[beacon-tag-name=beacon-hero][variant=standard],:root [beacon-tag-name=beacon-hero][variant=standard],[beacon-version="4.3.1"][class*=beacon-on][beacon-tag-name=beacon-hero][variant=standard],[beacon-version="4.3.1"][class*=beacon-on] [beacon-tag-name=beacon-hero][variant=standard],[class*=beacon-on] [beacon-version="4.3.1"][beacon-tag-name=beacon-hero][variant=standard],[class*=beacon-on] [beacon-version="4.3.1"] [beacon-tag-name=beacon-hero][variant=standard],[beacon-version="4.3.1"][beacon-tag-name=beacon-hero][variant=standard],[beacon-version="4.3.1"] [beacon-tag-name=beacon-hero][variant=standard]{--hero-content-inline-size: calc(calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 12 + var(--beacon-system-space-gutter) * 11) + var(--hero-container-padding))}}@media (width >= 1600px){:root[beacon-tag-name=beacon-hero],:root [beacon-tag-name=beacon-hero],[beacon-version="4.3.1"][class*=beacon-on][beacon-tag-name=beacon-hero],[beacon-version="4.3.1"][class*=beacon-on] [beacon-tag-name=beacon-hero],[class*=beacon-on] [beacon-version="4.3.1"][beacon-tag-name=beacon-hero],[class*=beacon-on] [beacon-version="4.3.1"] [beacon-tag-name=beacon-hero],[beacon-version="4.3.1"][beacon-tag-name=beacon-hero],[beacon-version="4.3.1"] [beacon-tag-name=beacon-hero]{--hero-space-overlap: 176px;--hero-media-margin-inline: auto;--hero-media-space-grid-columns: calc((100% - calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 12 + var(--beacon-system-space-gutter) * 11)) / 2);--media-inset-inline-start: 0;--media-inset-inline-end: 0}}`, Oi = {
  beaconTagName: "beacon-hero",
  withBylineClassName: "with-byline",
  mediaNodes: ["img", "video"],
  fullBleedClassName: "beacon-hero-img-full-bleed",
  DATA_METRICS_LOCATION_HERO: "MQ"
}, qL = ve`.beacon-hero-img-full-bleed{--hero-media-max-block-size-media-sizing: auto;aspect-ratio:2/1;box-sizing:border-box;display:block;inline-size:var(--hero-media-inline-size-media-sizing, 100vw);margin-inline:var(--hero-media-margin-inline, calc(50% - 50vw) );max-block-size:var(--hero-media-max-block-size-media-sizing);min-block-size:var(--hero-media-min-block-size-media-sizing);object-fit:cover}[beacon-tag-name=beacon-hero][variant=side-block] .beacon-hero-img-full-bleed{--min-hero-block-size: var(--hero-size-min-block-size);--hero-media-min-block-size-media-sizing: var(--min-hero-block-size)}[beacon-tag-name=beacon-hero][variant=side-block][contained] .beacon-hero-img-full-bleed{--hero-media-max-block-size-media-sizing: 100%;--hero-media-min-block-size-media-sizing: var(--hero-size-min-block-size)}[beacon-tag-name=beacon-hero][scale=mini]:not([contained]) .beacon-hero-img-full-bleed{--hero-media-max-block-size-media-sizing: var(--hero-media-size-mini)}[beacon-tag-name=beacon-hero][scale=normal]:not([contained]) .beacon-hero-img-full-bleed{--hero-media-max-block-size-media-sizing: var(--hero-media-size-normal)}[beacon-tag-name=beacon-hero][scale=jumbo]:not([contained]) .beacon-hero-img-full-bleed{--hero-media-max-block-size-media-sizing: var(--hero-media-size-jumbo)}[beacon-tag-name=beacon-hero] [slot=media] *{block-size:100%;inline-size:100%}@supports (block-size: -webkit-fill-available){[beacon-tag-name=beacon-hero] [slot=media] .video-js{block-size:-webkit-fill-available}}[beacon-tag-name=beacon-hero] a{color:var(--beacon-system-color-text-link)}[beacon-tag-name=beacon-hero] a:not(:is(:hover,:focus)){text-decoration:none}[beacon-tag-name=beacon-hero] [slot=eyebrow]{color:var(--beacon-system-color-text-standard);font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-caption-loose-300);margin:0}[beacon-tag-name=beacon-hero] [slot=page-title]{color:var(--beacon-system-color-text-standard);font:var(--hero-title-font, var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-headline-500));margin:0}[beacon-tag-name=beacon-hero] .beacon-hero__standfirst,[beacon-tag-name=beacon-hero] [slot=standfirst]{color:var(--beacon-system-color-text-standard);font:var(--hero-standfirst-font, var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-headline-300))}[beacon-tag-name=beacon-hero] [slot=details]{font:var(--hero-info-font, var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-300))}[beacon-tag-name=beacon-hero] [slot=cta]{inline-size:var(--cta-button-width, 100%)}[beacon-tag-name=beacon-hero][variant=split-media] [slot=eyebrow]{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-caption-loose-200)}[beacon-tag-name=beacon-hero] p{margin:0}[beacon-tag-name=beacon-hero] img,[beacon-tag-name=beacon-hero] video{aspect-ratio:2/1;box-sizing:border-box;display:block;inline-size:var(--hero-media-inline-size-media-sizing, 100vw);margin-inline:var(--hero-media-margin-inline, calc(50% - 50vw) );max-block-size:var(--hero-media-max-block-size-media-sizing);min-block-size:var(--hero-media-min-block-size-media-sizing);object-fit:cover}[beacon-tag-name=beacon-hero] [slot=additionalContent]{grid-area:additional}[beacon-tag-name=beacon-hero] [slot=additionalContent]:not(.empty){margin-block-start:var(--beacon-system-space-micro-jumbo);padding-inline:var(--hero-additional-content-padding-inline, initial)}[beacon-tag-name=beacon-hero] [slot=toolbelt]{align-items:center;display:flex;grid-area:toolbelt;justify-content:var(--toolbelt-spacing)}[beacon-tag-name=beacon-hero] [slot=toolbelt]:not(.empty){padding-block:var(--beacon-system-space-cell-free-floating);padding-inline:var(--hero-toolbelt-padding-inline, 0)}[beacon-tag-name=beacon-hero] [slot=media]{grid-column:var(--media-grid-column, initial);grid-row:var(--media-grid-row, initial)}[beacon-tag-name=beacon-hero] [slot=media]>img,[beacon-tag-name=beacon-hero] [slot=media]:not(picture){background-color:var(--media-background-color);block-size:var(--media-block-size, initial);display:var(--media-display, block);inline-size:100%;inset-block-start:var(--media-inset-block-start, initial);inset-inline:var(--media-inset-inline-start, initial) var(--media-inset-inline-end, initial);justify-content:var(--media-justify-content, initial);margin:0;margin-inline:var(--hero-media-margin-inline, 0);max-inline-size:var(--media-max-inline-size, var(--beacon-system-breakpoint-xxx-large));position:var(--media-position, initial)}@media (width >= 640px){[beacon-tag-name=beacon-hero] [slot=toolbelt]{gap:var(--beacon-reference-space-1)}}@media (width >= 960px){[beacon-tag-name=beacon-hero][variant=split-media] :is(img,picture){block-size:100%;inline-size:100%;max-block-size:none;position:absolute}}`, VL = ve`@media (prefers-reduced-motion: no-preference){:host([motion-state=enabled]:is([variant=side-block],[variant=standard],[variant=split-media])) .content{animation-delay:var(--beacon-reference-motion-duration-7);animation-duration:var(--beacon-reference-motion-duration-12);animation-fill-mode:forwards;animation-timing-function:var(--beacon-system-motion-easing-decelerate-emphasize-1);opacity:var(--hero-content-opacity, initial)}}@media (prefers-reduced-motion: no-preference) and (width >= 640px){:host([motion-state=enabled]:is([variant=side-block],[variant=standard],[variant=split-media])){--hero-content-opacity: 0}:host([motion-state=enabled]:is([variant=standard],[variant=split-media],[variant=side-block]:not([contained])).b-motion-viewed) .content{animation-name:intro-from-bottom}@keyframes intro-from-bottom{0%{opacity:0;transform:translateY(calc(1 * var(--motion-translate-intro-override, var(--motion-translate-intro-micro))))}to{opacity:1;transform:translateY(0)}}:host([motion-state=enabled][variant=side-block][contained].b-motion-viewed) .content,:host([motion-state=enabled][variant=side-block][contained].intro-from-bottom.b-motion-viewed) .content,:host([motion-state=enabled][variant=side-block][contained].intro-from-left.b-motion-viewed) .content{animation-name:intro-from-bottom}}@media (prefers-reduced-motion: no-preference) and (width >= 960px){@keyframes intro-from-left{0%{opacity:0;transform:translate(calc(-1 * var(--motion-translate-intro-override, var(--motion-translate-intro-micro))))}to{opacity:1;transform:translate(0)}}:host([motion-state=enabled][variant=side-block][contained].intro-from-left.b-motion-viewed) .content{animation-name:intro-from-left}}`;
var YL = Object.getOwnPropertyDescriptor, QL = (i, t, e, a) => {
  for (var o = a > 1 ? void 0 : a ? YL(t, e) : t, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = r(o) || o);
  return o;
};
function XL(i) {
  let t = class extends i {
    static get HeroMotionStyles() {
      return [VL];
    }
  };
  return t = QL([
    je("HeroMotion")
  ], t), t;
}
const ZL = ve`:host{--hero-media-max-block-size-media-sizing: auto;--hero-override-byline-padding-block-start: 0;--hero-override-byline-margin: 0;--hero-content-grid-template: "eyebrow eyebrow" "title title" "standfirst standfirst" "info toolbelt" "cta cta" "additional additional";--title-container-layout-margin: calc(2 * var(--hero-title-space-margin));--title-container-width: calc(100% - var(--title-container-layout-margin));--toolbelt-spacing: space-between;--hero-content-padding-block-end: var(--beacon-reference-space-7);--hero-content-padding-block-start: var(--beacon-reference-space-7);--max-grid-size: min(calc(100% - calc(2 * var(--hero-media-space-grid-columns))), var(--beacon-system-breakpoint-xx-large));background-color:var(--beacon-custom-hero-backdrop-color-background, var(--hero-color-background));display:var(--hero-display, block);grid-template-columns:var(--hero-content-grid-template-columns, initial);grid-template-rows:var(--hero-content-grid-template-rows, initial);min-block-size:var(--hero-size-min-block-size);position:var(--hero-position, initial)}:host *{margin:0}:host([variant=split-media]){min-block-size:0}.shell:not(.split-media){display:contents}.shell:not(.split-media) .media-wrapper{display:contents}.shell.split-media{background-color:var(--beacon-system-color-background-1);max-inline-size:var(--beacon-system-breakpoint-xxx-large)}.shell.split-media .content{--hero-content-color-background: transparent;align-items:start;display:flex;flex-direction:column;justify-content:center;padding:var(--beacon-system-space-organism-jumbo)}.shell.split-media .media-wrapper{position:relative}@media (width >= 960px){.shell.split-media{display:grid;grid-auto-columns:1fr;grid-auto-flow:column;margin-inline:auto}.shell.split-media.right .media-wrapper{grid-column:2/3;grid-row:1/2}.shell.split-media.right .content{grid-column:1/2;grid-row:1/2}}.cta-wrapper{display:flex;flex-direction:var(--cta-direction, column);gap:var(--hero-cta-space-gap);grid-area:cta;grid-column:1/3}.cta-wrapper:not(.empty){margin-block-start:var(--beacon-system-space-micro-jumbo);padding-block:var(--beacon-system-space-cell-free-floating, initial);padding-inline:var(--hero-cta-padding-inline, initial)}.content{-webkit-backdrop-filter:var(--hero-content-backdrop-filter, blur(var(--beacon-reference-space-7)));backdrop-filter:var(--hero-content-backdrop-filter, blur(var(--beacon-reference-space-7)));background-color:var(--beacon-custom-hero-color-background, var(--hero-content-color-background, var(--hero-color-background)));block-size:var(--hero-content-block-size, initial);border-end-end-radius:var(--hero-content-border-end-end-radius, var(--hero-content-border-radius, initial));border-end-start-radius:var(--hero-content-border-end-start-radius, var(--hero-content-border-radius, initial));border-start-end-radius:var(--hero-content-border-start-end-radius, var(--hero-content-border-radius, var(--hero-notch-size)));border-start-start-radius:var(--hero-content-border-start-start-radius, var(--hero-content-border-radius, var(--hero-notch-size)));box-sizing:var(--hero-content-box-sizing, inherit);display:flex;flex-direction:column;grid-column:var(--hero-content-grid-column, initial);grid-row:var(--hero-content-grid-row, initial);inline-size:var(--hero-content-inline-size);justify-content:var(--hero-content-justify-content, initial);margin-inline:var(--hero-content-margin-inline);max-inline-size:var(--hero-content-max-inline-size, 1232px);place-self:var(--hero-content-vertical-align, initial) var(--hero-content-justify-self, initial);position:var(--hero-content-position, relative);z-index:1;padding-inline:var(--hero-content-padding-inline);padding-block-end:var(--hero-content-padding-block-end, initial);padding-block-start:var(--hero-content-padding-block-start, initial)}.content>*:not(:empty,.empty){padding-block:var(--hero-content-padding-block, var(--beacon-reference-space-2));padding-inline:var(--hero-content-padding-inline, 0)}.with-byline:after{content:" -"}@media (width < 960px){::slotted([slot=byline]){margin:0}}.eyebrow,::slotted([slot=eyebrow]){color:var(--beacon-system-color-text-standard, currentcolor);font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-caption-loose-300);grid-area:eyebrow;text-transform:var(--hero-eyebrow-text-transform, uppercase)}.eyebrow:not(.empty){padding-block:var(--beacon-system-space-cell-free-floating, initial);padding-inline:var(--hero-eyebrow-padding-inline, initial)}.page-title,::slotted([slot=page-title]){color:var(--beacon-system-color-text-standard);font:var(--hero-title-font, var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-headline-500));grid-area:title;margin:0}.page-title:not(.empty){padding-block:var(--beacon-system-space-cell-free-floating) var(--hero-title-padding-block-end, var(--beacon-system-space-cell-free-floating));padding-inline:var(--hero-title-padding-inline, initial)}.standfirst,::slotted([slot=standfirst]){color:var(--beacon-system-color-text-standard);font:var(--hero-standfirst-font, var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-headline-300));grid-area:standfirst;margin:0}.standfirst:not(.empty){margin-block-start:var(--hero-standfirst-margin-block-start, initial);padding-block:var(--beacon-system-space-cell-free-floating);padding-inline:var(--hero-standfirst-padding-inline, initial)}.info,::slotted([slot=details]){color:var(--hero-info-color, currentcolor);display:flex;flex-direction:row;flex-wrap:wrap;font:var(--hero-info-font, var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-300));gap:var(--beacon-reference-space-2);grid-area:info}.info:not(.empty){padding-block:var(--beacon-system-space-cell-free-floating);padding-inline:var(--hero-info-padding-inline, initial)}:host([scale=mini]){--hero-media-max-block-size-media-sizing: var(--hero-media-size-mini)}:host([scale=normal]){--hero-media-max-block-size-media-sizing: var(--hero-media-size-normal)}:host([scale=jumbo]){--hero-media-max-block-size-media-sizing: var(--hero-media-size-jumbo)}@media screen and (width >= 375px){:host{--hero-title-font: var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-headline-600)}}@media (width >= 640px){:host{--toolbelt-spacing: end}:host([variant=side-block]),:host([variant=split-media]){--cta-direction: row;--cta-button-width: auto}.content{display:grid;grid-template-areas:var(--hero-content-grid-template)}::slotted([slot=toolbelt]){gap:var(--beacon-reference-space-1)}}@media (width >= 960px){:host([variant=standard]){--hero-content-inline-size: var(--title-container-width);--hero-content-margin-inline: auto}:host([variant=standard]:not(:is([no-notch],[no-media]))){--hero-content-border-radius: var(--hero-notch-size);--hero-display: grid;--hero-content-grid-template-rows: 1fr var(--hero-notch-space) auto;--hero-content-grid-template-columns: minmax(var(--max-grid-size), 1fr);--hero-content-grid-column: 1/2;--media-grid-column: 1/2;--media-grid-row: 1/3;--hero-content-grid-row: 2/4}:host([variant=standard]:is([no-notch],[no-media])){--hero-content-max-inline-size: 100%}:host([contained]){--hero-position: initial;--media-position: initial}.info{align-items:center;flex-direction:row;inline-size:max-content}:host([no-notch]),:host([no-media]),:host([variant=side-block]){--hero-content-position: static;--hero-content-padding-block-start: var(--hero-no-notch-space-padding-block-start);--hero-content-padding-block-end: var(--hero-no-notch-space-padding-block-end)}:host([variant=side-block][scale=mini]),:host([variant=side-block][scale=normal]){--hero-media-max-block-size-media-sizing: var(--hero-media-size-normal)}:host([variant=side-block]){--hero-backdrop-color-background: transparent;--hero-content-padding-inline: var(--beacon-reference-space-12);--hero-content-padding-block-start: var(--beacon-reference-space-12);--hero-content-padding-block-end: var(--beacon-reference-space-12);--hero-display: grid;--hero-content-border-radius: var(--hero-notch-size);--hero-content-inline-size: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 6 + var(--beacon-system-space-gutter) * 5);--hero-content-bottom-radius: var(--hero-notch-size);--hero-content-position: static;--media-block-size: 100%;--hero-title-padding-block-end: var(--beacon-system-space-cell-free-floating)}:host([variant=side-block]),:host([variant=split-media]){--cta-button-width: 100%;--cta-direction: column}:host([variant=side-block][orientation=left]){--hero-content-justify-self: start}:host([variant=side-block][orientation=right]){--hero-content-justify-self: end}:host([variant=side-block][contained]){--hero-content-grid-template-columns: minmax(var(--hero-media-space-grid-columns), 1fr) minmax(var(--max-grid-size), 1fr) minmax(var(--hero-media-space-grid-columns), 1fr);--hero-content-grid-template-rows: var(--hero-media-space-grid-rows) 1fr var(--hero-media-space-grid-rows) ;--hero-content-grid-column: 2/3;--hero-content-grid-row: 2/3;--hero-content-vertical-align: start;--media-grid-column: 1/4;--media-grid-row: 1/4;--hero-position: relative;--media-position: absolute;--media-inset-block-start: 0}:host([variant=side-block]:not([contained])){--hero-content-grid-template-columns: minmax(var(--hero-media-space-grid-columns), 1fr) minmax(var(--max-grid-size), 1fr) minmax(var(--hero-media-space-grid-columns), 1fr);--hero-content-grid-template-rows: var(--hero-media-space-grid-rows) 1fr var(--hero-space-overlap) ;--hero-content-grid-column: 2/3;--hero-content-grid-row: -1/-3;--hero-content-vertical-align: end;--media-grid-column: 1/4;--media-grid-row: 1/3}}@media (width >= 1280px){:host([variant=side-block]),:host([variant=split-media]){--cta-direction: row;--cta-button-width: auto}}@media (width >= 1920px){:host(:not([variant=side-block])){--hero-color-background: var(--beacon-system-color-background-0);--media-background-color: var(--hero-color-background);--media-display: flex;--media-justify-content: center}}`;
var JL = Object.defineProperty, eO = Object.getOwnPropertyDescriptor, mt = (i, t, e, a) => {
  for (var o = a > 1 ? void 0 : a ? eO(t, e) : t, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = (a ? r(t, e, o) : r(o)) || o);
  return a && o && JL(t, e, o), o;
};
const Mb = class Mb extends Ke(Le).with(
  XL,
  ff({ autoRemoveMotionClasses: !1, threshold: 0.5 })
) {
  constructor() {
    super(...arguments), this.beaconTagName = Oi.beaconTagName, this.scale = tn.NORMAL, this.hideNotch = !1, this.noMedia = !1, this.contained = !1, this.variant = wv.STANDARD, this.dataMetricsLocation = Oi.DATA_METRICS_LOCATION_HERO, this.orientation = _h.LEFT, this.waitForMediaSlot = !0, this.addMutationObserver = !0, this.mediaSlotChange = () => {
      this.slottedMediaNode && this.waitForMediaSlot && (this.waitForMediaSlot = !1, this.slottedMediaNode.classList.add(Oi.fullBleedClassName));
    };
  }
  static get styles() {
    return [super.styles, ZL, this.HeroMotionStyles, this.motionStyles];
  }
  static get lightDOMStyles() {
    return [...super.lightDOMStyles, qL, WL];
  }
  get hasEyebrowContent() {
    return this.eyebrowSlot.length > 0;
  }
  get hasTitleContent() {
    return this.pageTitleSlot.length > 0;
  }
  get hasStandfirstContent() {
    return this.standfirstSlot.length > 0;
  }
  get hasCtaContent() {
    var t;
    return ((t = this.ctaSlot) == null ? void 0 : t.length) > 0;
  }
  get hasBylineContent() {
    var t;
    return ((t = this.byline) == null ? void 0 : t.length) > 0;
  }
  get hasDetailsContent() {
    var t;
    return ((t = this.detailsSlot) == null ? void 0 : t.length) > 0;
  }
  get hasInfoContent() {
    return this.hasDetailsContent || this.hasBylineContent;
  }
  get hasToolbeltContent() {
    var t;
    return ((t = this.toolbeltSlot) == null ? void 0 : t.length) > 0;
  }
  get hasAdditionalContent() {
    var t;
    return ((t = this.additionalContentSlot) == null ? void 0 : t.length) > 0;
  }
  /**
   * @returns the first slotted image or media element
   */
  get firstSlottedMedia() {
    return this.slottedMedia[0];
  }
  /**
   * searches for slotted img or video elements that are potentially nested in other tags
   */
  get slottedMediaNode() {
    return kv(
      this.firstSlottedMedia,
      Oi.mediaNodes
    ) || this.firstSlottedMedia;
  }
  applyMotionStyles() {
    this.classList.add(jh.VIEWED);
  }
  applyMotionIntersectionObserver() {
    this.motionIntersectionObserver.observe(this.contentElement);
  }
  handleSlotChange() {
    this.addMutationObserver = GL(
      this.firstSlottedMedia,
      !0,
      this.mediaSlotChange
    ), this.requestUpdate();
  }
  /**
   * Toggles the with-byline class to conditionally render `-` character
   */
  handleBylineSlotChange() {
    const t = this.byline[0];
    this.detailsElement && (t ? this.detailsElement.classList.add(Oi.withBylineClassName) : this.detailsElement.classList.remove(Oi.withBylineClassName)), this.requestUpdate();
  }
  hideNotchIfNoMediaSlotted() {
    var t;
    (t = this.slottedMedia) != null && t.length || (this.hideNotch = !0);
  }
  render() {
    return pe`
      <div class="shell ${this.variant} ${this.orientation}">
        <div class="media-wrapper">
          <slot
            name="media"
            class="slotted-media-wrapper"
            @slotchange="${this.handleSlotChange}"
            ${Ue({ useParent: !0 })}></slot>
        </div>
        <section class="content">
          <div class="eyebrow ${Oe({ empty: !this.hasEyebrowContent })}">
            <slot name="eyebrow" @slotchange=${this.handleSlotChange}></slot>
          </div>
          <div class="page-title ${Oe({ empty: !this.hasTitleContent })}">
            <slot name="page-title" @slotchange=${this.handleSlotChange}></slot>
          </div>
          <div
            class="standfirst ${Oe({
      empty: !this.hasStandfirstContent
    })}">
            <slot name="standfirst" @slotchange=${this.handleSlotChange}></slot>
          </div>
          <div
            class="info ${Oe({
      empty: !(this.hasInfoContent || this.hasBylineContent)
    })}">
            <slot
              name="details"
              class="details"
              @slotchange=${this.handleSlotChange}></slot>
            <slot
              name="byline"
              @slotchange=${this.handleBylineSlotChange}></slot>
          </div>
          <slot
            name="toolbelt"
            class="${Oe({ empty: !this.hasToolbeltContent })}"
            @slotchange=${this.handleSlotChange}></slot>
          <slot
            class="cta-wrapper ${Oe({ empty: !this.hasCtaContent })}"
            @slotchange=${this.handleSlotChange}
            name="cta"></slot>
          <slot
            name="additionalContent"
            class="${Oe({ empty: !this.hasAdditionalContent })}"
            @slotchange=${this.handleSlotChange}></slot>
        </section>
      </div>
    `;
  }
};
Mb.tagName = Oi.beaconTagName;
let nt = Mb;
mt([
  ue({ reflect: !0 })
], nt.prototype, "scale", 2);
mt([
  ue({ type: Boolean, attribute: "no-notch", reflect: !0 })
], nt.prototype, "hideNotch", 2);
mt([
  ue({ type: Boolean, attribute: "no-media", reflect: !0 })
], nt.prototype, "noMedia", 2);
mt([
  ue({ type: Boolean, reflect: !0 })
], nt.prototype, "contained", 2);
mt([
  ue({ type: String, reflect: !0 })
], nt.prototype, "variant", 2);
mt([
  ue({ attribute: go.LOCATION, reflect: !0 })
], nt.prototype, "dataMetricsLocation", 2);
mt([
  ue({ type: String, reflect: !0 })
], nt.prototype, "orientation", 2);
mt([
  Se()
], nt.prototype, "waitForMediaSlot", 2);
mt([
  Se()
], nt.prototype, "addMutationObserver", 2);
mt([
  Ge(".details")
], nt.prototype, "detailsElement", 2);
mt([
  Ge(".content")
], nt.prototype, "contentElement", 2);
mt([
  Fo({ slot: "eyebrow", flatten: !0 })
], nt.prototype, "eyebrowSlot", 2);
mt([
  Fo({ slot: "page-title", flatten: !0 })
], nt.prototype, "pageTitleSlot", 2);
mt([
  Fo({ slot: "standfirst", flatten: !0 })
], nt.prototype, "standfirstSlot", 2);
mt([
  Fo({ slot: "cta", flatten: !0 })
], nt.prototype, "ctaSlot", 2);
mt([
  Fo({ slot: "details", flatten: !0 })
], nt.prototype, "detailsSlot", 2);
mt([
  Fo({ slot: "toolbelt", flatten: !0 })
], nt.prototype, "toolbeltSlot", 2);
mt([
  Fo({ slot: "additionalContent", flatten: !0 })
], nt.prototype, "additionalContentSlot", 2);
mt([
  Pe({ slot: "byline" })
], nt.prototype, "byline", 2);
mt([
  Pe({ flatten: !0, slot: "media" })
], nt.prototype, "slottedMedia", 2);
mt([
  De
], nt.prototype, "applyMotionIntersectionObserver", 1);
mt([
  De
], nt.prototype, "hideNotchIfNoMediaSlotted", 1);
const gg = {
  beaconTagName: "beacon-input-chip"
}, tO = {
  Normal: "normal"
}, oO = ve`[beacon-tag-name=beacon-input-chip]{--icon-spacing: var(--beacon-reference-space-3);--label-font: var(--beacon-system-font-weight-bold) var(--beacon-component-button-normal-font-size-sans-serif-standard)}[beacon-tag-name=beacon-input-chip] :is(*:not([slot])){color:var(--input-chip-text-color, --beacon-system-color-text-standard);font:var(--label-font)}[beacon-tag-name=beacon-input-chip] :is([slot=icon]){block-size:var(--beacon-reference-space-4);color:var(--input-chip-icon-color, var(--beacon-system-color-icon-standard));fill:currentcolor;inline-size:var(--beacon-reference-space-4);margin-inline-end:var(--icon-spacing)}[beacon-tag-name=beacon-input-chip] :is([slot=icon]) *{fill:inherit}[beacon-tag-name=beacon-input-chip][disabled]{--input-chip-text-color: var(--beacon-system-color-text-secondary-inactive)}[beacon-tag-name=beacon-input-chip][scale=mini]{--icon-spacing: var(--beacon-reference-space-2);--label-font: var(--beacon-system-font-weight-bold) var(--beacon-component-button-mini-font-size-sans-serif-standard)}`, aO = ve`.input-chip,.input-chip.normal{--icon-color: var(--beacon-system-color-icon-standard);align-items:center;background-color:var(--input-chip-background-color, var(--beacon-component-control-chip-color-background-default));border-color:var(--input-chip-border-color, var(--beacon-system-color-border-2));border-radius:var(--beacon-system-radius-corner-round);border-style:solid;border-width:var(--beacon-system-width-border-mini);display:flex;flex-direction:row;inline-size:fit-content;padding-block:var(--input-chip-padding-block, var(--beacon-reference-space-4));padding-inline-end:var(--input-chip-padding-inline-end, var(--beacon-reference-space-3));padding-inline-start:var(--input-chip-padding-inline-start, var(--beacon-reference-space-4))}.input-chip .label,.input-chip.normal .label{cursor:inherit;display:flex}.input-chip .icon,.input-chip.normal .icon{align-items:center;display:flex}.input-chip .icon ::slotted([slot=icon]),.input-chip.normal .icon ::slotted([slot=icon]){block-size:var(--beacon-reference-space-5);color:var(--icon-color, var(--beacon-system-color-icon-standard));fill:currentcolor;inline-size:var(--beacon-reference-space-5)}.input-chip:has([disabled]),.input-chip.normal:has([disabled]){--icon-color: var(--beacon-system-color-icon-primary-inactive);--input-chip-text-color: var(--beacon-system-color-text-secondary-inactive);--input-chip-border-color: var(--beacon-component-control-chip-color-background-default);cursor:not-allowed}.input-chip .close,.input-chip.normal .close{align-items:center;background-color:var(--close-icon-background-color, transparent);block-size:var(--close-button-size, var(--beacon-reference-space-7));border:unset;border-radius:var(--beacon-system-radius-corner-round);cursor:inherit;display:flex;inline-size:var(--close-button-size, var(--beacon-reference-space-7));justify-content:center;margin-block:calc(-1 * var(--beacon-reference-space-2));margin-inline-start:var(--beacon-reference-space-3);position:relative}.input-chip .close:before,.input-chip.normal .close:before{block-size:var(--beacon-reference-space-7);content:"";inline-size:var(--beacon-reference-space-7);position:absolute}.input-chip .close:focus-visible,.input-chip.normal .close:focus-visible{outline:none}.input-chip .close:focus-visible:before,.input-chip.normal .close:focus-visible:before{border-radius:var(--beacon-system-radius-corner-round);outline:auto}.input-chip .close .close-small-icon,.input-chip.normal .close .close-small-icon{block-size:var(--beacon-reference-space-5);color:var(--close-icon-color, var(--beacon-system-color-icon-secondary));fill:currentcolor;flex-shrink:0;inline-size:var(--beacon-reference-space-5)}.input-chip .close:hover,.input-chip .close:focus-visible,.input-chip.normal .close:hover,.input-chip.normal .close:focus-visible{--close-icon-background-color: var(--beacon-system-color-background-secondary-hover);--close-icon-color: var(--beacon-system-color-icon-secondary-hover)}.input-chip .close:active,.input-chip.normal .close:active{--close-icon-background-color: var(--beacon-system-color-background-secondary-pressed);--close-icon-color: var(--beacon-system-color-icon-secondary-pressed)}.input-chip .close[disabled],.input-chip.normal .close[disabled]{--close-icon-background-color: transparent;--close-icon-color: var(--beacon-system-color-icon-secondary-inactive)}.input-chip.mini,.input-chip.normal.mini{--input-chip-padding-block: var(--beacon-reference-space-2);--input-chip-padding-inline-start: var(--beacon-reference-space-3);--input-chip-padding-inline-end: var(--beacon-reference-space-2);--close-button-size: var(--beacon-reference-space-5)}`;
var iO = Object.defineProperty, Cv = (i, t, e, a) => {
  for (var o = void 0, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = r(t, e, o) || o);
  return o && iO(t, e, o), o;
};
const Lb = class Lb extends Le {
  constructor() {
    super(...arguments), this.beaconTagName = gg.beaconTagName, this.focusOverride = !0, this._passthroughs = new mc(this), this.scale = tO.Normal, this.disabled = !1;
  }
  static get styles() {
    return [super.styles, aO];
  }
  static get lightDOMStyles() {
    return [super.lightDOMStyles, oO];
  }
  dismiss(t) {
    Re(this, Ee.DISMISS), this.remove();
  }
  render() {
    return pe`
      <output class="${this.scale} input-chip">
        <div class="icon">
          <slot name="icon" ${Ue({ useParent: !0 })}></slot>
        </div>
        <div class="label">
          <slot></slot>
        </div>
        <button
          id="${gt(this._passthroughs.attributes.get("id"))}"
          class="close"
          @click=${this.dismiss}
          ?disabled=${this.disabled}
          aria-disabled="${this.disabled}"
          aria-label="close">
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="close-small-icon">
            <g clip-path="url(#clip0_233_84)">
              <path
                d="M4.14636 11.1459C3.95115 11.3412 3.95122 11.6578 4.14653 11.853C4.34184 12.0482 4.65842 12.0481 4.85364 11.8528L7.94072 8.76618C7.95635 8.75051 7.97758 8.7417 7.99972 8.7417C8.02185 8.7417 8.04308 8.75051 8.05871 8.76618L11.1458 11.8535C11.2721 11.9798 11.4562 12.0292 11.6287 11.983C11.8013 11.9368 11.9361 11.8021 11.9824 11.6295C12.0286 11.457 11.9794 11.2729 11.8531 11.1466L8.76632 8.05861C8.75065 8.04297 8.74184 8.02175 8.74184 7.99961C8.74184 7.97748 8.75065 7.95625 8.76632 7.94062L11.8537 4.85367C12.049 4.65819 12.0487 4.34147 11.8532 4.14626C11.6577 3.95105 11.341 3.95128 11.1458 4.14676L8.05871 7.23304C8.04308 7.24871 8.02185 7.25752 7.99972 7.25752C7.97758 7.25752 7.95635 7.24871 7.94072 7.23304L4.85364 4.14676C4.65842 3.95146 4.34184 3.95138 4.14653 4.14659C3.95122 4.3418 3.95115 4.65837 4.14636 4.85367L7.23311 7.94062C7.24878 7.95625 7.25759 7.97748 7.25759 7.99961C7.25759 8.02175 7.24878 8.04297 7.23311 8.05861L4.14636 11.1459Z"
                fill="currentColor" />
            </g>
            <defs>
              <clipPath id="clip0_233_84">
                <rect width="16" height="16" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </button>
      </output>
    `;
  }
};
Lb.tagName = gg.beaconTagName;
let ds = Lb;
Cv([
  ue({ reflect: !0 })
], ds.prototype, "scale");
Cv([
  ue({ type: Boolean })
], ds.prototype, "disabled");
var dh = /* @__PURE__ */ ((i) => (i.LIST_ITEM = "list-item", i.CARD = "card", i))(dh || {});
const In = {
  beaconTagName: "beacon-key-facts",
  frostedGlassName: "frosted-glass",
  valueName: "value",
  labelName: "label"
}, nO = ve`:root,.beacon-on-light,.beacon-on-light [beacon-version="4.3.1"][beacon-tag-name=beacon-key-facts],.beacon-on-light[beacon-version="4.3.1"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light [beacon-version="4.3.1"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light[beacon-version="4.3.1"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light [beacon-version="4.3.1"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light[beacon-version="4.3.1"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light [beacon-version="4.3.1"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light[beacon-version="4.3.1"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light [beacon-version="4.3.1"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light[beacon-version="4.3.1"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light [beacon-version="4.3.1"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light[beacon-version="4.3.1"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light [beacon-version="4.3.1"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light[beacon-version="4.3.1"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light [beacon-version="4.3.1"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light[beacon-version="4.3.1"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] .beacon-on-light [beacon-version="4.3.1"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] .beacon-on-light[beacon-version="4.3.1"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] .beacon-on-light [beacon-version="4.3.1"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] .beacon-on-light[beacon-version="4.3.1"][beacon-tag-name=beacon-key-facts]{--key-facts-color-background-blurred: rgb(255 255 255 / 64%)}.beacon-on-lighter,.beacon-on-lighter [beacon-version="4.3.1"][beacon-tag-name=beacon-key-facts],.beacon-on-lighter[beacon-version="4.3.1"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter [beacon-version="4.3.1"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter[beacon-version="4.3.1"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter [beacon-version="4.3.1"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter[beacon-version="4.3.1"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter [beacon-version="4.3.1"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter[beacon-version="4.3.1"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter [beacon-version="4.3.1"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter[beacon-version="4.3.1"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter [beacon-version="4.3.1"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter[beacon-version="4.3.1"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter [beacon-version="4.3.1"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter[beacon-version="4.3.1"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter [beacon-version="4.3.1"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter[beacon-version="4.3.1"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter [beacon-version="4.3.1"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter[beacon-version="4.3.1"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] .beacon-on-lighter [beacon-version="4.3.1"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] .beacon-on-lighter[beacon-version="4.3.1"][beacon-tag-name=beacon-key-facts]{--key-facts-color-background-blurred: rgb(255 255 255 / 64%)}.beacon-on-dark,.beacon-on-dark [beacon-version="4.3.1"][beacon-tag-name=beacon-key-facts],.beacon-on-dark[beacon-version="4.3.1"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark [beacon-version="4.3.1"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark[beacon-version="4.3.1"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark [beacon-version="4.3.1"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark[beacon-version="4.3.1"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark [beacon-version="4.3.1"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark[beacon-version="4.3.1"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark [beacon-version="4.3.1"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark[beacon-version="4.3.1"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark [beacon-version="4.3.1"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark[beacon-version="4.3.1"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark [beacon-version="4.3.1"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark[beacon-version="4.3.1"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark [beacon-version="4.3.1"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark[beacon-version="4.3.1"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark [beacon-version="4.3.1"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark[beacon-version="4.3.1"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] .beacon-on-dark [beacon-version="4.3.1"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] .beacon-on-dark[beacon-version="4.3.1"][beacon-tag-name=beacon-key-facts],.beacon-on-darker,.beacon-on-darker [beacon-version="4.3.1"][beacon-tag-name=beacon-key-facts],.beacon-on-darker[beacon-version="4.3.1"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker [beacon-version="4.3.1"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker[beacon-version="4.3.1"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker [beacon-version="4.3.1"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker[beacon-version="4.3.1"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker [beacon-version="4.3.1"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker[beacon-version="4.3.1"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker [beacon-version="4.3.1"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker[beacon-version="4.3.1"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker [beacon-version="4.3.1"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker[beacon-version="4.3.1"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker [beacon-version="4.3.1"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker[beacon-version="4.3.1"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker [beacon-version="4.3.1"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker[beacon-version="4.3.1"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker [beacon-version="4.3.1"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker[beacon-version="4.3.1"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] .beacon-on-darker [beacon-version="4.3.1"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] .beacon-on-darker[beacon-version="4.3.1"][beacon-tag-name=beacon-key-facts]{--key-facts-color-background-blurred: rgb(5 76 112 / 48%)}`, rO = ve`:host([scale=mini]){font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-headline-200)}:host([scale=normal]){font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-headline-400)}:host([scale=jumbo]){font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-headline-600)}:host{background-color:transparent;padding:var(--beacon-system-space-cell-contained)}:host([frosted-glass]){-webkit-backdrop-filter:blur(beacon-reference-space-13);backdrop-filter:blur(beacon-reference-space-13);background-color:var(--key-facts-color-background-blurred)}:host([variant=card]){background-color:var(--beacon-system-color-background-1);border-radius:var(--beacon-system-radius-corner-standard);padding:var(--beacon-system-space-organism-normal)}.label{color:var(--key-facts-supporting-text-label-color);display:var(--key-facts-label-display);font:var(--key-facts-label-font)}.container{--key-facts-cell-padding: var(--beacon-system-space-cell-contained);align-items:flex-start;display:var(--key-facts-figure-display);flex-direction:var(--key-facts-figure-flex-dir, row);margin:0;padding:var(--key-facts-cell-padding);position:relative}.container.variant--list-item{--key-facts-label-display: inline;--key-facts-figure-display: inline-block;--key-facts-supporting-text-label-color: var(--beacon-system-color-text-title);--key-facts-divider-spacing-sides: var(--beacon-reference-space-4);--key-facts-divider-block-size-jumbo: var(--beacon-reference-space-9);--key-facts-divider-block-size-normal: var(--beacon-reference-space-7);--key-facts-divider-block-size-mini: var(--beacon-reference-space-5);--key-facts-divider-spacing-top-jumbo: 3px;--key-facts-divider-spacing-top-normal: 2px;--key-facts-divider-spacing-top-mini: 3px;--beacon-override-vertical-divider-block-size: var(--key-facts-divider-block-size)}@media (width >= 640px){.container.variant--list-item{--key-facts-divider-block-size-jumbo: calc(2.25 * var(--beacon-reference-space-5));--key-facts-divider-block-size-normal: var(--beacon-reference-space-8);--key-facts-divider-block-size-mini: var(--beacon-reference-space-6);--key-facts-divider-spacing-top-jumbo: 4px;--key-facts-divider-spacing-top-normal: 3px;--key-facts-divider-spacing-top-mini: 2px}}@media (width >= 1280px){.container.variant--list-item{--key-facts-divider-block-size-jumbo: var(--beacon-reference-space-10);--key-facts-divider-block-size-normal: var(--beacon-reference-space-9);--key-facts-divider-block-size-mini: var(--beacon-reference-space-7);--key-facts-divider-spacing-top-jumbo: 5px;--key-facts-divider-spacing-top-normal: 4px;--key-facts-divider-spacing-top-mini: 3px}}.container.variant--list-item.scale--mini{--key-facts-label-font: var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-headline-100);--key-facts-value-font: var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-100);--key-facts-divider-block-size: var(--key-facts-divider-block-size-mini);--key-facts-divider-spacing-top: var(--key-facts-divider-spacing-top-mini)}.container.variant--list-item.scale--normal{--key-facts-label-font: var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-headline-300);--key-facts-value-font: var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-300);--key-facts-divider-block-size: var(--key-facts-divider-block-size-normal);--key-facts-divider-spacing-top: var(--key-facts-divider-spacing-top-normal)}.container.variant--list-item.scale--jumbo{--key-facts-divider-spacing-sides: var(--beacon-reference-space-5);--key-facts-label-font: var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-headline-500);--key-facts-value-font: var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-500);--key-facts-divider-block-size: var(--key-facts-divider-block-size-jumbo);--key-facts-divider-spacing-top: var(--key-facts-divider-spacing-top-jumbo)}.container.variant--list-item .divider{inset-block-start:var(--key-facts-divider-spacing-top);margin-inline:var(--key-facts-divider-spacing-sides);position:relative}.container.variant--card{--key-facts-label-display: block;--key-facts-figure-display: flex;--key-facts-supporting-text-label-color: var(--beacon-system-color-text-standard);--key-facts-figure-flex-dir: column;--key-facts-label-font: var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-200);gap:var(--beacon-reference-space-3)}.container.variant--card.scale--mini{--key-facts-value-font: var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-100)}.container.variant--card.scale--normal{--key-facts-value-font: var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-300)}.container.variant--card.scale--jumbo{--key-facts-value-font: var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-500)}.container.variant--card .divider{inline-size:var(--beacon-reference-space-7)}.figure-line,.figure-cell{display:inline-flex;flex-wrap:wrap}.figure-cell{font-weight:var(--beacon-system-font-weight-bold)}.field{display:inline-block}::slotted(*){display:inline;margin:0;padding:0}.value{color:var(--beacon-system-color-text-title);font:var(--key-facts-value-font)}`;
var sO = Object.defineProperty, lO = Object.getOwnPropertyDescriptor, Ec = (i, t, e, a) => {
  for (var o = a > 1 ? void 0 : a ? lO(t, e) : t, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = (a ? r(t, e, o) : r(o)) || o);
  return a && o && sO(t, e, o), o;
};
const Jl = class Jl extends Le {
  constructor() {
    super(...arguments), this.beaconTagName = In.beaconTagName, this.componentModeStyles = [nO], this.variant = dh.LIST_ITEM, this.scale = Do.NORMAL;
  }
  static get styles() {
    return [super.styles, rO];
  }
  postrenderMethods() {
    this.renderComponentModeStyles();
  }
  render() {
    const t = this.variant === dh.CARD ? Va.Horizontal : Va.Vertical;
    return pe`
      <figure class="container scale--${this.scale} variant--${this.variant}">
        <div class="figure-cell">
          <div class="figure-line">
            <div class="field ${In.valueName}">
              <slot name="${In.valueName}"></slot>
            </div>
          </div>
        </div>
        <beacon-divider
          class="divider"
          small-sectioning-mode="${t}"
          orientation="${t}"
          color-mode="${rv.Strong}"
          weight="${nv.Thick}"></beacon-divider>
        <figcaption class="label">
          <slot name="${In.labelName}"></slot>
        </figcaption>
      </figure>
    `;
  }
};
Jl.tagName = In.beaconTagName, Jl.nestedComponents = [ta];
let nr = Jl;
Ec([
  ue({ reflect: !0 })
], nr.prototype, "variant", 2);
Ec([
  ue({ reflect: !0 })
], nr.prototype, "scale", 2);
Ec([
  ue({ attribute: In.frostedGlassName, type: Boolean })
], nr.prototype, "frostedGlass", 2);
Ec([
  De
], nr.prototype, "postrenderMethods", 1);
const mg = {
  beaconTagName: "beacon-line-chart"
}, Ob = class Ob extends Ke(ct).with(
  zs,
  Ds,
  un
) {
  constructor() {
    super(...arguments), this.beaconTagName = mg.beaconTagName;
  }
  static get styles() {
    return [super.styles, this.chartAreaStyles, this.navigatorStyles];
  }
};
Ob.tagName = mg.beaconTagName;
let fg = Ob;
const cO = {
  Mini: "mini",
  Normal: "normal",
  Jumbo: "jumbo",
  Maxi: "maxi"
}, { Maxi: tz, ...Ur } = cO, vg = {
  beaconTagName: "beacon-loading-spinner"
}, dO = ve`@keyframes spin{to{transform:rotate(1turn)}}:host{--loader-base-size: 40px;--loader-multiplier: 1;--loader-size: calc(var(--loader-base-size) * var(--loader-multiplier));inline-size:var(--loader-size)!important}:host(:is([scale=normal],[scale=jumbo])){--loader-multiplier: 2}@media (width >= 640px){:host([scale=jumbo]){--loader-multiplier: 3}}.label{border:0;clip:rect(0,0,0,0);block-size:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;inline-size:1px}.outer,.inner{fill:transparent;stroke-width:10}.outer{stroke:var(--beacon-system-color-background-secondary-hover)}.inner{animation:var(--beacon-reference-motion-duration-10) var(--beacon-system-motion-easing-linear) infinite spin;stroke:var(--beacon-system-color-icon-secondary);stroke-dasharray:282.744;stroke-dashoffset:70;transform-origin:50% 50%}`;
var hO = Object.defineProperty, bO = (i, t, e, a) => {
  for (var o = void 0, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = r(t, e, o) || o);
  return o && hO(t, e, o), o;
};
const Pb = class Pb extends Le {
  constructor() {
    super(...arguments), this.beaconTagName = vg.beaconTagName, this.motionState = "enabled", this.scale = Ur.Normal;
  }
  static get styles() {
    return [super.styles, dO];
  }
  render() {
    return pe`
      <svg
        viewBox="0 0 100 100"
        xmlns="http://www.w3.org/2000/svg"
        role="progressbar"
        aria-labelledby="label">
        <circle class="outer" cx="50" cy="50" r="45" />
        <circle class="inner" cx="50" cy="50" r="45" />
      </svg>
      <div class="label" id="label">
        <slot></slot>
      </div>
    `;
  }
};
Pb.tagName = vg.beaconTagName;
let hh = Pb;
bO([
  ue({ reflect: !0 })
], hh.prototype, "scale");
var Sv = /* @__PURE__ */ ((i) => (i.NORMAL = "normal", i.PERCENT = "percent", i))(Sv || {});
const Ag = {
  beaconTagName: "beacon-meter-chart"
}, Dr = {
  mini: 20,
  normal: 24,
  jumbo: 28
}, Yt = {
  SPACING_TOP: 40,
  TOOLTIP_OFFSET: {
    X: 8,
    Y: 65
  },
  Y_AXIS: {
    MIN: 0,
    MAX: 100,
    TICK_AMOUNT: 2,
    LABEL_Y_OFFSET: -37
  },
  CHART_BORDER: 16,
  BAR: {
    BORDER_RADIUS: 0
  },
  LEGEND: {
    X: -6
  },
  NAVIGATION: {
    BUTTON_Y: -80
  }
}, pO = ve`.highcharts-legend .highcharts-legend-item .highcharts-point{display:none}.highcharts-axis-labels span .label{font-weight:var(--beacon-system-font-weight-bold)}.highcharts-axis-labels span:last-child .label{font-weight:var(--beacon-system-font-weight-light)}.caption{margin-block-start:0}.header{margin-block-end:0}.highcharts-plot-border{fill:var(--beacon-system-color-background-1);stroke:var(--beacon-component-data-viz-color-border-minor)}.highcharts-series-group .highcharts-column-series .highcharts-point,.highcharts-series-group .highcharts-bar-series .highcharts-point{stroke:var(--beacon-component-data-viz-color-border-minor)}.highcharts-plot-line,.highcharts-grid-line,.highcharts-plot-band,.highcharts-markers,.highcharts-axis,.highcharts-grid,.highcharts-pane-group,.highcharts-plot-background,.highcharts-background{display:none!important}.highcharts-root,.highcharts-container,.chart{overflow:visible!important}`;
var uO = Object.defineProperty, vn = (i, t, e, a) => {
  for (var o = void 0, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = r(t, e, o) || o);
  return o && uO(t, e, o), o;
};
const zb = class zb extends Ke(ct).with(
  zs,
  Ds,
  un
) {
  constructor() {
    super(), this.beaconTagName = Ag.beaconTagName, this.tooltipPositioner = (t, e, a) => {
      let o = a.plotX - t / 2 + Yt.TOOLTIP_OFFSET.X, n = a.plotY + Yt.TOOLTIP_OFFSET.Y;
      const r = window.innerWidth, T = window.innerHeight;
      return o = Math.max(0, Math.min(o, r - t)), n = Math.max(0, Math.min(n, T - e)), { x: o, y: n };
    }, this.variant = Gr.HORIZONTAL, this.scale = tn.NORMAL, this.stacking = Sv.PERCENT, this.percentage = !1, this.label1 = "Label 1", this.label2 = "Label 2", this.decimal = !1, this.resizeObserver = new ResizeObserver(
      Io(() => {
        this.chart && this.updateChartHeight();
      }, 200)
    );
  }
  static get styles() {
    return [super.styles, pO, this.chartAreaStyles, this.navigatorStyles];
  }
  get type() {
    return Jt.BAR;
  }
  // Local component options for the chart
  get localComponentOptions() {
    const t = this;
    return ct.createChartOptions(
      super.localComponentOptions,
      {
        chart: {
          type: "bar",
          spacingTop: Yt.SPACING_TOP,
          spacingLeft: Yt.CHART_BORDER,
          spacingRight: Yt.CHART_BORDER,
          events: {
            render: function() {
              const a = this;
              a.series.forEach((T) => {
                T.points.forEach(
                  (O) => {
                    var j;
                    O.tooltipPos && (O.tooltipPos[0] -= ((j = O.shapeArgs) == null ? void 0 : j.height) / 2);
                  }
                );
              });
              const n = a.container.querySelector(
                ".highcharts-series-group"
              ), r = a.container.querySelector(
                ".highcharts-plot-border"
              );
              if (n && r && n.getBBox().width > 0) {
                const T = n.getBBox();
                r.setAttribute(
                  "height",
                  Dr[t.scale].toString()
                ), r.setAttribute(
                  "x",
                  Yt.CHART_BORDER.toString()
                ), r.setAttribute(
                  "y",
                  T.y.toString()
                );
              }
            },
            load: function() {
              const a = this;
              t.resizeObserver.observe(a.container), t.updateChartHeight(), zo.addEvent(a, "destroy", function() {
                t.resizeObserver.unobserve(a.container);
              });
            }
          }
        },
        xAxis: {
          visible: !1
        },
        yAxis: {
          min: Yt.Y_AXIS.MIN,
          max: Yt.Y_AXIS.MAX,
          tickAmount: Yt.Y_AXIS.TICK_AMOUNT,
          labels: {
            useHTML: !0,
            y: Yt.Y_AXIS.LABEL_Y_OFFSET,
            formatter: function() {
              var n;
              const a = [t.label1, t.label2];
              return `<span class="label">${(n = this.axis) != null && n.tickPositions && a[this.axis.tickPositions.indexOf(Number(this.value))] || ""}</span>`;
            }
          },
          reversedStacks: !1
        },
        tooltip: {
          positioner: this.tooltipPositioner,
          useHTML: !0,
          pointFormatter() {
            var n, r;
            const a = this, o = t.decimal ? (n = a.y) == null ? void 0 : n.toFixed(1) : (r = a.y) == null ? void 0 : r.toFixed(0);
            return ct.tooltipPointHTML(
              this,
              this.series.name,
              o + (t.percentage ? "%" : "")
            );
          }
        },
        plotOptions: {
          bar: {
            borderRadius: Yt.BAR.BORDER_RADIUS,
            pointWidth: this.getSeriesHeight()
          },
          series: {
            stacking: this.stacking
          }
        },
        legend: {
          x: Yt.LEGEND.X
        },
        navigation: {
          buttonOptions: {
            enabled: !0,
            y: Yt.NAVIGATION.BUTTON_Y
          }
        }
      }
    );
  }
  // Update chart options based on property changes
  willUpdate(t) {
    var e, a, o, n, r;
    (e = super.willUpdate) == null || e.call(this, t), t.has("stacking") && this.updateChart({
      plotOptions: { series: { stacking: this.stacking } }
    }), t.has("scale") && (this.updateChart({
      plotOptions: { bar: { pointWidth: this.getSeriesHeight() } }
    }), this.updateChartHeight()), t.has("chart") && this.setLoadedChartOptions(), t.has("percentage") && this.updateChart({
      tooltip: {
        pointFormatter: (a = this.localComponentOptions.tooltip) == null ? void 0 : a.pointFormatter
      }
    }), (t.has("label1") || t.has("label2")) && this.updateChart({
      yAxis: {
        labels: {
          formatter: (n = (o = this.localComponentOptions.yAxis) == null ? void 0 : o.labels) == null ? void 0 : n.formatter
        }
      }
    }), t.has("decimal") && this.updateChart({
      tooltip: {
        pointFormatter: (r = this.localComponentOptions.tooltip) == null ? void 0 : r.pointFormatter
      }
    });
  }
  // Sets the loaded chart options
  setLoadedChartOptions() {
    this.updateChart({ plotOptions: { series: { stacking: this.stacking } } });
  }
  // Gets the series height based on scale
  getSeriesHeight() {
    return Dr[this.scale];
  }
  // Update chart height based on the current scale
  updateChartHeight() {
    if (this.chart) {
      this.chart.update({
        chart: {
          height: Dr[this.scale] + (this.chart.chartHeight - this.chart.plotHeight)
        }
      });
      const t = this.chart.container.querySelector(
        ".highcharts-series-group"
      ), e = this.chart.container.querySelector(
        ".highcharts-plot-border"
      );
      if (t && e && t.getBBox().width > 0) {
        const a = t.getBBox();
        e.setAttribute(
          "height",
          Dr[this.scale].toString()
        ), e.setAttribute(
          "x",
          Yt.CHART_BORDER.toString()
        ), e.setAttribute(
          "y",
          a.y.toString()
        ), t.setAttribute(
          "height",
          Dr[this.scale].toString()
        ), t.setAttribute(
          "y",
          a.y.toString()
        );
      }
    }
  }
};
zb.tagName = Ag.beaconTagName;
let Ta = zb;
vn([
  ue()
], Ta.prototype, "variant");
vn([
  ue({ type: String, reflect: !0 })
], Ta.prototype, "scale");
vn([
  ue({ type: String, reflect: !0 })
], Ta.prototype, "stacking");
vn([
  ue({ type: Boolean, reflect: !0 })
], Ta.prototype, "percentage");
vn([
  ue({ type: String })
], Ta.prototype, "label1");
vn([
  ue({ type: String })
], Ta.prototype, "label2");
vn([
  ue({ type: Boolean })
], Ta.prototype, "decimal");
const yg = {
  beaconTagName: "beacon-modal"
}, gO = ve`[beacon-tag-name=beacon-modal] :where([slot=logo] :where(img,svg)){block-size:inherit;inline-size:inherit}`, mO = ve`:host{--header-justification: space-between;--modal-max-block-size: calc(100dvh - 2 * var(--beacon-system-space-gutter))}dialog{--max-width: calc(100% - 2 * var(--beacon-system-space-gutter));--min-width: none;border-radius:var(--beacon-system-radius-corner-standard);box-shadow:var(--beacon-system-color-shadow-high);max-block-size:var(--modal-max-block-size)}@media (width >= 640px){dialog{--default-width: 100%}}.persist .header{padding:0}.persist .logo-slot{padding:var(--beacon-system-space-cell-contained)}.normal{inset-block-end:var(--beacon-system-space-gutter);inset-block-start:initial}@media (width >= 640px){.normal{--max-width: 23.625rem;--min-width: 17.625rem;top:0;right:0;bottom:0;left:0}}@media (width >= 960px){.normal{--max-width: 45.5rem;--min-width: 26.5rem}}:is(.jumbo,.maxi){--max-width: 100%;--min-width: 100%;top:0;right:0;bottom:0;left:0}@media (width < 640px){:is(.jumbo,.maxi){block-size:100dvh;margin-block:0;max-block-size:none}:is(.jumbo,.maxi) .wrapper{block-size:100dvh;max-block-size:100dvh}}@media (width >= 640px){.jumbo{--max-width: 36rem;--min-width: none}}@media (width >= 960px){.jumbo{--max-width: 44rem}}@media (width >= 1280px){.jumbo{--max-width: 57rem}}@media (width >= 640px){.maxi{--max-width: calc(100% - 2 * var(--beacon-system-space-gutter));--min-width: calc(100% - 2 * var(--beacon-system-space-gutter))}}.wrapper{max-block-size:var(--modal-max-block-size)}@media (width >= 1216px){.wrapper.maxi{grid-template-areas:"panel header" "panel content" "panel footer";grid-template-columns:4fr 8fr}.wrapper.maxi .body{display:contents}.wrapper.maxi .header{grid-area:header}.wrapper.maxi .panel{grid-area:panel}.wrapper.maxi .content{grid-area:content}.wrapper.maxi .footer{grid-area:footer}.wrapper.maxi .content,.wrapper.maxi .panel{overflow-y:auto;scrollbar-color:var(--beacon-component-scrollbar-color-background-thumb) var(--beacon-component-scrollbar-color-background-track);scrollbar-gutter:stable}}.content{padding-block:var(--beacon-system-space-organism-jumbo);padding-inline:var(--beacon-system-space-organism-jumbo)}.panel{background-color:var(--beacon-system-color-background-2);padding:var(--beacon-system-space-organism-jumbo)}.close-button{margin-inline-start:auto}::slotted([slot=logo]){block-size:100%;inline-size:100%;max-block-size:var(--beacon-reference-space-10);max-inline-size:var(--beacon-reference-space-10)}`;
var fO = Object.defineProperty, vO = (i, t, e, a) => {
  for (var o = void 0, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = r(t, e, o) || o);
  return o && fO(t, e, o), o;
};
const Db = class Db extends Ut {
  constructor() {
    super(...arguments), this.beaconTagName = yg.beaconTagName, this.scale = "normal";
  }
  static get styles() {
    return [super.styles, mO];
  }
  static get lightDOMStyles() {
    return [super.lightDOMStyles, gO];
  }
  /**
   * @todo 4.0.0 Rename to something other than `additional-content`
   */
  renderSidePanel() {
    return this.scale !== "maxi" ? pe`` : pe`
      <div class="panel" tabindex=${qi()}>
        <slot
          name="additional-content"
          ${Ue({ useParent: !0 })}></slot>
      </div>
    `;
  }
  render() {
    const t = {
      persist: this.persist
    };
    return t[this.scale] = !0, pe`
      ${this.anyComputedZIndex && this.open ? pe`<div class="non-modal-dialog-background-wrapper"></div>` : ""}
      <dialog
        @click=${this.handleDialogClick}
        class="${Oe(t)}">
        <div class="block-size-wrapper">
          <div class="wrapper ${this.scale}">
            <div class="header">
              <div class="logo-slot">
                <slot
                  name="logo"
                  aria-hidden="true"
                  ${Ue({ useParent: !0 })}></slot>
              </div>
              ${this.renderCloseButton()}
            </div>
            <div class="body" tabindex=${qi()}>
              <div class="content" tabindex=${qi()}>
                <slot ${Ue({ container: ".body" })}></slot>
              </div>
              ${this.renderSidePanel()}
            </div>
            <div class="footer">
              <div class="action-zone">
                <slot
                  name="action-zone"
                  ${Ue({ container: ".footer" })}></slot>
              </div>
            </div>
          </div>
        </div>
      </dialog>
    `;
  }
};
Db.tagName = yg.beaconTagName;
let Nl = Db;
vO([
  ue()
], Nl.prototype, "scale");
const bh = {
  beaconTagName: "beacon-multi-select-optgroup"
}, AO = ve`:host([beacon-tag-name=beacon-multi-select-optgroup]:not([is-visible])){display:none}.hidden{display:none}.title{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-caption-200);padding-block:var(--beacon-reference-space-3);padding-inline:var(--beacon-reference-space-4)}.has-count::part(label){inline-size:100%}.has-count .option-label{display:flex;justify-content:space-between}.has-count .option-label .label{flex:1 1 auto}.has-count .option-label .count{align-self:center;flex:0 0 auto;font-size:var(--beacon-reference-font-scale-2);margin-inline-start:auto;padding-inline-start:var(--beacon-reference-space-4)}.option{padding-block:var(--beacon-reference-space-3);padding-inline:var(--beacon-reference-space-4)}.option:hover{background-color:var(--beacon-reference-color-background-secondary-hover)}.option:active{background-color:var(--beacon-reference-color-background-secondary-pressed)}[beacon-tag-name=beacon-control]{padding-block:0}[beacon-tag-name=beacon-control] [slot=label]{display:block flex;inline-size:100%;padding-block:calc(var(--beacon-reference-space-4))}[beacon-tag-name=beacon-control] [slot=label] .label{inline-size:100%}[beacon-tag-name=beacon-control]::part(label){inline-size:100%}`;
var yO = Object.defineProperty, xO = Object.getOwnPropertyDescriptor, An = (i, t, e, a) => {
  for (var o = a > 1 ? void 0 : a ? xO(t, e) : t, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = (a ? r(t, e, o) : r(o)) || o);
  return a && o && yO(t, e, o), o;
}, ws, ka;
const wi = (ka = class extends Le {
  constructor() {
    super(...arguments);
    Fe(this, ws);
    this.beaconTagName = bh.beaconTagName, this.focusOverride = !0, this.resetSpacing = !0, this.optionsList = [], this.value = /* @__PURE__ */ new Map(), this.isVisible = !0;
  }
  static get styles() {
    return [super.styles, AO];
  }
  get titleElement() {
    return ze(this, ws);
  }
  set titleElement(e) {
    Ne(this, ws, e);
  }
  /**
   * Handles the selection of an option.
   */
  handleOptionSelection(e) {
    const a = e.target;
    a instanceof HTMLInputElement ? this.updateValue(a) : a instanceof HTMLElement && a.closest(this.getScopedTagName("beacon-control")) && ka.toggleCheckbox(a);
  }
  /**
   * Updates the value map based on the target input element.
   */
  updateValue(e) {
    const {
      checked: a,
      dataset: { value: o, count: n }
    } = e, r = new Map(this.value);
    a ? r.set(o, n) : r.delete(o), this.value = r, Re(e, Ee.TOGGLE, {
      detail: {
        option: e,
        value: e.dataset.value,
        count: e.dataset.count,
        checked: e.checked
      }
    });
  }
  /**
   * Toggles the checkbox state of the target element.
   */
  static toggleCheckbox(e) {
    const a = e.querySelector(
      'input[type="checkbox"]'
    );
    a && (a.checked = !a.checked, a.dispatchEvent(new Event("input", { bubbles: !0 })), a.focus());
  }
  /**
   * When content changes in the default slot where options are slotted triggers fresh
   * render of the options.
   */
  handleOptionsUpdates() {
    this.optionsList = this.options;
    const e = this.options.filter(
      (a) => a.selected && a.label
    );
    e.length && this.setDefaultSelectedOptions(e);
  }
  handleTitleSlotchange() {
    this.titleElement = this.titleElements[0];
  }
  /**
   * Renders the list of options.
   */
  renderOptionsList() {
    return pe`
      ${Nf(
      // safer version of map when working with keyed data items: https://lit.dev/docs/templates/directives/#repeat
      this.optionsList,
      (e) => e.controlId,
      // unique identifier of the option
      (e, a) => {
        const o = { "has-count": e.count, option: !0 };
        return Be`
          <${this.getScopedTag("beacon-control")} inline class="${Oe(o)}" id="${e.controlId}">
            <label slot="label" for="value-${a}" class="option-label">
              <span class="label">${e.label}</span>
              ${e.count ? pe`<span class="count">${e.count}</span>` : ""}
            </label>
            <input
              type="checkbox"
              name="selection"
              id="value-${a}"
              ?checked=${e.selected}
              data-value="${e.label}"
              data-count="${e.count}"
              @input=${this.handleOptionSelection}
            />
          </${this.getScopedTag("beacon-control")}>
        `;
      }
    )}
    `;
  }
  /**
   * Sets the initial selected values from the options.
   */
  setDefaultSelectedOptions(e) {
    const a = new Map(this.value);
    e.forEach((o) => {
      a.set(o.label, o.count);
    }), this.value = a, Re(this, Ee.CHANGE);
  }
  initializeOptionsList() {
    this.handleOptionsUpdates();
  }
  /**
   * Keeps beacon-controls rendered in MSOG in sync with MSO's if any are removed from the DOM.
   */
  handleOptionRemoval() {
    const e = this.options.map(({ controlId: a }) => a);
    this.beaconControls.forEach((a) => {
      if (!e.includes(a.id)) {
        const o = a.querySelector("input");
        o && o.checked && (o.checked = !1, this.updateValue(o)), a.remove();
      }
    }), this.beaconControls.length && this.beaconControls[0].renderLightDOMStyles();
  }
  /**
   * Renders the component template.
   */
  render() {
    return pe`
      <slot
        style="display: none;"
        @slotchange=${this.handleOptionRemoval}
        @beacon-event-change=${this.handleOptionsUpdates}></slot>
      <div class="base">
        <div class="title">
          <slot
            name="title"
            @slotchange=${this.handleTitleSlotchange}
            ${Ue({ useParent: !0 })}></slot>
        </div>
        ${this.renderOptionsList()}
      </div>
    `;
  }
}, ws = new WeakMap(), ka.tagName = bh.beaconTagName, ka.nestedComponents = [wc], ka.shadowRootOptions = {
  ...Le.shadowRootOptions,
  delegatesFocus: !1
}, ka);
An([
  Se()
], wi.prototype, "optionsList", 2);
An([
  Se()
], wi.prototype, "value", 2);
An([
  ue({ reflect: !0, attribute: "is-visible", type: Boolean })
], wi.prototype, "isVisible", 2);
An([
  Pe({ selector: "beacon-multi-select-option" }, !0)
], wi.prototype, "options", 2);
An([
  wt({ flatten: !0, slot: "title" })
], wi.prototype, "titleElements", 2);
An([
  Ts('[beacon-tag-name="beacon-control"]')
], wi.prototype, "beaconControls", 2);
An([
  De
], wi.prototype, "initializeOptionsList", 1);
let wO = wi;
const xg = {
  beaconTagName: "beacon-multi-select"
}, kO = ve`::placeholder{color:var(--beacon-system-color-text-standard)}:host{position:relative}.options{--beacon-multi-select-options-menu-z-index: 999;background-color:var(--beacon-system-color-background-1);border:var(--beacon-system-width-border-mini) solid var(--beacon-component-form-color-border-standard);border-block-start:0;border-end-end-radius:var(--beacon-system-radius-corner-standard);border-end-start-radius:var(--beacon-system-radius-corner-standard);inline-size:100%;max-block-size:368px;overflow:hidden;position:absolute;z-index:var(--beacon-multi-select-options-menu-z-index)}.options .content{max-block-size:368px;overflow-y:auto;padding-block:var(--beacon-reference-space-3);scrollbar-color:var(--beacon-component-scrollbar-color-background-thumb) var(--beacon-component-scrollbar-color-background-track);scrollbar-gutter:stable}.options:not(.visible){display:none}.icon{--icon-color: var(--beacon-system-color-icon-link);color:var(--icon-color);display:flex;place-items:center}.no-results-message{font-weight:var(--beacon-system-font-weight-bold);padding-block:0 var(--beacon-reference-space-6);padding-inline:var(--beacon-reference-space-4)}.toggle-select{background:none;border-style:none;color:inherit;cursor:pointer;font:inherit;margin:0;padding-inline:var(--beacon-reference-space-4)}.toggle-select:focus{outline:none}[beacon-tag-name=beacon-input-chip]{--beacon-multi-select-filter-chip-max-width: 14ch}[beacon-tag-name=beacon-input-chip] .chip-label{color:var(--beacon-system-color-text-standard);cursor:default;display:inline-block;font-weight:var(--beacon-system-font-weight-bold);max-inline-size:var(--beacon-multi-select-filter-chip-max-width);overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.hidden{display:none}.option{align-items:center;display:flex;justify-content:space-between;padding-inline:var(--beacon-reference-space-4)}.option:hover{background-color:var(--beacon-system-color-background-secondary-hover)}.option:active{background-color:var(--beacon-system-color-background-secondary-pressed)}@supports not ((scrollbar-color) and (scrollbar-width)){.options .content::-webkit-scrollbar{background-color:var(--beacon-component-scrollbar-color-background-track);inline-size:var(--beacon-reference-space-5)}.options .content::-webkit-scrollbar-track{background-color:var(--beacon-component-scrollbar-color-background-track)}.options .content::-webkit-scrollbar-thumb{background-clip:content-box;background-color:var(--beacon-component-scrollbar-color-background-thumb);border:var(--beacon-reference-space-2) solid transparent;border-radius:var(--beacon-reference-space-4)}}.search.searching::part(field){--beacon-multi-select-search-bar-searching-z-index: 1;border-end-end-radius:0;border-end-start-radius:0;position:relative;z-index:var(--beacon-multi-select-search-bar-searching-z-index)}.search.searching .icon{transform:rotate(180deg)}.search.disabled .icon{--icon-color: var(--beacon-system-color-icon-primary-inactive)}.search.disabled ::placeholder{color:var(--beacon-system-color-text-inactive)}`;
var CO = Object.defineProperty, SO = Object.getOwnPropertyDescriptor, lo = (i, t, e, a) => {
  for (var o = a > 1 ? void 0 : a ? SO(t, e) : t, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = (a ? r(t, e, o) : r(o)) || o);
  return a && o && CO(t, e, o), o;
}, Hi, Oo;
const to = (Oo = class extends Ke(Le).with(
  $h
) {
  constructor() {
    super(...arguments);
    Fe(this, Hi);
    this.focusOverride = !0, this.resetSpacing = !0, this.beaconTagName = xg.beaconTagName, this.disabled = !1, this.placeholder = "Select", this.searching = !1, Ne(this, Hi, ""), this.value = /* @__PURE__ */ new Map(), this.hasSearchResults = !0, this.selectedValues = [], this.documentClickHandler = (e) => {
      e.composedPath().some((n) => n instanceof HTMLElement ? n.getAttribute("beacon-tag-name") === bh.beaconTagName || n.classList.contains("toggle-select") : !1) || this.closeDialog();
    }, this.handleKeydown = (e) => {
      const { key: a } = e;
      a === "Escape" && (this.searchValue === "" ? this.closeDialog() : (this.searchValue = "", this.combobox.value = "", this.combobox.focus())), a === "Backspace" && this.searchValue.length === 0 && this.reset(), a === "Enter" && this.openDialog(), a === "Tab" && this.closeDialog(), super.handleKeydown(e);
    }, this.handleArrowKeydown = (e) => {
      if (e.isTrusted && e instanceof KeyboardEvent) {
        const { key: a } = e;
        if ((a === "Enter" || a === " ") && e.currentTarget && e.currentTarget.getAttribute("type") === "checkbox" && (e.currentTarget.click(), e.stopPropagation(), e.preventDefault()), this.handleArrowControlKeydown(
          e,
          this.getArrowControlElements(),
          "vertical",
          Oo.arrowControlFocusCallback
        ))
          return e.preventDefault(), e.stopPropagation(), !1;
      }
    };
  }
  static get styles() {
    return [super.styles, kO];
  }
  get dynamicPlaceholder() {
    return this.value.size > 0 || this.searching ? "" : this.placeholder;
  }
  get searchValue() {
    return ze(this, Hi);
  }
  set searchValue(e) {
    Ne(this, Hi, e), this.filterSearchOptions();
  }
  /**
   * Function that should be used to open the dialog (dropdown). Adds an event listener
   * to the document to close the dialog on clickout. See the documentClickHandler comment for
   * an explanation why this was done.
   */
  openDialog() {
    this.searching = !0, document.addEventListener("mousedown", this.documentClickHandler);
  }
  /**
   * Function that should be used to close the dialog to remove the click listener from
   * the document. See the documentClickHandler comment for an explanation why this was done.
   *
   * Also clears the search value from the search bar.
   */
  closeDialog() {
    document.removeEventListener("mousedown", this.documentClickHandler), this.searching = !1, this.searchValue = "", this.combobox.value = "";
  }
  /**
   * Handles option selection events to update the selected values.
   */
  handleOptionSelection(e) {
    const {
      option: {
        checked: a,
        dataset: { value: o, count: n }
      }
    } = e.detail, r = new Map(this.value);
    a ? r.set(o, n) : r.delete(o), this.value = r;
  }
  /**
   * Captures the selected options from an optgroup that
   * were initialized via HTML.
   * @param event Beacon Change Event
   */
  handleDefaultSelectedValues(e) {
    const { target: a } = e;
    if (a instanceof wO) {
      const o = new Map(this.value);
      a.value.forEach((n, r) => {
        o.set(r, n);
      }), this.value = o;
    }
  }
  /**
   * Handles input events to update the search value and set searching state.
   */
  handleSearching(e) {
    const a = e.target;
    a && (this.searchValue = a.value, this.openDialog());
  }
  /**
   * Filters the search options based on the current search value.
   * This method updates the visibility of options and optgroups based on the search input.
   */
  filterSearchOptions() {
    const e = this.searchValue.toLowerCase();
    this.hasSearchResults = !1, this.optgroups.forEach((a) => {
      a.isVisible = !1, a.beaconControls.forEach((o) => {
        var T;
        const n = o.labelElement;
        if (!n) return;
        const r = (T = n.textContent) == null ? void 0 : T.trim().toLowerCase();
        r && r.includes(e) ? (o.classList.remove("hidden"), a.isVisible = !0, this.hasSearchResults = !0) : o.classList.add("hidden");
      });
    }), this.optgroups.forEach((a) => {
      var n;
      const o = a.titleElement;
      if (o) {
        const r = (n = o.textContent) == null ? void 0 : n.trim().toLowerCase();
        r != null && r.includes(e) && (a.isVisible = !0, this.hasSearchResults = !0, a.beaconControls.forEach(
          (T) => T.classList.remove("hidden")
        ));
      }
    });
  }
  /**
   * Resets the selected values and unchecks all options.
   */
  reset() {
    this.value = /* @__PURE__ */ new Map(), this.optgroups.forEach((e) => {
      e.beaconControls.forEach((a) => {
        const o = a.fieldElement;
        o && o.checked && (o.checked = !1);
      });
    }), this.selectedValues = [];
  }
  /**
   * Renders the prefix element showing the selected values.
   */
  renderPrefix() {
    let e;
    switch (this.value.size) {
      case 0:
        return pe``;
      case 1:
        e = pe`${this.value.keys().next().value}`;
        break;
      default:
        e = pe`${this.value.size}
          <slot name="filter-chip-text">Selected</slot>`;
    }
    return Be`
    <${this.getScopedTag("beacon-input-chip")} scale="mini" class="input-chip" slot="prefix">
      <span class="chip-label">${e}</span>
    </${this.getScopedTag("beacon-input-chip")}>`;
  }
  /**
   * Handles click events on the chevron button to toggle the searching state.
   */
  handleChevronClick(e) {
    e.preventDefault(), this.searching ? this.closeDialog() : this.openDialog();
  }
  /**
   * Renders the suffix element containing the chevron button.
   */
  renderSuffix() {
    return Be`
      <button
        tabindex="-1"
        class="toggle-select"
        @click=${this.handleChevronClick}
        aria-label="toggle">
        <${this.getScopedTag("beacon-icon")} name="sorted_down" size="m" slot="suffix" class="icon" variant="link"></${this.getScopedTag("beacon-icon")}>
      </button>
    `;
  }
  /**
   * Gets visible options to pass into the arrow control mixin
   */
  getArrowControlElements() {
    const e = [this.combobox];
    return this.optgroups.forEach((a) => {
      a.beaconControls.forEach((o) => {
        o.classList.contains("hidden") || o && e.push(o.fieldElement);
      });
    }), e;
  }
  /**
   * Moves focus onto the option determined by the arrow-control mixin
   * @param beaconControl
   */
  static arrowControlFocusCallback(e) {
    e instanceof HTMLElement && e.focus(), e.scrollIntoView({ behavior: "smooth", block: "center" });
  }
  async addMultiSelectEventListeners() {
    this.addEventListener("keydown", this.handleKeydown), this.addEventListener("click", this.handleClick);
  }
  /**
   * When the blank space to the top right of the component is clicked, this ensures that the dialog closes.
   */
  handleClick(e) {
    e.target && e.target.matches(".group:not(.inline)") && (this.closeDialog(), this.blur());
  }
  async attachArrowControlKeyboardListeners() {
    this.combobox.addEventListener("keydown", this.handleArrowKeydown), await this.updateComplete, await this.optgroups.forEach(async (e) => {
      e.addEventListener(Ee.ELEMENT_READY, () => {
        e.beaconControls.forEach((a) => {
          var o;
          (o = a.fieldElement) == null || o.addEventListener(
            "keydown",
            this.handleArrowKeydown
          );
        });
      });
    });
  }
  async sortOptions() {
    await this.updateComplete;
    const e = this.optgroups;
    await e.forEach(async (a) => {
      await a.updateComplete;
    }), e.sort(
      (a, o) => {
        var T, O, j, D;
        const n = (O = (T = a.titleElement) == null ? void 0 : T.textContent) != null ? O : "", r = (D = (j = o.titleElement) == null ? void 0 : j.textContent) != null ? D : "";
        return n.localeCompare(r);
      }
    ), await e.forEach(async (a) => {
      a.remove(), this.appendChild(a);
      const o = [...a.options];
      await o.forEach(async (n) => {
        await n.updateComplete;
      }), o.sort((n, r) => {
        var j, D, F, B;
        const T = (D = (j = n.labelNode) == null ? void 0 : j.nodeValue) != null ? D : "", O = (B = (F = r.labelNode) == null ? void 0 : F.nodeValue) != null ? B : "";
        return T.localeCompare(O);
      }), o.forEach((n) => {
        n.remove(), a.appendChild(n);
      });
    });
  }
  initializeSelectedValues() {
    const e = new Map(this.value);
    this.optgroups.forEach((a) => {
      a.value.forEach((o, n) => {
        e.set(n, o);
      });
    }), this.value = e;
  }
  /**
   * Renders the search field element.
   */
  renderSearchField() {
    const e = {
      disabled: this.disabled,
      search: !0,
      searching: this.searching
    };
    return Be`
      <${this.getScopedTag("beacon-control")} class="${Oe(e)}"
      @beacon-event-dismiss=${this.reset}>
        <label slot="label" for="multi-select">
          <slot name="label"></slot>
        </label>
        ${this.renderPrefix()}
        <input
          role="combobox"
          aria-autocomplete="none"
          aria-expanded="${this.searching.toString()}"
          aria-controls="options"
          aria-haspopup="dialog"
          name="multi-select"
          id="multi-select"
          ?disabled=${this.disabled}
          placeholder="${this.dynamicPlaceholder}"
          autocomplete="off"
          @input=${this.handleSearching}
          @focus=${this.openDialog}
          @click=${this.openDialog}
        />
        ${this.renderSuffix()}
      </${this.getScopedTag("beacon-control")}>
    `;
  }
  /**
   * Renders the multi-select component.
   */
  render() {
    const e = {
      options: !0,
      visible: this.searching
    };
    return pe`
      ${this.renderSearchField()}
      <div role="dialog" id="options" class="${Oe(e)}">
        <div class="content">
          <slot
            @beacon-event-toggle=${this.handleOptionSelection}
            @beacon-event-change=${this.handleDefaultSelectedValues}></slot>
        </div>
        ${this.hasSearchResults ? pe`` : pe`<div class="no-results-message">
              No results found for “${ze(this, Hi)}”
            </div>`}
      </div>
    `;
  }
}, Hi = new WeakMap(), Oo.tagName = xg.beaconTagName, Oo.nestedComponents = [wc, ds, fo], Oo.shadowRootOptions = {
  ...Jb(Oo, Oo, "shadowRootOptions"),
  delegatesFocus: !1
}, Oo);
lo([
  ue({ type: Boolean })
], to.prototype, "disabled", 2);
lo([
  ue()
], to.prototype, "placeholder", 2);
lo([
  Se()
], to.prototype, "searching", 2);
lo([
  Se()
], to.prototype, "value", 2);
lo([
  Se()
], to.prototype, "hasSearchResults", 2);
lo([
  et('[role="combobox"]')
], to.prototype, "combobox", 2);
lo([
  et('[beacon-tag-name="beacon-multi-select"]')
], to.prototype, "multiSelectComponent", 2);
lo([
  et('[beacon-tag-name="beacon-control"]')
], to.prototype, "beaconControl", 2);
lo([
  Pe({
    flatten: !0,
    selector: '[beacon-tag-name="beacon-multi-select-optgroup"]'
  })
], to.prototype, "optgroups", 2);
lo([
  qe
], to.prototype, "addMultiSelectEventListeners", 1);
lo([
  De
], to.prototype, "attachArrowControlKeyboardListeners", 1);
lo([
  De
], to.prototype, "sortOptions", 1);
lo([
  De
], to.prototype, "initializeSelectedValues", 1);
let oz = to;
const wg = {
  beaconTagName: "beacon-multi-select-option"
};
var EO = Object.defineProperty, Tc = (i, t, e, a) => {
  for (var o = void 0, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = r(t, e, o) || o);
  return o && EO(t, e, o), o;
}, ks, ri;
const js = (ri = class extends Le {
  constructor() {
    super(...arguments);
    Fe(this, ks);
    this.beaconTagName = wg.beaconTagName, this.selected = !1, this.controlId = this.id || Ia();
  }
  get optionText() {
    return ze(this, ks);
  }
  set labelNode(e) {
    Ne(this, ks, e);
  }
  static concatNodeTextContent(e) {
    return e.map((a) => {
      var o, n;
      return (n = (o = a == null ? void 0 : a.textContent) == null ? void 0 : o.trim()) != null ? n : "";
    }).join(" ").trim();
  }
  get label() {
    return ri.concatNodeTextContent(this.defaultSlotNodes);
  }
  get count() {
    return ri.concatNodeTextContent(this.countSlotNodes);
  }
  handleLabelSlotchange() {
    this.labelNode = this.labelNodes.find((e) => !!e), this.label && Re(this, Ee.CHANGE);
  }
  render() {
    return Be`
      <slot @slotchange=${this.handleLabelSlotchange}></slot>
      <slot name="count"></slot>
    `;
  }
}, ks = new WeakMap(), ri.tagName = wg.beaconTagName, ri);
Tc([
  ue({ type: Boolean })
], js.prototype, "selected");
Tc([
  Fo()
], js.prototype, "defaultSlotNodes");
Tc([
  Fo({ slot: "count" })
], js.prototype, "countSlotNodes");
Tc([
  Fo()
], js.prototype, "labelNodes");
let az = js;
const TO = ve`[beacon-tag-name=beacon-navigation-footer] a,[beacon-tag-name=beacon-navigation-footer] li{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100)}[beacon-tag-name=beacon-navigation-footer] a{color:var(--beacon-system-color-text-link)}[beacon-tag-name=beacon-navigation-footer] a:not(:hover,:focus){text-decoration:none}[beacon-tag-name=beacon-navigation-footer]:not(:last-of-type){border-block-end:var(--beacon-system-width-border-mini) solid var(--beacon-system-color-border-0);padding-block-end:var(--beacon-system-space-micro-jumbo)}@media (width >= 960px){[beacon-tag-name=beacon-navigation-footer]:not(:last-of-type){border-block-end:0;padding-block-end:0}}[beacon-tag-name=beacon-navigation-footer] [slot=title]{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-50)}`, MO = ve`::slotted([slot=title]){font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-50)}`, Ib = class Ib extends ev {
  constructor() {
    super(...arguments), this.beaconTagName = Bn.beaconFooterNavTagName;
  }
  static get styles() {
    return [super.styles, MO];
  }
  static get lightDOMStyles() {
    return [...super.lightDOMStyles, TO];
  }
  setLevel() {
    this.level = 2;
  }
  setLevel2GridTemplate() {
    this.style.setProperty("--expanded-nav-grid-template", "1");
  }
};
Ib.tagName = Bn.beaconFooterNavTagName;
let kg = Ib;
const LO = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path d="M8 14L12 10L16 14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`, OO = `<svg class="icon--close" slot="icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M18.4697 19.5303C18.7626 19.8232 19.2374 19.8232 19.5303 19.5303C19.8232 19.2374 19.8232 18.7626 19.5303 18.4697L13.0607 12L19.5303 5.53033C19.8232 5.23744 19.8232 4.76256 19.5303 4.46967C19.2374 4.17678 18.7626 4.17678 18.4697 4.46967L12 10.9393L5.53033 4.46967C5.23744 4.17678 4.76256 4.17678 4.46967 4.46967C4.17678 4.76256 4.17678 5.23744 4.46967 5.53033L10.9393 12L4.46967 18.4697C4.17678 18.7626 4.17678 19.2374 4.46967 19.5303C4.76256 19.8232 5.23744 19.8232 5.53033 19.5303L12 13.0607L18.4697 19.5303Z" fill="#0063AD"/>
</svg>
`, PO = `<svg class="icon--error" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Error">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M1.57752 11.0009C1.22025 11.6197 1.22025 12.3821 1.57752 13.0009L5.92282 20.5272C6.28009 21.146 6.94034 21.5272 7.65487 21.5272H16.3455C17.06 21.5272 17.7203 21.146 18.0775 20.5272L22.4228 13.0009C22.7801 12.3821 22.7801 11.6197 22.4228 11.0009L18.0775 3.47461C17.7203 2.85581 17.06 2.47461 16.3455 2.47461H7.65487C6.94034 2.47461 6.28008 2.85581 5.92282 3.47461L1.57752 11.0009ZM11.2502 7.75087C11.2502 7.33665 11.586 7.00087 12.0002 7.00087C12.4144 7.00087 12.7502 7.33665 12.7502 7.75087V12.2509C12.7502 12.6651 12.4144 13.0009 12.0002 13.0009C11.586 13.0009 11.2502 12.6651 11.2502 12.2509V7.75087ZM13.0002 16.0009C13.0002 16.5532 12.5525 17.0009 12.0002 17.0009C11.4479 17.0009 11.0002 16.5532 11.0002 16.0009C11.0002 15.4486 11.4479 15.0009 12.0002 15.0009C12.5525 15.0009 13.0002 15.4486 13.0002 16.0009Z" fill="#DD3636"/>
</svg>
`, zO = `<svg class="icon--informational" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="Informational">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12.75 16.25C12.75 16.6642 12.4142 17 12 17C11.5858 17 11.25 16.6642 11.25 16.25V11.75C11.25 11.3358 11.5858 11 12 11C12.4142 11 12.75 11.3358 12.75 11.75V16.25ZM11 8C11 7.44771 11.4477 7 12 7C12.5523 7 13 7.44771 13 8C13 8.55229 12.5523 9 12 9C11.4477 9 11 8.55229 11 8Z" fill="#0063AD"/>
</svg>
`, DO = `<svg class="icon--success" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="Succcess">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM16.6081 9.43895C16.8506 9.10309 16.7748 8.6343 16.439 8.39187C16.1031 8.14944 15.6343 8.22519 15.3919 8.56105L10.8463 14.8586L8.52152 12.6092C8.22385 12.3211 7.74904 12.3289 7.46101 12.6266C7.17298 12.9243 7.1808 13.3991 7.47848 13.6871L10.4258 16.539C10.5823 16.6903 10.7967 16.7663 11.0135 16.7471C11.2303 16.7279 11.4281 16.6154 11.5555 16.439L16.6081 9.43895Z" fill="#248647"/>
</svg>
`, IO = `<svg class="icon--warning" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="Warning">
  <path d="M10.0652 3C10.835 1.66667 12.7595 1.66667 13.5293 3L21.3235 16.5C22.0933 17.8333 21.131 19.5 19.5914 19.5H4.00298C2.46338 19.5 1.50113 17.8333 2.27093 16.5L10.0652 3Z" fill="#FFC42D"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M12 7C11.5858 7 11.25 7.33579 11.25 7.75V12.25C11.25 12.6642 11.5858 13 12 13C12.4142 13 12.75 12.6642 12.75 12.25V7.75C12.75 7.33579 12.4142 7 12 7ZM12 17C12.5523 17 13 16.5523 13 16C13 15.4477 12.5523 15 12 15C11.4477 15 11 15.4477 11 16C11 16.5523 11.4477 17 12 17Z" fill="#061937"/>
</svg>
`, Cg = {
  beaconTagName: "beacon-notification"
}, BO = ve`:host([motion-state=enabled][in-motion]) .motion-wrap,:host([collapsed]) .motion-wrap{overflow:hidden}`;
var RO = Object.getOwnPropertyDescriptor, NO = (i, t, e, a) => {
  for (var o = a > 1 ? void 0 : a ? RO(t, e) : t, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = r(o) || o);
  return o;
};
function FO(i) {
  let t = class extends i {
    static get NotificationMotionStyles() {
      return [BO];
    }
  };
  return t = NO([
    je("NotificationMotion")
  ], t), t;
}
const _O = ve`.visually-hidden{border:0;clip:rect(0,0,0,0);block-size:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;inline-size:1px}:host{background-color:var(--notification-background-color, var(--beacon-component-notification-color-background-standard))}:host([variant=informational]){--notification-background-color: var(--beacon-component-notification-color-background-informational);--notification-border-color: var(--beacon-component-notification-color-border-informational)}:host([variant=warning]){--notification-background-color: var(--beacon-component-notification-color-background-warning);--notification-border-color: var(--beacon-component-notification-color-border-warning)}:host([variant=error]){--notification-background-color: var(--beacon-component-notification-color-background-error);--notification-border-color: var(--beacon-component-notification-color-border-error)}:host([variant=success]){--notification-background-color: var(--beacon-component-notification-color-background-success);--notification-border-color: var(--beacon-component-notification-color-border-success)}:host(:is([type=inline],[type=toast])){max-inline-size:var(--beacon-system-breakpoint-xxx-large)}.base{margin:auto;max-inline-size:var(--beacon-system-breakpoint-xxx-large);position:relative}.base .shell{display:grid;grid-column-gap:var(--beacon-reference-space-4);grid-template-columns:auto 1fr;grid-template-rows:auto;padding:var(--beacon-system-space-cell-contained)}.base .shell .icon{align-self:center;display:grid;grid-area:1}.base .shell .description{grid-area:2/2}.base .shell .action-zone{grid-area:3/2}.base .shell .chevron,.base .shell .close-wrapper{align-self:baseline;grid-area:1/3}.base .shell .title{align-self:center}.base .shell:has(.icon.hide-slot-area){grid-template-columns:1fr auto}.base .shell:has(.icon.hide-slot-area) .description{grid-area:2}.base .shell:has(.icon.hide-slot-area) .action-zone{grid-area:3}.base .shell:has(.icon.hide-slot-area) .chevron{grid-area:1/2}.base:not(.standard){color:var(--beacon-system-color-text-set-navy)}.base:not(.standard) ::part(icon-button){color:var(--beacon-reference-palette-functional-blue-3)}.base:is(.alert,.banner){padding-block:var(--beacon-system-space-organism-normal);padding-inline:var(--beacon-system-space-organism-maxi)}.base:is(.alert,.banner) .title{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-100)}.base:is(.alert,.banner) .description{margin-block-start:var(--beacon-reference-space-3)}.base:is(.alert,.banner) .action-zone{margin-block-start:var(--beacon-reference-space-5)}.base.inline{padding:var(--beacon-system-space-organism-normal)}.base.inline .shell,.base.inline .body{padding:var(--beacon-system-space-cell-contained)}.base.toast{box-shadow:var(--beacon-system-color-shadow-low);padding:var(--beacon-system-space-cell-contained)}.base.toast .shell{padding:var(--beacon-reference-space-2)}.base.toast .shell .icon{align-self:baseline}.base:is(.inline,.toast){border:var(--beacon-system-width-border-normal) solid var(--notification-border-color, var(--beacon-component-notification-color-border-standard));border-radius:var(--beacon-system-radius-corner-standard)}.base:is(.inline,.toast) .title{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-body-200)}.base:is(.inline,.toast) .description{margin-block-start:var(--beacon-reference-space-2)}.base:is(.inline,.toast) .action-zone{margin-block-start:var(--beacon-reference-space-3)}.base.banner:not(.expanded) .description,.base.banner:not(.expanded) .action-zone,.base.banner:not(.expanded) .body{margin:0;opacity:0}.base.banner .chevron{--active-bg: var(--beacon-system-color-background-primary-pressed);--active-border: var(--beacon-system-color-border-secondary-pressed);--active-icon: var(--beacon-system-color-icon-secondary-pressed);--bg-color: var(--beacon-system-color-background-primary);--border-color: var(--beacon-system-color-border-secondary);--border-width: var(--beacon-system-width-border-mini);--default-size: var(--beacon-reference-space-9);--disabled-bg: var(--beacon-system-color-background-primary-inactive);--disabled-border: var(--beacon-system-color-border-secondary-inactive);--disabled-icon: var(--beacon-system-color-icon-primary-inactive);--hover-bg: var(--beacon-system-color-background-primary-hover);--hover-border: var(--beacon-system-color-border-secondary-hover);--hover-icon: var(--beacon-system-color-icon-secondary-hover);--icon-color: var(--beacon-system-color-icon-primary);align-items:center;background-color:var(--override-icon-button-bg-color, var(--bg-color));block-size:var(--override-icon-button-wrapper-block-size, var(--beacon-reference-space-10));border:var(--border-width) solid var(--border-color);border-radius:var(--override-icon-button-border-radius, var(--beacon-system-radius-corner-circle));box-shadow:var(--override-icon-button-box-shadow, initial);color:var(--override-icon-button-color, var(--beacon-host-override-icon-button-color, var(--icon-color)));cursor:pointer;display:inline-flex;inline-size:var(--override-icon-button-wrapper-inline-size, var(--beacon-reference-space-10));justify-content:center;outline-offset:var(--override-icon-button-outline-offset);position:relative;--active-bg: var(--beacon-system-color-background-tertiary-pressed);--active-icon: var(--beacon-system-color-icon-tertiary-pressed);--bg-color: transparent;--default-hover-bg: var(--beacon-system-color-background-tertiary-hover);--default-hover-icon: var(--beacon-system-color-icon-tertiary-hover);--default-icon-color: var(--beacon-system-color-icon-tertiary);--disabled-bg: transparent;--disabled-icon: var(--beacon-system-color-icon-tertiary-inactive);--hover-bg: var(--override-icon-button-hover-bg, var(--default-hover-bg));--hover-icon: var(--override-icon-button-icon-color, var(--default-hover-icon));--icon-color: var(--override-icon-button-icon-color, var(--default-icon-color));border:0;transform:rotate(0);transition-duration:var(--beacon-reference-motion-duration-3);transition-property:transform}.base.banner .chevron .contents{align-items:inherit;display:inherit;justify-content:inherit;position:inherit}.base.banner .chevron[aria-disabled=true]{--icon-color: var(--disabled-icon);background-color:var(--disabled-bg);border-color:var(--disabled-border);color:var(--disabled-icon);cursor:not-allowed}.base.banner .chevron svg,.base.banner .chevron [beacon-tag-name=beacon-icon]{position:absolute}.base.banner .chevron:-webkit-direct-focus{outline:-webkit-focus-ring-color auto 0}.base.banner .chevron:hover:not([aria-disabled=true]){--icon-color: var(--hover-icon);background-color:var(--hover-bg);border-color:var(--hover-border);color:var(--hover-icon)}.base.banner .chevron:active:not([aria-disabled=true]){--icon-color: var(--active-icon);background-color:var(--active-bg);border-color:var(--active-border);color:var(--active-icon)}.base.banner.expanded .chevron{transform:rotate(180deg)}.base.banner:not(.standard) svg{color:var(--beacon-reference-palette-functional-blue-3)}.base.banner :is(.description,.body,.action-zone){display:grid;transition-property:var(--unroll-from-transition-direction);--unroll-from-transition-property: grid-template-rows;grid-template-rows:0fr;transition-duration:var(--beacon-reference-motion-duration-5);transition-property:margin,opacity;transition-timing-function:var(--beacon-system-motion-easing-accelerate-emphasize-1)}.base.banner :is(.description,.body,.action-zone) [class*=wrapper]{overflow:hidden}.base.banner.expanded :is(.description,.body,.action-zone){display:grid;grid-template-rows:1fr}.shell .icon{flex-shrink:0}.shell .icon svg,.shell .icon ::slotted(svg),.shell .icon ::slotted(img){max-block-size:var(--beacon-reference-space-7);max-inline-size:var(--beacon-reference-space-7)}.shell .content{flex-grow:1}.shell:has(.description.hide-slot-area):has(.action-zone.hide-slot-area){align-items:center}.description,.body{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100)}@media (width >= 1920px){.base:is(.banner,.alert){padding-inline:0}}`;
var UO = Object.defineProperty, jO = Object.getOwnPropertyDescriptor, kr = (i, t, e, a) => {
  for (var o = a > 1 ? void 0 : a ? jO(t, e) : t, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = (a ? r(t, e, o) : r(o)) || o);
  return a && o && UO(t, e, o), o;
}, Ca;
const yn = (Ca = class extends Ke(Le).with(
  fr({ autoRemoveMotionClasses: !1 }),
  FO
) {
  constructor() {
    super(...arguments), this.beaconTagName = Cg.beaconTagName, this.resetSpacing = !0, this.type = "inline", this.variant = "standard", this.dismissable = !1, this.collapsed = !1;
  }
  static get styles() {
    return [super.styles, _O, this.NotificationMotionStyles];
  }
  static renderIcon(t) {
    if (t === "standard")
      return pe`
        <div class="icon" aria-hidden="true">
          <slot ${Ue({ useParent: !0 })} name="icon"></slot>
        </div>
      `;
    let e = pe``;
    switch (t) {
      case "informational":
        e = pe`${ut(zO)}`;
        break;
      case "success":
        e = pe`${ut(DO)}`;
        break;
      case "warning":
        e = pe`${ut(IO)}`;
        break;
      case "error":
        e = pe`${ut(PO)}`;
        break;
    }
    return pe`<div class="icon" aria-hidden="true">${e}</div>`;
  }
  toggleCollapsed() {
    this.collapsed = !this.collapsed;
  }
  renderIconByType() {
    return this.type === "banner" ? pe`
        <button
          class="${Oe({
      chevron: !0
    })}"
          aria-expanded="${String(!this.collapsed)}"
          aria-controls="description action-zone body"
          @click=${this.toggleCollapsed}>
          <span class="visually-hidden">Notification Details</span>
          ${ut(LO)}
        </button>
      ` : this.type === "toast" || this.dismissable ? Be`
        <div class="close-wrapper">
          <${this.getScopedTag("beacon-icon-button")} @beacon-event-click=${this.dismiss} class="close" variant="tertiary">${ut(OO)} Dismiss</${this.getScopedTag("beacon-icon-button")}>
        </div>
      ` : pe``;
  }
  renderBodySlot() {
    return this.type !== "toast" ? pe`
        <div
          class="body"
          id="body"
          ?inert=${gt(this.inertContentStatus())}>
          <div class="motion-wrap">
            <slot name="body" ${Ue({ container: ".body" })}></slot>
          </div>
        </div>
      ` : pe``;
  }
  dismiss() {
    Re(this, Ee.DISMISS), this.remove();
  }
  static getRelevantAriaRole(t) {
    if (t === "inline")
      return "status";
  }
  addAnalyticsAttributes() {
    const t = this.type === "toast" ? "PU" : "ALRT";
    this.dataset.metricsLocation = t;
  }
  /**
   * Non-standard notifications default to a light mode. This will find the closest variant of light mode and add it to the class list.
   */
  addLightModeClasses() {
    if (this.variant !== "standard") {
      const t = this.closest(
        '[class*="beacon-on-light"]'
      );
      if (t) {
        const e = Array.from(t.classList).find(
          (a) => a.startsWith("beacon-on-light")
        );
        this.classList.add(e != null ? e : "beacon-on-light");
      } else
        this.classList.add("beacon-on-light");
    }
  }
  inertContentStatus() {
    if (this.type === "banner" && this.collapsed) return !0;
  }
  // aria-role is added to the most important text area since live regions read out text within as a single string
  // so semantics of an anchor link or button will not be noted
  render() {
    const t = {
      base: !0,
      dismissable: this.dismissable || this.type === "toast",
      expanded: !this.collapsed
    };
    return t[this.variant] = !0, t[this.type] = !0, pe`
      <div class="${Oe(t)}">
        <div
          class="shell"
          role="${gt(
      Ca.getRelevantAriaRole(this.type)
    )}">
          ${Ca.renderIcon(this.variant)}
          <div class="title" id="title" role="heading" aria-level="2">
            <slot></slot>
          </div>
          <div
            class="description"
            id="description"
            ?inert=${gt(this.inertContentStatus())}>
            <div class="motion-wrap">
              <slot
                name="description"
                ${Ue({ container: ".description" })}></slot>
            </div>
          </div>
          <div
            class="action-zone"
            id="action-zone"
            ?inert=${gt(this.inertContentStatus())}>
            <div class="motion-wrap">
              <slot
                name="action-zone"
                ${Ue({ container: ".action-zone" })}></slot>
            </div>
          </div>
          ${this.renderIconByType()}
        </div>
        ${this.renderBodySlot()}
      </div>
    `;
  }
}, Ca.tagName = Cg.beaconTagName, Ca.nestedComponents = [eo], Ca);
kr([
  ue({ reflect: !0 })
], yn.prototype, "type", 2);
kr([
  ue({ reflect: !0 })
], yn.prototype, "variant", 2);
kr([
  ue({ type: Boolean })
], yn.prototype, "dismissable", 2);
kr([
  ue({ type: Boolean, reflect: !0 })
], yn.prototype, "collapsed", 2);
kr([
  De
], yn.prototype, "addAnalyticsAttributes", 1);
kr([
  De
], yn.prototype, "addLightModeClasses", 1);
let iz = yn;
const Sg = {
  beaconTagName: "beacon-notification-group"
}, $O = ve`:where([beacon-tag-name=beacon-notification-group]):where([floating]) :where([beacon-tag-name=beacon-notification]){inline-size:100%;margin-inline:auto;max-inline-size:var(--notification-width, auto);pointer-events:auto}@media (width >= 640px){:where([beacon-tag-name=beacon-notification-group]):where([floating]):where([align=right]){--notification-width: 340px}:where([beacon-tag-name=beacon-notification-group]):where([floating]):where([align=right]) :where([beacon-tag-name=beacon-notification]){margin-inline-end:0}:where([beacon-tag-name=beacon-notification-group]):where([floating]):where([align=center]){--notification-width: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 6 + var(--beacon-system-space-gutter) * 5)}}`, HO = ve`.visually-hidden{border:0;clip:rect(0,0,0,0);block-size:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;inline-size:1px}.notifications{display:flex;flex-direction:column-reverse;gap:var(--beacon-reference-space-6)}.notifications.floating{inline-size:100%;inset-block-start:var(--notification-group-position, auto);padding-inline:var(--beacon-system-space-gutter);pointer-events:none;position:fixed;z-index:2500}`;
var KO = Object.defineProperty, xn = (i, t, e, a) => {
  for (var o = void 0, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = r(t, e, o) || o);
  return o && KO(t, e, o), o;
}, si;
const ki = (si = class extends Le {
  constructor() {
    super(), this.beaconTagName = Sg.beaconTagName, this.floating = !1, this.align = "right", this.anchor = '[beacon-tag-name="beacon-navigation"]', this.debounceOnScroll = !1, this.externalObserversApplied = !1, this.positionDebounced = Io(() => {
      this.setScreenPosition();
    }, 100), this.resizeObserverCallback = Io(() => {
      this.position();
    }, 100), this.position = this.position.bind(this);
  }
  static get styles() {
    return [super.styles, HO];
  }
  static get lightDOMStyles() {
    return [super.lightDOMStyles, $O];
  }
  getPositionOffset() {
    const t = document.querySelector(this.anchor);
    if (t) {
      const e = t.getBoundingClientRect(), { bottom: a } = e;
      return a <= 0 ? 0 : a;
    }
    return 0;
  }
  setScreenPosition() {
    const t = this.getPositionOffset();
    this.notificationsContainer.style.setProperty(
      "--notification-group-position",
      `calc(${t}px + ${si.minimumScreenPosition})`
    );
  }
  position() {
    this.setScreenPosition();
  }
  addScrollEventToWindow() {
    this.debounceOnScroll ? window.addEventListener("scroll", this.positionDebounced) : window.addEventListener("scroll", this.position), this.externalObserversApplied = !0;
  }
  removeScrollEventFromWindow() {
    this.debounceOnScroll ? window.removeEventListener("scroll", this.positionDebounced) : window.removeEventListener("scroll", this.position), this.externalObserversApplied = !1;
  }
  startScrollTracking(t) {
    const { target: e } = t;
    e instanceof HTMLSlotElement && e.classList.contains("notification-group") && (this.notifications.length > 0 ? (this.externalObserversApplied || (this.addScrollEventToWindow(), this.applyResizeObserver()), this.position()) : (this.removeScrollEventFromWindow(), this.removeResizeObserver()));
  }
  handleSlotchange(t) {
    this.floating && this.startScrollTracking(t);
  }
  createResizeObserver() {
    this.observer || (this.observer = new ResizeObserver(this.resizeObserverCallback));
  }
  applyResizeObserver() {
    var t;
    this.createResizeObserver(), (t = this.observer) == null || t.observe(this);
  }
  removeResizeObserver() {
    var t;
    (t = this.observer) == null || t.unobserve(this);
  }
  /** Convenience method for adding new toasts to the group. */
  addToast(t, e = "standard") {
    const a = document.createElement(
      this.getScopedTagName("beacon-notification")
    );
    a.type = "toast", a.variant = e, a.innerHTML = t, this.append(a);
  }
  renderTitleSlot() {
    return this.floating ? pe`
        <div class="visually-hidden" id="title">
          <slot name="title">Notifications</slot>
        </div>
      ` : pe``;
  }
  render() {
    const t = this.floating ? "log" : void 0, e = this.floating ? "additions" : void 0, a = this.floating ? "title" : void 0, o = {
      floating: this.floating,
      notifications: !0
    };
    return o[this.align] = !0, pe`
      ${this.renderTitleSlot()}
      <div
        class="${Oe(o)}"
        role="${gt(t)}"
        aria-relevant="${gt(e)}"
        aria-labelledby="${gt(a)}">
        <slot
          class="notification-group"
          @slotchange=${this.handleSlotchange}></slot>
      </div>
    `;
  }
}, si.tagName = Sg.beaconTagName, si.minimumScreenPosition = Nv, si);
xn([
  ue({ type: Boolean, reflect: !0 })
], ki.prototype, "floating");
xn([
  ue({ reflect: !0 })
], ki.prototype, "align");
xn([
  ue()
], ki.prototype, "anchor");
xn([
  ue({ attribute: "debounce-on-scroll", type: Boolean })
], ki.prototype, "debounceOnScroll");
xn([
  Se()
], ki.prototype, "externalObserversApplied");
xn([
  Pe({ selector: "beacon-notification" }, !0)
], ki.prototype, "notifications");
xn([
  Ge(".notifications")
], ki.prototype, "notificationsContainer");
let nz = ki;
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function* GO(i, t, e = 1) {
  const a = t === void 0 ? 0 : i;
  t != null || (t = i);
  for (let o = a; e > 0 ? o < t : t < o; o += e) yield o;
}
const WO = `<svg xmlns="http://www.w3.org/2000/svg" slot="icon" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M16 8L12 12L16 16" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M8 8V16" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`, qO = `<svg xmlns="http://www.w3.org/2000/svg" slot="icon" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M8 8L12 12L8 16" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M16 8V16" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`, VO = `<svg xmlns="http://www.w3.org/2000/svg" slot="icon" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M14 16L10 12L14 8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`, YO = `<svg xmlns="http://www.w3.org/2000/svg" slot="icon" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M10 8L14 12L10 16" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`, Eg = {
  beaconTagName: "beacon-pagination-button"
}, QO = ve`[beacon-tag-name=beacon-pagination-button] button:hover,[beacon-tag-name=beacon-pagination-button] a:hover{background-color:var(--beacon-system-color-background-secondary-hover);border-color:transparent}[beacon-tag-name=beacon-pagination-button] button:active,[beacon-tag-name=beacon-pagination-button] a:active{background-color:var(--beacon-system-color-background-secondary-pressed);border-color:transparent}`, XO = ve`.visually-hidden{border:0;clip:rect(0,0,0,0);block-size:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;inline-size:1px}:host button:hover{background-color:var(--beacon-system-color-background-secondary-hover);border-color:transparent}:host button:active{background-color:var(--beacon-system-color-background-secondary-pressed);border-color:transparent}:host button,:host ::slotted(a){align-items:center;-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:transparent;block-size:var(--beacon-reference-space-7);border-color:transparent;border-inline-start-width:var(--beacon-system-width-border-mini);border-radius:var(--beacon-system-radius-corner-standard);border-style:solid;border-width:var(--beacon-system-width-border-mini);color:var(--beacon-system-color-text-standard);display:inline-flex;inline-size:var(--beacon-reference-space-7);justify-content:center;overflow:hidden;text-decoration:none;text-wrap:nowrap;font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100)}@media (width >= 640px){:host button,:host ::slotted(a){block-size:var(--beacon-reference-space-8);inline-size:var(--beacon-reference-space-8)}}@media (width >= 1280px){:host button,:host ::slotted(a){block-size:var(--beacon-reference-space-9);inline-size:var(--beacon-reference-space-9)}}:host .current button,:host .current ::slotted(a){background-color:var(--beacon-system-color-background-primary);border-color:var(--beacon-system-color-background-primary);color:var(--beacon-system-color-text-primary);font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-body-100)}:host .truncated-pagination{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100)}`;
var ZO = Object.defineProperty, JO = Object.getOwnPropertyDescriptor, Cr = (i, t, e, a) => {
  for (var o = a > 1 ? void 0 : a ? JO(t, e) : t, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = (a ? r(t, e, o) : r(o)) || o);
  return a && o && ZO(t, e, o), o;
}, ti;
const Bb = class Bb extends Le {
  constructor() {
    super(...arguments);
    Fe(this, ti);
    this.beaconTagName = Eg.beaconTagName, this.isTruncating = !1, Ne(this, ti, !1), this._isLink = !1, this.emitPaginateEvent = () => {
      Re(this, Ee.PAGINATE, {
        detail: {
          page: this._value
        }
      });
    };
  }
  static get styles() {
    return [super.styles, XO];
  }
  static get lightDOMStyles() {
    return [...super.lightDOMStyles, QO];
  }
  get _current() {
    return ze(this, ti);
  }
  set _current(e) {
    Ne(this, ti, e), ze(this, ti) && this._slottedLink && this._slottedLink.setAttribute(
      "aria-current",
      ze(this, ti) ? "page" : "false"
    );
  }
  handlePaginate() {
    this.emitPaginateEvent();
  }
  handleDefaultSlotchange() {
    this._slottedLink && (this._isLink = !0, this._slottedLink.addEventListener("click", this.emitPaginateEvent));
  }
  render() {
    const e = {
      base: !0,
      current: this._current
    };
    return this.isTruncating ? (e["truncated-pagination"] = !0, pe` <div class="${Oe(e)}">...</div> `) : pe`
      <div class="${Oe(e)}">
        <slot @slotchange=${this.handleDefaultSlotchange}>
          <button
            aria-current="${this._current ? "page" : "false"}"
            @click=${this.handlePaginate}>
            <span>${this._value}</span>
            <span class="visually-hidden" id="total"
              >of ${this._totalPageCount}</span
            >
          </button>
        </slot>
      </div>
    `;
  }
};
ti = new WeakMap(), Bb.tagName = Eg.beaconTagName;
let Ma = Bb;
Cr([
  ue({ type: Number })
], Ma.prototype, "_value", 2);
Cr([
  ue({ attribute: "is-truncating", type: Boolean })
], Ma.prototype, "isTruncating", 2);
Cr([
  ue({ type: Boolean, reflect: !0, attribute: "current" })
], Ma.prototype, "_current", 1);
Cr([
  Se()
], Ma.prototype, "_isLink", 2);
Cr([
  Se()
], Ma.prototype, "_totalPageCount", 2);
Cr([
  bn("a")
], Ma.prototype, "_slottedLink", 2);
const Qt = {
  beaconTagName: "beacon-pagination",
  ICON_BUTTON_TAG: "beacon-icon-button",
  PAGINATION_BUTTON_TAG: "beacon-pagination-button"
}, eP = ve`.visually-hidden{border:0;clip:rect(0,0,0,0);block-size:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;inline-size:1px}:host{--override-icon-button-block-size: var(--beacon-reference-space-7);--override-icon-button-inline-size: var(--beacon-reference-space-7);--override-icon-button-border-radius: var(--beacon-system-radius-corner-standard);--override-icon-button-wrapper-block-size: var(--beacon-reference-space-7);--override-icon-button-wrapper-inline-size: var(--beacon-reference-space-7);--override-icon-button-display: flex}@media (width >= 640px){:host{--override-icon-button-block-size: var(--beacon-reference-space-8);--override-icon-button-inline-size: var(--beacon-reference-space-8);--override-icon-button-wrapper-block-size: var(--beacon-reference-space-8);--override-icon-button-wrapper-inline-size: var(--beacon-reference-space-8)}}@media (width >= 1280px){:host{--override-icon-button-block-size: var(--beacon-reference-space-9);--override-icon-button-inline-size: var(--beacon-reference-space-9);--override-icon-button-wrapper-block-size: var(--beacon-reference-space-9);--override-icon-button-wrapper-inline-size: var(--beacon-reference-space-9)}}:host .base{align-items:center;display:flex;gap:var(--beacon-reference-space-3)}:host .base.on-first .previous,:host .base.on-first .first{display:none}:host .base.on-last .next,:host .base.on-last .last{display:none}:host .base.input .search-wrapper{align-items:center;display:flex;gap:var(--beacon-reference-space-3)}:host .base.input .total-pages{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100);text-wrap:nowrap}:host .base.input input{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100);background-color:var(--beacon-system-color-background-1);block-size:var(--beacon-reference-space-9);border:var(--beacon-system-width-border-mini) solid var(--beacon-component-form-color-border-standard);border-radius:var(--beacon-system-radius-corner-standard);color:var(--beacon-system-color-text-standard);inline-size:var(--beacon-reference-space-10);text-align:center}:host .base.input input:focus-visible{outline:var(--beacon-system-width-border-normal) solid var(--beacon-system-color-border-focus-middle);outline-offset:var(--beacon-system-width-border-normal);position:relative;z-index:1}:host .pagination-buttons,:host ::slotted(ol){align-items:center;display:flex;gap:var(--beacon-reference-space-3);list-style:none;margin:0;padding:0}:host .number-input{-webkit-appearance:textfield;-moz-appearance:textfield;appearance:textfield}:host .number-input::-webkit-inner-spin-button,:host .number-input::-webkit-outer-spin-button{-webkit-appearance:none;-moz-appearance:none;appearance:none}:host .truncated{display:none}:host .truncated:has(+.last-page){display:revert}:host .first-page+.truncated,:host:has(+.last-page){display:revert}`;
var tP = Object.defineProperty, oP = Object.getOwnPropertyDescriptor, Ci = (i, t, e, a) => {
  for (var o = a > 1 ? void 0 : a ? oP(t, e) : t, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = (a ? r(t, e, o) : r(o)) || o);
  return a && o && tP(t, e, o), o;
}, Cs, oi, Tt;
const _a = (Tt = class extends Le {
  constructor() {
    super(...arguments);
    Fe(this, Cs);
    Fe(this, oi);
    this.beaconTagName = Qt.beaconTagName, this.variant = "default", Ne(this, oi, 1), this.pageUpdatedByNavigation = !1, this.isKeyboardNavigation = !1, this.handleKeyDown = () => {
      this.isKeyboardNavigation = !0;
    }, this.handleMouseDown = () => {
      this.isKeyboardNavigation = !1;
    };
  }
  static get styles() {
    return [super.styles, eP];
  }
  get pages() {
    return ze(this, Cs);
  }
  set pages(e) {
    Ne(this, Cs, e), this.currentPage > this.pages && (this.pageUpdatedByNavigation = !1, this.currentPage = this.pages);
  }
  get currentPage() {
    return ze(this, oi);
  }
  set currentPage(e) {
    e > this.totalPages ? (Tt.pageCountErrorLog(), Ne(this, oi, 1)) : ze(this, oi) !== e && (Ne(this, oi, Number(e)), Re(this, Ee.CHANGE, {
      detail: {
        page: this.currentPage,
        interaction: this.pageUpdatedByNavigation
      }
    }), this.variant === "default" && (this.resetCurrentPage(), this.setCurrentPage()));
  }
  // doesn't use a query decorator since we're looking at child elements of a list
  get slottedPaginationButtons() {
    return Array.from(
      this.querySelectorAll('[beacon-tag-name="beacon-pagination-button"]')
    );
  }
  get inUsePaginationButtons() {
    return this.slottedPaginationButtons.length > 0 ? this.slottedPaginationButtons : this.paginationButtons;
  }
  get totalPages() {
    return this.slottedPaginationButtons.length > 0 ? this.slottedPaginationButtons.length : this.pages;
  }
  get isOnLastPage() {
    return this.currentPage === this.totalPages;
  }
  get isOnFirstPage() {
    return this.currentPage === 1;
  }
  static pageCountErrorLog() {
    console.log(
      "Beacon Pagination tried to set a current page that is out of range of possible pages."
    );
  }
  incrementPage() {
    this.pageUpdatedByNavigation = !0, this.currentPage++, this.isOnLastPage && this.handleOnLastPage();
  }
  decrementPage() {
    this.pageUpdatedByNavigation = !0, this.currentPage--, this.isOnFirstPage && this.handleOnFirstPage();
  }
  skipToFirstPage() {
    this.pageUpdatedByNavigation = !0, this.currentPage = 1, this.handleOnFirstPage();
  }
  skipToLastPage() {
    this.pageUpdatedByNavigation = !0, this.currentPage = this.pages, this.handleOnLastPage();
  }
  handleOnFirstPage() {
    this.isKeyboardNavigation && (this.variant === "input" ? this.searchField.focus() : this.inUsePaginationButtons[0].focus());
  }
  handleOnLastPage() {
    this.isKeyboardNavigation && (this.variant === "input" ? this.searchField.focus() : this.inUsePaginationButtons[this.inUsePaginationButtons.length - 1].focus());
  }
  resetCurrentPage() {
    const e = this.inUsePaginationButtons, a = Array.from(e).find(
      (o) => o._current
    );
    a && (a._current = !1);
  }
  setCurrentPage() {
    const e = this.inUsePaginationButtons[this.currentPage - 1];
    e && (e._current = !0, e._isLink && this.pageUpdatedByNavigation && e._slottedLink.click());
  }
  handlePaginateEvent(e) {
    this.pageUpdatedByNavigation = !1, this.currentPage = e.detail.page;
  }
  handleDefaultSlotchange() {
    if (this.resetCurrentPage(), this.slottedPaginationButtons.forEach(
      (e, a) => {
        e._value = a + 1;
      }
    ), this.currentPage > this.totalPages)
      Tt.pageCountErrorLog(), this.currentPage = 1;
    else {
      const e = this.inUsePaginationButtons[this.currentPage - 1];
      e && !e._current && (e._current = !0);
    }
  }
  static renderPaginationButtonListItem(e, a) {
    return pe`<li class="${e}">${a}</li>`;
  }
  /**
   * Renders all the buttons in a pagination. Only the necessary pages are shown untruncated.
   *
   * Logic works as follows:
   *
   * - Current page visible
   * - First page visible
   * - Last page visible
   * - Previous page visible
   * - Next page visible
   * - Third page visible if the first page is the current page
   * - Third to last page visible if the last page is the current page
   */
  generateButtons() {
    return pe`
      <ol class="pagination-buttons" role="list">
        ${Vo(GO(this.pages), (e) => {
      const a = e + 1, o = Be`
            <${this.getScopedTag(Qt.PAGINATION_BUTTON_TAG)}
              ._value="${a}"
              ._current=${this.currentPage === a}
              ._totalPageCount=${this.totalPages}
            ></${this.getScopedTag(Qt.PAGINATION_BUTTON_TAG)}>
          `;
      return a === this.currentPage ? Tt.renderPaginationButtonListItem(
        "current-page",
        o
      ) : a === this.currentPage - 1 ? Tt.renderPaginationButtonListItem(
        "previous-page",
        o
      ) : a === this.currentPage + 1 ? Tt.renderPaginationButtonListItem(
        "next-page",
        o
      ) : a === 1 ? Tt.renderPaginationButtonListItem(
        "first-page",
        o
      ) : a === this.pages ? Tt.renderPaginationButtonListItem(
        "last-page",
        o
      ) : this.isOnFirstPage && a === 3 ? Tt.renderPaginationButtonListItem(
        "third-page",
        o
      ) : this.isOnLastPage && a === this.pages - 2 ? Tt.renderPaginationButtonListItem(
        "third-last-page",
        o
      ) : Tt.renderPaginationButtonListItem(
        "truncated",
        Be`<${this.getScopedTag(Qt.PAGINATION_BUTTON_TAG)} is-truncating></${this.getScopedTag(Qt.PAGINATION_BUTTON_TAG)}>`
      );
    })}
      </ol>
    `;
  }
  // TODO: replace all these with their respective icons
  renderPreviousPageButton() {
    return Be`<${this.getScopedTag(Qt.ICON_BUTTON_TAG)} @beacon-event-click=${this.decrementPage} variant="tertiary"
      >Previous page${ut(VO)}
    </${this.getScopedTag(Qt.ICON_BUTTON_TAG)}>`;
  }
  renderNextPageButton() {
    return Be`<${this.getScopedTag(Qt.ICON_BUTTON_TAG)} @beacon-event-click=${this.incrementPage} variant="tertiary"
      >Next page${ut(YO)}
    </${this.getScopedTag(Qt.ICON_BUTTON_TAG)}>`;
  }
  renderFirstPageButton() {
    return Be`<${this.getScopedTag(Qt.ICON_BUTTON_TAG)} @beacon-event-click=${this.skipToFirstPage} variant="tertiary"
      >Skip to first page${ut(WO)}
    </${this.getScopedTag(Qt.ICON_BUTTON_TAG)}>`;
  }
  renderLastPageButton() {
    return Be`<${this.getScopedTag(Qt.ICON_BUTTON_TAG)} @beacon-event-click=${this.skipToLastPage} variant="tertiary"
      >Skip to last page${ut(qO)}
    </${this.getScopedTag(Qt.ICON_BUTTON_TAG)}>`;
  }
  // slotted link clicks do not emit beacon-event-paginate because they are links to new pages
  renderDefaultVariant() {
    return pe`
      <div class="previous">${this.renderPreviousPageButton()}</div>
      <nav class="main" aria-labelledby="title">
        <span class="visually-hidden" id="title"
          ><slot name="title">Pagination</slot></span
        >
        <slot
          ${Rh()}
          @beacon-event-paginate=${this.handlePaginateEvent}
          @slotchange=${Is(this.handleDefaultSlotchange.bind(this))}
          >${this.generateButtons()}</slot
        >
      </nav>
      <div class="next">${this.renderNextPageButton()}</div>
    `;
  }
  handleInputKeydown(e) {
    if (e.key === "Enter") {
      const a = parseInt(this.searchField.value, 10);
      !isNaN(a) && a >= 1 && a <= this.pages ? this.currentPage = a : this.searchField.value = String(this.currentPage);
    }
  }
  renderInputVariant() {
    return pe`
      <div class="first">${this.renderFirstPageButton()}</div>
      <div class="previous">${this.renderPreviousPageButton()}</div>
      <search class="search-wrapper">
        <label for="search" class="visually-hidden">
          <slot name="search-label">Enter page number</slot>
        </label>
        <input
          class="skip-focus-override number-input"
          id="search"
          name="search"
          aria-describedby="total-pages"
          type="number"
          min="1"
          max="${this.pages}"
          inputmode="numeric"
          .value=${this.currentPage}
          @keydown=${this.handleInputKeydown} />
        <span id="total-pages" class="total-pages">of ${this.pages}</span>
      </search>
      <div class="next">${this.renderNextPageButton()}</div>
      <div class="last">${this.renderLastPageButton()}</div>
    `;
  }
  renderMainContent() {
    return this.variant === "input" ? this.renderInputVariant() : this.renderDefaultVariant();
  }
  registerNavigation() {
    this.addEventListener("keydown", this.handleKeyDown), this.addEventListener("mousedown", this.handleMouseDown);
  }
  tearDownNavigation() {
    this.removeEventListener("keydown", this.handleKeyDown), this.removeEventListener("mousedown", this.handleMouseDown);
  }
  render() {
    const e = {
      base: !0,
      "on-first": this.isOnFirstPage,
      "on-last": this.isOnLastPage
    };
    return e[this.variant] = !0, pe`<div class="${Oe(e)}">
      ${this.renderMainContent()}
    </div>`;
  }
}, Cs = new WeakMap(), oi = new WeakMap(), Tt.nestedComponents = [Ma, eo], Tt.tagName = Qt.beaconTagName, Tt.shadowRootOptions = {
  ...Le.shadowRootOptions,
  delegatesFocus: !1
}, Tt);
Ci([
  ue({ type: Number })
], _a.prototype, "pages", 1);
Ci([
  ue()
], _a.prototype, "variant", 2);
Ci([
  ue({ type: Number, attribute: "current-page", reflect: !0 })
], _a.prototype, "currentPage", 1);
Ci([
  Se()
], _a.prototype, "pageUpdatedByNavigation", 2);
Ci([
  Ge("input")
], _a.prototype, "searchField", 2);
Ci([
  Ts('[beacon-tag-name="beacon-pagination-button"]')
], _a.prototype, "paginationButtons", 2);
Ci([
  qe
], _a.prototype, "registerNavigation", 1);
Ci([
  Lt
], _a.prototype, "tearDownNavigation", 1);
let rz = _a;
const Tg = {
  beaconTagName: "beacon-progress-indicator"
}, aP = ve`.header{align-items:center;display:flex;gap:var(--beacon-reference-space-5);justify-content:space-between;margin-block-end:var(--beacon-reference-space-5)}.title{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100)}.progress-bar{background-color:var(--beacon-component-progress-indicator-color-background-incomplete);block-size:var(--beacon-reference-space-3);inline-size:100%}.progress-value{background-color:var(--beacon-component-progress-indicator-color-background-complete);block-size:100%;inline-size:min(100%,var(--progress, 0))}`;
var iP = Object.defineProperty, Ev = (i, t, e, a) => {
  for (var o = void 0, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = r(t, e, o) || o);
  return o && iP(t, e, o), o;
};
const Rb = class Rb extends Le {
  constructor() {
    super(...arguments), this.beaconTagName = Tg.beaconTagName, this.value = 0, this.max = 10;
  }
  static get styles() {
    return [super.styles, aP];
  }
  get ratio() {
    return this.value / this.max;
  }
  render() {
    const t = {
      "--progress": this.ratio * 100 + "%"
    };
    return pe`
      <div class="base">
        <div class="header" part="header">
          <div id="title" class="title">
            <slot name="title">Step ${this.value} of ${this.max}</slot>
          </div>
          <div class="action-zone">
            <slot name="action-zone" ${Ue({ useParent: !0 })}></slot>
          </div>
        </div>
        <div
          class="progress-bar"
          role="progressbar"
          aria-valuemin="0"
          aria-valuemax="${this.max}"
          aria-labelledby="title"
          aria-valuenow="${this.value}">
          <div class="progress-value" style="${Qf(t)}"></div>
        </div>
      </div>
    `;
  }
};
Rb.tagName = Tg.beaconTagName;
let Fl = Rb;
Ev([
  ue({ type: Number })
], Fl.prototype, "value");
Ev([
  ue({ type: Number })
], Fl.prototype, "max");
const Mg = {
  beaconTagName: "beacon-promo-tile"
}, nP = ve`[beacon-tag-name=beacon-promo-tile] .beacon-promo-tile__eyebrow{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-caption-300);color:var(--beacon-system-color-text-standard);display:block;margin:0;padding-block-end:var(--beacon-reference-space-5)}[beacon-tag-name=beacon-promo-tile] .beacon-promo-tile__title{color:var(--beacon-system-color-text-standard)}[beacon-tag-name=beacon-promo-tile] .beacon-promo-tile__title,[beacon-tag-name=beacon-promo-tile] .beacon-promo-tile__title>*{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-100);margin:0;text-decoration:none}[beacon-tag-name=beacon-promo-tile] a.beacon-promo-tile__title,[beacon-tag-name=beacon-promo-tile] .beacon-promo-tile__title>a{color:var(--beacon-system-color-text-link)}[beacon-tag-name=beacon-promo-tile] a.beacon-promo-tile__title:is(:focus,:hover),[beacon-tag-name=beacon-promo-tile] .beacon-promo-tile__title>a:is(:focus,:hover){text-decoration:underline}[beacon-tag-name=beacon-promo-tile] .beacon-promo-tile__description{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-loose-200);color:var(--beacon-system-color-text-standard);margin:0;padding-block-start:var(--beacon-system-space-micro-jumbo)}[beacon-tag-name=beacon-promo-tile] .beacon-action-zone{display:flex;flex-wrap:wrap;gap:var(--beacon-system-space-micro-jumbo);padding:var(--beacon-system-space-cell-contained)}[beacon-tag-name=beacon-promo-tile] .tile__footer--full-width .beacon-action-zone{padding:0}[beacon-tag-name=beacon-promo-tile] [slot=body]{--tile-body-margin-block-end: var(--beacon-system-space-micro-normal);padding-block:var(--beacon-system-space-cell-contained)}[beacon-tag-name=beacon-promo-tile] [slot=footer]{padding-block:var(--beacon-system-space-cell-contained)}[beacon-tag-name=beacon-promo-tile][media-template=standard] [slot=body]{padding-inline:var(--beacon-system-space-cell-contained)}[beacon-tag-name=beacon-promo-tile][media-template=standard] [slot=media]{max-block-size:var(--override-promo-tile-max-block-size, 296px);max-inline-size:var(--override-promo-tile-max-inline-size, 592px)}@media (width >= 640px){[beacon-tag-name=beacon-promo-tile][media-template=standard] [slot=media]:is(picture){inline-size:min(var(--promo-tile-media-inline-size),100%)}}[beacon-tag-name=beacon-promo-tile][media-template=standard].beacon-promo-tile__vertical-fill{--promo-tile-content-zone-block-size: 100%}[class*=b-grid-item] [beacon-tag-name=beacon-promo-tile][media-template=standard].beacon-promo-tile__vertical-fill{block-size:100%}[beacon-tag-name=beacon-promo-tile][media-template=full-bleed] .beacon-promo-tile__title,[beacon-tag-name=beacon-promo-tile][media-template=full-bleed] .beacon-promo-tile__title>*{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-loose-500)}[beacon-tag-name=beacon-promo-tile][media-template=full-bleed] [slot=media]{max-block-size:var(--override-promo-tile-max-block-size, 320px);max-inline-size:var(--override-promo-tile-max-inline-size, 640px)}[beacon-tag-name=beacon-promo-tile] [slot=media]>img,[beacon-tag-name=beacon-promo-tile] [slot=media]:not(picture){aspect-ratio:var(--promo-tile-media-aspect-ratio, initial);block-size:100%;inline-size:min(var(--promo-tile-media-inline-size),100%);object-fit:cover}@media (width >= 640px){[beacon-tag-name=beacon-promo-tile] .beacon-promo-tile__eyebrow{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-caption-200)}[beacon-tag-name=beacon-promo-tile][media-template=standard] [slot=media]{max-block-size:var(--override-promo-tile-max-block-size, 456px);max-inline-size:var(--override-promo-tile-max-inline-size, 456px)}[beacon-tag-name=beacon-promo-tile][position*=horizontal][media-template=standard] .beacon-promo-tile__title,[beacon-tag-name=beacon-promo-tile][position*=horizontal][media-template=standard] .beacon-promo-tile__title>*{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-300)}[beacon-tag-name=beacon-promo-tile][media-template=full-bleed] .beacon-promo-tile__eyebrow{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-caption-loose-300)}[beacon-tag-name=beacon-promo-tile][media-template=full-bleed] [slot=media]{max-block-size:var(--override-promo-tile-max-block-size, 480px);max-inline-size:var(--override-promo-tile-max-inline-size, 960px)}}@media (width >= 960px){[beacon-tag-name=beacon-promo-tile][media-template=full-bleed][scale=jumbo] .beacon-promo-tile__title,[beacon-tag-name=beacon-promo-tile][media-template=full-bleed][scale=jumbo] .beacon-promo-tile__title>*{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-display-loose-200)}[beacon-tag-name=beacon-promo-tile] [slot=media]:is(picture) img{aspect-ratio:var(--promo-tile-media-aspect-ratio, initial);inline-size:min(var(--promo-tile-media-inline-size) * 2,100%);object-fit:cover}[beacon-tag-name=beacon-promo-tile] [slot=media]{inline-size:min(var(--promo-tile-media-inline-size),100%)}[beacon-tag-name=beacon-promo-tile][media-template=standard] [slot=media]{max-block-size:var(--override-promo-tile-max-block-size, 400px);max-inline-size:var(--override-promo-tile-max-inline-size, 800px)}[beacon-tag-name=beacon-promo-tile][media-template=full-bleed] [slot=media]{max-block-size:var(--override-promo-tile-max-block-size, 600px);max-inline-size:var(--override-promo-tile-max-inline-size, 600px)}[beacon-tag-name=beacon-promo-tile][resize-to=content][position*=horizontal] :is([slot=media],[slot=media]>:is(picture,img)){--override-promo-tile-max-block-size: none;--override-promo-tile-max-inline-size: none;aspect-ratio:auto;block-size:100%;inline-size:100%;position:absolute}}@media (width >= 1280px){[beacon-tag-name=beacon-promo-tile][media-template=full-bleed][scale=jumbo] .beacon-promo-tile__title,[beacon-tag-name=beacon-promo-tile][media-template=full-bleed][scale=jumbo] .beacon-promo-tile__title>*{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-display-loose-300)}[beacon-tag-name=beacon-promo-tile][media-template=standard] [slot=media]{max-block-size:var(--override-promo-tile-max-block-size, 544px);max-inline-size:var(--override-promo-tile-max-inline-size, 1088px)}[beacon-tag-name=beacon-promo-tile][media-template=full-bleed] [slot=media]{max-block-size:var(--override-promo-tile-max-block-size, 800px);max-inline-size:var(--override-promo-tile-max-inline-size, 800px)}}@media (width >= 1600px){[media-template=full-bleed]{--promo-tile-content-zone-padding: 10rem;--promo-tile-content-zone-inline-size: 100%}[beacon-tag-name=beacon-promo-tile][position=horizontal] [slot=media]:is(picture) img{aspect-ratio:var(--promo-tile-media-aspect-ratio, initial);inline-size:unset;object-fit:cover}[beacon-tag-name=beacon-promo-tile] [slot=media]{inline-size:unset}}`, rP = ve`@media (prefers-reduced-motion: no-preference){:host([motion-state=enabled]) ::slotted(:is([slot=body],[slot=footer])){--motion-translate-intro-override: var(--beacon-reference-space-3);animation-delay:var(--beacon-reference-motion-duration-7);animation-duration:var(--beacon-reference-motion-duration-12);animation-fill-mode:forwards;animation-timing-function:var(--beacon-system-motion-easing-decelerate-emphasize-1);opacity:var(--promo-tile-content-opacity, initial)}}@media (prefers-reduced-motion: no-preference) and (width >= 640px){:host([motion-state=enabled]){--promo-tile-content-opacity: 0}@keyframes intro-from-bottom{0%{opacity:0;transform:translateY(calc(1 * var(--motion-translate-intro-override, var(--motion-translate-intro-micro))))}to{opacity:1;transform:translateY(0)}}:host([motion-state=enabled].b-motion-viewed) ::slotted(:is([slot=body],[slot=footer])){animation-name:intro-from-bottom}}`;
var sP = Object.getOwnPropertyDescriptor, lP = (i, t, e, a) => {
  for (var o = a > 1 ? void 0 : a ? sP(t, e) : t, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = r(o) || o);
  return o;
};
function cP(i) {
  let t = class extends i {
    static get PromoTileMotionStyles() {
      return [rP];
    }
  };
  return t = lP([
    je("PromoTileMotion")
  ], t), t;
}
const dP = ve`:host{--promo-tile-media-aspect-ratio: 2;--promo-tile-inline-size: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 6 + var(--beacon-system-space-gutter) * 5);--promo-tile-media-inline-size: 100%;--promo-tile-content-zone-inline-size: 100%;--promo-tile-content-zone-padding: var(--beacon-system-space-organism-normal);font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-light-body-200);color:var(--beacon-system-color-text-standard);inline-size:min(var(--promo-tile-inline-size),100%)}.content-zone{background-color:var(--beacon-system-color-background-1);block-size:var(--promo-tile-content-zone-block-size);inline-size:min(var(--promo-tile-content-zone-inline-size),100%);padding:var(--promo-tile-content-zone-padding)}:host([beacon-tag-name=beacon-promo-tile]){--tile-flex-direction: column}:host([beacon-tag-name=beacon-promo-tile][media-template=full-bleed]){--tile-content-align-self: auto}:host([media-template=full-bleed]){--promo-tile-inline-size: 100vw;--promo-tile-content-zone-padding: var(--beacon-system-space-organism-maxi);--tile-display: flex;--tile-flex-direction: column-reverse;--tile-content-end-end-radius: 0;--tile-content-end-start-radius: 0;--tile-content-start-end-radius: 0;--tile-content-start-start-radius: 0;--tile-media-end-end-radius: 0;--tile-media-end-start-radius: 0;--tile-media-start-end-radius: 0;--tile-media-start-start-radius: 0;--tile-border-radius: 0;max-block-size:800px}:host(:is([position=horizontal-left][media-template=standard],[position*=vertical-top][media-template=standard])){--tile-flex-direction: column-reverse}:host(:is([position*=horizontal][media-template=standard],[position=vertical-top][media-template=standard])){--tile-content-end-end-radius: var(--beacon-system-radius-corner-standard);--tile-content-end-start-radius: var(--beacon-system-radius-corner-standard);--tile-content-start-end-radius: 0;--tile-media-start-end-radius: var(--beacon-system-radius-corner-standard);--tile-media-start-start-radius: var(--beacon-system-radius-corner-standard);--tile-media-end-start-radius: 0}:host(:is([position=vertical-top][media-template=standard],[position=horizontal-left][media-template=standard])){--tile-content-start-start-radius: 0;--tile-media-end-end-radius: 0}.media-wrapper{display:contents}@media (width >= 640px){:host([position*=horizontal][media-template=standard]){--tile-flex-direction: row;--tile-content-end-end-radius: var(--beacon-system-radius-corner-standard);--tile-content-end-start-radius: 0;--tile-content-start-end-radius: var(--beacon-system-radius-corner-standard);--tile-content-start-start-radius: 0;--tile-media-end-end-radius: 0;--tile-media-end-start-radius: var(--beacon-system-radius-corner-standard);--tile-media-start-end-radius: 0;--tile-media-start-start-radius: var(--beacon-system-radius-corner-standard);--promo-tile-media-aspect-ratio: 1;--promo-tile-content-zone-inline-size: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 6 + var(--beacon-system-space-gutter) * 5);--promo-tile-media-inline-size: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 6 + var(--beacon-system-space-gutter) * 6);--promo-tile-inline-size: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 12 + var(--beacon-system-space-gutter) * 11);--tile-content-justify-content: center}:host([position=horizontal-left][media-template=standard]){--tile-content-end-end-radius: 0;--tile-content-end-start-radius: var(--beacon-system-radius-corner-standard);--tile-content-start-end-radius: 0;--tile-content-start-start-radius: var(--beacon-system-radius-corner-standard);--tile-media-end-end-radius: var(--beacon-system-radius-corner-standard);--tile-media-end-start-radius: 0;--tile-media-start-end-radius: var(--beacon-system-radius-corner-standard);--tile-media-start-start-radius: 0;--tile-flex-direction: row}}@media (width >= 960px){:host([position*=vertical][media-template=standard]){--promo-tile-inline-size: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 4 + var(--beacon-system-space-gutter) * 3)}:host(:is([position*=horizontal],[media-template=full-bleed])){--tile-content-justify-content: center}:host([media-template=full-bleed][position=horizontal-right]){--tile-flex-direction: row-reverse}:host([media-template=full-bleed]){--tile-flex-direction: row;--promo-tile-media-aspect-ratio: 1;--promo-tile-content-zone-inline-size: 50%;--promo-tile-media-inline-size: 50%}:host([position*=horizontal][media-template=standard][layout=wide]){--promo-tile-media-aspect-ratio: 2;--promo-tile-content-zone-inline-size: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 4 + var(--beacon-system-space-gutter) * 3);--promo-tile-media-inline-size: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 8 + var(--beacon-system-space-gutter) * 8)}.container.non-fixed:not(.vertical){display:grid;grid-auto-columns:1fr;grid-auto-flow:column;grid-template-columns:unset}.container.non-fixed:not(.vertical) .content-zone{grid-column:1/2;grid-row:1/2;inline-size:100%}.container.non-fixed:not(.vertical) .media-wrapper{display:unset;grid-column:2/3;grid-row:1/2;position:relative}.container.non-fixed:not(.vertical).horizontal-right .media-wrapper{grid-column:1/2}.container.non-fixed:not(.vertical).horizontal-right .content-zone{grid-column:2/3}.container.non-fixed:not(.vertical).wide{grid-template-columns:1fr 2fr}.container.non-fixed:not(.vertical).wide.horizontal-right{grid-template-columns:2fr 1fr}}@media (width >= 1600px){:host([media-template=full-bleed]){--promo-tile-content-zone-padding: 10rem;--promo-tile-content-zone-inline-size: 100%}}`;
var hP = Object.defineProperty, bP = (i, t, e, a) => {
  for (var o = void 0, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = r(t, e, o) || o);
  return o && hP(t, e, o), o;
};
const Nb = class Nb extends Ke(ia).with(
  cP,
  ff({ autoRemoveMotionClasses: !1 })
) {
  constructor() {
    super(...arguments), this.beaconTagName = Mg.beaconTagName, this.resizeTo = "image";
  }
  static get styles() {
    return [super.styles, dP, this.PromoTileMotionStyles];
  }
  static get lightDOMStyles() {
    return [...super.lightDOMStyles, nP];
  }
  applyMotionStyles() {
    this.classList.add(jh.VIEWED);
  }
  renderMedia() {
    return pe`
      <div class="${Oe({
      "media-wrapper": !0
    })}">
        <slot name="media"></slot>
      </div>
    `;
  }
  /**
   * Renders body and footer zones for full-bleed, and just body zone for standard mediaTemplate
   * @returns an HTML template
   */
  renderContentZone() {
    return this.mediaTemplate === os.FULL_BLEED ? pe`<div class="content-zone">
        ${this.renderBody()} ${this.renderFooter()}
      </div>` : pe`<div class="content-zone">${this.renderBody()}</div>`;
  }
  /**
   * Overrides base renderTile to include exception ordering need for Full bleed mediaTemplate.
   * Necessary because Full bleed horizontal variant orients content zone to the left rather than the right
   * as it works in base tile.
   * @param position TilePosition value
   * @returns
   */
  renderTile(t) {
    const e = {
      container: !0,
      "non-fixed": this.resizeTo === "content"
    };
    return e[this.position] = !0, e[this.layout] = !0, this.mediaTemplate === os.FULL_BLEED || t === Vi.HORIZONTAL_LEFT || t === Vi.VERTICAL_TOP ? pe`<div class="${Oe(e)}">
        ${this.renderContentZone()} ${this.renderMedia()}
      </div>` : pe`<div class="${Oe(e)}">
      ${this.renderMedia()} ${this.renderContentZone()}
    </div>`;
  }
  render() {
    return pe`${this.renderTile(this.position)}`;
  }
};
Nb.tagName = Mg.beaconTagName;
let ph = Nb;
bP([
  ue({ attribute: "resize-to", reflect: !0 })
], ph.prototype, "resizeTo");
var jr = /* @__PURE__ */ ((i) => (i.INLINE = "inline", i.STANDARD = "standard", i.HERO = "hero", i))(jr || {}), uh = /* @__PURE__ */ ((i) => (i.STANDARD = "standard", i.CUTOUT = "cutout", i))(uh || {});
const pP = ve`:root[beacon-tag-name=beacon-quote-block],:root [beacon-tag-name=beacon-quote-block],[beacon-version="4.3.1"][class*=beacon-on][beacon-tag-name=beacon-quote-block],[beacon-version="4.3.1"][class*=beacon-on] [beacon-tag-name=beacon-quote-block],[class*=beacon-on] [beacon-version="4.3.1"][beacon-tag-name=beacon-quote-block],[class*=beacon-on] [beacon-version="4.3.1"] [beacon-tag-name=beacon-quote-block],[beacon-version="4.3.1"][beacon-tag-name=beacon-quote-block],[beacon-version="4.3.1"] [beacon-tag-name=beacon-quote-block]{--quote-block-quote-container-padding-inline-start: 0;--quote-block-mini-hanging-quote-inset-inline-start: 0;--quote-block-hanging-quote-inset-inline-start: calc(-1 * var(--beacon-reference-space-1));--quote-block-normal-cutout-overlap-margin: var(--beacon-reference-space-5);--quote-block-mini-cutout-overlap-margin: var(--beacon-reference-space-5);--quote-block-jumbo-cutout-overlap-margin: var(--beacon-reference-space-5);--quote-block-cutout-full-bleed-overlap-margin-normal: var(--beacon-system-space-organism-maxi);--quote-block-cutout-full-bleed-overlap-margin-mini: var(--beacon-system-space-organism-maxi);--quote-block-cutout-full-bleed-overlap-margin-jumbo: var(--beacon-system-space-organism-maxi);--quote-block-media-inline-size-standard-mini: 0;--quote-block-media-inline-size-full-bleed-mini: 0;--quote-block-media-inline-size-standard-normal: 0;--quote-block-media-inline-size-full-bleed-normal: 0;--quote-block-media-inline-size-standard-jumbo: 0;--quote-block-media-block-size: 100%;--quote-block-media-block-size-default-jumbo: 0;--quote-block-media-block-size-default-normal: 0;--quote-block-media-block-size-default-mini: 0;--quote-block-media-block-size-full-bleed-normal: 0;--quote-block-media-block-size-full-bleed-mini: 0;--quote-block-media-max-block-size: none;--quote-block-media-display: block;--quote-block-space-padding-inline-end-default: var(--beacon-reference-space-3);--quote-block-space-padding-inline-end-full-bleed: 0}@media (width >= 640px){:root[beacon-tag-name=beacon-quote-block],:root [beacon-tag-name=beacon-quote-block],[beacon-version="4.3.1"][class*=beacon-on][beacon-tag-name=beacon-quote-block],[beacon-version="4.3.1"][class*=beacon-on] [beacon-tag-name=beacon-quote-block],[class*=beacon-on] [beacon-version="4.3.1"][beacon-tag-name=beacon-quote-block],[class*=beacon-on] [beacon-version="4.3.1"] [beacon-tag-name=beacon-quote-block],[beacon-version="4.3.1"][beacon-tag-name=beacon-quote-block],[beacon-version="4.3.1"] [beacon-tag-name=beacon-quote-block]{--quote-block-hanging-quote-inset-inline-start: calc(-1 * var(--beacon-reference-space-2));--quote-block-normal-cutout-overlap-margin: calc(-1 * var(--beacon-reference-space-11));--quote-block-mini-cutout-overlap-margin: calc(-1 * var(--beacon-reference-space-9));--quote-block-cutout-full-bleed-overlap-margin-normal: calc(-1 * var(--beacon-reference-space-11));--quote-block-cutout-full-bleed-overlap-margin-mini: calc(-1 * var(--beacon-reference-space-15));--quote-block-cutout-full-bleed-overlap-margin-jumbo: calc(-1 * var(--beacon-reference-space-11));--quote-block-media-inline-size-standard-mini: 192px;--quote-block-media-inline-size-full-bleed-mini: 252px;--quote-block-media-inline-size-standard-normal: 192px;--quote-block-media-inline-size-full-bleed-normal: 204px;--quote-block-media-inline-size-standard-jumbo: 192px;--quote-block-media-inline-size-full-bleed-jumbo: 204px;--quote-block-media-block-size-default-jumbo: 512px;--quote-block-media-block-size-default-normal: 512px;--quote-block-media-block-size-default-mini: 512px;--quote-block-media-block-size-full-bleed-normal: 332px;--quote-block-media-block-size-full-bleed-mini: 262px}}@media (width >= 960px){:root[beacon-tag-name=beacon-quote-block],:root [beacon-tag-name=beacon-quote-block],[beacon-version="4.3.1"][class*=beacon-on][beacon-tag-name=beacon-quote-block],[beacon-version="4.3.1"][class*=beacon-on] [beacon-tag-name=beacon-quote-block],[class*=beacon-on] [beacon-version="4.3.1"][beacon-tag-name=beacon-quote-block],[class*=beacon-on] [beacon-version="4.3.1"] [beacon-tag-name=beacon-quote-block],[beacon-version="4.3.1"][beacon-tag-name=beacon-quote-block],[beacon-version="4.3.1"] [beacon-tag-name=beacon-quote-block]{--quote-block-normal-cutout-overlap-margin: calc(-1 * var(--beacon-reference-space-13));--quote-block-mini-cutout-overlap-margin: calc(-1 * var(--beacon-reference-space-14));--quote-block-jumbo-cutout-overlap-margin: calc(-1 * var(--beacon-reference-space-12));--quote-block-cutout-full-bleed-overlap-margin-normal: calc(-1 * var(--beacon-reference-space-14));--quote-block-cutout-full-bleed-overlap-margin-mini: calc(-1 * var(--beacon-reference-space-18));--quote-block-cutout-full-bleed-overlap-margin-jumbo: calc(-1 * var(--beacon-reference-space-17));--quote-block-media-inline-size-standard-mini: 204px;--quote-block-media-inline-size-full-bleed-mini: 316px;--quote-block-media-inline-size-standard-normal: 256px;--quote-block-media-inline-size-full-bleed-normal: 360px;--quote-block-media-inline-size-standard-jumbo: 320px;--quote-block-media-inline-size-full-bleed-jumbo: 432px;--quote-block-media-block-size-default-jumbo: 800px;--quote-block-media-block-size-default-normal: 640px;--quote-block-space-padding-inline-end-full-bleed: var(--beacon-reference-space-12);--quote-block-media-block-size-full-bleed-normal: 424px;--quote-block-media-block-size-full-bleed-mini: 424px}}@media (width >= 1280px){:root[beacon-tag-name=beacon-quote-block],:root [beacon-tag-name=beacon-quote-block],[beacon-version="4.3.1"][class*=beacon-on][beacon-tag-name=beacon-quote-block],[beacon-version="4.3.1"][class*=beacon-on] [beacon-tag-name=beacon-quote-block],[class*=beacon-on] [beacon-version="4.3.1"][beacon-tag-name=beacon-quote-block],[class*=beacon-on] [beacon-version="4.3.1"] [beacon-tag-name=beacon-quote-block],[beacon-version="4.3.1"][beacon-tag-name=beacon-quote-block],[beacon-version="4.3.1"] [beacon-tag-name=beacon-quote-block]{--quote-block-hanging-quote-inset-inline-start: calc(-.375 * var(--beacon-reference-space-5));--quote-block-mini-hanging-quote-inset-inline-start: calc(-1 * var(--beacon-reference-space-1));--quote-block-mini-cutout-overlap-margin: calc(-1 * var(--beacon-reference-space-13));--quote-block-jumbo-cutout-overlap-margin: calc(-1 * var(--beacon-reference-space-13));--quote-block-cutout-full-bleed-overlap-margin-normal: calc(-1 * var(--beacon-reference-space-16));--quote-block-cutout-full-bleed-overlap-margin-mini: calc(-1 * var(--beacon-reference-space-19));--quote-block-cutout-full-bleed-overlap-margin-jumbo: calc(-1 * var(--beacon-reference-space-18));--quote-block-media-inline-size-standard-mini: 245px;--quote-block-media-inline-size-full-bleed-mini: 368px;--quote-block-media-inline-size-standard-normal: 320px;--quote-block-media-inline-size-full-bleed-normal: 424px;--quote-block-media-inline-size-standard-jumbo: 400px;--quote-block-media-inline-size-full-bleed-jumbo: 480px;--quote-block-space-padding-inline-end-default: var(--beacon-reference-space-4);--quote-block-media-block-size-default-jumbo: 960px;--quote-block-media-block-size-default-normal: 840px;--quote-block-media-block-size-default-mini: 640px;--quote-block-space-padding-inline-end-full-bleed: var(--beacon-reference-space-16);--quote-block-media-block-size-full-bleed-normal: 552px;--quote-block-media-block-size-full-bleed-mini: 552px}}`, _l = {
  beaconTagName: "beacon-quote-block",
  signature: "signature",
  mediaSlot: "media"
}, uP = ve`[beacon-tag-name=beacon-quote-block] [slot=media]>img,[beacon-tag-name=beacon-quote-block] [slot=media]:not(picture){block-size:var(--quote-block-media-block-size, none);inline-size:var(--quote-block-media-inline-size, none);max-block-size:var(--quote-block-media-block-size, var(--media-wrapper-max-block-size));object-fit:cover}[beacon-tag-name=beacon-quote-block] [slot=signature]{padding:0}[beacon-tag-name=beacon-quote-block] [beacon-tag-name=beacon-id-card]{--display-name-space-padding-block-start: 0;--id-card-avatar-display: none}[beacon-tag-name=beacon-quote-block] [slot=footnote]{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-caption-loose-300)}[beacon-tag-name=beacon-quote-block][variant=hero] [beacon-tag-name=beacon-id-card]{--id-card-avatar-display: unset}[beacon-tag-name=beacon-quote-block][variant=hero] [beacon-tag-name=beacon-id-card] :where(img [slot=media]){max-inline-size:none}[beacon-tag-name=beacon-quote-block][variant=hero] :where(img,picture){block-size:var(--quote-block-media-block-size, none);max-inline-size:none}@media (width >= 320px){[beacon-tag-name=beacon-quote-block] [slot=signature]{padding:0}}@media (width >= 640px){[beacon-tag-name=beacon-quote-block][image-variant=cutout]:not([full-bleed]) [beacon-tag-name=beacon-id-card]{--id-card-avatar-display: unset}[beacon-tag-name=beacon-quote-block][variant=hero] [beacon-tag-name=beacon-id-card]{--id-card-avatar-display: none}}@media (width >= 960px){[beacon-tag-name=beacon-quote-block][image-variant=cutout]:not([full-bleed]) [beacon-tag-name=beacon-id-card]{--id-card-avatar-display: none}}`, gP = ve`@charset "UTF-8";:host{--media-wrapper-display: var(--quote-block-media-display, flex);--figure-align-self: inherit;--figure-padding-block: var(--beacon-system-space-organism-normal);--figure-padding-inline-end: var(--quote-block-space-padding-inline-end-default);--cutout-overlap-margin: var(--quote-block-normal-cutout-overlap-margin);--border-inline-style: solid;--container-padding-inline: var(--beacon-reference-space-2);--media-wrapper-max-block-size: var(--quote-block-media-block-size-default-normal);--quote-block-media-inline-size: var(--quote-block-media-inline-size-standard-normal);background:var(--beacon-custom-quote-block-background, var(--beacon-system-color-background-1))}:host .beacon-quote-container{border-inline-start:var(--beacon-system-width-border-jumbo) var(--border-inline-style) var(--beacon-system-color-border-brand);display:inline-flex}:host .beacon-quote-container p{margin:0}:host .beacon-quote-container figure{align-self:var(--figure-align-self);border:0;margin:0;margin-inline:var(--beacon-reference-space-5);padding-block:var(--beacon-system-space-organism-normal);padding-inline:var(--beacon-system-space-organism-normal) var(--beacon-system-space-organism-normal)}:host .beacon-quote-container blockquote{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-loose-200);border:0;margin:0;padding-block:var(--beacon-system-space-cell-contained) var(--beacon-system-space-cell-contained);padding-inline:var(--beacon-system-space-cell-contained);position:relative;word-break:break-word}:host .beacon-quote-container blockquote:before{content:"“";inset-block-start:var(--beacon-system-space-cell-contained);inset-inline-start:var(--quote-block-hanging-quote-inset-inline-start);position:absolute}:host .beacon-quote-container blockquote:after{content:"”";position:relative}:host .beacon-quote-container .cutout{margin-inline-end:var(--cutout-overlap-margin)}:host .beacon-quote-container .full-bleed-excessive{--figure-padding-block: var(--beacon-system-space-organism-normal);--figure-padding-inline-start: var(--beacon-system-space-organism-normal)}.media-wrapper{display:var(--media-wrapper-display)}.media-wrapper img{max-block-size:var(--quote-block-media-max-block-size, var(--media-wrapper-max-block-size));object-fit:cover}figcaption{border:0;padding:var(--beacon-system-space-cell-contained)}figcaption p{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-300)}figcaption .beacon-signature{font-weight:var(--beacon-system-font-weight-bold)}.beacon-quote-container.hero figure{--figure-align-self: center}.beacon-quote-container.mini blockquote{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-loose-50)}.beacon-quote-container.mini blockquote:before{inset-inline-start:var(--quote-block-mini-hanging-quote-inset-inline-start)}.beacon-quote-container.mini .cutout{--cutout-overlap-margin: var(--quote-block-mini-cutout-overlap-margin)}.beacon-quote-container.mini .media-wrapper{--quote-block-media-inline-size: var(--quote-block-media-inline-size-standard-mini);--media-wrapper-max-block-size: var(--quote-block-media-block-size-default-mini)}.beacon-quote-container.jumbo blockquote{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-loose-300)}.beacon-quote-container.jumbo .cutout{--cutout-overlap-margin: var(--quote-block-jumbo-cutout-overlap-margin)}.beacon-quote-container.jumbo .media-wrapper{--quote-block-media-inline-size: var(--quote-block-media-inline-size-standard-jumbo);--media-wrapper-max-block-size: var(--quote-block-media-block-size-default-jumbo)}:host([full-bleed]) .beacon-quote-container{--border-inline-style: none;--container-padding-inline: 0;padding-inline-end:var(--quote-block-space-padding-inline-end-full-bleed)}:host([full-bleed]) .beacon-quote-container figure{--quote-block-figure-full-bleed-padding-inline: calc(var(--beacon-reference-space-5) + var(--beacon-system-space-organism-normal));--border-inline-style: solid;border-inline-start:var(--beacon-system-width-border-jumbo) var(--border-inline-style) var(--beacon-system-color-border-brand);margin-block:var(--beacon-system-space-organism-jumbo);margin-inline-start:var(--beacon-system-space-organism-maxi);padding-block:var(--beacon-system-space-organism-normal);padding-inline:var(--quote-block-figure-full-bleed-padding-inline, 0) var(--quote-block-figure-full-bleed-padding-inline, var(--figure-padding-inline-end))}:host([full-bleed]) .beacon-quote-container.normal .cutout{--cutout-overlap-margin: var(--quote-block-cutout-full-bleed-overlap-margin-normal)}:host([full-bleed]) .beacon-quote-container.normal .media-wrapper{--quote-block-media-inline-size: var(--quote-block-media-inline-size-full-bleed-normal);--media-wrapper-max-block-size: var(--quote-block-media-block-size-full-bleed-normal)}:host([full-bleed]) .beacon-quote-container.mini .cutout{--cutout-overlap-margin: var(--quote-block-cutout-full-bleed-overlap-margin-mini)}:host([full-bleed]) .beacon-quote-container.mini .media-wrapper{--quote-block-media-inline-size: var(--quote-block-media-inline-size-full-bleed-mini);--media-wrapper-max-block-size: var(--quote-block-media-block-size-full-bleed-mini)}:host([full-bleed]) .beacon-quote-container.jumbo .cutout{--cutout-overlap-margin: var(--quote-block-cutout-full-bleed-overlap-margin-jumbo)}:host([full-bleed]) .beacon-quote-container.jumbo .media-wrapper{--quote-block-media-inline-size: var(--quote-block-media-inline-size-full-bleed-jumbo);--media-wrapper-max-block-size: var(--quote-block-media-block-size)}::slotted([beacon-tag-name=beacon-id-card]){--id-card-avatar-border: 0}@media (width >= 320px){:host{--media-wrapper-display: none}}@media (width >= 640px){:host{--media-wrapper-display: var(--quote-block-media-display, flex)}:host([image-variant=cutout]:not([full-bleed])) .beacon-quote-container.jumbo{--media-wrapper-display: none}}@media (width >= 960px){:host([image-variant=cutout]:not([full-bleed])) .beacon-quote-container.jumbo{--media-wrapper-display: var(--quote-block-media-display, flex)}}@media (width >= 1920px){:host([variant=hero]){background-color:var(--beacon-system-color-background-1);display:flex;justify-content:center}:host([variant=hero]) .beacon-quote-container{max-inline-size:var(--beacon-system-breakpoint-xxx-large)}}`;
var mP = Object.defineProperty, fP = Object.getOwnPropertyDescriptor, Si = (i, t, e, a) => {
  for (var o = a > 1 ? void 0 : a ? fP(t, e) : t, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = (a ? r(t, e, o) : r(o)) || o);
  return a && o && mP(t, e, o), o;
};
const Fb = class Fb extends Le {
  constructor() {
    super(...arguments), this.beaconTagName = _l.beaconTagName, this.scale = Do.NORMAL, this.variant = jr.STANDARD, this.fullBleed = !1, this.imageVariant = uh.STANDARD;
  }
  static get styles() {
    return [super.styles, gP];
  }
  static get lightDOMStyles() {
    return [...super.lightDOMStyles, pP, uP];
  }
  /** Template for caption(hero/standard variant) */
  getCaption() {
    return this.variant === jr.HERO || this.variant === jr.STANDARD ? pe`<figcaption>
        <slot
          @slotchange=${this.signatureSlotChange}
          name="signature"
          ${Ue({ container: "figcaption" })}>
        </slot>
        <slot
          @slotchange=${this.footerSlotChange}
          name="footnote"
          ${Ue({ container: "figcaption" })}>
        </slot>
      </figcaption>` : _e;
  }
  /** Template for media (hero variant) */
  renderMedia() {
    return this.variant === jr.HERO ? pe`<div class="media-wrapper">
        <slot name="media"></slot>
      </div>` : pe``;
  }
  /** slotChange handler  */
  signatureSlotChange() {
    this.requestUpdate("slottedSignature");
  }
  /** slotChange handler  */
  footerSlotChange() {
    this.requestUpdate("slottedFooter");
  }
  async cloneIdCardImage() {
    await this.updateComplete;
    const t = this.slottedSignature[0];
    if (t instanceof Bo && t.slottedAvatar && this.slottedMedia.length === 0) {
      const e = t.slottedAvatar.cloneNode();
      e && e instanceof HTMLElement && (e.setAttribute("slot", "media"), this.insertAdjacentElement("beforeend", e));
    }
  }
  render() {
    const t = {
      cutout: !!(this.imageVariant === uh.CUTOUT || this.fullBleed),
      "full-bleed-excessive": !!this.fullBleed
    };
    return pe`<div
      class="beacon-quote-container ${this.variant} ${this.scale}">
      <figure class=${Oe(t)}>
        <blockquote>
          <slot></slot>
        </blockquote>
        ${this.getCaption()}
      </figure>
      ${this.renderMedia()}
    </div>`;
  }
};
Fb.tagName = _l.beaconTagName;
let oa = Fb;
Si([
  ue({ reflect: !0 })
], oa.prototype, "scale", 2);
Si([
  ue()
], oa.prototype, "variant", 2);
Si([
  ue({ type: Boolean, reflect: !0, attribute: "full-bleed" })
], oa.prototype, "fullBleed", 2);
Si([
  ue({ type: String, attribute: "image-variant" })
], oa.prototype, "imageVariant", 2);
Si([
  Pe({ slot: _l.signature, flatten: !0 })
], oa.prototype, "slottedSignature", 2);
Si([
  Pe({ slot: _l.mediaSlot, flatten: !0 })
], oa.prototype, "slottedMedia", 2);
Si([
  wt({ slot: "" })
], oa.prototype, "defaultSlottedContent", 2);
Si([
  De
], oa.prototype, "cloneIdCardImage", 1);
const Lg = {
  beaconTagName: "beacon-region-selector"
}, vP = ve`[beacon-tag-name=beacon-region-selector]{border-block-start:var(--beacon-system-width-border-mini) solid var(--beacon-system-color-border-1);padding-block-start:var(--beacon-system-space-micro-jumbo)}[beacon-tag-name=beacon-region-selector] [slot=title]{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-50)}[beacon-tag-name=beacon-region-selector] [slot=title] :is(h1,h2,h3,h4,h5,h6){font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-50)}@media (width >= 960px){[beacon-tag-name=beacon-region-selector]{padding-block-start:var(--beacon-reference-space-9)}}`, AP = ve`.b-grid{--b-default-auto-layout: calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns));--b-default-grid-gap: var(--b-grid-gap, var(--beacon-system-space-gutter));--b-default-column-count: var(--b-grid-columns, var(--beacon-system-grid-columns));display:grid;gap:var(--b-default-grid-gap);grid-template-columns:var(--b-grid-template-col, repeat(var(--b-default-column-count), minmax(0, 1fr)));grid-template-rows:var(--b-grid-template-row, repeat(var(--b-grid-rows, 1), 1fr));inline-size:100%;margin-inline:auto;max-inline-size:var(--beacon-system-breakpoint-xx-large)}.b-grid.b-full-bleed{max-inline-size:none}.b-grid.b-auto-fill{--b-grid-template-col: repeat(auto-fill, minmax(min(var(--b-grid-auto-fill, var(--b-default-auto-layout)), 100%), 1fr))}.b-grid.b-auto-fit{--b-grid-template-col: repeat(auto-fit, minmax(min(var(--b-grid-auto-fit, var(--b-default-auto-layout)), 100%), 1fr))}.b-grid.b-vertical-fill [class*=b-grid-item] :first-child:not([class*=b-grid-item] [beacon-tag-name] *){block-size:100%}@media (width >= 320px){[class*=b-grid-item].b-sm\\:order-1{order:1}[class*=b-grid-item].b-sm\\:order-2{order:2}[class*=b-grid-item].b-sm\\:order-3{order:3}[class*=b-grid-item].b-sm\\:order-4{order:4}[class*=b-grid-item].b-sm\\:order-5{order:5}[class*=b-grid-item].b-sm\\:order-6{order:6}[class*=b-grid-item].b-sm\\:order-7{order:7}[class*=b-grid-item].b-sm\\:order-8{order:8}[class*=b-grid-item].b-sm\\:order-9{order:9}[class*=b-grid-item].b-sm\\:order-10{order:10}[class*=b-grid-item].b-sm\\:order-11{order:11}[class*=b-grid-item].b-sm\\:order-12{order:12}[class*=b-grid-item].b-sm\\:order-13{order:13}[class*=b-grid-item].b-sm\\:order-14{order:14}[class*=b-grid-item].b-sm\\:order-15{order:15}[class*=b-grid-item].b-sm\\:order-16{order:16}[class*=b-grid-item].b-sm\\:order-17{order:17}[class*=b-grid-item].b-sm\\:order-18{order:18}[class*=b-grid-item].b-sm\\:order-19{order:19}[class*=b-grid-item].b-sm\\:order-20{order:20}[class*=b-grid-item][class*="b-sm:vertical-divider"]{position:relative}[class*=b-grid-item][class*="b-sm:vertical-divider"]:after{background-color:var(--b-grid-divider-color, var(--beacon-system-color-border-2));block-size:100%;content:"";inline-size:var(--b-grid-divider-size, var(--beacon-system-width-border-mini));inset-block-start:0;inset-inline-start:calc(100% + var(--b-default-grid-gap) / 2);position:absolute;z-index:1}[class*=b-grid-item].b-sm\\:vertical-divider--thin--neutral{--b-grid-divider-size: var(--beacon-system-width-border-mini);--b-grid-divider-color: var(--beacon-system-color-border-2)}[class*=b-grid-item].b-sm\\:vertical-divider--thin--strong{--b-grid-divider-size: var(--beacon-system-width-border-mini);--b-grid-divider-color: var(--beacon-system-color-border-brand)}[class*=b-grid-item].b-sm\\:vertical-divider--thick--neutral{--b-grid-divider-size: var(--beacon-system-width-border-normal);--b-grid-divider-color: var(--beacon-system-color-border-2)}[class*=b-grid-item].b-sm\\:vertical-divider--thick--strong{--b-grid-divider-size: var(--beacon-system-width-border-normal);--b-grid-divider-color: var(--beacon-system-color-border-brand)}}@media (width >= 640px){[class*=b-grid-item].b-md\\:order-1{order:1}[class*=b-grid-item].b-md\\:order-2{order:2}[class*=b-grid-item].b-md\\:order-3{order:3}[class*=b-grid-item].b-md\\:order-4{order:4}[class*=b-grid-item].b-md\\:order-5{order:5}[class*=b-grid-item].b-md\\:order-6{order:6}[class*=b-grid-item].b-md\\:order-7{order:7}[class*=b-grid-item].b-md\\:order-8{order:8}[class*=b-grid-item].b-md\\:order-9{order:9}[class*=b-grid-item].b-md\\:order-10{order:10}[class*=b-grid-item].b-md\\:order-11{order:11}[class*=b-grid-item].b-md\\:order-12{order:12}[class*=b-grid-item].b-md\\:order-13{order:13}[class*=b-grid-item].b-md\\:order-14{order:14}[class*=b-grid-item].b-md\\:order-15{order:15}[class*=b-grid-item].b-md\\:order-16{order:16}[class*=b-grid-item].b-md\\:order-17{order:17}[class*=b-grid-item].b-md\\:order-18{order:18}[class*=b-grid-item].b-md\\:order-19{order:19}[class*=b-grid-item].b-md\\:order-20{order:20}[class*=b-grid-item][class*="b-md:vertical-divider"]{position:relative}[class*=b-grid-item][class*="b-md:vertical-divider"]:after{background-color:var(--b-grid-divider-color, var(--beacon-system-color-border-2));block-size:100%;content:"";inline-size:var(--b-grid-divider-size, var(--beacon-system-width-border-mini));inset-block-start:0;inset-inline-start:calc(100% + var(--b-default-grid-gap) / 2);position:absolute;z-index:1}[class*=b-grid-item].b-md\\:vertical-divider--thin--neutral{--b-grid-divider-size: var(--beacon-system-width-border-mini);--b-grid-divider-color: var(--beacon-system-color-border-2)}[class*=b-grid-item].b-md\\:vertical-divider--thin--strong{--b-grid-divider-size: var(--beacon-system-width-border-mini);--b-grid-divider-color: var(--beacon-system-color-border-brand)}[class*=b-grid-item].b-md\\:vertical-divider--thick--neutral{--b-grid-divider-size: var(--beacon-system-width-border-normal);--b-grid-divider-color: var(--beacon-system-color-border-2)}[class*=b-grid-item].b-md\\:vertical-divider--thick--strong{--b-grid-divider-size: var(--beacon-system-width-border-normal);--b-grid-divider-color: var(--beacon-system-color-border-brand)}}@media (width >= 960px){[class*=b-grid-item].b-lg\\:order-1{order:1}[class*=b-grid-item].b-lg\\:order-2{order:2}[class*=b-grid-item].b-lg\\:order-3{order:3}[class*=b-grid-item].b-lg\\:order-4{order:4}[class*=b-grid-item].b-lg\\:order-5{order:5}[class*=b-grid-item].b-lg\\:order-6{order:6}[class*=b-grid-item].b-lg\\:order-7{order:7}[class*=b-grid-item].b-lg\\:order-8{order:8}[class*=b-grid-item].b-lg\\:order-9{order:9}[class*=b-grid-item].b-lg\\:order-10{order:10}[class*=b-grid-item].b-lg\\:order-11{order:11}[class*=b-grid-item].b-lg\\:order-12{order:12}[class*=b-grid-item].b-lg\\:order-13{order:13}[class*=b-grid-item].b-lg\\:order-14{order:14}[class*=b-grid-item].b-lg\\:order-15{order:15}[class*=b-grid-item].b-lg\\:order-16{order:16}[class*=b-grid-item].b-lg\\:order-17{order:17}[class*=b-grid-item].b-lg\\:order-18{order:18}[class*=b-grid-item].b-lg\\:order-19{order:19}[class*=b-grid-item].b-lg\\:order-20{order:20}[class*=b-grid-item][class*="b-lg:vertical-divider"]{position:relative}[class*=b-grid-item][class*="b-lg:vertical-divider"]:after{background-color:var(--b-grid-divider-color, var(--beacon-system-color-border-2));block-size:100%;content:"";inline-size:var(--b-grid-divider-size, var(--beacon-system-width-border-mini));inset-block-start:0;inset-inline-start:calc(100% + var(--b-default-grid-gap) / 2);position:absolute;z-index:1}[class*=b-grid-item].b-lg\\:vertical-divider--thin--neutral{--b-grid-divider-size: var(--beacon-system-width-border-mini);--b-grid-divider-color: var(--beacon-system-color-border-2)}[class*=b-grid-item].b-lg\\:vertical-divider--thin--strong{--b-grid-divider-size: var(--beacon-system-width-border-mini);--b-grid-divider-color: var(--beacon-system-color-border-brand)}[class*=b-grid-item].b-lg\\:vertical-divider--thick--neutral{--b-grid-divider-size: var(--beacon-system-width-border-normal);--b-grid-divider-color: var(--beacon-system-color-border-2)}[class*=b-grid-item].b-lg\\:vertical-divider--thick--strong{--b-grid-divider-size: var(--beacon-system-width-border-normal);--b-grid-divider-color: var(--beacon-system-color-border-brand)}}@media (width >= 1280px){[class*=b-grid-item].b-xl\\:order-1{order:1}[class*=b-grid-item].b-xl\\:order-2{order:2}[class*=b-grid-item].b-xl\\:order-3{order:3}[class*=b-grid-item].b-xl\\:order-4{order:4}[class*=b-grid-item].b-xl\\:order-5{order:5}[class*=b-grid-item].b-xl\\:order-6{order:6}[class*=b-grid-item].b-xl\\:order-7{order:7}[class*=b-grid-item].b-xl\\:order-8{order:8}[class*=b-grid-item].b-xl\\:order-9{order:9}[class*=b-grid-item].b-xl\\:order-10{order:10}[class*=b-grid-item].b-xl\\:order-11{order:11}[class*=b-grid-item].b-xl\\:order-12{order:12}[class*=b-grid-item].b-xl\\:order-13{order:13}[class*=b-grid-item].b-xl\\:order-14{order:14}[class*=b-grid-item].b-xl\\:order-15{order:15}[class*=b-grid-item].b-xl\\:order-16{order:16}[class*=b-grid-item].b-xl\\:order-17{order:17}[class*=b-grid-item].b-xl\\:order-18{order:18}[class*=b-grid-item].b-xl\\:order-19{order:19}[class*=b-grid-item].b-xl\\:order-20{order:20}[class*=b-grid-item][class*="b-xl:vertical-divider"]{position:relative}[class*=b-grid-item][class*="b-xl:vertical-divider"]:after{background-color:var(--b-grid-divider-color, var(--beacon-system-color-border-2));block-size:100%;content:"";inline-size:var(--b-grid-divider-size, var(--beacon-system-width-border-mini));inset-block-start:0;inset-inline-start:calc(100% + var(--b-default-grid-gap) / 2);position:absolute;z-index:1}[class*=b-grid-item].b-xl\\:vertical-divider--thin--neutral{--b-grid-divider-size: var(--beacon-system-width-border-mini);--b-grid-divider-color: var(--beacon-system-color-border-2)}[class*=b-grid-item].b-xl\\:vertical-divider--thin--strong{--b-grid-divider-size: var(--beacon-system-width-border-mini);--b-grid-divider-color: var(--beacon-system-color-border-brand)}[class*=b-grid-item].b-xl\\:vertical-divider--thick--neutral{--b-grid-divider-size: var(--beacon-system-width-border-normal);--b-grid-divider-color: var(--beacon-system-color-border-2)}[class*=b-grid-item].b-xl\\:vertical-divider--thick--strong{--b-grid-divider-size: var(--beacon-system-width-border-normal);--b-grid-divider-color: var(--beacon-system-color-border-brand)}}@media (width >= 1600px){[class*=b-grid-item].b-xxl\\:order-1{order:1}[class*=b-grid-item].b-xxl\\:order-2{order:2}[class*=b-grid-item].b-xxl\\:order-3{order:3}[class*=b-grid-item].b-xxl\\:order-4{order:4}[class*=b-grid-item].b-xxl\\:order-5{order:5}[class*=b-grid-item].b-xxl\\:order-6{order:6}[class*=b-grid-item].b-xxl\\:order-7{order:7}[class*=b-grid-item].b-xxl\\:order-8{order:8}[class*=b-grid-item].b-xxl\\:order-9{order:9}[class*=b-grid-item].b-xxl\\:order-10{order:10}[class*=b-grid-item].b-xxl\\:order-11{order:11}[class*=b-grid-item].b-xxl\\:order-12{order:12}[class*=b-grid-item].b-xxl\\:order-13{order:13}[class*=b-grid-item].b-xxl\\:order-14{order:14}[class*=b-grid-item].b-xxl\\:order-15{order:15}[class*=b-grid-item].b-xxl\\:order-16{order:16}[class*=b-grid-item].b-xxl\\:order-17{order:17}[class*=b-grid-item].b-xxl\\:order-18{order:18}[class*=b-grid-item].b-xxl\\:order-19{order:19}[class*=b-grid-item].b-xxl\\:order-20{order:20}[class*=b-grid-item][class*="b-xxl:vertical-divider"]{position:relative}[class*=b-grid-item][class*="b-xxl:vertical-divider"]:after{background-color:var(--b-grid-divider-color, var(--beacon-system-color-border-2));block-size:100%;content:"";inline-size:var(--b-grid-divider-size, var(--beacon-system-width-border-mini));inset-block-start:0;inset-inline-start:calc(100% + var(--b-default-grid-gap) / 2);position:absolute;z-index:1}[class*=b-grid-item].b-xxl\\:vertical-divider--thin--neutral{--b-grid-divider-size: var(--beacon-system-width-border-mini);--b-grid-divider-color: var(--beacon-system-color-border-2)}[class*=b-grid-item].b-xxl\\:vertical-divider--thin--strong{--b-grid-divider-size: var(--beacon-system-width-border-mini);--b-grid-divider-color: var(--beacon-system-color-border-brand)}[class*=b-grid-item].b-xxl\\:vertical-divider--thick--neutral{--b-grid-divider-size: var(--beacon-system-width-border-normal);--b-grid-divider-color: var(--beacon-system-color-border-2)}[class*=b-grid-item].b-xxl\\:vertical-divider--thick--strong{--b-grid-divider-size: var(--beacon-system-width-border-normal);--b-grid-divider-color: var(--beacon-system-color-border-brand)}}@media (width >= 1920px){[class*=b-grid-item].b-xxxl\\:order-1{order:1}[class*=b-grid-item].b-xxxl\\:order-2{order:2}[class*=b-grid-item].b-xxxl\\:order-3{order:3}[class*=b-grid-item].b-xxxl\\:order-4{order:4}[class*=b-grid-item].b-xxxl\\:order-5{order:5}[class*=b-grid-item].b-xxxl\\:order-6{order:6}[class*=b-grid-item].b-xxxl\\:order-7{order:7}[class*=b-grid-item].b-xxxl\\:order-8{order:8}[class*=b-grid-item].b-xxxl\\:order-9{order:9}[class*=b-grid-item].b-xxxl\\:order-10{order:10}[class*=b-grid-item].b-xxxl\\:order-11{order:11}[class*=b-grid-item].b-xxxl\\:order-12{order:12}[class*=b-grid-item].b-xxxl\\:order-13{order:13}[class*=b-grid-item].b-xxxl\\:order-14{order:14}[class*=b-grid-item].b-xxxl\\:order-15{order:15}[class*=b-grid-item].b-xxxl\\:order-16{order:16}[class*=b-grid-item].b-xxxl\\:order-17{order:17}[class*=b-grid-item].b-xxxl\\:order-18{order:18}[class*=b-grid-item].b-xxxl\\:order-19{order:19}[class*=b-grid-item].b-xxxl\\:order-20{order:20}[class*=b-grid-item][class*="b-xxxl:vertical-divider"]{position:relative}[class*=b-grid-item][class*="b-xxxl:vertical-divider"]:after{background-color:var(--b-grid-divider-color, var(--beacon-system-color-border-2));block-size:100%;content:"";inline-size:var(--b-grid-divider-size, var(--beacon-system-width-border-mini));inset-block-start:0;inset-inline-start:calc(100% + var(--b-default-grid-gap) / 2);position:absolute;z-index:1}[class*=b-grid-item].b-xxxl\\:vertical-divider--thin--neutral{--b-grid-divider-size: var(--beacon-system-width-border-mini);--b-grid-divider-color: var(--beacon-system-color-border-2)}[class*=b-grid-item].b-xxxl\\:vertical-divider--thin--strong{--b-grid-divider-size: var(--beacon-system-width-border-mini);--b-grid-divider-color: var(--beacon-system-color-border-brand)}[class*=b-grid-item].b-xxxl\\:vertical-divider--thick--neutral{--b-grid-divider-size: var(--beacon-system-width-border-normal);--b-grid-divider-color: var(--beacon-system-color-border-2)}[class*=b-grid-item].b-xxxl\\:vertical-divider--thick--strong{--b-grid-divider-size: var(--beacon-system-width-border-normal);--b-grid-divider-color: var(--beacon-system-color-border-brand)}}@media (width < 640px){[class*=b-grid-item].b-sm-only\\:order-1{order:1}[class*=b-grid-item].b-sm-only\\:order-2{order:2}[class*=b-grid-item].b-sm-only\\:order-3{order:3}[class*=b-grid-item].b-sm-only\\:order-4{order:4}[class*=b-grid-item].b-sm-only\\:order-5{order:5}[class*=b-grid-item].b-sm-only\\:order-6{order:6}[class*=b-grid-item].b-sm-only\\:order-7{order:7}[class*=b-grid-item].b-sm-only\\:order-8{order:8}[class*=b-grid-item].b-sm-only\\:order-9{order:9}[class*=b-grid-item].b-sm-only\\:order-10{order:10}[class*=b-grid-item].b-sm-only\\:order-11{order:11}[class*=b-grid-item].b-sm-only\\:order-12{order:12}[class*=b-grid-item].b-sm-only\\:order-13{order:13}[class*=b-grid-item].b-sm-only\\:order-14{order:14}[class*=b-grid-item].b-sm-only\\:order-15{order:15}[class*=b-grid-item].b-sm-only\\:order-16{order:16}[class*=b-grid-item].b-sm-only\\:order-17{order:17}[class*=b-grid-item].b-sm-only\\:order-18{order:18}[class*=b-grid-item].b-sm-only\\:order-19{order:19}[class*=b-grid-item].b-sm-only\\:order-20{order:20}[class*=b-grid-item][class*="b-sm-only:vertical-divider"]{position:relative}[class*=b-grid-item][class*="b-sm-only:vertical-divider"]:after{background-color:var(--b-grid-divider-color, var(--beacon-system-color-border-2));block-size:100%;content:"";inline-size:var(--b-grid-divider-size, var(--beacon-system-width-border-mini));inset-block-start:0;inset-inline-start:calc(100% + var(--b-default-grid-gap) / 2);position:absolute;z-index:1}[class*=b-grid-item].b-sm-only\\:vertical-divider--thin--neutral{--b-grid-divider-size: var(--beacon-system-width-border-mini);--b-grid-divider-color: var(--beacon-system-color-border-2)}[class*=b-grid-item].b-sm-only\\:vertical-divider--thin--strong{--b-grid-divider-size: var(--beacon-system-width-border-mini);--b-grid-divider-color: var(--beacon-system-color-border-brand)}[class*=b-grid-item].b-sm-only\\:vertical-divider--thick--neutral{--b-grid-divider-size: var(--beacon-system-width-border-normal);--b-grid-divider-color: var(--beacon-system-color-border-2)}[class*=b-grid-item].b-sm-only\\:vertical-divider--thick--strong{--b-grid-divider-size: var(--beacon-system-width-border-normal);--b-grid-divider-color: var(--beacon-system-color-border-brand)}}@media (640px <= width < 960px){[class*=b-grid-item].b-md-only\\:order-1{order:1}[class*=b-grid-item].b-md-only\\:order-2{order:2}[class*=b-grid-item].b-md-only\\:order-3{order:3}[class*=b-grid-item].b-md-only\\:order-4{order:4}[class*=b-grid-item].b-md-only\\:order-5{order:5}[class*=b-grid-item].b-md-only\\:order-6{order:6}[class*=b-grid-item].b-md-only\\:order-7{order:7}[class*=b-grid-item].b-md-only\\:order-8{order:8}[class*=b-grid-item].b-md-only\\:order-9{order:9}[class*=b-grid-item].b-md-only\\:order-10{order:10}[class*=b-grid-item].b-md-only\\:order-11{order:11}[class*=b-grid-item].b-md-only\\:order-12{order:12}[class*=b-grid-item].b-md-only\\:order-13{order:13}[class*=b-grid-item].b-md-only\\:order-14{order:14}[class*=b-grid-item].b-md-only\\:order-15{order:15}[class*=b-grid-item].b-md-only\\:order-16{order:16}[class*=b-grid-item].b-md-only\\:order-17{order:17}[class*=b-grid-item].b-md-only\\:order-18{order:18}[class*=b-grid-item].b-md-only\\:order-19{order:19}[class*=b-grid-item].b-md-only\\:order-20{order:20}[class*=b-grid-item][class*="b-md-only:vertical-divider"]{position:relative}[class*=b-grid-item][class*="b-md-only:vertical-divider"]:after{background-color:var(--b-grid-divider-color, var(--beacon-system-color-border-2));block-size:100%;content:"";inline-size:var(--b-grid-divider-size, var(--beacon-system-width-border-mini));inset-block-start:0;inset-inline-start:calc(100% + var(--b-default-grid-gap) / 2);position:absolute;z-index:1}[class*=b-grid-item].b-md-only\\:vertical-divider--thin--neutral{--b-grid-divider-size: var(--beacon-system-width-border-mini);--b-grid-divider-color: var(--beacon-system-color-border-2)}[class*=b-grid-item].b-md-only\\:vertical-divider--thin--strong{--b-grid-divider-size: var(--beacon-system-width-border-mini);--b-grid-divider-color: var(--beacon-system-color-border-brand)}[class*=b-grid-item].b-md-only\\:vertical-divider--thick--neutral{--b-grid-divider-size: var(--beacon-system-width-border-normal);--b-grid-divider-color: var(--beacon-system-color-border-2)}[class*=b-grid-item].b-md-only\\:vertical-divider--thick--strong{--b-grid-divider-size: var(--beacon-system-width-border-normal);--b-grid-divider-color: var(--beacon-system-color-border-brand)}}.b-grid-item--vertical-divider--thin--neutral{--b-grid-divider-size: var(--beacon-system-width-border-mini);--b-grid-divider-color: var(--beacon-system-color-border-2)}.b-grid-item--vertical-divider--thin--strong{--b-grid-divider-size: var(--beacon-system-width-border-mini);--b-grid-divider-color: var(--beacon-system-color-border-brand)}.b-grid-item--vertical-divider--thick--neutral{--b-grid-divider-size: var(--beacon-system-width-border-normal);--b-grid-divider-color: var(--beacon-system-color-border-2)}.b-grid-item--vertical-divider--thick--strong{--b-grid-divider-size: var(--beacon-system-width-border-normal);--b-grid-divider-color: var(--beacon-system-color-border-brand)}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item]{grid-column:var(--b-grid-start, auto)/span var(--b-grid-offset-column, var(--b-grid-span, 1))}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--full-col{--b-grid-span: var(--b-default-column-count)}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item--offset]{--b-grid-offset-column: calc(var(--b-grid-offset) + var(--b-grid-offset-span));margin-inline-start:calc((100% + var(--b-default-grid-gap)) / (var(--b-grid-offset-span) + var(--b-grid-offset)) * var(--b-grid-offset))}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--1-col{--b-grid-offset-span: 1;--b-grid-span: 1}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--start-1:not([class*=b-grid-item--offset]){--b-grid-start: 1}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--offset-1{--b-grid-offset: 1}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--2-col{--b-grid-offset-span: 2;--b-grid-span: 2}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--start-2:not([class*=b-grid-item--offset]){--b-grid-start: 2}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--offset-2{--b-grid-offset: 2}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--3-col{--b-grid-offset-span: 3;--b-grid-span: 3}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--start-3:not([class*=b-grid-item--offset]){--b-grid-start: 3}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--offset-3{--b-grid-offset: 3}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--4-col{--b-grid-offset-span: 4;--b-grid-span: 4}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--start-4:not([class*=b-grid-item--offset]){--b-grid-start: 4}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--offset-4{--b-grid-offset: 4}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--5-col{--b-grid-offset-span: 5;--b-grid-span: 5}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--start-5:not([class*=b-grid-item--offset]){--b-grid-start: 5}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--offset-5{--b-grid-offset: 5}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--6-col{--b-grid-offset-span: 6;--b-grid-span: 6}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--start-6:not([class*=b-grid-item--offset]){--b-grid-start: 6}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--offset-6{--b-grid-offset: 6}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--7-col{--b-grid-offset-span: 7;--b-grid-span: 7}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--start-7:not([class*=b-grid-item--offset]){--b-grid-start: 7}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--offset-7{--b-grid-offset: 7}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--8-col{--b-grid-offset-span: 8;--b-grid-span: 8}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--start-8:not([class*=b-grid-item--offset]){--b-grid-start: 8}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--offset-8{--b-grid-offset: 8}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--9-col{--b-grid-offset-span: 9;--b-grid-span: 9}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--start-9:not([class*=b-grid-item--offset]){--b-grid-start: 9}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--offset-9{--b-grid-offset: 9}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--10-col{--b-grid-offset-span: 10;--b-grid-span: 10}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--start-10:not([class*=b-grid-item--offset]){--b-grid-start: 10}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--offset-10{--b-grid-offset: 10}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--11-col{--b-grid-offset-span: 11;--b-grid-span: 11}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--start-11:not([class*=b-grid-item--offset]){--b-grid-start: 11}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--offset-11{--b-grid-offset: 11}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--12-col{--b-grid-offset-span: 12;--b-grid-span: 12}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--start-12:not([class*=b-grid-item--offset]){--b-grid-start: 12}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--offset-12{--b-grid-offset: 12}@media (width >= 320px){:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:1-col{--b-grid-span: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:start-1{--b-grid-start: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:offset-1{--b-grid-offset: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:2-col{--b-grid-span: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:start-2{--b-grid-start: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:offset-2{--b-grid-offset: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:3-col{--b-grid-span: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:start-3{--b-grid-start: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:offset-3{--b-grid-offset: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:4-col{--b-grid-span: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:start-4{--b-grid-start: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:offset-4{--b-grid-offset: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:5-col{--b-grid-span: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:start-5{--b-grid-start: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:offset-5{--b-grid-offset: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:6-col{--b-grid-span: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:start-6{--b-grid-start: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:offset-6{--b-grid-offset: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:7-col{--b-grid-span: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:start-7{--b-grid-start: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:offset-7{--b-grid-offset: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:8-col{--b-grid-span: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:start-8{--b-grid-start: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:offset-8{--b-grid-offset: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:9-col{--b-grid-span: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:start-9{--b-grid-start: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:offset-9{--b-grid-offset: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:10-col{--b-grid-span: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:start-10{--b-grid-start: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:offset-10{--b-grid-offset: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:11-col{--b-grid-span: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:start-11{--b-grid-start: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:offset-11{--b-grid-offset: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:12-col{--b-grid-span: 12}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:start-12{--b-grid-start: 12}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:offset-12{--b-grid-offset: 12}}@media (width >= 640px){:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:1-col{--b-grid-span: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:start-1{--b-grid-start: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:offset-1{--b-grid-offset: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:2-col{--b-grid-span: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:start-2{--b-grid-start: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:offset-2{--b-grid-offset: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:3-col{--b-grid-span: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:start-3{--b-grid-start: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:offset-3{--b-grid-offset: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:4-col{--b-grid-span: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:start-4{--b-grid-start: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:offset-4{--b-grid-offset: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:5-col{--b-grid-span: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:start-5{--b-grid-start: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:offset-5{--b-grid-offset: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:6-col{--b-grid-span: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:start-6{--b-grid-start: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:offset-6{--b-grid-offset: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:7-col{--b-grid-span: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:start-7{--b-grid-start: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:offset-7{--b-grid-offset: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:8-col{--b-grid-span: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:start-8{--b-grid-start: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:offset-8{--b-grid-offset: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:9-col{--b-grid-span: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:start-9{--b-grid-start: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:offset-9{--b-grid-offset: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:10-col{--b-grid-span: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:start-10{--b-grid-start: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:offset-10{--b-grid-offset: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:11-col{--b-grid-span: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:start-11{--b-grid-start: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:offset-11{--b-grid-offset: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:12-col{--b-grid-span: 12}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:start-12{--b-grid-start: 12}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:offset-12{--b-grid-offset: 12}}@media (width >= 960px){:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:1-col{--b-grid-span: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:start-1{--b-grid-start: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:offset-1{--b-grid-offset: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:2-col{--b-grid-span: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:start-2{--b-grid-start: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:offset-2{--b-grid-offset: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:3-col{--b-grid-span: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:start-3{--b-grid-start: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:offset-3{--b-grid-offset: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:4-col{--b-grid-span: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:start-4{--b-grid-start: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:offset-4{--b-grid-offset: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:5-col{--b-grid-span: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:start-5{--b-grid-start: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:offset-5{--b-grid-offset: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:6-col{--b-grid-span: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:start-6{--b-grid-start: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:offset-6{--b-grid-offset: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:7-col{--b-grid-span: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:start-7{--b-grid-start: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:offset-7{--b-grid-offset: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:8-col{--b-grid-span: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:start-8{--b-grid-start: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:offset-8{--b-grid-offset: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:9-col{--b-grid-span: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:start-9{--b-grid-start: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:offset-9{--b-grid-offset: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:10-col{--b-grid-span: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:start-10{--b-grid-start: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:offset-10{--b-grid-offset: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:11-col{--b-grid-span: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:start-11{--b-grid-start: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:offset-11{--b-grid-offset: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:12-col{--b-grid-span: 12}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:start-12{--b-grid-start: 12}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:offset-12{--b-grid-offset: 12}}@media (width >= 1280px){:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:1-col{--b-grid-span: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:start-1{--b-grid-start: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:offset-1{--b-grid-offset: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:2-col{--b-grid-span: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:start-2{--b-grid-start: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:offset-2{--b-grid-offset: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:3-col{--b-grid-span: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:start-3{--b-grid-start: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:offset-3{--b-grid-offset: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:4-col{--b-grid-span: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:start-4{--b-grid-start: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:offset-4{--b-grid-offset: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:5-col{--b-grid-span: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:start-5{--b-grid-start: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:offset-5{--b-grid-offset: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:6-col{--b-grid-span: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:start-6{--b-grid-start: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:offset-6{--b-grid-offset: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:7-col{--b-grid-span: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:start-7{--b-grid-start: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:offset-7{--b-grid-offset: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:8-col{--b-grid-span: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:start-8{--b-grid-start: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:offset-8{--b-grid-offset: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:9-col{--b-grid-span: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:start-9{--b-grid-start: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:offset-9{--b-grid-offset: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:10-col{--b-grid-span: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:start-10{--b-grid-start: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:offset-10{--b-grid-offset: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:11-col{--b-grid-span: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:start-11{--b-grid-start: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:offset-11{--b-grid-offset: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:12-col{--b-grid-span: 12}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:start-12{--b-grid-start: 12}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:offset-12{--b-grid-offset: 12}}@media (width >= 1600px){:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:1-col{--b-grid-span: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:start-1{--b-grid-start: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:offset-1{--b-grid-offset: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:2-col{--b-grid-span: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:start-2{--b-grid-start: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:offset-2{--b-grid-offset: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:3-col{--b-grid-span: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:start-3{--b-grid-start: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:offset-3{--b-grid-offset: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:4-col{--b-grid-span: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:start-4{--b-grid-start: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:offset-4{--b-grid-offset: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:5-col{--b-grid-span: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:start-5{--b-grid-start: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:offset-5{--b-grid-offset: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:6-col{--b-grid-span: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:start-6{--b-grid-start: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:offset-6{--b-grid-offset: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:7-col{--b-grid-span: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:start-7{--b-grid-start: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:offset-7{--b-grid-offset: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:8-col{--b-grid-span: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:start-8{--b-grid-start: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:offset-8{--b-grid-offset: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:9-col{--b-grid-span: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:start-9{--b-grid-start: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:offset-9{--b-grid-offset: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:10-col{--b-grid-span: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:start-10{--b-grid-start: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:offset-10{--b-grid-offset: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:11-col{--b-grid-span: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:start-11{--b-grid-start: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:offset-11{--b-grid-offset: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:12-col{--b-grid-span: 12}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:start-12{--b-grid-start: 12}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:offset-12{--b-grid-offset: 12}}@media (width >= 1920px){:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:1-col{--b-grid-span: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:start-1{--b-grid-start: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:offset-1{--b-grid-offset: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:2-col{--b-grid-span: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:start-2{--b-grid-start: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:offset-2{--b-grid-offset: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:3-col{--b-grid-span: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:start-3{--b-grid-start: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:offset-3{--b-grid-offset: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:4-col{--b-grid-span: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:start-4{--b-grid-start: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:offset-4{--b-grid-offset: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:5-col{--b-grid-span: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:start-5{--b-grid-start: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:offset-5{--b-grid-offset: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:6-col{--b-grid-span: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:start-6{--b-grid-start: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:offset-6{--b-grid-offset: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:7-col{--b-grid-span: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:start-7{--b-grid-start: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:offset-7{--b-grid-offset: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:8-col{--b-grid-span: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:start-8{--b-grid-start: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:offset-8{--b-grid-offset: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:9-col{--b-grid-span: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:start-9{--b-grid-start: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:offset-9{--b-grid-offset: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:10-col{--b-grid-span: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:start-10{--b-grid-start: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:offset-10{--b-grid-offset: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:11-col{--b-grid-span: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:start-11{--b-grid-start: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:offset-11{--b-grid-offset: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:12-col{--b-grid-span: 12}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:start-12{--b-grid-start: 12}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:offset-12{--b-grid-offset: 12}}@media (width >= 1600px){:root{--beacon-grid-layout-space-margin: 10rem;--beacon-grid-gutter-size-inline: 2rem}}.wrapper{display:grid;gap:var(--beacon-system-space-micro-normal)}.header{align-items:baseline;display:flex;gap:var(--beacon-reference-space-3);padding-block:var(--beacon-system-space-cell-contained)}.title{color:var(--beacon-system-color-text-title)}.title ::slotted(*){font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-50)}.item-count{color:var(--beacon-system-color-text-standard);font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100)}.countries{--b-grid-columns: 1;--b-grid-gap: var(--beacon-system-space-micro-normal);margin-inline:0}@media (width >= 640px){.countries{--b-grid-columns: 2;--b-grid-gap: var(--beacon-system-space-micro-jumbo)}}@media (width >= 960px){.countries{--b-grid-columns: 4;row-gap:var(--beacon-system-space-micro-normal)}}`, _b = class _b extends Le {
  constructor() {
    super(...arguments), this.beaconTagName = Lg.beaconTagName, this.resetSpacing = !0;
  }
  static get styles() {
    return [super.styles, AP];
  }
  static get lightDOMStyles() {
    return [...super.lightDOMStyles, vP];
  }
  render() {
    return pe`<div class="wrapper">
      <header class="header">
        <div class="title">
          <slot name="title"></slot>
        </div>
        <div class="item-count">
          <slot name="item-count"></slot>
        </div>
      </header>
      <section class="countries b-grid">
        <slot></slot>
      </section>
    </div>`;
  }
};
_b.tagName = Lg.beaconTagName;
let Og = _b;
const Pg = {
  beaconTagName: "beacon-scatter-chart"
}, yP = ve`.highcharts-series-inactive{opacity:1}.highcharts-crosshair{stroke:var(--beacon-component-data-viz-color-border-major);stroke-width:var(--beacon-system-width-border-mini)}.highcharts-point-hover{stroke:var(--beacon-system-color-border-1);stroke-width:var(--beacon-system-width-border-normal)}:has(.highcharts-point-hover) .highcharts-point:not(.highcharts-point-hover){opacity:.2}`;
var xP = Object.defineProperty, wP = Object.getOwnPropertyDescriptor, Tv = (i, t, e, a) => {
  for (var o = a > 1 ? void 0 : a ? wP(t, e) : t, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = (a ? r(t, e, o) : r(o)) || o);
  return a && o && xP(t, e, o), o;
}, uo, Yn, Ss, gh;
const ib = (uo = class extends Ke(ct).with(
  zs,
  un
) {
  constructor() {
    super(...arguments), this.beaconTagName = Pg.beaconTagName, this._type = Jt.SCATTER, this.scale = Ur.Mini;
  }
  static get styles() {
    return [super.styles, yP, this.chartAreaStyles];
  }
  get localComponentOptions() {
    var e;
    const t = this.addBeaconModeToTooltipContainer.bind(this);
    return ct.createChartOptions(super.localComponentOptions, {
      xAxis: {
        crosshair: !0
      },
      yAxis: {
        crosshair: !0
      },
      plotOptions: {
        scatter: {
          marker: {
            radius: ze(uo, Yn).get(this.scale)
          },
          states: {
            hover: {
              halo: {
                opacity: 0.6,
                size: Ze(e = uo, Ss, gh).call(e, this.scale)
              }
            }
          }
        }
      },
      tooltip: {
        pointFormatter() {
          return t(), ct.tooltipPointHTML(
            this,
            this.series.name,
            `${this.x}, ${this.y}`
          );
        }
      }
    });
  }
  _updateScale() {
    var t;
    this.updateChart({
      plotOptions: {
        scatter: {
          marker: {
            radius: ze(uo, Yn).get(this.scale)
          },
          states: {
            hover: {
              halo: {
                size: Ze(t = uo, Ss, gh).call(t, this.scale)
              }
            }
          }
        }
      }
    });
  }
}, Yn = new WeakMap(), Ss = new WeakSet(), gh = function(t) {
  const e = ze(this, Yn).get(t);
  return e ? e + 6 : void 0;
}, Fe(uo, Ss), uo.tagName = Pg.beaconTagName, Fe(uo, Yn, /* @__PURE__ */ new Map([
  [Ur.Mini, 4],
  [Ur.Normal, 8],
  [Ur.Jumbo, 12]
])), uo);
Tv([
  ue()
], ib.prototype, "scale", 2);
Tv([
  yo("scale")
], ib.prototype, "_updateScale", 1);
let sz = ib;
const zg = {
  beaconTagName: "beacon-segmented-control"
};
var kP = Object.defineProperty, CP = Object.getOwnPropertyDescriptor, Mc = (i, t, e, a) => {
  for (var o = a > 1 ? void 0 : a ? CP(t, e) : t, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = (a ? r(t, e, o) : r(o)) || o);
  return a && o && kP(t, e, o), o;
};
const Ub = class Ub extends Le {
  constructor() {
    super(...arguments), this.beaconTagName = zg.beaconTagName, this.selected = !1, this.value = "";
  }
  get text() {
    var t, e;
    return (e = (t = this.innerText) == null ? void 0 : t.trim()) != null ? e : "";
  }
  /** Normalized text content to remove any spaces so it remains a continuous string. */
  get normalizedValue() {
    return this.value || this.text.replace(" ", "-") || "";
  }
  get icon() {
    return this.icons[0];
  }
  handleSlotChange() {
    Re(this, "beacon-event-change");
  }
  render() {
    return pe`
      <slot name="icon"></slot>
      <slot @slotchange="${this.handleSlotChange}></slot>
    `;
  }
};
Ub.tagName = zg.beaconTagName;
let rr = Ub;
Mc([
  ue({ type: Boolean })
], rr.prototype, "selected", 2);
Mc([
  ue()
], rr.prototype, "value", 2);
Mc([
  wt({ slot: "icon" })
], rr.prototype, "icons", 2);
Mc([
  De
], rr.prototype, "handleSlotChange", 1);
const Dg = {
  beaconTagName: "beacon-segmented-controls"
}, SP = ve`.radios{background-color:var(--beacon-system-color-background-1);border-color:var(--beacon-component-form-color-border-standard);border-radius:var(--beacon-system-radius-corner-round);border-style:solid;border-width:var(--beacon-system-width-border-mini);display:flex;gap:var(--beacon-reference-space-2);inline-size:fit-content;padding:var(--beacon-reference-space-2);position:relative}.radios .control{flex-shrink:0}.radios[inert]{border:0;clip:rect(0,0,0,0);block-size:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;inline-size:1px;padding:var(--beacon-reference-space-2)}[type=radio]{opacity:0;pointer-events:none;position:absolute}[type=radio]+label{align-items:center;border-radius:var(--beacon-system-radius-corner-round);color:var(--beacon-system-color-text-secondary);display:flex;gap:var(--beacon-reference-space-3)}[type=radio]+label svg{block-size:var(--beacon-reference-space-5);color:var(--beacon-system-color-icon-secondary);inline-size:var(--beacon-reference-space-5)}[type=radio]+label path{fill:currentcolor}[type=radio]:not(:disabled)+label{cursor:pointer}[type=radio]:not(:disabled):not(:checked)+label:hover{background-color:var(--beacon-system-color-background-secondary-hover)}[type=radio]:disabled+label{color:var(--beacon-system-color-text-secondary-inactive)}[type=radio]:disabled+label svg{color:var(--beacon-system-color-icon-secondary-inactive)}[type=radio]:active:not(:disabled,:checked)+label:hover{background-color:var(--beacon-system-color-background-secondary-pressed)}[type=radio]:checked+label{background-color:var(--beacon-system-color-background-primary);color:var(--beacon-system-color-text-primary)}[type=radio]:checked+label svg{color:var(--beacon-system-color-icon-primary)}[type=radio]:checked:disabled+label{background-color:var(--beacon-system-color-background-primary-inactive);color:var(--beacon-system-color-text-primary-inactive)}[type=radio]:checked:disabled+label svg{color:var(--beacon-system-color-icon-primary-inactive)}[type=radio]:focus-visible+label{box-shadow:0 0 0 var(--beacon-system-width-border-jumbo) var(--beacon-system-color-border-focus-middle),0 0 0 var(--beacon-system-width-border-maxi) var(--beacon-system-color-border-focus-outer);outline:var(--beacon-system-width-border-normal) solid var(--beacon-system-color-border-focus-inner);outline-offset:0;z-index:1}[type=radio]:focus-visible+label:not(dialog){position:relative}.title{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-headline-50);margin:0;margin-block-end:var(--beacon-reference-space-3);padding:0}.base{border:0;margin:0;padding:0;position:relative}.base:not(.compact) .select{display:none}.base.normal label{font:var(--beacon-system-font-weight-bold) var(--beacon-component-button-normal-font-size-sans-serif-standard);padding:var(--beacon-reference-space-4)}.base.mini label{font:var(--beacon-system-font-weight-bold) var(--beacon-component-button-mini-font-size-sans-serif-standard);padding:var(--beacon-reference-space-3)}.base.disabled .radios{border-color:var(--beacon-system-color-border-secondary-inactive)}select{color:var(--beacon-system-color-text-standard)}::part(field){inline-size:100%}::part(field):focus-within{outline:var(--beacon-system-width-border-normal) solid var(--beacon-system-color-border-focus-middle);outline-offset:var(--beacon-system-width-border-normal);position:relative;z-index:1}`;
var EP = Object.defineProperty, TP = Object.getOwnPropertyDescriptor, oo = (i, t, e, a) => {
  for (var o = a > 1 ? void 0 : a ? TP(t, e) : t, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = (a ? r(t, e, o) : r(o)) || o);
  return a && o && EP(t, e, o), o;
};
const ec = class ec extends Le {
  constructor() {
    super(...arguments), this.beaconTagName = Dg.beaconTagName, this.focusOverride = !0, this.resetSpacing = !0, this.scale = "normal", this.disabled = !1, this.value = void 0, this.controlsList = [], this.compact = !1;
  }
  static get styles() {
    return [super.styles, SP];
  }
  handleDefaultSlotchange() {
    this.controls.find(
      (e) => e.selected
    ) || (this.controls[0].selected = !0, this.setDefaultValue()), this.controlsList = [...this.controls];
  }
  renderRadioButtons() {
    return pe`${Vo(
      this.controlsList,
      (t) => pe`
        <div class="control">
          <input
            focus-override
            ?checked=${t.selected}
            type="radio"
            name="controls"
            id="control--${t.normalizedValue ? t.normalizedValue : t.value}"
            value="${t.normalizedValue ? t.normalizedValue : t.value}" />
          <label
            for="control--${t.normalizedValue}"
            id="label--${t.normalizedValue ? t.normalizedValue : t.value}">
            ${t.icon ? pe`${t.icon.cloneNode(!0)}` : pe``}
            <span class="label-text"
              >${t.text ? t.text : t.value}</span
            >
          </label>
        </div>
      `
    )}`;
  }
  renderSelectMenu() {
    const t = pe`${Vo(
      this.controlsList,
      (e) => pe`
        <option
          ?selected=${e.selected}
          id="option--${e.normalizedValue}"
          value="${e.normalizedValue}">
          ${e.text}
        </option>
      `
    )}`;
    return Be`
      <${this.getScopedTag("beacon-control")}>
        <select ?disabled=${this.disabled} aria-labelledby="title">
          ${t}
        </select>
      </${this.getScopedTag("beacon-control")}>
    `;
  }
  // this event won't fire when we use JS to check a radio button
  handleRadioInputEvent(t) {
    const { target: e } = t;
    if (!(e instanceof HTMLInputElement)) return;
    this.value = e.value;
    const o = Array.from(this.options).find(
      (n) => n.value === e.value
    );
    o.selected = !0, this.emitSegmentInput();
  }
  // this event won't fire when we use JS to select an option
  handleSelectInputEvent(t) {
    const { target: e } = t;
    if (!(e instanceof HTMLSelectElement)) return;
    this.value = e.value;
    const a = Array.from(this.radioButtons), o = e.selectedOptions[0], n = a.find(
      (r) => r.value === o.value
    );
    n.checked = !0, this.emitSegmentInput();
  }
  emitSegmentInput() {
    Re(this, Ee.INPUT, {
      detail: {
        value: this.value
      }
    });
  }
  applyBaseResizeObserver() {
    const t = (a) => {
      for (const o of a) {
        const { target: n } = o, { clientWidth: r } = n, { scrollWidth: T } = this.radiosContainer;
        T > r ? this.compact = !0 : this.compact = !1;
        return;
      }
    }, e = new ResizeObserver(Io(t, 100));
    this.baseResizeObserver = e, this.baseResizeObserver.observe(this.base);
  }
  setDefaultValue() {
    const t = this.controls.find(
      (e) => e.selected
    );
    t && (this.value = t.value);
  }
  render() {
    const t = {
      base: !0,
      compact: this.compact,
      disabled: this.disabled
    };
    return t[this.scale] = !0, pe`
      <slot
        style="display: none;"
        @slotchange=${this.handleDefaultSlotchange}
        @beacon-event-change=${this.handleDefaultSlotchange}></slot>
      <fieldset class="${Oe(t)}" ?disabled=${this.disabled}>
        <legend class="title" id="title">
          <slot name="title" ${Ue({ useParent: !0 })}></slot>
        </legend>
        <div
          ?inert=${this.compact}
          class="radios"
          @input=${this.handleRadioInputEvent}>
          ${this.renderRadioButtons()}
        </div>
        <div class="select" @input=${this.handleSelectInputEvent}>
          ${this.renderSelectMenu()}
        </div>
      </fieldset>
    `;
  }
};
ec.tagName = Dg.beaconTagName, ec.nestedComponents = [wc];
let jt = ec;
oo([
  ue()
], jt.prototype, "scale", 2);
oo([
  ue({ type: Boolean })
], jt.prototype, "disabled", 2);
oo([
  Se()
], jt.prototype, "value", 2);
oo([
  Se()
], jt.prototype, "controlsList", 2);
oo([
  Se()
], jt.prototype, "compact", 2);
oo([
  Ge(".base")
], jt.prototype, "base", 2);
oo([
  Ge(".radios")
], jt.prototype, "radiosContainer", 2);
oo([
  Ge('[type="radio"]:checked')
], jt.prototype, "checkedRadio", 2);
oo([
  Ge("select")
], jt.prototype, "select", 2);
oo([
  Ts('[type="radio"]')
], jt.prototype, "radioButtons", 2);
oo([
  Ts("option")
], jt.prototype, "options", 2);
oo([
  Pe({ selector: "beacon-segmented-control" }, !0)
], jt.prototype, "controls", 2);
oo([
  De
], jt.prototype, "applyBaseResizeObserver", 1);
oo([
  De
], jt.prototype, "setDefaultValue", 1);
const Ig = {
  beaconTagName: "beacon-selection-tile"
}, MP = ve`:where([beacon-tag-name=beacon-selection-tile]):has(:checked)::part(internal--tile){--selection-tile-background-color: var(--beacon-system-color-background-secondary-hover);--selection-tile-border-color: var(--beacon-system-color-border-active);outline:var(--beacon-system-width-border-mini) solid var(--beacon-system-color-border-active)}:where([beacon-tag-name=beacon-selection-tile]):has(:checked)::part(internal--field){border-color:var(--beacon-system-color-background-primary)}:where([beacon-tag-name=beacon-selection-tile]):has(:active)::part(internal--tile){--selection-tile-background-color: var(--beacon-system-color-background-secondary-pressed)}:where([beacon-tag-name=beacon-selection-tile]):has(:disabled,[aria-disabled=true])::part(internal--field){border-color:var(--beacon-component-form-color-background-inactive)}:where([beacon-tag-name=beacon-selection-tile]):focus-within:has(input:focus-visible){box-shadow:0 0 0 var(--beacon-system-width-border-jumbo) var(--beacon-system-color-border-focus-middle),0 0 0 var(--beacon-system-width-border-maxi) var(--beacon-system-color-border-focus-outer);outline:var(--beacon-system-width-border-normal) solid var(--beacon-system-color-border-focus-inner);outline-offset:0;z-index:1}:where([beacon-tag-name=beacon-selection-tile]):focus-within:has(input:focus-visible):not(dialog){position:relative}`, LP = ve`:host{border-radius:var(--beacon-system-radius-corner-standard)}.tile{background-color:var(--selection-tile-background-color, var(--beacon-system-color-background-1));block-size:100%;border:var(--selection-tile-border-width, var(--beacon-system-width-border-mini)) solid var(--selection-tile-border-color, var(--beacon-component-form-color-border-standard));border-radius:var(--beacon-system-radius-corner-standard);column-gap:var(--beacon-component-selection-tile-space-padding);display:grid;grid-template-columns:auto 1fr;grid-template-rows:auto 1fr;padding:var(--beacon-component-selection-tile-space-padding);position:relative}.tile:hover{--selection-tile-background-color: var(--beacon-system-color-background-secondary-hover)}.tile.disabled{--selection-tile-background-color: transparent !important;--selection-tile-border-color: var(--beacon-system-color-border-inactive) !important}.tile.radio .field{border-radius:50%}.tile.checkbox .field{border:var(--beacon-system-width-border-mini) solid var(--beacon-component-form-color-border-standard);border-radius:var(--beacon-system-radius-corner-standard)}.label{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-body-100);grid-column:2/3;grid-row:1/2}.hint{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100);block-size:fit-content;grid-column:2/3;grid-row:2/3;margin-block-start:var(--beacon-reference-space-3);pointer-events:none;position:relative;z-index:1}.field{align-self:center;background-color:var(--beacon-system-color-background-1);display:grid}::slotted(label):before{content:"";cursor:pointer;display:block;top:0;right:0;bottom:0;left:0;position:absolute}::slotted(input){margin:0;padding:0}::slotted(input:focus-visible){box-shadow:none!important;outline:0!important}::slotted(:is([type=checkbox],[type=radio])){-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:var(--beacon-system-color-background-1);block-size:var(--beacon-component-selection-tile-icon-size);border:var(--beacon-system-width-border-mini) solid var(--beacon-component-form-color-border-standard);cursor:pointer;inline-size:var(--beacon-component-selection-tile-icon-size)}::slotted(:is([type=checkbox],[type=radio]):is([aria-disabled=true],:disabled)){background-color:var(--beacon-component-form-color-background-inactive);border:0}::slotted([type=checkbox]){border:0;border-radius:var(--beacon-system-radius-corner-standard)}::slotted([type=checkbox]:checked){accent-color:var(--beacon-system-color-background-primary);-webkit-appearance:revert;-moz-appearance:revert;appearance:revert}::slotted([type=checkbox]:checked:is([aria-disabled=true],:disabled)){accent-color:var(--beacon-component-form-color-foreground-inactive)}@supports (hanging-punctuation: first) and (font: -apple-system-body) and (-webkit-appearance: none){::slotted([type=checkbox]:checked){-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:var(--beacon-system-color-background-primary);background-image:url("data:image/svg+xml,%3Csvg width='15' height='13' viewBox='0 0 15 13' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 7.51852L5.78947 12L14 1' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A");background-position:center;background-repeat:no-repeat;border-radius:unset}::slotted([type=checkbox]:checked:is([aria-disabled=true],:disabled)){background-color:var(--beacon-component-form-color-foreground-inactive);border:0}}::slotted([type=radio]){border-radius:50%;padding:var(--beacon-reference-space-1)}::slotted([type=radio]:checked){background-clip:content-box;background-color:var(--beacon-system-color-background-primary);border-color:var(--beacon-system-color-background-primary)}::slotted([type=radio]:checked:is([aria-disabled=true],:disabled)){background-color:var(--beacon-component-form-color-foreground-inactive);border:0}`;
var Ki;
const tc = class tc extends Ke(Le).with(
  Zh,
  Xh,
  Gf
) {
  constructor() {
    super(...arguments);
    Fe(this, Ki);
    this.beaconTagName = Ig.beaconTagName, Ne(this, Ki, void 0);
  }
  static get styles() {
    return [super.styles, LP];
  }
  // Uses light DOM styles to control colors not otherwise accessible through ::slotted or events
  static get lightDOMStyles() {
    return [super.lightDOMStyles, MP];
  }
  postSetFormControlElement() {
    this.setDisabledState(), this.setInputType(), this.applyFieldElementObserver(), this.preventDisabledEventsOnElement(this.fieldElement);
  }
  postSetHintElement() {
    this.setFormControlAriaDescribedBy();
  }
  getAriaDescribedByIds() {
    var a;
    return [(a = this.hintElement) == null ? void 0 : a.id];
  }
  setFormControlAriaDescribedBy(e = this.getAriaDescribedByIds()) {
    if (!this.fieldElement) return;
    const a = e.filter(
      (o) => o
    );
    if (a.length === 0) {
      this.fieldElement.removeAttribute("aria-describedby");
      return;
    }
    this.fieldElement.setAttribute("aria-describedby", a.join(" "));
  }
  // component state is drived by changes to the slotted form element, i.e. disabled/aria-disabled
  applyFieldElementObserver() {
    this.fieldElement && !ze(this, Ki) && (Ne(this, Ki, new MutationObserver(
      (e) => {
        e.find(
          (o) => o.attributeName === "aria-disabled" || o.attributeName === "disabled"
        ) && this.setDisabledState();
      }
    )), ze(this, Ki).observe(this.fieldElement, {
      attributes: !0
    }));
  }
  setDisabledState() {
    if (this.fieldElement) {
      if (this.fieldElement.disabled) {
        this.disabled = this.fieldElement.disabled;
        return;
      }
      const e = this.fieldElement.getAttribute("aria-disabled");
      e === null ? this.disabled = this.fieldElement.disabled : this.disabled = e === "true";
    }
  }
  render() {
    const e = {
      disabled: this.disabled,
      tile: !0
    };
    return this._inputType && (e[this._inputType] = !0), pe`
      <div class="${Oe(e)}" part="internal--tile">
        <div class="label" part="label">
          <slot name="label"></slot>
        </div>
        <div class="field" part="internal--field">
          ${this.renderFormControlTemplate()}
        </div>
        ${this.renderHintTemplate()}
      </div>
    `;
  }
};
Ki = new WeakMap(), tc.tagName = Ig.beaconTagName, tc.nestedComponents = [wc];
let Bg = tc;
const OP = ve`:root[beacon-tag-name=beacon-social-link],:root [beacon-tag-name=beacon-social-link],[beacon-version="4.3.1"][class*=beacon-on][beacon-tag-name=beacon-social-link],[beacon-version="4.3.1"][class*=beacon-on] [beacon-tag-name=beacon-social-link],[class*=beacon-on] [beacon-version="4.3.1"][beacon-tag-name=beacon-social-link],[class*=beacon-on] [beacon-version="4.3.1"] [beacon-tag-name=beacon-social-link],[beacon-version="4.3.1"][beacon-tag-name=beacon-social-link],[beacon-version="4.3.1"] [beacon-tag-name=beacon-social-link]{--social-link-flex-gap: var(--beacon-reference-space-3);--social-link-icon-container-size: var(--beacon-reference-space-5)}@media (width >= 960px){:root[beacon-tag-name=beacon-social-link],:root [beacon-tag-name=beacon-social-link],[beacon-version="4.3.1"][class*=beacon-on][beacon-tag-name=beacon-social-link],[beacon-version="4.3.1"][class*=beacon-on] [beacon-tag-name=beacon-social-link],[class*=beacon-on] [beacon-version="4.3.1"][beacon-tag-name=beacon-social-link],[class*=beacon-on] [beacon-version="4.3.1"] [beacon-tag-name=beacon-social-link],[beacon-version="4.3.1"][beacon-tag-name=beacon-social-link],[beacon-version="4.3.1"] [beacon-tag-name=beacon-social-link]{--social-link-flex-gap: var(--beacon-reference-space-2);--social-link-icon-container-size: var(--beacon-reference-space-7)}}[beacon-tag-name=beacon-social-link]{--social-link-icon-instagram-pattern-url-heritage: url(#pattern0)}`, zd = {
  beaconTagName: "beacon-social-link",
  iconMap: /* @__PURE__ */ new Map([
    [
      "facebook",
      pe`<svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        role="presentation">
        <g clip-path="url(#clip0_2188_14217)">
          <path
            d="M16 8C16 3.58172 12.4183 -9.53674e-07 8 -9.53674e-07C3.58172 -9.53674e-07 0 3.58172 0 8C0 11.993 2.92548 15.3027 6.75 15.9028V10.3125H4.71875V8H6.75V6.2375C6.75 4.2325 7.94434 3.125 9.77172 3.125C10.647 3.125 11.5625 3.28125 11.5625 3.28125V5.25H10.5537C9.55992 5.25 9.25 5.86667 9.25 6.49933V8H11.4688L11.1141 10.3125H9.25V15.9028C13.0745 15.3027 16 11.993 16 8Z"
            fill="var(--social-link-facebook-color-fill-outside)" />
          <path
            d="M11.1141 10.3125L11.4688 8H9.25V6.49933C9.25 5.86667 9.55992 5.25 10.5537 5.25H11.5625V3.28125C11.5625 3.28125 10.647 3.125 9.77172 3.125C7.94434 3.125 6.75 4.2325 6.75 6.2375V8H4.71875V10.3125H6.75V15.9028C7.1573 15.9667 7.57475 16 8 16C8.42525 16 8.8427 15.9667 9.25 15.9028V10.3125H11.1141Z"
            fill="var(--social-link-facebook-color-fill-inside)" />
        </g>
        <defs>
          <clipPath id="clip0_2188_14217">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>`
    ],
    [
      "twitter",
      pe`<svg
        width="16"
        height="14"
        viewBox="0 0 16 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        role="presentation">
        <g clip-path="url(#clip0_2188_14227)">
          <path
            d="M14.3193 3.72903C14.329 3.86903 14.329 4.00903 14.329 4.15032C14.329 8.45548 11.0515 13.4206 5.05865 13.4206V13.4181C3.28832 13.4206 1.55478 12.9135 0.0644531 11.9574C0.321872 11.9884 0.580582 12.0039 0.839937 12.0045C2.30703 12.0058 3.73219 11.5135 4.88639 10.6071C3.49219 10.5806 2.26961 9.67161 1.84252 8.34451C2.3309 8.43871 2.83413 8.41935 3.31349 8.28838C1.79349 7.98129 0.699937 6.6458 0.699937 5.09484C0.699937 5.08064 0.699937 5.06709 0.699937 5.05354C1.15284 5.3058 1.65994 5.4458 2.17865 5.46129C0.747034 4.50451 0.305743 2.6 1.17026 1.11096C2.82445 3.14645 5.2651 4.38387 7.8851 4.51484C7.62252 3.38322 7.98123 2.19742 8.82768 1.40193C10.1399 0.168384 12.2038 0.23161 13.4374 1.54322C14.167 1.39935 14.8664 1.13161 15.5064 0.752255C15.2632 1.50645 14.7541 2.14709 14.0741 2.55419C14.7199 2.47806 15.3509 2.30516 15.9451 2.04129C15.5077 2.69677 14.9567 3.26774 14.3193 3.72903Z"
            fill="var(--social-link-twitter-color-fill)" />
        </g>
        <defs>
          <clipPath id="clip0_2188_14227">
            <rect
              width="16"
              height="13.1613"
              fill="white"
              transform="translate(0 0.419998)" />
          </clipPath>
        </defs>
      </svg>`
    ],
    [
      "linkedin",
      pe`<svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        role="presentation">
        <path
          d="M14.8189 0H1.18111C0.867861 0 0.567441 0.124438 0.34594 0.34594C0.124438 0.567441 0 0.867861 0 1.18111V14.8189C0 15.1321 0.124438 15.4326 0.34594 15.6541C0.567441 15.8756 0.867861 16 1.18111 16H14.8189C15.1321 16 15.4326 15.8756 15.6541 15.6541C15.8756 15.4326 16 15.1321 16 14.8189V1.18111C16 0.867861 15.8756 0.567441 15.6541 0.34594C15.4326 0.124438 15.1321 0 14.8189 0ZM4.76889 13.63H2.36333V5.98889H4.76889V13.63ZM3.56445 4.93C3.29158 4.92846 3.02528 4.84613 2.79916 4.69339C2.57304 4.54065 2.39723 4.32435 2.29392 4.07179C2.19061 3.81923 2.16443 3.54173 2.21869 3.2743C2.27294 3.00688 2.4052 2.76152 2.59877 2.56919C2.79234 2.37686 3.03854 2.24618 3.30631 2.19364C3.57408 2.1411 3.85141 2.16906 4.1033 2.27399C4.35519 2.37892 4.57036 2.55611 4.72164 2.78321C4.87293 3.01031 4.95355 3.27713 4.95333 3.55C4.95591 3.73269 4.92167 3.91403 4.85267 4.0832C4.78368 4.25238 4.68132 4.40593 4.55171 4.53471C4.42211 4.66349 4.2679 4.76486 4.09828 4.83277C3.92867 4.90068 3.74711 4.93375 3.56445 4.93ZM13.6356 13.6367H11.2311V9.46222C11.2311 8.23111 10.7078 7.85111 10.0322 7.85111C9.31889 7.85111 8.61889 8.38889 8.61889 9.49333V13.6367H6.21333V5.99445H8.52667V7.05333H8.55778C8.79 6.58333 9.60333 5.78 10.8444 5.78C12.1867 5.78 13.6367 6.57667 13.6367 8.91L13.6356 13.6367Z"
          fill="var(--social-link-linkedin-color-fill)" />
      </svg>`
    ],
    [
      "youtube",
      pe`<svg
        width="16"
        height="12"
        viewBox="0 0 16 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        role="presentation">
        <path
          d="M15.6656 2.14892C15.4816 1.46055 14.9395 0.918356 14.2511 0.73438C13.0033 0.400024 7.99996 0.400023 7.99996 0.400023C7.99996 0.400023 2.99666 0.400024 1.74888 0.73438C1.06052 0.918356 0.518326 1.46055 0.334352 2.14892C0 3.3967 0 6 0 6C0 6 0 8.60341 0.334352 9.85115C0.518326 10.5395 1.06052 11.0817 1.74888 11.2656C2.99666 11.6001 7.99996 11.6001 7.99996 11.6001C7.99996 11.6001 13.0033 11.6001 14.2511 11.2656C14.9395 11.0817 15.4816 10.5395 15.6656 9.85115C16 8.60341 16 6 16 6C16 6 16 3.3967 15.6656 2.14892Z"
          fill="var(--social-link-youtube-color-fill-outside)" />
        <path
          d="M6.40039 8.40002L10.5572 6.00004L6.40039 3.6V8.40002Z"
          fill="var(--social-link-youtube-color-fill-inside)" />
      </svg>`
    ],
    [
      "x",
      pe`<svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        role="presentation">
        <g clip-path="url(#clip0_1286_254)">
          <path
            d="M9.48734 6.77491L15.3156 0H13.9345L8.87381 5.88256L4.83185 0H0.169922L6.28217 8.89547L0.169922 16H1.55112L6.89534 9.78782L11.164 16H15.8259L9.48701 6.77491H9.48734ZM7.59561 8.97384L6.97631 8.08805L2.04878 1.03974H4.17022L8.14679 6.72795L8.76609 7.61374L13.9352 15.0075H11.8137L7.59561 8.97418V8.97384Z"
            fill="var(--social-link-x-color-fill)" />
        </g>
        <defs>
          <clipPath id="clip0_1286_254">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>`
    ],
    [
      "instagram",
      pe`<svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        aria-hidden="true">
        <g clip-path="url(#clip0_2188_14249)">
          <mask
            id="mask0_2188_14249"
            style="mask-type:luminance"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="16"
            height="16">
            <path
              d="M4.70349 0.0949238C3.85651 0.1349 3.27802 0.270564 2.77251 0.468642C2.24921 0.672648 1.80561 0.946046 1.36433 1.38914C0.922524 1.83249 0.651202 2.27688 0.448748 2.8007C0.252733 3.3075 0.119906 3.88627 0.0825045 4.73377C0.0453702 5.58283 0.0368544 5.85363 0.0409937 8.01522C0.045117 10.1765 0.0546566 10.4479 0.0951453 11.2972C0.135632 12.1439 0.27079 12.7222 0.468867 13.2279C0.673131 13.7512 0.946248 14.1946 1.38959 14.6361C1.83269 15.0777 2.27733 15.3488 2.8014 15.5515C3.30768 15.7472 3.88669 15.8806 4.73393 15.9177C5.58298 15.9551 5.85403 15.9634 8.01507 15.9592C10.1771 15.9551 10.4482 15.9456 11.2972 15.9053C12.1442 15.8648 12.7222 15.7292 13.2282 15.5316C13.7515 15.3268 14.1951 15.0542 14.6364 14.6109C15.0777 14.1678 15.349 13.7231 15.5515 13.199C15.7475 12.6927 15.8808 12.1137 15.9177 11.267C15.9549 10.4174 15.9636 10.1461 15.9595 7.98478C15.9554 5.8232 15.9456 5.55239 15.9053 4.7036C15.8651 3.85609 15.7294 3.27811 15.5316 2.77208C15.3271 2.24877 15.0542 1.80567 14.6111 1.36387C14.1681 0.922574 13.7234 0.650729 13.1993 0.448785C12.6928 0.252768 12.1141 0.119166 11.2668 0.0825425C10.4178 0.0448876 10.1467 0.0366393 7.9849 0.0407642C5.8236 0.0448892 5.55255 0.0541772 4.70349 0.0949238ZM4.79635 14.485C4.02029 14.4512 3.59887 14.3222 3.31801 14.2142C2.94609 14.0703 2.68071 13.8977 2.40139 13.6205C2.12259 13.3422 1.94952 13.0776 1.80432 12.7064C1.69522 12.4255 1.56395 12.0046 1.52758 11.2286C1.48812 10.3896 1.4791 10.1378 1.47523 8.01237C1.4711 5.88742 1.47883 5.63569 1.51546 4.79593C1.54873 4.02038 1.67847 3.59843 1.78627 3.31782C1.93017 2.94539 2.1022 2.68051 2.37998 2.4012C2.65826 2.12187 2.92287 1.94933 3.29427 1.80412C3.57488 1.6945 3.99579 1.56426 4.77159 1.52738C5.61109 1.48766 5.86255 1.47915 7.98747 1.47502C10.1129 1.47089 10.3646 1.47838 11.2044 1.51526C11.9799 1.54904 12.4019 1.67749 12.6822 1.78607C13.0544 1.92998 13.3198 2.1015 13.5988 2.37979C13.8779 2.65808 14.051 2.92218 14.1962 3.29435C14.3058 3.57418 14.436 3.99562 14.4726 4.77117C14.5126 5.61068 14.5217 5.8624 14.5255 7.98736C14.5296 10.1128 14.5219 10.3646 14.485 11.2038C14.4512 11.9799 14.3225 12.4016 14.2142 12.6827C14.0703 13.0543 13.8983 13.3197 13.6202 13.5991C13.3422 13.8773 13.0776 14.0509 12.706 14.1961C12.4259 14.3055 12.0044 14.436 11.2292 14.4729C10.3897 14.5123 10.1382 14.5214 8.01249 14.5252C5.88756 14.5294 5.6361 14.5214 4.79635 14.485ZM11.2856 3.74493C11.2867 4.27211 11.7153 4.69896 12.2425 4.69792C12.7699 4.69689 13.1968 4.2685 13.196 3.74132C13.195 3.21414 12.7663 2.78704 12.2389 2.78807C11.7115 2.7891 11.2846 3.21775 11.2856 3.74493ZM3.91301 8.00773C3.91739 10.2653 5.75088 12.0913 8.00785 12.0869C10.2651 12.0825 12.0921 10.2495 12.0877 7.99201C12.0834 5.73526 10.2496 3.90819 7.99212 3.91257C5.73513 3.91696 3.90862 5.75073 3.91301 8.00773ZM5.34673 8.0049C5.34414 6.53969 6.53002 5.34942 7.99496 5.34683C9.46015 5.344 10.6507 6.52937 10.6535 7.99484C10.6563 9.46031 9.47047 10.6503 8.00501 10.6532C6.54008 10.656 5.34956 9.47037 5.34673 8.0049Z"
              fill="white" />
          </mask>
          <g mask="url(#mask0_2188_14249)">
            <mask
              id="mask1_2188_14249"
              style="mask-type:luminance"
              maskUnits="userSpaceOnUse"
              x="-1"
              y="-1"
              width="18"
              height="18">
              <path
                d="M16.5905 -0.583628H-0.603516V16.6106H16.5905V-0.583628Z"
                fill="white" />
            </mask>
            <g mask="url(#mask1_2188_14249)">
              <mask
                id="mask2_2188_14249"
                style="mask-type:luminance"
                maskUnits="userSpaceOnUse"
                x="-1"
                y="-1"
                width="18"
                height="18">
                <path
                  d="M16.6696 -0.663237H-0.683594V16.6902H16.6696V-0.663237Z"
                  fill="white" />
              </mask>
              <g mask="url(#mask2_2188_14249)">
                <mask
                  id="mask3_2188_14249"
                  style="mask-type:luminance"
                  maskUnits="userSpaceOnUse"
                  x="-1"
                  y="-1"
                  width="18"
                  height="18">
                  <path
                    d="M16.6696 -0.663237H-0.683594V16.6902H16.6696V-0.663237Z"
                    fill="white" />
                </mask>
                <g mask="url(#mask3_2188_14249)">
                  <rect
                    x="-0.689453"
                    y="-0.665792"
                    width="17.3622"
                    height="17.3622"
                    fill="var(--social-link-instagram-color-fill)" />
                </g>
              </g>
            </g>
          </g>
        </g>
        <defs>
          <pattern
            id="pattern0"
            patternContentUnits="objectBoundingBox"
            width="1"
            height="1">
            <use
              xlink:href="#image0_2188_14249"
              transform="scale(0.000439947)" />
          </pattern>
          <clipPath id="clip0_2188_14249">
            <rect width="16" height="16" fill="white" />
          </clipPath>
          <image
            id="image0_2188_14249"
            width="2273"
            height="2275"
            xlink:href="data:image/jpeg;base64,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" />
        </defs>
      </svg>`
    ]
  ])
}, PP = ve`[beacon-tag-name=beacon-social-link]{padding-block:var(--beacon-system-space-cell-contained)}[beacon-tag-name=beacon-social-link] a{color:var(--beacon-system-color-text-link)}[beacon-tag-name=beacon-social-link] a:not(:hover,:focus){text-decoration:none}`, zP = ve`:root,.beacon-on-light,.beacon-on-light [beacon-version="4.3.1"][beacon-tag-name=beacon-social-link],.beacon-on-light[beacon-version="4.3.1"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light [beacon-version="4.3.1"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light[beacon-version="4.3.1"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light [beacon-version="4.3.1"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light[beacon-version="4.3.1"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light [beacon-version="4.3.1"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light[beacon-version="4.3.1"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light [beacon-version="4.3.1"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light[beacon-version="4.3.1"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light [beacon-version="4.3.1"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light[beacon-version="4.3.1"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light [beacon-version="4.3.1"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light[beacon-version="4.3.1"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light [beacon-version="4.3.1"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light[beacon-version="4.3.1"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] .beacon-on-light [beacon-version="4.3.1"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] .beacon-on-light[beacon-version="4.3.1"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] .beacon-on-light [beacon-version="4.3.1"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] .beacon-on-light[beacon-version="4.3.1"][beacon-tag-name=beacon-social-link]{--social-link-facebook-color-fill-inside: #fff;--social-link-facebook-color-fill-outside: #1877f2;--social-link-instagram-color-fill: url(#pattern0);--social-link-linkedin-color-fill: #0a66c2;--social-link-twitter-color-fill: #1d9bf0;--social-link-x-color-fill: #000;--social-link-youtube-color-fill-inside: #fff;--social-link-youtube-color-fill-outside: #ed1d24}.beacon-on-lighter,.beacon-on-lighter [beacon-version="4.3.1"][beacon-tag-name=beacon-social-link],.beacon-on-lighter[beacon-version="4.3.1"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter [beacon-version="4.3.1"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter[beacon-version="4.3.1"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter [beacon-version="4.3.1"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter[beacon-version="4.3.1"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter [beacon-version="4.3.1"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter[beacon-version="4.3.1"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter [beacon-version="4.3.1"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter[beacon-version="4.3.1"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter [beacon-version="4.3.1"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter[beacon-version="4.3.1"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter [beacon-version="4.3.1"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter[beacon-version="4.3.1"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter [beacon-version="4.3.1"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter[beacon-version="4.3.1"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter [beacon-version="4.3.1"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter[beacon-version="4.3.1"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] .beacon-on-lighter [beacon-version="4.3.1"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] .beacon-on-lighter[beacon-version="4.3.1"][beacon-tag-name=beacon-social-link]{--social-link-facebook-color-fill-inside: #fff;--social-link-facebook-color-fill-outside: #1877f2;--social-link-instagram-color-fill: url(#pattern0);--social-link-linkedin-color-fill: #0a66c2;--social-link-twitter-color-fill: #1d9bf0;--social-link-x-color-fill: #000;--social-link-youtube-color-fill-inside: #fff;--social-link-youtube-color-fill-outside: #ed1d24}.beacon-on-dark,.beacon-on-dark [beacon-version="4.3.1"][beacon-tag-name=beacon-social-link],.beacon-on-dark[beacon-version="4.3.1"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark [beacon-version="4.3.1"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark[beacon-version="4.3.1"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark [beacon-version="4.3.1"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark[beacon-version="4.3.1"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark [beacon-version="4.3.1"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark[beacon-version="4.3.1"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark [beacon-version="4.3.1"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark[beacon-version="4.3.1"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark [beacon-version="4.3.1"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark[beacon-version="4.3.1"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark [beacon-version="4.3.1"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark[beacon-version="4.3.1"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark [beacon-version="4.3.1"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark[beacon-version="4.3.1"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark [beacon-version="4.3.1"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark[beacon-version="4.3.1"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] .beacon-on-dark [beacon-version="4.3.1"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] .beacon-on-dark[beacon-version="4.3.1"][beacon-tag-name=beacon-social-link],.beacon-on-darker,.beacon-on-darker [beacon-version="4.3.1"][beacon-tag-name=beacon-social-link],.beacon-on-darker[beacon-version="4.3.1"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker [beacon-version="4.3.1"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker[beacon-version="4.3.1"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker [beacon-version="4.3.1"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker[beacon-version="4.3.1"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker [beacon-version="4.3.1"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker[beacon-version="4.3.1"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker [beacon-version="4.3.1"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker[beacon-version="4.3.1"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker [beacon-version="4.3.1"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker[beacon-version="4.3.1"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker [beacon-version="4.3.1"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker[beacon-version="4.3.1"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker [beacon-version="4.3.1"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker[beacon-version="4.3.1"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker [beacon-version="4.3.1"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker[beacon-version="4.3.1"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] .beacon-on-darker [beacon-version="4.3.1"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] .beacon-on-darker[beacon-version="4.3.1"][beacon-tag-name=beacon-social-link]{--social-link-facebook-color-fill-inside: none;--social-link-facebook-color-fill-outside: #fff;--social-link-instagram-color-fill: #fff;--social-link-linkedin-color-fill: #fff;--social-link-twitter-color-fill: #fff;--social-link-x-color-fill: #fff;--social-link-youtube-color-fill-inside: #253746;--social-link-youtube-color-fill-outside: #fff}`, DP = ve`:host{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100);align-items:center;display:flex;gap:var(--social-link-flex-gap)}.icon-slot{--icon-container-size: var(--social-link-icon-container-size);block-size:var(--icon-container-size);display:flex;inline-size:var(--icon-container-size)}.icon-slot svg{--icon-size: var(--beacon-reference-space-5);block-size:var(--icon-size);inline-size:var(--icon-size);margin:auto}`;
var IP = Object.defineProperty, BP = Object.getOwnPropertyDescriptor, Lc = (i, t, e, a) => {
  for (var o = a > 1 ? void 0 : a ? BP(t, e) : t, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = (a ? r(t, e, o) : r(o)) || o);
  return a && o && IP(t, e, o), o;
};
const jb = class jb extends Le {
  constructor() {
    super(...arguments), this.beaconTagName = zd.beaconTagName, this.componentModeStyles = [zP], this.icon = pe``;
  }
  static get styles() {
    return [super.styles, DP];
  }
  static get lightDOMStyles() {
    return [...super.lightDOMStyles, OP, PP];
  }
  /** The textContent of the first element in the title nodes. */
  get nameElementText() {
    var e;
    if (this.nameNodes.length < 1)
      return console.warn("No text found in the default slot."), "";
    const t = Array.from(this.nameNodes).find(
      (a) => a.nodeName === "A"
    );
    return (e = t == null ? void 0 : t.textContent) != null ? e : "";
  }
  /**
   * Renders the appropriate icon based on the text passed into the name slot.
   *
   * If the name can't be matched, no icon is rendered.
   */
  renderIcon() {
    const t = this.nameElementText.toLowerCase(), e = zd.iconMap.get(t);
    this.icon = e || pe``;
  }
  postrenderMethods() {
    this.renderIcon(), this.renderComponentModeStyles();
  }
  render() {
    return pe` <div class="icon-slot">
        <slot name="icon">${this.icon}</slot>
      </div>
      <div class="name">
        <slot></slot>
      </div>`;
  }
};
jb.tagName = zd.beaconTagName;
let sr = jb;
Lc([
  Se()
], sr.prototype, "icon", 2);
Lc([
  wt()
], sr.prototype, "nameNodes", 2);
Lc([
  Ge(".icon-slot")
], sr.prototype, "iconSlot", 2);
Lc([
  De
], sr.prototype, "postrenderMethods", 1);
const RP = ve`:root[beacon-tag-name=beacon-social-link-container],:root [beacon-tag-name=beacon-social-link-container],[beacon-version="4.3.1"][class*=beacon-on][beacon-tag-name=beacon-social-link-container],[beacon-version="4.3.1"][class*=beacon-on] [beacon-tag-name=beacon-social-link-container],[class*=beacon-on] [beacon-version="4.3.1"][beacon-tag-name=beacon-social-link-container],[class*=beacon-on] [beacon-version="4.3.1"] [beacon-tag-name=beacon-social-link-container],[beacon-version="4.3.1"][beacon-tag-name=beacon-social-link-container],[beacon-version="4.3.1"] [beacon-tag-name=beacon-social-link-container]{--social-link-container-flex-gap: var(--beacon-reference-space-2);--social-link-container-links-gap: var(--beacon-reference-space-2)}@media (width >= 960px){:root[beacon-tag-name=beacon-social-link-container],:root [beacon-tag-name=beacon-social-link-container],[beacon-version="4.3.1"][class*=beacon-on][beacon-tag-name=beacon-social-link-container],[beacon-version="4.3.1"][class*=beacon-on] [beacon-tag-name=beacon-social-link-container],[class*=beacon-on] [beacon-version="4.3.1"][beacon-tag-name=beacon-social-link-container],[class*=beacon-on] [beacon-version="4.3.1"] [beacon-tag-name=beacon-social-link-container],[beacon-version="4.3.1"][beacon-tag-name=beacon-social-link-container],[beacon-version="4.3.1"] [beacon-tag-name=beacon-social-link-container]{--social-link-container-flex-gap: var(--beacon-reference-space-6);--social-link-container-links-gap: var(--beacon-reference-space-7)}}`, Rg = {
  beaconTagName: "beacon-social-link-container"
}, NP = ve`:host,.links,.links ::slotted(ul){display:flex;flex-direction:var(--container-flex-direction, column);gap:var(--container-flex-gap)}:host{--container-flex-gap: var(--social-link-container-flex-gap)}.links{--container-flex-gap: var(--social-link-container-links-gap)}::slotted(*){margin:0}.text ::slotted([slot=text]){font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-50)!important;margin-block:var(--social-link-container-text-margin-block-start, 0) var(--social-link-container-text-margin-block-end, 0)!important;padding-block:var(--beacon-system-space-cell-free-floating)!important}@media (width >= 960px){:host,.links{--container-flex-direction: row;align-items:center}}`, $b = class $b extends Le {
  constructor() {
    super(...arguments), this.beaconTagName = Rg.beaconTagName;
  }
  static get styles() {
    return [super.styles, NP];
  }
  static get lightDOMStyles() {
    return [super.lightDOMStyles, RP];
  }
  render() {
    return pe`<div class="text">
        <slot name="text"></slot>
      </div>
      <div class="links">
        <slot @slotchange=${Is()}></slot>
      </div>`;
  }
};
$b.tagName = Rg.beaconTagName;
let Ng = $b;
var Ya = /* @__PURE__ */ ((i) => (i.STANDARD = "standard", i.INLINE_ICON = "inline-icon", i.STACKED_ICON = "stacked-icon", i))(Ya || {}), bo = /* @__PURE__ */ ((i) => (i.PRIMARY = "primary", i.SECONDARY = "secondary", i.TERTIARY = "tertiary", i.PAGINATION = "pagination", i.ZONED = "zoned", i))(bo || {});
const Fg = {
  TAB_PLACEHOLDER_SMALL: pe`<svg
    width="32"
    height="32"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="presentation">
    <rect x="0.25" y="0.25" width="15.5" height="15.5" fill="#A2E0EE" />
    <g clip-path="url(#clip0_28935_46687)">
      <rect width="16" height="16" fill="#8B57D9" fill-opacity="0.04" />
      <rect
        x="0.25"
        y="0.25"
        width="15.5"
        height="15.5"
        stroke="#8B57D9"
        stroke-opacity="0.5"
        stroke-width="0.5" />
      <rect
        opacity="0.5"
        width="16"
        height="16"
        rx="8"
        stroke="#8B57D9"
        stroke-width="0.5" />
      <rect
        opacity="0.5"
        x="4"
        y="4"
        width="8"
        height="8"
        stroke="#8B57D9"
        stroke-width="0.5" />
    </g>
    <rect
      x="0.25"
      y="0.25"
      width="15.5"
      height="15.5"
      stroke="#05C3DE"
      stroke-width="0.5"
      stroke-dasharray="2.4 2.4" />
    <defs>
      <clipPath id="clip0_28935_46687">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>`,
  TAB_PLACEHOLDER_LARGE: pe`<svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="presentation">
    <rect x="0.25" y="0.25" width="31.5" height="31.5" fill="#A2E0EE" />
    <g clip-path="url(#clip0_28935_21638)">
      <rect width="32" height="32" fill="#8B57D9" fill-opacity="0.04" />
      <rect
        x="0.25"
        y="0.25"
        width="31.5"
        height="31.5"
        stroke="#8B57D9"
        stroke-opacity="0.5"
        stroke-width="0.5" />
      <rect
        opacity="0.5"
        width="32"
        height="32"
        rx="16"
        stroke="#8B57D9"
        stroke-width="0.5" />
      <rect
        opacity="0.5"
        x="8"
        y="8"
        width="16"
        height="16"
        stroke="#8B57D9"
        stroke-width="0.5" />
    </g>
    <rect
      x="0.25"
      y="0.25"
      width="31.5"
      height="31.5"
      stroke="#05C3DE"
      stroke-width="0.5"
      stroke-dasharray="2.4 2.4" />
    <defs>
      <clipPath id="clip0_28935_21638">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>`
}, Qa = {
  beaconTagName: "beacon-tab",
  dataMetricsType: { TAB: "TAB" },
  dataMetricsClickable: !0,
  dataMetricsLocation: { PU: "PU" }
}, FP = ve`:host{--tab-background-color: var(--beacon-system-color-background-primary);display:flex}:host .tab{--direction: row;--icon-size: var(--beacon-reference-space-5);--justified: center;--slot-display: none;--tab-block-size: var(--tabs-tab-size-block-size-default);--tab-font-color: var(--beacon-system-color-text-primary);--text-decoration: initial;--wrapping: var(--tabs-overflow-wrapping, initial);align-items:center;background-color:var(--tab-background-color);border:0;cursor:pointer;display:flex;flex-direction:var(--direction);gap:var(--beacon-reference-space-2);inline-size:inherit;justify-content:var(--justified);max-inline-size:var(--tabs-tab-size-max-inline-size);min-block-size:var(--tab-block-size);min-inline-size:var(--tabs-tab-size-min-inline-size);padding-block:var(--tab-padding);padding-inline:var(--tab-padding);font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-300)}:host .tab span,:host .tab ::slotted(*){color:var(--tab-font-color);display:block;margin-block:var(--tabs-tab-title-space-margin-block-start) var(--tabs-tab-title-space-margin-block-end);margin-inline:var(--tabs-tab-title-space-margin-inline);text-decoration:var(--text-decoration);white-space:var(--wrapping)}:host .tab [name=tab-icon]{align-items:center;block-size:var(--icon-size);box-sizing:border-box;display:var(--slot-display);inline-size:var(--icon-size);justify-content:center;margin-block:var(--tabs-tab-icon-space-margin-block);margin-inline-start:var(--tabs-tab-icon-space-margin-inline-start)}:host .tab.primary:active{--tab-background-color: var(--beacon-system-color-background-primary-pressed)}:host .tab:hover{--text-decoration: underline;--tab-background-color: var(--beacon-system-color-background-primary-hover)}:host .tab:is(.stacked-icon,.inline-icon){--justified: initial;--slot-display: flex;--tab-block-size: var(--tabs-tab-size-block-size-with-icon);--wrapping: var(--tabs-overflow-wrapping, nowrap)}:host .tab.stacked-icon{--direction: column;--icon-size: var(--beacon-reference-space-9)}:host .tab.inline-icon{--direction: var(--tabs-tab-flex-direction)}:host .tab:is(.secondary,.tertiary){--tab-font-color: var(--beacon-system-color-text-link);inline-size:revert;min-block-size:revert;padding-block:calc(var(--beacon-system-space-cell-contained) + var(--beacon-system-space-cell-free-floating));padding-inline:0}:host .tab:is(.secondary,.tertiary) span{margin:0}:host .tab:is(.primary,.secondary,.tertiary):active{--text-decoration: none}:host :host([more]) [name=tab-icon]{background-color:initial;border-color:initial;border-style:initial;border-width:initial}:host .tab.selected,:host .tab.selected:is(.secondary,.tertiary){--tab-background-color: var(--beacon-system-color-background-0);--tab-font-color: unset;font-weight:var(--beacon-system-font-weight-bold)}:host .tab.standard{--wrapping: var(--tabs-overflow-wrapping, nowrap)}:host .tab.secondary{background-color:transparent;block-size:var(--tabs-size-block-size-secondary)}:host .tab.tertiary{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-300);background-color:transparent;block-size:var(--tabs-tab-size-block-size-tertiary);padding-block:var(--beacon-system-space-cell-free-floating) var(--beacon-system-space-cell-free-floating)}:host .tab.selected:is(.secondary,.tertiary){border-block-end:var(--beacon-system-width-border-normal, 2px) solid var(--beacon-system-color-border-brand)}:host .tab.secondary.inline-icon{--direction: row;--icon-size: var(--beacon-reference-space-5);padding-block:var(--tab-space-secondary-padding-block) var(--tab-space-secondary-padding-block)}:host .tab.secondary.inline-icon span,:host .tab.secondary.inline-icon ::slotted(*){align-self:var(--tab-span-align-self);margin-block-start:var(--tabs-tab-title-space-secondary-margin-block-start);margin-inline-start:var(--tabs-tab-title-space-secondary-margin-inline-start)}:host .tab.secondary.inline-icon [name=tab-icon]{align-self:var(--tab-icon-align-self);margin-block:0;margin-inline-start:0}:host(:focus-visible){outline:none}:host(:focus-visible) .tab:is(.secondary,.tertiary),:host(:focus-visible) .tab:is(.secondary,.tertiary).selected{--tab-font-color: var(--beacon-system-color-text-set-navy);background-color:var(--beacon-system-color-background-link-focus)!important;border-block-end-color:unset;box-shadow:0 var(--beacon-system-width-border-jumbo) 0 0 var(--beacon-system-color-border-link-focus);color:var(--beacon-system-color-text-set-navy)!important;outline:none;text-decoration:none}@media (forced-colors: active){:host(:focus-visible) .tab:is(.secondary,.tertiary),:host(:focus-visible) .tab:is(.secondary,.tertiary).selected{border-block-end:var(--beacon-system-width-border-jumbo) solid var(--beacon-system-color-border-link-focus)}}:host(:focus-visible) .tab.primary{--inset-middle-border-width: calc(var(--beacon-system-width-border-maxi) - var(--beacon-system-width-border-normal));box-shadow:inset 0 0 0 var(--beacon-system-width-border-jumbo) var(--beacon-system-color-border-focus-outer),inset 0 0 0 var(--inset-middle-border-width) var(--beacon-system-color-border-focus-middle);outline:var(--beacon-system-width-border-normal) solid var(--beacon-system-color-border-focus-inner);outline-offset:calc(var(--beacon-system-width-border-maxi) * -1)}@media (width >= 640px){:host .tab.inline-icon{--justified: center;--direction: row;--slot-display: flex;--tab-block-size: var(--tabs-tab-size-block-size-default)}}`;
var _P = Object.defineProperty, UP = Object.getOwnPropertyDescriptor, Eo = (i, t, e, a) => {
  for (var o = a > 1 ? void 0 : a ? UP(t, e) : t, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = (a ? r(t, e, o) : r(o)) || o);
  return a && o && _P(t, e, o), o;
};
const oc = class oc extends Le {
  constructor() {
    super(...arguments), this.beaconTagName = Qa.beaconTagName, this.deferrable = !1, this.focusOverride = !0, this.variant = bo.PRIMARY, this.tabType = Ya.STANDARD, this.ariaSelected = "false", this.more = !1, this.ariaControls = "tabpanel-0", this.getFallbackIcon = () => this.tabType === Ya.INLINE_ICON ? Fg.TAB_PLACEHOLDER_SMALL : this.tabType === Ya.STACKED_ICON ? Fg.TAB_PLACEHOLDER_LARGE : _e, this.getTabTypeClass = () => this.variant === bo.PRIMARY ? this.tabType : this.variant === bo.SECONDARY && this.tabType !== Ya.STANDARD ? Ya.INLINE_ICON : Ya.STANDARD;
  }
  static get styles() {
    return [super.styles, FP];
  }
  /**
   * Emits the click event when using the keyboard to navigate the tabs.
   * @param event Keyboard Event
   */
  handleKeydown(t) {
    ["Enter", " "].includes(t.key) && (this.emitClick(), t.preventDefault());
  }
  /**
   * Sets the tabindex property dependent on the this.ariaSelected property
   * @param changedProperties an Inherited Map of properties that have changed since the last update.
   */
  willUpdate(t) {
    t && t.has("ariaSelected") && (this.tabIndex = this.ariaSelected === "true" ? 0 : -1);
  }
  addIconAnalytics() {
    this.TabIcons.forEach((t) => {
      t.setAttribute(
        go.TYPE,
        Qa.dataMetricsType.TAB
      ), t.setAttribute(
        go.CLICKABLE,
        `${Qa.dataMetricsClickable}`
      ), t.setAttribute(go.TEXT, this.label);
    });
  }
  addStyles() {
    this.setAttribute("role", "tab"), this.more && (this.removeAttribute("aria-controls"), this.setAttribute("aria-haspopup", "dialog"));
  }
  addEventListeners() {
    this.addEventListener("click", this.emitClick), this.addEventListener("keydown", this.handleKeydown);
  }
  /**
   * Tabs don't use button elements due to Axe Core rule for aria required children.
   * The tabs themselves need the `role` of "tab", not interior elements.
   * Otherwise, the tablist container doesn't know where tabs are since we are using Shadow DOM.
   *
   * It isn't enough to remove the role from the button element because that causes a separate a11y error
   * of having interactive elements contained inside interactive elements
   * (buttons inside an element with role of tab). We use `div`s with a `tabindex` or 0 to allow focus,
   * and listen for keydown events to select tabs on Enter or Spacebar.
   *
   * @link https://dequeuniversity.com/rules/axe/4.6/aria-required-children?application=axeAPI
   */
  render() {
    return pe`<div
      class="tab ${this.variant} ${this.getTabTypeClass()} ${this.ariaSelected === "true" ? "selected" : ""}"
      data-metrics-type="${Qa.dataMetricsType.TAB}"
      data-metrics-clickable="${Qa.dataMetricsClickable}">
      <slot name="tab-icon" @slotchange=${this.addIconAnalytics}
        >${this.getFallbackIcon()}</slot
      >
      <span>${this.label}</span>
    </div>`;
  }
};
oc.shadowRootOptions = {
  ...Le.shadowRootOptions,
  delegatesFocus: !1
}, oc.tagName = Qa.beaconTagName;
let Dt = oc;
Eo([
  ue({ reflect: !0 })
], Dt.prototype, "variant", 2);
Eo([
  ue({ reflect: !0, attribute: "tab-type" })
], Dt.prototype, "tabType", 2);
Eo([
  ue({ type: String })
], Dt.prototype, "label", 2);
Eo([
  ue({ reflect: !0 })
], Dt.prototype, "value", 2);
Eo([
  ue({ reflect: !0, attribute: "aria-selected" })
], Dt.prototype, "ariaSelected", 2);
Eo([
  ue({ type: Boolean })
], Dt.prototype, "more", 2);
Eo([
  ue({ reflect: !0, attribute: "aria-controls" })
], Dt.prototype, "ariaControls", 2);
Eo([
  Pe({ slot: "tab-icon", selector: "svg" })
], Dt.prototype, "TabIcons", 2);
Eo([
  Ge(".tab")
], Dt.prototype, "tab", 2);
Eo([
  De
], Dt.prototype, "addIconAnalytics", 1);
Eo([
  De
], Dt.prototype, "addStyles", 1);
Eo([
  De
], Dt.prototype, "addEventListeners", 1);
const _g = {
  beaconTagName: "beacon-tab-panel"
}, jP = ve`:host([aria-hidden=true]){display:none}:host(:focus-visible){box-shadow:0 0 0 var(--beacon-system-width-border-jumbo) var(--beacon-system-color-border-focus-middle),0 0 0 var(--beacon-system-width-border-maxi) var(--beacon-system-color-border-focus-outer);outline:var(--beacon-system-width-border-normal) solid var(--beacon-system-color-border-focus-inner);outline-offset:0;z-index:1}:host(:focus-visible):not(dialog){position:relative}`;
var $P = Object.defineProperty, Oc = (i, t, e, a) => {
  for (var o = void 0, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = r(t, e, o) || o);
  return o && $P(t, e, o), o;
};
const ac = class ac extends Le {
  constructor() {
    super(...arguments), this.beaconTagName = _g.beaconTagName, this.ariaHidden = "true", this.role = "tabpanel", this.tabIndex = -1;
  }
  static get styles() {
    return [super.styles, jP];
  }
  /**
   * Sets tabindex based on ariaHidden property
   * @param changedProperties an Inherited Map of properties that have changed since the last update.
   */
  willUpdate(t) {
    t && t.has("ariaHidden") && (this.tabIndex = this.ariaHidden === "true" ? -1 : 0);
  }
  render() {
    return pe`<slot></slot>`;
  }
};
ac.shadowRootOptions = {
  ...Le.shadowRootOptions,
  delegatesFocus: !1
}, ac.tagName = _g.beaconTagName;
let lr = ac;
Oc([
  ue({ reflect: !0 })
], lr.prototype, "value");
Oc([
  ue({ reflect: !0, attribute: "aria-hidden" })
], lr.prototype, "ariaHidden");
Oc([
  ue({ reflect: !0 })
], lr.prototype, "role");
Oc([
  ue({ reflect: !0, attribute: "tabindex" })
], lr.prototype, "tabIndex");
var Rn = /* @__PURE__ */ ((i) => (i[i.DEFAULT = 4] = "DEFAULT", i[i.MEDIUM = 5] = "MEDIUM", i[i.LARGE = 7] = "LARGE", i[i.XLARGE = 7] = "XLARGE", i))(Rn || {});
const HP = ve`:root[beacon-tag-name=beacon-tabs],:root [beacon-tag-name=beacon-tabs],[beacon-version="4.3.1"][class*=beacon-on][beacon-tag-name=beacon-tabs],[beacon-version="4.3.1"][class*=beacon-on] [beacon-tag-name=beacon-tabs],[class*=beacon-on] [beacon-version="4.3.1"][beacon-tag-name=beacon-tabs],[class*=beacon-on] [beacon-version="4.3.1"] [beacon-tag-name=beacon-tabs],[beacon-version="4.3.1"][beacon-tag-name=beacon-tabs],[beacon-version="4.3.1"] [beacon-tag-name=beacon-tabs]{--caption-300-line-height: var(--beacon-reference-space-5);--tabs-size-block-size-secondary: calc(var(--beacon-system-space-cell-contained) + var(--beacon-system-space-cell-free-floating) + var(--caption-300-line-height) + var(--beacon-system-width-border-normal));--tabs-tab-size-block-size-tertiary: var(--beacon-reference-space-8);--tabs-menu-item-space-padding: calc(var(--beacon-system-space-cell-contained) + var(--beacon-system-space-cell-free-floating));--tabs-menu-item-space-margin-block-start: var(--beacon-reference-space-5);--tabs-menu-max-block-size: 100%;--tabs-menu-max-inline-size: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 6 + var(--beacon-system-space-gutter) * 5);--tabs-menu-item-block-size: var(--beacon-reference-space-12);--tabs-tab-title-space-margin-block-end: 0;--tabs-tab-title-space-margin-block-start: 0;--tabs-tab-title-space-margin-inline: 0;--tabs-tab-icon-space-margin-block: 0;--tabs-tab-icon-space-margin-inline-start: 0;--tabs-tab-title-space-secondary-margin-block-start: 0;--tabs-tab-title-space-secondary-margin-inline-start: 0;--tabs-tab-size-block-size-default: var(--beacon-reference-space-11);--tabs-tab-size-block-size-with-icon: var(--beacon-reference-space-14);--tabs-menu-item-space-padding-block-start: 0;--tab-padding: calc(2 * var(--beacon-system-space-cell-contained));--tab-space-secondary-padding-block: calc(var(--beacon-system-space-cell-contained) + var(--beacon-system-space-cell-free-floating));--tab-icon-align-self: center;--tab-span-align-self: center;--tabs-tab-size-min-inline-size: fit-content;--tabs-tab-size-max-inline-size: unset;--tabs-tab-flex-direction: row}@media (width >= 640px){:root[beacon-tag-name=beacon-tabs],:root [beacon-tag-name=beacon-tabs],[beacon-version="4.3.1"][class*=beacon-on][beacon-tag-name=beacon-tabs],[beacon-version="4.3.1"][class*=beacon-on] [beacon-tag-name=beacon-tabs],[class*=beacon-on] [beacon-version="4.3.1"][beacon-tag-name=beacon-tabs],[class*=beacon-on] [beacon-version="4.3.1"] [beacon-tag-name=beacon-tabs],[beacon-version="4.3.1"][beacon-tag-name=beacon-tabs],[beacon-version="4.3.1"] [beacon-tag-name=beacon-tabs]{--caption-300-line-height: var(--beacon-reference-space-6);--tabs-tab-size-block-size-default: 3.25rem;--tabs-menu-item-space-margin-block-start: 0;--tabs-menu-max-block-size: calc(var(--tabs-menu-item-block-size) * 9 + var(--beacon-reference-space-10) + 40px);--tabs-menu-max-inline-size: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 10 + var(--beacon-system-space-gutter) * 9);--tabs-menu-item-block-size: 3.75rem;--tabs-tab-size-block-size-tertiary: var(--beacon-reference-space-9)}}@media (width >= 960px){:root[beacon-tag-name=beacon-tabs],:root [beacon-tag-name=beacon-tabs],[beacon-version="4.3.1"][class*=beacon-on][beacon-tag-name=beacon-tabs],[beacon-version="4.3.1"][class*=beacon-on] [beacon-tag-name=beacon-tabs],[class*=beacon-on] [beacon-version="4.3.1"][beacon-tag-name=beacon-tabs],[class*=beacon-on] [beacon-version="4.3.1"] [beacon-tag-name=beacon-tabs],[beacon-version="4.3.1"][beacon-tag-name=beacon-tabs],[beacon-version="4.3.1"] [beacon-tag-name=beacon-tabs]{--caption-300-line-height: var(--beacon-reference-space-7);--tabs-menu-max-inline-size: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 8 + var(--beacon-system-space-gutter) * 7)}}@media (width >= 1280px){:root[beacon-tag-name=beacon-tabs],:root [beacon-tag-name=beacon-tabs],[beacon-version="4.3.1"][class*=beacon-on][beacon-tag-name=beacon-tabs],[beacon-version="4.3.1"][class*=beacon-on] [beacon-tag-name=beacon-tabs],[class*=beacon-on] [beacon-version="4.3.1"][beacon-tag-name=beacon-tabs],[class*=beacon-on] [beacon-version="4.3.1"] [beacon-tag-name=beacon-tabs],[beacon-version="4.3.1"][beacon-tag-name=beacon-tabs],[beacon-version="4.3.1"] [beacon-tag-name=beacon-tabs]{--tabs-tab-size-block-size-tertiary: var(--beacon-reference-space-10);--tabs-tab-size-block-size-with-icon: calc(19 * var(--beacon-reference-space-2));--tabs-menu-max-inline-size: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 10 + var(--beacon-system-space-gutter) * 9);--tabs-menu-item-block-size: var(--beacon-reference-space-13)}}`;
function KP(i) {
  return i <= Zt.DEFAULT ? Rn.DEFAULT : i <= Zt.MEDIUM ? Rn.MEDIUM : i <= Zt.LARGE ? Rn.LARGE : Rn.XLARGE;
}
function GP(i, t) {
  const { scrollTop: e } = i, a = 0, o = "scrolled-close-button-row", n = t.classList.contains(o);
  e !== a && t.classList.add(o), e === a && n && t.classList.remove(o);
}
function WP(i) {
  return {
    firstVisibleTabIndex: 0,
    lastVisibleTabIndex: i - 1
  };
}
function qP(i, t, e, a) {
  const o = t - 1, n = e - 1, r = a ? 1 : 0, T = {
    firstVisibleTabIndex: 0,
    lastVisibleTabIndex: o - r
  };
  return e < t && (T.lastVisibleTabIndex = n), i >= t && (T.firstVisibleTabIndex = i - o, T.lastVisibleTabIndex = i - r), T;
}
function Ug(i, t, e, a, o) {
  return o ? WP(e) : qP(
    i,
    t,
    e,
    a
  );
}
const VP = ve`[beacon-tag-name=beacon-tabs] [beacon-tag-name=beacon-tab]{inline-size:100%}[beacon-tag-name=beacon-tabs] [beacon-tag-name=beacon-tab][variant=secondary],[beacon-tag-name=beacon-tabs] [beacon-tag-name=beacon-tab][variant=tertiary]{inline-size:fit-content;margin-inline-end:var(--beacon-system-space-micro-maxi)}[beacon-tag-name=beacon-tabs] [beacon-tag-name=beacon-tab][variant=secondary]:last-of-type,[beacon-tag-name=beacon-tabs] [beacon-tag-name=beacon-tab][variant=tertiary]:last-of-type{margin-inline-end:0}`, YP = ve`:host{margin:auto;max-inline-size:var(--beacon-system-breakpoint-xxx-large)}[beacon-tag-name=beacon-tab]{inline-size:100%}.tablist,.menu-tablist{display:flex;inline-size:100%}.tablist{-webkit-hyphens:auto;hyphens:auto;max-inline-size:100vw;overflow-wrap:anywhere}.menu-tablist{flex-direction:column;overflow:auto;padding-block-start:var(--beacon-system-space-cell-contained)}:host([tab-type=stacked-icon][scrollable]),:host([tab-type=inline-icon][scrollable]){--tab-width-non-scrollable: 100%}:host([tab-type=stacked-icon][scrollable]) .tablist,:host([tab-type=inline-icon][scrollable]) .tablist{inline-size:max-content}:host([tab-type=inline-icon][scrollable][variant=secondary]) .tablist{inline-size:100%}:host([variant=secondary]) .container{block-size:var(--tabs-size-block-size-secondary);border-block-end:var(--beacon-system-width-border-normal, 2px) solid var(--beacon-system-color-border-0);margin-block:var(--beacon-system-space-micro-maxi)}:host([variant=tertiary]) .container{block-size:var(--tabs-tab-size-block-size-tertiary);margin-block:var(--beacon-system-space-micro-maxi)}:host([variant=secondary]) .tablist:focus-within,:host([variant=tertiary]) .tablist:focus-within{block-size:calc(100% + var(--total-ring-width))}:host([variant=secondary][scrolled]) .container,:host([variant=tertiary][scrolled]) .container{inline-size:100vw;inset-inline-start:0;position:absolute}:host([variant=secondary][scrolled]) .spacer{block-size:calc(var(--beacon-reference-space-5) + var(--tabs-size-block-size-secondary))}:host([variant=tertiary][scrolled]) .spacer{block-size:calc(var(--beacon-reference-space-5) + var(--tabs-tab-size-block-size-tertiary))}:host([scrollable]){--scrollbar-visible: hidden;--scrollbar-hover-visible: hidden}:host([scrollable]) ::-webkit-scrollbar{inline-size:calc(.875 * var(--beacon-reference-space-5))}:host([scrollable]) ::-webkit-scrollbar-thumb{background:var(--beacon-component-scrollbar-color-background-thumb);background-clip:content-box;border:var(--beacon-reference-space-2) solid transparent;border-radius:calc(.875 * var(--beacon-reference-space-5))}:host([scrollable]) ::-webkit-scrollbar{display:none}:host([scrollable]) .tablist{overflow-x:auto}:host([scrollable]) .tablist:hover{--scrollbar-visible: var(--scrollbar-hover-visible)}:host([scrollable]) ::-webkit-scrollbar-thumb{visibility:var(--scrollbar-visible)}:host(:not([scrollable])) dialog{--override-icon-button-bg-color: var(--beacon-system-color-background-primary);--override-icon-button-bg-color-hover: rgb(7 96 141 / 100%);--override-icon-button-bg-color-pressed: rgb(6 83 121 / 100%)}:host([overflowing-x=true]:not([scrollable])){--tabs-overflow-wrapping: normal}:host([tab-type=stacked-icon]:not([scrollable])){--tab-width-non-scrollable: 100%}.overlay{--close-button-padding-block: var(--beacon-reference-space-3) 0;align-items:center;background-color:#002f48a3;display:flex;flex-direction:column;inline-size:100%;top:0;right:0;bottom:0;left:0;justify-content:center;position:fixed}.overlay ::-webkit-scrollbar{inline-size:calc(.875 * var(--beacon-reference-space-5))}.overlay ::-webkit-scrollbar-thumb{background:var(--beacon-component-scrollbar-color-background-thumb);background-clip:content-box;border:var(--beacon-reference-space-2) solid transparent;border-radius:calc(.875 * var(--beacon-reference-space-5))}.overlay dialog{align-items:center;background-color:var(--beacon-system-color-background-primary);block-size:100dvh;border:0;box-shadow:0 2px 4px -2px rgba(var(--beacon-system-color-shadow-high),.8);box-sizing:border-box;display:flex;flex-direction:column;inline-size:var(--tabs-menu-max-inline-size);max-block-size:var(--tabs-menu-max-block-size);padding:0}.overlay dialog h2{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-200);color:var(--beacon-reference-palette-grayscale-white);display:flex;margin:0}.overlay dialog .scrolled-close-button-row{--close-button-padding-block: var(--beacon-reference-space-3);box-shadow:0 2px 4px -2px rgba(var(--beacon-system-color-shadow-high),.8)}.close-button-row{background-color:var(--beacon-system-color-background-primary);display:flex;flex-direction:row-reverse;inline-size:100%;inset-block-start:0;padding:var(--beacon-reference-space-3);position:sticky}.close-button-row [beacon-tag-name=beacon-icon-button]{padding-block:var(--close-button-padding-block);padding-inline-end:var(--beacon-reference-space-3)}.menu-item{--menu-item-underline: initial;align-items:center;background-color:var(--beacon-system-color-background-primary);border:0;box-sizing:border-box;color:var(--beacon-system-color-text-primary);cursor:default;display:flex;inline-size:100%;justify-content:center;min-block-size:var(--tabs-menu-item-block-size);padding:var(--tabs-menu-item-space-padding)}.menu-item[aria-selected=true]{background-color:var(--beacon-component-tab-menu-color-background-primary-active)}.menu-item[aria-selected=true] span{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-body-200)}.menu-item span{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-200);padding-block-start:var(--tabs-menu-item-space-padding-block-start);text-decoration:var(--menu-item-underline)}.menu-item:focus-visible{box-shadow:0 0 0 var(--beacon-system-width-border-jumbo) var(--beacon-system-color-border-focus-middle),0 0 0 var(--beacon-system-width-border-maxi) var(--beacon-system-color-border-focus-outer);outline:var(--beacon-system-width-border-normal) solid var(--beacon-system-color-border-focus-inner);outline-offset:0;z-index:1;align-self:center;inline-size:calc(100% - var(--total-ring-width))}.menu-item:focus-visible:not(dialog){position:relative}.menu-item--btn{cursor:pointer}.menu-item:hover{--menu-item-underline: underline}.menu-item:first-of-type{margin-block-start:var(--tabs-menu-item-space-margin-block-start)}.menu-item:last-of-type{margin-block-end:var(--beacon-system-space-organism-jumbo)}.hide,::slotted(.hide){display:none}@media (width >= 320px){:host([tab-type=inline-icon]){--tab-width-non-scrollable: 100%}:host([tab-type=inline-icon]) .tablist{inline-size:100%}}@media (width >= 640px){:host([scrollable]) ::-webkit-scrollbar{display:block}:host([scrollable][variant=primary]){--scrollbar-hover-visible: visible}.overlay dialog{block-size:unset;max-block-size:100dvh}}`;
var QP = Object.defineProperty, XP = Object.getOwnPropertyDescriptor, dt = (i, t, e, a) => {
  for (var o = a > 1 ? void 0 : a ? XP(t, e) : t, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = (a ? r(t, e, o) : r(o)) || o);
  return a && o && QP(t, e, o), o;
};
const jg = "beacon-tabs", Pi = "hide", ZP = "1", JP = "", e3 = "tabChildren", t3 = "currentMaxTabs", o3 = "scrollable", a3 = "tabType", i3 = "variant", n3 = "DIALOG", r3 = "tab-list", s3 = 320;
var Gi, Mt;
const rt = (Mt = class extends Ke(Le).with($h) {
  constructor() {
    super(...arguments);
    Fe(this, Gi);
    this.beaconTagName = jg, this.focusOverride = !0, this.currentTotalTabs = 0, this.currentMaxTabs = Rn.XLARGE, this.scrollable = !1, this.scrolled = !1, this.closeOnClickOut = !0, this.variant = bo.PRIMARY, this.tabType = Ya.STACKED_ICON, this.menuTitle = "Choose a view:", Ne(this, Gi, ""), this.menuOpen = !1, this.markedAsOverflowingX = !1, this.markedAsMenuOverFlowingY = !1, this.id = Ia(), this.tabsResizeObserver = new ResizeObserver((e) => {
      var O, j;
      let a, o;
      const n = e.find(
        (D) => D
      ), { borderBoxSize: r, contentRect: T } = n;
      if (r && (o = Array.isArray(r) ? r[0] : r), ((O = n == null ? void 0 : n.target) == null ? void 0 : O.tagName) === n3 && this.menuOpen && !this.markedAsMenuOverFlowingY) {
        const D = Math.ceil(o.blockSize || T.height), F = n.target.scrollHeight;
        this.observeHeight(D, F);
      } else (n == null ? void 0 : n.target.id) === r3 ? (a = Math.ceil(o.inlineSize || T.width), this.observePrimaryTabsWidth(a)) : (a = Math.ceil((j = o.inlineSize || (T == null ? void 0 : T.width)) != null ? j : 0), this.observeBodyWidth(a));
    }), this.toggleTabListScrollClass = () => {
      const { scrollLeft: e } = this.tabListElement;
      e === 0 ? this.scrolled = !1 : this.scrolled = !0;
    }, this.buildTabMenuItem = (e) => pe`<button
      role="tab"
      data-metrics-type="${Qa.dataMetricsType.TAB}"
      value="${e.value}"
      class="menu-item menu-item--btn"
      aria-selected="${e.ariaSelected}"
      @click=${this.handleMenuTabClick}>
      <span>${e.label}</span>
    </button>`, this.buildTabMenu = (e) => pe`${e.map((a) => this.buildTabMenuItem(a))}`, this.handleKeydown = (e) => {
      this.handleArrowControlKeydown(
        e,
        this.getArrowControlElements(),
        "horizontal",
        Mt.arrowControlFocusCallback
      );
    };
  }
  static get styles() {
    return [super.styles, YP];
  }
  static get lightDOMStyles() {
    return [...super.lightDOMStyles, HP, VP];
  }
  get selected() {
    return ze(this, Gi);
  }
  set selected(e) {
    const a = parseInt(e, 10);
    if (isNaN(a)) {
      const o = this.querySelector(
        this.getScopedTagName("beacon-tab") + `#${e}`
      );
      Ne(this, Gi, o instanceof Dt ? o.value : e);
    } else
      Ne(this, Gi, a.toString());
  }
  /**
   * Getter for a Boolean property indicating whether the more button and more menu should be rendered
   */
  get shouldShowMore() {
    return !this.scrollable && this.currentTotalTabs > this.currentMaxTabs && this.variant === bo.PRIMARY;
  }
  /**
   * Getter for the Scroll Width of the tab list, used in calculating overflow
   */
  get TabsWidth() {
    return this.tabListElement.scrollWidth;
  }
  /**
   * Observer logic to conditionally apply the overflow class
   * and update the max amount of visible tabs allowed based
   * on an input tabList width
   * @param width the width of the tablist contentRect
   */
  observePrimaryTabsWidth(e) {
    this.handleOverflowing();
    const a = KP(e);
    this.currentMaxTabs !== a && (this.currentMaxTabs = a, this.requestUpdate());
  }
  /**
   * Conditionally applies a scroll listener to the moreMenu if and only if the moreMenu is overflowing
   * for the first time
   * @param moreMenuHeight the height of the more menu currently visible on the screen
   * @param moreMenuScrollHeight the complete height of the more menu including what's vertically scrollable
   */
  observeHeight(e, a) {
    this.closeButtonRow && e < a && (this.markedAsMenuOverFlowingY = !0, this.tabMenu.addEventListener(Je.SCROLL, () => {
      GP(this.tabMenu, this.closeButtonRow);
    }));
  }
  /**
   * Checks the width of the body element. If it's at mobile breakpoint width adds scroll listener that toggles
   * full-width 'scrolled' styles for tab-list. For performance reasons, removes scroll listener when width is
   * bigger than mobile breakpoint.
   * @param width of the body element
   */
  observeBodyWidth(e) {
    e <= s3 ? (this.toggleTabListScrollClass(), this.tabListElement.addEventListener(
      Je.SCROLL,
      this.toggleTabListScrollClass
    )) : (this.tabListElement.removeEventListener(
      Je.SCROLL,
      this.toggleTabListScrollClass
    ), this.scrolled = !1);
  }
  /**
   * checks the scrollWidth of the tab list element,
   * then compares the scrollWidth to the window innerWidth
   * to determine if the tabs are overflowing.
   * Applies an overflow class to the tabs if they are overflowing.
   */
  handleOverflowing() {
    let e = !1;
    const a = Math.ceil(
      this.tabListElement.getBoundingClientRect().width
    );
    this.markedAsOverflowingX || (e = this.TabsWidth > a), e && !this.markedAsOverflowingX && (this.markedAsOverflowingX = !0);
  }
  tearDownTabs() {
    this.focusTrapObject && this.focusTrapObject.deactivate(), this.tabsResizeObserver.disconnect(), (this.variant === bo.SECONDARY || this.variant === bo.TERTIARY) && this.tabListElement.removeEventListener(
      Je.SCROLL,
      this.toggleTabListScrollClass
    );
  }
  /**
   * function attached to the more menu's close button
   * that hides the menu upon clicking.
   * @param event a user interaction generated Click event
   */
  handleClose(e) {
    e.stopPropagation(), this.hideMenu(), this.focusSelectedTab();
  }
  /**
   * sets the clicked tab to active,
   * and updates the rendering according to updateCurrentlyActiveTab
   * @param event a user interaction generated Click event
   */
  handleTabClick(e) {
    this.emitClick();
    const a = e.target;
    a.value && this.updateCurrentlyActiveTab(a.value);
  }
  /**
   * Sets the tabs selected attribute,
   * then sets the currently visible tab and tab panel
   * to match the selected attribute
   * @param selected the value attribute of a clicked tab or tab menu-item
   */
  updateCurrentlyActiveTab(e) {
    this.selected = e, this.deselectAllTabs(), this.hideAllTabPanels(), this.selectClickedTab(this.selected), this.displaySelectedTabPanel(this.selected);
  }
  /**
   * Closes the more menu and
   * Sets which tab is currently active based on the menu item clicked,
   * then shifts the visible tab range to match if the clicked tab value
   * is greater than what's currently visible.
   * @param event A user generated Click event
   */
  handleMenuTabClick(e) {
    const a = e.currentTarget;
    this.emitClick();
    const o = parseInt(a.value, 10), n = Ug(
      o,
      this.currentMaxTabs,
      this.currentTotalTabs,
      this.shouldShowMore,
      this.scrollable
    );
    this.updateCurrentlyActiveTab(a.value), Mt.showTabsInRange(n, this.tabChildren), this.hideMenu(), this.focusSelectedTab();
  }
  /**
   * Sets the arrow-control arrowControlElements array to the currently visible elements
   * and the more button at the end if needed.
   */
  getArrowControlElements() {
    return this.shouldShowMore && this.moreButton != null ? [...Mt.getVisibleTabs(this.tabChildren), this.moreButton] : Mt.getVisibleTabs(this.tabChildren);
  }
  /**
   * Closes the more menu dialog, when the user clicks outside of the dialog and
   * the closeOnClickOut parameter is true.
   * @param event a user interaction generated Click event
   */
  handleMenuClickBlur(e) {
    this.closeOnClickOut && this.menuOpen && e.target === this.tabMenuOverlay && this.hideMenu();
  }
  /**
   * Sets currently active tab of the slotted tabChildren based on the clicked tab's value
   * @param clickedValue the value attribute of a user clicked tab
   */
  selectClickedTab(e) {
    this.tabChildren.forEach((a) => {
      a.value === e && (a.ariaSelected = "true");
    });
  }
  /**
   * Sets focus to the currently selected tab after selecting the tab from the menu
   */
  focusSelectedTab() {
    this.tabChildren.forEach((e) => {
      e.ariaSelected === "true" && e.focus();
    });
  }
  /**
   * sets the active value of each slotted tab to false
   */
  deselectAllTabs() {
    this.tabChildren.forEach((e) => {
      e.ariaSelected = "false";
    });
  }
  /**
   * Removes the hide class from the tab panel with a value matching the input value attribute
   * @param clickedValue the value attribute of the tab clicked corresponding with the tab panel value
   */
  displaySelectedTabPanel(e) {
    this.tabPanels.forEach((a) => {
      a.value === e && (a.ariaHidden = "false");
    });
  }
  /**
   * Applies the hide class to each slotted tab panel
   * setting their display to none.
   */
  hideAllTabPanels() {
    this.tabPanels.forEach((e) => {
      e.ariaHidden = "true";
    });
  }
  /**
   * applies the hide css class to the overlay div
   * to hide the more menu modal.
   * Triggered by blur, the menu close button, or clicking an option
   */
  hideMenu() {
    this.tabMenuOverlay.classList.add(Pi), this.menuOpen = !1, this.focusTrapObject.deactivate(), this.tabsResizeObserver.unobserve(this.tabMenu), ls();
  }
  /**
   * remove the hide css class from the overlay div
   * to show the more menu modal.
   * Triggered by blur, or menu click
   * Focuses on first tabbable element within the more menu
   */
  showMenu() {
    var e, a;
    this.tabMenuOverlay.classList.remove(Pi), this.menuOpen = !0, this.focusTrapObject.activate(), this.tabsResizeObserver.observe(this.tabMenu), (a = (e = this.closeButton.shadowRoot) == null ? void 0 : e.querySelector("button")) == null || a.focus(), eb();
  }
  /**
   * applies the hide class setting display to none on the input tab
   * @param tab BeaconTab in the tabChildren slot to hide
   */
  static hideTab(e) {
    e.classList.add(Pi);
  }
  /**
   * removes the hide class setting display to none on the input tab
   * @param tab BeaconTab in the tabChildren slot to show
   */
  static showTab(e) {
    e.classList.remove(Pi);
  }
  /**
   * Getter for all currently slotted tabs without the .hide class applied
   * @param tabs an Array of slotted Beacon Tab components
   * @returns an array of tabs without the .hide class applied
   */
  static getVisibleTabs(e) {
    return e.filter(
      (o) => !o.classList.contains(Pi)
    );
  }
  /**
   * Hides all tabs outside of the specified range
   * and shows all tabs inside the range by applying and
   * removing the hide class to the slotted tabChildren
   * @param firstVisibleTabIndex the inclusive starting index range to show tabs
   * @param lastVisibleTabIndex the inclusive ending index range to show tabs
   * @param tabs the slotted tabChildren
   */
  static showTabsInRange({
    firstVisibleTabIndex: e,
    lastVisibleTabIndex: a
  }, o) {
    o.forEach((n, r) => {
      r < e || r > a ? Mt.hideTab(n) : Mt.showTab(n);
    });
  }
  /**
   * Applies the .hide class setting display: none on
   * each slotted tab component.
   */
  hideAllTabs() {
    this.tabChildren.forEach((e) => {
      e.classList.add(Pi);
    });
  }
  /**
   * Removes the .hide class from each slotted tab component.
   */
  showAllTabs() {
    this.tabChildren.forEach((e) => {
      e.classList.remove(Pi);
    });
  }
  /**
   * Overridden.
   * checks if the amount of slotted tabChildren changed, to update the "watching"
   * currentTotalTab attribute accordingly.
   * Also calls updateShownTabs() to re-render tabs accordingly, when the max amount
   * of visible tabs allowed changes.
   * @param changedProperties Inherited Map of properties changed during a component's update lifeCycle
   */
  async willUpdate(e) {
    e.has(e3) && (this.currentTotalTabs = this.tabChildren.length), e.has(t3) && this.updateShownTabs(), e.has(o3) && this.updateShownTabs(), e.has(a3) && this.applyTabType(this.tabChildren), e.has(i3) && this.applyTabVariant(this.tabChildren);
  }
  /**
   * Repeated update lifecyle logic to update tab visibility based on which value is currently selected.
   * Will shift the visible tab range downwards if the max tabs allowed decreases on a resize.
   */
  updateShownTabs() {
    const e = parseInt(this.selected, 10), a = Ug(
      e,
      this.currentMaxTabs,
      this.currentTotalTabs,
      this.shouldShowMore,
      this.scrollable
    );
    Mt.showTabsInRange(a, this.tabChildren);
  }
  /**
   * Applies the variant attribute from the parent to all slotted
   * tab components
   * @param tabs the slotted Tab Components from this.tabChildren
   */
  applyTabVariant(e) {
    e.forEach((a) => {
      a.variant = this.variant;
    });
  }
  /**
   * Applies the tabType attribute from the parent to all slotted
   * tab components
   * @param tabs the slotted Tab Components from this.tabChildren
   */
  applyTabType(e) {
    (this.variant === bo.PRIMARY || bo.SECONDARY) && e.forEach((a) => {
      a.tabType = this.tabType;
    });
  }
  /**
   * Iterates over the loaded tabPanels and sets their
   * value attribute to 1 + index. Necessary for tab hiding
   * and shifting logic.
   * @param tabs the loaded Array of slotted Beacon Tab components
   */
  static initializeTabValues(e) {
    e.forEach((a, o) => {
      a.value = `${o + 1}`;
    });
  }
  /**
   * Iterates over the loaded tabPanels and sets their
   * value attribute to 1 + index. Necessary for tab hiding
   * and shifting logic.
   * @param tabPanels the loaded Array of slotted Beacon Tab Panel components
   */
  static initializeTabPanelValues(e) {
    e.forEach((a, o) => {
      a.value = `${o + 1}`;
    });
  }
  /**
   * Iterates over the loaded tabPanels and prefixes their IDs with the tab component's
   * input or randomly generated Unique ID
   * @param tabPanels the loaded Array of slotted Beacon Tab Panel components
   * @param uniqueID the Tab Component's input ID or randomly generated fallback ID.
   */
  static initializeTabPanelIDs(e, a) {
    e.forEach((o) => {
      o.id || (o.id = `${a}-tabpanel-${o.value}`);
    });
  }
  /**
   * Iterates over the loaded tab components and prefixes their IDs with the tab component's
   * input or randomly generated Unique ID. Also updates attributes dependent on the tab ID including
   * ariaControls.
   * @param tabPanels the loaded Array of slotted Beacon Tab components
   * @param uniqueID the Tab Component's input ID or randomly generated fallback ID.
   */
  static initializeTabIDs(e, a, o) {
    e.forEach((n) => {
      var T;
      n.id || (n.id = `${a}-tab-${n.value}`);
      const r = `${a}-tabpanel-${n.value}`;
      if (o) {
        const O = o.find(
          (j) => j.value === n.value
        );
        n.ariaControls = (T = O == null ? void 0 : O.id) != null ? T : r;
      } else
        n.ariaControls = r;
    });
  }
  /**
   * Fallback case for the initially selected tab when the user selected value
   * is invalid or not supplied. Sets the first tab and tab panel to active.
   */
  setActiveToFirst() {
    this.updateCurrentlyActiveTab(ZP);
  }
  /**
   * Sets the currently active tab to the string input,
   * if the string input is within the range of currently slotted tabs,
   * and sets the active tab to the first slotted tab otherwise.
   * @param selected tab with matching value to set as active, this.selected
   * @param currentTotalTabs the length of currently slotted tab array, this.currentTotalTabs
   */
  initializeUserSelectedTab(e, a) {
    const o = parseInt(this.selected, 10);
    o > a || o < 0 ? this.setActiveToFirst() : this.updateCurrentlyActiveTab(e);
  }
  /**
   * Sets the currently active tab to the user supplied selected value
   * if it exists and is valid, or to the first slotted tab otherwise.
   * @param selected tab with matching value to set as active, this.selected
   * @param currentTotalTabs the length of currently slotted tab array, this.currentTotalTabs
   */
  initializeSelectedTab(e, a) {
    e !== JP ? this.initializeUserSelectedTab(e, a) : this.setActiveToFirst();
  }
  removeArrowControlKeyboardListeners() {
    var e;
    this.tabChildren.forEach((a) => {
      a.removeEventListener("keydown", this.handleKeydown);
    }), this.shouldShowMore && ((e = this.moreButton) == null || e.removeEventListener("keydown", this.handleKeydown));
  }
  /**
   * Keyboard listeners for all arrow-controlled children. Makes the events
   * store a reference (event.currentTarget) to the focused tab to simplify logic
   */
  attachArrowControlKeyboardListeners() {
    var e;
    this.tabChildren.forEach((a) => {
      a.addEventListener("keydown", this.handleKeydown);
    }), this.shouldShowMore && ((e = this.moreButton) == null || e.addEventListener("keydown", this.handleKeydown));
  }
  /**
   * Basic focus callback for ArrowControl
   * @param tab
   */
  static arrowControlFocusCallback(e) {
    e instanceof Dt && e.focus();
  }
  async handleSlotChange() {
    await this.initializeTabs(), this.requestUpdate();
  }
  /**
   * When the tabs component first Updates or the slot changes, it waits for the slotted
   * tab, and tab panel components, selects the appropriate tab, hides the rest,
   * and applies some attributes from the tabs component to each tab/ tab panel, then
   * hides the tabMenuOverlay if it's shown.
   */
  async initializeTabs() {
    var e;
    await Promise.all(this.tabChildren.map((a) => a.updateComplete)), await Promise.all(this.tabPanels.map((a) => a.updateComplete)), this.shouldShowMore && await ((e = this.moreButton) == null ? void 0 : e.updateComplete), this.currentTotalTabs = this.tabChildren.length, Mt.initializeTabPanelValues(this.tabPanels), Mt.initializeTabValues(this.tabChildren), Mt.initializeTabPanelIDs(this.tabPanels, this.id), Mt.initializeTabIDs(this.tabChildren, this.id, this.tabPanels), this.updateShownTabs(), this.applyTabVariant(this.tabChildren), this.applyTabType(this.tabChildren), this.removeArrowControlKeyboardListeners(), this.attachArrowControlKeyboardListeners(), this.initializeSelectedTab(this.selected, this.currentTotalTabs), this.tabMenuOverlay && this.hideMenu();
  }
  /**
   * When the tabs component first Updates, it waits for the slotted
   * tab, and tab panel components, selects the appropriate tab, hides the rest,
   * and applies some attributes from the tabs component to each tab/ tab panel, then
   * hides the tabMenuOverlay if it's shown.
   */
  async firstUpdated() {
    this.variant !== bo.PRIMARY && (this.scrollable = !0), await this.initializeTabs(), this.variant === bo.PRIMARY ? this.tabsResizeObserver.observe(this.tabListElement) : this.tabsResizeObserver.observe(document.body), this.renderStyles(
      "lightDOMStyles",
      `${this.beaconTagName}-light-DOM-styles`
    ), this.shouldShowMore && (this.focusTrapObject = lv(this.tabMenuOverlay, {
      fallbackFocus: this.closeButton,
      // focusTrap needs a fallbackFocus node if there are no focusable nodes found in the host element
      tabbableOptions: {
        getShadowRoot: !0
        // option that allows focusTrap to penetrate closed shadowRoot's and grab focusable nodes
      },
      // overrides keyForward and keyBackward events to include arrowKey navigation
      isKeyForward: (e) => e.key === Aa.DOWN || e.key === Aa.RIGHT || e.key === Ea.TAB,
      isKeyBackward: (e) => e.key === Aa.UP || e.key === Aa.LEFT || e.shiftKey && e.key === Ea.TAB,
      escapeDeactivates: () => (this.hideMenu(), !0)
    })), super.firstUpdated();
  }
  /**
   * renders a `<beacon-tab>` component with the more attribute set to true
   * and an icon matching the `<beacon-tabs>` tab type property
   * @returns An HTML `<beacon-tab>` with more attribute set to true and a slotted more icon
   */
  renderMoreButton() {
    return Be`<${this.getScopedTag("beacon-tab")}
      label="More"
      variant=${this.variant}
      tab-type=${this.tabType}
      value="-1"
      @beacon-event-click=${this.showMenu}
      more
      aria-haspopup="menu"
    >
      <svg slot="tab-icon" width="17" height="4" viewBox="0 0 17 4" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="2.5" cy="2" r="2" fill="white" />
        <circle cx="8.5" cy="2" r="2" fill="white" />
        <circle cx="14.5" cy="2" r="2" fill="white" />
      </svg>
    </${this.getScopedTag("beacon-tab")}>`;
  }
  /**
   * Renders a dialog containing the mapped values of the slotted tabs
   * @returns an HTML dialog containing a tablist of mapped tab items
   */
  renderMoreMenu() {
    return pe`<div
      class="overlay hide"
      @click=${this.handleMenuClickBlur}
      id="menu"
      data-metrics-location="${Qa.dataMetricsLocation.PU}">
      <dialog>
        <div class="close-button-row">
          ${Be`<${this.getScopedTag("beacon-icon-button")} @beacon-event-click=${this.handleClose} label="close-button" variant="primary">
            <${this.getScopedTag("beacon-icon")} slot="icon" name="close" size="m"></${this.getScopedTag("beacon-icon")}>
          </${this.getScopedTag("beacon-icon-button")}>`}
        </div>
        <div class="menu-item">
          <h2>${this.menuTitle}</h2>
        </div>
        <div class="menu-tablist" role="tablist">
          ${this.buildTabMenu(this.tabChildren)}
        </div>
      </dialog>
    </div>`;
  }
  render() {
    return pe`<div class="container">
        <div id="tab-list" role="tablist" class="tablist">
          <slot
            name="tab-children"
            @beacon-event-click=${this.handleTabClick}
            @slotchange=${this.handleSlotChange}></slot>
          ${this.shouldShowMore ? this.renderMoreButton() : _e}
        </div>
      </div>
      <div class="spacer"></div>
      <slot name="tab-panel" @slotchange=${this.handleSlotChange}></slot>
      ${this.shouldShowMore ? this.renderMoreMenu() : _e}`;
  }
}, Gi = new WeakMap(), Mt.tagName = jg, Mt.nestedComponents = [eo, Dt], Mt);
dt([
  et("#menu")
], rt.prototype, "tabMenuOverlay", 2);
dt([
  et("#menu dialog")
], rt.prototype, "tabMenu", 2);
dt([
  n1("#menu button.menu-item")
], rt.prototype, "menuTabs", 2);
dt([
  et(
    '#menu dialog .close-button-row [beacon-tag-name="beacon-icon-button"]'
  )
], rt.prototype, "closeButton", 2);
dt([
  et("#menu dialog .close-button-row")
], rt.prototype, "closeButtonRow", 2);
dt([
  et("#tab-list")
], rt.prototype, "tabListElement", 2);
dt([
  et("[more]")
], rt.prototype, "moreButton", 2);
dt([
  Pe(
    { slot: "tab-children", selector: "beacon-tab" },
    !0
  )
], rt.prototype, "tabChildren", 2);
dt([
  Pe(
    { slot: "tab-panel", selector: "beacon-tab-panel" },
    !0
  )
], rt.prototype, "tabPanels", 2);
dt([
  Se()
], rt.prototype, "currentTotalTabs", 2);
dt([
  Se()
], rt.prototype, "currentMaxTabs", 2);
dt([
  ue({ reflect: !0, type: Boolean })
], rt.prototype, "scrollable", 2);
dt([
  ue({ reflect: !0, type: Boolean })
], rt.prototype, "scrolled", 2);
dt([
  ue({ type: Boolean, attribute: "close-on-click-out" })
], rt.prototype, "closeOnClickOut", 2);
dt([
  ue({ reflect: !0 })
], rt.prototype, "variant", 2);
dt([
  ue({ reflect: !0, attribute: "tab-type" })
], rt.prototype, "tabType", 2);
dt([
  ue({ attribute: "menu-title" })
], rt.prototype, "menuTitle", 2);
dt([
  ue()
], rt.prototype, "selected", 1);
dt([
  Se()
], rt.prototype, "menuOpen", 2);
dt([
  ue({ reflect: !0, attribute: "overflowing-x" })
], rt.prototype, "markedAsOverflowingX", 2);
dt([
  Se()
], rt.prototype, "markedAsMenuOverFlowingY", 2);
dt([
  ue({ reflect: !0 })
], rt.prototype, "id", 2);
dt([
  Lt
], rt.prototype, "tearDownTabs", 1);
let lz = rt;
const $g = {
  beaconTagName: "beacon-tooltip"
}, l3 = ve`[beacon-tag-name=beacon-tooltip] :where(*){margin:0;padding:0}`, c3 = ve`@media (prefers-reduced-motion: no-preference){:host([motion-state=enabled]){transition-duration:var(--beacon-reference-motion-duration-3);transition-property:opacity;transition-timing-function:var(--tooltip-transition-timing-function, var(--beacon-system-motion-easing-decelerate-standard-1))}:host([motion-state=enabled]:not([open])){opacity:0}:host([motion-state=enabled][open]){opacity:1}:host([motion-state=enabled][open][closing]){--tooltip-transition-timing-function: var(--beacon-system-motion-easing-accelerate-emphasize-1);opacity:0}}`;
var d3 = Object.getOwnPropertyDescriptor, h3 = (i, t, e, a) => {
  for (var o = a > 1 ? void 0 : a ? d3(t, e) : t, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = r(o) || o);
  return o;
};
function b3(i) {
  let t = class extends i {
    static get TooltipMotionStyles() {
      return [c3];
    }
  };
  return t = h3([
    je("TestTooltipMotion")
  ], t), t;
}
const p3 = ve`:host{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-caption-300);filter:drop-shadow(0 0 var(--beacon-reference-space-1) var(--beacon-reference-palette-grayscale-shadow-1));max-inline-size:15ch;min-inline-size:40px;padding:var(--beacon-system-space-cell-contained);text-align:center}.arrow{--arrow-inline-size: 6px;--arrow-block-size: 12px;background-color:initial;block-size:12px;inline-size:12px}.arrow[data-side=bottom]{transform:rotate(90deg)}.arrow[data-side=left]{transform:rotate(180deg)}.arrow[data-side=top]{transform:rotate(-90deg)}.arrow .arrow-vector{background-color:initial;block-size:var(--arrow-block-size);fill:var(--beacon-system-color-background-1);inline-size:var(--arrow-inline-size);inset-inline-end:-1px;position:absolute}`;
var u3 = Object.defineProperty, g3 = Object.getOwnPropertyDescriptor, $s = (i, t, e, a) => {
  for (var o = a > 1 ? void 0 : a ? g3(t, e) : t, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = (a ? r(t, e, o) : r(o)) || o);
  return a && o && u3(t, e, o), o;
}, li;
const Sr = (li = class extends Ke(Le).with(
  Bf,
  Hh,
  vf,
  b3
) {
  constructor() {
    super(...arguments), this.beaconTagName = $g.beaconTagName, this._hovered = !1, this.show = (t) => {
      this.attachTooltipListeners(), !this.prefersReducedMotion && this.motionState === ns.ENABLED ? (this.closing = !1, this.showCallback(t)) : this.showCallback(t);
    }, this.hide = (t) => {
      this.removeTooltipListeners(), !this.prefersReducedMotion && this.motionState === ns.ENABLED ? this.closing = !0 : this.hideCallback(t);
    }, this.mouseOverTooltipListener = () => {
      this._hovered = !0, this.waitUntilMouseHoversTooltip && clearTimeout(this.waitUntilMouseHoversTooltip);
    }, this.mouseOutTooltipListener = (t) => {
      this._hovered = !1, this.hide(t);
    }, this.opensByMouseOutListener = (t) => {
      this.waitUntilMouseHoversTooltip = setTimeout(() => {
        this._hovered || this.hide(t);
      }, 100);
    };
  }
  static get styles() {
    return [super.styles, this.popupStyles, p3, this.TooltipMotionStyles];
  }
  static get lightDOMStyles() {
    return [super.lightDOMStyles, l3];
  }
  get text() {
    let t = "";
    return this.slottedElements ? (t = li.getCleanTextContent(
      this.slottedElements
    ), t) : (this.slottedNodes && (t = li.getCleanTextContent(this.slottedNodes)), t);
  }
  /**
   * Grabs the cleaned `.textContent` from the element's slotted content.
   * This is used to prevent `<style>` element contents from being assigned to the aria-description attribute.
   * @param slottedContent
   * @returns
   */
  static getCleanTextContent(t) {
    return [...t].reduce((e, a) => {
      var n, r;
      const o = (r = (n = a == null ? void 0 : a.textContent) == null ? void 0 : n.trim()) != null ? r : "";
      return e + o;
    }, "");
  }
  _renderArrowHTML() {
    return pe`<div class="arrow">
      <svg
        aria-hidden="true"
        width="6"
        height="12"
        viewBox="0 0 6 12"
        xmlns="http://www.w3.org/2000/svg"
        class="arrow-vector">
        <path d="M6 0L0 6L6 12V0Z" />
      </svg>
    </div>`;
  }
  runOpensBySetup() {
    this.opensByElements.forEach((t, e) => {
      e.addEventListener("mouseenter", this.show), e.addEventListener("mouseleave", this.opensByMouseOutListener), e.addEventListener("focus", this.show), e.addEventListener("blur", this.hide), e instanceof Fi ? e.updateComplete.then(() => {
        var a;
        (a = e.button) == null || a.setAttribute("aria-description", this.text);
      }) : e.setAttribute("aria-describedby", this.id);
    });
  }
  runOpensByClean() {
    this.opensByElements.forEach((t, e) => {
      e.removeEventListener("mouseenter", this.show), e.removeEventListener("mouseleave", this.hide), e.removeEventListener("focus", this.show), e.removeEventListener("blur", this.hide);
    });
  }
  attachTooltipListeners() {
    this.addEventListener("mouseenter", this.mouseOverTooltipListener), this.addEventListener("mouseleave", this.mouseOutTooltipListener);
  }
  removeTooltipListeners() {
    this.removeEventListener("mouseenter", this.mouseOverTooltipListener), this.removeEventListener("mouseleave", this.mouseOutTooltipListener);
  }
  closingAnimationCallback() {
    this.hideCallback();
  }
  applyAriaRole() {
    this.setAttribute("role", "tooltip");
  }
  render() {
    return pe`
      <div id="tooltip">
        <slot></slot>
        ${this._renderArrowHTML()}
      </div>
    `;
  }
}, li.tagName = $g.beaconTagName, li);
$s([
  wt({ slot: "", selector: ":not(style)" })
], Sr.prototype, "slottedElements", 2);
$s([
  Fo({ slot: "", flatten: !0 })
], Sr.prototype, "slottedNodes", 2);
$s([
  ue({ attribute: "hovered", type: Boolean })
], Sr.prototype, "_hovered", 2);
$s([
  Lt
], Sr.prototype, "removeTooltipListeners", 1);
$s([
  De
], Sr.prototype, "applyAriaRole", 1);
let cz = Sr;
const m3 = `<svg width="33" height="32" viewBox="0 0 33 32" slot="icon" fill="currentColor" xmlns="http://www.w3.org/2000/svg" class="play-icon">
<path d="M32 16L8 29.8564L8 2.14359L32 16Z"  stroke-width="2" stroke-linejoin="round"/>
</svg>`, Hg = {
  beaconTagName: "beacon-video"
}, f3 = ve`.beacon-video-player .vjs-loading-spinner,.beacon-video-player .vjs-big-play-button,.beacon-video-player .vjs-title-bar{display:none}.beacon-video-player .vjs-poster{box-shadow:inset 0 0 0 100vw #1e2d3961}.beacon-video-player .vjs-play-progress,.beacon-video-player .vjs-volume-level{background-color:var(--beacon-system-color-text-link)}[beacon-tag-name=beacon-video] video-js.beacon-video-player{grid-column:var(--video-overlay-column-span);grid-row:var(--video-overlay-column-span);inline-size:100%}[beacon-tag-name=beacon-video] [beacon-tag-name=beacon-video-tag]{inset-block-start:var(--video-tag-inset-block-start);inset-inline-end:var(--video-tag-inset-inline-end);position:var(--video-tag-position, absolute)}[beacon-tag-name=beacon-video] [beacon-tag-name=beacon-video-tag][aspect-ratio="1:1"]{--video-tag-inset-inline-end: var(--beacon-reference-space-3);--video-tag-inset-block-start: var(--beacon-reference-space-3)}[beacon-tag-name=beacon-video] [beacon-tag-name=beacon-video-tag][aspect-ratio="2:1"]{--video-tag-inset-inline-end: var(--beacon-system-space-micro-normal);--video-tag-inset-block-start: var(--beacon-system-space-micro-normal)}@media (width >= 960px){[beacon-tag-name=beacon-video] [beacon-tag-name=beacon-video-tag][aspect-ratio="2:1"]{--video-tag-inset-inline-end: var(--beacon-system-space-micro-normal);--video-tag-inset-block-start: var(--beacon-system-space-micro-normal)}}[beacon-tag-name=beacon-video] [beacon-tag-name=beacon-video-transcript]{align-items:flex-start;align-self:stretch;background-color:var(--video-transcript-background-color);display:flex;flex-direction:column;gap:var(--beacon-system-space-micro-mini);padding:var(--video-transcript-padding);padding-inline-start:var(--override-transcript-padding, var(--video-transcript-padding))}[beacon-tag-name=beacon-video] [beacon-tag-name=beacon-video-transcript] [beacon-tag-name=beacon-button]{--override-button-default-gap: 0;align-items:center;display:flex;justify-content:center}[beacon-tag-name=beacon-video] [beacon-tag-name=beacon-video-transcript].video-transcript-contained{--video-transcript-padding: var(--beacon-system-space-cell-contained);--video-transcript-background-color: var(--beacon-system-color-background-1)}[beacon-tag-name=beacon-video] [beacon-tag-name=beacon-video-transcript].video-transcript-contained [beacon-tag-name=beacon-button]{padding-block:var(--beacon-reference-space-2) var(--beacon-reference-space-2);padding-inline:var(--beacon-reference-space-5) 0}[beacon-tag-name=beacon-video] [beacon-tag-name=beacon-video-transcript].video-transcript-free-floating{--video-transcript-padding: var(--beacon-system-space-cell-free-floating) 0;--video-transcript-background-color: transparent}[beacon-tag-name=beacon-video] [beacon-tag-name=beacon-video-transcript].video-transcript-free-floating [beacon-tag-name=beacon-button]{padding:var(--beacon-reference-space-2) 0}[beacon-tag-name=beacon-article-tile]:is([position=horizontal],[position=horizontal-right]) [beacon-tag-name=beacon-video]{--override-video-thumbnail-border-end-start-radius: var(--tile-media-end-start-radius);--override-video-thumbnail-border-start-start-radius: var(--tile-media-start-start-radius);--override-video-thumbnail-inline-size: var(--override-video-inline-size);--override-video-thumbnail-aspect-ratio: var(--override-video-aspect-ratio);--override-video-thumbnail-object-fit: var(--override-video-object-fit);--override-video-thumbnail-block-size: var(--override-video-block-size)}[beacon-tag-name=beacon-article-tile]:is([position=horizontal],[position=horizontal-right]) [beacon-tag-name=beacon-video] img{aspect-ratio:var(--override-video-thumbnail-aspect-ratio);block-size:var(--override-video-thumbnail-block-size, 100%);border-end-start-radius:var(--override-video-thumbnail-border-end-start-radius);border-start-start-radius:var(--override-video-thumbnail-border-start-start-radius);inline-size:min(var(--override-video-thumbnail-inline-size, 100%));object-fit:var(--override-video-thumbnail-object-fit, cover)}[beacon-tag-name=beacon-article-tile]:is([position=horizontal-left]) [beacon-tag-name=beacon-video]{--override-video-thumbnail-border-start-end-radius: var(--tile-start-end-radius);--override-video-thumbnail-border-end-end-radius: var(--tile-end-end-radius);--override-video-thumbnail-inline-size: var(--override-video-inline-size);--override-video-thumbnail-aspect-ratio: var(--override-video-aspect-ratio);--override-video-thumbnail-object-fit: var(--override-video-object-fit);--override-video-thumbnail-block-size: var(--override-video-block-size)}[beacon-tag-name=beacon-article-tile]:is([position=horizontal-left]) [beacon-tag-name=beacon-video] img{aspect-ratio:var(--override-video-thumbnail-aspect-ratio);block-size:var(--override-video-thumbnail-block-size, 100%);border-end-end-radius:var(--override-video-thumbnail-border-end-end-radius);border-start-end-radius:var(--override-video-thumbnail-border-start-end-radius);inline-size:min(var(--override-video-thumbnail-inline-size, 100%));object-fit:var(--override-video-thumbnail-object-fit, cover)}[beacon-tag-name=beacon-article-tile]:is([position=vertical],[position=vertical-bottom]) [beacon-tag-name=beacon-video]{--override-video-thumbnail-aspect-ratio: var(--override-video-aspect-ratio);--override-video-thumbnail-inline-size: var(--override-video-vertical-inline-size);--override-video-thumbnail-object-fit: var(--override-video-object-fit)}[beacon-tag-name=beacon-article-tile]:is([position=vertical],[position=vertical-bottom]) [beacon-tag-name=beacon-video] img{aspect-ratio:var(--override-video-thumbnail-aspect-ratio);border-start-end-radius:var(--tile-start-end-radius);border-start-start-radius:var(--tile-start-start-radius);display:block;inline-size:min(var(--override-video-thumbnail-inline-size, 100%));object-fit:var(--override-video-thumbnail-object-fit, cover)}@media (width >= 640px){[beacon-tag-name=beacon-article-tile]:is([position=vertical],[position=vertical-bottom]) [beacon-tag-name=beacon-video] img{aspect-ratio:var(--override-video-thumbnail-aspect-ratio);border-end-end-radius:var(--tile-media-end-end-radius);border-end-start-radius:var(--tile-media-end-start-radius);display:block;inline-size:min(var(--override-video-thumbnail-inline-size, 100%));object-fit:var(--override-video-thumbnail-object-fit, cover)}}[beacon-tag-name=beacon-article-tile]:is([position=vertical-top]) [beacon-tag-name=beacon-video]{--override-video-thumbnail-inline-size: var(--override-video-vertical-inline-size)}[beacon-tag-name=beacon-article-tile]:is([position=vertical-top]) [beacon-tag-name=beacon-video] img{aspect-ratio:var(--article-tile-media-aspect-ratio);border-end-end-radius:var(--tile-media-end-end-radius);border-end-start-radius:var(--tile-media-end-start-radius);display:block;inline-size:min(var(--override-video-thumbnail-inline-size, 100%));object-fit:var(--override-video-thumbnail-object-fit, cover)}`, v3 = ve`:host{--video-overlay-column-span: 1/2;--overlay-z-index: 1;display:grid;grid-template-columns:auto;grid-template-rows:auto;inline-size:100%}[beacon-tag-name=beacon-icon-button]::part(icon-button){--override-icon-button-wrapper-inline-size: 48px;--override-icon-button-wrapper-block-size: 48px;--override-icon-button-block-size: 24px;--override-icon-button-inline-size: 24px}.video-play-button{--play-button-size-override: calc(var(--beacon-reference-space-11) / 2);--override-icon-button-box-shadow: var(--beacon-elevation-block-end-level-1);--override-icon-button-bg-color: var(--beacon-system-color-background-primary);--override-icon-button-color: var(--beacon-system-color-icon-primary);--override-icon-button-surface-size: calc(2 * var(--play-button-size-override));--override-icon-button-padding: var(--beacon-reference-space-4);display:flex;grid-column:var(--video-overlay-column-span);grid-row:var(--video-overlay-column-span);place-self:center center;z-index:var(--overlay-z-index)}@media (width >= 640px){.video-play-button{--play-button-size-override: calc(var(--beacon-reference-space-13) / 2);--override-icon-button-padding: var(--beacon-reference-space-5)}[beacon-tag-name=beacon-icon-button]::part(icon-button){--override-icon-button-wrapper-inline-size: 64px;--override-icon-button-wrapper-block-size: 64px;--override-icon-button-block-size: 32px;--override-icon-button-inline-size: 32px}}@media (width >= 960px){.video-play-button{--play-button-size-override: calc(var(--beacon-reference-space-15) / 2);--override-icon-button-padding: var(--beacon-reference-space-6)}[beacon-tag-name=beacon-icon-button]::part(icon-button){--override-icon-button-wrapper-inline-size: 80px;--override-icon-button-wrapper-block-size: 80px;--override-icon-button-block-size: 40px;--override-icon-button-inline-size: 40px}}.timestamp-container{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-caption-300);-webkit-backdrop-filter:blur(var(--beacon-reference-space-2));backdrop-filter:blur(var(--beacon-reference-space-2));background-color:var(--beacon-system-color-background-1);border-radius:var(--beacon-system-radius-corner-standard);color:var(--beacon-system-color-text-standard);grid-column:var(--video-overlay-column-span);grid-row:var(--video-overlay-column-span);margin-block-end:var(--beacon-system-space-organism-normal);margin-inline-end:var(--beacon-system-space-organism-normal);padding:var(--beacon-system-space-cell-contained);place-self:end end;z-index:var(--overlay-z-index)}.timestamp-container .timestamp-tag{padding-block:var(--beacon-reference-space-1);padding-inline:var(--beacon-reference-space-3)}.hidden{display:none}.video-tag-container{display:inline-block;inline-size:fit-content;position:relative}`;
var A3 = Object.defineProperty, nb = (i, t, e, a) => {
  for (var o = void 0, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = r(t, e, o) || o);
  return o && A3(t, e, o), o;
};
const ic = class ic extends _n {
  constructor() {
    super(...arguments), this.beaconTagName = Hg.beaconTagName, this.showPrePlayInformation = !1, this.videoCSSClass = "beacon-video-player";
  }
  static get styles() {
    return [super.styles, v3];
  }
  static get lightDOMStyles() {
    return [...super.lightDOMStyles, f3];
  }
  get thumbnails() {
    return Array.from(this.querySelectorAll("img, picture"));
  }
  getDuration() {
    return new Promise((t) => {
      var e, a;
      if (this.brightcovePlayer) {
        const o = (a = (e = this.brightcovePlayer) == null ? void 0 : e.mediainfo) == null ? void 0 : a.duration;
        o ? (this.duration = _n.formatDuration(o), t()) : this.brightcovePlayer.on("loadedmetadata", () => {
          var n, r;
          this.duration = _n.formatDuration(
            (r = (n = this.brightcovePlayer) == null ? void 0 : n.mediainfo) == null ? void 0 : r.duration
          ), t();
        });
      }
    });
  }
  handlePlayButtonPress() {
    var t;
    (t = this.brightcovePlayer) == null || t.play();
  }
  async brightcoveInit() {
    var t;
    if (this.thumbnails.length > 0 && (this.isLinkingExternally = !0), this.thumbnails.length === 0) {
      await this.applyPlayerScript(), (t = this.brightcovePlayer) == null || t.on("play", () => {
        this.showPrePlayInformation = !1;
      });
      const { tagAttributes: e } = this.brightcovePlayer;
      e != null && e.autoplay || (this.showPrePlayInformation = !0, await this.getDuration()), Re(this, Ee.VIDEO_BRIGHTCOVE_READY);
    }
  }
  render() {
    return this.isLinkingExternally ? pe`
        <div class="video-tag-container">
          ${this.renderBrightcoveDefaultSlot()}
        </div>
      ` : pe`
      ${this.showPrePlayInformation ? pe`
            ${Be`
          <${this.getScopedTag("beacon-icon-button")}
            class="video-play-button"
            exportparts="icon-button: play-button"
            @beacon-event-click=${this.handlePlayButtonPress}>
            Play Video
            ${ut(m3)}
          </${this.getScopedTag("beacon-icon-button")}>
        `}
            <div class="timestamp-container">
              <time
                class="timestamp-tag"
                part="timestamp"
                datetime="${this.duration}"
                >${this.duration}</time
              >
            </div>
          ` : pe``}
      ${this.renderBrightcoveDefaultSlot()}
    `;
  }
};
ic.tagName = Hg.beaconTagName, ic.nestedComponents = [eo];
let cr = ic;
nb([
  Se()
], cr.prototype, "isLinkingExternally");
nb([
  Se()
], cr.prototype, "duration");
nb([
  Se()
], cr.prototype, "showPrePlayInformation");
const Kg = {
  beaconTagName: "beacon-video-playlist"
}, y3 = ve`[beacon-tag-name=beacon-video-playlist]{--playlist-item-min-inline-size: 160px;--override-transcript-button-padding-inline-start: var(--beacon-reference-space-3);--override-transcript-padding: var(--beacon-system-space-organism-normal)}[beacon-tag-name=beacon-video-playlist] [beacon-tag-name=beacon-video-transcript]{border-block-end:var(--beacon-system-width-border-mini) solid var(--beacon-system-color-border-1)}[beacon-tag-name=beacon-video-playlist] .beacon-video-playlist__playlist-title{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-100);margin-inline-start:var(--beacon-reference-space-3);padding-block:var(--beacon-system-space-cell-contained)}[beacon-tag-name=beacon-video-playlist] .vjs-playlist{background-color:var(--beacon-system-color-background-1);padding-block:var(--beacon-system-space-organism-mini)}[beacon-tag-name=beacon-video-playlist] .vjs-playlist .vjs-playlist-title-container{background-color:var(--beacon-system-color-background-1);border-radius:var(--beacon-system-width-border-normal);color:var(--beacon-system-color-text-standard);inline-size:unset;margin:var(--beacon-reference-space-2);padding:var(--beacon-system-space-organism-mini);text-shadow:none;font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-caption-100)}[beacon-tag-name=beacon-video-playlist] .vjs-playlist .vjs-playlist-name{line-height:initial;padding:unset}[beacon-tag-name=beacon-video-playlist] .vjs-selected,[beacon-tag-name=beacon-video-playlist] .vjs-mouse .vjs-selected{background:var(--beacon-reference-palette-primary-midnight-navy-1);background-image:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='18' height='22' viewBox='0 0 18 22' fill='none'%3E%3Cpath d='M18 11.0005L-9.78799e-07 21.3928L-7.02746e-08 0.608183L18 11.0005Z' fill='white'/%3E%3C/svg%3E");background-position:center;background-repeat:no-repeat;border:var(--beacon-system-width-border-normal) solid var(--beacon-system-color-border-focus-middle);box-shadow:inset 0 0 0 var(--beacon-system-width-border-normal) var(--beacon-system-color-border-focus-inner)}[beacon-tag-name=beacon-video-playlist] .vjs-selected img{opacity:.64}[beacon-tag-name=beacon-video-playlist] .vjs-selected .vjs-playlist-now-playing-text,[beacon-tag-name=beacon-video-playlist] .vjs-up-next .vjs-up-next-text,[beacon-tag-name=beacon-video-playlist] .vjs-playlist-duration{display:none}[beacon-tag-name=beacon-video-playlist] .vjs-playlist-item img{min-inline-size:var(--playlist-item-min-inline-size)}[beacon-tag-name=beacon-video-playlist] .beacon-video-playlist__playlist-container{background-color:var(--beacon-system-color-background-1);padding:var(--beacon-system-space-organism-normal)}[beacon-tag-name=beacon-video-playlist] .vjs-playlist-horizontal .vjs-playlist-item{margin-inline:var(--beacon-system-space-micro-normal) 0}[beacon-tag-name=beacon-video-playlist] .vjs-playlist-horizontal .vjs-playlist-item:first-child{margin-inline-start:0}[beacon-tag-name=beacon-video-playlist] .vjs-playlist-item-list{background-color:var(--beacon-system-color-background-1);margin-block:var(--beacon-reference-space-3);margin-inline-start:var(--beacon-reference-space-3)}@media (width >= 960px){[beacon-tag-name=beacon-video-playlist]{--playlist-item-min-inline-size: 240px}}`, x3 = ve`:host{border-radius:var(--beacon-system-radius-corner-standard);overflow:hidden}`;
var w3 = Object.defineProperty, k3 = (i, t, e, a) => {
  for (var o = void 0, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = r(t, e, o) || o);
  return o && w3(t, e, o), o;
}, Qn;
const Hb = class Hb extends Le {
  constructor() {
    super(...arguments);
    Fe(this, Qn);
    this.beaconTagName = Kg.beaconTagName, Ne(this, Qn, []);
  }
  static get styles() {
    return [super.styles, x3];
  }
  static get lightDOMStyles() {
    return [super.lightDOMStyles, y3];
  }
  get playlistItems() {
    return ze(this, Qn);
  }
  set playlistItems(e) {
    Ne(this, Qn, e), this.setPlaylistItemListeners();
  }
  setPlaylistItems({ target: e }) {
    var a;
    e instanceof cr && (this.playlistItems = Array.from(
      (a = e.brightcovePlayer.playlistMenu.el_) == null ? void 0 : a.querySelectorAll(
        "li.vjs-playlist-item"
      )
    ));
  }
  setPlaylistItemListeners() {
    this.playlistItems.forEach((e, a) => {
      e.addEventListener("click", () => {
        this.beaconVideoTranscript.setActiveTranscript(a);
      }), e.addEventListener("keydown", (o) => {
        (o.key == Ea.ENTER || o.key == Ea.SPACE) && this.beaconVideoTranscript.setActiveTranscript(a);
      });
    });
  }
  render() {
    return pe`<slot
      @beacon-event-video-brightcove-ready=${this.setPlaylistItems}></slot>`;
  }
};
Qn = new WeakMap(), Hb.tagName = Kg.beaconTagName;
let mh = Hb;
k3([
  bn('[beacon-tag-name="beacon-video-transcript"]')
], mh.prototype, "beaconVideoTranscript");
const C3 = `<svg class="play-icon" slot="icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
    <path d="M12 8L6 12L6 4L12 8Z" stroke-width="2" stroke-linejoin="round"/>
</svg>`, S3 = `<svg class="play-icon" slot="prefix" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
    <path d="M12 8L6 12L6 4L12 8Z" stroke-width="2" stroke-linejoin="round"/>
</svg>`, E3 = ve`:root[beacon-tag-name=beacon-video-tag],:root [beacon-tag-name=beacon-video-tag],[beacon-version="4.3.1"][class*=beacon-on][beacon-tag-name=beacon-video-tag],[beacon-version="4.3.1"][class*=beacon-on] [beacon-tag-name=beacon-video-tag],[class*=beacon-on] [beacon-version="4.3.1"][beacon-tag-name=beacon-video-tag],[class*=beacon-on] [beacon-version="4.3.1"] [beacon-tag-name=beacon-video-tag],[beacon-version="4.3.1"][beacon-tag-name=beacon-video-tag],[beacon-version="4.3.1"] [beacon-tag-name=beacon-video-tag]{--video-play-button-size-block-size-jumbo: var(--beacon-reference-space-11)}@media (width >= 640px){:root[beacon-tag-name=beacon-video-tag],:root [beacon-tag-name=beacon-video-tag],[beacon-version="4.3.1"][class*=beacon-on][beacon-tag-name=beacon-video-tag],[beacon-version="4.3.1"][class*=beacon-on] [beacon-tag-name=beacon-video-tag],[class*=beacon-on] [beacon-version="4.3.1"][beacon-tag-name=beacon-video-tag],[class*=beacon-on] [beacon-version="4.3.1"] [beacon-tag-name=beacon-video-tag],[beacon-version="4.3.1"][beacon-tag-name=beacon-video-tag],[beacon-version="4.3.1"] [beacon-tag-name=beacon-video-tag]{--video-play-button-size-block-size-jumbo: var(--beacon-reference-space-13)}}@media (width >= 960px){:root[beacon-tag-name=beacon-video-tag],:root [beacon-tag-name=beacon-video-tag],[beacon-version="4.3.1"][class*=beacon-on][beacon-tag-name=beacon-video-tag],[beacon-version="4.3.1"][class*=beacon-on] [beacon-tag-name=beacon-video-tag],[class*=beacon-on] [beacon-version="4.3.1"][beacon-tag-name=beacon-video-tag],[class*=beacon-on] [beacon-version="4.3.1"] [beacon-tag-name=beacon-video-tag],[beacon-version="4.3.1"][beacon-tag-name=beacon-video-tag],[beacon-version="4.3.1"] [beacon-tag-name=beacon-video-tag]{--video-play-button-size-block-size-jumbo: var(--beacon-reference-space-15)}}`, T3 = {
  RECTANGLE: "2:1"
}, M3 = ve`[beacon-tag-name=beacon-button]{--override-button-bg-color: var(--beacon-system-color-background-primary);--override-button-border-radius: var(--beacon-reference-space-6);--override-button-font-size-normal: var(--beacon-component-video-tag-font-size-sans-serif-standard);--override-button-font-size: var(--beacon-component-video-tag-font-size-sans-serif-standard);--override-button-font-weight-normal: var(--beacon-system-font-weight-bold);--override-button-space-padding-inline-normal: var(--beacon-reference-space-4);--override-button-space-padding-block-end-normal: var(--beacon-reference-space-3);--override-button-space-padding-block-start-normal: var(--beacon-reference-space-3);--override-button-border-width: 0;align-items:center;display:flex}[beacon-tag-name=beacon-button]::part(standard-button),[beacon-tag-name=beacon-icon-button]::part(icon-button){align-items:center;display:flex}[beacon-tag-name=beacon-icon-button]::part(icon-button){block-size:var(--beacon-reference-space-8);inline-size:var(--beacon-reference-space-8)}.play-icon{--beacon-button-icon-align: center;--override-icon-button-block-size: var(--beacon-reference-space-5);--override-icon-button-inline-size: var(--beacon-reference-space-5);color:var(--beacon-system-color-icon-primary)}[beacon-tag-name=beacon-icon-button]{--override-icon-button-bg-color: var(--beacon-system-color-background-primary);--play-button-size-override: calc(var(--video-tag-play-button-size-block-size-jumbo) / 2);--override-icon-button-box-shadow: var(--beacon-elevation-block-end-level-1);grid-column:var(--video-overlay-column-span);grid-row:var(--video-overlay-column-span);place-self:center center;z-index:var(--overlay-z-index)}.video-tag-container{display:inline-block;position:relative}`;
var L3 = Object.defineProperty, Mv = (i, t, e, a) => {
  for (var o = void 0, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = r(t, e, o) || o);
  return o && L3(t, e, o), o;
};
const nc = class nc extends Le {
  constructor() {
    super(...arguments), this.beaconTagName = "beacon-video-tag", this.linkHref = "";
  }
  static get styles() {
    return [super.styles, M3];
  }
  static get lightDOMstyles() {
    return [super.lightDOMStyles, E3];
  }
  openVideo() {
    window.open(this.linkHref, "_blank");
  }
  render() {
    return this.aspectRatio === T3.RECTANGLE ? pe`<div>
        ${Be`<${this.getScopedTag("beacon-button")} 
          class="video-tag-button-rect" 
          @beacon-event-click=${this.openVideo}
        ><slot></slot>
          ${jd(S3)}</${this.getScopedTag("beacon-button")}>`}
      </div>` : pe`
      ${Be`<${this.getScopedTag("beacon-icon-button")}  
        class="video-tag-button-icon-square" 
        @beacon-event-click=${this.openVideo}
      ><slot></slot>${jd(C3)}</${this.getScopedTag("beacon-icon-button")}>`}
    `;
  }
};
nc.tagName = "beacon-video-tag", nc.nestedComponents = [Zo, eo];
let Ul = nc;
Mv([
  ue({ attribute: "aspect-ratio", reflect: !0 })
], Ul.prototype, "aspectRatio");
Mv([
  ue({ attribute: "link-href", reflect: !0 })
], Ul.prototype, "linkHref");
const Gg = {
  beaconTagName: "beacon-video-tile"
}, O3 = ve`[beacon-tag-name=beacon-video-tile] .beacon-video-tile__eyebrow{padding-block-end:var(--beacon-reference-space-5)}[beacon-tag-name=beacon-video-tile] [beacon-tag-name=beacon-video]::part(play-button){--override-icon-button-wrapper-inline-size: var(--beacon-reference-space-11);--override-icon-button-wrapper-block-size: var(--beacon-reference-space-11);--override-icon-button-block-size: var(--beacon-reference-space-7);--override-icon-button-inline-size: var(--beacon-reference-space-7)}[beacon-tag-name=beacon-video-tile] [beacon-tag-name=beacon-video]::part(timestamp){font:var(--beacon-system-font-weight-bold) .75rem/1rem var(--beacon-system-font-family-body);margin-block-end:.5rem;margin-inline-end:.5rem}[beacon-tag-name=beacon-video-tile] [beacon-tag-name=beacon-video] .beacon-video-player{background-color:currentcolor;block-size:100%;border-radius:var(--beacon-video-tile-border-radius, 0)}[beacon-tag-name=beacon-video-tile] [beacon-tag-name=beacon-video] .vjs-dock-text{display:none}[beacon-tag-name=beacon-video-tile] [beacon-tag-name=beacon-video] .vjs-poster{background-color:currentcolor}@container (inline-size >= 640px){[beacon-tag-name=beacon-video-tile] [beacon-tag-name=beacon-video]::part(play-button){--override-icon-button-wrapper-inline-size: var(--beacon-reference-space-13);--override-icon-button-wrapper-block-size: var(--beacon-reference-space-13);--override-icon-button-block-size: var(--beacon-reference-space-9);--override-icon-button-inline-size: var(--beacon-reference-space-9)}[beacon-tag-name=beacon-video-tile] [beacon-tag-name=beacon-video]::part(timestamp){font:var(--beacon-system-font-weight-bold) .875rem/1.25rem var(--beacon-system-font-family-body);margin-block-end:1rem;margin-inline-end:1rem}}@container (inline-size >= 960px){[beacon-tag-name=beacon-video-tile] [beacon-tag-name=beacon-video]::part(play-button){--override-icon-button-wrapper-inline-size: var(--beacon-reference-space-15);--override-icon-button-wrapper-block-size: var(--beacon-reference-space-15);--override-icon-button-block-size: var(--beacon-reference-space-10);--override-icon-button-inline-size: var(--beacon-reference-space-10)}[beacon-tag-name=beacon-video-tile] [beacon-tag-name=beacon-video]::part(timestamp){font:var(--beacon-system-font-weight-bold) .875rem/1.25rem var(--beacon-system-font-family-body);margin-block-end:1.5rem;margin-inline-end:1.5rem}}@container (inline-size >= 1280px){[beacon-tag-name=beacon-video-tile] [beacon-tag-name=beacon-video]::part(timestamp){font:var(--beacon-system-font-weight-bold) .875rem/1.25rem var(--beacon-system-font-family-body);margin-block-end:1.5rem;margin-inline-end:1.5rem}}`, P3 = ve`:host{--grid-template-columns: auto;--beacon-video-tile-border-radius: var(--beacon-system-radius-corner-standard) var(--beacon-system-radius-corner-standard) 0 0;--content-container-border-radius: 0 0 var(--beacon-system-radius-corner-standard) var(--beacon-system-radius-corner-standard);container-name:video-tile;container-type:inline-size}.video-tile{display:grid;grid-template-columns:var(--grid-template-columns, auto)}.video-tile .content-container{background:var(--beacon-system-color-background-1);border-radius:var(--content-container-border-radius);display:flex;flex-direction:column;justify-content:space-between;padding:.5rem}.video-tile .content-container .content{padding:var(--beacon-system-space-cell-contained)}.video-tile .content-container ::slotted([slot=eyebrow]),.video-tile .content-container ::slotted([slot=title]){padding-block-end:var(--beacon-reference-space-5)}.video-tile .content-container ::slotted([slot=eyebrow]){font:var(--beacon-system-font-weight-bold) .75rem/1rem var(--beacon-system-font-family-body)}.video-tile .content-container ::slotted([slot=title]){font:var(--beacon-system-font-weight-bold) 1.125rem/1.5rem var(--beacon-system-font-family-heading)}.video-tile .content-container ::slotted([slot=body]),.video-tile .content-container .body{font:1rem/1.5rem var(--beacon-system-font-family-body)}.video-tile .content-container .transcript{padding:var(--beacon-system-space-cell-contained)}.video-tile .content-container .body{max-block-size:10lh;overflow:auto}.video-tile .content-container .body ::-webkit-scrollbar{inline-size:calc(.875 * var(--beacon-reference-space-5))}.video-tile .content-container .body ::-webkit-scrollbar-thumb{background:var(--beacon-component-scrollbar-color-background-thumb);background-clip:content-box;border:var(--beacon-reference-space-2) solid transparent;border-radius:calc(.875 * var(--beacon-reference-space-5))}.video-tile.free-floating .content-container{background-color:transparent;padding-block:.5rem 0;padding-inline:0}.video-tile.free-floating .content-container .content{padding-block:var(--beacon-system-space-cell-free-floating);padding-inline:0}.video-tile.free-floating .content-container .transcript{padding-block:var(--beacon-system-space-cell-contained);padding-inline:0}@container video-tile (inline-size >= 640px){.video-tile .content-container{padding:1rem}.video-tile .content-container ::slotted([slot=title]){font:var(--beacon-system-font-weight-bold) 1.25rem/1.75rem var(--beacon-system-font-family-heading)}.video-tile .content-container ::slotted([slot=eyebrow]){font:var(--beacon-system-font-weight-bold) .875rem/1.25rem var(--beacon-system-font-family-body)}.video-tile .content-container ::slotted([slot=body]),.video-tile .content-container .body{font:1.125rem/1.5rem var(--beacon-system-font-family-body)}.video-tile .content-container .body{max-block-size:6lh;overflow:auto}.video-tile .content-container .body ::-webkit-scrollbar{inline-size:calc(.875 * var(--beacon-reference-space-5))}.video-tile .content-container .body ::-webkit-scrollbar-thumb{background:var(--beacon-component-scrollbar-color-background-thumb);background-clip:content-box;border:var(--beacon-reference-space-2) solid transparent;border-radius:calc(.875 * var(--beacon-reference-space-5))}.video-tile.free-floating .content-container{padding-block:1rem 0;padding-inline:0}}@container video-tile (inline-size >= 960px){.video-tile{--grid-template-columns: 67% 33%;grid-template-areas:"video content"}.video-tile .video-slot{grid-area:slot}.video-tile .content-container{grid-area:content;padding:1.5rem}.video-tile .content-container ::slotted([slot=title]){font:var(--beacon-system-font-weight-bold) 1.25rem/1.75rem var(--beacon-system-font-family-heading)}.video-tile .content-container ::slotted([slot=eyebrow]){font:var(--beacon-system-font-weight-bold) .875rem/1.25rem var(--beacon-system-font-family-body)}.video-tile .content-container ::slotted([slot=body]),.video-tile .content-container .body{font:1.125rem/1.5rem var(--beacon-system-font-family-body)}.video-tile.horizontal__right{--grid-template-columns: 33% 67%;--beacon-video-tile-border-radius: 0 var(--beacon-system-radius-corner-standard) var(--beacon-system-radius-corner-standard) 0;--content-container-border-radius: var(--beacon-system-radius-corner-standard) 0 0 var(--beacon-system-radius-corner-standard);grid-template-areas:"content video"}.video-tile.horizontal__left{--grid-template-columns: 67% 33%;--beacon-video-tile-border-radius: var(--beacon-system-radius-corner-standard) 0 0 var(--beacon-system-radius-corner-standard);--content-container-border-radius: 0 var(--beacon-system-radius-corner-standard) var(--beacon-system-radius-corner-standard) 0;grid-template-areas:"video content"}.video-tile.horizontal__left .content-container .body,.video-tile.horizontal__right .content-container .body{max-block-size:6lh;overflow:auto}.video-tile.horizontal__left .content-container .body ::-webkit-scrollbar,.video-tile.horizontal__right .content-container .body ::-webkit-scrollbar{inline-size:calc(.875 * var(--beacon-reference-space-5))}.video-tile.horizontal__left .content-container .body ::-webkit-scrollbar-thumb,.video-tile.horizontal__right .content-container .body ::-webkit-scrollbar-thumb{background:var(--beacon-component-scrollbar-color-background-thumb);background-clip:content-box;border:var(--beacon-reference-space-2) solid transparent;border-radius:calc(.875 * var(--beacon-reference-space-5))}.video-tile.vertical{--grid-template-columns: auto;grid-template-areas:none}.video-tile.vertical .content-container{grid-area:initial}.video-tile.free-floating.horizontal__left .content-container{padding-block:0;padding-inline:1.5rem 0}.video-tile.free-floating.horizontal__left .content{padding:0}.video-tile.free-floating.horizontal__right .content-container{padding-block:0;padding-inline:0 1.5rem}.video-tile.free-floating.horizontal__right .content{padding:0}.video-tile.free-floating.vertical .content-container{padding-block:1.5rem 0;padding-inline:0}.video-tile.free-floating.vertical .content{padding:0}}@container video-tile (inline-size >= 1280px){.video-tile .content-container{padding:1.5rem}.video-tile .content-container ::slotted([slot=title]){font:var(--beacon-system-font-weight-bold) 1.5rem/2rem var(--beacon-system-font-family-heading)}.video-tile .content-container ::slotted([slot=eyebrow]){font:var(--beacon-system-font-weight-bold) 1rem/1.5rem var(--beacon-system-font-family-body)}.video-tile .content-container ::slotted([slot=body]),.video-tile .content-container .body{font:1.25rem/1.75rem var(--beacon-system-font-family-body)}.video-tile.horizontal__left .content-container .body,.video-tile.horizontal__right .content-container .body{max-block-size:6lh;overflow:auto}.video-tile.horizontal__left .content-container .body ::-webkit-scrollbar,.video-tile.horizontal__right .content-container .body ::-webkit-scrollbar{inline-size:calc(.875 * var(--beacon-reference-space-5))}.video-tile.horizontal__left .content-container .body ::-webkit-scrollbar-thumb,.video-tile.horizontal__right .content-container .body ::-webkit-scrollbar-thumb{background:var(--beacon-component-scrollbar-color-background-thumb);background-clip:content-box;border:var(--beacon-reference-space-2) solid transparent;border-radius:calc(.875 * var(--beacon-reference-space-5))}.video-tile.free-floating.horizontal__left .content-container{padding-block:0;padding-inline:1.5rem 0}.video-tile.free-floating.horizontal__left .content{padding:0}.video-tile.free-floating.horizontal__right .content-container{padding-block:0;padding-inline:0 0 1.5rem}.video-tile.free-floating.horizontal__right .content{padding:0}.video-tile.free-floating.vertical .content-container{padding-block:1.5rem 0;padding-inline:0}.video-tile.free-floating.vertical .content{padding:0}}`;
var z3 = Object.defineProperty, Lv = (i, t, e, a) => {
  for (var o = void 0, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = r(t, e, o) || o);
  return o && z3(t, e, o), o;
}, ci;
const rb = (ci = class extends Le {
  constructor() {
    super(...arguments), this.beaconTagName = Gg.beaconTagName, this.position = "vertical", this.freeFloating = !1;
  }
  static get styles() {
    return [super.styles, P3];
  }
  static get lightDOMStyles() {
    return [super.lightDOMStyles, O3];
  }
  static renderBody() {
    return pe`<div class="body" tabindex="${qi()}">
      <slot name="body"></slot>
    </div>`;
  }
  static renderEyebrow() {
    return pe`<slot name="eyebrow"></slot>`;
  }
  static renderTitle() {
    return pe`<slot name="title"></slot>`;
  }
  static renderTranscript() {
    return pe`<slot name="transcript"></slot>`;
  }
  static renderTile() {
    return pe`
      <div class="content-container">
        <div class="content">
          ${this.renderEyebrow()} ${this.renderTitle()} ${this.renderBody()}
        </div>
        <div class="transcript">${this.renderTranscript()}</div>
      </div>
    `;
  }
  static renderVideo() {
    return pe`<slot class="video-slot"></slot>`;
  }
  render() {
    const t = {
      horizontal__left: this.position === "horizontal-left",
      horizontal__right: this.position === "horizontal-right",
      vertical: this.position === "vertical",
      "free-floating": this.freeFloating
    };
    return pe` <div class="video-tile ${Oe(t)}">
      ${ci.renderVideo()} ${ci.renderTile()}
    </div>`;
  }
}, ci.tagName = Gg.beaconTagName, ci);
Lv([
  ue({ reflect: !0 })
], rb.prototype, "position");
Lv([
  ue({ attribute: "free-floating", type: Boolean })
], rb.prototype, "freeFloating");
let dz = rb;
const D3 = `<svg slot="suffix" width="16" height="16" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M4 3C4 2.44772 4.44772 2 5 2H15C15.5523 2 16 2.44772 16 3V10C16 10.5523 15.5523 11 15 11H5C4.44772 11 4 10.5523 4 10V3ZM15 4V3.5H5V4V9V10H6H14H15V9V4ZM0 7C0 6.44772 0.447715 6 1 6H2.5C2.77614 6 3 6.22386 3 6.5C3 6.77614 2.77614 7 2.5 7H1V14H11V12.5C11 12.2239 11.2239 12 11.5 12C11.7761 12 12 12.2239 12 12.5V14C12 14.5523 11.5523 15 11 15H1C0.447716 15 0 14.5523 0 14V7Z"/>
</svg>
`, I3 = ve`:root[beacon-tag-name=beacon-video-transcript],:root [beacon-tag-name=beacon-video-transcript],[beacon-version="4.3.1"][class*=beacon-on][beacon-tag-name=beacon-video-transcript],[beacon-version="4.3.1"][class*=beacon-on] [beacon-tag-name=beacon-video-transcript],[class*=beacon-on] [beacon-version="4.3.1"][beacon-tag-name=beacon-video-transcript],[class*=beacon-on] [beacon-version="4.3.1"] [beacon-tag-name=beacon-video-transcript],[beacon-version="4.3.1"][beacon-tag-name=beacon-video-transcript],[beacon-version="4.3.1"] [beacon-tag-name=beacon-video-transcript]{--video-transcript-text-font: var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100)}`, zi = {
  beaconTagName: "beacon-video-transcript",
  videoTranscriptModalScale: "jumbo",
  variant: "tertiary",
  scale: "normal",
  inlineLabel: "Transcript",
  modalLabel: "View Transcript"
}, B3 = ve`details>summary{align-items:center;cursor:pointer;display:flex;list-style-type:none}[open]>summary [slot=icon]{transform:rotate(180deg)}.video-transcript-beacon-modal{position:absolute}.transcript-label{text-transform:capitalize}.video-view-transcript{background-color:transparent;border-color:transparent;border-style:solid;border-width:var(--beacon-system-width-border-mini);color:var(--beacon-system-color-text-tertiary);flex-direction:row;font:var(--beacon-system-font-weight-bold) var(--beacon-component-button-mini-font-size-sans-serif-standard);gap:var(--override-button-default-gap, --beacon-reference-space-2);inline-size:inherit;margin-block:var(--beacon-reference-space-2);padding-block:var(--beacon-reference-space-3) var(--beacon-reference-space-3);padding-inline:0;text-align:start;word-break:initial}.video-view-transcript:is(:hover,:focus-visible):not([aria-disabled=true]){text-decoration:underline}.video-view-transcript span{display:flex}.video-view-transcript [aria-hidden=true]{display:contents}.video-view-transcript svg{color:var(--beacon-system-color-icon-tertiary);margin-inline:var(--beacon-reference-space-3) 0}.video-view-transcript svg:is(:hover,:focus-visible):not([aria-disabled=true]){color:var(--beacon-system-color-icon-tertiary-hover)}.video-view-transcript svg:active:not([aria-disabled=true]){color:var(--beacon-system-color-icon-tertiary-active)}.video-view-transcript [aria-disabled=true]{color:var(--beacon-system-color-icon-tertiary-inactive)}.transcript-text{font:var(--video-transcript-text-font, var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-200))}:host{align-items:flex-start;align-self:stretch;background-color:var(--video-transcript-background-color);display:flex;flex-direction:column;gap:var(--beacon-system-space-micro-mini, 0)}:host .video-view-transcript,:host [beacon-tag-name=beacon-button]{--override-button-default-gap: 0;align-items:center;display:flex;justify-content:center}:host(.video-transcript-contained){--video-transcript-padding: var(--beacon-system-space-cell-contained);--video-transcript-background-color: var(--beacon-system-color-background-1)}:host(.video-transcript-contained) .video-view-transcript,:host(.video-transcript-contained) [beacon-tag-name=beacon-button]{padding-block:var(--beacon-reference-space-2) var(--beacon-reference-space-2);padding-inline:var(--override-transcript-button-padding-inline-start, var(--beacon-reference-space-5)) 0}:host(.video-transcript-free-floating){--video-transcript-padding: var(--beacon-system-space-cell-free-floating) 0;--video-transcript-background-color: transparent}:host(.video-transcript-free-floating) .video-view-transcript,:host(.video-transcript-free-floating) [beacon-tag-name=beacon-button]{padding:var(--beacon-reference-space-2) 0}.transcript-button ::part(standard-button){position:relative}.transcript-button ::part(standard-button):before{block-size:100%;content:"";inline-size:100%;position:absolute}`;
var R3 = Object.defineProperty, N3 = Object.getOwnPropertyDescriptor, Er = (i, t, e, a) => {
  for (var o = a > 1 ? void 0 : a ? N3(t, e) : t, n = i.length - 1, r; n >= 0; n--)
    (r = i[n]) && (o = (a ? r(t, e, o) : r(o)) || o);
  return a && o && R3(t, e, o), o;
}, di;
const wn = (di = class extends Le {
  constructor() {
    super(...arguments), this.beaconTagName = zi.beaconTagName, this.inline = !1, this.activeTranscriptIndex = 0;
  }
  static get styles() {
    return [super.styles, B3];
  }
  static get lightDOMStyles() {
    return [super.lightDOMStyles, I3];
  }
  handleClick() {
    this.modal ? this.modal.show() : console.error(
      "Beacon Modal with class 'video-transcript-beacon-modal' not found"
    );
  }
  addAnalyticsToIcon() {
    var t;
    if (this.inline) {
      const e = (t = this.shadowRoot) == null ? void 0 : t.querySelector("svg");
      e && Wr(e, "Video Transcript Icon - Inline");
    }
  }
  conditionallyRenderTranscripts() {
    var t;
    if (this.slottedTranscriptTexts && this.slottedTranscriptTexts.length > 1)
      for (let e = 1; e < this.slottedTranscriptTexts.length; e++)
        (t = this.slottedTranscriptTexts.at(e)) == null || t.style.setProperty("display", "none");
  }
  /**
   * Sets the index of `slottedTranscriptTexts` to `display: flex` and sets last active transcript element to `display:none`
   * @param {any} index: respective index of transcript text content
   */
  setActiveTranscript(t) {
    var e, a;
    this.activeTranscriptIndex === t || t >= this.slottedTranscriptTexts.length || ((e = this.slottedTranscriptTexts.at(this.activeTranscriptIndex)) == null || e.style.setProperty("display", "none"), (a = this.slottedTranscriptTexts.at(t)) == null || a.style.setProperty("display", ""), this.activeTranscriptIndex = t);
  }
  /** This function is called in render when inline is set to true which opens the transcript text below the video component */
  static renderInline() {
    return pe`<details>
      <summary>
        ${Be`
            <div
                class="video-view-transcript">
                <span class="transcript-label"><slot name="transcript-label">${zi.inlineLabel}</slot></span><span role="presentation">${ut(Hm)}</span></div>`}
      </summary>
      <slot class="transcript-text"></slot>
    </details>`;
  }
  /** This function is called in render when inline is set to false which opens a modal with transcript text in it */
  renderModal() {
    return pe`${Be`<div class="transcript-button"><${this.getScopedTag("beacon-button")} variant="${zi.variant}" scale="${zi.scale}" class="video-view-transcript" @beacon-event-click=${this.handleClick}>
    <span class="transcript-label">
      <slot name="transcript-label">${zi.modalLabel}</slot>
    </span>
    ${ut(D3)}</${this.getScopedTag("beacon-button")}></div>
    <${this.getScopedTag("beacon-modal")} class="video-transcript-beacon-modal" scale="${zi.videoTranscriptModalScale}">
      <slot></slot>
    </${this.getScopedTag("beacon-modal")}>`}`;
  }
  render() {
    return pe`
      ${this.inline ? di.renderInline() : this.renderModal()}
    `;
  }
}, di.tagName = zi.beaconTagName, di.nestedComponents = [Nl, Zo], di);
Er([
  ue({ type: Boolean })
], wn.prototype, "inline", 2);
Er([
  et(".video-transcript-beacon-modal")
], wn.prototype, "modal", 2);
Er([
  Pe({ slot: "transcript-label", flatten: !0 })
], wn.prototype, "slottedTranscriptLabel", 2);
Er([
  wt({ flatten: !0 })
], wn.prototype, "slottedTranscriptTexts", 2);
Er([
  De
], wn.prototype, "addAnalyticsToIcon", 1);
Er([
  De
], wn.prototype, "conditionallyRenderTranscripts", 1);
let hz = wn;
export {
  pi as BeaconAccordion,
  W3 as BeaconAccordionItem,
  as as BeaconActionBar,
  q3 as BeaconAnchorNavigation,
  Zd as BeaconAreaChart,
  hu as BeaconArticleTile,
  pu as BeaconAudio,
  Jd as BeaconBarChart,
  Jo as BeaconBioCard,
  V3 as BeaconBreadcrumbs,
  Zo as BeaconButton,
  Il as BeaconByline,
  Y3 as BeaconCarousel,
  ct as BeaconChartBase,
  Bl as BeaconCollectionTile,
  Iu as BeaconContactTile,
  wc as BeaconControl,
  or as BeaconControlGroup,
  Ao as BeaconCountry,
  ir as BeaconCountrySelector,
  Yi as BeaconDataList,
  mi as BeaconDividedList,
  lh as BeaconDividedListItem,
  ta as BeaconDivider,
  Q3 as BeaconDonutChart,
  sg as BeaconDrawer,
  Rl as BeaconError,
  cs as BeaconFilterChip,
  rn as BeaconFooter,
  J3 as BeaconFootnote,
  bg as BeaconFootnoteList,
  ez as BeaconGaugeChart,
  nt as BeaconHero,
  fo as BeaconIcon,
  eo as BeaconIconButton,
  Bo as BeaconIdCard,
  ds as BeaconInputChip,
  nr as BeaconKeyFacts,
  fg as BeaconLineChart,
  hh as BeaconLoadingSpinner,
  is as BeaconMenu,
  Ta as BeaconMeterChart,
  Nl as BeaconModal,
  oz as BeaconMultiSelect,
  wO as BeaconMultiSelectOptgroup,
  az as BeaconMultiSelectOption,
  qr as BeaconNavigation,
  it as BeaconNavigationButton,
  ov as BeaconNavigationExpanded,
  kg as BeaconNavigationFooter,
  gi as BeaconNavigationPopover,
  ar as BeaconNavigationToolbelt,
  iz as BeaconNotification,
  nz as BeaconNotificationGroup,
  rz as BeaconPagination,
  Ma as BeaconPaginationButton,
  vo as BeaconPopover,
  Fl as BeaconProgressIndicator,
  ph as BeaconPromoTile,
  oa as BeaconQuoteBlock,
  Og as BeaconRegionSelector,
  sz as BeaconScatterChart,
  rr as BeaconSegmentedControl,
  jt as BeaconSegmentedControls,
  Bg as BeaconSelectionTile,
  sr as BeaconSocialLink,
  Ng as BeaconSocialLinkContainer,
  Dt as BeaconTab,
  lr as BeaconTabPanel,
  ck as BeaconTable,
  Jc as BeaconTableHeader,
  ed as BeaconTableRecord,
  Zs as BeaconTableStub,
  lz as BeaconTabs,
  ia as BeaconTile,
  cz as BeaconTooltip,
  cr as BeaconVideo,
  mh as BeaconVideoPlaylist,
  Ul as BeaconVideoTag,
  dz as BeaconVideoTile,
  hz as BeaconVideoTranscript
};
